/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */
( function( global, factory ) {

    "use strict";

    if ( typeof module === "object" && typeof module.exports === "object" ) {

        // For CommonJS and CommonJS-like environments where a proper `window`
        // is present, execute the factory and get jQuery.
        // For environments that do not have a `window` with a `document`
        // (such as Node.js), expose a factory as module.exports.
        // This accentuates the need for the creation of a real `window`.
        // e.g. var jQuery = require("jquery")(window);
        // See ticket #14549 for more info.
        module.exports = global.document ?
            factory( global, true ) :
            function( w ) {
                if ( !w.document ) {
                    throw new Error( "jQuery requires a window with a document" );
                }
                return factory( w );
            };
    } else {
        factory( global );
    }

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
    "use strict";

    var arr = [];

    var document = window.document;

    var getProto = Object.getPrototypeOf;

    var slice = arr.slice;

    var concat = arr.concat;

    var push = arr.push;

    var indexOf = arr.indexOf;

    var class2type = {};

    var toString = class2type.toString;

    var hasOwn = class2type.hasOwnProperty;

    var fnToString = hasOwn.toString;

    var ObjectFunctionString = fnToString.call( Object );

    var support = {};



    function DOMEval( code, doc ) {
        doc = doc || document;

        var script = doc.createElement( "script" );

        script.text = code;
        doc.head.appendChild( script ).parentNode.removeChild( script );
    }
    /* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



    var
        version = "3.2.1",

        // Define a local copy of jQuery
        jQuery = function( selector, context ) {

            // The jQuery object is actually just the init constructor 'enhanced'
            // Need init if jQuery is called (just allow error to be thrown if not included)
            return new jQuery.fn.init( selector, context );
        },

        // Support: Android <=4.0 only
        // Make sure we trim BOM and NBSP
        rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

        // Matches dashed string for camelizing
        rmsPrefix = /^-ms-/,
        rdashAlpha = /-([a-z])/g,

        // Used by jQuery.camelCase as callback to replace()
        fcamelCase = function( all, letter ) {
            return letter.toUpperCase();
        };

    jQuery.fn = jQuery.prototype = {

        // The current version of jQuery being used
        jquery: version,

        constructor: jQuery,

        // The default length of a jQuery object is 0
        length: 0,

        toArray: function() {
            return slice.call( this );
        },

        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function( num ) {

            // Return all the elements in a clean array
            if ( num == null ) {
                return slice.call( this );
            }

            // Return just the one element from the set
            return num < 0 ? this[ num + this.length ] : this[ num ];
        },

        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function( elems ) {

            // Build a new jQuery matched element set
            var ret = jQuery.merge( this.constructor(), elems );

            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;

            // Return the newly-formed element set
            return ret;
        },

        // Execute a callback for every element in the matched set.
        each: function( callback ) {
            return jQuery.each( this, callback );
        },

        map: function( callback ) {
            return this.pushStack( jQuery.map( this, function( elem, i ) {
                return callback.call( elem, i, elem );
            } ) );
        },

        slice: function() {
            return this.pushStack( slice.apply( this, arguments ) );
        },

        first: function() {
            return this.eq( 0 );
        },

        last: function() {
            return this.eq( -1 );
        },

        eq: function( i ) {
            var len = this.length,
                j = +i + ( i < 0 ? len : 0 );
            return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
        },

        end: function() {
            return this.prevObject || this.constructor();
        },

        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };

    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone,
            target = arguments[ 0 ] || {},
            i = 1,
            length = arguments.length,
            deep = false;

        // Handle a deep copy situation
        if ( typeof target === "boolean" ) {
            deep = target;

            // Skip the boolean and the target
            target = arguments[ i ] || {};
            i++;
        }

        // Handle case when target is a string or something (possible in deep copy)
        if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
            target = {};
        }

        // Extend jQuery itself if only one argument is passed
        if ( i === length ) {
            target = this;
            i--;
        }

        for ( ; i < length; i++ ) {

            // Only deal with non-null/undefined values
            if ( ( options = arguments[ i ] ) != null ) {

                // Extend the base object
                for ( name in options ) {
                    src = target[ name ];
                    copy = options[ name ];

                    // Prevent never-ending loop
                    if ( target === copy ) {
                        continue;
                    }

                    // Recurse if we're merging plain objects or arrays
                    if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
                            ( copyIsArray = Array.isArray( copy ) ) ) ) {

                        if ( copyIsArray ) {
                            copyIsArray = false;
                            clone = src && Array.isArray( src ) ? src : [];

                        } else {
                            clone = src && jQuery.isPlainObject( src ) ? src : {};
                        }

                        // Never move original objects, clone them
                        target[ name ] = jQuery.extend( deep, clone, copy );

                        // Don't bring in undefined values
                    } else if ( copy !== undefined ) {
                        target[ name ] = copy;
                    }
                }
            }
        }

        // Return the modified object
        return target;
    };

    jQuery.extend( {

        // Unique for each copy of jQuery on the page
        expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

        // Assume jQuery is ready without the ready module
        isReady: true,

        error: function( msg ) {
            throw new Error( msg );
        },

        noop: function() {},

        isFunction: function( obj ) {
            return jQuery.type( obj ) === "function";
        },

        isWindow: function( obj ) {
            return obj != null && obj === obj.window;
        },

        isNumeric: function( obj ) {

            // As of jQuery 3.0, isNumeric is limited to
            // strings and numbers (primitives or objects)
            // that can be coerced to finite numbers (gh-2662)
            var type = jQuery.type( obj );
            return ( type === "number" || type === "string" ) &&

                // parseFloat NaNs numeric-cast false positives ("")
                // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
                // subtraction forces infinities to NaN
                !isNaN( obj - parseFloat( obj ) );
        },

        isPlainObject: function( obj ) {
            var proto, Ctor;

            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if ( !obj || toString.call( obj ) !== "[object Object]" ) {
                return false;
            }

            proto = getProto( obj );

            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if ( !proto ) {
                return true;
            }

            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
            return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
        },

        isEmptyObject: function( obj ) {

            /* eslint-disable no-unused-vars */
            // See https://github.com/eslint/eslint/issues/6125
            var name;

            for ( name in obj ) {
                return false;
            }
            return true;
        },

        type: function( obj ) {
            if ( obj == null ) {
                return obj + "";
            }

            // Support: Android <=2.3 only (functionish RegExp)
            return typeof obj === "object" || typeof obj === "function" ?
                class2type[ toString.call( obj ) ] || "object" :
                typeof obj;
        },

        // Evaluates a script in a global context
        globalEval: function( code ) {
            DOMEval( code );
        },

        // Convert dashed to camelCase; used by the css and data modules
        // Support: IE <=9 - 11, Edge 12 - 13
        // Microsoft forgot to hump their vendor prefix (#9572)
        camelCase: function( string ) {
            return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
        },

        each: function( obj, callback ) {
            var length, i = 0;

            if ( isArrayLike( obj ) ) {
                length = obj.length;
                for ( ; i < length; i++ ) {
                    if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
                        break;
                    }
                }
            } else {
                for ( i in obj ) {
                    if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
                        break;
                    }
                }
            }

            return obj;
        },

        // Support: Android <=4.0 only
        trim: function( text ) {
            return text == null ?
                "" :
                ( text + "" ).replace( rtrim, "" );
        },

        // results is for internal usage only
        makeArray: function( arr, results ) {
            var ret = results || [];

            if ( arr != null ) {
                if ( isArrayLike( Object( arr ) ) ) {
                    jQuery.merge( ret,
                        typeof arr === "string" ?
                            [ arr ] : arr
                    );
                } else {
                    push.call( ret, arr );
                }
            }

            return ret;
        },

        inArray: function( elem, arr, i ) {
            return arr == null ? -1 : indexOf.call( arr, elem, i );
        },

        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function( first, second ) {
            var len = +second.length,
                j = 0,
                i = first.length;

            for ( ; j < len; j++ ) {
                first[ i++ ] = second[ j ];
            }

            first.length = i;

            return first;
        },

        grep: function( elems, callback, invert ) {
            var callbackInverse,
                matches = [],
                i = 0,
                length = elems.length,
                callbackExpect = !invert;

            // Go through the array, only saving the items
            // that pass the validator function
            for ( ; i < length; i++ ) {
                callbackInverse = !callback( elems[ i ], i );
                if ( callbackInverse !== callbackExpect ) {
                    matches.push( elems[ i ] );
                }
            }

            return matches;
        },

        // arg is for internal usage only
        map: function( elems, callback, arg ) {
            var length, value,
                i = 0,
                ret = [];

            // Go through the array, translating each of the items to their new values
            if ( isArrayLike( elems ) ) {
                length = elems.length;
                for ( ; i < length; i++ ) {
                    value = callback( elems[ i ], i, arg );

                    if ( value != null ) {
                        ret.push( value );
                    }
                }

                // Go through every key on the object,
            } else {
                for ( i in elems ) {
                    value = callback( elems[ i ], i, arg );

                    if ( value != null ) {
                        ret.push( value );
                    }
                }
            }

            // Flatten any nested arrays
            return concat.apply( [], ret );
        },

        // A global GUID counter for objects
        guid: 1,

        // Bind a function to a context, optionally partially applying any
        // arguments.
        proxy: function( fn, context ) {
            var tmp, args, proxy;

            if ( typeof context === "string" ) {
                tmp = fn[ context ];
                context = fn;
                fn = tmp;
            }

            // Quick check to determine if target is callable, in the spec
            // this throws a TypeError, but we will just return undefined.
            if ( !jQuery.isFunction( fn ) ) {
                return undefined;
            }

            // Simulated bind
            args = slice.call( arguments, 2 );
            proxy = function() {
                return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
            };

            // Set the guid of unique handler to the same of original handler, so it can be removed
            proxy.guid = fn.guid = fn.guid || jQuery.guid++;

            return proxy;
        },

        now: Date.now,

        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    } );

    if ( typeof Symbol === "function" ) {
        jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
    }

// Populate the class2type map
    jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
        function( i, name ) {
            class2type[ "[object " + name + "]" ] = name.toLowerCase();
        } );

    function isArrayLike( obj ) {

        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length,
            type = jQuery.type( obj );

        if ( type === "function" || jQuery.isWindow( obj ) ) {
            return false;
        }

        return type === "array" || length === 0 ||
            typeof length === "number" && length > 0 && ( length - 1 ) in obj;
    }
    var Sizzle =
        /*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
        (function( window ) {

            var i,
                support,
                Expr,
                getText,
                isXML,
                tokenize,
                compile,
                select,
                outermostContext,
                sortInput,
                hasDuplicate,

                // Local document vars
                setDocument,
                document,
                docElem,
                documentIsHTML,
                rbuggyQSA,
                rbuggyMatches,
                matches,
                contains,

                // Instance-specific data
                expando = "sizzle" + 1 * new Date(),
                preferredDoc = window.document,
                dirruns = 0,
                done = 0,
                classCache = createCache(),
                tokenCache = createCache(),
                compilerCache = createCache(),
                sortOrder = function( a, b ) {
                    if ( a === b ) {
                        hasDuplicate = true;
                    }
                    return 0;
                },

                // Instance methods
                hasOwn = ({}).hasOwnProperty,
                arr = [],
                pop = arr.pop,
                push_native = arr.push,
                push = arr.push,
                slice = arr.slice,
                // Use a stripped-down indexOf as it's faster than native
                // https://jsperf.com/thor-indexof-vs-for/5
                indexOf = function( list, elem ) {
                    var i = 0,
                        len = list.length;
                    for ( ; i < len; i++ ) {
                        if ( list[i] === elem ) {
                            return i;
                        }
                    }
                    return -1;
                },

                booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

                // Regular expressions

                // http://www.w3.org/TR/css3-selectors/#whitespace
                whitespace = "[\\x20\\t\\r\\n\\f]",

                // http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
                identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

                // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
                attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
                    // Operator (capture 2)
                    "*([*^$|!~]?=)" + whitespace +
                    // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
                    "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
                    "*\\]",

                pseudos = ":(" + identifier + ")(?:\\((" +
                    // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
                    // 1. quoted (capture 3; capture 4 or capture 5)
                    "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
                    // 2. simple (capture 6)
                    "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
                    // 3. anything else (capture 2)
                    ".*" +
                    ")\\)|)",

                // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
                rwhitespace = new RegExp( whitespace + "+", "g" ),
                rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

                rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
                rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

                rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

                rpseudo = new RegExp( pseudos ),
                ridentifier = new RegExp( "^" + identifier + "$" ),

                matchExpr = {
                    "ID": new RegExp( "^#(" + identifier + ")" ),
                    "CLASS": new RegExp( "^\\.(" + identifier + ")" ),
                    "TAG": new RegExp( "^(" + identifier + "|[*])" ),
                    "ATTR": new RegExp( "^" + attributes ),
                    "PSEUDO": new RegExp( "^" + pseudos ),
                    "CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
                        "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
                        "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
                    "bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
                    // For use in libraries implementing .is()
                    // We use this for POS matching in `select`
                    "needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                        whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
                },

                rinputs = /^(?:input|select|textarea|button)$/i,
                rheader = /^h\d$/i,

                rnative = /^[^{]+\{\s*\[native \w/,

                // Easily-parseable/retrievable ID or TAG or CLASS selectors
                rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

                rsibling = /[+~]/,

                // CSS escapes
                // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
                runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
                funescape = function( _, escaped, escapedWhitespace ) {
                    var high = "0x" + escaped - 0x10000;
                    // NaN means non-codepoint
                    // Support: Firefox<24
                    // Workaround erroneous numeric interpretation of +"0x"
                    return high !== high || escapedWhitespace ?
                        escaped :
                        high < 0 ?
                            // BMP codepoint
                            String.fromCharCode( high + 0x10000 ) :
                            // Supplemental Plane codepoint (surrogate pair)
                            String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
                },

                // CSS string/identifier serialization
                // https://drafts.csswg.org/cssom/#common-serializing-idioms
                rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                fcssescape = function( ch, asCodePoint ) {
                    if ( asCodePoint ) {

                        // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                        if ( ch === "\0" ) {
                            return "\uFFFD";
                        }

                        // Control characters and (dependent upon position) numbers get escaped as code points
                        return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
                    }

                    // Other potentially-special ASCII characters get backslash-escaped
                    return "\\" + ch;
                },

                // Used for iframes
                // See setDocument()
                // Removing the function wrapper causes a "Permission Denied"
                // error in IE
                unloadHandler = function() {
                    setDocument();
                },

                disabledAncestor = addCombinator(
                    function( elem ) {
                        return elem.disabled === true && ("form" in elem || "label" in elem);
                    },
                    { dir: "parentNode", next: "legend" }
                );

// Optimize for push.apply( _, NodeList )
            try {
                push.apply(
                    (arr = slice.call( preferredDoc.childNodes )),
                    preferredDoc.childNodes
                );
                // Support: Android<4.0
                // Detect silently failing push.apply
                arr[ preferredDoc.childNodes.length ].nodeType;
            } catch ( e ) {
                push = { apply: arr.length ?

                    // Leverage slice if possible
                    function( target, els ) {
                        push_native.apply( target, slice.call(els) );
                    } :

                    // Support: IE<9
                    // Otherwise append directly
                    function( target, els ) {
                        var j = target.length,
                            i = 0;
                        // Can't trust NodeList.length
                        while ( (target[j++] = els[i++]) ) {}
                        target.length = j - 1;
                    }
                };
            }

            function Sizzle( selector, context, results, seed ) {
                var m, i, elem, nid, match, groups, newSelector,
                    newContext = context && context.ownerDocument,

                    // nodeType defaults to 9, since context defaults to document
                    nodeType = context ? context.nodeType : 9;

                results = results || [];

                // Return early from calls with invalid selector or context
                if ( typeof selector !== "string" || !selector ||
                    nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

                    return results;
                }

                // Try to shortcut find operations (as opposed to filters) in HTML documents
                if ( !seed ) {

                    if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
                        setDocument( context );
                    }
                    context = context || document;

                    if ( documentIsHTML ) {

                        // If the selector is sufficiently simple, try using a "get*By*" DOM method
                        // (excepting DocumentFragment context, where the methods don't exist)
                        if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

                            // ID selector
                            if ( (m = match[1]) ) {

                                // Document context
                                if ( nodeType === 9 ) {
                                    if ( (elem = context.getElementById( m )) ) {

                                        // Support: IE, Opera, Webkit
                                        // TODO: identify versions
                                        // getElementById can match elements by name instead of ID
                                        if ( elem.id === m ) {
                                            results.push( elem );
                                            return results;
                                        }
                                    } else {
                                        return results;
                                    }

                                    // Element context
                                } else {

                                    // Support: IE, Opera, Webkit
                                    // TODO: identify versions
                                    // getElementById can match elements by name instead of ID
                                    if ( newContext && (elem = newContext.getElementById( m )) &&
                                        contains( context, elem ) &&
                                        elem.id === m ) {

                                        results.push( elem );
                                        return results;
                                    }
                                }

                                // Type selector
                            } else if ( match[2] ) {
                                push.apply( results, context.getElementsByTagName( selector ) );
                                return results;

                                // Class selector
                            } else if ( (m = match[3]) && support.getElementsByClassName &&
                                context.getElementsByClassName ) {

                                push.apply( results, context.getElementsByClassName( m ) );
                                return results;
                            }
                        }

                        // Take advantage of querySelectorAll
                        if ( support.qsa &&
                            !compilerCache[ selector + " " ] &&
                            (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

                            if ( nodeType !== 1 ) {
                                newContext = context;
                                newSelector = selector;

                                // qSA looks outside Element context, which is not what we want
                                // Thanks to Andrew Dupont for this workaround technique
                                // Support: IE <=8
                                // Exclude object elements
                            } else if ( context.nodeName.toLowerCase() !== "object" ) {

                                // Capture the context ID, setting it first if necessary
                                if ( (nid = context.getAttribute( "id" )) ) {
                                    nid = nid.replace( rcssescape, fcssescape );
                                } else {
                                    context.setAttribute( "id", (nid = expando) );
                                }

                                // Prefix every selector in the list
                                groups = tokenize( selector );
                                i = groups.length;
                                while ( i-- ) {
                                    groups[i] = "#" + nid + " " + toSelector( groups[i] );
                                }
                                newSelector = groups.join( "," );

                                // Expand context for sibling selectors
                                newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
                                    context;
                            }

                            if ( newSelector ) {
                                try {
                                    push.apply( results,
                                        newContext.querySelectorAll( newSelector )
                                    );
                                    return results;
                                } catch ( qsaError ) {
                                } finally {
                                    if ( nid === expando ) {
                                        context.removeAttribute( "id" );
                                    }
                                }
                            }
                        }
                    }
                }

                // All others
                return select( selector.replace( rtrim, "$1" ), context, results, seed );
            }

            /**
             * Create key-value caches of limited size
             * @returns {function(string, object)} Returns the Object data after storing it on itself with
             *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
             *	deleting the oldest entry
             */
            function createCache() {
                var keys = [];

                function cache( key, value ) {
                    // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                    if ( keys.push( key + " " ) > Expr.cacheLength ) {
                        // Only keep the most recent entries
                        delete cache[ keys.shift() ];
                    }
                    return (cache[ key + " " ] = value);
                }
                return cache;
            }

            /**
             * Mark a function for special use by Sizzle
             * @param {Function} fn The function to mark
             */
            function markFunction( fn ) {
                fn[ expando ] = true;
                return fn;
            }

            /**
             * Support testing using an element
             * @param {Function} fn Passed the created element and returns a boolean result
             */
            function assert( fn ) {
                var el = document.createElement("fieldset");

                try {
                    return !!fn( el );
                } catch (e) {
                    return false;
                } finally {
                    // Remove from its parent by default
                    if ( el.parentNode ) {
                        el.parentNode.removeChild( el );
                    }
                    // release memory in IE
                    el = null;
                }
            }

            /**
             * Adds the same handler for all of the specified attrs
             * @param {String} attrs Pipe-separated list of attributes
             * @param {Function} handler The method that will be applied
             */
            function addHandle( attrs, handler ) {
                var arr = attrs.split("|"),
                    i = arr.length;

                while ( i-- ) {
                    Expr.attrHandle[ arr[i] ] = handler;
                }
            }

            /**
             * Checks document order of two siblings
             * @param {Element} a
             * @param {Element} b
             * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
             */
            function siblingCheck( a, b ) {
                var cur = b && a,
                    diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
                        a.sourceIndex - b.sourceIndex;

                // Use IE sourceIndex if available on both nodes
                if ( diff ) {
                    return diff;
                }

                // Check if b follows a
                if ( cur ) {
                    while ( (cur = cur.nextSibling) ) {
                        if ( cur === b ) {
                            return -1;
                        }
                    }
                }

                return a ? 1 : -1;
            }

            /**
             * Returns a function to use in pseudos for input types
             * @param {String} type
             */
            function createInputPseudo( type ) {
                return function( elem ) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === type;
                };
            }

            /**
             * Returns a function to use in pseudos for buttons
             * @param {String} type
             */
            function createButtonPseudo( type ) {
                return function( elem ) {
                    var name = elem.nodeName.toLowerCase();
                    return (name === "input" || name === "button") && elem.type === type;
                };
            }

            /**
             * Returns a function to use in pseudos for :enabled/:disabled
             * @param {Boolean} disabled true for :disabled; false for :enabled
             */
            function createDisabledPseudo( disabled ) {

                // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
                return function( elem ) {

                    // Only certain elements can match :enabled or :disabled
                    // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                    // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                    if ( "form" in elem ) {

                        // Check for inherited disabledness on relevant non-disabled elements:
                        // * listed form-associated elements in a disabled fieldset
                        //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                        //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                        // * option elements in a disabled optgroup
                        //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                        // All such elements have a "form" property.
                        if ( elem.parentNode && elem.disabled === false ) {

                            // Option elements defer to a parent optgroup if present
                            if ( "label" in elem ) {
                                if ( "label" in elem.parentNode ) {
                                    return elem.parentNode.disabled === disabled;
                                } else {
                                    return elem.disabled === disabled;
                                }
                            }

                            // Support: IE 6 - 11
                            // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                            return elem.isDisabled === disabled ||

                                // Where there is no isDisabled, check manually
                                /* jshint -W018 */
                                elem.isDisabled !== !disabled &&
                                disabledAncestor( elem ) === disabled;
                        }

                        return elem.disabled === disabled;

                        // Try to winnow out elements that can't be disabled before trusting the disabled property.
                        // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                        // even exist on them, let alone have a boolean value.
                    } else if ( "label" in elem ) {
                        return elem.disabled === disabled;
                    }

                    // Remaining elements are neither :enabled nor :disabled
                    return false;
                };
            }

            /**
             * Returns a function to use in pseudos for positionals
             * @param {Function} fn
             */
            function createPositionalPseudo( fn ) {
                return markFunction(function( argument ) {
                    argument = +argument;
                    return markFunction(function( seed, matches ) {
                        var j,
                            matchIndexes = fn( [], seed.length, argument ),
                            i = matchIndexes.length;

                        // Match elements found at the specified indexes
                        while ( i-- ) {
                            if ( seed[ (j = matchIndexes[i]) ] ) {
                                seed[j] = !(matches[j] = seed[j]);
                            }
                        }
                    });
                });
            }

            /**
             * Checks a node for validity as a Sizzle context
             * @param {Element|Object=} context
             * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
             */
            function testContext( context ) {
                return context && typeof context.getElementsByTagName !== "undefined" && context;
            }

// Expose support vars for convenience
            support = Sizzle.support = {};

            /**
             * Detects XML nodes
             * @param {Element|Object} elem An element or a document
             * @returns {Boolean} True iff elem is a non-HTML XML node
             */
            isXML = Sizzle.isXML = function( elem ) {
                // documentElement is verified for cases where it doesn't yet exist
                // (such as loading iframes in IE - #4833)
                var documentElement = elem && (elem.ownerDocument || elem).documentElement;
                return documentElement ? documentElement.nodeName !== "HTML" : false;
            };

            /**
             * Sets document-related variables once based on the current document
             * @param {Element|Object} [doc] An element or document object to use to set the document
             * @returns {Object} Returns the current document
             */
            setDocument = Sizzle.setDocument = function( node ) {
                var hasCompare, subWindow,
                    doc = node ? node.ownerDocument || node : preferredDoc;

                // Return early if doc is invalid or already selected
                if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
                    return document;
                }

                // Update global variables
                document = doc;
                docElem = document.documentElement;
                documentIsHTML = !isXML( document );

                // Support: IE 9-11, Edge
                // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
                if ( preferredDoc !== document &&
                    (subWindow = document.defaultView) && subWindow.top !== subWindow ) {

                    // Support: IE 11, Edge
                    if ( subWindow.addEventListener ) {
                        subWindow.addEventListener( "unload", unloadHandler, false );

                        // Support: IE 9 - 10 only
                    } else if ( subWindow.attachEvent ) {
                        subWindow.attachEvent( "onunload", unloadHandler );
                    }
                }

                /* Attributes
	---------------------------------------------------------------------- */

                // Support: IE<8
                // Verify that getAttribute really returns attributes and not properties
                // (excepting IE8 booleans)
                support.attributes = assert(function( el ) {
                    el.className = "i";
                    return !el.getAttribute("className");
                });

                /* getElement(s)By*
	---------------------------------------------------------------------- */

                // Check if getElementsByTagName("*") returns only elements
                support.getElementsByTagName = assert(function( el ) {
                    el.appendChild( document.createComment("") );
                    return !el.getElementsByTagName("*").length;
                });

                // Support: IE<9
                support.getElementsByClassName = rnative.test( document.getElementsByClassName );

                // Support: IE<10
                // Check if getElementById returns elements by name
                // The broken getElementById methods don't pick up programmatically-set names,
                // so use a roundabout getElementsByName test
                support.getById = assert(function( el ) {
                    docElem.appendChild( el ).id = expando;
                    return !document.getElementsByName || !document.getElementsByName( expando ).length;
                });

                // ID filter and find
                if ( support.getById ) {
                    Expr.filter["ID"] = function( id ) {
                        var attrId = id.replace( runescape, funescape );
                        return function( elem ) {
                            return elem.getAttribute("id") === attrId;
                        };
                    };
                    Expr.find["ID"] = function( id, context ) {
                        if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
                            var elem = context.getElementById( id );
                            return elem ? [ elem ] : [];
                        }
                    };
                } else {
                    Expr.filter["ID"] =  function( id ) {
                        var attrId = id.replace( runescape, funescape );
                        return function( elem ) {
                            var node = typeof elem.getAttributeNode !== "undefined" &&
                                elem.getAttributeNode("id");
                            return node && node.value === attrId;
                        };
                    };

                    // Support: IE 6 - 7 only
                    // getElementById is not reliable as a find shortcut
                    Expr.find["ID"] = function( id, context ) {
                        if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
                            var node, i, elems,
                                elem = context.getElementById( id );

                            if ( elem ) {

                                // Verify the id attribute
                                node = elem.getAttributeNode("id");
                                if ( node && node.value === id ) {
                                    return [ elem ];
                                }

                                // Fall back on getElementsByName
                                elems = context.getElementsByName( id );
                                i = 0;
                                while ( (elem = elems[i++]) ) {
                                    node = elem.getAttributeNode("id");
                                    if ( node && node.value === id ) {
                                        return [ elem ];
                                    }
                                }
                            }

                            return [];
                        }
                    };
                }

                // Tag
                Expr.find["TAG"] = support.getElementsByTagName ?
                    function( tag, context ) {
                        if ( typeof context.getElementsByTagName !== "undefined" ) {
                            return context.getElementsByTagName( tag );

                            // DocumentFragment nodes don't have gEBTN
                        } else if ( support.qsa ) {
                            return context.querySelectorAll( tag );
                        }
                    } :

                    function( tag, context ) {
                        var elem,
                            tmp = [],
                            i = 0,
                            // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                            results = context.getElementsByTagName( tag );

                        // Filter out possible comments
                        if ( tag === "*" ) {
                            while ( (elem = results[i++]) ) {
                                if ( elem.nodeType === 1 ) {
                                    tmp.push( elem );
                                }
                            }

                            return tmp;
                        }
                        return results;
                    };

                // Class
                Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
                    if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
                        return context.getElementsByClassName( className );
                    }
                };

                /* QSA/matchesSelector
	---------------------------------------------------------------------- */

                // QSA and matchesSelector support

                // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
                rbuggyMatches = [];

                // qSa(:focus) reports false when true (Chrome 21)
                // We allow this because of a bug in IE8/9 that throws an error
                // whenever `document.activeElement` is accessed on an iframe
                // So, we allow :focus to pass through QSA all the time to avoid the IE error
                // See https://bugs.jquery.com/ticket/13378
                rbuggyQSA = [];

                if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
                    // Build QSA regex
                    // Regex strategy adopted from Diego Perini
                    assert(function( el ) {
                        // Select is set to empty string on purpose
                        // This is to test IE's treatment of not explicitly
                        // setting a boolean content attribute,
                        // since its presence should be enough
                        // https://bugs.jquery.com/ticket/12359
                        docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
                            "<select id='" + expando + "-\r\\' msallowcapture=''>" +
                            "<option selected=''></option></select>";

                        // Support: IE8, Opera 11-12.16
                        // Nothing should be selected when empty strings follow ^= or $= or *=
                        // The test attribute must be unknown in Opera but "safe" for WinRT
                        // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                        if ( el.querySelectorAll("[msallowcapture^='']").length ) {
                            rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
                        }

                        // Support: IE8
                        // Boolean attributes and "value" are not treated correctly
                        if ( !el.querySelectorAll("[selected]").length ) {
                            rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
                        }

                        // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                        if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
                            rbuggyQSA.push("~=");
                        }

                        // Webkit/Opera - :checked should return selected option elements
                        // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                        // IE8 throws error here and will not see later tests
                        if ( !el.querySelectorAll(":checked").length ) {
                            rbuggyQSA.push(":checked");
                        }

                        // Support: Safari 8+, iOS 8+
                        // https://bugs.webkit.org/show_bug.cgi?id=136851
                        // In-page `selector#id sibling-combinator selector` fails
                        if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
                            rbuggyQSA.push(".#.+[+~]");
                        }
                    });

                    assert(function( el ) {
                        el.innerHTML = "<a href='' disabled='disabled'></a>" +
                            "<select disabled='disabled'><option/></select>";

                        // Support: Windows 8 Native Apps
                        // The type and name attributes are restricted during .innerHTML assignment
                        var input = document.createElement("input");
                        input.setAttribute( "type", "hidden" );
                        el.appendChild( input ).setAttribute( "name", "D" );

                        // Support: IE8
                        // Enforce case-sensitivity of name attribute
                        if ( el.querySelectorAll("[name=d]").length ) {
                            rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
                        }

                        // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                        // IE8 throws error here and will not see later tests
                        if ( el.querySelectorAll(":enabled").length !== 2 ) {
                            rbuggyQSA.push( ":enabled", ":disabled" );
                        }

                        // Support: IE9-11+
                        // IE's :disabled selector does not pick up the children of disabled fieldsets
                        docElem.appendChild( el ).disabled = true;
                        if ( el.querySelectorAll(":disabled").length !== 2 ) {
                            rbuggyQSA.push( ":enabled", ":disabled" );
                        }

                        // Opera 10-11 does not throw on post-comma invalid pseudos
                        el.querySelectorAll("*,:x");
                        rbuggyQSA.push(",.*:");
                    });
                }

                if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
                        docElem.webkitMatchesSelector ||
                        docElem.mozMatchesSelector ||
                        docElem.oMatchesSelector ||
                        docElem.msMatchesSelector) )) ) {

                    assert(function( el ) {
                        // Check to see if it's possible to do matchesSelector
                        // on a disconnected node (IE 9)
                        support.disconnectedMatch = matches.call( el, "*" );

                        // This should fail with an exception
                        // Gecko does not error, returns false instead
                        matches.call( el, "[s!='']:x" );
                        rbuggyMatches.push( "!=", pseudos );
                    });
                }

                rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
                rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

                /* Contains
	---------------------------------------------------------------------- */
                hasCompare = rnative.test( docElem.compareDocumentPosition );

                // Element contains another
                // Purposefully self-exclusive
                // As in, an element does not contain itself
                contains = hasCompare || rnative.test( docElem.contains ) ?
                    function( a, b ) {
                        var adown = a.nodeType === 9 ? a.documentElement : a,
                            bup = b && b.parentNode;
                        return a === bup || !!( bup && bup.nodeType === 1 && (
                            adown.contains ?
                                adown.contains( bup ) :
                                a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
                        ));
                    } :
                    function( a, b ) {
                        if ( b ) {
                            while ( (b = b.parentNode) ) {
                                if ( b === a ) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    };

                /* Sorting
	---------------------------------------------------------------------- */

                // Document order sorting
                sortOrder = hasCompare ?
                    function( a, b ) {

                        // Flag for duplicate removal
                        if ( a === b ) {
                            hasDuplicate = true;
                            return 0;
                        }

                        // Sort on method existence if only one input has compareDocumentPosition
                        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                        if ( compare ) {
                            return compare;
                        }

                        // Calculate position if both inputs belong to the same document
                        compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
                            a.compareDocumentPosition( b ) :

                            // Otherwise we know they are disconnected
                            1;

                        // Disconnected nodes
                        if ( compare & 1 ||
                            (!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

                            // Choose the first element that is related to our preferred document
                            if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
                                return -1;
                            }
                            if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
                                return 1;
                            }

                            // Maintain original order
                            return sortInput ?
                                ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                                0;
                        }

                        return compare & 4 ? -1 : 1;
                    } :
                    function( a, b ) {
                        // Exit early if the nodes are identical
                        if ( a === b ) {
                            hasDuplicate = true;
                            return 0;
                        }

                        var cur,
                            i = 0,
                            aup = a.parentNode,
                            bup = b.parentNode,
                            ap = [ a ],
                            bp = [ b ];

                        // Parentless nodes are either documents or disconnected
                        if ( !aup || !bup ) {
                            return a === document ? -1 :
                                b === document ? 1 :
                                    aup ? -1 :
                                        bup ? 1 :
                                            sortInput ?
                                                ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                                                0;

                            // If the nodes are siblings, we can do a quick check
                        } else if ( aup === bup ) {
                            return siblingCheck( a, b );
                        }

                        // Otherwise we need full lists of their ancestors for comparison
                        cur = a;
                        while ( (cur = cur.parentNode) ) {
                            ap.unshift( cur );
                        }
                        cur = b;
                        while ( (cur = cur.parentNode) ) {
                            bp.unshift( cur );
                        }

                        // Walk down the tree looking for a discrepancy
                        while ( ap[i] === bp[i] ) {
                            i++;
                        }

                        return i ?
                            // Do a sibling check if the nodes have a common ancestor
                            siblingCheck( ap[i], bp[i] ) :

                            // Otherwise nodes in our document sort first
                            ap[i] === preferredDoc ? -1 :
                                bp[i] === preferredDoc ? 1 :
                                    0;
                    };

                return document;
            };

            Sizzle.matches = function( expr, elements ) {
                return Sizzle( expr, null, null, elements );
            };

            Sizzle.matchesSelector = function( elem, expr ) {
                // Set document vars if needed
                if ( ( elem.ownerDocument || elem ) !== document ) {
                    setDocument( elem );
                }

                // Make sure that attribute selectors are quoted
                expr = expr.replace( rattributeQuotes, "='$1']" );

                if ( support.matchesSelector && documentIsHTML &&
                    !compilerCache[ expr + " " ] &&
                    ( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
                    ( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

                    try {
                        var ret = matches.call( elem, expr );

                        // IE 9's matchesSelector returns false on disconnected nodes
                        if ( ret || support.disconnectedMatch ||
                            // As well, disconnected nodes are said to be in a document
                            // fragment in IE 9
                            elem.document && elem.document.nodeType !== 11 ) {
                            return ret;
                        }
                    } catch (e) {}
                }

                return Sizzle( expr, document, null, [ elem ] ).length > 0;
            };

            Sizzle.contains = function( context, elem ) {
                // Set document vars if needed
                if ( ( context.ownerDocument || context ) !== document ) {
                    setDocument( context );
                }
                return contains( context, elem );
            };

            Sizzle.attr = function( elem, name ) {
                // Set document vars if needed
                if ( ( elem.ownerDocument || elem ) !== document ) {
                    setDocument( elem );
                }

                var fn = Expr.attrHandle[ name.toLowerCase() ],
                    // Don't get fooled by Object.prototype properties (jQuery #13807)
                    val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
                        fn( elem, name, !documentIsHTML ) :
                        undefined;

                return val !== undefined ?
                    val :
                    support.attributes || !documentIsHTML ?
                        elem.getAttribute( name ) :
                        (val = elem.getAttributeNode(name)) && val.specified ?
                            val.value :
                            null;
            };

            Sizzle.escape = function( sel ) {
                return (sel + "").replace( rcssescape, fcssescape );
            };

            Sizzle.error = function( msg ) {
                throw new Error( "Syntax error, unrecognized expression: " + msg );
            };

            /**
             * Document sorting and removing duplicates
             * @param {ArrayLike} results
             */
            Sizzle.uniqueSort = function( results ) {
                var elem,
                    duplicates = [],
                    j = 0,
                    i = 0;

                // Unless we *know* we can detect duplicates, assume their presence
                hasDuplicate = !support.detectDuplicates;
                sortInput = !support.sortStable && results.slice( 0 );
                results.sort( sortOrder );

                if ( hasDuplicate ) {
                    while ( (elem = results[i++]) ) {
                        if ( elem === results[ i ] ) {
                            j = duplicates.push( i );
                        }
                    }
                    while ( j-- ) {
                        results.splice( duplicates[ j ], 1 );
                    }
                }

                // Clear input after sorting to release objects
                // See https://github.com/jquery/sizzle/pull/225
                sortInput = null;

                return results;
            };

            /**
             * Utility function for retrieving the text value of an array of DOM nodes
             * @param {Array|Element} elem
             */
            getText = Sizzle.getText = function( elem ) {
                var node,
                    ret = "",
                    i = 0,
                    nodeType = elem.nodeType;

                if ( !nodeType ) {
                    // If no nodeType, this is expected to be an array
                    while ( (node = elem[i++]) ) {
                        // Do not traverse comment nodes
                        ret += getText( node );
                    }
                } else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
                    // Use textContent for elements
                    // innerText usage removed for consistency of new lines (jQuery #11153)
                    if ( typeof elem.textContent === "string" ) {
                        return elem.textContent;
                    } else {
                        // Traverse its children
                        for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
                            ret += getText( elem );
                        }
                    }
                } else if ( nodeType === 3 || nodeType === 4 ) {
                    return elem.nodeValue;
                }
                // Do not include comment or processing instruction nodes

                return ret;
            };

            Expr = Sizzle.selectors = {

                // Can be adjusted by the user
                cacheLength: 50,

                createPseudo: markFunction,

                match: matchExpr,

                attrHandle: {},

                find: {},

                relative: {
                    ">": { dir: "parentNode", first: true },
                    " ": { dir: "parentNode" },
                    "+": { dir: "previousSibling", first: true },
                    "~": { dir: "previousSibling" }
                },

                preFilter: {
                    "ATTR": function( match ) {
                        match[1] = match[1].replace( runescape, funescape );

                        // Move the given value to match[3] whether quoted or unquoted
                        match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

                        if ( match[2] === "~=" ) {
                            match[3] = " " + match[3] + " ";
                        }

                        return match.slice( 0, 4 );
                    },

                    "CHILD": function( match ) {
                        /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
                        match[1] = match[1].toLowerCase();

                        if ( match[1].slice( 0, 3 ) === "nth" ) {
                            // nth-* requires argument
                            if ( !match[3] ) {
                                Sizzle.error( match[0] );
                            }

                            // numeric x and y parameters for Expr.filter.CHILD
                            // remember that false/true cast respectively to 0/1
                            match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
                            match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

                            // other types prohibit arguments
                        } else if ( match[3] ) {
                            Sizzle.error( match[0] );
                        }

                        return match;
                    },

                    "PSEUDO": function( match ) {
                        var excess,
                            unquoted = !match[6] && match[2];

                        if ( matchExpr["CHILD"].test( match[0] ) ) {
                            return null;
                        }

                        // Accept quoted arguments as-is
                        if ( match[3] ) {
                            match[2] = match[4] || match[5] || "";

                            // Strip excess characters from unquoted arguments
                        } else if ( unquoted && rpseudo.test( unquoted ) &&
                            // Get excess from tokenize (recursively)
                            (excess = tokenize( unquoted, true )) &&
                            // advance to the next closing parenthesis
                            (excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

                            // excess is a negative index
                            match[0] = match[0].slice( 0, excess );
                            match[2] = unquoted.slice( 0, excess );
                        }

                        // Return only captures needed by the pseudo filter method (type and argument)
                        return match.slice( 0, 3 );
                    }
                },

                filter: {

                    "TAG": function( nodeNameSelector ) {
                        var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
                        return nodeNameSelector === "*" ?
                            function() { return true; } :
                            function( elem ) {
                                return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                            };
                    },

                    "CLASS": function( className ) {
                        var pattern = classCache[ className + " " ];

                        return pattern ||
                            (pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
                            classCache( className, function( elem ) {
                                return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
                            });
                    },

                    "ATTR": function( name, operator, check ) {
                        return function( elem ) {
                            var result = Sizzle.attr( elem, name );

                            if ( result == null ) {
                                return operator === "!=";
                            }
                            if ( !operator ) {
                                return true;
                            }

                            result += "";

                            return operator === "=" ? result === check :
                                operator === "!=" ? result !== check :
                                    operator === "^=" ? check && result.indexOf( check ) === 0 :
                                        operator === "*=" ? check && result.indexOf( check ) > -1 :
                                            operator === "$=" ? check && result.slice( -check.length ) === check :
                                                operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
                                                    operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
                                                        false;
                        };
                    },

                    "CHILD": function( type, what, argument, first, last ) {
                        var simple = type.slice( 0, 3 ) !== "nth",
                            forward = type.slice( -4 ) !== "last",
                            ofType = what === "of-type";

                        return first === 1 && last === 0 ?

                            // Shortcut for :nth-*(n)
                            function( elem ) {
                                return !!elem.parentNode;
                            } :

                            function( elem, context, xml ) {
                                var cache, uniqueCache, outerCache, node, nodeIndex, start,
                                    dir = simple !== forward ? "nextSibling" : "previousSibling",
                                    parent = elem.parentNode,
                                    name = ofType && elem.nodeName.toLowerCase(),
                                    useCache = !xml && !ofType,
                                    diff = false;

                                if ( parent ) {

                                    // :(first|last|only)-(child|of-type)
                                    if ( simple ) {
                                        while ( dir ) {
                                            node = elem;
                                            while ( (node = node[ dir ]) ) {
                                                if ( ofType ?
                                                        node.nodeName.toLowerCase() === name :
                                                        node.nodeType === 1 ) {

                                                    return false;
                                                }
                                            }
                                            // Reverse direction for :only-* (if we haven't yet done so)
                                            start = dir = type === "only" && !start && "nextSibling";
                                        }
                                        return true;
                                    }

                                    start = [ forward ? parent.firstChild : parent.lastChild ];

                                    // non-xml :nth-child(...) stores cache data on `parent`
                                    if ( forward && useCache ) {

                                        // Seek `elem` from a previously-cached index

                                        // ...in a gzip-friendly way
                                        node = parent;
                                        outerCache = node[ expando ] || (node[ expando ] = {});

                                        // Support: IE <9 only
                                        // Defend against cloned attroperties (jQuery gh-1709)
                                        uniqueCache = outerCache[ node.uniqueID ] ||
                                            (outerCache[ node.uniqueID ] = {});

                                        cache = uniqueCache[ type ] || [];
                                        nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                                        diff = nodeIndex && cache[ 2 ];
                                        node = nodeIndex && parent.childNodes[ nodeIndex ];

                                        while ( (node = ++nodeIndex && node && node[ dir ] ||

                                            // Fallback to seeking `elem` from the start
                                            (diff = nodeIndex = 0) || start.pop()) ) {

                                            // When found, cache indexes on `parent` and break
                                            if ( node.nodeType === 1 && ++diff && node === elem ) {
                                                uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
                                                break;
                                            }
                                        }

                                    } else {
                                        // Use previously-cached element index if available
                                        if ( useCache ) {
                                            // ...in a gzip-friendly way
                                            node = elem;
                                            outerCache = node[ expando ] || (node[ expando ] = {});

                                            // Support: IE <9 only
                                            // Defend against cloned attroperties (jQuery gh-1709)
                                            uniqueCache = outerCache[ node.uniqueID ] ||
                                                (outerCache[ node.uniqueID ] = {});

                                            cache = uniqueCache[ type ] || [];
                                            nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                                            diff = nodeIndex;
                                        }

                                        // xml :nth-child(...)
                                        // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                        if ( diff === false ) {
                                            // Use the same loop as above to seek `elem` from the start
                                            while ( (node = ++nodeIndex && node && node[ dir ] ||
                                                (diff = nodeIndex = 0) || start.pop()) ) {

                                                if ( ( ofType ?
                                                        node.nodeName.toLowerCase() === name :
                                                        node.nodeType === 1 ) &&
                                                    ++diff ) {

                                                    // Cache the index of each encountered element
                                                    if ( useCache ) {
                                                        outerCache = node[ expando ] || (node[ expando ] = {});

                                                        // Support: IE <9 only
                                                        // Defend against cloned attroperties (jQuery gh-1709)
                                                        uniqueCache = outerCache[ node.uniqueID ] ||
                                                            (outerCache[ node.uniqueID ] = {});

                                                        uniqueCache[ type ] = [ dirruns, diff ];
                                                    }

                                                    if ( node === elem ) {
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    // Incorporate the offset, then check against cycle size
                                    diff -= last;
                                    return diff === first || ( diff % first === 0 && diff / first >= 0 );
                                }
                            };
                    },

                    "PSEUDO": function( pseudo, argument ) {
                        // pseudo-class names are case-insensitive
                        // http://www.w3.org/TR/selectors/#pseudo-classes
                        // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                        // Remember that setFilters inherits from pseudos
                        var args,
                            fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
                                Sizzle.error( "unsupported pseudo: " + pseudo );

                        // The user may use createPseudo to indicate that
                        // arguments are needed to create the filter function
                        // just as Sizzle does
                        if ( fn[ expando ] ) {
                            return fn( argument );
                        }

                        // But maintain support for old signatures
                        if ( fn.length > 1 ) {
                            args = [ pseudo, pseudo, "", argument ];
                            return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
                                markFunction(function( seed, matches ) {
                                    var idx,
                                        matched = fn( seed, argument ),
                                        i = matched.length;
                                    while ( i-- ) {
                                        idx = indexOf( seed, matched[i] );
                                        seed[ idx ] = !( matches[ idx ] = matched[i] );
                                    }
                                }) :
                                function( elem ) {
                                    return fn( elem, 0, args );
                                };
                        }

                        return fn;
                    }
                },

                pseudos: {
                    // Potentially complex pseudos
                    "not": markFunction(function( selector ) {
                        // Trim the selector passed to compile
                        // to avoid treating leading and trailing
                        // spaces as combinators
                        var input = [],
                            results = [],
                            matcher = compile( selector.replace( rtrim, "$1" ) );

                        return matcher[ expando ] ?
                            markFunction(function( seed, matches, context, xml ) {
                                var elem,
                                    unmatched = matcher( seed, null, xml, [] ),
                                    i = seed.length;

                                // Match elements unmatched by `matcher`
                                while ( i-- ) {
                                    if ( (elem = unmatched[i]) ) {
                                        seed[i] = !(matches[i] = elem);
                                    }
                                }
                            }) :
                            function( elem, context, xml ) {
                                input[0] = elem;
                                matcher( input, null, xml, results );
                                // Don't keep the element (issue #299)
                                input[0] = null;
                                return !results.pop();
                            };
                    }),

                    "has": markFunction(function( selector ) {
                        return function( elem ) {
                            return Sizzle( selector, elem ).length > 0;
                        };
                    }),

                    "contains": markFunction(function( text ) {
                        text = text.replace( runescape, funescape );
                        return function( elem ) {
                            return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
                        };
                    }),

                    // "Whether an element is represented by a :lang() selector
                    // is based solely on the element's language value
                    // being equal to the identifier C,
                    // or beginning with the identifier C immediately followed by "-".
                    // The matching of C against the element's language value is performed case-insensitively.
                    // The identifier C does not have to be a valid language name."
                    // http://www.w3.org/TR/selectors/#lang-pseudo
                    "lang": markFunction( function( lang ) {
                        // lang value must be a valid identifier
                        if ( !ridentifier.test(lang || "") ) {
                            Sizzle.error( "unsupported lang: " + lang );
                        }
                        lang = lang.replace( runescape, funescape ).toLowerCase();
                        return function( elem ) {
                            var elemLang;
                            do {
                                if ( (elemLang = documentIsHTML ?
                                        elem.lang :
                                        elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

                                    elemLang = elemLang.toLowerCase();
                                    return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
                                }
                            } while ( (elem = elem.parentNode) && elem.nodeType === 1 );
                            return false;
                        };
                    }),

                    // Miscellaneous
                    "target": function( elem ) {
                        var hash = window.location && window.location.hash;
                        return hash && hash.slice( 1 ) === elem.id;
                    },

                    "root": function( elem ) {
                        return elem === docElem;
                    },

                    "focus": function( elem ) {
                        return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                    },

                    // Boolean properties
                    "enabled": createDisabledPseudo( false ),
                    "disabled": createDisabledPseudo( true ),

                    "checked": function( elem ) {
                        // In CSS3, :checked should return both checked and selected elements
                        // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                        var nodeName = elem.nodeName.toLowerCase();
                        return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
                    },

                    "selected": function( elem ) {
                        // Accessing this property makes selected-by-default
                        // options in Safari work properly
                        if ( elem.parentNode ) {
                            elem.parentNode.selectedIndex;
                        }

                        return elem.selected === true;
                    },

                    // Contents
                    "empty": function( elem ) {
                        // http://www.w3.org/TR/selectors/#empty-pseudo
                        // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                        //   but not by others (comment: 8; processing instruction: 7; etc.)
                        // nodeType < 6 works because attributes (2) do not appear as children
                        for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
                            if ( elem.nodeType < 6 ) {
                                return false;
                            }
                        }
                        return true;
                    },

                    "parent": function( elem ) {
                        return !Expr.pseudos["empty"]( elem );
                    },

                    // Element/input types
                    "header": function( elem ) {
                        return rheader.test( elem.nodeName );
                    },

                    "input": function( elem ) {
                        return rinputs.test( elem.nodeName );
                    },

                    "button": function( elem ) {
                        var name = elem.nodeName.toLowerCase();
                        return name === "input" && elem.type === "button" || name === "button";
                    },

                    "text": function( elem ) {
                        var attr;
                        return elem.nodeName.toLowerCase() === "input" &&
                            elem.type === "text" &&

                            // Support: IE<8
                            // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                            ( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
                    },

                    // Position-in-collection
                    "first": createPositionalPseudo(function() {
                        return [ 0 ];
                    }),

                    "last": createPositionalPseudo(function( matchIndexes, length ) {
                        return [ length - 1 ];
                    }),

                    "eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
                        return [ argument < 0 ? argument + length : argument ];
                    }),

                    "even": createPositionalPseudo(function( matchIndexes, length ) {
                        var i = 0;
                        for ( ; i < length; i += 2 ) {
                            matchIndexes.push( i );
                        }
                        return matchIndexes;
                    }),

                    "odd": createPositionalPseudo(function( matchIndexes, length ) {
                        var i = 1;
                        for ( ; i < length; i += 2 ) {
                            matchIndexes.push( i );
                        }
                        return matchIndexes;
                    }),

                    "lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
                        var i = argument < 0 ? argument + length : argument;
                        for ( ; --i >= 0; ) {
                            matchIndexes.push( i );
                        }
                        return matchIndexes;
                    }),

                    "gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
                        var i = argument < 0 ? argument + length : argument;
                        for ( ; ++i < length; ) {
                            matchIndexes.push( i );
                        }
                        return matchIndexes;
                    })
                }
            };

            Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
            for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
                Expr.pseudos[ i ] = createInputPseudo( i );
            }
            for ( i in { submit: true, reset: true } ) {
                Expr.pseudos[ i ] = createButtonPseudo( i );
            }

// Easy API for creating new setFilters
            function setFilters() {}
            setFilters.prototype = Expr.filters = Expr.pseudos;
            Expr.setFilters = new setFilters();

            tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
                var matched, match, tokens, type,
                    soFar, groups, preFilters,
                    cached = tokenCache[ selector + " " ];

                if ( cached ) {
                    return parseOnly ? 0 : cached.slice( 0 );
                }

                soFar = selector;
                groups = [];
                preFilters = Expr.preFilter;

                while ( soFar ) {

                    // Comma and first run
                    if ( !matched || (match = rcomma.exec( soFar )) ) {
                        if ( match ) {
                            // Don't consume trailing commas as valid
                            soFar = soFar.slice( match[0].length ) || soFar;
                        }
                        groups.push( (tokens = []) );
                    }

                    matched = false;

                    // Combinators
                    if ( (match = rcombinators.exec( soFar )) ) {
                        matched = match.shift();
                        tokens.push({
                            value: matched,
                            // Cast descendant combinators to space
                            type: match[0].replace( rtrim, " " )
                        });
                        soFar = soFar.slice( matched.length );
                    }

                    // Filters
                    for ( type in Expr.filter ) {
                        if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
                                (match = preFilters[ type ]( match ))) ) {
                            matched = match.shift();
                            tokens.push({
                                value: matched,
                                type: type,
                                matches: match
                            });
                            soFar = soFar.slice( matched.length );
                        }
                    }

                    if ( !matched ) {
                        break;
                    }
                }

                // Return the length of the invalid excess
                // if we're just parsing
                // Otherwise, throw an error or return tokens
                return parseOnly ?
                    soFar.length :
                    soFar ?
                        Sizzle.error( selector ) :
                        // Cache the tokens
                        tokenCache( selector, groups ).slice( 0 );
            };

            function toSelector( tokens ) {
                var i = 0,
                    len = tokens.length,
                    selector = "";
                for ( ; i < len; i++ ) {
                    selector += tokens[i].value;
                }
                return selector;
            }

            function addCombinator( matcher, combinator, base ) {
                var dir = combinator.dir,
                    skip = combinator.next,
                    key = skip || dir,
                    checkNonElements = base && key === "parentNode",
                    doneName = done++;

                return combinator.first ?
                    // Check against closest ancestor/preceding element
                    function( elem, context, xml ) {
                        while ( (elem = elem[ dir ]) ) {
                            if ( elem.nodeType === 1 || checkNonElements ) {
                                return matcher( elem, context, xml );
                            }
                        }
                        return false;
                    } :

                    // Check against all ancestor/preceding elements
                    function( elem, context, xml ) {
                        var oldCache, uniqueCache, outerCache,
                            newCache = [ dirruns, doneName ];

                        // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                        if ( xml ) {
                            while ( (elem = elem[ dir ]) ) {
                                if ( elem.nodeType === 1 || checkNonElements ) {
                                    if ( matcher( elem, context, xml ) ) {
                                        return true;
                                    }
                                }
                            }
                        } else {
                            while ( (elem = elem[ dir ]) ) {
                                if ( elem.nodeType === 1 || checkNonElements ) {
                                    outerCache = elem[ expando ] || (elem[ expando ] = {});

                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

                                    if ( skip && skip === elem.nodeName.toLowerCase() ) {
                                        elem = elem[ dir ] || elem;
                                    } else if ( (oldCache = uniqueCache[ key ]) &&
                                        oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

                                        // Assign to newCache so results back-propagate to previous elements
                                        return (newCache[ 2 ] = oldCache[ 2 ]);
                                    } else {
                                        // Reuse newcache so results back-propagate to previous elements
                                        uniqueCache[ key ] = newCache;

                                        // A match means we're done; a fail means we have to keep checking
                                        if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
                                            return true;
                                        }
                                    }
                                }
                            }
                        }
                        return false;
                    };
            }

            function elementMatcher( matchers ) {
                return matchers.length > 1 ?
                    function( elem, context, xml ) {
                        var i = matchers.length;
                        while ( i-- ) {
                            if ( !matchers[i]( elem, context, xml ) ) {
                                return false;
                            }
                        }
                        return true;
                    } :
                    matchers[0];
            }

            function multipleContexts( selector, contexts, results ) {
                var i = 0,
                    len = contexts.length;
                for ( ; i < len; i++ ) {
                    Sizzle( selector, contexts[i], results );
                }
                return results;
            }

            function condense( unmatched, map, filter, context, xml ) {
                var elem,
                    newUnmatched = [],
                    i = 0,
                    len = unmatched.length,
                    mapped = map != null;

                for ( ; i < len; i++ ) {
                    if ( (elem = unmatched[i]) ) {
                        if ( !filter || filter( elem, context, xml ) ) {
                            newUnmatched.push( elem );
                            if ( mapped ) {
                                map.push( i );
                            }
                        }
                    }
                }

                return newUnmatched;
            }

            function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
                if ( postFilter && !postFilter[ expando ] ) {
                    postFilter = setMatcher( postFilter );
                }
                if ( postFinder && !postFinder[ expando ] ) {
                    postFinder = setMatcher( postFinder, postSelector );
                }
                return markFunction(function( seed, results, context, xml ) {
                    var temp, i, elem,
                        preMap = [],
                        postMap = [],
                        preexisting = results.length,

                        // Get initial elements from seed or context
                        elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

                        // Prefilter to get matcher input, preserving a map for seed-results synchronization
                        matcherIn = preFilter && ( seed || !selector ) ?
                            condense( elems, preMap, preFilter, context, xml ) :
                            elems,

                        matcherOut = matcher ?
                            // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                            postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

                                // ...intermediate processing is necessary
                                [] :

                                // ...otherwise use results directly
                                results :
                            matcherIn;

                    // Find primary matches
                    if ( matcher ) {
                        matcher( matcherIn, matcherOut, context, xml );
                    }

                    // Apply postFilter
                    if ( postFilter ) {
                        temp = condense( matcherOut, postMap );
                        postFilter( temp, [], context, xml );

                        // Un-match failing elements by moving them back to matcherIn
                        i = temp.length;
                        while ( i-- ) {
                            if ( (elem = temp[i]) ) {
                                matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
                            }
                        }
                    }

                    if ( seed ) {
                        if ( postFinder || preFilter ) {
                            if ( postFinder ) {
                                // Get the final matcherOut by condensing this intermediate into postFinder contexts
                                temp = [];
                                i = matcherOut.length;
                                while ( i-- ) {
                                    if ( (elem = matcherOut[i]) ) {
                                        // Restore matcherIn since elem is not yet a final match
                                        temp.push( (matcherIn[i] = elem) );
                                    }
                                }
                                postFinder( null, (matcherOut = []), temp, xml );
                            }

                            // Move matched elements from seed to results to keep them synchronized
                            i = matcherOut.length;
                            while ( i-- ) {
                                if ( (elem = matcherOut[i]) &&
                                    (temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

                                    seed[temp] = !(results[temp] = elem);
                                }
                            }
                        }

                        // Add elements to results, through postFinder if defined
                    } else {
                        matcherOut = condense(
                            matcherOut === results ?
                                matcherOut.splice( preexisting, matcherOut.length ) :
                                matcherOut
                        );
                        if ( postFinder ) {
                            postFinder( null, results, matcherOut, xml );
                        } else {
                            push.apply( results, matcherOut );
                        }
                    }
                });
            }

            function matcherFromTokens( tokens ) {
                var checkContext, matcher, j,
                    len = tokens.length,
                    leadingRelative = Expr.relative[ tokens[0].type ],
                    implicitRelative = leadingRelative || Expr.relative[" "],
                    i = leadingRelative ? 1 : 0,

                    // The foundational matcher ensures that elements are reachable from top-level context(s)
                    matchContext = addCombinator( function( elem ) {
                        return elem === checkContext;
                    }, implicitRelative, true ),
                    matchAnyContext = addCombinator( function( elem ) {
                        return indexOf( checkContext, elem ) > -1;
                    }, implicitRelative, true ),
                    matchers = [ function( elem, context, xml ) {
                        var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
                            (checkContext = context).nodeType ?
                                matchContext( elem, context, xml ) :
                                matchAnyContext( elem, context, xml ) );
                        // Avoid hanging onto element (issue #299)
                        checkContext = null;
                        return ret;
                    } ];

                for ( ; i < len; i++ ) {
                    if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
                        matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
                    } else {
                        matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

                        // Return special upon seeing a positional matcher
                        if ( matcher[ expando ] ) {
                            // Find the next relative operator (if any) for proper handling
                            j = ++i;
                            for ( ; j < len; j++ ) {
                                if ( Expr.relative[ tokens[j].type ] ) {
                                    break;
                                }
                            }
                            return setMatcher(
                                i > 1 && elementMatcher( matchers ),
                                i > 1 && toSelector(
                                // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                                tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
                                ).replace( rtrim, "$1" ),
                                matcher,
                                i < j && matcherFromTokens( tokens.slice( i, j ) ),
                                j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
                                j < len && toSelector( tokens )
                            );
                        }
                        matchers.push( matcher );
                    }
                }

                return elementMatcher( matchers );
            }

            function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
                var bySet = setMatchers.length > 0,
                    byElement = elementMatchers.length > 0,
                    superMatcher = function( seed, context, xml, results, outermost ) {
                        var elem, j, matcher,
                            matchedCount = 0,
                            i = "0",
                            unmatched = seed && [],
                            setMatched = [],
                            contextBackup = outermostContext,
                            // We must always have either seed elements or outermost context
                            elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
                            // Use integer dirruns iff this is the outermost matcher
                            dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
                            len = elems.length;

                        if ( outermost ) {
                            outermostContext = context === document || context || outermost;
                        }

                        // Add elements passing elementMatchers directly to results
                        // Support: IE<9, Safari
                        // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                        for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
                            if ( byElement && elem ) {
                                j = 0;
                                if ( !context && elem.ownerDocument !== document ) {
                                    setDocument( elem );
                                    xml = !documentIsHTML;
                                }
                                while ( (matcher = elementMatchers[j++]) ) {
                                    if ( matcher( elem, context || document, xml) ) {
                                        results.push( elem );
                                        break;
                                    }
                                }
                                if ( outermost ) {
                                    dirruns = dirrunsUnique;
                                }
                            }

                            // Track unmatched elements for set filters
                            if ( bySet ) {
                                // They will have gone through all possible matchers
                                if ( (elem = !matcher && elem) ) {
                                    matchedCount--;
                                }

                                // Lengthen the array for every element, matched or not
                                if ( seed ) {
                                    unmatched.push( elem );
                                }
                            }
                        }

                        // `i` is now the count of elements visited above, and adding it to `matchedCount`
                        // makes the latter nonnegative.
                        matchedCount += i;

                        // Apply set filters to unmatched elements
                        // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                        // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                        // no element matchers and no seed.
                        // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                        // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                        // numerically zero.
                        if ( bySet && i !== matchedCount ) {
                            j = 0;
                            while ( (matcher = setMatchers[j++]) ) {
                                matcher( unmatched, setMatched, context, xml );
                            }

                            if ( seed ) {
                                // Reintegrate element matches to eliminate the need for sorting
                                if ( matchedCount > 0 ) {
                                    while ( i-- ) {
                                        if ( !(unmatched[i] || setMatched[i]) ) {
                                            setMatched[i] = pop.call( results );
                                        }
                                    }
                                }

                                // Discard index placeholder values to get only actual matches
                                setMatched = condense( setMatched );
                            }

                            // Add matches to results
                            push.apply( results, setMatched );

                            // Seedless set matches succeeding multiple successful matchers stipulate sorting
                            if ( outermost && !seed && setMatched.length > 0 &&
                                ( matchedCount + setMatchers.length ) > 1 ) {

                                Sizzle.uniqueSort( results );
                            }
                        }

                        // Override manipulation of globals by nested matchers
                        if ( outermost ) {
                            dirruns = dirrunsUnique;
                            outermostContext = contextBackup;
                        }

                        return unmatched;
                    };

                return bySet ?
                    markFunction( superMatcher ) :
                    superMatcher;
            }

            compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
                var i,
                    setMatchers = [],
                    elementMatchers = [],
                    cached = compilerCache[ selector + " " ];

                if ( !cached ) {
                    // Generate a function of recursive functions that can be used to check each element
                    if ( !match ) {
                        match = tokenize( selector );
                    }
                    i = match.length;
                    while ( i-- ) {
                        cached = matcherFromTokens( match[i] );
                        if ( cached[ expando ] ) {
                            setMatchers.push( cached );
                        } else {
                            elementMatchers.push( cached );
                        }
                    }

                    // Cache the compiled function
                    cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

                    // Save selector and tokenization
                    cached.selector = selector;
                }
                return cached;
            };

            /**
             * A low-level selection function that works with Sizzle's compiled
             *  selector functions
             * @param {String|Function} selector A selector or a pre-compiled
             *  selector function built with Sizzle.compile
             * @param {Element} context
             * @param {Array} [results]
             * @param {Array} [seed] A set of elements to match against
             */
            select = Sizzle.select = function( selector, context, results, seed ) {
                var i, tokens, token, type, find,
                    compiled = typeof selector === "function" && selector,
                    match = !seed && tokenize( (selector = compiled.selector || selector) );

                results = results || [];

                // Try to minimize operations if there is only one selector in the list and no seed
                // (the latter of which guarantees us context)
                if ( match.length === 1 ) {

                    // Reduce context if the leading compound selector is an ID
                    tokens = match[0] = match[0].slice( 0 );
                    if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
                        context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

                        context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
                        if ( !context ) {
                            return results;

                            // Precompiled matchers will still verify ancestry, so step up a level
                        } else if ( compiled ) {
                            context = context.parentNode;
                        }

                        selector = selector.slice( tokens.shift().value.length );
                    }

                    // Fetch a seed set for right-to-left matching
                    i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
                    while ( i-- ) {
                        token = tokens[i];

                        // Abort if we hit a combinator
                        if ( Expr.relative[ (type = token.type) ] ) {
                            break;
                        }
                        if ( (find = Expr.find[ type ]) ) {
                            // Search, expanding context for leading sibling combinators
                            if ( (seed = find(
                                    token.matches[0].replace( runescape, funescape ),
                                    rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
                                )) ) {

                                // If seed is empty or no tokens remain, we can return early
                                tokens.splice( i, 1 );
                                selector = seed.length && toSelector( tokens );
                                if ( !selector ) {
                                    push.apply( results, seed );
                                    return results;
                                }

                                break;
                            }
                        }
                    }
                }

                // Compile and execute a filtering function if one is not provided
                // Provide `match` to avoid retokenization if we modified the selector above
                ( compiled || compile( selector, match ) )(
                    seed,
                    context,
                    !documentIsHTML,
                    results,
                    !context || rsibling.test( selector ) && testContext( context.parentNode ) || context
                );
                return results;
            };

// One-time assignments

// Sort stability
            support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
            support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
            setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
            support.sortDetached = assert(function( el ) {
                // Should return 1, but returns 4 (following)
                return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
            });

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
            if ( !assert(function( el ) {
                    el.innerHTML = "<a href='#'></a>";
                    return el.firstChild.getAttribute("href") === "#" ;
                }) ) {
                addHandle( "type|href|height|width", function( elem, name, isXML ) {
                    if ( !isXML ) {
                        return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
                    }
                });
            }

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
            if ( !support.attributes || !assert(function( el ) {
                    el.innerHTML = "<input/>";
                    el.firstChild.setAttribute( "value", "" );
                    return el.firstChild.getAttribute( "value" ) === "";
                }) ) {
                addHandle( "value", function( elem, name, isXML ) {
                    if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
                        return elem.defaultValue;
                    }
                });
            }

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
            if ( !assert(function( el ) {
                    return el.getAttribute("disabled") == null;
                }) ) {
                addHandle( booleans, function( elem, name, isXML ) {
                    var val;
                    if ( !isXML ) {
                        return elem[ name ] === true ? name.toLowerCase() :
                            (val = elem.getAttributeNode( name )) && val.specified ?
                                val.value :
                                null;
                    }
                });
            }

            return Sizzle;

        })( window );



    jQuery.find = Sizzle;
    jQuery.expr = Sizzle.selectors;

// Deprecated
    jQuery.expr[ ":" ] = jQuery.expr.pseudos;
    jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
    jQuery.text = Sizzle.getText;
    jQuery.isXMLDoc = Sizzle.isXML;
    jQuery.contains = Sizzle.contains;
    jQuery.escapeSelector = Sizzle.escape;




    var dir = function( elem, dir, until ) {
        var matched = [],
            truncate = until !== undefined;

        while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
            if ( elem.nodeType === 1 ) {
                if ( truncate && jQuery( elem ).is( until ) ) {
                    break;
                }
                matched.push( elem );
            }
        }
        return matched;
    };


    var siblings = function( n, elem ) {
        var matched = [];

        for ( ; n; n = n.nextSibling ) {
            if ( n.nodeType === 1 && n !== elem ) {
                matched.push( n );
            }
        }

        return matched;
    };


    var rneedsContext = jQuery.expr.match.needsContext;



    function nodeName( elem, name ) {

        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

    };
    var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



    var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
    function winnow( elements, qualifier, not ) {
        if ( jQuery.isFunction( qualifier ) ) {
            return jQuery.grep( elements, function( elem, i ) {
                return !!qualifier.call( elem, i, elem ) !== not;
            } );
        }

        // Single element
        if ( qualifier.nodeType ) {
            return jQuery.grep( elements, function( elem ) {
                return ( elem === qualifier ) !== not;
            } );
        }

        // Arraylike of elements (jQuery, arguments, Array)
        if ( typeof qualifier !== "string" ) {
            return jQuery.grep( elements, function( elem ) {
                return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
            } );
        }

        // Simple selector that can be filtered directly, removing non-Elements
        if ( risSimple.test( qualifier ) ) {
            return jQuery.filter( qualifier, elements, not );
        }

        // Complex selector, compare the two sets, removing non-Elements
        qualifier = jQuery.filter( qualifier, elements );
        return jQuery.grep( elements, function( elem ) {
            return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
        } );
    }

    jQuery.filter = function( expr, elems, not ) {
        var elem = elems[ 0 ];

        if ( not ) {
            expr = ":not(" + expr + ")";
        }

        if ( elems.length === 1 && elem.nodeType === 1 ) {
            return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
        }

        return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
            return elem.nodeType === 1;
        } ) );
    };

    jQuery.fn.extend( {
        find: function( selector ) {
            var i, ret,
                len = this.length,
                self = this;

            if ( typeof selector !== "string" ) {
                return this.pushStack( jQuery( selector ).filter( function() {
                    for ( i = 0; i < len; i++ ) {
                        if ( jQuery.contains( self[ i ], this ) ) {
                            return true;
                        }
                    }
                } ) );
            }

            ret = this.pushStack( [] );

            for ( i = 0; i < len; i++ ) {
                jQuery.find( selector, self[ i ], ret );
            }

            return len > 1 ? jQuery.uniqueSort( ret ) : ret;
        },
        filter: function( selector ) {
            return this.pushStack( winnow( this, selector || [], false ) );
        },
        not: function( selector ) {
            return this.pushStack( winnow( this, selector || [], true ) );
        },
        is: function( selector ) {
            return !!winnow(
                this,

                // If this is a positional/relative selector, check membership in the returned set
                // so $("p:first").is("p:last") won't return true for a doc with two "p".
                typeof selector === "string" && rneedsContext.test( selector ) ?
                    jQuery( selector ) :
                    selector || [],
                false
            ).length;
        }
    } );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
    var rootjQuery,

        // A simple way to check for HTML strings
        // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
        // Strict HTML recognition (#11290: must start with <)
        // Shortcut simple #id case for speed
        rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

        init = jQuery.fn.init = function( selector, context, root ) {
            var match, elem;

            // HANDLE: $(""), $(null), $(undefined), $(false)
            if ( !selector ) {
                return this;
            }

            // Method init() accepts an alternate rootjQuery
            // so migrate can support jQuery.sub (gh-2101)
            root = root || rootjQuery;

            // Handle HTML strings
            if ( typeof selector === "string" ) {
                if ( selector[ 0 ] === "<" &&
                    selector[ selector.length - 1 ] === ">" &&
                    selector.length >= 3 ) {

                    // Assume that strings that start and end with <> are HTML and skip the regex check
                    match = [ null, selector, null ];

                } else {
                    match = rquickExpr.exec( selector );
                }

                // Match html or make sure no context is specified for #id
                if ( match && ( match[ 1 ] || !context ) ) {

                    // HANDLE: $(html) -> $(array)
                    if ( match[ 1 ] ) {
                        context = context instanceof jQuery ? context[ 0 ] : context;

                        // Option to run scripts is true for back-compat
                        // Intentionally let the error be thrown if parseHTML is not present
                        jQuery.merge( this, jQuery.parseHTML(
                            match[ 1 ],
                            context && context.nodeType ? context.ownerDocument || context : document,
                            true
                        ) );

                        // HANDLE: $(html, props)
                        if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
                            for ( match in context ) {

                                // Properties of context are called as methods if possible
                                if ( jQuery.isFunction( this[ match ] ) ) {
                                    this[ match ]( context[ match ] );

                                    // ...and otherwise set as attributes
                                } else {
                                    this.attr( match, context[ match ] );
                                }
                            }
                        }

                        return this;

                        // HANDLE: $(#id)
                    } else {
                        elem = document.getElementById( match[ 2 ] );

                        if ( elem ) {

                            // Inject the element directly into the jQuery object
                            this[ 0 ] = elem;
                            this.length = 1;
                        }
                        return this;
                    }

                    // HANDLE: $(expr, $(...))
                } else if ( !context || context.jquery ) {
                    return ( context || root ).find( selector );

                    // HANDLE: $(expr, context)
                    // (which is just equivalent to: $(context).find(expr)
                } else {
                    return this.constructor( context ).find( selector );
                }

                // HANDLE: $(DOMElement)
            } else if ( selector.nodeType ) {
                this[ 0 ] = selector;
                this.length = 1;
                return this;

                // HANDLE: $(function)
                // Shortcut for document ready
            } else if ( jQuery.isFunction( selector ) ) {
                return root.ready !== undefined ?
                    root.ready( selector ) :

                    // Execute immediately if ready is not present
                    selector( jQuery );
            }

            return jQuery.makeArray( selector, this );
        };

// Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;

// Initialize central reference
    rootjQuery = jQuery( document );


    var rparentsprev = /^(?:parents|prev(?:Until|All))/,

        // Methods guaranteed to produce a unique set when starting from a unique set
        guaranteedUnique = {
            children: true,
            contents: true,
            next: true,
            prev: true
        };

    jQuery.fn.extend( {
        has: function( target ) {
            var targets = jQuery( target, this ),
                l = targets.length;

            return this.filter( function() {
                var i = 0;
                for ( ; i < l; i++ ) {
                    if ( jQuery.contains( this, targets[ i ] ) ) {
                        return true;
                    }
                }
            } );
        },

        closest: function( selectors, context ) {
            var cur,
                i = 0,
                l = this.length,
                matched = [],
                targets = typeof selectors !== "string" && jQuery( selectors );

            // Positional selectors never match, since there's no _selection_ context
            if ( !rneedsContext.test( selectors ) ) {
                for ( ; i < l; i++ ) {
                    for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

                        // Always skip document fragments
                        if ( cur.nodeType < 11 && ( targets ?
                                targets.index( cur ) > -1 :

                                // Don't pass non-elements to Sizzle
                                cur.nodeType === 1 &&
                                jQuery.find.matchesSelector( cur, selectors ) ) ) {

                            matched.push( cur );
                            break;
                        }
                    }
                }
            }

            return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
        },

        // Determine the position of an element within the set
        index: function( elem ) {

            // No argument, return index in parent
            if ( !elem ) {
                return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
            }

            // Index in selector
            if ( typeof elem === "string" ) {
                return indexOf.call( jQuery( elem ), this[ 0 ] );
            }

            // Locate the position of the desired element
            return indexOf.call( this,

                // If it receives a jQuery object, the first element is used
                elem.jquery ? elem[ 0 ] : elem
            );
        },

        add: function( selector, context ) {
            return this.pushStack(
                jQuery.uniqueSort(
                    jQuery.merge( this.get(), jQuery( selector, context ) )
                )
            );
        },

        addBack: function( selector ) {
            return this.add( selector == null ?
                this.prevObject : this.prevObject.filter( selector )
            );
        }
    } );

    function sibling( cur, dir ) {
        while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
        return cur;
    }

    jQuery.each( {
        parent: function( elem ) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function( elem ) {
            return dir( elem, "parentNode" );
        },
        parentsUntil: function( elem, i, until ) {
            return dir( elem, "parentNode", until );
        },
        next: function( elem ) {
            return sibling( elem, "nextSibling" );
        },
        prev: function( elem ) {
            return sibling( elem, "previousSibling" );
        },
        nextAll: function( elem ) {
            return dir( elem, "nextSibling" );
        },
        prevAll: function( elem ) {
            return dir( elem, "previousSibling" );
        },
        nextUntil: function( elem, i, until ) {
            return dir( elem, "nextSibling", until );
        },
        prevUntil: function( elem, i, until ) {
            return dir( elem, "previousSibling", until );
        },
        siblings: function( elem ) {
            return siblings( ( elem.parentNode || {} ).firstChild, elem );
        },
        children: function( elem ) {
            return siblings( elem.firstChild );
        },
        contents: function( elem ) {
            if ( nodeName( elem, "iframe" ) ) {
                return elem.contentDocument;
            }

            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if ( nodeName( elem, "template" ) ) {
                elem = elem.content || elem;
            }

            return jQuery.merge( [], elem.childNodes );
        }
    }, function( name, fn ) {
        jQuery.fn[ name ] = function( until, selector ) {
            var matched = jQuery.map( this, fn, until );

            if ( name.slice( -5 ) !== "Until" ) {
                selector = until;
            }

            if ( selector && typeof selector === "string" ) {
                matched = jQuery.filter( selector, matched );
            }

            if ( this.length > 1 ) {

                // Remove duplicates
                if ( !guaranteedUnique[ name ] ) {
                    jQuery.uniqueSort( matched );
                }

                // Reverse order for parents* and prev-derivatives
                if ( rparentsprev.test( name ) ) {
                    matched.reverse();
                }
            }

            return this.pushStack( matched );
        };
    } );
    var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
    function createOptions( options ) {
        var object = {};
        jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
            object[ flag ] = true;
        } );
        return object;
    }

    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
    jQuery.Callbacks = function( options ) {

        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ?
            createOptions( options ) :
            jQuery.extend( {}, options );

        var // Flag to know if list is currently firing
            firing,

            // Last fire value for non-forgettable lists
            memory,

            // Flag to know if list was already fired
            fired,

            // Flag to prevent firing
            locked,

            // Actual callback list
            list = [],

            // Queue of execution data for repeatable lists
            queue = [],

            // Index of currently firing callback (modified by add/remove as needed)
            firingIndex = -1,

            // Fire callbacks
            fire = function() {

                // Enforce single-firing
                locked = locked || options.once;

                // Execute callbacks for all pending executions,
                // respecting firingIndex overrides and runtime changes
                fired = firing = true;
                for ( ; queue.length; firingIndex = -1 ) {
                    memory = queue.shift();
                    while ( ++firingIndex < list.length ) {

                        // Run callback and check for early termination
                        if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
                            options.stopOnFalse ) {

                            // Jump to end and forget the data so .add doesn't re-fire
                            firingIndex = list.length;
                            memory = false;
                        }
                    }
                }

                // Forget the data if we're done with it
                if ( !options.memory ) {
                    memory = false;
                }

                firing = false;

                // Clean up if we're done firing for good
                if ( locked ) {

                    // Keep an empty list if we have data for future add calls
                    if ( memory ) {
                        list = [];

                        // Otherwise, this object is spent
                    } else {
                        list = "";
                    }
                }
            },

            // Actual Callbacks object
            self = {

                // Add a callback or a collection of callbacks to the list
                add: function() {
                    if ( list ) {

                        // If we have memory from a past run, we should fire after adding
                        if ( memory && !firing ) {
                            firingIndex = list.length - 1;
                            queue.push( memory );
                        }

                        ( function add( args ) {
                            jQuery.each( args, function( _, arg ) {
                                if ( jQuery.isFunction( arg ) ) {
                                    if ( !options.unique || !self.has( arg ) ) {
                                        list.push( arg );
                                    }
                                } else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

                                    // Inspect recursively
                                    add( arg );
                                }
                            } );
                        } )( arguments );

                        if ( memory && !firing ) {
                            fire();
                        }
                    }
                    return this;
                },

                // Remove a callback from the list
                remove: function() {
                    jQuery.each( arguments, function( _, arg ) {
                        var index;
                        while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
                            list.splice( index, 1 );

                            // Handle firing indexes
                            if ( index <= firingIndex ) {
                                firingIndex--;
                            }
                        }
                    } );
                    return this;
                },

                // Check if a given callback is in the list.
                // If no argument is given, return whether or not list has callbacks attached.
                has: function( fn ) {
                    return fn ?
                        jQuery.inArray( fn, list ) > -1 :
                        list.length > 0;
                },

                // Remove all callbacks from the list
                empty: function() {
                    if ( list ) {
                        list = [];
                    }
                    return this;
                },

                // Disable .fire and .add
                // Abort any current/pending executions
                // Clear all callbacks and values
                disable: function() {
                    locked = queue = [];
                    list = memory = "";
                    return this;
                },
                disabled: function() {
                    return !list;
                },

                // Disable .fire
                // Also disable .add unless we have memory (since it would have no effect)
                // Abort any pending executions
                lock: function() {
                    locked = queue = [];
                    if ( !memory && !firing ) {
                        list = memory = "";
                    }
                    return this;
                },
                locked: function() {
                    return !!locked;
                },

                // Call all callbacks with the given context and arguments
                fireWith: function( context, args ) {
                    if ( !locked ) {
                        args = args || [];
                        args = [ context, args.slice ? args.slice() : args ];
                        queue.push( args );
                        if ( !firing ) {
                            fire();
                        }
                    }
                    return this;
                },

                // Call all the callbacks with the given arguments
                fire: function() {
                    self.fireWith( this, arguments );
                    return this;
                },

                // To know if the callbacks have already been called at least once
                fired: function() {
                    return !!fired;
                }
            };

        return self;
    };


    function Identity( v ) {
        return v;
    }
    function Thrower( ex ) {
        throw ex;
    }

    function adoptValue( value, resolve, reject, noValue ) {
        var method;

        try {

            // Check for promise aspect first to privilege synchronous behavior
            if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
                method.call( value ).done( resolve ).fail( reject );

                // Other thenables
            } else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
                method.call( value, resolve, reject );

                // Other non-thenables
            } else {

                // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
                // * false: [ value ].slice( 0 ) => resolve( value )
                // * true: [ value ].slice( 1 ) => resolve()
                resolve.apply( undefined, [ value ].slice( noValue ) );
            }

            // For Promises/A+, convert exceptions into rejections
            // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
            // Deferred#then to conditionally suppress rejection.
        } catch ( value ) {

            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply( undefined, [ value ] );
        }
    }

    jQuery.extend( {

        Deferred: function( func ) {
            var tuples = [

                    // action, add listener, callbacks,
                    // ... .then handlers, argument index, [final state]
                    [ "notify", "progress", jQuery.Callbacks( "memory" ),
                        jQuery.Callbacks( "memory" ), 2 ],
                    [ "resolve", "done", jQuery.Callbacks( "once memory" ),
                        jQuery.Callbacks( "once memory" ), 0, "resolved" ],
                    [ "reject", "fail", jQuery.Callbacks( "once memory" ),
                        jQuery.Callbacks( "once memory" ), 1, "rejected" ]
                ],
                state = "pending",
                promise = {
                    state: function() {
                        return state;
                    },
                    always: function() {
                        deferred.done( arguments ).fail( arguments );
                        return this;
                    },
                    "catch": function( fn ) {
                        return promise.then( null, fn );
                    },

                    // Keep pipe for back-compat
                    pipe: function( /* fnDone, fnFail, fnProgress */ ) {
                        var fns = arguments;

                        return jQuery.Deferred( function( newDefer ) {
                            jQuery.each( tuples, function( i, tuple ) {

                                // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                                var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

                                // deferred.progress(function() { bind to newDefer or newDefer.notify })
                                // deferred.done(function() { bind to newDefer or newDefer.resolve })
                                // deferred.fail(function() { bind to newDefer or newDefer.reject })
                                deferred[ tuple[ 1 ] ]( function() {
                                    var returned = fn && fn.apply( this, arguments );
                                    if ( returned && jQuery.isFunction( returned.promise ) ) {
                                        returned.promise()
                                            .progress( newDefer.notify )
                                            .done( newDefer.resolve )
                                            .fail( newDefer.reject );
                                    } else {
                                        newDefer[ tuple[ 0 ] + "With" ](
                                            this,
                                            fn ? [ returned ] : arguments
                                        );
                                    }
                                } );
                            } );
                            fns = null;
                        } ).promise();
                    },
                    then: function( onFulfilled, onRejected, onProgress ) {
                        var maxDepth = 0;
                        function resolve( depth, deferred, handler, special ) {
                            return function() {
                                var that = this,
                                    args = arguments,
                                    mightThrow = function() {
                                        var returned, then;

                                        // Support: Promises/A+ section 2.3.3.3.3
                                        // https://promisesaplus.com/#point-59
                                        // Ignore double-resolution attempts
                                        if ( depth < maxDepth ) {
                                            return;
                                        }

                                        returned = handler.apply( that, args );

                                        // Support: Promises/A+ section 2.3.1
                                        // https://promisesaplus.com/#point-48
                                        if ( returned === deferred.promise() ) {
                                            throw new TypeError( "Thenable self-resolution" );
                                        }

                                        // Support: Promises/A+ sections 2.3.3.1, 3.5
                                        // https://promisesaplus.com/#point-54
                                        // https://promisesaplus.com/#point-75
                                        // Retrieve `then` only once
                                        then = returned &&

                                            // Support: Promises/A+ section 2.3.4
                                            // https://promisesaplus.com/#point-64
                                            // Only check objects and functions for thenability
                                            ( typeof returned === "object" ||
                                                typeof returned === "function" ) &&
                                            returned.then;

                                        // Handle a returned thenable
                                        if ( jQuery.isFunction( then ) ) {

                                            // Special processors (notify) just wait for resolution
                                            if ( special ) {
                                                then.call(
                                                    returned,
                                                    resolve( maxDepth, deferred, Identity, special ),
                                                    resolve( maxDepth, deferred, Thrower, special )
                                                );

                                                // Normal processors (resolve) also hook into progress
                                            } else {

                                                // ...and disregard older resolution values
                                                maxDepth++;

                                                then.call(
                                                    returned,
                                                    resolve( maxDepth, deferred, Identity, special ),
                                                    resolve( maxDepth, deferred, Thrower, special ),
                                                    resolve( maxDepth, deferred, Identity,
                                                        deferred.notifyWith )
                                                );
                                            }

                                            // Handle all other returned values
                                        } else {

                                            // Only substitute handlers pass on context
                                            // and multiple values (non-spec behavior)
                                            if ( handler !== Identity ) {
                                                that = undefined;
                                                args = [ returned ];
                                            }

                                            // Process the value(s)
                                            // Default process is resolve
                                            ( special || deferred.resolveWith )( that, args );
                                        }
                                    },

                                    // Only normal processors (resolve) catch and reject exceptions
                                    process = special ?
                                        mightThrow :
                                        function() {
                                            try {
                                                mightThrow();
                                            } catch ( e ) {

                                                if ( jQuery.Deferred.exceptionHook ) {
                                                    jQuery.Deferred.exceptionHook( e,
                                                        process.stackTrace );
                                                }

                                                // Support: Promises/A+ section 2.3.3.3.4.1
                                                // https://promisesaplus.com/#point-61
                                                // Ignore post-resolution exceptions
                                                if ( depth + 1 >= maxDepth ) {

                                                    // Only substitute handlers pass on context
                                                    // and multiple values (non-spec behavior)
                                                    if ( handler !== Thrower ) {
                                                        that = undefined;
                                                        args = [ e ];
                                                    }

                                                    deferred.rejectWith( that, args );
                                                }
                                            }
                                        };

                                // Support: Promises/A+ section 2.3.3.3.1
                                // https://promisesaplus.com/#point-57
                                // Re-resolve promises immediately to dodge false rejection from
                                // subsequent errors
                                if ( depth ) {
                                    process();
                                } else {

                                    // Call an optional hook to record the stack, in case of exception
                                    // since it's otherwise lost when execution goes async
                                    if ( jQuery.Deferred.getStackHook ) {
                                        process.stackTrace = jQuery.Deferred.getStackHook();
                                    }
                                    window.setTimeout( process );
                                }
                            };
                        }

                        return jQuery.Deferred( function( newDefer ) {

                            // progress_handlers.add( ... )
                            tuples[ 0 ][ 3 ].add(
                                resolve(
                                    0,
                                    newDefer,
                                    jQuery.isFunction( onProgress ) ?
                                        onProgress :
                                        Identity,
                                    newDefer.notifyWith
                                )
                            );

                            // fulfilled_handlers.add( ... )
                            tuples[ 1 ][ 3 ].add(
                                resolve(
                                    0,
                                    newDefer,
                                    jQuery.isFunction( onFulfilled ) ?
                                        onFulfilled :
                                        Identity
                                )
                            );

                            // rejected_handlers.add( ... )
                            tuples[ 2 ][ 3 ].add(
                                resolve(
                                    0,
                                    newDefer,
                                    jQuery.isFunction( onRejected ) ?
                                        onRejected :
                                        Thrower
                                )
                            );
                        } ).promise();
                    },

                    // Get a promise for this deferred
                    // If obj is provided, the promise aspect is added to the object
                    promise: function( obj ) {
                        return obj != null ? jQuery.extend( obj, promise ) : promise;
                    }
                },
                deferred = {};

            // Add list-specific methods
            jQuery.each( tuples, function( i, tuple ) {
                var list = tuple[ 2 ],
                    stateString = tuple[ 5 ];

                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[ tuple[ 1 ] ] = list.add;

                // Handle state
                if ( stateString ) {
                    list.add(
                        function() {

                            // state = "resolved" (i.e., fulfilled)
                            // state = "rejected"
                            state = stateString;
                        },

                        // rejected_callbacks.disable
                        // fulfilled_callbacks.disable
                        tuples[ 3 - i ][ 2 ].disable,

                        // progress_callbacks.lock
                        tuples[ 0 ][ 2 ].lock
                    );
                }

                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add( tuple[ 3 ].fire );

                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[ tuple[ 0 ] ] = function() {
                    deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
                    return this;
                };

                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
            } );

            // Make the deferred a promise
            promise.promise( deferred );

            // Call given func if any
            if ( func ) {
                func.call( deferred, deferred );
            }

            // All done!
            return deferred;
        },

        // Deferred helper
        when: function( singleValue ) {
            var

                // count of uncompleted subordinates
                remaining = arguments.length,

                // count of unprocessed arguments
                i = remaining,

                // subordinate fulfillment data
                resolveContexts = Array( i ),
                resolveValues = slice.call( arguments ),

                // the master Deferred
                master = jQuery.Deferred(),

                // subordinate callback factory
                updateFunc = function( i ) {
                    return function( value ) {
                        resolveContexts[ i ] = this;
                        resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
                        if ( !( --remaining ) ) {
                            master.resolveWith( resolveContexts, resolveValues );
                        }
                    };
                };

            // Single- and empty arguments are adopted like Promise.resolve
            if ( remaining <= 1 ) {
                adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
                    !remaining );

                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if ( master.state() === "pending" ||
                    jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

                    return master.then();
                }
            }

            // Multiple arguments are aggregated like Promise.all array elements
            while ( i-- ) {
                adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
            }

            return master.promise();
        }
    } );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

    jQuery.Deferred.exceptionHook = function( error, stack ) {

        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
            window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
        }
    };




    jQuery.readyException = function( error ) {
        window.setTimeout( function() {
            throw error;
        } );
    };




// The deferred used on DOM ready
    var readyList = jQuery.Deferred();

    jQuery.fn.ready = function( fn ) {

        readyList
            .then( fn )

            // Wrap jQuery.readyException in a function so that the lookup
            // happens at the time of error handling instead of callback
            // signup.
            .catch( function( error ) {
                jQuery.readyException( error );
            } );

        return this;
    };

    jQuery.extend( {

        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,

        // A counter to track how many items to wait for before
        // the ready event fires. See #6781
        readyWait: 1,

        // Handle when the DOM is ready
        ready: function( wait ) {

            // Abort if there are pending holds or we're already ready
            if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
                return;
            }

            // Remember that the DOM is ready
            jQuery.isReady = true;

            // If a normal DOM Ready event fired, decrement, and wait if need be
            if ( wait !== true && --jQuery.readyWait > 0 ) {
                return;
            }

            // If there are functions bound, to execute
            readyList.resolveWith( document, [ jQuery ] );
        }
    } );

    jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener( "DOMContentLoaded", completed );
        window.removeEventListener( "load", completed );
        jQuery.ready();
    }

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
    if ( document.readyState === "complete" ||
        ( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

        // Handle it asynchronously to allow scripts the opportunity to delay ready
        window.setTimeout( jQuery.ready );

    } else {

        // Use the handy event callback
        document.addEventListener( "DOMContentLoaded", completed );

        // A fallback to window.onload, that will always work
        window.addEventListener( "load", completed );
    }




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
    var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
        var i = 0,
            len = elems.length,
            bulk = key == null;

        // Sets many values
        if ( jQuery.type( key ) === "object" ) {
            chainable = true;
            for ( i in key ) {
                access( elems, fn, i, key[ i ], true, emptyGet, raw );
            }

            // Sets one value
        } else if ( value !== undefined ) {
            chainable = true;

            if ( !jQuery.isFunction( value ) ) {
                raw = true;
            }

            if ( bulk ) {

                // Bulk operations run against the entire set
                if ( raw ) {
                    fn.call( elems, value );
                    fn = null;

                    // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function( elem, key, value ) {
                        return bulk.call( jQuery( elem ), value );
                    };
                }
            }

            if ( fn ) {
                for ( ; i < len; i++ ) {
                    fn(
                        elems[ i ], key, raw ?
                            value :
                            value.call( elems[ i ], i, fn( elems[ i ], key ) )
                    );
                }
            }
        }

        if ( chainable ) {
            return elems;
        }

        // Gets
        if ( bulk ) {
            return fn.call( elems );
        }

        return len ? fn( elems[ 0 ], key ) : emptyGet;
    };
    var acceptData = function( owner ) {

        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
    };




    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }

    Data.uid = 1;

    Data.prototype = {

        cache: function( owner ) {

            // Check if the owner object already has a cache
            var value = owner[ this.expando ];

            // If not, create one
            if ( !value ) {
                value = {};

                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see #8335.
                // Always return an empty object.
                if ( acceptData( owner ) ) {

                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if ( owner.nodeType ) {
                        owner[ this.expando ] = value;

                        // Otherwise secure it in a non-enumerable property
                        // configurable must be true to allow the property to be
                        // deleted when data is removed
                    } else {
                        Object.defineProperty( owner, this.expando, {
                            value: value,
                            configurable: true
                        } );
                    }
                }
            }

            return value;
        },
        set: function( owner, data, value ) {
            var prop,
                cache = this.cache( owner );

            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if ( typeof data === "string" ) {
                cache[ jQuery.camelCase( data ) ] = value;

                // Handle: [ owner, { properties } ] args
            } else {

                // Copy the properties one-by-one to the cache object
                for ( prop in data ) {
                    cache[ jQuery.camelCase( prop ) ] = data[ prop ];
                }
            }
            return cache;
        },
        get: function( owner, key ) {
            return key === undefined ?
                this.cache( owner ) :

                // Always use camelCase key (gh-2257)
                owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
        },
        access: function( owner, key, value ) {

            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if ( key === undefined ||
                ( ( key && typeof key === "string" ) && value === undefined ) ) {

                return this.get( owner, key );
            }

            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set( owner, key, value );

            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function( owner, key ) {
            var i,
                cache = owner[ this.expando ];

            if ( cache === undefined ) {
                return;
            }

            if ( key !== undefined ) {

                // Support array or space separated string of keys
                if ( Array.isArray( key ) ) {

                    // If key is an array of keys...
                    // We always set camelCase keys, so remove that.
                    key = key.map( jQuery.camelCase );
                } else {
                    key = jQuery.camelCase( key );

                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ?
                        [ key ] :
                        ( key.match( rnothtmlwhite ) || [] );
                }

                i = key.length;

                while ( i-- ) {
                    delete cache[ key[ i ] ];
                }
            }

            // Remove the expando if there's no more data
            if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if ( owner.nodeType ) {
                    owner[ this.expando ] = undefined;
                } else {
                    delete owner[ this.expando ];
                }
            }
        },
        hasData: function( owner ) {
            var cache = owner[ this.expando ];
            return cache !== undefined && !jQuery.isEmptyObject( cache );
        }
    };
    var dataPriv = new Data();

    var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        rmultiDash = /[A-Z]/g;

    function getData( data ) {
        if ( data === "true" ) {
            return true;
        }

        if ( data === "false" ) {
            return false;
        }

        if ( data === "null" ) {
            return null;
        }

        // Only convert to a number if it doesn't change the string
        if ( data === +data + "" ) {
            return +data;
        }

        if ( rbrace.test( data ) ) {
            return JSON.parse( data );
        }

        return data;
    }

    function dataAttr( elem, key, data ) {
        var name;

        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if ( data === undefined && elem.nodeType === 1 ) {
            name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
            data = elem.getAttribute( name );

            if ( typeof data === "string" ) {
                try {
                    data = getData( data );
                } catch ( e ) {}

                // Make sure we set the data so it isn't changed later
                dataUser.set( elem, key, data );
            } else {
                data = undefined;
            }
        }
        return data;
    }

    jQuery.extend( {
        hasData: function( elem ) {
            return dataUser.hasData( elem ) || dataPriv.hasData( elem );
        },

        data: function( elem, name, data ) {
            return dataUser.access( elem, name, data );
        },

        removeData: function( elem, name ) {
            dataUser.remove( elem, name );
        },

        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function( elem, name, data ) {
            return dataPriv.access( elem, name, data );
        },

        _removeData: function( elem, name ) {
            dataPriv.remove( elem, name );
        }
    } );

    jQuery.fn.extend( {
        data: function( key, value ) {
            var i, name, data,
                elem = this[ 0 ],
                attrs = elem && elem.attributes;

            // Gets all values
            if ( key === undefined ) {
                if ( this.length ) {
                    data = dataUser.get( elem );

                    if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
                        i = attrs.length;
                        while ( i-- ) {

                            // Support: IE 11 only
                            // The attrs elements can be null (#14894)
                            if ( attrs[ i ] ) {
                                name = attrs[ i ].name;
                                if ( name.indexOf( "data-" ) === 0 ) {
                                    name = jQuery.camelCase( name.slice( 5 ) );
                                    dataAttr( elem, name, data[ name ] );
                                }
                            }
                        }
                        dataPriv.set( elem, "hasDataAttrs", true );
                    }
                }

                return data;
            }

            // Sets multiple values
            if ( typeof key === "object" ) {
                return this.each( function() {
                    dataUser.set( this, key );
                } );
            }

            return access( this, function( value ) {
                var data;

                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if ( elem && value === undefined ) {

                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get( elem, key );
                    if ( data !== undefined ) {
                        return data;
                    }

                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr( elem, key );
                    if ( data !== undefined ) {
                        return data;
                    }

                    // We tried really hard, but the data doesn't exist.
                    return;
                }

                // Set the data...
                this.each( function() {

                    // We always store the camelCased key
                    dataUser.set( this, key, value );
                } );
            }, null, value, arguments.length > 1, null, true );
        },

        removeData: function( key ) {
            return this.each( function() {
                dataUser.remove( this, key );
            } );
        }
    } );


    jQuery.extend( {
        queue: function( elem, type, data ) {
            var queue;

            if ( elem ) {
                type = ( type || "fx" ) + "queue";
                queue = dataPriv.get( elem, type );

                // Speed up dequeue by getting out quickly if this is just a lookup
                if ( data ) {
                    if ( !queue || Array.isArray( data ) ) {
                        queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
                    } else {
                        queue.push( data );
                    }
                }
                return queue || [];
            }
        },

        dequeue: function( elem, type ) {
            type = type || "fx";

            var queue = jQuery.queue( elem, type ),
                startLength = queue.length,
                fn = queue.shift(),
                hooks = jQuery._queueHooks( elem, type ),
                next = function() {
                    jQuery.dequeue( elem, type );
                };

            // If the fx queue is dequeued, always remove the progress sentinel
            if ( fn === "inprogress" ) {
                fn = queue.shift();
                startLength--;
            }

            if ( fn ) {

                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if ( type === "fx" ) {
                    queue.unshift( "inprogress" );
                }

                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call( elem, next, hooks );
            }

            if ( !startLength && hooks ) {
                hooks.empty.fire();
            }
        },

        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function( elem, type ) {
            var key = type + "queueHooks";
            return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
                empty: jQuery.Callbacks( "once memory" ).add( function() {
                    dataPriv.remove( elem, [ type + "queue", key ] );
                } )
            } );
        }
    } );

    jQuery.fn.extend( {
        queue: function( type, data ) {
            var setter = 2;

            if ( typeof type !== "string" ) {
                data = type;
                type = "fx";
                setter--;
            }

            if ( arguments.length < setter ) {
                return jQuery.queue( this[ 0 ], type );
            }

            return data === undefined ?
                this :
                this.each( function() {
                    var queue = jQuery.queue( this, type, data );

                    // Ensure a hooks for this queue
                    jQuery._queueHooks( this, type );

                    if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
                        jQuery.dequeue( this, type );
                    }
                } );
        },
        dequeue: function( type ) {
            return this.each( function() {
                jQuery.dequeue( this, type );
            } );
        },
        clearQueue: function( type ) {
            return this.queue( type || "fx", [] );
        },

        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function( type, obj ) {
            var tmp,
                count = 1,
                defer = jQuery.Deferred(),
                elements = this,
                i = this.length,
                resolve = function() {
                    if ( !( --count ) ) {
                        defer.resolveWith( elements, [ elements ] );
                    }
                };

            if ( typeof type !== "string" ) {
                obj = type;
                type = undefined;
            }
            type = type || "fx";

            while ( i-- ) {
                tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
                if ( tmp && tmp.empty ) {
                    count++;
                    tmp.empty.add( resolve );
                }
            }
            resolve();
            return defer.promise( obj );
        }
    } );
    var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

    var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


    var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

    var isHiddenWithinTree = function( elem, el ) {

        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;

        // Inline style trumps all
        return elem.style.display === "none" ||
            elem.style.display === "" &&

            // Otherwise, check computed style
            // Support: Firefox <=43 - 45
            // Disconnected elements can have computed display: none, so first confirm that elem is
            // in the document.
            jQuery.contains( elem.ownerDocument, elem ) &&

            jQuery.css( elem, "display" ) === "none";
    };

    var swap = function( elem, options, callback, args ) {
        var ret, name,
            old = {};

        // Remember the old values, and insert the new ones
        for ( name in options ) {
            old[ name ] = elem.style[ name ];
            elem.style[ name ] = options[ name ];
        }

        ret = callback.apply( elem, args || [] );

        // Revert the old values
        for ( name in options ) {
            elem.style[ name ] = old[ name ];
        }

        return ret;
    };




    function adjustCSS( elem, prop, valueParts, tween ) {
        var adjusted,
            scale = 1,
            maxIterations = 20,
            currentValue = tween ?
                function() {
                    return tween.cur();
                } :
                function() {
                    return jQuery.css( elem, prop, "" );
                },
            initial = currentValue(),
            unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

            // Starting value computation is required for potential unit mismatches
            initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
                rcssNum.exec( jQuery.css( elem, prop ) );

        if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[ 3 ];

            // Make sure we update the tween properties later on
            valueParts = valueParts || [];

            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;

            do {

                // If previous iteration zeroed out, double until we get *something*.
                // Use string for doubling so we don't accidentally see scale as unchanged below
                scale = scale || ".5";

                // Adjust and apply
                initialInUnit = initialInUnit / scale;
                jQuery.style( elem, prop, initialInUnit + unit );

                // Update scale, tolerating zero or NaN from tween.cur()
                // Break the loop if scale is unchanged or perfect, or if we've just had enough.
            } while (
                scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
                );
        }

        if ( valueParts ) {
            initialInUnit = +initialInUnit || +initial || 0;

            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[ 1 ] ?
                initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
                +valueParts[ 2 ];
            if ( tween ) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }


    var defaultDisplayMap = {};

    function getDefaultDisplay( elem ) {
        var temp,
            doc = elem.ownerDocument,
            nodeName = elem.nodeName,
            display = defaultDisplayMap[ nodeName ];

        if ( display ) {
            return display;
        }

        temp = doc.body.appendChild( doc.createElement( nodeName ) );
        display = jQuery.css( temp, "display" );

        temp.parentNode.removeChild( temp );

        if ( display === "none" ) {
            display = "block";
        }
        defaultDisplayMap[ nodeName ] = display;

        return display;
    }

    function showHide( elements, show ) {
        var display, elem,
            values = [],
            index = 0,
            length = elements.length;

        // Determine new display value for elements that need to change
        for ( ; index < length; index++ ) {
            elem = elements[ index ];
            if ( !elem.style ) {
                continue;
            }

            display = elem.style.display;
            if ( show ) {

                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if ( display === "none" ) {
                    values[ index ] = dataPriv.get( elem, "display" ) || null;
                    if ( !values[ index ] ) {
                        elem.style.display = "";
                    }
                }
                if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
                    values[ index ] = getDefaultDisplay( elem );
                }
            } else {
                if ( display !== "none" ) {
                    values[ index ] = "none";

                    // Remember what we're overwriting
                    dataPriv.set( elem, "display", display );
                }
            }
        }

        // Set the display of the elements in a second loop to avoid constant reflow
        for ( index = 0; index < length; index++ ) {
            if ( values[ index ] != null ) {
                elements[ index ].style.display = values[ index ];
            }
        }

        return elements;
    }

    jQuery.fn.extend( {
        show: function() {
            return showHide( this, true );
        },
        hide: function() {
            return showHide( this );
        },
        toggle: function( state ) {
            if ( typeof state === "boolean" ) {
                return state ? this.show() : this.hide();
            }

            return this.each( function() {
                if ( isHiddenWithinTree( this ) ) {
                    jQuery( this ).show();
                } else {
                    jQuery( this ).hide();
                }
            } );
        }
    } );
    var rcheckableType = ( /^(?:checkbox|radio)$/i );

    var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

    var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
    var wrapMap = {

        // Support: IE <=9 only
        option: [ 1, "<select multiple='multiple'>", "</select>" ],

        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [ 1, "<table>", "</table>" ],
        col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
        tr: [ 2, "<table><tbody>", "</tbody></table>" ],
        td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

        _default: [ 0, "", "" ]
    };

// Support: IE <=9 only
    wrapMap.optgroup = wrapMap.option;

    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;


    function getAll( context, tag ) {

        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (#15151)
        var ret;

        if ( typeof context.getElementsByTagName !== "undefined" ) {
            ret = context.getElementsByTagName( tag || "*" );

        } else if ( typeof context.querySelectorAll !== "undefined" ) {
            ret = context.querySelectorAll( tag || "*" );

        } else {
            ret = [];
        }

        if ( tag === undefined || tag && nodeName( context, tag ) ) {
            return jQuery.merge( [ context ], ret );
        }

        return ret;
    }


// Mark scripts as having already been evaluated
    function setGlobalEval( elems, refElements ) {
        var i = 0,
            l = elems.length;

        for ( ; i < l; i++ ) {
            dataPriv.set(
                elems[ i ],
                "globalEval",
                !refElements || dataPriv.get( refElements[ i ], "globalEval" )
            );
        }
    }


    var rhtml = /<|&#?\w+;/;

    function buildFragment( elems, context, scripts, selection, ignored ) {
        var elem, tmp, tag, wrap, contains, j,
            fragment = context.createDocumentFragment(),
            nodes = [],
            i = 0,
            l = elems.length;

        for ( ; i < l; i++ ) {
            elem = elems[ i ];

            if ( elem || elem === 0 ) {

                // Add nodes directly
                if ( jQuery.type( elem ) === "object" ) {

                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

                    // Convert non-html into a text node
                } else if ( !rhtml.test( elem ) ) {
                    nodes.push( context.createTextNode( elem ) );

                    // Convert html into DOM nodes
                } else {
                    tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

                    // Deserialize a standard representation
                    tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
                    wrap = wrapMap[ tag ] || wrapMap._default;
                    tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

                    // Descend through wrappers to the right content
                    j = wrap[ 0 ];
                    while ( j-- ) {
                        tmp = tmp.lastChild;
                    }

                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge( nodes, tmp.childNodes );

                    // Remember the top-level container
                    tmp = fragment.firstChild;

                    // Ensure the created nodes are orphaned (#12392)
                    tmp.textContent = "";
                }
            }
        }

        // Remove wrapper from fragment
        fragment.textContent = "";

        i = 0;
        while ( ( elem = nodes[ i++ ] ) ) {

            // Skip elements already in the context collection (trac-4087)
            if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
                if ( ignored ) {
                    ignored.push( elem );
                }
                continue;
            }

            contains = jQuery.contains( elem.ownerDocument, elem );

            // Append to fragment
            tmp = getAll( fragment.appendChild( elem ), "script" );

            // Preserve script evaluation history
            if ( contains ) {
                setGlobalEval( tmp );
            }

            // Capture executables
            if ( scripts ) {
                j = 0;
                while ( ( elem = tmp[ j++ ] ) ) {
                    if ( rscriptType.test( elem.type || "" ) ) {
                        scripts.push( elem );
                    }
                }
            }
        }

        return fragment;
    }


    ( function() {
        var fragment = document.createDocumentFragment(),
            div = fragment.appendChild( document.createElement( "div" ) ),
            input = document.createElement( "input" );

        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (#11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (#14901)
        input.setAttribute( "type", "radio" );
        input.setAttribute( "checked", "checked" );
        input.setAttribute( "name", "t" );

        div.appendChild( input );

        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
    } )();
    var documentElement = document.documentElement;



    var
        rkeyEvent = /^key/,
        rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

    function returnTrue() {
        return true;
    }

    function returnFalse() {
        return false;
    }

// Support: IE <=9 only
// See #13393 for more info
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch ( err ) { }
    }

    function on( elem, types, selector, data, fn, one ) {
        var origFn, type;

        // Types can be a map of types/handlers
        if ( typeof types === "object" ) {

            // ( types-Object, selector, data )
            if ( typeof selector !== "string" ) {

                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for ( type in types ) {
                on( elem, type, selector, data, types[ type ], one );
            }
            return elem;
        }

        if ( data == null && fn == null ) {

            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if ( fn == null ) {
            if ( typeof selector === "string" ) {

                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {

                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if ( fn === false ) {
            fn = returnFalse;
        } else if ( !fn ) {
            return elem;
        }

        if ( one === 1 ) {
            origFn = fn;
            fn = function( event ) {

                // Can use an empty set, since event contains the info
                jQuery().off( event );
                return origFn.apply( this, arguments );
            };

            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
        }
        return elem.each( function() {
            jQuery.event.add( this, types, fn, data, selector );
        } );
    }

    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
    jQuery.event = {

        global: {},

        add: function( elem, types, handler, data, selector ) {

            var handleObjIn, eventHandle, tmp,
                events, t, handleObj,
                special, handlers, type, namespaces, origType,
                elemData = dataPriv.get( elem );

            // Don't attach events to noData or text/comment nodes (but allow plain objects)
            if ( !elemData ) {
                return;
            }

            // Caller can pass in an object of custom data in lieu of the handler
            if ( handler.handler ) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }

            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if ( selector ) {
                jQuery.find.matchesSelector( documentElement, selector );
            }

            // Make sure that the handler has a unique ID, used to find/remove it later
            if ( !handler.guid ) {
                handler.guid = jQuery.guid++;
            }

            // Init the element's event structure and main handler, if this is the first
            if ( !( events = elemData.events ) ) {
                events = elemData.events = {};
            }
            if ( !( eventHandle = elemData.handle ) ) {
                eventHandle = elemData.handle = function( e ) {

                    // Discard the second event of a jQuery.event.trigger() and
                    // when an event is called after a page has unloaded
                    return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
                        jQuery.event.dispatch.apply( elem, arguments ) : undefined;
                };
            }

            // Handle multiple events separated by a space
            types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
            t = types.length;
            while ( t-- ) {
                tmp = rtypenamespace.exec( types[ t ] ) || [];
                type = origType = tmp[ 1 ];
                namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

                // There *must* be a type, no attaching namespace-only handlers
                if ( !type ) {
                    continue;
                }

                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[ type ] || {};

                // If selector defined, determine special event api type, otherwise given type
                type = ( selector ? special.delegateType : special.bindType ) || type;

                // Update special based on newly reset type
                special = jQuery.event.special[ type ] || {};

                // handleObj is passed to all event handlers
                handleObj = jQuery.extend( {
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
                    namespace: namespaces.join( "." )
                }, handleObjIn );

                // Init the event handler queue if we're the first
                if ( !( handlers = events[ type ] ) ) {
                    handlers = events[ type ] = [];
                    handlers.delegateCount = 0;

                    // Only use addEventListener if the special events handler returns false
                    if ( !special.setup ||
                        special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

                        if ( elem.addEventListener ) {
                            elem.addEventListener( type, eventHandle );
                        }
                    }
                }

                if ( special.add ) {
                    special.add.call( elem, handleObj );

                    if ( !handleObj.handler.guid ) {
                        handleObj.handler.guid = handler.guid;
                    }
                }

                // Add to the element's handler list, delegates in front
                if ( selector ) {
                    handlers.splice( handlers.delegateCount++, 0, handleObj );
                } else {
                    handlers.push( handleObj );
                }

                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[ type ] = true;
            }

        },

        // Detach an event or set of events from an element
        remove: function( elem, types, handler, selector, mappedTypes ) {

            var j, origCount, tmp,
                events, t, handleObj,
                special, handlers, type, namespaces, origType,
                elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

            if ( !elemData || !( events = elemData.events ) ) {
                return;
            }

            // Once for each type.namespace in types; type may be omitted
            types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
            t = types.length;
            while ( t-- ) {
                tmp = rtypenamespace.exec( types[ t ] ) || [];
                type = origType = tmp[ 1 ];
                namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

                // Unbind all events (on this namespace, if provided) for the element
                if ( !type ) {
                    for ( type in events ) {
                        jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
                    }
                    continue;
                }

                special = jQuery.event.special[ type ] || {};
                type = ( selector ? special.delegateType : special.bindType ) || type;
                handlers = events[ type ] || [];
                tmp = tmp[ 2 ] &&
                    new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

                // Remove matching events
                origCount = j = handlers.length;
                while ( j-- ) {
                    handleObj = handlers[ j ];

                    if ( ( mappedTypes || origType === handleObj.origType ) &&
                        ( !handler || handler.guid === handleObj.guid ) &&
                        ( !tmp || tmp.test( handleObj.namespace ) ) &&
                        ( !selector || selector === handleObj.selector ||
                            selector === "**" && handleObj.selector ) ) {
                        handlers.splice( j, 1 );

                        if ( handleObj.selector ) {
                            handlers.delegateCount--;
                        }
                        if ( special.remove ) {
                            special.remove.call( elem, handleObj );
                        }
                    }
                }

                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if ( origCount && !handlers.length ) {
                    if ( !special.teardown ||
                        special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

                        jQuery.removeEvent( elem, type, elemData.handle );
                    }

                    delete events[ type ];
                }
            }

            // Remove data and the expando if it's no longer used
            if ( jQuery.isEmptyObject( events ) ) {
                dataPriv.remove( elem, "handle events" );
            }
        },

        dispatch: function( nativeEvent ) {

            // Make a writable jQuery.Event from the native event object
            var event = jQuery.event.fix( nativeEvent );

            var i, j, ret, matched, handleObj, handlerQueue,
                args = new Array( arguments.length ),
                handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
                special = jQuery.event.special[ event.type ] || {};

            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[ 0 ] = event;

            for ( i = 1; i < arguments.length; i++ ) {
                args[ i ] = arguments[ i ];
            }

            event.delegateTarget = this;

            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
                return;
            }

            // Determine handlers
            handlerQueue = jQuery.event.handlers.call( this, event, handlers );

            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
                event.currentTarget = matched.elem;

                j = 0;
                while ( ( handleObj = matched.handlers[ j++ ] ) &&
                !event.isImmediatePropagationStopped() ) {

                    // Triggered event must either 1) have no namespace, or 2) have namespace(s)
                    // a subset or equal to those in the bound event (both can have no namespace).
                    if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

                        event.handleObj = handleObj;
                        event.data = handleObj.data;

                        ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
                            handleObj.handler ).apply( matched.elem, args );

                        if ( ret !== undefined ) {
                            if ( ( event.result = ret ) === false ) {
                                event.preventDefault();
                                event.stopPropagation();
                            }
                        }
                    }
                }
            }

            // Call the postDispatch hook for the mapped type
            if ( special.postDispatch ) {
                special.postDispatch.call( this, event );
            }

            return event.result;
        },

        handlers: function( event, handlers ) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors,
                handlerQueue = [],
                delegateCount = handlers.delegateCount,
                cur = event.target;

            // Find delegate handlers
            if ( delegateCount &&

                // Support: IE <=9
                // Black-hole SVG <use> instance trees (trac-13180)
                cur.nodeType &&

                // Support: Firefox <=42
                // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
                // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
                // Support: IE 11 only
                // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
                !( event.type === "click" && event.button >= 1 ) ) {

                for ( ; cur !== this; cur = cur.parentNode || this ) {

                    // Don't check non-elements (#13208)
                    // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                    if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
                        matchedHandlers = [];
                        matchedSelectors = {};
                        for ( i = 0; i < delegateCount; i++ ) {
                            handleObj = handlers[ i ];

                            // Don't conflict with Object.prototype properties (#13203)
                            sel = handleObj.selector + " ";

                            if ( matchedSelectors[ sel ] === undefined ) {
                                matchedSelectors[ sel ] = handleObj.needsContext ?
                                    jQuery( sel, this ).index( cur ) > -1 :
                                    jQuery.find( sel, this, null, [ cur ] ).length;
                            }
                            if ( matchedSelectors[ sel ] ) {
                                matchedHandlers.push( handleObj );
                            }
                        }
                        if ( matchedHandlers.length ) {
                            handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
                        }
                    }
                }
            }

            // Add the remaining (directly-bound) handlers
            cur = this;
            if ( delegateCount < handlers.length ) {
                handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
            }

            return handlerQueue;
        },

        addProp: function( name, hook ) {
            Object.defineProperty( jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,

                get: jQuery.isFunction( hook ) ?
                    function() {
                        if ( this.originalEvent ) {
                            return hook( this.originalEvent );
                        }
                    } :
                    function() {
                        if ( this.originalEvent ) {
                            return this.originalEvent[ name ];
                        }
                    },

                set: function( value ) {
                    Object.defineProperty( this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    } );
                }
            } );
        },

        fix: function( originalEvent ) {
            return originalEvent[ jQuery.expando ] ?
                originalEvent :
                new jQuery.Event( originalEvent );
        },

        special: {
            load: {

                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            focus: {

                // Fire native event if possible so blur/focus sequence is correct
                trigger: function() {
                    if ( this !== safeActiveElement() && this.focus ) {
                        this.focus();
                        return false;
                    }
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    if ( this === safeActiveElement() && this.blur ) {
                        this.blur();
                        return false;
                    }
                },
                delegateType: "focusout"
            },
            click: {

                // For checkbox, fire native event so checked state will be right
                trigger: function() {
                    if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
                        this.click();
                        return false;
                    }
                },

                // For cross-browser consistency, don't fire native .click() on links
                _default: function( event ) {
                    return nodeName( event.target, "a" );
                }
            },

            beforeunload: {
                postDispatch: function( event ) {

                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if ( event.result !== undefined && event.originalEvent ) {
                        event.originalEvent.returnValue = event.result;
                    }
                }
            }
        }
    };

    jQuery.removeEvent = function( elem, type, handle ) {

        // This "if" is needed for plain objects
        if ( elem.removeEventListener ) {
            elem.removeEventListener( type, handle );
        }
    };

    jQuery.Event = function( src, props ) {

        // Allow instantiation without the 'new' keyword
        if ( !( this instanceof jQuery.Event ) ) {
            return new jQuery.Event( src, props );
        }

        // Event object
        if ( src && src.type ) {
            this.originalEvent = src;
            this.type = src.type;

            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented ||
            src.defaultPrevented === undefined &&

            // Support: Android <=2.3 only
            src.returnValue === false ?
                returnTrue :
                returnFalse;

            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (#504, #13143)
            this.target = ( src.target && src.target.nodeType === 3 ) ?
                src.target.parentNode :
                src.target;

            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;

            // Event type
        } else {
            this.type = src;
        }

        // Put explicitly provided properties onto the event object
        if ( props ) {
            jQuery.extend( this, props );
        }

        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || jQuery.now();

        // Mark it as fixed
        this[ jQuery.expando ] = true;
    };

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,

        preventDefault: function() {
            var e = this.originalEvent;

            this.isDefaultPrevented = returnTrue;

            if ( e && !this.isSimulated ) {
                e.preventDefault();
            }
        },
        stopPropagation: function() {
            var e = this.originalEvent;

            this.isPropagationStopped = returnTrue;

            if ( e && !this.isSimulated ) {
                e.stopPropagation();
            }
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;

            this.isImmediatePropagationStopped = returnTrue;

            if ( e && !this.isSimulated ) {
                e.stopImmediatePropagation();
            }

            this.stopPropagation();
        }
    };

// Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each( {
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,

        which: function( event ) {
            var button = event.button;

            // Add which for key events
            if ( event.which == null && rkeyEvent.test( event.type ) ) {
                return event.charCode != null ? event.charCode : event.keyCode;
            }

            // Add which for click: 1 === left; 2 === middle; 3 === right
            if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
                if ( button & 1 ) {
                    return 1;
                }

                if ( button & 2 ) {
                    return 3;
                }

                if ( button & 4 ) {
                    return 2;
                }

                return 0;
            }

            return event.which;
        }
    }, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each( {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function( orig, fix ) {
        jQuery.event.special[ orig ] = {
            delegateType: fix,
            bindType: fix,

            handle: function( event ) {
                var ret,
                    target = this,
                    related = event.relatedTarget,
                    handleObj = event.handleObj;

                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply( this, arguments );
                    event.type = fix;
                }
                return ret;
            }
        };
    } );

    jQuery.fn.extend( {

        on: function( types, selector, data, fn ) {
            return on( this, types, selector, data, fn );
        },
        one: function( types, selector, data, fn ) {
            return on( this, types, selector, data, fn, 1 );
        },
        off: function( types, selector, fn ) {
            var handleObj, type;
            if ( types && types.preventDefault && types.handleObj ) {

                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery( types.delegateTarget ).off(
                    handleObj.namespace ?
                        handleObj.origType + "." + handleObj.namespace :
                        handleObj.origType,
                    handleObj.selector,
                    handleObj.handler
                );
                return this;
            }
            if ( typeof types === "object" ) {

                // ( types-object [, selector] )
                for ( type in types ) {
                    this.off( type, selector, types[ type ] );
                }
                return this;
            }
            if ( selector === false || typeof selector === "function" ) {

                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if ( fn === false ) {
                fn = returnFalse;
            }
            return this.each( function() {
                jQuery.event.remove( this, types, fn, selector );
            } );
        }
    } );


    var

        /* eslint-disable max-len */

        // See https://github.com/eslint/eslint/issues/3229
        rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

        /* eslint-enable */

        // Support: IE <=10 - 11, Edge 12 - 13
        // In IE/Edge using regex groups here causes severe slowdowns.
        // See https://connect.microsoft.com/IE/feedback/details/1736512/
        rnoInnerhtml = /<script|<style|<link/i,

        // checked="checked" or checked
        rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
        rscriptTypeMasked = /^true\/(.*)/,
        rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
    function manipulationTarget( elem, content ) {
        if ( nodeName( elem, "table" ) &&
            nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

            return jQuery( ">tbody", elem )[ 0 ] || elem;
        }

        return elem;
    }

// Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript( elem ) {
        elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
        return elem;
    }
    function restoreScript( elem ) {
        var match = rscriptTypeMasked.exec( elem.type );

        if ( match ) {
            elem.type = match[ 1 ];
        } else {
            elem.removeAttribute( "type" );
        }

        return elem;
    }

    function cloneCopyEvent( src, dest ) {
        var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

        if ( dest.nodeType !== 1 ) {
            return;
        }

        // 1. Copy private data: events, handlers, etc.
        if ( dataPriv.hasData( src ) ) {
            pdataOld = dataPriv.access( src );
            pdataCur = dataPriv.set( dest, pdataOld );
            events = pdataOld.events;

            if ( events ) {
                delete pdataCur.handle;
                pdataCur.events = {};

                for ( type in events ) {
                    for ( i = 0, l = events[ type ].length; i < l; i++ ) {
                        jQuery.event.add( dest, type, events[ type ][ i ] );
                    }
                }
            }
        }

        // 2. Copy user data
        if ( dataUser.hasData( src ) ) {
            udataOld = dataUser.access( src );
            udataCur = jQuery.extend( {}, udataOld );

            dataUser.set( dest, udataCur );
        }
    }

// Fix IE bugs, see support tests
    function fixInput( src, dest ) {
        var nodeName = dest.nodeName.toLowerCase();

        // Fails to persist the checked state of a cloned checkbox or radio button.
        if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
            dest.checked = src.checked;

            // Fails to return the selected option to the default selected state when cloning options
        } else if ( nodeName === "input" || nodeName === "textarea" ) {
            dest.defaultValue = src.defaultValue;
        }
    }

    function domManip( collection, args, callback, ignored ) {

        // Flatten any nested arrays
        args = concat.apply( [], args );

        var fragment, first, scripts, hasScripts, node, doc,
            i = 0,
            l = collection.length,
            iNoClone = l - 1,
            value = args[ 0 ],
            isFunction = jQuery.isFunction( value );

        // We can't cloneNode fragments that contain checked, in WebKit
        if ( isFunction ||
            ( l > 1 && typeof value === "string" &&
                !support.checkClone && rchecked.test( value ) ) ) {
            return collection.each( function( index ) {
                var self = collection.eq( index );
                if ( isFunction ) {
                    args[ 0 ] = value.call( this, index, self.html() );
                }
                domManip( self, args, callback, ignored );
            } );
        }

        if ( l ) {
            fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
            first = fragment.firstChild;

            if ( fragment.childNodes.length === 1 ) {
                fragment = first;
            }

            // Require either new content or an interest in ignored elements to invoke the callback
            if ( first || ignored ) {
                scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
                hasScripts = scripts.length;

                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (#8070).
                for ( ; i < l; i++ ) {
                    node = fragment;

                    if ( i !== iNoClone ) {
                        node = jQuery.clone( node, true, true );

                        // Keep references to cloned scripts for later restoration
                        if ( hasScripts ) {

                            // Support: Android <=4.0 only, PhantomJS 1 only
                            // push.apply(_, arraylike) throws on ancient WebKit
                            jQuery.merge( scripts, getAll( node, "script" ) );
                        }
                    }

                    callback.call( collection[ i ], node, i );
                }

                if ( hasScripts ) {
                    doc = scripts[ scripts.length - 1 ].ownerDocument;

                    // Reenable scripts
                    jQuery.map( scripts, restoreScript );

                    // Evaluate executable scripts on first document insertion
                    for ( i = 0; i < hasScripts; i++ ) {
                        node = scripts[ i ];
                        if ( rscriptType.test( node.type || "" ) &&
                            !dataPriv.access( node, "globalEval" ) &&
                            jQuery.contains( doc, node ) ) {

                            if ( node.src ) {

                                // Optional AJAX dependency, but won't run scripts if not present
                                if ( jQuery._evalUrl ) {
                                    jQuery._evalUrl( node.src );
                                }
                            } else {
                                DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
                            }
                        }
                    }
                }
            }
        }

        return collection;
    }

    function remove( elem, selector, keepData ) {
        var node,
            nodes = selector ? jQuery.filter( selector, elem ) : elem,
            i = 0;

        for ( ; ( node = nodes[ i ] ) != null; i++ ) {
            if ( !keepData && node.nodeType === 1 ) {
                jQuery.cleanData( getAll( node ) );
            }

            if ( node.parentNode ) {
                if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
                    setGlobalEval( getAll( node, "script" ) );
                }
                node.parentNode.removeChild( node );
            }
        }

        return elem;
    }

    jQuery.extend( {
        htmlPrefilter: function( html ) {
            return html.replace( rxhtmlTag, "<$1></$2>" );
        },

        clone: function( elem, dataAndEvents, deepDataAndEvents ) {
            var i, l, srcElements, destElements,
                clone = elem.cloneNode( true ),
                inPage = jQuery.contains( elem.ownerDocument, elem );

            // Fix IE cloning issues
            if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
                !jQuery.isXMLDoc( elem ) ) {

                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll( clone );
                srcElements = getAll( elem );

                for ( i = 0, l = srcElements.length; i < l; i++ ) {
                    fixInput( srcElements[ i ], destElements[ i ] );
                }
            }

            // Copy the events from the original to the clone
            if ( dataAndEvents ) {
                if ( deepDataAndEvents ) {
                    srcElements = srcElements || getAll( elem );
                    destElements = destElements || getAll( clone );

                    for ( i = 0, l = srcElements.length; i < l; i++ ) {
                        cloneCopyEvent( srcElements[ i ], destElements[ i ] );
                    }
                } else {
                    cloneCopyEvent( elem, clone );
                }
            }

            // Preserve script evaluation history
            destElements = getAll( clone, "script" );
            if ( destElements.length > 0 ) {
                setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
            }

            // Return the cloned set
            return clone;
        },

        cleanData: function( elems ) {
            var data, elem, type,
                special = jQuery.event.special,
                i = 0;

            for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
                if ( acceptData( elem ) ) {
                    if ( ( data = elem[ dataPriv.expando ] ) ) {
                        if ( data.events ) {
                            for ( type in data.events ) {
                                if ( special[ type ] ) {
                                    jQuery.event.remove( elem, type );

                                    // This is a shortcut to avoid jQuery.event.remove's overhead
                                } else {
                                    jQuery.removeEvent( elem, type, data.handle );
                                }
                            }
                        }

                        // Support: Chrome <=35 - 45+
                        // Assign undefined instead of using delete, see Data#remove
                        elem[ dataPriv.expando ] = undefined;
                    }
                    if ( elem[ dataUser.expando ] ) {

                        // Support: Chrome <=35 - 45+
                        // Assign undefined instead of using delete, see Data#remove
                        elem[ dataUser.expando ] = undefined;
                    }
                }
            }
        }
    } );

    jQuery.fn.extend( {
        detach: function( selector ) {
            return remove( this, selector, true );
        },

        remove: function( selector ) {
            return remove( this, selector );
        },

        text: function( value ) {
            return access( this, function( value ) {
                return value === undefined ?
                    jQuery.text( this ) :
                    this.empty().each( function() {
                        if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                            this.textContent = value;
                        }
                    } );
            }, null, value, arguments.length );
        },

        append: function() {
            return domManip( this, arguments, function( elem ) {
                if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                    var target = manipulationTarget( this, elem );
                    target.appendChild( elem );
                }
            } );
        },

        prepend: function() {
            return domManip( this, arguments, function( elem ) {
                if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                    var target = manipulationTarget( this, elem );
                    target.insertBefore( elem, target.firstChild );
                }
            } );
        },

        before: function() {
            return domManip( this, arguments, function( elem ) {
                if ( this.parentNode ) {
                    this.parentNode.insertBefore( elem, this );
                }
            } );
        },

        after: function() {
            return domManip( this, arguments, function( elem ) {
                if ( this.parentNode ) {
                    this.parentNode.insertBefore( elem, this.nextSibling );
                }
            } );
        },

        empty: function() {
            var elem,
                i = 0;

            for ( ; ( elem = this[ i ] ) != null; i++ ) {
                if ( elem.nodeType === 1 ) {

                    // Prevent memory leaks
                    jQuery.cleanData( getAll( elem, false ) );

                    // Remove any remaining nodes
                    elem.textContent = "";
                }
            }

            return this;
        },

        clone: function( dataAndEvents, deepDataAndEvents ) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

            return this.map( function() {
                return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
            } );
        },

        html: function( value ) {
            return access( this, function( value ) {
                var elem = this[ 0 ] || {},
                    i = 0,
                    l = this.length;

                if ( value === undefined && elem.nodeType === 1 ) {
                    return elem.innerHTML;
                }

                // See if we can take a shortcut and just use innerHTML
                if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
                    !wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

                    value = jQuery.htmlPrefilter( value );

                    try {
                        for ( ; i < l; i++ ) {
                            elem = this[ i ] || {};

                            // Remove element nodes and prevent memory leaks
                            if ( elem.nodeType === 1 ) {
                                jQuery.cleanData( getAll( elem, false ) );
                                elem.innerHTML = value;
                            }
                        }

                        elem = 0;

                        // If using innerHTML throws an exception, use the fallback method
                    } catch ( e ) {}
                }

                if ( elem ) {
                    this.empty().append( value );
                }
            }, null, value, arguments.length );
        },

        replaceWith: function() {
            var ignored = [];

            // Make the changes, replacing each non-ignored context element with the new content
            return domManip( this, arguments, function( elem ) {
                var parent = this.parentNode;

                if ( jQuery.inArray( this, ignored ) < 0 ) {
                    jQuery.cleanData( getAll( this ) );
                    if ( parent ) {
                        parent.replaceChild( elem, this );
                    }
                }

                // Force callback invocation
            }, ignored );
        }
    } );

    jQuery.each( {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function( name, original ) {
        jQuery.fn[ name ] = function( selector ) {
            var elems,
                ret = [],
                insert = jQuery( selector ),
                last = insert.length - 1,
                i = 0;

            for ( ; i <= last; i++ ) {
                elems = i === last ? this : this.clone( true );
                jQuery( insert[ i ] )[ original ]( elems );

                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply( ret, elems.get() );
            }

            return this.pushStack( ret );
        };
    } );
    var rmargin = ( /^margin/ );

    var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

    var getStyles = function( elem ) {

        // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;

        if ( !view || !view.opener ) {
            view = window;
        }

        return view.getComputedStyle( elem );
    };



    ( function() {

        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {

            // This is a singleton, we need to execute it only once
            if ( !div ) {
                return;
            }

            div.style.cssText =
                "box-sizing:border-box;" +
                "position:relative;display:block;" +
                "margin:auto;border:1px;padding:1px;" +
                "top:1%;width:50%";
            div.innerHTML = "";
            documentElement.appendChild( container );

            var divStyle = window.getComputedStyle( div );
            pixelPositionVal = divStyle.top !== "1%";

            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = divStyle.marginLeft === "2px";
            boxSizingReliableVal = divStyle.width === "4px";

            // Support: Android 4.0 - 4.3 only
            // Some styles come back with percentage values, even though they shouldn't
            div.style.marginRight = "50%";
            pixelMarginRightVal = divStyle.marginRight === "4px";

            documentElement.removeChild( container );

            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }

        var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
            container = document.createElement( "div" ),
            div = document.createElement( "div" );

        // Finish early in limited (non-browser) environments
        if ( !div.style ) {
            return;
        }

        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (#8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode( true ).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";

        container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
            "padding:0;margin-top:1px;position:absolute";
        container.appendChild( div );

        jQuery.extend( support, {
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelMarginRight: function() {
                computeStyleTests();
                return pixelMarginRightVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            }
        } );
    } )();


    function curCSS( elem, name, computed ) {
        var width, minWidth, maxWidth, ret,

            // Support: Firefox 51+
            // Retrieving style before computed somehow
            // fixes an issue with getting wrong values
            // on detached elements
            style = elem.style;

        computed = computed || getStyles( elem );

        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, #12537)
        //   .css('--customProperty) (#3144)
        if ( computed ) {
            ret = computed.getPropertyValue( name ) || computed[ name ];

            if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
                ret = jQuery.style( elem, name );
            }

            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;

                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;

                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }

        return ret !== undefined ?

            // Support: IE <=9 - 11 only
            // IE returns zIndex value as an integer.
            ret + "" :
            ret;
    }


    function addGetHookIf( conditionFn, hookFn ) {

        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if ( conditionFn() ) {

                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }

                // Hook needed; redefine it so that the support test is not executed again.
                return ( this.get = hookFn ).apply( this, arguments );
            }
        };
    }


    var

        // Swappable if display is none or starts with table
        // except "table", "table-cell", or "table-caption"
        // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
        rdisplayswap = /^(none|table(?!-c[ea]).+)/,
        rcustomProp = /^--/,
        cssShow = { position: "absolute", visibility: "hidden", display: "block" },
        cssNormalTransform = {
            letterSpacing: "0",
            fontWeight: "400"
        },

        cssPrefixes = [ "Webkit", "Moz", "ms" ],
        emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
    function vendorPropName( name ) {

        // Shortcut for names that are not vendor prefixed
        if ( name in emptyStyle ) {
            return name;
        }

        // Check for vendor prefixed names
        var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
            i = cssPrefixes.length;

        while ( i-- ) {
            name = cssPrefixes[ i ] + capName;
            if ( name in emptyStyle ) {
                return name;
            }
        }
    }

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
    function finalPropName( name ) {
        var ret = jQuery.cssProps[ name ];
        if ( !ret ) {
            ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
        }
        return ret;
    }

    function setPositiveNumber( elem, value, subtract ) {

        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec( value );
        return matches ?

            // Guard against undefined "subtract", e.g., when used as in cssHooks
            Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
            value;
    }

    function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
        var i,
            val = 0;

        // If we already have the right measurement, avoid augmentation
        if ( extra === ( isBorderBox ? "border" : "content" ) ) {
            i = 4;

            // Otherwise initialize for horizontal or vertical properties
        } else {
            i = name === "width" ? 1 : 0;
        }

        for ( ; i < 4; i += 2 ) {

            // Both box models exclude margin, so add it if we want it
            if ( extra === "margin" ) {
                val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
            }

            if ( isBorderBox ) {

                // border-box includes padding, so remove it if we want content
                if ( extra === "content" ) {
                    val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
                }

                // At this point, extra isn't border nor margin, so remove border
                if ( extra !== "margin" ) {
                    val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
                }
            } else {

                // At this point, extra isn't content, so add padding
                val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

                // At this point, extra isn't content nor padding, so add border
                if ( extra !== "padding" ) {
                    val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
                }
            }
        }

        return val;
    }

    function getWidthOrHeight( elem, name, extra ) {

        // Start with computed style
        var valueIsBorderBox,
            styles = getStyles( elem ),
            val = curCSS( elem, name, styles ),
            isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

        // Computed unit is not pixels. Stop here and return.
        if ( rnumnonpx.test( val ) ) {
            return val;
        }

        // Check for style in case a browser which returns unreliable values
        // for getComputedStyle silently falls back to the reliable elem.style
        valueIsBorderBox = isBorderBox &&
            ( support.boxSizingReliable() || val === elem.style[ name ] );

        // Fall back to offsetWidth/Height when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        if ( val === "auto" ) {
            val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
        }

        // Normalize "", auto, and prepare for extra
        val = parseFloat( val ) || 0;

        // Use the active box-sizing model to add/subtract irrelevant styles
        return ( val +
            augmentWidthOrHeight(
                elem,
                name,
                extra || ( isBorderBox ? "border" : "content" ),
                valueIsBorderBox,
                styles
            )
        ) + "px";
    }

    jQuery.extend( {

        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function( elem, computed ) {
                    if ( computed ) {

                        // We should always get a number back from opacity
                        var ret = curCSS( elem, "opacity" );
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },

        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            "animationIterationCount": true,
            "columnCount": true,
            "fillOpacity": true,
            "flexGrow": true,
            "flexShrink": true,
            "fontWeight": true,
            "lineHeight": true,
            "opacity": true,
            "order": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
        },

        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {
            "float": "cssFloat"
        },

        // Get and set the style property on a DOM Node
        style: function( elem, name, value, extra ) {

            // Don't set styles on text and comment nodes
            if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
                return;
            }

            // Make sure that we're working with the right name
            var ret, type, hooks,
                origName = jQuery.camelCase( name ),
                isCustomProp = rcustomProp.test( name ),
                style = elem.style;

            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if ( !isCustomProp ) {
                name = finalPropName( origName );
            }

            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

            // Check if we're setting a value
            if ( value !== undefined ) {
                type = typeof value;

                // Convert "+=" or "-=" to relative numbers (#7345)
                if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
                    value = adjustCSS( elem, name, ret );

                    // Fixes bug #9237
                    type = "number";
                }

                // Make sure that null and NaN values aren't set (#7116)
                if ( value == null || value !== value ) {
                    return;
                }

                // If a number was passed in, add the unit (except for certain CSS properties)
                if ( type === "number" ) {
                    value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
                }

                // background-* props affect original clone's values
                if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
                    style[ name ] = "inherit";
                }

                // If a hook was provided, use that value, otherwise just set the specified value
                if ( !hooks || !( "set" in hooks ) ||
                    ( value = hooks.set( elem, value, extra ) ) !== undefined ) {

                    if ( isCustomProp ) {
                        style.setProperty( name, value );
                    } else {
                        style[ name ] = value;
                    }
                }

            } else {

                // If a hook was provided get the non-computed value from there
                if ( hooks && "get" in hooks &&
                    ( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

                    return ret;
                }

                // Otherwise just get the value from the style object
                return style[ name ];
            }
        },

        css: function( elem, name, extra, styles ) {
            var val, num, hooks,
                origName = jQuery.camelCase( name ),
                isCustomProp = rcustomProp.test( name );

            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if ( !isCustomProp ) {
                name = finalPropName( origName );
            }

            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

            // If a hook was provided get the computed value from there
            if ( hooks && "get" in hooks ) {
                val = hooks.get( elem, true, extra );
            }

            // Otherwise, if a way to get the computed value exists, use that
            if ( val === undefined ) {
                val = curCSS( elem, name, styles );
            }

            // Convert "normal" to computed value
            if ( val === "normal" && name in cssNormalTransform ) {
                val = cssNormalTransform[ name ];
            }

            // Make numeric if forced or a qualifier was provided and val looks numeric
            if ( extra === "" || extra ) {
                num = parseFloat( val );
                return extra === true || isFinite( num ) ? num || 0 : val;
            }

            return val;
        }
    } );

    jQuery.each( [ "height", "width" ], function( i, name ) {
        jQuery.cssHooks[ name ] = {
            get: function( elem, computed, extra ) {
                if ( computed ) {

                    // Certain elements can have dimension info if we invisibly show them
                    // but it must have a current display style that would benefit
                    return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

                    // Support: Safari 8+
                    // Table columns in Safari have non-zero offsetWidth & zero
                    // getBoundingClientRect().width unless display is changed.
                    // Support: IE <=11 only
                    // Running getBoundingClientRect on a disconnected node
                    // in IE throws an error.
                    ( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
                        swap( elem, cssShow, function() {
                            return getWidthOrHeight( elem, name, extra );
                        } ) :
                        getWidthOrHeight( elem, name, extra );
                }
            },

            set: function( elem, value, extra ) {
                var matches,
                    styles = extra && getStyles( elem ),
                    subtract = extra && augmentWidthOrHeight(
                        elem,
                        name,
                        extra,
                        jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
                        styles
                    );

                // Convert to pixels if value adjustment is needed
                if ( subtract && ( matches = rcssNum.exec( value ) ) &&
                    ( matches[ 3 ] || "px" ) !== "px" ) {

                    elem.style[ name ] = value;
                    value = jQuery.css( elem, name );
                }

                return setPositiveNumber( elem, value, subtract );
            }
        };
    } );

    jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
        function( elem, computed ) {
            if ( computed ) {
                return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
                    elem.getBoundingClientRect().left -
                    swap( elem, { marginLeft: 0 }, function() {
                        return elem.getBoundingClientRect().left;
                    } )
                ) + "px";
            }
        }
    );

// These hooks are used by animate to expand properties
    jQuery.each( {
        margin: "",
        padding: "",
        border: "Width"
    }, function( prefix, suffix ) {
        jQuery.cssHooks[ prefix + suffix ] = {
            expand: function( value ) {
                var i = 0,
                    expanded = {},

                    // Assumes a single number if not a string
                    parts = typeof value === "string" ? value.split( " " ) : [ value ];

                for ( ; i < 4; i++ ) {
                    expanded[ prefix + cssExpand[ i ] + suffix ] =
                        parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
                }

                return expanded;
            }
        };

        if ( !rmargin.test( prefix ) ) {
            jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
        }
    } );

    jQuery.fn.extend( {
        css: function( name, value ) {
            return access( this, function( elem, name, value ) {
                var styles, len,
                    map = {},
                    i = 0;

                if ( Array.isArray( name ) ) {
                    styles = getStyles( elem );
                    len = name.length;

                    for ( ; i < len; i++ ) {
                        map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
                    }

                    return map;
                }

                return value !== undefined ?
                    jQuery.style( elem, name, value ) :
                    jQuery.css( elem, name );
            }, name, value, arguments.length > 1 );
        }
    } );


    function Tween( elem, options, prop, end, easing ) {
        return new Tween.prototype.init( elem, options, prop, end, easing );
    }
    jQuery.Tween = Tween;

    Tween.prototype = {
        constructor: Tween,
        init: function( elem, options, prop, end, easing, unit ) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
        },
        cur: function() {
            var hooks = Tween.propHooks[ this.prop ];

            return hooks && hooks.get ?
                hooks.get( this ) :
                Tween.propHooks._default.get( this );
        },
        run: function( percent ) {
            var eased,
                hooks = Tween.propHooks[ this.prop ];

            if ( this.options.duration ) {
                this.pos = eased = jQuery.easing[ this.easing ](
                    percent, this.options.duration * percent, 0, 1, this.options.duration
                );
            } else {
                this.pos = eased = percent;
            }
            this.now = ( this.end - this.start ) * eased + this.start;

            if ( this.options.step ) {
                this.options.step.call( this.elem, this.now, this );
            }

            if ( hooks && hooks.set ) {
                hooks.set( this );
            } else {
                Tween.propHooks._default.set( this );
            }
            return this;
        }
    };

    Tween.prototype.init.prototype = Tween.prototype;

    Tween.propHooks = {
        _default: {
            get: function( tween ) {
                var result;

                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if ( tween.elem.nodeType !== 1 ||
                    tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
                    return tween.elem[ tween.prop ];
                }

                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css( tween.elem, tween.prop, "" );

                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function( tween ) {

                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if ( jQuery.fx.step[ tween.prop ] ) {
                    jQuery.fx.step[ tween.prop ]( tween );
                } else if ( tween.elem.nodeType === 1 &&
                    ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
                        jQuery.cssHooks[ tween.prop ] ) ) {
                    jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
                } else {
                    tween.elem[ tween.prop ] = tween.now;
                }
            }
        }
    };

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function( tween ) {
            if ( tween.elem.nodeType && tween.elem.parentNode ) {
                tween.elem[ tween.prop ] = tween.now;
            }
        }
    };

    jQuery.easing = {
        linear: function( p ) {
            return p;
        },
        swing: function( p ) {
            return 0.5 - Math.cos( p * Math.PI ) / 2;
        },
        _default: "swing"
    };

    jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
    jQuery.fx.step = {};




    var
        fxNow, inProgress,
        rfxtypes = /^(?:toggle|show|hide)$/,
        rrun = /queueHooks$/;

    function schedule() {
        if ( inProgress ) {
            if ( document.hidden === false && window.requestAnimationFrame ) {
                window.requestAnimationFrame( schedule );
            } else {
                window.setTimeout( schedule, jQuery.fx.interval );
            }

            jQuery.fx.tick();
        }
    }

// Animations created synchronously will run synchronously
    function createFxNow() {
        window.setTimeout( function() {
            fxNow = undefined;
        } );
        return ( fxNow = jQuery.now() );
    }

// Generate parameters to create a standard animation
    function genFx( type, includeWidth ) {
        var which,
            i = 0,
            attrs = { height: type };

        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for ( ; i < 4; i += 2 - includeWidth ) {
            which = cssExpand[ i ];
            attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
        }

        if ( includeWidth ) {
            attrs.opacity = attrs.width = type;
        }

        return attrs;
    }

    function createTween( value, prop, animation ) {
        var tween,
            collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
            index = 0,
            length = collection.length;
        for ( ; index < length; index++ ) {
            if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

                // We're done with this property
                return tween;
            }
        }
    }

    function defaultPrefilter( elem, props, opts ) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
            isBox = "width" in props || "height" in props,
            anim = this,
            orig = {},
            style = elem.style,
            hidden = elem.nodeType && isHiddenWithinTree( elem ),
            dataShow = dataPriv.get( elem, "fxshow" );

        // Queue-skipping animations hijack the fx hooks
        if ( !opts.queue ) {
            hooks = jQuery._queueHooks( elem, "fx" );
            if ( hooks.unqueued == null ) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if ( !hooks.unqueued ) {
                        oldfire();
                    }
                };
            }
            hooks.unqueued++;

            anim.always( function() {

                // Ensure the complete handler is called before this completes
                anim.always( function() {
                    hooks.unqueued--;
                    if ( !jQuery.queue( elem, "fx" ).length ) {
                        hooks.empty.fire();
                    }
                } );
            } );
        }

        // Detect show/hide animations
        for ( prop in props ) {
            value = props[ prop ];
            if ( rfxtypes.test( value ) ) {
                delete props[ prop ];
                toggle = toggle || value === "toggle";
                if ( value === ( hidden ? "hide" : "show" ) ) {

                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
                        hidden = true;

                        // Ignore all other no-op show/hide data
                    } else {
                        continue;
                    }
                }
                orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
            }
        }

        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject( props );
        if ( !propTween && jQuery.isEmptyObject( orig ) ) {
            return;
        }

        // Restrict "overflow" and "display" styles during box animations
        if ( isBox && elem.nodeType === 1 ) {

            // Support: IE <=9 - 11, Edge 12 - 13
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY
            opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if ( restoreDisplay == null ) {
                restoreDisplay = dataPriv.get( elem, "display" );
            }
            display = jQuery.css( elem, "display" );
            if ( display === "none" ) {
                if ( restoreDisplay ) {
                    display = restoreDisplay;
                } else {

                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide( [ elem ], true );
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css( elem, "display" );
                    showHide( [ elem ] );
                }
            }

            // Animate inline elements as inline-block
            if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
                if ( jQuery.css( elem, "float" ) === "none" ) {

                    // Restore the original display value at the end of pure show/hide animations
                    if ( !propTween ) {
                        anim.done( function() {
                            style.display = restoreDisplay;
                        } );
                        if ( restoreDisplay == null ) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }

        if ( opts.overflow ) {
            style.overflow = "hidden";
            anim.always( function() {
                style.overflow = opts.overflow[ 0 ];
                style.overflowX = opts.overflow[ 1 ];
                style.overflowY = opts.overflow[ 2 ];
            } );
        }

        // Implement show/hide animations
        propTween = false;
        for ( prop in orig ) {

            // General show/hide setup for this element animation
            if ( !propTween ) {
                if ( dataShow ) {
                    if ( "hidden" in dataShow ) {
                        hidden = dataShow.hidden;
                    }
                } else {
                    dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
                }

                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if ( toggle ) {
                    dataShow.hidden = !hidden;
                }

                // Show elements before animating them
                if ( hidden ) {
                    showHide( [ elem ], true );
                }

                /* eslint-disable no-loop-func */

                anim.done( function() {

                    /* eslint-enable no-loop-func */

                    // The final step of a "hide" animation is actually hiding the element
                    if ( !hidden ) {
                        showHide( [ elem ] );
                    }
                    dataPriv.remove( elem, "fxshow" );
                    for ( prop in orig ) {
                        jQuery.style( elem, prop, orig[ prop ] );
                    }
                } );
            }

            // Per-property setup
            propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
            if ( !( prop in dataShow ) ) {
                dataShow[ prop ] = propTween.start;
                if ( hidden ) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }

    function propFilter( props, specialEasing ) {
        var index, name, easing, value, hooks;

        // camelCase, specialEasing and expand cssHook pass
        for ( index in props ) {
            name = jQuery.camelCase( index );
            easing = specialEasing[ name ];
            value = props[ index ];
            if ( Array.isArray( value ) ) {
                easing = value[ 1 ];
                value = props[ index ] = value[ 0 ];
            }

            if ( index !== name ) {
                props[ name ] = value;
                delete props[ index ];
            }

            hooks = jQuery.cssHooks[ name ];
            if ( hooks && "expand" in hooks ) {
                value = hooks.expand( value );
                delete props[ name ];

                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for ( index in value ) {
                    if ( !( index in props ) ) {
                        props[ index ] = value[ index ];
                        specialEasing[ index ] = easing;
                    }
                }
            } else {
                specialEasing[ name ] = easing;
            }
        }
    }

    function Animation( elem, properties, options ) {
        var result,
            stopped,
            index = 0,
            length = Animation.prefilters.length,
            deferred = jQuery.Deferred().always( function() {

                // Don't match elem in the :animated selector
                delete tick.elem;
            } ),
            tick = function() {
                if ( stopped ) {
                    return false;
                }
                var currentTime = fxNow || createFxNow(),
                    remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

                    // Support: Android 2.3 only
                    // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
                    temp = remaining / animation.duration || 0,
                    percent = 1 - temp,
                    index = 0,
                    length = animation.tweens.length;

                for ( ; index < length; index++ ) {
                    animation.tweens[ index ].run( percent );
                }

                deferred.notifyWith( elem, [ animation, percent, remaining ] );

                // If there's more to do, yield
                if ( percent < 1 && length ) {
                    return remaining;
                }

                // If this was an empty animation, synthesize a final progress notification
                if ( !length ) {
                    deferred.notifyWith( elem, [ animation, 1, 0 ] );
                }

                // Resolve the animation and report its conclusion
                deferred.resolveWith( elem, [ animation ] );
                return false;
            },
            animation = deferred.promise( {
                elem: elem,
                props: jQuery.extend( {}, properties ),
                opts: jQuery.extend( true, {
                    specialEasing: {},
                    easing: jQuery.easing._default
                }, options ),
                originalProperties: properties,
                originalOptions: options,
                startTime: fxNow || createFxNow(),
                duration: options.duration,
                tweens: [],
                createTween: function( prop, end ) {
                    var tween = jQuery.Tween( elem, animation.opts, prop, end,
                        animation.opts.specialEasing[ prop ] || animation.opts.easing );
                    animation.tweens.push( tween );
                    return tween;
                },
                stop: function( gotoEnd ) {
                    var index = 0,

                        // If we are going to the end, we want to run all the tweens
                        // otherwise we skip this part
                        length = gotoEnd ? animation.tweens.length : 0;
                    if ( stopped ) {
                        return this;
                    }
                    stopped = true;
                    for ( ; index < length; index++ ) {
                        animation.tweens[ index ].run( 1 );
                    }

                    // Resolve when we played the last frame; otherwise, reject
                    if ( gotoEnd ) {
                        deferred.notifyWith( elem, [ animation, 1, 0 ] );
                        deferred.resolveWith( elem, [ animation, gotoEnd ] );
                    } else {
                        deferred.rejectWith( elem, [ animation, gotoEnd ] );
                    }
                    return this;
                }
            } ),
            props = animation.props;

        propFilter( props, animation.opts.specialEasing );

        for ( ; index < length; index++ ) {
            result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
            if ( result ) {
                if ( jQuery.isFunction( result.stop ) ) {
                    jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
                        jQuery.proxy( result.stop, result );
                }
                return result;
            }
        }

        jQuery.map( props, createTween, animation );

        if ( jQuery.isFunction( animation.opts.start ) ) {
            animation.opts.start.call( elem, animation );
        }

        // Attach callbacks from options
        animation
            .progress( animation.opts.progress )
            .done( animation.opts.done, animation.opts.complete )
            .fail( animation.opts.fail )
            .always( animation.opts.always );

        jQuery.fx.timer(
            jQuery.extend( tick, {
                elem: elem,
                anim: animation,
                queue: animation.opts.queue
            } )
        );

        return animation;
    }

    jQuery.Animation = jQuery.extend( Animation, {

        tweeners: {
            "*": [ function( prop, value ) {
                var tween = this.createTween( prop, value );
                adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
                return tween;
            } ]
        },

        tweener: function( props, callback ) {
            if ( jQuery.isFunction( props ) ) {
                callback = props;
                props = [ "*" ];
            } else {
                props = props.match( rnothtmlwhite );
            }

            var prop,
                index = 0,
                length = props.length;

            for ( ; index < length; index++ ) {
                prop = props[ index ];
                Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
                Animation.tweeners[ prop ].unshift( callback );
            }
        },

        prefilters: [ defaultPrefilter ],

        prefilter: function( callback, prepend ) {
            if ( prepend ) {
                Animation.prefilters.unshift( callback );
            } else {
                Animation.prefilters.push( callback );
            }
        }
    } );

    jQuery.speed = function( speed, easing, fn ) {
        var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
            complete: fn || !fn && easing ||
            jQuery.isFunction( speed ) && speed,
            duration: speed,
            easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
        };

        // Go to the end state if fx are off
        if ( jQuery.fx.off ) {
            opt.duration = 0;

        } else {
            if ( typeof opt.duration !== "number" ) {
                if ( opt.duration in jQuery.fx.speeds ) {
                    opt.duration = jQuery.fx.speeds[ opt.duration ];

                } else {
                    opt.duration = jQuery.fx.speeds._default;
                }
            }
        }

        // Normalize opt.queue - true/undefined/null -> "fx"
        if ( opt.queue == null || opt.queue === true ) {
            opt.queue = "fx";
        }

        // Queueing
        opt.old = opt.complete;

        opt.complete = function() {
            if ( jQuery.isFunction( opt.old ) ) {
                opt.old.call( this );
            }

            if ( opt.queue ) {
                jQuery.dequeue( this, opt.queue );
            }
        };

        return opt;
    };

    jQuery.fn.extend( {
        fadeTo: function( speed, to, easing, callback ) {

            // Show any hidden elements after setting opacity to 0
            return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

            // Animate to the value specified
                .end().animate( { opacity: to }, speed, easing, callback );
        },
        animate: function( prop, speed, easing, callback ) {
            var empty = jQuery.isEmptyObject( prop ),
                optall = jQuery.speed( speed, easing, callback ),
                doAnimation = function() {

                    // Operate on a copy of prop so per-property easing won't be lost
                    var anim = Animation( this, jQuery.extend( {}, prop ), optall );

                    // Empty animations, or finishing resolves immediately
                    if ( empty || dataPriv.get( this, "finish" ) ) {
                        anim.stop( true );
                    }
                };
            doAnimation.finish = doAnimation;

            return empty || optall.queue === false ?
                this.each( doAnimation ) :
                this.queue( optall.queue, doAnimation );
        },
        stop: function( type, clearQueue, gotoEnd ) {
            var stopQueue = function( hooks ) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop( gotoEnd );
            };

            if ( typeof type !== "string" ) {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if ( clearQueue && type !== false ) {
                this.queue( type || "fx", [] );
            }

            return this.each( function() {
                var dequeue = true,
                    index = type != null && type + "queueHooks",
                    timers = jQuery.timers,
                    data = dataPriv.get( this );

                if ( index ) {
                    if ( data[ index ] && data[ index ].stop ) {
                        stopQueue( data[ index ] );
                    }
                } else {
                    for ( index in data ) {
                        if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
                            stopQueue( data[ index ] );
                        }
                    }
                }

                for ( index = timers.length; index--; ) {
                    if ( timers[ index ].elem === this &&
                        ( type == null || timers[ index ].queue === type ) ) {

                        timers[ index ].anim.stop( gotoEnd );
                        dequeue = false;
                        timers.splice( index, 1 );
                    }
                }

                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if ( dequeue || !gotoEnd ) {
                    jQuery.dequeue( this, type );
                }
            } );
        },
        finish: function( type ) {
            if ( type !== false ) {
                type = type || "fx";
            }
            return this.each( function() {
                var index,
                    data = dataPriv.get( this ),
                    queue = data[ type + "queue" ],
                    hooks = data[ type + "queueHooks" ],
                    timers = jQuery.timers,
                    length = queue ? queue.length : 0;

                // Enable finishing flag on private data
                data.finish = true;

                // Empty the queue first
                jQuery.queue( this, type, [] );

                if ( hooks && hooks.stop ) {
                    hooks.stop.call( this, true );
                }

                // Look for any active animations, and finish them
                for ( index = timers.length; index--; ) {
                    if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
                        timers[ index ].anim.stop( true );
                        timers.splice( index, 1 );
                    }
                }

                // Look for any animations in the old queue and finish them
                for ( index = 0; index < length; index++ ) {
                    if ( queue[ index ] && queue[ index ].finish ) {
                        queue[ index ].finish.call( this );
                    }
                }

                // Turn off finishing flag
                delete data.finish;
            } );
        }
    } );

    jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
        var cssFn = jQuery.fn[ name ];
        jQuery.fn[ name ] = function( speed, easing, callback ) {
            return speed == null || typeof speed === "boolean" ?
                cssFn.apply( this, arguments ) :
                this.animate( genFx( name, true ), speed, easing, callback );
        };
    } );

// Generate shortcuts for custom animations
    jQuery.each( {
        slideDown: genFx( "show" ),
        slideUp: genFx( "hide" ),
        slideToggle: genFx( "toggle" ),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" }
    }, function( name, props ) {
        jQuery.fn[ name ] = function( speed, easing, callback ) {
            return this.animate( props, speed, easing, callback );
        };
    } );

    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer,
            i = 0,
            timers = jQuery.timers;

        fxNow = jQuery.now();

        for ( ; i < timers.length; i++ ) {
            timer = timers[ i ];

            // Run the timer and safely remove it when done (allowing for external removal)
            if ( !timer() && timers[ i ] === timer ) {
                timers.splice( i--, 1 );
            }
        }

        if ( !timers.length ) {
            jQuery.fx.stop();
        }
        fxNow = undefined;
    };

    jQuery.fx.timer = function( timer ) {
        jQuery.timers.push( timer );
        jQuery.fx.start();
    };

    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if ( inProgress ) {
            return;
        }

        inProgress = true;
        schedule();
    };

    jQuery.fx.stop = function() {
        inProgress = null;
    };

    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,

        // Default speed
        _default: 400
    };


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
    jQuery.fn.delay = function( time, type ) {
        time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
        type = type || "fx";

        return this.queue( type, function( next, hooks ) {
            var timeout = window.setTimeout( next, time );
            hooks.stop = function() {
                window.clearTimeout( timeout );
            };
        } );
    };


    ( function() {
        var input = document.createElement( "input" ),
            select = document.createElement( "select" ),
            opt = select.appendChild( document.createElement( "option" ) );

        input.type = "checkbox";

        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";

        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;

        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement( "input" );
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    } )();


    var boolHook,
        attrHandle = jQuery.expr.attrHandle;

    jQuery.fn.extend( {
        attr: function( name, value ) {
            return access( this, jQuery.attr, name, value, arguments.length > 1 );
        },

        removeAttr: function( name ) {
            return this.each( function() {
                jQuery.removeAttr( this, name );
            } );
        }
    } );

    jQuery.extend( {
        attr: function( elem, name, value ) {
            var ret, hooks,
                nType = elem.nodeType;

            // Don't get/set attributes on text, comment and attribute nodes
            if ( nType === 3 || nType === 8 || nType === 2 ) {
                return;
            }

            // Fallback to prop when attributes are not supported
            if ( typeof elem.getAttribute === "undefined" ) {
                return jQuery.prop( elem, name, value );
            }

            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
                hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
                    ( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
            }

            if ( value !== undefined ) {
                if ( value === null ) {
                    jQuery.removeAttr( elem, name );
                    return;
                }

                if ( hooks && "set" in hooks &&
                    ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
                    return ret;
                }

                elem.setAttribute( name, value + "" );
                return value;
            }

            if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
                return ret;
            }

            ret = jQuery.find.attr( elem, name );

            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },

        attrHooks: {
            type: {
                set: function( elem, value ) {
                    if ( !support.radioValue && value === "radio" &&
                        nodeName( elem, "input" ) ) {
                        var val = elem.value;
                        elem.setAttribute( "type", value );
                        if ( val ) {
                            elem.value = val;
                        }
                        return value;
                    }
                }
            }
        },

        removeAttr: function( elem, value ) {
            var name,
                i = 0,

                // Attribute names can contain non-HTML whitespace characters
                // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
                attrNames = value && value.match( rnothtmlwhite );

            if ( attrNames && elem.nodeType === 1 ) {
                while ( ( name = attrNames[ i++ ] ) ) {
                    elem.removeAttribute( name );
                }
            }
        }
    } );

// Hooks for boolean attributes
    boolHook = {
        set: function( elem, value, name ) {
            if ( value === false ) {

                // Remove boolean attributes when set to false
                jQuery.removeAttr( elem, name );
            } else {
                elem.setAttribute( name, name );
            }
            return name;
        }
    };

    jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
        var getter = attrHandle[ name ] || jQuery.find.attr;

        attrHandle[ name ] = function( elem, name, isXML ) {
            var ret, handle,
                lowercaseName = name.toLowerCase();

            if ( !isXML ) {

                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[ lowercaseName ];
                attrHandle[ lowercaseName ] = ret;
                ret = getter( elem, name, isXML ) != null ?
                    lowercaseName :
                    null;
                attrHandle[ lowercaseName ] = handle;
            }
            return ret;
        };
    } );




    var rfocusable = /^(?:input|select|textarea|button)$/i,
        rclickable = /^(?:a|area)$/i;

    jQuery.fn.extend( {
        prop: function( name, value ) {
            return access( this, jQuery.prop, name, value, arguments.length > 1 );
        },

        removeProp: function( name ) {
            return this.each( function() {
                delete this[ jQuery.propFix[ name ] || name ];
            } );
        }
    } );

    jQuery.extend( {
        prop: function( elem, name, value ) {
            var ret, hooks,
                nType = elem.nodeType;

            // Don't get/set properties on text, comment and attribute nodes
            if ( nType === 3 || nType === 8 || nType === 2 ) {
                return;
            }

            if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

                // Fix name and attach hooks
                name = jQuery.propFix[ name ] || name;
                hooks = jQuery.propHooks[ name ];
            }

            if ( value !== undefined ) {
                if ( hooks && "set" in hooks &&
                    ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
                    return ret;
                }

                return ( elem[ name ] = value );
            }

            if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
                return ret;
            }

            return elem[ name ];
        },

        propHooks: {
            tabIndex: {
                get: function( elem ) {

                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                    // Use proper attribute retrieval(#12072)
                    var tabindex = jQuery.find.attr( elem, "tabindex" );

                    if ( tabindex ) {
                        return parseInt( tabindex, 10 );
                    }

                    if (
                        rfocusable.test( elem.nodeName ) ||
                        rclickable.test( elem.nodeName ) &&
                        elem.href
                    ) {
                        return 0;
                    }

                    return -1;
                }
            }
        },

        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    } );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
    if ( !support.optSelected ) {
        jQuery.propHooks.selected = {
            get: function( elem ) {

                /* eslint no-unused-expressions: "off" */

                var parent = elem.parentNode;
                if ( parent && parent.parentNode ) {
                    parent.parentNode.selectedIndex;
                }
                return null;
            },
            set: function( elem ) {

                /* eslint no-unused-expressions: "off" */

                var parent = elem.parentNode;
                if ( parent ) {
                    parent.selectedIndex;

                    if ( parent.parentNode ) {
                        parent.parentNode.selectedIndex;
                    }
                }
            }
        };
    }

    jQuery.each( [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[ this.toLowerCase() ] = this;
    } );




    // Strip and collapse whitespace according to HTML spec
    // https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
    function stripAndCollapse( value ) {
        var tokens = value.match( rnothtmlwhite ) || [];
        return tokens.join( " " );
    }


    function getClass( elem ) {
        return elem.getAttribute && elem.getAttribute( "class" ) || "";
    }

    jQuery.fn.extend( {
        addClass: function( value ) {
            var classes, elem, cur, curValue, clazz, j, finalValue,
                i = 0;

            if ( jQuery.isFunction( value ) ) {
                return this.each( function( j ) {
                    jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
                } );
            }

            if ( typeof value === "string" && value ) {
                classes = value.match( rnothtmlwhite ) || [];

                while ( ( elem = this[ i++ ] ) ) {
                    curValue = getClass( elem );
                    cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

                    if ( cur ) {
                        j = 0;
                        while ( ( clazz = classes[ j++ ] ) ) {
                            if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
                                cur += clazz + " ";
                            }
                        }

                        // Only assign if different to avoid unneeded rendering.
                        finalValue = stripAndCollapse( cur );
                        if ( curValue !== finalValue ) {
                            elem.setAttribute( "class", finalValue );
                        }
                    }
                }
            }

            return this;
        },

        removeClass: function( value ) {
            var classes, elem, cur, curValue, clazz, j, finalValue,
                i = 0;

            if ( jQuery.isFunction( value ) ) {
                return this.each( function( j ) {
                    jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
                } );
            }

            if ( !arguments.length ) {
                return this.attr( "class", "" );
            }

            if ( typeof value === "string" && value ) {
                classes = value.match( rnothtmlwhite ) || [];

                while ( ( elem = this[ i++ ] ) ) {
                    curValue = getClass( elem );

                    // This expression is here for better compressibility (see addClass)
                    cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

                    if ( cur ) {
                        j = 0;
                        while ( ( clazz = classes[ j++ ] ) ) {

                            // Remove *all* instances
                            while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
                                cur = cur.replace( " " + clazz + " ", " " );
                            }
                        }

                        // Only assign if different to avoid unneeded rendering.
                        finalValue = stripAndCollapse( cur );
                        if ( curValue !== finalValue ) {
                            elem.setAttribute( "class", finalValue );
                        }
                    }
                }
            }

            return this;
        },

        toggleClass: function( value, stateVal ) {
            var type = typeof value;

            if ( typeof stateVal === "boolean" && type === "string" ) {
                return stateVal ? this.addClass( value ) : this.removeClass( value );
            }

            if ( jQuery.isFunction( value ) ) {
                return this.each( function( i ) {
                    jQuery( this ).toggleClass(
                        value.call( this, i, getClass( this ), stateVal ),
                        stateVal
                    );
                } );
            }

            return this.each( function() {
                var className, i, self, classNames;

                if ( type === "string" ) {

                    // Toggle individual class names
                    i = 0;
                    self = jQuery( this );
                    classNames = value.match( rnothtmlwhite ) || [];

                    while ( ( className = classNames[ i++ ] ) ) {

                        // Check each className given, space separated list
                        if ( self.hasClass( className ) ) {
                            self.removeClass( className );
                        } else {
                            self.addClass( className );
                        }
                    }

                    // Toggle whole class name
                } else if ( value === undefined || type === "boolean" ) {
                    className = getClass( this );
                    if ( className ) {

                        // Store className if set
                        dataPriv.set( this, "__className__", className );
                    }

                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if ( this.setAttribute ) {
                        this.setAttribute( "class",
                            className || value === false ?
                                "" :
                                dataPriv.get( this, "__className__" ) || ""
                        );
                    }
                }
            } );
        },

        hasClass: function( selector ) {
            var className, elem,
                i = 0;

            className = " " + selector + " ";
            while ( ( elem = this[ i++ ] ) ) {
                if ( elem.nodeType === 1 &&
                    ( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
                    return true;
                }
            }

            return false;
        }
    } );




    var rreturn = /\r/g;

    jQuery.fn.extend( {
        val: function( value ) {
            var hooks, ret, isFunction,
                elem = this[ 0 ];

            if ( !arguments.length ) {
                if ( elem ) {
                    hooks = jQuery.valHooks[ elem.type ] ||
                        jQuery.valHooks[ elem.nodeName.toLowerCase() ];

                    if ( hooks &&
                        "get" in hooks &&
                        ( ret = hooks.get( elem, "value" ) ) !== undefined
                    ) {
                        return ret;
                    }

                    ret = elem.value;

                    // Handle most common string cases
                    if ( typeof ret === "string" ) {
                        return ret.replace( rreturn, "" );
                    }

                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }

                return;
            }

            isFunction = jQuery.isFunction( value );

            return this.each( function( i ) {
                var val;

                if ( this.nodeType !== 1 ) {
                    return;
                }

                if ( isFunction ) {
                    val = value.call( this, i, jQuery( this ).val() );
                } else {
                    val = value;
                }

                // Treat null/undefined as ""; convert numbers to string
                if ( val == null ) {
                    val = "";

                } else if ( typeof val === "number" ) {
                    val += "";

                } else if ( Array.isArray( val ) ) {
                    val = jQuery.map( val, function( value ) {
                        return value == null ? "" : value + "";
                    } );
                }

                hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

                // If set returns undefined, fall back to normal setting
                if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
                    this.value = val;
                }
            } );
        }
    } );

    jQuery.extend( {
        valHooks: {
            option: {
                get: function( elem ) {

                    var val = jQuery.find.attr( elem, "value" );
                    return val != null ?
                        val :

                        // Support: IE <=10 - 11 only
                        // option.text throws exceptions (#14686, #14858)
                        // Strip and collapse whitespace
                        // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                        stripAndCollapse( jQuery.text( elem ) );
                }
            },
            select: {
                get: function( elem ) {
                    var value, option, i,
                        options = elem.options,
                        index = elem.selectedIndex,
                        one = elem.type === "select-one",
                        values = one ? null : [],
                        max = one ? index + 1 : options.length;

                    if ( index < 0 ) {
                        i = max;

                    } else {
                        i = one ? index : 0;
                    }

                    // Loop through all the selected options
                    for ( ; i < max; i++ ) {
                        option = options[ i ];

                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (#2551)
                        if ( ( option.selected || i === index ) &&

                            // Don't return options that are disabled or in a disabled optgroup
                            !option.disabled &&
                            ( !option.parentNode.disabled ||
                                !nodeName( option.parentNode, "optgroup" ) ) ) {

                            // Get the specific value for the option
                            value = jQuery( option ).val();

                            // We don't need an array for one selects
                            if ( one ) {
                                return value;
                            }

                            // Multi-Selects return an array
                            values.push( value );
                        }
                    }

                    return values;
                },

                set: function( elem, value ) {
                    var optionSet, option,
                        options = elem.options,
                        values = jQuery.makeArray( value ),
                        i = options.length;

                    while ( i-- ) {
                        option = options[ i ];

                        /* eslint-disable no-cond-assign */

                        if ( option.selected =
                                jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
                        ) {
                            optionSet = true;
                        }

                        /* eslint-enable no-cond-assign */
                    }

                    // Force browsers to behave consistently when non-matching value is set
                    if ( !optionSet ) {
                        elem.selectedIndex = -1;
                    }
                    return values;
                }
            }
        }
    } );

// Radios and checkboxes getter/setter
    jQuery.each( [ "radio", "checkbox" ], function() {
        jQuery.valHooks[ this ] = {
            set: function( elem, value ) {
                if ( Array.isArray( value ) ) {
                    return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
                }
            }
        };
        if ( !support.checkOn ) {
            jQuery.valHooks[ this ].get = function( elem ) {
                return elem.getAttribute( "value" ) === null ? "on" : elem.value;
            };
        }
    } );




// Return jQuery for attributes-only inclusion


    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

    jQuery.extend( jQuery.event, {

        trigger: function( event, data, elem, onlyHandlers ) {

            var i, cur, tmp, bubbleType, ontype, handle, special,
                eventPath = [ elem || document ],
                type = hasOwn.call( event, "type" ) ? event.type : event,
                namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

            cur = tmp = elem = elem || document;

            // Don't do events on text and comment nodes
            if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
                return;
            }

            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
                return;
            }

            if ( type.indexOf( "." ) > -1 ) {

                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split( "." );
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf( ":" ) < 0 && "on" + type;

            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[ jQuery.expando ] ?
                event :
                new jQuery.Event( type, typeof event === "object" && event );

            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join( "." );
            event.rnamespace = event.namespace ?
                new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
                null;

            // Clean up the event in case it is being reused
            event.result = undefined;
            if ( !event.target ) {
                event.target = elem;
            }

            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ?
                [ event ] :
                jQuery.makeArray( data, [ event ] );

            // Allow special events to draw outside the lines
            special = jQuery.event.special[ type ] || {};
            if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
                return;
            }

            // Determine event propagation path in advance, per W3C events spec (#9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
            if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

                bubbleType = special.delegateType || type;
                if ( !rfocusMorph.test( bubbleType + type ) ) {
                    cur = cur.parentNode;
                }
                for ( ; cur; cur = cur.parentNode ) {
                    eventPath.push( cur );
                    tmp = cur;
                }

                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if ( tmp === ( elem.ownerDocument || document ) ) {
                    eventPath.push( tmp.defaultView || tmp.parentWindow || window );
                }
            }

            // Fire handlers on the event path
            i = 0;
            while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

                event.type = i > 1 ?
                    bubbleType :
                    special.bindType || type;

                // jQuery handler
                handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
                    dataPriv.get( cur, "handle" );
                if ( handle ) {
                    handle.apply( cur, data );
                }

                // Native handler
                handle = ontype && cur[ ontype ];
                if ( handle && handle.apply && acceptData( cur ) ) {
                    event.result = handle.apply( cur, data );
                    if ( event.result === false ) {
                        event.preventDefault();
                    }
                }
            }
            event.type = type;

            // If nobody prevented the default action, do it now
            if ( !onlyHandlers && !event.isDefaultPrevented() ) {

                if ( ( !special._default ||
                        special._default.apply( eventPath.pop(), data ) === false ) &&
                    acceptData( elem ) ) {

                    // Call a native DOM method on the target with the same name as the event.
                    // Don't do default actions on window, that's where global variables be (#6170)
                    if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ ontype ];

                        if ( tmp ) {
                            elem[ ontype ] = null;
                        }

                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        elem[ type ]();
                        jQuery.event.triggered = undefined;

                        if ( tmp ) {
                            elem[ ontype ] = tmp;
                        }
                    }
                }
            }

            return event.result;
        },

        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function( type, elem, event ) {
            var e = jQuery.extend(
                new jQuery.Event(),
                event,
                {
                    type: type,
                    isSimulated: true
                }
            );

            jQuery.event.trigger( e, null, elem );
        }

    } );

    jQuery.fn.extend( {

        trigger: function( type, data ) {
            return this.each( function() {
                jQuery.event.trigger( type, data, this );
            } );
        },
        triggerHandler: function( type, data ) {
            var elem = this[ 0 ];
            if ( elem ) {
                return jQuery.event.trigger( type, data, elem, true );
            }
        }
    } );


    jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
        "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
        "change select submit keydown keypress keyup contextmenu" ).split( " " ),
        function( i, name ) {

            // Handle event binding
            jQuery.fn[ name ] = function( data, fn ) {
                return arguments.length > 0 ?
                    this.on( name, null, data, fn ) :
                    this.trigger( name );
            };
        } );

    jQuery.fn.extend( {
        hover: function( fnOver, fnOut ) {
            return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
        }
    } );




    support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
    if ( !support.focusin ) {
        jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

            // Attach a single capturing handler on the document while someone wants focusin/focusout
            var handler = function( event ) {
                jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
            };

            jQuery.event.special[ fix ] = {
                setup: function() {
                    var doc = this.ownerDocument || this,
                        attaches = dataPriv.access( doc, fix );

                    if ( !attaches ) {
                        doc.addEventListener( orig, handler, true );
                    }
                    dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
                },
                teardown: function() {
                    var doc = this.ownerDocument || this,
                        attaches = dataPriv.access( doc, fix ) - 1;

                    if ( !attaches ) {
                        doc.removeEventListener( orig, handler, true );
                        dataPriv.remove( doc, fix );

                    } else {
                        dataPriv.access( doc, fix, attaches );
                    }
                }
            };
        } );
    }
    var location = window.location;

    var nonce = jQuery.now();

    var rquery = ( /\?/ );



// Cross-browser xml parsing
    jQuery.parseXML = function( data ) {
        var xml;
        if ( !data || typeof data !== "string" ) {
            return null;
        }

        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
        } catch ( e ) {
            xml = undefined;
        }

        if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
            jQuery.error( "Invalid XML: " + data );
        }
        return xml;
    };


    var
        rbracket = /\[\]$/,
        rCRLF = /\r?\n/g,
        rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
        rsubmittable = /^(?:input|select|textarea|keygen)/i;

    function buildParams( prefix, obj, traditional, add ) {
        var name;

        if ( Array.isArray( obj ) ) {

            // Serialize array item.
            jQuery.each( obj, function( i, v ) {
                if ( traditional || rbracket.test( prefix ) ) {

                    // Treat each array item as a scalar.
                    add( prefix, v );

                } else {

                    // Item is non-scalar (array or object), encode its numeric index.
                    buildParams(
                        prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
                        v,
                        traditional,
                        add
                    );
                }
            } );

        } else if ( !traditional && jQuery.type( obj ) === "object" ) {

            // Serialize object item.
            for ( name in obj ) {
                buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
            }

        } else {

            // Serialize scalar item.
            add( prefix, obj );
        }
    }

// Serialize an array of form elements or a set of
// key/values into a query string
    jQuery.param = function( a, traditional ) {
        var prefix,
            s = [],
            add = function( key, valueOrFunction ) {

                // If value is a function, invoke it and use its return value
                var value = jQuery.isFunction( valueOrFunction ) ?
                    valueOrFunction() :
                    valueOrFunction;

                s[ s.length ] = encodeURIComponent( key ) + "=" +
                    encodeURIComponent( value == null ? "" : value );
            };

        // If an array was passed in, assume that it is an array of form elements.
        if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

            // Serialize the form elements
            jQuery.each( a, function() {
                add( this.name, this.value );
            } );

        } else {

            // If traditional, encode the "old" way (the way 1.3.2 or older
            // did it), otherwise encode params recursively.
            for ( prefix in a ) {
                buildParams( prefix, a[ prefix ], traditional, add );
            }
        }

        // Return the resulting serialization
        return s.join( "&" );
    };

    jQuery.fn.extend( {
        serialize: function() {
            return jQuery.param( this.serializeArray() );
        },
        serializeArray: function() {
            return this.map( function() {

                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop( this, "elements" );
                return elements ? jQuery.makeArray( elements ) : this;
            } )
                .filter( function() {
                    var type = this.type;

                    // Use .is( ":disabled" ) so that fieldset[disabled] works
                    return this.name && !jQuery( this ).is( ":disabled" ) &&
                        rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
                        ( this.checked || !rcheckableType.test( type ) );
                } )
                .map( function( i, elem ) {
                    var val = jQuery( this ).val();

                    if ( val == null ) {
                        return null;
                    }

                    if ( Array.isArray( val ) ) {
                        return jQuery.map( val, function( val ) {
                            return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
                        } );
                    }

                    return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
                } ).get();
        }
    } );


    var
        r20 = /%20/g,
        rhash = /#.*$/,
        rantiCache = /([?&])_=[^&]*/,
        rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

        // #7653, #8125, #8152: local protocol detection
        rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
        rnoContent = /^(?:GET|HEAD)$/,
        rprotocol = /^\/\//,

        /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
        prefilters = {},

        /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
        transports = {},

        // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
        allTypes = "*/".concat( "*" ),

        // Anchor tag for parsing the document origin
        originAnchor = document.createElement( "a" );
    originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports( structure ) {

        // dataTypeExpression is optional and defaults to "*"
        return function( dataTypeExpression, func ) {

            if ( typeof dataTypeExpression !== "string" ) {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }

            var dataType,
                i = 0,
                dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

            if ( jQuery.isFunction( func ) ) {

                // For each dataType in the dataTypeExpression
                while ( ( dataType = dataTypes[ i++ ] ) ) {

                    // Prepend if requested
                    if ( dataType[ 0 ] === "+" ) {
                        dataType = dataType.slice( 1 ) || "*";
                        ( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

                        // Otherwise append
                    } else {
                        ( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
                    }
                }
            }
        };
    }

// Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

        var inspected = {},
            seekingTransport = ( structure === transports );

        function inspect( dataType ) {
            var selected;
            inspected[ dataType ] = true;
            jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
                var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
                if ( typeof dataTypeOrTransport === "string" &&
                    !seekingTransport && !inspected[ dataTypeOrTransport ] ) {

                    options.dataTypes.unshift( dataTypeOrTransport );
                    inspect( dataTypeOrTransport );
                    return false;
                } else if ( seekingTransport ) {
                    return !( selected = dataTypeOrTransport );
                }
            } );
            return selected;
        }

        return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
    }

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
    function ajaxExtend( target, src ) {
        var key, deep,
            flatOptions = jQuery.ajaxSettings.flatOptions || {};

        for ( key in src ) {
            if ( src[ key ] !== undefined ) {
                ( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
            }
        }
        if ( deep ) {
            jQuery.extend( true, target, deep );
        }

        return target;
    }

    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
    function ajaxHandleResponses( s, jqXHR, responses ) {

        var ct, type, finalDataType, firstDataType,
            contents = s.contents,
            dataTypes = s.dataTypes;

        // Remove auto dataType and get content-type in the process
        while ( dataTypes[ 0 ] === "*" ) {
            dataTypes.shift();
            if ( ct === undefined ) {
                ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
            }
        }

        // Check if we're dealing with a known content-type
        if ( ct ) {
            for ( type in contents ) {
                if ( contents[ type ] && contents[ type ].test( ct ) ) {
                    dataTypes.unshift( type );
                    break;
                }
            }
        }

        // Check to see if we have a response for the expected dataType
        if ( dataTypes[ 0 ] in responses ) {
            finalDataType = dataTypes[ 0 ];
        } else {

            // Try convertible dataTypes
            for ( type in responses ) {
                if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
                    finalDataType = type;
                    break;
                }
                if ( !firstDataType ) {
                    firstDataType = type;
                }
            }

            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }

        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if ( finalDataType ) {
            if ( finalDataType !== dataTypes[ 0 ] ) {
                dataTypes.unshift( finalDataType );
            }
            return responses[ finalDataType ];
        }
    }

    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
    function ajaxConvert( s, response, jqXHR, isSuccess ) {
        var conv2, current, conv, tmp, prev,
            converters = {},

            // Work with a copy of dataTypes in case we need to modify it for conversion
            dataTypes = s.dataTypes.slice();

        // Create converters map with lowercased keys
        if ( dataTypes[ 1 ] ) {
            for ( conv in s.converters ) {
                converters[ conv.toLowerCase() ] = s.converters[ conv ];
            }
        }

        current = dataTypes.shift();

        // Convert to each sequential dataType
        while ( current ) {

            if ( s.responseFields[ current ] ) {
                jqXHR[ s.responseFields[ current ] ] = response;
            }

            // Apply the dataFilter if provided
            if ( !prev && isSuccess && s.dataFilter ) {
                response = s.dataFilter( response, s.dataType );
            }

            prev = current;
            current = dataTypes.shift();

            if ( current ) {

                // There's only work to do if current dataType is non-auto
                if ( current === "*" ) {

                    current = prev;

                    // Convert response if prev dataType is non-auto and differs from current
                } else if ( prev !== "*" && prev !== current ) {

                    // Seek a direct converter
                    conv = converters[ prev + " " + current ] || converters[ "* " + current ];

                    // If none found, seek a pair
                    if ( !conv ) {
                        for ( conv2 in converters ) {

                            // If conv2 outputs current
                            tmp = conv2.split( " " );
                            if ( tmp[ 1 ] === current ) {

                                // If prev can be converted to accepted input
                                conv = converters[ prev + " " + tmp[ 0 ] ] ||
                                    converters[ "* " + tmp[ 0 ] ];
                                if ( conv ) {

                                    // Condense equivalence converters
                                    if ( conv === true ) {
                                        conv = converters[ conv2 ];

                                        // Otherwise, insert the intermediate dataType
                                    } else if ( converters[ conv2 ] !== true ) {
                                        current = tmp[ 0 ];
                                        dataTypes.unshift( tmp[ 1 ] );
                                    }
                                    break;
                                }
                            }
                        }
                    }

                    // Apply converter (if not an equivalence)
                    if ( conv !== true ) {

                        // Unless errors are allowed to bubble, catch and return them
                        if ( conv && s.throws ) {
                            response = conv( response );
                        } else {
                            try {
                                response = conv( response );
                            } catch ( e ) {
                                return {
                                    state: "parsererror",
                                    error: conv ? e : "No conversion from " + prev + " to " + current
                                };
                            }
                        }
                    }
                }
            }
        }

        return { state: "success", data: response };
    }

    jQuery.extend( {

        // Counter for holding the number of active queries
        active: 0,

        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},

        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test( location.protocol ),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",

            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

            accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },

            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },

            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },

            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {

                // Convert anything to text
                "* text": String,

                // Text to html (true = no transformation)
                "text html": true,

                // Evaluate text as a json expression
                "text json": JSON.parse,

                // Parse text as xml
                "text xml": jQuery.parseXML
            },

            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },

        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function( target, settings ) {
            return settings ?

                // Building a settings object
                ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

                // Extending ajaxSettings
                ajaxExtend( jQuery.ajaxSettings, target );
        },

        ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
        ajaxTransport: addToPrefiltersOrTransports( transports ),

        // Main method
        ajax: function( url, options ) {

            // If url is an object, simulate pre-1.5 signature
            if ( typeof url === "object" ) {
                options = url;
                url = undefined;
            }

            // Force options to be an object
            options = options || {};

            var transport,

                // URL without anti-cache param
                cacheURL,

                // Response headers
                responseHeadersString,
                responseHeaders,

                // timeout handle
                timeoutTimer,

                // Url cleanup var
                urlAnchor,

                // Request state (becomes false upon send and true upon completion)
                completed,

                // To know if global events are to be dispatched
                fireGlobals,

                // Loop variable
                i,

                // uncached part of the url
                uncached,

                // Create the final options object
                s = jQuery.ajaxSetup( {}, options ),

                // Callbacks context
                callbackContext = s.context || s,

                // Context for global events is callbackContext if it is a DOM node or jQuery collection
                globalEventContext = s.context &&
                ( callbackContext.nodeType || callbackContext.jquery ) ?
                    jQuery( callbackContext ) :
                    jQuery.event,

                // Deferreds
                deferred = jQuery.Deferred(),
                completeDeferred = jQuery.Callbacks( "once memory" ),

                // Status-dependent callbacks
                statusCode = s.statusCode || {},

                // Headers (they are sent all at once)
                requestHeaders = {},
                requestHeadersNames = {},

                // Default abort message
                strAbort = "canceled",

                // Fake xhr
                jqXHR = {
                    readyState: 0,

                    // Builds headers hashtable if needed
                    getResponseHeader: function( key ) {
                        var match;
                        if ( completed ) {
                            if ( !responseHeaders ) {
                                responseHeaders = {};
                                while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
                                    responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
                                }
                            }
                            match = responseHeaders[ key.toLowerCase() ];
                        }
                        return match == null ? null : match;
                    },

                    // Raw string
                    getAllResponseHeaders: function() {
                        return completed ? responseHeadersString : null;
                    },

                    // Caches the header
                    setRequestHeader: function( name, value ) {
                        if ( completed == null ) {
                            name = requestHeadersNames[ name.toLowerCase() ] =
                                requestHeadersNames[ name.toLowerCase() ] || name;
                            requestHeaders[ name ] = value;
                        }
                        return this;
                    },

                    // Overrides response content-type header
                    overrideMimeType: function( type ) {
                        if ( completed == null ) {
                            s.mimeType = type;
                        }
                        return this;
                    },

                    // Status-dependent callbacks
                    statusCode: function( map ) {
                        var code;
                        if ( map ) {
                            if ( completed ) {

                                // Execute the appropriate callbacks
                                jqXHR.always( map[ jqXHR.status ] );
                            } else {

                                // Lazy-add the new callbacks in a way that preserves old ones
                                for ( code in map ) {
                                    statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
                                }
                            }
                        }
                        return this;
                    },

                    // Cancel the request
                    abort: function( statusText ) {
                        var finalText = statusText || strAbort;
                        if ( transport ) {
                            transport.abort( finalText );
                        }
                        done( 0, finalText );
                        return this;
                    }
                };

            // Attach deferreds
            deferred.promise( jqXHR );

            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (#10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ( ( url || s.url || location.href ) + "" )
                .replace( rprotocol, location.protocol + "//" );

            // Alias method option to type as per ticket #12004
            s.type = options.method || options.type || s.method || s.type;

            // Extract dataTypes list
            s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

            // A cross-domain request is in order when the origin doesn't match the current origin.
            if ( s.crossDomain == null ) {
                urlAnchor = document.createElement( "a" );

                // Support: IE <=8 - 11, Edge 12 - 13
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;

                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
                        urlAnchor.protocol + "//" + urlAnchor.host;
                } catch ( e ) {

                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }

            // Convert data if not already a string
            if ( s.data && s.processData && typeof s.data !== "string" ) {
                s.data = jQuery.param( s.data, s.traditional );
            }

            // Apply prefilters
            inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

            // If request was aborted inside a prefilter, stop there
            if ( completed ) {
                return jqXHR;
            }

            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
            fireGlobals = jQuery.event && s.global;

            // Watch for a new set of requests
            if ( fireGlobals && jQuery.active++ === 0 ) {
                jQuery.event.trigger( "ajaxStart" );
            }

            // Uppercase the type
            s.type = s.type.toUpperCase();

            // Determine if request has content
            s.hasContent = !rnoContent.test( s.type );

            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace( rhash, "" );

            // More options handling for requests with no content
            if ( !s.hasContent ) {

                // Remember the hash so we can put it back
                uncached = s.url.slice( cacheURL.length );

                // If data is available, append data to url
                if ( s.data ) {
                    cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

                    // #9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }

                // Add or update anti-cache param if needed
                if ( s.cache === false ) {
                    cacheURL = cacheURL.replace( rantiCache, "$1" );
                    uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
                }

                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;

                // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if ( s.data && s.processData &&
                ( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
                s.data = s.data.replace( r20, "+" );
            }

            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if ( s.ifModified ) {
                if ( jQuery.lastModified[ cacheURL ] ) {
                    jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
                }
                if ( jQuery.etag[ cacheURL ] ) {
                    jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
                }
            }

            // Set the correct header, if data is being sent
            if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
                jqXHR.setRequestHeader( "Content-Type", s.contentType );
            }

            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader(
                "Accept",
                s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
                    s.accepts[ s.dataTypes[ 0 ] ] +
                    ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
                    s.accepts[ "*" ]
            );

            // Check for headers option
            for ( i in s.headers ) {
                jqXHR.setRequestHeader( i, s.headers[ i ] );
            }

            // Allow custom headers/mimetypes and early abort
            if ( s.beforeSend &&
                ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

                // Abort if not done already and return
                return jqXHR.abort();
            }

            // Aborting is no longer a cancellation
            strAbort = "abort";

            // Install callbacks on deferreds
            completeDeferred.add( s.complete );
            jqXHR.done( s.success );
            jqXHR.fail( s.error );

            // Get transport
            transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

            // If no transport, we auto-abort
            if ( !transport ) {
                done( -1, "No Transport" );
            } else {
                jqXHR.readyState = 1;

                // Send global event
                if ( fireGlobals ) {
                    globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
                }

                // If request was aborted inside ajaxSend, stop there
                if ( completed ) {
                    return jqXHR;
                }

                // Timeout
                if ( s.async && s.timeout > 0 ) {
                    timeoutTimer = window.setTimeout( function() {
                        jqXHR.abort( "timeout" );
                    }, s.timeout );
                }

                try {
                    completed = false;
                    transport.send( requestHeaders, done );
                } catch ( e ) {

                    // Rethrow post-completion exceptions
                    if ( completed ) {
                        throw e;
                    }

                    // Propagate others as results
                    done( -1, e );
                }
            }

            // Callback for when everything is done
            function done( status, nativeStatusText, responses, headers ) {
                var isSuccess, success, error, response, modified,
                    statusText = nativeStatusText;

                // Ignore repeat invocations
                if ( completed ) {
                    return;
                }

                completed = true;

                // Clear timeout if it exists
                if ( timeoutTimer ) {
                    window.clearTimeout( timeoutTimer );
                }

                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;

                // Cache response headers
                responseHeadersString = headers || "";

                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;

                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;

                // Get response data
                if ( responses ) {
                    response = ajaxHandleResponses( s, jqXHR, responses );
                }

                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert( s, response, jqXHR, isSuccess );

                // If successful, handle type chaining
                if ( isSuccess ) {

                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if ( s.ifModified ) {
                        modified = jqXHR.getResponseHeader( "Last-Modified" );
                        if ( modified ) {
                            jQuery.lastModified[ cacheURL ] = modified;
                        }
                        modified = jqXHR.getResponseHeader( "etag" );
                        if ( modified ) {
                            jQuery.etag[ cacheURL ] = modified;
                        }
                    }

                    // if no content
                    if ( status === 204 || s.type === "HEAD" ) {
                        statusText = "nocontent";

                        // if not modified
                    } else if ( status === 304 ) {
                        statusText = "notmodified";

                        // If we have data, let's convert it
                    } else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {

                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if ( status || !statusText ) {
                        statusText = "error";
                        if ( status < 0 ) {
                            status = 0;
                        }
                    }
                }

                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = ( nativeStatusText || statusText ) + "";

                // Success/Error
                if ( isSuccess ) {
                    deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
                } else {
                    deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
                }

                // Status-dependent callbacks
                jqXHR.statusCode( statusCode );
                statusCode = undefined;

                if ( fireGlobals ) {
                    globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
                        [ jqXHR, s, isSuccess ? success : error ] );
                }

                // Complete
                completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

                if ( fireGlobals ) {
                    globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

                    // Handle the global AJAX counter
                    if ( !( --jQuery.active ) ) {
                        jQuery.event.trigger( "ajaxStop" );
                    }
                }
            }

            return jqXHR;
        },

        getJSON: function( url, data, callback ) {
            return jQuery.get( url, data, callback, "json" );
        },

        getScript: function( url, callback ) {
            return jQuery.get( url, undefined, callback, "script" );
        }
    } );

    jQuery.each( [ "get", "post" ], function( i, method ) {
        jQuery[ method ] = function( url, data, callback, type ) {

            // Shift arguments if data argument was omitted
            if ( jQuery.isFunction( data ) ) {
                type = type || callback;
                callback = data;
                data = undefined;
            }

            // The url can be an options object (which then must have .url)
            return jQuery.ajax( jQuery.extend( {
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject( url ) && url ) );
        };
    } );


    jQuery._evalUrl = function( url ) {
        return jQuery.ajax( {
            url: url,

            // Make this explicit, since user can override this through ajaxSetup (#11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            "throws": true
        } );
    };


    jQuery.fn.extend( {
        wrapAll: function( html ) {
            var wrap;

            if ( this[ 0 ] ) {
                if ( jQuery.isFunction( html ) ) {
                    html = html.call( this[ 0 ] );
                }

                // The elements to wrap the target around
                wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

                if ( this[ 0 ].parentNode ) {
                    wrap.insertBefore( this[ 0 ] );
                }

                wrap.map( function() {
                    var elem = this;

                    while ( elem.firstElementChild ) {
                        elem = elem.firstElementChild;
                    }

                    return elem;
                } ).append( this );
            }

            return this;
        },

        wrapInner: function( html ) {
            if ( jQuery.isFunction( html ) ) {
                return this.each( function( i ) {
                    jQuery( this ).wrapInner( html.call( this, i ) );
                } );
            }

            return this.each( function() {
                var self = jQuery( this ),
                    contents = self.contents();

                if ( contents.length ) {
                    contents.wrapAll( html );

                } else {
                    self.append( html );
                }
            } );
        },

        wrap: function( html ) {
            var isFunction = jQuery.isFunction( html );

            return this.each( function( i ) {
                jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
            } );
        },

        unwrap: function( selector ) {
            this.parent( selector ).not( "body" ).each( function() {
                jQuery( this ).replaceWith( this.childNodes );
            } );
            return this;
        }
    } );


    jQuery.expr.pseudos.hidden = function( elem ) {
        return !jQuery.expr.pseudos.visible( elem );
    };
    jQuery.expr.pseudos.visible = function( elem ) {
        return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
    };




    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window.XMLHttpRequest();
        } catch ( e ) {}
    };

    var xhrSuccessStatus = {

            // File protocol always yields status code 0, assume 200
            0: 200,

            // Support: IE <=9 only
            // #1450: sometimes IE returns 1223 when it should be 204
            1223: 204
        },
        xhrSupported = jQuery.ajaxSettings.xhr();

    support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
    support.ajax = xhrSupported = !!xhrSupported;

    jQuery.ajaxTransport( function( options ) {
        var callback, errorCallback;

        // Cross domain only allowed if supported through XMLHttpRequest
        if ( support.cors || xhrSupported && !options.crossDomain ) {
            return {
                send: function( headers, complete ) {
                    var i,
                        xhr = options.xhr();

                    xhr.open(
                        options.type,
                        options.url,
                        options.async,
                        options.username,
                        options.password
                    );

                    // Apply custom fields if provided
                    if ( options.xhrFields ) {
                        for ( i in options.xhrFields ) {
                            xhr[ i ] = options.xhrFields[ i ];
                        }
                    }

                    // Override mime type if needed
                    if ( options.mimeType && xhr.overrideMimeType ) {
                        xhr.overrideMimeType( options.mimeType );
                    }

                    // X-Requested-With header
                    // For cross-domain requests, seeing as conditions for a preflight are
                    // akin to a jigsaw puzzle, we simply never set it to be sure.
                    // (it can always be set on a per-request basis or even using ajaxSetup)
                    // For same-domain requests, won't change header if already provided.
                    if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
                        headers[ "X-Requested-With" ] = "XMLHttpRequest";
                    }

                    // Set headers
                    for ( i in headers ) {
                        xhr.setRequestHeader( i, headers[ i ] );
                    }

                    // Callback
                    callback = function( type ) {
                        return function() {
                            if ( callback ) {
                                callback = errorCallback = xhr.onload =
                                    xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

                                if ( type === "abort" ) {
                                    xhr.abort();
                                } else if ( type === "error" ) {

                                    // Support: IE <=9 only
                                    // On a manual native abort, IE9 throws
                                    // errors on any property access that is not readyState
                                    if ( typeof xhr.status !== "number" ) {
                                        complete( 0, "error" );
                                    } else {
                                        complete(

                                            // File: protocol always yields status 0; see #8605, #14207
                                            xhr.status,
                                            xhr.statusText
                                        );
                                    }
                                } else {
                                    complete(
                                        xhrSuccessStatus[ xhr.status ] || xhr.status,
                                        xhr.statusText,

                                        // Support: IE <=9 only
                                        // IE9 has no XHR2 but throws on binary (trac-11426)
                                        // For XHR2 non-text, let the caller handle it (gh-2498)
                                        ( xhr.responseType || "text" ) !== "text"  ||
                                        typeof xhr.responseText !== "string" ?
                                            { binary: xhr.response } :
                                            { text: xhr.responseText },
                                        xhr.getAllResponseHeaders()
                                    );
                                }
                            }
                        };
                    };

                    // Listen to events
                    xhr.onload = callback();
                    errorCallback = xhr.onerror = callback( "error" );

                    // Support: IE 9 only
                    // Use onreadystatechange to replace onabort
                    // to handle uncaught aborts
                    if ( xhr.onabort !== undefined ) {
                        xhr.onabort = errorCallback;
                    } else {
                        xhr.onreadystatechange = function() {

                            // Check readyState before timeout as it changes
                            if ( xhr.readyState === 4 ) {

                                // Allow onerror to be called first,
                                // but that will not handle a native abort
                                // Also, save errorCallback to a variable
                                // as xhr.onerror cannot be accessed
                                window.setTimeout( function() {
                                    if ( callback ) {
                                        errorCallback();
                                    }
                                } );
                            }
                        };
                    }

                    // Create the abort callback
                    callback = callback( "abort" );

                    try {

                        // Do send the request (this may raise an exception)
                        xhr.send( options.hasContent && options.data || null );
                    } catch ( e ) {

                        // #14683: Only rethrow if this hasn't been notified as an error yet
                        if ( callback ) {
                            throw e;
                        }
                    }
                },

                abort: function() {
                    if ( callback ) {
                        callback();
                    }
                }
            };
        }
    } );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter( function( s ) {
        if ( s.crossDomain ) {
            s.contents.script = false;
        }
    } );

// Install script dataType
    jQuery.ajaxSetup( {
        accepts: {
            script: "text/javascript, application/javascript, " +
            "application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function( text ) {
                jQuery.globalEval( text );
                return text;
            }
        }
    } );

// Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter( "script", function( s ) {
        if ( s.cache === undefined ) {
            s.cache = false;
        }
        if ( s.crossDomain ) {
            s.type = "GET";
        }
    } );

// Bind script tag hack transport
    jQuery.ajaxTransport( "script", function( s ) {

        // This transport only deals with cross domain requests
        if ( s.crossDomain ) {
            var script, callback;
            return {
                send: function( _, complete ) {
                    script = jQuery( "<script>" ).prop( {
                        charset: s.scriptCharset,
                        src: s.url
                    } ).on(
                        "load error",
                        callback = function( evt ) {
                            script.remove();
                            callback = null;
                            if ( evt ) {
                                complete( evt.type === "error" ? 404 : 200, evt.type );
                            }
                        }
                    );

                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild( script[ 0 ] );
                },
                abort: function() {
                    if ( callback ) {
                        callback();
                    }
                }
            };
        }
    } );




    var oldCallbacks = [],
        rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
    jQuery.ajaxSetup( {
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
            this[ callback ] = true;
            return callback;
        }
    } );

// Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

        var callbackName, overwritten, responseContainer,
            jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
                    "url" :
                    typeof s.data === "string" &&
                    ( s.contentType || "" )
                        .indexOf( "application/x-www-form-urlencoded" ) === 0 &&
                    rjsonp.test( s.data ) && "data"
            );

        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
                s.jsonpCallback() :
                s.jsonpCallback;

            // Insert callback into url or form data
            if ( jsonProp ) {
                s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
            } else if ( s.jsonp !== false ) {
                s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
            }

            // Use data converter to retrieve json after script execution
            s.converters[ "script json" ] = function() {
                if ( !responseContainer ) {
                    jQuery.error( callbackName + " was not called" );
                }
                return responseContainer[ 0 ];
            };

            // Force json dataType
            s.dataTypes[ 0 ] = "json";

            // Install callback
            overwritten = window[ callbackName ];
            window[ callbackName ] = function() {
                responseContainer = arguments;
            };

            // Clean-up function (fires after converters)
            jqXHR.always( function() {

                // If previous value didn't exist - remove it
                if ( overwritten === undefined ) {
                    jQuery( window ).removeProp( callbackName );

                    // Otherwise restore preexisting value
                } else {
                    window[ callbackName ] = overwritten;
                }

                // Save back as free
                if ( s[ callbackName ] ) {

                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;

                    // Save the callback name for future use
                    oldCallbacks.push( callbackName );
                }

                // Call if it was a function and we have a response
                if ( responseContainer && jQuery.isFunction( overwritten ) ) {
                    overwritten( responseContainer[ 0 ] );
                }

                responseContainer = overwritten = undefined;
            } );

            // Delegate to script
            return "script";
        }
    } );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = ( function() {
        var body = document.implementation.createHTMLDocument( "" ).body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    } )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function( data, context, keepScripts ) {
        if ( typeof data !== "string" ) {
            return [];
        }
        if ( typeof context === "boolean" ) {
            keepScripts = context;
            context = false;
        }

        var base, parsed, scripts;

        if ( !context ) {

            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if ( support.createHTMLDocument ) {
                context = document.implementation.createHTMLDocument( "" );

                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement( "base" );
                base.href = document.location.href;
                context.head.appendChild( base );
            } else {
                context = document;
            }
        }

        parsed = rsingleTag.exec( data );
        scripts = !keepScripts && [];

        // Single tag
        if ( parsed ) {
            return [ context.createElement( parsed[ 1 ] ) ];
        }

        parsed = buildFragment( [ data ], context, scripts );

        if ( scripts && scripts.length ) {
            jQuery( scripts ).remove();
        }

        return jQuery.merge( [], parsed.childNodes );
    };


    /**
     * Load a url into a page
     */
    jQuery.fn.load = function( url, params, callback ) {
        var selector, type, response,
            self = this,
            off = url.indexOf( " " );

        if ( off > -1 ) {
            selector = stripAndCollapse( url.slice( off ) );
            url = url.slice( 0, off );
        }

        // If it's a function
        if ( jQuery.isFunction( params ) ) {

            // We assume that it's the callback
            callback = params;
            params = undefined;

            // Otherwise, build a param string
        } else if ( params && typeof params === "object" ) {
            type = "POST";
        }

        // If we have elements to modify, make the request
        if ( self.length > 0 ) {
            jQuery.ajax( {
                url: url,

                // If "type" variable is undefined, then "GET" method will be used.
                // Make value of this field explicit since
                // user can override it through ajaxSetup method
                type: type || "GET",
                dataType: "html",
                data: params
            } ).done( function( responseText ) {

                // Save response for use in complete callback
                response = arguments;

                self.html( selector ?

                    // If a selector was specified, locate the right elements in a dummy div
                    // Exclude scripts to avoid IE 'Permission Denied' errors
                    jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

                    // Otherwise use the full result
                    responseText );

                // If the request succeeds, this function gets "data", "status", "jqXHR"
                // but they are ignored because response was set above.
                // If it fails, this function gets "jqXHR", "status", "error"
            } ).always( callback && function( jqXHR, status ) {
                self.each( function() {
                    callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
                } );
            } );
        }

        return this;
    };




// Attach a bunch of functions for handling common AJAX events
    jQuery.each( [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function( i, type ) {
        jQuery.fn[ type ] = function( fn ) {
            return this.on( type, fn );
        };
    } );




    jQuery.expr.pseudos.animated = function( elem ) {
        return jQuery.grep( jQuery.timers, function( fn ) {
            return elem === fn.elem;
        } ).length;
    };




    jQuery.offset = {
        setOffset: function( elem, options, i ) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
                position = jQuery.css( elem, "position" ),
                curElem = jQuery( elem ),
                props = {};

            // Set position first, in-case top/left are set even on static elem
            if ( position === "static" ) {
                elem.style.position = "relative";
            }

            curOffset = curElem.offset();
            curCSSTop = jQuery.css( elem, "top" );
            curCSSLeft = jQuery.css( elem, "left" );
            calculatePosition = ( position === "absolute" || position === "fixed" ) &&
                ( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if ( calculatePosition ) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;

            } else {
                curTop = parseFloat( curCSSTop ) || 0;
                curLeft = parseFloat( curCSSLeft ) || 0;
            }

            if ( jQuery.isFunction( options ) ) {

                // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
                options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
            }

            if ( options.top != null ) {
                props.top = ( options.top - curOffset.top ) + curTop;
            }
            if ( options.left != null ) {
                props.left = ( options.left - curOffset.left ) + curLeft;
            }

            if ( "using" in options ) {
                options.using.call( elem, props );

            } else {
                curElem.css( props );
            }
        }
    };

    jQuery.fn.extend( {
        offset: function( options ) {

            // Preserve chaining for setter
            if ( arguments.length ) {
                return options === undefined ?
                    this :
                    this.each( function( i ) {
                        jQuery.offset.setOffset( this, options, i );
                    } );
            }

            var doc, docElem, rect, win,
                elem = this[ 0 ];

            if ( !elem ) {
                return;
            }

            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if ( !elem.getClientRects().length ) {
                return { top: 0, left: 0 };
            }

            rect = elem.getBoundingClientRect();

            doc = elem.ownerDocument;
            docElem = doc.documentElement;
            win = doc.defaultView;

            return {
                top: rect.top + win.pageYOffset - docElem.clientTop,
                left: rect.left + win.pageXOffset - docElem.clientLeft
            };
        },

        position: function() {
            if ( !this[ 0 ] ) {
                return;
            }

            var offsetParent, offset,
                elem = this[ 0 ],
                parentOffset = { top: 0, left: 0 };

            // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
            // because it is its only offset parent
            if ( jQuery.css( elem, "position" ) === "fixed" ) {

                // Assume getBoundingClientRect is there when computed position is fixed
                offset = elem.getBoundingClientRect();

            } else {

                // Get *real* offsetParent
                offsetParent = this.offsetParent();

                // Get correct offsets
                offset = this.offset();
                if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
                    parentOffset = offsetParent.offset();
                }

                // Add offsetParent borders
                parentOffset = {
                    top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
                    left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
                };
            }

            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
                left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
            };
        },

        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map( function() {
                var offsetParent = this.offsetParent;

                while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
                    offsetParent = offsetParent.offsetParent;
                }

                return offsetParent || documentElement;
            } );
        }
    } );

// Create scrollLeft and scrollTop methods
    jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
        var top = "pageYOffset" === prop;

        jQuery.fn[ method ] = function( val ) {
            return access( this, function( elem, method, val ) {

                // Coalesce documents and windows
                var win;
                if ( jQuery.isWindow( elem ) ) {
                    win = elem;
                } else if ( elem.nodeType === 9 ) {
                    win = elem.defaultView;
                }

                if ( val === undefined ) {
                    return win ? win[ prop ] : elem[ method ];
                }

                if ( win ) {
                    win.scrollTo(
                        !top ? val : win.pageXOffset,
                        top ? val : win.pageYOffset
                    );

                } else {
                    elem[ method ] = val;
                }
            }, method, val, arguments.length );
        };
    } );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
    jQuery.each( [ "top", "left" ], function( i, prop ) {
        jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
            function( elem, computed ) {
                if ( computed ) {
                    computed = curCSS( elem, prop );

                    // If curCSS returns percentage, fallback to offset
                    return rnumnonpx.test( computed ) ?
                        jQuery( elem ).position()[ prop ] + "px" :
                        computed;
                }
            }
        );
    } );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
        jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
            function( defaultExtra, funcName ) {

                // Margin is only for outerHeight, outerWidth
                jQuery.fn[ funcName ] = function( margin, value ) {
                    var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
                        extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

                    return access( this, function( elem, type, value ) {
                        var doc;

                        if ( jQuery.isWindow( elem ) ) {

                            // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                            return funcName.indexOf( "outer" ) === 0 ?
                                elem[ "inner" + name ] :
                                elem.document.documentElement[ "client" + name ];
                        }

                        // Get document width or height
                        if ( elem.nodeType === 9 ) {
                            doc = elem.documentElement;

                            // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                            // whichever is greatest
                            return Math.max(
                                elem.body[ "scroll" + name ], doc[ "scroll" + name ],
                                elem.body[ "offset" + name ], doc[ "offset" + name ],
                                doc[ "client" + name ]
                            );
                        }

                        return value === undefined ?

                            // Get width or height on the element, requesting but not forcing parseFloat
                            jQuery.css( elem, type, extra ) :

                            // Set width or height on the element
                            jQuery.style( elem, type, value, extra );
                    }, type, chainable ? margin : undefined, chainable );
                };
            } );
    } );


    jQuery.fn.extend( {

        bind: function( types, data, fn ) {
            return this.on( types, null, data, fn );
        },
        unbind: function( types, fn ) {
            return this.off( types, null, fn );
        },

        delegate: function( selector, types, data, fn ) {
            return this.on( types, selector, data, fn );
        },
        undelegate: function( selector, types, fn ) {

            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ?
                this.off( selector, "**" ) :
                this.off( types, selector || "**", fn );
        }
    } );

    jQuery.holdReady = function( hold ) {
        if ( hold ) {
            jQuery.readyWait++;
        } else {
            jQuery.ready( true );
        }
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

    if ( typeof define === "function" && define.amd ) {
        define( "jquery", [], function() {
            return jQuery;
        } );
    }




    var

        // Map over jQuery in case of overwrite
        _jQuery = window.jQuery,

        // Map over the $ in case of overwrite
        _$ = window.$;

    jQuery.noConflict = function( deep ) {
        if ( window.$ === jQuery ) {
            window.$ = _$;
        }

        if ( deep && window.jQuery === jQuery ) {
            window.jQuery = _jQuery;
        }

        return jQuery;
    };

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
    if ( !noGlobal ) {
        window.jQuery = window.$ = jQuery;
    }




    return jQuery;
} );

/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */

if (typeof jQuery === 'undefined') {
    throw new Error('Bootstrap\'s JavaScript requires jQuery')
}

+function ($) {
    'use strict';
    var version = $.fn.jquery.split(' ')[0].split('.')
    if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
        throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
    }
}(jQuery);

/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
    // ============================================================

    function transitionEnd() {
        var el = document.createElement('bootstrap')

        var transEndEventNames = {
            WebkitTransition : 'webkitTransitionEnd',
            MozTransition    : 'transitionend',
            OTransition      : 'oTransitionEnd otransitionend',
            transition       : 'transitionend'
        }

        for (var name in transEndEventNames) {
            if (el.style[name] !== undefined) {
                return { end: transEndEventNames[name] }
            }
        }

        return false // explicit for ie8 (  ._.)
    }

    // http://blog.alexmaccaw.com/css-transitions
    $.fn.emulateTransitionEnd = function (duration) {
        var called = false
        var $el = this
        $(this).one('bsTransitionEnd', function () { called = true })
        var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
        setTimeout(callback, duration)
        return this
    }

    $(function () {
        $.support.transition = transitionEnd()

        if (!$.support.transition) return

        $.event.special.bsTransitionEnd = {
            bindType: $.support.transition.end,
            delegateType: $.support.transition.end,
            handle: function (e) {
                if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
            }
        }
    })

}(jQuery);

/* ========================================================================
 * Bootstrap: alert.js v3.3.7
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // ALERT CLASS DEFINITION
    // ======================

    var dismiss = '[data-dismiss="alert"]'
    var Alert   = function (el) {
        $(el).on('click', dismiss, this.close)
    }

    Alert.VERSION = '3.3.7'

    Alert.TRANSITION_DURATION = 150

    Alert.prototype.close = function (e) {
        var $this    = $(this)
        var selector = $this.attr('data-target')

        if (!selector) {
            selector = $this.attr('href')
            selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
        }

        var $parent = $(selector === '#' ? [] : selector)

        if (e) e.preventDefault()

        if (!$parent.length) {
            $parent = $this.closest('.alert')
        }

        $parent.trigger(e = $.Event('close.bs.alert'))

        if (e.isDefaultPrevented()) return

        $parent.removeClass('in')

        function removeElement() {
            // detach from parent, fire event then clean up data
            $parent.detach().trigger('closed.bs.alert').remove()
        }

        $.support.transition && $parent.hasClass('fade') ?
            $parent
                .one('bsTransitionEnd', removeElement)
                .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
            removeElement()
    }


    // ALERT PLUGIN DEFINITION
    // =======================

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this)
            var data  = $this.data('bs.alert')

            if (!data) $this.data('bs.alert', (data = new Alert(this)))
            if (typeof option == 'string') data[option].call($this)
        })
    }

    var old = $.fn.alert

    $.fn.alert             = Plugin
    $.fn.alert.Constructor = Alert


    // ALERT NO CONFLICT
    // =================

    $.fn.alert.noConflict = function () {
        $.fn.alert = old
        return this
    }


    // ALERT DATA-API
    // ==============

    $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);

/* ========================================================================
 * Bootstrap: button.js v3.3.7
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // BUTTON PUBLIC CLASS DEFINITION
    // ==============================

    var Button = function (element, options) {
        this.$element  = $(element)
        this.options   = $.extend({}, Button.DEFAULTS, options)
        this.isLoading = false
    }

    Button.VERSION  = '3.3.7'

    Button.DEFAULTS = {
        loadingText: 'loading...'
    }

    Button.prototype.setState = function (state) {
        var d    = 'disabled'
        var $el  = this.$element
        var val  = $el.is('input') ? 'val' : 'html'
        var data = $el.data()

        state += 'Text'

        if (data.resetText == null) $el.data('resetText', $el[val]())

        // push to event loop to allow forms to submit
        setTimeout($.proxy(function () {
            $el[val](data[state] == null ? this.options[state] : data[state])

            if (state == 'loadingText') {
                this.isLoading = true
                $el.addClass(d).attr(d, d).prop(d, true)
            } else if (this.isLoading) {
                this.isLoading = false
                $el.removeClass(d).removeAttr(d).prop(d, false)
            }
        }, this), 0)
    }

    Button.prototype.toggle = function () {
        var changed = true
        var $parent = this.$element.closest('[data-toggle="buttons"]')

        if ($parent.length) {
            var $input = this.$element.find('input')
            if ($input.prop('type') == 'radio') {
                if ($input.prop('checked')) changed = false
                $parent.find('.active').removeClass('active')
                this.$element.addClass('active')
            } else if ($input.prop('type') == 'checkbox') {
                if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
                this.$element.toggleClass('active')
            }
            $input.prop('checked', this.$element.hasClass('active'))
            if (changed) $input.trigger('change')
        } else {
            this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
            this.$element.toggleClass('active')
        }
    }


    // BUTTON PLUGIN DEFINITION
    // ========================

    function Plugin(option) {
        return this.each(function () {
            var $this   = $(this)
            var data    = $this.data('bs.button')
            var options = typeof option == 'object' && option

            if (!data) $this.data('bs.button', (data = new Button(this, options)))

            if (option == 'toggle') data.toggle()
            else if (option) data.setState(option)
        })
    }

    var old = $.fn.button

    $.fn.button             = Plugin
    $.fn.button.Constructor = Button


    // BUTTON NO CONFLICT
    // ==================

    $.fn.button.noConflict = function () {
        $.fn.button = old
        return this
    }


    // BUTTON DATA-API
    // ===============

    $(document)
        .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
            var $btn = $(e.target).closest('.btn')
            Plugin.call($btn, 'toggle')
            if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
                // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
                e.preventDefault()
                // The target component still receive the focus
                if ($btn.is('input,button')) $btn.trigger('focus')
                else $btn.find('input:visible,button:visible').first().trigger('focus')
            }
        })
        .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
            $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
        })

}(jQuery);

/* ========================================================================
 * Bootstrap: carousel.js v3.3.7
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // CAROUSEL CLASS DEFINITION
    // =========================

    var Carousel = function (element, options) {
        this.$element    = $(element)
        this.$indicators = this.$element.find('.carousel-indicators')
        this.options     = options
        this.paused      = null
        this.sliding     = null
        this.interval    = null
        this.$active     = null
        this.$items      = null

        this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

        this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
            .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
            .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
    }

    Carousel.VERSION  = '3.3.7'

    Carousel.TRANSITION_DURATION = 600

    Carousel.DEFAULTS = {
        interval: 5000,
        pause: 'hover',
        wrap: true,
        keyboard: true
    }

    Carousel.prototype.keydown = function (e) {
        if (/input|textarea/i.test(e.target.tagName)) return
        switch (e.which) {
            case 37: this.prev(); break
            case 39: this.next(); break
            default: return
        }

        e.preventDefault()
    }

    Carousel.prototype.cycle = function (e) {
        e || (this.paused = false)

        this.interval && clearInterval(this.interval)

        this.options.interval
        && !this.paused
        && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

        return this
    }

    Carousel.prototype.getItemIndex = function (item) {
        this.$items = item.parent().children('.item')
        return this.$items.index(item || this.$active)
    }

    Carousel.prototype.getItemForDirection = function (direction, active) {
        var activeIndex = this.getItemIndex(active)
        var willWrap = (direction == 'prev' && activeIndex === 0)
            || (direction == 'next' && activeIndex == (this.$items.length - 1))
        if (willWrap && !this.options.wrap) return active
        var delta = direction == 'prev' ? -1 : 1
        var itemIndex = (activeIndex + delta) % this.$items.length
        return this.$items.eq(itemIndex)
    }

    Carousel.prototype.to = function (pos) {
        var that        = this
        var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

        if (pos > (this.$items.length - 1) || pos < 0) return

        if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
        if (activeIndex == pos) return this.pause().cycle()

        return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
    }

    Carousel.prototype.pause = function (e) {
        e || (this.paused = true)

        if (this.$element.find('.next, .prev').length && $.support.transition) {
            this.$element.trigger($.support.transition.end)
            this.cycle(true)
        }

        this.interval = clearInterval(this.interval)

        return this
    }

    Carousel.prototype.next = function () {
        if (this.sliding) return
        return this.slide('next')
    }

    Carousel.prototype.prev = function () {
        if (this.sliding) return
        return this.slide('prev')
    }

    Carousel.prototype.slide = function (type, next) {
        var $active   = this.$element.find('.item.active')
        var $next     = next || this.getItemForDirection(type, $active)
        var isCycling = this.interval
        var direction = type == 'next' ? 'left' : 'right'
        var that      = this

        if ($next.hasClass('active')) return (this.sliding = false)

        var relatedTarget = $next[0]
        var slideEvent = $.Event('slide.bs.carousel', {
            relatedTarget: relatedTarget,
            direction: direction
        })
        this.$element.trigger(slideEvent)
        if (slideEvent.isDefaultPrevented()) return

        this.sliding = true

        isCycling && this.pause()

        if (this.$indicators.length) {
            this.$indicators.find('.active').removeClass('active')
            var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
            $nextIndicator && $nextIndicator.addClass('active')
        }

        var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
        if ($.support.transition && this.$element.hasClass('slide')) {
            $next.addClass(type)
            $next[0].offsetWidth // force reflow
            $active.addClass(direction)
            $next.addClass(direction)
            $active
                .one('bsTransitionEnd', function () {
                    $next.removeClass([type, direction].join(' ')).addClass('active')
                    $active.removeClass(['active', direction].join(' '))
                    that.sliding = false
                    setTimeout(function () {
                        that.$element.trigger(slidEvent)
                    }, 0)
                })
                .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
        } else {
            $active.removeClass('active')
            $next.addClass('active')
            this.sliding = false
            this.$element.trigger(slidEvent)
        }

        isCycling && this.cycle()

        return this
    }


    // CAROUSEL PLUGIN DEFINITION
    // ==========================

    function Plugin(option) {
        return this.each(function () {
            var $this   = $(this)
            var data    = $this.data('bs.carousel')
            var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
            var action  = typeof option == 'string' ? option : options.slide

            if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
            if (typeof option == 'number') data.to(option)
            else if (action) data[action]()
            else if (options.interval) data.pause().cycle()
        })
    }

    var old = $.fn.carousel

    $.fn.carousel             = Plugin
    $.fn.carousel.Constructor = Carousel


    // CAROUSEL NO CONFLICT
    // ====================

    $.fn.carousel.noConflict = function () {
        $.fn.carousel = old
        return this
    }


    // CAROUSEL DATA-API
    // =================

    var clickHandler = function (e) {
        var href
        var $this   = $(this)
        var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
        if (!$target.hasClass('carousel')) return
        var options = $.extend({}, $target.data(), $this.data())
        var slideIndex = $this.attr('data-slide-to')
        if (slideIndex) options.interval = false

        Plugin.call($target, options)

        if (slideIndex) {
            $target.data('bs.carousel').to(slideIndex)
        }

        e.preventDefault()
    }

    $(document)
        .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
        .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

    $(window).on('load', function () {
        $('[data-ride="carousel"]').each(function () {
            var $carousel = $(this)
            Plugin.call($carousel, $carousel.data())
        })
    })

}(jQuery);

/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
    'use strict';

    // COLLAPSE PUBLIC CLASS DEFINITION
    // ================================

    var Collapse = function (element, options) {
        this.$element      = $(element)
        this.options       = $.extend({}, Collapse.DEFAULTS, options)
        this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
            '[data-toggle="collapse"][data-target="#' + element.id + '"]')
        this.transitioning = null

        if (this.options.parent) {
            this.$parent = this.getParent()
        } else {
            this.addAriaAndCollapsedClass(this.$element, this.$trigger)
        }

        if (this.options.toggle) this.toggle()
    }

    Collapse.VERSION  = '3.3.7'

    Collapse.TRANSITION_DURATION = 350

    Collapse.DEFAULTS = {
        toggle: true
    }

    Collapse.prototype.dimension = function () {
        var hasWidth = this.$element.hasClass('width')
        return hasWidth ? 'width' : 'height'
    }

    Collapse.prototype.show = function () {
        if (this.transitioning || this.$element.hasClass('in')) return

        var activesData
        var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

        if (actives && actives.length) {
            activesData = actives.data('bs.collapse')
            if (activesData && activesData.transitioning) return
        }

        var startEvent = $.Event('show.bs.collapse')
        this.$element.trigger(startEvent)
        if (startEvent.isDefaultPrevented()) return

        if (actives && actives.length) {
            Plugin.call(actives, 'hide')
            activesData || actives.data('bs.collapse', null)
        }

        var dimension = this.dimension()

        this.$element
            .removeClass('collapse')
            .addClass('collapsing')[dimension](0)
            .attr('aria-expanded', true)

        this.$trigger
            .removeClass('collapsed')
            .attr('aria-expanded', true)

        this.transitioning = 1

        var complete = function () {
            this.$element
                .removeClass('collapsing')
                .addClass('collapse in')[dimension]('')
            this.transitioning = 0
            this.$element
                .trigger('shown.bs.collapse')
        }

        if (!$.support.transition) return complete.call(this)

        var scrollSize = $.camelCase(['scroll', dimension].join('-'))

        this.$element
            .one('bsTransitionEnd', $.proxy(complete, this))
            .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
    }

    Collapse.prototype.hide = function () {
        if (this.transitioning || !this.$element.hasClass('in')) return

        var startEvent = $.Event('hide.bs.collapse')
        this.$element.trigger(startEvent)
        if (startEvent.isDefaultPrevented()) return

        var dimension = this.dimension()

        this.$element[dimension](this.$element[dimension]())[0].offsetHeight

        this.$element
            .addClass('collapsing')
            .removeClass('collapse in')
            .attr('aria-expanded', false)

        this.$trigger
            .addClass('collapsed')
            .attr('aria-expanded', false)

        this.transitioning = 1

        var complete = function () {
            this.transitioning = 0
            this.$element
                .removeClass('collapsing')
                .addClass('collapse')
                .trigger('hidden.bs.collapse')
        }

        if (!$.support.transition) return complete.call(this)

        this.$element
            [dimension](0)
            .one('bsTransitionEnd', $.proxy(complete, this))
            .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
    }

    Collapse.prototype.toggle = function () {
        this[this.$element.hasClass('in') ? 'hide' : 'show']()
    }

    Collapse.prototype.getParent = function () {
        return $(this.options.parent)
            .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
            .each($.proxy(function (i, element) {
                var $element = $(element)
                this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
            }, this))
            .end()
    }

    Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
        var isOpen = $element.hasClass('in')

        $element.attr('aria-expanded', isOpen)
        $trigger
            .toggleClass('collapsed', !isOpen)
            .attr('aria-expanded', isOpen)
    }

    function getTargetFromTrigger($trigger) {
        var href
        var target = $trigger.attr('data-target')
            || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

        return $(target)
    }


    // COLLAPSE PLUGIN DEFINITION
    // ==========================

    function Plugin(option) {
        return this.each(function () {
            var $this   = $(this)
            var data    = $this.data('bs.collapse')
            var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

            if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
            if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
            if (typeof option == 'string') data[option]()
        })
    }

    var old = $.fn.collapse

    $.fn.collapse             = Plugin
    $.fn.collapse.Constructor = Collapse


    // COLLAPSE NO CONFLICT
    // ====================

    $.fn.collapse.noConflict = function () {
        $.fn.collapse = old
        return this
    }


    // COLLAPSE DATA-API
    // =================

    $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
        var $this   = $(this)

        if (!$this.attr('data-target')) e.preventDefault()

        var $target = getTargetFromTrigger($this)
        var data    = $target.data('bs.collapse')
        var option  = data ? 'toggle' : $this.data()

        Plugin.call($target, option)
    })

}(jQuery);

/* ========================================================================
 * Bootstrap: dropdown.js v3.3.7
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // DROPDOWN CLASS DEFINITION
    // =========================

    var backdrop = '.dropdown-backdrop'
    var toggle   = '[data-toggle="dropdown"]'
    var Dropdown = function (element) {
        $(element).on('click.bs.dropdown', this.toggle)
    }

    Dropdown.VERSION = '3.3.7'

    function getParent($this) {
        var selector = $this.attr('data-target')

        if (!selector) {
            selector = $this.attr('href')
            selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
        }

        var $parent = selector && $(selector)

        return $parent && $parent.length ? $parent : $this.parent()
    }

    function clearMenus(e) {
        if (e && e.which === 3) return
        $(backdrop).remove()
        $(toggle).each(function () {
            var $this         = $(this)
            var $parent       = getParent($this)
            var relatedTarget = { relatedTarget: this }

            if (!$parent.hasClass('open')) return

            if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

            $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

            if (e.isDefaultPrevented()) return

            $this.attr('aria-expanded', 'false')
            $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
        })
    }

    Dropdown.prototype.toggle = function (e) {
        var $this = $(this)

        if ($this.is('.disabled, :disabled')) return

        var $parent  = getParent($this)
        var isActive = $parent.hasClass('open')

        clearMenus()

        if (!isActive) {
            if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
                // if mobile we use a backdrop because click events don't delegate
                $(document.createElement('div'))
                    .addClass('dropdown-backdrop')
                    .insertAfter($(this))
                    .on('click', clearMenus)
            }

            var relatedTarget = { relatedTarget: this }
            $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

            if (e.isDefaultPrevented()) return

            $this
                .trigger('focus')
                .attr('aria-expanded', 'true')

            $parent
                .toggleClass('open')
                .trigger($.Event('shown.bs.dropdown', relatedTarget))
        }

        return false
    }

    Dropdown.prototype.keydown = function (e) {
        if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

        var $this = $(this)

        e.preventDefault()
        e.stopPropagation()

        if ($this.is('.disabled, :disabled')) return

        var $parent  = getParent($this)
        var isActive = $parent.hasClass('open')

        if (!isActive && e.which != 27 || isActive && e.which == 27) {
            if (e.which == 27) $parent.find(toggle).trigger('focus')
            return $this.trigger('click')
        }

        var desc = ' li:not(.disabled):visible a'
        var $items = $parent.find('.dropdown-menu' + desc)

        if (!$items.length) return

        var index = $items.index(e.target)

        if (e.which == 38 && index > 0)                 index--         // up
        if (e.which == 40 && index < $items.length - 1) index++         // down
        if (!~index)                                    index = 0

        $items.eq(index).trigger('focus')
    }


    // DROPDOWN PLUGIN DEFINITION
    // ==========================

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this)
            var data  = $this.data('bs.dropdown')

            if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
            if (typeof option == 'string') data[option].call($this)
        })
    }

    var old = $.fn.dropdown

    $.fn.dropdown             = Plugin
    $.fn.dropdown.Constructor = Dropdown


    // DROPDOWN NO CONFLICT
    // ====================

    $.fn.dropdown.noConflict = function () {
        $.fn.dropdown = old
        return this
    }


    // APPLY TO STANDARD DROPDOWN ELEMENTS
    // ===================================

    $(document)
        .on('click.bs.dropdown.data-api', clearMenus)
        .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
        .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
        .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
        .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);

/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // MODAL CLASS DEFINITION
    // ======================

    var Modal = function (element, options) {
        this.options             = options
        this.$body               = $(document.body)
        this.$element            = $(element)
        this.$dialog             = this.$element.find('.modal-dialog')
        this.$backdrop           = null
        this.isShown             = null
        this.originalBodyPad     = null
        this.scrollbarWidth      = 0
        this.ignoreBackdropClick = false

        if (this.options.remote) {
            this.$element
                .find('.modal-content')
                .load(this.options.remote, $.proxy(function () {
                    this.$element.trigger('loaded.bs.modal')
                }, this))
        }
    }

    Modal.VERSION  = '3.3.7'

    Modal.TRANSITION_DURATION = 300
    Modal.BACKDROP_TRANSITION_DURATION = 150

    Modal.DEFAULTS = {
        backdrop: true,
        keyboard: true,
        show: true
    }

    Modal.prototype.toggle = function (_relatedTarget) {
        return this.isShown ? this.hide() : this.show(_relatedTarget)
    }

    Modal.prototype.show = function (_relatedTarget) {
        var that = this
        var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

        this.$element.trigger(e)

        if (this.isShown || e.isDefaultPrevented()) return

        this.isShown = true

        this.checkScrollbar()
        this.setScrollbar()
        this.$body.addClass('modal-open')

        this.escape()
        this.resize()

        this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

        this.$dialog.on('mousedown.dismiss.bs.modal', function () {
            that.$element.one('mouseup.dismiss.bs.modal', function (e) {
                if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
            })
        })

        this.backdrop(function () {
            var transition = $.support.transition && that.$element.hasClass('fade')

            if (!that.$element.parent().length) {
                that.$element.appendTo(that.$body) // don't move modals dom position
            }

            that.$element
                .show()
                .scrollTop(0)

            that.adjustDialog()

            if (transition) {
                that.$element[0].offsetWidth // force reflow
            }

            that.$element.addClass('in')

            that.enforceFocus()

            var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

            transition ?
                that.$dialog // wait for modal to slide in
                    .one('bsTransitionEnd', function () {
                        that.$element.trigger('focus').trigger(e)
                    })
                    .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
                that.$element.trigger('focus').trigger(e)
        })
    }

    Modal.prototype.hide = function (e) {
        if (e) e.preventDefault()

        e = $.Event('hide.bs.modal')

        this.$element.trigger(e)

        if (!this.isShown || e.isDefaultPrevented()) return

        this.isShown = false

        this.escape()
        this.resize()

        $(document).off('focusin.bs.modal')

        this.$element
            .removeClass('in')
            .off('click.dismiss.bs.modal')
            .off('mouseup.dismiss.bs.modal')

        this.$dialog.off('mousedown.dismiss.bs.modal')

        $.support.transition && this.$element.hasClass('fade') ?
            this.$element
                .one('bsTransitionEnd', $.proxy(this.hideModal, this))
                .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
            this.hideModal()
    }

    Modal.prototype.enforceFocus = function () {
        $(document)
            .off('focusin.bs.modal') // guard against infinite focus loop
            .on('focusin.bs.modal', $.proxy(function (e) {
                if (document !== e.target &&
                    this.$element[0] !== e.target &&
                    !this.$element.has(e.target).length) {
                    this.$element.trigger('focus')
                }
            }, this))
    }

    Modal.prototype.escape = function () {
        if (this.isShown && this.options.keyboard) {
            this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
                e.which == 27 && this.hide()
            }, this))
        } else if (!this.isShown) {
            this.$element.off('keydown.dismiss.bs.modal')
        }
    }

    Modal.prototype.resize = function () {
        if (this.isShown) {
            $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
        } else {
            $(window).off('resize.bs.modal')
        }
    }

    Modal.prototype.hideModal = function () {
        var that = this
        this.$element.hide()
        this.backdrop(function () {
            that.$body.removeClass('modal-open')
            that.resetAdjustments()
            that.resetScrollbar()
            that.$element.trigger('hidden.bs.modal')
        })
    }

    Modal.prototype.removeBackdrop = function () {
        this.$backdrop && this.$backdrop.remove()
        this.$backdrop = null
    }

    Modal.prototype.backdrop = function (callback) {
        var that = this
        var animate = this.$element.hasClass('fade') ? 'fade' : ''

        if (this.isShown && this.options.backdrop) {
            var doAnimate = $.support.transition && animate

            this.$backdrop = $(document.createElement('div'))
                .addClass('modal-backdrop ' + animate)
                .appendTo(this.$body)

            this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
                if (this.ignoreBackdropClick) {
                    this.ignoreBackdropClick = false
                    return
                }
                if (e.target !== e.currentTarget) return
                this.options.backdrop == 'static'
                    ? this.$element[0].focus()
                    : this.hide()
            }, this))

            if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

            this.$backdrop.addClass('in')

            if (!callback) return

            doAnimate ?
                this.$backdrop
                    .one('bsTransitionEnd', callback)
                    .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
                callback()

        } else if (!this.isShown && this.$backdrop) {
            this.$backdrop.removeClass('in')

            var callbackRemove = function () {
                that.removeBackdrop()
                callback && callback()
            }
            $.support.transition && this.$element.hasClass('fade') ?
                this.$backdrop
                    .one('bsTransitionEnd', callbackRemove)
                    .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
                callbackRemove()

        } else if (callback) {
            callback()
        }
    }

    // these following methods are used to handle overflowing modals

    Modal.prototype.handleUpdate = function () {
        this.adjustDialog()
    }

    Modal.prototype.adjustDialog = function () {
        var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

        this.$element.css({
            paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
            paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
        })
    }

    Modal.prototype.resetAdjustments = function () {
        this.$element.css({
            paddingLeft: '',
            paddingRight: ''
        })
    }

    Modal.prototype.checkScrollbar = function () {
        var fullWindowWidth = window.innerWidth
        if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
            var documentElementRect = document.documentElement.getBoundingClientRect()
            fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
        }
        this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
        this.scrollbarWidth = this.measureScrollbar()
    }

    Modal.prototype.setScrollbar = function () {
        var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
        this.originalBodyPad = document.body.style.paddingRight || ''
        if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
    }

    Modal.prototype.resetScrollbar = function () {
        this.$body.css('padding-right', this.originalBodyPad)
    }

    Modal.prototype.measureScrollbar = function () { // thx walsh
        var scrollDiv = document.createElement('div')
        scrollDiv.className = 'modal-scrollbar-measure'
        this.$body.append(scrollDiv)
        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
        this.$body[0].removeChild(scrollDiv)
        return scrollbarWidth
    }


    // MODAL PLUGIN DEFINITION
    // =======================

    function Plugin(option, _relatedTarget) {
        return this.each(function () {
            var $this   = $(this)
            var data    = $this.data('bs.modal')
            var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

            if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
            if (typeof option == 'string') data[option](_relatedTarget)
            else if (options.show) data.show(_relatedTarget)
        })
    }

    var old = $.fn.modal

    $.fn.modal             = Plugin
    $.fn.modal.Constructor = Modal


    // MODAL NO CONFLICT
    // =================

    $.fn.modal.noConflict = function () {
        $.fn.modal = old
        return this
    }


    // MODAL DATA-API
    // ==============

    $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
        var $this   = $(this)
        var href    = $this.attr('href')
        var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
        var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

        if ($this.is('a')) e.preventDefault()

        $target.one('show.bs.modal', function (showEvent) {
            if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
            $target.one('hidden.bs.modal', function () {
                $this.is(':visible') && $this.trigger('focus')
            })
        })
        Plugin.call($target, option, this)
    })

}(jQuery);

/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // TOOLTIP PUBLIC CLASS DEFINITION
    // ===============================

    var Tooltip = function (element, options) {
        this.type       = null
        this.options    = null
        this.enabled    = null
        this.timeout    = null
        this.hoverState = null
        this.$element   = null
        this.inState    = null

        this.init('tooltip', element, options)
    }

    Tooltip.VERSION  = '3.3.7'

    Tooltip.TRANSITION_DURATION = 150

    Tooltip.DEFAULTS = {
        animation: true,
        placement: 'top',
        selector: false,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: 'hover focus',
        title: '',
        delay: 0,
        html: false,
        container: false,
        viewport: {
            selector: 'body',
            padding: 0
        }
    }

    Tooltip.prototype.init = function (type, element, options) {
        this.enabled   = true
        this.type      = type
        this.$element  = $(element)
        this.options   = this.getOptions(options)
        this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
        this.inState   = { click: false, hover: false, focus: false }

        if (this.$element[0] instanceof document.constructor && !this.options.selector) {
            throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
        }

        var triggers = this.options.trigger.split(' ')

        for (var i = triggers.length; i--;) {
            var trigger = triggers[i]

            if (trigger == 'click') {
                this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
            } else if (trigger != 'manual') {
                var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
                var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

                this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
                this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
            }
        }

        this.options.selector ?
            (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
            this.fixTitle()
    }

    Tooltip.prototype.getDefaults = function () {
        return Tooltip.DEFAULTS
    }

    Tooltip.prototype.getOptions = function (options) {
        options = $.extend({}, this.getDefaults(), this.$element.data(), options)

        if (options.delay && typeof options.delay == 'number') {
            options.delay = {
                show: options.delay,
                hide: options.delay
            }
        }

        return options
    }

    Tooltip.prototype.getDelegateOptions = function () {
        var options  = {}
        var defaults = this.getDefaults()

        this._options && $.each(this._options, function (key, value) {
            if (defaults[key] != value) options[key] = value
        })

        return options
    }

    Tooltip.prototype.enter = function (obj) {
        var self = obj instanceof this.constructor ?
            obj : $(obj.currentTarget).data('bs.' + this.type)

        if (!self) {
            self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
            $(obj.currentTarget).data('bs.' + this.type, self)
        }

        if (obj instanceof $.Event) {
            self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
        }

        if (self.tip().hasClass('in') || self.hoverState == 'in') {
            self.hoverState = 'in'
            return
        }

        clearTimeout(self.timeout)

        self.hoverState = 'in'

        if (!self.options.delay || !self.options.delay.show) return self.show()

        self.timeout = setTimeout(function () {
            if (self.hoverState == 'in') self.show()
        }, self.options.delay.show)
    }

    Tooltip.prototype.isInStateTrue = function () {
        for (var key in this.inState) {
            if (this.inState[key]) return true
        }

        return false
    }

    Tooltip.prototype.leave = function (obj) {
        var self = obj instanceof this.constructor ?
            obj : $(obj.currentTarget).data('bs.' + this.type)

        if (!self) {
            self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
            $(obj.currentTarget).data('bs.' + this.type, self)
        }

        if (obj instanceof $.Event) {
            self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
        }

        if (self.isInStateTrue()) return

        clearTimeout(self.timeout)

        self.hoverState = 'out'

        if (!self.options.delay || !self.options.delay.hide) return self.hide()

        self.timeout = setTimeout(function () {
            if (self.hoverState == 'out') self.hide()
        }, self.options.delay.hide)
    }

    Tooltip.prototype.show = function () {
        var e = $.Event('show.bs.' + this.type)

        if (this.hasContent() && this.enabled) {
            this.$element.trigger(e)

            var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
            if (e.isDefaultPrevented() || !inDom) return
            var that = this

            var $tip = this.tip()

            var tipId = this.getUID(this.type)

            this.setContent()
            $tip.attr('id', tipId)
            this.$element.attr('aria-describedby', tipId)

            if (this.options.animation) $tip.addClass('fade')

            var placement = typeof this.options.placement == 'function' ?
                this.options.placement.call(this, $tip[0], this.$element[0]) :
                this.options.placement

            var autoToken = /\s?auto?\s?/i
            var autoPlace = autoToken.test(placement)
            if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

            $tip
                .detach()
                .css({ top: 0, left: 0, display: 'block' })
                .addClass(placement)
                .data('bs.' + this.type, this)

            this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
            this.$element.trigger('inserted.bs.' + this.type)

            var pos          = this.getPosition()
            var actualWidth  = $tip[0].offsetWidth
            var actualHeight = $tip[0].offsetHeight

            if (autoPlace) {
                var orgPlacement = placement
                var viewportDim = this.getPosition(this.$viewport)

                placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                        placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                            placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                                placement

                $tip
                    .removeClass(orgPlacement)
                    .addClass(placement)
            }

            var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

            this.applyPlacement(calculatedOffset, placement)

            var complete = function () {
                var prevHoverState = that.hoverState
                that.$element.trigger('shown.bs.' + that.type)
                that.hoverState = null

                if (prevHoverState == 'out') that.leave(that)
            }

            $.support.transition && this.$tip.hasClass('fade') ?
                $tip
                    .one('bsTransitionEnd', complete)
                    .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
                complete()
        }
    }

    Tooltip.prototype.applyPlacement = function (offset, placement) {
        var $tip   = this.tip()
        var width  = $tip[0].offsetWidth
        var height = $tip[0].offsetHeight

        // manually read margins because getBoundingClientRect includes difference
        var marginTop = parseInt($tip.css('margin-top'), 10)
        var marginLeft = parseInt($tip.css('margin-left'), 10)

        // we must check for NaN for ie 8/9
        if (isNaN(marginTop))  marginTop  = 0
        if (isNaN(marginLeft)) marginLeft = 0

        offset.top  += marginTop
        offset.left += marginLeft

        // $.fn.offset doesn't round pixel values
        // so we use setOffset directly with our own function B-0
        $.offset.setOffset($tip[0], $.extend({
            using: function (props) {
                $tip.css({
                    top: Math.round(props.top),
                    left: Math.round(props.left)
                })
            }
        }, offset), 0)

        $tip.addClass('in')

        // check to see if placing tip in new offset caused the tip to resize itself
        var actualWidth  = $tip[0].offsetWidth
        var actualHeight = $tip[0].offsetHeight

        if (placement == 'top' && actualHeight != height) {
            offset.top = offset.top + height - actualHeight
        }

        var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

        if (delta.left) offset.left += delta.left
        else offset.top += delta.top

        var isVertical          = /top|bottom/.test(placement)
        var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
        var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

        $tip.offset(offset)
        this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
    }

    Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
        this.arrow()
            .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
            .css(isVertical ? 'top' : 'left', '')
    }

    Tooltip.prototype.setContent = function () {
        var $tip  = this.tip()
        var title = this.getTitle()

        $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
        $tip.removeClass('fade in top bottom left right')
    }

    Tooltip.prototype.hide = function (callback) {
        var that = this
        var $tip = $(this.$tip)
        var e    = $.Event('hide.bs.' + this.type)

        function complete() {
            if (that.hoverState != 'in') $tip.detach()
            if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
                that.$element
                    .removeAttr('aria-describedby')
                    .trigger('hidden.bs.' + that.type)
            }
            callback && callback()
        }

        this.$element.trigger(e)

        if (e.isDefaultPrevented()) return

        $tip.removeClass('in')

        $.support.transition && $tip.hasClass('fade') ?
            $tip
                .one('bsTransitionEnd', complete)
                .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
            complete()

        this.hoverState = null

        return this
    }

    Tooltip.prototype.fixTitle = function () {
        var $e = this.$element
        if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
            $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
        }
    }

    Tooltip.prototype.hasContent = function () {
        return this.getTitle()
    }

    Tooltip.prototype.getPosition = function ($element) {
        $element   = $element || this.$element

        var el     = $element[0]
        var isBody = el.tagName == 'BODY'

        var elRect    = el.getBoundingClientRect()
        if (elRect.width == null) {
            // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
            elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
        }
        var isSvg = window.SVGElement && el instanceof window.SVGElement
        // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
        // See https://github.com/twbs/bootstrap/issues/20280
        var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
        var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
        var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

        return $.extend({}, elRect, scroll, outerDims, elOffset)
    }

    Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
        return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
            placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
                placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
                    /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

    }

    Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
        var delta = { top: 0, left: 0 }
        if (!this.$viewport) return delta

        var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
        var viewportDimensions = this.getPosition(this.$viewport)

        if (/right|left/.test(placement)) {
            var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
            var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
            if (topEdgeOffset < viewportDimensions.top) { // top overflow
                delta.top = viewportDimensions.top - topEdgeOffset
            } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
                delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
            }
        } else {
            var leftEdgeOffset  = pos.left - viewportPadding
            var rightEdgeOffset = pos.left + viewportPadding + actualWidth
            if (leftEdgeOffset < viewportDimensions.left) { // left overflow
                delta.left = viewportDimensions.left - leftEdgeOffset
            } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
                delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
            }
        }

        return delta
    }

    Tooltip.prototype.getTitle = function () {
        var title
        var $e = this.$element
        var o  = this.options

        title = $e.attr('data-original-title')
            || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

        return title
    }

    Tooltip.prototype.getUID = function (prefix) {
        do prefix += ~~(Math.random() * 1000000)
        while (document.getElementById(prefix))
        return prefix
    }

    Tooltip.prototype.tip = function () {
        if (!this.$tip) {
            this.$tip = $(this.options.template)
            if (this.$tip.length != 1) {
                throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
            }
        }
        return this.$tip
    }

    Tooltip.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
    }

    Tooltip.prototype.enable = function () {
        this.enabled = true
    }

    Tooltip.prototype.disable = function () {
        this.enabled = false
    }

    Tooltip.prototype.toggleEnabled = function () {
        this.enabled = !this.enabled
    }

    Tooltip.prototype.toggle = function (e) {
        var self = this
        if (e) {
            self = $(e.currentTarget).data('bs.' + this.type)
            if (!self) {
                self = new this.constructor(e.currentTarget, this.getDelegateOptions())
                $(e.currentTarget).data('bs.' + this.type, self)
            }
        }

        if (e) {
            self.inState.click = !self.inState.click
            if (self.isInStateTrue()) self.enter(self)
            else self.leave(self)
        } else {
            self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
        }
    }

    Tooltip.prototype.destroy = function () {
        var that = this
        clearTimeout(this.timeout)
        this.hide(function () {
            that.$element.off('.' + that.type).removeData('bs.' + that.type)
            if (that.$tip) {
                that.$tip.detach()
            }
            that.$tip = null
            that.$arrow = null
            that.$viewport = null
            that.$element = null
        })
    }


    // TOOLTIP PLUGIN DEFINITION
    // =========================

    function Plugin(option) {
        return this.each(function () {
            var $this   = $(this)
            var data    = $this.data('bs.tooltip')
            var options = typeof option == 'object' && option

            if (!data && /destroy|hide/.test(option)) return
            if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
            if (typeof option == 'string') data[option]()
        })
    }

    var old = $.fn.tooltip

    $.fn.tooltip             = Plugin
    $.fn.tooltip.Constructor = Tooltip


    // TOOLTIP NO CONFLICT
    // ===================

    $.fn.tooltip.noConflict = function () {
        $.fn.tooltip = old
        return this
    }

}(jQuery);

/* ========================================================================
 * Bootstrap: popover.js v3.3.7
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // POPOVER PUBLIC CLASS DEFINITION
    // ===============================

    var Popover = function (element, options) {
        this.init('popover', element, options)
    }

    if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

    Popover.VERSION  = '3.3.7'

    Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
        placement: 'right',
        trigger: 'click',
        content: '',
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    })


    // NOTE: POPOVER EXTENDS tooltip.js
    // ================================

    Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

    Popover.prototype.constructor = Popover

    Popover.prototype.getDefaults = function () {
        return Popover.DEFAULTS
    }

    Popover.prototype.setContent = function () {
        var $tip    = this.tip()
        var title   = this.getTitle()
        var content = this.getContent()

        $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
        $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
            this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
            ](content)

        $tip.removeClass('fade top bottom left right in')

        // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
        // this manually by checking the contents.
        if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
    }

    Popover.prototype.hasContent = function () {
        return this.getTitle() || this.getContent()
    }

    Popover.prototype.getContent = function () {
        var $e = this.$element
        var o  = this.options

        return $e.attr('data-content')
            || (typeof o.content == 'function' ?
                o.content.call($e[0]) :
                o.content)
    }

    Popover.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
    }


    // POPOVER PLUGIN DEFINITION
    // =========================

    function Plugin(option) {
        return this.each(function () {
            var $this   = $(this)
            var data    = $this.data('bs.popover')
            var options = typeof option == 'object' && option

            if (!data && /destroy|hide/.test(option)) return
            if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
            if (typeof option == 'string') data[option]()
        })
    }

    var old = $.fn.popover

    $.fn.popover             = Plugin
    $.fn.popover.Constructor = Popover


    // POPOVER NO CONFLICT
    // ===================

    $.fn.popover.noConflict = function () {
        $.fn.popover = old
        return this
    }

}(jQuery);

/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.7
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // SCROLLSPY CLASS DEFINITION
    // ==========================

    function ScrollSpy(element, options) {
        this.$body          = $(document.body)
        this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
        this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
        this.selector       = (this.options.target || '') + ' .nav li > a'
        this.offsets        = []
        this.targets        = []
        this.activeTarget   = null
        this.scrollHeight   = 0

        this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
        this.refresh()
        this.process()
    }

    ScrollSpy.VERSION  = '3.3.7'

    ScrollSpy.DEFAULTS = {
        offset: 10
    }

    ScrollSpy.prototype.getScrollHeight = function () {
        return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
    }

    ScrollSpy.prototype.refresh = function () {
        var that          = this
        var offsetMethod  = 'offset'
        var offsetBase    = 0

        this.offsets      = []
        this.targets      = []
        this.scrollHeight = this.getScrollHeight()

        if (!$.isWindow(this.$scrollElement[0])) {
            offsetMethod = 'position'
            offsetBase   = this.$scrollElement.scrollTop()
        }

        this.$body
            .find(this.selector)
            .map(function () {
                var $el   = $(this)
                var href  = $el.data('target') || $el.attr('href')
                var $href = /^#./.test(href) && $(href)

                return ($href
                    && $href.length
                    && $href.is(':visible')
                    && [[$href[offsetMethod]().top + offsetBase, href]]) || null
            })
            .sort(function (a, b) { return a[0] - b[0] })
            .each(function () {
                that.offsets.push(this[0])
                that.targets.push(this[1])
            })
    }

    ScrollSpy.prototype.process = function () {
        var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
        var scrollHeight = this.getScrollHeight()
        var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
        var offsets      = this.offsets
        var targets      = this.targets
        var activeTarget = this.activeTarget
        var i

        if (this.scrollHeight != scrollHeight) {
            this.refresh()
        }

        if (scrollTop >= maxScroll) {
            return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
        }

        if (activeTarget && scrollTop < offsets[0]) {
            this.activeTarget = null
            return this.clear()
        }

        for (i = offsets.length; i--;) {
            activeTarget != targets[i]
            && scrollTop >= offsets[i]
            && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
            && this.activate(targets[i])
        }
    }

    ScrollSpy.prototype.activate = function (target) {
        this.activeTarget = target

        this.clear()

        var selector = this.selector +
            '[data-target="' + target + '"],' +
            this.selector + '[href="' + target + '"]'

        var active = $(selector)
            .parents('li')
            .addClass('active')

        if (active.parent('.dropdown-menu').length) {
            active = active
                .closest('li.dropdown')
                .addClass('active')
        }

        active.trigger('activate.bs.scrollspy')
    }

    ScrollSpy.prototype.clear = function () {
        $(this.selector)
            .parentsUntil(this.options.target, '.active')
            .removeClass('active')
    }


    // SCROLLSPY PLUGIN DEFINITION
    // ===========================

    function Plugin(option) {
        return this.each(function () {
            var $this   = $(this)
            var data    = $this.data('bs.scrollspy')
            var options = typeof option == 'object' && option

            if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
            if (typeof option == 'string') data[option]()
        })
    }

    var old = $.fn.scrollspy

    $.fn.scrollspy             = Plugin
    $.fn.scrollspy.Constructor = ScrollSpy


    // SCROLLSPY NO CONFLICT
    // =====================

    $.fn.scrollspy.noConflict = function () {
        $.fn.scrollspy = old
        return this
    }


    // SCROLLSPY DATA-API
    // ==================

    $(window).on('load.bs.scrollspy.data-api', function () {
        $('[data-spy="scroll"]').each(function () {
            var $spy = $(this)
            Plugin.call($spy, $spy.data())
        })
    })

}(jQuery);

/* ========================================================================
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // TAB CLASS DEFINITION
    // ====================

    var Tab = function (element) {
        // jscs:disable requireDollarBeforejQueryAssignment
        this.element = $(element)
        // jscs:enable requireDollarBeforejQueryAssignment
    }

    Tab.VERSION = '3.3.7'

    Tab.TRANSITION_DURATION = 150

    Tab.prototype.show = function () {
        var $this    = this.element
        var $ul      = $this.closest('ul:not(.dropdown-menu)')
        var selector = $this.data('target')

        if (!selector) {
            selector = $this.attr('href')
            selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
        }

        if ($this.parent('li').hasClass('active')) return

        var $previous = $ul.find('.active:last a')
        var hideEvent = $.Event('hide.bs.tab', {
            relatedTarget: $this[0]
        })
        var showEvent = $.Event('show.bs.tab', {
            relatedTarget: $previous[0]
        })

        $previous.trigger(hideEvent)
        $this.trigger(showEvent)

        if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

        var $target = $(selector)

        this.activate($this.closest('li'), $ul)
        this.activate($target, $target.parent(), function () {
            $previous.trigger({
                type: 'hidden.bs.tab',
                relatedTarget: $this[0]
            })
            $this.trigger({
                type: 'shown.bs.tab',
                relatedTarget: $previous[0]
            })
        })
    }

    Tab.prototype.activate = function (element, container, callback) {
        var $active    = container.find('> .active')
        var transition = callback
            && $.support.transition
            && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

        function next() {
            $active
                .removeClass('active')
                .find('> .dropdown-menu > .active')
                .removeClass('active')
                .end()
                .find('[data-toggle="tab"]')
                .attr('aria-expanded', false)

            element
                .addClass('active')
                .find('[data-toggle="tab"]')
                .attr('aria-expanded', true)

            if (transition) {
                element[0].offsetWidth // reflow for transition
                element.addClass('in')
            } else {
                element.removeClass('fade')
            }

            if (element.parent('.dropdown-menu').length) {
                element
                    .closest('li.dropdown')
                    .addClass('active')
                    .end()
                    .find('[data-toggle="tab"]')
                    .attr('aria-expanded', true)
            }

            callback && callback()
        }

        $active.length && transition ?
            $active
                .one('bsTransitionEnd', next)
                .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
            next()

        $active.removeClass('in')
    }


    // TAB PLUGIN DEFINITION
    // =====================

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this)
            var data  = $this.data('bs.tab')

            if (!data) $this.data('bs.tab', (data = new Tab(this)))
            if (typeof option == 'string') data[option]()
        })
    }

    var old = $.fn.tab

    $.fn.tab             = Plugin
    $.fn.tab.Constructor = Tab


    // TAB NO CONFLICT
    // ===============

    $.fn.tab.noConflict = function () {
        $.fn.tab = old
        return this
    }


    // TAB DATA-API
    // ============

    var clickHandler = function (e) {
        e.preventDefault()
        Plugin.call($(this), 'show')
    }

    $(document)
        .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
        .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);

/* ========================================================================
 * Bootstrap: affix.js v3.3.7
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // AFFIX CLASS DEFINITION
    // ======================

    var Affix = function (element, options) {
        this.options = $.extend({}, Affix.DEFAULTS, options)

        this.$target = $(this.options.target)
            .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
            .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

        this.$element     = $(element)
        this.affixed      = null
        this.unpin        = null
        this.pinnedOffset = null

        this.checkPosition()
    }

    Affix.VERSION  = '3.3.7'

    Affix.RESET    = 'affix affix-top affix-bottom'

    Affix.DEFAULTS = {
        offset: 0,
        target: window
    }

    Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
        var scrollTop    = this.$target.scrollTop()
        var position     = this.$element.offset()
        var targetHeight = this.$target.height()

        if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

        if (this.affixed == 'bottom') {
            if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
            return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
        }

        var initializing   = this.affixed == null
        var colliderTop    = initializing ? scrollTop : position.top
        var colliderHeight = initializing ? targetHeight : height

        if (offsetTop != null && scrollTop <= offsetTop) return 'top'
        if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

        return false
    }

    Affix.prototype.getPinnedOffset = function () {
        if (this.pinnedOffset) return this.pinnedOffset
        this.$element.removeClass(Affix.RESET).addClass('affix')
        var scrollTop = this.$target.scrollTop()
        var position  = this.$element.offset()
        return (this.pinnedOffset = position.top - scrollTop)
    }

    Affix.prototype.checkPositionWithEventLoop = function () {
        setTimeout($.proxy(this.checkPosition, this), 1)
    }

    Affix.prototype.checkPosition = function () {
        if (!this.$element.is(':visible')) return

        var height       = this.$element.height()
        var offset       = this.options.offset
        var offsetTop    = offset.top
        var offsetBottom = offset.bottom
        var scrollHeight = Math.max($(document).height(), $(document.body).height())

        if (typeof offset != 'object')         offsetBottom = offsetTop = offset
        if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
        if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

        var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

        if (this.affixed != affix) {
            if (this.unpin != null) this.$element.css('top', '')

            var affixType = 'affix' + (affix ? '-' + affix : '')
            var e         = $.Event(affixType + '.bs.affix')

            this.$element.trigger(e)

            if (e.isDefaultPrevented()) return

            this.affixed = affix
            this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

            this.$element
                .removeClass(Affix.RESET)
                .addClass(affixType)
                .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
        }

        if (affix == 'bottom') {
            this.$element.offset({
                top: scrollHeight - height - offsetBottom
            })
        }
    }


    // AFFIX PLUGIN DEFINITION
    // =======================

    function Plugin(option) {
        return this.each(function () {
            var $this   = $(this)
            var data    = $this.data('bs.affix')
            var options = typeof option == 'object' && option

            if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
            if (typeof option == 'string') data[option]()
        })
    }

    var old = $.fn.affix

    $.fn.affix             = Plugin
    $.fn.affix.Constructor = Affix


    // AFFIX NO CONFLICT
    // =================

    $.fn.affix.noConflict = function () {
        $.fn.affix = old
        return this
    }


    // AFFIX DATA-API
    // ==============

    $(window).on('load', function () {
        $('[data-spy="affix"]').each(function () {
            var $spy = $(this)
            var data = $spy.data()

            data.offset = data.offset || {}

            if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
            if (data.offsetTop    != null) data.offset.top    = data.offsetTop

            Plugin.call($spy, data)
        })
    })

}(jQuery);

//! moment.js
//! version : 2.19.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

// This is done to register the method called with moment()
// without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

// Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

// compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

// format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

// FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

    addUnitAlias('year', 'y');

// PRIORITIES

    addUnitPriority('year', 1);

// PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

// HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

// HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

// MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year())) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

// MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

// FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

// ALIASES

    addUnitAlias('month', 'M');

// PRIORITY

    addUnitPriority('month', 8);

// PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

// LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

// MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

// start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

// FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

// PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

// PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

// HELPERS

// LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

// MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

// FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

// PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

// PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

// HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

// LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

// MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

// FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

// ALIASES

    addUnitAlias('hour', 'h');

// PRIORITY
    addUnitPriority('hour', 13);

// PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

// LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
    var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

// internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    if (!localeFamilies[config.parentLocale]) {
                        localeFamilies[config.parentLocale] = [];
                    }
                    localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config
                    });
                    return null;
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, parentConfig = baseConfig;
            // MERGE
            if (locales[name] != null) {
                parentConfig = locales[name]._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

// returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                    a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                        a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                                    a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                                        -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

// Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

// iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

// date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

// date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

// constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

// date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

// date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

// TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

// FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

// PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
            0 :
            parts[0] === '+' ? minutes : -minutes;
    }

// Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

// ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

// TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                    'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                    diff < 1 ? 'sameDay' :
                        diff < 2 ? 'nextDay' :
                            diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString() {
        if (!this.isValid()) {
            return null;
        }
        var m = this.clone().utc();
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            return this.toDate().toISOString();
        }
        return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
                createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
                createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
            /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
            /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
            /* falls through */
            case 'hour':
                this.minutes(0);
            /* falls through */
            case 'minute':
                this.seconds(0);
            /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

// FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


// PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

// MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

// FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

    addUnitAlias('quarter', 'Q');

// PRIORITY

    addUnitPriority('quarter', 7);

// PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

// MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

// FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

    addUnitAlias('date', 'D');

// PRIOROITY
    addUnitPriority('date', 9);

// PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
            (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
            locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

// MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

    addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
    addUnitPriority('dayOfYear', 4);

// PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

// HELPERS

// MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

// FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

    addUnitAlias('minute', 'm');

// PRIORITY

    addUnitPriority('minute', 14);

// PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

    addUnitAlias('second', 's');

// PRIORITY

    addUnitPriority('second', 15);

// PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

// MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


// ALIASES

    addUnitAlias('millisecond', 'ms');

// PRIORITY

    addUnitPriority('millisecond', 16);

// PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
// MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;

// Year
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;

// Week Year
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;

// Quarter
    proto.quarter = proto.quarters = getSetQuarter;

// Month
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;

// Week
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;

// Day
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;

// Hour
    proto.hour = proto.hours = getSetHour;

// Minute
    proto.minute = proto.minutes = getSetMinute;

// Second
    proto.second = proto.seconds = getSetSecond;

// Millisecond
    proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;

// Timezone
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;

// Deprecations
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

// Month
    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;

// Week
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                    (b === 1) ? 'st' :
                        (b === 2) ? 'nd' :
                            (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

// Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

// supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

// supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

// TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

// This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

// This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

// Deprecations
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

// Side effect imports

// FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

// PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

// Side effect imports


    hooks.version = '2.19.1';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    return hooks;

})));

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined'
    && typeof require === 'function' ? factory(require('../moment')) :
        typeof define === 'function' && define.amd ? define(['../moment'], factory) :
            factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сегодня в] LT',
            nextDay: '[Завтра в] LT',
            lastDay: '[Вчера в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd [в] LT';
                    } else {
                        return '[В] dddd [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd [в] LT';
                    } else {
                        return '[В] dddd [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'час',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;

})));

/*!
 * Bootstrap-select v1.12.4 (http://silviomoreto.github.io/bootstrap-select)
 *
 * Copyright 2013-2017 bootstrap-select
 * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)
 */

(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define(["jquery"], function (a0) {
      return (factory(a0));
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("jquery"));
  } else {
    factory(root["jQuery"]);
  }
}(this, function (jQuery) {

(function ($) {
  'use strict';

  //<editor-fold desc="Shims">
  if (!String.prototype.includes) {
    (function () {
      'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
      var toString = {}.toString;
      var defineProperty = (function () {
        // IE 8 only supports `Object.defineProperty` on DOM elements
        try {
          var object = {};
          var $defineProperty = Object.defineProperty;
          var result = $defineProperty(object, object, object) && $defineProperty;
        } catch (error) {
        }
        return result;
      }());
      var indexOf = ''.indexOf;
      var includes = function (search) {
        if (this == null) {
          throw new TypeError();
        }
        var string = String(this);
        if (search && toString.call(search) == '[object RegExp]') {
          throw new TypeError();
        }
        var stringLength = string.length;
        var searchString = String(search);
        var searchLength = searchString.length;
        var position = arguments.length > 1 ? arguments[1] : undefined;
        // `ToInteger`
        var pos = position ? Number(position) : 0;
        if (pos != pos) { // better `isNaN`
          pos = 0;
        }
        var start = Math.min(Math.max(pos, 0), stringLength);
        // Avoid the `indexOf` call if no match is possible
        if (searchLength + start > stringLength) {
          return false;
        }
        return indexOf.call(string, searchString, pos) != -1;
      };
      if (defineProperty) {
        defineProperty(String.prototype, 'includes', {
          'value': includes,
          'configurable': true,
          'writable': true
        });
      } else {
        String.prototype.includes = includes;
      }
    }());
  }

  if (!String.prototype.startsWith) {
    (function () {
      'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
      var defineProperty = (function () {
        // IE 8 only supports `Object.defineProperty` on DOM elements
        try {
          var object = {};
          var $defineProperty = Object.defineProperty;
          var result = $defineProperty(object, object, object) && $defineProperty;
        } catch (error) {
        }
        return result;
      }());
      var toString = {}.toString;
      var startsWith = function (search) {
        if (this == null) {
          throw new TypeError();
        }
        var string = String(this);
        if (search && toString.call(search) == '[object RegExp]') {
          throw new TypeError();
        }
        var stringLength = string.length;
        var searchString = String(search);
        var searchLength = searchString.length;
        var position = arguments.length > 1 ? arguments[1] : undefined;
        // `ToInteger`
        var pos = position ? Number(position) : 0;
        if (pos != pos) { // better `isNaN`
          pos = 0;
        }
        var start = Math.min(Math.max(pos, 0), stringLength);
        // Avoid the `indexOf` call if no match is possible
        if (searchLength + start > stringLength) {
          return false;
        }
        var index = -1;
        while (++index < searchLength) {
          if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
            return false;
          }
        }
        return true;
      };
      if (defineProperty) {
        defineProperty(String.prototype, 'startsWith', {
          'value': startsWith,
          'configurable': true,
          'writable': true
        });
      } else {
        String.prototype.startsWith = startsWith;
      }
    }());
  }

  if (!Object.keys) {
    Object.keys = function (
      o, // object
      k, // key
      r  // result array
      ){
      // initialize object and result
      r=[];
      // iterate over object keys
      for (k in o)
          // fill result array with non-prototypical keys
        r.hasOwnProperty.call(o, k) && r.push(k);
      // return result
      return r;
    };
  }

  // set data-selected on select element if the value has been programmatically selected
  // prior to initialization of bootstrap-select
  // * consider removing or replacing an alternative method *
  var valHooks = {
    useDefault: false,
    _set: $.valHooks.select.set
  };

  $.valHooks.select.set = function(elem, value) {
    if (value && !valHooks.useDefault) $(elem).data('selected', true);

    return valHooks._set.apply(this, arguments);
  };

  var changed_arguments = null;

  var EventIsSupported = (function() {
    try {
      new Event('change');
      return true;
    } catch (e) {
      return false;
    }
  })();

  $.fn.triggerNative = function (eventName) {
    var el = this[0],
        event;

    if (el.dispatchEvent) { // for modern browsers & IE9+
      if (EventIsSupported) {
        // For modern browsers
        event = new Event(eventName, {
          bubbles: true
        });
      } else {
        // For IE since it doesn't support Event constructor
        event = document.createEvent('Event');
        event.initEvent(eventName, true, false);
      }

      el.dispatchEvent(event);
    } else if (el.fireEvent) { // for IE8
      event = document.createEventObject();
      event.eventType = eventName;
      el.fireEvent('on' + eventName, event);
    } else {
      // fall back to jQuery.trigger
      this.trigger(eventName);
    }
  };
  //</editor-fold>

  // Case insensitive contains search
  $.expr.pseudos.icontains = function (obj, index, meta) {
    var $obj = $(obj).find('a');
    var haystack = ($obj.data('tokens') || $obj.text()).toString().toUpperCase();
    return haystack.includes(meta[3].toUpperCase());
  };

  // Case insensitive begins search
  $.expr.pseudos.ibegins = function (obj, index, meta) {
    var $obj = $(obj).find('a');
    var haystack = ($obj.data('tokens') || $obj.text()).toString().toUpperCase();
    return haystack.startsWith(meta[3].toUpperCase());
  };

  // Case and accent insensitive contains search
  $.expr.pseudos.aicontains = function (obj, index, meta) {
    var $obj = $(obj).find('a');
    var haystack = ($obj.data('tokens') || $obj.data('normalizedText') || $obj.text()).toString().toUpperCase();
    return haystack.includes(meta[3].toUpperCase());
  };

  // Case and accent insensitive begins search
  $.expr.pseudos.aibegins = function (obj, index, meta) {
    var $obj = $(obj).find('a');
    var haystack = ($obj.data('tokens') || $obj.data('normalizedText') || $obj.text()).toString().toUpperCase();
    return haystack.startsWith(meta[3].toUpperCase());
  };

  /**
   * Remove all diatrics from the given text.
   * @access private
   * @param {String} text
   * @returns {String}
   */
  function normalizeToBase(text) {
    var rExps = [
      {re: /[\xC0-\xC6]/g, ch: "A"},
      {re: /[\xE0-\xE6]/g, ch: "a"},
      {re: /[\xC8-\xCB]/g, ch: "E"},
      {re: /[\xE8-\xEB]/g, ch: "e"},
      {re: /[\xCC-\xCF]/g, ch: "I"},
      {re: /[\xEC-\xEF]/g, ch: "i"},
      {re: /[\xD2-\xD6]/g, ch: "O"},
      {re: /[\xF2-\xF6]/g, ch: "o"},
      {re: /[\xD9-\xDC]/g, ch: "U"},
      {re: /[\xF9-\xFC]/g, ch: "u"},
      {re: /[\xC7-\xE7]/g, ch: "c"},
      {re: /[\xD1]/g, ch: "N"},
      {re: /[\xF1]/g, ch: "n"}
    ];
    $.each(rExps, function () {
      text = text ? text.replace(this.re, this.ch) : '';
    });
    return text;
  }


  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  
  var unescapeMap = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#x27;': "'",
    '&#x60;': '`'
  };

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + Object.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };

  var htmlEscape = createEscaper(escapeMap);
  var htmlUnescape = createEscaper(unescapeMap);

  var Selectpicker = function (element, options) {
    // bootstrap-select has been initialized - revert valHooks.select.set back to its original function
    if (!valHooks.useDefault) {
      $.valHooks.select.set = valHooks._set;
      valHooks.useDefault = true;
    }

    this.$element = $(element);
    this.$newElement = null;
    this.$button = null;
    this.$menu = null;
    this.$lis = null;
    this.options = options;

    // If we have no title yet, try to pull it from the html title attribute (jQuery doesnt' pick it up as it's not a
    // data-attribute)
    if (this.options.title === null) {
      this.options.title = this.$element.attr('title');
    }

    // Format window padding
    var winPad = this.options.windowPadding;
    if (typeof winPad === 'number') {
      this.options.windowPadding = [winPad, winPad, winPad, winPad];
    }

    //Expose public methods
    this.val = Selectpicker.prototype.val;
    this.render = Selectpicker.prototype.render;
    this.refresh = Selectpicker.prototype.refresh;
    this.setStyle = Selectpicker.prototype.setStyle;
    this.selectAll = Selectpicker.prototype.selectAll;
    this.deselectAll = Selectpicker.prototype.deselectAll;
    this.destroy = Selectpicker.prototype.destroy;
    this.remove = Selectpicker.prototype.remove;
    this.show = Selectpicker.prototype.show;
    this.hide = Selectpicker.prototype.hide;

    this.init();
  };

  Selectpicker.VERSION = '1.12.4';

  // part of this is duplicated in i18n/defaults-en_US.js. Make sure to update both.
  Selectpicker.DEFAULTS = {
    noneSelectedText: 'Nothing selected',
    noneResultsText: 'No results matched {0}',
    countSelectedText: function (numSelected, numTotal) {
      return (numSelected == 1) ? "{0} item selected" : "{0} items selected";
    },
    maxOptionsText: function (numAll, numGroup) {
      return [
        (numAll == 1) ? 'Limit reached ({n} item max)' : 'Limit reached ({n} items max)',
        (numGroup == 1) ? 'Group limit reached ({n} item max)' : 'Group limit reached ({n} items max)'
      ];
    },
    selectAllText: 'Select All',
    deselectAllText: 'Deselect All',
    doneButton: false,
    doneButtonText: 'Close',
    multipleSeparator: ', ',
    styleBase: 'btn',
    style: 'btn-default',
    size: 'auto',
    title: null,
    selectedTextFormat: 'values',
    width: false,
    container: false,
    hideDisabled: false,
    showSubtext: false,
    showIcon: true,
    showContent: true,
    dropupAuto: true,
    header: false,
    liveSearch: false,
    liveSearchPlaceholder: null,
    liveSearchNormalize: false,
    liveSearchStyle: 'contains',
    actionsBox: false,
    iconBase: 'glyphicon',
    tickIcon: 'glyphicon-ok',
    showTick: false,
    template: {
      caret: '<span class="caret"></span>'
    },
    maxOptions: false,
    mobile: false,
    selectOnTab: false,
    dropdownAlignRight: false,
    windowPadding: 0
  };

  Selectpicker.prototype = {

    constructor: Selectpicker,

    init: function () {
      var that = this,
          id = this.$element.attr('id');

      this.$element.addClass('bs-select-hidden');

      // store originalIndex (key) and newIndex (value) in this.liObj for fast accessibility
      // allows us to do this.$lis.eq(that.liObj[index]) instead of this.$lis.filter('[data-original-index="' + index + '"]')
      this.liObj = {};
      this.multiple = this.$element.prop('multiple');
      this.autofocus = this.$element.prop('autofocus');
      this.$newElement = this.createView();
      this.$element
        .after(this.$newElement)
        .appendTo(this.$newElement);
      this.$button = this.$newElement.children('button');
      this.$menu = this.$newElement.children('.dropdown-menu');
      this.$menuInner = this.$menu.children('.inner');
      this.$searchbox = this.$menu.find('input');

      this.$element.removeClass('bs-select-hidden');

      if (this.options.dropdownAlignRight === true) this.$menu.addClass('dropdown-menu-right');

      if (typeof id !== 'undefined') {
        this.$button.attr('data-id', id);
        $('label[for="' + id + '"]').click(function (e) {
          e.preventDefault();
          that.$button.focus();
        });
      }

      this.checkDisabled();
      this.clickListener();
      if (this.options.liveSearch) this.liveSearchListener();
      this.render();
      this.setStyle();
      this.setWidth();
      if (this.options.container) this.selectPosition();
      this.$menu.data('this', this);
      this.$newElement.data('this', this);
      if (this.options.mobile) this.mobile();

      this.$newElement.on({
        'hide.bs.dropdown': function (e) {
          that.$menuInner.attr('aria-expanded', false);
          that.$element.trigger('hide.bs.select', e);
        },
        'hidden.bs.dropdown': function (e) {
          that.$element.trigger('hidden.bs.select', e);
        },
        'show.bs.dropdown': function (e) {
          that.$menuInner.attr('aria-expanded', true);
          that.$element.trigger('show.bs.select', e);
        },
        'shown.bs.dropdown': function (e) {
          that.$element.trigger('shown.bs.select', e);
        }
      });

      if (that.$element[0].hasAttribute('required')) {
        this.$element.on('invalid', function () {
          that.$button.addClass('bs-invalid');

          that.$element.on({
            'focus.bs.select': function () {
              that.$button.focus();
              that.$element.off('focus.bs.select');
            },
            'shown.bs.select': function () {
              that.$element
                .val(that.$element.val()) // set the value to hide the validation message in Chrome when menu is opened
                .off('shown.bs.select');
            },
            'rendered.bs.select': function () {
              // if select is no longer invalid, remove the bs-invalid class
              if (this.validity.valid) that.$button.removeClass('bs-invalid');
              that.$element.off('rendered.bs.select');
            }
          });

          that.$button.on('blur.bs.select', function() {
            that.$element.focus().blur();
            that.$button.off('blur.bs.select');
          });
        });
      }

      setTimeout(function () {
        that.$element.trigger('loaded.bs.select');
      });
    },

    createDropdown: function () {
      // Options
      // If we are multiple or showTick option is set, then add the show-tick class
      var showTick = (this.multiple || this.options.showTick) ? ' show-tick' : '',
          inputGroup = this.$element.parent().hasClass('input-group') ? ' input-group-btn' : '',
          autofocus = this.autofocus ? ' autofocus' : '';
      // Elements
      var header = this.options.header ? '<div class="popover-title"><button type="button" class="close" aria-hidden="true">&times;</button>' + this.options.header + '</div>' : '';
      var searchbox = this.options.liveSearch ?
      '<div class="bs-searchbox">' +
      '<input type="text" class="form-control" autocomplete="off"' +
      (null === this.options.liveSearchPlaceholder ? '' : ' placeholder="' + htmlEscape(this.options.liveSearchPlaceholder) + '"') + ' role="textbox" aria-label="Search">' +
      '</div>'
          : '';
      var actionsbox = this.multiple && this.options.actionsBox ?
      '<div class="bs-actionsbox">' +
      '<div class="btn-group btn-group-sm btn-block">' +
      '<button type="button" class="actions-btn bs-select-all btn btn-default">' +
      this.options.selectAllText +
      '</button>' +
      '<button type="button" class="actions-btn bs-deselect-all btn btn-default">' +
      this.options.deselectAllText +
      '</button>' +
      '</div>' +
      '</div>'
          : '';
      var donebutton = this.multiple && this.options.doneButton ?
      '<div class="bs-donebutton">' +
      '<div class="btn-group btn-block">' +
      '<button type="button" class="btn btn-sm btn-default">' +
      this.options.doneButtonText +
      '</button>' +
      '</div>' +
      '</div>'
          : '';
      var drop =
          '<div class="btn-group bootstrap-select' + showTick + inputGroup + '">' +
          '<button type="button" class="' + this.options.styleBase + ' dropdown-toggle" data-toggle="dropdown"' + autofocus + ' role="button">' +
          '<span class="filter-option pull-left"></span>&nbsp;' +
          '<span class="bs-caret">' +
          this.options.template.caret +
          '</span>' +
          '</button>' +
          '<div class="dropdown-menu open" role="combobox">' +
          header +
          searchbox +
          actionsbox +
          '<ul class="dropdown-menu inner" role="listbox" aria-expanded="false">' +
          '</ul>' +
          donebutton +
          '</div>' +
          '</div>';

      return $(drop);
    },

    createView: function () {
      var $drop = this.createDropdown(),
          li = this.createLi();

      $drop.find('ul')[0].innerHTML = li;
      return $drop;
    },

    reloadLi: function () {
      // rebuild
      var li = this.createLi();
      this.$menuInner[0].innerHTML = li;
    },

    createLi: function () {
      var that = this,
          _li = [],
          optID = 0,
          titleOption = document.createElement('option'),
          liIndex = -1; // increment liIndex whenever a new <li> element is created to ensure liObj is correct

      // Helper functions
      /**
       * @param content
       * @param [index]
       * @param [classes]
       * @param [optgroup]
       * @returns {string}
       */
      var generateLI = function (content, index, classes, optgroup) {
        return '<li' +
            ((typeof classes !== 'undefined' && '' !== classes) ? ' class="' + classes + '"' : '') +
            ((typeof index !== 'undefined' && null !== index) ? ' data-original-index="' + index + '"' : '') +
            ((typeof optgroup !== 'undefined' && null !== optgroup) ? 'data-optgroup="' + optgroup + '"' : '') +
            '>' + content + '</li>';
      };

      /**
       * @param text
       * @param [classes]
       * @param [inline]
       * @param [tokens]
       * @returns {string}
       */
      var generateA = function (text, classes, inline, tokens) {
        return '<a tabindex="0"' +
            (typeof classes !== 'undefined' ? ' class="' + classes + '"' : '') +
            (inline ? ' style="' + inline + '"' : '') +
            (that.options.liveSearchNormalize ? ' data-normalized-text="' + normalizeToBase(htmlEscape($(text).html())) + '"' : '') +
            (typeof tokens !== 'undefined' || tokens !== null ? ' data-tokens="' + tokens + '"' : '') +
            ' role="option">' + text +
            '<span class="' + that.options.iconBase + ' ' + that.options.tickIcon + ' check-mark"></span>' +
            '</a>';
      };

      if (this.options.title && !this.multiple) {
        // this option doesn't create a new <li> element, but does add a new option, so liIndex is decreased
        // since liObj is recalculated on every refresh, liIndex needs to be decreased even if the titleOption is already appended
        liIndex--;

        if (!this.$element.find('.bs-title-option').length) {
          // Use native JS to prepend option (faster)
          var element = this.$element[0];
          titleOption.className = 'bs-title-option';
          titleOption.innerHTML = this.options.title;
          titleOption.value = '';
          element.insertBefore(titleOption, element.firstChild);
          // Check if selected or data-selected attribute is already set on an option. If not, select the titleOption option.
          // the selected item may have been changed by user or programmatically before the bootstrap select plugin runs,
          // if so, the select will have the data-selected attribute
          var $opt = $(element.options[element.selectedIndex]);
          if ($opt.attr('selected') === undefined && this.$element.data('selected') === undefined) {
            titleOption.selected = true;
          }
        }
      }

      var $selectOptions = this.$element.find('option');

      $selectOptions.each(function (index) {
        var $this = $(this);

        liIndex++;

        if ($this.hasClass('bs-title-option')) return;

        // Get the class and text for the option
        var optionClass = this.className || '',
            inline = htmlEscape(this.style.cssText),
            text = $this.data('content') ? $this.data('content') : $this.html(),
            tokens = $this.data('tokens') ? $this.data('tokens') : null,
            subtext = typeof $this.data('subtext') !== 'undefined' ? '<small class="text-muted">' + $this.data('subtext') + '</small>' : '',
            icon = typeof $this.data('icon') !== 'undefined' ? '<span class="' + that.options.iconBase + ' ' + $this.data('icon') + '"></span> ' : '',
            $parent = $this.parent(),
            isOptgroup = $parent[0].tagName === 'OPTGROUP',
            isOptgroupDisabled = isOptgroup && $parent[0].disabled,
            isDisabled = this.disabled || isOptgroupDisabled,
            prevHiddenIndex;

        if (icon !== '' && isDisabled) {
          icon = '<span>' + icon + '</span>';
        }

        if (that.options.hideDisabled && (isDisabled && !isOptgroup || isOptgroupDisabled)) {
          // set prevHiddenIndex - the index of the first hidden option in a group of hidden options
          // used to determine whether or not a divider should be placed after an optgroup if there are
          // hidden options between the optgroup and the first visible option
          prevHiddenIndex = $this.data('prevHiddenIndex');
          $this.next().data('prevHiddenIndex', (prevHiddenIndex !== undefined ? prevHiddenIndex : index));

          liIndex--;
          return;
        }

        if (!$this.data('content')) {
          // Prepend any icon and append any subtext to the main text.
          text = icon + '<span class="text">' + text + subtext + '</span>';
        }

        if (isOptgroup && $this.data('divider') !== true) {
          if (that.options.hideDisabled && isDisabled) {
            if ($parent.data('allOptionsDisabled') === undefined) {
              var $options = $parent.children();
              $parent.data('allOptionsDisabled', $options.filter(':disabled').length === $options.length);
            }

            if ($parent.data('allOptionsDisabled')) {
              liIndex--;
              return;
            }
          }

          var optGroupClass = ' ' + $parent[0].className || '';

          if ($this.index() === 0) { // Is it the first option of the optgroup?
            optID += 1;

            // Get the opt group label
            var label = $parent[0].label,
                labelSubtext = typeof $parent.data('subtext') !== 'undefined' ? '<small class="text-muted">' + $parent.data('subtext') + '</small>' : '',
                labelIcon = $parent.data('icon') ? '<span class="' + that.options.iconBase + ' ' + $parent.data('icon') + '"></span> ' : '';

            label = labelIcon + '<span class="text">' + htmlEscape(label) + labelSubtext + '</span>';

            if (index !== 0 && _li.length > 0) { // Is it NOT the first option of the select && are there elements in the dropdown?
              liIndex++;
              _li.push(generateLI('', null, 'divider', optID + 'div'));
            }
            liIndex++;
            _li.push(generateLI(label, null, 'dropdown-header' + optGroupClass, optID));
          }

          if (that.options.hideDisabled && isDisabled) {
            liIndex--;
            return;
          }

          _li.push(generateLI(generateA(text, 'opt ' + optionClass + optGroupClass, inline, tokens), index, '', optID));
        } else if ($this.data('divider') === true) {
          _li.push(generateLI('', index, 'divider'));
        } else if ($this.data('hidden') === true) {
          // set prevHiddenIndex - the index of the first hidden option in a group of hidden options
          // used to determine whether or not a divider should be placed after an optgroup if there are
          // hidden options between the optgroup and the first visible option
          prevHiddenIndex = $this.data('prevHiddenIndex');
          $this.next().data('prevHiddenIndex', (prevHiddenIndex !== undefined ? prevHiddenIndex : index));

          _li.push(generateLI(generateA(text, optionClass, inline, tokens), index, 'hidden is-hidden'));
        } else {
          var showDivider = this.previousElementSibling && this.previousElementSibling.tagName === 'OPTGROUP';

          // if previous element is not an optgroup and hideDisabled is true
          if (!showDivider && that.options.hideDisabled) {
            prevHiddenIndex = $this.data('prevHiddenIndex');

            if (prevHiddenIndex !== undefined) {
              // select the element **before** the first hidden element in the group
              var prevHidden = $selectOptions.eq(prevHiddenIndex)[0].previousElementSibling;
              
              if (prevHidden && prevHidden.tagName === 'OPTGROUP' && !prevHidden.disabled) {
                showDivider = true;
              }
            }
          }

          if (showDivider) {
            liIndex++;
            _li.push(generateLI('', null, 'divider', optID + 'div'));
          }
          _li.push(generateLI(generateA(text, optionClass, inline, tokens), index));
        }

        that.liObj[index] = liIndex;
      });

      //If we are not multiple, we don't have a selected item, and we don't have a title, select the first element so something is set in the button
      if (!this.multiple && this.$element.find('option:selected').length === 0 && !this.options.title) {
        this.$element.find('option').eq(0).prop('selected', true).attr('selected', 'selected');
      }

      return _li.join('');
    },

    findLis: function () {
      if (this.$lis == null) this.$lis = this.$menu.find('li');
      return this.$lis;
    },

    /**
     * @param [updateLi] defaults to true
     */
    render: function (updateLi) {
      var that = this,
          notDisabled,
          $selectOptions = this.$element.find('option');

      //Update the LI to match the SELECT
      if (updateLi !== false) {
        $selectOptions.each(function (index) {
          var $lis = that.findLis().eq(that.liObj[index]);

          that.setDisabled(index, this.disabled || this.parentNode.tagName === 'OPTGROUP' && this.parentNode.disabled, $lis);
          that.setSelected(index, this.selected, $lis);
        });
      }

      this.togglePlaceholder();

      this.tabIndex();

      var selectedItems = $selectOptions.map(function () {
        if (this.selected) {
          if (that.options.hideDisabled && (this.disabled || this.parentNode.tagName === 'OPTGROUP' && this.parentNode.disabled)) return;

          var $this = $(this),
              icon = $this.data('icon') && that.options.showIcon ? '<i class="' + that.options.iconBase + ' ' + $this.data('icon') + '"></i> ' : '',
              subtext;

          if (that.options.showSubtext && $this.data('subtext') && !that.multiple) {
            subtext = ' <small class="text-muted">' + $this.data('subtext') + '</small>';
          } else {
            subtext = '';
          }
          if (typeof $this.attr('title') !== 'undefined') {
            return $this.attr('title');
          } else if ($this.data('content') && that.options.showContent) {
            return $this.data('content').toString();
          } else {
            return icon + $this.html() + subtext;
          }
        }
      }).toArray();

      //Fixes issue in IE10 occurring when no default option is selected and at least one option is disabled
      //Convert all the values into a comma delimited string
      var title = !this.multiple ? selectedItems[0] : selectedItems.join(this.options.multipleSeparator);

      //If this is multi select, and the selectText type is count, the show 1 of 2 selected etc..
      if (this.multiple && this.options.selectedTextFormat.indexOf('count') > -1) {
        var max = this.options.selectedTextFormat.split('>');
        if ((max.length > 1 && selectedItems.length > max[1]) || (max.length == 1 && selectedItems.length >= 2)) {
          notDisabled = this.options.hideDisabled ? ', [disabled]' : '';
          var totalCount = $selectOptions.not('[data-divider="true"], [data-hidden="true"]' + notDisabled).length,
              tr8nText = (typeof this.options.countSelectedText === 'function') ? this.options.countSelectedText(selectedItems.length, totalCount) : this.options.countSelectedText;
          title = tr8nText.replace('{0}', selectedItems.length.toString()).replace('{1}', totalCount.toString());
        }
      }

      if (this.options.title == undefined) {
        this.options.title = this.$element.attr('title');
      }

      if (this.options.selectedTextFormat == 'static') {
        title = this.options.title;
      }

      //If we dont have a title, then use the default, or if nothing is set at all, use the not selected text
      if (!title) {
        title = typeof this.options.title !== 'undefined' ? this.options.title : this.options.noneSelectedText;
      }

      //strip all HTML tags and trim the result, then unescape any escaped tags
      this.$button.attr('title', htmlUnescape($.trim(title.replace(/<[^>]*>?/g, ''))));
      this.$button.children('.filter-option').html(title);

      this.$element.trigger('rendered.bs.select');
    },

    /**
     * @param [style]
     * @param [status]
     */
    setStyle: function (style, status) {
      if (this.$element.attr('class')) {
        this.$newElement.addClass(this.$element.attr('class').replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi, ''));
      }

      var buttonClass = style ? style : this.options.style;

      if (status == 'add') {
        this.$button.addClass(buttonClass);
      } else if (status == 'remove') {
        this.$button.removeClass(buttonClass);
      } else {
        this.$button.removeClass(this.options.style);
        this.$button.addClass(buttonClass);
      }
    },

    liHeight: function (refresh) {
      if (!refresh && (this.options.size === false || this.sizeInfo)) return;

      var newElement = document.createElement('div'),
          menu = document.createElement('div'),
          menuInner = document.createElement('ul'),
          divider = document.createElement('li'),
          li = document.createElement('li'),
          a = document.createElement('a'),
          text = document.createElement('span'),
          header = this.options.header && this.$menu.find('.popover-title').length > 0 ? this.$menu.find('.popover-title')[0].cloneNode(true) : null,
          search = this.options.liveSearch ? document.createElement('div') : null,
          actions = this.options.actionsBox && this.multiple && this.$menu.find('.bs-actionsbox').length > 0 ? this.$menu.find('.bs-actionsbox')[0].cloneNode(true) : null,
          doneButton = this.options.doneButton && this.multiple && this.$menu.find('.bs-donebutton').length > 0 ? this.$menu.find('.bs-donebutton')[0].cloneNode(true) : null;

      text.className = 'text';
      newElement.className = this.$menu[0].parentNode.className + ' open';
      menu.className = 'dropdown-menu open';
      menuInner.className = 'dropdown-menu inner';
      divider.className = 'divider';

      text.appendChild(document.createTextNode('Inner text'));
      a.appendChild(text);
      li.appendChild(a);
      menuInner.appendChild(li);
      menuInner.appendChild(divider);
      if (header) menu.appendChild(header);
      if (search) {
        var input = document.createElement('input');
        search.className = 'bs-searchbox';
        input.className = 'form-control';
        search.appendChild(input);
        menu.appendChild(search);
      }
      if (actions) menu.appendChild(actions);
      menu.appendChild(menuInner);
      if (doneButton) menu.appendChild(doneButton);
      newElement.appendChild(menu);

      document.body.appendChild(newElement);

      var liHeight = a.offsetHeight,
          headerHeight = header ? header.offsetHeight : 0,
          searchHeight = search ? search.offsetHeight : 0,
          actionsHeight = actions ? actions.offsetHeight : 0,
          doneButtonHeight = doneButton ? doneButton.offsetHeight : 0,
          dividerHeight = $(divider).outerHeight(true),
          // fall back to jQuery if getComputedStyle is not supported
          menuStyle = typeof getComputedStyle === 'function' ? getComputedStyle(menu) : false,
          $menu = menuStyle ? null : $(menu),
          menuPadding = {
            vert: parseInt(menuStyle ? menuStyle.paddingTop : $menu.css('paddingTop')) +
                  parseInt(menuStyle ? menuStyle.paddingBottom : $menu.css('paddingBottom')) +
                  parseInt(menuStyle ? menuStyle.borderTopWidth : $menu.css('borderTopWidth')) +
                  parseInt(menuStyle ? menuStyle.borderBottomWidth : $menu.css('borderBottomWidth')),
            horiz: parseInt(menuStyle ? menuStyle.paddingLeft : $menu.css('paddingLeft')) +
                  parseInt(menuStyle ? menuStyle.paddingRight : $menu.css('paddingRight')) +
                  parseInt(menuStyle ? menuStyle.borderLeftWidth : $menu.css('borderLeftWidth')) +
                  parseInt(menuStyle ? menuStyle.borderRightWidth : $menu.css('borderRightWidth'))
          },
          menuExtras =  {
            vert: menuPadding.vert +
                  parseInt(menuStyle ? menuStyle.marginTop : $menu.css('marginTop')) +
                  parseInt(menuStyle ? menuStyle.marginBottom : $menu.css('marginBottom')) + 2,
            horiz: menuPadding.horiz +
                  parseInt(menuStyle ? menuStyle.marginLeft : $menu.css('marginLeft')) +
                  parseInt(menuStyle ? menuStyle.marginRight : $menu.css('marginRight')) + 2
          }

      document.body.removeChild(newElement);

      this.sizeInfo = {
        liHeight: liHeight,
        headerHeight: headerHeight,
        searchHeight: searchHeight,
        actionsHeight: actionsHeight,
        doneButtonHeight: doneButtonHeight,
        dividerHeight: dividerHeight,
        menuPadding: menuPadding,
        menuExtras: menuExtras
      };
    },

    setSize: function () {
      this.findLis();
      this.liHeight();

      if (this.options.header) this.$menu.css('padding-top', 0);
      if (this.options.size === false) return;

      var that = this,
          $menu = this.$menu,
          $menuInner = this.$menuInner,
          $window = $(window),
          selectHeight = this.$newElement[0].offsetHeight,
          selectWidth = this.$newElement[0].offsetWidth,
          liHeight = this.sizeInfo['liHeight'],
          headerHeight = this.sizeInfo['headerHeight'],
          searchHeight = this.sizeInfo['searchHeight'],
          actionsHeight = this.sizeInfo['actionsHeight'],
          doneButtonHeight = this.sizeInfo['doneButtonHeight'],
          divHeight = this.sizeInfo['dividerHeight'],
          menuPadding = this.sizeInfo['menuPadding'],
          menuExtras = this.sizeInfo['menuExtras'],
          notDisabled = this.options.hideDisabled ? '.disabled' : '',
          menuHeight,
          menuWidth,
          getHeight,
          getWidth,
          selectOffsetTop,
          selectOffsetBot,
          selectOffsetLeft,
          selectOffsetRight,
          getPos = function() {
            var pos = that.$newElement.offset(),
                $container = $(that.options.container),
                containerPos;

            if (that.options.container && !$container.is('body')) {
              containerPos = $container.offset();
              containerPos.top += parseInt($container.css('borderTopWidth'));
              containerPos.left += parseInt($container.css('borderLeftWidth'));
            } else {
              containerPos = { top: 0, left: 0 };
            }

            var winPad = that.options.windowPadding;
            selectOffsetTop = pos.top - containerPos.top - $window.scrollTop();
            selectOffsetBot = $window.height() - selectOffsetTop - selectHeight - containerPos.top - winPad[2];
            selectOffsetLeft = pos.left - containerPos.left - $window.scrollLeft();
            selectOffsetRight = $window.width() - selectOffsetLeft - selectWidth - containerPos.left - winPad[1];
            selectOffsetTop -= winPad[0];
            selectOffsetLeft -= winPad[3];
          };

      getPos();

      if (this.options.size === 'auto') {
        var getSize = function () {
          var minHeight,
              hasClass = function (className, include) {
                return function (element) {
                    if (include) {
                        return (element.classList ? element.classList.contains(className) : $(element).hasClass(className));
                    } else {
                        return !(element.classList ? element.classList.contains(className) : $(element).hasClass(className));
                    }
                };
              },
              lis = that.$menuInner[0].getElementsByTagName('li'),
              lisVisible = Array.prototype.filter ? Array.prototype.filter.call(lis, hasClass('hidden', false)) : that.$lis.not('.hidden'),
              optGroup = Array.prototype.filter ? Array.prototype.filter.call(lisVisible, hasClass('dropdown-header', true)) : lisVisible.filter('.dropdown-header');

          getPos();
          menuHeight = selectOffsetBot - menuExtras.vert;
          menuWidth = selectOffsetRight - menuExtras.horiz;

          if (that.options.container) {
            if (!$menu.data('height')) $menu.data('height', $menu.height());
            getHeight = $menu.data('height');

            if (!$menu.data('width')) $menu.data('width', $menu.width());
            getWidth = $menu.data('width');
          } else {
            getHeight = $menu.height();
            getWidth = $menu.width();
          }

          if (that.options.dropupAuto) {
            that.$newElement.toggleClass('dropup', selectOffsetTop > selectOffsetBot && (menuHeight - menuExtras.vert) < getHeight);
          }

          if (that.$newElement.hasClass('dropup')) {
            menuHeight = selectOffsetTop - menuExtras.vert;
          }

          if (that.options.dropdownAlignRight === 'auto') {
            $menu.toggleClass('dropdown-menu-right', selectOffsetLeft > selectOffsetRight && (menuWidth - menuExtras.horiz) < (getWidth - selectWidth));
          }

          if ((lisVisible.length + optGroup.length) > 3) {
            minHeight = liHeight * 3 + menuExtras.vert - 2;
          } else {
            minHeight = 0;
          }

          $menu.css({
            'max-height': menuHeight + 'px',
            'overflow': 'hidden',
            'min-height': minHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight + 'px'
          });
          $menuInner.css({
            'max-height': menuHeight - headerHeight - searchHeight - actionsHeight - doneButtonHeight - menuPadding.vert + 'px',
            'overflow-y': 'auto',
            'min-height': Math.max(minHeight - menuPadding.vert, 0) + 'px'
          });
        };
        getSize();
        this.$searchbox.off('input.getSize propertychange.getSize').on('input.getSize propertychange.getSize', getSize);
        $window.off('resize.getSize scroll.getSize').on('resize.getSize scroll.getSize', getSize);
      } else if (this.options.size && this.options.size != 'auto' && this.$lis.not(notDisabled).length > this.options.size) {
        var optIndex = this.$lis.not('.divider').not(notDisabled).children().slice(0, this.options.size).last().parent().index(),
            divLength = this.$lis.slice(0, optIndex + 1).filter('.divider').length;
        menuHeight = liHeight * this.options.size + divLength * divHeight + menuPadding.vert;

        if (that.options.container) {
          if (!$menu.data('height')) $menu.data('height', $menu.height());
          getHeight = $menu.data('height');
        } else {
          getHeight = $menu.height();
        }

        if (that.options.dropupAuto) {
          //noinspection JSUnusedAssignment
          this.$newElement.toggleClass('dropup', selectOffsetTop > selectOffsetBot && (menuHeight - menuExtras.vert) < getHeight);
        }
        $menu.css({
          'max-height': menuHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight + 'px',
          'overflow': 'hidden',
          'min-height': ''
        });
        $menuInner.css({
          'max-height': menuHeight - menuPadding.vert + 'px',
          'overflow-y': 'auto',
          'min-height': ''
        });
      }
    },

    setWidth: function () {
      if (this.options.width === 'auto') {
        this.$menu.css('min-width', '0');

        // Get correct width if element is hidden
        var $selectClone = this.$menu.parent().clone().appendTo('body'),
            $selectClone2 = this.options.container ? this.$newElement.clone().appendTo('body') : $selectClone,
            ulWidth = $selectClone.children('.dropdown-menu').outerWidth(),
            btnWidth = $selectClone2.css('width', 'auto').children('button').outerWidth();

        $selectClone.remove();
        $selectClone2.remove();

        // Set width to whatever's larger, button title or longest option
        this.$newElement.css('width', Math.max(ulWidth, btnWidth) + 'px');
      } else if (this.options.width === 'fit') {
        // Remove inline min-width so width can be changed from 'auto'
        this.$menu.css('min-width', '');
        this.$newElement.css('width', '').addClass('fit-width');
      } else if (this.options.width) {
        // Remove inline min-width so width can be changed from 'auto'
        this.$menu.css('min-width', '');
        this.$newElement.css('width', this.options.width);
      } else {
        // Remove inline min-width/width so width can be changed
        this.$menu.css('min-width', '');
        this.$newElement.css('width', '');
      }
      // Remove fit-width class if width is changed programmatically
      if (this.$newElement.hasClass('fit-width') && this.options.width !== 'fit') {
        this.$newElement.removeClass('fit-width');
      }
    },

    selectPosition: function () {
      this.$bsContainer = $('<div class="bs-container" />');

      var that = this,
          $container = $(this.options.container),
          pos,
          containerPos,
          actualHeight,
          getPlacement = function ($element) {
            that.$bsContainer.addClass($element.attr('class').replace(/form-control|fit-width/gi, '')).toggleClass('dropup', $element.hasClass('dropup'));
            pos = $element.offset();

            if (!$container.is('body')) {
              containerPos = $container.offset();
              containerPos.top += parseInt($container.css('borderTopWidth')) - $container.scrollTop();
              containerPos.left += parseInt($container.css('borderLeftWidth')) - $container.scrollLeft();
            } else {
              containerPos = { top: 0, left: 0 };
            }

            actualHeight = $element.hasClass('dropup') ? 0 : $element[0].offsetHeight;

            that.$bsContainer.css({
              'top': pos.top - containerPos.top + actualHeight,
              'left': pos.left - containerPos.left,
              'width': $element[0].offsetWidth
            });
          };

      this.$button.on('click', function () {
        var $this = $(this);

        if (that.isDisabled()) {
          return;
        }

        getPlacement(that.$newElement);

        that.$bsContainer
          .appendTo(that.options.container)
          .toggleClass('open', !$this.hasClass('open'))
          .append(that.$menu);
      });

      $(window).on('resize scroll', function () {
        getPlacement(that.$newElement);
      });

      this.$element.on('hide.bs.select', function () {
        that.$menu.data('height', that.$menu.height());
        that.$bsContainer.detach();
      });
    },

    /**
     * @param {number} index - the index of the option that is being changed
     * @param {boolean} selected - true if the option is being selected, false if being deselected
     * @param {JQuery} $lis - the 'li' element that is being modified
     */
    setSelected: function (index, selected, $lis) {
      if (!$lis) {
        this.togglePlaceholder(); // check if setSelected is being called by changing the value of the select
        $lis = this.findLis().eq(this.liObj[index]);
      }

      $lis.toggleClass('selected', selected).find('a').attr('aria-selected', selected);
    },

    /**
     * @param {number} index - the index of the option that is being disabled
     * @param {boolean} disabled - true if the option is being disabled, false if being enabled
     * @param {JQuery} $lis - the 'li' element that is being modified
     */
    setDisabled: function (index, disabled, $lis) {
      if (!$lis) {
        $lis = this.findLis().eq(this.liObj[index]);
      }

      if (disabled) {
        $lis.addClass('disabled').children('a').attr('href', '#').attr('tabindex', -1).attr('aria-disabled', true);
      } else {
        $lis.removeClass('disabled').children('a').removeAttr('href').attr('tabindex', 0).attr('aria-disabled', false);
      }
    },

    isDisabled: function () {
      return this.$element[0].disabled;
    },

    checkDisabled: function () {
      var that = this;

      if (this.isDisabled()) {
        this.$newElement.addClass('disabled');
        this.$button.addClass('disabled').attr('tabindex', -1).attr('aria-disabled', true);
      } else {
        if (this.$button.hasClass('disabled')) {
          this.$newElement.removeClass('disabled');
          this.$button.removeClass('disabled').attr('aria-disabled', false);
        }

        if (this.$button.attr('tabindex') == -1 && !this.$element.data('tabindex')) {
          this.$button.removeAttr('tabindex');
        }
      }

      this.$button.click(function () {
        return !that.isDisabled();
      });
    },

    togglePlaceholder: function () {
      var value = this.$element.val();
      this.$button.toggleClass('bs-placeholder', value === null || value === '' || (value.constructor === Array && value.length === 0));
    },

    tabIndex: function () {
      if (this.$element.data('tabindex') !== this.$element.attr('tabindex') && 
        (this.$element.attr('tabindex') !== -98 && this.$element.attr('tabindex') !== '-98')) {
        this.$element.data('tabindex', this.$element.attr('tabindex'));
        this.$button.attr('tabindex', this.$element.data('tabindex'));
      }

      this.$element.attr('tabindex', -98);
    },

    clickListener: function () {
      var that = this,
          $document = $(document);

      $document.data('spaceSelect', false);

      this.$button.on('keyup', function (e) {
        if (/(32)/.test(e.keyCode.toString(10)) && $document.data('spaceSelect')) {
            e.preventDefault();
            $document.data('spaceSelect', false);
        }
      });

      this.$button.on('click', function () {
        that.setSize();
      });

      this.$element.on('shown.bs.select', function () {
        if (!that.options.liveSearch && !that.multiple) {
          that.$menuInner.find('.selected a').focus();
        } else if (!that.multiple) {
          var selectedIndex = that.liObj[that.$element[0].selectedIndex];

          if (typeof selectedIndex !== 'number' || that.options.size === false) return;

          // scroll to selected option
          var offset = that.$lis.eq(selectedIndex)[0].offsetTop - that.$menuInner[0].offsetTop;
          offset = offset - that.$menuInner[0].offsetHeight/2 + that.sizeInfo.liHeight/2;
          that.$menuInner[0].scrollTop = offset;
        }
      });

      this.$menuInner.on('click', 'li a', function (e) {
        var $this = $(this),
            clickedIndex = $this.parent().data('originalIndex'),
            prevValue = that.$element.val(),
            prevIndex = that.$element.prop('selectedIndex'),
            triggerChange = true;

        // Don't close on multi choice menu
        if (that.multiple && that.options.maxOptions !== 1) {
          e.stopPropagation();
        }

        e.preventDefault();

        //Don't run if we have been disabled
        if (!that.isDisabled() && !$this.parent().hasClass('disabled')) {
          var $options = that.$element.find('option'),
              $option = $options.eq(clickedIndex),
              state = $option.prop('selected'),
              $optgroup = $option.parent('optgroup'),
              maxOptions = that.options.maxOptions,
              maxOptionsGrp = $optgroup.data('maxOptions') || false;

          if (!that.multiple) { // Deselect all others if not multi select box
            $options.prop('selected', false);
            $option.prop('selected', true);
            that.$menuInner.find('.selected').removeClass('selected').find('a').attr('aria-selected', false);
            that.setSelected(clickedIndex, true);
          } else { // Toggle the one we have chosen if we are multi select.
            $option.prop('selected', !state);
            that.setSelected(clickedIndex, !state);
            $this.blur();

            if (maxOptions !== false || maxOptionsGrp !== false) {
              var maxReached = maxOptions < $options.filter(':selected').length,
                  maxReachedGrp = maxOptionsGrp < $optgroup.find('option:selected').length;

              if ((maxOptions && maxReached) || (maxOptionsGrp && maxReachedGrp)) {
                if (maxOptions && maxOptions == 1) {
                  $options.prop('selected', false);
                  $option.prop('selected', true);
                  that.$menuInner.find('.selected').removeClass('selected');
                  that.setSelected(clickedIndex, true);
                } else if (maxOptionsGrp && maxOptionsGrp == 1) {
                  $optgroup.find('option:selected').prop('selected', false);
                  $option.prop('selected', true);
                  var optgroupID = $this.parent().data('optgroup');
                  that.$menuInner.find('[data-optgroup="' + optgroupID + '"]').removeClass('selected');
                  that.setSelected(clickedIndex, true);
                } else {
                  var maxOptionsText = typeof that.options.maxOptionsText === 'string' ? [that.options.maxOptionsText, that.options.maxOptionsText] : that.options.maxOptionsText,
                      maxOptionsArr = typeof maxOptionsText === 'function' ? maxOptionsText(maxOptions, maxOptionsGrp) : maxOptionsText,
                      maxTxt = maxOptionsArr[0].replace('{n}', maxOptions),
                      maxTxtGrp = maxOptionsArr[1].replace('{n}', maxOptionsGrp),
                      $notify = $('<div class="notify"></div>');
                  // If {var} is set in array, replace it
                  /** @deprecated */
                  if (maxOptionsArr[2]) {
                    maxTxt = maxTxt.replace('{var}', maxOptionsArr[2][maxOptions > 1 ? 0 : 1]);
                    maxTxtGrp = maxTxtGrp.replace('{var}', maxOptionsArr[2][maxOptionsGrp > 1 ? 0 : 1]);
                  }

                  $option.prop('selected', false);

                  that.$menu.append($notify);

                  if (maxOptions && maxReached) {
                    $notify.append($('<div>' + maxTxt + '</div>'));
                    triggerChange = false;
                    that.$element.trigger('maxReached.bs.select');
                  }

                  if (maxOptionsGrp && maxReachedGrp) {
                    $notify.append($('<div>' + maxTxtGrp + '</div>'));
                    triggerChange = false;
                    that.$element.trigger('maxReachedGrp.bs.select');
                  }

                  setTimeout(function () {
                    that.setSelected(clickedIndex, false);
                  }, 10);

                  $notify.delay(750).fadeOut(300, function () {
                    $(this).remove();
                  });
                }
              }
            }
          }

          if (!that.multiple || (that.multiple && that.options.maxOptions === 1)) {
            that.$button.focus();
          } else if (that.options.liveSearch) {
            that.$searchbox.focus();
          }

          // Trigger select 'change'
          if (triggerChange) {
            if ((prevValue != that.$element.val() && that.multiple) || (prevIndex != that.$element.prop('selectedIndex') && !that.multiple)) {
              // $option.prop('selected') is current option state (selected/unselected). state is previous option state.
              changed_arguments = [clickedIndex, $option.prop('selected'), state];
              that.$element
                .triggerNative('change');
            }
          }
        }
      });

      this.$menu.on('click', 'li.disabled a, .popover-title, .popover-title :not(.close)', function (e) {
        if (e.currentTarget == this) {
          e.preventDefault();
          e.stopPropagation();
          if (that.options.liveSearch && !$(e.target).hasClass('close')) {
            that.$searchbox.focus();
          } else {
            that.$button.focus();
          }
        }
      });

      this.$menuInner.on('click', '.divider, .dropdown-header', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (that.options.liveSearch) {
          that.$searchbox.focus();
        } else {
          that.$button.focus();
        }
      });

      this.$menu.on('click', '.popover-title .close', function () {
        that.$button.click();
      });

      this.$searchbox.on('click', function (e) {
        e.stopPropagation();
      });

      this.$menu.on('click', '.actions-btn', function (e) {
        if (that.options.liveSearch) {
          that.$searchbox.focus();
        } else {
          that.$button.focus();
        }

        e.preventDefault();
        e.stopPropagation();

        if ($(this).hasClass('bs-select-all')) {
          that.selectAll();
        } else {
          that.deselectAll();
        }
      });

      this.$element.change(function () {
        that.render(false);
        that.$element.trigger('changed.bs.select', changed_arguments);
        changed_arguments = null;
      });
    },

    liveSearchListener: function () {
      var that = this,
          $no_results = $('<li class="no-results"></li>');

      this.$button.on('click.dropdown.data-api', function () {
        that.$menuInner.find('.active').removeClass('active');
        if (!!that.$searchbox.val()) {
          that.$searchbox.val('');
          that.$lis.not('.is-hidden').removeClass('hidden');
          if (!!$no_results.parent().length) $no_results.remove();
        }
        if (!that.multiple) that.$menuInner.find('.selected').addClass('active');
        setTimeout(function () {
          that.$searchbox.focus();
        }, 10);
      });

      this.$searchbox.on('click.dropdown.data-api focus.dropdown.data-api touchend.dropdown.data-api', function (e) {
        e.stopPropagation();
      });

      this.$searchbox.on('input propertychange', function () {
        that.$lis.not('.is-hidden').removeClass('hidden');
        that.$lis.filter('.active').removeClass('active');
        $no_results.remove();

        if (that.$searchbox.val()) {
          var $searchBase = that.$lis.not('.is-hidden, .divider, .dropdown-header'),
              $hideItems;
          if (that.options.liveSearchNormalize) {
            $hideItems = $searchBase.not(':a' + that._searchStyle() + '("' + normalizeToBase(that.$searchbox.val()) + '")');
          } else {
            $hideItems = $searchBase.not(':' + that._searchStyle() + '("' + that.$searchbox.val() + '")');
          }

          if ($hideItems.length === $searchBase.length) {
            $no_results.html(that.options.noneResultsText.replace('{0}', '"' + htmlEscape(that.$searchbox.val()) + '"'));
            that.$menuInner.append($no_results);
            that.$lis.addClass('hidden');
          } else {
            $hideItems.addClass('hidden');

            var $lisVisible = that.$lis.not('.hidden'),
                $foundDiv;

            // hide divider if first or last visible, or if followed by another divider
            $lisVisible.each(function (index) {
              var $this = $(this);

              if ($this.hasClass('divider')) {
                if ($foundDiv === undefined) {
                  $this.addClass('hidden');
                } else {
                  if ($foundDiv) $foundDiv.addClass('hidden');
                  $foundDiv = $this;
                }
              } else if ($this.hasClass('dropdown-header') && $lisVisible.eq(index + 1).data('optgroup') !== $this.data('optgroup')) {
                $this.addClass('hidden');
              } else {
                $foundDiv = null;
              }
            });
            if ($foundDiv) $foundDiv.addClass('hidden');

            $searchBase.not('.hidden').first().addClass('active');
            that.$menuInner.scrollTop(0);
          }
        }
      });
    },

    _searchStyle: function () {
      var styles = {
        begins: 'ibegins',
        startsWith: 'ibegins'
      };

      return styles[this.options.liveSearchStyle] || 'icontains';
    },

    val: function (value) {
      if (typeof value !== 'undefined') {
        this.$element.val(value);
        this.render();

        return this.$element;
      } else {
        return this.$element.val();
      }
    },

    changeAll: function (status) {
      if (!this.multiple) return;
      if (typeof status === 'undefined') status = true;

      this.findLis();

      var $options = this.$element.find('option'),
          $lisVisible = this.$lis.not('.divider, .dropdown-header, .disabled, .hidden'),
          lisVisLen = $lisVisible.length,
          selectedOptions = [];
          
      if (status) {
        if ($lisVisible.filter('.selected').length === $lisVisible.length) return;
      } else {
        if ($lisVisible.filter('.selected').length === 0) return;
      }
          
      $lisVisible.toggleClass('selected', status);

      for (var i = 0; i < lisVisLen; i++) {
        var origIndex = $lisVisible[i].getAttribute('data-original-index');
        selectedOptions[selectedOptions.length] = $options.eq(origIndex)[0];
      }

      $(selectedOptions).prop('selected', status);

      this.render(false);

      this.togglePlaceholder();

      this.$element
        .triggerNative('change');
    },

    selectAll: function () {
      return this.changeAll(true);
    },

    deselectAll: function () {
      return this.changeAll(false);
    },

    toggle: function (e) {
      e = e || window.event;

      if (e) e.stopPropagation();

      this.$button.trigger('click');
    },

    keydown: function (e) {
      var $this = $(this),
          $parent = $this.is('input') ? $this.parent().parent() : $this.parent(),
          $items,
          that = $parent.data('this'),
          index,
          prevIndex,
          isActive,
          selector = ':not(.disabled, .hidden, .dropdown-header, .divider)',
          keyCodeMap = {
            32: ' ',
            48: '0',
            49: '1',
            50: '2',
            51: '3',
            52: '4',
            53: '5',
            54: '6',
            55: '7',
            56: '8',
            57: '9',
            59: ';',
            65: 'a',
            66: 'b',
            67: 'c',
            68: 'd',
            69: 'e',
            70: 'f',
            71: 'g',
            72: 'h',
            73: 'i',
            74: 'j',
            75: 'k',
            76: 'l',
            77: 'm',
            78: 'n',
            79: 'o',
            80: 'p',
            81: 'q',
            82: 'r',
            83: 's',
            84: 't',
            85: 'u',
            86: 'v',
            87: 'w',
            88: 'x',
            89: 'y',
            90: 'z',
            96: '0',
            97: '1',
            98: '2',
            99: '3',
            100: '4',
            101: '5',
            102: '6',
            103: '7',
            104: '8',
            105: '9'
          };


      isActive = that.$newElement.hasClass('open');

      if (!isActive && (e.keyCode >= 48 && e.keyCode <= 57 || e.keyCode >= 96 && e.keyCode <= 105 || e.keyCode >= 65 && e.keyCode <= 90)) {
        if (!that.options.container) {
          that.setSize();
          that.$menu.parent().addClass('open');
          isActive = true;
        } else {
          that.$button.trigger('click');
        }
        that.$searchbox.focus();
        return;
      }

      if (that.options.liveSearch) {
        if (/(^9$|27)/.test(e.keyCode.toString(10)) && isActive) {
          e.preventDefault();
          e.stopPropagation();
          that.$menuInner.click();
          that.$button.focus();
        }
      }

      if (/(38|40)/.test(e.keyCode.toString(10))) {
        $items = that.$lis.filter(selector);
        if (!$items.length) return;

        if (!that.options.liveSearch) {
          index = $items.index($items.find('a').filter(':focus').parent());
	    } else {
          index = $items.index($items.filter('.active'));
        }

        prevIndex = that.$menuInner.data('prevIndex');

        if (e.keyCode == 38) {
          if ((that.options.liveSearch || index == prevIndex) && index != -1) index--;
          if (index < 0) index += $items.length;
        } else if (e.keyCode == 40) {
          if (that.options.liveSearch || index == prevIndex) index++;
          index = index % $items.length;
        }

        that.$menuInner.data('prevIndex', index);

        if (!that.options.liveSearch) {
          $items.eq(index).children('a').focus();
        } else {
          e.preventDefault();
          if (!$this.hasClass('dropdown-toggle')) {
            $items.removeClass('active').eq(index).addClass('active').children('a').focus();
            $this.focus();
          }
        }

      } else if (!$this.is('input')) {
        var keyIndex = [],
            count,
            prevKey;

        $items = that.$lis.filter(selector);
        $items.each(function (i) {
          if ($.trim($(this).children('a').text().toLowerCase()).substring(0, 1) == keyCodeMap[e.keyCode]) {
            keyIndex.push(i);
          }
        });

        count = $(document).data('keycount');
        count++;
        $(document).data('keycount', count);

        prevKey = $.trim($(':focus').text().toLowerCase()).substring(0, 1);

        if (prevKey != keyCodeMap[e.keyCode]) {
          count = 1;
          $(document).data('keycount', count);
        } else if (count >= keyIndex.length) {
          $(document).data('keycount', 0);
          if (count > keyIndex.length) count = 1;
        }

        $items.eq(keyIndex[count - 1]).children('a').focus();
      }

      // Select focused option if "Enter", "Spacebar" or "Tab" (when selectOnTab is true) are pressed inside the menu.
      if ((/(13|32)/.test(e.keyCode.toString(10)) || (/(^9$)/.test(e.keyCode.toString(10)) && that.options.selectOnTab)) && isActive) {
        if (!/(32)/.test(e.keyCode.toString(10))) e.preventDefault();
        if (!that.options.liveSearch) {
          var elem = $(':focus');
          elem.click();
          // Bring back focus for multiselects
          elem.focus();
          // Prevent screen from scrolling if the user hit the spacebar
          e.preventDefault();
          // Fixes spacebar selection of dropdown items in FF & IE
          $(document).data('spaceSelect', true);
        } else if (!/(32)/.test(e.keyCode.toString(10))) {
          that.$menuInner.find('.active a').click();
          $this.focus();
        }
        $(document).data('keycount', 0);
      }

      if ((/(^9$|27)/.test(e.keyCode.toString(10)) && isActive && (that.multiple || that.options.liveSearch)) || (/(27)/.test(e.keyCode.toString(10)) && !isActive)) {
        that.$menu.parent().removeClass('open');
        if (that.options.container) that.$newElement.removeClass('open');
        that.$button.focus();
      }
    },

    mobile: function () {
      this.$element.addClass('mobile-device');
    },

    refresh: function () {
      this.$lis = null;
      this.liObj = {};
      this.reloadLi();
      this.render();
      this.checkDisabled();
      this.liHeight(true);
      this.setStyle();
      this.setWidth();
      if (this.$lis) this.$searchbox.trigger('propertychange');

      this.$element.trigger('refreshed.bs.select');
    },

    hide: function () {
      this.$newElement.hide();
    },

    show: function () {
      this.$newElement.show();
    },

    remove: function () {
      this.$newElement.remove();
      this.$element.remove();
    },

    destroy: function () {
      this.$newElement.before(this.$element).remove();

      if (this.$bsContainer) {
        this.$bsContainer.remove();
      } else {
        this.$menu.remove();
      }

      this.$element
        .off('.bs.select')
        .removeData('selectpicker')
        .removeClass('bs-select-hidden selectpicker');
    }
  };

  // SELECTPICKER PLUGIN DEFINITION
  // ==============================
  function Plugin(option) {
    // get the args of the outer function..
    var args = arguments;
    // The arguments of the function are explicitly re-defined from the argument list, because the shift causes them
    // to get lost/corrupted in android 2.3 and IE9 #715 #775
    var _option = option;

    [].shift.apply(args);

    var value;
    var chain = this.each(function () {
      var $this = $(this);
      if ($this.is('select')) {
        var data = $this.data('selectpicker'),
            options = typeof _option == 'object' && _option;

        if (!data) {
          var config = $.extend({}, Selectpicker.DEFAULTS, $.fn.selectpicker.defaults || {}, $this.data(), options);
          config.template = $.extend({}, Selectpicker.DEFAULTS.template, ($.fn.selectpicker.defaults ? $.fn.selectpicker.defaults.template : {}), $this.data().template, options.template);
          $this.data('selectpicker', (data = new Selectpicker(this, config)));
        } else if (options) {
          for (var i in options) {
            if (options.hasOwnProperty(i)) {
              data.options[i] = options[i];
            }
          }
        }

        if (typeof _option == 'string') {
          if (data[_option] instanceof Function) {
            value = data[_option].apply(data, args);
          } else {
            value = data.options[_option];
          }
        }
      }
    });

    if (typeof value !== 'undefined') {
      //noinspection JSUnusedAssignment
      return value;
    } else {
      return chain;
    }
  }

  var old = $.fn.selectpicker;
  $.fn.selectpicker = Plugin;
  $.fn.selectpicker.Constructor = Selectpicker;

  // SELECTPICKER NO CONFLICT
  // ========================
  $.fn.selectpicker.noConflict = function () {
    $.fn.selectpicker = old;
    return this;
  };

  $(document)
      .data('keycount', 0)
      .on('keydown.bs.select', '.bootstrap-select [data-toggle=dropdown], .bootstrap-select [role="listbox"], .bs-searchbox input', Selectpicker.prototype.keydown)
      .on('focusin.modal', '.bootstrap-select [data-toggle=dropdown], .bootstrap-select [role="listbox"], .bs-searchbox input', function (e) {
        e.stopPropagation();
      });

  // SELECTPICKER DATA-API
  // =====================
  $(window).on('load.bs.select.data-api', function () {
    $('.selectpicker').each(function () {
      var $selectpicker = $(this);
      Plugin.call($selectpicker, $selectpicker.data());
    })
  });
})(jQuery);


}));

/*!
 * Bootstrap-select v1.12.4 (http://silviomoreto.github.io/bootstrap-select)
 *
 * Copyright 2013-2017 bootstrap-select
 * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)
 */

(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define(["jquery"], function (a0) {
      return (factory(a0));
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("jquery"));
  } else {
    factory(root["jQuery"]);
  }
}(this, function (jQuery) {

(function ($) {
  $.fn.selectpicker.defaults = {
    noneSelectedText: 'Ничего не выбрано',
    noneResultsText: 'Совпадений не найдено {0}',
    countSelectedText: 'Выбрано {0} из {1}',
    maxOptionsText: ['Достигнут предел ({n} {var} максимум)', 'Достигнут предел в группе ({n} {var} максимум)', ['шт.', 'шт.']],
    doneButtonText: 'Закрыть',
    selectAllText: 'Выбрать все',
    deselectAllText: 'Отменить все',    
    multipleSeparator: ', '
  };
})(jQuery);


}));

/*! version : 4.17.47
 =========================================================
 bootstrap-datetimejs
 https://github.com/Eonasdan/bootstrap-datetimepicker
 Copyright (c) 2015 Jonathan Peterson
 =========================================================
 */
/*
 The MIT License (MIT)

 Copyright (c) 2015 Jonathan Peterson

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 */
/*global define:false */
/*global exports:false */
/*global require:false */
/*global jQuery:false */
/*global moment:false */
(function (factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        // AMD is used - Register as an anonymous module.
        define(['jquery', 'moment'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'), require('moment'));
    } else {
        // Neither AMD nor CommonJS used. Use global variables.
        if (typeof jQuery === 'undefined') {
            throw 'bootstrap-datetimepicker requires jQuery to be loaded first';
        }
        if (typeof moment === 'undefined') {
            throw 'bootstrap-datetimepicker requires Moment.js to be loaded first';
        }
        factory(jQuery, moment);
    }
}(function ($, moment) {
    'use strict';
    if (!moment) {
        throw new Error('bootstrap-datetimepicker requires Moment.js to be loaded first');
    }

    var dateTimePicker = function (element, options) {
        var picker = {},
            date,
            viewDate,
            unset = true,
            input,
            component = false,
            widget = false,
            use24Hours,
            minViewModeNumber = 0,
            actualFormat,
            parseFormats,
            currentViewMode,
            datePickerModes = [
                {
                    clsName: 'days',
                    navFnc: 'M',
                    navStep: 1
                },
                {
                    clsName: 'months',
                    navFnc: 'y',
                    navStep: 1
                },
                {
                    clsName: 'years',
                    navFnc: 'y',
                    navStep: 10
                },
                {
                    clsName: 'decades',
                    navFnc: 'y',
                    navStep: 100
                }
            ],
            viewModes = ['days', 'months', 'years', 'decades'],
            verticalModes = ['top', 'bottom', 'auto'],
            horizontalModes = ['left', 'right', 'auto'],
            toolbarPlacements = ['default', 'top', 'bottom'],
            keyMap = {
                'up': 38,
                38: 'up',
                'down': 40,
                40: 'down',
                'left': 37,
                37: 'left',
                'right': 39,
                39: 'right',
                'tab': 9,
                9: 'tab',
                'escape': 27,
                27: 'escape',
                'enter': 13,
                13: 'enter',
                'pageUp': 33,
                33: 'pageUp',
                'pageDown': 34,
                34: 'pageDown',
                'shift': 16,
                16: 'shift',
                'control': 17,
                17: 'control',
                'space': 32,
                32: 'space',
                't': 84,
                84: 't',
                'delete': 46,
                46: 'delete'
            },
            keyState = {},

            /********************************************************************************
             *
             * Private functions
             *
             ********************************************************************************/

            hasTimeZone = function () {
                return moment.tz !== undefined && options.timeZone !== undefined && options.timeZone !== null && options.timeZone !== '';
            },

            getMoment = function (d) {
                var returnMoment;

                if (d === undefined || d === null) {
                    returnMoment = moment(); //TODO should this use format? and locale?
                } else if (moment.isDate(d) || moment.isMoment(d)) {
                    // If the date that is passed in is already a Date() or moment() object,
                    // pass it directly to moment.
                    returnMoment = moment(d);
                } else if (hasTimeZone()) { // There is a string to parse and a default time zone
                    // parse with the tz function which takes a default time zone if it is not in the format string
                    returnMoment = moment.tz(d, parseFormats, options.useStrict, options.timeZone);
                } else {
                    returnMoment = moment(d, parseFormats, options.useStrict);
                }

                if (hasTimeZone()) {
                    returnMoment.tz(options.timeZone);
                }

                return returnMoment;
            },

            isEnabled = function (granularity) {
                if (typeof granularity !== 'string' || granularity.length > 1) {
                    throw new TypeError('isEnabled expects a single character string parameter');
                }
                switch (granularity) {
                    case 'y':
                        return actualFormat.indexOf('Y') !== -1;
                    case 'M':
                        return actualFormat.indexOf('M') !== -1;
                    case 'd':
                        return actualFormat.toLowerCase().indexOf('d') !== -1;
                    case 'h':
                    case 'H':
                        return actualFormat.toLowerCase().indexOf('h') !== -1;
                    case 'm':
                        return actualFormat.indexOf('m') !== -1;
                    case 's':
                        return actualFormat.indexOf('s') !== -1;
                    default:
                        return false;
                }
            },

            hasTime = function () {
                return (isEnabled('h') || isEnabled('m') || isEnabled('s'));
            },

            hasDate = function () {
                return (isEnabled('y') || isEnabled('M') || isEnabled('d'));
            },

            getDatePickerTemplate = function () {
                var headTemplate = $('<thead>')
                        .append($('<tr>')
                            .append($('<th>').addClass('prev').attr('data-action', 'previous')
                                .append($('<span>').addClass(options.icons.previous))
                                )
                            .append($('<th>').addClass('picker-switch').attr('data-action', 'pickerSwitch').attr('colspan', (options.calendarWeeks ? '6' : '5')))
                            .append($('<th>').addClass('next').attr('data-action', 'next')
                                .append($('<span>').addClass(options.icons.next))
                                )
                            ),
                    contTemplate = $('<tbody>')
                        .append($('<tr>')
                            .append($('<td>').attr('colspan', (options.calendarWeeks ? '8' : '7')))
                            );

                return [
                    $('<div>').addClass('datepicker-days')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate)
                            .append($('<tbody>'))
                            ),
                    $('<div>').addClass('datepicker-months')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate.clone())
                            .append(contTemplate.clone())
                            ),
                    $('<div>').addClass('datepicker-years')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate.clone())
                            .append(contTemplate.clone())
                            ),
                    $('<div>').addClass('datepicker-decades')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate.clone())
                            .append(contTemplate.clone())
                            )
                ];
            },

            getTimePickerMainTemplate = function () {
                var topRow = $('<tr>'),
                    middleRow = $('<tr>'),
                    bottomRow = $('<tr>');

                if (isEnabled('h')) {
                    topRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementHour }).addClass('btn').attr('data-action', 'incrementHours').append($('<span>').addClass(options.icons.up))));
                    middleRow.append($('<td>')
                        .append($('<span>').addClass('timepicker-hour').attr({ 'data-time-component': 'hours', 'title': options.tooltips.pickHour }).attr('data-action', 'showHours')));
                    bottomRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementHour }).addClass('btn').attr('data-action', 'decrementHours').append($('<span>').addClass(options.icons.down))));
                }
                if (isEnabled('m')) {
                    if (isEnabled('h')) {
                        topRow.append($('<td>').addClass('separator'));
                        middleRow.append($('<td>').addClass('separator').html(':'));
                        bottomRow.append($('<td>').addClass('separator'));
                    }
                    topRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementMinute }).addClass('btn').attr('data-action', 'incrementMinutes')
                            .append($('<span>').addClass(options.icons.up))));
                    middleRow.append($('<td>')
                        .append($('<span>').addClass('timepicker-minute').attr({ 'data-time-component': 'minutes', 'title': options.tooltips.pickMinute }).attr('data-action', 'showMinutes')));
                    bottomRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementMinute }).addClass('btn').attr('data-action', 'decrementMinutes')
                            .append($('<span>').addClass(options.icons.down))));
                }
                if (isEnabled('s')) {
                    if (isEnabled('m')) {
                        topRow.append($('<td>').addClass('separator'));
                        middleRow.append($('<td>').addClass('separator').html(':'));
                        bottomRow.append($('<td>').addClass('separator'));
                    }
                    topRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementSecond }).addClass('btn').attr('data-action', 'incrementSeconds')
                            .append($('<span>').addClass(options.icons.up))));
                    middleRow.append($('<td>')
                        .append($('<span>').addClass('timepicker-second').attr({ 'data-time-component': 'seconds', 'title': options.tooltips.pickSecond }).attr('data-action', 'showSeconds')));
                    bottomRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementSecond }).addClass('btn').attr('data-action', 'decrementSeconds')
                            .append($('<span>').addClass(options.icons.down))));
                }

                if (!use24Hours) {
                    topRow.append($('<td>').addClass('separator'));
                    middleRow.append($('<td>')
                        .append($('<button>').addClass('btn btn-primary').attr({ 'data-action': 'togglePeriod', tabindex: '-1', 'title': options.tooltips.togglePeriod })));
                    bottomRow.append($('<td>').addClass('separator'));
                }

                return $('<div>').addClass('timepicker-picker')
                    .append($('<table>').addClass('table-condensed')
                        .append([topRow, middleRow, bottomRow]));
            },

            getTimePickerTemplate = function () {
                var hoursView = $('<div>').addClass('timepicker-hours')
                        .append($('<table>').addClass('table-condensed')),
                    minutesView = $('<div>').addClass('timepicker-minutes')
                        .append($('<table>').addClass('table-condensed')),
                    secondsView = $('<div>').addClass('timepicker-seconds')
                        .append($('<table>').addClass('table-condensed')),
                    ret = [getTimePickerMainTemplate()];

                if (isEnabled('h')) {
                    ret.push(hoursView);
                }
                if (isEnabled('m')) {
                    ret.push(minutesView);
                }
                if (isEnabled('s')) {
                    ret.push(secondsView);
                }

                return ret;
            },

            getToolbar = function () {
                var row = [];
                if (options.showTodayButton) {
                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'today', 'title': options.tooltips.today }).append($('<span>').addClass(options.icons.today))));
                }
                if (!options.sideBySide && hasDate() && hasTime()) {
                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'togglePicker', 'title': options.tooltips.selectTime }).append($('<span>').addClass(options.icons.time))));
                }
                if (options.showClear) {
                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'clear', 'title': options.tooltips.clear }).append($('<span>').addClass(options.icons.clear))));
                }
                if (options.showClose) {
                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'close', 'title': options.tooltips.close }).append($('<span>').addClass(options.icons.close))));
                }
                return $('<table>').addClass('table-condensed').append($('<tbody>').append($('<tr>').append(row)));
            },

            getTemplate = function () {
                var template = $('<div>').addClass('bootstrap-datetimepicker-widget dropdown-menu'),
                    dateView = $('<div>').addClass('datepicker').append(getDatePickerTemplate()),
                    timeView = $('<div>').addClass('timepicker').append(getTimePickerTemplate()),
                    content = $('<ul>').addClass('list-unstyled'),
                    toolbar = $('<li>').addClass('picker-switch' + (options.collapse ? ' accordion-toggle' : '')).append(getToolbar());

                if (options.inline) {
                    template.removeClass('dropdown-menu');
                }

                if (use24Hours) {
                    template.addClass('usetwentyfour');
                }

                if (isEnabled('s') && !use24Hours) {
                    template.addClass('wider');
                }

                if (options.sideBySide && hasDate() && hasTime()) {
                    template.addClass('timepicker-sbs');
                    if (options.toolbarPlacement === 'top') {
                        template.append(toolbar);
                    }
                    template.append(
                        $('<div>').addClass('row')
                            .append(dateView.addClass('col-md-6'))
                            .append(timeView.addClass('col-md-6'))
                    );
                    if (options.toolbarPlacement === 'bottom') {
                        template.append(toolbar);
                    }
                    return template;
                }

                if (options.toolbarPlacement === 'top') {
                    content.append(toolbar);
                }
                if (hasDate()) {
                    content.append($('<li>').addClass((options.collapse && hasTime() ? 'collapse in' : '')).append(dateView));
                }
                if (options.toolbarPlacement === 'default') {
                    content.append(toolbar);
                }
                if (hasTime()) {
                    content.append($('<li>').addClass((options.collapse && hasDate() ? 'collapse' : '')).append(timeView));
                }
                if (options.toolbarPlacement === 'bottom') {
                    content.append(toolbar);
                }
                return template.append(content);
            },

            dataToOptions = function () {
                var eData,
                    dataOptions = {};

                if (element.is('input') || options.inline) {
                    eData = element.data();
                } else {
                    eData = element.find('input').data();
                }

                if (eData.dateOptions && eData.dateOptions instanceof Object) {
                    dataOptions = $.extend(true, dataOptions, eData.dateOptions);
                }

                $.each(options, function (key) {
                    var attributeName = 'date' + key.charAt(0).toUpperCase() + key.slice(1);
                    if (eData[attributeName] !== undefined) {
                        dataOptions[key] = eData[attributeName];
                    }
                });
                return dataOptions;
            },

            place = function () {
                var position = (component || element).position(),
                    offset = (component || element).offset(),
                    vertical = options.widgetPositioning.vertical,
                    horizontal = options.widgetPositioning.horizontal,
                    parent;

                if (options.widgetParent) {
                    parent = options.widgetParent.append(widget);
                } else if (element.is('input')) {
                    parent = element.after(widget).parent();
                } else if (options.inline) {
                    parent = element.append(widget);
                    return;
                } else {
                    parent = element;
                    element.children().first().after(widget);
                }

                // Top and bottom logic
                if (vertical === 'auto') {
                    if (offset.top + widget.height() * 1.5 >= $(window).height() + $(window).scrollTop() &&
                        widget.height() + element.outerHeight() < offset.top) {
                        vertical = 'top';
                    } else {
                        vertical = 'bottom';
                    }
                }

                // Left and right logic
                if (horizontal === 'auto') {
                    if (parent.width() < offset.left + widget.outerWidth() / 2 &&
                        offset.left + widget.outerWidth() > $(window).width()) {
                        horizontal = 'right';
                    } else {
                        horizontal = 'left';
                    }
                }

                if (vertical === 'top') {
                    widget.addClass('top').removeClass('bottom');
                } else {
                    widget.addClass('bottom').removeClass('top');
                }

                if (horizontal === 'right') {
                    widget.addClass('pull-right');
                } else {
                    widget.removeClass('pull-right');
                }

                // find the first parent element that has a non-static css positioning
                if (parent.css('position') === 'static') {
                    parent = parent.parents().filter(function () {
                        return $(this).css('position') !== 'static';
                    }).first();
                }

                if (parent.length === 0) {
                    throw new Error('datetimepicker component should be placed within a non-static positioned container');
                }

                widget.css({
                    top: vertical === 'top' ? 'auto' : position.top + element.outerHeight(),
                    bottom: vertical === 'top' ? parent.outerHeight() - (parent === element ? 0 : position.top) : 'auto',
                    left: horizontal === 'left' ? (parent === element ? 0 : position.left) : 'auto',
                    right: horizontal === 'left' ? 'auto' : parent.outerWidth() - element.outerWidth() - (parent === element ? 0 : position.left)
                });
            },

            notifyEvent = function (e) {
                if (e.type === 'dp.change' && ((e.date && e.date.isSame(e.oldDate)) || (!e.date && !e.oldDate))) {
                    return;
                }
                element.trigger(e);
            },

            viewUpdate = function (e) {
                if (e === 'y') {
                    e = 'YYYY';
                }
                notifyEvent({
                    type: 'dp.update',
                    change: e,
                    viewDate: viewDate.clone()
                });
            },

            showMode = function (dir) {
                if (!widget) {
                    return;
                }
                if (dir) {
                    currentViewMode = Math.max(minViewModeNumber, Math.min(3, currentViewMode + dir));
                }
                widget.find('.datepicker > div').hide().filter('.datepicker-' + datePickerModes[currentViewMode].clsName).show();
            },

            fillDow = function () {
                var row = $('<tr>'),
                    currentDate = viewDate.clone().startOf('w').startOf('d');

                if (options.calendarWeeks === true) {
                    row.append($('<th>').addClass('cw').text('#'));
                }

                while (currentDate.isBefore(viewDate.clone().endOf('w'))) {
                    row.append($('<th>').addClass('dow').text(currentDate.format('dd')));
                    currentDate.add(1, 'd');
                }
                widget.find('.datepicker-days thead').append(row);
            },

            isInDisabledDates = function (testDate) {
                return options.disabledDates[testDate.format('YYYY-MM-DD')] === true;
            },

            isInEnabledDates = function (testDate) {
                return options.enabledDates[testDate.format('YYYY-MM-DD')] === true;
            },

            isInDisabledHours = function (testDate) {
                return options.disabledHours[testDate.format('H')] === true;
            },

            isInEnabledHours = function (testDate) {
                return options.enabledHours[testDate.format('H')] === true;
            },

            isValid = function (targetMoment, granularity) {
                if (!targetMoment.isValid()) {
                    return false;
                }
                if (options.disabledDates && granularity === 'd' && isInDisabledDates(targetMoment)) {
                    return false;
                }
                if (options.enabledDates && granularity === 'd' && !isInEnabledDates(targetMoment)) {
                    return false;
                }
                if (options.minDate && targetMoment.isBefore(options.minDate, granularity)) {
                    return false;
                }
                if (options.maxDate && targetMoment.isAfter(options.maxDate, granularity)) {
                    return false;
                }
                if (options.daysOfWeekDisabled && granularity === 'd' && options.daysOfWeekDisabled.indexOf(targetMoment.day()) !== -1) {
                    return false;
                }
                if (options.disabledHours && (granularity === 'h' || granularity === 'm' || granularity === 's') && isInDisabledHours(targetMoment)) {
                    return false;
                }
                if (options.enabledHours && (granularity === 'h' || granularity === 'm' || granularity === 's') && !isInEnabledHours(targetMoment)) {
                    return false;
                }
                if (options.disabledTimeIntervals && (granularity === 'h' || granularity === 'm' || granularity === 's')) {
                    var found = false;
                    $.each(options.disabledTimeIntervals, function () {
                        if (targetMoment.isBetween(this[0], this[1])) {
                            found = true;
                            return false;
                        }
                    });
                    if (found) {
                        return false;
                    }
                }
                return true;
            },

            fillMonths = function () {
                var spans = [],
                    monthsShort = viewDate.clone().startOf('y').startOf('d');
                while (monthsShort.isSame(viewDate, 'y')) {
                    spans.push($('<span>').attr('data-action', 'selectMonth').addClass('month').text(monthsShort.format('MMM')));
                    monthsShort.add(1, 'M');
                }
                widget.find('.datepicker-months td').empty().append(spans);
            },

            updateMonths = function () {
                var monthsView = widget.find('.datepicker-months'),
                    monthsViewHeader = monthsView.find('th'),
                    months = monthsView.find('tbody').find('span');

                monthsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevYear);
                monthsViewHeader.eq(1).attr('title', options.tooltips.selectYear);
                monthsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextYear);

                monthsView.find('.disabled').removeClass('disabled');

                if (!isValid(viewDate.clone().subtract(1, 'y'), 'y')) {
                    monthsViewHeader.eq(0).addClass('disabled');
                }

                monthsViewHeader.eq(1).text(viewDate.year());

                if (!isValid(viewDate.clone().add(1, 'y'), 'y')) {
                    monthsViewHeader.eq(2).addClass('disabled');
                }

                months.removeClass('active');
                if (date.isSame(viewDate, 'y') && !unset) {
                    months.eq(date.month()).addClass('active');
                }

                months.each(function (index) {
                    if (!isValid(viewDate.clone().month(index), 'M')) {
                        $(this).addClass('disabled');
                    }
                });
            },

            updateYears = function () {
                var yearsView = widget.find('.datepicker-years'),
                    yearsViewHeader = yearsView.find('th'),
                    startYear = viewDate.clone().subtract(5, 'y'),
                    endYear = viewDate.clone().add(6, 'y'),
                    html = '';

                yearsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevDecade);
                yearsViewHeader.eq(1).attr('title', options.tooltips.selectDecade);
                yearsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextDecade);

                yearsView.find('.disabled').removeClass('disabled');

                if (options.minDate && options.minDate.isAfter(startYear, 'y')) {
                    yearsViewHeader.eq(0).addClass('disabled');
                }

                yearsViewHeader.eq(1).text(startYear.year() + '-' + endYear.year());

                if (options.maxDate && options.maxDate.isBefore(endYear, 'y')) {
                    yearsViewHeader.eq(2).addClass('disabled');
                }

                while (!startYear.isAfter(endYear, 'y')) {
                    html += '<span data-action="selectYear" class="year' + (startYear.isSame(date, 'y') && !unset ? ' active' : '') + (!isValid(startYear, 'y') ? ' disabled' : '') + '">' + startYear.year() + '</span>';
                    startYear.add(1, 'y');
                }

                yearsView.find('td').html(html);
            },

            updateDecades = function () {
                var decadesView = widget.find('.datepicker-decades'),
                    decadesViewHeader = decadesView.find('th'),
                    startDecade = moment({ y: viewDate.year() - (viewDate.year() % 100) - 1 }),
                    endDecade = startDecade.clone().add(100, 'y'),
                    startedAt = startDecade.clone(),
                    minDateDecade = false,
                    maxDateDecade = false,
                    endDecadeYear,
                    html = '';

                decadesViewHeader.eq(0).find('span').attr('title', options.tooltips.prevCentury);
                decadesViewHeader.eq(2).find('span').attr('title', options.tooltips.nextCentury);

                decadesView.find('.disabled').removeClass('disabled');

                if (startDecade.isSame(moment({ y: 1900 })) || (options.minDate && options.minDate.isAfter(startDecade, 'y'))) {
                    decadesViewHeader.eq(0).addClass('disabled');
                }

                decadesViewHeader.eq(1).text(startDecade.year() + '-' + endDecade.year());

                if (startDecade.isSame(moment({ y: 2000 })) || (options.maxDate && options.maxDate.isBefore(endDecade, 'y'))) {
                    decadesViewHeader.eq(2).addClass('disabled');
                }

                while (!startDecade.isAfter(endDecade, 'y')) {
                    endDecadeYear = startDecade.year() + 12;
                    minDateDecade = options.minDate && options.minDate.isAfter(startDecade, 'y') && options.minDate.year() <= endDecadeYear;
                    maxDateDecade = options.maxDate && options.maxDate.isAfter(startDecade, 'y') && options.maxDate.year() <= endDecadeYear;
                    html += '<span data-action="selectDecade" class="decade' + (date.isAfter(startDecade) && date.year() <= endDecadeYear ? ' active' : '') +
                        (!isValid(startDecade, 'y') && !minDateDecade && !maxDateDecade ? ' disabled' : '') + '" data-selection="' + (startDecade.year() + 6) + '">' + (startDecade.year() + 1) + ' - ' + (startDecade.year() + 12) + '</span>';
                    startDecade.add(12, 'y');
                }
                html += '<span></span><span></span><span></span>'; //push the dangling block over, at least this way it's even

                decadesView.find('td').html(html);
                decadesViewHeader.eq(1).text((startedAt.year() + 1) + '-' + (startDecade.year()));
            },

            fillDate = function () {
                var daysView = widget.find('.datepicker-days'),
                    daysViewHeader = daysView.find('th'),
                    currentDate,
                    html = [],
                    row,
                    clsNames = [],
                    i;

                if (!hasDate()) {
                    return;
                }

                daysViewHeader.eq(0).find('span').attr('title', options.tooltips.prevMonth);
                daysViewHeader.eq(1).attr('title', options.tooltips.selectMonth);
                daysViewHeader.eq(2).find('span').attr('title', options.tooltips.nextMonth);

                daysView.find('.disabled').removeClass('disabled');
                daysViewHeader.eq(1).text(viewDate.format(options.dayViewHeaderFormat));

                if (!isValid(viewDate.clone().subtract(1, 'M'), 'M')) {
                    daysViewHeader.eq(0).addClass('disabled');
                }
                if (!isValid(viewDate.clone().add(1, 'M'), 'M')) {
                    daysViewHeader.eq(2).addClass('disabled');
                }

                currentDate = viewDate.clone().startOf('M').startOf('w').startOf('d');

                for (i = 0; i < 42; i++) { //always display 42 days (should show 6 weeks)
                    if (currentDate.weekday() === 0) {
                        row = $('<tr>');
                        if (options.calendarWeeks) {
                            row.append('<td class="cw">' + currentDate.week() + '</td>');
                        }
                        html.push(row);
                    }
                    clsNames = ['day'];
                    if (currentDate.isBefore(viewDate, 'M')) {
                        clsNames.push('old');
                    }
                    if (currentDate.isAfter(viewDate, 'M')) {
                        clsNames.push('new');
                    }
                    if (currentDate.isSame(date, 'd') && !unset) {
                        clsNames.push('active');
                    }
                    if (!isValid(currentDate, 'd')) {
                        clsNames.push('disabled');
                    }
                    if (currentDate.isSame(getMoment(), 'd')) {
                        clsNames.push('today');
                    }
                    if (currentDate.day() === 0 || currentDate.day() === 6) {
                        clsNames.push('weekend');
                    }
                    notifyEvent({
                        type: 'dp.classify',
                        date: currentDate,
                        classNames: clsNames
                    });
                    row.append('<td data-action="selectDay" data-day="' + currentDate.format('L') + '" class="' + clsNames.join(' ') + '">' + currentDate.date() + '</td>');
                    currentDate.add(1, 'd');
                }

                daysView.find('tbody').empty().append(html);

                updateMonths();

                updateYears();

                updateDecades();
            },

            fillHours = function () {
                var table = widget.find('.timepicker-hours table'),
                    currentHour = viewDate.clone().startOf('d'),
                    html = [],
                    row = $('<tr>');

                if (viewDate.hour() > 11 && !use24Hours) {
                    currentHour.hour(12);
                }
                while (currentHour.isSame(viewDate, 'd') && (use24Hours || (viewDate.hour() < 12 && currentHour.hour() < 12) || viewDate.hour() > 11)) {
                    if (currentHour.hour() % 4 === 0) {
                        row = $('<tr>');
                        html.push(row);
                    }
                    row.append('<td data-action="selectHour" class="hour' + (!isValid(currentHour, 'h') ? ' disabled' : '') + '">' + currentHour.format(use24Hours ? 'HH' : 'hh') + '</td>');
                    currentHour.add(1, 'h');
                }
                table.empty().append(html);
            },

            fillMinutes = function () {
                var table = widget.find('.timepicker-minutes table'),
                    currentMinute = viewDate.clone().startOf('h'),
                    html = [],
                    row = $('<tr>'),
                    step = options.stepping === 1 ? 5 : options.stepping;

                while (viewDate.isSame(currentMinute, 'h')) {
                    if (currentMinute.minute() % (step * 4) === 0) {
                        row = $('<tr>');
                        html.push(row);
                    }
                    row.append('<td data-action="selectMinute" class="minute' + (!isValid(currentMinute, 'm') ? ' disabled' : '') + '">' + currentMinute.format('mm') + '</td>');
                    currentMinute.add(step, 'm');
                }
                table.empty().append(html);
            },

            fillSeconds = function () {
                var table = widget.find('.timepicker-seconds table'),
                    currentSecond = viewDate.clone().startOf('m'),
                    html = [],
                    row = $('<tr>');

                while (viewDate.isSame(currentSecond, 'm')) {
                    if (currentSecond.second() % 20 === 0) {
                        row = $('<tr>');
                        html.push(row);
                    }
                    row.append('<td data-action="selectSecond" class="second' + (!isValid(currentSecond, 's') ? ' disabled' : '') + '">' + currentSecond.format('ss') + '</td>');
                    currentSecond.add(5, 's');
                }

                table.empty().append(html);
            },

            fillTime = function () {
                var toggle, newDate, timeComponents = widget.find('.timepicker span[data-time-component]');

                if (!use24Hours) {
                    toggle = widget.find('.timepicker [data-action=togglePeriod]');
                    newDate = date.clone().add((date.hours() >= 12) ? -12 : 12, 'h');

                    toggle.text(date.format('A'));

                    if (isValid(newDate, 'h')) {
                        toggle.removeClass('disabled');
                    } else {
                        toggle.addClass('disabled');
                    }
                }
                timeComponents.filter('[data-time-component=hours]').text(date.format(use24Hours ? 'HH' : 'hh'));
                timeComponents.filter('[data-time-component=minutes]').text(date.format('mm'));
                timeComponents.filter('[data-time-component=seconds]').text(date.format('ss'));

                fillHours();
                fillMinutes();
                fillSeconds();
            },

            update = function () {
                if (!widget) {
                    return;
                }
                fillDate();
                fillTime();
            },

            setValue = function (targetMoment) {
                var oldDate = unset ? null : date;

                // case of calling setValue(null or false)
                if (!targetMoment) {
                    unset = true;
                    input.val('');
                    element.data('date', '');
                    notifyEvent({
                        type: 'dp.change',
                        date: false,
                        oldDate: oldDate
                    });
                    update();
                    return;
                }

                targetMoment = targetMoment.clone().locale(options.locale);

                if (hasTimeZone()) {
                    targetMoment.tz(options.timeZone);
                }

                if (options.stepping !== 1) {
                    targetMoment.minutes((Math.round(targetMoment.minutes() / options.stepping) * options.stepping)).seconds(0);

                    while (options.minDate && targetMoment.isBefore(options.minDate)) {
                        targetMoment.add(options.stepping, 'minutes');
                    }
                }

                if (isValid(targetMoment)) {
                    date = targetMoment;
                    viewDate = date.clone();
                    input.val(date.format(actualFormat));
                    element.data('date', date.format(actualFormat));
                    unset = false;
                    update();
                    notifyEvent({
                        type: 'dp.change',
                        date: date.clone(),
                        oldDate: oldDate
                    });
                } else {
                    if (!options.keepInvalid) {
                        input.val(unset ? '' : date.format(actualFormat));
                    } else {
                        notifyEvent({
                            type: 'dp.change',
                            date: targetMoment,
                            oldDate: oldDate
                        });
                    }
                    notifyEvent({
                        type: 'dp.error',
                        date: targetMoment,
                        oldDate: oldDate
                    });
                }
            },

            /**
             * Hides the widget. Possibly will emit dp.hide
             */
            hide = function () {
                var transitioning = false;
                if (!widget) {
                    return picker;
                }
                // Ignore event if in the middle of a picker transition
                widget.find('.collapse').each(function () {
                    var collapseData = $(this).data('collapse');
                    if (collapseData && collapseData.transitioning) {
                        transitioning = true;
                        return false;
                    }
                    return true;
                });
                if (transitioning) {
                    return picker;
                }
                if (component && component.hasClass('btn')) {
                    component.toggleClass('active');
                }
                widget.hide();

                $(window).off('resize', place);
                widget.off('click', '[data-action]');
                widget.off('mousedown', false);

                widget.remove();
                widget = false;

                notifyEvent({
                    type: 'dp.hide',
                    date: date.clone()
                });

                input.blur();

                viewDate = date.clone();

                return picker;
            },

            clear = function () {
                setValue(null);
            },

            parseInputDate = function (inputDate) {
                if (options.parseInputDate === undefined) {
                    if (!moment.isMoment(inputDate) || inputDate instanceof Date) {
                        inputDate = getMoment(inputDate);
                    }
                } else {
                    inputDate = options.parseInputDate(inputDate);
                }
                //inputDate.locale(options.locale);
                return inputDate;
            },

            /********************************************************************************
             *
             * Widget UI interaction functions
             *
             ********************************************************************************/
            actions = {
                next: function () {
                    var navFnc = datePickerModes[currentViewMode].navFnc;
                    viewDate.add(datePickerModes[currentViewMode].navStep, navFnc);
                    fillDate();
                    viewUpdate(navFnc);
                },

                previous: function () {
                    var navFnc = datePickerModes[currentViewMode].navFnc;
                    viewDate.subtract(datePickerModes[currentViewMode].navStep, navFnc);
                    fillDate();
                    viewUpdate(navFnc);
                },

                pickerSwitch: function () {
                    showMode(1);
                },

                selectMonth: function (e) {
                    var month = $(e.target).closest('tbody').find('span').index($(e.target));
                    viewDate.month(month);
                    if (currentViewMode === minViewModeNumber) {
                        setValue(date.clone().year(viewDate.year()).month(viewDate.month()));
                        if (!options.inline) {
                            hide();
                        }
                    } else {
                        showMode(-1);
                        fillDate();
                    }
                    viewUpdate('M');
                },

                selectYear: function (e) {
                    var year = parseInt($(e.target).text(), 10) || 0;
                    viewDate.year(year);
                    if (currentViewMode === minViewModeNumber) {
                        setValue(date.clone().year(viewDate.year()));
                        if (!options.inline) {
                            hide();
                        }
                    } else {
                        showMode(-1);
                        fillDate();
                    }
                    viewUpdate('YYYY');
                },

                selectDecade: function (e) {
                    var year = parseInt($(e.target).data('selection'), 10) || 0;
                    viewDate.year(year);
                    if (currentViewMode === minViewModeNumber) {
                        setValue(date.clone().year(viewDate.year()));
                        if (!options.inline) {
                            hide();
                        }
                    } else {
                        showMode(-1);
                        fillDate();
                    }
                    viewUpdate('YYYY');
                },

                selectDay: function (e) {
                    var day = viewDate.clone();
                    if ($(e.target).is('.old')) {
                        day.subtract(1, 'M');
                    }
                    if ($(e.target).is('.new')) {
                        day.add(1, 'M');
                    }
                    setValue(day.date(parseInt($(e.target).text(), 10)));
                    if (!hasTime() && !options.keepOpen && !options.inline) {
                        hide();
                    }
                },

                incrementHours: function () {
                    var newDate = date.clone().add(1, 'h');
                    if (isValid(newDate, 'h')) {
                        setValue(newDate);
                    }
                },

                incrementMinutes: function () {
                    var newDate = date.clone().add(options.stepping, 'm');
                    if (isValid(newDate, 'm')) {
                        setValue(newDate);
                    }
                },

                incrementSeconds: function () {
                    var newDate = date.clone().add(1, 's');
                    if (isValid(newDate, 's')) {
                        setValue(newDate);
                    }
                },

                decrementHours: function () {
                    var newDate = date.clone().subtract(1, 'h');
                    if (isValid(newDate, 'h')) {
                        setValue(newDate);
                    }
                },

                decrementMinutes: function () {
                    var newDate = date.clone().subtract(options.stepping, 'm');
                    if (isValid(newDate, 'm')) {
                        setValue(newDate);
                    }
                },

                decrementSeconds: function () {
                    var newDate = date.clone().subtract(1, 's');
                    if (isValid(newDate, 's')) {
                        setValue(newDate);
                    }
                },

                togglePeriod: function () {
                    setValue(date.clone().add((date.hours() >= 12) ? -12 : 12, 'h'));
                },

                togglePicker: function (e) {
                    var $this = $(e.target),
                        $parent = $this.closest('ul'),
                        expanded = $parent.find('.in'),
                        closed = $parent.find('.collapse:not(.in)'),
                        collapseData;

                    if (expanded && expanded.length) {
                        collapseData = expanded.data('collapse');
                        if (collapseData && collapseData.transitioning) {
                            return;
                        }
                        if (expanded.collapse) { // if collapse plugin is available through bootstrap.js then use it
                            expanded.collapse('hide');
                            closed.collapse('show');
                        } else { // otherwise just toggle in class on the two views
                            expanded.removeClass('in');
                            closed.addClass('in');
                        }
                        if ($this.is('span')) {
                            $this.toggleClass(options.icons.time + ' ' + options.icons.date);
                        } else {
                            $this.find('span').toggleClass(options.icons.time + ' ' + options.icons.date);
                        }

                        // NOTE: uncomment if toggled state will be restored in show()
                        //if (component) {
                        //    component.find('span').toggleClass(options.icons.time + ' ' + options.icons.date);
                        //}
                    }
                },

                showPicker: function () {
                    widget.find('.timepicker > div:not(.timepicker-picker)').hide();
                    widget.find('.timepicker .timepicker-picker').show();
                },

                showHours: function () {
                    widget.find('.timepicker .timepicker-picker').hide();
                    widget.find('.timepicker .timepicker-hours').show();
                },

                showMinutes: function () {
                    widget.find('.timepicker .timepicker-picker').hide();
                    widget.find('.timepicker .timepicker-minutes').show();
                },

                showSeconds: function () {
                    widget.find('.timepicker .timepicker-picker').hide();
                    widget.find('.timepicker .timepicker-seconds').show();
                },

                selectHour: function (e) {
                    var hour = parseInt($(e.target).text(), 10);

                    if (!use24Hours) {
                        if (date.hours() >= 12) {
                            if (hour !== 12) {
                                hour += 12;
                            }
                        } else {
                            if (hour === 12) {
                                hour = 0;
                            }
                        }
                    }
                    setValue(date.clone().hours(hour));
                    actions.showPicker.call(picker);
                },

                selectMinute: function (e) {
                    setValue(date.clone().minutes(parseInt($(e.target).text(), 10)));
                    actions.showPicker.call(picker);
                },

                selectSecond: function (e) {
                    setValue(date.clone().seconds(parseInt($(e.target).text(), 10)));
                    actions.showPicker.call(picker);
                },

                clear: clear,

                today: function () {
                    var todaysDate = getMoment();
                    if (isValid(todaysDate, 'd')) {
                        setValue(todaysDate);
                    }
                },

                close: hide
            },

            doAction = function (e) {
                if ($(e.currentTarget).is('.disabled')) {
                    return false;
                }
                actions[$(e.currentTarget).data('action')].apply(picker, arguments);
                return false;
            },

            /**
             * Shows the widget. Possibly will emit dp.show and dp.change
             */
            show = function () {
                var currentMoment,
                    useCurrentGranularity = {
                        'year': function (m) {
                            return m.month(0).date(1).hours(0).seconds(0).minutes(0);
                        },
                        'month': function (m) {
                            return m.date(1).hours(0).seconds(0).minutes(0);
                        },
                        'day': function (m) {
                            return m.hours(0).seconds(0).minutes(0);
                        },
                        'hour': function (m) {
                            return m.seconds(0).minutes(0);
                        },
                        'minute': function (m) {
                            return m.seconds(0);
                        }
                    };

                if (input.prop('disabled') || (!options.ignoreReadonly && input.prop('readonly')) || widget) {
                    return picker;
                }
                if (input.val() !== undefined && input.val().trim().length !== 0) {
                    setValue(parseInputDate(input.val().trim()));
                } else if (unset && options.useCurrent && (options.inline || (input.is('input') && input.val().trim().length === 0))) {
                    currentMoment = getMoment();
                    if (typeof options.useCurrent === 'string') {
                        currentMoment = useCurrentGranularity[options.useCurrent](currentMoment);
                    }
                    setValue(currentMoment);
                }
                widget = getTemplate();

                fillDow();
                fillMonths();

                widget.find('.timepicker-hours').hide();
                widget.find('.timepicker-minutes').hide();
                widget.find('.timepicker-seconds').hide();

                update();
                showMode();

                $(window).on('resize', place);
                widget.on('click', '[data-action]', doAction); // this handles clicks on the widget
                widget.on('mousedown', false);

                if (component && component.hasClass('btn')) {
                    component.toggleClass('active');
                }
                place();
                widget.show();
                if (options.focusOnShow && !input.is(':focus')) {
                    input.focus();
                }

                notifyEvent({
                    type: 'dp.show'
                });
                return picker;
            },

            /**
             * Shows or hides the widget
             */
            toggle = function () {
                return (widget ? hide() : show());
            },

            keydown = function (e) {
                var handler = null,
                    index,
                    index2,
                    pressedKeys = [],
                    pressedModifiers = {},
                    currentKey = e.which,
                    keyBindKeys,
                    allModifiersPressed,
                    pressed = 'p';

                keyState[currentKey] = pressed;

                for (index in keyState) {
                    if (keyState.hasOwnProperty(index) && keyState[index] === pressed) {
                        pressedKeys.push(index);
                        if (parseInt(index, 10) !== currentKey) {
                            pressedModifiers[index] = true;
                        }
                    }
                }

                for (index in options.keyBinds) {
                    if (options.keyBinds.hasOwnProperty(index) && typeof (options.keyBinds[index]) === 'function') {
                        keyBindKeys = index.split(' ');
                        if (keyBindKeys.length === pressedKeys.length && keyMap[currentKey] === keyBindKeys[keyBindKeys.length - 1]) {
                            allModifiersPressed = true;
                            for (index2 = keyBindKeys.length - 2; index2 >= 0; index2--) {
                                if (!(keyMap[keyBindKeys[index2]] in pressedModifiers)) {
                                    allModifiersPressed = false;
                                    break;
                                }
                            }
                            if (allModifiersPressed) {
                                handler = options.keyBinds[index];
                                break;
                            }
                        }
                    }
                }

                if (handler) {
                    handler.call(picker, widget);
                    e.stopPropagation();
                    e.preventDefault();
                }
            },

            keyup = function (e) {
                keyState[e.which] = 'r';
                e.stopPropagation();
                e.preventDefault();
            },

            change = function (e) {
                var val = $(e.target).val().trim(),
                    parsedDate = val ? parseInputDate(val) : null;
                setValue(parsedDate);
                e.stopImmediatePropagation();
                return false;
            },

            attachDatePickerElementEvents = function () {
                input.on({
                    'change': change,
                    'blur': options.debug ? '' : hide,
                    'keydown': keydown,
                    'keyup': keyup,
                    'focus': options.allowInputToggle ? show : ''
                });

                if (element.is('input')) {
                    input.on({
                        'focus': show
                    });
                } else if (component) {
                    component.on('click', toggle);
                    component.on('mousedown', false);
                }
            },

            detachDatePickerElementEvents = function () {
                input.off({
                    'change': change,
                    'blur': blur,
                    'keydown': keydown,
                    'keyup': keyup,
                    'focus': options.allowInputToggle ? hide : ''
                });

                if (element.is('input')) {
                    input.off({
                        'focus': show
                    });
                } else if (component) {
                    component.off('click', toggle);
                    component.off('mousedown', false);
                }
            },

            indexGivenDates = function (givenDatesArray) {
                // Store given enabledDates and disabledDates as keys.
                // This way we can check their existence in O(1) time instead of looping through whole array.
                // (for example: options.enabledDates['2014-02-27'] === true)
                var givenDatesIndexed = {};
                $.each(givenDatesArray, function () {
                    var dDate = parseInputDate(this);
                    if (dDate.isValid()) {
                        givenDatesIndexed[dDate.format('YYYY-MM-DD')] = true;
                    }
                });
                return (Object.keys(givenDatesIndexed).length) ? givenDatesIndexed : false;
            },

            indexGivenHours = function (givenHoursArray) {
                // Store given enabledHours and disabledHours as keys.
                // This way we can check their existence in O(1) time instead of looping through whole array.
                // (for example: options.enabledHours['2014-02-27'] === true)
                var givenHoursIndexed = {};
                $.each(givenHoursArray, function () {
                    givenHoursIndexed[this] = true;
                });
                return (Object.keys(givenHoursIndexed).length) ? givenHoursIndexed : false;
            },

            initFormatting = function () {
                var format = options.format || 'L LT';

                actualFormat = format.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (formatInput) {
                    var newinput = date.localeData().longDateFormat(formatInput) || formatInput;
                    return newinput.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (formatInput2) { //temp fix for #740
                        return date.localeData().longDateFormat(formatInput2) || formatInput2;
                    });
                });


                parseFormats = options.extraFormats ? options.extraFormats.slice() : [];
                if (parseFormats.indexOf(format) < 0 && parseFormats.indexOf(actualFormat) < 0) {
                    parseFormats.push(actualFormat);
                }

                use24Hours = (actualFormat.toLowerCase().indexOf('a') < 1 && actualFormat.replace(/\[.*?\]/g, '').indexOf('h') < 1);

                if (isEnabled('y')) {
                    minViewModeNumber = 2;
                }
                if (isEnabled('M')) {
                    minViewModeNumber = 1;
                }
                if (isEnabled('d')) {
                    minViewModeNumber = 0;
                }

                currentViewMode = Math.max(minViewModeNumber, currentViewMode);

                if (!unset) {
                    setValue(date);
                }
            };

        /********************************************************************************
         *
         * Public API functions
         * =====================
         *
         * Important: Do not expose direct references to private objects or the options
         * object to the outer world. Always return a clone when returning values or make
         * a clone when setting a private variable.
         *
         ********************************************************************************/
        picker.destroy = function () {
            ///<summary>Destroys the widget and removes all attached event listeners</summary>
            hide();
            detachDatePickerElementEvents();
            element.removeData('DateTimePicker');
            element.removeData('date');
        };

        picker.toggle = toggle;

        picker.show = show;

        picker.hide = hide;

        picker.disable = function () {
            ///<summary>Disables the input element, the component is attached to, by adding a disabled="true" attribute to it.
            ///If the widget was visible before that call it is hidden. Possibly emits dp.hide</summary>
            hide();
            if (component && component.hasClass('btn')) {
                component.addClass('disabled');
            }
            input.prop('disabled', true);
            return picker;
        };

        picker.enable = function () {
            ///<summary>Enables the input element, the component is attached to, by removing disabled attribute from it.</summary>
            if (component && component.hasClass('btn')) {
                component.removeClass('disabled');
            }
            input.prop('disabled', false);
            return picker;
        };

        picker.ignoreReadonly = function (ignoreReadonly) {
            if (arguments.length === 0) {
                return options.ignoreReadonly;
            }
            if (typeof ignoreReadonly !== 'boolean') {
                throw new TypeError('ignoreReadonly () expects a boolean parameter');
            }
            options.ignoreReadonly = ignoreReadonly;
            return picker;
        };

        picker.options = function (newOptions) {
            if (arguments.length === 0) {
                return $.extend(true, {}, options);
            }

            if (!(newOptions instanceof Object)) {
                throw new TypeError('options() options parameter should be an object');
            }
            $.extend(true, options, newOptions);
            $.each(options, function (key, value) {
                if (picker[key] !== undefined) {
                    picker[key](value);
                } else {
                    throw new TypeError('option ' + key + ' is not recognized!');
                }
            });
            return picker;
        };

        picker.date = function (newDate) {
            ///<signature helpKeyword="$.fn.datetimepicker.date">
            ///<summary>Returns the component's model current date, a moment object or null if not set.</summary>
            ///<returns type="Moment">date.clone()</returns>
            ///</signature>
            ///<signature>
            ///<summary>Sets the components model current moment to it. Passing a null value unsets the components model current moment. Parsing of the newDate parameter is made using moment library with the options.format and options.useStrict components configuration.</summary>
            ///<param name="newDate" locid="$.fn.datetimepicker.date_p:newDate">Takes string, Date, moment, null parameter.</param>
            ///</signature>
            if (arguments.length === 0) {
                if (unset) {
                    return null;
                }
                return date.clone();
            }

            if (newDate !== null && typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
                throw new TypeError('date() parameter must be one of [null, string, moment or Date]');
            }

            setValue(newDate === null ? null : parseInputDate(newDate));
            return picker;
        };

        picker.format = function (newFormat) {
            ///<summary>test su</summary>
            ///<param name="newFormat">info about para</param>
            ///<returns type="string|boolean">returns foo</returns>
            if (arguments.length === 0) {
                return options.format;
            }

            if ((typeof newFormat !== 'string') && ((typeof newFormat !== 'boolean') || (newFormat !== false))) {
                throw new TypeError('format() expects a string or boolean:false parameter ' + newFormat);
            }

            options.format = newFormat;
            if (actualFormat) {
                initFormatting(); // reinit formatting
            }
            return picker;
        };

        picker.timeZone = function (newZone) {
            if (arguments.length === 0) {
                return options.timeZone;
            }

            if (typeof newZone !== 'string') {
                throw new TypeError('newZone() expects a string parameter');
            }

            options.timeZone = newZone;

            return picker;
        };

        picker.dayViewHeaderFormat = function (newFormat) {
            if (arguments.length === 0) {
                return options.dayViewHeaderFormat;
            }

            if (typeof newFormat !== 'string') {
                throw new TypeError('dayViewHeaderFormat() expects a string parameter');
            }

            options.dayViewHeaderFormat = newFormat;
            return picker;
        };

        picker.extraFormats = function (formats) {
            if (arguments.length === 0) {
                return options.extraFormats;
            }

            if (formats !== false && !(formats instanceof Array)) {
                throw new TypeError('extraFormats() expects an array or false parameter');
            }

            options.extraFormats = formats;
            if (parseFormats) {
                initFormatting(); // reinit formatting
            }
            return picker;
        };

        picker.disabledDates = function (dates) {
            ///<signature helpKeyword="$.fn.datetimepicker.disabledDates">
            ///<summary>Returns an array with the currently set disabled dates on the component.</summary>
            ///<returns type="array">options.disabledDates</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
            ///options.enabledDates if such exist.</summary>
            ///<param name="dates" locid="$.fn.datetimepicker.disabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.disabledDates ? $.extend({}, options.disabledDates) : options.disabledDates);
            }

            if (!dates) {
                options.disabledDates = false;
                update();
                return picker;
            }
            if (!(dates instanceof Array)) {
                throw new TypeError('disabledDates() expects an array parameter');
            }
            options.disabledDates = indexGivenDates(dates);
            options.enabledDates = false;
            update();
            return picker;
        };

        picker.enabledDates = function (dates) {
            ///<signature helpKeyword="$.fn.datetimepicker.enabledDates">
            ///<summary>Returns an array with the currently set enabled dates on the component.</summary>
            ///<returns type="array">options.enabledDates</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of options.disabledDates if such exist.</summary>
            ///<param name="dates" locid="$.fn.datetimepicker.enabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.enabledDates ? $.extend({}, options.enabledDates) : options.enabledDates);
            }

            if (!dates) {
                options.enabledDates = false;
                update();
                return picker;
            }
            if (!(dates instanceof Array)) {
                throw new TypeError('enabledDates() expects an array parameter');
            }
            options.enabledDates = indexGivenDates(dates);
            options.disabledDates = false;
            update();
            return picker;
        };

        picker.daysOfWeekDisabled = function (daysOfWeekDisabled) {
            if (arguments.length === 0) {
                return options.daysOfWeekDisabled.splice(0);
            }

            if ((typeof daysOfWeekDisabled === 'boolean') && !daysOfWeekDisabled) {
                options.daysOfWeekDisabled = false;
                update();
                return picker;
            }

            if (!(daysOfWeekDisabled instanceof Array)) {
                throw new TypeError('daysOfWeekDisabled() expects an array parameter');
            }
            options.daysOfWeekDisabled = daysOfWeekDisabled.reduce(function (previousValue, currentValue) {
                currentValue = parseInt(currentValue, 10);
                if (currentValue > 6 || currentValue < 0 || isNaN(currentValue)) {
                    return previousValue;
                }
                if (previousValue.indexOf(currentValue) === -1) {
                    previousValue.push(currentValue);
                }
                return previousValue;
            }, []).sort();
            if (options.useCurrent && !options.keepInvalid) {
                var tries = 0;
                while (!isValid(date, 'd')) {
                    date.add(1, 'd');
                    if (tries === 31) {
                        throw 'Tried 31 times to find a valid date';
                    }
                    tries++;
                }
                setValue(date);
            }
            update();
            return picker;
        };

        picker.maxDate = function (maxDate) {
            if (arguments.length === 0) {
                return options.maxDate ? options.maxDate.clone() : options.maxDate;
            }

            if ((typeof maxDate === 'boolean') && maxDate === false) {
                options.maxDate = false;
                update();
                return picker;
            }

            if (typeof maxDate === 'string') {
                if (maxDate === 'now' || maxDate === 'moment') {
                    maxDate = getMoment();
                }
            }

            var parsedDate = parseInputDate(maxDate);

            if (!parsedDate.isValid()) {
                throw new TypeError('maxDate() Could not parse date parameter: ' + maxDate);
            }
            if (options.minDate && parsedDate.isBefore(options.minDate)) {
                throw new TypeError('maxDate() date parameter is before options.minDate: ' + parsedDate.format(actualFormat));
            }
            options.maxDate = parsedDate;
            if (options.useCurrent && !options.keepInvalid && date.isAfter(maxDate)) {
                setValue(options.maxDate);
            }
            if (viewDate.isAfter(parsedDate)) {
                viewDate = parsedDate.clone().subtract(options.stepping, 'm');
            }
            update();
            return picker;
        };

        picker.minDate = function (minDate) {
            if (arguments.length === 0) {
                return options.minDate ? options.minDate.clone() : options.minDate;
            }

            if ((typeof minDate === 'boolean') && minDate === false) {
                options.minDate = false;
                update();
                return picker;
            }

            if (typeof minDate === 'string') {
                if (minDate === 'now' || minDate === 'moment') {
                    minDate = getMoment();
                }
            }

            var parsedDate = parseInputDate(minDate);

            if (!parsedDate.isValid()) {
                throw new TypeError('minDate() Could not parse date parameter: ' + minDate);
            }
            if (options.maxDate && parsedDate.isAfter(options.maxDate)) {
                throw new TypeError('minDate() date parameter is after options.maxDate: ' + parsedDate.format(actualFormat));
            }
            options.minDate = parsedDate;
            if (options.useCurrent && !options.keepInvalid && date.isBefore(minDate)) {
                setValue(options.minDate);
            }
            if (viewDate.isBefore(parsedDate)) {
                viewDate = parsedDate.clone().add(options.stepping, 'm');
            }
            update();
            return picker;
        };

        picker.defaultDate = function (defaultDate) {
            ///<signature helpKeyword="$.fn.datetimepicker.defaultDate">
            ///<summary>Returns a moment with the options.defaultDate option configuration or false if not set</summary>
            ///<returns type="Moment">date.clone()</returns>
            ///</signature>
            ///<signature>
            ///<summary>Will set the picker's inital date. If a boolean:false value is passed the options.defaultDate parameter is cleared.</summary>
            ///<param name="defaultDate" locid="$.fn.datetimepicker.defaultDate_p:defaultDate">Takes a string, Date, moment, boolean:false</param>
            ///</signature>
            if (arguments.length === 0) {
                return options.defaultDate ? options.defaultDate.clone() : options.defaultDate;
            }
            if (!defaultDate) {
                options.defaultDate = false;
                return picker;
            }

            if (typeof defaultDate === 'string') {
                if (defaultDate === 'now' || defaultDate === 'moment') {
                    defaultDate = getMoment();
                } else {
                    defaultDate = getMoment(defaultDate);
                }
            }

            var parsedDate = parseInputDate(defaultDate);
            if (!parsedDate.isValid()) {
                throw new TypeError('defaultDate() Could not parse date parameter: ' + defaultDate);
            }
            if (!isValid(parsedDate)) {
                throw new TypeError('defaultDate() date passed is invalid according to component setup validations');
            }

            options.defaultDate = parsedDate;

            if ((options.defaultDate && options.inline) || input.val().trim() === '') {
                setValue(options.defaultDate);
            }
            return picker;
        };

        picker.locale = function (locale) {
            if (arguments.length === 0) {
                return options.locale;
            }

            if (!moment.localeData(locale)) {
                throw new TypeError('locale() locale ' + locale + ' is not loaded from moment locales!');
            }

            options.locale = locale;
            date.locale(options.locale);
            viewDate.locale(options.locale);

            if (actualFormat) {
                initFormatting(); // reinit formatting
            }
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.stepping = function (stepping) {
            if (arguments.length === 0) {
                return options.stepping;
            }

            stepping = parseInt(stepping, 10);
            if (isNaN(stepping) || stepping < 1) {
                stepping = 1;
            }
            options.stepping = stepping;
            return picker;
        };

        picker.useCurrent = function (useCurrent) {
            var useCurrentOptions = ['year', 'month', 'day', 'hour', 'minute'];
            if (arguments.length === 0) {
                return options.useCurrent;
            }

            if ((typeof useCurrent !== 'boolean') && (typeof useCurrent !== 'string')) {
                throw new TypeError('useCurrent() expects a boolean or string parameter');
            }
            if (typeof useCurrent === 'string' && useCurrentOptions.indexOf(useCurrent.toLowerCase()) === -1) {
                throw new TypeError('useCurrent() expects a string parameter of ' + useCurrentOptions.join(', '));
            }
            options.useCurrent = useCurrent;
            return picker;
        };

        picker.collapse = function (collapse) {
            if (arguments.length === 0) {
                return options.collapse;
            }

            if (typeof collapse !== 'boolean') {
                throw new TypeError('collapse() expects a boolean parameter');
            }
            if (options.collapse === collapse) {
                return picker;
            }
            options.collapse = collapse;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.icons = function (icons) {
            if (arguments.length === 0) {
                return $.extend({}, options.icons);
            }

            if (!(icons instanceof Object)) {
                throw new TypeError('icons() expects parameter to be an Object');
            }
            $.extend(options.icons, icons);
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.tooltips = function (tooltips) {
            if (arguments.length === 0) {
                return $.extend({}, options.tooltips);
            }

            if (!(tooltips instanceof Object)) {
                throw new TypeError('tooltips() expects parameter to be an Object');
            }
            $.extend(options.tooltips, tooltips);
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.useStrict = function (useStrict) {
            if (arguments.length === 0) {
                return options.useStrict;
            }

            if (typeof useStrict !== 'boolean') {
                throw new TypeError('useStrict() expects a boolean parameter');
            }
            options.useStrict = useStrict;
            return picker;
        };

        picker.sideBySide = function (sideBySide) {
            if (arguments.length === 0) {
                return options.sideBySide;
            }

            if (typeof sideBySide !== 'boolean') {
                throw new TypeError('sideBySide() expects a boolean parameter');
            }
            options.sideBySide = sideBySide;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.viewMode = function (viewMode) {
            if (arguments.length === 0) {
                return options.viewMode;
            }

            if (typeof viewMode !== 'string') {
                throw new TypeError('viewMode() expects a string parameter');
            }

            if (viewModes.indexOf(viewMode) === -1) {
                throw new TypeError('viewMode() parameter must be one of (' + viewModes.join(', ') + ') value');
            }

            options.viewMode = viewMode;
            currentViewMode = Math.max(viewModes.indexOf(viewMode), minViewModeNumber);

            showMode();
            return picker;
        };

        picker.toolbarPlacement = function (toolbarPlacement) {
            if (arguments.length === 0) {
                return options.toolbarPlacement;
            }

            if (typeof toolbarPlacement !== 'string') {
                throw new TypeError('toolbarPlacement() expects a string parameter');
            }
            if (toolbarPlacements.indexOf(toolbarPlacement) === -1) {
                throw new TypeError('toolbarPlacement() parameter must be one of (' + toolbarPlacements.join(', ') + ') value');
            }
            options.toolbarPlacement = toolbarPlacement;

            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.widgetPositioning = function (widgetPositioning) {
            if (arguments.length === 0) {
                return $.extend({}, options.widgetPositioning);
            }

            if (({}).toString.call(widgetPositioning) !== '[object Object]') {
                throw new TypeError('widgetPositioning() expects an object variable');
            }
            if (widgetPositioning.horizontal) {
                if (typeof widgetPositioning.horizontal !== 'string') {
                    throw new TypeError('widgetPositioning() horizontal variable must be a string');
                }
                widgetPositioning.horizontal = widgetPositioning.horizontal.toLowerCase();
                if (horizontalModes.indexOf(widgetPositioning.horizontal) === -1) {
                    throw new TypeError('widgetPositioning() expects horizontal parameter to be one of (' + horizontalModes.join(', ') + ')');
                }
                options.widgetPositioning.horizontal = widgetPositioning.horizontal;
            }
            if (widgetPositioning.vertical) {
                if (typeof widgetPositioning.vertical !== 'string') {
                    throw new TypeError('widgetPositioning() vertical variable must be a string');
                }
                widgetPositioning.vertical = widgetPositioning.vertical.toLowerCase();
                if (verticalModes.indexOf(widgetPositioning.vertical) === -1) {
                    throw new TypeError('widgetPositioning() expects vertical parameter to be one of (' + verticalModes.join(', ') + ')');
                }
                options.widgetPositioning.vertical = widgetPositioning.vertical;
            }
            update();
            return picker;
        };

        picker.calendarWeeks = function (calendarWeeks) {
            if (arguments.length === 0) {
                return options.calendarWeeks;
            }

            if (typeof calendarWeeks !== 'boolean') {
                throw new TypeError('calendarWeeks() expects parameter to be a boolean value');
            }

            options.calendarWeeks = calendarWeeks;
            update();
            return picker;
        };

        picker.showTodayButton = function (showTodayButton) {
            if (arguments.length === 0) {
                return options.showTodayButton;
            }

            if (typeof showTodayButton !== 'boolean') {
                throw new TypeError('showTodayButton() expects a boolean parameter');
            }

            options.showTodayButton = showTodayButton;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.showClear = function (showClear) {
            if (arguments.length === 0) {
                return options.showClear;
            }

            if (typeof showClear !== 'boolean') {
                throw new TypeError('showClear() expects a boolean parameter');
            }

            options.showClear = showClear;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.widgetParent = function (widgetParent) {
            if (arguments.length === 0) {
                return options.widgetParent;
            }

            if (typeof widgetParent === 'string') {
                widgetParent = $(widgetParent);
            }

            if (widgetParent !== null && (typeof widgetParent !== 'string' && !(widgetParent instanceof $))) {
                throw new TypeError('widgetParent() expects a string or a jQuery object parameter');
            }

            options.widgetParent = widgetParent;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.keepOpen = function (keepOpen) {
            if (arguments.length === 0) {
                return options.keepOpen;
            }

            if (typeof keepOpen !== 'boolean') {
                throw new TypeError('keepOpen() expects a boolean parameter');
            }

            options.keepOpen = keepOpen;
            return picker;
        };

        picker.focusOnShow = function (focusOnShow) {
            if (arguments.length === 0) {
                return options.focusOnShow;
            }

            if (typeof focusOnShow !== 'boolean') {
                throw new TypeError('focusOnShow() expects a boolean parameter');
            }

            options.focusOnShow = focusOnShow;
            return picker;
        };

        picker.inline = function (inline) {
            if (arguments.length === 0) {
                return options.inline;
            }

            if (typeof inline !== 'boolean') {
                throw new TypeError('inline() expects a boolean parameter');
            }

            options.inline = inline;
            return picker;
        };

        picker.clear = function () {
            clear();
            return picker;
        };

        picker.keyBinds = function (keyBinds) {
            if (arguments.length === 0) {
                return options.keyBinds;
            }

            options.keyBinds = keyBinds;
            return picker;
        };

        picker.getMoment = function (d) {
            return getMoment(d);
        };

        picker.debug = function (debug) {
            if (typeof debug !== 'boolean') {
                throw new TypeError('debug() expects a boolean parameter');
            }

            options.debug = debug;
            return picker;
        };

        picker.allowInputToggle = function (allowInputToggle) {
            if (arguments.length === 0) {
                return options.allowInputToggle;
            }

            if (typeof allowInputToggle !== 'boolean') {
                throw new TypeError('allowInputToggle() expects a boolean parameter');
            }

            options.allowInputToggle = allowInputToggle;
            return picker;
        };

        picker.showClose = function (showClose) {
            if (arguments.length === 0) {
                return options.showClose;
            }

            if (typeof showClose !== 'boolean') {
                throw new TypeError('showClose() expects a boolean parameter');
            }

            options.showClose = showClose;
            return picker;
        };

        picker.keepInvalid = function (keepInvalid) {
            if (arguments.length === 0) {
                return options.keepInvalid;
            }

            if (typeof keepInvalid !== 'boolean') {
                throw new TypeError('keepInvalid() expects a boolean parameter');
            }
            options.keepInvalid = keepInvalid;
            return picker;
        };

        picker.datepickerInput = function (datepickerInput) {
            if (arguments.length === 0) {
                return options.datepickerInput;
            }

            if (typeof datepickerInput !== 'string') {
                throw new TypeError('datepickerInput() expects a string parameter');
            }

            options.datepickerInput = datepickerInput;
            return picker;
        };

        picker.parseInputDate = function (parseInputDate) {
            if (arguments.length === 0) {
                return options.parseInputDate;
            }

            if (typeof parseInputDate !== 'function') {
                throw new TypeError('parseInputDate() sholud be as function');
            }

            options.parseInputDate = parseInputDate;

            return picker;
        };

        picker.disabledTimeIntervals = function (disabledTimeIntervals) {
            ///<signature helpKeyword="$.fn.datetimepicker.disabledTimeIntervals">
            ///<summary>Returns an array with the currently set disabled dates on the component.</summary>
            ///<returns type="array">options.disabledTimeIntervals</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
            ///options.enabledDates if such exist.</summary>
            ///<param name="dates" locid="$.fn.datetimepicker.disabledTimeIntervals_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.disabledTimeIntervals ? $.extend({}, options.disabledTimeIntervals) : options.disabledTimeIntervals);
            }

            if (!disabledTimeIntervals) {
                options.disabledTimeIntervals = false;
                update();
                return picker;
            }
            if (!(disabledTimeIntervals instanceof Array)) {
                throw new TypeError('disabledTimeIntervals() expects an array parameter');
            }
            options.disabledTimeIntervals = disabledTimeIntervals;
            update();
            return picker;
        };

        picker.disabledHours = function (hours) {
            ///<signature helpKeyword="$.fn.datetimepicker.disabledHours">
            ///<summary>Returns an array with the currently set disabled hours on the component.</summary>
            ///<returns type="array">options.disabledHours</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
            ///options.enabledHours if such exist.</summary>
            ///<param name="hours" locid="$.fn.datetimepicker.disabledHours_p:hours">Takes an [ int ] of values and disallows the user to select only from those hours.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.disabledHours ? $.extend({}, options.disabledHours) : options.disabledHours);
            }

            if (!hours) {
                options.disabledHours = false;
                update();
                return picker;
            }
            if (!(hours instanceof Array)) {
                throw new TypeError('disabledHours() expects an array parameter');
            }
            options.disabledHours = indexGivenHours(hours);
            options.enabledHours = false;
            if (options.useCurrent && !options.keepInvalid) {
                var tries = 0;
                while (!isValid(date, 'h')) {
                    date.add(1, 'h');
                    if (tries === 24) {
                        throw 'Tried 24 times to find a valid date';
                    }
                    tries++;
                }
                setValue(date);
            }
            update();
            return picker;
        };

        picker.enabledHours = function (hours) {
            ///<signature helpKeyword="$.fn.datetimepicker.enabledHours">
            ///<summary>Returns an array with the currently set enabled hours on the component.</summary>
            ///<returns type="array">options.enabledHours</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of options.disabledHours if such exist.</summary>
            ///<param name="hours" locid="$.fn.datetimepicker.enabledHours_p:hours">Takes an [ int ] of values and allows the user to select only from those hours.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.enabledHours ? $.extend({}, options.enabledHours) : options.enabledHours);
            }

            if (!hours) {
                options.enabledHours = false;
                update();
                return picker;
            }
            if (!(hours instanceof Array)) {
                throw new TypeError('enabledHours() expects an array parameter');
            }
            options.enabledHours = indexGivenHours(hours);
            options.disabledHours = false;
            if (options.useCurrent && !options.keepInvalid) {
                var tries = 0;
                while (!isValid(date, 'h')) {
                    date.add(1, 'h');
                    if (tries === 24) {
                        throw 'Tried 24 times to find a valid date';
                    }
                    tries++;
                }
                setValue(date);
            }
            update();
            return picker;
        };
        /**
         * Returns the component's model current viewDate, a moment object or null if not set. Passing a null value unsets the components model current moment. Parsing of the newDate parameter is made using moment library with the options.format and options.useStrict components configuration.
         * @param {Takes string, viewDate, moment, null parameter.} newDate
         * @returns {viewDate.clone()}
         */
        picker.viewDate = function (newDate) {
            if (arguments.length === 0) {
                return viewDate.clone();
            }

            if (!newDate) {
                viewDate = date.clone();
                return picker;
            }

            if (typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
                throw new TypeError('viewDate() parameter must be one of [string, moment or Date]');
            }

            viewDate = parseInputDate(newDate);
            viewUpdate();
            return picker;
        };

        // initializing element and component attributes
        if (element.is('input')) {
            input = element;
        } else {
            input = element.find(options.datepickerInput);
            if (input.length === 0) {
                input = element.find('input');
            } else if (!input.is('input')) {
                throw new Error('CSS class "' + options.datepickerInput + '" cannot be applied to non input element');
            }
        }

        if (element.hasClass('input-group')) {
            // in case there is more then one 'input-group-addon' Issue #48
            if (element.find('.datepickerbutton').length === 0) {
                component = element.find('.input-group-addon');
            } else {
                component = element.find('.datepickerbutton');
            }
        }

        if (!options.inline && !input.is('input')) {
            throw new Error('Could not initialize DateTimePicker without an input element');
        }

        // Set defaults for date here now instead of in var declaration
        date = getMoment();
        viewDate = date.clone();

        $.extend(true, options, dataToOptions());

        picker.options(options);

        initFormatting();

        attachDatePickerElementEvents();

        if (input.prop('disabled')) {
            picker.disable();
        }
        if (input.is('input') && input.val().trim().length !== 0) {
            setValue(parseInputDate(input.val().trim()));
        }
        else if (options.defaultDate && input.attr('placeholder') === undefined) {
            setValue(options.defaultDate);
        }
        if (options.inline) {
            show();
        }
        return picker;
    };

    /********************************************************************************
     *
     * jQuery plugin constructor and defaults object
     *
     ********************************************************************************/

    /**
    * See (http://jquery.com/).
    * @name jQuery
    * @class
    * See the jQuery Library  (http://jquery.com/) for full details.  This just
    * documents the function and classes that are added to jQuery by this plug-in.
    */
    /**
     * See (http://jquery.com/)
     * @name fn
     * @class
     * See the jQuery Library  (http://jquery.com/) for full details.  This just
     * documents the function and classes that are added to jQuery by this plug-in.
     * @memberOf jQuery
     */
    /**
     * Show comments
     * @class datetimepicker
     * @memberOf jQuery.fn
     */
    $.fn.datetimepicker = function (options) {
        options = options || {};

        var args = Array.prototype.slice.call(arguments, 1),
            isInstance = true,
            thisMethods = ['destroy', 'hide', 'show', 'toggle'],
            returnValue;

        if (typeof options === 'object') {
            return this.each(function () {
                var $this = $(this),
                    _options;
                if (!$this.data('DateTimePicker')) {
                    // create a private copy of the defaults object
                    _options = $.extend(true, {}, $.fn.datetimepicker.defaults, options);
                    $this.data('DateTimePicker', dateTimePicker($this, _options));
                }
            });
        } else if (typeof options === 'string') {
            this.each(function () {
                var $this = $(this),
                    instance = $this.data('DateTimePicker');
                if (!instance) {
                    throw new Error('bootstrap-datetimepicker("' + options + '") method was called on an element that is not using DateTimePicker');
                }

                returnValue = instance[options].apply(instance, args);
                isInstance = returnValue === instance;
            });

            if (isInstance || $.inArray(options, thisMethods) > -1) {
                return this;
            }

            return returnValue;
        }

        throw new TypeError('Invalid arguments for DateTimePicker: ' + options);
    };

    $.fn.datetimepicker.defaults = {
        timeZone: '',
        format: false,
        dayViewHeaderFormat: 'MMMM YYYY',
        extraFormats: false,
        stepping: 1,
        minDate: false,
        maxDate: false,
        useCurrent: true,
        collapse: true,
        locale: moment.locale(),
        defaultDate: false,
        disabledDates: false,
        enabledDates: false,
        icons: {
            time: 'glyphicon glyphicon-time',
            date: 'glyphicon glyphicon-calendar',
            up: 'glyphicon glyphicon-chevron-up',
            down: 'glyphicon glyphicon-chevron-down',
            previous: 'glyphicon glyphicon-chevron-left',
            next: 'glyphicon glyphicon-chevron-right',
            today: 'glyphicon glyphicon-screenshot',
            clear: 'glyphicon glyphicon-trash',
            close: 'glyphicon glyphicon-remove'
        },
        tooltips: {
            today: 'Go to today',
            clear: 'Clear selection',
            close: 'Close the picker',
            selectMonth: 'Select Month',
            prevMonth: 'Previous Month',
            nextMonth: 'Next Month',
            selectYear: 'Select Year',
            prevYear: 'Previous Year',
            nextYear: 'Next Year',
            selectDecade: 'Select Decade',
            prevDecade: 'Previous Decade',
            nextDecade: 'Next Decade',
            prevCentury: 'Previous Century',
            nextCentury: 'Next Century',
            pickHour: 'Pick Hour',
            incrementHour: 'Increment Hour',
            decrementHour: 'Decrement Hour',
            pickMinute: 'Pick Minute',
            incrementMinute: 'Increment Minute',
            decrementMinute: 'Decrement Minute',
            pickSecond: 'Pick Second',
            incrementSecond: 'Increment Second',
            decrementSecond: 'Decrement Second',
            togglePeriod: 'Toggle Period',
            selectTime: 'Select Time'
        },
        useStrict: false,
        sideBySide: false,
        daysOfWeekDisabled: false,
        calendarWeeks: false,
        viewMode: 'days',
        toolbarPlacement: 'default',
        showTodayButton: false,
        showClear: false,
        showClose: false,
        widgetPositioning: {
            horizontal: 'auto',
            vertical: 'auto'
        },
        widgetParent: null,
        ignoreReadonly: false,
        keepOpen: false,
        focusOnShow: true,
        inline: false,
        keepInvalid: false,
        datepickerInput: '.datepickerinput',
        keyBinds: {
            up: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(7, 'd'));
                } else {
                    this.date(d.clone().add(this.stepping(), 'm'));
                }
            },
            down: function (widget) {
                if (!widget) {
                    this.show();
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(7, 'd'));
                } else {
                    this.date(d.clone().subtract(this.stepping(), 'm'));
                }
            },
            'control up': function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(1, 'y'));
                } else {
                    this.date(d.clone().add(1, 'h'));
                }
            },
            'control down': function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(1, 'y'));
                } else {
                    this.date(d.clone().subtract(1, 'h'));
                }
            },
            left: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(1, 'd'));
                }
            },
            right: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(1, 'd'));
                }
            },
            pageUp: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(1, 'M'));
                }
            },
            pageDown: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(1, 'M'));
                }
            },
            enter: function () {
                this.hide();
            },
            escape: function () {
                this.hide();
            },
            //tab: function (widget) { //this break the flow of the form. disabling for now
            //    var toggle = widget.find('.picker-switch a[data-action="togglePicker"]');
            //    if(toggle.length > 0) toggle.click();
            //},
            'control space': function (widget) {
                if (!widget) {
                    return;
                }
                if (widget.find('.timepicker').is(':visible')) {
                    widget.find('.btn[data-action="togglePeriod"]').click();
                }
            },
            t: function () {
                this.date(this.getMoment());
            },
            'delete': function () {
                this.clear();
            }
        },
        debug: false,
        allowInputToggle: false,
        disabledTimeIntervals: false,
        disabledHours: false,
        enabledHours: false,
        viewDate: false
    };

    return $.fn.datetimepicker;
}));

/*
 *  Bootstrap TouchSpin - v3.1.2
 *  A mobile and touch friendly input spinner component for Bootstrap 3.
 *  http://www.virtuosoft.eu/code/bootstrap-touchspin/
 *
 *  Made by István Ujj-Mészáros
 *  Under Apache License v2.0 License
 */
(function($) {
  'use strict';

  var _currentSpinnerId = 0;

  function _scopedEventName(name, id) {
    return name + '.touchspin_' + id;
  }

  function _scopeEventNames(names, id) {
    return $.map(names, function(name) {
      return _scopedEventName(name, id);
    });
  }

  $.fn.TouchSpin = function(options) {

    if (options === 'destroy') {
      this.each(function() {
        var originalinput = $(this),
            originalinput_data = originalinput.data();
        $(document).off(_scopeEventNames([
          'mouseup',
          'touchend',
          'touchcancel',
          'mousemove',
          'touchmove',
          'scroll',
          'scrollstart'], originalinput_data.spinnerid).join(' '));
      });
      return;
    }

    var defaults = {
      min: 0,
      max: 100,
      initval: '',
      replacementval: '',
      step: 1,
      decimals: 0,
      stepinterval: 100,
      forcestepdivisibility: 'round', // none | floor | round | ceil
      stepintervaldelay: 500,
      verticalbuttons: false,
      verticalupclass: 'glyphicon glyphicon-chevron-up',
      verticaldownclass: 'glyphicon glyphicon-chevron-down',
      prefix: '',
      postfix: '',
      prefix_extraclass: '',
      postfix_extraclass: '',
      booster: true,
      boostat: 10,
      maxboostedstep: false,
      mousewheel: true,
      buttondown_class: 'btn btn-default',
      buttonup_class: 'btn btn-default',
      buttondown_txt: '-',
      buttonup_txt: '+'
    };

    var attributeMap = {
      min: 'min',
      max: 'max',
      initval: 'init-val',
      replacementval: 'replacement-val',
      step: 'step',
      decimals: 'decimals',
      stepinterval: 'step-interval',
      verticalbuttons: 'vertical-buttons',
      verticalupclass: 'vertical-up-class',
      verticaldownclass: 'vertical-down-class',
      forcestepdivisibility: 'force-step-divisibility',
      stepintervaldelay: 'step-interval-delay',
      prefix: 'prefix',
      postfix: 'postfix',
      prefix_extraclass: 'prefix-extra-class',
      postfix_extraclass: 'postfix-extra-class',
      booster: 'booster',
      boostat: 'boostat',
      maxboostedstep: 'max-boosted-step',
      mousewheel: 'mouse-wheel',
      buttondown_class: 'button-down-class',
      buttonup_class: 'button-up-class',
      buttondown_txt: 'button-down-txt',
      buttonup_txt: 'button-up-txt'
    };

    return this.each(function() {

      var settings,
          originalinput = $(this),
          originalinput_data = originalinput.data(),
          container,
          elements,
          value,
          downSpinTimer,
          upSpinTimer,
          downDelayTimeout,
          upDelayTimeout,
          spincount = 0,
          spinning = false;

      init();


      function init() {
        if (originalinput.data('alreadyinitialized')) {
          return;
        }

        originalinput.data('alreadyinitialized', true);
        _currentSpinnerId += 1;
        originalinput.data('spinnerid', _currentSpinnerId);


        if (!originalinput.is('input')) {
          console.log('Must be an input.');
          return;
        }

        _initSettings();
        _setInitval();
        _checkValue();
        _buildHtml();
        _initElements();
        _hideEmptyPrefixPostfix();
        _bindEvents();
        _bindEventsInterface();
        elements.input.css('display', 'block');
      }

      function _setInitval() {
        if (settings.initval !== '' && originalinput.val() === '') {
          originalinput.val(settings.initval);
        }
      }

      function changeSettings(newsettings) {
        _updateSettings(newsettings);
        _checkValue();

        var value = elements.input.val();

        if (value !== '') {
          value = Number(elements.input.val());
          elements.input.val(value.toFixed(settings.decimals));
        }
      }

      function _initSettings() {
        settings = $.extend({}, defaults, originalinput_data, _parseAttributes(), options);
      }

      function _parseAttributes() {
        var data = {};
        $.each(attributeMap, function(key, value) {
          var attrName = 'bts-' + value + '';
          if (originalinput.is('[data-' + attrName + ']')) {
            data[key] = originalinput.data(attrName);
          }
        });
        return data;
      }

      function _updateSettings(newsettings) {
        settings = $.extend({}, settings, newsettings);

        // Update postfix and prefix texts if those settings were changed.
        if (newsettings.postfix) {
          originalinput.parent().find('.bootstrap-touchspin-postfix').text(newsettings.postfix);
        }
        if (newsettings.prefix) {
          originalinput.parent().find('.bootstrap-touchspin-prefix').text(newsettings.prefix);
        }
      }

      function _buildHtml() {
        var initval = originalinput.val(),
            parentelement = originalinput.parent();

        if (initval !== '') {
          initval = Number(initval).toFixed(settings.decimals);
        }

        originalinput.data('initvalue', initval).val(initval);
        originalinput.addClass('form-control');

        if (parentelement.hasClass('input-group')) {
          _advanceInputGroup(parentelement);
        }
        else {
          _buildInputGroup();
        }
      }

      function _advanceInputGroup(parentelement) {
        parentelement.addClass('bootstrap-touchspin');

        var prev = originalinput.prev(),
            next = originalinput.next();

        var downhtml,
            uphtml,
            prefixhtml = '<span class="input-group-addon bootstrap-touchspin-prefix">' + settings.prefix + '</span>',
            postfixhtml = '<span class="input-group-addon bootstrap-touchspin-postfix">' + settings.postfix + '</span>';

        if (prev.hasClass('input-group-btn')) {
          downhtml = '<button class="' + settings.buttondown_class + ' bootstrap-touchspin-down" type="button">' + settings.buttondown_txt + '</button>';
          prev.append(downhtml);
        }
        else {
          downhtml = '<span class="input-group-btn"><button class="' + settings.buttondown_class + ' bootstrap-touchspin-down" type="button">' + settings.buttondown_txt + '</button></span>';
          $(downhtml).insertBefore(originalinput);
        }

        if (next.hasClass('input-group-btn')) {
          uphtml = '<button class="' + settings.buttonup_class + ' bootstrap-touchspin-up" type="button">' + settings.buttonup_txt + '</button>';
          next.prepend(uphtml);
        }
        else {
          uphtml = '<span class="input-group-btn"><button class="' + settings.buttonup_class + ' bootstrap-touchspin-up" type="button">' + settings.buttonup_txt + '</button></span>';
          $(uphtml).insertAfter(originalinput);
        }

        $(prefixhtml).insertBefore(originalinput);
        $(postfixhtml).insertAfter(originalinput);

        container = parentelement;
      }

      function _buildInputGroup() {
        var html;

        if (settings.verticalbuttons) {
          html = '<div class="input-group bootstrap-touchspin"><span class="input-group-addon bootstrap-touchspin-prefix">' + settings.prefix + '</span><span class="input-group-addon bootstrap-touchspin-postfix">' + settings.postfix + '</span><span class="input-group-btn-vertical"><button class="' + settings.buttondown_class + ' bootstrap-touchspin-up" type="button"><i class="' + settings.verticalupclass + '"></i></button><button class="' + settings.buttonup_class + ' bootstrap-touchspin-down" type="button"><i class="' + settings.verticaldownclass + '"></i></button></span></div>';
        }
        else {
          html = '<div class="input-group bootstrap-touchspin"><span class="input-group-btn"><button class="' + settings.buttondown_class + ' bootstrap-touchspin-down" type="button">' + settings.buttondown_txt + '</button></span><span class="input-group-addon bootstrap-touchspin-prefix">' + settings.prefix + '</span><span class="input-group-addon bootstrap-touchspin-postfix">' + settings.postfix + '</span><span class="input-group-btn"><button class="' + settings.buttonup_class + ' bootstrap-touchspin-up" type="button">' + settings.buttonup_txt + '</button></span></div>';
        }

        container = $(html).insertBefore(originalinput);

        $('.bootstrap-touchspin-prefix', container).after(originalinput);

        if (originalinput.hasClass('input-sm')) {
          container.addClass('input-group-sm');
        }
        else if (originalinput.hasClass('input-lg')) {
          container.addClass('input-group-lg');
        }
      }

      function _initElements() {
        elements = {
          down: $('.bootstrap-touchspin-down', container),
          up: $('.bootstrap-touchspin-up', container),
          input: $('input', container),
          prefix: $('.bootstrap-touchspin-prefix', container).addClass(settings.prefix_extraclass),
          postfix: $('.bootstrap-touchspin-postfix', container).addClass(settings.postfix_extraclass)
        };
      }

      function _hideEmptyPrefixPostfix() {
        if (settings.prefix === '') {
          elements.prefix.hide();
        }

        if (settings.postfix === '') {
          elements.postfix.hide();
        }
      }

      function _bindEvents() {
        originalinput.on('keydown', function(ev) {
          var code = ev.keyCode || ev.which;

          if (code === 38) {
            if (spinning !== 'up') {
              upOnce();
              startUpSpin();
            }
            ev.preventDefault();
          }
          else if (code === 40) {
            if (spinning !== 'down') {
              downOnce();
              startDownSpin();
            }
            ev.preventDefault();
          }
        });

        originalinput.on('keyup', function(ev) {
          var code = ev.keyCode || ev.which;

          if (code === 38) {
            stopSpin();
          }
          else if (code === 40) {
            stopSpin();
          }
        });

        originalinput.on('blur', function() {
          _checkValue();
        });

        elements.down.on('keydown', function(ev) {
          var code = ev.keyCode || ev.which;

          if (code === 32 || code === 13) {
            if (spinning !== 'down') {
              downOnce();
              startDownSpin();
            }
            ev.preventDefault();
          }
        });

        elements.down.on('keyup', function(ev) {
          var code = ev.keyCode || ev.which;

          if (code === 32 || code === 13) {
            stopSpin();
          }
        });

        elements.up.on('keydown', function(ev) {
          var code = ev.keyCode || ev.which;

          if (code === 32 || code === 13) {
            if (spinning !== 'up') {
              upOnce();
              startUpSpin();
            }
            ev.preventDefault();
          }
        });

        elements.up.on('keyup', function(ev) {
          var code = ev.keyCode || ev.which;

          if (code === 32 || code === 13) {
            stopSpin();
          }
        });

        elements.down.on('mousedown.touchspin', function(ev) {
          elements.down.off('touchstart.touchspin');  // android 4 workaround

          if (originalinput.is(':disabled')) {
            return;
          }

          downOnce();
          startDownSpin();

          ev.preventDefault();
          ev.stopPropagation();
        });

        elements.down.on('touchstart.touchspin', function(ev) {
          elements.down.off('mousedown.touchspin');  // android 4 workaround

          if (originalinput.is(':disabled')) {
            return;
          }

          downOnce();
          startDownSpin();

          ev.preventDefault();
          ev.stopPropagation();
        });

        elements.up.on('mousedown.touchspin', function(ev) {
          elements.up.off('touchstart.touchspin');  // android 4 workaround

          if (originalinput.is(':disabled')) {
            return;
          }

          upOnce();
          startUpSpin();

          ev.preventDefault();
          ev.stopPropagation();
        });

        elements.up.on('touchstart.touchspin', function(ev) {
          elements.up.off('mousedown.touchspin');  // android 4 workaround

          if (originalinput.is(':disabled')) {
            return;
          }

          upOnce();
          startUpSpin();

          ev.preventDefault();
          ev.stopPropagation();
        });

        elements.up.on('mouseout touchleave touchend touchcancel', function(ev) {
          if (!spinning) {
            return;
          }

          ev.stopPropagation();
          stopSpin();
        });

        elements.down.on('mouseout touchleave touchend touchcancel', function(ev) {
          if (!spinning) {
            return;
          }

          ev.stopPropagation();
          stopSpin();
        });

        elements.down.on('mousemove touchmove', function(ev) {
          if (!spinning) {
            return;
          }

          ev.stopPropagation();
          ev.preventDefault();
        });

        elements.up.on('mousemove touchmove', function(ev) {
          if (!spinning) {
            return;
          }

          ev.stopPropagation();
          ev.preventDefault();
        });

        $(document).on(_scopeEventNames(['mouseup', 'touchend', 'touchcancel'], _currentSpinnerId).join(' '), function(ev) {
          if (!spinning) {
            return;
          }

          ev.preventDefault();
          stopSpin();
        });

        $(document).on(_scopeEventNames(['mousemove', 'touchmove', 'scroll', 'scrollstart'], _currentSpinnerId).join(' '), function(ev) {
          if (!spinning) {
            return;
          }

          ev.preventDefault();
          stopSpin();
        });

        originalinput.on('mousewheel DOMMouseScroll', function(ev) {
          if (!settings.mousewheel || !originalinput.is(':focus')) {
            return;
          }

          var delta = ev.originalEvent.wheelDelta || -ev.originalEvent.deltaY || -ev.originalEvent.detail;

          ev.stopPropagation();
          ev.preventDefault();

          if (delta < 0) {
            downOnce();
          }
          else {
            upOnce();
          }
        });
      }

      function _bindEventsInterface() {
        originalinput.on('touchspin.uponce', function() {
          stopSpin();
          upOnce();
        });

        originalinput.on('touchspin.downonce', function() {
          stopSpin();
          downOnce();
        });

        originalinput.on('touchspin.startupspin', function() {
          startUpSpin();
        });

        originalinput.on('touchspin.startdownspin', function() {
          startDownSpin();
        });

        originalinput.on('touchspin.stopspin', function() {
          stopSpin();
        });

        originalinput.on('touchspin.updatesettings', function(e, newsettings) {
          changeSettings(newsettings);
        });
      }

      function _forcestepdivisibility(value) {
        switch (settings.forcestepdivisibility) {
          case 'round':
            return (Math.round(value / settings.step) * settings.step).toFixed(settings.decimals);
          case 'floor':
            return (Math.floor(value / settings.step) * settings.step).toFixed(settings.decimals);
          case 'ceil':
            return (Math.ceil(value / settings.step) * settings.step).toFixed(settings.decimals);
          default:
            return value;
        }
      }

      function _checkValue() {
        var val, parsedval, returnval;

        val = originalinput.val();

        if (val === '') {
          if (settings.replacementval !== '') {
            originalinput.val(settings.replacementval);
            originalinput.trigger('change');
          }
          return;
        }

        if (settings.decimals > 0 && val === '.') {
          return;
        }

        parsedval = parseFloat(val);

        if (isNaN(parsedval)) {
          if (settings.replacementval !== '') {
            parsedval = settings.replacementval;
          }
          else {
            parsedval = 0;
          }
        }

        returnval = parsedval;

        if (parsedval.toString() !== val) {
          returnval = parsedval;
        }

        if (parsedval < settings.min) {
          returnval = settings.min;
        }

        if (parsedval > settings.max) {
          returnval = settings.max;
        }

        returnval = _forcestepdivisibility(returnval);

        if (Number(val).toString() !== returnval.toString()) {
          originalinput.val(returnval);
          originalinput.trigger('change');
        }
      }

      function _getBoostedStep() {
        if (!settings.booster) {
          return settings.step;
        }
        else {
          var boosted = Math.pow(2, Math.floor(spincount / settings.boostat)) * settings.step;

          if (settings.maxboostedstep) {
            if (boosted > settings.maxboostedstep) {
              boosted = settings.maxboostedstep;
              value = Math.round((value / boosted)) * boosted;
            }
          }

          return Math.max(settings.step, boosted);
        }
      }

      function upOnce() {
        _checkValue();

        value = parseFloat(elements.input.val());
        if (isNaN(value)) {
          value = 0;
        }

        var initvalue = value,
            boostedstep = _getBoostedStep();

        value = value + boostedstep;

        if (value > settings.max) {
          value = settings.max;
          originalinput.trigger('touchspin.on.max');
          stopSpin();
        }

        elements.input.val(Number(value).toFixed(settings.decimals));

        if (initvalue !== value) {
          originalinput.trigger('change');
        }
      }

      function downOnce() {
        _checkValue();

        value = parseFloat(elements.input.val());
        if (isNaN(value)) {
          value = 0;
        }

        var initvalue = value,
            boostedstep = _getBoostedStep();

        value = value - boostedstep;

        if (value < settings.min) {
          value = settings.min;
          originalinput.trigger('touchspin.on.min');
          stopSpin();
        }

        elements.input.val(value.toFixed(settings.decimals));

        if (initvalue !== value) {
          originalinput.trigger('change');
        }
      }

      function startDownSpin() {
        stopSpin();

        spincount = 0;
        spinning = 'down';

        originalinput.trigger('touchspin.on.startspin');
        originalinput.trigger('touchspin.on.startdownspin');

        downDelayTimeout = setTimeout(function() {
          downSpinTimer = setInterval(function() {
            spincount++;
            downOnce();
          }, settings.stepinterval);
        }, settings.stepintervaldelay);
      }

      function startUpSpin() {
        stopSpin();

        spincount = 0;
        spinning = 'up';

        originalinput.trigger('touchspin.on.startspin');
        originalinput.trigger('touchspin.on.startupspin');

        upDelayTimeout = setTimeout(function() {
          upSpinTimer = setInterval(function() {
            spincount++;
            upOnce();
          }, settings.stepinterval);
        }, settings.stepintervaldelay);
      }

      function stopSpin() {
        clearTimeout(downDelayTimeout);
        clearTimeout(upDelayTimeout);
        clearInterval(downSpinTimer);
        clearInterval(upSpinTimer);

        switch (spinning) {
          case 'up':
            originalinput.trigger('touchspin.on.stopupspin');
            originalinput.trigger('touchspin.on.stopspin');
            break;
          case 'down':
            originalinput.trigger('touchspin.on.stopdownspin');
            originalinput.trigger('touchspin.on.stopspin');
            break;
        }

        spincount = 0;
        spinning = false;
      }

    });

  };

})(jQuery);

!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.ES6Promise=e()}(this,function(){"use strict";function t(t){var e=typeof t;return null!==t&&("object"===e||"function"===e)}function e(t){return"function"==typeof t}function n(t){I=t}function r(t){J=t}function o(){return function(){return process.nextTick(a)}}function i(){return"undefined"!=typeof H?function(){H(a)}:c()}function s(){var t=0,e=new V(a),n=document.createTextNode("");return e.observe(n,{characterData:!0}),function(){n.data=t=++t%2}}function u(){var t=new MessageChannel;return t.port1.onmessage=a,function(){return t.port2.postMessage(0)}}function c(){var t=setTimeout;return function(){return t(a,1)}}function a(){for(var t=0;t<G;t+=2){var e=$[t],n=$[t+1];e(n),$[t]=void 0,$[t+1]=void 0}G=0}function f(){try{var t=require,e=t("vertx");return H=e.runOnLoop||e.runOnContext,i()}catch(n){return c()}}function l(t,e){var n=arguments,r=this,o=new this.constructor(p);void 0===o[et]&&k(o);var i=r._state;return i?!function(){var t=n[i-1];J(function(){return x(i,o,t,r._result)})}():E(r,o,t,e),o}function h(t){var e=this;if(t&&"object"==typeof t&&t.constructor===e)return t;var n=new e(p);return g(n,t),n}function p(){}function v(){return new TypeError("You cannot resolve a promise with itself")}function d(){return new TypeError("A promises callback cannot return that same promise.")}function _(t){try{return t.then}catch(e){return it.error=e,it}}function y(t,e,n,r){try{t.call(e,n,r)}catch(o){return o}}function m(t,e,n){J(function(t){var r=!1,o=y(n,e,function(n){r||(r=!0,e!==n?g(t,n):S(t,n))},function(e){r||(r=!0,j(t,e))},"Settle: "+(t._label||" unknown promise"));!r&&o&&(r=!0,j(t,o))},t)}function b(t,e){e._state===rt?S(t,e._result):e._state===ot?j(t,e._result):E(e,void 0,function(e){return g(t,e)},function(e){return j(t,e)})}function w(t,n,r){n.constructor===t.constructor&&r===l&&n.constructor.resolve===h?b(t,n):r===it?(j(t,it.error),it.error=null):void 0===r?S(t,n):e(r)?m(t,n,r):S(t,n)}function g(e,n){e===n?j(e,v()):t(n)?w(e,n,_(n)):S(e,n)}function A(t){t._onerror&&t._onerror(t._result),T(t)}function S(t,e){t._state===nt&&(t._result=e,t._state=rt,0!==t._subscribers.length&&J(T,t))}function j(t,e){t._state===nt&&(t._state=ot,t._result=e,J(A,t))}function E(t,e,n,r){var o=t._subscribers,i=o.length;t._onerror=null,o[i]=e,o[i+rt]=n,o[i+ot]=r,0===i&&t._state&&J(T,t)}function T(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var r=void 0,o=void 0,i=t._result,s=0;s<e.length;s+=3)r=e[s],o=e[s+n],r?x(n,r,o,i):o(i);t._subscribers.length=0}}function M(){this.error=null}function P(t,e){try{return t(e)}catch(n){return st.error=n,st}}function x(t,n,r,o){var i=e(r),s=void 0,u=void 0,c=void 0,a=void 0;if(i){if(s=P(r,o),s===st?(a=!0,u=s.error,s.error=null):c=!0,n===s)return void j(n,d())}else s=o,c=!0;n._state!==nt||(i&&c?g(n,s):a?j(n,u):t===rt?S(n,s):t===ot&&j(n,s))}function C(t,e){try{e(function(e){g(t,e)},function(e){j(t,e)})}catch(n){j(t,n)}}function O(){return ut++}function k(t){t[et]=ut++,t._state=void 0,t._result=void 0,t._subscribers=[]}function Y(t,e){this._instanceConstructor=t,this.promise=new t(p),this.promise[et]||k(this.promise),B(e)?(this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?S(this.promise,this._result):(this.length=this.length||0,this._enumerate(e),0===this._remaining&&S(this.promise,this._result))):j(this.promise,q())}function q(){return new Error("Array Methods must be provided an Array")}function F(t){return new Y(this,t).promise}function D(t){var e=this;return new e(B(t)?function(n,r){for(var o=t.length,i=0;i<o;i++)e.resolve(t[i]).then(n,r)}:function(t,e){return e(new TypeError("You must pass an array to race."))})}function K(t){var e=this,n=new e(p);return j(n,t),n}function L(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function N(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}function U(t){this[et]=O(),this._result=this._state=void 0,this._subscribers=[],p!==t&&("function"!=typeof t&&L(),this instanceof U?C(this,t):N())}function W(){var t=void 0;if("undefined"!=typeof global)t=global;else if("undefined"!=typeof self)t=self;else try{t=Function("return this")()}catch(e){throw new Error("polyfill failed because global object is unavailable in this environment")}var n=t.Promise;if(n){var r=null;try{r=Object.prototype.toString.call(n.resolve())}catch(e){}if("[object Promise]"===r&&!n.cast)return}t.Promise=U}var z=void 0;z=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)};var B=z,G=0,H=void 0,I=void 0,J=function(t,e){$[G]=t,$[G+1]=e,G+=2,2===G&&(I?I(a):tt())},Q="undefined"!=typeof window?window:void 0,R=Q||{},V=R.MutationObserver||R.WebKitMutationObserver,X="undefined"==typeof self&&"undefined"!=typeof process&&"[object process]"==={}.toString.call(process),Z="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,$=new Array(1e3),tt=void 0;tt=X?o():V?s():Z?u():void 0===Q&&"function"==typeof require?f():c();var et=Math.random().toString(36).substring(16),nt=void 0,rt=1,ot=2,it=new M,st=new M,ut=0;return Y.prototype._enumerate=function(t){for(var e=0;this._state===nt&&e<t.length;e++)this._eachEntry(t[e],e)},Y.prototype._eachEntry=function(t,e){var n=this._instanceConstructor,r=n.resolve;if(r===h){var o=_(t);if(o===l&&t._state!==nt)this._settledAt(t._state,e,t._result);else if("function"!=typeof o)this._remaining--,this._result[e]=t;else if(n===U){var i=new n(p);w(i,t,o),this._willSettleAt(i,e)}else this._willSettleAt(new n(function(e){return e(t)}),e)}else this._willSettleAt(r(t),e)},Y.prototype._settledAt=function(t,e,n){var r=this.promise;r._state===nt&&(this._remaining--,t===ot?j(r,n):this._result[e]=n),0===this._remaining&&S(r,this._result)},Y.prototype._willSettleAt=function(t,e){var n=this;E(t,void 0,function(t){return n._settledAt(rt,e,t)},function(t){return n._settledAt(ot,e,t)})},U.all=F,U.race=D,U.resolve=h,U.reject=K,U._setScheduler=n,U._setAsap=r,U._asap=J,U.prototype={constructor:U,then:l,"catch":function(t){return this.then(null,t)}},U.polyfill=W,U.Promise=U,U.polyfill(),U});
/*!
 * Chart.js
 * http://chartjs.org/
 * Version: 2.7.2
 *
 * Copyright 2018 Chart.js Contributors
 * Released under the MIT license
 * https://github.com/chartjs/Chart.js/blob/master/LICENSE.md
 */
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).Chart=t()}}(function(){return function t(e,i,n){function a(r,s){if(!i[r]){if(!e[r]){var l="function"==typeof require&&require;if(!s&&l)return l(r,!0);if(o)return o(r,!0);var u=new Error("Cannot find module '"+r+"'");throw u.code="MODULE_NOT_FOUND",u}var d=i[r]={exports:{}};e[r][0].call(d.exports,function(t){var i=e[r][1][t];return a(i||t)},d,d.exports,t,e,i,n)}return i[r].exports}for(var o="function"==typeof require&&require,r=0;r<n.length;r++)a(n[r]);return a}({1:[function(t,e,i){},{}],2:[function(t,e,i){var n=t(6);function a(t){if(t){var e=[0,0,0],i=1,a=t.match(/^#([a-fA-F0-9]{3})$/i);if(a){a=a[1];for(var o=0;o<e.length;o++)e[o]=parseInt(a[o]+a[o],16)}else if(a=t.match(/^#([a-fA-F0-9]{6})$/i)){a=a[1];for(o=0;o<e.length;o++)e[o]=parseInt(a.slice(2*o,2*o+2),16)}else if(a=t.match(/^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i)){for(o=0;o<e.length;o++)e[o]=parseInt(a[o+1]);i=parseFloat(a[4])}else if(a=t.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i)){for(o=0;o<e.length;o++)e[o]=Math.round(2.55*parseFloat(a[o+1]));i=parseFloat(a[4])}else if(a=t.match(/(\w+)/)){if("transparent"==a[1])return[0,0,0,0];if(!(e=n[a[1]]))return}for(o=0;o<e.length;o++)e[o]=d(e[o],0,255);return i=i||0==i?d(i,0,1):1,e[3]=i,e}}function o(t){if(t){var e=t.match(/^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/);if(e){var i=parseFloat(e[4]);return[d(parseInt(e[1]),0,360),d(parseFloat(e[2]),0,100),d(parseFloat(e[3]),0,100),d(isNaN(i)?1:i,0,1)]}}}function r(t){if(t){var e=t.match(/^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/);if(e){var i=parseFloat(e[4]);return[d(parseInt(e[1]),0,360),d(parseFloat(e[2]),0,100),d(parseFloat(e[3]),0,100),d(isNaN(i)?1:i,0,1)]}}}function s(t,e){return void 0===e&&(e=void 0!==t[3]?t[3]:1),"rgba("+t[0]+", "+t[1]+", "+t[2]+", "+e+")"}function l(t,e){return"rgba("+Math.round(t[0]/255*100)+"%, "+Math.round(t[1]/255*100)+"%, "+Math.round(t[2]/255*100)+"%, "+(e||t[3]||1)+")"}function u(t,e){return void 0===e&&(e=void 0!==t[3]?t[3]:1),"hsla("+t[0]+", "+t[1]+"%, "+t[2]+"%, "+e+")"}function d(t,e,i){return Math.min(Math.max(e,t),i)}function c(t){var e=t.toString(16).toUpperCase();return e.length<2?"0"+e:e}e.exports={getRgba:a,getHsla:o,getRgb:function(t){var e=a(t);return e&&e.slice(0,3)},getHsl:function(t){var e=o(t);return e&&e.slice(0,3)},getHwb:r,getAlpha:function(t){var e=a(t);{if(e)return e[3];if(e=o(t))return e[3];if(e=r(t))return e[3]}},hexString:function(t){return"#"+c(t[0])+c(t[1])+c(t[2])},rgbString:function(t,e){if(e<1||t[3]&&t[3]<1)return s(t,e);return"rgb("+t[0]+", "+t[1]+", "+t[2]+")"},rgbaString:s,percentString:function(t,e){if(e<1||t[3]&&t[3]<1)return l(t,e);var i=Math.round(t[0]/255*100),n=Math.round(t[1]/255*100),a=Math.round(t[2]/255*100);return"rgb("+i+"%, "+n+"%, "+a+"%)"},percentaString:l,hslString:function(t,e){if(e<1||t[3]&&t[3]<1)return u(t,e);return"hsl("+t[0]+", "+t[1]+"%, "+t[2]+"%)"},hslaString:u,hwbString:function(t,e){void 0===e&&(e=void 0!==t[3]?t[3]:1);return"hwb("+t[0]+", "+t[1]+"%, "+t[2]+"%"+(void 0!==e&&1!==e?", "+e:"")+")"},keyword:function(t){return h[t.slice(0,3)]}};var h={};for(var f in n)h[n[f]]=f},{6:6}],3:[function(t,e,i){var n=t(5),a=t(2),o=function(t){return t instanceof o?t:this instanceof o?(this.valid=!1,this.values={rgb:[0,0,0],hsl:[0,0,0],hsv:[0,0,0],hwb:[0,0,0],cmyk:[0,0,0,0],alpha:1},void("string"==typeof t?(e=a.getRgba(t))?this.setValues("rgb",e):(e=a.getHsla(t))?this.setValues("hsl",e):(e=a.getHwb(t))&&this.setValues("hwb",e):"object"==typeof t&&(void 0!==(e=t).r||void 0!==e.red?this.setValues("rgb",e):void 0!==e.l||void 0!==e.lightness?this.setValues("hsl",e):void 0!==e.v||void 0!==e.value?this.setValues("hsv",e):void 0!==e.w||void 0!==e.whiteness?this.setValues("hwb",e):void 0===e.c&&void 0===e.cyan||this.setValues("cmyk",e)))):new o(t);var e};o.prototype={isValid:function(){return this.valid},rgb:function(){return this.setSpace("rgb",arguments)},hsl:function(){return this.setSpace("hsl",arguments)},hsv:function(){return this.setSpace("hsv",arguments)},hwb:function(){return this.setSpace("hwb",arguments)},cmyk:function(){return this.setSpace("cmyk",arguments)},rgbArray:function(){return this.values.rgb},hslArray:function(){return this.values.hsl},hsvArray:function(){return this.values.hsv},hwbArray:function(){var t=this.values;return 1!==t.alpha?t.hwb.concat([t.alpha]):t.hwb},cmykArray:function(){return this.values.cmyk},rgbaArray:function(){var t=this.values;return t.rgb.concat([t.alpha])},hslaArray:function(){var t=this.values;return t.hsl.concat([t.alpha])},alpha:function(t){return void 0===t?this.values.alpha:(this.setValues("alpha",t),this)},red:function(t){return this.setChannel("rgb",0,t)},green:function(t){return this.setChannel("rgb",1,t)},blue:function(t){return this.setChannel("rgb",2,t)},hue:function(t){return t&&(t=(t%=360)<0?360+t:t),this.setChannel("hsl",0,t)},saturation:function(t){return this.setChannel("hsl",1,t)},lightness:function(t){return this.setChannel("hsl",2,t)},saturationv:function(t){return this.setChannel("hsv",1,t)},whiteness:function(t){return this.setChannel("hwb",1,t)},blackness:function(t){return this.setChannel("hwb",2,t)},value:function(t){return this.setChannel("hsv",2,t)},cyan:function(t){return this.setChannel("cmyk",0,t)},magenta:function(t){return this.setChannel("cmyk",1,t)},yellow:function(t){return this.setChannel("cmyk",2,t)},black:function(t){return this.setChannel("cmyk",3,t)},hexString:function(){return a.hexString(this.values.rgb)},rgbString:function(){return a.rgbString(this.values.rgb,this.values.alpha)},rgbaString:function(){return a.rgbaString(this.values.rgb,this.values.alpha)},percentString:function(){return a.percentString(this.values.rgb,this.values.alpha)},hslString:function(){return a.hslString(this.values.hsl,this.values.alpha)},hslaString:function(){return a.hslaString(this.values.hsl,this.values.alpha)},hwbString:function(){return a.hwbString(this.values.hwb,this.values.alpha)},keyword:function(){return a.keyword(this.values.rgb,this.values.alpha)},rgbNumber:function(){var t=this.values.rgb;return t[0]<<16|t[1]<<8|t[2]},luminosity:function(){for(var t=this.values.rgb,e=[],i=0;i<t.length;i++){var n=t[i]/255;e[i]=n<=.03928?n/12.92:Math.pow((n+.055)/1.055,2.4)}return.2126*e[0]+.7152*e[1]+.0722*e[2]},contrast:function(t){var e=this.luminosity(),i=t.luminosity();return e>i?(e+.05)/(i+.05):(i+.05)/(e+.05)},level:function(t){var e=this.contrast(t);return e>=7.1?"AAA":e>=4.5?"AA":""},dark:function(){var t=this.values.rgb;return(299*t[0]+587*t[1]+114*t[2])/1e3<128},light:function(){return!this.dark()},negate:function(){for(var t=[],e=0;e<3;e++)t[e]=255-this.values.rgb[e];return this.setValues("rgb",t),this},lighten:function(t){var e=this.values.hsl;return e[2]+=e[2]*t,this.setValues("hsl",e),this},darken:function(t){var e=this.values.hsl;return e[2]-=e[2]*t,this.setValues("hsl",e),this},saturate:function(t){var e=this.values.hsl;return e[1]+=e[1]*t,this.setValues("hsl",e),this},desaturate:function(t){var e=this.values.hsl;return e[1]-=e[1]*t,this.setValues("hsl",e),this},whiten:function(t){var e=this.values.hwb;return e[1]+=e[1]*t,this.setValues("hwb",e),this},blacken:function(t){var e=this.values.hwb;return e[2]+=e[2]*t,this.setValues("hwb",e),this},greyscale:function(){var t=this.values.rgb,e=.3*t[0]+.59*t[1]+.11*t[2];return this.setValues("rgb",[e,e,e]),this},clearer:function(t){var e=this.values.alpha;return this.setValues("alpha",e-e*t),this},opaquer:function(t){var e=this.values.alpha;return this.setValues("alpha",e+e*t),this},rotate:function(t){var e=this.values.hsl,i=(e[0]+t)%360;return e[0]=i<0?360+i:i,this.setValues("hsl",e),this},mix:function(t,e){var i=this,n=t,a=void 0===e?.5:e,o=2*a-1,r=i.alpha()-n.alpha(),s=((o*r==-1?o:(o+r)/(1+o*r))+1)/2,l=1-s;return this.rgb(s*i.red()+l*n.red(),s*i.green()+l*n.green(),s*i.blue()+l*n.blue()).alpha(i.alpha()*a+n.alpha()*(1-a))},toJSON:function(){return this.rgb()},clone:function(){var t,e,i=new o,n=this.values,a=i.values;for(var r in n)n.hasOwnProperty(r)&&(t=n[r],"[object Array]"===(e={}.toString.call(t))?a[r]=t.slice(0):"[object Number]"===e?a[r]=t:console.error("unexpected color value:",t));return i}},o.prototype.spaces={rgb:["red","green","blue"],hsl:["hue","saturation","lightness"],hsv:["hue","saturation","value"],hwb:["hue","whiteness","blackness"],cmyk:["cyan","magenta","yellow","black"]},o.prototype.maxes={rgb:[255,255,255],hsl:[360,100,100],hsv:[360,100,100],hwb:[360,100,100],cmyk:[100,100,100,100]},o.prototype.getValues=function(t){for(var e=this.values,i={},n=0;n<t.length;n++)i[t.charAt(n)]=e[t][n];return 1!==e.alpha&&(i.a=e.alpha),i},o.prototype.setValues=function(t,e){var i,a,o=this.values,r=this.spaces,s=this.maxes,l=1;if(this.valid=!0,"alpha"===t)l=e;else if(e.length)o[t]=e.slice(0,t.length),l=e[t.length];else if(void 0!==e[t.charAt(0)]){for(i=0;i<t.length;i++)o[t][i]=e[t.charAt(i)];l=e.a}else if(void 0!==e[r[t][0]]){var u=r[t];for(i=0;i<t.length;i++)o[t][i]=e[u[i]];l=e.alpha}if(o.alpha=Math.max(0,Math.min(1,void 0===l?o.alpha:l)),"alpha"===t)return!1;for(i=0;i<t.length;i++)a=Math.max(0,Math.min(s[t][i],o[t][i])),o[t][i]=Math.round(a);for(var d in r)d!==t&&(o[d]=n[t][d](o[t]));return!0},o.prototype.setSpace=function(t,e){var i=e[0];return void 0===i?this.getValues(t):("number"==typeof i&&(i=Array.prototype.slice.call(e)),this.setValues(t,i),this)},o.prototype.setChannel=function(t,e,i){var n=this.values[t];return void 0===i?n[e]:i===n[e]?this:(n[e]=i,this.setValues(t,n),this)},"undefined"!=typeof window&&(window.Color=o),e.exports=o},{2:2,5:5}],4:[function(t,e,i){function n(t){var e,i,n=t[0]/255,a=t[1]/255,o=t[2]/255,r=Math.min(n,a,o),s=Math.max(n,a,o),l=s-r;return s==r?e=0:n==s?e=(a-o)/l:a==s?e=2+(o-n)/l:o==s&&(e=4+(n-a)/l),(e=Math.min(60*e,360))<0&&(e+=360),i=(r+s)/2,[e,100*(s==r?0:i<=.5?l/(s+r):l/(2-s-r)),100*i]}function a(t){var e,i,n=t[0],a=t[1],o=t[2],r=Math.min(n,a,o),s=Math.max(n,a,o),l=s-r;return i=0==s?0:l/s*1e3/10,s==r?e=0:n==s?e=(a-o)/l:a==s?e=2+(o-n)/l:o==s&&(e=4+(n-a)/l),(e=Math.min(60*e,360))<0&&(e+=360),[e,i,s/255*1e3/10]}function o(t){var e=t[0],i=t[1],a=t[2];return[n(t)[0],100*(1/255*Math.min(e,Math.min(i,a))),100*(a=1-1/255*Math.max(e,Math.max(i,a)))]}function s(t){var e,i=t[0]/255,n=t[1]/255,a=t[2]/255;return[100*((1-i-(e=Math.min(1-i,1-n,1-a)))/(1-e)||0),100*((1-n-e)/(1-e)||0),100*((1-a-e)/(1-e)||0),100*e]}function l(t){return C[JSON.stringify(t)]}function u(t){var e=t[0]/255,i=t[1]/255,n=t[2]/255;return[100*(.4124*(e=e>.04045?Math.pow((e+.055)/1.055,2.4):e/12.92)+.3576*(i=i>.04045?Math.pow((i+.055)/1.055,2.4):i/12.92)+.1805*(n=n>.04045?Math.pow((n+.055)/1.055,2.4):n/12.92)),100*(.2126*e+.7152*i+.0722*n),100*(.0193*e+.1192*i+.9505*n)]}function d(t){var e=u(t),i=e[0],n=e[1],a=e[2];return n/=100,a/=108.883,i=(i/=95.047)>.008856?Math.pow(i,1/3):7.787*i+16/116,[116*(n=n>.008856?Math.pow(n,1/3):7.787*n+16/116)-16,500*(i-n),200*(n-(a=a>.008856?Math.pow(a,1/3):7.787*a+16/116))]}function c(t){var e,i,n,a,o,r=t[0]/360,s=t[1]/100,l=t[2]/100;if(0==s)return[o=255*l,o,o];e=2*l-(i=l<.5?l*(1+s):l+s-l*s),a=[0,0,0];for(var u=0;u<3;u++)(n=r+1/3*-(u-1))<0&&n++,n>1&&n--,o=6*n<1?e+6*(i-e)*n:2*n<1?i:3*n<2?e+(i-e)*(2/3-n)*6:e,a[u]=255*o;return a}function h(t){var e=t[0]/60,i=t[1]/100,n=t[2]/100,a=Math.floor(e)%6,o=e-Math.floor(e),r=255*n*(1-i),s=255*n*(1-i*o),l=255*n*(1-i*(1-o));n*=255;switch(a){case 0:return[n,l,r];case 1:return[s,n,r];case 2:return[r,n,l];case 3:return[r,s,n];case 4:return[l,r,n];case 5:return[n,r,s]}}function f(t){var e,i,n,a,o=t[0]/360,s=t[1]/100,l=t[2]/100,u=s+l;switch(u>1&&(s/=u,l/=u),n=6*o-(e=Math.floor(6*o)),0!=(1&e)&&(n=1-n),a=s+n*((i=1-l)-s),e){default:case 6:case 0:r=i,g=a,b=s;break;case 1:r=a,g=i,b=s;break;case 2:r=s,g=i,b=a;break;case 3:r=s,g=a,b=i;break;case 4:r=a,g=s,b=i;break;case 5:r=i,g=s,b=a}return[255*r,255*g,255*b]}function p(t){var e=t[0]/100,i=t[1]/100,n=t[2]/100,a=t[3]/100;return[255*(1-Math.min(1,e*(1-a)+a)),255*(1-Math.min(1,i*(1-a)+a)),255*(1-Math.min(1,n*(1-a)+a))]}function m(t){var e,i,n,a=t[0]/100,o=t[1]/100,r=t[2]/100;return i=-.9689*a+1.8758*o+.0415*r,n=.0557*a+-.204*o+1.057*r,e=(e=3.2406*a+-1.5372*o+-.4986*r)>.0031308?1.055*Math.pow(e,1/2.4)-.055:e*=12.92,i=i>.0031308?1.055*Math.pow(i,1/2.4)-.055:i*=12.92,n=n>.0031308?1.055*Math.pow(n,1/2.4)-.055:n*=12.92,[255*(e=Math.min(Math.max(0,e),1)),255*(i=Math.min(Math.max(0,i),1)),255*(n=Math.min(Math.max(0,n),1))]}function v(t){var e=t[0],i=t[1],n=t[2];return i/=100,n/=108.883,e=(e/=95.047)>.008856?Math.pow(e,1/3):7.787*e+16/116,[116*(i=i>.008856?Math.pow(i,1/3):7.787*i+16/116)-16,500*(e-i),200*(i-(n=n>.008856?Math.pow(n,1/3):7.787*n+16/116))]}function x(t){var e,i,n,a,o=t[0],r=t[1],s=t[2];return o<=8?a=(i=100*o/903.3)/100*7.787+16/116:(i=100*Math.pow((o+16)/116,3),a=Math.pow(i/100,1/3)),[e=e/95.047<=.008856?e=95.047*(r/500+a-16/116)/7.787:95.047*Math.pow(r/500+a,3),i,n=n/108.883<=.008859?n=108.883*(a-s/200-16/116)/7.787:108.883*Math.pow(a-s/200,3)]}function y(t){var e,i=t[0],n=t[1],a=t[2];return(e=360*Math.atan2(a,n)/2/Math.PI)<0&&(e+=360),[i,Math.sqrt(n*n+a*a),e]}function k(t){return m(x(t))}function M(t){var e,i=t[0],n=t[1];return e=t[2]/360*2*Math.PI,[i,n*Math.cos(e),n*Math.sin(e)]}function w(t){return S[t]}e.exports={rgb2hsl:n,rgb2hsv:a,rgb2hwb:o,rgb2cmyk:s,rgb2keyword:l,rgb2xyz:u,rgb2lab:d,rgb2lch:function(t){return y(d(t))},hsl2rgb:c,hsl2hsv:function(t){var e=t[0],i=t[1]/100,n=t[2]/100;if(0===n)return[0,0,0];return[e,100*(2*(i*=(n*=2)<=1?n:2-n)/(n+i)),100*((n+i)/2)]},hsl2hwb:function(t){return o(c(t))},hsl2cmyk:function(t){return s(c(t))},hsl2keyword:function(t){return l(c(t))},hsv2rgb:h,hsv2hsl:function(t){var e,i,n=t[0],a=t[1]/100,o=t[2]/100;return e=a*o,[n,100*(e=(e/=(i=(2-a)*o)<=1?i:2-i)||0),100*(i/=2)]},hsv2hwb:function(t){return o(h(t))},hsv2cmyk:function(t){return s(h(t))},hsv2keyword:function(t){return l(h(t))},hwb2rgb:f,hwb2hsl:function(t){return n(f(t))},hwb2hsv:function(t){return a(f(t))},hwb2cmyk:function(t){return s(f(t))},hwb2keyword:function(t){return l(f(t))},cmyk2rgb:p,cmyk2hsl:function(t){return n(p(t))},cmyk2hsv:function(t){return a(p(t))},cmyk2hwb:function(t){return o(p(t))},cmyk2keyword:function(t){return l(p(t))},keyword2rgb:w,keyword2hsl:function(t){return n(w(t))},keyword2hsv:function(t){return a(w(t))},keyword2hwb:function(t){return o(w(t))},keyword2cmyk:function(t){return s(w(t))},keyword2lab:function(t){return d(w(t))},keyword2xyz:function(t){return u(w(t))},xyz2rgb:m,xyz2lab:v,xyz2lch:function(t){return y(v(t))},lab2xyz:x,lab2rgb:k,lab2lch:y,lch2lab:M,lch2xyz:function(t){return x(M(t))},lch2rgb:function(t){return k(M(t))}};var S={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]},C={};for(var _ in S)C[JSON.stringify(S[_])]=_},{}],5:[function(t,e,i){var n=t(4),a=function(){return new u};for(var o in n){a[o+"Raw"]=function(t){return function(e){return"number"==typeof e&&(e=Array.prototype.slice.call(arguments)),n[t](e)}}(o);var r=/(\w+)2(\w+)/.exec(o),s=r[1],l=r[2];(a[s]=a[s]||{})[l]=a[o]=function(t){return function(e){"number"==typeof e&&(e=Array.prototype.slice.call(arguments));var i=n[t](e);if("string"==typeof i||void 0===i)return i;for(var a=0;a<i.length;a++)i[a]=Math.round(i[a]);return i}}(o)}var u=function(){this.convs={}};u.prototype.routeSpace=function(t,e){var i=e[0];return void 0===i?this.getValues(t):("number"==typeof i&&(i=Array.prototype.slice.call(e)),this.setValues(t,i))},u.prototype.setValues=function(t,e){return this.space=t,this.convs={},this.convs[t]=e,this},u.prototype.getValues=function(t){var e=this.convs[t];if(!e){var i=this.space,n=this.convs[i];e=a[i][t](n),this.convs[t]=e}return e},["rgb","hsl","hsv","cmyk","keyword"].forEach(function(t){u.prototype[t]=function(e){return this.routeSpace(t,arguments)}}),e.exports=a},{4:4}],6:[function(t,e,i){"use strict";e.exports={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]}},{}],7:[function(t,e,i){var n=t(29)();n.helpers=t(45),t(27)(n),n.defaults=t(25),n.Element=t(26),n.elements=t(40),n.Interaction=t(28),n.layouts=t(30),n.platform=t(48),n.plugins=t(31),n.Ticks=t(34),t(22)(n),t(23)(n),t(24)(n),t(33)(n),t(32)(n),t(35)(n),t(55)(n),t(53)(n),t(54)(n),t(56)(n),t(57)(n),t(58)(n),t(15)(n),t(16)(n),t(17)(n),t(18)(n),t(19)(n),t(20)(n),t(21)(n),t(8)(n),t(9)(n),t(10)(n),t(11)(n),t(12)(n),t(13)(n),t(14)(n);var a=t(49);for(var o in a)a.hasOwnProperty(o)&&n.plugins.register(a[o]);n.platform.initialize(),e.exports=n,"undefined"!=typeof window&&(window.Chart=n),n.Legend=a.legend._element,n.Title=a.title._element,n.pluginService=n.plugins,n.PluginBase=n.Element.extend({}),n.canvasHelpers=n.helpers.canvas,n.layoutService=n.layouts},{10:10,11:11,12:12,13:13,14:14,15:15,16:16,17:17,18:18,19:19,20:20,21:21,22:22,23:23,24:24,25:25,26:26,27:27,28:28,29:29,30:30,31:31,32:32,33:33,34:34,35:35,40:40,45:45,48:48,49:49,53:53,54:54,55:55,56:56,57:57,58:58,8:8,9:9}],8:[function(t,e,i){"use strict";e.exports=function(t){t.Bar=function(e,i){return i.type="bar",new t(e,i)}}},{}],9:[function(t,e,i){"use strict";e.exports=function(t){t.Bubble=function(e,i){return i.type="bubble",new t(e,i)}}},{}],10:[function(t,e,i){"use strict";e.exports=function(t){t.Doughnut=function(e,i){return i.type="doughnut",new t(e,i)}}},{}],11:[function(t,e,i){"use strict";e.exports=function(t){t.Line=function(e,i){return i.type="line",new t(e,i)}}},{}],12:[function(t,e,i){"use strict";e.exports=function(t){t.PolarArea=function(e,i){return i.type="polarArea",new t(e,i)}}},{}],13:[function(t,e,i){"use strict";e.exports=function(t){t.Radar=function(e,i){return i.type="radar",new t(e,i)}}},{}],14:[function(t,e,i){"use strict";e.exports=function(t){t.Scatter=function(e,i){return i.type="scatter",new t(e,i)}}},{}],15:[function(t,e,i){"use strict";var n=t(25),a=t(40),o=t(45);n._set("bar",{hover:{mode:"label"},scales:{xAxes:[{type:"category",categoryPercentage:.8,barPercentage:.9,offset:!0,gridLines:{offsetGridLines:!0}}],yAxes:[{type:"linear"}]}}),n._set("horizontalBar",{hover:{mode:"index",axis:"y"},scales:{xAxes:[{type:"linear",position:"bottom"}],yAxes:[{position:"left",type:"category",categoryPercentage:.8,barPercentage:.9,offset:!0,gridLines:{offsetGridLines:!0}}]},elements:{rectangle:{borderSkipped:"left"}},tooltips:{callbacks:{title:function(t,e){var i="";return t.length>0&&(t[0].yLabel?i=t[0].yLabel:e.labels.length>0&&t[0].index<e.labels.length&&(i=e.labels[t[0].index])),i},label:function(t,e){return(e.datasets[t.datasetIndex].label||"")+": "+t.xLabel}},mode:"index",axis:"y"}}),e.exports=function(t){t.controllers.bar=t.DatasetController.extend({dataElementType:a.Rectangle,initialize:function(){var e;t.DatasetController.prototype.initialize.apply(this,arguments),(e=this.getMeta()).stack=this.getDataset().stack,e.bar=!0},update:function(t){var e,i,n=this.getMeta().data;for(this._ruler=this.getRuler(),e=0,i=n.length;e<i;++e)this.updateElement(n[e],e,t)},updateElement:function(t,e,i){var n=this,a=n.chart,r=n.getMeta(),s=n.getDataset(),l=t.custom||{},u=a.options.elements.rectangle;t._xScale=n.getScaleForId(r.xAxisID),t._yScale=n.getScaleForId(r.yAxisID),t._datasetIndex=n.index,t._index=e,t._model={datasetLabel:s.label,label:a.data.labels[e],borderSkipped:l.borderSkipped?l.borderSkipped:u.borderSkipped,backgroundColor:l.backgroundColor?l.backgroundColor:o.valueAtIndexOrDefault(s.backgroundColor,e,u.backgroundColor),borderColor:l.borderColor?l.borderColor:o.valueAtIndexOrDefault(s.borderColor,e,u.borderColor),borderWidth:l.borderWidth?l.borderWidth:o.valueAtIndexOrDefault(s.borderWidth,e,u.borderWidth)},n.updateElementGeometry(t,e,i),t.pivot()},updateElementGeometry:function(t,e,i){var n=this,a=t._model,o=n.getValueScale(),r=o.getBasePixel(),s=o.isHorizontal(),l=n._ruler||n.getRuler(),u=n.calculateBarValuePixels(n.index,e),d=n.calculateBarIndexPixels(n.index,e,l);a.horizontal=s,a.base=i?r:u.base,a.x=s?i?r:u.head:d.center,a.y=s?d.center:i?r:u.head,a.height=s?d.size:void 0,a.width=s?void 0:d.size},getValueScaleId:function(){return this.getMeta().yAxisID},getIndexScaleId:function(){return this.getMeta().xAxisID},getValueScale:function(){return this.getScaleForId(this.getValueScaleId())},getIndexScale:function(){return this.getScaleForId(this.getIndexScaleId())},_getStacks:function(t){var e,i,n=this.chart,a=this.getIndexScale().options.stacked,o=void 0===t?n.data.datasets.length:t+1,r=[];for(e=0;e<o;++e)(i=n.getDatasetMeta(e)).bar&&n.isDatasetVisible(e)&&(!1===a||!0===a&&-1===r.indexOf(i.stack)||void 0===a&&(void 0===i.stack||-1===r.indexOf(i.stack)))&&r.push(i.stack);return r},getStackCount:function(){return this._getStacks().length},getStackIndex:function(t,e){var i=this._getStacks(t),n=void 0!==e?i.indexOf(e):-1;return-1===n?i.length-1:n},getRuler:function(){var t,e,i=this.getIndexScale(),n=this.getStackCount(),a=this.index,r=i.isHorizontal(),s=r?i.left:i.top,l=s+(r?i.width:i.height),u=[];for(t=0,e=this.getMeta().data.length;t<e;++t)u.push(i.getPixelForValue(null,t,a));return{min:o.isNullOrUndef(i.options.barThickness)?function(t,e){var i,n,a,o,r=t.isHorizontal()?t.width:t.height,s=t.getTicks();for(a=1,o=e.length;a<o;++a)r=Math.min(r,e[a]-e[a-1]);for(a=0,o=s.length;a<o;++a)n=t.getPixelForTick(a),r=a>0?Math.min(r,n-i):r,i=n;return r}(i,u):-1,pixels:u,start:s,end:l,stackCount:n,scale:i}},calculateBarValuePixels:function(t,e){var i,n,a,o,r,s,l=this.chart,u=this.getMeta(),d=this.getValueScale(),c=l.data.datasets,h=d.getRightValue(c[t].data[e]),f=d.options.stacked,g=u.stack,p=0;if(f||void 0===f&&void 0!==g)for(i=0;i<t;++i)(n=l.getDatasetMeta(i)).bar&&n.stack===g&&n.controller.getValueScaleId()===d.id&&l.isDatasetVisible(i)&&(a=d.getRightValue(c[i].data[e]),(h<0&&a<0||h>=0&&a>0)&&(p+=a));return o=d.getPixelForValue(p),{size:s=((r=d.getPixelForValue(p+h))-o)/2,base:o,head:r,center:r+s/2}},calculateBarIndexPixels:function(t,e,i){var n,a,r,s,l,u,d,c,h,f,g,p,m,v,b,x,y,k=i.scale.options,M="flex"===k.barThickness?(h=e,g=k,m=(f=i).pixels,v=m[h],b=h>0?m[h-1]:null,x=h<m.length-1?m[h+1]:null,y=g.categoryPercentage,null===b&&(b=v-(null===x?f.end-v:x-v)),null===x&&(x=v+v-b),p=v-(v-b)/2*y,{chunk:(x-b)/2*y/f.stackCount,ratio:g.barPercentage,start:p}):(n=e,a=i,u=(r=k).barThickness,d=a.stackCount,c=a.pixels[n],o.isNullOrUndef(u)?(s=a.min*r.categoryPercentage,l=r.barPercentage):(s=u*d,l=1),{chunk:s/d,ratio:l,start:c-s/2}),w=this.getStackIndex(t,this.getMeta().stack),S=M.start+M.chunk*w+M.chunk/2,C=Math.min(o.valueOrDefault(k.maxBarThickness,1/0),M.chunk*M.ratio);return{base:S-C/2,head:S+C/2,center:S,size:C}},draw:function(){var t=this.chart,e=this.getValueScale(),i=this.getMeta().data,n=this.getDataset(),a=i.length,r=0;for(o.canvas.clipArea(t.ctx,t.chartArea);r<a;++r)isNaN(e.getRightValue(n.data[r]))||i[r].draw();o.canvas.unclipArea(t.ctx)},setHoverStyle:function(t){var e=this.chart.data.datasets[t._datasetIndex],i=t._index,n=t.custom||{},a=t._model;a.backgroundColor=n.hoverBackgroundColor?n.hoverBackgroundColor:o.valueAtIndexOrDefault(e.hoverBackgroundColor,i,o.getHoverColor(a.backgroundColor)),a.borderColor=n.hoverBorderColor?n.hoverBorderColor:o.valueAtIndexOrDefault(e.hoverBorderColor,i,o.getHoverColor(a.borderColor)),a.borderWidth=n.hoverBorderWidth?n.hoverBorderWidth:o.valueAtIndexOrDefault(e.hoverBorderWidth,i,a.borderWidth)},removeHoverStyle:function(t){var e=this.chart.data.datasets[t._datasetIndex],i=t._index,n=t.custom||{},a=t._model,r=this.chart.options.elements.rectangle;a.backgroundColor=n.backgroundColor?n.backgroundColor:o.valueAtIndexOrDefault(e.backgroundColor,i,r.backgroundColor),a.borderColor=n.borderColor?n.borderColor:o.valueAtIndexOrDefault(e.borderColor,i,r.borderColor),a.borderWidth=n.borderWidth?n.borderWidth:o.valueAtIndexOrDefault(e.borderWidth,i,r.borderWidth)}}),t.controllers.horizontalBar=t.controllers.bar.extend({getValueScaleId:function(){return this.getMeta().xAxisID},getIndexScaleId:function(){return this.getMeta().yAxisID}})}},{25:25,40:40,45:45}],16:[function(t,e,i){"use strict";var n=t(25),a=t(40),o=t(45);n._set("bubble",{hover:{mode:"single"},scales:{xAxes:[{type:"linear",position:"bottom",id:"x-axis-0"}],yAxes:[{type:"linear",position:"left",id:"y-axis-0"}]},tooltips:{callbacks:{title:function(){return""},label:function(t,e){var i=e.datasets[t.datasetIndex].label||"",n=e.datasets[t.datasetIndex].data[t.index];return i+": ("+t.xLabel+", "+t.yLabel+", "+n.r+")"}}}}),e.exports=function(t){t.controllers.bubble=t.DatasetController.extend({dataElementType:a.Point,update:function(t){var e=this,i=e.getMeta().data;o.each(i,function(i,n){e.updateElement(i,n,t)})},updateElement:function(t,e,i){var n=this,a=n.getMeta(),o=t.custom||{},r=n.getScaleForId(a.xAxisID),s=n.getScaleForId(a.yAxisID),l=n._resolveElementOptions(t,e),u=n.getDataset().data[e],d=n.index,c=i?r.getPixelForDecimal(.5):r.getPixelForValue("object"==typeof u?u:NaN,e,d),h=i?s.getBasePixel():s.getPixelForValue(u,e,d);t._xScale=r,t._yScale=s,t._options=l,t._datasetIndex=d,t._index=e,t._model={backgroundColor:l.backgroundColor,borderColor:l.borderColor,borderWidth:l.borderWidth,hitRadius:l.hitRadius,pointStyle:l.pointStyle,radius:i?0:l.radius,skip:o.skip||isNaN(c)||isNaN(h),x:c,y:h},t.pivot()},setHoverStyle:function(t){var e=t._model,i=t._options;e.backgroundColor=o.valueOrDefault(i.hoverBackgroundColor,o.getHoverColor(i.backgroundColor)),e.borderColor=o.valueOrDefault(i.hoverBorderColor,o.getHoverColor(i.borderColor)),e.borderWidth=o.valueOrDefault(i.hoverBorderWidth,i.borderWidth),e.radius=i.radius+i.hoverRadius},removeHoverStyle:function(t){var e=t._model,i=t._options;e.backgroundColor=i.backgroundColor,e.borderColor=i.borderColor,e.borderWidth=i.borderWidth,e.radius=i.radius},_resolveElementOptions:function(t,e){var i,n,a,r=this.chart,s=r.data.datasets[this.index],l=t.custom||{},u=r.options.elements.point,d=o.options.resolve,c=s.data[e],h={},f={chart:r,dataIndex:e,dataset:s,datasetIndex:this.index},g=["backgroundColor","borderColor","borderWidth","hoverBackgroundColor","hoverBorderColor","hoverBorderWidth","hoverRadius","hitRadius","pointStyle"];for(i=0,n=g.length;i<n;++i)h[a=g[i]]=d([l[a],s[a],u[a]],f,e);return h.radius=d([l.radius,c?c.r:void 0,s.radius,u.radius],f,e),h}})}},{25:25,40:40,45:45}],17:[function(t,e,i){"use strict";var n=t(25),a=t(40),o=t(45);n._set("doughnut",{animation:{animateRotate:!0,animateScale:!1},hover:{mode:"single"},legendCallback:function(t){var e=[];e.push('<ul class="'+t.id+'-legend">');var i=t.data,n=i.datasets,a=i.labels;if(n.length)for(var o=0;o<n[0].data.length;++o)e.push('<li><span style="background-color:'+n[0].backgroundColor[o]+'"></span>'),a[o]&&e.push(a[o]),e.push("</li>");return e.push("</ul>"),e.join("")},legend:{labels:{generateLabels:function(t){var e=t.data;return e.labels.length&&e.datasets.length?e.labels.map(function(i,n){var a=t.getDatasetMeta(0),r=e.datasets[0],s=a.data[n],l=s&&s.custom||{},u=o.valueAtIndexOrDefault,d=t.options.elements.arc;return{text:i,fillStyle:l.backgroundColor?l.backgroundColor:u(r.backgroundColor,n,d.backgroundColor),strokeStyle:l.borderColor?l.borderColor:u(r.borderColor,n,d.borderColor),lineWidth:l.borderWidth?l.borderWidth:u(r.borderWidth,n,d.borderWidth),hidden:isNaN(r.data[n])||a.data[n].hidden,index:n}}):[]}},onClick:function(t,e){var i,n,a,o=e.index,r=this.chart;for(i=0,n=(r.data.datasets||[]).length;i<n;++i)(a=r.getDatasetMeta(i)).data[o]&&(a.data[o].hidden=!a.data[o].hidden);r.update()}},cutoutPercentage:50,rotation:-.5*Math.PI,circumference:2*Math.PI,tooltips:{callbacks:{title:function(){return""},label:function(t,e){var i=e.labels[t.index],n=": "+e.datasets[t.datasetIndex].data[t.index];return o.isArray(i)?(i=i.slice())[0]+=n:i+=n,i}}}}),n._set("pie",o.clone(n.doughnut)),n._set("pie",{cutoutPercentage:0}),e.exports=function(t){t.controllers.doughnut=t.controllers.pie=t.DatasetController.extend({dataElementType:a.Arc,linkScales:o.noop,getRingIndex:function(t){for(var e=0,i=0;i<t;++i)this.chart.isDatasetVisible(i)&&++e;return e},update:function(t){var e=this,i=e.chart,n=i.chartArea,a=i.options,r=a.elements.arc,s=n.right-n.left-r.borderWidth,l=n.bottom-n.top-r.borderWidth,u=Math.min(s,l),d={x:0,y:0},c=e.getMeta(),h=a.cutoutPercentage,f=a.circumference;if(f<2*Math.PI){var g=a.rotation%(2*Math.PI),p=(g+=2*Math.PI*(g>=Math.PI?-1:g<-Math.PI?1:0))+f,m=Math.cos(g),v=Math.sin(g),b=Math.cos(p),x=Math.sin(p),y=g<=0&&p>=0||g<=2*Math.PI&&2*Math.PI<=p,k=g<=.5*Math.PI&&.5*Math.PI<=p||g<=2.5*Math.PI&&2.5*Math.PI<=p,M=g<=-Math.PI&&-Math.PI<=p||g<=Math.PI&&Math.PI<=p,w=g<=.5*-Math.PI&&.5*-Math.PI<=p||g<=1.5*Math.PI&&1.5*Math.PI<=p,S=h/100,C=M?-1:Math.min(m*(m<0?1:S),b*(b<0?1:S)),_=w?-1:Math.min(v*(v<0?1:S),x*(x<0?1:S)),D=y?1:Math.max(m*(m>0?1:S),b*(b>0?1:S)),I=k?1:Math.max(v*(v>0?1:S),x*(x>0?1:S)),P=.5*(D-C),A=.5*(I-_);u=Math.min(s/P,l/A),d={x:-.5*(D+C),y:-.5*(I+_)}}i.borderWidth=e.getMaxBorderWidth(c.data),i.outerRadius=Math.max((u-i.borderWidth)/2,0),i.innerRadius=Math.max(h?i.outerRadius/100*h:0,0),i.radiusLength=(i.outerRadius-i.innerRadius)/i.getVisibleDatasetCount(),i.offsetX=d.x*i.outerRadius,i.offsetY=d.y*i.outerRadius,c.total=e.calculateTotal(),e.outerRadius=i.outerRadius-i.radiusLength*e.getRingIndex(e.index),e.innerRadius=Math.max(e.outerRadius-i.radiusLength,0),o.each(c.data,function(i,n){e.updateElement(i,n,t)})},updateElement:function(t,e,i){var n=this,a=n.chart,r=a.chartArea,s=a.options,l=s.animation,u=(r.left+r.right)/2,d=(r.top+r.bottom)/2,c=s.rotation,h=s.rotation,f=n.getDataset(),g=i&&l.animateRotate?0:t.hidden?0:n.calculateCircumference(f.data[e])*(s.circumference/(2*Math.PI)),p=i&&l.animateScale?0:n.innerRadius,m=i&&l.animateScale?0:n.outerRadius,v=o.valueAtIndexOrDefault;o.extend(t,{_datasetIndex:n.index,_index:e,_model:{x:u+a.offsetX,y:d+a.offsetY,startAngle:c,endAngle:h,circumference:g,outerRadius:m,innerRadius:p,label:v(f.label,e,a.data.labels[e])}});var b=t._model;this.removeHoverStyle(t),i&&l.animateRotate||(b.startAngle=0===e?s.rotation:n.getMeta().data[e-1]._model.endAngle,b.endAngle=b.startAngle+b.circumference),t.pivot()},removeHoverStyle:function(e){t.DatasetController.prototype.removeHoverStyle.call(this,e,this.chart.options.elements.arc)},calculateTotal:function(){var t,e=this.getDataset(),i=this.getMeta(),n=0;return o.each(i.data,function(i,a){t=e.data[a],isNaN(t)||i.hidden||(n+=Math.abs(t))}),n},calculateCircumference:function(t){var e=this.getMeta().total;return e>0&&!isNaN(t)?2*Math.PI*(Math.abs(t)/e):0},getMaxBorderWidth:function(t){for(var e,i,n=0,a=this.index,o=t.length,r=0;r<o;r++)e=t[r]._model?t[r]._model.borderWidth:0,n=(i=t[r]._chart?t[r]._chart.config.data.datasets[a].hoverBorderWidth:0)>(n=e>n?e:n)?i:n;return n}})}},{25:25,40:40,45:45}],18:[function(t,e,i){"use strict";var n=t(25),a=t(40),o=t(45);n._set("line",{showLines:!0,spanGaps:!1,hover:{mode:"label"},scales:{xAxes:[{type:"category",id:"x-axis-0"}],yAxes:[{type:"linear",id:"y-axis-0"}]}}),e.exports=function(t){function e(t,e){return o.valueOrDefault(t.showLine,e.showLines)}t.controllers.line=t.DatasetController.extend({datasetElementType:a.Line,dataElementType:a.Point,update:function(t){var i,n,a,r=this,s=r.getMeta(),l=s.dataset,u=s.data||[],d=r.chart.options,c=d.elements.line,h=r.getScaleForId(s.yAxisID),f=r.getDataset(),g=e(f,d);for(g&&(a=l.custom||{},void 0!==f.tension&&void 0===f.lineTension&&(f.lineTension=f.tension),l._scale=h,l._datasetIndex=r.index,l._children=u,l._model={spanGaps:f.spanGaps?f.spanGaps:d.spanGaps,tension:a.tension?a.tension:o.valueOrDefault(f.lineTension,c.tension),backgroundColor:a.backgroundColor?a.backgroundColor:f.backgroundColor||c.backgroundColor,borderWidth:a.borderWidth?a.borderWidth:f.borderWidth||c.borderWidth,borderColor:a.borderColor?a.borderColor:f.borderColor||c.borderColor,borderCapStyle:a.borderCapStyle?a.borderCapStyle:f.borderCapStyle||c.borderCapStyle,borderDash:a.borderDash?a.borderDash:f.borderDash||c.borderDash,borderDashOffset:a.borderDashOffset?a.borderDashOffset:f.borderDashOffset||c.borderDashOffset,borderJoinStyle:a.borderJoinStyle?a.borderJoinStyle:f.borderJoinStyle||c.borderJoinStyle,fill:a.fill?a.fill:void 0!==f.fill?f.fill:c.fill,steppedLine:a.steppedLine?a.steppedLine:o.valueOrDefault(f.steppedLine,c.stepped),cubicInterpolationMode:a.cubicInterpolationMode?a.cubicInterpolationMode:o.valueOrDefault(f.cubicInterpolationMode,c.cubicInterpolationMode)},l.pivot()),i=0,n=u.length;i<n;++i)r.updateElement(u[i],i,t);for(g&&0!==l._model.tension&&r.updateBezierControlPoints(),i=0,n=u.length;i<n;++i)u[i].pivot()},getPointBackgroundColor:function(t,e){var i=this.chart.options.elements.point.backgroundColor,n=this.getDataset(),a=t.custom||{};return a.backgroundColor?i=a.backgroundColor:n.pointBackgroundColor?i=o.valueAtIndexOrDefault(n.pointBackgroundColor,e,i):n.backgroundColor&&(i=n.backgroundColor),i},getPointBorderColor:function(t,e){var i=this.chart.options.elements.point.borderColor,n=this.getDataset(),a=t.custom||{};return a.borderColor?i=a.borderColor:n.pointBorderColor?i=o.valueAtIndexOrDefault(n.pointBorderColor,e,i):n.borderColor&&(i=n.borderColor),i},getPointBorderWidth:function(t,e){var i=this.chart.options.elements.point.borderWidth,n=this.getDataset(),a=t.custom||{};return isNaN(a.borderWidth)?!isNaN(n.pointBorderWidth)||o.isArray(n.pointBorderWidth)?i=o.valueAtIndexOrDefault(n.pointBorderWidth,e,i):isNaN(n.borderWidth)||(i=n.borderWidth):i=a.borderWidth,i},updateElement:function(t,e,i){var n,a,r=this,s=r.getMeta(),l=t.custom||{},u=r.getDataset(),d=r.index,c=u.data[e],h=r.getScaleForId(s.yAxisID),f=r.getScaleForId(s.xAxisID),g=r.chart.options.elements.point;void 0!==u.radius&&void 0===u.pointRadius&&(u.pointRadius=u.radius),void 0!==u.hitRadius&&void 0===u.pointHitRadius&&(u.pointHitRadius=u.hitRadius),n=f.getPixelForValue("object"==typeof c?c:NaN,e,d),a=i?h.getBasePixel():r.calculatePointY(c,e,d),t._xScale=f,t._yScale=h,t._datasetIndex=d,t._index=e,t._model={x:n,y:a,skip:l.skip||isNaN(n)||isNaN(a),radius:l.radius||o.valueAtIndexOrDefault(u.pointRadius,e,g.radius),pointStyle:l.pointStyle||o.valueAtIndexOrDefault(u.pointStyle,e,g.pointStyle),backgroundColor:r.getPointBackgroundColor(t,e),borderColor:r.getPointBorderColor(t,e),borderWidth:r.getPointBorderWidth(t,e),tension:s.dataset._model?s.dataset._model.tension:0,steppedLine:!!s.dataset._model&&s.dataset._model.steppedLine,hitRadius:l.hitRadius||o.valueAtIndexOrDefault(u.pointHitRadius,e,g.hitRadius)}},calculatePointY:function(t,e,i){var n,a,o,r=this.chart,s=this.getMeta(),l=this.getScaleForId(s.yAxisID),u=0,d=0;if(l.options.stacked){for(n=0;n<i;n++)if(a=r.data.datasets[n],"line"===(o=r.getDatasetMeta(n)).type&&o.yAxisID===l.id&&r.isDatasetVisible(n)){var c=Number(l.getRightValue(a.data[e]));c<0?d+=c||0:u+=c||0}var h=Number(l.getRightValue(t));return h<0?l.getPixelForValue(d+h):l.getPixelForValue(u+h)}return l.getPixelForValue(t)},updateBezierControlPoints:function(){var t,e,i,n,a=this.getMeta(),r=this.chart.chartArea,s=a.data||[];function l(t,e,i){return Math.max(Math.min(t,i),e)}if(a.dataset._model.spanGaps&&(s=s.filter(function(t){return!t._model.skip})),"monotone"===a.dataset._model.cubicInterpolationMode)o.splineCurveMonotone(s);else for(t=0,e=s.length;t<e;++t)i=s[t]._model,n=o.splineCurve(o.previousItem(s,t)._model,i,o.nextItem(s,t)._model,a.dataset._model.tension),i.controlPointPreviousX=n.previous.x,i.controlPointPreviousY=n.previous.y,i.controlPointNextX=n.next.x,i.controlPointNextY=n.next.y;if(this.chart.options.elements.line.capBezierPoints)for(t=0,e=s.length;t<e;++t)(i=s[t]._model).controlPointPreviousX=l(i.controlPointPreviousX,r.left,r.right),i.controlPointPreviousY=l(i.controlPointPreviousY,r.top,r.bottom),i.controlPointNextX=l(i.controlPointNextX,r.left,r.right),i.controlPointNextY=l(i.controlPointNextY,r.top,r.bottom)},draw:function(){var t=this.chart,i=this.getMeta(),n=i.data||[],a=t.chartArea,r=n.length,s=0;for(o.canvas.clipArea(t.ctx,a),e(this.getDataset(),t.options)&&i.dataset.draw(),o.canvas.unclipArea(t.ctx);s<r;++s)n[s].draw(a)},setHoverStyle:function(t){var e=this.chart.data.datasets[t._datasetIndex],i=t._index,n=t.custom||{},a=t._model;a.radius=n.hoverRadius||o.valueAtIndexOrDefault(e.pointHoverRadius,i,this.chart.options.elements.point.hoverRadius),a.backgroundColor=n.hoverBackgroundColor||o.valueAtIndexOrDefault(e.pointHoverBackgroundColor,i,o.getHoverColor(a.backgroundColor)),a.borderColor=n.hoverBorderColor||o.valueAtIndexOrDefault(e.pointHoverBorderColor,i,o.getHoverColor(a.borderColor)),a.borderWidth=n.hoverBorderWidth||o.valueAtIndexOrDefault(e.pointHoverBorderWidth,i,a.borderWidth)},removeHoverStyle:function(t){var e=this,i=e.chart.data.datasets[t._datasetIndex],n=t._index,a=t.custom||{},r=t._model;void 0!==i.radius&&void 0===i.pointRadius&&(i.pointRadius=i.radius),r.radius=a.radius||o.valueAtIndexOrDefault(i.pointRadius,n,e.chart.options.elements.point.radius),r.backgroundColor=e.getPointBackgroundColor(t,n),r.borderColor=e.getPointBorderColor(t,n),r.borderWidth=e.getPointBorderWidth(t,n)}})}},{25:25,40:40,45:45}],19:[function(t,e,i){"use strict";var n=t(25),a=t(40),o=t(45);n._set("polarArea",{scale:{type:"radialLinear",angleLines:{display:!1},gridLines:{circular:!0},pointLabels:{display:!1},ticks:{beginAtZero:!0}},animation:{animateRotate:!0,animateScale:!0},startAngle:-.5*Math.PI,legendCallback:function(t){var e=[];e.push('<ul class="'+t.id+'-legend">');var i=t.data,n=i.datasets,a=i.labels;if(n.length)for(var o=0;o<n[0].data.length;++o)e.push('<li><span style="background-color:'+n[0].backgroundColor[o]+'"></span>'),a[o]&&e.push(a[o]),e.push("</li>");return e.push("</ul>"),e.join("")},legend:{labels:{generateLabels:function(t){var e=t.data;return e.labels.length&&e.datasets.length?e.labels.map(function(i,n){var a=t.getDatasetMeta(0),r=e.datasets[0],s=a.data[n].custom||{},l=o.valueAtIndexOrDefault,u=t.options.elements.arc;return{text:i,fillStyle:s.backgroundColor?s.backgroundColor:l(r.backgroundColor,n,u.backgroundColor),strokeStyle:s.borderColor?s.borderColor:l(r.borderColor,n,u.borderColor),lineWidth:s.borderWidth?s.borderWidth:l(r.borderWidth,n,u.borderWidth),hidden:isNaN(r.data[n])||a.data[n].hidden,index:n}}):[]}},onClick:function(t,e){var i,n,a,o=e.index,r=this.chart;for(i=0,n=(r.data.datasets||[]).length;i<n;++i)(a=r.getDatasetMeta(i)).data[o].hidden=!a.data[o].hidden;r.update()}},tooltips:{callbacks:{title:function(){return""},label:function(t,e){return e.labels[t.index]+": "+t.yLabel}}}}),e.exports=function(t){t.controllers.polarArea=t.DatasetController.extend({dataElementType:a.Arc,linkScales:o.noop,update:function(t){var e=this,i=e.chart,n=i.chartArea,a=e.getMeta(),r=i.options,s=r.elements.arc,l=Math.min(n.right-n.left,n.bottom-n.top);i.outerRadius=Math.max((l-s.borderWidth/2)/2,0),i.innerRadius=Math.max(r.cutoutPercentage?i.outerRadius/100*r.cutoutPercentage:1,0),i.radiusLength=(i.outerRadius-i.innerRadius)/i.getVisibleDatasetCount(),e.outerRadius=i.outerRadius-i.radiusLength*e.index,e.innerRadius=e.outerRadius-i.radiusLength,a.count=e.countVisibleElements(),o.each(a.data,function(i,n){e.updateElement(i,n,t)})},updateElement:function(t,e,i){for(var n=this,a=n.chart,r=n.getDataset(),s=a.options,l=s.animation,u=a.scale,d=a.data.labels,c=n.calculateCircumference(r.data[e]),h=u.xCenter,f=u.yCenter,g=0,p=n.getMeta(),m=0;m<e;++m)isNaN(r.data[m])||p.data[m].hidden||++g;var v=s.startAngle,b=t.hidden?0:u.getDistanceFromCenterForValue(r.data[e]),x=v+c*g,y=x+(t.hidden?0:c),k=l.animateScale?0:u.getDistanceFromCenterForValue(r.data[e]);o.extend(t,{_datasetIndex:n.index,_index:e,_scale:u,_model:{x:h,y:f,innerRadius:0,outerRadius:i?k:b,startAngle:i&&l.animateRotate?v:x,endAngle:i&&l.animateRotate?v:y,label:o.valueAtIndexOrDefault(d,e,d[e])}}),n.removeHoverStyle(t),t.pivot()},removeHoverStyle:function(e){t.DatasetController.prototype.removeHoverStyle.call(this,e,this.chart.options.elements.arc)},countVisibleElements:function(){var t=this.getDataset(),e=this.getMeta(),i=0;return o.each(e.data,function(e,n){isNaN(t.data[n])||e.hidden||i++}),i},calculateCircumference:function(t){var e=this.getMeta().count;return e>0&&!isNaN(t)?2*Math.PI/e:0}})}},{25:25,40:40,45:45}],20:[function(t,e,i){"use strict";var n=t(25),a=t(40),o=t(45);n._set("radar",{scale:{type:"radialLinear"},elements:{line:{tension:0}}}),e.exports=function(t){t.controllers.radar=t.DatasetController.extend({datasetElementType:a.Line,dataElementType:a.Point,linkScales:o.noop,update:function(t){var e=this,i=e.getMeta(),n=i.dataset,a=i.data,r=n.custom||{},s=e.getDataset(),l=e.chart.options.elements.line,u=e.chart.scale;void 0!==s.tension&&void 0===s.lineTension&&(s.lineTension=s.tension),o.extend(i.dataset,{_datasetIndex:e.index,_scale:u,_children:a,_loop:!0,_model:{tension:r.tension?r.tension:o.valueOrDefault(s.lineTension,l.tension),backgroundColor:r.backgroundColor?r.backgroundColor:s.backgroundColor||l.backgroundColor,borderWidth:r.borderWidth?r.borderWidth:s.borderWidth||l.borderWidth,borderColor:r.borderColor?r.borderColor:s.borderColor||l.borderColor,fill:r.fill?r.fill:void 0!==s.fill?s.fill:l.fill,borderCapStyle:r.borderCapStyle?r.borderCapStyle:s.borderCapStyle||l.borderCapStyle,borderDash:r.borderDash?r.borderDash:s.borderDash||l.borderDash,borderDashOffset:r.borderDashOffset?r.borderDashOffset:s.borderDashOffset||l.borderDashOffset,borderJoinStyle:r.borderJoinStyle?r.borderJoinStyle:s.borderJoinStyle||l.borderJoinStyle}}),i.dataset.pivot(),o.each(a,function(i,n){e.updateElement(i,n,t)},e),e.updateBezierControlPoints()},updateElement:function(t,e,i){var n=this,a=t.custom||{},r=n.getDataset(),s=n.chart.scale,l=n.chart.options.elements.point,u=s.getPointPositionForValue(e,r.data[e]);void 0!==r.radius&&void 0===r.pointRadius&&(r.pointRadius=r.radius),void 0!==r.hitRadius&&void 0===r.pointHitRadius&&(r.pointHitRadius=r.hitRadius),o.extend(t,{_datasetIndex:n.index,_index:e,_scale:s,_model:{x:i?s.xCenter:u.x,y:i?s.yCenter:u.y,tension:a.tension?a.tension:o.valueOrDefault(r.lineTension,n.chart.options.elements.line.tension),radius:a.radius?a.radius:o.valueAtIndexOrDefault(r.pointRadius,e,l.radius),backgroundColor:a.backgroundColor?a.backgroundColor:o.valueAtIndexOrDefault(r.pointBackgroundColor,e,l.backgroundColor),borderColor:a.borderColor?a.borderColor:o.valueAtIndexOrDefault(r.pointBorderColor,e,l.borderColor),borderWidth:a.borderWidth?a.borderWidth:o.valueAtIndexOrDefault(r.pointBorderWidth,e,l.borderWidth),pointStyle:a.pointStyle?a.pointStyle:o.valueAtIndexOrDefault(r.pointStyle,e,l.pointStyle),hitRadius:a.hitRadius?a.hitRadius:o.valueAtIndexOrDefault(r.pointHitRadius,e,l.hitRadius)}}),t._model.skip=a.skip?a.skip:isNaN(t._model.x)||isNaN(t._model.y)},updateBezierControlPoints:function(){var t=this.chart.chartArea,e=this.getMeta();o.each(e.data,function(i,n){var a=i._model,r=o.splineCurve(o.previousItem(e.data,n,!0)._model,a,o.nextItem(e.data,n,!0)._model,a.tension);a.controlPointPreviousX=Math.max(Math.min(r.previous.x,t.right),t.left),a.controlPointPreviousY=Math.max(Math.min(r.previous.y,t.bottom),t.top),a.controlPointNextX=Math.max(Math.min(r.next.x,t.right),t.left),a.controlPointNextY=Math.max(Math.min(r.next.y,t.bottom),t.top),i.pivot()})},setHoverStyle:function(t){var e=this.chart.data.datasets[t._datasetIndex],i=t.custom||{},n=t._index,a=t._model;a.radius=i.hoverRadius?i.hoverRadius:o.valueAtIndexOrDefault(e.pointHoverRadius,n,this.chart.options.elements.point.hoverRadius),a.backgroundColor=i.hoverBackgroundColor?i.hoverBackgroundColor:o.valueAtIndexOrDefault(e.pointHoverBackgroundColor,n,o.getHoverColor(a.backgroundColor)),a.borderColor=i.hoverBorderColor?i.hoverBorderColor:o.valueAtIndexOrDefault(e.pointHoverBorderColor,n,o.getHoverColor(a.borderColor)),a.borderWidth=i.hoverBorderWidth?i.hoverBorderWidth:o.valueAtIndexOrDefault(e.pointHoverBorderWidth,n,a.borderWidth)},removeHoverStyle:function(t){var e=this.chart.data.datasets[t._datasetIndex],i=t.custom||{},n=t._index,a=t._model,r=this.chart.options.elements.point;a.radius=i.radius?i.radius:o.valueAtIndexOrDefault(e.pointRadius,n,r.radius),a.backgroundColor=i.backgroundColor?i.backgroundColor:o.valueAtIndexOrDefault(e.pointBackgroundColor,n,r.backgroundColor),a.borderColor=i.borderColor?i.borderColor:o.valueAtIndexOrDefault(e.pointBorderColor,n,r.borderColor),a.borderWidth=i.borderWidth?i.borderWidth:o.valueAtIndexOrDefault(e.pointBorderWidth,n,r.borderWidth)}})}},{25:25,40:40,45:45}],21:[function(t,e,i){"use strict";t(25)._set("scatter",{hover:{mode:"single"},scales:{xAxes:[{id:"x-axis-1",type:"linear",position:"bottom"}],yAxes:[{id:"y-axis-1",type:"linear",position:"left"}]},showLines:!1,tooltips:{callbacks:{title:function(){return""},label:function(t){return"("+t.xLabel+", "+t.yLabel+")"}}}}),e.exports=function(t){t.controllers.scatter=t.controllers.line}},{25:25}],22:[function(t,e,i){"use strict";var n=t(25),a=t(26),o=t(45);n._set("global",{animation:{duration:1e3,easing:"easeOutQuart",onProgress:o.noop,onComplete:o.noop}}),e.exports=function(t){t.Animation=a.extend({chart:null,currentStep:0,numSteps:60,easing:"",render:null,onAnimationProgress:null,onAnimationComplete:null}),t.animationService={frameDuration:17,animations:[],dropFrames:0,request:null,addAnimation:function(t,e,i,n){var a,o,r=this.animations;for(e.chart=t,n||(t.animating=!0),a=0,o=r.length;a<o;++a)if(r[a].chart===t)return void(r[a]=e);r.push(e),1===r.length&&this.requestAnimationFrame()},cancelAnimation:function(t){var e=o.findIndex(this.animations,function(e){return e.chart===t});-1!==e&&(this.animations.splice(e,1),t.animating=!1)},requestAnimationFrame:function(){var t=this;null===t.request&&(t.request=o.requestAnimFrame.call(window,function(){t.request=null,t.startDigest()}))},startDigest:function(){var t=this,e=Date.now(),i=0;t.dropFrames>1&&(i=Math.floor(t.dropFrames),t.dropFrames=t.dropFrames%1),t.advance(1+i);var n=Date.now();t.dropFrames+=(n-e)/t.frameDuration,t.animations.length>0&&t.requestAnimationFrame()},advance:function(t){for(var e,i,n=this.animations,a=0;a<n.length;)i=(e=n[a]).chart,e.currentStep=(e.currentStep||0)+t,e.currentStep=Math.min(e.currentStep,e.numSteps),o.callback(e.render,[i,e],i),o.callback(e.onAnimationProgress,[e],i),e.currentStep>=e.numSteps?(o.callback(e.onAnimationComplete,[e],i),i.animating=!1,n.splice(a,1)):++a}},Object.defineProperty(t.Animation.prototype,"animationObject",{get:function(){return this}}),Object.defineProperty(t.Animation.prototype,"chartInstance",{get:function(){return this.chart},set:function(t){this.chart=t}})}},{25:25,26:26,45:45}],23:[function(t,e,i){"use strict";var n=t(25),a=t(45),o=t(28),r=t(30),s=t(48),l=t(31);e.exports=function(t){function e(t){return"top"===t||"bottom"===t}t.types={},t.instances={},t.controllers={},a.extend(t.prototype,{construct:function(e,i){var o,r,l=this;(r=(o=(o=i)||{}).data=o.data||{}).datasets=r.datasets||[],r.labels=r.labels||[],o.options=a.configMerge(n.global,n[o.type],o.options||{}),i=o;var u=s.acquireContext(e,i),d=u&&u.canvas,c=d&&d.height,h=d&&d.width;l.id=a.uid(),l.ctx=u,l.canvas=d,l.config=i,l.width=h,l.height=c,l.aspectRatio=c?h/c:null,l.options=i.options,l._bufferedRender=!1,l.chart=l,l.controller=l,t.instances[l.id]=l,Object.defineProperty(l,"data",{get:function(){return l.config.data},set:function(t){l.config.data=t}}),u&&d?(l.initialize(),l.update()):console.error("Failed to create chart: can't acquire context from the given item")},initialize:function(){var t=this;return l.notify(t,"beforeInit"),a.retinaScale(t,t.options.devicePixelRatio),t.bindEvents(),t.options.responsive&&t.resize(!0),t.ensureScalesHaveIDs(),t.buildOrUpdateScales(),t.initToolTip(),l.notify(t,"afterInit"),t},clear:function(){return a.canvas.clear(this),this},stop:function(){return t.animationService.cancelAnimation(this),this},resize:function(t){var e=this,i=e.options,n=e.canvas,o=i.maintainAspectRatio&&e.aspectRatio||null,r=Math.max(0,Math.floor(a.getMaximumWidth(n))),s=Math.max(0,Math.floor(o?r/o:a.getMaximumHeight(n)));if((e.width!==r||e.height!==s)&&(n.width=e.width=r,n.height=e.height=s,n.style.width=r+"px",n.style.height=s+"px",a.retinaScale(e,i.devicePixelRatio),!t)){var u={width:r,height:s};l.notify(e,"resize",[u]),e.options.onResize&&e.options.onResize(e,u),e.stop(),e.update(e.options.responsiveAnimationDuration)}},ensureScalesHaveIDs:function(){var t=this.options,e=t.scales||{},i=t.scale;a.each(e.xAxes,function(t,e){t.id=t.id||"x-axis-"+e}),a.each(e.yAxes,function(t,e){t.id=t.id||"y-axis-"+e}),i&&(i.id=i.id||"scale")},buildOrUpdateScales:function(){var i=this,n=i.options,o=i.scales||{},r=[],s=Object.keys(o).reduce(function(t,e){return t[e]=!1,t},{});n.scales&&(r=r.concat((n.scales.xAxes||[]).map(function(t){return{options:t,dtype:"category",dposition:"bottom"}}),(n.scales.yAxes||[]).map(function(t){return{options:t,dtype:"linear",dposition:"left"}}))),n.scale&&r.push({options:n.scale,dtype:"radialLinear",isDefault:!0,dposition:"chartArea"}),a.each(r,function(n){var r=n.options,l=r.id,u=a.valueOrDefault(r.type,n.dtype);e(r.position)!==e(n.dposition)&&(r.position=n.dposition),s[l]=!0;var d=null;if(l in o&&o[l].type===u)(d=o[l]).options=r,d.ctx=i.ctx,d.chart=i;else{var c=t.scaleService.getScaleConstructor(u);if(!c)return;d=new c({id:l,type:u,options:r,ctx:i.ctx,chart:i}),o[d.id]=d}d.mergeTicksOptions(),n.isDefault&&(i.scale=d)}),a.each(s,function(t,e){t||delete o[e]}),i.scales=o,t.scaleService.addScalesToLayout(this)},buildOrUpdateControllers:function(){var e=this,i=[],n=[];return a.each(e.data.datasets,function(a,o){var r=e.getDatasetMeta(o),s=a.type||e.config.type;if(r.type&&r.type!==s&&(e.destroyDatasetMeta(o),r=e.getDatasetMeta(o)),r.type=s,i.push(r.type),r.controller)r.controller.updateIndex(o),r.controller.linkScales();else{var l=t.controllers[r.type];if(void 0===l)throw new Error('"'+r.type+'" is not a chart type.');r.controller=new l(e,o),n.push(r.controller)}},e),n},resetElements:function(){var t=this;a.each(t.data.datasets,function(e,i){t.getDatasetMeta(i).controller.reset()},t)},reset:function(){this.resetElements(),this.tooltip.initialize()},update:function(e){var i,n,o=this;if(e&&"object"==typeof e||(e={duration:e,lazy:arguments[1]}),n=(i=o).options,a.each(i.scales,function(t){r.removeBox(i,t)}),n=a.configMerge(t.defaults.global,t.defaults[i.config.type],n),i.options=i.config.options=n,i.ensureScalesHaveIDs(),i.buildOrUpdateScales(),i.tooltip._options=n.tooltips,i.tooltip.initialize(),l._invalidate(o),!1!==l.notify(o,"beforeUpdate")){o.tooltip._data=o.data;var s=o.buildOrUpdateControllers();a.each(o.data.datasets,function(t,e){o.getDatasetMeta(e).controller.buildOrUpdateElements()},o),o.updateLayout(),o.options.animation&&o.options.animation.duration&&a.each(s,function(t){t.reset()}),o.updateDatasets(),o.tooltip.initialize(),o.lastActive=[],l.notify(o,"afterUpdate"),o._bufferedRender?o._bufferedRequest={duration:e.duration,easing:e.easing,lazy:e.lazy}:o.render(e)}},updateLayout:function(){!1!==l.notify(this,"beforeLayout")&&(r.update(this,this.width,this.height),l.notify(this,"afterScaleUpdate"),l.notify(this,"afterLayout"))},updateDatasets:function(){if(!1!==l.notify(this,"beforeDatasetsUpdate")){for(var t=0,e=this.data.datasets.length;t<e;++t)this.updateDataset(t);l.notify(this,"afterDatasetsUpdate")}},updateDataset:function(t){var e=this.getDatasetMeta(t),i={meta:e,index:t};!1!==l.notify(this,"beforeDatasetUpdate",[i])&&(e.controller.update(),l.notify(this,"afterDatasetUpdate",[i]))},render:function(e){var i=this;e&&"object"==typeof e||(e={duration:e,lazy:arguments[1]});var n=e.duration,o=e.lazy;if(!1!==l.notify(i,"beforeRender")){var r=i.options.animation,s=function(t){l.notify(i,"afterRender"),a.callback(r&&r.onComplete,[t],i)};if(r&&(void 0!==n&&0!==n||void 0===n&&0!==r.duration)){var u=new t.Animation({numSteps:(n||r.duration)/16.66,easing:e.easing||r.easing,render:function(t,e){var i=a.easing.effects[e.easing],n=e.currentStep,o=n/e.numSteps;t.draw(i(o),o,n)},onAnimationProgress:r.onProgress,onAnimationComplete:s});t.animationService.addAnimation(i,u,n,o)}else i.draw(),s(new t.Animation({numSteps:0,chart:i}));return i}},draw:function(t){var e=this;e.clear(),a.isNullOrUndef(t)&&(t=1),e.transition(t),!1!==l.notify(e,"beforeDraw",[t])&&(a.each(e.boxes,function(t){t.draw(e.chartArea)},e),e.scale&&e.scale.draw(),e.drawDatasets(t),e._drawTooltip(t),l.notify(e,"afterDraw",[t]))},transition:function(t){for(var e=0,i=(this.data.datasets||[]).length;e<i;++e)this.isDatasetVisible(e)&&this.getDatasetMeta(e).controller.transition(t);this.tooltip.transition(t)},drawDatasets:function(t){var e=this;if(!1!==l.notify(e,"beforeDatasetsDraw",[t])){for(var i=(e.data.datasets||[]).length-1;i>=0;--i)e.isDatasetVisible(i)&&e.drawDataset(i,t);l.notify(e,"afterDatasetsDraw",[t])}},drawDataset:function(t,e){var i=this.getDatasetMeta(t),n={meta:i,index:t,easingValue:e};!1!==l.notify(this,"beforeDatasetDraw",[n])&&(i.controller.draw(e),l.notify(this,"afterDatasetDraw",[n]))},_drawTooltip:function(t){var e=this.tooltip,i={tooltip:e,easingValue:t};!1!==l.notify(this,"beforeTooltipDraw",[i])&&(e.draw(),l.notify(this,"afterTooltipDraw",[i]))},getElementAtEvent:function(t){return o.modes.single(this,t)},getElementsAtEvent:function(t){return o.modes.label(this,t,{intersect:!0})},getElementsAtXAxis:function(t){return o.modes["x-axis"](this,t,{intersect:!0})},getElementsAtEventForMode:function(t,e,i){var n=o.modes[e];return"function"==typeof n?n(this,t,i):[]},getDatasetAtEvent:function(t){return o.modes.dataset(this,t,{intersect:!0})},getDatasetMeta:function(t){var e=this.data.datasets[t];e._meta||(e._meta={});var i=e._meta[this.id];return i||(i=e._meta[this.id]={type:null,data:[],dataset:null,controller:null,hidden:null,xAxisID:null,yAxisID:null}),i},getVisibleDatasetCount:function(){for(var t=0,e=0,i=this.data.datasets.length;e<i;++e)this.isDatasetVisible(e)&&t++;return t},isDatasetVisible:function(t){var e=this.getDatasetMeta(t);return"boolean"==typeof e.hidden?!e.hidden:!this.data.datasets[t].hidden},generateLegend:function(){return this.options.legendCallback(this)},destroyDatasetMeta:function(t){var e=this.id,i=this.data.datasets[t],n=i._meta&&i._meta[e];n&&(n.controller.destroy(),delete i._meta[e])},destroy:function(){var e,i,n=this,o=n.canvas;for(n.stop(),e=0,i=n.data.datasets.length;e<i;++e)n.destroyDatasetMeta(e);o&&(n.unbindEvents(),a.canvas.clear(n),s.releaseContext(n.ctx),n.canvas=null,n.ctx=null),l.notify(n,"destroy"),delete t.instances[n.id]},toBase64Image:function(){return this.canvas.toDataURL.apply(this.canvas,arguments)},initToolTip:function(){var e=this;e.tooltip=new t.Tooltip({_chart:e,_chartInstance:e,_data:e.data,_options:e.options.tooltips},e)},bindEvents:function(){var t=this,e=t._listeners={},i=function(){t.eventHandler.apply(t,arguments)};a.each(t.options.events,function(n){s.addEventListener(t,n,i),e[n]=i}),t.options.responsive&&(i=function(){t.resize()},s.addEventListener(t,"resize",i),e.resize=i)},unbindEvents:function(){var t=this,e=t._listeners;e&&(delete t._listeners,a.each(e,function(e,i){s.removeEventListener(t,i,e)}))},updateHoverStyle:function(t,e,i){var n,a,o,r=i?"setHoverStyle":"removeHoverStyle";for(a=0,o=t.length;a<o;++a)(n=t[a])&&this.getDatasetMeta(n._datasetIndex).controller[r](n)},eventHandler:function(t){var e=this,i=e.tooltip;if(!1!==l.notify(e,"beforeEvent",[t])){e._bufferedRender=!0,e._bufferedRequest=null;var n=e.handleEvent(t);i&&(n=i._start?i.handleEvent(t):n|i.handleEvent(t)),l.notify(e,"afterEvent",[t]);var a=e._bufferedRequest;return a?e.render(a):n&&!e.animating&&(e.stop(),e.render(e.options.hover.animationDuration,!0)),e._bufferedRender=!1,e._bufferedRequest=null,e}},handleEvent:function(t){var e,i=this,n=i.options||{},o=n.hover;return i.lastActive=i.lastActive||[],"mouseout"===t.type?i.active=[]:i.active=i.getElementsAtEventForMode(t,o.mode,o),a.callback(n.onHover||n.hover.onHover,[t.native,i.active],i),"mouseup"!==t.type&&"click"!==t.type||n.onClick&&n.onClick.call(i,t.native,i.active),i.lastActive.length&&i.updateHoverStyle(i.lastActive,o.mode,!1),i.active.length&&o.mode&&i.updateHoverStyle(i.active,o.mode,!0),e=!a.arrayEquals(i.active,i.lastActive),i.lastActive=i.active,e}}),t.Controller=t}},{25:25,28:28,30:30,31:31,45:45,48:48}],24:[function(t,e,i){"use strict";var n=t(45);e.exports=function(t){var e=["push","pop","shift","splice","unshift"];function i(t,i){var n=t._chartjs;if(n){var a=n.listeners,o=a.indexOf(i);-1!==o&&a.splice(o,1),a.length>0||(e.forEach(function(e){delete t[e]}),delete t._chartjs)}}t.DatasetController=function(t,e){this.initialize(t,e)},n.extend(t.DatasetController.prototype,{datasetElementType:null,dataElementType:null,initialize:function(t,e){this.chart=t,this.index=e,this.linkScales(),this.addElements()},updateIndex:function(t){this.index=t},linkScales:function(){var t=this,e=t.getMeta(),i=t.getDataset();null!==e.xAxisID&&e.xAxisID in t.chart.scales||(e.xAxisID=i.xAxisID||t.chart.options.scales.xAxes[0].id),null!==e.yAxisID&&e.yAxisID in t.chart.scales||(e.yAxisID=i.yAxisID||t.chart.options.scales.yAxes[0].id)},getDataset:function(){return this.chart.data.datasets[this.index]},getMeta:function(){return this.chart.getDatasetMeta(this.index)},getScaleForId:function(t){return this.chart.scales[t]},reset:function(){this.update(!0)},destroy:function(){this._data&&i(this._data,this)},createMetaDataset:function(){var t=this.datasetElementType;return t&&new t({_chart:this.chart,_datasetIndex:this.index})},createMetaData:function(t){var e=this.dataElementType;return e&&new e({_chart:this.chart,_datasetIndex:this.index,_index:t})},addElements:function(){var t,e,i=this.getMeta(),n=this.getDataset().data||[],a=i.data;for(t=0,e=n.length;t<e;++t)a[t]=a[t]||this.createMetaData(t);i.dataset=i.dataset||this.createMetaDataset()},addElementAndReset:function(t){var e=this.createMetaData(t);this.getMeta().data.splice(t,0,e),this.updateElement(e,t,!0)},buildOrUpdateElements:function(){var t,a,o=this,r=o.getDataset(),s=r.data||(r.data=[]);o._data!==s&&(o._data&&i(o._data,o),a=o,(t=s)._chartjs?t._chartjs.listeners.push(a):(Object.defineProperty(t,"_chartjs",{configurable:!0,enumerable:!1,value:{listeners:[a]}}),e.forEach(function(e){var i="onData"+e.charAt(0).toUpperCase()+e.slice(1),a=t[e];Object.defineProperty(t,e,{configurable:!0,enumerable:!1,value:function(){var e=Array.prototype.slice.call(arguments),o=a.apply(this,e);return n.each(t._chartjs.listeners,function(t){"function"==typeof t[i]&&t[i].apply(t,e)}),o}})})),o._data=s),o.resyncElements()},update:n.noop,transition:function(t){for(var e=this.getMeta(),i=e.data||[],n=i.length,a=0;a<n;++a)i[a].transition(t);e.dataset&&e.dataset.transition(t)},draw:function(){var t=this.getMeta(),e=t.data||[],i=e.length,n=0;for(t.dataset&&t.dataset.draw();n<i;++n)e[n].draw()},removeHoverStyle:function(t,e){var i=this.chart.data.datasets[t._datasetIndex],a=t._index,o=t.custom||{},r=n.valueAtIndexOrDefault,s=t._model;s.backgroundColor=o.backgroundColor?o.backgroundColor:r(i.backgroundColor,a,e.backgroundColor),s.borderColor=o.borderColor?o.borderColor:r(i.borderColor,a,e.borderColor),s.borderWidth=o.borderWidth?o.borderWidth:r(i.borderWidth,a,e.borderWidth)},setHoverStyle:function(t){var e=this.chart.data.datasets[t._datasetIndex],i=t._index,a=t.custom||{},o=n.valueAtIndexOrDefault,r=n.getHoverColor,s=t._model;s.backgroundColor=a.hoverBackgroundColor?a.hoverBackgroundColor:o(e.hoverBackgroundColor,i,r(s.backgroundColor)),s.borderColor=a.hoverBorderColor?a.hoverBorderColor:o(e.hoverBorderColor,i,r(s.borderColor)),s.borderWidth=a.hoverBorderWidth?a.hoverBorderWidth:o(e.hoverBorderWidth,i,s.borderWidth)},resyncElements:function(){var t=this.getMeta(),e=this.getDataset().data,i=t.data.length,n=e.length;n<i?t.data.splice(n,i-n):n>i&&this.insertElements(i,n-i)},insertElements:function(t,e){for(var i=0;i<e;++i)this.addElementAndReset(t+i)},onDataPush:function(){this.insertElements(this.getDataset().data.length-1,arguments.length)},onDataPop:function(){this.getMeta().data.pop()},onDataShift:function(){this.getMeta().data.shift()},onDataSplice:function(t,e){this.getMeta().data.splice(t,e),this.insertElements(t,arguments.length-2)},onDataUnshift:function(){this.insertElements(0,arguments.length)}}),t.DatasetController.extend=n.inherits}},{45:45}],25:[function(t,e,i){"use strict";var n=t(45);e.exports={_set:function(t,e){return n.merge(this[t]||(this[t]={}),e)}}},{45:45}],26:[function(t,e,i){"use strict";var n=t(3),a=t(45);var o=function(t){a.extend(this,t),this.initialize.apply(this,arguments)};a.extend(o.prototype,{initialize:function(){this.hidden=!1},pivot:function(){var t=this;return t._view||(t._view=a.clone(t._model)),t._start={},t},transition:function(t){var e=this,i=e._model,a=e._start,o=e._view;return i&&1!==t?(o||(o=e._view={}),a||(a=e._start={}),function(t,e,i,a){var o,r,s,l,u,d,c,h,f,g=Object.keys(i);for(o=0,r=g.length;o<r;++o)if(d=i[s=g[o]],e.hasOwnProperty(s)||(e[s]=d),(l=e[s])!==d&&"_"!==s[0]){if(t.hasOwnProperty(s)||(t[s]=l),(c=typeof d)==typeof(u=t[s]))if("string"===c){if((h=n(u)).valid&&(f=n(d)).valid){e[s]=f.mix(h,a).rgbString();continue}}else if("number"===c&&isFinite(u)&&isFinite(d)){e[s]=u+(d-u)*a;continue}e[s]=d}}(a,o,i,t),e):(e._view=i,e._start=null,e)},tooltipPosition:function(){return{x:this._model.x,y:this._model.y}},hasValue:function(){return a.isNumber(this._model.x)&&a.isNumber(this._model.y)}}),o.extend=a.inherits,e.exports=o},{3:3,45:45}],27:[function(t,e,i){"use strict";var n=t(3),a=t(25),o=t(45);e.exports=function(t){function e(t,e,i){var n;return"string"==typeof t?(n=parseInt(t,10),-1!==t.indexOf("%")&&(n=n/100*e.parentNode[i])):n=t,n}function i(t){return null!=t&&"none"!==t}function r(t,n,a){var o=document.defaultView,r=t.parentNode,s=o.getComputedStyle(t)[n],l=o.getComputedStyle(r)[n],u=i(s),d=i(l),c=Number.POSITIVE_INFINITY;return u||d?Math.min(u?e(s,t,a):c,d?e(l,r,a):c):"none"}o.configMerge=function(){return o.merge(o.clone(arguments[0]),[].slice.call(arguments,1),{merger:function(e,i,n,a){var r=i[e]||{},s=n[e];"scales"===e?i[e]=o.scaleMerge(r,s):"scale"===e?i[e]=o.merge(r,[t.scaleService.getScaleDefaults(s.type),s]):o._merger(e,i,n,a)}})},o.scaleMerge=function(){return o.merge(o.clone(arguments[0]),[].slice.call(arguments,1),{merger:function(e,i,n,a){if("xAxes"===e||"yAxes"===e){var r,s,l,u=n[e].length;for(i[e]||(i[e]=[]),r=0;r<u;++r)l=n[e][r],s=o.valueOrDefault(l.type,"xAxes"===e?"category":"linear"),r>=i[e].length&&i[e].push({}),!i[e][r].type||l.type&&l.type!==i[e][r].type?o.merge(i[e][r],[t.scaleService.getScaleDefaults(s),l]):o.merge(i[e][r],l)}else o._merger(e,i,n,a)}})},o.where=function(t,e){if(o.isArray(t)&&Array.prototype.filter)return t.filter(e);var i=[];return o.each(t,function(t){e(t)&&i.push(t)}),i},o.findIndex=Array.prototype.findIndex?function(t,e,i){return t.findIndex(e,i)}:function(t,e,i){i=void 0===i?t:i;for(var n=0,a=t.length;n<a;++n)if(e.call(i,t[n],n,t))return n;return-1},o.findNextWhere=function(t,e,i){o.isNullOrUndef(i)&&(i=-1);for(var n=i+1;n<t.length;n++){var a=t[n];if(e(a))return a}},o.findPreviousWhere=function(t,e,i){o.isNullOrUndef(i)&&(i=t.length);for(var n=i-1;n>=0;n--){var a=t[n];if(e(a))return a}},o.isNumber=function(t){return!isNaN(parseFloat(t))&&isFinite(t)},o.almostEquals=function(t,e,i){return Math.abs(t-e)<i},o.almostWhole=function(t,e){var i=Math.round(t);return i-e<t&&i+e>t},o.max=function(t){return t.reduce(function(t,e){return isNaN(e)?t:Math.max(t,e)},Number.NEGATIVE_INFINITY)},o.min=function(t){return t.reduce(function(t,e){return isNaN(e)?t:Math.min(t,e)},Number.POSITIVE_INFINITY)},o.sign=Math.sign?function(t){return Math.sign(t)}:function(t){return 0===(t=+t)||isNaN(t)?t:t>0?1:-1},o.log10=Math.log10?function(t){return Math.log10(t)}:function(t){var e=Math.log(t)*Math.LOG10E,i=Math.round(e);return t===Math.pow(10,i)?i:e},o.toRadians=function(t){return t*(Math.PI/180)},o.toDegrees=function(t){return t*(180/Math.PI)},o.getAngleFromPoint=function(t,e){var i=e.x-t.x,n=e.y-t.y,a=Math.sqrt(i*i+n*n),o=Math.atan2(n,i);return o<-.5*Math.PI&&(o+=2*Math.PI),{angle:o,distance:a}},o.distanceBetweenPoints=function(t,e){return Math.sqrt(Math.pow(e.x-t.x,2)+Math.pow(e.y-t.y,2))},o.aliasPixel=function(t){return t%2==0?0:.5},o.splineCurve=function(t,e,i,n){var a=t.skip?e:t,o=e,r=i.skip?e:i,s=Math.sqrt(Math.pow(o.x-a.x,2)+Math.pow(o.y-a.y,2)),l=Math.sqrt(Math.pow(r.x-o.x,2)+Math.pow(r.y-o.y,2)),u=s/(s+l),d=l/(s+l),c=n*(u=isNaN(u)?0:u),h=n*(d=isNaN(d)?0:d);return{previous:{x:o.x-c*(r.x-a.x),y:o.y-c*(r.y-a.y)},next:{x:o.x+h*(r.x-a.x),y:o.y+h*(r.y-a.y)}}},o.EPSILON=Number.EPSILON||1e-14,o.splineCurveMonotone=function(t){var e,i,n,a,r,s,l,u,d,c=(t||[]).map(function(t){return{model:t._model,deltaK:0,mK:0}}),h=c.length;for(e=0;e<h;++e)if(!(n=c[e]).model.skip){if(i=e>0?c[e-1]:null,(a=e<h-1?c[e+1]:null)&&!a.model.skip){var f=a.model.x-n.model.x;n.deltaK=0!==f?(a.model.y-n.model.y)/f:0}!i||i.model.skip?n.mK=n.deltaK:!a||a.model.skip?n.mK=i.deltaK:this.sign(i.deltaK)!==this.sign(n.deltaK)?n.mK=0:n.mK=(i.deltaK+n.deltaK)/2}for(e=0;e<h-1;++e)n=c[e],a=c[e+1],n.model.skip||a.model.skip||(o.almostEquals(n.deltaK,0,this.EPSILON)?n.mK=a.mK=0:(r=n.mK/n.deltaK,s=a.mK/n.deltaK,(u=Math.pow(r,2)+Math.pow(s,2))<=9||(l=3/Math.sqrt(u),n.mK=r*l*n.deltaK,a.mK=s*l*n.deltaK)));for(e=0;e<h;++e)(n=c[e]).model.skip||(i=e>0?c[e-1]:null,a=e<h-1?c[e+1]:null,i&&!i.model.skip&&(d=(n.model.x-i.model.x)/3,n.model.controlPointPreviousX=n.model.x-d,n.model.controlPointPreviousY=n.model.y-d*n.mK),a&&!a.model.skip&&(d=(a.model.x-n.model.x)/3,n.model.controlPointNextX=n.model.x+d,n.model.controlPointNextY=n.model.y+d*n.mK))},o.nextItem=function(t,e,i){return i?e>=t.length-1?t[0]:t[e+1]:e>=t.length-1?t[t.length-1]:t[e+1]},o.previousItem=function(t,e,i){return i?e<=0?t[t.length-1]:t[e-1]:e<=0?t[0]:t[e-1]},o.niceNum=function(t,e){var i=Math.floor(o.log10(t)),n=t/Math.pow(10,i);return(e?n<1.5?1:n<3?2:n<7?5:10:n<=1?1:n<=2?2:n<=5?5:10)*Math.pow(10,i)},o.requestAnimFrame="undefined"==typeof window?function(t){t()}:window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(t){return window.setTimeout(t,1e3/60)},o.getRelativePosition=function(t,e){var i,n,a=t.originalEvent||t,r=t.currentTarget||t.srcElement,s=r.getBoundingClientRect(),l=a.touches;l&&l.length>0?(i=l[0].clientX,n=l[0].clientY):(i=a.clientX,n=a.clientY);var u=parseFloat(o.getStyle(r,"padding-left")),d=parseFloat(o.getStyle(r,"padding-top")),c=parseFloat(o.getStyle(r,"padding-right")),h=parseFloat(o.getStyle(r,"padding-bottom")),f=s.right-s.left-u-c,g=s.bottom-s.top-d-h;return{x:i=Math.round((i-s.left-u)/f*r.width/e.currentDevicePixelRatio),y:n=Math.round((n-s.top-d)/g*r.height/e.currentDevicePixelRatio)}},o.getConstraintWidth=function(t){return r(t,"max-width","clientWidth")},o.getConstraintHeight=function(t){return r(t,"max-height","clientHeight")},o.getMaximumWidth=function(t){var e=t.parentNode;if(!e)return t.clientWidth;var i=parseInt(o.getStyle(e,"padding-left"),10),n=parseInt(o.getStyle(e,"padding-right"),10),a=e.clientWidth-i-n,r=o.getConstraintWidth(t);return isNaN(r)?a:Math.min(a,r)},o.getMaximumHeight=function(t){var e=t.parentNode;if(!e)return t.clientHeight;var i=parseInt(o.getStyle(e,"padding-top"),10),n=parseInt(o.getStyle(e,"padding-bottom"),10),a=e.clientHeight-i-n,r=o.getConstraintHeight(t);return isNaN(r)?a:Math.min(a,r)},o.getStyle=function(t,e){return t.currentStyle?t.currentStyle[e]:document.defaultView.getComputedStyle(t,null).getPropertyValue(e)},o.retinaScale=function(t,e){var i=t.currentDevicePixelRatio=e||window.devicePixelRatio||1;if(1!==i){var n=t.canvas,a=t.height,o=t.width;n.height=a*i,n.width=o*i,t.ctx.scale(i,i),n.style.height||n.style.width||(n.style.height=a+"px",n.style.width=o+"px")}},o.fontString=function(t,e,i){return e+" "+t+"px "+i},o.longestText=function(t,e,i,n){var a=(n=n||{}).data=n.data||{},r=n.garbageCollect=n.garbageCollect||[];n.font!==e&&(a=n.data={},r=n.garbageCollect=[],n.font=e),t.font=e;var s=0;o.each(i,function(e){null!=e&&!0!==o.isArray(e)?s=o.measureText(t,a,r,s,e):o.isArray(e)&&o.each(e,function(e){null==e||o.isArray(e)||(s=o.measureText(t,a,r,s,e))})});var l=r.length/2;if(l>i.length){for(var u=0;u<l;u++)delete a[r[u]];r.splice(0,l)}return s},o.measureText=function(t,e,i,n,a){var o=e[a];return o||(o=e[a]=t.measureText(a).width,i.push(a)),o>n&&(n=o),n},o.numberOfLabelLines=function(t){var e=1;return o.each(t,function(t){o.isArray(t)&&t.length>e&&(e=t.length)}),e},o.color=n?function(t){return t instanceof CanvasGradient&&(t=a.global.defaultColor),n(t)}:function(t){return console.error("Color.js not found!"),t},o.getHoverColor=function(t){return t instanceof CanvasPattern?t:o.color(t).saturate(.5).darken(.1).rgbString()}}},{25:25,3:3,45:45}],28:[function(t,e,i){"use strict";var n=t(45);function a(t,e){return t.native?{x:t.x,y:t.y}:n.getRelativePosition(t,e)}function o(t,e){var i,n,a,o,r;for(n=0,o=t.data.datasets.length;n<o;++n)if(t.isDatasetVisible(n))for(a=0,r=(i=t.getDatasetMeta(n)).data.length;a<r;++a){var s=i.data[a];s._view.skip||e(s)}}function r(t,e){var i=[];return o(t,function(t){t.inRange(e.x,e.y)&&i.push(t)}),i}function s(t,e,i,n){var a=Number.POSITIVE_INFINITY,r=[];return o(t,function(t){if(!i||t.inRange(e.x,e.y)){var o=t.getCenterPoint(),s=n(e,o);s<a?(r=[t],a=s):s===a&&r.push(t)}}),r}function l(t){var e=-1!==t.indexOf("x"),i=-1!==t.indexOf("y");return function(t,n){var a=e?Math.abs(t.x-n.x):0,o=i?Math.abs(t.y-n.y):0;return Math.sqrt(Math.pow(a,2)+Math.pow(o,2))}}function u(t,e,i){var n=a(e,t);i.axis=i.axis||"x";var o=l(i.axis),u=i.intersect?r(t,n):s(t,n,!1,o),d=[];return u.length?(t.data.datasets.forEach(function(e,i){if(t.isDatasetVisible(i)){var n=t.getDatasetMeta(i).data[u[0]._index];n&&!n._view.skip&&d.push(n)}}),d):[]}e.exports={modes:{single:function(t,e){var i=a(e,t),n=[];return o(t,function(t){if(t.inRange(i.x,i.y))return n.push(t),n}),n.slice(0,1)},label:u,index:u,dataset:function(t,e,i){var n=a(e,t);i.axis=i.axis||"xy";var o=l(i.axis),u=i.intersect?r(t,n):s(t,n,!1,o);return u.length>0&&(u=t.getDatasetMeta(u[0]._datasetIndex).data),u},"x-axis":function(t,e){return u(t,e,{intersect:!1})},point:function(t,e){return r(t,a(e,t))},nearest:function(t,e,i){var n=a(e,t);i.axis=i.axis||"xy";var o=l(i.axis),r=s(t,n,i.intersect,o);return r.length>1&&r.sort(function(t,e){var i=t.getArea()-e.getArea();return 0===i&&(i=t._datasetIndex-e._datasetIndex),i}),r.slice(0,1)},x:function(t,e,i){var n=a(e,t),r=[],s=!1;return o(t,function(t){t.inXRange(n.x)&&r.push(t),t.inRange(n.x,n.y)&&(s=!0)}),i.intersect&&!s&&(r=[]),r},y:function(t,e,i){var n=a(e,t),r=[],s=!1;return o(t,function(t){t.inYRange(n.y)&&r.push(t),t.inRange(n.x,n.y)&&(s=!0)}),i.intersect&&!s&&(r=[]),r}}}},{45:45}],29:[function(t,e,i){"use strict";t(25)._set("global",{responsive:!0,responsiveAnimationDuration:0,maintainAspectRatio:!0,events:["mousemove","mouseout","click","touchstart","touchmove"],hover:{onHover:null,mode:"nearest",intersect:!0,animationDuration:400},onClick:null,defaultColor:"rgba(0,0,0,0.1)",defaultFontColor:"#666",defaultFontFamily:"'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",defaultFontSize:12,defaultFontStyle:"normal",showLines:!0,elements:{},layout:{padding:{top:0,right:0,bottom:0,left:0}}}),e.exports=function(){var t=function(t,e){return this.construct(t,e),this};return t.Chart=t,t}},{25:25}],30:[function(t,e,i){"use strict";var n=t(45);function a(t,e){return n.where(t,function(t){return t.position===e})}function o(t,e){t.forEach(function(t,e){return t._tmpIndex_=e,t}),t.sort(function(t,i){var n=e?i:t,a=e?t:i;return n.weight===a.weight?n._tmpIndex_-a._tmpIndex_:n.weight-a.weight}),t.forEach(function(t){delete t._tmpIndex_})}e.exports={defaults:{},addBox:function(t,e){t.boxes||(t.boxes=[]),e.fullWidth=e.fullWidth||!1,e.position=e.position||"top",e.weight=e.weight||0,t.boxes.push(e)},removeBox:function(t,e){var i=t.boxes?t.boxes.indexOf(e):-1;-1!==i&&t.boxes.splice(i,1)},configure:function(t,e,i){for(var n,a=["fullWidth","position","weight"],o=a.length,r=0;r<o;++r)n=a[r],i.hasOwnProperty(n)&&(e[n]=i[n])},update:function(t,e,i){if(t){var r=t.options.layout||{},s=n.options.toPadding(r.padding),l=s.left,u=s.right,d=s.top,c=s.bottom,h=a(t.boxes,"left"),f=a(t.boxes,"right"),g=a(t.boxes,"top"),p=a(t.boxes,"bottom"),m=a(t.boxes,"chartArea");o(h,!0),o(f,!1),o(g,!0),o(p,!1);var v=e-l-u,b=i-d-c,x=b/2,y=(e-v/2)/(h.length+f.length),k=(i-x)/(g.length+p.length),M=v,w=b,S=[];n.each(h.concat(f,g,p),function(t){var e,i=t.isHorizontal();i?(e=t.update(t.fullWidth?v:M,k),w-=e.height):(e=t.update(y,w),M-=e.width),S.push({horizontal:i,minSize:e,box:t})});var C=0,_=0,D=0,I=0;n.each(g.concat(p),function(t){if(t.getPadding){var e=t.getPadding();C=Math.max(C,e.left),_=Math.max(_,e.right)}}),n.each(h.concat(f),function(t){if(t.getPadding){var e=t.getPadding();D=Math.max(D,e.top),I=Math.max(I,e.bottom)}});var P=l,A=u,T=d,F=c;n.each(h.concat(f),N),n.each(h,function(t){P+=t.width}),n.each(f,function(t){A+=t.width}),n.each(g.concat(p),N),n.each(g,function(t){T+=t.height}),n.each(p,function(t){F+=t.height}),n.each(h.concat(f),function(t){var e=n.findNextWhere(S,function(e){return e.box===t}),i={left:0,right:0,top:T,bottom:F};e&&t.update(e.minSize.width,w,i)}),P=l,A=u,T=d,F=c,n.each(h,function(t){P+=t.width}),n.each(f,function(t){A+=t.width}),n.each(g,function(t){T+=t.height}),n.each(p,function(t){F+=t.height});var O=Math.max(C-P,0);P+=O,A+=Math.max(_-A,0);var R=Math.max(D-T,0);T+=R,F+=Math.max(I-F,0);var L=i-T-F,z=e-P-A;z===M&&L===w||(n.each(h,function(t){t.height=L}),n.each(f,function(t){t.height=L}),n.each(g,function(t){t.fullWidth||(t.width=z)}),n.each(p,function(t){t.fullWidth||(t.width=z)}),w=L,M=z);var B=l+O,W=d+R;n.each(h.concat(g),V),B+=M,W+=w,n.each(f,V),n.each(p,V),t.chartArea={left:P,top:T,right:P+M,bottom:T+w},n.each(m,function(e){e.left=t.chartArea.left,e.top=t.chartArea.top,e.right=t.chartArea.right,e.bottom=t.chartArea.bottom,e.update(M,w)})}function N(t){var e=n.findNextWhere(S,function(e){return e.box===t});if(e)if(t.isHorizontal()){var i={left:Math.max(P,C),right:Math.max(A,_),top:0,bottom:0};t.update(t.fullWidth?v:M,b/2,i)}else t.update(e.minSize.width,w)}function V(t){t.isHorizontal()?(t.left=t.fullWidth?l:P,t.right=t.fullWidth?e-u:P+M,t.top=W,t.bottom=W+t.height,W=t.bottom):(t.left=B,t.right=B+t.width,t.top=T,t.bottom=T+w,B=t.right)}}}},{45:45}],31:[function(t,e,i){"use strict";var n=t(25),a=t(45);n._set("global",{plugins:{}}),e.exports={_plugins:[],_cacheId:0,register:function(t){var e=this._plugins;[].concat(t).forEach(function(t){-1===e.indexOf(t)&&e.push(t)}),this._cacheId++},unregister:function(t){var e=this._plugins;[].concat(t).forEach(function(t){var i=e.indexOf(t);-1!==i&&e.splice(i,1)}),this._cacheId++},clear:function(){this._plugins=[],this._cacheId++},count:function(){return this._plugins.length},getAll:function(){return this._plugins},notify:function(t,e,i){var n,a,o,r,s,l=this.descriptors(t),u=l.length;for(n=0;n<u;++n)if("function"==typeof(s=(o=(a=l[n]).plugin)[e])&&((r=[t].concat(i||[])).push(a.options),!1===s.apply(o,r)))return!1;return!0},descriptors:function(t){var e=t.$plugins||(t.$plugins={});if(e.id===this._cacheId)return e.descriptors;var i=[],o=[],r=t&&t.config||{},s=r.options&&r.options.plugins||{};return this._plugins.concat(r.plugins||[]).forEach(function(t){if(-1===i.indexOf(t)){var e=t.id,r=s[e];!1!==r&&(!0===r&&(r=a.clone(n.global.plugins[e])),i.push(t),o.push({plugin:t,options:r||{}}))}}),e.descriptors=o,e.id=this._cacheId,o},_invalidate:function(t){delete t.$plugins}}},{25:25,45:45}],32:[function(t,e,i){"use strict";var n=t(25),a=t(26),o=t(45),r=t(34);function s(t){var e,i,n=[];for(e=0,i=t.length;e<i;++e)n.push(t[e].label);return n}function l(t,e,i){var n=t.getPixelForTick(e);return i&&(n-=0===e?(t.getPixelForTick(1)-n)/2:(n-t.getPixelForTick(e-1))/2),n}n._set("scale",{display:!0,position:"left",offset:!1,gridLines:{display:!0,color:"rgba(0, 0, 0, 0.1)",lineWidth:1,drawBorder:!0,drawOnChartArea:!0,drawTicks:!0,tickMarkLength:10,zeroLineWidth:1,zeroLineColor:"rgba(0,0,0,0.25)",zeroLineBorderDash:[],zeroLineBorderDashOffset:0,offsetGridLines:!1,borderDash:[],borderDashOffset:0},scaleLabel:{display:!1,labelString:"",lineHeight:1.2,padding:{top:4,bottom:4}},ticks:{beginAtZero:!1,minRotation:0,maxRotation:50,mirror:!1,padding:0,reverse:!1,display:!0,autoSkip:!0,autoSkipPadding:0,labelOffset:0,callback:r.formatters.values,minor:{},major:{}}}),e.exports=function(t){function e(t,e,i){return o.isArray(e)?o.longestText(t,i,e):t.measureText(e).width}function i(t){var e=o.valueOrDefault,i=n.global,a=e(t.fontSize,i.defaultFontSize),r=e(t.fontStyle,i.defaultFontStyle),s=e(t.fontFamily,i.defaultFontFamily);return{size:a,style:r,family:s,font:o.fontString(a,r,s)}}function r(t){return o.options.toLineHeight(o.valueOrDefault(t.lineHeight,1.2),o.valueOrDefault(t.fontSize,n.global.defaultFontSize))}t.Scale=a.extend({getPadding:function(){return{left:this.paddingLeft||0,top:this.paddingTop||0,right:this.paddingRight||0,bottom:this.paddingBottom||0}},getTicks:function(){return this._ticks},mergeTicksOptions:function(){var t=this.options.ticks;for(var e in!1===t.minor&&(t.minor={display:!1}),!1===t.major&&(t.major={display:!1}),t)"major"!==e&&"minor"!==e&&(void 0===t.minor[e]&&(t.minor[e]=t[e]),void 0===t.major[e]&&(t.major[e]=t[e]))},beforeUpdate:function(){o.callback(this.options.beforeUpdate,[this])},update:function(t,e,i){var n,a,r,s,l,u,d=this;for(d.beforeUpdate(),d.maxWidth=t,d.maxHeight=e,d.margins=o.extend({left:0,right:0,top:0,bottom:0},i),d.longestTextCache=d.longestTextCache||{},d.beforeSetDimensions(),d.setDimensions(),d.afterSetDimensions(),d.beforeDataLimits(),d.determineDataLimits(),d.afterDataLimits(),d.beforeBuildTicks(),l=d.buildTicks()||[],d.afterBuildTicks(),d.beforeTickToLabelConversion(),r=d.convertTicksToLabels(l)||d.ticks,d.afterTickToLabelConversion(),d.ticks=r,n=0,a=r.length;n<a;++n)s=r[n],(u=l[n])?u.label=s:l.push(u={label:s,major:!1});return d._ticks=l,d.beforeCalculateTickRotation(),d.calculateTickRotation(),d.afterCalculateTickRotation(),d.beforeFit(),d.fit(),d.afterFit(),d.afterUpdate(),d.minSize},afterUpdate:function(){o.callback(this.options.afterUpdate,[this])},beforeSetDimensions:function(){o.callback(this.options.beforeSetDimensions,[this])},setDimensions:function(){var t=this;t.isHorizontal()?(t.width=t.maxWidth,t.left=0,t.right=t.width):(t.height=t.maxHeight,t.top=0,t.bottom=t.height),t.paddingLeft=0,t.paddingTop=0,t.paddingRight=0,t.paddingBottom=0},afterSetDimensions:function(){o.callback(this.options.afterSetDimensions,[this])},beforeDataLimits:function(){o.callback(this.options.beforeDataLimits,[this])},determineDataLimits:o.noop,afterDataLimits:function(){o.callback(this.options.afterDataLimits,[this])},beforeBuildTicks:function(){o.callback(this.options.beforeBuildTicks,[this])},buildTicks:o.noop,afterBuildTicks:function(){o.callback(this.options.afterBuildTicks,[this])},beforeTickToLabelConversion:function(){o.callback(this.options.beforeTickToLabelConversion,[this])},convertTicksToLabels:function(){var t=this.options.ticks;this.ticks=this.ticks.map(t.userCallback||t.callback,this)},afterTickToLabelConversion:function(){o.callback(this.options.afterTickToLabelConversion,[this])},beforeCalculateTickRotation:function(){o.callback(this.options.beforeCalculateTickRotation,[this])},calculateTickRotation:function(){var t=this,e=t.ctx,n=t.options.ticks,a=s(t._ticks),r=i(n);e.font=r.font;var l=n.minRotation||0;if(a.length&&t.options.display&&t.isHorizontal())for(var u,d=o.longestText(e,r.font,a,t.longestTextCache),c=d,h=t.getPixelForTick(1)-t.getPixelForTick(0)-6;c>h&&l<n.maxRotation;){var f=o.toRadians(l);if(u=Math.cos(f),Math.sin(f)*d>t.maxHeight){l--;break}l++,c=u*d}t.labelRotation=l},afterCalculateTickRotation:function(){o.callback(this.options.afterCalculateTickRotation,[this])},beforeFit:function(){o.callback(this.options.beforeFit,[this])},fit:function(){var t=this,n=t.minSize={width:0,height:0},a=s(t._ticks),l=t.options,u=l.ticks,d=l.scaleLabel,c=l.gridLines,h=l.display,f=t.isHorizontal(),g=i(u),p=l.gridLines.tickMarkLength;if(n.width=f?t.isFullWidth()?t.maxWidth-t.margins.left-t.margins.right:t.maxWidth:h&&c.drawTicks?p:0,n.height=f?h&&c.drawTicks?p:0:t.maxHeight,d.display&&h){var m=r(d)+o.options.toPadding(d.padding).height;f?n.height+=m:n.width+=m}if(u.display&&h){var v=o.longestText(t.ctx,g.font,a,t.longestTextCache),b=o.numberOfLabelLines(a),x=.5*g.size,y=t.options.ticks.padding;if(f){t.longestLabelWidth=v;var k=o.toRadians(t.labelRotation),M=Math.cos(k),w=Math.sin(k)*v+g.size*b+x*(b-1)+x;n.height=Math.min(t.maxHeight,n.height+w+y),t.ctx.font=g.font;var S=e(t.ctx,a[0],g.font),C=e(t.ctx,a[a.length-1],g.font);0!==t.labelRotation?(t.paddingLeft="bottom"===l.position?M*S+3:M*x+3,t.paddingRight="bottom"===l.position?M*x+3:M*C+3):(t.paddingLeft=S/2+3,t.paddingRight=C/2+3)}else u.mirror?v=0:v+=y+x,n.width=Math.min(t.maxWidth,n.width+v),t.paddingTop=g.size/2,t.paddingBottom=g.size/2}t.handleMargins(),t.width=n.width,t.height=n.height},handleMargins:function(){var t=this;t.margins&&(t.paddingLeft=Math.max(t.paddingLeft-t.margins.left,0),t.paddingTop=Math.max(t.paddingTop-t.margins.top,0),t.paddingRight=Math.max(t.paddingRight-t.margins.right,0),t.paddingBottom=Math.max(t.paddingBottom-t.margins.bottom,0))},afterFit:function(){o.callback(this.options.afterFit,[this])},isHorizontal:function(){return"top"===this.options.position||"bottom"===this.options.position},isFullWidth:function(){return this.options.fullWidth},getRightValue:function(t){if(o.isNullOrUndef(t))return NaN;if("number"==typeof t&&!isFinite(t))return NaN;if(t)if(this.isHorizontal()){if(void 0!==t.x)return this.getRightValue(t.x)}else if(void 0!==t.y)return this.getRightValue(t.y);return t},getLabelForIndex:o.noop,getPixelForValue:o.noop,getValueForPixel:o.noop,getPixelForTick:function(t){var e=this,i=e.options.offset;if(e.isHorizontal()){var n=(e.width-(e.paddingLeft+e.paddingRight))/Math.max(e._ticks.length-(i?0:1),1),a=n*t+e.paddingLeft;i&&(a+=n/2);var o=e.left+Math.round(a);return o+=e.isFullWidth()?e.margins.left:0}var r=e.height-(e.paddingTop+e.paddingBottom);return e.top+t*(r/(e._ticks.length-1))},getPixelForDecimal:function(t){var e=this;if(e.isHorizontal()){var i=(e.width-(e.paddingLeft+e.paddingRight))*t+e.paddingLeft,n=e.left+Math.round(i);return n+=e.isFullWidth()?e.margins.left:0}return e.top+t*e.height},getBasePixel:function(){return this.getPixelForValue(this.getBaseValue())},getBaseValue:function(){var t=this.min,e=this.max;return this.beginAtZero?0:t<0&&e<0?e:t>0&&e>0?t:0},_autoSkip:function(t){var e,i,n,a,r=this,s=r.isHorizontal(),l=r.options.ticks.minor,u=t.length,d=o.toRadians(r.labelRotation),c=Math.cos(d),h=r.longestLabelWidth*c,f=[];for(l.maxTicksLimit&&(a=l.maxTicksLimit),s&&(e=!1,(h+l.autoSkipPadding)*u>r.width-(r.paddingLeft+r.paddingRight)&&(e=1+Math.floor((h+l.autoSkipPadding)*u/(r.width-(r.paddingLeft+r.paddingRight)))),a&&u>a&&(e=Math.max(e,Math.floor(u/a)))),i=0;i<u;i++)n=t[i],(e>1&&i%e>0||i%e==0&&i+e>=u)&&i!==u-1&&delete n.label,f.push(n);return f},draw:function(t){var e=this,a=e.options;if(a.display){var s=e.ctx,u=n.global,d=a.ticks.minor,c=a.ticks.major||d,h=a.gridLines,f=a.scaleLabel,g=0!==e.labelRotation,p=e.isHorizontal(),m=d.autoSkip?e._autoSkip(e.getTicks()):e.getTicks(),v=o.valueOrDefault(d.fontColor,u.defaultFontColor),b=i(d),x=o.valueOrDefault(c.fontColor,u.defaultFontColor),y=i(c),k=h.drawTicks?h.tickMarkLength:0,M=o.valueOrDefault(f.fontColor,u.defaultFontColor),w=i(f),S=o.options.toPadding(f.padding),C=o.toRadians(e.labelRotation),_=[],D=e.options.gridLines.lineWidth,I="right"===a.position?e.right:e.right-D-k,P="right"===a.position?e.right+k:e.right,A="bottom"===a.position?e.top+D:e.bottom-k-D,T="bottom"===a.position?e.top+D+k:e.bottom+D;if(o.each(m,function(i,n){if(!o.isNullOrUndef(i.label)){var r,s,c,f,v,b,x,y,M,w,S,F,O,R,L=i.label;n===e.zeroLineIndex&&a.offset===h.offsetGridLines?(r=h.zeroLineWidth,s=h.zeroLineColor,c=h.zeroLineBorderDash,f=h.zeroLineBorderDashOffset):(r=o.valueAtIndexOrDefault(h.lineWidth,n),s=o.valueAtIndexOrDefault(h.color,n),c=o.valueOrDefault(h.borderDash,u.borderDash),f=o.valueOrDefault(h.borderDashOffset,u.borderDashOffset));var z="middle",B="middle",W=d.padding;if(p){var N=k+W;"bottom"===a.position?(B=g?"middle":"top",z=g?"right":"center",R=e.top+N):(B=g?"middle":"bottom",z=g?"left":"center",R=e.bottom-N);var V=l(e,n,h.offsetGridLines&&m.length>1);V<e.left&&(s="rgba(0,0,0,0)"),V+=o.aliasPixel(r),O=e.getPixelForTick(n)+d.labelOffset,v=x=M=S=V,b=A,y=T,w=t.top,F=t.bottom+D}else{var E,H="left"===a.position;d.mirror?(z=H?"left":"right",E=W):(z=H?"right":"left",E=k+W),O=H?e.right-E:e.left+E;var j=l(e,n,h.offsetGridLines&&m.length>1);j<e.top&&(s="rgba(0,0,0,0)"),j+=o.aliasPixel(r),R=e.getPixelForTick(n)+d.labelOffset,v=I,x=P,M=t.left,S=t.right+D,b=y=w=F=j}_.push({tx1:v,ty1:b,tx2:x,ty2:y,x1:M,y1:w,x2:S,y2:F,labelX:O,labelY:R,glWidth:r,glColor:s,glBorderDash:c,glBorderDashOffset:f,rotation:-1*C,label:L,major:i.major,textBaseline:B,textAlign:z})}}),o.each(_,function(t){if(h.display&&(s.save(),s.lineWidth=t.glWidth,s.strokeStyle=t.glColor,s.setLineDash&&(s.setLineDash(t.glBorderDash),s.lineDashOffset=t.glBorderDashOffset),s.beginPath(),h.drawTicks&&(s.moveTo(t.tx1,t.ty1),s.lineTo(t.tx2,t.ty2)),h.drawOnChartArea&&(s.moveTo(t.x1,t.y1),s.lineTo(t.x2,t.y2)),s.stroke(),s.restore()),d.display){s.save(),s.translate(t.labelX,t.labelY),s.rotate(t.rotation),s.font=t.major?y.font:b.font,s.fillStyle=t.major?x:v,s.textBaseline=t.textBaseline,s.textAlign=t.textAlign;var i=t.label;if(o.isArray(i))for(var n=i.length,a=1.5*b.size,r=e.isHorizontal()?0:-a*(n-1)/2,l=0;l<n;++l)s.fillText(""+i[l],0,r),r+=a;else s.fillText(i,0,0);s.restore()}}),f.display){var F,O,R=0,L=r(f)/2;if(p)F=e.left+(e.right-e.left)/2,O="bottom"===a.position?e.bottom-L-S.bottom:e.top+L+S.top;else{var z="left"===a.position;F=z?e.left+L+S.top:e.right-L-S.top,O=e.top+(e.bottom-e.top)/2,R=z?-.5*Math.PI:.5*Math.PI}s.save(),s.translate(F,O),s.rotate(R),s.textAlign="center",s.textBaseline="middle",s.fillStyle=M,s.font=w.font,s.fillText(f.labelString,0,0),s.restore()}if(h.drawBorder){s.lineWidth=o.valueAtIndexOrDefault(h.lineWidth,0),s.strokeStyle=o.valueAtIndexOrDefault(h.color,0);var B=e.left,W=e.right+D,N=e.top,V=e.bottom+D,E=o.aliasPixel(s.lineWidth);p?(N=V="top"===a.position?e.bottom:e.top,N+=E,V+=E):(B=W="left"===a.position?e.right:e.left,B+=E,W+=E),s.beginPath(),s.moveTo(B,N),s.lineTo(W,V),s.stroke()}}}})}},{25:25,26:26,34:34,45:45}],33:[function(t,e,i){"use strict";var n=t(25),a=t(45),o=t(30);e.exports=function(t){t.scaleService={constructors:{},defaults:{},registerScaleType:function(t,e,i){this.constructors[t]=e,this.defaults[t]=a.clone(i)},getScaleConstructor:function(t){return this.constructors.hasOwnProperty(t)?this.constructors[t]:void 0},getScaleDefaults:function(t){return this.defaults.hasOwnProperty(t)?a.merge({},[n.scale,this.defaults[t]]):{}},updateScaleDefaults:function(t,e){this.defaults.hasOwnProperty(t)&&(this.defaults[t]=a.extend(this.defaults[t],e))},addScalesToLayout:function(t){a.each(t.scales,function(e){e.fullWidth=e.options.fullWidth,e.position=e.options.position,e.weight=e.options.weight,o.addBox(t,e)})}}}},{25:25,30:30,45:45}],34:[function(t,e,i){"use strict";var n=t(45);e.exports={formatters:{values:function(t){return n.isArray(t)?t:""+t},linear:function(t,e,i){var a=i.length>3?i[2]-i[1]:i[1]-i[0];Math.abs(a)>1&&t!==Math.floor(t)&&(a=t-Math.floor(t));var o=n.log10(Math.abs(a)),r="";if(0!==t){var s=-1*Math.floor(o);s=Math.max(Math.min(s,20),0),r=t.toFixed(s)}else r="0";return r},logarithmic:function(t,e,i){var a=t/Math.pow(10,Math.floor(n.log10(t)));return 0===t?"0":1===a||2===a||5===a||0===e||e===i.length-1?t.toExponential():""}}}},{45:45}],35:[function(t,e,i){"use strict";var n=t(25),a=t(26),o=t(45);n._set("global",{tooltips:{enabled:!0,custom:null,mode:"nearest",position:"average",intersect:!0,backgroundColor:"rgba(0,0,0,0.8)",titleFontStyle:"bold",titleSpacing:2,titleMarginBottom:6,titleFontColor:"#fff",titleAlign:"left",bodySpacing:2,bodyFontColor:"#fff",bodyAlign:"left",footerFontStyle:"bold",footerSpacing:2,footerMarginTop:6,footerFontColor:"#fff",footerAlign:"left",yPadding:6,xPadding:6,caretPadding:2,caretSize:5,cornerRadius:6,multiKeyBackground:"#fff",displayColors:!0,borderColor:"rgba(0,0,0,0)",borderWidth:0,callbacks:{beforeTitle:o.noop,title:function(t,e){var i="",n=e.labels,a=n?n.length:0;if(t.length>0){var o=t[0];o.xLabel?i=o.xLabel:a>0&&o.index<a&&(i=n[o.index])}return i},afterTitle:o.noop,beforeBody:o.noop,beforeLabel:o.noop,label:function(t,e){var i=e.datasets[t.datasetIndex].label||"";return i&&(i+=": "),i+=t.yLabel},labelColor:function(t,e){var i=e.getDatasetMeta(t.datasetIndex).data[t.index]._view;return{borderColor:i.borderColor,backgroundColor:i.backgroundColor}},labelTextColor:function(){return this._options.bodyFontColor},afterLabel:o.noop,afterBody:o.noop,beforeFooter:o.noop,footer:o.noop,afterFooter:o.noop}}}),e.exports=function(t){function e(t,e){var i=o.color(t);return i.alpha(e*i.alpha()).rgbaString()}function i(t,e){return e&&(o.isArray(e)?Array.prototype.push.apply(t,e):t.push(e)),t}function r(t){var e=n.global,i=o.valueOrDefault;return{xPadding:t.xPadding,yPadding:t.yPadding,xAlign:t.xAlign,yAlign:t.yAlign,bodyFontColor:t.bodyFontColor,_bodyFontFamily:i(t.bodyFontFamily,e.defaultFontFamily),_bodyFontStyle:i(t.bodyFontStyle,e.defaultFontStyle),_bodyAlign:t.bodyAlign,bodyFontSize:i(t.bodyFontSize,e.defaultFontSize),bodySpacing:t.bodySpacing,titleFontColor:t.titleFontColor,_titleFontFamily:i(t.titleFontFamily,e.defaultFontFamily),_titleFontStyle:i(t.titleFontStyle,e.defaultFontStyle),titleFontSize:i(t.titleFontSize,e.defaultFontSize),_titleAlign:t.titleAlign,titleSpacing:t.titleSpacing,titleMarginBottom:t.titleMarginBottom,footerFontColor:t.footerFontColor,_footerFontFamily:i(t.footerFontFamily,e.defaultFontFamily),_footerFontStyle:i(t.footerFontStyle,e.defaultFontStyle),footerFontSize:i(t.footerFontSize,e.defaultFontSize),_footerAlign:t.footerAlign,footerSpacing:t.footerSpacing,footerMarginTop:t.footerMarginTop,caretSize:t.caretSize,cornerRadius:t.cornerRadius,backgroundColor:t.backgroundColor,opacity:0,legendColorBackground:t.multiKeyBackground,displayColors:t.displayColors,borderColor:t.borderColor,borderWidth:t.borderWidth}}t.Tooltip=a.extend({initialize:function(){this._model=r(this._options),this._lastActive=[]},getTitle:function(){var t=this._options.callbacks,e=t.beforeTitle.apply(this,arguments),n=t.title.apply(this,arguments),a=t.afterTitle.apply(this,arguments),o=[];return o=i(o=i(o=i(o,e),n),a)},getBeforeBody:function(){var t=this._options.callbacks.beforeBody.apply(this,arguments);return o.isArray(t)?t:void 0!==t?[t]:[]},getBody:function(t,e){var n=this,a=n._options.callbacks,r=[];return o.each(t,function(t){var o={before:[],lines:[],after:[]};i(o.before,a.beforeLabel.call(n,t,e)),i(o.lines,a.label.call(n,t,e)),i(o.after,a.afterLabel.call(n,t,e)),r.push(o)}),r},getAfterBody:function(){var t=this._options.callbacks.afterBody.apply(this,arguments);return o.isArray(t)?t:void 0!==t?[t]:[]},getFooter:function(){var t=this._options.callbacks,e=t.beforeFooter.apply(this,arguments),n=t.footer.apply(this,arguments),a=t.afterFooter.apply(this,arguments),o=[];return o=i(o=i(o=i(o,e),n),a)},update:function(e){var i,n,a,s,l,u,d,c,h,f,g,p,m,v,b,x,y,k,M,w,S=this,C=S._options,_=S._model,D=S._model=r(C),I=S._active,P=S._data,A={xAlign:_.xAlign,yAlign:_.yAlign},T={x:_.x,y:_.y},F={width:_.width,height:_.height},O={x:_.caretX,y:_.caretY};if(I.length){D.opacity=1;var R=[],L=[];O=t.Tooltip.positioners[C.position].call(S,I,S._eventPosition);var z=[];for(i=0,n=I.length;i<n;++i)z.push((x=I[i],y=void 0,k=void 0,void 0,void 0,y=x._xScale,k=x._yScale||x._scale,M=x._index,w=x._datasetIndex,{xLabel:y?y.getLabelForIndex(M,w):"",yLabel:k?k.getLabelForIndex(M,w):"",index:M,datasetIndex:w,x:x._model.x,y:x._model.y}));C.filter&&(z=z.filter(function(t){return C.filter(t,P)})),C.itemSort&&(z=z.sort(function(t,e){return C.itemSort(t,e,P)})),o.each(z,function(t){R.push(C.callbacks.labelColor.call(S,t,S._chart)),L.push(C.callbacks.labelTextColor.call(S,t,S._chart))}),D.title=S.getTitle(z,P),D.beforeBody=S.getBeforeBody(z,P),D.body=S.getBody(z,P),D.afterBody=S.getAfterBody(z,P),D.footer=S.getFooter(z,P),D.x=Math.round(O.x),D.y=Math.round(O.y),D.caretPadding=C.caretPadding,D.labelColors=R,D.labelTextColors=L,D.dataPoints=z,A=function(t,e){var i,n,a,o,r,s=t._model,l=t._chart,u=t._chart.chartArea,d="center",c="center";s.y<e.height?c="top":s.y>l.height-e.height&&(c="bottom");var h=(u.left+u.right)/2,f=(u.top+u.bottom)/2;"center"===c?(i=function(t){return t<=h},n=function(t){return t>h}):(i=function(t){return t<=e.width/2},n=function(t){return t>=l.width-e.width/2}),a=function(t){return t+e.width+s.caretSize+s.caretPadding>l.width},o=function(t){return t-e.width-s.caretSize-s.caretPadding<0},r=function(t){return t<=f?"top":"bottom"},i(s.x)?(d="left",a(s.x)&&(d="center",c=r(s.y))):n(s.x)&&(d="right",o(s.x)&&(d="center",c=r(s.y)));var g=t._options;return{xAlign:g.xAlign?g.xAlign:d,yAlign:g.yAlign?g.yAlign:c}}(this,F=function(t,e){var i=t._chart.ctx,n=2*e.yPadding,a=0,r=e.body,s=r.reduce(function(t,e){return t+e.before.length+e.lines.length+e.after.length},0);s+=e.beforeBody.length+e.afterBody.length;var l=e.title.length,u=e.footer.length,d=e.titleFontSize,c=e.bodyFontSize,h=e.footerFontSize;n+=l*d,n+=l?(l-1)*e.titleSpacing:0,n+=l?e.titleMarginBottom:0,n+=s*c,n+=s?(s-1)*e.bodySpacing:0,n+=u?e.footerMarginTop:0,n+=u*h,n+=u?(u-1)*e.footerSpacing:0;var f=0,g=function(t){a=Math.max(a,i.measureText(t).width+f)};return i.font=o.fontString(d,e._titleFontStyle,e._titleFontFamily),o.each(e.title,g),i.font=o.fontString(c,e._bodyFontStyle,e._bodyFontFamily),o.each(e.beforeBody.concat(e.afterBody),g),f=e.displayColors?c+2:0,o.each(r,function(t){o.each(t.before,g),o.each(t.lines,g),o.each(t.after,g)}),f=0,i.font=o.fontString(h,e._footerFontStyle,e._footerFontFamily),o.each(e.footer,g),{width:a+=2*e.xPadding,height:n}}(this,D)),a=D,s=F,l=A,u=S._chart,d=a.x,c=a.y,h=a.caretSize,f=a.caretPadding,g=a.cornerRadius,p=l.xAlign,m=l.yAlign,v=h+f,b=g+f,"right"===p?d-=s.width:"center"===p&&((d-=s.width/2)+s.width>u.width&&(d=u.width-s.width),d<0&&(d=0)),"top"===m?c+=v:c-="bottom"===m?s.height+v:s.height/2,"center"===m?"left"===p?d+=v:"right"===p&&(d-=v):"left"===p?d-=b:"right"===p&&(d+=b),T={x:d,y:c}}else D.opacity=0;return D.xAlign=A.xAlign,D.yAlign=A.yAlign,D.x=T.x,D.y=T.y,D.width=F.width,D.height=F.height,D.caretX=O.x,D.caretY=O.y,S._model=D,e&&C.custom&&C.custom.call(S,D),S},drawCaret:function(t,e){var i=this._chart.ctx,n=this._view,a=this.getCaretPosition(t,e,n);i.lineTo(a.x1,a.y1),i.lineTo(a.x2,a.y2),i.lineTo(a.x3,a.y3)},getCaretPosition:function(t,e,i){var n,a,o,r,s,l,u=i.caretSize,d=i.cornerRadius,c=i.xAlign,h=i.yAlign,f=t.x,g=t.y,p=e.width,m=e.height;if("center"===h)s=g+m/2,"left"===c?(a=(n=f)-u,o=n,r=s+u,l=s-u):(a=(n=f+p)+u,o=n,r=s-u,l=s+u);else if("left"===c?(n=(a=f+d+u)-u,o=a+u):"right"===c?(n=(a=f+p-d-u)-u,o=a+u):(n=(a=i.caretX)-u,o=a+u),"top"===h)s=(r=g)-u,l=r;else{s=(r=g+m)+u,l=r;var v=o;o=n,n=v}return{x1:n,x2:a,x3:o,y1:r,y2:s,y3:l}},drawTitle:function(t,i,n,a){var r=i.title;if(r.length){n.textAlign=i._titleAlign,n.textBaseline="top";var s,l,u=i.titleFontSize,d=i.titleSpacing;for(n.fillStyle=e(i.titleFontColor,a),n.font=o.fontString(u,i._titleFontStyle,i._titleFontFamily),s=0,l=r.length;s<l;++s)n.fillText(r[s],t.x,t.y),t.y+=u+d,s+1===r.length&&(t.y+=i.titleMarginBottom-d)}},drawBody:function(t,i,n,a){var r=i.bodyFontSize,s=i.bodySpacing,l=i.body;n.textAlign=i._bodyAlign,n.textBaseline="top",n.font=o.fontString(r,i._bodyFontStyle,i._bodyFontFamily);var u=0,d=function(e){n.fillText(e,t.x+u,t.y),t.y+=r+s};n.fillStyle=e(i.bodyFontColor,a),o.each(i.beforeBody,d);var c=i.displayColors;u=c?r+2:0,o.each(l,function(s,l){var u=e(i.labelTextColors[l],a);n.fillStyle=u,o.each(s.before,d),o.each(s.lines,function(o){c&&(n.fillStyle=e(i.legendColorBackground,a),n.fillRect(t.x,t.y,r,r),n.lineWidth=1,n.strokeStyle=e(i.labelColors[l].borderColor,a),n.strokeRect(t.x,t.y,r,r),n.fillStyle=e(i.labelColors[l].backgroundColor,a),n.fillRect(t.x+1,t.y+1,r-2,r-2),n.fillStyle=u),d(o)}),o.each(s.after,d)}),u=0,o.each(i.afterBody,d),t.y-=s},drawFooter:function(t,i,n,a){var r=i.footer;r.length&&(t.y+=i.footerMarginTop,n.textAlign=i._footerAlign,n.textBaseline="top",n.fillStyle=e(i.footerFontColor,a),n.font=o.fontString(i.footerFontSize,i._footerFontStyle,i._footerFontFamily),o.each(r,function(e){n.fillText(e,t.x,t.y),t.y+=i.footerFontSize+i.footerSpacing}))},drawBackground:function(t,i,n,a,o){n.fillStyle=e(i.backgroundColor,o),n.strokeStyle=e(i.borderColor,o),n.lineWidth=i.borderWidth;var r=i.xAlign,s=i.yAlign,l=t.x,u=t.y,d=a.width,c=a.height,h=i.cornerRadius;n.beginPath(),n.moveTo(l+h,u),"top"===s&&this.drawCaret(t,a),n.lineTo(l+d-h,u),n.quadraticCurveTo(l+d,u,l+d,u+h),"center"===s&&"right"===r&&this.drawCaret(t,a),n.lineTo(l+d,u+c-h),n.quadraticCurveTo(l+d,u+c,l+d-h,u+c),"bottom"===s&&this.drawCaret(t,a),n.lineTo(l+h,u+c),n.quadraticCurveTo(l,u+c,l,u+c-h),"center"===s&&"left"===r&&this.drawCaret(t,a),n.lineTo(l,u+h),n.quadraticCurveTo(l,u,l+h,u),n.closePath(),n.fill(),i.borderWidth>0&&n.stroke()},draw:function(){var t=this._chart.ctx,e=this._view;if(0!==e.opacity){var i={width:e.width,height:e.height},n={x:e.x,y:e.y},a=Math.abs(e.opacity<.001)?0:e.opacity,o=e.title.length||e.beforeBody.length||e.body.length||e.afterBody.length||e.footer.length;this._options.enabled&&o&&(this.drawBackground(n,e,t,i,a),n.x+=e.xPadding,n.y+=e.yPadding,this.drawTitle(n,e,t,a),this.drawBody(n,e,t,a),this.drawFooter(n,e,t,a))}},handleEvent:function(t){var e,i=this,n=i._options;return i._lastActive=i._lastActive||[],"mouseout"===t.type?i._active=[]:i._active=i._chart.getElementsAtEventForMode(t,n.mode,n),(e=!o.arrayEquals(i._active,i._lastActive))&&(i._lastActive=i._active,(n.enabled||n.custom)&&(i._eventPosition={x:t.x,y:t.y},i.update(!0),i.pivot())),e}}),t.Tooltip.positioners={average:function(t){if(!t.length)return!1;var e,i,n=0,a=0,o=0;for(e=0,i=t.length;e<i;++e){var r=t[e];if(r&&r.hasValue()){var s=r.tooltipPosition();n+=s.x,a+=s.y,++o}}return{x:Math.round(n/o),y:Math.round(a/o)}},nearest:function(t,e){var i,n,a,r=e.x,s=e.y,l=Number.POSITIVE_INFINITY;for(i=0,n=t.length;i<n;++i){var u=t[i];if(u&&u.hasValue()){var d=u.getCenterPoint(),c=o.distanceBetweenPoints(e,d);c<l&&(l=c,a=u)}}if(a){var h=a.tooltipPosition();r=h.x,s=h.y}return{x:r,y:s}}}}},{25:25,26:26,45:45}],36:[function(t,e,i){"use strict";var n=t(25),a=t(26),o=t(45);n._set("global",{elements:{arc:{backgroundColor:n.global.defaultColor,borderColor:"#fff",borderWidth:2}}}),e.exports=a.extend({inLabelRange:function(t){var e=this._view;return!!e&&Math.pow(t-e.x,2)<Math.pow(e.radius+e.hoverRadius,2)},inRange:function(t,e){var i=this._view;if(i){for(var n=o.getAngleFromPoint(i,{x:t,y:e}),a=n.angle,r=n.distance,s=i.startAngle,l=i.endAngle;l<s;)l+=2*Math.PI;for(;a>l;)a-=2*Math.PI;for(;a<s;)a+=2*Math.PI;var u=a>=s&&a<=l,d=r>=i.innerRadius&&r<=i.outerRadius;return u&&d}return!1},getCenterPoint:function(){var t=this._view,e=(t.startAngle+t.endAngle)/2,i=(t.innerRadius+t.outerRadius)/2;return{x:t.x+Math.cos(e)*i,y:t.y+Math.sin(e)*i}},getArea:function(){var t=this._view;return Math.PI*((t.endAngle-t.startAngle)/(2*Math.PI))*(Math.pow(t.outerRadius,2)-Math.pow(t.innerRadius,2))},tooltipPosition:function(){var t=this._view,e=t.startAngle+(t.endAngle-t.startAngle)/2,i=(t.outerRadius-t.innerRadius)/2+t.innerRadius;return{x:t.x+Math.cos(e)*i,y:t.y+Math.sin(e)*i}},draw:function(){var t=this._chart.ctx,e=this._view,i=e.startAngle,n=e.endAngle;t.beginPath(),t.arc(e.x,e.y,e.outerRadius,i,n),t.arc(e.x,e.y,e.innerRadius,n,i,!0),t.closePath(),t.strokeStyle=e.borderColor,t.lineWidth=e.borderWidth,t.fillStyle=e.backgroundColor,t.fill(),t.lineJoin="bevel",e.borderWidth&&t.stroke()}})},{25:25,26:26,45:45}],37:[function(t,e,i){"use strict";var n=t(25),a=t(26),o=t(45),r=n.global;n._set("global",{elements:{line:{tension:.4,backgroundColor:r.defaultColor,borderWidth:3,borderColor:r.defaultColor,borderCapStyle:"butt",borderDash:[],borderDashOffset:0,borderJoinStyle:"miter",capBezierPoints:!0,fill:!0}}}),e.exports=a.extend({draw:function(){var t,e,i,n,a=this._view,s=this._chart.ctx,l=a.spanGaps,u=this._children.slice(),d=r.elements.line,c=-1;for(this._loop&&u.length&&u.push(u[0]),s.save(),s.lineCap=a.borderCapStyle||d.borderCapStyle,s.setLineDash&&s.setLineDash(a.borderDash||d.borderDash),s.lineDashOffset=a.borderDashOffset||d.borderDashOffset,s.lineJoin=a.borderJoinStyle||d.borderJoinStyle,s.lineWidth=a.borderWidth||d.borderWidth,s.strokeStyle=a.borderColor||r.defaultColor,s.beginPath(),c=-1,t=0;t<u.length;++t)e=u[t],i=o.previousItem(u,t),n=e._view,0===t?n.skip||(s.moveTo(n.x,n.y),c=t):(i=-1===c?i:u[c],n.skip||(c!==t-1&&!l||-1===c?s.moveTo(n.x,n.y):o.canvas.lineTo(s,i._view,e._view),c=t));s.stroke(),s.restore()}})},{25:25,26:26,45:45}],38:[function(t,e,i){"use strict";var n=t(25),a=t(26),o=t(45),r=n.global.defaultColor;function s(t){var e=this._view;return!!e&&Math.abs(t-e.x)<e.radius+e.hitRadius}n._set("global",{elements:{point:{radius:3,pointStyle:"circle",backgroundColor:r,borderColor:r,borderWidth:1,hitRadius:1,hoverRadius:4,hoverBorderWidth:1}}}),e.exports=a.extend({inRange:function(t,e){var i=this._view;return!!i&&Math.pow(t-i.x,2)+Math.pow(e-i.y,2)<Math.pow(i.hitRadius+i.radius,2)},inLabelRange:s,inXRange:s,inYRange:function(t){var e=this._view;return!!e&&Math.abs(t-e.y)<e.radius+e.hitRadius},getCenterPoint:function(){var t=this._view;return{x:t.x,y:t.y}},getArea:function(){return Math.PI*Math.pow(this._view.radius,2)},tooltipPosition:function(){var t=this._view;return{x:t.x,y:t.y,padding:t.radius+t.borderWidth}},draw:function(t){var e=this._view,i=this._model,a=this._chart.ctx,s=e.pointStyle,l=e.radius,u=e.x,d=e.y,c=o.color,h=0;e.skip||(a.strokeStyle=e.borderColor||r,a.lineWidth=o.valueOrDefault(e.borderWidth,n.global.elements.point.borderWidth),a.fillStyle=e.backgroundColor||r,void 0!==t&&(i.x<t.left||1.01*t.right<i.x||i.y<t.top||1.01*t.bottom<i.y)&&(i.x<t.left?h=(u-i.x)/(t.left-i.x):1.01*t.right<i.x?h=(i.x-u)/(i.x-t.right):i.y<t.top?h=(d-i.y)/(t.top-i.y):1.01*t.bottom<i.y&&(h=(i.y-d)/(i.y-t.bottom)),h=Math.round(100*h)/100,a.strokeStyle=c(a.strokeStyle).alpha(h).rgbString(),a.fillStyle=c(a.fillStyle).alpha(h).rgbString()),o.canvas.drawPoint(a,s,l,u,d))}})},{25:25,26:26,45:45}],39:[function(t,e,i){"use strict";var n=t(25),a=t(26);function o(t){return void 0!==t._view.width}function r(t){var e,i,n,a,r=t._view;if(o(t)){var s=r.width/2;e=r.x-s,i=r.x+s,n=Math.min(r.y,r.base),a=Math.max(r.y,r.base)}else{var l=r.height/2;e=Math.min(r.x,r.base),i=Math.max(r.x,r.base),n=r.y-l,a=r.y+l}return{left:e,top:n,right:i,bottom:a}}n._set("global",{elements:{rectangle:{backgroundColor:n.global.defaultColor,borderColor:n.global.defaultColor,borderSkipped:"bottom",borderWidth:0}}}),e.exports=a.extend({draw:function(){var t,e,i,n,a,o,r,s=this._chart.ctx,l=this._view,u=l.borderWidth;if(l.horizontal?(t=l.base,e=l.x,i=l.y-l.height/2,n=l.y+l.height/2,a=e>t?1:-1,o=1,r=l.borderSkipped||"left"):(t=l.x-l.width/2,e=l.x+l.width/2,i=l.y,a=1,o=(n=l.base)>i?1:-1,r=l.borderSkipped||"bottom"),u){var d=Math.min(Math.abs(t-e),Math.abs(i-n)),c=(u=u>d?d:u)/2,h=t+("left"!==r?c*a:0),f=e+("right"!==r?-c*a:0),g=i+("top"!==r?c*o:0),p=n+("bottom"!==r?-c*o:0);h!==f&&(i=g,n=p),g!==p&&(t=h,e=f)}s.beginPath(),s.fillStyle=l.backgroundColor,s.strokeStyle=l.borderColor,s.lineWidth=u;var m=[[t,n],[t,i],[e,i],[e,n]],v=["bottom","left","top","right"].indexOf(r,0);function b(t){return m[(v+t)%4]}-1===v&&(v=0);var x=b(0);s.moveTo(x[0],x[1]);for(var y=1;y<4;y++)x=b(y),s.lineTo(x[0],x[1]);s.fill(),u&&s.stroke()},height:function(){var t=this._view;return t.base-t.y},inRange:function(t,e){var i=!1;if(this._view){var n=r(this);i=t>=n.left&&t<=n.right&&e>=n.top&&e<=n.bottom}return i},inLabelRange:function(t,e){if(!this._view)return!1;var i=r(this);return o(this)?t>=i.left&&t<=i.right:e>=i.top&&e<=i.bottom},inXRange:function(t){var e=r(this);return t>=e.left&&t<=e.right},inYRange:function(t){var e=r(this);return t>=e.top&&t<=e.bottom},getCenterPoint:function(){var t,e,i=this._view;return o(this)?(t=i.x,e=(i.y+i.base)/2):(t=(i.x+i.base)/2,e=i.y),{x:t,y:e}},getArea:function(){var t=this._view;return t.width*Math.abs(t.y-t.base)},tooltipPosition:function(){var t=this._view;return{x:t.x,y:t.y}}})},{25:25,26:26}],40:[function(t,e,i){"use strict";e.exports={},e.exports.Arc=t(36),e.exports.Line=t(37),e.exports.Point=t(38),e.exports.Rectangle=t(39)},{36:36,37:37,38:38,39:39}],41:[function(t,e,i){"use strict";var n=t(42);i=e.exports={clear:function(t){t.ctx.clearRect(0,0,t.width,t.height)},roundedRect:function(t,e,i,n,a,o){if(o){var r=Math.min(o,n/2),s=Math.min(o,a/2);t.moveTo(e+r,i),t.lineTo(e+n-r,i),t.quadraticCurveTo(e+n,i,e+n,i+s),t.lineTo(e+n,i+a-s),t.quadraticCurveTo(e+n,i+a,e+n-r,i+a),t.lineTo(e+r,i+a),t.quadraticCurveTo(e,i+a,e,i+a-s),t.lineTo(e,i+s),t.quadraticCurveTo(e,i,e+r,i)}else t.rect(e,i,n,a)},drawPoint:function(t,e,i,n,a){var o,r,s,l,u,d;if(!e||"object"!=typeof e||"[object HTMLImageElement]"!==(o=e.toString())&&"[object HTMLCanvasElement]"!==o){if(!(isNaN(i)||i<=0)){switch(e){default:t.beginPath(),t.arc(n,a,i,0,2*Math.PI),t.closePath(),t.fill();break;case"triangle":t.beginPath(),u=(r=3*i/Math.sqrt(3))*Math.sqrt(3)/2,t.moveTo(n-r/2,a+u/3),t.lineTo(n+r/2,a+u/3),t.lineTo(n,a-2*u/3),t.closePath(),t.fill();break;case"rect":d=1/Math.SQRT2*i,t.beginPath(),t.fillRect(n-d,a-d,2*d,2*d),t.strokeRect(n-d,a-d,2*d,2*d);break;case"rectRounded":var c=i/Math.SQRT2,h=n-c,f=a-c,g=Math.SQRT2*i;t.beginPath(),this.roundedRect(t,h,f,g,g,i/2),t.closePath(),t.fill();break;case"rectRot":d=1/Math.SQRT2*i,t.beginPath(),t.moveTo(n-d,a),t.lineTo(n,a+d),t.lineTo(n+d,a),t.lineTo(n,a-d),t.closePath(),t.fill();break;case"cross":t.beginPath(),t.moveTo(n,a+i),t.lineTo(n,a-i),t.moveTo(n-i,a),t.lineTo(n+i,a),t.closePath();break;case"crossRot":t.beginPath(),s=Math.cos(Math.PI/4)*i,l=Math.sin(Math.PI/4)*i,t.moveTo(n-s,a-l),t.lineTo(n+s,a+l),t.moveTo(n-s,a+l),t.lineTo(n+s,a-l),t.closePath();break;case"star":t.beginPath(),t.moveTo(n,a+i),t.lineTo(n,a-i),t.moveTo(n-i,a),t.lineTo(n+i,a),s=Math.cos(Math.PI/4)*i,l=Math.sin(Math.PI/4)*i,t.moveTo(n-s,a-l),t.lineTo(n+s,a+l),t.moveTo(n-s,a+l),t.lineTo(n+s,a-l),t.closePath();break;case"line":t.beginPath(),t.moveTo(n-i,a),t.lineTo(n+i,a),t.closePath();break;case"dash":t.beginPath(),t.moveTo(n,a),t.lineTo(n+i,a),t.closePath()}t.stroke()}}else t.drawImage(e,n-e.width/2,a-e.height/2,e.width,e.height)},clipArea:function(t,e){t.save(),t.beginPath(),t.rect(e.left,e.top,e.right-e.left,e.bottom-e.top),t.clip()},unclipArea:function(t){t.restore()},lineTo:function(t,e,i,n){if(i.steppedLine)return"after"===i.steppedLine&&!n||"after"!==i.steppedLine&&n?t.lineTo(e.x,i.y):t.lineTo(i.x,e.y),void t.lineTo(i.x,i.y);i.tension?t.bezierCurveTo(n?e.controlPointPreviousX:e.controlPointNextX,n?e.controlPointPreviousY:e.controlPointNextY,n?i.controlPointNextX:i.controlPointPreviousX,n?i.controlPointNextY:i.controlPointPreviousY,i.x,i.y):t.lineTo(i.x,i.y)}};n.clear=i.clear,n.drawRoundedRectangle=function(t){t.beginPath(),i.roundedRect.apply(i,arguments),t.closePath()}},{42:42}],42:[function(t,e,i){"use strict";var n,a={noop:function(){},uid:(n=0,function(){return n++}),isNullOrUndef:function(t){return null==t},isArray:Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)},isObject:function(t){return null!==t&&"[object Object]"===Object.prototype.toString.call(t)},valueOrDefault:function(t,e){return void 0===t?e:t},valueAtIndexOrDefault:function(t,e,i){return a.valueOrDefault(a.isArray(t)?t[e]:t,i)},callback:function(t,e,i){if(t&&"function"==typeof t.call)return t.apply(i,e)},each:function(t,e,i,n){var o,r,s;if(a.isArray(t))if(r=t.length,n)for(o=r-1;o>=0;o--)e.call(i,t[o],o);else for(o=0;o<r;o++)e.call(i,t[o],o);else if(a.isObject(t))for(r=(s=Object.keys(t)).length,o=0;o<r;o++)e.call(i,t[s[o]],s[o])},arrayEquals:function(t,e){var i,n,o,r;if(!t||!e||t.length!==e.length)return!1;for(i=0,n=t.length;i<n;++i)if(o=t[i],r=e[i],o instanceof Array&&r instanceof Array){if(!a.arrayEquals(o,r))return!1}else if(o!==r)return!1;return!0},clone:function(t){if(a.isArray(t))return t.map(a.clone);if(a.isObject(t)){for(var e={},i=Object.keys(t),n=i.length,o=0;o<n;++o)e[i[o]]=a.clone(t[i[o]]);return e}return t},_merger:function(t,e,i,n){var o=e[t],r=i[t];a.isObject(o)&&a.isObject(r)?a.merge(o,r,n):e[t]=a.clone(r)},_mergerIf:function(t,e,i){var n=e[t],o=i[t];a.isObject(n)&&a.isObject(o)?a.mergeIf(n,o):e.hasOwnProperty(t)||(e[t]=a.clone(o))},merge:function(t,e,i){var n,o,r,s,l,u=a.isArray(e)?e:[e],d=u.length;if(!a.isObject(t))return t;for(n=(i=i||{}).merger||a._merger,o=0;o<d;++o)if(e=u[o],a.isObject(e))for(l=0,s=(r=Object.keys(e)).length;l<s;++l)n(r[l],t,e,i);return t},mergeIf:function(t,e){return a.merge(t,e,{merger:a._mergerIf})},extend:function(t){for(var e=function(e,i){t[i]=e},i=1,n=arguments.length;i<n;++i)a.each(arguments[i],e);return t},inherits:function(t){var e=this,i=t&&t.hasOwnProperty("constructor")?t.constructor:function(){return e.apply(this,arguments)},n=function(){this.constructor=i};return n.prototype=e.prototype,i.prototype=new n,i.extend=a.inherits,t&&a.extend(i.prototype,t),i.__super__=e.prototype,i}};e.exports=a,a.callCallback=a.callback,a.indexOf=function(t,e,i){return Array.prototype.indexOf.call(t,e,i)},a.getValueOrDefault=a.valueOrDefault,a.getValueAtIndexOrDefault=a.valueAtIndexOrDefault},{}],43:[function(t,e,i){"use strict";var n=t(42),a={linear:function(t){return t},easeInQuad:function(t){return t*t},easeOutQuad:function(t){return-t*(t-2)},easeInOutQuad:function(t){return(t/=.5)<1?.5*t*t:-.5*(--t*(t-2)-1)},easeInCubic:function(t){return t*t*t},easeOutCubic:function(t){return(t-=1)*t*t+1},easeInOutCubic:function(t){return(t/=.5)<1?.5*t*t*t:.5*((t-=2)*t*t+2)},easeInQuart:function(t){return t*t*t*t},easeOutQuart:function(t){return-((t-=1)*t*t*t-1)},easeInOutQuart:function(t){return(t/=.5)<1?.5*t*t*t*t:-.5*((t-=2)*t*t*t-2)},easeInQuint:function(t){return t*t*t*t*t},easeOutQuint:function(t){return(t-=1)*t*t*t*t+1},easeInOutQuint:function(t){return(t/=.5)<1?.5*t*t*t*t*t:.5*((t-=2)*t*t*t*t+2)},easeInSine:function(t){return 1-Math.cos(t*(Math.PI/2))},easeOutSine:function(t){return Math.sin(t*(Math.PI/2))},easeInOutSine:function(t){return-.5*(Math.cos(Math.PI*t)-1)},easeInExpo:function(t){return 0===t?0:Math.pow(2,10*(t-1))},easeOutExpo:function(t){return 1===t?1:1-Math.pow(2,-10*t)},easeInOutExpo:function(t){return 0===t?0:1===t?1:(t/=.5)<1?.5*Math.pow(2,10*(t-1)):.5*(2-Math.pow(2,-10*--t))},easeInCirc:function(t){return t>=1?t:-(Math.sqrt(1-t*t)-1)},easeOutCirc:function(t){return Math.sqrt(1-(t-=1)*t)},easeInOutCirc:function(t){return(t/=.5)<1?-.5*(Math.sqrt(1-t*t)-1):.5*(Math.sqrt(1-(t-=2)*t)+1)},easeInElastic:function(t){var e=1.70158,i=0,n=1;return 0===t?0:1===t?1:(i||(i=.3),n<1?(n=1,e=i/4):e=i/(2*Math.PI)*Math.asin(1/n),-n*Math.pow(2,10*(t-=1))*Math.sin((t-e)*(2*Math.PI)/i))},easeOutElastic:function(t){var e=1.70158,i=0,n=1;return 0===t?0:1===t?1:(i||(i=.3),n<1?(n=1,e=i/4):e=i/(2*Math.PI)*Math.asin(1/n),n*Math.pow(2,-10*t)*Math.sin((t-e)*(2*Math.PI)/i)+1)},easeInOutElastic:function(t){var e=1.70158,i=0,n=1;return 0===t?0:2==(t/=.5)?1:(i||(i=.45),n<1?(n=1,e=i/4):e=i/(2*Math.PI)*Math.asin(1/n),t<1?n*Math.pow(2,10*(t-=1))*Math.sin((t-e)*(2*Math.PI)/i)*-.5:n*Math.pow(2,-10*(t-=1))*Math.sin((t-e)*(2*Math.PI)/i)*.5+1)},easeInBack:function(t){return t*t*(2.70158*t-1.70158)},easeOutBack:function(t){return(t-=1)*t*(2.70158*t+1.70158)+1},easeInOutBack:function(t){var e=1.70158;return(t/=.5)<1?t*t*((1+(e*=1.525))*t-e)*.5:.5*((t-=2)*t*((1+(e*=1.525))*t+e)+2)},easeInBounce:function(t){return 1-a.easeOutBounce(1-t)},easeOutBounce:function(t){return t<1/2.75?7.5625*t*t:t<2/2.75?7.5625*(t-=1.5/2.75)*t+.75:t<2.5/2.75?7.5625*(t-=2.25/2.75)*t+.9375:7.5625*(t-=2.625/2.75)*t+.984375},easeInOutBounce:function(t){return t<.5?.5*a.easeInBounce(2*t):.5*a.easeOutBounce(2*t-1)+.5}};e.exports={effects:a},n.easingEffects=a},{42:42}],44:[function(t,e,i){"use strict";var n=t(42);e.exports={toLineHeight:function(t,e){var i=(""+t).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);if(!i||"normal"===i[1])return 1.2*e;switch(t=+i[2],i[3]){case"px":return t;case"%":t/=100}return e*t},toPadding:function(t){var e,i,a,o;return n.isObject(t)?(e=+t.top||0,i=+t.right||0,a=+t.bottom||0,o=+t.left||0):e=i=a=o=+t||0,{top:e,right:i,bottom:a,left:o,height:e+a,width:o+i}},resolve:function(t,e,i){var a,o,r;for(a=0,o=t.length;a<o;++a)if(void 0!==(r=t[a])&&(void 0!==e&&"function"==typeof r&&(r=r(e)),void 0!==i&&n.isArray(r)&&(r=r[i]),void 0!==r))return r}}},{42:42}],45:[function(t,e,i){"use strict";e.exports=t(42),e.exports.easing=t(43),e.exports.canvas=t(41),e.exports.options=t(44)},{41:41,42:42,43:43,44:44}],46:[function(t,e,i){e.exports={acquireContext:function(t){return t&&t.canvas&&(t=t.canvas),t&&t.getContext("2d")||null}}},{}],47:[function(t,e,i){"use strict";var n=t(45),a="$chartjs",o="chartjs-",r=o+"render-monitor",s=o+"render-animation",l=["animationstart","webkitAnimationStart"],u={touchstart:"mousedown",touchmove:"mousemove",touchend:"mouseup",pointerenter:"mouseenter",pointerdown:"mousedown",pointermove:"mousemove",pointerup:"mouseup",pointerleave:"mouseout",pointerout:"mouseout"};function d(t,e){var i=n.getStyle(t,e),a=i&&i.match(/^(\d+)(\.\d+)?px$/);return a?Number(a[1]):void 0}var c=!!function(){var t=!1;try{var e=Object.defineProperty({},"passive",{get:function(){t=!0}});window.addEventListener("e",null,e)}catch(t){}return t}()&&{passive:!0};function h(t,e,i){t.addEventListener(e,i,c)}function f(t,e,i){t.removeEventListener(e,i,c)}function g(t,e,i,n,a){return{type:t,chart:e,native:a||null,x:void 0!==i?i:null,y:void 0!==n?n:null}}function p(t,e,i){var u,d,c,f,p,m,v,b,x=t[a]||(t[a]={}),y=x.resizer=function(t){var e=document.createElement("div"),i=o+"size-monitor",n="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;";e.style.cssText=n,e.className=i,e.innerHTML='<div class="'+i+'-expand" style="'+n+'"><div style="position:absolute;width:1000000px;height:1000000px;left:0;top:0"></div></div><div class="'+i+'-shrink" style="'+n+'"><div style="position:absolute;width:200%;height:200%;left:0; top:0"></div></div>';var a=e.childNodes[0],r=e.childNodes[1];e._reset=function(){a.scrollLeft=1e6,a.scrollTop=1e6,r.scrollLeft=1e6,r.scrollTop=1e6};var s=function(){e._reset(),t()};return h(a,"scroll",s.bind(a,"expand")),h(r,"scroll",s.bind(r,"shrink")),e}((u=function(){if(x.resizer)return e(g("resize",i))},c=!1,f=[],function(){f=Array.prototype.slice.call(arguments),d=d||this,c||(c=!0,n.requestAnimFrame.call(window,function(){c=!1,u.apply(d,f)}))}));m=function(){if(x.resizer){var e=t.parentNode;e&&e!==y.parentNode&&e.insertBefore(y,e.firstChild),y._reset()}},v=(p=t)[a]||(p[a]={}),b=v.renderProxy=function(t){t.animationName===s&&m()},n.each(l,function(t){h(p,t,b)}),v.reflow=!!p.offsetParent,p.classList.add(r)}function m(t){var e,i,o,s=t[a]||{},u=s.resizer;delete s.resizer,i=(e=t)[a]||{},(o=i.renderProxy)&&(n.each(l,function(t){f(e,t,o)}),delete i.renderProxy),e.classList.remove(r),u&&u.parentNode&&u.parentNode.removeChild(u)}e.exports={_enabled:"undefined"!=typeof window&&"undefined"!=typeof document,initialize:function(){var t,e,i,n="from{opacity:0.99}to{opacity:1}";e="@-webkit-keyframes "+s+"{"+n+"}@keyframes "+s+"{"+n+"}."+r+"{-webkit-animation:"+s+" 0.001s;animation:"+s+" 0.001s;}",i=(t=this)._style||document.createElement("style"),t._style||(t._style=i,e="/* Chart.js */\n"+e,i.setAttribute("type","text/css"),document.getElementsByTagName("head")[0].appendChild(i)),i.appendChild(document.createTextNode(e))},acquireContext:function(t,e){"string"==typeof t?t=document.getElementById(t):t.length&&(t=t[0]),t&&t.canvas&&(t=t.canvas);var i=t&&t.getContext&&t.getContext("2d");return i&&i.canvas===t?(function(t,e){var i=t.style,n=t.getAttribute("height"),o=t.getAttribute("width");if(t[a]={initial:{height:n,width:o,style:{display:i.display,height:i.height,width:i.width}}},i.display=i.display||"block",null===o||""===o){var r=d(t,"width");void 0!==r&&(t.width=r)}if(null===n||""===n)if(""===t.style.height)t.height=t.width/(e.options.aspectRatio||2);else{var s=d(t,"height");void 0!==r&&(t.height=s)}}(t,e),i):null},releaseContext:function(t){var e=t.canvas;if(e[a]){var i=e[a].initial;["height","width"].forEach(function(t){var a=i[t];n.isNullOrUndef(a)?e.removeAttribute(t):e.setAttribute(t,a)}),n.each(i.style||{},function(t,i){e.style[i]=t}),e.width=e.width,delete e[a]}},addEventListener:function(t,e,i){var o=t.canvas;if("resize"!==e){var r=i[a]||(i[a]={});h(o,e,(r.proxies||(r.proxies={}))[t.id+"_"+e]=function(e){var a,o,r,s;i((o=t,r=u[(a=e).type]||a.type,s=n.getRelativePosition(a,o),g(r,o,s.x,s.y,a)))})}else p(o,i,t)},removeEventListener:function(t,e,i){var n=t.canvas;if("resize"!==e){var o=((i[a]||{}).proxies||{})[t.id+"_"+e];o&&f(n,e,o)}else m(n)}},n.addEvent=h,n.removeEvent=f},{45:45}],48:[function(t,e,i){"use strict";var n=t(45),a=t(46),o=t(47),r=o._enabled?o:a;e.exports=n.extend({initialize:function(){},acquireContext:function(){},releaseContext:function(){},addEventListener:function(){},removeEventListener:function(){}},r)},{45:45,46:46,47:47}],49:[function(t,e,i){"use strict";e.exports={},e.exports.filler=t(50),e.exports.legend=t(51),e.exports.title=t(52)},{50:50,51:51,52:52}],50:[function(t,e,i){"use strict";var n=t(25),a=t(40),o=t(45);n._set("global",{plugins:{filler:{propagate:!0}}});var r={dataset:function(t){var e=t.fill,i=t.chart,n=i.getDatasetMeta(e),a=n&&i.isDatasetVisible(e)&&n.dataset._children||[],o=a.length||0;return o?function(t,e){return e<o&&a[e]._view||null}:null},boundary:function(t){var e=t.boundary,i=e?e.x:null,n=e?e.y:null;return function(t){return{x:null===i?t.x:i,y:null===n?t.y:n}}}};function s(t,e,i){var n,a=t._model||{},o=a.fill;if(void 0===o&&(o=!!a.backgroundColor),!1===o||null===o)return!1;if(!0===o)return"origin";if(n=parseFloat(o,10),isFinite(n)&&Math.floor(n)===n)return"-"!==o[0]&&"+"!==o[0]||(n=e+n),!(n===e||n<0||n>=i)&&n;switch(o){case"bottom":return"start";case"top":return"end";case"zero":return"origin";case"origin":case"start":case"end":return o;default:return!1}}function l(t){var e,i=t.el._model||{},n=t.el._scale||{},a=t.fill,o=null;if(isFinite(a))return null;if("start"===a?o=void 0===i.scaleBottom?n.bottom:i.scaleBottom:"end"===a?o=void 0===i.scaleTop?n.top:i.scaleTop:void 0!==i.scaleZero?o=i.scaleZero:n.getBasePosition?o=n.getBasePosition():n.getBasePixel&&(o=n.getBasePixel()),null!=o){if(void 0!==o.x&&void 0!==o.y)return o;if("number"==typeof o&&isFinite(o))return{x:(e=n.isHorizontal())?o:null,y:e?null:o}}return null}function u(t,e,i){var n,a=t[e].fill,o=[e];if(!i)return a;for(;!1!==a&&-1===o.indexOf(a);){if(!isFinite(a))return a;if(!(n=t[a]))return!1;if(n.visible)return a;o.push(a),a=n.fill}return!1}function d(t){return t&&!t.skip}function c(t,e,i,n,a){var r;if(n&&a){for(t.moveTo(e[0].x,e[0].y),r=1;r<n;++r)o.canvas.lineTo(t,e[r-1],e[r]);for(t.lineTo(i[a-1].x,i[a-1].y),r=a-1;r>0;--r)o.canvas.lineTo(t,i[r],i[r-1],!0)}}e.exports={id:"filler",afterDatasetsUpdate:function(t,e){var i,n,o,d,c,h,f,g=(t.data.datasets||[]).length,p=e.propagate,m=[];for(n=0;n<g;++n)d=null,(o=(i=t.getDatasetMeta(n)).dataset)&&o._model&&o instanceof a.Line&&(d={visible:t.isDatasetVisible(n),fill:s(o,n,g),chart:t,el:o}),i.$filler=d,m.push(d);for(n=0;n<g;++n)(d=m[n])&&(d.fill=u(m,n,p),d.boundary=l(d),d.mapper=(void 0,f=void 0,h=(c=d).fill,f="dataset",!1===h?null:(isFinite(h)||(f="boundary"),r[f](c))))},beforeDatasetDraw:function(t,e){var i=e.meta.$filler;if(i){var a=t.ctx,r=i.el,s=r._view,l=r._children||[],u=i.mapper,h=s.backgroundColor||n.global.defaultColor;u&&h&&l.length&&(o.canvas.clipArea(a,t.chartArea),function(t,e,i,n,a,o){var r,s,l,u,h,f,g,p=e.length,m=n.spanGaps,v=[],b=[],x=0,y=0;for(t.beginPath(),r=0,s=p+!!o;r<s;++r)h=i(u=e[l=r%p]._view,l,n),f=d(u),g=d(h),f&&g?(x=v.push(u),y=b.push(h)):x&&y&&(m?(f&&v.push(u),g&&b.push(h)):(c(t,v,b,x,y),x=y=0,v=[],b=[]));c(t,v,b,x,y),t.closePath(),t.fillStyle=a,t.fill()}(a,l,u,s,h,r._loop),o.canvas.unclipArea(a))}}}},{25:25,40:40,45:45}],51:[function(t,e,i){"use strict";var n=t(25),a=t(26),o=t(45),r=t(30),s=o.noop;function l(t,e){return t.usePointStyle?e*Math.SQRT2:t.boxWidth}n._set("global",{legend:{display:!0,position:"top",fullWidth:!0,reverse:!1,weight:1e3,onClick:function(t,e){var i=e.datasetIndex,n=this.chart,a=n.getDatasetMeta(i);a.hidden=null===a.hidden?!n.data.datasets[i].hidden:null,n.update()},onHover:null,labels:{boxWidth:40,padding:10,generateLabels:function(t){var e=t.data;return o.isArray(e.datasets)?e.datasets.map(function(e,i){return{text:e.label,fillStyle:o.isArray(e.backgroundColor)?e.backgroundColor[0]:e.backgroundColor,hidden:!t.isDatasetVisible(i),lineCap:e.borderCapStyle,lineDash:e.borderDash,lineDashOffset:e.borderDashOffset,lineJoin:e.borderJoinStyle,lineWidth:e.borderWidth,strokeStyle:e.borderColor,pointStyle:e.pointStyle,datasetIndex:i}},this):[]}}},legendCallback:function(t){var e=[];e.push('<ul class="'+t.id+'-legend">');for(var i=0;i<t.data.datasets.length;i++)e.push('<li><span style="background-color:'+t.data.datasets[i].backgroundColor+'"></span>'),t.data.datasets[i].label&&e.push(t.data.datasets[i].label),e.push("</li>");return e.push("</ul>"),e.join("")}});var u=a.extend({initialize:function(t){o.extend(this,t),this.legendHitBoxes=[],this.doughnutMode=!1},beforeUpdate:s,update:function(t,e,i){var n=this;return n.beforeUpdate(),n.maxWidth=t,n.maxHeight=e,n.margins=i,n.beforeSetDimensions(),n.setDimensions(),n.afterSetDimensions(),n.beforeBuildLabels(),n.buildLabels(),n.afterBuildLabels(),n.beforeFit(),n.fit(),n.afterFit(),n.afterUpdate(),n.minSize},afterUpdate:s,beforeSetDimensions:s,setDimensions:function(){var t=this;t.isHorizontal()?(t.width=t.maxWidth,t.left=0,t.right=t.width):(t.height=t.maxHeight,t.top=0,t.bottom=t.height),t.paddingLeft=0,t.paddingTop=0,t.paddingRight=0,t.paddingBottom=0,t.minSize={width:0,height:0}},afterSetDimensions:s,beforeBuildLabels:s,buildLabels:function(){var t=this,e=t.options.labels||{},i=o.callback(e.generateLabels,[t.chart],t)||[];e.filter&&(i=i.filter(function(i){return e.filter(i,t.chart.data)})),t.options.reverse&&i.reverse(),t.legendItems=i},afterBuildLabels:s,beforeFit:s,fit:function(){var t=this,e=t.options,i=e.labels,a=e.display,r=t.ctx,s=n.global,u=o.valueOrDefault,d=u(i.fontSize,s.defaultFontSize),c=u(i.fontStyle,s.defaultFontStyle),h=u(i.fontFamily,s.defaultFontFamily),f=o.fontString(d,c,h),g=t.legendHitBoxes=[],p=t.minSize,m=t.isHorizontal();if(m?(p.width=t.maxWidth,p.height=a?10:0):(p.width=a?10:0,p.height=t.maxHeight),a)if(r.font=f,m){var v=t.lineWidths=[0],b=t.legendItems.length?d+i.padding:0;r.textAlign="left",r.textBaseline="top",o.each(t.legendItems,function(e,n){var a=l(i,d)+d/2+r.measureText(e.text).width;v[v.length-1]+a+i.padding>=t.width&&(b+=d+i.padding,v[v.length]=t.left),g[n]={left:0,top:0,width:a,height:d},v[v.length-1]+=a+i.padding}),p.height+=b}else{var x=i.padding,y=t.columnWidths=[],k=i.padding,M=0,w=0,S=d+x;o.each(t.legendItems,function(t,e){var n=l(i,d)+d/2+r.measureText(t.text).width;w+S>p.height&&(k+=M+i.padding,y.push(M),M=0,w=0),M=Math.max(M,n),w+=S,g[e]={left:0,top:0,width:n,height:d}}),k+=M,y.push(M),p.width+=k}t.width=p.width,t.height=p.height},afterFit:s,isHorizontal:function(){return"top"===this.options.position||"bottom"===this.options.position},draw:function(){var t=this,e=t.options,i=e.labels,a=n.global,r=a.elements.line,s=t.width,u=t.lineWidths;if(e.display){var d,c=t.ctx,h=o.valueOrDefault,f=h(i.fontColor,a.defaultFontColor),g=h(i.fontSize,a.defaultFontSize),p=h(i.fontStyle,a.defaultFontStyle),m=h(i.fontFamily,a.defaultFontFamily),v=o.fontString(g,p,m);c.textAlign="left",c.textBaseline="middle",c.lineWidth=.5,c.strokeStyle=f,c.fillStyle=f,c.font=v;var b=l(i,g),x=t.legendHitBoxes,y=t.isHorizontal();d=y?{x:t.left+(s-u[0])/2,y:t.top+i.padding,line:0}:{x:t.left+i.padding,y:t.top+i.padding,line:0};var k=g+i.padding;o.each(t.legendItems,function(n,l){var f,p,m,v,M,w=c.measureText(n.text).width,S=b+g/2+w,C=d.x,_=d.y;y?C+S>=s&&(_=d.y+=k,d.line++,C=d.x=t.left+(s-u[d.line])/2):_+k>t.bottom&&(C=d.x=C+t.columnWidths[d.line]+i.padding,_=d.y=t.top+i.padding,d.line++),function(t,i,n){if(!(isNaN(b)||b<=0)){c.save(),c.fillStyle=h(n.fillStyle,a.defaultColor),c.lineCap=h(n.lineCap,r.borderCapStyle),c.lineDashOffset=h(n.lineDashOffset,r.borderDashOffset),c.lineJoin=h(n.lineJoin,r.borderJoinStyle),c.lineWidth=h(n.lineWidth,r.borderWidth),c.strokeStyle=h(n.strokeStyle,a.defaultColor);var s=0===h(n.lineWidth,r.borderWidth);if(c.setLineDash&&c.setLineDash(h(n.lineDash,r.borderDash)),e.labels&&e.labels.usePointStyle){var l=g*Math.SQRT2/2,u=l/Math.SQRT2,d=t+u,f=i+u;o.canvas.drawPoint(c,n.pointStyle,l,d,f)}else s||c.strokeRect(t,i,b,g),c.fillRect(t,i,b,g);c.restore()}}(C,_,n),x[l].left=C,x[l].top=_,f=n,p=w,v=b+(m=g/2)+C,M=_+m,c.fillText(f.text,v,M),f.hidden&&(c.beginPath(),c.lineWidth=2,c.moveTo(v,M),c.lineTo(v+p,M),c.stroke()),y?d.x+=S+i.padding:d.y+=k})}},handleEvent:function(t){var e=this,i=e.options,n="mouseup"===t.type?"click":t.type,a=!1;if("mousemove"===n){if(!i.onHover)return}else{if("click"!==n)return;if(!i.onClick)return}var o=t.x,r=t.y;if(o>=e.left&&o<=e.right&&r>=e.top&&r<=e.bottom)for(var s=e.legendHitBoxes,l=0;l<s.length;++l){var u=s[l];if(o>=u.left&&o<=u.left+u.width&&r>=u.top&&r<=u.top+u.height){if("click"===n){i.onClick.call(e,t.native,e.legendItems[l]),a=!0;break}if("mousemove"===n){i.onHover.call(e,t.native,e.legendItems[l]),a=!0;break}}}return a}});function d(t,e){var i=new u({ctx:t.ctx,options:e,chart:t});r.configure(t,i,e),r.addBox(t,i),t.legend=i}e.exports={id:"legend",_element:u,beforeInit:function(t){var e=t.options.legend;e&&d(t,e)},beforeUpdate:function(t){var e=t.options.legend,i=t.legend;e?(o.mergeIf(e,n.global.legend),i?(r.configure(t,i,e),i.options=e):d(t,e)):i&&(r.removeBox(t,i),delete t.legend)},afterEvent:function(t,e){var i=t.legend;i&&i.handleEvent(e)}}},{25:25,26:26,30:30,45:45}],52:[function(t,e,i){"use strict";var n=t(25),a=t(26),o=t(45),r=t(30),s=o.noop;n._set("global",{title:{display:!1,fontStyle:"bold",fullWidth:!0,lineHeight:1.2,padding:10,position:"top",text:"",weight:2e3}});var l=a.extend({initialize:function(t){o.extend(this,t),this.legendHitBoxes=[]},beforeUpdate:s,update:function(t,e,i){var n=this;return n.beforeUpdate(),n.maxWidth=t,n.maxHeight=e,n.margins=i,n.beforeSetDimensions(),n.setDimensions(),n.afterSetDimensions(),n.beforeBuildLabels(),n.buildLabels(),n.afterBuildLabels(),n.beforeFit(),n.fit(),n.afterFit(),n.afterUpdate(),n.minSize},afterUpdate:s,beforeSetDimensions:s,setDimensions:function(){var t=this;t.isHorizontal()?(t.width=t.maxWidth,t.left=0,t.right=t.width):(t.height=t.maxHeight,t.top=0,t.bottom=t.height),t.paddingLeft=0,t.paddingTop=0,t.paddingRight=0,t.paddingBottom=0,t.minSize={width:0,height:0}},afterSetDimensions:s,beforeBuildLabels:s,buildLabels:s,afterBuildLabels:s,beforeFit:s,fit:function(){var t=this,e=o.valueOrDefault,i=t.options,a=i.display,r=e(i.fontSize,n.global.defaultFontSize),s=t.minSize,l=o.isArray(i.text)?i.text.length:1,u=o.options.toLineHeight(i.lineHeight,r),d=a?l*u+2*i.padding:0;t.isHorizontal()?(s.width=t.maxWidth,s.height=d):(s.width=d,s.height=t.maxHeight),t.width=s.width,t.height=s.height},afterFit:s,isHorizontal:function(){var t=this.options.position;return"top"===t||"bottom"===t},draw:function(){var t=this,e=t.ctx,i=o.valueOrDefault,a=t.options,r=n.global;if(a.display){var s,l,u,d=i(a.fontSize,r.defaultFontSize),c=i(a.fontStyle,r.defaultFontStyle),h=i(a.fontFamily,r.defaultFontFamily),f=o.fontString(d,c,h),g=o.options.toLineHeight(a.lineHeight,d),p=g/2+a.padding,m=0,v=t.top,b=t.left,x=t.bottom,y=t.right;e.fillStyle=i(a.fontColor,r.defaultFontColor),e.font=f,t.isHorizontal()?(l=b+(y-b)/2,u=v+p,s=y-b):(l="left"===a.position?b+p:y-p,u=v+(x-v)/2,s=x-v,m=Math.PI*("left"===a.position?-.5:.5)),e.save(),e.translate(l,u),e.rotate(m),e.textAlign="center",e.textBaseline="middle";var k=a.text;if(o.isArray(k))for(var M=0,w=0;w<k.length;++w)e.fillText(k[w],0,M,s),M+=g;else e.fillText(k,0,0,s);e.restore()}}});function u(t,e){var i=new l({ctx:t.ctx,options:e,chart:t});r.configure(t,i,e),r.addBox(t,i),t.titleBlock=i}e.exports={id:"title",_element:l,beforeInit:function(t){var e=t.options.title;e&&u(t,e)},beforeUpdate:function(t){var e=t.options.title,i=t.titleBlock;e?(o.mergeIf(e,n.global.title),i?(r.configure(t,i,e),i.options=e):u(t,e)):i&&(r.removeBox(t,i),delete t.titleBlock)}}},{25:25,26:26,30:30,45:45}],53:[function(t,e,i){"use strict";e.exports=function(t){var e=t.Scale.extend({getLabels:function(){var t=this.chart.data;return this.options.labels||(this.isHorizontal()?t.xLabels:t.yLabels)||t.labels},determineDataLimits:function(){var t,e=this,i=e.getLabels();e.minIndex=0,e.maxIndex=i.length-1,void 0!==e.options.ticks.min&&(t=i.indexOf(e.options.ticks.min),e.minIndex=-1!==t?t:e.minIndex),void 0!==e.options.ticks.max&&(t=i.indexOf(e.options.ticks.max),e.maxIndex=-1!==t?t:e.maxIndex),e.min=i[e.minIndex],e.max=i[e.maxIndex]},buildTicks:function(){var t=this,e=t.getLabels();t.ticks=0===t.minIndex&&t.maxIndex===e.length-1?e:e.slice(t.minIndex,t.maxIndex+1)},getLabelForIndex:function(t,e){var i=this,n=i.chart.data,a=i.isHorizontal();return n.yLabels&&!a?i.getRightValue(n.datasets[e].data[t]):i.ticks[t-i.minIndex]},getPixelForValue:function(t,e){var i,n=this,a=n.options.offset,o=Math.max(n.maxIndex+1-n.minIndex-(a?0:1),1);if(null!=t&&(i=n.isHorizontal()?t.x:t.y),void 0!==i||void 0!==t&&isNaN(e)){t=i||t;var r=n.getLabels().indexOf(t);e=-1!==r?r:e}if(n.isHorizontal()){var s=n.width/o,l=s*(e-n.minIndex);return a&&(l+=s/2),n.left+Math.round(l)}var u=n.height/o,d=u*(e-n.minIndex);return a&&(d+=u/2),n.top+Math.round(d)},getPixelForTick:function(t){return this.getPixelForValue(this.ticks[t],t+this.minIndex,null)},getValueForPixel:function(t){var e=this,i=e.options.offset,n=Math.max(e._ticks.length-(i?0:1),1),a=e.isHorizontal(),o=(a?e.width:e.height)/n;return t-=a?e.left:e.top,i&&(t-=o/2),(t<=0?0:Math.round(t/o))+e.minIndex},getBasePixel:function(){return this.bottom}});t.scaleService.registerScaleType("category",e,{position:"bottom"})}},{}],54:[function(t,e,i){"use strict";var n=t(25),a=t(45),o=t(34);e.exports=function(t){var e={position:"left",ticks:{callback:o.formatters.linear}},i=t.LinearScaleBase.extend({determineDataLimits:function(){var t=this,e=t.options,i=t.chart,n=i.data.datasets,o=t.isHorizontal();function r(e){return o?e.xAxisID===t.id:e.yAxisID===t.id}t.min=null,t.max=null;var s=e.stacked;if(void 0===s&&a.each(n,function(t,e){if(!s){var n=i.getDatasetMeta(e);i.isDatasetVisible(e)&&r(n)&&void 0!==n.stack&&(s=!0)}}),e.stacked||s){var l={};a.each(n,function(n,o){var s=i.getDatasetMeta(o),u=[s.type,void 0===e.stacked&&void 0===s.stack?o:"",s.stack].join(".");void 0===l[u]&&(l[u]={positiveValues:[],negativeValues:[]});var d=l[u].positiveValues,c=l[u].negativeValues;i.isDatasetVisible(o)&&r(s)&&a.each(n.data,function(i,n){var a=+t.getRightValue(i);isNaN(a)||s.data[n].hidden||(d[n]=d[n]||0,c[n]=c[n]||0,e.relativePoints?d[n]=100:a<0?c[n]+=a:d[n]+=a)})}),a.each(l,function(e){var i=e.positiveValues.concat(e.negativeValues),n=a.min(i),o=a.max(i);t.min=null===t.min?n:Math.min(t.min,n),t.max=null===t.max?o:Math.max(t.max,o)})}else a.each(n,function(e,n){var o=i.getDatasetMeta(n);i.isDatasetVisible(n)&&r(o)&&a.each(e.data,function(e,i){var n=+t.getRightValue(e);isNaN(n)||o.data[i].hidden||(null===t.min?t.min=n:n<t.min&&(t.min=n),null===t.max?t.max=n:n>t.max&&(t.max=n))})});t.min=isFinite(t.min)&&!isNaN(t.min)?t.min:0,t.max=isFinite(t.max)&&!isNaN(t.max)?t.max:1,this.handleTickRangeOptions()},getTickLimit:function(){var t,e=this.options.ticks;if(this.isHorizontal())t=Math.min(e.maxTicksLimit?e.maxTicksLimit:11,Math.ceil(this.width/50));else{var i=a.valueOrDefault(e.fontSize,n.global.defaultFontSize);t=Math.min(e.maxTicksLimit?e.maxTicksLimit:11,Math.ceil(this.height/(2*i)))}return t},handleDirectionalChanges:function(){this.isHorizontal()||this.ticks.reverse()},getLabelForIndex:function(t,e){return+this.getRightValue(this.chart.data.datasets[e].data[t])},getPixelForValue:function(t){var e=this,i=e.start,n=+e.getRightValue(t),a=e.end-i;return e.isHorizontal()?e.left+e.width/a*(n-i):e.bottom-e.height/a*(n-i)},getValueForPixel:function(t){var e=this,i=e.isHorizontal(),n=i?e.width:e.height,a=(i?t-e.left:e.bottom-t)/n;return e.start+(e.end-e.start)*a},getPixelForTick:function(t){return this.getPixelForValue(this.ticksAsNumbers[t])}});t.scaleService.registerScaleType("linear",i,e)}},{25:25,34:34,45:45}],55:[function(t,e,i){"use strict";var n=t(45);e.exports=function(t){var e=n.noop;t.LinearScaleBase=t.Scale.extend({getRightValue:function(e){return"string"==typeof e?+e:t.Scale.prototype.getRightValue.call(this,e)},handleTickRangeOptions:function(){var t=this,e=t.options.ticks;if(e.beginAtZero){var i=n.sign(t.min),a=n.sign(t.max);i<0&&a<0?t.max=0:i>0&&a>0&&(t.min=0)}var o=void 0!==e.min||void 0!==e.suggestedMin,r=void 0!==e.max||void 0!==e.suggestedMax;void 0!==e.min?t.min=e.min:void 0!==e.suggestedMin&&(null===t.min?t.min=e.suggestedMin:t.min=Math.min(t.min,e.suggestedMin)),void 0!==e.max?t.max=e.max:void 0!==e.suggestedMax&&(null===t.max?t.max=e.suggestedMax:t.max=Math.max(t.max,e.suggestedMax)),o!==r&&t.min>=t.max&&(o?t.max=t.min+1:t.min=t.max-1),t.min===t.max&&(t.max++,e.beginAtZero||t.min--)},getTickLimit:e,handleDirectionalChanges:e,buildTicks:function(){var t=this,e=t.options.ticks,i=t.getTickLimit(),a={maxTicks:i=Math.max(2,i),min:e.min,max:e.max,stepSize:n.valueOrDefault(e.fixedStepSize,e.stepSize)},o=t.ticks=function(t,e){var i,a=[];if(t.stepSize&&t.stepSize>0)i=t.stepSize;else{var o=n.niceNum(e.max-e.min,!1);i=n.niceNum(o/(t.maxTicks-1),!0)}var r=Math.floor(e.min/i)*i,s=Math.ceil(e.max/i)*i;t.min&&t.max&&t.stepSize&&n.almostWhole((t.max-t.min)/t.stepSize,i/1e3)&&(r=t.min,s=t.max);var l=(s-r)/i;l=n.almostEquals(l,Math.round(l),i/1e3)?Math.round(l):Math.ceil(l);var u=1;i<1&&(u=Math.pow(10,i.toString().length-2),r=Math.round(r*u)/u,s=Math.round(s*u)/u),a.push(void 0!==t.min?t.min:r);for(var d=1;d<l;++d)a.push(Math.round((r+d*i)*u)/u);return a.push(void 0!==t.max?t.max:s),a}(a,t);t.handleDirectionalChanges(),t.max=n.max(o),t.min=n.min(o),e.reverse?(o.reverse(),t.start=t.max,t.end=t.min):(t.start=t.min,t.end=t.max)},convertTicksToLabels:function(){var e=this;e.ticksAsNumbers=e.ticks.slice(),e.zeroLineIndex=e.ticks.indexOf(0),t.Scale.prototype.convertTicksToLabels.call(e)}})}},{45:45}],56:[function(t,e,i){"use strict";var n=t(45),a=t(34);e.exports=function(t){var e={position:"left",ticks:{callback:a.formatters.logarithmic}},i=t.Scale.extend({determineDataLimits:function(){var t=this,e=t.options,i=t.chart,a=i.data.datasets,o=t.isHorizontal();function r(e){return o?e.xAxisID===t.id:e.yAxisID===t.id}t.min=null,t.max=null,t.minNotZero=null;var s=e.stacked;if(void 0===s&&n.each(a,function(t,e){if(!s){var n=i.getDatasetMeta(e);i.isDatasetVisible(e)&&r(n)&&void 0!==n.stack&&(s=!0)}}),e.stacked||s){var l={};n.each(a,function(a,o){var s=i.getDatasetMeta(o),u=[s.type,void 0===e.stacked&&void 0===s.stack?o:"",s.stack].join(".");i.isDatasetVisible(o)&&r(s)&&(void 0===l[u]&&(l[u]=[]),n.each(a.data,function(e,i){var n=l[u],a=+t.getRightValue(e);isNaN(a)||s.data[i].hidden||a<0||(n[i]=n[i]||0,n[i]+=a)}))}),n.each(l,function(e){if(e.length>0){var i=n.min(e),a=n.max(e);t.min=null===t.min?i:Math.min(t.min,i),t.max=null===t.max?a:Math.max(t.max,a)}})}else n.each(a,function(e,a){var o=i.getDatasetMeta(a);i.isDatasetVisible(a)&&r(o)&&n.each(e.data,function(e,i){var n=+t.getRightValue(e);isNaN(n)||o.data[i].hidden||n<0||(null===t.min?t.min=n:n<t.min&&(t.min=n),null===t.max?t.max=n:n>t.max&&(t.max=n),0!==n&&(null===t.minNotZero||n<t.minNotZero)&&(t.minNotZero=n))})});this.handleTickRangeOptions()},handleTickRangeOptions:function(){var t=this,e=t.options.ticks,i=n.valueOrDefault;t.min=i(e.min,t.min),t.max=i(e.max,t.max),t.min===t.max&&(0!==t.min&&null!==t.min?(t.min=Math.pow(10,Math.floor(n.log10(t.min))-1),t.max=Math.pow(10,Math.floor(n.log10(t.max))+1)):(t.min=1,t.max=10)),null===t.min&&(t.min=Math.pow(10,Math.floor(n.log10(t.max))-1)),null===t.max&&(t.max=0!==t.min?Math.pow(10,Math.floor(n.log10(t.min))+1):10),null===t.minNotZero&&(t.min>0?t.minNotZero=t.min:t.max<1?t.minNotZero=Math.pow(10,Math.floor(n.log10(t.max))):t.minNotZero=1)},buildTicks:function(){var t=this,e=t.options.ticks,i=!t.isHorizontal(),a={min:e.min,max:e.max},o=t.ticks=function(t,e){var i,a,o=[],r=n.valueOrDefault,s=r(t.min,Math.pow(10,Math.floor(n.log10(e.min)))),l=Math.floor(n.log10(e.max)),u=Math.ceil(e.max/Math.pow(10,l));0===s?(i=Math.floor(n.log10(e.minNotZero)),a=Math.floor(e.minNotZero/Math.pow(10,i)),o.push(s),s=a*Math.pow(10,i)):(i=Math.floor(n.log10(s)),a=Math.floor(s/Math.pow(10,i)));for(var d=i<0?Math.pow(10,Math.abs(i)):1;o.push(s),10==++a&&(a=1,d=++i>=0?1:d),s=Math.round(a*Math.pow(10,i)*d)/d,i<l||i===l&&a<u;);var c=r(t.max,s);return o.push(c),o}(a,t);t.max=n.max(o),t.min=n.min(o),e.reverse?(i=!i,t.start=t.max,t.end=t.min):(t.start=t.min,t.end=t.max),i&&o.reverse()},convertTicksToLabels:function(){this.tickValues=this.ticks.slice(),t.Scale.prototype.convertTicksToLabels.call(this)},getLabelForIndex:function(t,e){return+this.getRightValue(this.chart.data.datasets[e].data[t])},getPixelForTick:function(t){return this.getPixelForValue(this.tickValues[t])},_getFirstTickValue:function(t){var e=Math.floor(n.log10(t));return Math.floor(t/Math.pow(10,e))*Math.pow(10,e)},getPixelForValue:function(e){var i,a,o,r,s,l=this,u=l.options.ticks.reverse,d=n.log10,c=l._getFirstTickValue(l.minNotZero),h=0;return e=+l.getRightValue(e),u?(o=l.end,r=l.start,s=-1):(o=l.start,r=l.end,s=1),l.isHorizontal()?(i=l.width,a=u?l.right:l.left):(i=l.height,s*=-1,a=u?l.top:l.bottom),e!==o&&(0===o&&(i-=h=n.getValueOrDefault(l.options.ticks.fontSize,t.defaults.global.defaultFontSize),o=c),0!==e&&(h+=i/(d(r)-d(o))*(d(e)-d(o))),a+=s*h),a},getValueForPixel:function(e){var i,a,o,r,s=this,l=s.options.ticks.reverse,u=n.log10,d=s._getFirstTickValue(s.minNotZero);if(l?(a=s.end,o=s.start):(a=s.start,o=s.end),s.isHorizontal()?(i=s.width,r=l?s.right-e:e-s.left):(i=s.height,r=l?e-s.top:s.bottom-e),r!==a){if(0===a){var c=n.getValueOrDefault(s.options.ticks.fontSize,t.defaults.global.defaultFontSize);r-=c,i-=c,a=d}r*=u(o)-u(a),r/=i,r=Math.pow(10,u(a)+r)}return r}});t.scaleService.registerScaleType("logarithmic",i,e)}},{34:34,45:45}],57:[function(t,e,i){"use strict";var n=t(25),a=t(45),o=t(34);e.exports=function(t){var e=n.global,i={display:!0,animate:!0,position:"chartArea",angleLines:{display:!0,color:"rgba(0, 0, 0, 0.1)",lineWidth:1},gridLines:{circular:!1},ticks:{showLabelBackdrop:!0,backdropColor:"rgba(255,255,255,0.75)",backdropPaddingY:2,backdropPaddingX:2,callback:o.formatters.linear},pointLabels:{display:!0,fontSize:10,callback:function(t){return t}}};function r(t){var e=t.options;return e.angleLines.display||e.pointLabels.display?t.chart.data.labels.length:0}function s(t){var i=t.options.pointLabels,n=a.valueOrDefault(i.fontSize,e.defaultFontSize),o=a.valueOrDefault(i.fontStyle,e.defaultFontStyle),r=a.valueOrDefault(i.fontFamily,e.defaultFontFamily);return{size:n,style:o,family:r,font:a.fontString(n,o,r)}}function l(t,e,i,n,a){return t===n||t===a?{start:e-i/2,end:e+i/2}:t<n||t>a?{start:e-i-5,end:e}:{start:e,end:e+i+5}}function u(t,e,i,n){if(a.isArray(e))for(var o=i.y,r=1.5*n,s=0;s<e.length;++s)t.fillText(e[s],i.x,o),o+=r;else t.fillText(e,i.x,i.y)}function d(t){return a.isNumber(t)?t:0}var c=t.LinearScaleBase.extend({setDimensions:function(){var t=this,i=t.options,n=i.ticks;t.width=t.maxWidth,t.height=t.maxHeight,t.xCenter=Math.round(t.width/2),t.yCenter=Math.round(t.height/2);var o=a.min([t.height,t.width]),r=a.valueOrDefault(n.fontSize,e.defaultFontSize);t.drawingArea=i.display?o/2-(r/2+n.backdropPaddingY):o/2},determineDataLimits:function(){var t=this,e=t.chart,i=Number.POSITIVE_INFINITY,n=Number.NEGATIVE_INFINITY;a.each(e.data.datasets,function(o,r){if(e.isDatasetVisible(r)){var s=e.getDatasetMeta(r);a.each(o.data,function(e,a){var o=+t.getRightValue(e);isNaN(o)||s.data[a].hidden||(i=Math.min(o,i),n=Math.max(o,n))})}}),t.min=i===Number.POSITIVE_INFINITY?0:i,t.max=n===Number.NEGATIVE_INFINITY?0:n,t.handleTickRangeOptions()},getTickLimit:function(){var t=this.options.ticks,i=a.valueOrDefault(t.fontSize,e.defaultFontSize);return Math.min(t.maxTicksLimit?t.maxTicksLimit:11,Math.ceil(this.drawingArea/(1.5*i)))},convertTicksToLabels:function(){var e=this;t.LinearScaleBase.prototype.convertTicksToLabels.call(e),e.pointLabels=e.chart.data.labels.map(e.options.pointLabels.callback,e)},getLabelForIndex:function(t,e){return+this.getRightValue(this.chart.data.datasets[e].data[t])},fit:function(){var t,e;this.options.pointLabels.display?function(t){var e,i,n,o=s(t),u=Math.min(t.height/2,t.width/2),d={r:t.width,l:0,t:t.height,b:0},c={};t.ctx.font=o.font,t._pointLabelSizes=[];var h,f,g,p=r(t);for(e=0;e<p;e++){n=t.getPointPosition(e,u),h=t.ctx,f=o.size,g=t.pointLabels[e]||"",i=a.isArray(g)?{w:a.longestText(h,h.font,g),h:g.length*f+1.5*(g.length-1)*f}:{w:h.measureText(g).width,h:f},t._pointLabelSizes[e]=i;var m=t.getIndexAngle(e),v=a.toDegrees(m)%360,b=l(v,n.x,i.w,0,180),x=l(v,n.y,i.h,90,270);b.start<d.l&&(d.l=b.start,c.l=m),b.end>d.r&&(d.r=b.end,c.r=m),x.start<d.t&&(d.t=x.start,c.t=m),x.end>d.b&&(d.b=x.end,c.b=m)}t.setReductions(u,d,c)}(this):(t=this,e=Math.min(t.height/2,t.width/2),t.drawingArea=Math.round(e),t.setCenterPoint(0,0,0,0))},setReductions:function(t,e,i){var n=e.l/Math.sin(i.l),a=Math.max(e.r-this.width,0)/Math.sin(i.r),o=-e.t/Math.cos(i.t),r=-Math.max(e.b-this.height,0)/Math.cos(i.b);n=d(n),a=d(a),o=d(o),r=d(r),this.drawingArea=Math.min(Math.round(t-(n+a)/2),Math.round(t-(o+r)/2)),this.setCenterPoint(n,a,o,r)},setCenterPoint:function(t,e,i,n){var a=this,o=a.width-e-a.drawingArea,r=t+a.drawingArea,s=i+a.drawingArea,l=a.height-n-a.drawingArea;a.xCenter=Math.round((r+o)/2+a.left),a.yCenter=Math.round((s+l)/2+a.top)},getIndexAngle:function(t){return t*(2*Math.PI/r(this))+(this.chart.options&&this.chart.options.startAngle?this.chart.options.startAngle:0)*Math.PI*2/360},getDistanceFromCenterForValue:function(t){var e=this;if(null===t)return 0;var i=e.drawingArea/(e.max-e.min);return e.options.ticks.reverse?(e.max-t)*i:(t-e.min)*i},getPointPosition:function(t,e){var i=this.getIndexAngle(t)-Math.PI/2;return{x:Math.round(Math.cos(i)*e)+this.xCenter,y:Math.round(Math.sin(i)*e)+this.yCenter}},getPointPositionForValue:function(t,e){return this.getPointPosition(t,this.getDistanceFromCenterForValue(e))},getBasePosition:function(){var t=this.min,e=this.max;return this.getPointPositionForValue(0,this.beginAtZero?0:t<0&&e<0?e:t>0&&e>0?t:0)},draw:function(){var t=this,i=t.options,n=i.gridLines,o=i.ticks,l=a.valueOrDefault;if(i.display){var d=t.ctx,c=this.getIndexAngle(0),h=l(o.fontSize,e.defaultFontSize),f=l(o.fontStyle,e.defaultFontStyle),g=l(o.fontFamily,e.defaultFontFamily),p=a.fontString(h,f,g);a.each(t.ticks,function(i,s){if(s>0||o.reverse){var u=t.getDistanceFromCenterForValue(t.ticksAsNumbers[s]);if(n.display&&0!==s&&function(t,e,i,n){var o=t.ctx;if(o.strokeStyle=a.valueAtIndexOrDefault(e.color,n-1),o.lineWidth=a.valueAtIndexOrDefault(e.lineWidth,n-1),t.options.gridLines.circular)o.beginPath(),o.arc(t.xCenter,t.yCenter,i,0,2*Math.PI),o.closePath(),o.stroke();else{var s=r(t);if(0===s)return;o.beginPath();var l=t.getPointPosition(0,i);o.moveTo(l.x,l.y);for(var u=1;u<s;u++)l=t.getPointPosition(u,i),o.lineTo(l.x,l.y);o.closePath(),o.stroke()}}(t,n,u,s),o.display){var f=l(o.fontColor,e.defaultFontColor);if(d.font=p,d.save(),d.translate(t.xCenter,t.yCenter),d.rotate(c),o.showLabelBackdrop){var g=d.measureText(i).width;d.fillStyle=o.backdropColor,d.fillRect(-g/2-o.backdropPaddingX,-u-h/2-o.backdropPaddingY,g+2*o.backdropPaddingX,h+2*o.backdropPaddingY)}d.textAlign="center",d.textBaseline="middle",d.fillStyle=f,d.fillText(i,0,-u),d.restore()}}}),(i.angleLines.display||i.pointLabels.display)&&function(t){var i=t.ctx,n=t.options,o=n.angleLines,l=n.pointLabels;i.lineWidth=o.lineWidth,i.strokeStyle=o.color;var d,c,h,f,g=t.getDistanceFromCenterForValue(n.ticks.reverse?t.min:t.max),p=s(t);i.textBaseline="top";for(var m=r(t)-1;m>=0;m--){if(o.display){var v=t.getPointPosition(m,g);i.beginPath(),i.moveTo(t.xCenter,t.yCenter),i.lineTo(v.x,v.y),i.stroke(),i.closePath()}if(l.display){var b=t.getPointPosition(m,g+5),x=a.valueAtIndexOrDefault(l.fontColor,m,e.defaultFontColor);i.font=p.font,i.fillStyle=x;var y=t.getIndexAngle(m),k=a.toDegrees(y);i.textAlign=0===(f=k)||180===f?"center":f<180?"left":"right",d=k,c=t._pointLabelSizes[m],h=b,90===d||270===d?h.y-=c.h/2:(d>270||d<90)&&(h.y-=c.h),u(i,t.pointLabels[m]||"",b,p.size)}}}(t)}}});t.scaleService.registerScaleType("radialLinear",c,i)}},{25:25,34:34,45:45}],58:[function(t,e,i){"use strict";var n=t(1);n="function"==typeof n?n:window.moment;var a=t(25),o=t(45),r=Number.MIN_SAFE_INTEGER||-9007199254740991,s=Number.MAX_SAFE_INTEGER||9007199254740991,l={millisecond:{common:!0,size:1,steps:[1,2,5,10,20,50,100,250,500]},second:{common:!0,size:1e3,steps:[1,2,5,10,30]},minute:{common:!0,size:6e4,steps:[1,2,5,10,30]},hour:{common:!0,size:36e5,steps:[1,2,3,6,12]},day:{common:!0,size:864e5,steps:[1,2,5]},week:{common:!1,size:6048e5,steps:[1,2,3,4]},month:{common:!0,size:2628e6,steps:[1,2,3]},quarter:{common:!1,size:7884e6,steps:[1,2,3,4]},year:{common:!0,size:3154e7}},u=Object.keys(l);function d(t,e){return t-e}function c(t){var e,i,n,a={},o=[];for(e=0,i=t.length;e<i;++e)a[n=t[e]]||(a[n]=!0,o.push(n));return o}function h(t,e,i,n){var a=function(t,e,i){for(var n,a,o,r=0,s=t.length-1;r>=0&&r<=s;){if(a=t[(n=r+s>>1)-1]||null,o=t[n],!a)return{lo:null,hi:o};if(o[e]<i)r=n+1;else{if(!(a[e]>i))return{lo:a,hi:o};s=n-1}}return{lo:o,hi:null}}(t,e,i),o=a.lo?a.hi?a.lo:t[t.length-2]:t[0],r=a.lo?a.hi?a.hi:t[t.length-1]:t[1],s=r[e]-o[e],l=s?(i-o[e])/s:0,u=(r[n]-o[n])*l;return o[n]+u}function f(t,e){var i=e.parser,a=e.parser||e.format;return"function"==typeof i?i(t):"string"==typeof t&&"string"==typeof a?n(t,a):(t instanceof n||(t=n(t)),t.isValid()?t:"function"==typeof a?a(t):t)}function g(t,e){if(o.isNullOrUndef(t))return null;var i=e.options.time,n=f(e.getRightValue(t),i);return n.isValid()?(i.round&&n.startOf(i.round),n.valueOf()):null}function p(t){for(var e=u.indexOf(t)+1,i=u.length;e<i;++e)if(l[u[e]].common)return u[e]}function m(t,e,i,a){var r,d=a.time,c=d.unit||function(t,e,i,n){var a,o,r,d=u.length;for(a=u.indexOf(t);a<d-1;++a)if(r=(o=l[u[a]]).steps?o.steps[o.steps.length-1]:s,o.common&&Math.ceil((i-e)/(r*o.size))<=n)return u[a];return u[d-1]}(d.minUnit,t,e,i),h=p(c),f=o.valueOrDefault(d.stepSize,d.unitStepSize),g="week"===c&&d.isoWeekday,m=a.ticks.major.enabled,v=l[c],b=n(t),x=n(e),y=[];for(f||(f=function(t,e,i,n){var a,o,r,s=e-t,u=l[i],d=u.size,c=u.steps;if(!c)return Math.ceil(s/(n*d));for(a=0,o=c.length;a<o&&(r=c[a],!(Math.ceil(s/(d*r))<=n));++a);return r}(t,e,c,i)),g&&(b=b.isoWeekday(g),x=x.isoWeekday(g)),b=b.startOf(g?"day":c),(x=x.startOf(g?"day":c))<e&&x.add(1,c),r=n(b),m&&h&&!g&&!d.round&&(r.startOf(h),r.add(~~((b-r)/(v.size*f))*f,c));r<x;r.add(f,c))y.push(+r);return y.push(+r),y}e.exports=function(t){var e=t.Scale.extend({initialize:function(){if(!n)throw new Error("Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com");this.mergeTicksOptions(),t.Scale.prototype.initialize.call(this)},update:function(){var e=this.options;return e.time&&e.time.format&&console.warn("options.time.format is deprecated and replaced by options.time.parser."),t.Scale.prototype.update.apply(this,arguments)},getRightValue:function(e){return e&&void 0!==e.t&&(e=e.t),t.Scale.prototype.getRightValue.call(this,e)},determineDataLimits:function(){var t,e,i,a,l,u,h=this,f=h.chart,p=h.options.time,m=p.unit||"day",v=s,b=r,x=[],y=[],k=[];for(t=0,i=f.data.labels.length;t<i;++t)k.push(g(f.data.labels[t],h));for(t=0,i=(f.data.datasets||[]).length;t<i;++t)if(f.isDatasetVisible(t))if(l=f.data.datasets[t].data,o.isObject(l[0]))for(y[t]=[],e=0,a=l.length;e<a;++e)u=g(l[e],h),x.push(u),y[t][e]=u;else x.push.apply(x,k),y[t]=k.slice(0);else y[t]=[];k.length&&(k=c(k).sort(d),v=Math.min(v,k[0]),b=Math.max(b,k[k.length-1])),x.length&&(x=c(x).sort(d),v=Math.min(v,x[0]),b=Math.max(b,x[x.length-1])),v=g(p.min,h)||v,b=g(p.max,h)||b,v=v===s?+n().startOf(m):v,b=b===r?+n().endOf(m)+1:b,h.min=Math.min(v,b),h.max=Math.max(v+1,b),h._horizontal=h.isHorizontal(),h._table=[],h._timestamps={data:x,datasets:y,labels:k}},buildTicks:function(){var t,e,i,a,o,r,s,d,c,v,b,x,y=this,k=y.min,M=y.max,w=y.options,S=w.time,C=[],_=[];switch(w.ticks.source){case"data":C=y._timestamps.data;break;case"labels":C=y._timestamps.labels;break;case"auto":default:C=m(k,M,y.getLabelCapacity(k),w)}for("ticks"===w.bounds&&C.length&&(k=C[0],M=C[C.length-1]),k=g(S.min,y)||k,M=g(S.max,y)||M,t=0,e=C.length;t<e;++t)(i=C[t])>=k&&i<=M&&_.push(i);return y.min=k,y.max=M,y._unit=S.unit||function(t,e,i,a){var o,r,s=n.duration(n(a).diff(n(i)));for(o=u.length-1;o>=u.indexOf(e);o--)if(r=u[o],l[r].common&&s.as(r)>=t.length)return r;return u[e?u.indexOf(e):0]}(_,S.minUnit,y.min,y.max),y._majorUnit=p(y._unit),y._table=function(t,e,i,n){if("linear"===n||!t.length)return[{time:e,pos:0},{time:i,pos:1}];var a,o,r,s,l,u=[],d=[e];for(a=0,o=t.length;a<o;++a)(s=t[a])>e&&s<i&&d.push(s);for(d.push(i),a=0,o=d.length;a<o;++a)l=d[a+1],r=d[a-1],s=d[a],void 0!==r&&void 0!==l&&Math.round((l+r)/2)===s||u.push({time:s,pos:a/(o-1)});return u}(y._timestamps.data,k,M,w.distribution),y._offsets=(a=y._table,o=_,r=k,s=M,b=0,x=0,(d=w).offset&&o.length&&(d.time.min||(c=o.length>1?o[1]:s,v=o[0],b=(h(a,"time",c,"pos")-h(a,"time",v,"pos"))/2),d.time.max||(c=o[o.length-1],v=o.length>1?o[o.length-2]:r,x=(h(a,"time",c,"pos")-h(a,"time",v,"pos"))/2)),{left:b,right:x}),y._labelFormat=function(t,e){var i,n,a,o=t.length;for(i=0;i<o;i++){if(0!==(n=f(t[i],e)).millisecond())return"MMM D, YYYY h:mm:ss.SSS a";0===n.second()&&0===n.minute()&&0===n.hour()||(a=!0)}return a?"MMM D, YYYY h:mm:ss a":"MMM D, YYYY"}(y._timestamps.data,S),function(t,e){var i,a,o,r,s=[];for(i=0,a=t.length;i<a;++i)o=t[i],r=!!e&&o===+n(o).startOf(e),s.push({value:o,major:r});return s}(_,y._majorUnit)},getLabelForIndex:function(t,e){var i=this.chart.data,n=this.options.time,a=i.labels&&t<i.labels.length?i.labels[t]:"",r=i.datasets[e].data[t];return o.isObject(r)&&(a=this.getRightValue(r)),n.tooltipFormat?f(a,n).format(n.tooltipFormat):"string"==typeof a?a:f(a,n).format(this._labelFormat)},tickFormatFunction:function(t,e,i,n){var a=this.options,r=t.valueOf(),s=a.time.displayFormats,l=s[this._unit],u=this._majorUnit,d=s[u],c=t.clone().startOf(u).valueOf(),h=a.ticks.major,f=h.enabled&&u&&d&&r===c,g=t.format(n||(f?d:l)),p=f?h:a.ticks.minor,m=o.valueOrDefault(p.callback,p.userCallback);return m?m(g,e,i):g},convertTicksToLabels:function(t){var e,i,a=[];for(e=0,i=t.length;e<i;++e)a.push(this.tickFormatFunction(n(t[e].value),e,t));return a},getPixelForOffset:function(t){var e=this,i=e._horizontal?e.width:e.height,n=e._horizontal?e.left:e.top,a=h(e._table,"time",t,"pos");return n+i*(e._offsets.left+a)/(e._offsets.left+1+e._offsets.right)},getPixelForValue:function(t,e,i){var n=null;if(void 0!==e&&void 0!==i&&(n=this._timestamps.datasets[i][e]),null===n&&(n=g(t,this)),null!==n)return this.getPixelForOffset(n)},getPixelForTick:function(t){var e=this.getTicks();return t>=0&&t<e.length?this.getPixelForOffset(e[t].value):null},getValueForPixel:function(t){var e=this,i=e._horizontal?e.width:e.height,a=e._horizontal?e.left:e.top,o=(i?(t-a)/i:0)*(e._offsets.left+1+e._offsets.left)-e._offsets.right,r=h(e._table,"pos",o,"time");return n(r)},getLabelWidth:function(t){var e=this.options.ticks,i=this.ctx.measureText(t).width,n=o.toRadians(e.maxRotation),r=Math.cos(n),s=Math.sin(n);return i*r+o.valueOrDefault(e.fontSize,a.global.defaultFontSize)*s},getLabelCapacity:function(t){var e=this,i=e.options.time.displayFormats.millisecond,a=e.tickFormatFunction(n(t),0,[],i),o=e.getLabelWidth(a),r=e.isHorizontal()?e.width:e.height,s=Math.floor(r/o);return s>0?s:1}});t.scaleService.registerScaleType("time",e,{position:"bottom",distribution:"linear",bounds:"data",time:{parser:!1,format:!1,unit:!1,round:!1,displayFormat:!1,isoWeekday:!1,minUnit:"millisecond",displayFormats:{millisecond:"h:mm:ss.SSS a",second:"h:mm:ss a",minute:"h:mm a",hour:"hA",day:"MMM D",week:"ll",month:"MMM YYYY",quarter:"[Q]Q - YYYY",year:"YYYY"}},ticks:{autoSkip:!1,source:"auto",major:{enabled:!1}}})}},{1:1,25:25,45:45}]},{},[7])(7)});
/*! howler.js v2.2.1 | (c) 2013-2020, James Simpson of GoldFire Studios | MIT License | howlerjs.com */
!function(){"use strict";var e=function(){this.init()};e.prototype={init:function(){var e=this||n;return e._counter=1e3,e._html5AudioPool=[],e.html5PoolSize=10,e._codecs={},e._howls=[],e._muted=!1,e._volume=1,e._canPlayEvent="canplaythrough",e._navigator="undefined"!=typeof window&&window.navigator?window.navigator:null,e.masterGain=null,e.noAudio=!1,e.usingWebAudio=!0,e.autoSuspend=!0,e.ctx=null,e.autoUnlock=!0,e._setup(),e},volume:function(e){var o=this||n;if(e=parseFloat(e),o.ctx||_(),void 0!==e&&e>=0&&e<=1){if(o._volume=e,o._muted)return o;o.usingWebAudio&&o.masterGain.gain.setValueAtTime(e,n.ctx.currentTime);for(var t=0;t<o._howls.length;t++)if(!o._howls[t]._webAudio)for(var r=o._howls[t]._getSoundIds(),a=0;a<r.length;a++){var u=o._howls[t]._soundById(r[a]);u&&u._node&&(u._node.volume=u._volume*e)}return o}return o._volume},mute:function(e){var o=this||n;o.ctx||_(),o._muted=e,o.usingWebAudio&&o.masterGain.gain.setValueAtTime(e?0:o._volume,n.ctx.currentTime);for(var t=0;t<o._howls.length;t++)if(!o._howls[t]._webAudio)for(var r=o._howls[t]._getSoundIds(),a=0;a<r.length;a++){var u=o._howls[t]._soundById(r[a]);u&&u._node&&(u._node.muted=!!e||u._muted)}return o},stop:function(){for(var e=this||n,o=0;o<e._howls.length;o++)e._howls[o].stop();return e},unload:function(){for(var e=this||n,o=e._howls.length-1;o>=0;o--)e._howls[o].unload();return e.usingWebAudio&&e.ctx&&void 0!==e.ctx.close&&(e.ctx.close(),e.ctx=null,_()),e},codecs:function(e){return(this||n)._codecs[e.replace(/^x-/,"")]},_setup:function(){var e=this||n;if(e.state=e.ctx?e.ctx.state||"suspended":"suspended",e._autoSuspend(),!e.usingWebAudio)if("undefined"!=typeof Audio)try{var o=new Audio;void 0===o.oncanplaythrough&&(e._canPlayEvent="canplay")}catch(n){e.noAudio=!0}else e.noAudio=!0;try{var o=new Audio;o.muted&&(e.noAudio=!0)}catch(e){}return e.noAudio||e._setupCodecs(),e},_setupCodecs:function(){var e=this||n,o=null;try{o="undefined"!=typeof Audio?new Audio:null}catch(n){return e}if(!o||"function"!=typeof o.canPlayType)return e;var t=o.canPlayType("audio/mpeg;").replace(/^no$/,""),r=e._navigator&&e._navigator.userAgent.match(/OPR\/([0-6].)/g),a=r&&parseInt(r[0].split("/")[1],10)<33;return e._codecs={mp3:!(a||!t&&!o.canPlayType("audio/mp3;").replace(/^no$/,"")),mpeg:!!t,opus:!!o.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/,""),ogg:!!o.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),oga:!!o.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),wav:!!(o.canPlayType('audio/wav; codecs="1"')||o.canPlayType("audio/wav")).replace(/^no$/,""),aac:!!o.canPlayType("audio/aac;").replace(/^no$/,""),caf:!!o.canPlayType("audio/x-caf;").replace(/^no$/,""),m4a:!!(o.canPlayType("audio/x-m4a;")||o.canPlayType("audio/m4a;")||o.canPlayType("audio/aac;")).replace(/^no$/,""),m4b:!!(o.canPlayType("audio/x-m4b;")||o.canPlayType("audio/m4b;")||o.canPlayType("audio/aac;")).replace(/^no$/,""),mp4:!!(o.canPlayType("audio/x-mp4;")||o.canPlayType("audio/mp4;")||o.canPlayType("audio/aac;")).replace(/^no$/,""),weba:!!o.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/,""),webm:!!o.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/,""),dolby:!!o.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/,""),flac:!!(o.canPlayType("audio/x-flac;")||o.canPlayType("audio/flac;")).replace(/^no$/,"")},e},_unlockAudio:function(){var e=this||n;if(!e._audioUnlocked&&e.ctx){e._audioUnlocked=!1,e.autoUnlock=!1,e._mobileUnloaded||44100===e.ctx.sampleRate||(e._mobileUnloaded=!0,e.unload()),e._scratchBuffer=e.ctx.createBuffer(1,1,22050);var o=function(n){for(;e._html5AudioPool.length<e.html5PoolSize;)try{var t=new Audio;t._unlocked=!0,e._releaseHtml5Audio(t)}catch(n){e.noAudio=!0;break}for(var r=0;r<e._howls.length;r++)if(!e._howls[r]._webAudio)for(var a=e._howls[r]._getSoundIds(),u=0;u<a.length;u++){var d=e._howls[r]._soundById(a[u]);d&&d._node&&!d._node._unlocked&&(d._node._unlocked=!0,d._node.load())}e._autoResume();var i=e.ctx.createBufferSource();i.buffer=e._scratchBuffer,i.connect(e.ctx.destination),void 0===i.start?i.noteOn(0):i.start(0),"function"==typeof e.ctx.resume&&e.ctx.resume(),i.onended=function(){i.disconnect(0),e._audioUnlocked=!0,document.removeEventListener("touchstart",o,!0),document.removeEventListener("touchend",o,!0),document.removeEventListener("click",o,!0);for(var n=0;n<e._howls.length;n++)e._howls[n]._emit("unlock")}};return document.addEventListener("touchstart",o,!0),document.addEventListener("touchend",o,!0),document.addEventListener("click",o,!0),e}},_obtainHtml5Audio:function(){var e=this||n;if(e._html5AudioPool.length)return e._html5AudioPool.pop();var o=(new Audio).play();return o&&"undefined"!=typeof Promise&&(o instanceof Promise||"function"==typeof o.then)&&o.catch(function(){console.warn("HTML5 Audio pool exhausted, returning potentially locked audio object.")}),new Audio},_releaseHtml5Audio:function(e){var o=this||n;return e._unlocked&&o._html5AudioPool.push(e),o},_autoSuspend:function(){var e=this;if(e.autoSuspend&&e.ctx&&void 0!==e.ctx.suspend&&n.usingWebAudio){for(var o=0;o<e._howls.length;o++)if(e._howls[o]._webAudio)for(var t=0;t<e._howls[o]._sounds.length;t++)if(!e._howls[o]._sounds[t]._paused)return e;return e._suspendTimer&&clearTimeout(e._suspendTimer),e._suspendTimer=setTimeout(function(){if(e.autoSuspend){e._suspendTimer=null,e.state="suspending";var n=function(){e.state="suspended",e._resumeAfterSuspend&&(delete e._resumeAfterSuspend,e._autoResume())};e.ctx.suspend().then(n,n)}},3e4),e}},_autoResume:function(){var e=this;if(e.ctx&&void 0!==e.ctx.resume&&n.usingWebAudio)return"running"===e.state&&"interrupted"!==e.ctx.state&&e._suspendTimer?(clearTimeout(e._suspendTimer),e._suspendTimer=null):"suspended"===e.state||"running"===e.state&&"interrupted"===e.ctx.state?(e.ctx.resume().then(function(){e.state="running";for(var n=0;n<e._howls.length;n++)e._howls[n]._emit("resume")}),e._suspendTimer&&(clearTimeout(e._suspendTimer),e._suspendTimer=null)):"suspending"===e.state&&(e._resumeAfterSuspend=!0),e}};var n=new e,o=function(e){var n=this;if(!e.src||0===e.src.length)return void console.error("An array of source files must be passed with any new Howl.");n.init(e)};o.prototype={init:function(e){var o=this;return n.ctx||_(),o._autoplay=e.autoplay||!1,o._format="string"!=typeof e.format?e.format:[e.format],o._html5=e.html5||!1,o._muted=e.mute||!1,o._loop=e.loop||!1,o._pool=e.pool||5,o._preload="boolean"!=typeof e.preload&&"metadata"!==e.preload||e.preload,o._rate=e.rate||1,o._sprite=e.sprite||{},o._src="string"!=typeof e.src?e.src:[e.src],o._volume=void 0!==e.volume?e.volume:1,o._xhr={method:e.xhr&&e.xhr.method?e.xhr.method:"GET",headers:e.xhr&&e.xhr.headers?e.xhr.headers:null,withCredentials:!(!e.xhr||!e.xhr.withCredentials)&&e.xhr.withCredentials},o._duration=0,o._state="unloaded",o._sounds=[],o._endTimers={},o._queue=[],o._playLock=!1,o._onend=e.onend?[{fn:e.onend}]:[],o._onfade=e.onfade?[{fn:e.onfade}]:[],o._onload=e.onload?[{fn:e.onload}]:[],o._onloaderror=e.onloaderror?[{fn:e.onloaderror}]:[],o._onplayerror=e.onplayerror?[{fn:e.onplayerror}]:[],o._onpause=e.onpause?[{fn:e.onpause}]:[],o._onplay=e.onplay?[{fn:e.onplay}]:[],o._onstop=e.onstop?[{fn:e.onstop}]:[],o._onmute=e.onmute?[{fn:e.onmute}]:[],o._onvolume=e.onvolume?[{fn:e.onvolume}]:[],o._onrate=e.onrate?[{fn:e.onrate}]:[],o._onseek=e.onseek?[{fn:e.onseek}]:[],o._onunlock=e.onunlock?[{fn:e.onunlock}]:[],o._onresume=[],o._webAudio=n.usingWebAudio&&!o._html5,void 0!==n.ctx&&n.ctx&&n.autoUnlock&&n._unlockAudio(),n._howls.push(o),o._autoplay&&o._queue.push({event:"play",action:function(){o.play()}}),o._preload&&"none"!==o._preload&&o.load(),o},load:function(){var e=this,o=null;if(n.noAudio)return void e._emit("loaderror",null,"No audio support.");"string"==typeof e._src&&(e._src=[e._src]);for(var r=0;r<e._src.length;r++){var u,d;if(e._format&&e._format[r])u=e._format[r];else{if("string"!=typeof(d=e._src[r])){e._emit("loaderror",null,"Non-string found in selected audio sources - ignoring.");continue}u=/^data:audio\/([^;,]+);/i.exec(d),u||(u=/\.([^.]+)$/.exec(d.split("?",1)[0])),u&&(u=u[1].toLowerCase())}if(u||console.warn('No file extension was found. Consider using the "format" property or specify an extension.'),u&&n.codecs(u)){o=e._src[r];break}}return o?(e._src=o,e._state="loading","https:"===window.location.protocol&&"http:"===o.slice(0,5)&&(e._html5=!0,e._webAudio=!1),new t(e),e._webAudio&&a(e),e):void e._emit("loaderror",null,"No codec support for selected audio sources.")},play:function(e,o){var t=this,r=null;if("number"==typeof e)r=e,e=null;else{if("string"==typeof e&&"loaded"===t._state&&!t._sprite[e])return null;if(void 0===e&&(e="__default",!t._playLock)){for(var a=0,u=0;u<t._sounds.length;u++)t._sounds[u]._paused&&!t._sounds[u]._ended&&(a++,r=t._sounds[u]._id);1===a?e=null:r=null}}var d=r?t._soundById(r):t._inactiveSound();if(!d)return null;if(r&&!e&&(e=d._sprite||"__default"),"loaded"!==t._state){d._sprite=e,d._ended=!1;var i=d._id;return t._queue.push({event:"play",action:function(){t.play(i)}}),i}if(r&&!d._paused)return o||t._loadQueue("play"),d._id;t._webAudio&&n._autoResume();var _=Math.max(0,d._seek>0?d._seek:t._sprite[e][0]/1e3),s=Math.max(0,(t._sprite[e][0]+t._sprite[e][1])/1e3-_),l=1e3*s/Math.abs(d._rate),c=t._sprite[e][0]/1e3,f=(t._sprite[e][0]+t._sprite[e][1])/1e3;d._sprite=e,d._ended=!1;var p=function(){d._paused=!1,d._seek=_,d._start=c,d._stop=f,d._loop=!(!d._loop&&!t._sprite[e][2])};if(_>=f)return void t._ended(d);var m=d._node;if(t._webAudio){var v=function(){t._playLock=!1,p(),t._refreshBuffer(d);var e=d._muted||t._muted?0:d._volume;m.gain.setValueAtTime(e,n.ctx.currentTime),d._playStart=n.ctx.currentTime,void 0===m.bufferSource.start?d._loop?m.bufferSource.noteGrainOn(0,_,86400):m.bufferSource.noteGrainOn(0,_,s):d._loop?m.bufferSource.start(0,_,86400):m.bufferSource.start(0,_,s),l!==1/0&&(t._endTimers[d._id]=setTimeout(t._ended.bind(t,d),l)),o||setTimeout(function(){t._emit("play",d._id),t._loadQueue()},0)};"running"===n.state&&"interrupted"!==n.ctx.state?v():(t._playLock=!0,t.once("resume",v),t._clearTimer(d._id))}else{var h=function(){m.currentTime=_,m.muted=d._muted||t._muted||n._muted||m.muted,m.volume=d._volume*n.volume(),m.playbackRate=d._rate;try{var r=m.play();if(r&&"undefined"!=typeof Promise&&(r instanceof Promise||"function"==typeof r.then)?(t._playLock=!0,p(),r.then(function(){t._playLock=!1,m._unlocked=!0,o||(t._emit("play",d._id),t._loadQueue())}).catch(function(){t._playLock=!1,t._emit("playerror",d._id,"Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction."),d._ended=!0,d._paused=!0})):o||(t._playLock=!1,p(),t._emit("play",d._id),t._loadQueue()),m.playbackRate=d._rate,m.paused)return void t._emit("playerror",d._id,"Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");"__default"!==e||d._loop?t._endTimers[d._id]=setTimeout(t._ended.bind(t,d),l):(t._endTimers[d._id]=function(){t._ended(d),m.removeEventListener("ended",t._endTimers[d._id],!1)},m.addEventListener("ended",t._endTimers[d._id],!1))}catch(e){t._emit("playerror",d._id,e)}};"data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA"===m.src&&(m.src=t._src,m.load());var y=window&&window.ejecta||!m.readyState&&n._navigator.isCocoonJS;if(m.readyState>=3||y)h();else{t._playLock=!0;var g=function(){h(),m.removeEventListener(n._canPlayEvent,g,!1)};m.addEventListener(n._canPlayEvent,g,!1),t._clearTimer(d._id)}}return d._id},pause:function(e){var n=this;if("loaded"!==n._state||n._playLock)return n._queue.push({event:"pause",action:function(){n.pause(e)}}),n;for(var o=n._getSoundIds(e),t=0;t<o.length;t++){n._clearTimer(o[t]);var r=n._soundById(o[t]);if(r&&!r._paused&&(r._seek=n.seek(o[t]),r._rateSeek=0,r._paused=!0,n._stopFade(o[t]),r._node))if(n._webAudio){if(!r._node.bufferSource)continue;void 0===r._node.bufferSource.stop?r._node.bufferSource.noteOff(0):r._node.bufferSource.stop(0),n._cleanBuffer(r._node)}else isNaN(r._node.duration)&&r._node.duration!==1/0||r._node.pause();arguments[1]||n._emit("pause",r?r._id:null)}return n},stop:function(e,n){var o=this;if("loaded"!==o._state||o._playLock)return o._queue.push({event:"stop",action:function(){o.stop(e)}}),o;for(var t=o._getSoundIds(e),r=0;r<t.length;r++){o._clearTimer(t[r]);var a=o._soundById(t[r]);a&&(a._seek=a._start||0,a._rateSeek=0,a._paused=!0,a._ended=!0,o._stopFade(t[r]),a._node&&(o._webAudio?a._node.bufferSource&&(void 0===a._node.bufferSource.stop?a._node.bufferSource.noteOff(0):a._node.bufferSource.stop(0),o._cleanBuffer(a._node)):isNaN(a._node.duration)&&a._node.duration!==1/0||(a._node.currentTime=a._start||0,a._node.pause(),a._node.duration===1/0&&o._clearSound(a._node))),n||o._emit("stop",a._id))}return o},mute:function(e,o){var t=this;if("loaded"!==t._state||t._playLock)return t._queue.push({event:"mute",action:function(){t.mute(e,o)}}),t;if(void 0===o){if("boolean"!=typeof e)return t._muted;t._muted=e}for(var r=t._getSoundIds(o),a=0;a<r.length;a++){var u=t._soundById(r[a]);u&&(u._muted=e,u._interval&&t._stopFade(u._id),t._webAudio&&u._node?u._node.gain.setValueAtTime(e?0:u._volume,n.ctx.currentTime):u._node&&(u._node.muted=!!n._muted||e),t._emit("mute",u._id))}return t},volume:function(){var e,o,t=this,r=arguments;if(0===r.length)return t._volume;if(1===r.length||2===r.length&&void 0===r[1]){t._getSoundIds().indexOf(r[0])>=0?o=parseInt(r[0],10):e=parseFloat(r[0])}else r.length>=2&&(e=parseFloat(r[0]),o=parseInt(r[1],10));var a;if(!(void 0!==e&&e>=0&&e<=1))return a=o?t._soundById(o):t._sounds[0],a?a._volume:0;if("loaded"!==t._state||t._playLock)return t._queue.push({event:"volume",action:function(){t.volume.apply(t,r)}}),t;void 0===o&&(t._volume=e),o=t._getSoundIds(o);for(var u=0;u<o.length;u++)(a=t._soundById(o[u]))&&(a._volume=e,r[2]||t._stopFade(o[u]),t._webAudio&&a._node&&!a._muted?a._node.gain.setValueAtTime(e,n.ctx.currentTime):a._node&&!a._muted&&(a._node.volume=e*n.volume()),t._emit("volume",a._id));return t},fade:function(e,o,t,r){var a=this;if("loaded"!==a._state||a._playLock)return a._queue.push({event:"fade",action:function(){a.fade(e,o,t,r)}}),a;e=Math.min(Math.max(0,parseFloat(e)),1),o=Math.min(Math.max(0,parseFloat(o)),1),t=parseFloat(t),a.volume(e,r);for(var u=a._getSoundIds(r),d=0;d<u.length;d++){var i=a._soundById(u[d]);if(i){if(r||a._stopFade(u[d]),a._webAudio&&!i._muted){var _=n.ctx.currentTime,s=_+t/1e3;i._volume=e,i._node.gain.setValueAtTime(e,_),i._node.gain.linearRampToValueAtTime(o,s)}a._startFadeInterval(i,e,o,t,u[d],void 0===r)}}return a},_startFadeInterval:function(e,n,o,t,r,a){var u=this,d=n,i=o-n,_=Math.abs(i/.01),s=Math.max(4,_>0?t/_:t),l=Date.now();e._fadeTo=o,e._interval=setInterval(function(){var r=(Date.now()-l)/t;l=Date.now(),d+=i*r,d=Math.round(100*d)/100,d=i<0?Math.max(o,d):Math.min(o,d),u._webAudio?e._volume=d:u.volume(d,e._id,!0),a&&(u._volume=d),(o<n&&d<=o||o>n&&d>=o)&&(clearInterval(e._interval),e._interval=null,e._fadeTo=null,u.volume(o,e._id),u._emit("fade",e._id))},s)},_stopFade:function(e){var o=this,t=o._soundById(e);return t&&t._interval&&(o._webAudio&&t._node.gain.cancelScheduledValues(n.ctx.currentTime),clearInterval(t._interval),t._interval=null,o.volume(t._fadeTo,e),t._fadeTo=null,o._emit("fade",e)),o},loop:function(){var e,n,o,t=this,r=arguments;if(0===r.length)return t._loop;if(1===r.length){if("boolean"!=typeof r[0])return!!(o=t._soundById(parseInt(r[0],10)))&&o._loop;e=r[0],t._loop=e}else 2===r.length&&(e=r[0],n=parseInt(r[1],10));for(var a=t._getSoundIds(n),u=0;u<a.length;u++)(o=t._soundById(a[u]))&&(o._loop=e,t._webAudio&&o._node&&o._node.bufferSource&&(o._node.bufferSource.loop=e,e&&(o._node.bufferSource.loopStart=o._start||0,o._node.bufferSource.loopEnd=o._stop)));return t},rate:function(){var e,o,t=this,r=arguments;if(0===r.length)o=t._sounds[0]._id;else if(1===r.length){var a=t._getSoundIds(),u=a.indexOf(r[0]);u>=0?o=parseInt(r[0],10):e=parseFloat(r[0])}else 2===r.length&&(e=parseFloat(r[0]),o=parseInt(r[1],10));var d;if("number"!=typeof e)return d=t._soundById(o),d?d._rate:t._rate;if("loaded"!==t._state||t._playLock)return t._queue.push({event:"rate",action:function(){t.rate.apply(t,r)}}),t;void 0===o&&(t._rate=e),o=t._getSoundIds(o);for(var i=0;i<o.length;i++)if(d=t._soundById(o[i])){t.playing(o[i])&&(d._rateSeek=t.seek(o[i]),d._playStart=t._webAudio?n.ctx.currentTime:d._playStart),d._rate=e,t._webAudio&&d._node&&d._node.bufferSource?d._node.bufferSource.playbackRate.setValueAtTime(e,n.ctx.currentTime):d._node&&(d._node.playbackRate=e);var _=t.seek(o[i]),s=(t._sprite[d._sprite][0]+t._sprite[d._sprite][1])/1e3-_,l=1e3*s/Math.abs(d._rate);!t._endTimers[o[i]]&&d._paused||(t._clearTimer(o[i]),t._endTimers[o[i]]=setTimeout(t._ended.bind(t,d),l)),t._emit("rate",d._id)}return t},seek:function(){var e,o,t=this,r=arguments;if(0===r.length)o=t._sounds[0]._id;else if(1===r.length){var a=t._getSoundIds(),u=a.indexOf(r[0]);u>=0?o=parseInt(r[0],10):t._sounds.length&&(o=t._sounds[0]._id,e=parseFloat(r[0]))}else 2===r.length&&(e=parseFloat(r[0]),o=parseInt(r[1],10));if(void 0===o)return t;if("number"==typeof e&&("loaded"!==t._state||t._playLock))return t._queue.push({event:"seek",action:function(){t.seek.apply(t,r)}}),t;var d=t._soundById(o);if(d){if(!("number"==typeof e&&e>=0)){if(t._webAudio){var i=t.playing(o)?n.ctx.currentTime-d._playStart:0,_=d._rateSeek?d._rateSeek-d._seek:0;return d._seek+(_+i*Math.abs(d._rate))}return d._node.currentTime}var s=t.playing(o);s&&t.pause(o,!0),d._seek=e,d._ended=!1,t._clearTimer(o),t._webAudio||!d._node||isNaN(d._node.duration)||(d._node.currentTime=e);var l=function(){t._emit("seek",o),s&&t.play(o,!0)};if(s&&!t._webAudio){var c=function(){t._playLock?setTimeout(c,0):l()};setTimeout(c,0)}else l()}return t},playing:function(e){var n=this;if("number"==typeof e){var o=n._soundById(e);return!!o&&!o._paused}for(var t=0;t<n._sounds.length;t++)if(!n._sounds[t]._paused)return!0;return!1},duration:function(e){var n=this,o=n._duration,t=n._soundById(e);return t&&(o=n._sprite[t._sprite][1]/1e3),o},state:function(){return this._state},unload:function(){for(var e=this,o=e._sounds,t=0;t<o.length;t++)o[t]._paused||e.stop(o[t]._id),e._webAudio||(e._clearSound(o[t]._node),o[t]._node.removeEventListener("error",o[t]._errorFn,!1),o[t]._node.removeEventListener(n._canPlayEvent,o[t]._loadFn,!1),o[t]._node.removeEventListener("ended",o[t]._endFn,!1),n._releaseHtml5Audio(o[t]._node)),delete o[t]._node,e._clearTimer(o[t]._id);var a=n._howls.indexOf(e);a>=0&&n._howls.splice(a,1);var u=!0;for(t=0;t<n._howls.length;t++)if(n._howls[t]._src===e._src||e._src.indexOf(n._howls[t]._src)>=0){u=!1;break}return r&&u&&delete r[e._src],n.noAudio=!1,e._state="unloaded",e._sounds=[],e=null,null},on:function(e,n,o,t){var r=this,a=r["_on"+e];return"function"==typeof n&&a.push(t?{id:o,fn:n,once:t}:{id:o,fn:n}),r},off:function(e,n,o){var t=this,r=t["_on"+e],a=0;if("number"==typeof n&&(o=n,n=null),n||o)for(a=0;a<r.length;a++){var u=o===r[a].id;if(n===r[a].fn&&u||!n&&u){r.splice(a,1);break}}else if(e)t["_on"+e]=[];else{var d=Object.keys(t);for(a=0;a<d.length;a++)0===d[a].indexOf("_on")&&Array.isArray(t[d[a]])&&(t[d[a]]=[])}return t},once:function(e,n,o){var t=this;return t.on(e,n,o,1),t},_emit:function(e,n,o){for(var t=this,r=t["_on"+e],a=r.length-1;a>=0;a--)r[a].id&&r[a].id!==n&&"load"!==e||(setTimeout(function(e){e.call(this,n,o)}.bind(t,r[a].fn),0),r[a].once&&t.off(e,r[a].fn,r[a].id));return t._loadQueue(e),t},_loadQueue:function(e){var n=this;if(n._queue.length>0){var o=n._queue[0];o.event===e&&(n._queue.shift(),n._loadQueue()),e||o.action()}return n},_ended:function(e){var o=this,t=e._sprite;if(!o._webAudio&&e._node&&!e._node.paused&&!e._node.ended&&e._node.currentTime<e._stop)return setTimeout(o._ended.bind(o,e),100),o;var r=!(!e._loop&&!o._sprite[t][2]);if(o._emit("end",e._id),!o._webAudio&&r&&o.stop(e._id,!0).play(e._id),o._webAudio&&r){o._emit("play",e._id),e._seek=e._start||0,e._rateSeek=0,e._playStart=n.ctx.currentTime;var a=1e3*(e._stop-e._start)/Math.abs(e._rate);o._endTimers[e._id]=setTimeout(o._ended.bind(o,e),a)}return o._webAudio&&!r&&(e._paused=!0,e._ended=!0,e._seek=e._start||0,e._rateSeek=0,o._clearTimer(e._id),o._cleanBuffer(e._node),n._autoSuspend()),o._webAudio||r||o.stop(e._id,!0),o},_clearTimer:function(e){var n=this;if(n._endTimers[e]){if("function"!=typeof n._endTimers[e])clearTimeout(n._endTimers[e]);else{var o=n._soundById(e);o&&o._node&&o._node.removeEventListener("ended",n._endTimers[e],!1)}delete n._endTimers[e]}return n},_soundById:function(e){for(var n=this,o=0;o<n._sounds.length;o++)if(e===n._sounds[o]._id)return n._sounds[o];return null},_inactiveSound:function(){var e=this;e._drain();for(var n=0;n<e._sounds.length;n++)if(e._sounds[n]._ended)return e._sounds[n].reset();return new t(e)},_drain:function(){var e=this,n=e._pool,o=0,t=0;if(!(e._sounds.length<n)){for(t=0;t<e._sounds.length;t++)e._sounds[t]._ended&&o++;for(t=e._sounds.length-1;t>=0;t--){if(o<=n)return;e._sounds[t]._ended&&(e._webAudio&&e._sounds[t]._node&&e._sounds[t]._node.disconnect(0),e._sounds.splice(t,1),o--)}}},_getSoundIds:function(e){var n=this;if(void 0===e){for(var o=[],t=0;t<n._sounds.length;t++)o.push(n._sounds[t]._id);return o}return[e]},_refreshBuffer:function(e){var o=this;return e._node.bufferSource=n.ctx.createBufferSource(),e._node.bufferSource.buffer=r[o._src],e._panner?e._node.bufferSource.connect(e._panner):e._node.bufferSource.connect(e._node),e._node.bufferSource.loop=e._loop,e._loop&&(e._node.bufferSource.loopStart=e._start||0,e._node.bufferSource.loopEnd=e._stop||0),e._node.bufferSource.playbackRate.setValueAtTime(e._rate,n.ctx.currentTime),o},_cleanBuffer:function(e){var o=this,t=n._navigator&&n._navigator.vendor.indexOf("Apple")>=0;if(n._scratchBuffer&&e.bufferSource&&(e.bufferSource.onended=null,e.bufferSource.disconnect(0),t))try{e.bufferSource.buffer=n._scratchBuffer}catch(e){}return e.bufferSource=null,o},_clearSound:function(e){/MSIE |Trident\//.test(n._navigator&&n._navigator.userAgent)||(e.src="data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA")}};var t=function(e){this._parent=e,this.init()};t.prototype={init:function(){var e=this,o=e._parent;return e._muted=o._muted,e._loop=o._loop,e._volume=o._volume,e._rate=o._rate,e._seek=0,e._paused=!0,e._ended=!0,e._sprite="__default",e._id=++n._counter,o._sounds.push(e),e.create(),e},create:function(){var e=this,o=e._parent,t=n._muted||e._muted||e._parent._muted?0:e._volume;return o._webAudio?(e._node=void 0===n.ctx.createGain?n.ctx.createGainNode():n.ctx.createGain(),e._node.gain.setValueAtTime(t,n.ctx.currentTime),e._node.paused=!0,e._node.connect(n.masterGain)):n.noAudio||(e._node=n._obtainHtml5Audio(),e._errorFn=e._errorListener.bind(e),e._node.addEventListener("error",e._errorFn,!1),e._loadFn=e._loadListener.bind(e),e._node.addEventListener(n._canPlayEvent,e._loadFn,!1),e._endFn=e._endListener.bind(e),e._node.addEventListener("ended",e._endFn,!1),e._node.src=o._src,e._node.preload=!0===o._preload?"auto":o._preload,e._node.volume=t*n.volume(),e._node.load()),e},reset:function(){var e=this,o=e._parent;return e._muted=o._muted,e._loop=o._loop,e._volume=o._volume,e._rate=o._rate,e._seek=0,e._rateSeek=0,e._paused=!0,e._ended=!0,e._sprite="__default",e._id=++n._counter,e},_errorListener:function(){var e=this;e._parent._emit("loaderror",e._id,e._node.error?e._node.error.code:0),e._node.removeEventListener("error",e._errorFn,!1)},_loadListener:function(){var e=this,o=e._parent;o._duration=Math.ceil(10*e._node.duration)/10,0===Object.keys(o._sprite).length&&(o._sprite={__default:[0,1e3*o._duration]}),"loaded"!==o._state&&(o._state="loaded",o._emit("load"),o._loadQueue()),e._node.removeEventListener(n._canPlayEvent,e._loadFn,!1)},_endListener:function(){var e=this,n=e._parent;n._duration===1/0&&(n._duration=Math.ceil(10*e._node.duration)/10,n._sprite.__default[1]===1/0&&(n._sprite.__default[1]=1e3*n._duration),n._ended(e)),e._node.removeEventListener("ended",e._endFn,!1)}};var r={},a=function(e){var n=e._src;if(r[n])return e._duration=r[n].duration,void i(e);if(/^data:[^;]+;base64,/.test(n)){for(var o=atob(n.split(",")[1]),t=new Uint8Array(o.length),a=0;a<o.length;++a)t[a]=o.charCodeAt(a);d(t.buffer,e)}else{var _=new XMLHttpRequest;_.open(e._xhr.method,n,!0),_.withCredentials=e._xhr.withCredentials,_.responseType="arraybuffer",e._xhr.headers&&Object.keys(e._xhr.headers).forEach(function(n){_.setRequestHeader(n,e._xhr.headers[n])}),_.onload=function(){var n=(_.status+"")[0];if("0"!==n&&"2"!==n&&"3"!==n)return void e._emit("loaderror",null,"Failed loading audio file with status: "+_.status+".");d(_.response,e)},_.onerror=function(){e._webAudio&&(e._html5=!0,e._webAudio=!1,e._sounds=[],delete r[n],e.load())},u(_)}},u=function(e){try{e.send()}catch(n){e.onerror()}},d=function(e,o){var t=function(){o._emit("loaderror",null,"Decoding audio data failed.")},a=function(e){e&&o._sounds.length>0?(r[o._src]=e,i(o,e)):t()};"undefined"!=typeof Promise&&1===n.ctx.decodeAudioData.length?n.ctx.decodeAudioData(e).then(a).catch(t):n.ctx.decodeAudioData(e,a,t)},i=function(e,n){n&&!e._duration&&(e._duration=n.duration),0===Object.keys(e._sprite).length&&(e._sprite={__default:[0,1e3*e._duration]}),"loaded"!==e._state&&(e._state="loaded",e._emit("load"),e._loadQueue())},_=function(){if(n.usingWebAudio){try{"undefined"!=typeof AudioContext?n.ctx=new AudioContext:"undefined"!=typeof webkitAudioContext?n.ctx=new webkitAudioContext:n.usingWebAudio=!1}catch(e){n.usingWebAudio=!1}n.ctx||(n.usingWebAudio=!1);var e=/iP(hone|od|ad)/.test(n._navigator&&n._navigator.platform),o=n._navigator&&n._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/),t=o?parseInt(o[1],10):null;if(e&&t&&t<9){var r=/safari/.test(n._navigator&&n._navigator.userAgent.toLowerCase());n._navigator&&!r&&(n.usingWebAudio=!1)}n.usingWebAudio&&(n.masterGain=void 0===n.ctx.createGain?n.ctx.createGainNode():n.ctx.createGain(),n.masterGain.gain.setValueAtTime(n._muted?0:n._volume,n.ctx.currentTime),n.masterGain.connect(n.ctx.destination)),n._setup()}};"function"==typeof define&&define.amd&&define([],function(){return{Howler:n,Howl:o}}),"undefined"!=typeof exports&&(exports.Howler=n,exports.Howl=o),"undefined"!=typeof global?(global.HowlerGlobal=e,global.Howler=n,global.Howl=o,global.Sound=t):"undefined"!=typeof window&&(window.HowlerGlobal=e,window.Howler=n,window.Howl=o,window.Sound=t)}();
/*! Spatial Plugin */
!function(){"use strict";HowlerGlobal.prototype._pos=[0,0,0],HowlerGlobal.prototype._orientation=[0,0,-1,0,1,0],HowlerGlobal.prototype.stereo=function(e){var n=this;if(!n.ctx||!n.ctx.listener)return n;for(var t=n._howls.length-1;t>=0;t--)n._howls[t].stereo(e);return n},HowlerGlobal.prototype.pos=function(e,n,t){var r=this;return r.ctx&&r.ctx.listener?(n="number"!=typeof n?r._pos[1]:n,t="number"!=typeof t?r._pos[2]:t,"number"!=typeof e?r._pos:(r._pos=[e,n,t],void 0!==r.ctx.listener.positionX?(r.ctx.listener.positionX.setTargetAtTime(r._pos[0],Howler.ctx.currentTime,.1),r.ctx.listener.positionY.setTargetAtTime(r._pos[1],Howler.ctx.currentTime,.1),r.ctx.listener.positionZ.setTargetAtTime(r._pos[2],Howler.ctx.currentTime,.1)):r.ctx.listener.setPosition(r._pos[0],r._pos[1],r._pos[2]),r)):r},HowlerGlobal.prototype.orientation=function(e,n,t,r,o,i){var a=this;if(!a.ctx||!a.ctx.listener)return a;var s=a._orientation;return n="number"!=typeof n?s[1]:n,t="number"!=typeof t?s[2]:t,r="number"!=typeof r?s[3]:r,o="number"!=typeof o?s[4]:o,i="number"!=typeof i?s[5]:i,"number"!=typeof e?s:(a._orientation=[e,n,t,r,o,i],void 0!==a.ctx.listener.forwardX?(a.ctx.listener.forwardX.setTargetAtTime(e,Howler.ctx.currentTime,.1),a.ctx.listener.forwardY.setTargetAtTime(n,Howler.ctx.currentTime,.1),a.ctx.listener.forwardZ.setTargetAtTime(t,Howler.ctx.currentTime,.1),a.ctx.listener.upX.setTargetAtTime(r,Howler.ctx.currentTime,.1),a.ctx.listener.upY.setTargetAtTime(o,Howler.ctx.currentTime,.1),a.ctx.listener.upZ.setTargetAtTime(i,Howler.ctx.currentTime,.1)):a.ctx.listener.setOrientation(e,n,t,r,o,i),a)},Howl.prototype.init=function(e){return function(n){var t=this;return t._orientation=n.orientation||[1,0,0],t._stereo=n.stereo||null,t._pos=n.pos||null,t._pannerAttr={coneInnerAngle:void 0!==n.coneInnerAngle?n.coneInnerAngle:360,coneOuterAngle:void 0!==n.coneOuterAngle?n.coneOuterAngle:360,coneOuterGain:void 0!==n.coneOuterGain?n.coneOuterGain:0,distanceModel:void 0!==n.distanceModel?n.distanceModel:"inverse",maxDistance:void 0!==n.maxDistance?n.maxDistance:1e4,panningModel:void 0!==n.panningModel?n.panningModel:"HRTF",refDistance:void 0!==n.refDistance?n.refDistance:1,rolloffFactor:void 0!==n.rolloffFactor?n.rolloffFactor:1},t._onstereo=n.onstereo?[{fn:n.onstereo}]:[],t._onpos=n.onpos?[{fn:n.onpos}]:[],t._onorientation=n.onorientation?[{fn:n.onorientation}]:[],e.call(this,n)}}(Howl.prototype.init),Howl.prototype.stereo=function(n,t){var r=this;if(!r._webAudio)return r;if("loaded"!==r._state)return r._queue.push({event:"stereo",action:function(){r.stereo(n,t)}}),r;var o=void 0===Howler.ctx.createStereoPanner?"spatial":"stereo";if(void 0===t){if("number"!=typeof n)return r._stereo;r._stereo=n,r._pos=[n,0,0]}for(var i=r._getSoundIds(t),a=0;a<i.length;a++){var s=r._soundById(i[a]);if(s){if("number"!=typeof n)return s._stereo;s._stereo=n,s._pos=[n,0,0],s._node&&(s._pannerAttr.panningModel="equalpower",s._panner&&s._panner.pan||e(s,o),"spatial"===o?void 0!==s._panner.positionX?(s._panner.positionX.setValueAtTime(n,Howler.ctx.currentTime),s._panner.positionY.setValueAtTime(0,Howler.ctx.currentTime),s._panner.positionZ.setValueAtTime(0,Howler.ctx.currentTime)):s._panner.setPosition(n,0,0):s._panner.pan.setValueAtTime(n,Howler.ctx.currentTime)),r._emit("stereo",s._id)}}return r},Howl.prototype.pos=function(n,t,r,o){var i=this;if(!i._webAudio)return i;if("loaded"!==i._state)return i._queue.push({event:"pos",action:function(){i.pos(n,t,r,o)}}),i;if(t="number"!=typeof t?0:t,r="number"!=typeof r?-.5:r,void 0===o){if("number"!=typeof n)return i._pos;i._pos=[n,t,r]}for(var a=i._getSoundIds(o),s=0;s<a.length;s++){var p=i._soundById(a[s]);if(p){if("number"!=typeof n)return p._pos;p._pos=[n,t,r],p._node&&(p._panner&&!p._panner.pan||e(p,"spatial"),void 0!==p._panner.positionX?(p._panner.positionX.setValueAtTime(n,Howler.ctx.currentTime),p._panner.positionY.setValueAtTime(t,Howler.ctx.currentTime),p._panner.positionZ.setValueAtTime(r,Howler.ctx.currentTime)):p._panner.setPosition(n,t,r)),i._emit("pos",p._id)}}return i},Howl.prototype.orientation=function(n,t,r,o){var i=this;if(!i._webAudio)return i;if("loaded"!==i._state)return i._queue.push({event:"orientation",action:function(){i.orientation(n,t,r,o)}}),i;if(t="number"!=typeof t?i._orientation[1]:t,r="number"!=typeof r?i._orientation[2]:r,void 0===o){if("number"!=typeof n)return i._orientation;i._orientation=[n,t,r]}for(var a=i._getSoundIds(o),s=0;s<a.length;s++){var p=i._soundById(a[s]);if(p){if("number"!=typeof n)return p._orientation;p._orientation=[n,t,r],p._node&&(p._panner||(p._pos||(p._pos=i._pos||[0,0,-.5]),e(p,"spatial")),void 0!==p._panner.orientationX?(p._panner.orientationX.setValueAtTime(n,Howler.ctx.currentTime),p._panner.orientationY.setValueAtTime(t,Howler.ctx.currentTime),p._panner.orientationZ.setValueAtTime(r,Howler.ctx.currentTime)):p._panner.setOrientation(n,t,r)),i._emit("orientation",p._id)}}return i},Howl.prototype.pannerAttr=function(){var n,t,r,o=this,i=arguments;if(!o._webAudio)return o;if(0===i.length)return o._pannerAttr;if(1===i.length){if("object"!=typeof i[0])return r=o._soundById(parseInt(i[0],10)),r?r._pannerAttr:o._pannerAttr;n=i[0],void 0===t&&(n.pannerAttr||(n.pannerAttr={coneInnerAngle:n.coneInnerAngle,coneOuterAngle:n.coneOuterAngle,coneOuterGain:n.coneOuterGain,distanceModel:n.distanceModel,maxDistance:n.maxDistance,refDistance:n.refDistance,rolloffFactor:n.rolloffFactor,panningModel:n.panningModel}),o._pannerAttr={coneInnerAngle:void 0!==n.pannerAttr.coneInnerAngle?n.pannerAttr.coneInnerAngle:o._coneInnerAngle,coneOuterAngle:void 0!==n.pannerAttr.coneOuterAngle?n.pannerAttr.coneOuterAngle:o._coneOuterAngle,coneOuterGain:void 0!==n.pannerAttr.coneOuterGain?n.pannerAttr.coneOuterGain:o._coneOuterGain,distanceModel:void 0!==n.pannerAttr.distanceModel?n.pannerAttr.distanceModel:o._distanceModel,maxDistance:void 0!==n.pannerAttr.maxDistance?n.pannerAttr.maxDistance:o._maxDistance,refDistance:void 0!==n.pannerAttr.refDistance?n.pannerAttr.refDistance:o._refDistance,rolloffFactor:void 0!==n.pannerAttr.rolloffFactor?n.pannerAttr.rolloffFactor:o._rolloffFactor,panningModel:void 0!==n.pannerAttr.panningModel?n.pannerAttr.panningModel:o._panningModel})}else 2===i.length&&(n=i[0],t=parseInt(i[1],10));for(var a=o._getSoundIds(t),s=0;s<a.length;s++)if(r=o._soundById(a[s])){var p=r._pannerAttr;p={coneInnerAngle:void 0!==n.coneInnerAngle?n.coneInnerAngle:p.coneInnerAngle,coneOuterAngle:void 0!==n.coneOuterAngle?n.coneOuterAngle:p.coneOuterAngle,coneOuterGain:void 0!==n.coneOuterGain?n.coneOuterGain:p.coneOuterGain,distanceModel:void 0!==n.distanceModel?n.distanceModel:p.distanceModel,maxDistance:void 0!==n.maxDistance?n.maxDistance:p.maxDistance,refDistance:void 0!==n.refDistance?n.refDistance:p.refDistance,rolloffFactor:void 0!==n.rolloffFactor?n.rolloffFactor:p.rolloffFactor,panningModel:void 0!==n.panningModel?n.panningModel:p.panningModel};var c=r._panner;c?(c.coneInnerAngle=p.coneInnerAngle,c.coneOuterAngle=p.coneOuterAngle,c.coneOuterGain=p.coneOuterGain,c.distanceModel=p.distanceModel,c.maxDistance=p.maxDistance,c.refDistance=p.refDistance,c.rolloffFactor=p.rolloffFactor,c.panningModel=p.panningModel):(r._pos||(r._pos=o._pos||[0,0,-.5]),e(r,"spatial"))}return o},Sound.prototype.init=function(e){return function(){var n=this,t=n._parent;n._orientation=t._orientation,n._stereo=t._stereo,n._pos=t._pos,n._pannerAttr=t._pannerAttr,e.call(this),n._stereo?t.stereo(n._stereo):n._pos&&t.pos(n._pos[0],n._pos[1],n._pos[2],n._id)}}(Sound.prototype.init),Sound.prototype.reset=function(e){return function(){var n=this,t=n._parent;return n._orientation=t._orientation,n._stereo=t._stereo,n._pos=t._pos,n._pannerAttr=t._pannerAttr,n._stereo?t.stereo(n._stereo):n._pos?t.pos(n._pos[0],n._pos[1],n._pos[2],n._id):n._panner&&(n._panner.disconnect(0),n._panner=void 0,t._refreshBuffer(n)),e.call(this)}}(Sound.prototype.reset);var e=function(e,n){n=n||"spatial","spatial"===n?(e._panner=Howler.ctx.createPanner(),e._panner.coneInnerAngle=e._pannerAttr.coneInnerAngle,e._panner.coneOuterAngle=e._pannerAttr.coneOuterAngle,e._panner.coneOuterGain=e._pannerAttr.coneOuterGain,e._panner.distanceModel=e._pannerAttr.distanceModel,e._panner.maxDistance=e._pannerAttr.maxDistance,e._panner.refDistance=e._pannerAttr.refDistance,e._panner.rolloffFactor=e._pannerAttr.rolloffFactor,e._panner.panningModel=e._pannerAttr.panningModel,void 0!==e._panner.positionX?(e._panner.positionX.setValueAtTime(e._pos[0],Howler.ctx.currentTime),e._panner.positionY.setValueAtTime(e._pos[1],Howler.ctx.currentTime),e._panner.positionZ.setValueAtTime(e._pos[2],Howler.ctx.currentTime)):e._panner.setPosition(e._pos[0],e._pos[1],e._pos[2]),void 0!==e._panner.orientationX?(e._panner.orientationX.setValueAtTime(e._orientation[0],Howler.ctx.currentTime),e._panner.orientationY.setValueAtTime(e._orientation[1],Howler.ctx.currentTime),e._panner.orientationZ.setValueAtTime(e._orientation[2],Howler.ctx.currentTime)):e._panner.setOrientation(e._orientation[0],e._orientation[1],e._orientation[2])):(e._panner=Howler.ctx.createStereoPanner(),e._panner.pan.setValueAtTime(e._stereo,Howler.ctx.currentTime)),e._panner.connect(e._node),e._paused||e._parent.pause(e._id,!0).play(e._id,!0)}}();
/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
!function(a,b,c,d){function e(b,c){this.settings=null,this.options=a.extend({},e.Defaults,c),this.$element=a(b),this._handlers={},this._plugins={},this._supress={},this._current=null,this._speed=null,this._coordinates=[],this._breakpoint=null,this._width=null,this._items=[],this._clones=[],this._mergers=[],this._widths=[],this._invalidated={},this._pipe=[],this._drag={time:null,target:null,pointer:null,stage:{start:null,current:null},direction:null},this._states={current:{},tags:{initializing:["busy"],animating:["busy"],dragging:["interacting"]}},a.each(["onResize","onThrottledResize"],a.proxy(function(b,c){this._handlers[c]=a.proxy(this[c],this)},this)),a.each(e.Plugins,a.proxy(function(a,b){this._plugins[a.charAt(0).toLowerCase()+a.slice(1)]=new b(this)},this)),a.each(e.Workers,a.proxy(function(b,c){this._pipe.push({filter:c.filter,run:a.proxy(c.run,this)})},this)),this.setup(),this.initialize()}e.Defaults={items:3,loop:!1,center:!1,rewind:!1,checkVisibility:!0,mouseDrag:!0,touchDrag:!0,pullDrag:!0,freeDrag:!1,margin:0,stagePadding:0,merge:!1,mergeFit:!0,autoWidth:!1,startPosition:0,rtl:!1,smartSpeed:250,fluidSpeed:!1,dragEndSpeed:!1,responsive:{},responsiveRefreshRate:200,responsiveBaseElement:b,fallbackEasing:"swing",slideTransition:"",info:!1,nestedItemSelector:!1,itemElement:"div",stageElement:"div",refreshClass:"owl-refresh",loadedClass:"owl-loaded",loadingClass:"owl-loading",rtlClass:"owl-rtl",responsiveClass:"owl-responsive",dragClass:"owl-drag",itemClass:"owl-item",stageClass:"owl-stage",stageOuterClass:"owl-stage-outer",grabClass:"owl-grab"},e.Width={Default:"default",Inner:"inner",Outer:"outer"},e.Type={Event:"event",State:"state"},e.Plugins={},e.Workers=[{filter:["width","settings"],run:function(){this._width=this.$element.width()}},{filter:["width","items","settings"],run:function(a){a.current=this._items&&this._items[this.relative(this._current)]}},{filter:["items","settings"],run:function(){this.$stage.children(".cloned").remove()}},{filter:["width","items","settings"],run:function(a){var b=this.settings.margin||"",c=!this.settings.autoWidth,d=this.settings.rtl,e={width:"auto","margin-left":d?b:"","margin-right":d?"":b};!c&&this.$stage.children().css(e),a.css=e}},{filter:["width","items","settings"],run:function(a){var b=(this.width()/this.settings.items).toFixed(3)-this.settings.margin,c=null,d=this._items.length,e=!this.settings.autoWidth,f=[];for(a.items={merge:!1,width:b};d--;)c=this._mergers[d],c=this.settings.mergeFit&&Math.min(c,this.settings.items)||c,a.items.merge=c>1||a.items.merge,f[d]=e?b*c:this._items[d].width();this._widths=f}},{filter:["items","settings"],run:function(){var b=[],c=this._items,d=this.settings,e=Math.max(2*d.items,4),f=2*Math.ceil(c.length/2),g=d.loop&&c.length?d.rewind?e:Math.max(e,f):0,h="",i="";for(g/=2;g>0;)b.push(this.normalize(b.length/2,!0)),h+=c[b[b.length-1]][0].outerHTML,b.push(this.normalize(c.length-1-(b.length-1)/2,!0)),i=c[b[b.length-1]][0].outerHTML+i,g-=1;this._clones=b,a(h).addClass("cloned").appendTo(this.$stage),a(i).addClass("cloned").prependTo(this.$stage)}},{filter:["width","items","settings"],run:function(){for(var a=this.settings.rtl?1:-1,b=this._clones.length+this._items.length,c=-1,d=0,e=0,f=[];++c<b;)d=f[c-1]||0,e=this._widths[this.relative(c)]+this.settings.margin,f.push(d+e*a);this._coordinates=f}},{filter:["width","items","settings"],run:function(){var a=this.settings.stagePadding,b=this._coordinates,c={width:Math.ceil(Math.abs(b[b.length-1]))+2*a,"padding-left":a||"","padding-right":a||""};this.$stage.css(c)}},{filter:["width","items","settings"],run:function(a){var b=this._coordinates.length,c=!this.settings.autoWidth,d=this.$stage.children();if(c&&a.items.merge)for(;b--;)a.css.width=this._widths[this.relative(b)],d.eq(b).css(a.css);else c&&(a.css.width=a.items.width,d.css(a.css))}},{filter:["items"],run:function(){this._coordinates.length<1&&this.$stage.removeAttr("style")}},{filter:["width","items","settings"],run:function(a){a.current=a.current?this.$stage.children().index(a.current):0,a.current=Math.max(this.minimum(),Math.min(this.maximum(),a.current)),this.reset(a.current)}},{filter:["position"],run:function(){this.animate(this.coordinates(this._current))}},{filter:["width","position","items","settings"],run:function(){var a,b,c,d,e=this.settings.rtl?1:-1,f=2*this.settings.stagePadding,g=this.coordinates(this.current())+f,h=g+this.width()*e,i=[];for(c=0,d=this._coordinates.length;c<d;c++)a=this._coordinates[c-1]||0,b=Math.abs(this._coordinates[c])+f*e,(this.op(a,"<=",g)&&this.op(a,">",h)||this.op(b,"<",g)&&this.op(b,">",h))&&i.push(c);this.$stage.children(".active").removeClass("active"),this.$stage.children(":eq("+i.join("), :eq(")+")").addClass("active"),this.$stage.children(".center").removeClass("center"),this.settings.center&&this.$stage.children().eq(this.current()).addClass("center")}}],e.prototype.initializeStage=function(){this.$stage=this.$element.find("."+this.settings.stageClass),this.$stage.length||(this.$element.addClass(this.options.loadingClass),this.$stage=a("<"+this.settings.stageElement+">",{class:this.settings.stageClass}).wrap(a("<div/>",{class:this.settings.stageOuterClass})),this.$element.append(this.$stage.parent()))},e.prototype.initializeItems=function(){var b=this.$element.find(".owl-item");if(b.length)return this._items=b.get().map(function(b){return a(b)}),this._mergers=this._items.map(function(){return 1}),void this.refresh();this.replace(this.$element.children().not(this.$stage.parent())),this.isVisible()?this.refresh():this.invalidate("width"),this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)},e.prototype.initialize=function(){if(this.enter("initializing"),this.trigger("initialize"),this.$element.toggleClass(this.settings.rtlClass,this.settings.rtl),this.settings.autoWidth&&!this.is("pre-loading")){var a,b,c;a=this.$element.find("img"),b=this.settings.nestedItemSelector?"."+this.settings.nestedItemSelector:d,c=this.$element.children(b).width(),a.length&&c<=0&&this.preloadAutoWidthImages(a)}this.initializeStage(),this.initializeItems(),this.registerEventHandlers(),this.leave("initializing"),this.trigger("initialized")},e.prototype.isVisible=function(){return!this.settings.checkVisibility||this.$element.is(":visible")},e.prototype.setup=function(){var b=this.viewport(),c=this.options.responsive,d=-1,e=null;c?(a.each(c,function(a){a<=b&&a>d&&(d=Number(a))}),e=a.extend({},this.options,c[d]),"function"==typeof e.stagePadding&&(e.stagePadding=e.stagePadding()),delete e.responsive,e.responsiveClass&&this.$element.attr("class",this.$element.attr("class").replace(new RegExp("("+this.options.responsiveClass+"-)\\S+\\s","g"),"$1"+d))):e=a.extend({},this.options),this.trigger("change",{property:{name:"settings",value:e}}),this._breakpoint=d,this.settings=e,this.invalidate("settings"),this.trigger("changed",{property:{name:"settings",value:this.settings}})},e.prototype.optionsLogic=function(){this.settings.autoWidth&&(this.settings.stagePadding=!1,this.settings.merge=!1)},e.prototype.prepare=function(b){var c=this.trigger("prepare",{content:b});return c.data||(c.data=a("<"+this.settings.itemElement+"/>").addClass(this.options.itemClass).append(b)),this.trigger("prepared",{content:c.data}),c.data},e.prototype.update=function(){for(var b=0,c=this._pipe.length,d=a.proxy(function(a){return this[a]},this._invalidated),e={};b<c;)(this._invalidated.all||a.grep(this._pipe[b].filter,d).length>0)&&this._pipe[b].run(e),b++;this._invalidated={},!this.is("valid")&&this.enter("valid")},e.prototype.width=function(a){switch(a=a||e.Width.Default){case e.Width.Inner:case e.Width.Outer:return this._width;default:return this._width-2*this.settings.stagePadding+this.settings.margin}},e.prototype.refresh=function(){this.enter("refreshing"),this.trigger("refresh"),this.setup(),this.optionsLogic(),this.$element.addClass(this.options.refreshClass),this.update(),this.$element.removeClass(this.options.refreshClass),this.leave("refreshing"),this.trigger("refreshed")},e.prototype.onThrottledResize=function(){b.clearTimeout(this.resizeTimer),this.resizeTimer=b.setTimeout(this._handlers.onResize,this.settings.responsiveRefreshRate)},e.prototype.onResize=function(){return!!this._items.length&&(this._width!==this.$element.width()&&(!!this.isVisible()&&(this.enter("resizing"),this.trigger("resize").isDefaultPrevented()?(this.leave("resizing"),!1):(this.invalidate("width"),this.refresh(),this.leave("resizing"),void this.trigger("resized")))))},e.prototype.registerEventHandlers=function(){a.support.transition&&this.$stage.on(a.support.transition.end+".owl.core",a.proxy(this.onTransitionEnd,this)),!1!==this.settings.responsive&&this.on(b,"resize",this._handlers.onThrottledResize),this.settings.mouseDrag&&(this.$element.addClass(this.options.dragClass),this.$stage.on("mousedown.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("dragstart.owl.core selectstart.owl.core",function(){return!1})),this.settings.touchDrag&&(this.$stage.on("touchstart.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("touchcancel.owl.core",a.proxy(this.onDragEnd,this)))},e.prototype.onDragStart=function(b){var d=null;3!==b.which&&(a.support.transform?(d=this.$stage.css("transform").replace(/.*\(|\)| /g,"").split(","),d={x:d[16===d.length?12:4],y:d[16===d.length?13:5]}):(d=this.$stage.position(),d={x:this.settings.rtl?d.left+this.$stage.width()-this.width()+this.settings.margin:d.left,y:d.top}),this.is("animating")&&(a.support.transform?this.animate(d.x):this.$stage.stop(),this.invalidate("position")),this.$element.toggleClass(this.options.grabClass,"mousedown"===b.type),this.speed(0),this._drag.time=(new Date).getTime(),this._drag.target=a(b.target),this._drag.stage.start=d,this._drag.stage.current=d,this._drag.pointer=this.pointer(b),a(c).on("mouseup.owl.core touchend.owl.core",a.proxy(this.onDragEnd,this)),a(c).one("mousemove.owl.core touchmove.owl.core",a.proxy(function(b){var d=this.difference(this._drag.pointer,this.pointer(b));a(c).on("mousemove.owl.core touchmove.owl.core",a.proxy(this.onDragMove,this)),Math.abs(d.x)<Math.abs(d.y)&&this.is("valid")||(b.preventDefault(),this.enter("dragging"),this.trigger("drag"))},this)))},e.prototype.onDragMove=function(a){var b=null,c=null,d=null,e=this.difference(this._drag.pointer,this.pointer(a)),f=this.difference(this._drag.stage.start,e);this.is("dragging")&&(a.preventDefault(),this.settings.loop?(b=this.coordinates(this.minimum()),c=this.coordinates(this.maximum()+1)-b,f.x=((f.x-b)%c+c)%c+b):(b=this.settings.rtl?this.coordinates(this.maximum()):this.coordinates(this.minimum()),c=this.settings.rtl?this.coordinates(this.minimum()):this.coordinates(this.maximum()),d=this.settings.pullDrag?-1*e.x/5:0,f.x=Math.max(Math.min(f.x,b+d),c+d)),this._drag.stage.current=f,this.animate(f.x))},e.prototype.onDragEnd=function(b){var d=this.difference(this._drag.pointer,this.pointer(b)),e=this._drag.stage.current,f=d.x>0^this.settings.rtl?"left":"right";a(c).off(".owl.core"),this.$element.removeClass(this.options.grabClass),(0!==d.x&&this.is("dragging")||!this.is("valid"))&&(this.speed(this.settings.dragEndSpeed||this.settings.smartSpeed),this.current(this.closest(e.x,0!==d.x?f:this._drag.direction)),this.invalidate("position"),this.update(),this._drag.direction=f,(Math.abs(d.x)>3||(new Date).getTime()-this._drag.time>300)&&this._drag.target.one("click.owl.core",function(){return!1})),this.is("dragging")&&(this.leave("dragging"),this.trigger("dragged"))},e.prototype.closest=function(b,c){var e=-1,f=30,g=this.width(),h=this.coordinates();return this.settings.freeDrag||a.each(h,a.proxy(function(a,i){return"left"===c&&b>i-f&&b<i+f?e=a:"right"===c&&b>i-g-f&&b<i-g+f?e=a+1:this.op(b,"<",i)&&this.op(b,">",h[a+1]!==d?h[a+1]:i-g)&&(e="left"===c?a+1:a),-1===e},this)),this.settings.loop||(this.op(b,">",h[this.minimum()])?e=b=this.minimum():this.op(b,"<",h[this.maximum()])&&(e=b=this.maximum())),e},e.prototype.animate=function(b){var c=this.speed()>0;this.is("animating")&&this.onTransitionEnd(),c&&(this.enter("animating"),this.trigger("translate")),a.support.transform3d&&a.support.transition?this.$stage.css({transform:"translate3d("+b+"px,0px,0px)",transition:this.speed()/1e3+"s"+(this.settings.slideTransition?" "+this.settings.slideTransition:"")}):c?this.$stage.animate({left:b+"px"},this.speed(),this.settings.fallbackEasing,a.proxy(this.onTransitionEnd,this)):this.$stage.css({left:b+"px"})},e.prototype.is=function(a){return this._states.current[a]&&this._states.current[a]>0},e.prototype.current=function(a){if(a===d)return this._current;if(0===this._items.length)return d;if(a=this.normalize(a),this._current!==a){var b=this.trigger("change",{property:{name:"position",value:a}});b.data!==d&&(a=this.normalize(b.data)),this._current=a,this.invalidate("position"),this.trigger("changed",{property:{name:"position",value:this._current}})}return this._current},e.prototype.invalidate=function(b){return"string"===a.type(b)&&(this._invalidated[b]=!0,this.is("valid")&&this.leave("valid")),a.map(this._invalidated,function(a,b){return b})},e.prototype.reset=function(a){(a=this.normalize(a))!==d&&(this._speed=0,this._current=a,this.suppress(["translate","translated"]),this.animate(this.coordinates(a)),this.release(["translate","translated"]))},e.prototype.normalize=function(a,b){var c=this._items.length,e=b?0:this._clones.length;return!this.isNumeric(a)||c<1?a=d:(a<0||a>=c+e)&&(a=((a-e/2)%c+c)%c+e/2),a},e.prototype.relative=function(a){return a-=this._clones.length/2,this.normalize(a,!0)},e.prototype.maximum=function(a){var b,c,d,e=this.settings,f=this._coordinates.length;if(e.loop)f=this._clones.length/2+this._items.length-1;else if(e.autoWidth||e.merge){if(b=this._items.length)for(c=this._items[--b].width(),d=this.$element.width();b--&&!((c+=this._items[b].width()+this.settings.margin)>d););f=b+1}else f=e.center?this._items.length-1:this._items.length-e.items;return a&&(f-=this._clones.length/2),Math.max(f,0)},e.prototype.minimum=function(a){return a?0:this._clones.length/2},e.prototype.items=function(a){return a===d?this._items.slice():(a=this.normalize(a,!0),this._items[a])},e.prototype.mergers=function(a){return a===d?this._mergers.slice():(a=this.normalize(a,!0),this._mergers[a])},e.prototype.clones=function(b){var c=this._clones.length/2,e=c+this._items.length,f=function(a){return a%2==0?e+a/2:c-(a+1)/2};return b===d?a.map(this._clones,function(a,b){return f(b)}):a.map(this._clones,function(a,c){return a===b?f(c):null})},e.prototype.speed=function(a){return a!==d&&(this._speed=a),this._speed},e.prototype.coordinates=function(b){var c,e=1,f=b-1;return b===d?a.map(this._coordinates,a.proxy(function(a,b){return this.coordinates(b)},this)):(this.settings.center?(this.settings.rtl&&(e=-1,f=b+1),c=this._coordinates[b],c+=(this.width()-c+(this._coordinates[f]||0))/2*e):c=this._coordinates[f]||0,c=Math.ceil(c))},e.prototype.duration=function(a,b,c){return 0===c?0:Math.min(Math.max(Math.abs(b-a),1),6)*Math.abs(c||this.settings.smartSpeed)},e.prototype.to=function(a,b){var c=this.current(),d=null,e=a-this.relative(c),f=(e>0)-(e<0),g=this._items.length,h=this.minimum(),i=this.maximum();this.settings.loop?(!this.settings.rewind&&Math.abs(e)>g/2&&(e+=-1*f*g),a=c+e,(d=((a-h)%g+g)%g+h)!==a&&d-e<=i&&d-e>0&&(c=d-e,a=d,this.reset(c))):this.settings.rewind?(i+=1,a=(a%i+i)%i):a=Math.max(h,Math.min(i,a)),this.speed(this.duration(c,a,b)),this.current(a),this.isVisible()&&this.update()},e.prototype.next=function(a){a=a||!1,this.to(this.relative(this.current())+1,a)},e.prototype.prev=function(a){a=a||!1,this.to(this.relative(this.current())-1,a)},e.prototype.onTransitionEnd=function(a){if(a!==d&&(a.stopPropagation(),(a.target||a.srcElement||a.originalTarget)!==this.$stage.get(0)))return!1;this.leave("animating"),this.trigger("translated")},e.prototype.viewport=function(){var d;return this.options.responsiveBaseElement!==b?d=a(this.options.responsiveBaseElement).width():b.innerWidth?d=b.innerWidth:c.documentElement&&c.documentElement.clientWidth?d=c.documentElement.clientWidth:console.warn("Can not detect viewport width."),d},e.prototype.replace=function(b){this.$stage.empty(),this._items=[],b&&(b=b instanceof jQuery?b:a(b)),this.settings.nestedItemSelector&&(b=b.find("."+this.settings.nestedItemSelector)),b.filter(function(){return 1===this.nodeType}).each(a.proxy(function(a,b){b=this.prepare(b),this.$stage.append(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)},this)),this.reset(this.isNumeric(this.settings.startPosition)?this.settings.startPosition:0),this.invalidate("items")},e.prototype.add=function(b,c){var e=this.relative(this._current);c=c===d?this._items.length:this.normalize(c,!0),b=b instanceof jQuery?b:a(b),this.trigger("add",{content:b,position:c}),b=this.prepare(b),0===this._items.length||c===this._items.length?(0===this._items.length&&this.$stage.append(b),0!==this._items.length&&this._items[c-1].after(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)):(this._items[c].before(b),this._items.splice(c,0,b),this._mergers.splice(c,0,1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)),this._items[e]&&this.reset(this._items[e].index()),this.invalidate("items"),this.trigger("added",{content:b,position:c})},e.prototype.remove=function(a){(a=this.normalize(a,!0))!==d&&(this.trigger("remove",{content:this._items[a],position:a}),this._items[a].remove(),this._items.splice(a,1),this._mergers.splice(a,1),this.invalidate("items"),this.trigger("removed",{content:null,position:a}))},e.prototype.preloadAutoWidthImages=function(b){b.each(a.proxy(function(b,c){this.enter("pre-loading"),c=a(c),a(new Image).one("load",a.proxy(function(a){c.attr("src",a.target.src),c.css("opacity",1),this.leave("pre-loading"),!this.is("pre-loading")&&!this.is("initializing")&&this.refresh()},this)).attr("src",c.attr("src")||c.attr("data-src")||c.attr("data-src-retina"))},this))},e.prototype.destroy=function(){this.$element.off(".owl.core"),this.$stage.off(".owl.core"),a(c).off(".owl.core"),!1!==this.settings.responsive&&(b.clearTimeout(this.resizeTimer),this.off(b,"resize",this._handlers.onThrottledResize));for(var d in this._plugins)this._plugins[d].destroy();this.$stage.children(".cloned").remove(),this.$stage.unwrap(),this.$stage.children().contents().unwrap(),this.$stage.children().unwrap(),this.$stage.remove(),this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class",this.$element.attr("class").replace(new RegExp(this.options.responsiveClass+"-\\S+\\s","g"),"")).removeData("owl.carousel")},e.prototype.op=function(a,b,c){var d=this.settings.rtl;switch(b){case"<":return d?a>c:a<c;case">":return d?a<c:a>c;case">=":return d?a<=c:a>=c;case"<=":return d?a>=c:a<=c}},e.prototype.on=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d):a.attachEvent&&a.attachEvent("on"+b,c)},e.prototype.off=function(a,b,c,d){a.removeEventListener?a.removeEventListener(b,c,d):a.detachEvent&&a.detachEvent("on"+b,c)},e.prototype.trigger=function(b,c,d,f,g){var h={item:{count:this._items.length,index:this.current()}},i=a.camelCase(a.grep(["on",b,d],function(a){return a}).join("-").toLowerCase()),j=a.Event([b,"owl",d||"carousel"].join(".").toLowerCase(),a.extend({relatedTarget:this},h,c));return this._supress[b]||(a.each(this._plugins,function(a,b){b.onTrigger&&b.onTrigger(j)}),this.register({type:e.Type.Event,name:b}),this.$element.trigger(j),this.settings&&"function"==typeof this.settings[i]&&this.settings[i].call(this,j)),j},e.prototype.enter=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]===d&&(this._states.current[b]=0),this._states.current[b]++},this))},e.prototype.leave=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]--},this))},e.prototype.register=function(b){if(b.type===e.Type.Event){if(a.event.special[b.name]||(a.event.special[b.name]={}),!a.event.special[b.name].owl){var c=a.event.special[b.name]._default;a.event.special[b.name]._default=function(a){return!c||!c.apply||a.namespace&&-1!==a.namespace.indexOf("owl")?a.namespace&&a.namespace.indexOf("owl")>-1:c.apply(this,arguments)},a.event.special[b.name].owl=!0}}else b.type===e.Type.State&&(this._states.tags[b.name]?this._states.tags[b.name]=this._states.tags[b.name].concat(b.tags):this._states.tags[b.name]=b.tags,this._states.tags[b.name]=a.grep(this._states.tags[b.name],a.proxy(function(c,d){return a.inArray(c,this._states.tags[b.name])===d},this)))},e.prototype.suppress=function(b){a.each(b,a.proxy(function(a,b){this._supress[b]=!0},this))},e.prototype.release=function(b){a.each(b,a.proxy(function(a,b){delete this._supress[b]},this))},e.prototype.pointer=function(a){var c={x:null,y:null};return a=a.originalEvent||a||b.event,a=a.touches&&a.touches.length?a.touches[0]:a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:a,a.pageX?(c.x=a.pageX,c.y=a.pageY):(c.x=a.clientX,c.y=a.clientY),c},e.prototype.isNumeric=function(a){return!isNaN(parseFloat(a))},e.prototype.difference=function(a,b){return{x:a.x-b.x,y:a.y-b.y}},a.fn.owlCarousel=function(b){var c=Array.prototype.slice.call(arguments,1);return this.each(function(){var d=a(this),f=d.data("owl.carousel");f||(f=new e(this,"object"==typeof b&&b),d.data("owl.carousel",f),a.each(["next","prev","to","destroy","refresh","replace","add","remove"],function(b,c){f.register({type:e.Type.Event,name:c}),f.$element.on(c+".owl.carousel.core",a.proxy(function(a){a.namespace&&a.relatedTarget!==this&&(this.suppress([c]),f[c].apply(this,[].slice.call(arguments,1)),this.release([c]))},f))})),"string"==typeof b&&"_"!==b.charAt(0)&&f[b].apply(f,c)})},a.fn.owlCarousel.Constructor=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._interval=null,this._visible=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoRefresh&&this.watch()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={autoRefresh:!0,autoRefreshInterval:500},e.prototype.watch=function(){this._interval||(this._visible=this._core.isVisible(),this._interval=b.setInterval(a.proxy(this.refresh,this),this._core.settings.autoRefreshInterval))},e.prototype.refresh=function(){this._core.isVisible()!==this._visible&&(this._visible=!this._visible,this._core.$element.toggleClass("owl-hidden",!this._visible),this._visible&&this._core.invalidate("width")&&this._core.refresh())},e.prototype.destroy=function(){var a,c;b.clearInterval(this._interval);for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoRefresh=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._loaded=[],this._handlers={"initialized.owl.carousel change.owl.carousel resized.owl.carousel":a.proxy(function(b){if(b.namespace&&this._core.settings&&this._core.settings.lazyLoad&&(b.property&&"position"==b.property.name||"initialized"==b.type)){var c=this._core.settings,e=c.center&&Math.ceil(c.items/2)||c.items,f=c.center&&-1*e||0,g=(b.property&&b.property.value!==d?b.property.value:this._core.current())+f,h=this._core.clones().length,i=a.proxy(function(a,b){this.load(b)},this);for(c.lazyLoadEager>0&&(e+=c.lazyLoadEager,c.loop&&(g-=c.lazyLoadEager,e++));f++<e;)this.load(h/2+this._core.relative(g)),h&&a.each(this._core.clones(this._core.relative(g)),i),g++}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={lazyLoad:!1,lazyLoadEager:0},e.prototype.load=function(c){var d=this._core.$stage.children().eq(c),e=d&&d.find(".owl-lazy");!e||a.inArray(d.get(0),this._loaded)>-1||(e.each(a.proxy(function(c,d){var e,f=a(d),g=b.devicePixelRatio>1&&f.attr("data-src-retina")||f.attr("data-src")||f.attr("data-srcset");this._core.trigger("load",{element:f,url:g},"lazy"),f.is("img")?f.one("load.owl.lazy",a.proxy(function(){f.css("opacity",1),this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("src",g):f.is("source")?f.one("load.owl.lazy",a.proxy(function(){this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("srcset",g):(e=new Image,e.onload=a.proxy(function(){f.css({"background-image":'url("'+g+'")',opacity:"1"}),this._core.trigger("loaded",{element:f,url:g},"lazy")},this),e.src=g)},this)),this._loaded.push(d.get(0)))},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this._core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Lazy=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(c){this._core=c,this._previousHeight=null,this._handlers={"initialized.owl.carousel refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&this.update()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&"position"===a.property.name&&this.update()},this),"loaded.owl.lazy":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&a.element.closest("."+this._core.settings.itemClass).index()===this._core.current()&&this.update()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers),this._intervalId=null;var d=this;a(b).on("load",function(){d._core.settings.autoHeight&&d.update()}),a(b).resize(function(){d._core.settings.autoHeight&&(null!=d._intervalId&&clearTimeout(d._intervalId),d._intervalId=setTimeout(function(){d.update()},250))})};e.Defaults={autoHeight:!1,autoHeightClass:"owl-height"},e.prototype.update=function(){var b=this._core._current,c=b+this._core.settings.items,d=this._core.settings.lazyLoad,e=this._core.$stage.children().toArray().slice(b,c),f=[],g=0;a.each(e,function(b,c){f.push(a(c).height())}),g=Math.max.apply(null,f),g<=1&&d&&this._previousHeight&&(g=this._previousHeight),this._previousHeight=g,this._core.$stage.parent().height(g).addClass(this._core.settings.autoHeightClass)},e.prototype.destroy=function(){var a,b;for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoHeight=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._videos={},this._playing=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.register({type:"state",name:"playing",tags:["interacting"]})},this),"resize.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.video&&this.isInFullScreen()&&a.preventDefault()},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.is("resizing")&&this._core.$stage.find(".cloned .owl-video-frame").remove()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"===a.property.name&&this._playing&&this.stop()},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find(".owl-video");c.length&&(c.css("display","none"),this.fetch(c,a(b.content)))}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers),this._core.$element.on("click.owl.video",".owl-video-play-icon",a.proxy(function(a){this.play(a)},this))};e.Defaults={video:!1,videoHeight:!1,videoWidth:!1},e.prototype.fetch=function(a,b){var c=function(){return a.attr("data-vimeo-id")?"vimeo":a.attr("data-vzaar-id")?"vzaar":"youtube"}(),d=a.attr("data-vimeo-id")||a.attr("data-youtube-id")||a.attr("data-vzaar-id"),e=a.attr("data-width")||this._core.settings.videoWidth,f=a.attr("data-height")||this._core.settings.videoHeight,g=a.attr("href");if(!g)throw new Error("Missing video URL.");if(d=g.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/),d[3].indexOf("youtu")>-1)c="youtube";else if(d[3].indexOf("vimeo")>-1)c="vimeo";else{if(!(d[3].indexOf("vzaar")>-1))throw new Error("Video URL not supported.");c="vzaar"}d=d[6],this._videos[g]={type:c,id:d,width:e,height:f},b.attr("data-video",g),this.thumbnail(a,this._videos[g])},e.prototype.thumbnail=function(b,c){var d,e,f,g=c.width&&c.height?"width:"+c.width+"px;height:"+c.height+"px;":"",h=b.find("img"),i="src",j="",k=this._core.settings,l=function(c){e='<div class="owl-video-play-icon"></div>',d=k.lazyLoad?a("<div/>",{class:"owl-video-tn "+j,srcType:c}):a("<div/>",{class:"owl-video-tn",style:"opacity:1;background-image:url("+c+")"}),b.after(d),b.after(e)};if(b.wrap(a("<div/>",{class:"owl-video-wrapper",style:g})),this._core.settings.lazyLoad&&(i="data-src",j="owl-lazy"),h.length)return l(h.attr(i)),h.remove(),!1;"youtube"===c.type?(f="//img.youtube.com/vi/"+c.id+"/hqdefault.jpg",l(f)):"vimeo"===c.type?a.ajax({type:"GET",url:"//vimeo.com/api/v2/video/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a[0].thumbnail_large,l(f)}}):"vzaar"===c.type&&a.ajax({type:"GET",url:"//vzaar.com/api/videos/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a.framegrab_url,l(f)}})},e.prototype.stop=function(){this._core.trigger("stop",null,"video"),this._playing.find(".owl-video-frame").remove(),this._playing.removeClass("owl-video-playing"),this._playing=null,this._core.leave("playing"),this._core.trigger("stopped",null,"video")},e.prototype.play=function(b){var c,d=a(b.target),e=d.closest("."+this._core.settings.itemClass),f=this._videos[e.attr("data-video")],g=f.width||"100%",h=f.height||this._core.$stage.height();this._playing||(this._core.enter("playing"),this._core.trigger("play",null,"video"),e=this._core.items(this._core.relative(e.index())),this._core.reset(e.index()),c=a('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'),c.attr("height",h),c.attr("width",g),"youtube"===f.type?c.attr("src","//www.youtube.com/embed/"+f.id+"?autoplay=1&rel=0&v="+f.id):"vimeo"===f.type?c.attr("src","//player.vimeo.com/video/"+f.id+"?autoplay=1"):"vzaar"===f.type&&c.attr("src","//view.vzaar.com/"+f.id+"/player?autoplay=true"),a(c).wrap('<div class="owl-video-frame" />').insertAfter(e.find(".owl-video")),this._playing=e.addClass("owl-video-playing"))},e.prototype.isInFullScreen=function(){var b=c.fullscreenElement||c.mozFullScreenElement||c.webkitFullscreenElement;return b&&a(b).parent().hasClass("owl-video-frame")},e.prototype.destroy=function(){var a,b;this._core.$element.off("click.owl.video");for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Video=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this.core=b,this.core.options=a.extend({},e.Defaults,this.core.options),this.swapping=!0,this.previous=d,this.next=d,this.handlers={"change.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&(this.previous=this.core.current(),this.next=a.property.value)},this),"drag.owl.carousel dragged.owl.carousel translated.owl.carousel":a.proxy(function(a){a.namespace&&(this.swapping="translated"==a.type)},this),"translate.owl.carousel":a.proxy(function(a){a.namespace&&this.swapping&&(this.core.options.animateOut||this.core.options.animateIn)&&this.swap()},this)},this.core.$element.on(this.handlers)};e.Defaults={animateOut:!1,
animateIn:!1},e.prototype.swap=function(){if(1===this.core.settings.items&&a.support.animation&&a.support.transition){this.core.speed(0);var b,c=a.proxy(this.clear,this),d=this.core.$stage.children().eq(this.previous),e=this.core.$stage.children().eq(this.next),f=this.core.settings.animateIn,g=this.core.settings.animateOut;this.core.current()!==this.previous&&(g&&(b=this.core.coordinates(this.previous)-this.core.coordinates(this.next),d.one(a.support.animation.end,c).css({left:b+"px"}).addClass("animated owl-animated-out").addClass(g)),f&&e.one(a.support.animation.end,c).addClass("animated owl-animated-in").addClass(f))}},e.prototype.clear=function(b){a(b.target).css({left:""}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut),this.core.onTransitionEnd()},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this.core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Animate=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._call=null,this._time=0,this._timeout=0,this._paused=!0,this._handlers={"changed.owl.carousel":a.proxy(function(a){a.namespace&&"settings"===a.property.name?this._core.settings.autoplay?this.play():this.stop():a.namespace&&"position"===a.property.name&&this._paused&&(this._time=0)},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoplay&&this.play()},this),"play.owl.autoplay":a.proxy(function(a,b,c){a.namespace&&this.play(b,c)},this),"stop.owl.autoplay":a.proxy(function(a){a.namespace&&this.stop()},this),"mouseover.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"mouseleave.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.play()},this),"touchstart.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"touchend.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this.play()},this)},this._core.$element.on(this._handlers),this._core.options=a.extend({},e.Defaults,this._core.options)};e.Defaults={autoplay:!1,autoplayTimeout:5e3,autoplayHoverPause:!1,autoplaySpeed:!1},e.prototype._next=function(d){this._call=b.setTimeout(a.proxy(this._next,this,d),this._timeout*(Math.round(this.read()/this._timeout)+1)-this.read()),this._core.is("interacting")||c.hidden||this._core.next(d||this._core.settings.autoplaySpeed)},e.prototype.read=function(){return(new Date).getTime()-this._time},e.prototype.play=function(c,d){var e;this._core.is("rotating")||this._core.enter("rotating"),c=c||this._core.settings.autoplayTimeout,e=Math.min(this._time%(this._timeout||c),c),this._paused?(this._time=this.read(),this._paused=!1):b.clearTimeout(this._call),this._time+=this.read()%c-e,this._timeout=c,this._call=b.setTimeout(a.proxy(this._next,this,d),c-e)},e.prototype.stop=function(){this._core.is("rotating")&&(this._time=0,this._paused=!0,b.clearTimeout(this._call),this._core.leave("rotating"))},e.prototype.pause=function(){this._core.is("rotating")&&!this._paused&&(this._time=this.read(),this._paused=!0,b.clearTimeout(this._call))},e.prototype.destroy=function(){var a,b;this.stop();for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.autoplay=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(b){this._core=b,this._initialized=!1,this._pages=[],this._controls={},this._templates=[],this.$element=this._core.$element,this._overrides={next:this._core.next,prev:this._core.prev,to:this._core.to},this._handlers={"prepared.owl.carousel":a.proxy(function(b){b.namespace&&this._core.settings.dotsData&&this._templates.push('<div class="'+this._core.settings.dotClass+'">'+a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot")+"</div>")},this),"added.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,0,this._templates.pop())},this),"remove.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,1)},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&this.draw()},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&!this._initialized&&(this._core.trigger("initialize",null,"navigation"),this.initialize(),this.update(),this.draw(),this._initialized=!0,this._core.trigger("initialized",null,"navigation"))},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._initialized&&(this._core.trigger("refresh",null,"navigation"),this.update(),this.draw(),this._core.trigger("refreshed",null,"navigation"))},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers)};e.Defaults={nav:!1,navText:['<span aria-label="Previous">&#x2039;</span>','<span aria-label="Next">&#x203a;</span>'],navSpeed:!1,navElement:'button type="button" role="presentation"',navContainer:!1,navContainerClass:"owl-nav",navClass:["owl-prev","owl-next"],slideBy:1,dotClass:"owl-dot",dotsClass:"owl-dots",dots:!0,dotsEach:!1,dotsData:!1,dotsSpeed:!1,dotsContainer:!1},e.prototype.initialize=function(){var b,c=this._core.settings;this._controls.$relative=(c.navContainer?a(c.navContainer):a("<div>").addClass(c.navContainerClass).appendTo(this.$element)).addClass("disabled"),this._controls.$previous=a("<"+c.navElement+">").addClass(c.navClass[0]).html(c.navText[0]).prependTo(this._controls.$relative).on("click",a.proxy(function(a){this.prev(c.navSpeed)},this)),this._controls.$next=a("<"+c.navElement+">").addClass(c.navClass[1]).html(c.navText[1]).appendTo(this._controls.$relative).on("click",a.proxy(function(a){this.next(c.navSpeed)},this)),c.dotsData||(this._templates=[a('<button role="button">').addClass(c.dotClass).append(a("<span>")).prop("outerHTML")]),this._controls.$absolute=(c.dotsContainer?a(c.dotsContainer):a("<div>").addClass(c.dotsClass).appendTo(this.$element)).addClass("disabled"),this._controls.$absolute.on("click","button",a.proxy(function(b){var d=a(b.target).parent().is(this._controls.$absolute)?a(b.target).index():a(b.target).parent().index();b.preventDefault(),this.to(d,c.dotsSpeed)},this));for(b in this._overrides)this._core[b]=a.proxy(this[b],this)},e.prototype.destroy=function(){var a,b,c,d,e;e=this._core.settings;for(a in this._handlers)this.$element.off(a,this._handlers[a]);for(b in this._controls)"$relative"===b&&e.navContainer?this._controls[b].html(""):this._controls[b].remove();for(d in this.overides)this._core[d]=this._overrides[d];for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},e.prototype.update=function(){var a,b,c,d=this._core.clones().length/2,e=d+this._core.items().length,f=this._core.maximum(!0),g=this._core.settings,h=g.center||g.autoWidth||g.dotsData?1:g.dotsEach||g.items;if("page"!==g.slideBy&&(g.slideBy=Math.min(g.slideBy,g.items)),g.dots||"page"==g.slideBy)for(this._pages=[],a=d,b=0,c=0;a<e;a++){if(b>=h||0===b){if(this._pages.push({start:Math.min(f,a-d),end:a-d+h-1}),Math.min(f,a-d)===f)break;b=0,++c}b+=this._core.mergers(this._core.relative(a))}},e.prototype.draw=function(){var b,c=this._core.settings,d=this._core.items().length<=c.items,e=this._core.relative(this._core.current()),f=c.loop||c.rewind;this._controls.$relative.toggleClass("disabled",!c.nav||d),c.nav&&(this._controls.$previous.toggleClass("disabled",!f&&e<=this._core.minimum(!0)),this._controls.$next.toggleClass("disabled",!f&&e>=this._core.maximum(!0))),this._controls.$absolute.toggleClass("disabled",!c.dots||d),c.dots&&(b=this._pages.length-this._controls.$absolute.children().length,c.dotsData&&0!==b?this._controls.$absolute.html(this._templates.join("")):b>0?this._controls.$absolute.append(new Array(b+1).join(this._templates[0])):b<0&&this._controls.$absolute.children().slice(b).remove(),this._controls.$absolute.find(".active").removeClass("active"),this._controls.$absolute.children().eq(a.inArray(this.current(),this._pages)).addClass("active"))},e.prototype.onTrigger=function(b){var c=this._core.settings;b.page={index:a.inArray(this.current(),this._pages),count:this._pages.length,size:c&&(c.center||c.autoWidth||c.dotsData?1:c.dotsEach||c.items)}},e.prototype.current=function(){var b=this._core.relative(this._core.current());return a.grep(this._pages,a.proxy(function(a,c){return a.start<=b&&a.end>=b},this)).pop()},e.prototype.getPosition=function(b){var c,d,e=this._core.settings;return"page"==e.slideBy?(c=a.inArray(this.current(),this._pages),d=this._pages.length,b?++c:--c,c=this._pages[(c%d+d)%d].start):(c=this._core.relative(this._core.current()),d=this._core.items().length,b?c+=e.slideBy:c-=e.slideBy),c},e.prototype.next=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!0),b)},e.prototype.prev=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!1),b)},e.prototype.to=function(b,c,d){var e;!d&&this._pages.length?(e=this._pages.length,a.proxy(this._overrides.to,this._core)(this._pages[(b%e+e)%e].start,c)):a.proxy(this._overrides.to,this._core)(b,c)},a.fn.owlCarousel.Constructor.Plugins.Navigation=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(c){this._core=c,this._hashes={},this.$element=this._core.$element,this._handlers={"initialized.owl.carousel":a.proxy(function(c){c.namespace&&"URLHash"===this._core.settings.startPosition&&a(b).trigger("hashchange.owl.navigation")},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");if(!c)return;this._hashes[c]=b.content}},this),"changed.owl.carousel":a.proxy(function(c){if(c.namespace&&"position"===c.property.name){var d=this._core.items(this._core.relative(this._core.current())),e=a.map(this._hashes,function(a,b){return a===d?b:null}).join();if(!e||b.location.hash.slice(1)===e)return;b.location.hash=e}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers),a(b).on("hashchange.owl.navigation",a.proxy(function(a){var c=b.location.hash.substring(1),e=this._core.$stage.children(),f=this._hashes[c]&&e.index(this._hashes[c]);f!==d&&f!==this._core.current()&&this._core.to(this._core.relative(f),!1,!0)},this))};e.Defaults={URLhashListener:!1},e.prototype.destroy=function(){var c,d;a(b).off("hashchange.owl.navigation");for(c in this._handlers)this._core.$element.off(c,this._handlers[c]);for(d in Object.getOwnPropertyNames(this))"function"!=typeof this[d]&&(this[d]=null)},a.fn.owlCarousel.Constructor.Plugins.Hash=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){function e(b,c){var e=!1,f=b.charAt(0).toUpperCase()+b.slice(1);return a.each((b+" "+h.join(f+" ")+f).split(" "),function(a,b){if(g[b]!==d)return e=!c||b,!1}),e}function f(a){return e(a,!0)}var g=a("<support>").get(0).style,h="Webkit Moz O ms".split(" "),i={transition:{end:{WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",transition:"transitionend"}},animation:{end:{WebkitAnimation:"webkitAnimationEnd",MozAnimation:"animationend",OAnimation:"oAnimationEnd",animation:"animationend"}}},j={csstransforms:function(){return!!e("transform")},csstransforms3d:function(){return!!e("perspective")},csstransitions:function(){return!!e("transition")},cssanimations:function(){return!!e("animation")}};j.csstransitions()&&(a.support.transition=new String(f("transition")),a.support.transition.end=i.transition.end[a.support.transition]),j.cssanimations()&&(a.support.animation=new String(f("animation")),a.support.animation.end=i.animation.end[a.support.animation]),j.csstransforms()&&(a.support.transform=new String(f("transform")),a.support.transform3d=j.csstransforms3d())}(window.Zepto||window.jQuery,window,document);
/*! Hammer.JS - v2.0.8 - 2016-04-23
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
!function(a,b,c,d){"use strict";function e(a,b,c){return setTimeout(j(a,c),b)}function f(a,b,c){return Array.isArray(a)?(g(a,c[b],c),!0):!1}function g(a,b,c){var e;if(a)if(a.forEach)a.forEach(b,c);else if(a.length!==d)for(e=0;e<a.length;)b.call(c,a[e],e,a),e++;else for(e in a)a.hasOwnProperty(e)&&b.call(c,a[e],e,a)}function h(b,c,d){var e="DEPRECATED METHOD: "+c+"\n"+d+" AT \n";return function(){var c=new Error("get-stack-trace"),d=c&&c.stack?c.stack.replace(/^[^\(]+?[\n$]/gm,"").replace(/^\s+at\s+/gm,"").replace(/^Object.<anonymous>\s*\(/gm,"{anonymous}()@"):"Unknown Stack Trace",f=a.console&&(a.console.warn||a.console.log);return f&&f.call(a.console,e,d),b.apply(this,arguments)}}function i(a,b,c){var d,e=b.prototype;d=a.prototype=Object.create(e),d.constructor=a,d._super=e,c&&la(d,c)}function j(a,b){return function(){return a.apply(b,arguments)}}function k(a,b){return typeof a==oa?a.apply(b?b[0]||d:d,b):a}function l(a,b){return a===d?b:a}function m(a,b,c){g(q(b),function(b){a.addEventListener(b,c,!1)})}function n(a,b,c){g(q(b),function(b){a.removeEventListener(b,c,!1)})}function o(a,b){for(;a;){if(a==b)return!0;a=a.parentNode}return!1}function p(a,b){return a.indexOf(b)>-1}function q(a){return a.trim().split(/\s+/g)}function r(a,b,c){if(a.indexOf&&!c)return a.indexOf(b);for(var d=0;d<a.length;){if(c&&a[d][c]==b||!c&&a[d]===b)return d;d++}return-1}function s(a){return Array.prototype.slice.call(a,0)}function t(a,b,c){for(var d=[],e=[],f=0;f<a.length;){var g=b?a[f][b]:a[f];r(e,g)<0&&d.push(a[f]),e[f]=g,f++}return c&&(d=b?d.sort(function(a,c){return a[b]>c[b]}):d.sort()),d}function u(a,b){for(var c,e,f=b[0].toUpperCase()+b.slice(1),g=0;g<ma.length;){if(c=ma[g],e=c?c+f:b,e in a)return e;g++}return d}function v(){return ua++}function w(b){var c=b.ownerDocument||b;return c.defaultView||c.parentWindow||a}function x(a,b){var c=this;this.manager=a,this.callback=b,this.element=a.element,this.target=a.options.inputTarget,this.domHandler=function(b){k(a.options.enable,[a])&&c.handler(b)},this.init()}function y(a){var b,c=a.options.inputClass;return new(b=c?c:xa?M:ya?P:wa?R:L)(a,z)}function z(a,b,c){var d=c.pointers.length,e=c.changedPointers.length,f=b&Ea&&d-e===0,g=b&(Ga|Ha)&&d-e===0;c.isFirst=!!f,c.isFinal=!!g,f&&(a.session={}),c.eventType=b,A(a,c),a.emit("hammer.input",c),a.recognize(c),a.session.prevInput=c}function A(a,b){var c=a.session,d=b.pointers,e=d.length;c.firstInput||(c.firstInput=D(b)),e>1&&!c.firstMultiple?c.firstMultiple=D(b):1===e&&(c.firstMultiple=!1);var f=c.firstInput,g=c.firstMultiple,h=g?g.center:f.center,i=b.center=E(d);b.timeStamp=ra(),b.deltaTime=b.timeStamp-f.timeStamp,b.angle=I(h,i),b.distance=H(h,i),B(c,b),b.offsetDirection=G(b.deltaX,b.deltaY);var j=F(b.deltaTime,b.deltaX,b.deltaY);b.overallVelocityX=j.x,b.overallVelocityY=j.y,b.overallVelocity=qa(j.x)>qa(j.y)?j.x:j.y,b.scale=g?K(g.pointers,d):1,b.rotation=g?J(g.pointers,d):0,b.maxPointers=c.prevInput?b.pointers.length>c.prevInput.maxPointers?b.pointers.length:c.prevInput.maxPointers:b.pointers.length,C(c,b);var k=a.element;o(b.srcEvent.target,k)&&(k=b.srcEvent.target),b.target=k}function B(a,b){var c=b.center,d=a.offsetDelta||{},e=a.prevDelta||{},f=a.prevInput||{};b.eventType!==Ea&&f.eventType!==Ga||(e=a.prevDelta={x:f.deltaX||0,y:f.deltaY||0},d=a.offsetDelta={x:c.x,y:c.y}),b.deltaX=e.x+(c.x-d.x),b.deltaY=e.y+(c.y-d.y)}function C(a,b){var c,e,f,g,h=a.lastInterval||b,i=b.timeStamp-h.timeStamp;if(b.eventType!=Ha&&(i>Da||h.velocity===d)){var j=b.deltaX-h.deltaX,k=b.deltaY-h.deltaY,l=F(i,j,k);e=l.x,f=l.y,c=qa(l.x)>qa(l.y)?l.x:l.y,g=G(j,k),a.lastInterval=b}else c=h.velocity,e=h.velocityX,f=h.velocityY,g=h.direction;b.velocity=c,b.velocityX=e,b.velocityY=f,b.direction=g}function D(a){for(var b=[],c=0;c<a.pointers.length;)b[c]={clientX:pa(a.pointers[c].clientX),clientY:pa(a.pointers[c].clientY)},c++;return{timeStamp:ra(),pointers:b,center:E(b),deltaX:a.deltaX,deltaY:a.deltaY}}function E(a){var b=a.length;if(1===b)return{x:pa(a[0].clientX),y:pa(a[0].clientY)};for(var c=0,d=0,e=0;b>e;)c+=a[e].clientX,d+=a[e].clientY,e++;return{x:pa(c/b),y:pa(d/b)}}function F(a,b,c){return{x:b/a||0,y:c/a||0}}function G(a,b){return a===b?Ia:qa(a)>=qa(b)?0>a?Ja:Ka:0>b?La:Ma}function H(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return Math.sqrt(d*d+e*e)}function I(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return 180*Math.atan2(e,d)/Math.PI}function J(a,b){return I(b[1],b[0],Ra)+I(a[1],a[0],Ra)}function K(a,b){return H(b[0],b[1],Ra)/H(a[0],a[1],Ra)}function L(){this.evEl=Ta,this.evWin=Ua,this.pressed=!1,x.apply(this,arguments)}function M(){this.evEl=Xa,this.evWin=Ya,x.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function N(){this.evTarget=$a,this.evWin=_a,this.started=!1,x.apply(this,arguments)}function O(a,b){var c=s(a.touches),d=s(a.changedTouches);return b&(Ga|Ha)&&(c=t(c.concat(d),"identifier",!0)),[c,d]}function P(){this.evTarget=bb,this.targetIds={},x.apply(this,arguments)}function Q(a,b){var c=s(a.touches),d=this.targetIds;if(b&(Ea|Fa)&&1===c.length)return d[c[0].identifier]=!0,[c,c];var e,f,g=s(a.changedTouches),h=[],i=this.target;if(f=c.filter(function(a){return o(a.target,i)}),b===Ea)for(e=0;e<f.length;)d[f[e].identifier]=!0,e++;for(e=0;e<g.length;)d[g[e].identifier]&&h.push(g[e]),b&(Ga|Ha)&&delete d[g[e].identifier],e++;return h.length?[t(f.concat(h),"identifier",!0),h]:void 0}function R(){x.apply(this,arguments);var a=j(this.handler,this);this.touch=new P(this.manager,a),this.mouse=new L(this.manager,a),this.primaryTouch=null,this.lastTouches=[]}function S(a,b){a&Ea?(this.primaryTouch=b.changedPointers[0].identifier,T.call(this,b)):a&(Ga|Ha)&&T.call(this,b)}function T(a){var b=a.changedPointers[0];if(b.identifier===this.primaryTouch){var c={x:b.clientX,y:b.clientY};this.lastTouches.push(c);var d=this.lastTouches,e=function(){var a=d.indexOf(c);a>-1&&d.splice(a,1)};setTimeout(e,cb)}}function U(a){for(var b=a.srcEvent.clientX,c=a.srcEvent.clientY,d=0;d<this.lastTouches.length;d++){var e=this.lastTouches[d],f=Math.abs(b-e.x),g=Math.abs(c-e.y);if(db>=f&&db>=g)return!0}return!1}function V(a,b){this.manager=a,this.set(b)}function W(a){if(p(a,jb))return jb;var b=p(a,kb),c=p(a,lb);return b&&c?jb:b||c?b?kb:lb:p(a,ib)?ib:hb}function X(){if(!fb)return!1;var b={},c=a.CSS&&a.CSS.supports;return["auto","manipulation","pan-y","pan-x","pan-x pan-y","none"].forEach(function(d){b[d]=c?a.CSS.supports("touch-action",d):!0}),b}function Y(a){this.options=la({},this.defaults,a||{}),this.id=v(),this.manager=null,this.options.enable=l(this.options.enable,!0),this.state=nb,this.simultaneous={},this.requireFail=[]}function Z(a){return a&sb?"cancel":a&qb?"end":a&pb?"move":a&ob?"start":""}function $(a){return a==Ma?"down":a==La?"up":a==Ja?"left":a==Ka?"right":""}function _(a,b){var c=b.manager;return c?c.get(a):a}function aa(){Y.apply(this,arguments)}function ba(){aa.apply(this,arguments),this.pX=null,this.pY=null}function ca(){aa.apply(this,arguments)}function da(){Y.apply(this,arguments),this._timer=null,this._input=null}function ea(){aa.apply(this,arguments)}function fa(){aa.apply(this,arguments)}function ga(){Y.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function ha(a,b){return b=b||{},b.recognizers=l(b.recognizers,ha.defaults.preset),new ia(a,b)}function ia(a,b){this.options=la({},ha.defaults,b||{}),this.options.inputTarget=this.options.inputTarget||a,this.handlers={},this.session={},this.recognizers=[],this.oldCssProps={},this.element=a,this.input=y(this),this.touchAction=new V(this,this.options.touchAction),ja(this,!0),g(this.options.recognizers,function(a){var b=this.add(new a[0](a[1]));a[2]&&b.recognizeWith(a[2]),a[3]&&b.requireFailure(a[3])},this)}function ja(a,b){var c=a.element;if(c.style){var d;g(a.options.cssProps,function(e,f){d=u(c.style,f),b?(a.oldCssProps[d]=c.style[d],c.style[d]=e):c.style[d]=a.oldCssProps[d]||""}),b||(a.oldCssProps={})}}function ka(a,c){var d=b.createEvent("Event");d.initEvent(a,!0,!0),d.gesture=c,c.target.dispatchEvent(d)}var la,ma=["","webkit","Moz","MS","ms","o"],na=b.createElement("div"),oa="function",pa=Math.round,qa=Math.abs,ra=Date.now;la="function"!=typeof Object.assign?function(a){if(a===d||null===a)throw new TypeError("Cannot convert undefined or null to object");for(var b=Object(a),c=1;c<arguments.length;c++){var e=arguments[c];if(e!==d&&null!==e)for(var f in e)e.hasOwnProperty(f)&&(b[f]=e[f])}return b}:Object.assign;var sa=h(function(a,b,c){for(var e=Object.keys(b),f=0;f<e.length;)(!c||c&&a[e[f]]===d)&&(a[e[f]]=b[e[f]]),f++;return a},"extend","Use `assign`."),ta=h(function(a,b){return sa(a,b,!0)},"merge","Use `assign`."),ua=1,va=/mobile|tablet|ip(ad|hone|od)|android/i,wa="ontouchstart"in a,xa=u(a,"PointerEvent")!==d,ya=wa&&va.test(navigator.userAgent),za="touch",Aa="pen",Ba="mouse",Ca="kinect",Da=25,Ea=1,Fa=2,Ga=4,Ha=8,Ia=1,Ja=2,Ka=4,La=8,Ma=16,Na=Ja|Ka,Oa=La|Ma,Pa=Na|Oa,Qa=["x","y"],Ra=["clientX","clientY"];x.prototype={handler:function(){},init:function(){this.evEl&&m(this.element,this.evEl,this.domHandler),this.evTarget&&m(this.target,this.evTarget,this.domHandler),this.evWin&&m(w(this.element),this.evWin,this.domHandler)},destroy:function(){this.evEl&&n(this.element,this.evEl,this.domHandler),this.evTarget&&n(this.target,this.evTarget,this.domHandler),this.evWin&&n(w(this.element),this.evWin,this.domHandler)}};var Sa={mousedown:Ea,mousemove:Fa,mouseup:Ga},Ta="mousedown",Ua="mousemove mouseup";i(L,x,{handler:function(a){var b=Sa[a.type];b&Ea&&0===a.button&&(this.pressed=!0),b&Fa&&1!==a.which&&(b=Ga),this.pressed&&(b&Ga&&(this.pressed=!1),this.callback(this.manager,b,{pointers:[a],changedPointers:[a],pointerType:Ba,srcEvent:a}))}});var Va={pointerdown:Ea,pointermove:Fa,pointerup:Ga,pointercancel:Ha,pointerout:Ha},Wa={2:za,3:Aa,4:Ba,5:Ca},Xa="pointerdown",Ya="pointermove pointerup pointercancel";a.MSPointerEvent&&!a.PointerEvent&&(Xa="MSPointerDown",Ya="MSPointerMove MSPointerUp MSPointerCancel"),i(M,x,{handler:function(a){var b=this.store,c=!1,d=a.type.toLowerCase().replace("ms",""),e=Va[d],f=Wa[a.pointerType]||a.pointerType,g=f==za,h=r(b,a.pointerId,"pointerId");e&Ea&&(0===a.button||g)?0>h&&(b.push(a),h=b.length-1):e&(Ga|Ha)&&(c=!0),0>h||(b[h]=a,this.callback(this.manager,e,{pointers:b,changedPointers:[a],pointerType:f,srcEvent:a}),c&&b.splice(h,1))}});var Za={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},$a="touchstart",_a="touchstart touchmove touchend touchcancel";i(N,x,{handler:function(a){var b=Za[a.type];if(b===Ea&&(this.started=!0),this.started){var c=O.call(this,a,b);b&(Ga|Ha)&&c[0].length-c[1].length===0&&(this.started=!1),this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}}});var ab={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},bb="touchstart touchmove touchend touchcancel";i(P,x,{handler:function(a){var b=ab[a.type],c=Q.call(this,a,b);c&&this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}});var cb=2500,db=25;i(R,x,{handler:function(a,b,c){var d=c.pointerType==za,e=c.pointerType==Ba;if(!(e&&c.sourceCapabilities&&c.sourceCapabilities.firesTouchEvents)){if(d)S.call(this,b,c);else if(e&&U.call(this,c))return;this.callback(a,b,c)}},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var eb=u(na.style,"touchAction"),fb=eb!==d,gb="compute",hb="auto",ib="manipulation",jb="none",kb="pan-x",lb="pan-y",mb=X();V.prototype={set:function(a){a==gb&&(a=this.compute()),fb&&this.manager.element.style&&mb[a]&&(this.manager.element.style[eb]=a),this.actions=a.toLowerCase().trim()},update:function(){this.set(this.manager.options.touchAction)},compute:function(){var a=[];return g(this.manager.recognizers,function(b){k(b.options.enable,[b])&&(a=a.concat(b.getTouchAction()))}),W(a.join(" "))},preventDefaults:function(a){var b=a.srcEvent,c=a.offsetDirection;if(this.manager.session.prevented)return void b.preventDefault();var d=this.actions,e=p(d,jb)&&!mb[jb],f=p(d,lb)&&!mb[lb],g=p(d,kb)&&!mb[kb];if(e){var h=1===a.pointers.length,i=a.distance<2,j=a.deltaTime<250;if(h&&i&&j)return}return g&&f?void 0:e||f&&c&Na||g&&c&Oa?this.preventSrc(b):void 0},preventSrc:function(a){this.manager.session.prevented=!0,a.preventDefault()}};var nb=1,ob=2,pb=4,qb=8,rb=qb,sb=16,tb=32;Y.prototype={defaults:{},set:function(a){return la(this.options,a),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function(a){if(f(a,"recognizeWith",this))return this;var b=this.simultaneous;return a=_(a,this),b[a.id]||(b[a.id]=a,a.recognizeWith(this)),this},dropRecognizeWith:function(a){return f(a,"dropRecognizeWith",this)?this:(a=_(a,this),delete this.simultaneous[a.id],this)},requireFailure:function(a){if(f(a,"requireFailure",this))return this;var b=this.requireFail;return a=_(a,this),-1===r(b,a)&&(b.push(a),a.requireFailure(this)),this},dropRequireFailure:function(a){if(f(a,"dropRequireFailure",this))return this;a=_(a,this);var b=r(this.requireFail,a);return b>-1&&this.requireFail.splice(b,1),this},hasRequireFailures:function(){return this.requireFail.length>0},canRecognizeWith:function(a){return!!this.simultaneous[a.id]},emit:function(a){function b(b){c.manager.emit(b,a)}var c=this,d=this.state;qb>d&&b(c.options.event+Z(d)),b(c.options.event),a.additionalEvent&&b(a.additionalEvent),d>=qb&&b(c.options.event+Z(d))},tryEmit:function(a){return this.canEmit()?this.emit(a):void(this.state=tb)},canEmit:function(){for(var a=0;a<this.requireFail.length;){if(!(this.requireFail[a].state&(tb|nb)))return!1;a++}return!0},recognize:function(a){var b=la({},a);return k(this.options.enable,[this,b])?(this.state&(rb|sb|tb)&&(this.state=nb),this.state=this.process(b),void(this.state&(ob|pb|qb|sb)&&this.tryEmit(b))):(this.reset(),void(this.state=tb))},process:function(a){},getTouchAction:function(){},reset:function(){}},i(aa,Y,{defaults:{pointers:1},attrTest:function(a){var b=this.options.pointers;return 0===b||a.pointers.length===b},process:function(a){var b=this.state,c=a.eventType,d=b&(ob|pb),e=this.attrTest(a);return d&&(c&Ha||!e)?b|sb:d||e?c&Ga?b|qb:b&ob?b|pb:ob:tb}}),i(ba,aa,{defaults:{event:"pan",threshold:10,pointers:1,direction:Pa},getTouchAction:function(){var a=this.options.direction,b=[];return a&Na&&b.push(lb),a&Oa&&b.push(kb),b},directionTest:function(a){var b=this.options,c=!0,d=a.distance,e=a.direction,f=a.deltaX,g=a.deltaY;return e&b.direction||(b.direction&Na?(e=0===f?Ia:0>f?Ja:Ka,c=f!=this.pX,d=Math.abs(a.deltaX)):(e=0===g?Ia:0>g?La:Ma,c=g!=this.pY,d=Math.abs(a.deltaY))),a.direction=e,c&&d>b.threshold&&e&b.direction},attrTest:function(a){return aa.prototype.attrTest.call(this,a)&&(this.state&ob||!(this.state&ob)&&this.directionTest(a))},emit:function(a){this.pX=a.deltaX,this.pY=a.deltaY;var b=$(a.direction);b&&(a.additionalEvent=this.options.event+b),this._super.emit.call(this,a)}}),i(ca,aa,{defaults:{event:"pinch",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.scale-1)>this.options.threshold||this.state&ob)},emit:function(a){if(1!==a.scale){var b=a.scale<1?"in":"out";a.additionalEvent=this.options.event+b}this._super.emit.call(this,a)}}),i(da,Y,{defaults:{event:"press",pointers:1,time:251,threshold:9},getTouchAction:function(){return[hb]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime>b.time;if(this._input=a,!d||!c||a.eventType&(Ga|Ha)&&!f)this.reset();else if(a.eventType&Ea)this.reset(),this._timer=e(function(){this.state=rb,this.tryEmit()},b.time,this);else if(a.eventType&Ga)return rb;return tb},reset:function(){clearTimeout(this._timer)},emit:function(a){this.state===rb&&(a&&a.eventType&Ga?this.manager.emit(this.options.event+"up",a):(this._input.timeStamp=ra(),this.manager.emit(this.options.event,this._input)))}}),i(ea,aa,{defaults:{event:"rotate",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.rotation)>this.options.threshold||this.state&ob)}}),i(fa,aa,{defaults:{event:"swipe",threshold:10,velocity:.3,direction:Na|Oa,pointers:1},getTouchAction:function(){return ba.prototype.getTouchAction.call(this)},attrTest:function(a){var b,c=this.options.direction;return c&(Na|Oa)?b=a.overallVelocity:c&Na?b=a.overallVelocityX:c&Oa&&(b=a.overallVelocityY),this._super.attrTest.call(this,a)&&c&a.offsetDirection&&a.distance>this.options.threshold&&a.maxPointers==this.options.pointers&&qa(b)>this.options.velocity&&a.eventType&Ga},emit:function(a){var b=$(a.offsetDirection);b&&this.manager.emit(this.options.event+b,a),this.manager.emit(this.options.event,a)}}),i(ga,Y,{defaults:{event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:9,posThreshold:10},getTouchAction:function(){return[ib]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime<b.time;if(this.reset(),a.eventType&Ea&&0===this.count)return this.failTimeout();if(d&&f&&c){if(a.eventType!=Ga)return this.failTimeout();var g=this.pTime?a.timeStamp-this.pTime<b.interval:!0,h=!this.pCenter||H(this.pCenter,a.center)<b.posThreshold;this.pTime=a.timeStamp,this.pCenter=a.center,h&&g?this.count+=1:this.count=1,this._input=a;var i=this.count%b.taps;if(0===i)return this.hasRequireFailures()?(this._timer=e(function(){this.state=rb,this.tryEmit()},b.interval,this),ob):rb}return tb},failTimeout:function(){return this._timer=e(function(){this.state=tb},this.options.interval,this),tb},reset:function(){clearTimeout(this._timer)},emit:function(){this.state==rb&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),ha.VERSION="2.0.8",ha.defaults={domEvents:!1,touchAction:gb,enable:!0,inputTarget:null,inputClass:null,preset:[[ea,{enable:!1}],[ca,{enable:!1},["rotate"]],[fa,{direction:Na}],[ba,{direction:Na},["swipe"]],[ga],[ga,{event:"doubletap",taps:2},["tap"]],[da]],cssProps:{userSelect:"none",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}};var ub=1,vb=2;ia.prototype={set:function(a){return la(this.options,a),a.touchAction&&this.touchAction.update(),a.inputTarget&&(this.input.destroy(),this.input.target=a.inputTarget,this.input.init()),this},stop:function(a){this.session.stopped=a?vb:ub},recognize:function(a){var b=this.session;if(!b.stopped){this.touchAction.preventDefaults(a);var c,d=this.recognizers,e=b.curRecognizer;(!e||e&&e.state&rb)&&(e=b.curRecognizer=null);for(var f=0;f<d.length;)c=d[f],b.stopped===vb||e&&c!=e&&!c.canRecognizeWith(e)?c.reset():c.recognize(a),!e&&c.state&(ob|pb|qb)&&(e=b.curRecognizer=c),f++}},get:function(a){if(a instanceof Y)return a;for(var b=this.recognizers,c=0;c<b.length;c++)if(b[c].options.event==a)return b[c];return null},add:function(a){if(f(a,"add",this))return this;var b=this.get(a.options.event);return b&&this.remove(b),this.recognizers.push(a),a.manager=this,this.touchAction.update(),a},remove:function(a){if(f(a,"remove",this))return this;if(a=this.get(a)){var b=this.recognizers,c=r(b,a);-1!==c&&(b.splice(c,1),this.touchAction.update())}return this},on:function(a,b){if(a!==d&&b!==d){var c=this.handlers;return g(q(a),function(a){c[a]=c[a]||[],c[a].push(b)}),this}},off:function(a,b){if(a!==d){var c=this.handlers;return g(q(a),function(a){b?c[a]&&c[a].splice(r(c[a],b),1):delete c[a]}),this}},emit:function(a,b){this.options.domEvents&&ka(a,b);var c=this.handlers[a]&&this.handlers[a].slice();if(c&&c.length){b.type=a,b.preventDefault=function(){b.srcEvent.preventDefault()};for(var d=0;d<c.length;)c[d](b),d++}},destroy:function(){this.element&&ja(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},la(ha,{INPUT_START:Ea,INPUT_MOVE:Fa,INPUT_END:Ga,INPUT_CANCEL:Ha,STATE_POSSIBLE:nb,STATE_BEGAN:ob,STATE_CHANGED:pb,STATE_ENDED:qb,STATE_RECOGNIZED:rb,STATE_CANCELLED:sb,STATE_FAILED:tb,DIRECTION_NONE:Ia,DIRECTION_LEFT:Ja,DIRECTION_RIGHT:Ka,DIRECTION_UP:La,DIRECTION_DOWN:Ma,DIRECTION_HORIZONTAL:Na,DIRECTION_VERTICAL:Oa,DIRECTION_ALL:Pa,Manager:ia,Input:x,TouchAction:V,TouchInput:P,MouseInput:L,PointerEventInput:M,TouchMouseInput:R,SingleTouchInput:N,Recognizer:Y,AttrRecognizer:aa,Tap:ga,Pan:ba,Swipe:fa,Pinch:ca,Rotate:ea,Press:da,on:m,off:n,each:g,merge:ta,extend:sa,assign:la,inherit:i,bindFn:j,prefixed:u});var wb="undefined"!=typeof a?a:"undefined"!=typeof self?self:{};wb.Hammer=ha,"function"==typeof define&&define.amd?define(function(){return ha}):"undefined"!=typeof module&&module.exports?module.exports=ha:a[c]=ha}(window,document,"Hammer");
//# sourceMappingURL=hammer.min.js.map
/*!
 * Vue.js v2.7.15
 * (c) 2014-2023 Evan You
 * Released under the MIT License.
 */
/*!
 * Vue.js v2.7.15
 * (c) 2014-2023 Evan You
 * Released under the MIT License.
 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).Vue=e()}(this,(function(){"use strict";var t=Object.freeze({}),e=Array.isArray;function n(t){return null==t}function r(t){return null!=t}function o(t){return!0===t}function i(t){return"string"==typeof t||"number"==typeof t||"symbol"==typeof t||"boolean"==typeof t}function a(t){return"function"==typeof t}function s(t){return null!==t&&"object"==typeof t}var c=Object.prototype.toString;function u(t){return"[object Object]"===c.call(t)}function l(t){var e=parseFloat(String(t));return e>=0&&Math.floor(e)===e&&isFinite(t)}function f(t){return r(t)&&"function"==typeof t.then&&"function"==typeof t.catch}function d(t){return null==t?"":Array.isArray(t)||u(t)&&t.toString===c?JSON.stringify(t,null,2):String(t)}function p(t){var e=parseFloat(t);return isNaN(e)?t:e}function v(t,e){for(var n=Object.create(null),r=t.split(","),o=0;o<r.length;o++)n[r[o]]=!0;return e?function(t){return n[t.toLowerCase()]}:function(t){return n[t]}}var h=v("slot,component",!0),m=v("key,ref,slot,slot-scope,is");function g(t,e){var n=t.length;if(n){if(e===t[n-1])return void(t.length=n-1);var r=t.indexOf(e);if(r>-1)return t.splice(r,1)}}var y=Object.prototype.hasOwnProperty;function _(t,e){return y.call(t,e)}function b(t){var e=Object.create(null);return function(n){return e[n]||(e[n]=t(n))}}var $=/-(\w)/g,w=b((function(t){return t.replace($,(function(t,e){return e?e.toUpperCase():""}))})),x=b((function(t){return t.charAt(0).toUpperCase()+t.slice(1)})),C=/\B([A-Z])/g,k=b((function(t){return t.replace(C,"-$1").toLowerCase()}));var S=Function.prototype.bind?function(t,e){return t.bind(e)}:function(t,e){function n(n){var r=arguments.length;return r?r>1?t.apply(e,arguments):t.call(e,n):t.call(e)}return n._length=t.length,n};function O(t,e){e=e||0;for(var n=t.length-e,r=new Array(n);n--;)r[n]=t[n+e];return r}function T(t,e){for(var n in e)t[n]=e[n];return t}function A(t){for(var e={},n=0;n<t.length;n++)t[n]&&T(e,t[n]);return e}function j(t,e,n){}var E=function(t,e,n){return!1},N=function(t){return t};function P(t,e){if(t===e)return!0;var n=s(t),r=s(e);if(!n||!r)return!n&&!r&&String(t)===String(e);try{var o=Array.isArray(t),i=Array.isArray(e);if(o&&i)return t.length===e.length&&t.every((function(t,n){return P(t,e[n])}));if(t instanceof Date&&e instanceof Date)return t.getTime()===e.getTime();if(o||i)return!1;var a=Object.keys(t),c=Object.keys(e);return a.length===c.length&&a.every((function(n){return P(t[n],e[n])}))}catch(t){return!1}}function D(t,e){for(var n=0;n<t.length;n++)if(P(t[n],e))return n;return-1}function M(t){var e=!1;return function(){e||(e=!0,t.apply(this,arguments))}}function I(t,e){return t===e?0===t&&1/t!=1/e:t==t||e==e}var L="data-server-rendered",R=["component","directive","filter"],F=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured","serverPrefetch","renderTracked","renderTriggered"],H={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:E,isReservedAttr:E,isUnknownElement:E,getTagNamespace:j,parsePlatformTagName:N,mustUseProp:E,async:!0,_lifecycleHooks:F},B=/a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;function U(t){var e=(t+"").charCodeAt(0);return 36===e||95===e}function z(t,e,n,r){Object.defineProperty(t,e,{value:n,enumerable:!!r,writable:!0,configurable:!0})}var V=new RegExp("[^".concat(B.source,".$_\\d]"));var K="__proto__"in{},J="undefined"!=typeof window,q=J&&window.navigator.userAgent.toLowerCase(),W=q&&/msie|trident/.test(q),Z=q&&q.indexOf("msie 9.0")>0,G=q&&q.indexOf("edge/")>0;q&&q.indexOf("android");var X=q&&/iphone|ipad|ipod|ios/.test(q);q&&/chrome\/\d+/.test(q),q&&/phantomjs/.test(q);var Y,Q=q&&q.match(/firefox\/(\d+)/),tt={}.watch,et=!1;if(J)try{var nt={};Object.defineProperty(nt,"passive",{get:function(){et=!0}}),window.addEventListener("test-passive",null,nt)}catch(t){}var rt=function(){return void 0===Y&&(Y=!J&&"undefined"!=typeof global&&(global.process&&"server"===global.process.env.VUE_ENV)),Y},ot=J&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function it(t){return"function"==typeof t&&/native code/.test(t.toString())}var at,st="undefined"!=typeof Symbol&&it(Symbol)&&"undefined"!=typeof Reflect&&it(Reflect.ownKeys);at="undefined"!=typeof Set&&it(Set)?Set:function(){function t(){this.set=Object.create(null)}return t.prototype.has=function(t){return!0===this.set[t]},t.prototype.add=function(t){this.set[t]=!0},t.prototype.clear=function(){this.set=Object.create(null)},t}();var ct=null;function ut(t){void 0===t&&(t=null),t||ct&&ct._scope.off(),ct=t,t&&t._scope.on()}var lt=function(){function t(t,e,n,r,o,i,a,s){this.tag=t,this.data=e,this.children=n,this.text=r,this.elm=o,this.ns=void 0,this.context=i,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=e&&e.key,this.componentOptions=a,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1}return Object.defineProperty(t.prototype,"child",{get:function(){return this.componentInstance},enumerable:!1,configurable:!0}),t}(),ft=function(t){void 0===t&&(t="");var e=new lt;return e.text=t,e.isComment=!0,e};function dt(t){return new lt(void 0,void 0,void 0,String(t))}function pt(t){var e=new lt(t.tag,t.data,t.children&&t.children.slice(),t.text,t.elm,t.context,t.componentOptions,t.asyncFactory);return e.ns=t.ns,e.isStatic=t.isStatic,e.key=t.key,e.isComment=t.isComment,e.fnContext=t.fnContext,e.fnOptions=t.fnOptions,e.fnScopeId=t.fnScopeId,e.asyncMeta=t.asyncMeta,e.isCloned=!0,e}var vt=0,ht=[],mt=function(){function t(){this._pending=!1,this.id=vt++,this.subs=[]}return t.prototype.addSub=function(t){this.subs.push(t)},t.prototype.removeSub=function(t){this.subs[this.subs.indexOf(t)]=null,this._pending||(this._pending=!0,ht.push(this))},t.prototype.depend=function(e){t.target&&t.target.addDep(this)},t.prototype.notify=function(t){for(var e=this.subs.filter((function(t){return t})),n=0,r=e.length;n<r;n++){e[n].update()}},t}();mt.target=null;var gt=[];function yt(t){gt.push(t),mt.target=t}function _t(){gt.pop(),mt.target=gt[gt.length-1]}var bt=Array.prototype,$t=Object.create(bt);["push","pop","shift","unshift","splice","sort","reverse"].forEach((function(t){var e=bt[t];z($t,t,(function(){for(var n=[],r=0;r<arguments.length;r++)n[r]=arguments[r];var o,i=e.apply(this,n),a=this.__ob__;switch(t){case"push":case"unshift":o=n;break;case"splice":o=n.slice(2)}return o&&a.observeArray(o),a.dep.notify(),i}))}));var wt=Object.getOwnPropertyNames($t),xt={},Ct=!0;function kt(t){Ct=t}var St={notify:j,depend:j,addSub:j,removeSub:j},Ot=function(){function t(t,n,r){if(void 0===n&&(n=!1),void 0===r&&(r=!1),this.value=t,this.shallow=n,this.mock=r,this.dep=r?St:new mt,this.vmCount=0,z(t,"__ob__",this),e(t)){if(!r)if(K)t.__proto__=$t;else for(var o=0,i=wt.length;o<i;o++){z(t,s=wt[o],$t[s])}n||this.observeArray(t)}else{var a=Object.keys(t);for(o=0;o<a.length;o++){var s;At(t,s=a[o],xt,void 0,n,r)}}}return t.prototype.observeArray=function(t){for(var e=0,n=t.length;e<n;e++)Tt(t[e],!1,this.mock)},t}();function Tt(t,n,r){return t&&_(t,"__ob__")&&t.__ob__ instanceof Ot?t.__ob__:!Ct||!r&&rt()||!e(t)&&!u(t)||!Object.isExtensible(t)||t.__v_skip||Ft(t)||t instanceof lt?void 0:new Ot(t,n,r)}function At(t,n,r,o,i,a){var s=new mt,c=Object.getOwnPropertyDescriptor(t,n);if(!c||!1!==c.configurable){var u=c&&c.get,l=c&&c.set;u&&!l||r!==xt&&2!==arguments.length||(r=t[n]);var f=!i&&Tt(r,!1,a);return Object.defineProperty(t,n,{enumerable:!0,configurable:!0,get:function(){var n=u?u.call(t):r;return mt.target&&(s.depend(),f&&(f.dep.depend(),e(n)&&Nt(n))),Ft(n)&&!i?n.value:n},set:function(e){var n=u?u.call(t):r;if(I(n,e)){if(l)l.call(t,e);else{if(u)return;if(!i&&Ft(n)&&!Ft(e))return void(n.value=e);r=e}f=!i&&Tt(e,!1,a),s.notify()}}}),s}}function jt(t,n,r){if(!Lt(t)){var o=t.__ob__;return e(t)&&l(n)?(t.length=Math.max(t.length,n),t.splice(n,1,r),o&&!o.shallow&&o.mock&&Tt(r,!1,!0),r):n in t&&!(n in Object.prototype)?(t[n]=r,r):t._isVue||o&&o.vmCount?r:o?(At(o.value,n,r,void 0,o.shallow,o.mock),o.dep.notify(),r):(t[n]=r,r)}}function Et(t,n){if(e(t)&&l(n))t.splice(n,1);else{var r=t.__ob__;t._isVue||r&&r.vmCount||Lt(t)||_(t,n)&&(delete t[n],r&&r.dep.notify())}}function Nt(t){for(var n=void 0,r=0,o=t.length;r<o;r++)(n=t[r])&&n.__ob__&&n.__ob__.dep.depend(),e(n)&&Nt(n)}function Pt(t){return Dt(t,!0),z(t,"__v_isShallow",!0),t}function Dt(t,e){Lt(t)||Tt(t,e,rt())}function Mt(t){return Lt(t)?Mt(t.__v_raw):!(!t||!t.__ob__)}function It(t){return!(!t||!t.__v_isShallow)}function Lt(t){return!(!t||!t.__v_isReadonly)}var Rt="__v_isRef";function Ft(t){return!(!t||!0!==t.__v_isRef)}function Ht(t,e){if(Ft(t))return t;var n={};return z(n,Rt,!0),z(n,"__v_isShallow",e),z(n,"dep",At(n,"value",t,null,e,rt())),n}function Bt(t,e,n){Object.defineProperty(t,n,{enumerable:!0,configurable:!0,get:function(){var t=e[n];if(Ft(t))return t.value;var r=t&&t.__ob__;return r&&r.dep.depend(),t},set:function(t){var r=e[n];Ft(r)&&!Ft(t)?r.value=t:e[n]=t}})}function Ut(t,e,n){var r=t[e];if(Ft(r))return r;var o={get value(){var r=t[e];return void 0===r?n:r},set value(n){t[e]=n}};return z(o,Rt,!0),o}function zt(t){return Vt(t,!1)}function Vt(t,e){if(!u(t))return t;if(Lt(t))return t;var n=e?"__v_rawToShallowReadonly":"__v_rawToReadonly",r=t[n];if(r)return r;var o=Object.create(Object.getPrototypeOf(t));z(t,n,o),z(o,"__v_isReadonly",!0),z(o,"__v_raw",t),Ft(t)&&z(o,Rt,!0),(e||It(t))&&z(o,"__v_isShallow",!0);for(var i=Object.keys(t),a=0;a<i.length;a++)Kt(o,t,i[a],e);return o}function Kt(t,e,n,r){Object.defineProperty(t,n,{enumerable:!0,configurable:!0,get:function(){var t=e[n];return r||!u(t)?t:zt(t)},set:function(){}})}var Jt=b((function(t){var e="&"===t.charAt(0),n="~"===(t=e?t.slice(1):t).charAt(0),r="!"===(t=n?t.slice(1):t).charAt(0);return{name:t=r?t.slice(1):t,once:n,capture:r,passive:e}}));function qt(t,n){function r(){var t=r.fns;if(!e(t))return pn(t,null,arguments,n,"v-on handler");for(var o=t.slice(),i=0;i<o.length;i++)pn(o[i],null,arguments,n,"v-on handler")}return r.fns=t,r}function Wt(t,e,r,i,a,s){var c,u,l,f;for(c in t)u=t[c],l=e[c],f=Jt(c),n(u)||(n(l)?(n(u.fns)&&(u=t[c]=qt(u,s)),o(f.once)&&(u=t[c]=a(f.name,u,f.capture)),r(f.name,u,f.capture,f.passive,f.params)):u!==l&&(l.fns=u,t[c]=l));for(c in e)n(t[c])&&i((f=Jt(c)).name,e[c],f.capture)}function Zt(t,e,i){var a;t instanceof lt&&(t=t.data.hook||(t.data.hook={}));var s=t[e];function c(){i.apply(this,arguments),g(a.fns,c)}n(s)?a=qt([c]):r(s.fns)&&o(s.merged)?(a=s).fns.push(c):a=qt([s,c]),a.merged=!0,t[e]=a}function Gt(t,e,n,o,i){if(r(e)){if(_(e,n))return t[n]=e[n],i||delete e[n],!0;if(_(e,o))return t[n]=e[o],i||delete e[o],!0}return!1}function Xt(t){return i(t)?[dt(t)]:e(t)?Qt(t):void 0}function Yt(t){return r(t)&&r(t.text)&&!1===t.isComment}function Qt(t,a){var s,c,u,l,f=[];for(s=0;s<t.length;s++)n(c=t[s])||"boolean"==typeof c||(l=f[u=f.length-1],e(c)?c.length>0&&(Yt((c=Qt(c,"".concat(a||"","_").concat(s)))[0])&&Yt(l)&&(f[u]=dt(l.text+c[0].text),c.shift()),f.push.apply(f,c)):i(c)?Yt(l)?f[u]=dt(l.text+c):""!==c&&f.push(dt(c)):Yt(c)&&Yt(l)?f[u]=dt(l.text+c.text):(o(t._isVList)&&r(c.tag)&&n(c.key)&&r(a)&&(c.key="__vlist".concat(a,"_").concat(s,"__")),f.push(c)));return f}function te(t,n,c,u,l,f){return(e(c)||i(c))&&(l=u,u=c,c=void 0),o(f)&&(l=2),function(t,n,o,i,c){if(r(o)&&r(o.__ob__))return ft();r(o)&&r(o.is)&&(n=o.is);if(!n)return ft();e(i)&&a(i[0])&&((o=o||{}).scopedSlots={default:i[0]},i.length=0);2===c?i=Xt(i):1===c&&(i=function(t){for(var n=0;n<t.length;n++)if(e(t[n]))return Array.prototype.concat.apply([],t);return t}(i));var u,l;if("string"==typeof n){var f=void 0;l=t.$vnode&&t.$vnode.ns||H.getTagNamespace(n),u=H.isReservedTag(n)?new lt(H.parsePlatformTagName(n),o,i,void 0,void 0,t):o&&o.pre||!r(f=_r(t.$options,"components",n))?new lt(n,o,i,void 0,void 0,t):ur(f,o,t,i,n)}else u=ur(n,o,t,i);return e(u)?u:r(u)?(r(l)&&ee(u,l),r(o)&&function(t){s(t.style)&&Un(t.style);s(t.class)&&Un(t.class)}(o),u):ft()}(t,n,c,u,l)}function ee(t,e,i){if(t.ns=e,"foreignObject"===t.tag&&(e=void 0,i=!0),r(t.children))for(var a=0,s=t.children.length;a<s;a++){var c=t.children[a];r(c.tag)&&(n(c.ns)||o(i)&&"svg"!==c.tag)&&ee(c,e,i)}}function ne(t,n){var o,i,a,c,u=null;if(e(t)||"string"==typeof t)for(u=new Array(t.length),o=0,i=t.length;o<i;o++)u[o]=n(t[o],o);else if("number"==typeof t)for(u=new Array(t),o=0;o<t;o++)u[o]=n(o+1,o);else if(s(t))if(st&&t[Symbol.iterator]){u=[];for(var l=t[Symbol.iterator](),f=l.next();!f.done;)u.push(n(f.value,u.length)),f=l.next()}else for(a=Object.keys(t),u=new Array(a.length),o=0,i=a.length;o<i;o++)c=a[o],u[o]=n(t[c],c,o);return r(u)||(u=[]),u._isVList=!0,u}function re(t,e,n,r){var o,i=this.$scopedSlots[t];i?(n=n||{},r&&(n=T(T({},r),n)),o=i(n)||(a(e)?e():e)):o=this.$slots[t]||(a(e)?e():e);var s=n&&n.slot;return s?this.$createElement("template",{slot:s},o):o}function oe(t){return _r(this.$options,"filters",t)||N}function ie(t,n){return e(t)?-1===t.indexOf(n):t!==n}function ae(t,e,n,r,o){var i=H.keyCodes[e]||n;return o&&r&&!H.keyCodes[e]?ie(o,r):i?ie(i,t):r?k(r)!==e:void 0===t}function se(t,n,r,o,i){if(r)if(s(r)){e(r)&&(r=A(r));var a=void 0,c=function(e){if("class"===e||"style"===e||m(e))a=t;else{var s=t.attrs&&t.attrs.type;a=o||H.mustUseProp(n,s,e)?t.domProps||(t.domProps={}):t.attrs||(t.attrs={})}var c=w(e),u=k(e);c in a||u in a||(a[e]=r[e],i&&((t.on||(t.on={}))["update:".concat(e)]=function(t){r[e]=t}))};for(var u in r)c(u)}else;return t}function ce(t,e){var n=this._staticTrees||(this._staticTrees=[]),r=n[t];return r&&!e||le(r=n[t]=this.$options.staticRenderFns[t].call(this._renderProxy,this._c,this),"__static__".concat(t),!1),r}function ue(t,e,n){return le(t,"__once__".concat(e).concat(n?"_".concat(n):""),!0),t}function le(t,n,r){if(e(t))for(var o=0;o<t.length;o++)t[o]&&"string"!=typeof t[o]&&fe(t[o],"".concat(n,"_").concat(o),r);else fe(t,n,r)}function fe(t,e,n){t.isStatic=!0,t.key=e,t.isOnce=n}function de(t,e){if(e)if(u(e)){var n=t.on=t.on?T({},t.on):{};for(var r in e){var o=n[r],i=e[r];n[r]=o?[].concat(o,i):i}}else;return t}function pe(t,n,r,o){n=n||{$stable:!r};for(var i=0;i<t.length;i++){var a=t[i];e(a)?pe(a,n,r):a&&(a.proxy&&(a.fn.proxy=!0),n[a.key]=a.fn)}return o&&(n.$key=o),n}function ve(t,e){for(var n=0;n<e.length;n+=2){var r=e[n];"string"==typeof r&&r&&(t[e[n]]=e[n+1])}return t}function he(t,e){return"string"==typeof t?e+t:t}function me(t){t._o=ue,t._n=p,t._s=d,t._l=ne,t._t=re,t._q=P,t._i=D,t._m=ce,t._f=oe,t._k=ae,t._b=se,t._v=dt,t._e=ft,t._u=pe,t._g=de,t._d=ve,t._p=he}function ge(t,e){if(!t||!t.length)return{};for(var n={},r=0,o=t.length;r<o;r++){var i=t[r],a=i.data;if(a&&a.attrs&&a.attrs.slot&&delete a.attrs.slot,i.context!==e&&i.fnContext!==e||!a||null==a.slot)(n.default||(n.default=[])).push(i);else{var s=a.slot,c=n[s]||(n[s]=[]);"template"===i.tag?c.push.apply(c,i.children||[]):c.push(i)}}for(var u in n)n[u].every(ye)&&delete n[u];return n}function ye(t){return t.isComment&&!t.asyncFactory||" "===t.text}function _e(t){return t.isComment&&t.asyncFactory}function be(e,n,r,o){var i,a=Object.keys(r).length>0,s=n?!!n.$stable:!a,c=n&&n.$key;if(n){if(n._normalized)return n._normalized;if(s&&o&&o!==t&&c===o.$key&&!a&&!o.$hasNormal)return o;for(var u in i={},n)n[u]&&"$"!==u[0]&&(i[u]=$e(e,r,u,n[u]))}else i={};for(var l in r)l in i||(i[l]=we(r,l));return n&&Object.isExtensible(n)&&(n._normalized=i),z(i,"$stable",s),z(i,"$key",c),z(i,"$hasNormal",a),i}function $e(t,n,r,o){var i=function(){var n=ct;ut(t);var r=arguments.length?o.apply(null,arguments):o({}),i=(r=r&&"object"==typeof r&&!e(r)?[r]:Xt(r))&&r[0];return ut(n),r&&(!i||1===r.length&&i.isComment&&!_e(i))?void 0:r};return o.proxy&&Object.defineProperty(n,r,{get:i,enumerable:!0,configurable:!0}),i}function we(t,e){return function(){return t[e]}}function xe(e){return{get attrs(){if(!e._attrsProxy){var n=e._attrsProxy={};z(n,"_v_attr_proxy",!0),Ce(n,e.$attrs,t,e,"$attrs")}return e._attrsProxy},get listeners(){e._listenersProxy||Ce(e._listenersProxy={},e.$listeners,t,e,"$listeners");return e._listenersProxy},get slots(){return function(t){t._slotsProxy||Se(t._slotsProxy={},t.$scopedSlots);return t._slotsProxy}(e)},emit:S(e.$emit,e),expose:function(t){t&&Object.keys(t).forEach((function(n){return Bt(e,t,n)}))}}}function Ce(t,e,n,r,o){var i=!1;for(var a in e)a in t?e[a]!==n[a]&&(i=!0):(i=!0,ke(t,a,r,o));for(var a in t)a in e||(i=!0,delete t[a]);return i}function ke(t,e,n,r){Object.defineProperty(t,e,{enumerable:!0,configurable:!0,get:function(){return n[r][e]}})}function Se(t,e){for(var n in e)t[n]=e[n];for(var n in t)n in e||delete t[n]}function Oe(){var t=ct;return t._setupContext||(t._setupContext=xe(t))}var Te,Ae,je=null;function Ee(t,e){return(t.__esModule||st&&"Module"===t[Symbol.toStringTag])&&(t=t.default),s(t)?e.extend(t):t}function Ne(t){if(e(t))for(var n=0;n<t.length;n++){var o=t[n];if(r(o)&&(r(o.componentOptions)||_e(o)))return o}}function Pe(t,e){Te.$on(t,e)}function De(t,e){Te.$off(t,e)}function Me(t,e){var n=Te;return function r(){var o=e.apply(null,arguments);null!==o&&n.$off(t,r)}}function Ie(t,e,n){Te=t,Wt(e,n||{},Pe,De,Me,t),Te=void 0}var Le=function(){function t(t){void 0===t&&(t=!1),this.detached=t,this.active=!0,this.effects=[],this.cleanups=[],this.parent=Ae,!t&&Ae&&(this.index=(Ae.scopes||(Ae.scopes=[])).push(this)-1)}return t.prototype.run=function(t){if(this.active){var e=Ae;try{return Ae=this,t()}finally{Ae=e}}},t.prototype.on=function(){Ae=this},t.prototype.off=function(){Ae=this.parent},t.prototype.stop=function(t){if(this.active){var e=void 0,n=void 0;for(e=0,n=this.effects.length;e<n;e++)this.effects[e].teardown();for(e=0,n=this.cleanups.length;e<n;e++)this.cleanups[e]();if(this.scopes)for(e=0,n=this.scopes.length;e<n;e++)this.scopes[e].stop(!0);if(!this.detached&&this.parent&&!t){var r=this.parent.scopes.pop();r&&r!==this&&(this.parent.scopes[this.index]=r,r.index=this.index)}this.parent=void 0,this.active=!1}},t}();function Re(){return Ae}var Fe=null;function He(t){var e=Fe;return Fe=t,function(){Fe=e}}function Be(t){for(;t&&(t=t.$parent);)if(t._inactive)return!0;return!1}function Ue(t,e){if(e){if(t._directInactive=!1,Be(t))return}else if(t._directInactive)return;if(t._inactive||null===t._inactive){t._inactive=!1;for(var n=0;n<t.$children.length;n++)Ue(t.$children[n]);Ve(t,"activated")}}function ze(t,e){if(!(e&&(t._directInactive=!0,Be(t))||t._inactive)){t._inactive=!0;for(var n=0;n<t.$children.length;n++)ze(t.$children[n]);Ve(t,"deactivated")}}function Ve(t,e,n,r){void 0===r&&(r=!0),yt();var o=ct,i=Re();r&&ut(t);var a=t.$options[e],s="".concat(e," hook");if(a)for(var c=0,u=a.length;c<u;c++)pn(a[c],t,n||null,t,s);t._hasHookEvent&&t.$emit("hook:"+e),r&&(ut(o),i&&i.on()),_t()}var Ke=[],Je=[],qe={},We=!1,Ze=!1,Ge=0;var Xe=0,Ye=Date.now;if(J&&!W){var Qe=window.performance;Qe&&"function"==typeof Qe.now&&Ye()>document.createEvent("Event").timeStamp&&(Ye=function(){return Qe.now()})}var tn=function(t,e){if(t.post){if(!e.post)return 1}else if(e.post)return-1;return t.id-e.id};function en(){var t,e;for(Xe=Ye(),Ze=!0,Ke.sort(tn),Ge=0;Ge<Ke.length;Ge++)(t=Ke[Ge]).before&&t.before(),e=t.id,qe[e]=null,t.run();var n=Je.slice(),r=Ke.slice();Ge=Ke.length=Je.length=0,qe={},We=Ze=!1,function(t){for(var e=0;e<t.length;e++)t[e]._inactive=!0,Ue(t[e],!0)}(n),function(t){var e=t.length;for(;e--;){var n=t[e],r=n.vm;r&&r._watcher===n&&r._isMounted&&!r._isDestroyed&&Ve(r,"updated")}}(r),function(){for(var t=0;t<ht.length;t++){var e=ht[t];e.subs=e.subs.filter((function(t){return t})),e._pending=!1}ht.length=0}(),ot&&H.devtools&&ot.emit("flush")}function nn(t){var e=t.id;if(null==qe[e]&&(t!==mt.target||!t.noRecurse)){if(qe[e]=!0,Ze){for(var n=Ke.length-1;n>Ge&&Ke[n].id>t.id;)n--;Ke.splice(n+1,0,t)}else Ke.push(t);We||(We=!0,kn(en))}}var rn="watcher",on="".concat(rn," callback"),an="".concat(rn," getter"),sn="".concat(rn," cleanup");function cn(t,e){return ln(t,null,{flush:"post"})}var un={};function ln(n,r,o){var i=void 0===o?t:o,s=i.immediate,c=i.deep,u=i.flush,l=void 0===u?"pre":u;i.onTrack,i.onTrigger;var f,d,p=ct,v=function(t,e,n){return void 0===n&&(n=null),pn(t,null,n,p,e)},h=!1,m=!1;if(Ft(n)?(f=function(){return n.value},h=It(n)):Mt(n)?(f=function(){return n.__ob__.dep.depend(),n},c=!0):e(n)?(m=!0,h=n.some((function(t){return Mt(t)||It(t)})),f=function(){return n.map((function(t){return Ft(t)?t.value:Mt(t)?Un(t):a(t)?v(t,an):void 0}))}):f=a(n)?r?function(){return v(n,an)}:function(){if(!p||!p._isDestroyed)return d&&d(),v(n,rn,[y])}:j,r&&c){var g=f;f=function(){return Un(g())}}var y=function(t){d=_.onStop=function(){v(t,sn)}};if(rt())return y=j,r?s&&v(r,on,[f(),m?[]:void 0,y]):f(),j;var _=new Kn(ct,f,j,{lazy:!0});_.noRecurse=!r;var b=m?[]:un;return _.run=function(){if(_.active)if(r){var t=_.get();(c||h||(m?t.some((function(t,e){return I(t,b[e])})):I(t,b)))&&(d&&d(),v(r,on,[t,b===un?void 0:b,y]),b=t)}else _.get()},"sync"===l?_.update=_.run:"post"===l?(_.post=!0,_.update=function(){return nn(_)}):_.update=function(){if(p&&p===ct&&!p._isMounted){var t=p._preWatchers||(p._preWatchers=[]);t.indexOf(_)<0&&t.push(_)}else nn(_)},r?s?_.run():b=_.get():"post"===l&&p?p.$once("hook:mounted",(function(){return _.get()})):_.get(),function(){_.teardown()}}function fn(t){var e=t._provided,n=t.$parent&&t.$parent._provided;return n===e?t._provided=Object.create(n):e}function dn(t,e,n){yt();try{if(e)for(var r=e;r=r.$parent;){var o=r.$options.errorCaptured;if(o)for(var i=0;i<o.length;i++)try{if(!1===o[i].call(r,t,e,n))return}catch(t){vn(t,r,"errorCaptured hook")}}vn(t,e,n)}finally{_t()}}function pn(t,e,n,r,o){var i;try{(i=n?t.apply(e,n):t.call(e))&&!i._isVue&&f(i)&&!i._handled&&(i.catch((function(t){return dn(t,r,o+" (Promise/async)")})),i._handled=!0)}catch(t){dn(t,r,o)}return i}function vn(t,e,n){if(H.errorHandler)try{return H.errorHandler.call(null,t,e,n)}catch(e){e!==t&&hn(e)}hn(t)}function hn(t,e,n){if(!J||"undefined"==typeof console)throw t;console.error(t)}var mn,gn=!1,yn=[],_n=!1;function bn(){_n=!1;var t=yn.slice(0);yn.length=0;for(var e=0;e<t.length;e++)t[e]()}if("undefined"!=typeof Promise&&it(Promise)){var $n=Promise.resolve();mn=function(){$n.then(bn),X&&setTimeout(j)},gn=!0}else if(W||"undefined"==typeof MutationObserver||!it(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())mn="undefined"!=typeof setImmediate&&it(setImmediate)?function(){setImmediate(bn)}:function(){setTimeout(bn,0)};else{var wn=1,xn=new MutationObserver(bn),Cn=document.createTextNode(String(wn));xn.observe(Cn,{characterData:!0}),mn=function(){wn=(wn+1)%2,Cn.data=String(wn)},gn=!0}function kn(t,e){var n;if(yn.push((function(){if(t)try{t.call(e)}catch(t){dn(t,e,"nextTick")}else n&&n(e)})),_n||(_n=!0,mn()),!t&&"undefined"!=typeof Promise)return new Promise((function(t){n=t}))}function Sn(t){return function(e,n){if(void 0===n&&(n=ct),n)return function(t,e,n){var r=t.$options;r[e]=hr(r[e],n)}(n,t,e)}}var On=Sn("beforeMount"),Tn=Sn("mounted"),An=Sn("beforeUpdate"),jn=Sn("updated"),En=Sn("beforeDestroy"),Nn=Sn("destroyed"),Pn=Sn("activated"),Dn=Sn("deactivated"),Mn=Sn("serverPrefetch"),In=Sn("renderTracked"),Ln=Sn("renderTriggered"),Rn=Sn("errorCaptured");var Fn="2.7.15";var Hn=Object.freeze({__proto__:null,version:Fn,defineComponent:function(t){return t},ref:function(t){return Ht(t,!1)},shallowRef:function(t){return Ht(t,!0)},isRef:Ft,toRef:Ut,toRefs:function(t){var n=e(t)?new Array(t.length):{};for(var r in t)n[r]=Ut(t,r);return n},unref:function(t){return Ft(t)?t.value:t},proxyRefs:function(t){if(Mt(t))return t;for(var e={},n=Object.keys(t),r=0;r<n.length;r++)Bt(e,t,n[r]);return e},customRef:function(t){var e=new mt,n=t((function(){e.depend()}),(function(){e.notify()})),r=n.get,o=n.set,i={get value(){return r()},set value(t){o(t)}};return z(i,Rt,!0),i},triggerRef:function(t){t.dep&&t.dep.notify()},reactive:function(t){return Dt(t,!1),t},isReactive:Mt,isReadonly:Lt,isShallow:It,isProxy:function(t){return Mt(t)||Lt(t)},shallowReactive:Pt,markRaw:function(t){return Object.isExtensible(t)&&z(t,"__v_skip",!0),t},toRaw:function t(e){var n=e&&e.__v_raw;return n?t(n):e},readonly:zt,shallowReadonly:function(t){return Vt(t,!0)},computed:function(t,e){var n,r,o=a(t);o?(n=t,r=j):(n=t.get,r=t.set);var i=rt()?null:new Kn(ct,n,j,{lazy:!0}),s={effect:i,get value(){return i?(i.dirty&&i.evaluate(),mt.target&&i.depend(),i.value):n()},set value(t){r(t)}};return z(s,Rt,!0),z(s,"__v_isReadonly",o),s},watch:function(t,e,n){return ln(t,e,n)},watchEffect:function(t,e){return ln(t,null,e)},watchPostEffect:cn,watchSyncEffect:function(t,e){return ln(t,null,{flush:"sync"})},EffectScope:Le,effectScope:function(t){return new Le(t)},onScopeDispose:function(t){Ae&&Ae.cleanups.push(t)},getCurrentScope:Re,provide:function(t,e){ct&&(fn(ct)[t]=e)},inject:function(t,e,n){void 0===n&&(n=!1);var r=ct;if(r){var o=r.$parent&&r.$parent._provided;if(o&&t in o)return o[t];if(arguments.length>1)return n&&a(e)?e.call(r):e}},h:function(t,e,n){return te(ct,t,e,n,2,!0)},getCurrentInstance:function(){return ct&&{proxy:ct}},useSlots:function(){return Oe().slots},useAttrs:function(){return Oe().attrs},useListeners:function(){return Oe().listeners},mergeDefaults:function(t,n){var r=e(t)?t.reduce((function(t,e){return t[e]={},t}),{}):t;for(var o in n){var i=r[o];i?e(i)||a(i)?r[o]={type:i,default:n[o]}:i.default=n[o]:null===i&&(r[o]={default:n[o]})}return r},nextTick:kn,set:jt,del:Et,useCssModule:function(e){return t},useCssVars:function(t){if(J){var e=ct;e&&cn((function(){var n=e.$el,r=t(e,e._setupProxy);if(n&&1===n.nodeType){var o=n.style;for(var i in r)o.setProperty("--".concat(i),r[i])}}))}},defineAsyncComponent:function(t){a(t)&&(t={loader:t});var e=t.loader,n=t.loadingComponent,r=t.errorComponent,o=t.delay,i=void 0===o?200:o,s=t.timeout;t.suspensible;var c=t.onError,u=null,l=0,f=function(){var t;return u||(t=u=e().catch((function(t){if(t=t instanceof Error?t:new Error(String(t)),c)return new Promise((function(e,n){c(t,(function(){return e((l++,u=null,f()))}),(function(){return n(t)}),l+1)}));throw t})).then((function(e){return t!==u&&u?u:(e&&(e.__esModule||"Module"===e[Symbol.toStringTag])&&(e=e.default),e)})))};return function(){return{component:f(),delay:i,timeout:s,error:r,loading:n}}},onBeforeMount:On,onMounted:Tn,onBeforeUpdate:An,onUpdated:jn,onBeforeUnmount:En,onUnmounted:Nn,onActivated:Pn,onDeactivated:Dn,onServerPrefetch:Mn,onRenderTracked:In,onRenderTriggered:Ln,onErrorCaptured:function(t,e){void 0===e&&(e=ct),Rn(t,e)}}),Bn=new at;function Un(t){return zn(t,Bn),Bn.clear(),t}function zn(t,n){var r,o,i=e(t);if(!(!i&&!s(t)||t.__v_skip||Object.isFrozen(t)||t instanceof lt)){if(t.__ob__){var a=t.__ob__.dep.id;if(n.has(a))return;n.add(a)}if(i)for(r=t.length;r--;)zn(t[r],n);else if(Ft(t))zn(t.value,n);else for(r=(o=Object.keys(t)).length;r--;)zn(t[o[r]],n)}}var Vn=0,Kn=function(){function t(t,e,n,r,o){!function(t,e){void 0===e&&(e=Ae),e&&e.active&&e.effects.push(t)}(this,Ae&&!Ae._vm?Ae:t?t._scope:void 0),(this.vm=t)&&o&&(t._watcher=this),r?(this.deep=!!r.deep,this.user=!!r.user,this.lazy=!!r.lazy,this.sync=!!r.sync,this.before=r.before):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++Vn,this.active=!0,this.post=!1,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new at,this.newDepIds=new at,this.expression="",a(e)?this.getter=e:(this.getter=function(t){if(!V.test(t)){var e=t.split(".");return function(t){for(var n=0;n<e.length;n++){if(!t)return;t=t[e[n]]}return t}}}(e),this.getter||(this.getter=j)),this.value=this.lazy?void 0:this.get()}return t.prototype.get=function(){var t;yt(this);var e=this.vm;try{t=this.getter.call(e,e)}catch(t){if(!this.user)throw t;dn(t,e,'getter for watcher "'.concat(this.expression,'"'))}finally{this.deep&&Un(t),_t(),this.cleanupDeps()}return t},t.prototype.addDep=function(t){var e=t.id;this.newDepIds.has(e)||(this.newDepIds.add(e),this.newDeps.push(t),this.depIds.has(e)||t.addSub(this))},t.prototype.cleanupDeps=function(){for(var t=this.deps.length;t--;){var e=this.deps[t];this.newDepIds.has(e.id)||e.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},t.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():nn(this)},t.prototype.run=function(){if(this.active){var t=this.get();if(t!==this.value||s(t)||this.deep){var e=this.value;if(this.value=t,this.user){var n='callback for watcher "'.concat(this.expression,'"');pn(this.cb,this.vm,[t,e],this.vm,n)}else this.cb.call(this.vm,t,e)}}},t.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},t.prototype.depend=function(){for(var t=this.deps.length;t--;)this.deps[t].depend()},t.prototype.teardown=function(){if(this.vm&&!this.vm._isBeingDestroyed&&g(this.vm._scope.effects,this),this.active){for(var t=this.deps.length;t--;)this.deps[t].removeSub(this);this.active=!1,this.onStop&&this.onStop()}},t}(),Jn={enumerable:!0,configurable:!0,get:j,set:j};function qn(t,e,n){Jn.get=function(){return this[e][n]},Jn.set=function(t){this[e][n]=t},Object.defineProperty(t,n,Jn)}function Wn(t){var n=t.$options;if(n.props&&function(t,e){var n=t.$options.propsData||{},r=t._props=Pt({}),o=t.$options._propKeys=[];t.$parent&&kt(!1);var i=function(i){o.push(i);var a=br(i,e,n,t);At(r,i,a),i in t||qn(t,"_props",i)};for(var a in e)i(a);kt(!0)}(t,n.props),function(t){var e=t.$options,n=e.setup;if(n){var r=t._setupContext=xe(t);ut(t),yt();var o=pn(n,null,[t._props||Pt({}),r],t,"setup");if(_t(),ut(),a(o))e.render=o;else if(s(o))if(t._setupState=o,o.__sfc){var i=t._setupProxy={};for(var c in o)"__sfc"!==c&&Bt(i,o,c)}else for(var c in o)U(c)||Bt(t,o,c)}}(t),n.methods&&function(t,e){for(var n in t.$options.props,e)t[n]="function"!=typeof e[n]?j:S(e[n],t)}(t,n.methods),n.data)!function(t){var e=t.$options.data;u(e=t._data=a(e)?function(t,e){yt();try{return t.call(e,e)}catch(t){return dn(t,e,"data()"),{}}finally{_t()}}(e,t):e||{})||(e={});var n=Object.keys(e),r=t.$options.props;t.$options.methods;var o=n.length;for(;o--;){var i=n[o];r&&_(r,i)||U(i)||qn(t,"_data",i)}var s=Tt(e);s&&s.vmCount++}(t);else{var r=Tt(t._data={});r&&r.vmCount++}n.computed&&function(t,e){var n=t._computedWatchers=Object.create(null),r=rt();for(var o in e){var i=e[o],s=a(i)?i:i.get;r||(n[o]=new Kn(t,s||j,j,Zn)),o in t||Gn(t,o,i)}}(t,n.computed),n.watch&&n.watch!==tt&&function(t,n){for(var r in n){var o=n[r];if(e(o))for(var i=0;i<o.length;i++)Qn(t,r,o[i]);else Qn(t,r,o)}}(t,n.watch)}var Zn={lazy:!0};function Gn(t,e,n){var r=!rt();a(n)?(Jn.get=r?Xn(e):Yn(n),Jn.set=j):(Jn.get=n.get?r&&!1!==n.cache?Xn(e):Yn(n.get):j,Jn.set=n.set||j),Object.defineProperty(t,e,Jn)}function Xn(t){return function(){var e=this._computedWatchers&&this._computedWatchers[t];if(e)return e.dirty&&e.evaluate(),mt.target&&e.depend(),e.value}}function Yn(t){return function(){return t.call(this,this)}}function Qn(t,e,n,r){return u(n)&&(r=n,n=n.handler),"string"==typeof n&&(n=t[n]),t.$watch(e,n,r)}function tr(t,e){if(t){for(var n=Object.create(null),r=st?Reflect.ownKeys(t):Object.keys(t),o=0;o<r.length;o++){var i=r[o];if("__ob__"!==i){var s=t[i].from;if(s in e._provided)n[i]=e._provided[s];else if("default"in t[i]){var c=t[i].default;n[i]=a(c)?c.call(e):c}}}return n}}var er=0;function nr(t){var e=t.options;if(t.super){var n=nr(t.super);if(n!==t.superOptions){t.superOptions=n;var r=function(t){var e,n=t.options,r=t.sealedOptions;for(var o in n)n[o]!==r[o]&&(e||(e={}),e[o]=n[o]);return e}(t);r&&T(t.extendOptions,r),(e=t.options=yr(n,t.extendOptions)).name&&(e.components[e.name]=t)}}return e}function rr(n,r,i,a,s){var c,u=this,l=s.options;_(a,"_uid")?(c=Object.create(a))._original=a:(c=a,a=a._original);var f=o(l._compiled),d=!f;this.data=n,this.props=r,this.children=i,this.parent=a,this.listeners=n.on||t,this.injections=tr(l.inject,a),this.slots=function(){return u.$slots||be(a,n.scopedSlots,u.$slots=ge(i,a)),u.$slots},Object.defineProperty(this,"scopedSlots",{enumerable:!0,get:function(){return be(a,n.scopedSlots,this.slots())}}),f&&(this.$options=l,this.$slots=this.slots(),this.$scopedSlots=be(a,n.scopedSlots,this.$slots)),l._scopeId?this._c=function(t,n,r,o){var i=te(c,t,n,r,o,d);return i&&!e(i)&&(i.fnScopeId=l._scopeId,i.fnContext=a),i}:this._c=function(t,e,n,r){return te(c,t,e,n,r,d)}}function or(t,e,n,r,o){var i=pt(t);return i.fnContext=n,i.fnOptions=r,e.slot&&((i.data||(i.data={})).slot=e.slot),i}function ir(t,e){for(var n in e)t[w(n)]=e[n]}function ar(t){return t.name||t.__name||t._componentTag}me(rr.prototype);var sr={init:function(t,e){if(t.componentInstance&&!t.componentInstance._isDestroyed&&t.data.keepAlive){var n=t;sr.prepatch(n,n)}else{(t.componentInstance=function(t,e){var n={_isComponent:!0,_parentVnode:t,parent:e},o=t.data.inlineTemplate;r(o)&&(n.render=o.render,n.staticRenderFns=o.staticRenderFns);return new t.componentOptions.Ctor(n)}(t,Fe)).$mount(e?t.elm:void 0,e)}},prepatch:function(e,n){var r=n.componentOptions;!function(e,n,r,o,i){var a=o.data.scopedSlots,s=e.$scopedSlots,c=!!(a&&!a.$stable||s!==t&&!s.$stable||a&&e.$scopedSlots.$key!==a.$key||!a&&e.$scopedSlots.$key),u=!!(i||e.$options._renderChildren||c),l=e.$vnode;e.$options._parentVnode=o,e.$vnode=o,e._vnode&&(e._vnode.parent=o),e.$options._renderChildren=i;var f=o.data.attrs||t;e._attrsProxy&&Ce(e._attrsProxy,f,l.data&&l.data.attrs||t,e,"$attrs")&&(u=!0),e.$attrs=f,r=r||t;var d=e.$options._parentListeners;if(e._listenersProxy&&Ce(e._listenersProxy,r,d||t,e,"$listeners"),e.$listeners=e.$options._parentListeners=r,Ie(e,r,d),n&&e.$options.props){kt(!1);for(var p=e._props,v=e.$options._propKeys||[],h=0;h<v.length;h++){var m=v[h],g=e.$options.props;p[m]=br(m,g,n,e)}kt(!0),e.$options.propsData=n}u&&(e.$slots=ge(i,o.context),e.$forceUpdate())}(n.componentInstance=e.componentInstance,r.propsData,r.listeners,n,r.children)},insert:function(t){var e,n=t.context,r=t.componentInstance;r._isMounted||(r._isMounted=!0,Ve(r,"mounted")),t.data.keepAlive&&(n._isMounted?((e=r)._inactive=!1,Je.push(e)):Ue(r,!0))},destroy:function(t){var e=t.componentInstance;e._isDestroyed||(t.data.keepAlive?ze(e,!0):e.$destroy())}},cr=Object.keys(sr);function ur(i,a,c,u,l){if(!n(i)){var d=c.$options._base;if(s(i)&&(i=d.extend(i)),"function"==typeof i){var p;if(n(i.cid)&&(i=function(t,e){if(o(t.error)&&r(t.errorComp))return t.errorComp;if(r(t.resolved))return t.resolved;var i=je;if(i&&r(t.owners)&&-1===t.owners.indexOf(i)&&t.owners.push(i),o(t.loading)&&r(t.loadingComp))return t.loadingComp;if(i&&!r(t.owners)){var a=t.owners=[i],c=!0,u=null,l=null;i.$on("hook:destroyed",(function(){return g(a,i)}));var d=function(t){for(var e=0,n=a.length;e<n;e++)a[e].$forceUpdate();t&&(a.length=0,null!==u&&(clearTimeout(u),u=null),null!==l&&(clearTimeout(l),l=null))},p=M((function(n){t.resolved=Ee(n,e),c?a.length=0:d(!0)})),v=M((function(e){r(t.errorComp)&&(t.error=!0,d(!0))})),h=t(p,v);return s(h)&&(f(h)?n(t.resolved)&&h.then(p,v):f(h.component)&&(h.component.then(p,v),r(h.error)&&(t.errorComp=Ee(h.error,e)),r(h.loading)&&(t.loadingComp=Ee(h.loading,e),0===h.delay?t.loading=!0:u=setTimeout((function(){u=null,n(t.resolved)&&n(t.error)&&(t.loading=!0,d(!1))}),h.delay||200)),r(h.timeout)&&(l=setTimeout((function(){l=null,n(t.resolved)&&v(null)}),h.timeout)))),c=!1,t.loading?t.loadingComp:t.resolved}}(p=i,d),void 0===i))return function(t,e,n,r,o){var i=ft();return i.asyncFactory=t,i.asyncMeta={data:e,context:n,children:r,tag:o},i}(p,a,c,u,l);a=a||{},nr(i),r(a.model)&&function(t,n){var o=t.model&&t.model.prop||"value",i=t.model&&t.model.event||"input";(n.attrs||(n.attrs={}))[o]=n.model.value;var a=n.on||(n.on={}),s=a[i],c=n.model.callback;r(s)?(e(s)?-1===s.indexOf(c):s!==c)&&(a[i]=[c].concat(s)):a[i]=c}(i.options,a);var v=function(t,e,o){var i=e.options.props;if(!n(i)){var a={},s=t.attrs,c=t.props;if(r(s)||r(c))for(var u in i){var l=k(u);Gt(a,c,u,l,!0)||Gt(a,s,u,l,!1)}return a}}(a,i);if(o(i.options.functional))return function(n,o,i,a,s){var c=n.options,u={},l=c.props;if(r(l))for(var f in l)u[f]=br(f,l,o||t);else r(i.attrs)&&ir(u,i.attrs),r(i.props)&&ir(u,i.props);var d=new rr(i,u,s,a,n),p=c.render.call(null,d._c,d);if(p instanceof lt)return or(p,i,d.parent,c);if(e(p)){for(var v=Xt(p)||[],h=new Array(v.length),m=0;m<v.length;m++)h[m]=or(v[m],i,d.parent,c);return h}}(i,v,a,c,u);var h=a.on;if(a.on=a.nativeOn,o(i.options.abstract)){var m=a.slot;a={},m&&(a.slot=m)}!function(t){for(var e=t.hook||(t.hook={}),n=0;n<cr.length;n++){var r=cr[n],o=e[r],i=sr[r];o===i||o&&o._merged||(e[r]=o?lr(i,o):i)}}(a);var y=ar(i.options)||l;return new lt("vue-component-".concat(i.cid).concat(y?"-".concat(y):""),a,void 0,void 0,void 0,c,{Ctor:i,propsData:v,listeners:h,tag:l,children:u},p)}}}function lr(t,e){var n=function(n,r){t(n,r),e(n,r)};return n._merged=!0,n}var fr=j,dr=H.optionMergeStrategies;function pr(t,e,n){if(void 0===n&&(n=!0),!e)return t;for(var r,o,i,a=st?Reflect.ownKeys(e):Object.keys(e),s=0;s<a.length;s++)"__ob__"!==(r=a[s])&&(o=t[r],i=e[r],n&&_(t,r)?o!==i&&u(o)&&u(i)&&pr(o,i):jt(t,r,i));return t}function vr(t,e,n){return n?function(){var r=a(e)?e.call(n,n):e,o=a(t)?t.call(n,n):t;return r?pr(r,o):o}:e?t?function(){return pr(a(e)?e.call(this,this):e,a(t)?t.call(this,this):t)}:e:t}function hr(t,n){var r=n?t?t.concat(n):e(n)?n:[n]:t;return r?function(t){for(var e=[],n=0;n<t.length;n++)-1===e.indexOf(t[n])&&e.push(t[n]);return e}(r):r}function mr(t,e,n,r){var o=Object.create(t||null);return e?T(o,e):o}dr.data=function(t,e,n){return n?vr(t,e,n):e&&"function"!=typeof e?t:vr(t,e)},F.forEach((function(t){dr[t]=hr})),R.forEach((function(t){dr[t+"s"]=mr})),dr.watch=function(t,n,r,o){if(t===tt&&(t=void 0),n===tt&&(n=void 0),!n)return Object.create(t||null);if(!t)return n;var i={};for(var a in T(i,t),n){var s=i[a],c=n[a];s&&!e(s)&&(s=[s]),i[a]=s?s.concat(c):e(c)?c:[c]}return i},dr.props=dr.methods=dr.inject=dr.computed=function(t,e,n,r){if(!t)return e;var o=Object.create(null);return T(o,t),e&&T(o,e),o},dr.provide=function(t,e){return t?function(){var n=Object.create(null);return pr(n,a(t)?t.call(this):t),e&&pr(n,a(e)?e.call(this):e,!1),n}:e};var gr=function(t,e){return void 0===e?t:e};function yr(t,n,r){if(a(n)&&(n=n.options),function(t,n){var r=t.props;if(r){var o,i,a={};if(e(r))for(o=r.length;o--;)"string"==typeof(i=r[o])&&(a[w(i)]={type:null});else if(u(r))for(var s in r)i=r[s],a[w(s)]=u(i)?i:{type:i};t.props=a}}(n),function(t,n){var r=t.inject;if(r){var o=t.inject={};if(e(r))for(var i=0;i<r.length;i++)o[r[i]]={from:r[i]};else if(u(r))for(var a in r){var s=r[a];o[a]=u(s)?T({from:a},s):{from:s}}}}(n),function(t){var e=t.directives;if(e)for(var n in e){var r=e[n];a(r)&&(e[n]={bind:r,update:r})}}(n),!n._base&&(n.extends&&(t=yr(t,n.extends,r)),n.mixins))for(var o=0,i=n.mixins.length;o<i;o++)t=yr(t,n.mixins[o],r);var s,c={};for(s in t)l(s);for(s in n)_(t,s)||l(s);function l(e){var o=dr[e]||gr;c[e]=o(t[e],n[e],r,e)}return c}function _r(t,e,n,r){if("string"==typeof n){var o=t[e];if(_(o,n))return o[n];var i=w(n);if(_(o,i))return o[i];var a=x(i);return _(o,a)?o[a]:o[n]||o[i]||o[a]}}function br(t,e,n,r){var o=e[t],i=!_(n,t),s=n[t],c=Cr(Boolean,o.type);if(c>-1)if(i&&!_(o,"default"))s=!1;else if(""===s||s===k(t)){var u=Cr(String,o.type);(u<0||c<u)&&(s=!0)}if(void 0===s){s=function(t,e,n){if(!_(e,"default"))return;var r=e.default;if(t&&t.$options.propsData&&void 0===t.$options.propsData[n]&&void 0!==t._props[n])return t._props[n];return a(r)&&"Function"!==wr(e.type)?r.call(t):r}(r,o,t);var l=Ct;kt(!0),Tt(s),kt(l)}return s}var $r=/^\s*function (\w+)/;function wr(t){var e=t&&t.toString().match($r);return e?e[1]:""}function xr(t,e){return wr(t)===wr(e)}function Cr(t,n){if(!e(n))return xr(n,t)?0:-1;for(var r=0,o=n.length;r<o;r++)if(xr(n[r],t))return r;return-1}function kr(t){this._init(t)}function Sr(t){t.cid=0;var e=1;t.extend=function(t){t=t||{};var n=this,r=n.cid,o=t._Ctor||(t._Ctor={});if(o[r])return o[r];var i=ar(t)||ar(n.options),a=function(t){this._init(t)};return(a.prototype=Object.create(n.prototype)).constructor=a,a.cid=e++,a.options=yr(n.options,t),a.super=n,a.options.props&&function(t){var e=t.options.props;for(var n in e)qn(t.prototype,"_props",n)}(a),a.options.computed&&function(t){var e=t.options.computed;for(var n in e)Gn(t.prototype,n,e[n])}(a),a.extend=n.extend,a.mixin=n.mixin,a.use=n.use,R.forEach((function(t){a[t]=n[t]})),i&&(a.options.components[i]=a),a.superOptions=n.options,a.extendOptions=t,a.sealedOptions=T({},a.options),o[r]=a,a}}function Or(t){return t&&(ar(t.Ctor.options)||t.tag)}function Tr(t,n){return e(t)?t.indexOf(n)>-1:"string"==typeof t?t.split(",").indexOf(n)>-1:(r=t,"[object RegExp]"===c.call(r)&&t.test(n));var r}function Ar(t,e){var n=t.cache,r=t.keys,o=t._vnode;for(var i in n){var a=n[i];if(a){var s=a.name;s&&!e(s)&&jr(n,i,r,o)}}}function jr(t,e,n,r){var o=t[e];!o||r&&o.tag===r.tag||o.componentInstance.$destroy(),t[e]=null,g(n,e)}!function(e){e.prototype._init=function(e){var n=this;n._uid=er++,n._isVue=!0,n.__v_skip=!0,n._scope=new Le(!0),n._scope._vm=!0,e&&e._isComponent?function(t,e){var n=t.$options=Object.create(t.constructor.options),r=e._parentVnode;n.parent=e.parent,n._parentVnode=r;var o=r.componentOptions;n.propsData=o.propsData,n._parentListeners=o.listeners,n._renderChildren=o.children,n._componentTag=o.tag,e.render&&(n.render=e.render,n.staticRenderFns=e.staticRenderFns)}(n,e):n.$options=yr(nr(n.constructor),e||{},n),n._renderProxy=n,n._self=n,function(t){var e=t.$options,n=e.parent;if(n&&!e.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(t)}t.$parent=n,t.$root=n?n.$root:t,t.$children=[],t.$refs={},t._provided=n?n._provided:Object.create(null),t._watcher=null,t._inactive=null,t._directInactive=!1,t._isMounted=!1,t._isDestroyed=!1,t._isBeingDestroyed=!1}(n),function(t){t._events=Object.create(null),t._hasHookEvent=!1;var e=t.$options._parentListeners;e&&Ie(t,e)}(n),function(e){e._vnode=null,e._staticTrees=null;var n=e.$options,r=e.$vnode=n._parentVnode,o=r&&r.context;e.$slots=ge(n._renderChildren,o),e.$scopedSlots=r?be(e.$parent,r.data.scopedSlots,e.$slots):t,e._c=function(t,n,r,o){return te(e,t,n,r,o,!1)},e.$createElement=function(t,n,r,o){return te(e,t,n,r,o,!0)};var i=r&&r.data;At(e,"$attrs",i&&i.attrs||t,null,!0),At(e,"$listeners",n._parentListeners||t,null,!0)}(n),Ve(n,"beforeCreate",void 0,!1),function(t){var e=tr(t.$options.inject,t);e&&(kt(!1),Object.keys(e).forEach((function(n){At(t,n,e[n])})),kt(!0))}(n),Wn(n),function(t){var e=t.$options.provide;if(e){var n=a(e)?e.call(t):e;if(!s(n))return;for(var r=fn(t),o=st?Reflect.ownKeys(n):Object.keys(n),i=0;i<o.length;i++){var c=o[i];Object.defineProperty(r,c,Object.getOwnPropertyDescriptor(n,c))}}}(n),Ve(n,"created"),n.$options.el&&n.$mount(n.$options.el)}}(kr),function(t){var e={get:function(){return this._data}},n={get:function(){return this._props}};Object.defineProperty(t.prototype,"$data",e),Object.defineProperty(t.prototype,"$props",n),t.prototype.$set=jt,t.prototype.$delete=Et,t.prototype.$watch=function(t,e,n){var r=this;if(u(e))return Qn(r,t,e,n);(n=n||{}).user=!0;var o=new Kn(r,t,e,n);if(n.immediate){var i='callback for immediate watcher "'.concat(o.expression,'"');yt(),pn(e,r,[o.value],r,i),_t()}return function(){o.teardown()}}}(kr),function(t){var n=/^hook:/;t.prototype.$on=function(t,r){var o=this;if(e(t))for(var i=0,a=t.length;i<a;i++)o.$on(t[i],r);else(o._events[t]||(o._events[t]=[])).push(r),n.test(t)&&(o._hasHookEvent=!0);return o},t.prototype.$once=function(t,e){var n=this;function r(){n.$off(t,r),e.apply(n,arguments)}return r.fn=e,n.$on(t,r),n},t.prototype.$off=function(t,n){var r=this;if(!arguments.length)return r._events=Object.create(null),r;if(e(t)){for(var o=0,i=t.length;o<i;o++)r.$off(t[o],n);return r}var a,s=r._events[t];if(!s)return r;if(!n)return r._events[t]=null,r;for(var c=s.length;c--;)if((a=s[c])===n||a.fn===n){s.splice(c,1);break}return r},t.prototype.$emit=function(t){var e=this,n=e._events[t];if(n){n=n.length>1?O(n):n;for(var r=O(arguments,1),o='event handler for "'.concat(t,'"'),i=0,a=n.length;i<a;i++)pn(n[i],e,r,e,o)}return e}}(kr),function(t){t.prototype._update=function(t,e){var n=this,r=n.$el,o=n._vnode,i=He(n);n._vnode=t,n.$el=o?n.__patch__(o,t):n.__patch__(n.$el,t,e,!1),i(),r&&(r.__vue__=null),n.$el&&(n.$el.__vue__=n);for(var a=n;a&&a.$vnode&&a.$parent&&a.$vnode===a.$parent._vnode;)a.$parent.$el=a.$el,a=a.$parent},t.prototype.$forceUpdate=function(){this._watcher&&this._watcher.update()},t.prototype.$destroy=function(){var t=this;if(!t._isBeingDestroyed){Ve(t,"beforeDestroy"),t._isBeingDestroyed=!0;var e=t.$parent;!e||e._isBeingDestroyed||t.$options.abstract||g(e.$children,t),t._scope.stop(),t._data.__ob__&&t._data.__ob__.vmCount--,t._isDestroyed=!0,t.__patch__(t._vnode,null),Ve(t,"destroyed"),t.$off(),t.$el&&(t.$el.__vue__=null),t.$vnode&&(t.$vnode.parent=null)}}}(kr),function(t){me(t.prototype),t.prototype.$nextTick=function(t){return kn(t,this)},t.prototype._render=function(){var t,n=this,r=n.$options,o=r.render,i=r._parentVnode;i&&n._isMounted&&(n.$scopedSlots=be(n.$parent,i.data.scopedSlots,n.$slots,n.$scopedSlots),n._slotsProxy&&Se(n._slotsProxy,n.$scopedSlots)),n.$vnode=i;try{ut(n),je=n,t=o.call(n._renderProxy,n.$createElement)}catch(e){dn(e,n,"render"),t=n._vnode}finally{je=null,ut()}return e(t)&&1===t.length&&(t=t[0]),t instanceof lt||(t=ft()),t.parent=i,t}}(kr);var Er=[String,RegExp,Array],Nr={name:"keep-alive",abstract:!0,props:{include:Er,exclude:Er,max:[String,Number]},methods:{cacheVNode:function(){var t=this,e=t.cache,n=t.keys,r=t.vnodeToCache,o=t.keyToCache;if(r){var i=r.tag,a=r.componentInstance,s=r.componentOptions;e[o]={name:Or(s),tag:i,componentInstance:a},n.push(o),this.max&&n.length>parseInt(this.max)&&jr(e,n[0],n,this._vnode),this.vnodeToCache=null}}},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var t in this.cache)jr(this.cache,t,this.keys)},mounted:function(){var t=this;this.cacheVNode(),this.$watch("include",(function(e){Ar(t,(function(t){return Tr(e,t)}))})),this.$watch("exclude",(function(e){Ar(t,(function(t){return!Tr(e,t)}))}))},updated:function(){this.cacheVNode()},render:function(){var t=this.$slots.default,e=Ne(t),n=e&&e.componentOptions;if(n){var r=Or(n),o=this.include,i=this.exclude;if(o&&(!r||!Tr(o,r))||i&&r&&Tr(i,r))return e;var a=this.cache,s=this.keys,c=null==e.key?n.Ctor.cid+(n.tag?"::".concat(n.tag):""):e.key;a[c]?(e.componentInstance=a[c].componentInstance,g(s,c),s.push(c)):(this.vnodeToCache=e,this.keyToCache=c),e.data.keepAlive=!0}return e||t&&t[0]}},Pr={KeepAlive:Nr};!function(t){var e={get:function(){return H}};Object.defineProperty(t,"config",e),t.util={warn:fr,extend:T,mergeOptions:yr,defineReactive:At},t.set=jt,t.delete=Et,t.nextTick=kn,t.observable=function(t){return Tt(t),t},t.options=Object.create(null),R.forEach((function(e){t.options[e+"s"]=Object.create(null)})),t.options._base=t,T(t.options.components,Pr),function(t){t.use=function(t){var e=this._installedPlugins||(this._installedPlugins=[]);if(e.indexOf(t)>-1)return this;var n=O(arguments,1);return n.unshift(this),a(t.install)?t.install.apply(t,n):a(t)&&t.apply(null,n),e.push(t),this}}(t),function(t){t.mixin=function(t){return this.options=yr(this.options,t),this}}(t),Sr(t),function(t){R.forEach((function(e){t[e]=function(t,n){return n?("component"===e&&u(n)&&(n.name=n.name||t,n=this.options._base.extend(n)),"directive"===e&&a(n)&&(n={bind:n,update:n}),this.options[e+"s"][t]=n,n):this.options[e+"s"][t]}}))}(t)}(kr),Object.defineProperty(kr.prototype,"$isServer",{get:rt}),Object.defineProperty(kr.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Object.defineProperty(kr,"FunctionalRenderContext",{value:rr}),kr.version=Fn;var Dr=v("style,class"),Mr=v("input,textarea,option,select,progress"),Ir=function(t,e,n){return"value"===n&&Mr(t)&&"button"!==e||"selected"===n&&"option"===t||"checked"===n&&"input"===t||"muted"===n&&"video"===t},Lr=v("contenteditable,draggable,spellcheck"),Rr=v("events,caret,typing,plaintext-only"),Fr=v("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,truespeed,typemustmatch,visible"),Hr="http://www.w3.org/1999/xlink",Br=function(t){return":"===t.charAt(5)&&"xlink"===t.slice(0,5)},Ur=function(t){return Br(t)?t.slice(6,t.length):""},zr=function(t){return null==t||!1===t};function Vr(t){for(var e=t.data,n=t,o=t;r(o.componentInstance);)(o=o.componentInstance._vnode)&&o.data&&(e=Kr(o.data,e));for(;r(n=n.parent);)n&&n.data&&(e=Kr(e,n.data));return function(t,e){if(r(t)||r(e))return Jr(t,qr(e));return""}(e.staticClass,e.class)}function Kr(t,e){return{staticClass:Jr(t.staticClass,e.staticClass),class:r(t.class)?[t.class,e.class]:e.class}}function Jr(t,e){return t?e?t+" "+e:t:e||""}function qr(t){return Array.isArray(t)?function(t){for(var e,n="",o=0,i=t.length;o<i;o++)r(e=qr(t[o]))&&""!==e&&(n&&(n+=" "),n+=e);return n}(t):s(t)?function(t){var e="";for(var n in t)t[n]&&(e&&(e+=" "),e+=n);return e}(t):"string"==typeof t?t:""}var Wr={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},Zr=v("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),Gr=v("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),Xr=function(t){return Zr(t)||Gr(t)};function Yr(t){return Gr(t)?"svg":"math"===t?"math":void 0}var Qr=Object.create(null);var to=v("text,number,password,search,email,tel,url");function eo(t){if("string"==typeof t){var e=document.querySelector(t);return e||document.createElement("div")}return t}var no=Object.freeze({__proto__:null,createElement:function(t,e){var n=document.createElement(t);return"select"!==t||e.data&&e.data.attrs&&void 0!==e.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n},createElementNS:function(t,e){return document.createElementNS(Wr[t],e)},createTextNode:function(t){return document.createTextNode(t)},createComment:function(t){return document.createComment(t)},insertBefore:function(t,e,n){t.insertBefore(e,n)},removeChild:function(t,e){t.removeChild(e)},appendChild:function(t,e){t.appendChild(e)},parentNode:function(t){return t.parentNode},nextSibling:function(t){return t.nextSibling},tagName:function(t){return t.tagName},setTextContent:function(t,e){t.textContent=e},setStyleScope:function(t,e){t.setAttribute(e,"")}}),ro={create:function(t,e){oo(e)},update:function(t,e){t.data.ref!==e.data.ref&&(oo(t,!0),oo(e))},destroy:function(t){oo(t,!0)}};function oo(t,n){var o=t.data.ref;if(r(o)){var i=t.context,s=t.componentInstance||t.elm,c=n?null:s,u=n?void 0:s;if(a(o))pn(o,i,[c],i,"template ref function");else{var l=t.data.refInFor,f="string"==typeof o||"number"==typeof o,d=Ft(o),p=i.$refs;if(f||d)if(l){var v=f?p[o]:o.value;n?e(v)&&g(v,s):e(v)?v.includes(s)||v.push(s):f?(p[o]=[s],io(i,o,p[o])):o.value=[s]}else if(f){if(n&&p[o]!==s)return;p[o]=u,io(i,o,c)}else if(d){if(n&&o.value!==s)return;o.value=c}}}}function io(t,e,n){var r=t._setupState;r&&_(r,e)&&(Ft(r[e])?r[e].value=n:r[e]=n)}var ao=new lt("",{},[]),so=["create","activate","update","remove","destroy"];function co(t,e){return t.key===e.key&&t.asyncFactory===e.asyncFactory&&(t.tag===e.tag&&t.isComment===e.isComment&&r(t.data)===r(e.data)&&function(t,e){if("input"!==t.tag)return!0;var n,o=r(n=t.data)&&r(n=n.attrs)&&n.type,i=r(n=e.data)&&r(n=n.attrs)&&n.type;return o===i||to(o)&&to(i)}(t,e)||o(t.isAsyncPlaceholder)&&n(e.asyncFactory.error))}function uo(t,e,n){var o,i,a={};for(o=e;o<=n;++o)r(i=t[o].key)&&(a[i]=o);return a}var lo={create:fo,update:fo,destroy:function(t){fo(t,ao)}};function fo(t,e){(t.data.directives||e.data.directives)&&function(t,e){var n,r,o,i=t===ao,a=e===ao,s=vo(t.data.directives,t.context),c=vo(e.data.directives,e.context),u=[],l=[];for(n in c)r=s[n],o=c[n],r?(o.oldValue=r.value,o.oldArg=r.arg,mo(o,"update",e,t),o.def&&o.def.componentUpdated&&l.push(o)):(mo(o,"bind",e,t),o.def&&o.def.inserted&&u.push(o));if(u.length){var f=function(){for(var n=0;n<u.length;n++)mo(u[n],"inserted",e,t)};i?Zt(e,"insert",f):f()}l.length&&Zt(e,"postpatch",(function(){for(var n=0;n<l.length;n++)mo(l[n],"componentUpdated",e,t)}));if(!i)for(n in s)c[n]||mo(s[n],"unbind",t,t,a)}(t,e)}var po=Object.create(null);function vo(t,e){var n,r,o=Object.create(null);if(!t)return o;for(n=0;n<t.length;n++){if((r=t[n]).modifiers||(r.modifiers=po),o[ho(r)]=r,e._setupState&&e._setupState.__sfc){var i=r.def||_r(e,"_setupState","v-"+r.name);r.def="function"==typeof i?{bind:i,update:i}:i}r.def=r.def||_r(e.$options,"directives",r.name)}return o}function ho(t){return t.rawName||"".concat(t.name,".").concat(Object.keys(t.modifiers||{}).join("."))}function mo(t,e,n,r,o){var i=t.def&&t.def[e];if(i)try{i(n.elm,t,n,r,o)}catch(r){dn(r,n.context,"directive ".concat(t.name," ").concat(e," hook"))}}var go=[ro,lo];function yo(t,e){var i=e.componentOptions;if(!(r(i)&&!1===i.Ctor.options.inheritAttrs||n(t.data.attrs)&&n(e.data.attrs))){var a,s,c=e.elm,u=t.data.attrs||{},l=e.data.attrs||{};for(a in(r(l.__ob__)||o(l._v_attr_proxy))&&(l=e.data.attrs=T({},l)),l)s=l[a],u[a]!==s&&_o(c,a,s,e.data.pre);for(a in(W||G)&&l.value!==u.value&&_o(c,"value",l.value),u)n(l[a])&&(Br(a)?c.removeAttributeNS(Hr,Ur(a)):Lr(a)||c.removeAttribute(a))}}function _o(t,e,n,r){r||t.tagName.indexOf("-")>-1?bo(t,e,n):Fr(e)?zr(n)?t.removeAttribute(e):(n="allowfullscreen"===e&&"EMBED"===t.tagName?"true":e,t.setAttribute(e,n)):Lr(e)?t.setAttribute(e,function(t,e){return zr(e)||"false"===e?"false":"contenteditable"===t&&Rr(e)?e:"true"}(e,n)):Br(e)?zr(n)?t.removeAttributeNS(Hr,Ur(e)):t.setAttributeNS(Hr,e,n):bo(t,e,n)}function bo(t,e,n){if(zr(n))t.removeAttribute(e);else{if(W&&!Z&&"TEXTAREA"===t.tagName&&"placeholder"===e&&""!==n&&!t.__ieph){var r=function(e){e.stopImmediatePropagation(),t.removeEventListener("input",r)};t.addEventListener("input",r),t.__ieph=!0}t.setAttribute(e,n)}}var $o={create:yo,update:yo};function wo(t,e){var o=e.elm,i=e.data,a=t.data;if(!(n(i.staticClass)&&n(i.class)&&(n(a)||n(a.staticClass)&&n(a.class)))){var s=Vr(e),c=o._transitionClasses;r(c)&&(s=Jr(s,qr(c))),s!==o._prevClass&&(o.setAttribute("class",s),o._prevClass=s)}}var xo,Co,ko,So,Oo,To,Ao={create:wo,update:wo},jo=/[\w).+\-_$\]]/;function Eo(t){var e,n,r,o,i,a=!1,s=!1,c=!1,u=!1,l=0,f=0,d=0,p=0;for(r=0;r<t.length;r++)if(n=e,e=t.charCodeAt(r),a)39===e&&92!==n&&(a=!1);else if(s)34===e&&92!==n&&(s=!1);else if(c)96===e&&92!==n&&(c=!1);else if(u)47===e&&92!==n&&(u=!1);else if(124!==e||124===t.charCodeAt(r+1)||124===t.charCodeAt(r-1)||l||f||d){switch(e){case 34:s=!0;break;case 39:a=!0;break;case 96:c=!0;break;case 40:d++;break;case 41:d--;break;case 91:f++;break;case 93:f--;break;case 123:l++;break;case 125:l--}if(47===e){for(var v=r-1,h=void 0;v>=0&&" "===(h=t.charAt(v));v--);h&&jo.test(h)||(u=!0)}}else void 0===o?(p=r+1,o=t.slice(0,r).trim()):m();function m(){(i||(i=[])).push(t.slice(p,r).trim()),p=r+1}if(void 0===o?o=t.slice(0,r).trim():0!==p&&m(),i)for(r=0;r<i.length;r++)o=No(o,i[r]);return o}function No(t,e){var n=e.indexOf("(");if(n<0)return'_f("'.concat(e,'")(').concat(t,")");var r=e.slice(0,n),o=e.slice(n+1);return'_f("'.concat(r,'")(').concat(t).concat(")"!==o?","+o:o)}function Po(t,e){console.error("[Vue compiler]: ".concat(t))}function Do(t,e){return t?t.map((function(t){return t[e]})).filter((function(t){return t})):[]}function Mo(t,e,n,r,o){(t.props||(t.props=[])).push(Vo({name:e,value:n,dynamic:o},r)),t.plain=!1}function Io(t,e,n,r,o){(o?t.dynamicAttrs||(t.dynamicAttrs=[]):t.attrs||(t.attrs=[])).push(Vo({name:e,value:n,dynamic:o},r)),t.plain=!1}function Lo(t,e,n,r){t.attrsMap[e]=n,t.attrsList.push(Vo({name:e,value:n},r))}function Ro(t,e,n,r,o,i,a,s){(t.directives||(t.directives=[])).push(Vo({name:e,rawName:n,value:r,arg:o,isDynamicArg:i,modifiers:a},s)),t.plain=!1}function Fo(t,e,n){return n?"_p(".concat(e,',"').concat(t,'")'):t+e}function Ho(e,n,r,o,i,a,s,c){var u;(o=o||t).right?c?n="(".concat(n,")==='click'?'contextmenu':(").concat(n,")"):"click"===n&&(n="contextmenu",delete o.right):o.middle&&(c?n="(".concat(n,")==='click'?'mouseup':(").concat(n,")"):"click"===n&&(n="mouseup")),o.capture&&(delete o.capture,n=Fo("!",n,c)),o.once&&(delete o.once,n=Fo("~",n,c)),o.passive&&(delete o.passive,n=Fo("&",n,c)),o.native?(delete o.native,u=e.nativeEvents||(e.nativeEvents={})):u=e.events||(e.events={});var l=Vo({value:r.trim(),dynamic:c},s);o!==t&&(l.modifiers=o);var f=u[n];Array.isArray(f)?i?f.unshift(l):f.push(l):u[n]=f?i?[l,f]:[f,l]:l,e.plain=!1}function Bo(t,e,n){var r=Uo(t,":"+e)||Uo(t,"v-bind:"+e);if(null!=r)return Eo(r);if(!1!==n){var o=Uo(t,e);if(null!=o)return JSON.stringify(o)}}function Uo(t,e,n){var r;if(null!=(r=t.attrsMap[e]))for(var o=t.attrsList,i=0,a=o.length;i<a;i++)if(o[i].name===e){o.splice(i,1);break}return n&&delete t.attrsMap[e],r}function zo(t,e){for(var n=t.attrsList,r=0,o=n.length;r<o;r++){var i=n[r];if(e.test(i.name))return n.splice(r,1),i}}function Vo(t,e){return e&&(null!=e.start&&(t.start=e.start),null!=e.end&&(t.end=e.end)),t}function Ko(t,e,n){var r=n||{},o=r.number,i="$$v",a=i;r.trim&&(a="(typeof ".concat(i," === 'string'")+"? ".concat(i,".trim()")+": ".concat(i,")")),o&&(a="_n(".concat(a,")"));var s=Jo(e,a);t.model={value:"(".concat(e,")"),expression:JSON.stringify(e),callback:"function (".concat(i,") {").concat(s,"}")}}function Jo(t,e){var n=function(t){if(t=t.trim(),xo=t.length,t.indexOf("[")<0||t.lastIndexOf("]")<xo-1)return(So=t.lastIndexOf("."))>-1?{exp:t.slice(0,So),key:'"'+t.slice(So+1)+'"'}:{exp:t,key:null};Co=t,So=Oo=To=0;for(;!Wo();)Zo(ko=qo())?Xo(ko):91===ko&&Go(ko);return{exp:t.slice(0,Oo),key:t.slice(Oo+1,To)}}(t);return null===n.key?"".concat(t,"=").concat(e):"$set(".concat(n.exp,", ").concat(n.key,", ").concat(e,")")}function qo(){return Co.charCodeAt(++So)}function Wo(){return So>=xo}function Zo(t){return 34===t||39===t}function Go(t){var e=1;for(Oo=So;!Wo();)if(Zo(t=qo()))Xo(t);else if(91===t&&e++,93===t&&e--,0===e){To=So;break}}function Xo(t){for(var e=t;!Wo()&&(t=qo())!==e;);}var Yo,Qo="__r";function ti(t,e,n){var r=Yo;return function o(){var i=e.apply(null,arguments);null!==i&&ri(t,o,n,r)}}var ei=gn&&!(Q&&Number(Q[1])<=53);function ni(t,e,n,r){if(ei){var o=Xe,i=e;e=i._wrapper=function(t){if(t.target===t.currentTarget||t.timeStamp>=o||t.timeStamp<=0||t.target.ownerDocument!==document)return i.apply(this,arguments)}}Yo.addEventListener(t,e,et?{capture:n,passive:r}:n)}function ri(t,e,n,r){(r||Yo).removeEventListener(t,e._wrapper||e,n)}function oi(t,e){if(!n(t.data.on)||!n(e.data.on)){var o=e.data.on||{},i=t.data.on||{};Yo=e.elm||t.elm,function(t){if(r(t.__r)){var e=W?"change":"input";t[e]=[].concat(t.__r,t[e]||[]),delete t.__r}r(t.__c)&&(t.change=[].concat(t.__c,t.change||[]),delete t.__c)}(o),Wt(o,i,ni,ri,ti,e.context),Yo=void 0}}var ii,ai={create:oi,update:oi,destroy:function(t){return oi(t,ao)}};function si(t,e){if(!n(t.data.domProps)||!n(e.data.domProps)){var i,a,s=e.elm,c=t.data.domProps||{},u=e.data.domProps||{};for(i in(r(u.__ob__)||o(u._v_attr_proxy))&&(u=e.data.domProps=T({},u)),c)i in u||(s[i]="");for(i in u){if(a=u[i],"textContent"===i||"innerHTML"===i){if(e.children&&(e.children.length=0),a===c[i])continue;1===s.childNodes.length&&s.removeChild(s.childNodes[0])}if("value"===i&&"PROGRESS"!==s.tagName){s._value=a;var l=n(a)?"":String(a);ci(s,l)&&(s.value=l)}else if("innerHTML"===i&&Gr(s.tagName)&&n(s.innerHTML)){(ii=ii||document.createElement("div")).innerHTML="<svg>".concat(a,"</svg>");for(var f=ii.firstChild;s.firstChild;)s.removeChild(s.firstChild);for(;f.firstChild;)s.appendChild(f.firstChild)}else if(a!==c[i])try{s[i]=a}catch(t){}}}}function ci(t,e){return!t.composing&&("OPTION"===t.tagName||function(t,e){var n=!0;try{n=document.activeElement!==t}catch(t){}return n&&t.value!==e}(t,e)||function(t,e){var n=t.value,o=t._vModifiers;if(r(o)){if(o.number)return p(n)!==p(e);if(o.trim)return n.trim()!==e.trim()}return n!==e}(t,e))}var ui={create:si,update:si},li=b((function(t){var e={},n=/:(.+)/;return t.split(/;(?![^(]*\))/g).forEach((function(t){if(t){var r=t.split(n);r.length>1&&(e[r[0].trim()]=r[1].trim())}})),e}));function fi(t){var e=di(t.style);return t.staticStyle?T(t.staticStyle,e):e}function di(t){return Array.isArray(t)?A(t):"string"==typeof t?li(t):t}var pi,vi=/^--/,hi=/\s*!important$/,mi=function(t,e,n){if(vi.test(e))t.style.setProperty(e,n);else if(hi.test(n))t.style.setProperty(k(e),n.replace(hi,""),"important");else{var r=yi(e);if(Array.isArray(n))for(var o=0,i=n.length;o<i;o++)t.style[r]=n[o];else t.style[r]=n}},gi=["Webkit","Moz","ms"],yi=b((function(t){if(pi=pi||document.createElement("div").style,"filter"!==(t=w(t))&&t in pi)return t;for(var e=t.charAt(0).toUpperCase()+t.slice(1),n=0;n<gi.length;n++){var r=gi[n]+e;if(r in pi)return r}}));function _i(t,e){var o=e.data,i=t.data;if(!(n(o.staticStyle)&&n(o.style)&&n(i.staticStyle)&&n(i.style))){var a,s,c=e.elm,u=i.staticStyle,l=i.normalizedStyle||i.style||{},f=u||l,d=di(e.data.style)||{};e.data.normalizedStyle=r(d.__ob__)?T({},d):d;var p=function(t,e){var n,r={};if(e)for(var o=t;o.componentInstance;)(o=o.componentInstance._vnode)&&o.data&&(n=fi(o.data))&&T(r,n);(n=fi(t.data))&&T(r,n);for(var i=t;i=i.parent;)i.data&&(n=fi(i.data))&&T(r,n);return r}(e,!0);for(s in f)n(p[s])&&mi(c,s,"");for(s in p)(a=p[s])!==f[s]&&mi(c,s,null==a?"":a)}}var bi={create:_i,update:_i},$i=/\s+/;function wi(t,e){if(e&&(e=e.trim()))if(t.classList)e.indexOf(" ")>-1?e.split($i).forEach((function(e){return t.classList.add(e)})):t.classList.add(e);else{var n=" ".concat(t.getAttribute("class")||""," ");n.indexOf(" "+e+" ")<0&&t.setAttribute("class",(n+e).trim())}}function xi(t,e){if(e&&(e=e.trim()))if(t.classList)e.indexOf(" ")>-1?e.split($i).forEach((function(e){return t.classList.remove(e)})):t.classList.remove(e),t.classList.length||t.removeAttribute("class");else{for(var n=" ".concat(t.getAttribute("class")||""," "),r=" "+e+" ";n.indexOf(r)>=0;)n=n.replace(r," ");(n=n.trim())?t.setAttribute("class",n):t.removeAttribute("class")}}function Ci(t){if(t){if("object"==typeof t){var e={};return!1!==t.css&&T(e,ki(t.name||"v")),T(e,t),e}return"string"==typeof t?ki(t):void 0}}var ki=b((function(t){return{enterClass:"".concat(t,"-enter"),enterToClass:"".concat(t,"-enter-to"),enterActiveClass:"".concat(t,"-enter-active"),leaveClass:"".concat(t,"-leave"),leaveToClass:"".concat(t,"-leave-to"),leaveActiveClass:"".concat(t,"-leave-active")}})),Si=J&&!Z,Oi="transition",Ti="animation",Ai="transition",ji="transitionend",Ei="animation",Ni="animationend";Si&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(Ai="WebkitTransition",ji="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Ei="WebkitAnimation",Ni="webkitAnimationEnd"));var Pi=J?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(t){return t()};function Di(t){Pi((function(){Pi(t)}))}function Mi(t,e){var n=t._transitionClasses||(t._transitionClasses=[]);n.indexOf(e)<0&&(n.push(e),wi(t,e))}function Ii(t,e){t._transitionClasses&&g(t._transitionClasses,e),xi(t,e)}function Li(t,e,n){var r=Fi(t,e),o=r.type,i=r.timeout,a=r.propCount;if(!o)return n();var s=o===Oi?ji:Ni,c=0,u=function(){t.removeEventListener(s,l),n()},l=function(e){e.target===t&&++c>=a&&u()};setTimeout((function(){c<a&&u()}),i+1),t.addEventListener(s,l)}var Ri=/\b(transform|all)(,|$)/;function Fi(t,e){var n,r=window.getComputedStyle(t),o=(r[Ai+"Delay"]||"").split(", "),i=(r[Ai+"Duration"]||"").split(", "),a=Hi(o,i),s=(r[Ei+"Delay"]||"").split(", "),c=(r[Ei+"Duration"]||"").split(", "),u=Hi(s,c),l=0,f=0;return e===Oi?a>0&&(n=Oi,l=a,f=i.length):e===Ti?u>0&&(n=Ti,l=u,f=c.length):f=(n=(l=Math.max(a,u))>0?a>u?Oi:Ti:null)?n===Oi?i.length:c.length:0,{type:n,timeout:l,propCount:f,hasTransform:n===Oi&&Ri.test(r[Ai+"Property"])}}function Hi(t,e){for(;t.length<e.length;)t=t.concat(t);return Math.max.apply(null,e.map((function(e,n){return Bi(e)+Bi(t[n])})))}function Bi(t){return 1e3*Number(t.slice(0,-1).replace(",","."))}function Ui(t,e){var o=t.elm;r(o._leaveCb)&&(o._leaveCb.cancelled=!0,o._leaveCb());var i=Ci(t.data.transition);if(!n(i)&&!r(o._enterCb)&&1===o.nodeType){for(var c=i.css,u=i.type,l=i.enterClass,f=i.enterToClass,d=i.enterActiveClass,v=i.appearClass,h=i.appearToClass,m=i.appearActiveClass,g=i.beforeEnter,y=i.enter,_=i.afterEnter,b=i.enterCancelled,$=i.beforeAppear,w=i.appear,x=i.afterAppear,C=i.appearCancelled,k=i.duration,S=Fe,O=Fe.$vnode;O&&O.parent;)S=O.context,O=O.parent;var T=!S._isMounted||!t.isRootInsert;if(!T||w||""===w){var A=T&&v?v:l,j=T&&m?m:d,E=T&&h?h:f,N=T&&$||g,P=T&&a(w)?w:y,D=T&&x||_,I=T&&C||b,L=p(s(k)?k.enter:k),R=!1!==c&&!Z,F=Ki(P),H=o._enterCb=M((function(){R&&(Ii(o,E),Ii(o,j)),H.cancelled?(R&&Ii(o,A),I&&I(o)):D&&D(o),o._enterCb=null}));t.data.show||Zt(t,"insert",(function(){var e=o.parentNode,n=e&&e._pending&&e._pending[t.key];n&&n.tag===t.tag&&n.elm._leaveCb&&n.elm._leaveCb(),P&&P(o,H)})),N&&N(o),R&&(Mi(o,A),Mi(o,j),Di((function(){Ii(o,A),H.cancelled||(Mi(o,E),F||(Vi(L)?setTimeout(H,L):Li(o,u,H)))}))),t.data.show&&(e&&e(),P&&P(o,H)),R||F||H()}}}function zi(t,e){var o=t.elm;r(o._enterCb)&&(o._enterCb.cancelled=!0,o._enterCb());var i=Ci(t.data.transition);if(n(i)||1!==o.nodeType)return e();if(!r(o._leaveCb)){var a=i.css,c=i.type,u=i.leaveClass,l=i.leaveToClass,f=i.leaveActiveClass,d=i.beforeLeave,v=i.leave,h=i.afterLeave,m=i.leaveCancelled,g=i.delayLeave,y=i.duration,_=!1!==a&&!Z,b=Ki(v),$=p(s(y)?y.leave:y),w=o._leaveCb=M((function(){o.parentNode&&o.parentNode._pending&&(o.parentNode._pending[t.key]=null),_&&(Ii(o,l),Ii(o,f)),w.cancelled?(_&&Ii(o,u),m&&m(o)):(e(),h&&h(o)),o._leaveCb=null}));g?g(x):x()}function x(){w.cancelled||(!t.data.show&&o.parentNode&&((o.parentNode._pending||(o.parentNode._pending={}))[t.key]=t),d&&d(o),_&&(Mi(o,u),Mi(o,f),Di((function(){Ii(o,u),w.cancelled||(Mi(o,l),b||(Vi($)?setTimeout(w,$):Li(o,c,w)))}))),v&&v(o,w),_||b||w())}}function Vi(t){return"number"==typeof t&&!isNaN(t)}function Ki(t){if(n(t))return!1;var e=t.fns;return r(e)?Ki(Array.isArray(e)?e[0]:e):(t._length||t.length)>1}function Ji(t,e){!0!==e.data.show&&Ui(e)}var qi=function(t){var a,s,c={},u=t.modules,l=t.nodeOps;for(a=0;a<so.length;++a)for(c[so[a]]=[],s=0;s<u.length;++s)r(u[s][so[a]])&&c[so[a]].push(u[s][so[a]]);function f(t){var e=l.parentNode(t);r(e)&&l.removeChild(e,t)}function d(t,e,n,i,a,s,u){if(r(t.elm)&&r(s)&&(t=s[u]=pt(t)),t.isRootInsert=!a,!function(t,e,n,i){var a=t.data;if(r(a)){var s=r(t.componentInstance)&&a.keepAlive;if(r(a=a.hook)&&r(a=a.init)&&a(t,!1),r(t.componentInstance))return p(t,e),h(n,t.elm,i),o(s)&&function(t,e,n,o){var i,a=t;for(;a.componentInstance;)if(r(i=(a=a.componentInstance._vnode).data)&&r(i=i.transition)){for(i=0;i<c.activate.length;++i)c.activate[i](ao,a);e.push(a);break}h(n,t.elm,o)}(t,e,n,i),!0}}(t,e,n,i)){var f=t.data,d=t.children,v=t.tag;r(v)?(t.elm=t.ns?l.createElementNS(t.ns,v):l.createElement(v,t),_(t),m(t,d,e),r(f)&&y(t,e),h(n,t.elm,i)):o(t.isComment)?(t.elm=l.createComment(t.text),h(n,t.elm,i)):(t.elm=l.createTextNode(t.text),h(n,t.elm,i))}}function p(t,e){r(t.data.pendingInsert)&&(e.push.apply(e,t.data.pendingInsert),t.data.pendingInsert=null),t.elm=t.componentInstance.$el,g(t)?(y(t,e),_(t)):(oo(t),e.push(t))}function h(t,e,n){r(t)&&(r(n)?l.parentNode(n)===t&&l.insertBefore(t,e,n):l.appendChild(t,e))}function m(t,n,r){if(e(n))for(var o=0;o<n.length;++o)d(n[o],r,t.elm,null,!0,n,o);else i(t.text)&&l.appendChild(t.elm,l.createTextNode(String(t.text)))}function g(t){for(;t.componentInstance;)t=t.componentInstance._vnode;return r(t.tag)}function y(t,e){for(var n=0;n<c.create.length;++n)c.create[n](ao,t);r(a=t.data.hook)&&(r(a.create)&&a.create(ao,t),r(a.insert)&&e.push(t))}function _(t){var e;if(r(e=t.fnScopeId))l.setStyleScope(t.elm,e);else for(var n=t;n;)r(e=n.context)&&r(e=e.$options._scopeId)&&l.setStyleScope(t.elm,e),n=n.parent;r(e=Fe)&&e!==t.context&&e!==t.fnContext&&r(e=e.$options._scopeId)&&l.setStyleScope(t.elm,e)}function b(t,e,n,r,o,i){for(;r<=o;++r)d(n[r],i,t,e,!1,n,r)}function $(t){var e,n,o=t.data;if(r(o))for(r(e=o.hook)&&r(e=e.destroy)&&e(t),e=0;e<c.destroy.length;++e)c.destroy[e](t);if(r(e=t.children))for(n=0;n<t.children.length;++n)$(t.children[n])}function w(t,e,n){for(;e<=n;++e){var o=t[e];r(o)&&(r(o.tag)?(x(o),$(o)):f(o.elm))}}function x(t,e){if(r(e)||r(t.data)){var n,o=c.remove.length+1;for(r(e)?e.listeners+=o:e=function(t,e){function n(){0==--n.listeners&&f(t)}return n.listeners=e,n}(t.elm,o),r(n=t.componentInstance)&&r(n=n._vnode)&&r(n.data)&&x(n,e),n=0;n<c.remove.length;++n)c.remove[n](t,e);r(n=t.data.hook)&&r(n=n.remove)?n(t,e):e()}else f(t.elm)}function C(t,e,n,o){for(var i=n;i<o;i++){var a=e[i];if(r(a)&&co(t,a))return i}}function k(t,e,i,a,s,u){if(t!==e){r(e.elm)&&r(a)&&(e=a[s]=pt(e));var f=e.elm=t.elm;if(o(t.isAsyncPlaceholder))r(e.asyncFactory.resolved)?T(t.elm,e,i):e.isAsyncPlaceholder=!0;else if(o(e.isStatic)&&o(t.isStatic)&&e.key===t.key&&(o(e.isCloned)||o(e.isOnce)))e.componentInstance=t.componentInstance;else{var p,v=e.data;r(v)&&r(p=v.hook)&&r(p=p.prepatch)&&p(t,e);var h=t.children,m=e.children;if(r(v)&&g(e)){for(p=0;p<c.update.length;++p)c.update[p](t,e);r(p=v.hook)&&r(p=p.update)&&p(t,e)}n(e.text)?r(h)&&r(m)?h!==m&&function(t,e,o,i,a){for(var s,c,u,f=0,p=0,v=e.length-1,h=e[0],m=e[v],g=o.length-1,y=o[0],_=o[g],$=!a;f<=v&&p<=g;)n(h)?h=e[++f]:n(m)?m=e[--v]:co(h,y)?(k(h,y,i,o,p),h=e[++f],y=o[++p]):co(m,_)?(k(m,_,i,o,g),m=e[--v],_=o[--g]):co(h,_)?(k(h,_,i,o,g),$&&l.insertBefore(t,h.elm,l.nextSibling(m.elm)),h=e[++f],_=o[--g]):co(m,y)?(k(m,y,i,o,p),$&&l.insertBefore(t,m.elm,h.elm),m=e[--v],y=o[++p]):(n(s)&&(s=uo(e,f,v)),n(c=r(y.key)?s[y.key]:C(y,e,f,v))?d(y,i,t,h.elm,!1,o,p):co(u=e[c],y)?(k(u,y,i,o,p),e[c]=void 0,$&&l.insertBefore(t,u.elm,h.elm)):d(y,i,t,h.elm,!1,o,p),y=o[++p]);f>v?b(t,n(o[g+1])?null:o[g+1].elm,o,p,g,i):p>g&&w(e,f,v)}(f,h,m,i,u):r(m)?(r(t.text)&&l.setTextContent(f,""),b(f,null,m,0,m.length-1,i)):r(h)?w(h,0,h.length-1):r(t.text)&&l.setTextContent(f,""):t.text!==e.text&&l.setTextContent(f,e.text),r(v)&&r(p=v.hook)&&r(p=p.postpatch)&&p(t,e)}}}function S(t,e,n){if(o(n)&&r(t.parent))t.parent.data.pendingInsert=e;else for(var i=0;i<e.length;++i)e[i].data.hook.insert(e[i])}var O=v("attrs,class,staticClass,staticStyle,key");function T(t,e,n,i){var a,s=e.tag,c=e.data,u=e.children;if(i=i||c&&c.pre,e.elm=t,o(e.isComment)&&r(e.asyncFactory))return e.isAsyncPlaceholder=!0,!0;if(r(c)&&(r(a=c.hook)&&r(a=a.init)&&a(e,!0),r(a=e.componentInstance)))return p(e,n),!0;if(r(s)){if(r(u))if(t.hasChildNodes())if(r(a=c)&&r(a=a.domProps)&&r(a=a.innerHTML)){if(a!==t.innerHTML)return!1}else{for(var l=!0,f=t.firstChild,d=0;d<u.length;d++){if(!f||!T(f,u[d],n,i)){l=!1;break}f=f.nextSibling}if(!l||f)return!1}else m(e,u,n);if(r(c)){var v=!1;for(var h in c)if(!O(h)){v=!0,y(e,n);break}!v&&c.class&&Un(c.class)}}else t.data!==e.text&&(t.data=e.text);return!0}return function(t,e,i,a){if(!n(e)){var s,u=!1,f=[];if(n(t))u=!0,d(e,f);else{var p=r(t.nodeType);if(!p&&co(t,e))k(t,e,f,null,null,a);else{if(p){if(1===t.nodeType&&t.hasAttribute(L)&&(t.removeAttribute(L),i=!0),o(i)&&T(t,e,f))return S(e,f,!0),t;s=t,t=new lt(l.tagName(s).toLowerCase(),{},[],void 0,s)}var v=t.elm,h=l.parentNode(v);if(d(e,f,v._leaveCb?null:h,l.nextSibling(v)),r(e.parent))for(var m=e.parent,y=g(e);m;){for(var _=0;_<c.destroy.length;++_)c.destroy[_](m);if(m.elm=e.elm,y){for(var b=0;b<c.create.length;++b)c.create[b](ao,m);var x=m.data.hook.insert;if(x.merged)for(var C=x.fns.slice(1),O=0;O<C.length;O++)C[O]()}else oo(m);m=m.parent}r(h)?w([t],0,0):r(t.tag)&&$(t)}}return S(e,f,u),e.elm}r(t)&&$(t)}}({nodeOps:no,modules:[$o,Ao,ai,ui,bi,J?{create:Ji,activate:Ji,remove:function(t,e){!0!==t.data.show?zi(t,e):e()}}:{}].concat(go)});Z&&document.addEventListener("selectionchange",(function(){var t=document.activeElement;t&&t.vmodel&&ea(t,"input")}));var Wi={inserted:function(t,e,n,r){"select"===n.tag?(r.elm&&!r.elm._vOptions?Zt(n,"postpatch",(function(){Wi.componentUpdated(t,e,n)})):Zi(t,e,n.context),t._vOptions=[].map.call(t.options,Yi)):("textarea"===n.tag||to(t.type))&&(t._vModifiers=e.modifiers,e.modifiers.lazy||(t.addEventListener("compositionstart",Qi),t.addEventListener("compositionend",ta),t.addEventListener("change",ta),Z&&(t.vmodel=!0)))},componentUpdated:function(t,e,n){if("select"===n.tag){Zi(t,e,n.context);var r=t._vOptions,o=t._vOptions=[].map.call(t.options,Yi);if(o.some((function(t,e){return!P(t,r[e])})))(t.multiple?e.value.some((function(t){return Xi(t,o)})):e.value!==e.oldValue&&Xi(e.value,o))&&ea(t,"change")}}};function Zi(t,e,n){Gi(t,e),(W||G)&&setTimeout((function(){Gi(t,e)}),0)}function Gi(t,e,n){var r=e.value,o=t.multiple;if(!o||Array.isArray(r)){for(var i,a,s=0,c=t.options.length;s<c;s++)if(a=t.options[s],o)i=D(r,Yi(a))>-1,a.selected!==i&&(a.selected=i);else if(P(Yi(a),r))return void(t.selectedIndex!==s&&(t.selectedIndex=s));o||(t.selectedIndex=-1)}}function Xi(t,e){return e.every((function(e){return!P(e,t)}))}function Yi(t){return"_value"in t?t._value:t.value}function Qi(t){t.target.composing=!0}function ta(t){t.target.composing&&(t.target.composing=!1,ea(t.target,"input"))}function ea(t,e){var n=document.createEvent("HTMLEvents");n.initEvent(e,!0,!0),t.dispatchEvent(n)}function na(t){return!t.componentInstance||t.data&&t.data.transition?t:na(t.componentInstance._vnode)}var ra={bind:function(t,e,n){var r=e.value,o=(n=na(n)).data&&n.data.transition,i=t.__vOriginalDisplay="none"===t.style.display?"":t.style.display;r&&o?(n.data.show=!0,Ui(n,(function(){t.style.display=i}))):t.style.display=r?i:"none"},update:function(t,e,n){var r=e.value;!r!=!e.oldValue&&((n=na(n)).data&&n.data.transition?(n.data.show=!0,r?Ui(n,(function(){t.style.display=t.__vOriginalDisplay})):zi(n,(function(){t.style.display="none"}))):t.style.display=r?t.__vOriginalDisplay:"none")},unbind:function(t,e,n,r,o){o||(t.style.display=t.__vOriginalDisplay)}},oa={model:Wi,show:ra},ia={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]};function aa(t){var e=t&&t.componentOptions;return e&&e.Ctor.options.abstract?aa(Ne(e.children)):t}function sa(t){var e={},n=t.$options;for(var r in n.propsData)e[r]=t[r];var o=n._parentListeners;for(var r in o)e[w(r)]=o[r];return e}function ca(t,e){if(/\d-keep-alive$/.test(e.tag))return t("keep-alive",{props:e.componentOptions.propsData})}var ua=function(t){return t.tag||_e(t)},la=function(t){return"show"===t.name},fa={name:"transition",props:ia,abstract:!0,render:function(t){var e=this,n=this.$slots.default;if(n&&(n=n.filter(ua)).length){var r=this.mode,o=n[0];if(function(t){for(;t=t.parent;)if(t.data.transition)return!0}(this.$vnode))return o;var a=aa(o);if(!a)return o;if(this._leaving)return ca(t,o);var s="__transition-".concat(this._uid,"-");a.key=null==a.key?a.isComment?s+"comment":s+a.tag:i(a.key)?0===String(a.key).indexOf(s)?a.key:s+a.key:a.key;var c=(a.data||(a.data={})).transition=sa(this),u=this._vnode,l=aa(u);if(a.data.directives&&a.data.directives.some(la)&&(a.data.show=!0),l&&l.data&&!function(t,e){return e.key===t.key&&e.tag===t.tag}(a,l)&&!_e(l)&&(!l.componentInstance||!l.componentInstance._vnode.isComment)){var f=l.data.transition=T({},c);if("out-in"===r)return this._leaving=!0,Zt(f,"afterLeave",(function(){e._leaving=!1,e.$forceUpdate()})),ca(t,o);if("in-out"===r){if(_e(a))return u;var d,p=function(){d()};Zt(c,"afterEnter",p),Zt(c,"enterCancelled",p),Zt(f,"delayLeave",(function(t){d=t}))}}return o}}},da=T({tag:String,moveClass:String},ia);delete da.mode;var pa={props:da,beforeMount:function(){var t=this,e=this._update;this._update=function(n,r){var o=He(t);t.__patch__(t._vnode,t.kept,!1,!0),t._vnode=t.kept,o(),e.call(t,n,r)}},render:function(t){for(var e=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),r=this.prevChildren=this.children,o=this.$slots.default||[],i=this.children=[],a=sa(this),s=0;s<o.length;s++){(l=o[s]).tag&&null!=l.key&&0!==String(l.key).indexOf("__vlist")&&(i.push(l),n[l.key]=l,(l.data||(l.data={})).transition=a)}if(r){var c=[],u=[];for(s=0;s<r.length;s++){var l;(l=r[s]).data.transition=a,l.data.pos=l.elm.getBoundingClientRect(),n[l.key]?c.push(l):u.push(l)}this.kept=t(e,null,c),this.removed=u}return t(e,null,i)},updated:function(){var t=this.prevChildren,e=this.moveClass||(this.name||"v")+"-move";t.length&&this.hasMove(t[0].elm,e)&&(t.forEach(va),t.forEach(ha),t.forEach(ma),this._reflow=document.body.offsetHeight,t.forEach((function(t){if(t.data.moved){var n=t.elm,r=n.style;Mi(n,e),r.transform=r.WebkitTransform=r.transitionDuration="",n.addEventListener(ji,n._moveCb=function t(r){r&&r.target!==n||r&&!/transform$/.test(r.propertyName)||(n.removeEventListener(ji,t),n._moveCb=null,Ii(n,e))})}})))},methods:{hasMove:function(t,e){if(!Si)return!1;if(this._hasMove)return this._hasMove;var n=t.cloneNode();t._transitionClasses&&t._transitionClasses.forEach((function(t){xi(n,t)})),wi(n,e),n.style.display="none",this.$el.appendChild(n);var r=Fi(n);return this.$el.removeChild(n),this._hasMove=r.hasTransform}}};function va(t){t.elm._moveCb&&t.elm._moveCb(),t.elm._enterCb&&t.elm._enterCb()}function ha(t){t.data.newPos=t.elm.getBoundingClientRect()}function ma(t){var e=t.data.pos,n=t.data.newPos,r=e.left-n.left,o=e.top-n.top;if(r||o){t.data.moved=!0;var i=t.elm.style;i.transform=i.WebkitTransform="translate(".concat(r,"px,").concat(o,"px)"),i.transitionDuration="0s"}}var ga={Transition:fa,TransitionGroup:pa};kr.config.mustUseProp=Ir,kr.config.isReservedTag=Xr,kr.config.isReservedAttr=Dr,kr.config.getTagNamespace=Yr,kr.config.isUnknownElement=function(t){if(!J)return!0;if(Xr(t))return!1;if(t=t.toLowerCase(),null!=Qr[t])return Qr[t];var e=document.createElement(t);return t.indexOf("-")>-1?Qr[t]=e.constructor===window.HTMLUnknownElement||e.constructor===window.HTMLElement:Qr[t]=/HTMLUnknownElement/.test(e.toString())},T(kr.options.directives,oa),T(kr.options.components,ga),kr.prototype.__patch__=J?qi:j,kr.prototype.$mount=function(t,e){return function(t,e,n){var r;t.$el=e,t.$options.render||(t.$options.render=ft),Ve(t,"beforeMount"),r=function(){t._update(t._render(),n)},new Kn(t,r,j,{before:function(){t._isMounted&&!t._isDestroyed&&Ve(t,"beforeUpdate")}},!0),n=!1;var o=t._preWatchers;if(o)for(var i=0;i<o.length;i++)o[i].run();return null==t.$vnode&&(t._isMounted=!0,Ve(t,"mounted")),t}(this,t=t&&J?eo(t):void 0,e)},J&&setTimeout((function(){H.devtools&&ot&&ot.emit("init",kr)}),0);var ya=/\{\{((?:.|\r?\n)+?)\}\}/g,_a=/[-.*+?^${}()|[\]\/\\]/g,ba=b((function(t){var e=t[0].replace(_a,"\\$&"),n=t[1].replace(_a,"\\$&");return new RegExp(e+"((?:.|\\n)+?)"+n,"g")}));var $a={staticKeys:["staticClass"],transformNode:function(t,e){e.warn;var n=Uo(t,"class");n&&(t.staticClass=JSON.stringify(n.replace(/\s+/g," ").trim()));var r=Bo(t,"class",!1);r&&(t.classBinding=r)},genData:function(t){var e="";return t.staticClass&&(e+="staticClass:".concat(t.staticClass,",")),t.classBinding&&(e+="class:".concat(t.classBinding,",")),e}};var wa,xa={staticKeys:["staticStyle"],transformNode:function(t,e){e.warn;var n=Uo(t,"style");n&&(t.staticStyle=JSON.stringify(li(n)));var r=Bo(t,"style",!1);r&&(t.styleBinding=r)},genData:function(t){var e="";return t.staticStyle&&(e+="staticStyle:".concat(t.staticStyle,",")),t.styleBinding&&(e+="style:(".concat(t.styleBinding,"),")),e}},Ca=function(t){return(wa=wa||document.createElement("div")).innerHTML=t,wa.textContent},ka=v("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),Sa=v("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),Oa=v("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"),Ta=/^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,Aa=/^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,ja="[a-zA-Z_][\\-\\.0-9_a-zA-Z".concat(B.source,"]*"),Ea="((?:".concat(ja,"\\:)?").concat(ja,")"),Na=new RegExp("^<".concat(Ea)),Pa=/^\s*(\/?)>/,Da=new RegExp("^<\\/".concat(Ea,"[^>]*>")),Ma=/^<!DOCTYPE [^>]+>/i,Ia=/^<!\--/,La=/^<!\[/,Ra=v("script,style,textarea",!0),Fa={},Ha={"&lt;":"<","&gt;":">","&quot;":'"',"&amp;":"&","&#10;":"\n","&#9;":"\t","&#39;":"'"},Ba=/&(?:lt|gt|quot|amp|#39);/g,Ua=/&(?:lt|gt|quot|amp|#39|#10|#9);/g,za=v("pre,textarea",!0),Va=function(t,e){return t&&za(t)&&"\n"===e[0]};function Ka(t,e){var n=e?Ua:Ba;return t.replace(n,(function(t){return Ha[t]}))}function Ja(t,e){for(var n,r,o=[],i=e.expectHTML,a=e.isUnaryTag||E,s=e.canBeLeftOpenTag||E,c=0,u=function(){if(n=t,r&&Ra(r)){var u=0,d=r.toLowerCase(),p=Fa[d]||(Fa[d]=new RegExp("([\\s\\S]*?)(</"+d+"[^>]*>)","i"));w=t.replace(p,(function(t,n,r){return u=r.length,Ra(d)||"noscript"===d||(n=n.replace(/<!\--([\s\S]*?)-->/g,"$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g,"$1")),Va(d,n)&&(n=n.slice(1)),e.chars&&e.chars(n),""}));c+=t.length-w.length,t=w,f(d,c-u,c)}else{var v=t.indexOf("<");if(0===v){if(Ia.test(t)){var h=t.indexOf("--\x3e");if(h>=0)return e.shouldKeepComment&&e.comment&&e.comment(t.substring(4,h),c,c+h+3),l(h+3),"continue"}if(La.test(t)){var m=t.indexOf("]>");if(m>=0)return l(m+2),"continue"}var g=t.match(Ma);if(g)return l(g[0].length),"continue";var y=t.match(Da);if(y){var _=c;return l(y[0].length),f(y[1],_,c),"continue"}var b=function(){var e=t.match(Na);if(e){var n={tagName:e[1],attrs:[],start:c};l(e[0].length);for(var r=void 0,o=void 0;!(r=t.match(Pa))&&(o=t.match(Aa)||t.match(Ta));)o.start=c,l(o[0].length),o.end=c,n.attrs.push(o);if(r)return n.unarySlash=r[1],l(r[0].length),n.end=c,n}}();if(b)return function(t){var n=t.tagName,c=t.unarySlash;i&&("p"===r&&Oa(n)&&f(r),s(n)&&r===n&&f(n));for(var u=a(n)||!!c,l=t.attrs.length,d=new Array(l),p=0;p<l;p++){var v=t.attrs[p],h=v[3]||v[4]||v[5]||"",m="a"===n&&"href"===v[1]?e.shouldDecodeNewlinesForHref:e.shouldDecodeNewlines;d[p]={name:v[1],value:Ka(h,m)}}u||(o.push({tag:n,lowerCasedTag:n.toLowerCase(),attrs:d,start:t.start,end:t.end}),r=n);e.start&&e.start(n,d,u,t.start,t.end)}(b),Va(b.tagName,t)&&l(1),"continue"}var $=void 0,w=void 0,x=void 0;if(v>=0){for(w=t.slice(v);!(Da.test(w)||Na.test(w)||Ia.test(w)||La.test(w)||(x=w.indexOf("<",1))<0);)v+=x,w=t.slice(v);$=t.substring(0,v)}v<0&&($=t),$&&l($.length),e.chars&&$&&e.chars($,c-$.length,c)}if(t===n)return e.chars&&e.chars(t),"break"};t;){if("break"===u())break}function l(e){c+=e,t=t.substring(e)}function f(t,n,i){var a,s;if(null==n&&(n=c),null==i&&(i=c),t)for(s=t.toLowerCase(),a=o.length-1;a>=0&&o[a].lowerCasedTag!==s;a--);else a=0;if(a>=0){for(var u=o.length-1;u>=a;u--)e.end&&e.end(o[u].tag,n,i);o.length=a,r=a&&o[a-1].tag}else"br"===s?e.start&&e.start(t,[],!0,n,i):"p"===s&&(e.start&&e.start(t,[],!1,n,i),e.end&&e.end(t,n,i))}f()}var qa,Wa,Za,Ga,Xa,Ya,Qa,ts,es=/^@|^v-on:/,ns=/^v-|^@|^:|^#/,rs=/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,os=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,is=/^\(|\)$/g,as=/^\[.*\]$/,ss=/:(.*)$/,cs=/^:|^\.|^v-bind:/,us=/\.[^.\]]+(?=[^\]]*$)/g,ls=/^v-slot(:|$)|^#/,fs=/[\r\n]/,ds=/[ \f\t\r\n]+/g,ps=b(Ca),vs="_empty_";function hs(t,e,n){return{type:1,tag:t,attrsList:e,attrsMap:ws(e),rawAttrsMap:{},parent:n,children:[]}}function ms(t,e){qa=e.warn||Po,Ya=e.isPreTag||E,Qa=e.mustUseProp||E,ts=e.getTagNamespace||E,e.isReservedTag,Za=Do(e.modules,"transformNode"),Ga=Do(e.modules,"preTransformNode"),Xa=Do(e.modules,"postTransformNode"),Wa=e.delimiters;var n,r,o=[],i=!1!==e.preserveWhitespace,a=e.whitespace,s=!1,c=!1;function u(t){if(l(t),s||t.processed||(t=gs(t,e)),o.length||t===n||n.if&&(t.elseif||t.else)&&_s(n,{exp:t.elseif,block:t}),r&&!t.forbidden)if(t.elseif||t.else)a=t,u=function(t){for(var e=t.length;e--;){if(1===t[e].type)return t[e];t.pop()}}(r.children),u&&u.if&&_s(u,{exp:a.elseif,block:a});else{if(t.slotScope){var i=t.slotTarget||'"default"';(r.scopedSlots||(r.scopedSlots={}))[i]=t}r.children.push(t),t.parent=r}var a,u;t.children=t.children.filter((function(t){return!t.slotScope})),l(t),t.pre&&(s=!1),Ya(t.tag)&&(c=!1);for(var f=0;f<Xa.length;f++)Xa[f](t,e)}function l(t){if(!c)for(var e=void 0;(e=t.children[t.children.length-1])&&3===e.type&&" "===e.text;)t.children.pop()}return Ja(t,{warn:qa,expectHTML:e.expectHTML,isUnaryTag:e.isUnaryTag,canBeLeftOpenTag:e.canBeLeftOpenTag,shouldDecodeNewlines:e.shouldDecodeNewlines,shouldDecodeNewlinesForHref:e.shouldDecodeNewlinesForHref,shouldKeepComment:e.comments,outputSourceRange:e.outputSourceRange,start:function(t,i,a,l,f){var d=r&&r.ns||ts(t);W&&"svg"===d&&(i=function(t){for(var e=[],n=0;n<t.length;n++){var r=t[n];xs.test(r.name)||(r.name=r.name.replace(Cs,""),e.push(r))}return e}(i));var p,v=hs(t,i,r);d&&(v.ns=d),"style"!==(p=v).tag&&("script"!==p.tag||p.attrsMap.type&&"text/javascript"!==p.attrsMap.type)||rt()||(v.forbidden=!0);for(var h=0;h<Ga.length;h++)v=Ga[h](v,e)||v;s||(!function(t){null!=Uo(t,"v-pre")&&(t.pre=!0)}(v),v.pre&&(s=!0)),Ya(v.tag)&&(c=!0),s?function(t){var e=t.attrsList,n=e.length;if(n)for(var r=t.attrs=new Array(n),o=0;o<n;o++)r[o]={name:e[o].name,value:JSON.stringify(e[o].value)},null!=e[o].start&&(r[o].start=e[o].start,r[o].end=e[o].end);else t.pre||(t.plain=!0)}(v):v.processed||(ys(v),function(t){var e=Uo(t,"v-if");if(e)t.if=e,_s(t,{exp:e,block:t});else{null!=Uo(t,"v-else")&&(t.else=!0);var n=Uo(t,"v-else-if");n&&(t.elseif=n)}}(v),function(t){null!=Uo(t,"v-once")&&(t.once=!0)}(v)),n||(n=v),a?u(v):(r=v,o.push(v))},end:function(t,e,n){var i=o[o.length-1];o.length-=1,r=o[o.length-1],u(i)},chars:function(t,e,n){if(r&&(!W||"textarea"!==r.tag||r.attrsMap.placeholder!==t)){var o,u=r.children;if(t=c||t.trim()?"script"===(o=r).tag||"style"===o.tag?t:ps(t):u.length?a?"condense"===a&&fs.test(t)?"":" ":i?" ":"":""){c||"condense"!==a||(t=t.replace(ds," "));var l=void 0,f=void 0;!s&&" "!==t&&(l=function(t,e){var n=e?ba(e):ya;if(n.test(t)){for(var r,o,i,a=[],s=[],c=n.lastIndex=0;r=n.exec(t);){(o=r.index)>c&&(s.push(i=t.slice(c,o)),a.push(JSON.stringify(i)));var u=Eo(r[1].trim());a.push("_s(".concat(u,")")),s.push({"@binding":u}),c=o+r[0].length}return c<t.length&&(s.push(i=t.slice(c)),a.push(JSON.stringify(i))),{expression:a.join("+"),tokens:s}}}(t,Wa))?f={type:2,expression:l.expression,tokens:l.tokens,text:t}:" "===t&&u.length&&" "===u[u.length-1].text||(f={type:3,text:t}),f&&u.push(f)}}},comment:function(t,e,n){if(r){var o={type:3,text:t,isComment:!0};r.children.push(o)}}}),n}function gs(t,e){var n,r;(r=Bo(n=t,"key"))&&(n.key=r),t.plain=!t.key&&!t.scopedSlots&&!t.attrsList.length,function(t){var e=Bo(t,"ref");e&&(t.ref=e,t.refInFor=function(t){var e=t;for(;e;){if(void 0!==e.for)return!0;e=e.parent}return!1}(t))}(t),function(t){var e;"template"===t.tag?(e=Uo(t,"scope"),t.slotScope=e||Uo(t,"slot-scope")):(e=Uo(t,"slot-scope"))&&(t.slotScope=e);var n=Bo(t,"slot");n&&(t.slotTarget='""'===n?'"default"':n,t.slotTargetDynamic=!(!t.attrsMap[":slot"]&&!t.attrsMap["v-bind:slot"]),"template"===t.tag||t.slotScope||Io(t,"slot",n,function(t,e){return t.rawAttrsMap[":"+e]||t.rawAttrsMap["v-bind:"+e]||t.rawAttrsMap[e]}(t,"slot")));if("template"===t.tag){if(a=zo(t,ls)){var r=bs(a),o=r.name,i=r.dynamic;t.slotTarget=o,t.slotTargetDynamic=i,t.slotScope=a.value||vs}}else{var a;if(a=zo(t,ls)){var s=t.scopedSlots||(t.scopedSlots={}),c=bs(a),u=c.name,l=(i=c.dynamic,s[u]=hs("template",[],t));l.slotTarget=u,l.slotTargetDynamic=i,l.children=t.children.filter((function(t){if(!t.slotScope)return t.parent=l,!0})),l.slotScope=a.value||vs,t.children=[],t.plain=!1}}}(t),function(t){"slot"===t.tag&&(t.slotName=Bo(t,"name"))}(t),function(t){var e;(e=Bo(t,"is"))&&(t.component=e);null!=Uo(t,"inline-template")&&(t.inlineTemplate=!0)}(t);for(var o=0;o<Za.length;o++)t=Za[o](t,e)||t;return function(t){var e,n,r,o,i,a,s,c,u=t.attrsList;for(e=0,n=u.length;e<n;e++)if(r=o=u[e].name,i=u[e].value,ns.test(r))if(t.hasBindings=!0,(a=$s(r.replace(ns,"")))&&(r=r.replace(us,"")),cs.test(r))r=r.replace(cs,""),i=Eo(i),(c=as.test(r))&&(r=r.slice(1,-1)),a&&(a.prop&&!c&&"innerHtml"===(r=w(r))&&(r="innerHTML"),a.camel&&!c&&(r=w(r)),a.sync&&(s=Jo(i,"$event"),c?Ho(t,'"update:"+('.concat(r,")"),s,null,!1,0,u[e],!0):(Ho(t,"update:".concat(w(r)),s,null,!1,0,u[e]),k(r)!==w(r)&&Ho(t,"update:".concat(k(r)),s,null,!1,0,u[e])))),a&&a.prop||!t.component&&Qa(t.tag,t.attrsMap.type,r)?Mo(t,r,i,u[e],c):Io(t,r,i,u[e],c);else if(es.test(r))r=r.replace(es,""),(c=as.test(r))&&(r=r.slice(1,-1)),Ho(t,r,i,a,!1,0,u[e],c);else{var l=(r=r.replace(ns,"")).match(ss),f=l&&l[1];c=!1,f&&(r=r.slice(0,-(f.length+1)),as.test(f)&&(f=f.slice(1,-1),c=!0)),Ro(t,r,o,i,f,c,a,u[e])}else Io(t,r,JSON.stringify(i),u[e]),!t.component&&"muted"===r&&Qa(t.tag,t.attrsMap.type,r)&&Mo(t,r,"true",u[e])}(t),t}function ys(t){var e;if(e=Uo(t,"v-for")){var n=function(t){var e=t.match(rs);if(!e)return;var n={};n.for=e[2].trim();var r=e[1].trim().replace(is,""),o=r.match(os);o?(n.alias=r.replace(os,"").trim(),n.iterator1=o[1].trim(),o[2]&&(n.iterator2=o[2].trim())):n.alias=r;return n}(e);n&&T(t,n)}}function _s(t,e){t.ifConditions||(t.ifConditions=[]),t.ifConditions.push(e)}function bs(t){var e=t.name.replace(ls,"");return e||"#"!==t.name[0]&&(e="default"),as.test(e)?{name:e.slice(1,-1),dynamic:!0}:{name:'"'.concat(e,'"'),dynamic:!1}}function $s(t){var e=t.match(us);if(e){var n={};return e.forEach((function(t){n[t.slice(1)]=!0})),n}}function ws(t){for(var e={},n=0,r=t.length;n<r;n++)e[t[n].name]=t[n].value;return e}var xs=/^xmlns:NS\d+/,Cs=/^NS\d+:/;function ks(t){return hs(t.tag,t.attrsList.slice(),t.parent)}var Ss=[$a,xa,{preTransformNode:function(t,e){if("input"===t.tag){var n=t.attrsMap;if(!n["v-model"])return;var r=void 0;if((n[":type"]||n["v-bind:type"])&&(r=Bo(t,"type")),n.type||r||!n["v-bind"]||(r="(".concat(n["v-bind"],").type")),r){var o=Uo(t,"v-if",!0),i=o?"&&(".concat(o,")"):"",a=null!=Uo(t,"v-else",!0),s=Uo(t,"v-else-if",!0),c=ks(t);ys(c),Lo(c,"type","checkbox"),gs(c,e),c.processed=!0,c.if="(".concat(r,")==='checkbox'")+i,_s(c,{exp:c.if,block:c});var u=ks(t);Uo(u,"v-for",!0),Lo(u,"type","radio"),gs(u,e),_s(c,{exp:"(".concat(r,")==='radio'")+i,block:u});var l=ks(t);return Uo(l,"v-for",!0),Lo(l,":type",r),gs(l,e),_s(c,{exp:o,block:l}),a?c.else=!0:s&&(c.elseif=s),c}}}}];var Os,Ts,As={model:function(t,e,n){var r=e.value,o=e.modifiers,i=t.tag,a=t.attrsMap.type;if(t.component)return Ko(t,r,o),!1;if("select"===i)!function(t,e,n){var r=n&&n.number,o='Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;'+"return ".concat(r?"_n(val)":"val","})"),i="$event.target.multiple ? $$selectedVal : $$selectedVal[0]",a="var $$selectedVal = ".concat(o,";");a="".concat(a," ").concat(Jo(e,i)),Ho(t,"change",a,null,!0)}(t,r,o);else if("input"===i&&"checkbox"===a)!function(t,e,n){var r=n&&n.number,o=Bo(t,"value")||"null",i=Bo(t,"true-value")||"true",a=Bo(t,"false-value")||"false";Mo(t,"checked","Array.isArray(".concat(e,")")+"?_i(".concat(e,",").concat(o,")>-1")+("true"===i?":(".concat(e,")"):":_q(".concat(e,",").concat(i,")"))),Ho(t,"change","var $$a=".concat(e,",")+"$$el=$event.target,"+"$$c=$$el.checked?(".concat(i,"):(").concat(a,");")+"if(Array.isArray($$a)){"+"var $$v=".concat(r?"_n("+o+")":o,",")+"$$i=_i($$a,$$v);"+"if($$el.checked){$$i<0&&(".concat(Jo(e,"$$a.concat([$$v])"),")}")+"else{$$i>-1&&(".concat(Jo(e,"$$a.slice(0,$$i).concat($$a.slice($$i+1))"),")}")+"}else{".concat(Jo(e,"$$c"),"}"),null,!0)}(t,r,o);else if("input"===i&&"radio"===a)!function(t,e,n){var r=n&&n.number,o=Bo(t,"value")||"null";o=r?"_n(".concat(o,")"):o,Mo(t,"checked","_q(".concat(e,",").concat(o,")")),Ho(t,"change",Jo(e,o),null,!0)}(t,r,o);else if("input"===i||"textarea"===i)!function(t,e,n){var r=t.attrsMap.type,o=n||{},i=o.lazy,a=o.number,s=o.trim,c=!i&&"range"!==r,u=i?"change":"range"===r?Qo:"input",l="$event.target.value";s&&(l="$event.target.value.trim()");a&&(l="_n(".concat(l,")"));var f=Jo(e,l);c&&(f="if($event.target.composing)return;".concat(f));Mo(t,"value","(".concat(e,")")),Ho(t,u,f,null,!0),(s||a)&&Ho(t,"blur","$forceUpdate()")}(t,r,o);else if(!H.isReservedTag(i))return Ko(t,r,o),!1;return!0},text:function(t,e){e.value&&Mo(t,"textContent","_s(".concat(e.value,")"),e)},html:function(t,e){e.value&&Mo(t,"innerHTML","_s(".concat(e.value,")"),e)}},js={expectHTML:!0,modules:Ss,directives:As,isPreTag:function(t){return"pre"===t},isUnaryTag:ka,mustUseProp:Ir,canBeLeftOpenTag:Sa,isReservedTag:Xr,getTagNamespace:Yr,staticKeys:function(t){return t.reduce((function(t,e){return t.concat(e.staticKeys||[])}),[]).join(",")}(Ss)},Es=b((function(t){return v("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap"+(t?","+t:""))}));function Ns(t,e){t&&(Os=Es(e.staticKeys||""),Ts=e.isReservedTag||E,Ps(t),Ds(t,!1))}function Ps(t){if(t.static=function(t){if(2===t.type)return!1;if(3===t.type)return!0;return!(!t.pre&&(t.hasBindings||t.if||t.for||h(t.tag)||!Ts(t.tag)||function(t){for(;t.parent;){if("template"!==(t=t.parent).tag)return!1;if(t.for)return!0}return!1}(t)||!Object.keys(t).every(Os)))}(t),1===t.type){if(!Ts(t.tag)&&"slot"!==t.tag&&null==t.attrsMap["inline-template"])return;for(var e=0,n=t.children.length;e<n;e++){var r=t.children[e];Ps(r),r.static||(t.static=!1)}if(t.ifConditions)for(e=1,n=t.ifConditions.length;e<n;e++){var o=t.ifConditions[e].block;Ps(o),o.static||(t.static=!1)}}}function Ds(t,e){if(1===t.type){if((t.static||t.once)&&(t.staticInFor=e),t.static&&t.children.length&&(1!==t.children.length||3!==t.children[0].type))return void(t.staticRoot=!0);if(t.staticRoot=!1,t.children)for(var n=0,r=t.children.length;n<r;n++)Ds(t.children[n],e||!!t.for);if(t.ifConditions)for(n=1,r=t.ifConditions.length;n<r;n++)Ds(t.ifConditions[n].block,e)}}var Ms=/^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/,Is=/\([^)]*?\);*$/,Ls=/^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,Rs={esc:27,tab:9,enter:13,space:32,up:38,left:37,right:39,down:40,delete:[8,46]},Fs={esc:["Esc","Escape"],tab:"Tab",enter:"Enter",space:[" ","Spacebar"],up:["Up","ArrowUp"],left:["Left","ArrowLeft"],right:["Right","ArrowRight"],down:["Down","ArrowDown"],delete:["Backspace","Delete","Del"]},Hs=function(t){return"if(".concat(t,")return null;")},Bs={stop:"$event.stopPropagation();",prevent:"$event.preventDefault();",self:Hs("$event.target !== $event.currentTarget"),ctrl:Hs("!$event.ctrlKey"),shift:Hs("!$event.shiftKey"),alt:Hs("!$event.altKey"),meta:Hs("!$event.metaKey"),left:Hs("'button' in $event && $event.button !== 0"),middle:Hs("'button' in $event && $event.button !== 1"),right:Hs("'button' in $event && $event.button !== 2")};function Us(t,e){var n=e?"nativeOn:":"on:",r="",o="";for(var i in t){var a=zs(t[i]);t[i]&&t[i].dynamic?o+="".concat(i,",").concat(a,","):r+='"'.concat(i,'":').concat(a,",")}return r="{".concat(r.slice(0,-1),"}"),o?n+"_d(".concat(r,",[").concat(o.slice(0,-1),"])"):n+r}function zs(t){if(!t)return"function(){}";if(Array.isArray(t))return"[".concat(t.map((function(t){return zs(t)})).join(","),"]");var e=Ls.test(t.value),n=Ms.test(t.value),r=Ls.test(t.value.replace(Is,""));if(t.modifiers){var o="",i="",a=[],s=function(e){if(Bs[e])i+=Bs[e],Rs[e]&&a.push(e);else if("exact"===e){var n=t.modifiers;i+=Hs(["ctrl","shift","alt","meta"].filter((function(t){return!n[t]})).map((function(t){return"$event.".concat(t,"Key")})).join("||"))}else a.push(e)};for(var c in t.modifiers)s(c);a.length&&(o+=function(t){return"if(!$event.type.indexOf('key')&&"+"".concat(t.map(Vs).join("&&"),")return null;")}(a)),i&&(o+=i);var u=e?"return ".concat(t.value,".apply(null, arguments)"):n?"return (".concat(t.value,").apply(null, arguments)"):r?"return ".concat(t.value):t.value;return"function($event){".concat(o).concat(u,"}")}return e||n?t.value:"function($event){".concat(r?"return ".concat(t.value):t.value,"}")}function Vs(t){var e=parseInt(t,10);if(e)return"$event.keyCode!==".concat(e);var n=Rs[t],r=Fs[t];return"_k($event.keyCode,"+"".concat(JSON.stringify(t),",")+"".concat(JSON.stringify(n),",")+"$event.key,"+"".concat(JSON.stringify(r))+")"}var Ks={on:function(t,e){t.wrapListeners=function(t){return"_g(".concat(t,",").concat(e.value,")")}},bind:function(t,e){t.wrapData=function(n){return"_b(".concat(n,",'").concat(t.tag,"',").concat(e.value,",").concat(e.modifiers&&e.modifiers.prop?"true":"false").concat(e.modifiers&&e.modifiers.sync?",true":"",")")}},cloak:j},Js=function(t){this.options=t,this.warn=t.warn||Po,this.transforms=Do(t.modules,"transformCode"),this.dataGenFns=Do(t.modules,"genData"),this.directives=T(T({},Ks),t.directives);var e=t.isReservedTag||E;this.maybeComponent=function(t){return!!t.component||!e(t.tag)},this.onceId=0,this.staticRenderFns=[],this.pre=!1};function qs(t,e){var n=new Js(e),r=t?"script"===t.tag?"null":Ws(t,n):'_c("div")';return{render:"with(this){return ".concat(r,"}"),staticRenderFns:n.staticRenderFns}}function Ws(t,e){if(t.parent&&(t.pre=t.pre||t.parent.pre),t.staticRoot&&!t.staticProcessed)return Zs(t,e);if(t.once&&!t.onceProcessed)return Gs(t,e);if(t.for&&!t.forProcessed)return Qs(t,e);if(t.if&&!t.ifProcessed)return Xs(t,e);if("template"!==t.tag||t.slotTarget||e.pre){if("slot"===t.tag)return function(t,e){var n=t.slotName||'"default"',r=rc(t,e),o="_t(".concat(n).concat(r?",function(){return ".concat(r,"}"):""),i=t.attrs||t.dynamicAttrs?ac((t.attrs||[]).concat(t.dynamicAttrs||[]).map((function(t){return{name:w(t.name),value:t.value,dynamic:t.dynamic}}))):null,a=t.attrsMap["v-bind"];!i&&!a||r||(o+=",null");i&&(o+=",".concat(i));a&&(o+="".concat(i?"":",null",",").concat(a));return o+")"}(t,e);var n=void 0;if(t.component)n=function(t,e,n){var r=e.inlineTemplate?null:rc(e,n,!0);return"_c(".concat(t,",").concat(tc(e,n)).concat(r?",".concat(r):"",")")}(t.component,t,e);else{var r=void 0,o=e.maybeComponent(t);(!t.plain||t.pre&&o)&&(r=tc(t,e));var i=void 0,a=e.options.bindings;o&&a&&!1!==a.__isScriptSetup&&(i=function(t,e){var n=w(e),r=x(n),o=function(o){return t[e]===o?e:t[n]===o?n:t[r]===o?r:void 0},i=o("setup-const")||o("setup-reactive-const");if(i)return i;var a=o("setup-let")||o("setup-ref")||o("setup-maybe-ref");if(a)return a}(a,t.tag)),i||(i="'".concat(t.tag,"'"));var s=t.inlineTemplate?null:rc(t,e,!0);n="_c(".concat(i).concat(r?",".concat(r):"").concat(s?",".concat(s):"",")")}for(var c=0;c<e.transforms.length;c++)n=e.transforms[c](t,n);return n}return rc(t,e)||"void 0"}function Zs(t,e){t.staticProcessed=!0;var n=e.pre;return t.pre&&(e.pre=t.pre),e.staticRenderFns.push("with(this){return ".concat(Ws(t,e),"}")),e.pre=n,"_m(".concat(e.staticRenderFns.length-1).concat(t.staticInFor?",true":"",")")}function Gs(t,e){if(t.onceProcessed=!0,t.if&&!t.ifProcessed)return Xs(t,e);if(t.staticInFor){for(var n="",r=t.parent;r;){if(r.for){n=r.key;break}r=r.parent}return n?"_o(".concat(Ws(t,e),",").concat(e.onceId++,",").concat(n,")"):Ws(t,e)}return Zs(t,e)}function Xs(t,e,n,r){return t.ifProcessed=!0,Ys(t.ifConditions.slice(),e,n,r)}function Ys(t,e,n,r){if(!t.length)return r||"_e()";var o=t.shift();return o.exp?"(".concat(o.exp,")?").concat(i(o.block),":").concat(Ys(t,e,n,r)):"".concat(i(o.block));function i(t){return n?n(t,e):t.once?Gs(t,e):Ws(t,e)}}function Qs(t,e,n,r){var o=t.for,i=t.alias,a=t.iterator1?",".concat(t.iterator1):"",s=t.iterator2?",".concat(t.iterator2):"";return t.forProcessed=!0,"".concat(r||"_l","((").concat(o,"),")+"function(".concat(i).concat(a).concat(s,"){")+"return ".concat((n||Ws)(t,e))+"})"}function tc(t,e){var n="{",r=function(t,e){var n=t.directives;if(!n)return;var r,o,i,a,s="directives:[",c=!1;for(r=0,o=n.length;r<o;r++){i=n[r],a=!0;var u=e.directives[i.name];u&&(a=!!u(t,i,e.warn)),a&&(c=!0,s+='{name:"'.concat(i.name,'",rawName:"').concat(i.rawName,'"').concat(i.value?",value:(".concat(i.value,"),expression:").concat(JSON.stringify(i.value)):"").concat(i.arg?",arg:".concat(i.isDynamicArg?i.arg:'"'.concat(i.arg,'"')):"").concat(i.modifiers?",modifiers:".concat(JSON.stringify(i.modifiers)):"","},"))}if(c)return s.slice(0,-1)+"]"}(t,e);r&&(n+=r+","),t.key&&(n+="key:".concat(t.key,",")),t.ref&&(n+="ref:".concat(t.ref,",")),t.refInFor&&(n+="refInFor:true,"),t.pre&&(n+="pre:true,"),t.component&&(n+='tag:"'.concat(t.tag,'",'));for(var o=0;o<e.dataGenFns.length;o++)n+=e.dataGenFns[o](t);if(t.attrs&&(n+="attrs:".concat(ac(t.attrs),",")),t.props&&(n+="domProps:".concat(ac(t.props),",")),t.events&&(n+="".concat(Us(t.events,!1),",")),t.nativeEvents&&(n+="".concat(Us(t.nativeEvents,!0),",")),t.slotTarget&&!t.slotScope&&(n+="slot:".concat(t.slotTarget,",")),t.scopedSlots&&(n+="".concat(function(t,e,n){var r=t.for||Object.keys(e).some((function(t){var n=e[t];return n.slotTargetDynamic||n.if||n.for||ec(n)})),o=!!t.if;if(!r)for(var i=t.parent;i;){if(i.slotScope&&i.slotScope!==vs||i.for){r=!0;break}i.if&&(o=!0),i=i.parent}var a=Object.keys(e).map((function(t){return nc(e[t],n)})).join(",");return"scopedSlots:_u([".concat(a,"]").concat(r?",null,true":"").concat(!r&&o?",null,false,".concat(function(t){var e=5381,n=t.length;for(;n;)e=33*e^t.charCodeAt(--n);return e>>>0}(a)):"",")")}(t,t.scopedSlots,e),",")),t.model&&(n+="model:{value:".concat(t.model.value,",callback:").concat(t.model.callback,",expression:").concat(t.model.expression,"},")),t.inlineTemplate){var i=function(t,e){var n=t.children[0];if(n&&1===n.type){var r=qs(n,e.options);return"inlineTemplate:{render:function(){".concat(r.render,"},staticRenderFns:[").concat(r.staticRenderFns.map((function(t){return"function(){".concat(t,"}")})).join(","),"]}")}}(t,e);i&&(n+="".concat(i,","))}return n=n.replace(/,$/,"")+"}",t.dynamicAttrs&&(n="_b(".concat(n,',"').concat(t.tag,'",').concat(ac(t.dynamicAttrs),")")),t.wrapData&&(n=t.wrapData(n)),t.wrapListeners&&(n=t.wrapListeners(n)),n}function ec(t){return 1===t.type&&("slot"===t.tag||t.children.some(ec))}function nc(t,e){var n=t.attrsMap["slot-scope"];if(t.if&&!t.ifProcessed&&!n)return Xs(t,e,nc,"null");if(t.for&&!t.forProcessed)return Qs(t,e,nc);var r=t.slotScope===vs?"":String(t.slotScope),o="function(".concat(r,"){")+"return ".concat("template"===t.tag?t.if&&n?"(".concat(t.if,")?").concat(rc(t,e)||"undefined",":undefined"):rc(t,e)||"undefined":Ws(t,e),"}"),i=r?"":",proxy:true";return"{key:".concat(t.slotTarget||'"default"',",fn:").concat(o).concat(i,"}")}function rc(t,e,n,r,o){var i=t.children;if(i.length){var a=i[0];if(1===i.length&&a.for&&"template"!==a.tag&&"slot"!==a.tag){var s=n?e.maybeComponent(a)?",1":",0":"";return"".concat((r||Ws)(a,e)).concat(s)}var c=n?function(t,e){for(var n=0,r=0;r<t.length;r++){var o=t[r];if(1===o.type){if(oc(o)||o.ifConditions&&o.ifConditions.some((function(t){return oc(t.block)}))){n=2;break}(e(o)||o.ifConditions&&o.ifConditions.some((function(t){return e(t.block)})))&&(n=1)}}return n}(i,e.maybeComponent):0,u=o||ic;return"[".concat(i.map((function(t){return u(t,e)})).join(","),"]").concat(c?",".concat(c):"")}}function oc(t){return void 0!==t.for||"template"===t.tag||"slot"===t.tag}function ic(t,e){return 1===t.type?Ws(t,e):3===t.type&&t.isComment?function(t){return"_e(".concat(JSON.stringify(t.text),")")}(t):function(t){return"_v(".concat(2===t.type?t.expression:sc(JSON.stringify(t.text)),")")}(t)}function ac(t){for(var e="",n="",r=0;r<t.length;r++){var o=t[r],i=sc(o.value);o.dynamic?n+="".concat(o.name,",").concat(i,","):e+='"'.concat(o.name,'":').concat(i,",")}return e="{".concat(e.slice(0,-1),"}"),n?"_d(".concat(e,",[").concat(n.slice(0,-1),"])"):e}function sc(t){return t.replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")}function cc(t,e){try{return new Function(t)}catch(n){return e.push({err:n,code:t}),j}}function uc(t){var e=Object.create(null);return function(n,r,o){(r=T({},r)).warn,delete r.warn;var i=r.delimiters?String(r.delimiters)+n:n;if(e[i])return e[i];var a=t(n,r),s={},c=[];return s.render=cc(a.render,c),s.staticRenderFns=a.staticRenderFns.map((function(t){return cc(t,c)})),e[i]=s}}new RegExp("\\b"+"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b")+"\\b"),new RegExp("\\b"+"delete,typeof,void".split(",").join("\\s*\\([^\\)]*\\)|\\b")+"\\s*\\([^\\)]*\\)");var lc,fc,dc=(lc=function(t,e){var n=ms(t.trim(),e);!1!==e.optimize&&Ns(n,e);var r=qs(n,e);return{ast:n,render:r.render,staticRenderFns:r.staticRenderFns}},function(t){function e(e,n){var r=Object.create(t),o=[],i=[];if(n)for(var a in n.modules&&(r.modules=(t.modules||[]).concat(n.modules)),n.directives&&(r.directives=T(Object.create(t.directives||null),n.directives)),n)"modules"!==a&&"directives"!==a&&(r[a]=n[a]);r.warn=function(t,e,n){(n?i:o).push(t)};var s=lc(e.trim(),r);return s.errors=o,s.tips=i,s}return{compile:e,compileToFunctions:uc(e)}}),pc=dc(js).compileToFunctions;function vc(t){return(fc=fc||document.createElement("div")).innerHTML=t?'<a href="\n"/>':'<div a="\n"/>',fc.innerHTML.indexOf("&#10;")>0}var hc=!!J&&vc(!1),mc=!!J&&vc(!0),gc=b((function(t){var e=eo(t);return e&&e.innerHTML})),yc=kr.prototype.$mount;return kr.prototype.$mount=function(t,e){if((t=t&&eo(t))===document.body||t===document.documentElement)return this;var n=this.$options;if(!n.render){var r=n.template;if(r)if("string"==typeof r)"#"===r.charAt(0)&&(r=gc(r));else{if(!r.nodeType)return this;r=r.innerHTML}else t&&(r=function(t){if(t.outerHTML)return t.outerHTML;var e=document.createElement("div");return e.appendChild(t.cloneNode(!0)),e.innerHTML}(t));if(r){var o=pc(r,{outputSourceRange:!1,shouldDecodeNewlines:hc,shouldDecodeNewlinesForHref:mc,delimiters:n.delimiters,comments:n.comments},this),i=o.render,a=o.staticRenderFns;n.render=i,n.staticRenderFns=a}}return yc.call(this,t,e)},kr.compile=pc,T(kr,Hn),kr.effect=function(t,e){var n=new Kn(ct,t,j,{sync:!0});e&&(n.update=function(){e((function(){return n.run()}))})},kr}));
/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).Vuex=e()}(this,(function(){"use strict";var t=("undefined"!=typeof window?window:"undefined"!=typeof global?global:{}).__VUE_DEVTOOLS_GLOBAL_HOOK__;function e(t,n){if(void 0===n&&(n=[]),null===t||"object"!=typeof t)return t;var o,r=(o=function(e){return e.original===t},n.filter(o)[0]);if(r)return r.copy;var i=Array.isArray(t)?[]:{};return n.push({original:t,copy:i}),Object.keys(t).forEach((function(o){i[o]=e(t[o],n)})),i}function n(t,e){Object.keys(t).forEach((function(n){return e(t[n],n)}))}function o(t){return null!==t&&"object"==typeof t}var r=function(t,e){this.runtime=e,this._children=Object.create(null),this._rawModule=t;var n=t.state;this.state=("function"==typeof n?n():n)||{}},i={namespaced:{configurable:!0}};i.namespaced.get=function(){return!!this._rawModule.namespaced},r.prototype.addChild=function(t,e){this._children[t]=e},r.prototype.removeChild=function(t){delete this._children[t]},r.prototype.getChild=function(t){return this._children[t]},r.prototype.hasChild=function(t){return t in this._children},r.prototype.update=function(t){this._rawModule.namespaced=t.namespaced,t.actions&&(this._rawModule.actions=t.actions),t.mutations&&(this._rawModule.mutations=t.mutations),t.getters&&(this._rawModule.getters=t.getters)},r.prototype.forEachChild=function(t){n(this._children,t)},r.prototype.forEachGetter=function(t){this._rawModule.getters&&n(this._rawModule.getters,t)},r.prototype.forEachAction=function(t){this._rawModule.actions&&n(this._rawModule.actions,t)},r.prototype.forEachMutation=function(t){this._rawModule.mutations&&n(this._rawModule.mutations,t)},Object.defineProperties(r.prototype,i);var c,a=function(t){this.register([],t,!1)};a.prototype.get=function(t){return t.reduce((function(t,e){return t.getChild(e)}),this.root)},a.prototype.getNamespace=function(t){var e=this.root;return t.reduce((function(t,n){return t+((e=e.getChild(n)).namespaced?n+"/":"")}),"")},a.prototype.update=function(t){!function t(e,n,o){if(n.update(o),o.modules)for(var r in o.modules){if(!n.getChild(r))return;t(e.concat(r),n.getChild(r),o.modules[r])}}([],this.root,t)},a.prototype.register=function(t,e,o){var i=this;void 0===o&&(o=!0);var c=new r(e,o);0===t.length?this.root=c:this.get(t.slice(0,-1)).addChild(t[t.length-1],c);e.modules&&n(e.modules,(function(e,n){i.register(t.concat(n),e,o)}))},a.prototype.unregister=function(t){var e=this.get(t.slice(0,-1)),n=t[t.length-1],o=e.getChild(n);o&&o.runtime&&e.removeChild(n)},a.prototype.isRegistered=function(t){var e=this.get(t.slice(0,-1)),n=t[t.length-1];return!!e&&e.hasChild(n)};var s=function(e){var n=this;void 0===e&&(e={}),!c&&"undefined"!=typeof window&&window.Vue&&v(window.Vue);var o=e.plugins;void 0===o&&(o=[]);var r=e.strict;void 0===r&&(r=!1),this._committing=!1,this._actions=Object.create(null),this._actionSubscribers=[],this._mutations=Object.create(null),this._wrappedGetters=Object.create(null),this._modules=new a(e),this._modulesNamespaceMap=Object.create(null),this._subscribers=[],this._watcherVM=new c,this._makeLocalGettersCache=Object.create(null);var i=this,s=this.dispatch,u=this.commit;this.dispatch=function(t,e){return s.call(i,t,e)},this.commit=function(t,e,n){return u.call(i,t,e,n)},this.strict=r;var f=this._modules.root.state;p(this,f,[],this._modules.root),h(this,f),o.forEach((function(t){return t(n)})),(void 0!==e.devtools?e.devtools:c.config.devtools)&&function(e){t&&(e._devtoolHook=t,t.emit("vuex:init",e),t.on("vuex:travel-to-state",(function(t){e.replaceState(t)})),e.subscribe((function(e,n){t.emit("vuex:mutation",e,n)}),{prepend:!0}),e.subscribeAction((function(e,n){t.emit("vuex:action",e,n)}),{prepend:!0}))}(this)},u={state:{configurable:!0}};function f(t,e,n){return e.indexOf(t)<0&&(n&&n.prepend?e.unshift(t):e.push(t)),function(){var n=e.indexOf(t);n>-1&&e.splice(n,1)}}function l(t,e){t._actions=Object.create(null),t._mutations=Object.create(null),t._wrappedGetters=Object.create(null),t._modulesNamespaceMap=Object.create(null);var n=t.state;p(t,n,[],t._modules.root,!0),h(t,n,e)}function h(t,e,o){var r=t._vm;t.getters={},t._makeLocalGettersCache=Object.create(null);var i=t._wrappedGetters,a={};n(i,(function(e,n){a[n]=function(t,e){return function(){return t(e)}}(e,t),Object.defineProperty(t.getters,n,{get:function(){return t._vm[n]},enumerable:!0})}));var s=c.config.silent;c.config.silent=!0,t._vm=new c({data:{$$state:e},computed:a}),c.config.silent=s,t.strict&&function(t){t._vm.$watch((function(){return this._data.$$state}),(function(){}),{deep:!0,sync:!0})}(t),r&&(o&&t._withCommit((function(){r._data.$$state=null})),c.nextTick((function(){return r.$destroy()})))}function p(t,e,n,o,r){var i=!n.length,a=t._modules.getNamespace(n);if(o.namespaced&&(t._modulesNamespaceMap[a],t._modulesNamespaceMap[a]=o),!i&&!r){var s=d(e,n.slice(0,-1)),u=n[n.length-1];t._withCommit((function(){c.set(s,u,o.state)}))}var f=o.context=function(t,e,n){var o=""===e,r={dispatch:o?t.dispatch:function(n,o,r){var i=m(n,o,r),c=i.payload,a=i.options,s=i.type;return a&&a.root||(s=e+s),t.dispatch(s,c)},commit:o?t.commit:function(n,o,r){var i=m(n,o,r),c=i.payload,a=i.options,s=i.type;a&&a.root||(s=e+s),t.commit(s,c,a)}};return Object.defineProperties(r,{getters:{get:o?function(){return t.getters}:function(){return function(t,e){if(!t._makeLocalGettersCache[e]){var n={},o=e.length;Object.keys(t.getters).forEach((function(r){if(r.slice(0,o)===e){var i=r.slice(o);Object.defineProperty(n,i,{get:function(){return t.getters[r]},enumerable:!0})}})),t._makeLocalGettersCache[e]=n}return t._makeLocalGettersCache[e]}(t,e)}},state:{get:function(){return d(t.state,n)}}}),r}(t,a,n);o.forEachMutation((function(e,n){!function(t,e,n,o){(t._mutations[e]||(t._mutations[e]=[])).push((function(e){n.call(t,o.state,e)}))}(t,a+n,e,f)})),o.forEachAction((function(e,n){var o=e.root?n:a+n,r=e.handler||e;!function(t,e,n,o){(t._actions[e]||(t._actions[e]=[])).push((function(e){var r,i=n.call(t,{dispatch:o.dispatch,commit:o.commit,getters:o.getters,state:o.state,rootGetters:t.getters,rootState:t.state},e);return(r=i)&&"function"==typeof r.then||(i=Promise.resolve(i)),t._devtoolHook?i.catch((function(e){throw t._devtoolHook.emit("vuex:error",e),e})):i}))}(t,o,r,f)})),o.forEachGetter((function(e,n){!function(t,e,n,o){if(t._wrappedGetters[e])return;t._wrappedGetters[e]=function(t){return n(o.state,o.getters,t.state,t.getters)}}(t,a+n,e,f)})),o.forEachChild((function(o,i){p(t,e,n.concat(i),o,r)}))}function d(t,e){return e.reduce((function(t,e){return t[e]}),t)}function m(t,e,n){return o(t)&&t.type&&(n=e,e=t,t=t.type),{type:t,payload:e,options:n}}function v(t){c&&t===c||function(t){if(Number(t.version.split(".")[0])>=2)t.mixin({beforeCreate:n});else{var e=t.prototype._init;t.prototype._init=function(t){void 0===t&&(t={}),t.init=t.init?[n].concat(t.init):n,e.call(this,t)}}function n(){var t=this.$options;t.store?this.$store="function"==typeof t.store?t.store():t.store:t.parent&&t.parent.$store&&(this.$store=t.parent.$store)}}(c=t)}u.state.get=function(){return this._vm._data.$$state},u.state.set=function(t){},s.prototype.commit=function(t,e,n){var o=this,r=m(t,e,n),i=r.type,c=r.payload,a={type:i,payload:c},s=this._mutations[i];s&&(this._withCommit((function(){s.forEach((function(t){t(c)}))})),this._subscribers.slice().forEach((function(t){return t(a,o.state)})))},s.prototype.dispatch=function(t,e){var n=this,o=m(t,e),r=o.type,i=o.payload,c={type:r,payload:i},a=this._actions[r];if(a){try{this._actionSubscribers.slice().filter((function(t){return t.before})).forEach((function(t){return t.before(c,n.state)}))}catch(t){}var s=a.length>1?Promise.all(a.map((function(t){return t(i)}))):a[0](i);return new Promise((function(t,e){s.then((function(e){try{n._actionSubscribers.filter((function(t){return t.after})).forEach((function(t){return t.after(c,n.state)}))}catch(t){}t(e)}),(function(t){try{n._actionSubscribers.filter((function(t){return t.error})).forEach((function(e){return e.error(c,n.state,t)}))}catch(t){}e(t)}))}))}},s.prototype.subscribe=function(t,e){return f(t,this._subscribers,e)},s.prototype.subscribeAction=function(t,e){return f("function"==typeof t?{before:t}:t,this._actionSubscribers,e)},s.prototype.watch=function(t,e,n){var o=this;return this._watcherVM.$watch((function(){return t(o.state,o.getters)}),e,n)},s.prototype.replaceState=function(t){var e=this;this._withCommit((function(){e._vm._data.$$state=t}))},s.prototype.registerModule=function(t,e,n){void 0===n&&(n={}),"string"==typeof t&&(t=[t]),this._modules.register(t,e),p(this,this.state,t,this._modules.get(t),n.preserveState),h(this,this.state)},s.prototype.unregisterModule=function(t){var e=this;"string"==typeof t&&(t=[t]),this._modules.unregister(t),this._withCommit((function(){var n=d(e.state,t.slice(0,-1));c.delete(n,t[t.length-1])})),l(this)},s.prototype.hasModule=function(t){return"string"==typeof t&&(t=[t]),this._modules.isRegistered(t)},s.prototype.hotUpdate=function(t){this._modules.update(t),l(this,!0)},s.prototype._withCommit=function(t){var e=this._committing;this._committing=!0,t(),this._committing=e},Object.defineProperties(s.prototype,u);var g=M((function(t,e){var n={};return w(e).forEach((function(e){var o=e.key,r=e.val;n[o]=function(){var e=this.$store.state,n=this.$store.getters;if(t){var o=$(this.$store,"mapState",t);if(!o)return;e=o.context.state,n=o.context.getters}return"function"==typeof r?r.call(this,e,n):e[r]},n[o].vuex=!0})),n})),y=M((function(t,e){var n={};return w(e).forEach((function(e){var o=e.key,r=e.val;n[o]=function(){for(var e=[],n=arguments.length;n--;)e[n]=arguments[n];var o=this.$store.commit;if(t){var i=$(this.$store,"mapMutations",t);if(!i)return;o=i.context.commit}return"function"==typeof r?r.apply(this,[o].concat(e)):o.apply(this.$store,[r].concat(e))}})),n})),_=M((function(t,e){var n={};return w(e).forEach((function(e){var o=e.key,r=e.val;r=t+r,n[o]=function(){if(!t||$(this.$store,"mapGetters",t))return this.$store.getters[r]},n[o].vuex=!0})),n})),b=M((function(t,e){var n={};return w(e).forEach((function(e){var o=e.key,r=e.val;n[o]=function(){for(var e=[],n=arguments.length;n--;)e[n]=arguments[n];var o=this.$store.dispatch;if(t){var i=$(this.$store,"mapActions",t);if(!i)return;o=i.context.dispatch}return"function"==typeof r?r.apply(this,[o].concat(e)):o.apply(this.$store,[r].concat(e))}})),n}));function w(t){return function(t){return Array.isArray(t)||o(t)}(t)?Array.isArray(t)?t.map((function(t){return{key:t,val:t}})):Object.keys(t).map((function(e){return{key:e,val:t[e]}})):[]}function M(t){return function(e,n){return"string"!=typeof e?(n=e,e=""):"/"!==e.charAt(e.length-1)&&(e+="/"),t(e,n)}}function $(t,e,n){return t._modulesNamespaceMap[n]}function C(t,e,n){var o=n?t.groupCollapsed:t.group;try{o.call(t,e)}catch(n){t.log(e)}}function E(t){try{t.groupEnd()}catch(e){t.log("—— log end ——")}}function O(){var t=new Date;return" @ "+j(t.getHours(),2)+":"+j(t.getMinutes(),2)+":"+j(t.getSeconds(),2)+"."+j(t.getMilliseconds(),3)}function j(t,e){return n="0",o=e-t.toString().length,new Array(o+1).join(n)+t;var n,o}return{Store:s,install:v,version:"3.6.2",mapState:g,mapMutations:y,mapGetters:_,mapActions:b,createNamespacedHelpers:function(t){return{mapState:g.bind(null,t),mapGetters:_.bind(null,t),mapMutations:y.bind(null,t),mapActions:b.bind(null,t)}},createLogger:function(t){void 0===t&&(t={});var n=t.collapsed;void 0===n&&(n=!0);var o=t.filter;void 0===o&&(o=function(t,e,n){return!0});var r=t.transformer;void 0===r&&(r=function(t){return t});var i=t.mutationTransformer;void 0===i&&(i=function(t){return t});var c=t.actionFilter;void 0===c&&(c=function(t,e){return!0});var a=t.actionTransformer;void 0===a&&(a=function(t){return t});var s=t.logMutations;void 0===s&&(s=!0);var u=t.logActions;void 0===u&&(u=!0);var f=t.logger;return void 0===f&&(f=console),function(t){var l=e(t.state);void 0!==f&&(s&&t.subscribe((function(t,c){var a=e(c);if(o(t,l,a)){var s=O(),u=i(t),h="mutation "+t.type+s;C(f,h,n),f.log("%c prev state","color: #9E9E9E; font-weight: bold",r(l)),f.log("%c mutation","color: #03A9F4; font-weight: bold",u),f.log("%c next state","color: #4CAF50; font-weight: bold",r(a)),E(f)}l=a})),u&&t.subscribeAction((function(t,e){if(c(t,e)){var o=O(),r=a(t),i="action "+t.type+o;C(f,i,n),f.log("%c action","color: #03A9F4; font-weight: bold",r),E(f)}})))}}}}));

/*! Sortable 1.7.0 - MIT | git://github.com/rubaxa/Sortable.git */
!function(a){"use strict";"function"==typeof define&&define.amd?define(a):"undefined"!=typeof module&&"undefined"!=typeof module.exports?module.exports=a():window.Sortable=a()}(function(){"use strict";function a(b,c){if(!b||!b.nodeType||1!==b.nodeType)throw"Sortable: `el` must be HTMLElement, and not "+{}.toString.call(b);this.el=b,this.options=c=t({},c),b[V]=this;var d={group:Math.random(),sort:!0,disabled:!1,store:null,handle:null,scroll:!0,scrollSensitivity:30,scrollSpeed:10,draggable:/[uo]l/i.test(b.nodeName)?"li":">*",ghostClass:"sortable-ghost",chosenClass:"sortable-chosen",dragClass:"sortable-drag",ignore:"a, img",filter:null,preventOnFilter:!0,animation:0,setData:function(a,b){a.setData("Text",b.textContent)},dropBubble:!1,dragoverBubble:!1,dataIdAttr:"data-id",delay:0,forceFallback:!1,fallbackClass:"sortable-fallback",fallbackOnBody:!1,fallbackTolerance:0,fallbackOffset:{x:0,y:0},supportPointer:a.supportPointer!==!1};for(var e in d)!(e in c)&&(c[e]=d[e]);ka(c);for(var g in this)"_"===g.charAt(0)&&"function"==typeof this[g]&&(this[g]=this[g].bind(this));this.nativeDraggable=!c.forceFallback&&ca,f(b,"mousedown",this._onTapStart),f(b,"touchstart",this._onTapStart),c.supportPointer&&f(b,"pointerdown",this._onTapStart),this.nativeDraggable&&(f(b,"dragover",this),f(b,"dragenter",this)),ia.push(this._onDragOver),c.store&&this.sort(c.store.get(this))}function b(a,b){"clone"!==a.lastPullMode&&(b=!0),B&&B.state!==b&&(i(B,"display",b?"none":""),b||B.state&&(a.options.group.revertClone?(C.insertBefore(B,D),a._animate(y,B)):C.insertBefore(B,y)),B.state=b)}function c(a,b,c){if(a){c=c||X;do if(">*"===b&&a.parentNode===c||r(a,b))return a;while(a=d(a))}return null}function d(a){var b=a.host;return b&&b.nodeType?b:a.parentNode}function e(a){a.dataTransfer&&(a.dataTransfer.dropEffect="move"),a.preventDefault()}function f(a,b,c){a.addEventListener(b,c,aa)}function g(a,b,c){a.removeEventListener(b,c,aa)}function h(a,b,c){if(a)if(a.classList)a.classList[c?"add":"remove"](b);else{var d=(" "+a.className+" ").replace(T," ").replace(" "+b+" "," ");a.className=(d+(c?" "+b:"")).replace(T," ")}}function i(a,b,c){var d=a&&a.style;if(d){if(void 0===c)return X.defaultView&&X.defaultView.getComputedStyle?c=X.defaultView.getComputedStyle(a,""):a.currentStyle&&(c=a.currentStyle),void 0===b?c:c[b];b in d||(b="-webkit-"+b),d[b]=c+("string"==typeof c?"":"px")}}function j(a,b,c){if(a){var d=a.getElementsByTagName(b),e=0,f=d.length;if(c)for(;e<f;e++)c(d[e],e);return d}return[]}function k(a,b,c,d,e,f,g,h){a=a||b[V];var i=X.createEvent("Event"),j=a.options,k="on"+c.charAt(0).toUpperCase()+c.substr(1);i.initEvent(c,!0,!0),i.to=e||b,i.from=f||b,i.item=d||b,i.clone=B,i.oldIndex=g,i.newIndex=h,b.dispatchEvent(i),j[k]&&j[k].call(a,i)}function l(a,b,c,d,e,f,g,h){var i,j,k=a[V],l=k.options.onMove;return i=X.createEvent("Event"),i.initEvent("move",!0,!0),i.to=b,i.from=a,i.dragged=c,i.draggedRect=d,i.related=e||b,i.relatedRect=f||b.getBoundingClientRect(),i.willInsertAfter=h,a.dispatchEvent(i),l&&(j=l.call(k,i,g)),j}function m(a){a.draggable=!1}function n(){ea=!1}function o(a,b){var c=a.lastElementChild,d=c.getBoundingClientRect();return b.clientY-(d.top+d.height)>5||b.clientX-(d.left+d.width)>5}function p(a){for(var b=a.tagName+a.className+a.src+a.href+a.textContent,c=b.length,d=0;c--;)d+=b.charCodeAt(c);return d.toString(36)}function q(a,b){var c=0;if(!a||!a.parentNode)return-1;for(;a&&(a=a.previousElementSibling);)"TEMPLATE"===a.nodeName.toUpperCase()||">*"!==b&&!r(a,b)||c++;return c}function r(a,b){if(a){b=b.split(".");var c=b.shift().toUpperCase(),d=new RegExp("\\s("+b.join("|")+")(?=\\s)","g");return!(""!==c&&a.nodeName.toUpperCase()!=c||b.length&&((" "+a.className+" ").match(d)||[]).length!=b.length)}return!1}function s(a,b){var c,d;return function(){void 0===c&&(c=arguments,d=this,Z(function(){1===c.length?a.call(d,c[0]):a.apply(d,c),c=void 0},b))}}function t(a,b){if(a&&b)for(var c in b)b.hasOwnProperty(c)&&(a[c]=b[c]);return a}function u(a){return _&&_.dom?_.dom(a).cloneNode(!0):$?$(a).clone(!0)[0]:a.cloneNode(!0)}function v(a){for(var b=a.getElementsByTagName("input"),c=b.length;c--;){var d=b[c];d.checked&&ha.push(d)}}function w(a){return Z(a,0)}function x(a){return clearTimeout(a)}if("undefined"==typeof window||!window.document)return function(){throw new Error("Sortable.js requires a window with a document")};var y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S={},T=/\s+/g,U=/left|right|inline/,V="Sortable"+(new Date).getTime(),W=window,X=W.document,Y=W.parseInt,Z=W.setTimeout,$=W.jQuery||W.Zepto,_=W.Polymer,aa=!1,ba=!1,ca="draggable"in X.createElement("div"),da=function(a){return!navigator.userAgent.match(/(?:Trident.*rv[ :]?11\.|msie)/i)&&(a=X.createElement("x"),a.style.cssText="pointer-events:auto","auto"===a.style.pointerEvents)}(),ea=!1,fa=Math.abs,ga=Math.min,ha=[],ia=[],ja=s(function(a,b,c){if(c&&b.scroll){var d,e,f,g,h,i,j=c[V],k=b.scrollSensitivity,l=b.scrollSpeed,m=a.clientX,n=a.clientY,o=window.innerWidth,p=window.innerHeight;if(G!==c&&(F=b.scroll,G=c,H=b.scrollFn,F===!0)){F=c;do if(F.offsetWidth<F.scrollWidth||F.offsetHeight<F.scrollHeight)break;while(F=F.parentNode)}F&&(d=F,e=F.getBoundingClientRect(),f=(fa(e.right-m)<=k)-(fa(e.left-m)<=k),g=(fa(e.bottom-n)<=k)-(fa(e.top-n)<=k)),f||g||(f=(o-m<=k)-(m<=k),g=(p-n<=k)-(n<=k),(f||g)&&(d=W)),S.vx===f&&S.vy===g&&S.el===d||(S.el=d,S.vx=f,S.vy=g,clearInterval(S.pid),d&&(S.pid=setInterval(function(){return i=g?g*l:0,h=f?f*l:0,"function"==typeof H?H.call(j,h,i,a):void(d===W?W.scrollTo(W.pageXOffset+h,W.pageYOffset+i):(d.scrollTop+=i,d.scrollLeft+=h))},24)))}},30),ka=function(a){function b(a,b){return void 0!==a&&a!==!0||(a=c.name),"function"==typeof a?a:function(c,d){var e=d.options.group.name;return b?a:a&&(a.join?a.indexOf(e)>-1:e==a)}}var c={},d=a.group;d&&"object"==typeof d||(d={name:d}),c.name=d.name,c.checkPull=b(d.pull,!0),c.checkPut=b(d.put),c.revertClone=d.revertClone,a.group=c};try{window.addEventListener("test",null,Object.defineProperty({},"passive",{get:function(){ba=!1,aa={capture:!1,passive:ba}}}))}catch(a){}return a.prototype={constructor:a,_onTapStart:function(a){var b,d=this,e=this.el,f=this.options,g=f.preventOnFilter,h=a.type,i=a.touches&&a.touches[0],j=(i||a).target,l=a.target.shadowRoot&&a.path&&a.path[0]||j,m=f.filter;if(v(e),!y&&!(/mousedown|pointerdown/.test(h)&&0!==a.button||f.disabled)&&!l.isContentEditable&&(j=c(j,f.draggable,e),j&&E!==j)){if(b=q(j,f.draggable),"function"==typeof m){if(m.call(this,a,j,this))return k(d,l,"filter",j,e,e,b),void(g&&a.preventDefault())}else if(m&&(m=m.split(",").some(function(a){if(a=c(l,a.trim(),e))return k(d,a,"filter",j,e,e,b),!0})))return void(g&&a.preventDefault());f.handle&&!c(l,f.handle,e)||this._prepareDragStart(a,i,j,b)}},_prepareDragStart:function(a,b,c,d){var e,g=this,i=g.el,l=g.options,n=i.ownerDocument;c&&!y&&c.parentNode===i&&(P=a,C=i,y=c,z=y.parentNode,D=y.nextSibling,E=c,N=l.group,L=d,this._lastX=(b||a).clientX,this._lastY=(b||a).clientY,y.style["will-change"]="all",e=function(){g._disableDelayedDrag(),y.draggable=g.nativeDraggable,h(y,l.chosenClass,!0),g._triggerDragStart(a,b),k(g,C,"choose",y,C,C,L)},l.ignore.split(",").forEach(function(a){j(y,a.trim(),m)}),f(n,"mouseup",g._onDrop),f(n,"touchend",g._onDrop),f(n,"touchcancel",g._onDrop),f(n,"selectstart",g),l.supportPointer&&f(n,"pointercancel",g._onDrop),l.delay?(f(n,"mouseup",g._disableDelayedDrag),f(n,"touchend",g._disableDelayedDrag),f(n,"touchcancel",g._disableDelayedDrag),f(n,"mousemove",g._disableDelayedDrag),f(n,"touchmove",g._disableDelayedDrag),l.supportPointer&&f(n,"pointermove",g._disableDelayedDrag),g._dragStartTimer=Z(e,l.delay)):e())},_disableDelayedDrag:function(){var a=this.el.ownerDocument;clearTimeout(this._dragStartTimer),g(a,"mouseup",this._disableDelayedDrag),g(a,"touchend",this._disableDelayedDrag),g(a,"touchcancel",this._disableDelayedDrag),g(a,"mousemove",this._disableDelayedDrag),g(a,"touchmove",this._disableDelayedDrag),g(a,"pointermove",this._disableDelayedDrag)},_triggerDragStart:function(a,b){b=b||("touch"==a.pointerType?a:null),b?(P={target:y,clientX:b.clientX,clientY:b.clientY},this._onDragStart(P,"touch")):this.nativeDraggable?(f(y,"dragend",this),f(C,"dragstart",this._onDragStart)):this._onDragStart(P,!0);try{X.selection?w(function(){X.selection.empty()}):window.getSelection().removeAllRanges()}catch(a){}},_dragStarted:function(){if(C&&y){var b=this.options;h(y,b.ghostClass,!0),h(y,b.dragClass,!1),a.active=this,k(this,C,"start",y,C,C,L)}else this._nulling()},_emulateDragOver:function(){if(Q){if(this._lastX===Q.clientX&&this._lastY===Q.clientY)return;this._lastX=Q.clientX,this._lastY=Q.clientY,da||i(A,"display","none");var a=X.elementFromPoint(Q.clientX,Q.clientY),b=a,c=ia.length;if(a&&a.shadowRoot&&(a=a.shadowRoot.elementFromPoint(Q.clientX,Q.clientY),b=a),b)do{if(b[V]){for(;c--;)ia[c]({clientX:Q.clientX,clientY:Q.clientY,target:a,rootEl:b});break}a=b}while(b=b.parentNode);da||i(A,"display","")}},_onTouchMove:function(b){if(P){var c=this.options,d=c.fallbackTolerance,e=c.fallbackOffset,f=b.touches?b.touches[0]:b,g=f.clientX-P.clientX+e.x,h=f.clientY-P.clientY+e.y,j=b.touches?"translate3d("+g+"px,"+h+"px,0)":"translate("+g+"px,"+h+"px)";if(!a.active){if(d&&ga(fa(f.clientX-this._lastX),fa(f.clientY-this._lastY))<d)return;this._dragStarted()}this._appendGhost(),R=!0,Q=f,i(A,"webkitTransform",j),i(A,"mozTransform",j),i(A,"msTransform",j),i(A,"transform",j),b.preventDefault()}},_appendGhost:function(){if(!A){var a,b=y.getBoundingClientRect(),c=i(y),d=this.options;A=y.cloneNode(!0),h(A,d.ghostClass,!1),h(A,d.fallbackClass,!0),h(A,d.dragClass,!0),i(A,"top",b.top-Y(c.marginTop,10)),i(A,"left",b.left-Y(c.marginLeft,10)),i(A,"width",b.width),i(A,"height",b.height),i(A,"opacity","0.8"),i(A,"position","fixed"),i(A,"zIndex","100000"),i(A,"pointerEvents","none"),d.fallbackOnBody&&X.body.appendChild(A)||C.appendChild(A),a=A.getBoundingClientRect(),i(A,"width",2*b.width-a.width),i(A,"height",2*b.height-a.height)}},_onDragStart:function(a,b){var c=this,d=a.dataTransfer,e=c.options;c._offUpEvents(),N.checkPull(c,c,y,a)&&(B=u(y),B.draggable=!1,B.style["will-change"]="",i(B,"display","none"),h(B,c.options.chosenClass,!1),c._cloneId=w(function(){C.insertBefore(B,y),k(c,C,"clone",y)})),h(y,e.dragClass,!0),b?("touch"===b?(f(X,"touchmove",c._onTouchMove),f(X,"touchend",c._onDrop),f(X,"touchcancel",c._onDrop),e.supportPointer&&(f(X,"pointermove",c._onTouchMove),f(X,"pointerup",c._onDrop))):(f(X,"mousemove",c._onTouchMove),f(X,"mouseup",c._onDrop)),c._loopId=setInterval(c._emulateDragOver,50)):(d&&(d.effectAllowed="move",e.setData&&e.setData.call(c,d,y)),f(X,"drop",c),c._dragStartId=w(c._dragStarted))},_onDragOver:function(d){var e,f,g,h,j=this.el,k=this.options,m=k.group,p=a.active,q=N===m,r=!1,s=k.sort;if(void 0!==d.preventDefault&&(d.preventDefault(),!k.dragoverBubble&&d.stopPropagation()),!y.animated&&(R=!0,p&&!k.disabled&&(q?s||(h=!C.contains(y)):O===this||(p.lastPullMode=N.checkPull(this,p,y,d))&&m.checkPut(this,p,y,d))&&(void 0===d.rootEl||d.rootEl===this.el))){if(ja(d,k,this.el),ea)return;if(e=c(d.target,k.draggable,j),f=y.getBoundingClientRect(),O!==this&&(O=this,r=!0),h)return b(p,!0),z=C,void(B||D?C.insertBefore(y,B||D):s||C.appendChild(y));if(0===j.children.length||j.children[0]===A||j===d.target&&o(j,d)){if(0!==j.children.length&&j.children[0]!==A&&j===d.target&&(e=j.lastElementChild),e){if(e.animated)return;g=e.getBoundingClientRect()}b(p,q),l(C,j,y,f,e,g,d)!==!1&&(y.contains(j)||(j.appendChild(y),z=j),this._animate(f,y),e&&this._animate(g,e))}else if(e&&!e.animated&&e!==y&&void 0!==e.parentNode[V]){I!==e&&(I=e,J=i(e),K=i(e.parentNode)),g=e.getBoundingClientRect();var t=g.right-g.left,u=g.bottom-g.top,v=U.test(J.cssFloat+J.display)||"flex"==K.display&&0===K["flex-direction"].indexOf("row"),w=e.offsetWidth>y.offsetWidth,x=e.offsetHeight>y.offsetHeight,E=(v?(d.clientX-g.left)/t:(d.clientY-g.top)/u)>.5,F=e.nextElementSibling,G=!1;if(v){var H=y.offsetTop,L=e.offsetTop;G=H===L?e.previousElementSibling===y&&!w||E&&w:e.previousElementSibling===y||y.previousElementSibling===e?(d.clientY-g.top)/u>.5:L>H}else r||(G=F!==y&&!x||E&&x);var M=l(C,j,y,f,e,g,d,G);M!==!1&&(1!==M&&M!==-1||(G=1===M),ea=!0,Z(n,30),b(p,q),y.contains(j)||(G&&!F?j.appendChild(y):e.parentNode.insertBefore(y,G?F:e)),z=y.parentNode,this._animate(f,y),this._animate(g,e))}}},_animate:function(a,b){var c=this.options.animation;if(c){var d=b.getBoundingClientRect();1===a.nodeType&&(a=a.getBoundingClientRect()),i(b,"transition","none"),i(b,"transform","translate3d("+(a.left-d.left)+"px,"+(a.top-d.top)+"px,0)"),b.offsetWidth,i(b,"transition","all "+c+"ms"),i(b,"transform","translate3d(0,0,0)"),clearTimeout(b.animated),b.animated=Z(function(){i(b,"transition",""),i(b,"transform",""),b.animated=!1},c)}},_offUpEvents:function(){var a=this.el.ownerDocument;g(X,"touchmove",this._onTouchMove),g(X,"pointermove",this._onTouchMove),g(a,"mouseup",this._onDrop),g(a,"touchend",this._onDrop),g(a,"pointerup",this._onDrop),g(a,"touchcancel",this._onDrop),g(a,"pointercancel",this._onDrop),g(a,"selectstart",this)},_onDrop:function(b){var c=this.el,d=this.options;clearInterval(this._loopId),clearInterval(S.pid),clearTimeout(this._dragStartTimer),x(this._cloneId),x(this._dragStartId),g(X,"mouseover",this),g(X,"mousemove",this._onTouchMove),this.nativeDraggable&&(g(X,"drop",this),g(c,"dragstart",this._onDragStart)),this._offUpEvents(),b&&(R&&(b.preventDefault(),!d.dropBubble&&b.stopPropagation()),A&&A.parentNode&&A.parentNode.removeChild(A),C!==z&&"clone"===a.active.lastPullMode||B&&B.parentNode&&B.parentNode.removeChild(B),y&&(this.nativeDraggable&&g(y,"dragend",this),m(y),y.style["will-change"]="",h(y,this.options.ghostClass,!1),h(y,this.options.chosenClass,!1),k(this,C,"unchoose",y,z,C,L),C!==z?(M=q(y,d.draggable),M>=0&&(k(null,z,"add",y,z,C,L,M),k(this,C,"remove",y,z,C,L,M),k(null,z,"sort",y,z,C,L,M),k(this,C,"sort",y,z,C,L,M))):y.nextSibling!==D&&(M=q(y,d.draggable),M>=0&&(k(this,C,"update",y,z,C,L,M),k(this,C,"sort",y,z,C,L,M))),a.active&&(null!=M&&M!==-1||(M=L),k(this,C,"end",y,z,C,L,M),this.save()))),this._nulling()},_nulling:function(){C=y=z=A=D=B=E=F=G=P=Q=R=M=I=J=O=N=a.active=null,ha.forEach(function(a){a.checked=!0}),ha.length=0},handleEvent:function(a){switch(a.type){case"drop":case"dragend":this._onDrop(a);break;case"dragover":case"dragenter":y&&(this._onDragOver(a),e(a));break;case"mouseover":this._onDrop(a);break;case"selectstart":a.preventDefault()}},toArray:function(){for(var a,b=[],d=this.el.children,e=0,f=d.length,g=this.options;e<f;e++)a=d[e],c(a,g.draggable,this.el)&&b.push(a.getAttribute(g.dataIdAttr)||p(a));return b},sort:function(a){var b={},d=this.el;this.toArray().forEach(function(a,e){var f=d.children[e];c(f,this.options.draggable,d)&&(b[a]=f)},this),a.forEach(function(a){b[a]&&(d.removeChild(b[a]),d.appendChild(b[a]))})},save:function(){var a=this.options.store;a&&a.set(this)},closest:function(a,b){return c(a,b||this.options.draggable,this.el)},option:function(a,b){var c=this.options;return void 0===b?c[a]:(c[a]=b,void("group"===a&&ka(c)))},destroy:function(){var a=this.el;a[V]=null,g(a,"mousedown",this._onTapStart),g(a,"touchstart",this._onTapStart),g(a,"pointerdown",this._onTapStart),this.nativeDraggable&&(g(a,"dragover",this),g(a,"dragenter",this)),Array.prototype.forEach.call(a.querySelectorAll("[draggable]"),function(a){a.removeAttribute("draggable")}),ia.splice(ia.indexOf(this._onDragOver),1),this._onDrop(),this.el=a=null}},f(X,"touchmove",function(b){a.active&&b.preventDefault()}),a.utils={on:f,off:g,css:i,find:j,is:function(a,b){return!!c(a,b,a)},extend:t,throttle:s,closest:c,toggleClass:h,clone:u,index:q,nextTick:w,cancelNextTick:x},a.create=function(b,c){return new a(b,c)},a.version="1.7.0",a});
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  "use strict";

  if (!Array.from) {
    Array.from = function (object) {
      return [].slice.call(object);
    };
  }

  function buildAttribute(object, propName, value) {
    if (value == undefined) {
      return object;
    }
    object = object == null ? {} : object;
    object[propName] = value;
    return object;
  }

  function buildDraggable(Sortable) {
    function removeNode(node) {
      node.parentElement.removeChild(node);
    }

    function insertNodeAt(fatherNode, node, position) {
      var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
      fatherNode.insertBefore(node, refNode);
    }

    function computeVmIndex(vnodes, element) {
      return vnodes.map(function (elt) {
        return elt.elm;
      }).indexOf(element);
    }

    function _computeIndexes(slots, children, isTransition) {
      if (!slots) {
        return [];
      }

      var elmFromNodes = slots.map(function (elt) {
        return elt.elm;
      });
      var rawIndexes = [].concat(_toConsumableArray(children)).map(function (elt) {
        return elmFromNodes.indexOf(elt);
      });
      return isTransition ? rawIndexes.filter(function (ind) {
        return ind !== -1;
      }) : rawIndexes;
    }

    function emit(evtName, evtData) {
      var _this = this;

      this.$nextTick(function () {
        return _this.$emit(evtName.toLowerCase(), evtData);
      });
    }

    function delegateAndEmit(evtName) {
      var _this2 = this;

      return function (evtData) {
        if (_this2.realList !== null) {
          _this2['onDrag' + evtName](evtData);
        }
        emit.call(_this2, evtName, evtData);
      };
    }

    var eventsListened = ['Start', 'Add', 'Remove', 'Update', 'End'];
    var eventsToEmit = ['Choose', 'Sort', 'Filter', 'Clone'];
    var readonlyProperties = ['Move'].concat(eventsListened, eventsToEmit).map(function (evt) {
      return 'on' + evt;
    });
    var draggingElement = null;

    var props = {
      options: Object,
      list: {
        type: Array,
        required: false,
        default: null
      },
      value: {
        type: Array,
        required: false,
        default: null
      },
      noTransitionOnDrag: {
        type: Boolean,
        default: false
      },
      clone: {
        type: Function,
        default: function _default(original) {
          return original;
        }
      },
      element: {
        type: String,
        default: 'div'
      },
      move: {
        type: Function,
        default: null
      },
      componentData: {
        type: Object,
        required: false,
        default: null
      }
    };

    var draggableComponent = {
      name: 'draggable',

      props: props,

      data: function data() {
        return {
          transitionMode: false,
          noneFunctionalComponentMode: false,
          init: false
        };
      },
      render: function render(h) {
        var slots = this.$slots.default;
        if (slots && slots.length === 1) {
          var child = slots[0];
          if (child.componentOptions && child.componentOptions.tag === "transition-group") {
            this.transitionMode = true;
          }
        }
        var children = slots;
        var footer = this.$slots.footer;

        if (footer) {
          children = slots ? [].concat(_toConsumableArray(slots), _toConsumableArray(footer)) : [].concat(_toConsumableArray(footer));
        }
        var attributes = null;
        var update = function update(name, value) {
          attributes = buildAttribute(attributes, name, value);
        };
        update('attrs', this.$attrs);
        if (this.componentData) {
          var _componentData = this.componentData,
              on = _componentData.on,
              _props = _componentData.props;

          update('on', on);
          update('props', _props);
        }
        return h(this.element, attributes, children);
      },
      mounted: function mounted() {
        var _this3 = this;

        this.noneFunctionalComponentMode = this.element.toLowerCase() !== this.$el.nodeName.toLowerCase();
        if (this.noneFunctionalComponentMode && this.transitionMode) {
          throw new Error('Transition-group inside component is not supported. Please alter element value or remove transition-group. Current element value: ' + this.element);
        }
        var optionsAdded = {};
        eventsListened.forEach(function (elt) {
          optionsAdded['on' + elt] = delegateAndEmit.call(_this3, elt);
        });

        eventsToEmit.forEach(function (elt) {
          optionsAdded['on' + elt] = emit.bind(_this3, elt);
        });

        var options = _extends({}, this.options, optionsAdded, { onMove: function onMove(evt, originalEvent) {
            return _this3.onDragMove(evt, originalEvent);
          } });
        !('draggable' in options) && (options.draggable = '>*');
        this._sortable = new Sortable(this.rootContainer, options);
        this.computeIndexes();
      },
      beforeDestroy: function beforeDestroy() {
        this._sortable.destroy();
      },


      computed: {
        rootContainer: function rootContainer() {
          return this.transitionMode ? this.$el.children[0] : this.$el;
        },
        isCloning: function isCloning() {
          return !!this.options && !!this.options.group && this.options.group.pull === 'clone';
        },
        realList: function realList() {
          return !!this.list ? this.list : this.value;
        }
      },

      watch: {
        options: {
          handler: function handler(newOptionValue) {
            for (var property in newOptionValue) {
              if (readonlyProperties.indexOf(property) == -1) {
                this._sortable.option(property, newOptionValue[property]);
              }
            }
          },

          deep: true
        },

        realList: function realList() {
          this.computeIndexes();
        }
      },

      methods: {
        getChildrenNodes: function getChildrenNodes() {
          if (!this.init) {
            this.noneFunctionalComponentMode = this.noneFunctionalComponentMode && this.$children.length == 1;
            this.init = true;
          }

          if (this.noneFunctionalComponentMode) {
            return this.$children[0].$slots.default;
          }
          var rawNodes = this.$slots.default;
          return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
        },
        computeIndexes: function computeIndexes() {
          var _this4 = this;

          this.$nextTick(function () {
            _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode);
          });
        },
        getUnderlyingVm: function getUnderlyingVm(htmlElt) {
          var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);
          if (index === -1) {
            //Edge case during move callback: related element might be
            //an element different from collection
            return null;
          }
          var element = this.realList[index];
          return { index: index, element: element };
        },
        getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
          var __vue__ = _ref.__vue__;

          if (!__vue__ || !__vue__.$options || __vue__.$options._componentTag !== "transition-group") {
            return __vue__;
          }
          return __vue__.$parent;
        },
        emitChanges: function emitChanges(evt) {
          var _this5 = this;

          this.$nextTick(function () {
            _this5.$emit('change', evt);
          });
        },
        alterList: function alterList(onList) {
          if (!!this.list) {
            onList(this.list);
          } else {
            var newList = [].concat(_toConsumableArray(this.value));
            onList(newList);
            this.$emit('input', newList);
          }
        },
        spliceList: function spliceList() {
          var _arguments = arguments;

          var spliceList = function spliceList(list) {
            return list.splice.apply(list, _arguments);
          };
          this.alterList(spliceList);
        },
        updatePosition: function updatePosition(oldIndex, newIndex) {
          var updatePosition = function updatePosition(list) {
            return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
          };
          this.alterList(updatePosition);
        },
        getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
          var to = _ref2.to,
              related = _ref2.related;

          var component = this.getUnderlyingPotencialDraggableComponent(to);
          if (!component) {
            return { component: component };
          }
          var list = component.realList;
          var context = { list: list, component: component };
          if (to !== related && list && component.getUnderlyingVm) {
            var destination = component.getUnderlyingVm(related);
            if (destination) {
              return _extends(destination, context);
            }
          }

          return context;
        },
        getVmIndex: function getVmIndex(domIndex) {
          var indexes = this.visibleIndexes;
          var numberIndexes = indexes.length;
          return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
        },
        getComponent: function getComponent() {
          return this.$slots.default[0].componentInstance;
        },
        resetTransitionData: function resetTransitionData(index) {
          if (!this.noTransitionOnDrag || !this.transitionMode) {
            return;
          }
          var nodes = this.getChildrenNodes();
          nodes[index].data = null;
          var transitionContainer = this.getComponent();
          transitionContainer.children = [];
          transitionContainer.kept = undefined;
        },
        onDragStart: function onDragStart(evt) {
          this.context = this.getUnderlyingVm(evt.item);
          evt.item._underlying_vm_ = this.clone(this.context.element);
          draggingElement = evt.item;
        },
        onDragAdd: function onDragAdd(evt) {
          var element = evt.item._underlying_vm_;
          if (element === undefined) {
            return;
          }
          removeNode(evt.item);
          var newIndex = this.getVmIndex(evt.newIndex);
          this.spliceList(newIndex, 0, element);
          this.computeIndexes();
          var added = { element: element, newIndex: newIndex };
          this.emitChanges({ added: added });
        },
        onDragRemove: function onDragRemove(evt) {
          insertNodeAt(this.rootContainer, evt.item, evt.oldIndex);
          if (this.isCloning) {
            removeNode(evt.clone);
            return;
          }
          var oldIndex = this.context.index;
          this.spliceList(oldIndex, 1);
          var removed = { element: this.context.element, oldIndex: oldIndex };
          this.resetTransitionData(oldIndex);
          this.emitChanges({ removed: removed });
        },
        onDragUpdate: function onDragUpdate(evt) {
          removeNode(evt.item);
          insertNodeAt(evt.from, evt.item, evt.oldIndex);
          var oldIndex = this.context.index;
          var newIndex = this.getVmIndex(evt.newIndex);
          this.updatePosition(oldIndex, newIndex);
          var moved = { element: this.context.element, oldIndex: oldIndex, newIndex: newIndex };
          this.emitChanges({ moved: moved });
        },
        computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
          if (!relatedContext.element) {
            return 0;
          }
          var domChildren = [].concat(_toConsumableArray(evt.to.children)).filter(function (el) {
            return el.style['display'] !== 'none';
          });
          var currentDOMIndex = domChildren.indexOf(evt.related);
          var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
          var draggedInList = domChildren.indexOf(draggingElement) != -1;
          return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
        },
        onDragMove: function onDragMove(evt, originalEvent) {
          var onMove = this.move;
          if (!onMove || !this.realList) {
            return true;
          }

          var relatedContext = this.getRelatedContextFromMoveEvent(evt);
          var draggedContext = this.context;
          var futureIndex = this.computeFutureIndex(relatedContext, evt);
          _extends(draggedContext, { futureIndex: futureIndex });
          _extends(evt, { relatedContext: relatedContext, draggedContext: draggedContext });
          return onMove(evt, originalEvent);
        },
        onDragEnd: function onDragEnd(evt) {
          this.computeIndexes();
          draggingElement = null;
        }
      }
    };
    return draggableComponent;
  }

  if (typeof exports == "object") {
    var Sortable = require("sortablejs");
    module.exports = buildDraggable(Sortable);
  } else if (typeof define == "function" && define.amd) {
    define(['sortablejs'], function (Sortable) {
      return buildDraggable(Sortable);
    });
  } else if (window && window.Vue && window.Sortable) {
    var draggable = buildDraggable(window.Sortable);
    Vue.component('draggable', draggable);
  }
})();
/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}

					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}

				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			var jar = {};
			var decode = function (s) {
				return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
			};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function (key) {
			return api.call({
				json: true
			}, key);
		};
		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

!function(n){"use strict";function t(n,t){var r=(65535&n)+(65535&t);return(n>>16)+(t>>16)+(r>>16)<<16|65535&r}function r(n,t){return n<<t|n>>>32-t}function e(n,e,o,u,c,f){return t(r(t(t(e,n),t(u,f)),c),o)}function o(n,t,r,o,u,c,f){return e(t&r|~t&o,n,t,u,c,f)}function u(n,t,r,o,u,c,f){return e(t&o|r&~o,n,t,u,c,f)}function c(n,t,r,o,u,c,f){return e(t^r^o,n,t,u,c,f)}function f(n,t,r,o,u,c,f){return e(r^(t|~o),n,t,u,c,f)}function i(n,r){n[r>>5]|=128<<r%32,n[14+(r+64>>>9<<4)]=r;var e,i,a,d,h,l=1732584193,g=-271733879,v=-1732584194,m=271733878;for(e=0;e<n.length;e+=16)i=l,a=g,d=v,h=m,g=f(g=f(g=f(g=f(g=c(g=c(g=c(g=c(g=u(g=u(g=u(g=u(g=o(g=o(g=o(g=o(g,v=o(v,m=o(m,l=o(l,g,v,m,n[e],7,-680876936),g,v,n[e+1],12,-389564586),l,g,n[e+2],17,606105819),m,l,n[e+3],22,-1044525330),v=o(v,m=o(m,l=o(l,g,v,m,n[e+4],7,-176418897),g,v,n[e+5],12,1200080426),l,g,n[e+6],17,-1473231341),m,l,n[e+7],22,-45705983),v=o(v,m=o(m,l=o(l,g,v,m,n[e+8],7,1770035416),g,v,n[e+9],12,-1958414417),l,g,n[e+10],17,-42063),m,l,n[e+11],22,-1990404162),v=o(v,m=o(m,l=o(l,g,v,m,n[e+12],7,1804603682),g,v,n[e+13],12,-40341101),l,g,n[e+14],17,-1502002290),m,l,n[e+15],22,1236535329),v=u(v,m=u(m,l=u(l,g,v,m,n[e+1],5,-165796510),g,v,n[e+6],9,-1069501632),l,g,n[e+11],14,643717713),m,l,n[e],20,-373897302),v=u(v,m=u(m,l=u(l,g,v,m,n[e+5],5,-701558691),g,v,n[e+10],9,38016083),l,g,n[e+15],14,-660478335),m,l,n[e+4],20,-405537848),v=u(v,m=u(m,l=u(l,g,v,m,n[e+9],5,568446438),g,v,n[e+14],9,-1019803690),l,g,n[e+3],14,-187363961),m,l,n[e+8],20,1163531501),v=u(v,m=u(m,l=u(l,g,v,m,n[e+13],5,-1444681467),g,v,n[e+2],9,-51403784),l,g,n[e+7],14,1735328473),m,l,n[e+12],20,-1926607734),v=c(v,m=c(m,l=c(l,g,v,m,n[e+5],4,-378558),g,v,n[e+8],11,-2022574463),l,g,n[e+11],16,1839030562),m,l,n[e+14],23,-35309556),v=c(v,m=c(m,l=c(l,g,v,m,n[e+1],4,-1530992060),g,v,n[e+4],11,1272893353),l,g,n[e+7],16,-155497632),m,l,n[e+10],23,-1094730640),v=c(v,m=c(m,l=c(l,g,v,m,n[e+13],4,681279174),g,v,n[e],11,-358537222),l,g,n[e+3],16,-722521979),m,l,n[e+6],23,76029189),v=c(v,m=c(m,l=c(l,g,v,m,n[e+9],4,-640364487),g,v,n[e+12],11,-421815835),l,g,n[e+15],16,530742520),m,l,n[e+2],23,-995338651),v=f(v,m=f(m,l=f(l,g,v,m,n[e],6,-198630844),g,v,n[e+7],10,1126891415),l,g,n[e+14],15,-1416354905),m,l,n[e+5],21,-57434055),v=f(v,m=f(m,l=f(l,g,v,m,n[e+12],6,1700485571),g,v,n[e+3],10,-1894986606),l,g,n[e+10],15,-1051523),m,l,n[e+1],21,-2054922799),v=f(v,m=f(m,l=f(l,g,v,m,n[e+8],6,1873313359),g,v,n[e+15],10,-30611744),l,g,n[e+6],15,-1560198380),m,l,n[e+13],21,1309151649),v=f(v,m=f(m,l=f(l,g,v,m,n[e+4],6,-145523070),g,v,n[e+11],10,-1120210379),l,g,n[e+2],15,718787259),m,l,n[e+9],21,-343485551),l=t(l,i),g=t(g,a),v=t(v,d),m=t(m,h);return[l,g,v,m]}function a(n){var t,r="",e=32*n.length;for(t=0;t<e;t+=8)r+=String.fromCharCode(n[t>>5]>>>t%32&255);return r}function d(n){var t,r=[];for(r[(n.length>>2)-1]=void 0,t=0;t<r.length;t+=1)r[t]=0;var e=8*n.length;for(t=0;t<e;t+=8)r[t>>5]|=(255&n.charCodeAt(t/8))<<t%32;return r}function h(n){return a(i(d(n),8*n.length))}function l(n,t){var r,e,o=d(n),u=[],c=[];for(u[15]=c[15]=void 0,o.length>16&&(o=i(o,8*n.length)),r=0;r<16;r+=1)u[r]=909522486^o[r],c[r]=1549556828^o[r];return e=i(u.concat(d(t)),512+8*t.length),a(i(c.concat(e),640))}function g(n){var t,r,e="";for(r=0;r<n.length;r+=1)t=n.charCodeAt(r),e+="0123456789abcdef".charAt(t>>>4&15)+"0123456789abcdef".charAt(15&t);return e}function v(n){return unescape(encodeURIComponent(n))}function m(n){return h(v(n))}function p(n){return g(m(n))}function s(n,t){return l(v(n),v(t))}function C(n,t){return g(s(n,t))}function A(n,t,r){return t?r?s(t,n):C(t,n):r?m(n):p(n)}"function"==typeof define&&define.amd?define(function(){return A}):"object"==typeof module&&module.exports?module.exports=A:n.md5=A}(this);
//# sourceMappingURL=md5.min.js.map
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 17.02.2019
 */

window.ks = {
    // Приложение Vue
    app: null,
    // Клиент для AJAX-запросов
    client: null
};
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 22.09.2017
 */

(function() {

    ks.Client = function() {

        this._baseUrl = '/ajax/';

        this._getUrl = function(controller, action) {
            return this._baseUrl + controller + '/' + action;
        };

        this.last = {
            url: '',
            error: ks.consts.ERR_OK
        };

        this._onRequestEvent = function(error, json, onRequest, disableLoader, userData) {
            this.last.error = error;

            if (error !== ks.consts.ERR_OK && ! json.errors) {
                json.errors = {
                    global: 'Произошла непредвиденная ошибка #1000g.'
                };
            }
            
            if (disableLoader !== true && ! json.redirect && ! json.reload) {
                ks.app.$refs.loader.hide();
            }

            if (onRequest) {
                onRequest(error, json, userData);
            }

            if (json.redirect) {
                window.location.href = json.redirect;
            } else {
                if (json.reload) {
                    window.location.reload(true);
                }
            }
        };

        this._fillInfo = function(data) {
            data.screenSize = window.screen.width + 'x' + window.screen.height;
            data.path = window.location.pathname;
        };

        this.request = function(options, disableLoader) {
            var self = this,
                data = typeof options.data === 'object' ? $.extend({}, options.data) : {},
                userData = options.userData || null;

            this._fillInfo(data);

            this.last.url = this._getUrl(options.controller, options.action);

            if (disableLoader !== true) {
                ks.app.$refs.loader.show();
            }
            
            $.ajax({
                type: 'POST',
                url: this.last.url,
                data: data,
                cache: false,
                success: function(json) {
                    var dataJson = typeof json !== 'object' ? {} : json,
                        error = typeof dataJson.error !== 'number' ? ks.consts.ERR_UNKNOWN : dataJson.error;
                    
                    if (error === ks.consts.ERR_PARENT_BANNED) {
                        window.location.href = 'https://kids-smart.ru';
                        return;
                    }
                    
                    self._onRequestEvent(error, dataJson, options.onRequest, disableLoader, userData);
                },
                error: function(XMLHttpRequest, textStatus, errorThrown) {
                    self._onRequestEvent(ks.consts.ERR_UNKNOWN, {}, options.onRequest, disableLoader, userData);
                }
            });
        };

        this.uploadFile = function(options, disableLoader) {
            var self = this,
                data = new FormData(),
                userData = options.userData || null;

            data.append(options.file.name, options.file.data);

            this.last.url = this._getUrl(options.controller, options.action);

            if (disableLoader !== true) {
                ks.app.$refs.loader.show();
            }

            $.ajax({
                type: 'POST',
                url: this.last.url,
                data: data,
                cache: false,
                //dataType: 'json',
                processData: false,
                contentType: false,
                success: function(json) {
                    var dataJson = typeof json !== 'object' ? {} : json,
                        error = typeof dataJson.error !== 'number' ? ks.consts.ERR_UNKNOWN : dataJson.error;

                    self._onRequestEvent(error, dataJson, options.onRequest, disableLoader, userData);
                },
                error: function(XMLHttpRequest, textStatus, errorThrown) {
                    self._onRequestEvent(ks.consts.ERR_UNKNOWN, {}, options.onRequest, disableLoader, userData);
                }
            });
        };

    };

}());
/**
 * (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 09.11.2017
 */

(function(){

    ks.core = {

        // События, которые вызываются после создания app
        _app: {
            // Список компонентов Vue (создаются автоматически)
            components: {},

            // События, которые вызываются после создания app
            createEvents: []
        },

        _store: {
            // Список модулей Vuex
            modules: {},

            // События, которые вызываются после загрузки Store
            loadEvents: [],

            // Флаг загружен или нет Store
            loaded: false
        },

        addComponent: function(name, component) {
            if ( ! (name in this._app.components)) {
                this._app.components[name] = component;
            }

            return this;
        },

        /**
         * moduleObject = {
         *      module: module,
         *      eventLoad: eventLoad - function(store) {}
         * }
         *
         * @param name
         * @param moduleObject
         */
        addStoreModule: function(name, moduleObject) {
            if ( ! (name in this._store.modules)) {
                this._store.modules[name] = moduleObject;
            }

            return this;
        },

        addStoreLoadEvent: function(event) {
            this._store.loadEvents.push(event);

            // Если store уже загружен, то вызываем событие
            if (this._store.loaded) {
                event();
            }

            return this;
        },

        getStoreModules: function() {
            var modules = {};

            for(var name in this._store.modules) {
                modules[name] = this._store.modules[name].module;
            }

            return modules;
        },

        getInitStoreData: function(name) {
            if (typeof ksStore === 'undefined') return null;

            if (typeof name === 'string') {
                return typeof ksStore[name] !== 'undefined' ? ksStore[name] : null;
            } else {
                return ksStore;
            }
        },

        addAppCreateEvent: function(event) {
            this._app.createEvents.push(event);

            return this;
        },

        getComponents: function() {
            return this._app.components;
        },

        onCreateApp: function() {
            this._app.createEvents.forEach(function(event) {
                event();
            });
        },

        onLoadStore: function(store) {
            this._store.loaded = true;

            for(var name in this._store.modules) {
                this._store.modules[name].eventLoad(store);
            }

            this._store.loadEvents.forEach(function(event) {
                event(store);
            });
        }
    };

    ks.createClient = function() {
        this.client = new ks.Client();

        return ks;
    };

    ks.createStore = function() {
        var store = new Vuex.Store({

            state: {
                isBot: false,

                role: ks.consts.ROLE_GUEST,

                promocode: {
                    active: false,
                    discountMode: null,
                    discount: 0,
                    expireDate: null,
                    timeLeft: null,
                    periods: []
                },

                pricePostfix: null,

                wheelFortuneNotifyShown: false,

                sessionMessage: null,

                isPortraitScreenOrientation: false,

                canInstallApp: false,
                installAppDeferredPrompt: null
            },

            mutations: {
                setIsBot: function(state, isBot) {
                    state.isBot = isBot;
                },

                setRole: function(state, role) {
                    state.role = role;
                },

                setSessionMessage: function(state, sessionMessage) {
                    state.sessionMessage = sessionMessage;
                },

                setAvailableExercises: function(state, count) {
                    if (state.role === ks.consts.ROLE_GUEST) {
                        store.commit('guest/setAvailableExercises', count);
                        return true;
                    }

                    if (state.role === ks.consts.ROLE_KID) {
                        store.commit('kid/setAvailableExercises', count);
                        return true;
                    }

                    return false;
                },

                setPromocode: function(state, promocode) {
                    state.promocode.active = promocode.active;
                    state.promocode.discountMode = promocode.discountMode;
                    state.promocode.discount = promocode.discount;
                    state.promocode.expireDate = promocode.expireDate;
                    state.promocode.timeLeft  = promocode.timeLeft;
                    state.promocode.periods = promocode.periods;
                },

                setPricePostfix: function(state, pricePostfix){
                    state.pricePostfix = pricePostfix;
                },

                setWheelFortuneNotifyShown: function(state, shown){
                    state.wheelFortuneNotifyShown = shown;
                },

                setIsPortraitScreenOrientation: function(state, value) {
                    state.isPortraitScreenOrientation = value;
                },

                setInstallAppDeferredPrompt(state, deferredPrompt) {
                  state.installAppDeferredPrompt = deferredPrompt;
                  state.canInstallApp = deferredPrompt !== null;

                  ks.helpers.cookies.set('canInstallApp', state.canInstallApp);
                },

                clearInstallAppDeferredPrompt(state) {
                  state.installAppDeferredPrompt = null;
                  state.canInstallApp = false;

                  ks.helpers.cookies.set('canInstallApp', state.canInstallApp);
                },

                setCanInstallApp(state, canInstallApp) {
                  state.canInstallApp = canInstallApp;
                }
            },

            getters: {
                isGuest: function(state) {
                    return state.role === ks.consts.ROLE_GUEST;
                },

                isKid: function(state) {
                    return state.role === ks.consts.ROLE_KID;
                },

                isParent: function(state) {
                    return state.role === ks.consts.ROLE_PARENT;
                },

                getAvailableExercises: function(state) {
                    var name = state.role === ks.consts.ROLE_GUEST ? 'guest' : 'kid';
                    return store.getters[name + '/getAvailableExercises'];
                },

                getExercisesDayLimit: function(state) {
                    var name = state.role === ks.consts.ROLE_GUEST ? 'guest' : 'kid';
                    return store.getters[name + '/getExercisesDayLimit'];
                },

                isPortraitScreenOrientation: function(state) {
                    return state.isPortraitScreenOrientation;
                },

                getInstallAppDeferredPrompt(state) {
                  return state.installAppDeferredPrompt;
                },

                canInstallApp(state) {
                  return state.canInstallApp;
                }
            },

            modules: this.core.getStoreModules()

        });

        return store;
    };

    ks.loadStore = function(store) {
        const canInstallApp = Cookies.get('canInstallApp') === 'true';
        store.commit('setCanInstallApp', canInstallApp);

        var data =  this.core.getInitStoreData();
        if (data === null) return;

        store.commit('setIsBot', data.isBot);
        store.commit('setRole', data.role);

        if (typeof data.promocode !== 'undefined') {
            store.commit('setPromocode', data.promocode);
        }

        if (typeof data.pricePostfix !== 'undefined'){
            store.commit('setPricePostfix', data.pricePostfix);
        }

        if (typeof data.sessionMessage !== 'undefined') {
            store.commit('setSessionMessage', data.sessionMessage);
        }

        return this;
    };

    ks.createApp = function() {
        Vue.use(VueHammer);

        var self = this;

        this.app = new Vue({

            el: '#app',

            store: self.createStore(),

            data: {
                loaded: false
            },

            computed: {

            },

            methods: {
                canAutoSwitchUser: function(role){
                    switch (role) {
                        case 'parent':
                            return this.$store.getters['parent/canAutoSwitchToParent'];

                        case 'kid':
                            return this.$store.getters['parent/canAutoSwitchToKid'];
                    }

                    return false;
                },

                switchUser: function(options){
                    this.$refs.switchUser.show(options);
                },

                showLogin: function(email, password, errors, reload, signupMode) {
                    this.showLoginEx({ email, password, errors, reload, signupMode });
                },

                showLoginEx: function(options) {
                    this.$refs.loginDlg.showLogin(options);
                },

                needParentPassword: function() {
                    return this.$store.state.parent.options.need_parent_password;
                },

                /**
                 * @param {Number} role
                 * @param {Number} id
                 * @returns {Boolean}
                 */
                isLogged: function(role, id) {
                    if (this.$store.state.role !== role) {
                        return false;
                    }

                    if (role === ks.consts.ROLE_PARENT) {
                        return true;
                    } else {
                        return typeof id === 'undefined' ? true : this.$store.state.kid.id === id;
                    }
                },

                go: function(url) {
                    window.location.href = url;
                },

                reloadPage: function() {
                    window.location.reload();
                },

                applyPageBackgroundImage: function(image) {
                    var body = $('body');

                    if (image === '') {
                        body.css('background-image', '').addClass('body-std');
                    } else {
                        body.removeClass('body-std').css('background-image', 'url(' + image + ')');
                    }
                },

                processSessionMessage: function(msg) {
                    let self = this;

                    this.$nextTick(function() {
                        setTimeout(function() {
                            self.$refs.messageBox.show({
                                type    : msg.type,
                                title   : msg.title,
                                text    : msg.text,
                                buttons : typeof msg.buttons !== 'undefined' ? msg.buttons : ks.consts.MBB_OK
                            });
                        }, 500);
                    });
                },

                messageBox: function(options) {
                    this.$refs.messageBox.show(options);
                },

                showLoader: function() {
                  this.$refs.loader.show();
                },

                hideLoader: function() {
                  this.$refs.loader.hide();
                },

                showSignup: function(options){
                    this.$refs.signupDlg.show(options);
                },

                // 11.08.2021
                showOfferTrialTraining: function(){
                    if ( ! this.$store.getters.isKid || ! this.$store.state.kid.trainingTrial) {
                        return false;
                    }

                    let self = this;
                    setTimeout(function(){
                        self.$refs.offerTrialTraining.show();
                    }, 500);
                },
                //--

                // 01.03.2022
                showWheelFortuneDlg: function(){
                    try {
                        this.$refs.wheelFortuneDlg.show();

                        ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_WHEEL_FORTUNE_OPEN);
                    } catch (e) {}
                },

                setPromocode: function(promocode, apply, autoMode){
                    if (this.isLogged(ks.consts.ROLE_PARENT)) {
                        this.$refs.profilePayment.setPromocode(promocode, apply, autoMode);
                    } else {
                        if (this.$store.getters.isGuest) {
                            this.$refs.payment.setPromocode(promocode, apply, autoMode);
                        }
                    }
                },
                //--

                // 15.05.2023
                onWindowResize: function() {
                    this.$store.commit('setIsPortraitScreenOrientation', document.documentElement.clientWidth < document.documentElement.clientHeight);
                },
                //--

                async startInstallApp() {
                  if (! this.$store.getters.canInstallApp) {
                    return;
                  }

                  const deferredPrompt = this.$store.getters.getInstallAppDeferredPrompt;
                  if (deferredPrompt === null) {
                    return;
                  }

                  ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_PWA_PROMPT_INSTALL);

                  deferredPrompt.prompt();

                  // 'accepted' | 'dismissed'
                  const { outcome } = await deferredPrompt.userChoice;
                  if (outcome !== 'accepted') {
                    return;
                  }

                  ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_PWA_START_INSTALL);

                  this.$store.commit('clearInstallAppDeferredPrompt');
                }
            },

            components: self.core.getComponents(),

            created: function() {
                self.loadStore(this.$store);
                self.core.onLoadStore(this.$store);

                window.addEventListener('resize', this.onWindowResize);

                ks.serviceWorker.register();
            },

            destroyed: function() {
                window.removeEventListener('resize', this.onWindowResize);
            },

            mounted: function() {
                var body = $('body');

                body.tooltip({
                    selector: '[data-toggle="tooltip"]'
                });

                body.popover({
                    selector: '[data-toggle="popover"]',
                    trigger: 'hover',
                    html: true,
                    container: 'body'
                });

                if ( ! this.$store.getters.isGuest) {
                    // Применим настройки фона
                    this.applyPageBackgroundImage(this.$store.state.parent.options.background_image);
                }

                // VK Pixel Ретаргетинг
                try {
                  ks.vk.Retargeting.start();
                } catch (exception) {}

                this.loaded = true;

                // Session Message
                var msg = this.$store.state.sessionMessage;
                if (msg !== null) {
                    this.processSessionMessage(msg);
                }

                window.addEventListener('beforeinstallprompt', (e) => {
                  // Prevent the mini-infobar from appearing on mobile
                  e.preventDefault();
                  // Stash the event so it can be triggered later.
                  this.$store.commit('setInstallAppDeferredPrompt', e);
                });

                window.addEventListener('appinstalled', () => {
                  this.$store.commit('clearInstallAppDeferredPrompt');

                  ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_PWA_INSTALLED);
                });

                this.onWindowResize();
            }

        });

        this.core.onCreateApp();

        return this;
    };

    ks.start = function() {
      return ks.createClient().createApp();
    };
}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 27.02.2018
 */

(function() {

    var Current = {
        namespaced: true,

        state: {
            exercise: null,
            
            training: null,
            
            mode: -1, 
            
            // В режимет тренировки не используется
            subjectStage: {
                completedCountExercises: 0,
                countExercises: 0
            },
            
            // Используется только в режиме тренировки
            trainingState: {
                // Индекс текущего предмета
                subjectIndex: -1,
                // Кол-во пройденных заданий по текущему предмету
                countExercises: 0                 
            },
            
            history: {
                exercises: []
            },
            
            isDayLimitExceeded: false,
            
            // Получен или нет ответ на текущее упражнение
            hasAnswer: false
        },

        mutations: {
            /* Exercise */
            exercise: function(state, exercise) {
                state.exercise = exercise;
            },
            /* Training */
            training: function(state, training) {
                state.training = training;
            },
            
            mode: function(state, mode) {
                state.mode = mode;
            },
            /* Subject Stage */
            subjectStage: function(state, stage) {
                if ('completedCountExercises' in stage) {
                    state.subjectStage.completedCountExercises = stage.completedCountExercises;
                }
                
                if ('countExercises' in stage) {
                    state.subjectStage.countExercises = stage.countExercises;
                }
            },
            /* Training State */
            trainingState: function(state, trainingState) {
                state.trainingState.subjectIndex = trainingState.subjectIndex;
                state.trainingState.countExercises = trainingState.countExercises;
            },
            /* History */
            setHistoryExercises: function(state, exercises) {
                state.history.exercises = exercises;
            },
            
            clearHistoryExercises: function(state) {
                state.history.exercises = [];
            },
            
            startRecordHistoryExercise: function(state, exercise) {
                state.history.exercises.push(new ks.ExerciseHistoryInfo({
                    id: exercise.id,
                    groupId: exercise.groupId,
                    subjectId: exercise.subjectId
                }));                
            },
            
            stopRecordHistoryExercise: function(state) {
                var exercise = state.history.exercises[state.history.exercises.length - 1];

                exercise.stopDate = Date.now();
            },
            
            setLastHistoryExerciseAnswer: function(state, isCorrectAnswer) {
                var exercise = state.history.exercises[state.history.exercises.length - 1];

                exercise.isCorrectAnswer = isCorrectAnswer;
                exercise.isFinished = true;                
            },
            
            setExerciseAudioPlaying: function(state, currentAudioPlaying) {
                if (state.exercise !== null) {
                    state.exercise.currentAudioPlaying = currentAudioPlaying;
                }
            },
            
            setExerciseAnswered: function(state, answered) {
                if (state.exercise !== null) {
                    state.exercise.answered = answered;
                }
            },
            
            /**
             * Установка текущей страницы упражнения;
             * В зависимости от страницы проигрывается аудио-файл;
             * События изменения текущей страницы слушается в exercise-engine
             * @param {type} state
             * @param {Number} currentPage
             */
            setExercisesCurrentPage: function(state, currentPage) {
                if (state.exercise !== null) {
                    state.exercise.currentPage = currentPage;
                }
            },
            
            setIsDayLimitExceeded: function(state, isDayLimitExceeded) {
                state.isDayLimitExceeded = isDayLimitExceeded;
            },
            
            /**
             * Получен или нет ответ на текущее упражнение
             * @param {type} state
             * @param {Boolean} hasAnswer
             */
            setHasAnswer: function(state, hasAnswer) {
                state.hasAnswer = hasAnswer;
            }
        },

        actions: {},

        getters: {
            getLastHistoryExercise: function(state) {
                return state.history.exercises.length <= 0 ? null : state.history.exercises[state.history.exercises.length - 1];
            },
            
            /**
             * Текущее упражение последнее в тренировке?
             * @param {type} state
             * @returns {Boolean}
             */
            isLastExerciseTraining: function(state) {
                return function(countExercises) {
                    if (state.training === null) {
                        return null;
                    }

                    var index = state.trainingState.subjectIndex;

                    return index === state.training.subjects.length - 1 &&
                           countExercises >= state.training.subjects[index].countExercises;
               };
            },
            
            /**
             * Текущее упражение последнее в этапе темы?
             * @param {type} state
             * @returns {Boolean}
             */
            isLastExerciseSubjectStage: function(state) {
                return state.subjectStage.completedCountExercises >= state.subjectStage.countExercises;
            }
        }

    };

    var load = function(store) {
        // nothing
    };

    ks.core.addStoreModule('current', {
        module: Current,
        eventLoad: load
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 30.01.2018
 */

(function() {

    var Guest = {
        namespaced: true,

        state: {
            exercises: {
                dayLimit: 0,
                available: 0
            },
            
            offerLogin: {
                showed: false,
                email: ''
            },
            
            voiceEnabled: true
        },

        mutations: {
            setData: function(state, data){
                ks.helpers.loadProperties(state.exercises, data.exercises);
            },
            
            setAvailableExercises: function(state, count) {
                state.exercises.available = count;
            },
            
            setVoiceEnabled: function(state, voiceEnabled) {
                state.voiceEnabled = voiceEnabled;
                
                ks.helpers.cookies.set('voiceEnabled', voiceEnabled, { expires: 365 });
            },
            
            setOfferLoginShowed: function(state, showed) {
                state.offerLogin.showed = showed;
                
                if (showed) {
                    ks.helpers.cookies.set('offerLoginShowed', true, { expires: 7 });
                }
            },
            
            setOfferLoginEmail: function(state, email) {
                state.offerLogin.email = email;
            }            
        },

        actions: {},

        getters: {
            getExercisesDayLimit: function(state) {
                return state.exercises.dayLimit;
            },
           
            getAvailableExercises: function(state) {
                return state.exercises.available;
            },
           
            getExerciseDay: function(state) {
                return state.exercises.dayLimit - state.exercises.available;
            },
           
            getVoiceEnabled: function(state) {
                return state.voiceEnabled;
            },
            
            canShowOfferLogin: function(state) {
                return state.offerLogin.email !== '' && ! state.offerLogin.showed;
            },
            
            getOfferLoginEmail: function(state) {
                return state.offerLogin.email;
            }
        }

    };

    var load = function(store) {
        var data =  ks.core.getInitStoreData('guest');
        if (data === null) return;

        store.commit('guest/setData', data);
        
        var voiceEnabled = Cookies.get('voiceEnabled');
        store.commit('guest/setVoiceEnabled', typeof voiceEnabled === 'undefined' ? true : voiceEnabled === 'true');
        
        var offerLoginShowed = Cookies.get('offerLoginShowed');
        store.commit('guest/setOfferLoginShowed', offerLoginShowed);  
        store.commit('guest/setOfferLoginEmail', data.email);
    };

    ks.core.addStoreModule('guest', {
        module: Guest,
        eventLoad: load
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 05.10.2017
 */

(function() {

    var Kid = {
        namespaced: true,

        state: {
            id: -1,
            name: '',
            gender: 0,
            birthday: '',
            
            avatar: {
                id: 0,
                src: '',
                time: 0
            },
            
            subscription: {
                active: false,
                expired: null
            },
            
            exercises: {
                dayLimit: 0,
                available: 0,
                dayCount: 0
            },
            
            stars: 0,
            
            hasNewAchievements: false,
            hasNewAwards: false,
            hasNewDiplomas: false,
            
            // 11.08.2021
            trainingTrial: false
        },

        mutations: {
            setId: function (state, id) {
                state.id = id;
            },

            setProfile: function(state, kid) {
                state.name = kid.name;
                state.gender = kid.gender;
                state.birthday = kid.birthday;
                
                ks.helpers.loadProperties(state.avatar, kid.avatar);
                ks.helpers.loadProperties(state.exercises, kid.exercises);
                
                state.stars = kid.stars;
                
                state.hasNewAchievements = kid.hasNewAchievements;
                state.hasNewAwards = kid.hasNewAwards;
                state.hasNewDiplomas = kid.hasNewDiplomas;
                
                state.subscription.active = kid.subscription.active;
                state.subscription.expired = kid.subscription.expired;
                
                state.trainingTrial = kid.trainingTrial;
            },
            
            setAvailableExercises: function(state, count) {
                state.exercises.available = count;
            },            
            
            setHasNewAchievements: function(state, value) {
                state.hasNewAchievements = value;
            },
            
            setHasNewAwards: function(state, value) {
                state.hasNewAwards = value;
            },
            
            setHasNewDiplomas: function(state, value) {
                state.hasNewDiplomas = value;
            },
            
            setDayExercisesCount: function(state, value) {
                state.exercises.dayCount = value;
            },
            
            incDayExercisesCount: function(state) {
                state.exercises.dayCount++;
            }
        },

        actions: {},

        getters: {
            getAvatarBySize: function(state) {
                return function(size) {
                    var file = state.avatar.src + '_' + size + '.png';

                    if (state.avatar.time !== 0) {
                        file += '?t=' + state.avatar.time;
                    }

                    return file;
                };
            },
            
            hasActiveSubscription: function(state) {
                return state.subscription.active;
            },
            
            hasNewProgress: function(state) {
                return state.hasNewAchievements || state.hasNewAwards || state.hasNewDiplomas;
            },
            
            getExercisesDayLimit: function(state) {
                return state.exercises.dayLimit;
            },

            getAvailableExercises: function(state) {
                return state.exercises.available;
            }          
        }

    };

    var load = function(store) {
        var data = ks.core.getInitStoreData('kid');
        if (data === null) return;

        store.commit('kid/setId', data.id);

        store.commit('kid/setProfile', data);
    };

    ks.core.addStoreModule('kid', {
        module: Kid,
        eventLoad: load
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 23.03.2021
 */

(function() {

    var Mobile = {
        namespaced: true,

        state: {
            menu: {
                isShow: false
            }
        },

        mutations: {
            setMenuShow: function (state, isShow) {
                state.menu.isShow = isShow;
            }
        },

        actions: {},

        getters: {
            isMenuShow: function(state) {
                return state.menu.isShow;
            }
        }
    };

    let load = function(store) {};

    ks.core.addStoreModule('mobile', {
        module: Mobile,
        eventLoad: load
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 05.10.2017
 * 
 * 14.02.2022:
 * +nameComment
 */

(function() {

    var Parent = {
        namespaced: true,

        state: {
            id: -1,
            name: '',
            nameComment: '',
            gender: 0,
            birthday: '',
            avatar: {
                id: 0,
                src: '',
                time: 0
            },
            options: {
                need_parent_password: false,
                sound_effects: true,
                sound_voice: true,
                background_image: '',
                window_rest_enabled: true,
                window_rest_exercises: 20                
            },
            maxKids: 0,
            maxTrainings: 0,
            countKids: 0,
            hasActiveSubscription: false
        },

        mutations: {
            setId: function (state, id) {
                state.id = id;
            },

            setProfile: function(state, parent) {
                state.name = parent.name;
                state.nameComment = parent.nameComment;
                state.gender = parent.gender;
                state.birthday = parent.birthday;
                ks.helpers.loadProperties(state.avatar, parent.avatar);
                ks.helpers.loadProperties(state.options, parent.options);
                state.maxKids = parent.maxKids;
                state.maxTrainings = parent.maxTrainings;
                state.countKids = parent.countKids;
                state.hasActiveSubscription = parent.hasActiveSubscription;
            },

            setOptions: function(state, options) {
                ks.helpers.loadProperties(state.options, options);
            },
            
            setNameComment: function(state, nameComment) {
                state.nameComment = nameComment;
            }
        },

        actions: {},

        getters: {
            getAvatarBySize: function(state) {
                return function (size) {
                    var file = state.avatar.src + '_' + size + '.png';

                    if (state.avatar.time !== 0) {
                        file += '?t=' + state.avatar.time;
                    }

                    return file;
                };
            },
            
            canAutoSwitchToParent: function(state){
                return ! state.options.need_parent_password;
            },
            
            canAutoSwitchToKid: function(state){
                return state.countKids === 1;
            },
            
            hasActiveSubscription: function(state) {
                return state.hasActiveSubscription;
            }
        }
    };

    var load = function(store) {
        var data = ks.core.getInitStoreData('parent');
        if (data === null) return;

        store.commit('parent/setId', data.id);

        store.commit('parent/setProfile', data);
    };

    ks.core.addStoreModule('parent', {
        module: Parent,
        eventLoad: load
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 17.07.2018
 */

(function() {

    var Settings = {
        namespaced: true,

        state: {
            voiceEnabled: false
        },

        mutations: {
           setSettings: function (state, settings) {
                state.voiceEnabled = settings.voiceEnabled;
            }            
        },

        actions: {},

        getters: {

        }
    };

    var load = function(store) {
        var data = ks.core.getInitStoreData('settings');
        if (data === null) return;
        
        store.commit('settings/setSettings', data);
    };

    ks.core.addStoreModule('settings', {
        module: Settings,
        eventLoad: load
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 12.05.2018
 * 
 * 19.08.2021:
 * +visibleDialogs
 */

(function() {

    var Window = {
        namespaced: true,

        state: {
            size: {
                width: 0,
                height: 0
            },
            
            // 19.08.2021
            // Список показанных диалоговых окон на данный момент
            // Сейчас учитывается только signUp, но можно добавить и другие
            visibleDialogs: [],
            
            // Режим при котором идет перемещение элемента. Используется в мобильном меню
            draggableMode: false
        },

        mutations: {
            setSize: function (state, size) {
                state.size.width = size.width;
                state.size.height = size.height;
            },
            
            /**
             * options = { dialog: '<name>', visible: <value> }
             */
            setVisibleDialog: function(state, options) {
                let index = state.visibleDialogs.indexOf(options.dialog); 
                if (options.visible) {
                    if (index < 0) {
                        state.visibleDialogs.push(options.dialog);
                    }
                } else {
                    if (index > -1) {
                        state.visibleDialogs.splice(index, 1);
                    }
                }
            },
            
            setDraggableMode: function(state, draggableMode) {
                state.draggableMode = draggableMode;
            }
        },

        actions: {},

        getters: {
            isVisibleDialog: function(state, dialog) {
                return state.visibleDialogs.indexOf(dialog) > -1;
            },
            
            hasVisibileDialogs: function(state){
                return state.visibleDialogs.length > 0;
            },
            
            draggableMode: function(state) {
                return state.draggableMode;
            }
        }
    };

    var load = function(store) {
        var updateSize = function() {
            store.commit('window/setSize', {
                width: $(window).width(),
                height: $(window).height()
            });
        };
        
        $(window).resize(function() {
            // TODO: возможно стоит обновлять не каждый раз, а раз в 300 мсек?
            updateSize();
        });        

        // Initialization Window Size
        updateSize();
    };

    ks.core.addStoreModule('window', {
        module: Window,
        eventLoad: load
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 21.02.2018
 */

(function() {

    ks.browser = {
        isMobile: {
            Android: function() {
                return navigator.userAgent.match(/Android/i);
            },
            
            BlackBerry: function() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            
            iOS: function() {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            
            Opera: function() {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            
            Windows: function() {
                return navigator.userAgent.match(/IEMobile/i);
            },
            
            any: function() {
                return (ks.browser.isMobile.Android() || 
                        ks.browser.isMobile.BlackBerry() || 
                        ks.browser.isMobile.iOS() || 
                        ks.browser.isMobile.Opera() || 
                        ks.browser.isMobile.Windows());
            }
        },
        
        isSafari: function(){
            return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        },
        
        isTouch: function() {
            return (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));
        }/*,
        
        isSupportWebP: function(callback) {
            let webP = new Image();
            webP.onload = webP.onerror = function() {
                callback(webP.height === 2);
            };
            webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
        }*/        
    };
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 20.03.2018
 */

(function() {
    
    ks.colors = {
        items: [
            {
                name: 'green',
                background: '#edfde9',
                border: '#7fc659'
            },

            {   
                name: 'blue',
                background: '#e9f9fd',
                border: '#4ba4ba'
            },

            {
                name: 'orange',
                background: '#fbf1dd',
                border: '#ef982b'
            },

            {
                name: 'purple',
                background: '#fceaff',
                border: '#ba75c5'
            },

            {
                name: 'crimson',
                background: '#fde9f4',
                border: '#e27298'
            },
            {
                name: 'spruce',
                background: '#eafff5',
                border: '#5db389'
            },
            
            {
                name: 'olive',
                background: '#fffeea',
                border: '#c1bd4c'
            },
            
            
            {
                name: 'red',
                background: '#fcecea',
                border: '#f56c42'
            },
            

            {
                name: 'dark-blue',
                background: '#eaecfc',
                border: '#6370cf'
            },

            {
                name: 'gray',
                background: '#f3f3f3',
                border: '#a0a0a0'
            }
        ],
        
        getBackgroundColors: function(count) {
            var n = count <= this.items.length ? count : this.items.length,
                colors = [];
            
            for (var i = 0; i < n; i++) {
                colors.push(this.items[i].background);
            }
            
            return colors;
        },
        
        getBorderColors: function(count) {
            var n = count <= this.items.length ? count : this.items.length,
                colors = [];
            
            for (var i = 0; i < n; i++) {
                colors.push(this.items[i].border);
            }
            
            return colors;
        },
        
        getItemByName: function(name) {
            for (var i = 0; i < this.items.length; i++) {
                if (this.items[i].name === name) {
                    return this.items[i];
                }
            }
            
            return null;
        },
        
        getBackgroundColor: function(name) {
            var item = this.getItemByName(name);
            
            return item !== null ? item.background : '';
        },
        
        getBorderColor: function(name) {
            var item = this.getItemByName(name);
            
            return item !== null ? item.border : '';
        }
                
    };
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 22.09.2017
 */

ks.consts = {

    // Roles
    ROLE_GUEST  : 0,
    ROLE_PARENT : 1,
    ROLE_KID    : 2,

    // Gender
    GENDER_FEMALE : 0,
    GENDER_MALE   : 1,

    // Errors
    ERR_OK: 0,

    ERR_UNKNOWN: -1,

    ERR_UNKNOWN_STR: 'Неизвестная ошибка.',
    ERR_UNKNOWN_STR_EX:
        'Произошла непредвиденная ошибка.<br />'+
        'Пожалуйста, попробуйте выполнить действие ещё раз.<br /><br />'+
        'Приносим извинения за доставленные неудобства.',

    ERR_PARENT_BANNED : -4003,

    ERR_EMAIL_ALREADY_EXISTS: -8001,
    ERR_EMAIL_MISPRINT: -8002,

    ERR_KID_NOT_ONE: -9003,

    ERR_EXERCISE_NOT_FOUND          : -10000,
    ERR_EXERCISE_DAY_LIMIT_EXCEEDED : -10003,

    ERR_TRAINING_ACCESS_DENIED : -11001,
    ERR_TRAINING_AD_FINISHED   : -11005,

    ERR_NOT_ENOUGH_STORAGE: -12000,

    ERR_PAYMENT_PROBLEM: -14000,

    ERR_CONFIRM_CODE_USER_EMPTY    : -17000,
    ERR_CONFIRM_CODE_MAX_LIMIT     : -17001,
    ERR_CONFIRM_CODE_WAIT_INTERVAL : -17002,
    ERR_CONFIRM_CODE_INVALID       : -17003,
    ERR_CONFIRM_CODE_MAX_ATTEMPTS  : -17004,

    // Message Box Types
    MBT_INFO     : 0,
    MBT_WARNING  : 1,
    MBT_ERROR    : 2,
    MBT_QUESTION : 3,
    MBT_SUCCESS  : 4,

    // Message Box Buttons
    MBB_CANCEL : 0,
    MBB_OK     : 1,
    MBB_CLOSE  : 2,
    // ! MBB_YES и MBB_NO для задания кнопок в MessageBox не используется,
    // только для определения какую кнопку нажал пользователь
    MBB_YES    : 3,
    MBB_NO     : 4,
    MBB_YES_NO : 5,

    // Alert Types
    ALERT_INFO    : 0,
    ALERT_SUCCESS : 1,
    ALERT_WARNING : 2,
    ALERT_ERROR   : 3,

    // Account
    CUSTOM_AVATAR : -1,

    // Avatar Sizes (pixels)
    AVATAR_SIZE_BIG   : 80,
    AVATAR_SIZE_SMALL : 50,

    // Exercises
    EXERCISE_PAGE_ENTRY : 0,
    EXERCISE_PAGE_MAIN  : 1,

    EXERCISE_STATE_QUESTION       : 1,
    EXERCISE_STATE_INVALID_ANSWER : 2,
    EXERCISE_STATE_CORRECT_ANSWER : 3,

    EXERCISE_MODE_SUBJECT_STAGE: 0,
    EXERCISE_MODE_TRAINING: 1,

    // Trainings
    TRAINING_TYPE_FREE  : 0,
    TRAINING_TYPE_PAID  : 1,
    TRAINING_TYPE_TRIAL : 2,
    // 14.11.2023
    TRAINING_TYPE_AD    : 3,

    TRAINING_OWNER_SYSTEM: 1,
    TRAINING_OWNER_PARENT: 2,

    TRAINING_STORAGE_KEY: 'tg_se_ky', // TraininG StoragE KeY

    // Bugs
    BUG_TYPE_EXERCISE  : 1,

    // Upload
    MAX_UPLOAD_SIZE : 2097152, // 2Mb

    // Storage Types
    STORAGE_TYPE_LOCAL: 0,
    STORAGE_TYPE_SESSION: 1,

    // Sounds
    SOUND_TYPE_EFFECTS: 0,
    SOUND_TYPE_VOICE: 1,

    // Invites
    INVITE_STATUS_SENT: 0,
    INVITE_STATUS_ACCEPTED: 1,

    // Guest
    GUEST_OFFER_REGISTER_SHOWED: 'ks_gors', // Kids Smart Guest Offer Register Showed

    // Promocode Discount Modes
    PROMOCODE_DISCOUNT_MODE_PERCENT     : 0,  // Скидка X%
    PROMOCODE_DISCOUNT_MODE_MONTH       : 1,  // Скидка пролонгация подписки на X месяцев
    PROMOCODE_DISCOUNT_MODE_FIXED       : 2,  // Скидка фиксированная в руб.
    PROMOCODE_DISCOUNT_MODE_FIXED_PRICE : 3,  // Фиксированная цена в руб.

    // Achievements
    // Достижение :: Первый заход в систему
    ACHIEVEMENT_KID_FIRST_LOGIN: 1,
    // Достижение :: Ежедневный заход в систему
    ACHIEVEMENT_KID_LOGIN: 2,
    // Достижение :: Упорный труженик (несколько правильных ответов подряд)
    ACHIEVEMENT_CORRECT_ANSWERS_ROW: 3,
    // Достижение :: Пройти правильно минимум одно упражнение по разным предметам
    ACHIEVEMENT_CORRECT_ANSWER_DIFFERENT_SUBJECTS: 4,
    // Достижение :: Несколько правильных ответов по определенном предмету
    ACHIEVEMENT_CORRECT_ANSWERS_SUBJECT: 5,
    //12.04.2021: отключили
    // Достижение :: Несколько пройденых этапов по предмету без ошибок
    //ACHIEVEMENT_CORRECT_ANSWERS_SUBJECT_STAGE: 6,
    //12.04.2021: отключили
    // Достижение :: Несколько пройденых определенных тренировок без ошибок
    //ACHIEVEMENT_CORRECT_ANSWERS_TRAINING: 7,
    // Достижение :: Несколько правильно пройденых упражнений в день
    ACHIEVEMENT_EXERCISES_DAY: 8,

    // Invoices
    INVOICE_PAGE_PAYMENT : 0,
    INVOICE_PAGE_ORDER   : 1,

    // Controller Account Email
    CONTROLLER_ACCOUNT_EMAIL_MODE_ORDER  : 0,
    CONTROLLER_ACCOUNT_EMAIL_MODE_SIGNUP : 1,

    // OAuth Source Page
    OAUTH_SOURCE_PAGE_DEFAULT        : 0,
    OAUTH_SOURCE_PAGE_EXERCISES_OVER : 1,
    OAUTH_SOURCE_PAGE_SIGNUP_PAGE    : 2,
    OAUTH_SOURCE_PAGE_DIALOG         : 3,
    OAUTH_SOURCE_PAGE_ORDER_PAGE     : 4,
    OAUTH_SOURCE_PAGE_LOGIN_DIALOG   : 5
};

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 17.03.2018
 * 
 * Класс для подсчёта времени затраченного на выполнение упражнения.
 */

(function() {

    ks.ExerciseProfiler = function() {
        var self = this;
        
        this._counter = 0; // seconds
        
        this._timerId = null;
        
        this._active = true;
        
        this.start = function() {
            this.stop();
            this.reset();
            
            this._timerId = setInterval(function(){
                if (self._active) {
                    self._counter++;    
                }
            }, 1000);
        };
        
        this.stop = function() {
            if (this._timerId !== null) {
                clearInterval(this._timerId);
                this._timerId = null;
            }
            
            return this;
        };
        
        this.reset = function() {
            this._counter = 0;
            
            return this;
        };
        
        this.getTime = function() {
            return this._counter;
        };
        
        // Пользователь пришел
        window.onfocus = function(){ 
            self._active = true; 
        };
        
        // Пользователь ушел
        window.onblur = function(){ 
            self._active = false; 
        };        
    };
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 15.10.2019
 * 
 * Используется в Exercise Engine
 */

(function() {
    
    /**
     * events = {onPlay: onPlay, onStop: onStop, onEnd: onEnd}
     * @param {type} events
     * @returns {ks.ExerciseSound}
     */
    ks.ExerciseSound = function(events) {
        this._events = events;
        
        this._isPlaying = false;
        this._lastSound = null;
        
        this.play = function(sound) {
            if ( ! ks.app.$store.state.settings.voiceEnabled || this._isPlaying) {
                return;    
            }
            
            this._lastSound = sound;
            
            var self = this;
            ks.soundManager.playVoice(sound, {
                onPlay: function() {
                    self._isPlaying = true;
                    
                    if (typeof self._events !== 'undefined' && typeof self._events.onPlay !== 'undefined') {
                        self._events.onPlay();
                    }
                },
                
                onStop: function() {
                    self._isPlaying= false;
                    
                    if (typeof self._events !== 'undefined' && typeof self._events.onStop !== 'undefined') {
                        self._events.onStop();
                    }
                },
                
                onEnd: function() {
                    self._isPlaying = false;
                    
                    if (typeof self._events !== 'undefined' && typeof self._events.onEnd !== 'undefined') {
                        self._events.onEnd();
                    }
                }
            });
        };

        this.stop = function(sound) {
            if ( ! this._isPlaying) {
                return;
            }

            ks.soundManager.stop(typeof sound !== 'undefined' ? sound : this._lastSound);
        };         

    };
    
}());    
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 13.08.2018
 * 
 * Common File.
 * 
 * 30.07.2021:
 * +filter brightness
 * 
 * 06.10.2023:
 * +SortContainerType
 */

var ksGlobal = ksGlobal || {};

(function() {
    
    ksGlobal.urlBase = 'https://kids-smart.ru/';
    
    ksGlobal.Exercise = {
        status: {
            Disabled: 1,
            Development: 2,
            Active: 3
        }
    };
    
    ksGlobal.Coupon = {
        status: {
            Active: 0,
            Used: 1,
            Disabled: 2            
        }
    };
    
    ksGlobal.ImageModifier = {
        
        // Внимание! Не добавлять ф-ии в values, т.к. в коде идет перебор 
        // ключей values: Object.keys(ksGlobal.ImageModifier.values)
        values: {
            None                     : 0,
            FlipHorizontal           : 1,
            FlipVertical             : 2,
            Rotate180                : 3,
            Size                     : 4,
            Grayscale                : 5,
            Brightness               : 6
        },
        
        /**
         * Получаем css-значение для параметра transform
         * @param {Number} modifier
         * @param {Mixed} param
         * @returns {String}
         */
        getTransform: function(modifier, param) {
            var transform;
            
            switch (modifier) {
                case this.values.FlipHorizontal:
                    transform = 'scaleX(-1)';
                    break;

                case this.values.FlipVertical:
                    transform = 'scaleY(-1)';
                    break;

                case this.values.Rotate180:
                    transform = 'rotate(180deg)';
                    break;
                    
                case this.values.Size:
                    var val = parseInt(param) / 100;
                    transform = 'scale(' + val + ')';
                    break;
                    
                default:
                    transform = 'none';
                    break;
            }            
            
            return transform;
        },
        
        /**
         * Получаем css-значение для параметра filter
         * @param {Number} modifier
         * @param {Mixed} param
         * @returns {String}
         */
        getFilter: function(modifier, param) {
            var filter;
            
            switch (modifier) {
                case this.values.Grayscale:
                    filter = 'grayscale(100%)';
                    break;
                    
                case this.values.Brightness:
                    filter = 'brightness(' + param + '%)';
                    break;
                    
                default:
                    filter = 'none';
                    break;
            }            
            
            return filter;
        }        
    };
    
    ksGlobal.ShapeMode = {
        Default: 0,
        Answer: 1,
        Hover: 2,
        Selected: 3
    };
    
    ksGlobal.Colors = {
        
        values: [
            { name: 'black',  color: '#000000' },
            { name: 'green',  color: '#6bad48' },
            { name: 'blue',   color: '#0099b7'/*'#4091a5'*/ },
            { name: 'red',    color: '#e05a31' },
            { name: 'purple', color: '#a85cb4' },
            { name: 'pink',   color: '#df608b' },
            { name: 'white',  color: '#ffffff' },
            { name: 'yellow', color: '#f8d838' }
        ], 
        
        /**
         * Get Color By Name
         * @param {string} name
         * @returns {string|null}
         */
        getColorByName: function(name) {
            for (var i = 0; i < this.values.length; i++) {
                if (name === this.values[i].name) {
                    return this.values[i].color;
                }
            }
            
            return null;
        },
        
        hexToRgba: function(hex, opacity) {
            var h = hex.replace('#', '');
            h = h.match(new RegExp('(.{' + h.length / 3 + '})', 'g'));

            for(var i = 0; i < h.length; i++) {
                h[i] = parseInt(h[i].length === 1 ? h[i] + h[i] : h[i], 16);
            }

            if (typeof opacity !== 'undefined') {
                h.push(opacity);
            }

            return 'rgba(' + h.join(',')+')';
        },
        
        hexToRgb: function(hex) {
            // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
            var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            hex = hex.replace(shorthandRegex, function(m, r, g, b) {
                return r + r + g + g + b + b;
            });

            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },
        
        rgbToHex: function(r, g, b) {
            return '#' + [r, g, b].map(function(x) {
                var hex = x.toString(16);

                return hex.length === 1 ? '0' + hex : hex;
            }).join('');
        }
        
    };
    
    ksGlobal.ClockType = {
        Analog: 1,
        Digit: 2
    };    
    
    ksGlobal.ClockColors = [
        'gray', 
        'green', 
        'blue',
        'purple', 
        'crimson', 
        'orange'
    ];
    
    ksGlobal.ColorSchemes = [
        'green', 
        'blue',
        'purple', 
        'crimson', 
        'yellow', 
        'orange'
    ];    
    
    ksGlobal.SquareLettersMode = {
        Words        : 0,
        Images       : 1,
        FirstLetter  : 2,    
        CountLetters : 3         
    };
    
    ksGlobal.MagicCubesType = {
        Zero        : 0,
        Full        : 1,
        LeftTop     : 2,
        RightTop    : 3,
        RightBottom : 4,
        LeftBottom  : 5
    };
    
    ksGlobal.MathOperation = {
        Addition       : 0, // сложение
        Subtraction    : 1, // вычетание
        Multiplication : 2, // умножение
        Division       : 3// деление
    };     
    
    ksGlobal.SortContainerType = {
        SolidImage : 0,
        ExtraImage : 1,
        Text       : 2
    };
    
}());
/** 
 * (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 01.03.2018
 */

(function() {
    
    ks.Guest = {
        
        /* Training Info */
        saveTrainingInfo: function(trainingInfo) {
            var data = {
                    si: trainingInfo.subjectIndex,
                    ce: trainingInfo.countExercises,
                    he: []
                };
            
            for (var i = 0; i < trainingInfo.historyExercises.length; i++) {
                data.he.push(ks.ExerciseHistoryInfoToCompact(trainingInfo.historyExercises[i]));
            }
            
            ks.Storage.setItem(
                ks.consts.STORAGE_TYPE_LOCAL, 
                ks.consts.TRAINING_STORAGE_KEY,
                data,
                true
            );            
        },
        
        loadTrainingInfo: function() {
            var data = ks.Storage.getItem(ks.consts.STORAGE_TYPE_LOCAL, ks.consts.TRAINING_STORAGE_KEY, true, true);
            
            if (data === null) {
                return null;
            }
            
            var trainingInfo = {
                    subjectIndex: data.si,
                    countExercises: data.ce,
                    historyExercises: []
                };      
                
            for (var i = 0; i < data.he.length; i++) {
                trainingInfo.historyExercises.push(ks.ExerciseHistoryInfoFromCompact(data.he[i]));
            }
            
            return trainingInfo;
        },
        
        clearTrainingInfo: function() {
            ks.Storage.removeItem(ks.consts.STORAGE_TYPE_LOCAL, ks.consts.TRAINING_STORAGE_KEY, true);
        },
        
        isOfferRegisterShowed: function() {
            var showed = Cookies.get(ks.consts.GUEST_OFFER_REGISTER_SHOWED);
            return showed === true || showed === 'true';
        },
        
        setOfferRegisterShowed: function() {
            ks.helpers.cookies.set(ks.consts.GUEST_OFFER_REGISTER_SHOWED, true, { expires: 3650 });
        }
        
    };
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 27.10.2017
 */

(function(){

    ks.helpers = {

        // Копирование значений полей объекта data в obj;
        // копируются значения только тех полей из data, которые есть в obj;
        // поддерживается рекурсивное копирование.
        loadProperties: function(obj, data) {
            if (typeof data !== 'object') return obj;

            for (var key in obj) {
                if (key in data) {
                    switch (typeof obj[key]) {
                        case 'object':
                            if (typeof data[key] === 'object') {
                                this.loadProperties(obj[key], data[key]);
                            }
                            break;
                        case 'function':
                            //nothing
                            break;

                        default:
                            obj[key] = data[key];
                            break;
                    }
                }
            }

            return obj;
        }
    };


    ks.helpers.html = {
        _currentIndexId: 0,

        // Уникальный id для html-элемента
        getUniqueId: function() {
            this._currentIndexId++;

            // ks-cuid - Kids Smart Component Unique Id
            return 'ks-cuid-' + this._currentIndexId;
        },

        getElemRect: function(elem) {
	    let box = elem.getBoundingClientRect(),
	        body = document.body,
	        docElem = document.documentElement,
                scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop,
	        scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft,
	        clientTop = docElem.clientTop || body.clientTop || 0,
	        clientLeft = docElem.clientLeft || body.clientLeft || 0,
	        top  = box.top +  scrollTop - clientTop,
	        left = box.left + scrollLeft - clientLeft;

	    return {
                left: Math.round(left),
                top: Math.round(top),
                right: Math.round(left + box.width),
                bottom: Math.round(top + box.height),
                width: box.width,
                height: box.height
            };
        },

        /**
         * Изменение CSS-значения border в зависимости от коэффициента (0..1)
         * @param {String} border
         * @param {Number} coef
         * @param {Number} minBorder
         * @returns {String}
         */
        getStyleBorder(border, coef, minBorder) {
            coef = coef || 1;
            minBorder = minBorder || 1;

            const params = border.split(' ');
            let size = Math.round(ks.helpers.text.getNumberFromText(params[0]) * coef);

            if (size < minBorder) {
                size = minBorder;
            }

            let output = size + 'px';
            for (let i = 1; i < params.length; i++) {
               output += ' ' + params[i];
            }

            return output;
        },

        /**
         * Получение размера border в зависимости от коэффициента (0..1)
         * @param {String} border
         * @param {Number} coef
         * @param {Number} minBorder
         * @returns {Number}
         */
        getStyleBorderSize(border, coef, minBorder) {
            coef = coef || 1;
            minBorder = minBorder || 1;

            const params = border.split(' ');
            let size = Math.round(ks.helpers.text.getNumberFromText(params[0]) * coef);

            if (size < minBorder) {
                size = minBorder;
            }

            return size;
        },

        /**
         * Изменение CSS-значения padding в зависимости от коэффициента (0..1)
         * @param {String} padding
         * @param {Number} coef
         * @returns {String}
         */
        getStylePadding(padding, coef) {
            coef = coef || 1;

            const params = padding.split(' ');
            let output = '';

            params.forEach(param => {
                let size = Math.floor(ks.helpers.text.getNumberFromText(param) * coef);
                if (output !== '') {
                    output += ' ';
                }
                output += size + 'px';
            });

            return output;
        },

        /**
         * Изменение CSS-значения font-size в зависимости от коэффициента (0..1)
         * @param {String} fontSize
         * @param {Number} coef
         * @param {Number} minFontSize
         * @returns {String}
         */
        getStyleFontSize(fontSize, coef, minFontSize) {
            coef = coef || 1;
            minFontSize = minFontSize || 6;

            let size = Math.ceil(ks.helpers.text.getNumberFromText(fontSize) * coef);
            if (size < minFontSize) {
                size = minFontSize;
            }
            return size + 'px';
        }
    };

    ks.helpers.math = {
        shuffle: function(array) {
          for (let i = array.length - 1; i > 0; i--) {
            let j = Math.floor(Math.random() * (i + 1)); // случайный индекс от 0 до i

            // поменять элементы местами
            // мы используем для этого синтаксис "деструктурирующее присваивание"
            // то же самое можно записать как:
            // let t = array[i]; array[i] = array[j]; array[j] = t
            [array[i], array[j]] = [array[j], array[i]];
          }
        },

        // Случайное целое число
        getRandomInt: function(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },

        /**
         * Конвертация в римские цифры
         * @param {Number} num
         * @returns {String|Boolean}
         */
        romanize: function(num) {
            if (isNaN(+num)) {
                return false;
            }
            var digits = String(+num).split(""),
                key = ["","C","CC","CCC","CD","D","DC","DCC","DCCC","CM",
                       "","X","XX","XXX","XL","L","LX","LXX","LXXX","XC",
                       "","I","II","III","IV","V","VI","VII","VIII","IX"],
                roman = "",
                i = 3;
            while (i--) {
                roman = (key[+digits.pop() + (i * 10)] || "") + roman;
            }
            return Array(+digits.join("") + 1).join("M") + roman;
        },

        /*
         * Площадь пересечения прямоугольников
         * @param {Object} r1
         * @param {Object} r2
         * @returns {Number}
         */
        getIntersectionAreaRectangles: function(r1, r2) {
            var x1 = Math.max(Math.min(r1.left, r1.right), Math.min(r2.left, r2.right)),
                x2 = Math.min(Math.max(r1.left, r1.right),Math.max(r2.left, r2.right)),
                y1 = Math.max(Math.min(r1.top, r1.bottom),Math.min(r2.top, r2.bottom)),
                y2 = Math.min(Math.max(r1.top, r1.bottom),Math.max(r2.top, r2.bottom)),
                s = 0;

            if (x2 - x1 > 0 && y2 - y1 > 0) {
              s = (x2 - x1) * (y2 - y1);
            }

            return s;
        }

        /**
         * Проверяет нахождение точки в прямоугольнике
         * @param {Object} pt {x: 0, y: 0)
         * @param {Object} rect {left: 0, top: 0, right: 0, bottom: 0}
         * @returns {Boolean}
         */
        /*ptInRect(pt, rect) {
            return (pt.x >= rect.left && pt.x <= rect.right &&
                    pt.y >= rect.top && pt.y <= rect.bottom);
        }*/
    };

    ks.helpers.string = {
        reverse: function(str) {
            return str.split('').reverse().join('');
	},

        firstLetterCaps: function(string){
            return string[0].toUpperCase() + string.substring(1);
        }
    };

    ks.helpers.text = {
        /**
         *
         * @param {string} text
         * @param {int} limit
         * @param {string} endChars
         * @returns {string}
         */
        limitChars: function(text, limit, endChars) {
            if (typeof limit === 'undefined') {
                return text;
            }

            var endStr = endChars || '...';

            return text.length <= limit ? text : text.substr(0, limit) + endStr;
        },

        /**
         * Склонение числительных
         *
         * pluralize(2, ['рубль', 'рубля', 'рублей']);
         * -> 2 рубля
         *
         * @param {int} number
         * @param {array} titles
         * @returns {string}
         */
        pluralize: function(number, titles) {
            var cases = [2, 0, 1, 1, 1, 2];

            return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
        },

        /**
         *
         * @param {string} string
         * @returns {string}
         */
        capitalizeFirstLetter: function(string) {
            return string.length > 0 ? string[0].toUpperCase() + string.slice(1) : string;
        },

        /**
         * Преобразование цены (добавляем пробел как разделитель в целых)
         * @param {int} price
         * @returns {string}
         */
        price: function(price) {
            let val = Number.prototype.toFixed.call(parseFloat(price) || 0, 2),
                priceStr = parseInt(val, 10) === price ? price.toString() : val.replace(/(\D)/g, ',');

            return priceStr.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
        },

        /**
         * Преобразование цены (добавляем пробел как разделитель в целых, дробная часть в <span class="fractionalClass"></span>)
         * @param {int} price
         * @param {string} fractionalClass Default value 'number-fractional'
         * @returns {string}
         */
        priceHTML: function(price, fractionalClass){
            let priceStr = this.price(price).replace(',' ,'.');

            if (priceStr.indexOf('.') > -1) {
                let parts = priceStr.split('.'),
                    cls = fractionalClass || 'number-fractional';
                priceStr = parts[0] + '<span class="' + cls + '">.' + parts[1] + '</span>';
            }

            return priceStr;
        },

        /**
         * Получения размеров текста в зависимости от стиля
         * @param {string} text
         * @param {object} style
         * @returns {object}
         */
        getTextSize: function(text, style) {
            let span = document.createElement('span');
            document.body.appendChild(span);

            span.style.height = 'auto';
            span.style.width = 'auto';
            span.style.position = 'absolute';
            span.style.whiteSpace = 'no-wrap';
            span.style.left = -1000;
            span.style.top = -1000;

            const ignoreKeys = ['height', 'width', 'position', 'whiteSpace', 'left', 'top'];

            for (let key in style) {
                if (ignoreKeys.indexOf(key) < 0) {
                    span.style[key] = style[key];
                }
            }

            span.innerHTML = text;

            const size = {
                width  : Math.ceil(span.clientWidth),
                height : Math.ceil(span.clientHeight)
            };

            document.body.removeChild(span);
            span = null;

            return size;
        },

        /**
         * Получение числа из текста
         * Например, для '12px' результат: 12
         *
         * @param {type} text
         * @returns {number}
         */
        getNumberFromText(text) {
            return parseInt(text.replace(/[^0-9\s]/g,''), 10);
        }
    };

    ks.helpers.date = {
        getReadableAge: function(birthday) {
            if (birthday === '' || birthday === null) {
                return '';
            }

            var bDate = moment(birthday, 'DD.MM.YYYY'),
                years = moment().diff(bDate, 'years');

            if (years < 0) {
                return '';
            }

            if (years > 0) {
                return years + ' ' + ks.helpers.text.pluralize(years , ['год', 'года', 'лет']);
            }

            var months = moment().diff(bDate, 'months');

            if (months <= 0) {
                return '';
            }

            return months + ' ' + ks.helpers.text.pluralize(months , ['месяц', 'месяца', 'месяцев']);
        },

        /**
         * Вывод минут в тестовом виде: [Кол-во часов] ч. [Кол-во минут] мин.
         * @param {Number} minutes Кол-во минут
         * @param {Boolean} brUse Использовать перенос строки после значения часов ("12 ч. [br]5 мин.")
         * @param {String} brClass Css-класс для br, при brUse=true
         * @returns {String}
         */
        getMinutesText: function(minutes, brUse, brClass) {
            let h = Math.floor(minutes / 60),
                m = minutes % 60,
                text = h > 0 ? h + ' ч.' : '';

            if (m > 0) {
                if (text !== '') {
                    text += ' ';
                    if (typeof brUse !== 'undefined' && brUse) {
                        let br = typeof brClass !== 'undefined' ? '<br class="' + brClass + '" />' : '<br />';

                        text += br;
                    }
                }

                text += m + ' мин.';
            }

            return text;
        }
    };

    ks.helpers.clipboard = {

        // Копировать текст в буфер обмена
        copyText: function(text, callback) {
            /*
            if (navigator.clipboard) {
                navigator.clipboard.writeText(text)
                    .then(function() {
                        callback(true);
                    })
                    .catch(function(err) {
                        callback(false);
                    });


                return true;
            }
            */

            var result = false,
                textArea = document.createElement("textarea");

            //
            // *** This styling is an extra step which is likely not required. ***
            //
            // Why is it here? To ensure:
            // 1. the element is able to have focus and selection.
            // 2. if element was to flash render it has minimal visual impact.
            // 3. less flakyness with selection and copying which **might** occur if
            //    the textarea element is not visible.
            //
            // The likelihood is the element won't even render, not even a
            // flash, so some of these are just precautions. However in
            // Internet Explorer the element is visible whilst the popup
            // box asking the user for permission for the web page to
            // copy to the clipboard.
            //

            // Place in top-left corner of screen regardless of scroll position.
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;

            // Ensure it has a small width and height. Setting to 1px / 1em
            // doesn't work as this gives a negative w/h on some browsers.
            textArea.style.width = '2em';
            textArea.style.height = '2em';

            // We don't need padding, reducing the size if it does flash render.
            textArea.style.padding = 0;

            // Clean up any borders.
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';

            // Avoid flash of white box if rendered for any reason.
            textArea.style.background = 'transparent';

            textArea.contentEditable = true; // iOS will only select text on non-form elements if contentEditable = true;
            textArea.readOnly = false; // iOS will not select in a read only form element

            textArea.value = text;

            document.body.appendChild(textArea);

            var range = document.createRange();
		range.selectNodeContents(textArea);

            var sel = window.getSelection();
		sel.removeAllRanges();
		sel.addRange(range); // Does not work for Firefox if a textarea or input

            if (textArea.nodeName === 'TEXTAREA' || textArea.nodeName === 'INPUT') {
                textArea.select(); // Firefox will only select a form element with select()
            }

            if (textArea.setSelectionRange && navigator.userAgent.match(/ipad|ipod|iphone/i)) {
                textArea.setSelectionRange(0, 999999); // iOS only selects "form" elements with SelectionRange
            }

            if (document.queryCommandSupported('copy')) {
                try {
                  result = document.execCommand('copy');
                } catch (err) {
                  result = false;
                }
            } else {
                result = false;
            }

            document.body.removeChild(textArea);

            callback(result);

            return result;
        }
    };

    ks.helpers.cookies = {

        set: function(key, value, attributes) {

            if (ksStore.settings.app.cs) {
                attributes = attributes || {};
                attributes.secure = true;
                attributes.sameSite = 'Lax';
            }

            Cookies.set(key, value, attributes);
        }

    };

    ks.helpers.sizes = {
        isLg(value) {
            return value >= 1200;
        },

        isMd(value) {
            return value >= 992 && value <= 1199;
        },

        isSm(value) {
            return value >= 768 && value <= 991;
        },

        isXs(value) {
            return value <= 767;
        }
    };

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 30.10.2020
 * 
 */

(function() {
    
    const FIELD_BORDER_SIZE = 4;
    const CUBES_IN_ROW      = 3;
    
    const isMouseHoverDisabled = ks.browser.isMobile.any() || ks.browser.isTouch();
    
    Vue.component('magic-cubes-item-selector', {
        template: 
            '<div v-show="visible" class="magic-cubes-item-selector" :style="styleBox">' +
                '<div v-for="(row, rowIndex) in rows" :key="rowIndex" class="magic-cubes-item-selector-row">' + 
                '    <div class="magic-cubes-item-selector-el" v-for="(item, itemIndex) in row" :key="itemIndex"><magic-cubes-field-el ' + 
                        ':item="item" :width="itemWidth" ' +
                        ':field-size="1" ' + 
                        '@click="onClickItem">' + 
                '    </magic-cubes-field-el></div>' +  
                '</div>' +
            '</div>',
        
        props: {
            fieldWidth: {
                type: Number,
                required: true
            },
            
            fieldSize: {
                type: Number,
                required: true
            }
        },
        
        data: function() {
            return {
                window: {
                    width: 0,
                    height: 0
                },
                
                cursorPos: {
                    x: 0,
                    y: 0
                },
                visible: false,
                item: null,
                
                color: '',
                bgColor: '',
                
                items: []
            };
        },
        
        computed: {
            styleBox: function() {
                var delta = this.window.width - this.boxWidth,
                    left = delta < 20 ? Math.floor(delta / 2) : Math.floor(this.cursorPos.x - (this.boxWidth / 2)),
                    top = Math.floor(this.cursorPos.y - (this.itemWidth / 2)),
                    height = this.rows.length * (this.itemWidth + 8);  
            
                if (left + this.boxWidth + 8 > this.window.width) {
                    left = this.window.width - this.boxWidth - 8;
                }               
                
                if (left < 4) {
                    left = 4;
                }  
                
                if (top + this.boxHeight + 8 > this.window.height) {
                    top = this.window.height - this.boxHeight - 8;
                }               
                
                if (top < 4) {
                    top = 4;
                }                
                
                return {
                    'top': top + 'px',
                    'left': left + 'px',
                    'height': height + 'px'
                };
            },
            
            boxWidth: function() {
                return (this.itemWidth + 4) * CUBES_IN_ROW; // 3 кубика в ряд
            },
            
            boxHeight: function() {
                return (this.itemWidth + 4) * this.rows.length;
            },            
            
            width: function() {
                return this.fieldSize > 0 ? this.itemWidth * this.fieldSize : 0;
            },
            
            itemWidth: function() {
                let coef = 0.7, // "магический" коэффициент - просто так смотрится красиво. В случае чего - поправить)
                    width = this.fieldSize === 0 ? 0 : Math.floor(this.fieldWidth / this.fieldSize) * coef;
                
                return width > 50 ? width : 50;
            },
            
            rows: function() {
                let rows = [],
                    row = [];
                
                for (let i = 0; i < this.items.length; i++) {
                    row.push(this.items[i]);
                    if (row.length === CUBES_IN_ROW) { // 3 кубика в ряд
                        rows.push(row);
                        row = [];
                    }
                }
                
                if (row.length > 0) {
                    rows.push(row);
                }
                
                return rows;
            }
        },
        
        methods: {
            fillItems: function() {
                let types = [
                        ksGlobal.MagicCubesType.LeftTop,
                        ksGlobal.MagicCubesType.RightTop,
                        ksGlobal.MagicCubesType.RightBottom,
                        ksGlobal.MagicCubesType.LeftBottom
                    ],
                    color = this.color,
                    bgColor = this.color === this.bgColor ? '' : this.bgColor;                
                
                this.items = [];
                
                // Types: Full, LeftTop, RightTop, RightBottom, LeftBottom
                this.items.push({
                    type: ksGlobal.MagicCubesType.Full,
                    color: color,
                    bgColor: ''
                });   
                
                if (bgColor !== '') {
                    this.items.push({
                        type: ksGlobal.MagicCubesType.Full,
                        color: bgColor,
                        bgColor: ''
                    });                    
                }
                
                for (let i = 0; i < types.length; i++) {
                    this.items.push({
                        type: types[i],
                        color: color,
                        bgColor: bgColor
                    });           
                }
            },
            
            show: function(item, color, bgColor, cursorPos) {
                this.item = item;
                
                this.color = color;
                this.bgColor = bgColor;
                
                this.onWindowResize();
                
                this.cursorPos.x = cursorPos.x;
                this.cursorPos.y = cursorPos.y;
                
                this.fillItems();
                
                ks.soundManager.playEffect(ks.sounds.SHOW_MENU);
                
                var self = this;
                this.$nextTick(function() {
                    self.item.selected = true;
                    self.visible = true;
                });
            },
            
            hide: function() {
                if (this.item !== null) {
                    this.item.selected = false;
                }                
                this.visible = false;
            },
    
            onClickItem: function(item) {
                ks.soundManager.playEffect(ks.sounds.CUBE);
                
                this.item.type = item.type;
                this.item.color = item.color || '';
                this.item.bgColor = item.bgColor || '';
                        
                this.hide();
            },
            
            onWindowResize: function() {
                let wndWidth = window.innerWidth - 16,
                    wndHeight = window.innerHeight - 16;
                
                if (this.window.width !== wndWidth) {
                    this.window.width = wndWidth;
                    this.hide();
                }
                
                if (this.window.height !== wndHeight) {
                    this.window.height = wndHeight;
                    this.hide();
                }                
            }
        },
        
        created: function() {
            window.addEventListener('resize', this.onWindowResize);
            window.addEventListener('wheel', this.hide);
        },
        
        destroyed: function() {
            window.removeEventListener('resize', this.onWindowResize);
            window.removeEventListener('wheel', this.hide);
        },
        
        mounted: function() {
            var self = this;
            $(document).mouseup(function(e) {
                var container = $(self.$el);
                if (container.has(e.target).length === 0){
                    self.hide();
                }
            });
        }
        
    });
    
    Vue.component('magic-cubes-field-el', {
        template: 
            '<div class="magic-cubes-field-el" :class="classEl" :style="styleEl" @click="onClick($event)" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">' +
            
                '<div class="magic-cubes-field-el-container" :style="styleCubeContainer">' +
                    '<div class="magic-cubes-field-el-box" :style="styleCube"></div>' + 
                    '<div v-show=" ! readonly && (isMouseHover || item.selected)" class="magic-cubes-field-el-select" :class="classSelectRect"></div>' + 
                '</div>' + 

            '</div>',
        
        props: {
            item: {
                type: Object,
                required: true
            },
            
            width: {
                type: Number,
                required: true
            },
            
            fieldSize: {
                type: Number,
                required: true
            },
            
            readonly: {
                type: Boolean,
                default: false
            },
            
            correctMode: {
                type: Boolean,
                default: false
            }
        },
        
        computed: {
            classEl: function() {
                return {
                    readonly: this.readonly
                };
            },
            
            styleEl: function() {
                var style = {
                    width: this.width + 'px',
                    height: this.width + 'px'
                };
                
                if (this.item.x > 0) {
                    style['border-left'] = 'none';
                }
                
                if (this.item.y < this.fieldSize - 1) {
                    style['border-bottom'] = 'none';
                }
                
                return style;
            },
            
            cubeSize: function() {
                return this.width - 2;
            },
            
            bgColor: function() {
                return ksGlobal.Colors.getColorByName(this.item.bgColor);
            },
            
            color: function() {
                return ksGlobal.Colors.getColorByName(this.item.color);
            },
            
            classSelectRect: function() {
                return {
                    selected: this.item.selected
                };
            },
            
            styleCubeContainer: function() {
                let bgColor = this.item.type === ksGlobal.MagicCubesType.Full ? this.color : this.bgColor;
                        
                return {
                    'width': this.cubeSize + 'px',
                    'height': this.cubeSize + 'px',
                    'background-color': bgColor
                };
            },
            
            styleCube: function() {
                let style = {
                        width: '0',
                        height: '0'
                    };                
                
                switch (this.item.type) {
                    case ksGlobal.MagicCubesType.LeftTop:
                        style['border-top'] = this.cubeSize + 'px solid ' + this.color;
                        style['border-right'] = this.cubeSize + 'px solid transparent';
                        break;
                    
                    case ksGlobal.MagicCubesType.RightTop:
                        style['border-top'] = this.cubeSize + 'px solid ' + this.color;
                        style['border-left'] = this.cubeSize + 'px solid transparent';
                        break;
                    
                    case ksGlobal.MagicCubesType.RightBottom:
                        style['border-bottom'] = this.cubeSize + 'px solid ' + this.color;
                        style['border-left'] = this.cubeSize + 'px solid transparent';
                        break;
                    
                    case ksGlobal.MagicCubesType.LeftBottom:
                        style['border-bottom'] = this.cubeSize + 'px solid ' + this.color;
                        style['border-right'] = this.cubeSize + 'px solid transparent';
                        break;
                    
                }
                
                return style;
            }
        },
        
        data: function() {
            return {
                isMouseHover: false
            };
        },
        
        methods: {
            onClick: function(event) {
                this.$emit('click', this.item, {x: event.x, y: event.y});
            },
            
            onMouseEnter: function() {
                if (this.readonly || isMouseHoverDisabled) {
                    return;
                }
                
                this.isMouseHover = true;
            },
            
            onMouseLeave: function() {
                if (this.readonly) {
                    return;
                }
                
                this.isMouseHover = false;
            }            
        }
    });    
    
    Vue.component('magic-cubes-field', {
        template: 
            '<div class="magic-cubes-field" :class="classField">' +
            '  <div v-for="row in field" class="magic-cubes-field-row">' +    
            '    <magic-cubes-field-el ' + 
                    'v-for="item in row" ' + 
                    ':key="getItemKey(item)" ' + 
                    ':item="item" :width="itemWidth" ' +
                    ':field-size="field.length" ' + 
                    ':readonly="readonly" ' +
                    ':correct-mode="correctMode" ' +
                    '@click="onClickItem">' + 
            '    </magic-cubes-field-el>' +    
            '  </div>' +    
            '</div>',    
        
        props: {
            readonly: {
                type: Boolean,
                required: true
            },
            
            field: {
                type: Array,
                required: true
            },
            
            loaded: {
                type: Boolean,
                required: true
            },
            
            correctMode: {
                type: Boolean,
                default: false
            }
        },
        
        data: function() {
            return {
                width: 0,
                
                updateTimer: null
            };
        },
        
        computed: {
            classField: function() {
                return {
                    focused: ! this.readonly
                };
            },
            
            itemWidth: function() {
                return this.field.length > 0 ? Math.floor(this.width / this.field.length) : 0;
            }
        },
        
        methods: {
            getItemKey: function(item) {
                return (item.y + 1) * 100 + item.x;
            },
            
            onWindowResize: function() {
                this.updateSize();
            },
            
            onClickItem: function(item, cursorPos) {
                this.$emit('click-item', item, cursorPos);
            },
            
            intUpdateSize: function() {
                this.updateTimer = null;
                
                var style = window.getComputedStyle(this.$el),
                    width = Math.floor(parseFloat(style.width) - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight)) - FIELD_BORDER_SIZE * 2;
                if (this.width !== width && width > 0) {
                    this.width = width;
                }    
            },
            
            updateSize: function(width) {
                if (typeof width !== 'undefined' && this.width !== width) {
                    this.width = width;
                    return;
                }
                
                if (this.updateTimer !== null) {
                    clearTimeout(this.updateTimer);
                    this.updateTimer = null;
                }
                
                this.updateTimer = setTimeout(this.intUpdateSize, 50);
            }
        },
        
        watch: {
            loaded: function(newLoaded) {
                if (newLoaded) {
                    this.updateSize();
                }
            },
            
            width: function(newWidth) {
                this.$emit('change-width', newWidth);
            }
        },
        
        created: function() {
            window.addEventListener('resize', this.onWindowResize);
        },
        
        destroyed: function() {
            window.removeEventListener('resize', this.onWindowResize);
        },
        
        mounted: function() {
            this.updateSize();
        }
    });    
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 10.12.2019
 */

(function() {
    
    const DEFAULT_COLOR_SELECTOR_ITEM_SIZE = 50; //px
    const FIELD_BORDER_SIZE = 4;
    
    const isMouseHoverDisabled = ks.browser.isMobile.any() || ks.browser.isTouch();
    
    Vue.component('magic-points-color-selector', {
        template: 
            '<div v-show="visible" class="magic-points-color-selector" :style="styleBox">' +
                '<div v-for="color in colors" :key="color" @click="clickItem(color)" class="magic-points-color-selector-item"><div :style="itemStyle(color)" ></div></div>' +
            '</div>',
        
        props: {
            colors: {
                type: Array,
                required: true
            }
        },
        
        data: function() {
            return {
                windowWidth: 0,
                cursorPos: {
                    x: 0,
                    y: 0
                },
                visible: false,
                item: null
            };
        },
        
        computed: {
            styleBox: function() {
                var delta = this.windowWidth - this.width,
                    left = delta < 20 ? Math.floor(delta / 2) : Math.floor(this.cursorPos.x - (this.width / 2)),
                    top = Math.floor(this.cursorPos.y - (this.itemSize / 2)),
                    height = this.itemSize + 18;  
            
                if (left + this.width + 50 > this.windowWidth) {
                    left = Math.floor((this.windowWidth - this.width) / 2);
                }
                
                if (left < 4) {
                    left = 4;
                }  
                
                return {
                    'top': top + 'px',
                    'left': left + 'px',
                    'height': height + 'px'
                };
            },
            
            itemSize: function() {
                if (this.colors.length <= 0) {
                    return 0;
                }
                
                var size = DEFAULT_COLOR_SELECTOR_ITEM_SIZE;
                
                if (size * this.colors.length + 16 > this.windowWidth) {
                    size = Math.floor(this.windowWidth / this.colors.length) - 16;
                }
                
                return size;
            },
            
            width: function() {
                return this.colors.length > 0 ? this.itemSize * this.colors.length + 16 * (this.colors.length - 1) : 0;
            }
            
        },
        
        methods: {
            show: function(item, cursorPos) {
                this.item = item;
                
                this.onWindowResize();
                
                this.cursorPos.x = cursorPos.x;
                this.cursorPos.y = cursorPos.y;
                
                this.item.selected = true;
                
                ks.soundManager.playEffect(ks.sounds.SHOW_MENU);
                
                var self = this;
                this.$nextTick(function() {
                    self.visible = true;
                });
            },
            
            hide: function() {
                if (this.item !== null) {
                    this.item.selected = false;
                }
                this.visible = false;
            },
    
            clickItem: function(color) {
                this.item.color = color;
                this.item.hasPoint = true;
                
                ks.soundManager.playEffect(ks.sounds.CUBE);
                
                this.hide();
            },
            
            itemStyle: function(color) {
                var hexColor = ksGlobal.Colors.getColorByName(color);
                
                return {
                    'width': this.itemSize + 'px',
                    'height': this.itemSize + 'px',
                    'border-radius': Math.ceil(this.itemSize / 2) + 'px',
                    'background-color': hexColor,
                    'border': '2px solid ' + hexColor
                };
            },
            
            onWindowResize: function() {
                var wndWidth = window.innerWidth/* document.documentElement.clientWidth */ - 16;
                
                if (this.windowWidth !== wndWidth) {
                    this.windowWidth = wndWidth;
                    this.hide();
                }
            }
        },
        
        created: function() {
            window.addEventListener('resize', this.onWindowResize);
            window.addEventListener('wheel', this.hide);
        },
        
        destroyed: function() {
            window.removeEventListener('resize', this.onWindowResize);
            window.removeEventListener('wheel', this.hide);
        },
        
        mounted: function() {
            var self = this;
            $(document).mouseup(function(e) {
                var container = $(self.$el);
                if (container.has(e.target).length === 0){
                    self.hide();
                }
            });
        }
        
    });    
    
    Vue.component('magic-points-field-el', {
        template: 
            '<div class="magic-points-field-el" :class="classEl" :style="styleEl" @click="onClick($event)" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">' +
                '<div v-show="item.hasPoint" class="magic-points-point" :style="stylePoint"></div>' +
            '</div>',
        
        props: {
            item: {
                type: Object,
                required: true
            },
            
            width: {
                type: Number,
                required: true
            },
            
            fieldSize: {
                type: Number,
                required: true
            },
            
            readonly: {
                type: Boolean,
                required: true
            },
            
            correctMode: {
                type: Boolean,
                default: false
            }
        },
        
        computed: {
            styleEl: function() {
                var style = {
                    width: this.width + 'px',
                    height: this.width + 'px'
                };
                
                if (this.item.x > 0) {
                    style['border-left'] = 'none';
                }
                
                if (this.item.y < this.fieldSize - 1) {
                    style['border-bottom'] = 'none';
                }
                
                return style;
            },
            
            classEl: function() {
                return {
                    'magic-points-field-el-hover': ! isMouseHoverDisabled && ! this.item.selected && this.isMouseHover === true && ! this.item.hasPoint,
                    'magic-points-field-el-hover-point': ! isMouseHoverDisabled && ! this.item.selected && this.isMouseHover === true && this.item.hasPoint,
                    'magic-points-field-el-selected': this.item.selected,
                    
                    'magic-points-field-el-correct': this.correctMode && this.item.hasPoint && this.item.isCorrect,
                    'magic-points-field-el-incorrect': this.correctMode && ! this.item.isCorrect
                };
            },
            
            hexColor: function() {
                return this.item.color !== '' ? ksGlobal.Colors.getColorByName(this.item.color) : '#000000';
            },
            
            stylePoint: function() {
                var size = Math.floor(this.width * 0.7),
                    offset = (this.width - size) / 2;
                
                return {
                    width: size + 'px',
                    height: size + 'px',
                    'border-radius': Math.ceil(size / 2) + 'px',
                    'margin-top': offset + 'px',
                    'background-color': this.hexColor,
                    'box-shadow': ! isMouseHoverDisabled && this.isMouseHover ? '0 0 2px ' + ksGlobal.Colors.hexToRgba(this.hexColor) : 'none'
                };
            }
        },
        
        data: function() {
            return {
                isMouseHover: false
            };
        },
        
        methods: {
            onClick: function(event) {
                if (this.readonly) {
                    return;
                }
                
                this.$emit('click', this.item, {x: event.x, y: event.y});
            },
            
            onMouseEnter: function() {
                if (this.readonly) {
                    return;
                }
                
                this.isMouseHover = true;
            },
            
            onMouseLeave: function() {
                if (this.readonly) {
                    return;
                }
                
                this.isMouseHover = false;
            }
        }
    });    
    
    Vue.component('magic-points-field', {
        template: 
            '<div class="magic-points-field" :class="classField">' +
            '  <div v-for="row in field" class="magic-points-field-row">' +    
            '    <magic-points-field-el ' +
                    'v-for="item in row" ' +
                    ':key="getItemKey(item)" ' +
                    ':item="item" ' +
                    ':width="itemWidth" ' +
                    ':field-size="field.length" ' +
                    ':readonly="readonly" ' +
                    ':correct-mode="correctMode" ' +
                    '@click="onClickItem">' +
            '    </magic-points-field-el>' +    
            '  </div>' +    
            '</div>',
        
        props: {
            readonly: {
                type: Boolean,
                required: true
            },
            
            field: {
                type: Array,
                required: true
            },
            
            loaded: {
                type: Boolean,
                required: true
            },
            
            correctMode: {
                type: Boolean,
                default: false
            }
        },
        
        data: function() {
            return {
                width: 0,
                
                updateTimer: null
            };
        },
        
        computed: {
            classField: function() {
                return {
                    focused: ! this.readonly
                };
            },
            
            itemWidth: function() {
                return this.field.length > 0 ? Math.floor(this.width / this.field.length) : 0;
            }
        },
        
        methods: {
            getItemKey: function(item) {
                return (item.y + 1) * 100 + item.x;
            },
            
            onWindowResize: function() {
                this.updateSize();
            },
            
            onClickItem: function(item, cursorPos) {
                this.$emit('click-item', item, cursorPos);
            },
            
            intUpdateSize: function() {
                this.updateTimer = null;
                
                var style = window.getComputedStyle(this.$el),
                    width = Math.floor(parseFloat(style.width) - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight)) - FIELD_BORDER_SIZE * 2;
                if (this.width !== width && width > 0) {
                    this.width = width;
                }    
            },
            
            updateSize: function(width) {
                if (typeof width !== 'undefined' && this.width !== width) {
                    this.width = width;
                    return;
                }
                
                if (this.updateTimer !== null) {
                    clearTimeout(this.updateTimer);
                    this.updateTimer = null;
                }
                
                this.updateTimer = setTimeout(this.intUpdateSize, 50);
            }
        },
        
        watch: {
            loaded: function(newLoaded) {
                if (newLoaded) {
                    this.updateSize();
                }
            },
            
            width: function(newWidth) {
                this.$emit('change-width', newWidth);
            }
        },
        
        created: function() {
            window.addEventListener('resize', this.onWindowResize);
        },
        
        destroyed: function() {
            window.removeEventListener('resize', this.onWindowResize);
        },
        
        mounted: function() {
            this.updateSize();
        }
    });    
    
}());
/* 
 * (c) Kids Smart
 * 06.11.2020 -AF-
 */

(function(){

   var ParticleManager = function(maxPacticlesCount) {
        let self = this;

        this.maxPacticlesCount = maxPacticlesCount || 50; // макс кол-во частиц в момент времени, по умолчанию 50
        this._particles = [];
        
        this.colors = ['#f8d838', '#7fc659', '#4ba4ba', '#ba75c5', '#e27298'];
        this.symbols = [
            ['&#9883;'],
            ['&#9728;'],
            ['&#9752;'],
            ['&#127989;'],
            ['&#10084;'],
            ['&#9786;'],
            ['&#10023;', '&#10022;', '&#10036;', '&#10057;', '&#10037;'],
            ['&#10059;', '&#9733;', '&#10031;', '&#9885;', '&#10042;']            
        ];

        this.isEnabled = document.body.animate ? true : false;
        
        this.add = function(x, y, options, group) {
            if ( ! this.isEnabled) {
                return false;
            }

            let amount = options.amount || 20, // кол-во частиц, по умолчанию 20
                count = this._particles.length + amount > this.maxPacticlesCount ? this.maxPacticlesCount - this._particles.length : amount;
            if (count <= 0) {
                return false;
            }

            for (let i = 0; i < count; i++) {
                this._createParticle(x, y, options, group);
            }

            return true;
        };
        
        this.clear = function(group) {
            let useGroup = typeof group !== 'undefined',
                removeList = [];
            for (let i = 0, count = this._particles.length; i < count; i++) {
                if (useGroup && this._particles[i].getAttribute('data-group') !== group) {
                    continue;
                }
                
                removeList.push(this._particles[i]);
                this._particles[i].remove();
            }
            
            if (useGroup) {
                for (let i = 0, count = removeList.length; i < count; i++) {
                    let index = this._particles.indexOf(removeList[i]);
                    if (index < 0) {
                        continue;
                    }

                    this._particles.splice(index, 1);
                }
            } else {
                this._particles = [];
            }
        };

        this._createParticle = function(x, y, options, group) {
            let particle = document.createElement('particle'),
                width = Math.floor(Math.random() * 30 + 8),
                height = width,
                destinationX = x + (Math.random() - 0.5) * 300,
                destinationY = y + (Math.random() - 0.5) * 300,
                rotation = Math.random() * 520,
                delay = Math.random() * 200,
                color = typeof options.colors !== 'undefined' ? 
                    options.colors[Math.floor(Math.random() * options.colors.length)] : 
                    this.colors[Math.floor(Math.random() * this.colors.length)];

            if (typeof group !== 'undefined') {        
                particle.setAttribute('data-group', group);
            }
            particle.style.position = 'absolute';    
            particle.style.top = 0;    
            particle.style.left = 0;    
            particle.style.opacity = 0;    
            particle.style['pointer-events'] = 'none';    
            particle.style['background-repeat'] = 'no-repeat';    
            particle.style['background-size'] = 'contain';    

            document.body.appendChild(particle);
            
            this._particles.push(particle);

            switch (options.type) {
                case 'symbol':
                    let fontSize = options.fontSize || Math.random() * 36 + 10,
                        symbol = typeof options.symbols !== 'undefined' ? 
                            options.symbols[Math.floor(Math.random() * options.symbols.length)] : null;
                            
                    if (symbol === null) {
                        let symbols = this.symbols[Math.floor(Math.random() * this.symbols.length)];
                        symbol = symbols[Math.floor(Math.random() * symbols.length)];
                    }        

                    particle.innerHTML = symbol;
                    particle.style.color = color;
                    particle.style.fontSize = fontSize  + 'px'; 
                    width = height = 'auto';

                    break;

                case 'image':
                    particle.style.backgroundImage = 'url(' + options.image + ')';

                    break;

                case 'point':
                    let shadow = Math.floor(Math.random() * 10 + 10);

                    particle.style.boxShadow = '0 0 ' + shadow + 'px ' + color;
                    particle.style.background = color;
                    particle.style.borderRadius = '50%';
                    width = height = Math.random() * 5 + 4; 

                    break;

                case 'line':
                    particle.style.background = color;
                    height = options.height;
                    rotation += 1000;
                    delay = Math.random() * 1000;

                    break;
            }

            particle.style.width = width + 'px';
            particle.style.height = height + 'px';

            let animation = particle.animate([
                {
                    transform: 'translate(-50%, -50%) translate(' + x + 'px, ' + y + 'px) rotate(0deg)',
                    opacity: 1
                },
                {
                    transform: 'translate(-50%, -50%) translate(' + destinationX + 'px, ' + destinationY + 'px) rotate(' + rotation + 'deg)',
                    opacity: 0
                }
                ], {
                duration: options.duration || (Math.random() + 2) * 1000, // Продолжительность всех эффектов
                easing: 'cubic-bezier(0, .9, .57, 1)',
                delay: delay
            });
            animation.onfinish = this._removeParticle;
        };

        this._removeParticle = function(e) {
            let index = self._particles.indexOf(e.srcElement.effect.target);
            if (index > -1) {
                self._particles.splice(index, 1);
            }
            
            e.srcElement.effect.target.remove();
        };
    };
    
    ks.particleManager = new ParticleManager();

    var ParticleAnimations = function() {
        this._items = [];
        
        this._getRandomPos = function(rectangle) {
            let offsetX = (rectangle.right - rectangle.left) / 4, // кол-во пикселей, которое будет отступать от границ
                offsetY = (rectangle.top - rectangle.bottom) / 4, // кол-во пикселей, которое будет отступать от границ
                pos = {
                x: 0,
                y: 0
            };
            
            pos.x = rectangle.left === rectangle.right ? rectangle.left : rectangle.left + Math.floor(Math.random() * (rectangle.right - rectangle.left));
            pos.y = rectangle.top === rectangle.bottom ? rectangle.top : rectangle.top + Math.floor(Math.random() * (rectangle.bottom - rectangle.top));
            
            if (rectangle.left !== rectangle.right) {
                if (pos.x - rectangle.left < offsetX) {
                    pos.x += offsetX;
                }

                if (pos.x + offsetX > rectangle.right) {
                    pos.x = rectangle.right - offsetX;
                }            
            }
            
            if (rectangle.top !== rectangle.bottom) {
                if (pos.y - rectangle.top < offsetY) {
                    pos.y += offsetY;
                }

                if (pos.y + offsetY > rectangle.bottom) {
                    pos.y = rectangle.bottom - offsetY;
                }             
            }
            
            return pos;
        };
        
        this.start = function(name, rectangle, particleOptions, count, interval, onStop) {
            let index = this.getItemIndex(name);
            
            if (index > -1) {
                return false;
            }
            
            let self = this;
            this._items.push({
                name: name,
                maxCount: count - 1, // на один меньше, т.к. сразу покажем один раз
                count: 0,
                rectangle: rectangle,
                onStop: onStop,
                onTimer: function() {
                    let index = self.getItemIndex(name);

                    if (index < 0) {
                        return;
                    }   

                    let item = self._items[index],
                        pos = self._getRandomPos(item.rectangle);

                    ks.particleManager.add(pos.x, pos.y, particleOptions, name);

                    self._items[index].count++;
                    if (item.count >= self._items[index].maxCount) {
                        self.stop(name);
                    }                    
                },
                timer: null
            });
            
            let item = this._items[this._items.length - 1];
            item.timer = setInterval(item.onTimer, interval);
            item.onTimer();
            
            return true;
        };
        
        this.stop = function(name) {
            let index = this.getItemIndex(name);
            if (index < 0) {
                return false;
            }
            
            clearInterval(this._items[index].timer);
            
            ks.particleManager.clear(this._items[index].name);
            
            if (typeof this._items[index].onStop !== 'undefined') {
                this._items[index].onStop();
            }
            
            this._items.splice(index, 1);
            
            return true;
        };
        
        this.changeRectangle = function(name, rectangle) {
            let index = this.getItemIndex(name);
            
            if (index < 0) {
                return false;
            }
            
            this._items[index].rectangle = rectangle;
            
            return true;
        };
        
        this.getItemIndex = function(name) {
            for (let i = 0, count = this._items.length; i < count; i++) {
                if (this._items[i].name === name) {
                    return i;
                }
            }
            
            return -1;
        };
    };
    
    ks.particleAnimations = new ParticleAnimations();
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 23.12.2017
 */

(function() {
    
    /* Consts */
    var ZINDEX_NORMAL = 1,
        ZINDEX_FRONT  = 2,
        
        STATE_UNLOADED = 0,
        STATE_PREVIEW  = 1,
        STATE_SHUFFLE  = 2,
        STATE_PUZZLE   = 3,
        STATE_FINISH   = 4,
        
        MAX_DEFAULT_SHUFFLE_ITERATIONS = 50;
 
    /* Class PuzzleClassicItem */
    var PuzzleClassicItem = function(options) {
        var self = this;
        
        this.x = options.x;
        this.y = options.y;
        
        this.currentPosition = {
            x: this.x,
            y: this.y
        };
        
        this.size = options.size;
        
        this.events = options.events;
        
        this.el = $('<div/>', {
            class: 'puzzle-classic-item',
            css: {
                'background-image': 'url(' + options.imageUrl + ')',
                'z-index': 1
            }
        });        
        
        // Выбран элемент или нет
        this.selected = false;
        
        // В режиме fixed элементы не реагируют на действия с ними
        this.fixed = false;
        
        // Перемещается ли элемент
        this.isMoving = false;
        
        this.updateSize = function(imageWidth, imageHeight){
            var left = this.x * this.size.width,
                top = this.y * this.size.height,
                style = {
                    width: this.size.width,
                    height: this.size.height,                 
                    'background-position' : '-' + left + 'px -' + top + 'px'
                };         
                
            if (typeof imageWidth !== 'undefined' && typeof imageHeight !== 'undefined' && imageWidth !== null && imageHeight !== null) {
                style['background-size'] = imageWidth + 'px ' + imageHeight + 'px';
            }    
            
            this.el.css(style);
            
            return this;
        };
        
        this.resetPosition = function(updatePosition) {
            this.currentPosition.x = this.x;
            this.currentPosition.y = this.y;
            
            return updatePosition ? this.updatePosition() : this;
        };
        
        this.updatePosition = function(animate) {
            var currentX = this.currentPosition.x * this.size.width,         
                currentY = this.currentPosition.y * this.size.height;
        
            if (animate) {
                this.isMoving = true;
                
                this.el.animate({
                    left: currentX,
                    top: currentY								
                }, 300, 'swing', function(){
                    self.isMoving = false;
                });
            } else {
                this.el.css({
                    left: currentX,
                    top: currentY								
                });               
                
                this.isMoving = false;
            } 
            
            return this;
        };
        
        this.setSize = function(size, imageWidth, imageHeight){
            this.size = size;
            
            return this.updateSize(imageWidth, imageHeight).updatePosition();
        };
        
        this.setCurrentPosition = function(position, updatePosition, animate){
            this.currentPosition = position;
            
            return updatePosition ? this.updatePosition(animate) : this; 
        };
        
        this.setSelected = function(selected){
            if (this.selected === selected) {
                return this;
            }
            
            this.selected = selected;
            
            if (this.selected) {
                this.el.addClass('selected');
            } else {
                this.el.removeClass('selected');
            }
            
            return this;
        };
        
        this.setZIndex = function(zindex){
            this.el.css('z-index', zindex);
            
            return this;
        };
        
        // Правильную позицию (согласно первоначальной картинке) занимает элемент
        this.isCorrectPosition = function(){
            return this.x === this.currentPosition.x && this.y === this.currentPosition.y;
        };
        
        // Установка/снятие режима fixed (элемент не реагирует на дейтсвия)
        this.setFixed = function(isFixed) {
            this.fixed = isFixed;
            
            if (this.fixed) {
                this.el.addClass('fixed');
            } else {
                this.el.removeClass('fixed');
            }
            
            return this;
        };
        
        // Передаем события в главный класс PuzzleClassic
        this.el.on('click', function(){
            if (self.events.onClick) {
                self.events.onClick(self);
            }
        });
        
        this.el.on('mouseenter', function(){
            if (self.events.onMouseEnter) {
                self.events.onMouseEnter(self);
            }
        });        
        
        /* Init Section */
        this.updateSize(options.imageWidth, options.imageHeight).updatePosition(false);
    };
    
    /* Main Class PuzzleClassic */
    ks.PuzzleClassic = function(el) {
        var self = this;
        
        this.el = el;
        this.container = el.parent();
        
        this.options = null;
        
        this.itemSize = {
            width  : 0,
            height : 0
        };
        
        this.items = [];
        
        this.resizeTimer = null;
        
        this.state = STATE_UNLOADED;
        
        this.setFixedItems = function(isFixed) {
            for (var i = 0; i < this.items.length; i++) {
                this.items[i].setFixed(isFixed);
            }            
        };
        
        this.isItemsMoving = function() {
            for (var i = 0; i < this.items.length; i++) {
                if (this.items[i].isMoving) {
                    return true;
                }
            }   
            
            return false;
        };
        
        this.setState = function(state) {
            this.state = state;
            
            switch (this.state) {
                case STATE_UNLOADED:
                    this.el.addClass('hidden');
                    break;
                case STATE_PREVIEW:
                    this.el.removeClass('hidden');
                    this.setFixedItems(true);
                    break;
                case STATE_PUZZLE:
                    this.setFixedItems(false);
                    break;
                case STATE_FINISH:
                    this.setFixedItems(true);
                    break;
            }
            
            return this;
        };
        
        this.unload = function(changeState) {
            window.removeEventListener('resize', this.onWindowResize);
            
            if (changeState) {
                this.setState(STATE_UNLOADED);
            }
            
            this.itemSize = {
                width  : 0,
                height : 0
            };

            for (var i = 0; i < this.items.length; i++) {
                this.items[i].el.remove();
            }

            this.items = [];   
        };
        
        this.load = function(options) {
            this.options = options;
            
            this.unload(false);
            
            window.addEventListener('resize', this.onWindowResize);
            
            this.calcSizes().createItems();
            
            this.setState(STATE_PREVIEW);
        };
        
        this.createItems = function(){
            for (var x = 0; x < this.options.items.hCount; x++) {
                for (var y = 0; y < this.options.items.vCount; y++) {
                    var item = new PuzzleClassicItem({
                        imageUrl: this.options.image.url,
                        imageWidth: this.container.width(),
                        imageHeight: this.container.height(),
                        x: x,
                        y: y,
                        size: this.itemSize,
                        events: {
                            onClick: this.onClickItem,
                            onMouseEnter: this.onMouseEnterItem
                        }
                    });
                    
                    this.items.push(item);
                    
                    this.el.append(item.el);
                }
            }
            
            return this;
        };
        
        this.calcSizes = function(){
            var containerWidth = this.container.width(),
                width = containerWidth < this.options.image.width ? containerWidth : this.options.image.width,
                height = width * this.options.image.height / this.options.image.width,
                left = (containerWidth - width) / 2;
            
            this.el.css({
                'left'   : left,
                'width'  : width,
                'height' : height
            });
            
            this.itemSize.width = width / this.options.items.hCount;
            this.itemSize.height = height / this.options.items.vCount;
            
            for (var i = 0; i < this.items.length; i++) {
                this.items[i].setSize(this.itemSize, width, height);
            }
            
            return this;
        };
        
        this.moveItems = function(item1, item2, updatePosition, animate){
            var position = item1.currentPosition;

            if (updatePosition && animate) {
                for (var i = 0; i < this.items.length; i++) {
                    var isFront = this.items[i] === item1 || this.items[i] === item2;
                    this.items[i].setZIndex(isFront ? ZINDEX_FRONT : ZINDEX_NORMAL);
                }
            }

            item1.setCurrentPosition(item2.currentPosition, updatePosition, animate);
            item2.setCurrentPosition(position, updatePosition, animate);            
        };
        
        this.resetItems = function(updatePosition) {
            for (var i = 0; i < this.items.length; i++) {
                this.items[i].resetPosition(updatePosition).setFixed(true);
            }
            
            this.setState(STATE_PREVIEW);
            
            return this;
        };
        
        // Проверяем перемешались ли элементы - 
        // если каждый из элементов не на своем месте
        this.isShuffleItemsDone = function(){
            for (var i = 0; i < this.items.length; i++) {
                if (this.items[i].isCorrectPosition()) {
                    return false;
                }
            }
            
            return true;
        };
        
        // Событие вызывается после перемешивания элементов -
        // меняем состояние на STATE_PUZZLE и обновляем размеры и позиции элементов,
        // т.к. возможно, что во время перемешивания изменилось размер области для вывода пазла
        this.onShuffleFinish = function() {
            var self = this,
                timer = setInterval(function(){
                    if ( ! self.isItemsMoving()) {
                        clearInterval(timer);
                        self.calcSizes().setState(STATE_PUZZLE);
                    }
                }, 50);
                
            return this;    
        };
        
        // Максимальное кол-во перемещиваний
        this.getMaxShuffleIterations = function() {
            if (this.options.maxShuffleAttempts > 0) {
                return this.options.maxShuffleIterations;
            } else {
                var max = this.options.items.hCount * this.options.items.vCount;
                
                return max < MAX_DEFAULT_SHUFFLE_ITERATIONS ? MAX_DEFAULT_SHUFFLE_ITERATIONS : max;
            }
        };
        
        // Перемешиваем элементы пазлов
        this.shuffleItems = function(){
            var index1, index2,
                maxIterations = this.getMaxShuffleIterations(),
                interations;
        
            this.setState(STATE_SHUFFLE);    
            
            // Сбрасываем позиции элементов на первоначальные
            this.resetItems(false);
            
            // Мешаем элементы
            interations = 0;
            do {
                do { 
                    index1 = ks.helpers.math.getRandomInt(0, this.items.length - 1);
                    index2 = ks.helpers.math.getRandomInt(0, this.items.length - 1);
                } while (index1 === index2);
                
                // Меняем элементы местами, но не рендерим
                this.moveItems(this.items[index1], this.items[index2], false, false);
                
                interations++;
                
                // Перемешиваем элементы пазлов пока _каждый_ из элементов
                // будет не на своем месте, либо не достигнем максимального
                // кол-ва перемещений
                if (interations > maxIterations) {
                    break;
                }
            } while ( ! this.isShuffleItemsDone());
            
            // Все элементы поменяли свои места - рендерим
            for (var i = 0; i < this.items.length; i++) {
                this.items[i].updatePosition(true);
            }
            
            this.onShuffleFinish();
            
            return this;
        };
        
        this.getSelectedItem = function(){
            for (var i = 0; i < this.items.length; i++) {
                if (this.items[i].selected) {
                    return this.items[i];
                }
            }
            
            return null;
        };
        
        this.isFinish = function(){
            for (var i = 0; i < this.items.length; i++) {
                if ( ! this.items[i].isCorrectPosition()) {
                    return false;
                }
            }
            
            return true;
        };
        
        this.onClickItem = function(item){
            // Если в режиме preview - стартуем пазл
            if (self.state === STATE_PREVIEW) {
                if (self.options.events.onStart) {
                    self.options.events.onStart();
                }                 
                
                return true;
            }
            
            // Если мы не в режиме пазла - выходим
            if (self.state !== STATE_PUZZLE) {
                return false;
            }
            
            // Обрабатываем клик по элементу
            var selectedItem = self.getSelectedItem();
            
            if (selectedItem !== null) {
                if (selectedItem !== item) {
                    self.moveItems(selectedItem, item, true, true);
                    
                    ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                    
                    if (self.options.events.onStep) {
                        self.options.events.onStep();
                    }                    
                    
                    if (self.isFinish()) {
                        self.setState(STATE_FINISH);
                        
                        if (self.options.events.onFinish) {
                            self.options.events.onFinish(true);
                        }
                    }
                }
                
                selectedItem.setSelected(false);
            } else {
                if ( ! item.selected) {
                    ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                }
                item.setSelected( ! item.selected);
            }
            
            return true;
        };
        
        this.onMouseEnterItem = function(item) {
            // Если мы не в режиме пазла - выходим
            if (self.state !== STATE_PUZZLE) {
                return false;
            }
            
            if ( ! item.selected) {
                ks.soundManager.playEffect(ks.sounds.ANSWER_HOVER);
            }
        };
        
        // При изменении экрана (но не чаще 300 мс) изменяем размер элементов
        // пазла
        this.onWindowResize = function() {
            if (self.resizeTimer !== null) {
                clearTimeout(self.resizeTimer);
                self.resizeTimer = null;
            }
            
            self.resizeTimer = setTimeout(function(){
                self.calcSizes();
                self.resizeTimer = null;
            }, 300);            
        };        
    };
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 24.12.2017
 */

(function() {
    
    /* Consts */
    var STATE_UNLOADED = 0,
        STATE_PREVIEW  = 1,
        STATE_SHUFFLE  = 2,
        STATE_PUZZLE   = 3,
        STATE_FINISH   = 4,
        
        MIN_PERCENT_INCORRECT_ITEMS = 70;//30;
 
    /* Class PuzzleZeroFieldItem */
    var PuzzleZeroFieldItem = function(options) {
        var self = this;
        
        this.x = options.x;
        this.y = options.y;
        
        this.currentPosition = {
            x: this.x,
            y: this.y
        };
        
        this.size = options.size;
        
        this.events = options.events;
        
        this.canMove = false;
        
        // Флаг пустая клетка
        this.isZeroField = false;
        
        this.el = $('<div/>', {
            class: 'puzzle-zero-field-item',
            css: {
                'background-image': 'url(' + options.imageUrl + ')',
                'z-index': 1
            }
        });        
        
        // В режиме fixed элементы не реагируют на действия с ними
        this.fixed = false;
        
        this.updateSize = function(imageWidth, imageHeight){
            var left = this.x * this.size.width,
                top = this.y * this.size.height,
                style = {
                    width: this.size.width,
                    height: this.size.height,                 
                    'background-position' : '-' + left + 'px -' + top + 'px'
                };         
                
            if (typeof imageWidth !== 'undefined' && typeof imageHeight !== 'undefined' && imageWidth !== null && imageHeight !== null) {
                style['background-size'] = imageWidth + 'px ' + imageHeight + 'px';
            }    
            
            this.el.css(style);
            
            return this;
        };
        
        this.resetPosition = function(updatePosition) {
            this.currentPosition.x = this.x;
            this.currentPosition.y = this.y;
            
            return updatePosition ? this.updatePosition() : this;
        };
        
        this.updatePosition = function(animate) {
            var currentX = this.currentPosition.x * this.size.width,         
                currentY = this.currentPosition.y * this.size.height;
        
            if (animate) {
                this.el.animate({
                    left: currentX,
                    top: currentY								
                }, 300, 'swing');
            } else {
                this.el.css({
                    left: currentX,
                    top: currentY								
                });               
            } 
            
            return this;
        };
        
        this.setSize = function(size, imageWidth, imageHeight){
            this.size = size;
            
            return this.updateSize(imageWidth, imageHeight).updatePosition();
        };
        
        this.setCurrentPosition = function(position, updatePosition, animate){
            this.currentPosition = position;
            
            return updatePosition ? this.updatePosition(animate) : this; 
        };
        
        // Правильную позицию (согласно первоначальной картинке) занимает элемент
        this.isCorrectPosition = function(){
            return this.x === this.currentPosition.x && this.y === this.currentPosition.y;
        };
        
        // Установка/снятие режима fixed (элемент не реагирует на дейтсвия)
        this.setFixed = function(isFixed) {
            this.fixed = isFixed;
            
            if (this.fixed) {
                this.el.addClass('fixed');
            } else {
                this.el.removeClass('fixed');
            }
            
            return this;
        };
        
        // Передаем события в главный класс PuzzleZeroField
        this.el.on('click', function(){
            if (self.isZeroField) {
                return;
            }
            
            if (self.events.onClick) {
                self.events.onClick(self);
            }
        });
        
        this.el.on('mouseenter', function(){
            if (self.events.onMouseEnter) {
                self.events.onMouseEnter(self);
            }
        });        
        
        this.setZeroField = function(isZeroField) {
            this.isZeroField = isZeroField;
            
            this.el.css('opacity', this.isZeroField ? 0 : 1);
            
            return this;
        };
        
        this.setCanMove = function(canMove) {
            this.canMove = canMove;
            
            if (canMove) {
                this.el.addClass('can-move');
            } else {
                this.el.removeClass('can-move');
            }
            
            return this;
        };
        
        /* Init Section */
        this.updateSize(options.imageWidth, options.imageHeight).updatePosition(false);
    };
    
    /* Main Class PuzzleZeroField */
    ks.PuzzleZeroField = function(el) {
        var self = this;
        
        this.el = el;
        this.container = el.parent();
        
        this.options = null;
        
        this.itemSize = {
            width  : 0,
            height : 0
        };
        
        this.items = [];
        
        this.resizeTimer = null;
        
        this.state = STATE_UNLOADED;
        
        this.setFixedItems = function(isFixed) {
            for (var i = 0; i < this.items.length; i++) {
                this.items[i].setFixed(isFixed);
            }            
        };
        
        this.setState = function(state) {
            this.state = state;
            
            switch (this.state) {
                case STATE_UNLOADED:
                    this.el.addClass('hidden');
                    break;
                case STATE_PREVIEW:
                    this.el.removeClass('hidden');
                    this.setFixedItems(true);
                    break;
                case STATE_PUZZLE:
                    this.setFixedItems(false);
                    break;
                case STATE_FINISH:
                    this.setFixedItems(true);
                    break;
            }
            
            return this;
        };
        
        this.unload = function(changeState) {
            window.removeEventListener('resize', this.onWindowResize);
            
            if (changeState) {
                this.setState(STATE_UNLOADED);
            }
            
            this.itemSize = {
                width  : 0,
                height : 0
            };
            
            for (var i = 0; i < this.items.length; i++) {
                this.items[i].el.remove();
            }

            this.items = [];   
        };
        
        this.load = function(options) {
            this.options = options;
            
            this.unload(false);
            
            window.addEventListener('resize', this.onWindowResize);
            
            this.calcSizes().createItems();
            
            this.setState(STATE_PREVIEW);
        };
        
        this.createItems = function(){
            for (var x = 0; x < this.options.items.hCount; x++) {
                for (var y = 0; y < this.options.items.vCount; y++) {
                    var item = new PuzzleZeroFieldItem({
                        imageUrl: this.options.image.url,
                        imageWidth: this.container.width(),
                        imageHeight: this.container.height(),
                        x: x,
                        y: y,
                        size: this.itemSize,
                        events: {
                            onClick: this.onClickItem,
                            onMouseEnter: this.onMouseEnterItem
                        }
                    });
                    
                    this.items.push(item);
                    
                    this.el.append(item.el);
                }
            }
            
            return this;
        };
        
        this.calcSizes = function(){
            var containerWidth = this.container.width(),
                width = containerWidth < this.options.image.width ? containerWidth : this.options.image.width,
                height = width * this.options.image.height / this.options.image.width,
                left = (containerWidth - width) / 2;
            
            this.el.css({
                'left'   : left,
                'width'  : width,
                'height' : height
            });
            
            this.itemSize.width = width / this.options.items.hCount;
            this.itemSize.height = height / this.options.items.vCount;
            
            for (var i = 0; i < this.items.length; i++) {
                this.items[i].setSize(this.itemSize, width, height);
            }
            
            return this;
        };
        
        this.moveItems = function(item1, item2, updatePosition, animate){
            var position = item1.currentPosition;

            item1.setCurrentPosition(item2.currentPosition, updatePosition, animate);
            item2.setCurrentPosition(position, updatePosition, animate);            
        };
        
        this.resetItems = function(updatePosition) {
            for (var i = 0; i < this.items.length; i++) {
                this.items[i].resetPosition(updatePosition).setZeroField(false).setFixed(true);
            }
            
            this.setState(STATE_PREVIEW);
            
            return this;
        };
        
        // Максимальное кол-во перемещиваний
        this.getMaxShuffleIterations = function() {
            if (this.options.maxShuffleAttempts > 0) {
                return this.options.maxShuffleIterations;
            } else {
                return Math.floor(this.options.items.hCount * this.options.items.vCount / 2);
            }
        };
        
        this.getRandomZeroField = function() {
            var pos;
            
            switch (ks.helpers.math.getRandomInt(0, 3)) {
                case 0:
                    pos = {x: 0, y: 0};
                    break;
                case 1:
                    pos = {x: this.options.items.hCount - 1, y: 0};
                    break;
                case 2:
                    pos = {x: this.options.items.hCount - 1, y: this.options.items.vCount - 1};
                    break;
                case 3:
                    pos = {x: 0, y: this.options.items.vCount - 1};
                    break;
            }
            
            return this.getItemByPosition(pos.x, pos.y);
        };
        
        // Перемешиваем элементы пазлов
        this.shuffleItems = function(){
            var items, index,
                maxIterations = this.getMaxShuffleIterations(),
                interations;
        
            this.setState(STATE_SHUFFLE);    
            
            // Сбрасываем позиции элементов на первоначальные
            this.resetItems(false);
            
            this.getRandomZeroField().setZeroField(true);
            
            // Мешаем элементы
            var t = Date.now();
            interations = 0;
            do {
                items = this.getCanMoveItems();
                
                index = ks.helpers.math.getRandomInt(0, items.length - 1);
                
                // Меняем элементы местами, но не рендерим
                this.moveItems(this.getZeroFieldItem(), items[index], false, false);
                
                interations++;

                // 01.11.2023: Если больше 2 секунд идет процесс, то выходим
                if (Date.now() - t > 2000) {
                    break;
                }
                
                // Переставляем элементы пока не закончатся итерации;
                // Если итерации закончились, но все элементы на своих местах -
                // продолжаем перемешивать пока хотя бы 30% элементов будут
                // не на своем месте.
            } while (interations < maxIterations || ! this.isShuffleItemsFinish());
            
            // Все элементы поменяли свои места - рендерим
            for (var i = 0; i < this.items.length; i++) {
                this.items[i].updatePosition(false);
            }
            
            this.updateCanMoveStateItems();
            
            this.setState(STATE_PUZZLE);
            
            return this;
        };
        
        this.isShuffleItemsFinish = function() {
            var percent = this.getIncorrectItemsCount() * 100 / this.items.length;
            const minPrecent = this.options.shuffleMinPercent || MIN_PERCENT_INCORRECT_ITEMS; 
            
            return percent >= minPrecent;
        };
        
        this.getIncorrectItemsCount = function() {
            var count = 0;
            
            for (var i = 0; i < this.items.length; i++) {
                if ( ! this.items[i].isCorrectPosition()) {
                    count++;
                }
            }            
            
            return count;
        };
        
        this.isFinish = function(){
            for (var i = 0; i < this.items.length; i++) {
                if ( ! this.items[i].isCorrectPosition()) {
                    return false;
                }
            }
            
            return true;
        };
        
        this.getItemByPosition = function(x, y) {
            for (var i = 0; i < this.items.length; i++) {
                var position = this.items[i].currentPosition;
                if (position.x === x && position.y === y) {
                    return this.items[i];
                }
            }
            
            return null;
        };
        
        this.updateCanMoveStateItems = function() {
            for (var i = 0; i < this.items.length; i++) {
                if (this.items[i].isZeroField) {
                    continue;
                }
                
                this.items[i].setCanMove(this.canMove(this.items[i]) !== null);
            }
            
            return this;
        };
        
        this.canMove = function(item) {
            var field;
            
            // Проверяем можем ли передвинуть элемент вверх
            if (item.currentPosition.y > 0) {
                field = this.getItemByPosition(item.currentPosition.x, item.currentPosition.y - 1);
                if (field.isZeroField) {
                    return field;
                }
            }
            
            // Проверяем можем ли передвинуть элемент вниз
            if (item.currentPosition.y < this.options.items.vCount - 1) {
                field = this.getItemByPosition(item.currentPosition.x, item.currentPosition.y + 1);
                if (field.isZeroField) {
                    return field;
                }
            }
            
            // Проверяем можем ли передвинуть элемент влево
            if (item.currentPosition.x > 0) {
                field = this.getItemByPosition(item.currentPosition.x - 1, item.currentPosition.y);
                if (field.isZeroField) {
                    return field;
                }
            }
            
            // Проверяем можем ли передвинуть элемент вправо
            if (item.currentPosition.x < this.options.items.hCount - 1) {
                field = this.getItemByPosition(item.currentPosition.x + 1, item.currentPosition.y);
                if (field.isZeroField) {
                    return field;
                }
            }
            
            return null;
        };
        
        this.getCanMoveItems = function() {
            var items = [];
            
            for (var i = 0; i < this.items.length; i++) {
                if (this.items[i].isZeroField) {
                    continue;
                }
                
                if (this.canMove(this.items[i]) !== null) {
                    items.push(this.items[i]);
                }
            }
            
            return items;
        };
        
        this.getZeroFieldItem = function() {
            for (var i = 0; i < this.items.length; i++) {
                if (this.items[i].isZeroField) {
                    return this.items[i];
                }          
            }
            
            return null;
        };
        
        this.onClickItem = function(item){
            // Если в режиме preview - стартуем пазл
            if (self.state === STATE_PREVIEW) {
                if (self.options.events.onStart) {
                    self.options.events.onStart();
                }                 
                
                return true;
            }
            
            // Если мы не в режиме пазла - выходим            
            if (self.state !== STATE_PUZZLE) {
                return false;
            }
            
            // Обрабатываем клик по элементу
            var zeroField = self.canMove(item);
            if (zeroField === null) {
                return false;
            }
            
            self.moveItems(item, zeroField, true, true);
            self.updateCanMoveStateItems();
            
            ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);

            if (self.options.events.onStep) {
                self.options.events.onStep();
            }                    

            if (self.isFinish()) {
                self.setState(STATE_FINISH);
                
                zeroField.setZeroField(false);

                if (self.options.events.onFinish) {
                    self.options.events.onFinish(true);
                }
            }
            
            return true;
        };
        
        this.onMouseEnterItem = function(item) {
            // Если мы не в режиме пазла - выходим
            if (self.state !== STATE_PUZZLE) {
                return false;
            }
            
            if (item.canMove) {
                ks.soundManager.playEffect(ks.sounds.ANSWER_HOVER);
            }
        };        
        
        // При изменении экрана (но не чаще 300 мс) изменяем размер элементов
        // пазла
        this.onWindowResize = function() {
          if (self.resizeTimer !== null) {
                clearTimeout(self.resizeTimer);
                self.resizeTimer = null;
            }
            
            self.resizeTimer = setTimeout(function(){
                self.calcSizes();
                self.resizeTimer = null;
            }, 300);            
        };
    };
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 01.10.2024
 */

class ServiceWorker {

  register() {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        try {
          navigator.serviceWorker.register('/sw.min.js');
        } catch (e) {}
      });
    }
  }

}

ks.serviceWorker = new ServiceWorker();

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 05.04.2018
 */

ks.sounds = {

    ERROR: 'public/sounds/effects/error.ogg',
    
    ANSWER_TRUE: 'public/sounds/effects/answer_true.ogg',
    ANSWER_FALSE: 'public/sounds/effects/answer_false.ogg',

    ANSWER_HOVER: 'public/sounds/effects/answer_hover.ogg',
    
    ANSWER_SELECT: 'public/sounds/effects/answer_select.ogg',
    
    SHOW_MENU: 'public/sounds/effects/answer_hover.ogg',
    
    SUCCESS_ACTION: 'public/sounds/effects/success_action.ogg', 
    
    CLEAR: 'public/sounds/effects/clear.ogg',
    
    CUBE: 'public/sounds/effects/cube.ogg',
    
    FLY: 'public/sounds/effects/fly.ogg',
    
    ITEM_START_DRAG: 'public/sounds/effects/answer_hover.ogg',
    ITEM_STOP_DRAG: 'public/sounds/effects/answer_hover.ogg', 
    
    SEND_ANSWER_HOVER: 'public/sounds/effects/send_answer_hover.ogg',
    
    NEED_SELECT_ANSWER: 'public/sounds/answers/need_select_answer.ogg',
    NEED_SELECT_LEAST_ONE_ANSWER: 'public/sounds/answers/need_select_least_one_answer.ogg',
    NEED_ENTER_ANSWER: 'public/sounds/answers/need_enter_answer.ogg',
    NEED_SELECT_MISSING_PART_PICTURE: 'public/sounds/answers/need_select_missing_part_picture.ogg',
    
    WIN: [
        'public/sounds/effects/win/win1.ogg',
        'public/sounds/effects/win/win2.ogg',
        'public/sounds/effects/win/win3.ogg',
        'public/sounds/effects/win/win4.ogg',
        'public/sounds/effects/win/win5.ogg'
    ]
    
};
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 05.04.2018
 */

(function() {
    // При обновлении уже существующих файлов обновить версию для обновления кэша
    const SoundVersion = 2;

    var SoundItem = function(name, obj, events) {
        this.name = name;
        this.obj = obj;
        this.events = events || {};

        this.id = function() {
            return this.obj._sounds[0]._id;
        };

        this.play = function() {
            this.obj.play();
        };

        this.pause = function() {
            this.obj.pause();
        };

        this.stop = function() {
            this.obj.stop();
        };

        this.unload = function() {
            this.obj.unload();
        };

        this.volume = function(volume) {
            this.obj.volume(volume);
        };

        this.onPlay = function() {
            if (this.events.onPlay) {
                this.events.onPlay(this);
            }
        };

        this.onEnd = function() {
            if (this.events.onEnd) {
                this.events.onEnd(this);
            }
        };

        this.onStop = function() {
            if (this.events.onStop) {
                this.events.onStop(this);
            }
        };
    };

    ks.soundManager = {

        _items: [],

        active: true,

        getItemById: function(id) {
            for (var i = 0; i < this._items.length; i++) {
                var item = this.getItemByIndex(i);

                if (item.id() === id) {
                    return item;
                }
            }

            return null;
        },

        getItemByIndex: function(index) {
            return this._items[index];
        },

        getItemIndex: function(name) {
            for (var i = 0; i < this._items.length; i++) {
                if (this.getItemByIndex(i).name === name) {
                    return i;
                }
            }

            return -1;
        },

        addItem: function(name, events, volume) {
            let src = [],
                soundVolume = volume || 1.0;

            src.push(name.replace('.ogg', '.webm') + '?v=' + SoundVersion);
            src.push(name.replace('.ogg', '.mp3') + '?v=' + SoundVersion);
            //src.push(name);

            var self = this,
                sound = new Howl({
                    src: src,
                    html5: true,
                    volume: soundVolume,
                    onplay: function(id) {
                        var item = self.getItemById(id);
                        if (item !== null) {
                            item.onPlay();
                        }
                    },/*
                    onplayerror() {
                        try {
                            sound.once('unlock', function() {
                                sound.play();
                            });
                        } catch (e) {}
                    },*/
                    onend: function(id) {
                        var item = self.getItemById(id);
                        if (item !== null) {
                            item.onEnd();
                        }
                    },
                    onpause : function(id) {
                        //
                    },
                    onstop : function(id) {
                        var item = self.getItemById(id);
                        if (item !== null) {
                            item.onStop();
                        }
                    }
                }),
                item;

            item = new SoundItem(name, sound, events);

            this._items.push(item);

            return item;
        },

        play: function(type, name, events, volume, playForce) {
            if (! this.isSoundEnabled(type) && playForce !== true) {
                return this;
            }

            let index = this.getItemIndex(name),
                soundVolume = volume || 1.0,
                item = null;

            if (index < 0) {
                item = this.addItem(name, events, soundVolume);
            } else {
                item = this.getItemByIndex(index);
                item.volume(soundVolume);
            }

            try {
                item.play();
            } catch (err) {}

            return this;
        },

        playEffect: function(name, events, volume) {
            /* 16.02.2019 - Disabled hover sound effects on mobile devices */
            var isHoverEffect = name === ks.sounds.ANSWER_HOVER || name === ks.sounds.SEND_ANSWER_HOVER;

            if (isHoverEffect && (ks.browser.isMobile.any() || ks.browser.isTouch())) {
                /* nothing */
                return this;
            } else {
                return this.play(ks.consts.SOUND_TYPE_EFFECTS, name, events, volume);
            }
        },

        playVoice: function(name, events, playForce) {
            return this.play(ks.consts.SOUND_TYPE_VOICE, name, events, 1.0, playForce);
        },

        pause: function(name) {
            var index = this.getItemIndex(name);

            if (index >= 0) {
                this.getItemByIndex(index).pause();
            }

            return this;
        },

        stop: function(name) {
            var index = this.getItemIndex(name);

            if (index >= 0) {
                this.getItemByIndex(index).stop();
            }

            return this;
        },

        removeItem: function(name) {
            var index = this.getItemIndex(name);

            if (index  >= 0) {
                this.getItemByIndex(index).unload();

                this._items.splice(index, 1);
            }

            return this;
        },

        isSoundEnabled: function(type) {
            if ( ! ks.app.$store.state.settings.voiceEnabled) {
                return false;
            }

            var enabled = true;

            if ( ! ks.app.$store.getters.isGuest) {
                switch (type) {
                    case ks.consts.SOUND_TYPE_EFFECTS:
                        enabled = ks.app.$store.state.parent.options.sound_effects;
                        break;

                    case ks.consts.SOUND_TYPE_VOICE:
                        enabled = ks.app.$store.state.settings.voiceEnabled && ks.app.$store.state.parent.options.sound_voice;
                        break;
                }
            } else {
                enabled = ks.app.$store.state.guest.voiceEnabled;
            }

            return enabled;
        },

        getRandomSound: function(groupName) {
            let group = ks.sounds[groupName];

            return group[Math.floor(Math.random() * group.length)];
        }

    };
}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 24.03.2020
 * 
 * 29.05.2020: Добавлен функционал поиска одного слова в разных вариациях расположения
 * 03.06.2020: Исправлен алгоритм поиска слов
 * 10.06.2020: Доработан показ ненайденных слов
 * 14.09.2020: Исправлен баг: если в списке были слова с обратным написанием,
 *   например, "сон" и "нос", то второе слово не засчитывалось.
 */

(function() {
    
    var DEFAULT_COUNT_HINTS = 3,
        WORD_INDEX_MAX      = 5,
        WORD_INDEX_OTHER    = 999;
    
    Vue.component('square-letters-field-el', {
        template: 
            '<div class="square-letters-field-el" :class="classEl" :style="styleEl" @click="onClick($event)">' +
                '<div v-if="elMixVisible" class="square-letters-field-el-mix" :style="styleElMix"><div class="square-letters-field-el-mix" v-for="(wordIndex, index) in item.wordIndexes" :style="styleMixPart(item, index)" :class="classMixPart(wordIndex.color)"></div></div>' +
                '<div class="square-letters-field-el-letter" :style="styleLetterBox"><div :style="styleLetter">{{ item.letter }}</div></div>' +
            '</div>',
        
        props: {
            item: {
                type: Object,
                required: true
            },
            
            width: {
                type: Number,
                required: true
            },
            
            fontSize: {
                type: Number,
                required: true
            },
            
            fieldSize: {
                type: Number,
                required: true
            },
            
            readonly: {
                type: Boolean,
                required: true
            },
            
            animateMode: {
                type: Boolean,
                required: true
            },
            
            animateFinishMode: {
                type: Boolean,
                required: true
            },
            
            duplicateMode: {
                type: Boolean,
                required: true
            },
            
            animateFinishExercise: {
                type: Boolean,
                required: true
            }
        },
        
        computed: {
            styleEl: function() {
                var style = {
                    width: this.width + 'px',
                    height: this.width + 'px',
                    cursor: this.readonly || this.animateMode || this.animateFinishExercise ? 'default' : 'pointer'
                };
                
                if (this.item.x > 0) {
                    style['border-left'] = 'none';
                }
                
                if (this.item.y < this.fieldSize - 1) {
                    style['border-bottom'] = 'none';
                }
                
                return style;
            },
            
            elMixWidth: function() {
                return this.item.x > 0 ? this.width - 1 : this.width - 2;
            },
            
            elMixHeight: function() {
                return this.width - 1;
            },
            
            elMixVisible: function() {
                return this.readonly && this.item.wordIndexes.length > 1;
            },
            
            styleElMix: function() {
                var style = {
                    width: this.elMixWidth + 'px',
                    height: this.elMixHeight + 'px'
                };
                
                return style;
            },
            
            classEl: function() {
                var cls = {
                    hint: this.item.showHint,
                    readonly: this.readonly && ! this.item.selected && this.item.wordIndexes.length === 0,
                    selected: this.item.selected,
                    animate: ! this.animateFinishExercise && this.item.animate && ! this.animateFinishMode,
                    'animate-finish': ! this.animateFinishExercise && this.item.animate && this.animateFinishMode && ! this.duplicateMode,
                    'animate-duplicate': ! this.animateFinishExercise && this.item.animate && this.animateFinishMode && this.duplicateMode,
                    'animate-finish-exercise': this.animateFinishExercise,
                    'has-word': this.readonly && this.item.wordIndexes.length > 0
                };
                
                if (this.readonly) {
                    if ( ! this.elMixVisible && this.item.wordIndexes.length === 1) {
                        cls['word-' + this.item.wordIndexes[0].color] = true;
                    }
                }
                
                return cls;
            },
            
            styleLetterBox: function() {
                return {
                    width: this.width + 'px',
                    height: this.width + 'px',
                    'line-height': this.width + 'px'  
                };
            },
            
            styleLetter: function() {
                return {
                    'font-size': this.fontSize + 'px'
                };
            }
        },
        
        data: function() {
            return {
                
            };
        },
        
        methods: {
            styleMixPart: function(item, index) {
                var height = this.elMixHeight / item.wordIndexes.length,
                    top = index * height;
                
                if (index === item.wordIndexes.length - 1) {
                    height = this.elMixHeight - height * index;
                }
                
                return {
                    height: height + 'px',
                    'margin-top': top + 'px'
                };
            },
            
            classMixPart: function(wordColor) {
                var cls = {}; 
            
                cls['word-' + wordColor] = true;
                
                return cls;
            },
            
            onClick: function(event) {
                if (this.readonly || this.animateMode || this.animateFinishExercise) {
                    return;
                }
                
                this.$emit('click', this.item);
            }
        }
    });     
    
    Vue.component('square-letters-field', {
        template: 
            '<div class="square-letters-box">' +   
                '<div class="square-letters-title" :style="styleTitle"><span class="gray-text">Найдено слов:</span> {{ foundWords.length }} <span class="gray-text">из</span> {{ wordsCount }}</div>' + 
                '<div class="square-letters-hints" v-if="useHints && ! readonly"><button @click="showHint" :disabled="countHints <= 0 || animateMode" type="button" class="btn btn-glass btn-glass-blue" v-text="titleHints"></button> <i v-show="countHints > 0" title="Подсказка показывает первую букву слова." data-toggle="tooltip" data-placement="right" class="hidden-xs hidden-sm fa help-popover ks-tooltip fa-question-circle"></i></div>' + 
                '<div class="square-letters-field">' +
                '  <div v-for="row in field" class="square-letters-field-row">' +    
                '    <square-letters-field-el ' +
                        'v-for="item in row" ' +
                        ':key="getItemKey(item)" ' +
                        ':item="item" ' +
                        ':width="itemWidth" ' +
                        ':font-size="itemLetterFontSize" ' +
                        ':field-size="field.length" ' +
                        ':readonly="readonly" ' +
                        ':animate-mode="animateMode" ' +
                        ':animate-finish-mode="animateFinishMode" ' +
                        ':duplicate-mode="duplicateMode" ' +
                        ':animate-finish-exercise="animateFinishExercise" ' +
                        '@click="onClickItem">' +
                '    </square-letters-field-el>' +    
                '  </div>' +    
                '</div>' +
                '<div class="square-letters-found-list">' + 
                    '<div v-for="word in foundWords" :key="word" class="square-letters-found-list-item" :style="styleFoundListItem" :class="getClassFoundListItem(word)">{{ word }}</div>' + 
                '</div>' +
                '<div v-show="readonly && notFoundWords.length > 0" class="square-letters-not-found-container">' +
                    '<div class="invalid-answer-text">Не найдены слова:</div>' +
                    '<div class="square-letters-not-found-list">' + 
                        '<div v-for="word in notFoundWords" :key="word.value" class="square-letters-not-found-list-item" :style="styleFoundListItem"><span class="square-letters-not-found-list-item-color" :style="styleWordColor" :class="classWordColor(word.index)"></span> {{ word.value }}</div>' + 
                    '</div>' +
                '</div>' +    
            '</div>',    
        
        props: {
            readonly: {
                type: Boolean,
                required: true
            },
            
            field: {
                type: Array,
                required: true
            },
            
            words: {
                type: Array,
                required: true
            },
            
            useHints: {
                type: Boolean,
                required: true
            },
            
            loaded: {
                type: Boolean,
                required: true
            }
        },
        
        data: function() {
            return {
                width: 0,
                
                updateTimer: null,
                
                animateMode: false,
                animateFinishMode: false,
                animateFinishExercise: false,
                
                duplicateMode: false,
                duplicateWord: '',
                
                newFoundWord: '',
                
                foundWords: [],
                
                selectedWord: [],
                
                countHints: 0,
                
                wordsColors: []
            };
        },
        
        computed: {
            itemWidth: function() {
                return this.field.length > 0 ? Math.floor(this.width / this.field.length) : 0;
            },
            
            itemLetterFontSize: function() {
                if (this.itemWidth <= 0) {
                    return 0;
                }
                
                var div = document.createElement('div');

                document.body.appendChild(div);

                div.style.position = 'absolute';
                div.style.left = -1000;
                div.style.top = -1000;
                /*div.style.fontFamily = 'Open Sans, sans-serif';*/
                
                var span = document.createElement('span');
                span.innerHTML = 'Щ';
                
                div.appendChild(span);

                var fontSize = 0;
                for (var i = this.itemWidth; i > 1; i--) {
                    div.style.fontSize = i + 'px';
                    
                    var rect = span.getBoundingClientRect();

                    if (rect.width < this.itemWidth && rect.height < this.itemWidth) {
                        fontSize = i;
                        break;
                    }
                }

                div.removeChild(span);
                span = null;
                document.body.removeChild(div);
                div = null;
                
                return fontSize;
            },            
            
            wordsCount: function() {
                return this.words.length;
            },
            
            styleTitle: function() {
                var fontSize = this.width  * 0.05;
                
                return {
                    'font-size': fontSize + 'px'
                };
            },
            
            styleFoundListItem: function() {
                var fontSize = this.width  * 0.08;
                
                return {
                    'font-size': fontSize + 'px'
                };                
            },
            
            selectedCount: function() {
                var count = 0;
                
                for (var j = 0; j < this.field.length; j++) {
                    for (var i = 0; i < this.field[j].length; i++) {
                        var item = this.field[j][i];
                        
                        if ( ! item.selected) {
                            continue;
                        }
                        
                        count++;
                    }
                }
                
                return count;
            },
            
            titleHints: function() {
                if ( ! this.useHints) {
                    return '';
                }
                
                return this.countHints <= 0 ? 'Подсказки закончились' : 'Подсказки: ' + this.countHints;
            },
            
            notFoundWords: function() {
                var words = [];
                
                for (var i = 0; i < this.words.length; i++) {
                    var word = this.getWord(i);
                    if (this.foundWords.indexOf(word) >= 0) {
                        continue;
                    }
                    
                    words.push({
                        index: i,
                        value: word
                    });
                }
                
                return words;
            },
            
            styleWordColor: function() {
                var size = this.itemLetterFontSize / 2; 
                
                return {
                    width: size + 'px',
                    height: size + 'px',
                    'border-radius': size + 'px'
                };
            }
        },
        
        methods: {
            classWordColor: function(wordIndex) {
                var colorIndex = this.getWordColorIndex(wordIndex),
                    colorClass = colorIndex === WORD_INDEX_OTHER ? 'word-other' : 'word-' + colorIndex,
                    cls = {};
            
                cls[colorClass] = true;
                
                return cls;
            },
            
            showHint: function() {
                if ( ! this.useHints || this.animateMode || this.readonly) {
                    return;
                }
                
                var wordIndex = -1;
                for (var i = 0; i < this.words.length; i++) {
                    wordIndex = i;
                    if (this.foundWords.indexOf(this.getWord(wordIndex)) >= 0) {
                        continue;
                    }
                    
                    break;
                }
                
                if (wordIndex < 0 || wordIndex >= this.words.length) {
                    return;
                }
                
                this.countHints--;
                
                ks.soundManager.playEffect(ks.sounds.SHOW_MENU);

                this.animateMode = true;
                
                var self = this,
                    item = this.field[this.words[wordIndex][0].y][this.words[wordIndex][0].x];
                item.showHint = true;
                this.$nextTick(function() {
                    setTimeout(function() {
                        item.showHint = false;
                        self.animateMode = false;
                    }, 1500);
                });
            },
            
            getItemKey: function(item) {
                return (item.y + 1) * 100 + item.x;
            },
            
            onWindowResize: function() {
                this.updateSize();
            },
            
            onClickItem: function(item) {
                if (this.readonly) {
                    return;
                }
                
                if ( ! item.selected) {
                    ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                }
                item.selected = ! item.selected;
                
                this.processWordSelected();
            },
            
            intUpdateSize: function() {
                this.updateTimer = null;
                
                var style = window.getComputedStyle(this.$el),
                    width = Math.floor(parseFloat(style.width) - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight));
                if (this.width !== width && width > 0) {
                    this.width = width;
                }    
            },
            
            updateSize: function(width) {
                if (typeof width !== 'undefined') {
                    this.width = width;
                    return;
                }
                
                if (this.updateTimer !== null) {
                    clearTimeout(this.updateTimer);
                    this.updateTimer = null;
                }
                
                this.updateTimer = setTimeout(this.intUpdateSize, 50);
            },
            
            getSelectedItems: function(letter) {
                var items = [];
                
                for (var j = 0; j < this.field.length; j++) {
                    for (var i = 0; i < this.field[j].length; i++) {
                        var item = this.field[j][i];
                        
                        if ( ! item.selected || item.letter !== letter) {
                            continue;
                        }
                        
                        items.push(item);
                    }
                }
                
                return items;
            },
            
            getFieldLetter: function(x, y, onlySelected) {
                var len = this.field.length;
                
                if (x < 0 || y < 0 || x > len - 1 || y > len - 1) {
                    return null;
                }
                
                if (onlySelected) {
                    return this.field[y][x].selected ? this.field[y][x].letter : null;
                } else {
                    return this.field[y][x].letter;
                }
            },
            
            getWordLetter: function(word, letterIndex) {
                return letterIndex >= word.length ? null : this.field[word[letterIndex].y][word[letterIndex].x].letter;
            },          
            
            isItemInSelectedWord: function(x, y) {
                for (var i = 0; i < this.selectedWord.length; i++) {
                    if (this.selectedWord[i].x === x && this.selectedWord[i].y === y) {
                        return true;
                    }
                }
                
                return false;
            },
            
            findSelectedWord: function(word, indexLetter, curX, curY) {
                if (indexLetter === word.length - 1) {
                    return true;
                }
                
                var nextIndexLetter = indexLetter + 1,
                    letter = this.getWordLetter(word, nextIndexLetter);
                
                // up
                if (curY > 0 && this.getFieldLetter(curX, curY - 1, true) === letter && ! this.isItemInSelectedWord(curX, curY - 1)) {
                    this.selectedWord.push({x: curX, y: curY - 1});
                    if (this.findSelectedWord(word, indexLetter + 1, curX, curY - 1)) {
                        return true;
                    }
                    this.selectedWord.splice(this.selectedWord.length - 1, 1);
                }
                
                // down
                if (curY < this.field.length - 1 && this.getFieldLetter(curX, curY + 1, true) === letter && ! this.isItemInSelectedWord(curX, curY + 1)) {
                    this.selectedWord.push({x: curX, y: curY + 1});
                    if (this.findSelectedWord(word, indexLetter + 1, curX, curY + 1)) {
                        return true;
                    }
                    this.selectedWord.splice(this.selectedWord.length - 1, 1);
                }
                
                // left
                if (curX > 0 && this.getFieldLetter(curX - 1, curY, true) === letter && ! this.isItemInSelectedWord(curX - 1, curY)) {
                    this.selectedWord.push({x: curX - 1, y: curY});
                    if (this.findSelectedWord(word, indexLetter + 1, curX - 1, curY)) {
                        return true;
                    }
                    this.selectedWord.splice(this.selectedWord.length - 1, 1);
                }  
                
                // right
                if (curX < this.field.length - 1 && this.getFieldLetter(curX + 1, curY, true) === letter && ! this.isItemInSelectedWord(curX + 1, curY)) {
                    this.selectedWord.push({x: curX + 1, y: curY});
                    if (this.findSelectedWord(word, indexLetter + 1, curX + 1, curY)) {
                        return true;
                    }
                    this.selectedWord.splice(this.selectedWord.length - 1, 1);
                } 
                
                return false;
            },
            
            isWordSelected: function(wordIndex) {
                var word = this.words[wordIndex],
                    firstItems = this.getSelectedItems(this.field[word[0].y][word[0].x].letter);
            
                this.selectedWord = [];
                
                for (var firstIndex = 0; firstIndex < firstItems.length; firstIndex++) {
                    this.selectedWord.push({x: firstItems[firstIndex].x, y: firstItems[firstIndex].y});
                    
                    if (this.findSelectedWord(word, 0, firstItems[firstIndex].x, firstItems[firstIndex].y)) {
                        
                        if (this.selectedCount === word.length) {
                            return true;
                        }
                    }
                    
                    this.selectedWord = [];
                }
                
                return false;
            },
            
            getLetterItem: function(wordIndex, letterIndex) {
                var word = this.words[wordIndex];
                
                return letterIndex >= word.length ? null : this.field[word[letterIndex].y][word[letterIndex].x];
            },
            
            getWord: function(wordIndex) {
                var word = this.words[wordIndex],
                    wordText = '';
            
                for (var i = 0, count = word.length; i < count; i++) {
                    wordText += this.field[word[i].y][word[i].x].letter;
                }
                
                return wordText;
            },
            
            isWordPartOfAnotherWord: function(wordIndex) {
                for (var i = 0; i < this.words.length; i++) {
                    if (i === wordIndex) {
                        continue;
                    }
                    
                    var anotherWord = this.words[i];
                    
                    var found = false;
                    for (var j = 0; j < this.selectedWord.length; j++) {
                        found = false;
                        for (var n = 0; n < anotherWord.length; n++) {
                            if (this.selectedWord[j].x === anotherWord[n].x && this.selectedWord[j].y === anotherWord[n].y) {
                                found = true;
                                break;
                            }
                        }
                        if ( ! found) {
                            break;
                        }
                    }
                    
                    if (found) {
                        return true;
                    }
                }
                
                return false;
            }, 
            
            getReverseWordIndex: function(word) {
                var reverseWord = ks.helpers.string.reverse(word);
                
                for (var i = 0; i < this.words.length; i++) {
                    if (reverseWord === this.getWord(i)) {
                        return i;
                    }
                }
                
                return -1;                
            },
            
            processWordSelected: function() {
                for (var i = 0; i < this.wordsCount; i++) {
                    if (this.isWordSelected(i)) {
                        var word = this.getWord(i);
                    
                        if (this.foundWords.indexOf(word) >= 0) { 
                            // Проверим может выделенное слово с обратным порядком букв есть в списке
                            var reverseIndex = this.getReverseWordIndex(word);
                            if (reverseIndex >= 0) {
                                continue;
                            }
                            
                            // Проверим может выделенное слово является частью другого слова
                            if (this.isWordPartOfAnotherWord(i)) {
                                return;
                            }

                            this.duplicateMode = true;
                        } else {
                            this.duplicateMode = false;
                        }
                                
                        if ( ! this.duplicateMode) {        
                            this.$emit('word-selected', word);
                        } else {
                            this.$emit('word-duplicate', word);
                        }
                        
                        this.startAnimateWord(i);
                        
                        return;
                    }
                }
            },
            
            startAnimateWord: function(wordIndex) {
                this.animateMode = true;
                
                this.animateWord(wordIndex, 0);
            },
            
            clearAnimate: function() {
                for (var j = 0; j < this.field.length; j++) {
                    for (var i = 0; i < this.field[j].length; i++) {
                        this.field[j][i].animate = false;
                        this.field[j][i].selected = false;
                    }
                }
                
                this.animateMode = false;
                this.animateFinishMode = false; 
                
                this.duplicateMode = false;
                this.duplicateWord = '';
            },
            
            animateWord: function(wordIndex, letterIndex) {
                var self = this,
                    word = this.getWord(wordIndex),
                    itemPos = this.selectedWord[letterIndex],
                    item = letterIndex < this.selectedWord.length ? this.field[itemPos.y][itemPos.x] : null;
                
                if (item === null) {
                    setTimeout(function() {
                        self.animateFinishMode = true;
                        self.duplicateWord = word;
                        self.$nextTick(function() {
                            setTimeout(function() {
                                if ( ! self.duplicateMode) {
                                    
                                    ks.soundManager.playEffect(ks.sounds.SUCCESS_ACTION);
                                    
                                    self.foundWords.push(word);
                                    self.newFoundWord = word;
                                    setTimeout(function() {
                                        self.newFoundWord = '';
                                    }, 700);
                                } else {
                                    ks.soundManager.playEffect(ks.sounds.ERROR);
                                }
                                self.clearAnimate();
                            }, 500);
                        });
                    }, 400);
                    return;
                }
                
                setTimeout(function() {
                    item.animate = true;
                    self.animateWord(wordIndex, letterIndex + 1);
                }, 200);
            },
            
            getClassFoundListItem: function(word) {
                return {
                    'duplicate': this.animateMode && this.duplicateWord === word,
                    'new': this.newFoundWord === word
                };
            },
            
            // Для раскраски слов, которые не были найдены
            updateFieldWordsIndexes: function() {
                this.wordsColors = [];
                
                var colorIndex = 0;
                for (var i = 0; i < this.words.length; i++) {
                    var word = this.words[i];
                    
                    if (this.foundWords.indexOf(this.getWord(i)) > -1) {
                        continue;
                    }
                    
                    this.wordsColors.push({
                        wordIndex: i,
                        colorIndex: colorIndex
                    });
                    
                    for (var j = 0; j < word.length; j++) {
                        this.field[word[j].y][word[j].x].wordIndexes.push({
                            index: i,
                            color: colorIndex === WORD_INDEX_OTHER ? 'other' : colorIndex
                        });
                    }
                    
                    colorIndex++;
                    if (colorIndex > WORD_INDEX_MAX) {
                        colorIndex = WORD_INDEX_OTHER;
                    }
                }
            },
            
            getWordColorIndex: function(wordIndex) {
                for (var i = 0; i < this.wordsColors.length; i++) {
                    if (this.wordsColors[i].wordIndex === wordIndex) {
                        return this.wordsColors[i].colorIndex;
                    }
                }
                
                return WORD_INDEX_OTHER;
            }
        },
        
        watch: {
            loaded: function(newLoaded) {
                if (newLoaded) {
                    this.countHints = this.words.length < DEFAULT_COUNT_HINTS ? this.words.length : DEFAULT_COUNT_HINTS;
                    
                    this.updateSize();
                } else {
                    this.foundWords = [];
                }
            },
            
            width: function(newWidth) {
                this.$emit('change-width', newWidth);
            },
            
            foundWords: function(newFoundWords) {
                if (this.words.length > 0 && this.words.length === newFoundWords.length) {
                    this.animateFinishExercise = true;
                    
                    this.$emit('before-finish');
                    
                    var self = this;
                    setTimeout(function() {
                        self.animateFinishExercise = false;
                        self.$emit('finish', true);
                    }, 1500);
                }
            },
            
            readonly: function(newReadonly) {
                if (newReadonly) {
                    this.updateFieldWordsIndexes();
                }
            }
        },
        
        created: function() {
            window.addEventListener('resize', this.onWindowResize);
        },
        
        destroyed: function() {
            window.removeEventListener('resize', this.onWindowResize);
        },
        
        mounted: function() {
            this.updateSize();
        }
    });       
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 01.03.2018
 */

(function() {

    ks.Storage = {
        
        /**
         * 
         * @param {Boolean} hasRole
         * @returns {String}
         */
        _getRolePrefix: function(hasRole) {
            if (hasRole !== true) {
                return '';
            }
            
            var store = ks.app.$store,
                prefix = '';
            
            switch (store.state.role) {
                case ks.consts.ROLE_GUEST:
                    prefix = 'g';
                    break;
                    
                case ks.consts.ROLE_KID:
                    prefix = 'k' + store.state.kid.id;
                    break;
                    
                case ks.consts.ROLE_PARENT:
                    prefix = 'p' + store.state.parent.id;
                    break;
            }
            
            if (prefix !== '') {
                prefix += '_';
            }
            
            return prefix;
        },
        
        _getKeyName: function(key, hasRole) {
            return 'ks_' + this._getRolePrefix(hasRole) + key;
        },
        
        _getStorage: function(storageType) {
            var storage = null;
            
            switch (storageType) {
                case ks.consts.STORAGE_TYPE_LOCAL:
                    storage = window.localStorage;
                    break;
                case ks.consts.STORAGE_TYPE_SESSION:
                    storage = window.sessionStorage;
                    break;
            }
            
            return storage;
        },
        
        /**
         * @param {Number} storageType
         * @param {String} key
         * @param {Mixed} value
         * @param {Boolean} hasRole
         * @returns {Boolean}
         */
        setItem: function(storageType, key, value, hasRole) {
            var storage = this._getStorage(storageType);
            
            if (storage === null) {
                return false;
            }
            
            var storageValue = typeof value === 'object' ? JSON.stringify(value) : value;
            
            //try {
                storage.setItem(this._getKeyName(key, hasRole), storageValue);
                
                return true;
            //} catch (e) {
            //    if (e === QUOTA_EXCEEDED_ERR) {
                    // ks.consts.ERR_NOT_ENOUGH_STORAGE
            //    }
                
            //    return false;
            //}            
        },
        
        /**
         * @param {Number} storageType
         * @param {String} key
         * @param {Boolean} hasRole
         * @param {Boolean} isObject
         * @returns {Mixed}
         */
        getItem: function(storageType, key, hasRole, isObject) {
            var storage = this._getStorage(storageType);
            
            if (storage === null) {
                return null;
            }
            
            var value = storage.getItem(this._getKeyName(key, hasRole));
            
            if (value === null) {
                return null;
            } else {
                return isObject ? JSON.parse(value) : value;
            }
        },
        
        
        /**
         * @param {Number} storageType
         * @param {String} key
         * @param {Boolean} hasRole
         * @returns {undefined}
         */
        removeItem: function(storageType, key, hasRole) {
            var storage = this._getStorage(storageType);
            
            if (storage !== null) {
                storage.removeItem(this._getKeyName(key, hasRole));
            }
        }
        
    };

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 22.02.2018
 */

(function(){

    ks.upload = {
        
        checkImage: function(file) {
            var fileType = file.type.trim().toLowerCase();

            if (fileType !== 'image/jpeg' && fileType !== 'image/png') {
                return 'Некорректный формат файла изображения. Изображение должно быть в JPEG или PNG формате.';
            }

            if (file.size > ks.consts.MAX_UPLOAD_SIZE) {
                return 'Большой размер файла изображения. Размер файла должен быть не больше 2 MB.';
            }            
            
            return true;
        }
        
    };
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 22.09.2017
 */

(function() {

    ks.validator = {

        validateEmail: function(val) {
            var pattern = /^([a-zа-яё0-9_\.-])+@[a-zа-яё0-9-]+\.([a-zа-яё]{2,4}\.)?[a-zа-яё]{2,4}$/i;

            return pattern.test(val);
        }

    };

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 21.08.2019
 *
 *
 * Список реализованных конверсий:
 * add_to_cart
 * complete_registration
 * purchase
 *
 */

(function() {

    ks.vk = {};

    ks.vk.Retargeting = {

        EVENT_CLICK_SIGNUP: 1,
        EVENT_CLICK_PAY: 2,

        _audienceID: 30720304,

        _isVKLoaded: function() {
            try {
              return typeof VK !== 'undefined';
            } catch (exception) {
              return false;
            }
        },

        start: function() {
            if ( ! this._isVKLoaded()) {
                return false;
            }

            try {
                VK.Retargeting.Init('VK-RTRG-397452-1mVCx');
                VK.Retargeting.Hit();
                VK.Retargeting.Add(this._audienceID);
            } catch (exception) {
                return false;
            }

            return true;
        },

        onEvent: function(event) {
            if ( ! this._isVKLoaded()) {
                return false;
            }

            try {
                var name = this._getEventName(event);

                if (name !== null) {
                    VK.Retargeting.Event(name);
                    return true;
                } else {
                    return false;
                }
            } catch (exception) {
                return false;
            }
        },

        _getEventName: function(event) {
            var name;

            switch (event) {
                case ks.vk.Retargeting.EVENT_CLICK_SIGNUP:
                    name = 'click-signup';
                    break;

                case ks.vk.Retargeting.EVENT_CLICK_PAY:
                    name = 'click-pay';
                    break;

                default:
                    name = null;
                    break;
            }

            return name;
        }

    };

    ks.vk.Goal = function(event, params){
        if (typeof VK === 'undefined') {
            return false;
        }

        try {
            VK.Goal(event, params);
        } catch (exception) {
            return false;
        }

        return true;
    };

}());

const gestures = ['tap', 'pan', 'pinch', 'press', 'rotate', 'swipe'];
const subGestures = ['panstart', 'panend', 'panmove', 'pancancel', 'pinchstart', 'pinchmove', 'pinchend', 'pinchcancel', 'pinchin', 'pinchout', 'pressup', 'rotatestart', 'rotatemove', 'rotateend', 'rotatecancel'];
const directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];

window.VueHammer = {
  config: {},
  customEvents: {},
  install(Vue) {
    Vue.directive('hammer', {
      bind: (el, binding) => {
        if (!el.hammer) {
          el.hammer = new Hammer.Manager(el);
        }
        const mc = el.hammer;

        // determine event type
        const event = binding.arg;
        if (!event) {
          console.warn('[vue-hammer] event type argument is required.');
        }
        el.__hammerConfig = el.__hammerConfig || {};
        el.__hammerConfig[event] = {};

        const direction = binding.modifiers;
        el.__hammerConfig[event].direction = el.__hammerConfig[event].direction || [];
        if (Object.keys(direction).length) {
          Object.keys(direction)
            .filter(keyName => binding.modifiers[keyName])
            .forEach(keyName => {
              const elDirectionArray = el.__hammerConfig[event].direction;
              if (elDirectionArray.indexOf(keyName) === -1) {
                elDirectionArray.push(String(keyName));
              }
            });
        }

        let recognizerType,
          recognizer;

        if (this.customEvents[event]) {
          // custom event
          const custom = this.customEvents[event];
          recognizerType = custom.type;
          recognizer = new Hammer[this.capitalize(recognizerType)](custom);
          recognizer.recognizeWith(mc.recognizers);
          mc.add(recognizer);
        } else {
          // built-in event
          recognizerType = gestures.find(gesture => gesture === event);
          const subGesturesType = subGestures.find(gesture => gesture === event);
          if (!recognizerType && !subGesturesType) {
            console.warn('[vue-hammer] invalid event type: ' + event);
            return;
          }
          if (subGesturesType && el.__hammerConfig[subGesturesType].direction.length !== 0) {
            console.warn('[vue-hammer] ' + subGesturesType + ' should not have directions');
          }
          if (!recognizerType) {
            return;
          }
          if (recognizerType === 'tap' || recognizerType === 'pinch' || recognizerType === 'press' || recognizerType === 'rotate') {
            if (el.__hammerConfig[recognizerType].direction.length !== 0) {
              throw Error('[vue-hammer] ' + recognizerType + ' should not have directions');
            }
          }
          recognizer = mc.get(recognizerType);
          if (!recognizer) {
            // add recognizer
            recognizer = new Hammer[this.capitalize(recognizerType)]();
            // make sure multiple recognizers work together...
            recognizer.recognizeWith(mc.recognizers);
            mc.add(recognizer);
          }
          // apply global options
          const globalOptions = this.config[recognizerType];
          if (globalOptions) {
            this.guardDirections(globalOptions);
            recognizer.set(globalOptions);
          }
          // apply local options
          const localOptions = el.hammerOptions &&
          el.hammerOptions[recognizerType];
          if (localOptions) {
            this.guardDirections(localOptions);
            recognizer.set(localOptions);
          }
        }
      },
      inserted: (el, binding) => {
        const mc = el.hammer;
        const event = binding.arg;
        const eventWithDir = subGestures.find(subGes => subGes === event) ? event : this.buildEventWithDirections(event, el.__hammerConfig[event].direction);
        if (mc.handler) {
          mc.off(eventWithDir, mc.handler);
        }
        if (typeof binding.value !== 'function') {
          mc.handler = null;
          console.warn(
            '[vue-hammer] invalid handler function for v-hammer: ' +
            binding.arg
          );
        } else {
          mc.on(eventWithDir, (mc.handler = binding.value));
        }
      },
      componentUpdated: (el, binding) => {
        const mc = el.hammer;
        const event = binding.arg;
        const eventWithDir = subGestures.find(subGes => subGes === event) ? event : this.buildEventWithDirections(event, el.__hammerConfig[event].direction);
        // teardown old handler
        if (mc.handler) {
          mc.off(eventWithDir, mc.handler);
        }
        if (typeof binding.value !== 'function') {
          mc.handler = null;
          console.warn(
            '[vue-hammer] invalid handler function for v-hammer: ' +
            binding.arg
          );
        } else {
          mc.on(eventWithDir, (mc.handler = binding.value));
        }
      },
      unbind: (el, binding) => {
        const mc = el.hammer;
        const event = binding.arg;
        const eventWithDir = subGestures.find(subGes => subGes === event) ? event : this.buildEventWithDirections(event, el.__hammerConfig[event].direction);
        if (mc.handler) {
          el.hammer.off(eventWithDir, mc.handler);
        }
        if (!Object.keys(mc.handlers).length) {
          el.hammer.destroy();
          el.hammer = null;
        }
      }
    });
  },
  guardDirections(options) {
    var dir = options.direction;
    if (typeof dir === 'string') {
      var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
      if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
        options.direction = Hammer[hammerDirection];
      } else {
        console.warn('[vue-hammer] invalid direction: ' + dir);
      }
    }
  },
  buildEventWithDirections(eventName, directionArray) {
    const f = {};
    directionArray.forEach(dir => {
      dir = dir.toLowerCase();
      if (dir === 'horizontal') {
        f.left = 1;
        f.right = 1;
      } else if (dir === 'vertical') {
        f.up = 1;
        f.down = 1;
      } else if (dir === 'all') {
        f.left = 1;
        f.right = 1;
        f.up = 1;
        f.down = 1;
      } else {
        f[dir] = 1;
      }
    });
    const _directionArray = Object.keys(f);
    if (_directionArray.length === 0) {
      return eventName;
    }
    const eventWithDirArray = _directionArray.map(dir => {
      return eventName + dir;
    });
    return eventWithDirArray.join(' ');
  },
  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
};
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 18.07.2018
 */

(function() {
    var WindowRestCookieName = 'ks_wndrst_',
        WindowRestSalt = 'ID0Hf968687L';

    ks.windowRestHelper = {
        
        _getCookieName: function(kidId) {
            return WindowRestCookieName + md5(WindowRestSalt + kidId);
        },
        
        getLastState: function(kidId) {
            try {
                var cookieName = this._getCookieName(kidId),
                    state = Cookies.getJSON(cookieName);

                if (typeof state !== 'object') {
                    Cookies.remove(cookieName);
                    return false;
                }

                var lastDate = moment(state.date, 'YYYY-MM-DD'),
                    minutes = Math.abs(lastDate.diff(moment(), 'minutes'));
                    
                // Если уже прошло больше часа сбрасываем состояние
                if (minutes > 60) {
                    Cookies.remove(cookieName);
                    return false;
                }

                return state;
            } catch (e) {
                return false;
            }

        },
        
        setLastState: function(kidId, exercises) {
            var state = {
                date: moment().format('YYYY-MM-DD'),
                exercises: exercises
            };
            
            ks.helpers.cookies.set(this._getCookieName(kidId), state, { expires: 1 });
        }
        
    };
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 13.03.2020
 *
 * 02.03.2022:
 * +EVENT_WHEEL_FORTUNE_SPIN
 *
 * 06.09.2024:
 * +EVENT_SIGNUP_COMPLETED_<NAME>
 */

(function() {
    ks.yandex = {
        counterID: 53724640
    };

    ks.yandex.Events = {

        EVENT_WINDOW_REST_SHOW          : 1,
        EVENT_GUEST_OFFER_REGISTER      : 2,
        EVENT_APPLY_PROMOCODE           : 3,
        EVENT_CLICK_PAY                 : 4,
        EVENT_PAID                      : 5,
        EVENT_DAY_LIMIT_EXCEEDED        : 6,
        EVENT_BUG_REPORT                : 7,
        EVENT_LOAD_MORE_REVIEWS         : 8,

        EVENT_SIGNUP_PAGE               : 9,
        EVENT_SIGNUP_DIALOG             : 10,

        EVENT_TRIAL_TRAINING_OFFER      : 11,
        EVENT_TRIAL_TRAINING_START      : 12,
        EVENT_TRIAL_TRAINING_CLOSE      : 13,

        EVENT_SEND_COMMENT              : 14,

        EVENT_WHEEL_FORTUNE_SPIN        : 15,
        EVENT_WHEEL_FORTUNE_OPEN        : 16,
        EVENT_WHEEL_FORTUNE_CLOSE       : 17,
        EVENT_WHEEL_FORTUNE_APPLY_PROMO : 18,

        EVENT_PARTNERS_START_REQUEST    : 19,
        EVENT_PARTNERS_SEND_REQUEST     : 20,

        EVENT_CREATE_TRAINING_PAGE      : 21,
        EVENT_CLICK_PAY_BR              : 22,

        EVENT_SIGNUP_COMPLETED          : 23,

        EVENT_CONTACTS_MESSAGE          : 24,

        EVENT_PAID_1_MONTH              : 25,
        EVENT_PAID_3_MONTHS             : 26,
        EVENT_PAID_6_MONTHS             : 27,
        EVENT_PAID_12_MONTHS            : 28,

        EVENT_START_AD_TRAINING         : 29,
        EVENT_FINISH_AD_TRAINING        : 30,

        EVENT_GUEST_COMPLETE_FIRST_EXERCISE: 31,

        /** Registration via Email */
        EVENT_SIGNUP_COMPLETED_EMAIL    : 32,
        /** Registration via Third Party Services */
        EVENT_SIGNUP_COMPLETED_TPS      : 33,
        /** Registration on Order Page */
        EVENT_SIGNUP_COMPLETED_ORDER    : 34,

        EVENT_DAY_LIMIT_EXCEEDED_GUEST : 35,
        EVENT_DAY_LIMIT_EXCEEDED_USER  : 36,

        /** Registration via Email on Exercises Over Page */
        EVENT_SIGNUP_COMPLETED_EMAIL_EXERCISES_OVER : 37,

        /** Registration via Third Party Services on Exercises Over Page */
        EVENT_SIGNUP_COMPLETED_TPS_EXERCISES_OVER   : 38,

        /** Registration via Third Party Services on Signup Page */
        EVENT_SIGNUP_PAGE_COMPLETED_TPS             : 39,

        /** Registration via Third Party Services on Dialog */
        EVENT_SIGNUP_DIALOG_COMPLETED_TPS           : 40,

        EVENT_SHOW_SIGNUP_DIALOG: 41,

        /** Registration via Email on Order Page */
        EVENT_SIGNUP_COMPLETED_ORDER_EMAIL : 42,

        /** Registration via Third Party Services on Order Page */
        EVENT_SIGNUP_COMPLETED_ORDER_TPS   : 43,

        /** Registration via Third Party Services on Login Dialog */
        EVENT_SIGNUP_COMPLETED_LOGIN_DIALOG_TPS   : 44,

        /** Показ запроса на установку PWA-приложения */
        EVENT_PWA_PROMPT_INSTALL : 45,

        /** Пользователь дал согласие на установку PWA-приложения */
        EVENT_PWA_START_INSTALL  : 46,

        /** PWA-приложение успешно установлено */
        EVENT_PWA_INSTALLED      : 47,

        /** Клик гостя по закрытому лабиринту - показ формы входа */
        EVENT_MAZES_GUEST_CLICK_NO_ACCESS  : 48,

        /** Клик родителя по закрытому лабиринту (премиум) - показ страницы оплаты */
        EVENT_MAZES_PARENT_CLICK_NO_ACCESS : 49,

        onEvent: function(event, params) {
            try {
                let name = this._getEventName(event);

                if (name !== null) {
                  //console.log(name);

                  ym(ks.yandex.counterID, 'reachGoal', name, params);

                  //console.log(ks.yandex.counterID + ', ' + 'reachGoal' + ', ' + name);
                  //console.log(params);
                  return true;
                } else {
                  return false;
                }
            } catch (exception) {
                //console.log(exception);
                return false;
            }
        },

        _getEventName: function(event) {
            let name;

            switch (event) {
                case ks.yandex.Events.EVENT_WINDOW_REST_SHOW:
                    name = 'window-rest-show';
                    break;

                case ks.yandex.Events.EVENT_GUEST_OFFER_REGISTER:
                    name = 'guest-offer-register';
                    break;

                case ks.yandex.Events.EVENT_APPLY_PROMOCODE:
                    name = 'apply-promocode';
                    break;

                case ks.yandex.Events.EVENT_CLICK_PAY:
                    name = 'click-pay';
                    break;

                case ks.yandex.Events.EVENT_PAID:
                    name = 'paid';
                    break;

                case ks.yandex.Events.EVENT_DAY_LIMIT_EXCEEDED:
                    name = 'day-limit-exceeded';
                    break;

                case ks.yandex.Events.EVENT_BUG_REPORT:
                    name = 'bug-report';
                    break;

                case ks.yandex.Events.EVENT_LOAD_MORE_REVIEWS:
                    name = 'load-more-reviews';
                    break;

                case ks.yandex.Events.EVENT_SIGNUP_PAGE:
                    name = 'signup-page';
                    break;

                case ks.yandex.Events.EVENT_SIGNUP_DIALOG:
                    name = 'signup-dialog';
                    break;

                case ks.yandex.Events.EVENT_TRIAL_TRAINING_OFFER:
                    name = 'trial-training-offer';
                    break;

                case ks.yandex.Events.EVENT_TRIAL_TRAINING_START:
                    name = 'trial-training-start';
                    break;

                case ks.yandex.Events.EVENT_TRIAL_TRAINING_CLOSE:
                    name = 'trial-training-close';
                    break;

                case ks.yandex.Events.EVENT_SEND_COMMENT:
                    name = 'send-comment';
                    break;

                case ks.yandex.Events.EVENT_WHEEL_FORTUNE_SPIN:
                    name = 'wheel-fortune-spin';
                    break;

                case ks.yandex.Events.EVENT_WHEEL_FORTUNE_OPEN:
                    name = 'wheel-fortune-open';
                    break;

                case ks.yandex.Events.EVENT_WHEEL_FORTUNE_CLOSE:
                    name = 'wheel-fortune-close';
                    break;

                case ks.yandex.Events.EVENT_WHEEL_FORTUNE_APPLY_PROMO:
                    name = 'wheel-fortune-apply-promo';
                    break;

                case ks.yandex.Events.EVENT_PARTNERS_START_REQUEST:
                    name = 'partners-start-request';
                    break;

                case ks.yandex.Events.EVENT_PARTNERS_SEND_REQUEST:
                    name = 'partners-send-request';
                    break;

                case ks.yandex.Events.EVENT_CREATE_TRAINING_PAGE:
                    name = 'create-training-page';
                    break;

                case ks.yandex.Events.EVENT_CLICK_PAY_BR:
                    name = 'click-pay-br';
                    break;

                case ks.yandex.Events.EVENT_SIGNUP_COMPLETED:
                    name = 'signup-completed';
                    break;

                case ks.yandex.Events.EVENT_CONTACTS_MESSAGE:
                    name = 'contacts-message';
                    break;

                case ks.yandex.Events.EVENT_PAID_1_MONTH:
                    name = 'paid-1-month';
                    break;

                case ks.yandex.Events.EVENT_PAID_3_MONTHS:
                    name = 'paid-3-months';
                    break;

                case ks.yandex.Events.EVENT_PAID_6_MONTHS:
                    name = 'paid-6-months';
                    break;

                case ks.yandex.Events.EVENT_PAID_12_MONTHS:
                    name = 'paid-12-months';
                    break;

                case ks.yandex.Events.EVENT_START_AD_TRAINING:
                    name = 'start-ad-training';
                    break;

                case ks.yandex.Events.EVENT_FINISH_AD_TRAINING:
                    name = 'finish-ad-training';
                    break;

                case ks.yandex.Events.EVENT_GUEST_COMPLETE_FIRST_EXERCISE:
                    name = 'guest-complete-first-exercise';
                    break;

                case ks.yandex.Events.EVENT_SIGNUP_COMPLETED_EMAIL:
                  name = 'signup-completed-email';
                  break;

                case ks.yandex.Events.EVENT_SIGNUP_COMPLETED_TPS:
                  name = 'signup-completed-tps';
                  break;

                case ks.yandex.Events.EVENT_SIGNUP_COMPLETED_ORDER:
                  name = 'signup-completed-order';
                  break;

                case ks.yandex.Events.EVENT_DAY_LIMIT_EXCEEDED_GUEST:
                  name = 'day-limit-exceeded-guest';
                  break;

                case ks.yandex.Events.EVENT_DAY_LIMIT_EXCEEDED_USER:
                  name = 'day-limit-exceeded-user';
                  break;

                case ks.yandex.Events.EVENT_SIGNUP_COMPLETED_EMAIL_EXERCISES_OVER:
                  name = 'signup-completed-email-exercises-over';
                  break;

                case ks.yandex.Events.EVENT_SIGNUP_COMPLETED_TPS_EXERCISES_OVER:
                  name = 'signup-completed-tps-exercises-over';
                  break;

                case ks.yandex.Events.EVENT_SIGNUP_PAGE_COMPLETED_TPS:
                  name = 'signup-page-completed-tps';
                  break;

                case ks.yandex.Events.EVENT_SIGNUP_DIALOG_COMPLETED_TPS:
                  name = 'signup-dialog-completed-tps';
                  break;

                case ks.yandex.Events.EVENT_SHOW_SIGNUP_DIALOG:
                  name = 'show-signup-dialog';
                  break;

                case ks.yandex.Events.EVENT_SIGNUP_COMPLETED_ORDER_EMAIL:
                  name = 'signup-completed-order-email';
                  break;

                case ks.yandex.Events.EVENT_SIGNUP_COMPLETED_ORDER_TPS:
                  name = 'signup-completed-order-tps';
                  break;

                case ks.yandex.Events.EVENT_SIGNUP_COMPLETED_LOGIN_DIALOG_TPS:
                  name = 'signup-completed-login-dialog-tps';
                  break;

                case ks.yandex.Events.EVENT_PWA_PROMPT_INSTALL:
                  name = 'pwa-prompt-install';
                  break;

                case ks.yandex.Events.EVENT_PWA_START_INSTALL:
                  name = 'pwa-start-install';
                  break;

                case ks.yandex.Events.EVENT_PWA_INSTALLED:
                  name = 'pwa-installed';
                  break;

                case ks.yandex.Events.EVENT_MAZES_GUEST_CLICK_NO_ACCESS:
                  name = 'mazes-guest-click-no-access';
                  break;

                case ks.yandex.Events.EVENT_MAZES_PARENT_CLICK_NO_ACCESS:
                  name = 'mazes-parent-click-no-access';
                  break;

                default:
                  name = null;
                  break;
            }

            return name;
        }

    };

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 03.08.2019
 */

(function() {

    var BlogCategoryMenuMobile = {

        data: function() {
            return {
                loaded: false
            };
        },

        computed: {

        },

        methods: {
            show: function() {
                this.$dlg.modal('show');
            },
            
            hide: function() {
                this.$dlg.modal('hide');
            }
        },
        
        watch: {

        },

        mounted: function() {
            this.$dlg = $('#category-mobile-menu');
            
            this.loaded = true;
        }

    };

    ks.core.addComponent('blog-category-menu-mobile', BlogCategoryMenuMobile);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 11.02.2022
 */

(function() {
    
    Vue.component('blog-comment-rating', {

        template: 
            '<div class="blog-post-comment__rating text-right">' +   
                '<a v-show="!isLoading" class="blog-comment-rating" :class="classLink" href="#" @click.prevent="click">' +
                    '<i class="fa" :class="classHeart"></i> <span v-show="value > 0">{{ value }}</span></a>' +
                '</a>' +
                '<img v-show="isLoading" style="display: none;" src="/public/images/loaders/comment_rating_loader.gif" />'+
            '</div>',

        props: {
            isLogged: {
                type: Boolean,
                required: true
            },
            
            initHasRate: {
                type: Boolean,
                required: true
            },
            
            rating: {
                type: Number,
                required: true
            },
            
            commentId: {
                type: Number,
                required: true
            }
        },
        
        computed: {
            classLink: function() {
                return {
                    'disabled': ! this.isLogged
                };
            },
            
            classHeart: function() {
                return {
                    'fa-heart-o' : ! this.hasRate,
                    'fa-heart'   : this.hasRate
                };
            }
        },
        
        data: function(){
            return {
                isLoading: false,
                value: 0,
                hasRate: false
            };
        },
        
        methods: {
            click: function(){
                if ( ! this.isLogged) {
                    return;
                }
                
                this.isLoading = true;
                this.$emit('click', this.commentId);
            },
            
            setLoading: function(value){
                this.isLoading = value;
            },
            
            setRating: function(value){
                this.value = value;
                this.hasRate = ! this.hasRate;
            }
        },
        
        mounted: function(){
            this.value = this.rating;
            this.hasRate = this.initHasRate;
        }
    });
    
}());



/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 09.02.2022
 */

(function() {
    
    Vue.component('blog-write-comment', {

        template: 
            '<div ref="box" class="blog-write-comment">' +
                '<div v-show="isExpand" class="blog-write-comment__form std-block std-block-green">' +
                    '<div class="blog-write-comment__form__title">' +
                        '<div class="blog-write-comment__form__title__text"><label :for="textareaId" v-html="title"></label></div>'+
                        '<div v-show="canClose" class="blog-write-comment__form__title__close"><a href="#" @click.prevent="setExpand(false)"><i class="fa fa-close"></i></a></div>' +
                    '</div>' +
                    '<textarea :id="textareaId" v-model.trim="message" ref="message" class="form-control blog-write-comment__form__message" rows="5" :maxlength="maxLength" placeholder="Введите текст и нажмите кнопку &quot;Отправить&quot;"></textarea>' +
                    '<div v-if="isFirst" class="row blog-write-comment__form__first-time">' +
                        '<div class="col-xs-12 col-sm-6">' +
                            '<label>Ваше имя</label>' +
                            '<input ref="inputName" type="text" class="form-control blog-write-comment__form__first-time__name" placeholder="Ваше имя в комментариях" maxlength="50" v-model.trim="parentNameComment" />' +
                        '</div>' +
                        '<div class="col-xs-12 col-sm-6 blog-write-comment__form__first-time__notify-reply-comment">' + 
                            '<checkbox v-model="notifyReplyComment" title="Уведомлять об ответах"></checkbox>' + 
                        '</div>' +
                    '</div>' +
                    '<div class="blog-write-comment__form__privacy">' +
                        'Нажимая "Отправить", вы соглашаетесь с условиями <a href="/docs/data-policy" target="_blank">Политики конфиденциальности</a>.' +
                    '</div>' +   
                    '<div class="blog-write-comment__form__send text-center">'+
                        '<button type="button" class="btn btn-green" @click="send()" :disabled="!canSend"><i class="fa fa-send"></i> Отправить</button>' +
                    '</div>' +   
                '</div>' +
            '</div>',

        props: {
            isAdmin: {
                type: Boolean,
                required: true
            },
            
            parentName: {
                type: String,
                required: true
            },
            
            postId: {
                type: Number,
                required: true
            },
            
            parentCommentId: {
                type: Number,
                default: 0
            },
            
            expand: {
                type: Boolean,
                required: true
            },
            
            maxLength: {
                type: Number,
                default: 1000
            },
            
            canClose: {
                type: Boolean,
                default: true
            }
        },
        
        data: function() {
            return {
                isExpand: false,
                
                parentNameComment: '',
                notifyReplyComment: true,
                
                message: '',
                
                replyParentId: 0,
                replyParentName: '',
                replyCommentId: 0
            };
        },
        
        computed: {
            isFirst: function() {
                return this.$store.state.parent.nameComment === '';
            },
            
            canSend: function() {
                return this.message !== '' && ( ! this.isFirst || this.parentCName !== '');
            },
            
            isReply: function() {
                return this.replyParentId !== 0;
            },
            
            title: function() {
                return this.isReply ? 'Ответ для <b>' + this.replyParentName + '</b>' : 'Написать комментарий';
            },
            
            textareaId: function(){
                return 'commentTextarea' + this.parentCommentId;
            }
        },
        
        methods: {
            setExpand: function(expand) {
                this.isExpand = expand;
            },
            
            focus: function() {
                if (this.isExpand) {
                    this.scrollToMessage(true);
                } else {
                    let self = this;
                    
                    this.isExpand = true;
                    this.$nextTick(function(){
                       self.scrollToMessage(true); 
                    });
                }
            },
            
            scrollToMessage: function(doFocus){
                let box = this.$refs.box,
                    message = this.$refs.message;
            
                if ( ! this.isElementVisible(message)) {
                    box.scrollIntoView({block: 'end'});
                }
                
                if (doFocus) {
                    message.focus();                    
                }
            },
            
            isElementVisible: function(element) {
                let clientRect = element.getBoundingClientRect(),
                    elementPosition = {
                        //top    : window.pageYOffset + clientRect.top,
                        //left   : window.pageXOffset + clientRect.left,
                        //right  : window.pageXOffset + clientRect.right,
                        bottom : window.pageYOffset + clientRect.bottom
                    },
                    windowPosition = {
                        //top    : window.pageYOffset,
                        //left   : window.pageXOffset,
                        //right  : window.pageXOffset + document.documentElement.clientWidth,
                        bottom : window.pageYOffset + document.documentElement.clientHeight
                    };
   
                return elementPosition.bottom < windowPosition.bottom;
            },
            
            reply: function(replyParentId, replyParentName, replyCommentId) {
                this.replyParentId   = replyParentId;
                this.replyParentName = replyParentName;
                this.replyCommentId  = replyCommentId;
            },
            
            validate: function() {
                if (this.message === '') {
                    this.$refs.message.focus();
                    return false;
                }     
                
                if (this.isFirst) {
                    if (this.parentCName === '') {
                        this.$refs.inputName.focus();
                        return false;
                    } 
                }
                
                return true;
            },
            
            send: function() {
                if ( ! this.validate()) {
                    return;
                }
                
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SEND_COMMENT);

                let data =  {
                        postId: this.postId,
                        parentCommentId: this.parentCommentId,
                        replyParentId: this.replyParentId,
                        replyCommentId: this.replyCommentId,
                        message: this.message
                    };
               
                if (this.isFirst) {
                    data.parentNameComment = this.parentNameComment;
                    data.notifyReplyComment = this.notifyReplyComment;
                }

                ks.client.request({
                    controller: 'postComments',
                    action: 'send',
                    data: data,
                    onRequest: this.onSend
                });
            },
            
            onSend: function(errorCode, data){
                if (errorCode !== ks.consts.ERR_OK) {
                    let errorText = typeof data.errors !== 'undefined' && typeof data.errors.global !== 'undefined' ? data.errors.global :
                                    'Произошла ошибка при отправке комментария.<br />Пожалуйста, попробуйте ещё раз.';
                    
                    ks.app.$refs.messageBox.show({
                        type    : ks.consts.MBT_ERROR,
                        title   : 'Ошибка',
                        text    : errorText,
                        buttons : ks.consts.MBB_OK
                    });
                    
                    return;
                }   
                
                if (this.isReply) {
                    this.isExpand = false;
                }
                
                this.message = '';
                
                if (this.isFirst) {
                    this.$store.commit('parent/setNameComment', this.parentNameComment);
                }
                
                if ( ! this.isAdmin) {
                    ks.app.$refs.messageBox.show({
                        type    : ks.consts.MBT_INFO,
                        title   : 'Комментарий отправлен',
                        text    : data.text,
                        buttons : ks.consts.MBB_OK
                    });                
                } else {
                    document.location.reload();
                }
            }
        },
        
        watch: {
            message: function(newMessage) {
                if (newMessage.length > this.maxLength) {
                    this.message = newMessage.substr(0, this.maxLength);
                }
            }
        },
        
        mounted: function() {
            this.parentNameComment = this.parentName;
            this.isExpand = this.expand;
        }
    }); 
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 13.10.2017
 */

(function() {

    Vue.component('alert', {

        template: '<div v-show="visible" class="alert" :class="alertClass" role="alert">' +
                    '<button v-if="canClose" @click.prevent="hide()" type="button" class="close"><span aria-hidden="true">&times;</span></button>' +
                    '<i class="fa" :class="iconClass"></i>' +
                    '<span class="alert-text" v-html="getText"></span>' +
                  '</div>',

        props: {
            canClose: {
                type: Boolean,
                default: true
            },

            autoClose: {
                type: Boolean,
                default: false
            },

            autoCloseInterval: {
                type: Number,
                default: 3 // seconds
            },
            
            showCloseInterval: {
                type: Boolean,
                default: true
            },
            
            align: {
                type: String,
                default: 'left' // posible values: left, center, right   
            },
            
            classEx: {
                type: String,
                default: ''
            }
        },

        data: function() {
            return {
                visible: false,
                timerId: null,
                seconds: 0,

                text: '',
                type: 0
            };
        },

        computed: {
            alertClass: function() {
                let cls = {
                        'alert-info'    : this.type === ks.consts.ALERT_INFO,
                        'alert-success' : this.type === ks.consts.ALERT_SUCCESS,
                        'alert-warning' : this.type === ks.consts.ALERT_WARNING,
                        'alert-danger'  : this.type === ks.consts.ALERT_ERROR,

                        'text-left'     : this.align === 'left',
                        'text-center'   : this.align === 'center',
                        'text-right'    : this.align === 'right'
                    },
                    clsList = this.classEx.split(' ');
            
                for (let i = 0; i < clsList.length; i++) {
                    cls[clsList[i]] = true;
                }
                
                return cls;
            },

            iconClass: function() {
                return {
                    'fa-info'                 : this.type === ks.consts.ALERT_INFO,
                    'fa-check'                : this.type === ks.consts.ALERT_SUCCESS,
                    'fa-exclamation-triangle' : this.type === ks.consts.ALERT_WARNING || this.type === ks.consts.ALERT_ERROR
                };
            },
            
            getText: function() {
                var text = this.text;
                
                if (this.autoClose && this.showCloseInterval) {
                    text += ' (' + this.seconds + ')';
                }
                
                return text;
            }
        },

        methods: {
            show: function(text, type, canClose, autoClose, autoCloseInterval) {
                if (typeof text === 'undefined') {
                    return false;
                }
                
                this.text = text;
                this.type = type;

                if (typeof canClose === 'boolean') {
                    this.canClose = canClose;
                }

                if (typeof autoClose === 'boolean') {
                    this.autoClose = autoClose;
                }

                if (this.autoClose) {
                    this._startTimer(autoCloseInterval || this.autoCloseInterval);
                }

                this.visible = true;
                
                return true;
            },

            hide: function() {
                this._stopTimer();
                this.visible = false;
            },

            _startTimer: function(intervalSeconds) {
                var self = this;

                this._stopTimer();
                
                this.seconds = intervalSeconds;

                this.timerId = setInterval(function() {
                    self.seconds--;
                    
                    if (self.seconds <= 0) {
                        self._stopTimer();
                        self.hide();
                    }
                }, 1000);
            },

            _stopTimer: function() {
                if (this.timerId !== null) {
                    clearTimeout(this.timerId);
                    this.timerId = null;
                    this.seconds = 0;
                }
            }
        }

    });

}());
/**
 * (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 26.06.2018
 *
 * 27.10.2021:
 * Переместил в подвал
 *
 */

(function() {

    var AllowCookiesCookieName = 'ks_allowcookies';

    Vue.component('allow-cookies', {

        template:
            '<div v-show="isShow" class="allow-cookies-line text-center" style="display: none;">' +
                '<div v-html="text"></div>' +
                '<a class="btn btn-sm btn-blue" href="#" @click.prevent="allowClick" v-text="allowTitle"></a>' +
            '</div>',

        data: function() {
            return {
                isShow: false,
                text: 'Оставаясь на нашем сайте, вы соглашаетесь на использование файлов cookie и данных метрических систем. Подробности в <a href="/docs/data-policy" target="_blank">Политике конфиденциальности</a>.',
                allowTitle: 'Подтвердить'
            };
        },

        methods: {
            allowClick: function() {
                ks.helpers.cookies.set(AllowCookiesCookieName, true, { expires: 100 * 365 });

                this.isShow = false;
            },

            init: function() {
                var isAllow = Cookies.get(AllowCookiesCookieName),
                    isBot = this.$store.state.isBot;

                this.isShow = ! isBot && isAllow !== 'true';
            }
        },

        watch: {
            isShow: function(value) {
                var body = document.querySelector('body');

                if (value) {
                    body.classList.add('body-allow-cookies');
                } else {
                    body.classList.remove('body-allow-cookies');
                }
            }
        },

        mounted: function() {
            var self = this;
            ks.core.addAppCreateEvent(function(){
                self.init();
            });
        }

    });

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 19.12.2017
 */

(function() {

    var AnswerCommentDlg = {

        data: function() {
            return {
                text: ''
            };
        },

        methods: {
            show: function(text) {
                this.text = text;
               
                this.$dlg.modal('show');
            },

            hide: function() {
                this.$dlg.modal('hide');
            }

        },

        mounted: function() {
            this.$dlg = $('#answer-comment-dlg');
        }

    };

    ks.core.addComponent('answer-comment-dlg', AnswerCommentDlg);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 17.03.2018
 */

(function() {

    Vue.component('avatar-select-kid', {
        
        props: {
            kid: null
        },

        data: function() {
            return {
                loaded: false
            };
        },

        computed: {
            avatarSrc: function() {
                if (this.kid !== null) {
                    var file = this.kid.avatar.src + '_' + ks.consts.AVATAR_SIZE_BIG + '.png';

                    if (this.kid.avatar.time !== 0) {
                        file += '?t=' + this.kid.avatar.time;
                    }                    
                    
                    return file;
                } else {
                    return '';
                }
            },
            
            name: function() {
                return this.kid !== null ? this.kid.name : '';
            },
            
            canChangeKid: function() {
                return this.$store.getters.isParent && this.$store.state.parent.countKids > 1;
            }
        },
        
        methods: {
            changeKid: function() {
                this.$emit('change-kid');
            }
        },

        mounted: function() {
            this.loaded = true;
        }

    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 13.12.2017
 * 
 * 08.05.2020:
 * +captcha
 * 
 * 11.09.2022:
 * +email для гостя
 */

(function() {

    var BugDlg = {

        data: function() {
            return {
                text: {
                    value: '',
                    error: ''
                },
                
                // Только для гостя
                email: {
                    value: '',
                    error: ''
                },
                
                globalError: '',
                
                data: null,
                
                /**
                 * +08.05.2020
                 */
                captcha: {
                    x: 0,
                    y: 0,
                    value: '',
                    hasError: false
                }
            };
        },

        computed: {
            isGuest: function() {
                return this.$store.getters.isGuest;
            }, 
            
            textHasError: function() {
               return this.text.error !== '';
            },
            
            emailHasError: function() {
                return this.email.error !== '';
            },
           
            captchaAnswer: function() {
               return this.captcha.x + this.captcha.y;
            },
            
            captchaQuestion: function() {
                return this.captcha.x + ' + ' + this.captcha.y + ' =';
            }
        },

        methods: {
            show: function(data) {
                this.data = data;
                
                this.text.value = '';
                this.text.error = '';
                
                this.email.value = '';
                this.email.error = '';
                
                this.initCaptcha();
                
                this.globalError = '';
               
                this.$dlg.modal('show');
            },

            hide: function() {
                this.$dlg.modal('hide');
            },

            setAutoFocus: function() {
                this.$refs.text.focus();
            },
            
            onSendClick: function() {
                var data = {};
                
                for (var param in this.data) {
                    data[param] = this.data[param];
                }
                
                data.text = this.text.value;
                if (this.isGuest) {
                    data.email = this.email.value;
                }
                
                this.globalError = '';
                
                if (this.validateText() & this.validateEmail()) {
                    ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_BUG_REPORT);
                    
                    ks.client.request({
                        controller: 'bug',
                        action: 'send',
                        data: data,
                        onRequest: this.onSend
                    });
                }
            },
            
            validateText: function() {
                if (this.text.value === '') {
                    this.text.error = 'Пожалуйста, укажите ошибку.';
                    return false;
                }

                if (this.text.value.length > 2048) {
                    this.text.error = 'Слишком длинный текст ошибки.';
                    return false;
                }

                this.text.error = '';
                
                this.captcha.hasError = this.captchaAnswer !== this.captcha.value;
                if (this.captcha.hasError) {
                    return false;
                }

                return true;
            },
            
            validateEmail: function() {
                if ( ! this.isGuest) {
                    return true;
                }
                
                if (this.email.value === '') {
                    this.email.error = 'Пожалуйста, укажите ваш email.';
                    return false;
                }

                if ( ! ks.validator.validateEmail(this.email.value)) {
                    this.email.error = 'Пожалуйста, укажите корректный email.';
                    return false;
                }

                this.email.error = '';

                return true;
            },            
            
            onSend: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.globalError = data.errors.global;                     
                } else {
                    this.hide();

                    ks.app.$refs.messageBox.show({
                        type    : ks.consts.MBT_SUCCESS,
                        title   : 'Сообщение',
                        text    : data.text,
                        buttons : ks.consts.MBB_OK
                    });                    
                }
            },
            
            initCaptcha: function() {
                this.captcha.x = ks.helpers.math.getRandomInt(15, 80);
                this.captcha.y = 100 - this.captcha.x - ks.helpers.math.getRandomInt(1, 10);
                if ( this.captcha.y <= 0) {
                     this.captcha.y = ks.helpers.math.getRandomInt(15, 30);
                }
                this.captcha.value = '';
                this.captcha.hasError = false;
            }

        },
        
        watch: {
            'text.value': function() {
                if (this.text.value !== '') {
                    this.text.error = '';
                }
            },
            
            'email.value': function() {
                if (this.email.value !== '') {
                    this.email.error = '';
                }
            },
            
            'captcha.value': function() {
                this.captcha.hasError = false;
            }
        },

        mounted: function() {
            var self = this;

            this.initCaptcha();

            this.$dlg = $('#bug-dlg');

            this.$dlg.on('shown.bs.modal', function(e) {
                self.setAutoFocus();
            });
        }

    };

    ks.core.addComponent('bug-dlg', BugDlg);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 26.10.2017
 *
 * 28.10.2017 - add multiple (prop arrayMode)
 */

(function() {

    Vue.component('checkbox', {

        template: '<div class="checkbox checkbox-blue" :class="renderClass">' +
                      '<input ref="input" type="checkbox" :id="compId" :value="value" @change="onChange">' +
                      '<label :for="compId" class="checkbox-text">' +
                          '<div v-html="title"></div>' +
                      '</label>' +
                  '</div>',

        model: {
            prop: 'checked',
            event: 'change'
        },

        props: {
            checked: Boolean,
            
            arrayMode: {
                type: String,
                default: ''
            },
            value: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            extraClass: {
                type: String,
                default: ''
            }
        },

        computed: {
            renderClass: function() {
                var cls = {},
                    arr = this.extraClass !== '' ? this.extraClass.split(' ') : [];

                for(var i = 0; i < arr.length; i++) {
                    cls[arr[i]] = true;
                }

                return cls;
            }
        },

        data: function() {
            return {
                compId: ''
            };
        },

        watch: {
            checked: function(val) {
                this.updateChecked();
            }
        },

        methods: {
            onChange: function(e) {
                if (this.arrayMode === 'true') {
                    var items = this.checked, // array
                        index = items.indexOf(this.value);

                    if (e.target.checked) {
                        if (index === -1) {
                            items.push(this.value);
                            this.$emit('change', items);
                        }
                    } else {
                        if (index > -1) {
                            items.splice(index, 1);
                            this.$emit('change', items);
                        }
                    }
                } else {
                    this.$emit('change', e.target.checked);
                }
            },

            updateChecked: function(){
                this.$refs.input.checked = this.arrayMode === 'true' ? this.checked.indexOf(this.value) > -1 : this.checked;
            }
        },

        mounted: function() {
            this.compId = this.id === '' ? ks.helpers.html.getUniqueId() : this.id;

            this.updateChecked();
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 01.07.2021
 */

(function() {
    
    const mobileRowItems = 5,
          mobileMaxItemsCount = 30;

     Vue.component('countries-flags', {
        
        template: 
            '<div class="row countries-flags-container text-center" :class="containerClass">'+

            '    <div class="col-xs-12">'+
            '        <div class="countries-flags-container__title text-center" v-html="title"></div>'+
            '    </div>'+

            '    <div v-for="(item, index) in items" :key="index" class="countries-flags-container__box" :class="classBox(index)">'+
            '        <img width="64" height="64" loading="lazy" class="countries-flags-container__box__flag ks-tooltip" :src="getImageSrc(item)" :alt="item.title" data-toggle="tooltip" data-placement="top" :title="item.title" />'+
            '    </div>'+

            '    <div class="countries-flags-container__bottom visible-xs">'+
            '        <a v-show="canMobileShowMore" href="#" @click.prevent="mobileShowMore()" class="btn btn-round btn-glass-white btn-glass-blue">Показать ещё</a>'+
            '    </div>'+
            
            '</div>',
        
        props: {
            title: {
                type: String,
                required: true
            },
            
            items: {
                type: Array,
                required: true
            },
            
            imagePath: {
                type: String,
                required: true
            },
            
            profilePaymentMode: {
                type: Boolean,
                default: false
            }
        },

        data: function() {
            return {
               mobileRowsShown: 2
            };
        },

        computed: {
            canMobileShowMore: function(){
                return this.getRowsCount(mobileRowItems, true) > this.mobileRowsShown;
            },
            
            containerClass: function() {
                return {
                    'countries-flags-container-payment-page': this.profilePaymentMode
                };
            }
        },

        methods: {
            classBox: function(index){
                return {
                    'hidden-xs': index > mobileMaxItemsCount - 1 || this.getRowNum(index, mobileRowItems) >= this.mobileRowsShown,
                    'profile-payment-mode': this.profilePaymentMode
                };
            },
            
            getImageSrc: function(item){
                return this.imagePath + item.image;
            },
            
            /**
             * Номер строки элемента
             * @param {Number} index Индекс элемента
             * @param {Number} countInRow Количество элементов в строке
             * @returns {Number}
             */
            getRowNum: function(index, countInRow){
                return countInRow <= 0 ? 0 : Math.floor(index / countInRow);
            },
            
            /**
             * Количество строк
             * @param {Number} countInRow Количество элементов в строке
             * @param {Boolean} mobileMode Режим отображения для мобильных устройств
             * @returns {Number}
             */
            getRowsCount: function(countInRow, mobileMode){
                let count = this.items.length;
                if (mobileMode && count > mobileMaxItemsCount) {
                    count = mobileMaxItemsCount;
                }
                
                return countInRow <= 0 ? 0: Math.ceil(count / countInRow);
            },
            
            mobileShowMore: function(){
                this.mobileRowsShown += 2;
            }
        },

        mounted: function() {
        }

    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 28.10.2019
 */

(function() {

    Vue.component('count-down', {
        
        template: '<div v-show="loaded && active && enabled" class="count-down" :class="renderClass">' +
                  '  <div class="count-down-text">{{ infoText }}</div>' +  
                  '  <div class="count-down-container">' +  
                  '    <div class="count-down-number-container"><div class="count-down-number hours" :class="hoursClass">{{ hours }}</div><div class="count-down-number-text">{{ hoursText }}</div></div>' +
                  '    <div class="count-down-number-container"><div class="count-down-colon count-down-colon-blink">:</div><div class="count-down-number-text">&nbsp;</div></div>' +
                  '    <div class="count-down-number-container"><div class="count-down-number minutes" :class="minutesClass">{{ minutes }}</div><div class="count-down-number-text">{{ minutesText }}</div></div>' +
                  '    <div class="count-down-number-container"><div class="count-down-colon count-down-colon-blink">:</div><div class="count-down-number-text">&nbsp;</div></div>' +
                  '    <div class="count-down-number-container"><div class="count-down-number seconds" :class="secondsClass">{{ seconds }}</div><div class="count-down-number-text">{{ secondsText }}</div></div>' +
                  '  </div>' +
                  '</div>',
          
        props: {
            enabled: {
                type: Boolean,
                default: true
            },
            
            timeLeft: {
                type: String,
                default: ''
            },
            
            infoText: {
                type: String,
                default: ''
            }
        },
        
        data: function() {
            return {
                loaded: false,
                
                time: {
                    hours: 0,
                    minutes: 0,
                    seconds: 0
                },
                
                timer: null
            };
        },
        
        computed: {
            renderClass: function() {
                
            },
    
            hoursClass: function() {
                return {
                    'disabled': this.time.hours === 0
                };
            },
            
            minutesClass: function() {
                return {
                    'disabled': this.time.minutes === 0 && this.time.hours === 0
                };
            },
            
            secondsClass: function() {
                return { };
            },            
    
            active: function() {
                return (this.time.hours < 100) && (this.time.hours > 0 || this.time.minutes > 0 || this.time.seconds > 0);
            },
    
            hours: function() {
                return this.numberToString(this.time.hours);
            },
            
            minutes: function() {
                return this.numberToString(this.time.minutes);
            },
            
            seconds: function() {
                return this.numberToString(this.time.seconds);
            },
            
            hoursText: function() {
                return ks.helpers.text.pluralize(this.time.hours, ['час', 'часа', 'часов']);
            },
            
            minutesText: function() {
                return ks.helpers.text.pluralize(this.time.minutes, ['минуту', 'минуты', 'минут']);
            },
            
            secondsText: function() {
                return ks.helpers.text.pluralize(this.time.seconds, ['секунду', 'секунды', 'секунд']);
            }
        },
       
        methods: {
            numberToString: function(num) {
                var str = num.toString();
                
                if (str.length === 1) {
                    str = '0' + str;
                }
                
                return str;                
            },
            
            onTimer: function() {
                if (this.time.seconds > 0) {
                    this.time.seconds--;
                } else {
                    if (this.time.minutes > 0) {
                        this.time.minutes--;
                        this.time.seconds = 59;
                    } else {
                        if (this.time.hours > 0) {
                            this.time.hours--;
                            this.time.minutes = 59;
                            this.time.seconds = 59;
                        } else {
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }
                }
            },
            
            setTimeLeft: function(time) {
                if (this.timer !== null) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                
                var arr = time !== null || time === '' ? time.split(':') : [];

                if (arr.length !== 3) {
                    this.time.hours = 0;
                    this.time.minutes = 0;
                    this.time.seconds = 0;
                    return;
                }
                
                this.time.hours = parseInt(arr[0], 10);
                this.time.minutes = parseInt(arr[1], 10);
                this.time.seconds = parseInt(arr[2], 10);                
                
                this.timer = setInterval(this.onTimer, 1000);
            }
        },
        
        mounted: function() {
            this.setTimeLeft(this.timeLeft);
            
            this.loaded = true;
        }        
        
    });
    
}());    
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 17.04.2020
 *
 */

(function() {

    var CouponDlg = {

        data: function() {
            return {
                coupon: {
                    value: '',
                    error: ''
                },
                
                kid: null,
                
                onClose: null,
                onApplySuccess: null
            };
        },

        computed: {
            hasCouponError: function() {
                return this.coupon.error !== '';
            }
        },

        methods: {
            show: function(options) {
                this.kid = options.kid;
                
                this.onClose = options.onClose || null;
                this.onApplySuccess = options.onApplySuccess || null;
                
                this.coupon.value = '';
                this.coupon.error = '';
                
                this.$dlg.modal('show');
            },

            hide: function() {
                this.$dlg.modal('hide');
            },
            
            onUse: function() {
                this.coupon.error = '';
                
                if (this.coupon.value === '') {
                    this.coupon.error = 'Пожалуйста, введите купон.';
                    return false;
                }
                
                if (/*this.coupon.value.indexOf('-') < 0 || */this.coupon.value.length < 8) {
                    this.coupon.error = 'Купон не найден.';
                    return false;
                }
                
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-kids/apply-coupon',
                    data: {
                        coupon: this.coupon.value,
                        kidId: this.kid.id
                    },
                    onRequest: this.onApplyCoupon
                });
            },
            
            onApplyCoupon: function(errorCode, data) {
                this.coupon.value = '';
                
                if (errorCode !== ks.consts.ERR_OK) {
                    this.coupon.error = data.errors.global;
                    return;
                }
                
                if (this.onApplySuccess !== null) {
                    this.onApplySuccess(this.kid, data.expired);
                }
                
                this.hide();
            },

            onCloseEvent: function(){
                if (this.onClose !== null) {
                    this.onClose(this.modalResult, this.userData);
                }
            }
        },

        watch: {
            'coupon.value': function(newValue) {
                if (newValue !== '') {
                    this.coupon.error = '';
                }
            }
        },

        mounted: function() {
            var self = this;

            this.$dlg = $('#coupon-dlg');

            this.$dlg.on('hidden.bs.modal', function () {
                self.onCloseEvent();
            });
        }

    };

    ks.core.addComponent('coupon-dlg', CouponDlg);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 21.03.2018
 */

(function() {

    var CreateKid = {

        data: function() {
            return {
                name: {
                    value: '',
                    error: ''
                },
                
                birthday: {
                    value: '',
                    error: ''
                },
                
                gender: {
                    value: 0
                },
                
                onAddEvent: null
            };
        },

        computed: {
            nameHasError: function() {
                return this.name.error !== '';
            },

            birthdayHasError: function() {
                return this.birthday.error !== '';
            }            
        },

        methods: {
            show: function(options) {
                this.onAddEvent = options.onAdd;
                
                this.clear();
                
                this.$dlg.modal('show');
            },

            hide: function() {
                this.$dlg.modal('hide');
            },
            
            clear: function() {
                this.name.value = '';
                this.name.error = '';
                
                this.birthday.value = '';
                this.birthday.error = '';
                
                this.$refs.birthday.clear();
                
                this.gender.value = ks.consts.GENDER_FEMALE;
            },
            
            add: function() {
                this.$refs.alert.hide();
                
                if (this.validateLoginFields()) {
                    ks.client.request({
                        controller: 'parent',
                        action: 'profile-kids/add-kid',
                        data: {
                            kid: {
                                name: this.name.value,
                                birthday: this.birthday.value,
                                gender: this.gender.value
                            }
                        },
                        onRequest: this.onAddKid
                    });
                }                
            },
            
            onAddKid: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    for (var field in data.errors) {
                        switch (field) {
                            case 'name':
                                this.name.error = data.errors[field];
                                break;
                            case 'birthday':
                                this.birthday.error = data.errors[field];
                                break;
                        }
                    }

                    if (data.errors.global) {
                        this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    }
                    
                    return;
                }
                
                this.onAddEvent(data.kid);
                
                this.hide();
            },
            
            setAutoFocus: function() {
                this.$refs.name.focus();
            },
            
            validateLoginFields: function() {
                return this.validateName() & this.validateBirthday();
            },            
            
            validateName: function() {
                if (this.name.value === '') {
                    this.name.error = 'Пожалуйста, укажите имя ребёнка.';
                    return false;
                }
                
                if (this.name.value.length < 2) {
                    this.name.error = 'Длина имени не может быть меньше 2 символов.';
                    return false;
                }
                
                if (this.name.value.length > 50) {
                    this.name.error = 'Длина имени не может быть больше 50 символов.';
                    return false;
                }                

                this.name.error = '';

                return true;
            },

            validateBirthday: function() {
                if (this.birthday.value === '') {
                    this.birthday.error = 'Укажите дату рождения ребёнка.';
                    return false;
                }

                this.birthday.error = '';

                return true;
            }          
        },

        watch: {
            'name.value': function() {
                if (this.name.value !== '') {
                    this.name.error = '';
                }
            },

            'birthday.value': function() {
                if (this.birthday.value !== '') {
                    this.birthday.error = '';
                }
            }
        },

        mounted: function() {
            var self = this;
            
            this.$dlg = $('#create-kid');
            
            this.$dlg.on('shown.bs.modal', function(e) {
                self.setAutoFocus();
            });            
        }

    };

    ks.core.addComponent('create-kid', CreateKid);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 05.11.2019
 */

(function() {
    Vue.component('date-select-button', {
        template: '<button :class="buttonClass" @mousedown="fireDownEvent" @mouseup="fireUpEvent" @touchstart="fireTouchStartEvent" @touchend="fireTouchEndEvent" @mouseleave="fireUpEvent" type="button"><i class="fa" :class="iconClass"></i></button>',
    
        props: {
            /**
             * Direction: 'up' or 'down'
             */
            direction: {
                type: String,
                required: true
            },
            
            disabled: {
                type: Boolean,
                default: false
            },
            
            defaultActionInterval: {
                type: Number,
                default: 350
            },
            
            minActionInterval: {
                type: Number,
                default: 100
            }
        }, 
    
        data: function() {
            return {
                isDown: false,
                down: {
                    isClickMode: true,
                    time: 0,
                    timer: null,
                    action: {
                        lastTime: 0,
                        interval: 0
                    }
                }                    
            };
        }, 
        
        computed: {
            buttonClass: function() {
                return {
                    'disabled' : this.disabled,
                    'up'       : this.direction === 'up',
                    'down'     : this.direction === 'down'
                };
            },
            
            iconClass: function() {
                return {
                    'fa-caret-up'   : this.direction === 'up',
                    'fa-caret-down' : this.direction === 'down'
                };
            }
        },
            
        methods: {
            fireTouchStartEvent: function() {
                this.startDown();
            },
    
            fireTouchEndEvent: function() {
                this.stopDown(); 
            },
            
            fireDownEvent: function(event) {
                if (ks.browser.isTouch() || (typeof event.which !== 'undefined' && event.which !== 1)) {
                    return;
                }
                
                this.startDown();
            },
            
            fireUpEvent: function() {
                if (ks.browser.isTouch()) {
                    return;
                }
                
                this.stopDown();                
            },
            
            startDown: function() {
                if (this.disabled) {
                    return;
                }
                
                this.isDown = true;
                this.down.isClickMode = true;
                this.down.time = (new Date()).valueOf();
                this.down.action.lastTime = 0;
                
                var self = this;
                if (this.down.timer !== null) {
                    clearInterval(self.down.timer);
                    self.down.timer = null;                     
                }
                this.down.timer = setInterval(function() {
                    if (self.disabled) {
                        clearInterval(self.down.timer);
                        self.down.timer = null;  
                        
                        self.isDown = false;
                        self.down.isClickMode = true;
                        self.down.time = 0;
                        self.down.lastActionTime = 0;      
                        
                        return;
                    }
                    
                    var currentTime = (new Date()).valueOf(),
                        tick = currentTime - self.down.time;
                    
                    if (tick > self.defaultActionInterval) {
                        self.down.isClickMode = false;
                        
                        var k = Math.floor(tick / self.defaultActionInterval),
                            newInterval = k > 0 ? Math.floor(self.defaultActionInterval / k) : self.defaultActionInterval;
                        
                        self.down.action.interval = newInterval < self.minActionInterval ? self.minActionInterval : newInterval;
                        
                        var interval = currentTime - self.down.action.lastTime;
                        if (interval >= self.down.action.interval) {
                            self.down.action.lastTime = currentTime;
                            self.$emit('change', self.direction);                            
                        }
                    }
                    
                }, 50);                
            },
            
            stopDown: function() {
                if (this.disabled) {
                    return;
                }                
                
                if (this.down.timer !== null) {
                    clearInterval(this.down.timer);
                    this.down.timer = null;
                }
                
                if ( ! this.isDown) {
                    return;
                }
                
                if (this.down.isClickMode) {
                    this.$emit('change', this.direction);
                }
                
                this.isDown = false;
                this.down.isClickMode = true;
                this.down.time = 0;
                this.down.lastActionTime = 0;               
            }
        }
    });

    Vue.component('date-select', {

        template: '<div class="date-select">' +
                  // Day 
                  '  <div class="date-select-part date-select-part-day">' + 
                  '    <div class="date-select-part-button">' +
                  '      <date-select-button direction="up" @change="fireChangeDay"></date-select-button>' +
                  '    </div>' +
                  '    <div class="date-select-part-value">' +
                  '      {{ day }}' +
                  '    </div>' +
                  '    <div class="date-select-part-button">' +
                  '      <date-select-button direction="down" @change="fireChangeDay"></date-select-button>' +
                  '    </div>' +
                  '  </div>' +
                  
                  // Month
                  '  <div class="date-select-part date-select-part-month">' + 
                  '    <div class="date-select-part-button">' +
                  '      <date-select-button direction="up" @change="fireChangeMonth"></date-select-button>' +
                  '    </div>' +
                  '    <div class="date-select-part-value">' +
                  '      {{ month }}' +
                  '    </div>' +
                  '    <div class="date-select-part-button">' +
                  '      <date-select-button direction="down" @change="fireChangeMonth"></date-select-button>' +
                  '    </div>' +
                  '  </div>' +     
                  
                  // Year 
                  '  <div class="date-select-part date-select-part-year">' + 
                  '    <div class="date-select-part-button">' +
                  '      <date-select-button direction="up" :disabled="!canPrevYear" @change="fireChangeYear"></date-select-button>' +
                  '    </div>' +
                  '    <div class="date-select-part-value">' +
                  '      {{ year }}' +
                  '    </div>' +
                  '    <div class="date-select-part-button">' +
                  '      <date-select-button direction="down" :disabled="!canNextYear" @change="fireChangeYear"></date-select-button>' +
                  '    </div>' +
                  '  </div>' +                  
                  
                  '</div>',
        model: {
            prop: 'value',
            event: 'change'
        },          

        props: {
            value: String,
            
            minYear: {
                type: Number,
                default: 0
            },
            
            maxYear: {
                type: Number,
                default: 0        
            },
            
            maxDate: {
                type: String,
                default: ''
            },
            
            fullMonth: {
                type: Boolean,
                default: false
            },
            
            userData: {
                default: null
            }
        },
        
        data: function() {
            return {
                date: {
                    day: 0,
                    month: 0,
                    year: 0
                }
            };
        },
        
        computed: {
            isEmptyDate: function() {
                return this.date.day === 0 && this.date.month === 0 && this.date.year === 0;
            },
            
            day: function() {
                return this.date.day > 0 ? this.date.day : 'день';
            },
            
            month: function() {
                if (this.date.month > 0) {
                    return this.fullMonth ? moment.months(this.date.month - 1) : moment.monthsShort(this.date.month - 1);
                } else {
                    return 'месяц';
                }
            },
            
            year: function() {
                return this.date.year > 0 ? this.date.year : 'год';
            },
            
            daysInMonth: function() {
                return this.date.month > 0 && this.date.year > 0 ? 
                  moment(this.date.year + '-' + this.date.month, 'YYYY-MM').daysInMonth() : 0;
            },
            
            canPrevYear: function() {
                return this.isEmptyDate || this.minYear <= this.date.year - 1;
            },
            
            canNextYear: function() {
                return this.isEmptyDate || this.maxYear >= this.date.year + 1;
            }
        },
        
        methods: {
            fireChangeDay: function(direction) {
                this.changeDay(direction === 'up' ? -1 : 1);
            },
            
            changeDay: function(i) {
                if (this.date.day === 0) {
                    this.date.day = 1;
                } else {
                    var newDay = this.date.day + i;

                    if (newDay < 1) {
                        newDay = this.daysInMonth;
                    } else {
                        if (newDay > this.daysInMonth) {
                            newDay = 1;
                        }
                    }
                    
                    this.date.day = newDay;
                }
            },
            
            fireChangeMonth: function(direction) {
                this.changeMonth(direction === 'up' ? -1 : 1);
            },
            
            changeMonth: function(i) {
                if (this.date.month === 0) {
                    this.date.month = 1;
                } else {
                    var newMonth = this.date.month + i;
                    
                    if (newMonth < 1) {
                        newMonth = 12; 
                    } else {
                        if (newMonth > 12) {
                            newMonth = 1;
                        }
                    }
                    
                    this.date.month = newMonth;
                }
            },
            
            fireChangeYear: function(direction) {
                this.changeYear(direction === 'up' ? -1 : 1);
            },
            
            changeYear: function(i) {
                if (this.date.year === 0) {
                    this.date.year = this.minYear > 0 ? this.minYear : moment().year();
                } else {
                    var newYear = this.date.year + i;
                    
                    if (newYear < this.minYear || newYear > this.maxYear) {
                        return; 
                    }
                    
                    this.date.year = newYear;
                }                
            },
            
            initDate: function() {
                var current = moment(),
                    year = current.year();
            
                if (year < this.minYear) {
                    year = this.minYear;
                }   
                
                if (year > this.maxYear) {
                    year = this.maxYear;
                }
                
                this.date.day = current.date();
                this.date.month = current.month() + 1;
                this.date.year = year;                
            },
            
            fireChangeEvent: function() {
                var d = moment({ year: this.date.year, month: this.date.month - 1, day: this.date.day }),
                    val = d.format('DD.MM.YYYY');
            
                if (this.maxDate !== '') {
                    let maxDate = moment(this.maxDate, 'DD.MM.YYYY');
                    
                    if (maxDate < d) {
                        this.date.day = maxDate.date();
                        this.date.month = maxDate.month() + 1;
                        this.date.year = maxDate.year();   
                        
                        val = maxDate.format('DD.MM.YYYY');
                    }
                }           
                
                if (val === this.value) {
                    return;
                }
                
                this.$emit('change', val, this.userData); 
            },
            
            loadValue: function() {
                var d = moment(this.value, 'DD.MM.YYYY');
                
                this.date.day = d.date();
                this.date.month = d.month() + 1;
                this.date.year = d.year();
            }
            
        },
        
        watch: {
            'date.day': function() {
                if (this.date.month === 0 && this.date.year === 0) {
                    this.initDate();
                }
                
                this.fireChangeEvent();
            },
            
            'date.month': function() {
                if (this.date.day === 0 && this.date.year === 0) {
                    this.initDate();
                } else {
                    if (this.daysInMonth > 0 && this.date.day > this.daysInMonth) {
                        this.date.day = this.daysInMonth;
                    }
                }
                
                this.fireChangeEvent();
            },  
            
           'date.year': function() {
                if (this.date.day === 0 && this.date.month === 0) {
                    this.initDate();
                } else {
                    if (this.daysInMonth > 0 && this.date.day > this.daysInMonth) {
                        this.date.day = this.daysInMonth;
                    }
                }
                
                this.fireChangeEvent();
            },
            
            value: function(newValue) {
                if (newValue === '') {
                    this.date.day = 0;
                    this.date.month = 0;
                    this.date.year = 0;
                } else {
                    this.loadValue();
                }
            }
        },
        
        mounted: function() {
            if (this.value !== '') {
                this.loadValue();
            }
        }
        
    });

}());       
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 17.06.2021
 */

(function() {

    Vue.component('date-select-line', {
        template: 
            '<div class="select-date-control">'+
                '<div class="select-date-control__days">'+
                    '<bs-select ref="day" @select-change="onSelectDay" :options="days" additional-class="" size="7" :title="titleDay" :show-tick="showTick"></bs-select>'+
                '</div>'+

                '<div class="select-date-control__months">'+
                    '<bs-select ref="month" @select-change="onSelectMonth" :options="months" additional-class="" :title="titleMonth" :show-tick="showTick"></bs-select>'+
                '</div>'+

                '<div class="select-date-control__years">'+
                    '<bs-select ref="year" @select-change="onSelectYear" :options="years" additional-class="" size="7" :title="titleYear" :show-tick="showTick"></bs-select>'+
                '</div>'+
            '</div>',

        model: {
            prop: 'value',
            event: 'change'
        },            
            
        props: {
            value: String,
            
            showTick: {
                type: Boolean,
                default: false
            },
            
            titleDay: {
                type: String,
                default: 'День'
            },
            
            titleMonth: {
                type: String,
                default: 'Месяц'
            },
            
            titleYear: {
                type: String,
                default: 'Год'
            },
            
            maxYear: {
                type: Number,
                default: -1
            },
            
            minYear: {
                type: Number,
                default: -1
            },
            
            minDate: {
                type: String,
                default: ''
            },
            
            maxDate: {
                type: String,
                default: ''
            },
            
            userData: {
                default: null
            }
        },
        
        data: function() {
            return {
                days: [],
                months: [],
                years: [],
                
                date: {
                    day: 0,
                    month: 0,
                    year: 0
                }
            };
        },

        methods: {
            init: function(){
                // days
                this.createDays();
               
                // months
                for (let i = 0; i < 12; i++) {
                    this.months.push({
                        value: i + 1,
                        title: ks.helpers.string.firstLetterCaps(moment.months(i)),
                        selected: false
                    });
                }
               
                // years
                let currentYear = moment().year(),
                    fromYear = this.minYear > -1 ? this.minYear : currentYear - 100,
                    toYear = this.maxYear > -1 ? this.maxYear : currentYear;
           
                for (let i = toYear; i >= fromYear; i--) {
                    this.years.push({
                        value: i,
                        title: i,
                        selected: false
                    });
                }                   
            },
           
            daysInMonth: function() {
                return this.date.month > 0 && this.date.year > 0 ? moment(this.date.year + '-' + this.date.month, 'YYYY-MM').daysInMonth() : 31;
            },
           
            createDays: function(){
                let countDays = this.daysInMonth();
                
                if (countDays < this.date.day) {
                    this.date.day = countDays;
                }
                
                this.days = [];
                for (let i = 1; i <= countDays; i++) {
                    this.days.push({
                        value: i,
                        title: i,
                        selected: false
                    });
                }               
                
                this.$refs.day.selectOption(this.date.day);
            },
           
            dateChanged: function(recreateDays){
                if (recreateDays) {
                    this.createDays();
                }
                
                this.fireChangeEvent();
            },
           
            onSelectDay: function(option){
                this.date.day = option.value;
                this.dateChanged(false);
            },
           
            onSelectMonth: function(option){
                this.date.month = option.value;
                this.dateChanged(true);
            },
            
            onSelectYear: function(option){
                this.date.year = option.value;
                this.dateChanged(true);
            },
            
            fireChangeEvent: function() {
                let val = this.getDate();
                
                if (val === null || val === this.value) {
                    return;
                }                
                
                this.$emit('change', val, this.userData); 
            },
            
            loadValue: function() {
                if (this.value === '') {
                    this.date.day = 0;
                    this.date.month = 0;
                    this.date.year = 0;
                    
                    this.createDays();

                    this.$refs.year.selectOption(this.date.year);
                    this.$refs.month.selectOption(this.date.month);                    
                    
                    return;
                }
                
                let d = moment(this.value, 'DD.MM.YYYY'),
                    day = d.date(),
                    month = d.month(),
                    year = d.year();
            
                if (day <= 0 || month <= 0 || year <= 0) {
                    return;
                }    
                
                this.date.day = day;
                this.date.month = month + 1;
                this.date.year = year;
                
                this.createDays();
                
                this.$refs.year.selectOption(this.date.year);
                this.$refs.month.selectOption(this.date.month);
            },           
            
            getDate: function(){
                if (this.date.year <= 0 || this.date.month <= 0 || this.date.day <= 0) {
                    return null;
                }
                
                let date = moment({ year: this.date.year, month: this.date.month - 1, day: this.date.day }),
                    changed = false;
                
                if (this.maxDate !== '') {
                    let maxDate = moment(this.maxDate, 'DD.MM.YYYY');
                    
                    if (maxDate < date) {
                        this.date.day = maxDate.date();
                        this.date.month = maxDate.month() + 1;
                        this.date.year = maxDate.year();   
                        
                        changed = true;
                    }
                }
                
                if (this.minDate !== '') {
                    let minDate = moment(this.minDate, 'DD.MM.YYYY');
                    
                    if (minDate > date) {
                        this.date.day = minDate.date();
                        this.date.month = minDate.month() + 1;
                        this.date.year = minDate.year();   
                        
                        changed = true;
                    }
                } 
                
                if (changed) {
                    this.createDays();

                    this.$refs.year.selectOption(this.date.year);
                    this.$refs.month.selectOption(this.date.month);                    
                }
                
                let d = changed ? moment({ year: this.date.year, month: this.date.month - 1, day: this.date.day }) : date;
                
                return d.format('DD.MM.YYYY');
            },
            
            clear: function(){
                this.date.day = 0;
                this.date.month = 0;
                this.date.year = 0;

                this.createDays();

                this.$refs.year.selectOption(this.date.year);
                this.$refs.month.selectOption(this.date.month);                 
            }
        },
        
        watch: {
            value: function(newValue) {
                if (newValue === '') {
                    this.clear(); 
                } else {
                    this.loadValue();
                }
            }
        },
        
        mounted: function() {
            this.init();
            
            let self = this;
            this.$nextTick(function(){
                self.loadValue();
            });
        }        

    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 19.10.2017
 */

(function() {

    Vue.component('date-time-picker', {

        template: '<div class="input-group date">' +
                      '<input type="text" class="form-control" :placeholder="placeholder" :id="id" />' +
                      '<span class="input-group-addon">' +
                          '<span class="fa fa-calendar"></span>' +
                      '</span>' +
                  '</div>',

        props: {
            value: {
                default: null,
                required: true
            },

            placeholder: {
                type: String,
                default: ''
            },

            id: {
                type: String,
                default: ''
            },

            format: {
                type: String,
                default: 'DD.MM.YYYY'
            },
            
            minDate: {
                type: Object,
                default: function() {
                    return {
                        count: -1,
                        unit: '' // days|weeks|months|years
                    };
                }
            },
            
            maxDate: {
                type: Object,
                default: function() {
                    return {
                        count: -1,
                        unit: '' // days|weeks|months|years
                    };
                }                
            },
            
            userData: {
                default: null
            }
        },

        data: function() {
            return {
                dp: null
            };
        },

        watch: {
            value: function(newValue) {
                this.dp.date(newValue === '' ? null : newValue);
            }
        },

        mounted: function() {
            var self = this,
                el = $(this.$el),
                input = el.find('input'),
                options = {
                    allowInputToggle: true,
                    format: this.format,
                    icons: {
                        time  : 'fa fa-clock-o',
                        date  : 'fa fa-calendar',
                        up    : 'fa fa-arrow-up',
                        down  : 'fa fa-arrow-down'
                    }                    
                };
        
                
            if (this.minDate.unit !== '') {
                options.minDate = moment().add(this.minDate.count, this.minDate.unit).startOf('day');
            }     
            
            if (this.maxDate.unit !== '') {
                options.maxDate = moment().add(this.maxDate.count, this.maxDate.unit).endOf('day');
            }     

            el.datetimepicker(options);

            this.dp = el.data('DateTimePicker');

            if (this.value !== '') {
                this.dp.date(this.value);
            } else {
                this.dp.date(null);
            }

            el.on('dp.change', function(e){
                self.$emit('input', input.val());
                self.$emit('change', input.val(), self.userData);
            });
        }

    });

}());
(function() {

  Vue.component('email-code-input', {

    template:
      `<div class="col-xs-3" :class="boxClass">
        <input
          type="text"
          maxlength="1"
          class="form-control email-code__input"
          ref="input"
          autocomplete="off"
          readonly
          :name="name"
          :value="value"
          @change="onUpdateValue"
          @input="onUpdateValue"
          @keyup.enter="onEnter"
          @paste="onPaste"
        />
      </div>`,

    props: {
      value: {
        type: String
      },

      index: {
        type: Number,
        required: true
      },

      name: {
        type: String,
        required: true
      },

      hasError: {
        type: Boolean,
        required: true
      }
    },

    data() {
      return {
        prevValue: ''
      };
    },

    computed: {
      boxClass() {
        return {
          'has-error': this.hasError
        };
      }
    },

    methods: {
      focus() {
        this.$refs.input.focus();
        this.$refs.input.select();
      },

      onUpdateValue() {
        const input = this.$refs.input;
        let value = input.value;

        if (value) {
          value = value.replace(/[^0-9]/g, '');
        }

        if (input.value !== value) {
          input.value = value;
        }

        if (this.prevValue === value) {
          return;
        }

        this.prevValue = value;

        this.$emit('input', value);
        this.$emit('change', { value, index: this.index });
      },

      onEnter() {
        this.$emit('enter', this.index);
      },

      onPaste(event) {
        let clipboardText = null;

        if (event.clipboardData && event.clipboardData.getData) {
          clipboardText = event.clipboardData.getData('text/plain');
        } else {
          return true;
        }

        if (clipboardText) {
          const code = clipboardText.replace(/[^0-9]/g, '');
          if (code.length > 0) {
            this.$emit('paste', code);

            event.preventDefault();
            return false;
          }
        }

        return true;
      }
    },

    mounted() {
      this.prevValue = this.value;

      setTimeout(() => {
        this.$refs.input.removeAttribute('readonly');
      }, 300);
    }
  });


  Vue.component('email-code', {
    props: {
      uid: {
        type: String,
        required: true
      },

      size: {
        type: Number,
        default: 4,
      },

      errorText: {
        type: String,
        required: true
      }
    },

    template: `
      <div>
        <div class="row text-center email-code__inputs">
          <email-code-input
            v-for="(number, index) in numbers"
            v-model="number.value"
            :key="index"
            :index="index"
            :name="getInputName(index)"
            :ref="getInputRef(index)"
            :has-error="number.hasError"
            @enter="onConfirmCode"
            @paste="onPasteCode"
            @change="onChangeInput"
          />
        </div>

        <div class="row">
          <div v-show="hasError" class="col-xs-12 small-text error-text text-center">{{ errorText }}</div>
        </div>

        <div class="text-center email-code__apply-box">
          <a
            class="btn btn-green btn-lg"
            href="#"
            @click.prevent="onConfirmCode"
          >
            Подтвердить почту
          </a>
        </div>
      </div>
    `,

    data() {
      return {
        numbers: []
      };
    },

    computed: {
      hasError() {
        return this.errorText !== '';
      },

      code() {
        return this.numbers.map(number => number.value).join('');
      }
    },

    methods: {
      clear() {
        this.numbers = [];
        for (let i = 0; i < this.size; i++) {
          this.numbers.push({ value: '', hasError: false });
        }
      },

      getInputName(index) {
        return this.uid + '_' + index;
      },

      getInputRef(index) {
        return `n${index}`;
      },

      getInput(index) {
        const input = this.$refs[this.getInputRef(index)];

        if (! input) {
          return null;
        }

        return input.length && input.length === 1 ? input[0] : input;
      },

      validateCode() {
        let focusProcessed = false;
        let isValid = true;

        for (let i = 0; i < this.size; i++) {
          const isValidNumber = this.numbers[i].value !== '';
          const input = this.getInput(i);

          this.numbers[i].hasError = ! isValidNumber;

          if (! isValidNumber) {
            isValid = false;

            if (! focusProcessed) {
              focusProcessed = true;
              input.focus();
            }
          }
        }

        return isValid;
      },

      onConfirmCode() {
        if (! this.validateCode()) {
          return;
        }

        this.$emit('confirm', this.code);
      },

      onPasteCode(code) {
        const values = code.split('');
        const count = Math.min(values.length, this.size);

        for (let i = 0; i < count; i++) {
          this.numbers[i].value = values[i];
          this.getInput(i).focus();
        }

        if (count === this.size) {
          this.onConfirmCode();
        } else {
          const input = this.getInput(count);
          if (input) {
            input.focus();
          }
        }
      },

      onChangeInput(data) {
        const value = data.value;
        const index = data.index;

        if (value === '') {
          return;
        }

        this.numbers[index].hasError = false;

        if (index >= this.size - 1) {
          if (this.code.length === this.size) {
            this.onConfirmCode();
          }
        } else {
          this.getInput(index + 1).focus();
        }
      }
    },

    watch: {
      numbers: {
        handler() {
          this.$emit('change', this.code);
        },

        deep: true
      }
    },

    mounted() {
      this.clear();

      setTimeout(() => {
        this.getInput(0).focus();
      }, 300);
    }
  });
}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 13.12.2017
 */

(function() {

    Vue.component('exercise-bug-link', {

        template: '<div class="exercise-bug-link-box text-center">' +
                  '  <a href="#" @click.prevent="onClick" v-html="title"></a>' +
                  '</div>',

        props: {
            exerciseId: {
                type: Number,
                required: true
            },
            
            title: {
                type: String,
                default: '<i class="fa fa-envelope-o" aria-hidden="true"></i> Сообщить об ошибке'
//                default: 'сообщить об ошибке в упражнении'
            }
        },
            
        data: function() {
            return {
            };
        },
        
        methods: {
            onClick: function() {
                ks.app.$refs.bugDlg.show({
                    type       : ks.consts.BUG_TYPE_EXERCISE,
                    exerciseId : this.exerciseId
                });
            }
        }
        
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 11.12.2017
 * 
 * 04.08.2021:
 *   Если при неправильном ответе нужно что-то скрыть/показать, то нужно использовать классы 'invalid-answer-hide' и 'invalid-answer-show hidden' соответственно.
 *   При неправильном ответе у всех элементов с классом 'invalid-answer-show' удаляется класс 'hidden' 
 *   и всем элементам с классом 'invalid-answer-hide' добавляется класс 'hidden'
 */

(function() {

    Vue.component('exercise-standard', {

        template: '<div v-if="visible" ref="content" class="exercise-standard">' +
                
                    '<div class="exercise-standard-page exercise-standard-page-entry" v-if="isEntryPage">' +
                        '<div class="exercise-standard-page-text" v-html="entryText"></div>' +
                        '<div class="exercise-standard-page-btn-next-box">' + 
                            '<button @click="onNext" type="button" class="btn btn-blue exercise-standard-page-btn-next">Дальше</button>' +
                        '</div>' +
                    '</div>' +
                    
                    '<div class="exercise-standard-page exercise-standard-page-main" v-if="isMainPage">' +
                        '<div class="exercise-standard-page-text" v-html="text"></div>' +
                    '</div>' +   
                    
                  '</div>', 
        
        props: {
            isInvalidAnswerState: {
                type: Boolean,
                default: false
            }
        },

        data: function() {
          return {
              exercise: null,
              
              visible: false,
              
              currentPage: -1
          };
        },
        
        computed: {
            isEntryPage: function() {
                return this.currentPage === ks.consts.EXERCISE_PAGE_ENTRY;
            },
            
            isMainPage: function() {
                return this.currentPage === ks.consts.EXERCISE_PAGE_MAIN;
            },
            
            entryText: function() {
                if (this.exercise === null) {
                    return '';
                }
                
                return typeof this.exercise.extra !== 'undefined' && this.exercise.extra.enabled ? this.exercise.text : '';
            },
            
            text: function() {
                if (this.exercise === null) {
                    return '';
                }
                
                return typeof this.exercise.extra !== 'undefined' && this.exercise.extra.enabled ? 
                    this.exercise.extra.text :
                    this.exercise.text;        
            }
        },
        
        methods: {
            load: function(exercise) {
                this.exercise = exercise;
                
                this.currentPage = typeof this.exercise.extra !== 'undefined' && this.exercise.extra.enabled ?
                    ks.consts.EXERCISE_PAGE_ENTRY :
                    ks.consts.EXERCISE_PAGE_MAIN;
                
                this.visible = true;
            },
            
            unload: function() {
                this.visible = false;
                
                this.currentPage = -1;
                
                this.exercise = null;
            },
            
            onNext: function() {
                this.currentPage = ks.consts.EXERCISE_PAGE_MAIN;
            }
        },
        
        watch: {
            currentPage: function(newValue) {
                if (newValue === ks.consts.EXERCISE_PAGE_MAIN) {
                    this.$emit('show-main-page');
                }
                
                this.$store.commit('current/setExercisesCurrentPage', newValue);
            },
            
            isInvalidAnswerState: function(newValue){
                if (newValue) {
                    let showList = this.$refs.content.getElementsByClassName('invalid-answer-show');
                    for(let i = 0; i < showList.length; i++ ){
                        showList[i].classList.remove('hidden');
                    }
                    
                    let hideList = this.$refs.content.getElementsByClassName('invalid-answer-hide');
                    for(let i = 0; i < hideList.length; i++ ){
                        hideList[i].classList.add('hidden');
                    }
                }
            }
        }
        
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 15.11.2023
 */

(function() {

    Vue.component('finish-result', {
        
        template: 
            `<div class="finish-result-box">
                <div class="finish-result-title">
                    <div class="finish-result-title__text">{{ title }}</div>
                    <div class="finish-result-title__image"><img :src="image" alt="Результаты" /></div>
                </div>    
        
                <div class="finish-result-line">
                    <div class="finish-result-line__white"></div>
                    <div class="finish-result-line__color" :class="classLine" :style="styleLine">
                        <div class="finish-result-line__color__text">
                            <span>{{ correctAnswersCount }}</span> из <span>{{ countExercies }}</span>
                        </div>
                    </div>
                </div>
    
                <div class="finish-result-comment" :class="classComment" v-html="comment.text"></div>
        
                <div class="finish-result-trophy-list" v-if="hasTrophies">
                    <finish-result-trophy trophy="achievements" v-if="hasNewAchievements"></finish-result-trophy>
                    <finish-result-trophy trophy="awards" v-if="hasNewAwards"></finish-result-trophy> 
                    <finish-result-trophy trophy="diplomas" v-if="hasNewDiplomas"></finish-result-trophy>
                </div>
            </div>`,
        
        props: {
            title: {
                type: String,
                required: true
            },
            
            correctAnswersCount: {
                type: Number,
                required: true
            },
            
            countExercies: {
                type: Number,
                required: true
            },
            
            imagesCount: {
                type: Number,
                default: 7
            }
        },

        data: function() {
            return {
                marks: [
                    // 1
                    {
                        value: 1,
                        
                        range: {
                            min: 0,
                            max: 19
                        },
                        
                        comments: [
                            {
                                text  : 'Давай ещё позанимаемся!',
                                sound : 'lets_do_study_more.ogg'
                            }
                        ]
                                
                    },   
                    
                    // 2
                    {
                        value: 2,
                        
                        range: {
                            min: 20,
                            max: 49
                        },
                        
                        comments: [
                            {
                                text  : 'Ты делаешь успехи!',
                                sound : 'you_making_progress.ogg'
                            }
                        ]
                                
                    },
                    
                    // 3
                    {
                        value: 3,
                        
                        range: {
                            min: 50,
                            max: 74
                        },
                        
                        comments: [
                            {
                                text  : 'Хорошо!',
                                sound : 'good.ogg'
                            }
                        ]
                                
                    },  
                    
                    // 4
                    {
                        value: 4,
                        
                        range: {
                            min: 75,
                            max: 89
                        },
                        
                        comments: [
                            {
                                text  : 'Молодец!',
                                sound : 'well_done.ogg'
                            },
                            
                            {
                                text  : 'Замечательно!',
                                sound : 'amazing.ogg'
                            }
                        ]
                                
                    },
                    
                    // 5
                    {
                        value: 5,
                        
                        range: {
                            min: 90,
                            max: 100
                        },
                        
                        comments: [
                            {
                                text  : 'Превосходно!',
                                sound : 'perfect1.ogg'
                            },
                            
                            {
                                text  : 'Идеально!',
                                sound : 'perfect2.ogg'
                            }                            
                        ]
                                
                    }
                ],
                
                correctAnswersPercent: 0,
                
                markIndex: -1,
                markCommentIndex: -1,
                
                image: '',
                lastImageNum: -1,
                
                sound: ''
            };
        },
        
        computed: {
           hasNewAchievements: function() {
                if ( ! this.$store.getters.isKid) {
                    return false;
                }
                
                return this.$store.state.kid.hasNewAchievements;
            },     
            
            hasNewAwards: function() {
                if ( ! this.$store.getters.isKid) {
                    return false;
                }
                
                return this.$store.state.kid.hasNewAwards;                
            },
            
            hasNewDiplomas: function() {
                if ( ! this.$store.getters.isKid) {
                    return false;
                }
                
                return this.$store.state.kid.hasNewDiplomas;                
            },  
            
            hasTrophies: function() {
                return this.hasNewAchievements || this.hasNewAwards || this.hasNewDiplomas;
            },
            
            mark: function() {
                return this.markIndex < 0 ? -1 : this.marks[this.markIndex].value;
            },
            
            comment: function() {
                return this.markIndex > -1 && this.markCommentIndex > -1 ?
                    this.marks[this.markIndex].comments[this.markCommentIndex] : 
                    { text: '', sound: ''};
            },
            
            classComment: function() {
                return {
                    'crimson' : this.mark === 1,
                    'orange' : this.mark === 2 || this.mark === 3,
                    'blue'   : this.mark === 4,
                    'green'  : this.mark === 5,
                    
                    'shown'  : this.mark >= 1 && this.mark <= 5
                };
            },
            
            classLine: function() {
                let cls = {};
                
                if (this.mark > 0) {
                    cls['mark-' + this.mark] = true;
                }
                
                return cls;
            },
            
            styleLine: function() {
                let width = this.correctAnswersPercent;
                
                if (this.mark <= 0) {
                    width = 0; 
                } else {
                    if  (width < 30) {
                        width = 30;
                    }
                }
                
                return {
                    width   : width <= 0 ? '0px' : 'calc(' + width + '% - 4px)',
                    opacity : 1
                };
            }
        },
       
        methods: {
            show: function() {
                this.clear();
                this.image = '/public/images/exercises/finish/' + this.getImageNum() + '.png';
                
                setTimeout(() => {
                    this.correctAnswersPercent = this.countExercies <= 0 ? 0 : Math.round(100 * this.correctAnswersCount / this.countExercies);
                    if (this.correctAnswersPercent > 100) {
                        this.correctAnswersPercent = 100;
                    }
                    
                    this.fillMark();
                    
                    setTimeout(() => {
                        ks.soundManager.playEffect(this.commentSoundPath, {}, 0.9);
                    }, 1000);
                }, 100);
            },
            
            hide: function() {
                if (this.commentSoundPath !== '') {
                    ks.soundManager.stop(this.commentSoundPath);
                }
                
                this.clear();
            },
            
            clear: function() {
                this.correctAnswersPercent = 0;
                this.markIndex = -1;
                this.markCommentIndex = -1;
                this.commentSoundPath = '';
            },
            
            getImageNum: function() {
                if (this.imagesCount <= 0) {
                    return 0;
                }
                
                if (this.imagesCount === 1) {
                    return 1;
                }
                
                let num;
                do {
                   num = ks.helpers.math.getRandomInt(1, this.imagesCount);
                } while (num === this.lastImageNum);
                
                this.lastImageNum = num;
                
                return num;
            },
            
            fillMark: function() {
                this.markIndex = -1;
                this.markCommentIndex = -1;
                this.commentSoundPath = '';
                
                if (this.marks.length <= 0) {
                    return false;
                }
                
                let markIndex = -1;
                for (let i = 0; i < this.marks.length; i++) {
                    const mark = this.marks[i];
                    if (this.correctAnswersPercent >= mark.range.min && this.correctAnswersPercent <= mark.range.max) {
                        markIndex = i;
                        break;
                    }
                }
                
                if (markIndex < 0) {
                    return false;
                }
                
                this.markIndex = markIndex;
                
                const mark = this.marks[markIndex];
                if (mark.comments.length <= 0) {
                    return false;
                }
                
                this.markCommentIndex = ks.helpers.math.getRandomInt(0, mark.comments.length - 1);
                
                this.commentSoundPath = this.markCommentIndex > -1 ? 'public/sounds/finish/' + this.comment.sound : '';
                
                return true;
            }
        }        
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 15.11.2023
 */

(function() {

    Vue.component('finish-result-trophy', {
        
        template: 
            `<div class="finish-result-trophy-box">
                <a :href="url" target="_blank" class="finish-result-trophy">
                    <div class="finish-result-trophy__icon"><i class="fa" :class="classIcon"></i></div>
                    <div class="finish-result-trophy__text">{{ text }}</div>
                    <div class="clearfix"></div>
                </a>
            </div>`,
        
        props: {
            trophy: {
                type: String, // 'achievements' or 'awards' or 'diplomas'
                required: true
            }
        },

        data() {
            return {};
        },
        
        computed: {
            url() {
                let url;
                switch (this.trophy) {
                    case 'achievements':
                        url = '/progress/achievements';
                        break;
                        
                    case 'awards':
                        url = '/progress/awards';
                        break;
                        
                    case 'diplomas':
                        url = '/progress/diplomas';
                        break;
                        
                    default:
                        url = '';
                        break;
                }
                
                return url;
            },
            
            classIcon() {
                return {
                    'fa-star'   : this.trophy === 'achievements',
                    'fa-trophy' : this.trophy === 'awards',
                    'fa-bell'   : this.trophy === 'diplomas'
                };
            },
            
            text() {
                let text;
                switch (this.trophy) {
                    case 'achievements':
                        text = 'Новое достижение';
                        break;
                        
                    case 'awards':
                        text = 'Новая награда';
                        break;
                        
                    case 'diplomas':
                        text = 'Новый диплом';
                        break;
                        
                    default:
                        text = '';
                        break;
                }
                
                return text;                
            }
        }       
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 07.03.2018
 *
 * 23.03.2021:
 * + toggleMenu
 */

(function() {

    var Footer = {

        props: {
            canHideMenu: {
                type: Boolean
            }
        },

        data: function() {
            return {
                loaded: false,

                isShowMenu: false
            };
        },

        computed: {
            menuButtonIconClass: function() {
                return {
                    'fa-angle-double-down': ! this.isShowMenu,
                    'fa-angle-double-up': this.isShowMenu
                };
            },

            bottomBlockClass() {
              return {
                'hide-block': ! this.isShowMenu,
                'can-install-app' : this.canInstallApp
              };
            },

            canInstallApp() {
              return this.$store.getters.canInstallApp;
            }
        },

        methods: {
            toggleMenu() {
              this.isShowMenu = ! this.isShowMenu;
            },

            startInstallApp() {
              ks.app.startInstallApp();
            }
        },

        watch: {
        },

        mounted: function() {
            if ( ! this.canHideMenu) {
                this.isShowMenu = true;
            }

            this.loaded = true;
        }

    };

    ks.core.addComponent('footer-control', Footer);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 05.01.2018
 * 
 * Окно для предпросмотра изображения.
 * 
 */

(function() {

    var ImagePreviewDlg = {

        data: function() {
            return {
                // Заголовок окна
                title: '',
                // Ссылка на изображение
                imageSrc: '',
                // Прозрачность окна (style css opacity); по умолчанию 1.0
                opacity: 1.0
            };
        },

        methods: {
            show: function(data) {
                this.title = data.title || 'Просмотр изображения';
                this.imageSrc = data.imageSrc;
                this.opacity = data.opacity || 1.0;
               
                this.$dlg.modal('show');
            },

            hide: function() {
                this.$dlg.modal('hide');
            }
        },

        mounted: function() {
            this.$dlg = $('#image-preview-dlg');
        }

    };

    ks.core.addComponent('image-preview-dlg', ImagePreviewDlg);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 29.09.2021
 *
 */

(function() {
    
    const typePassword = 'password';
    const typeText     = 'text';

    Vue.component('input-password', {

        template: 
            '<div class="input-password-box" :class="renderBoxClass">'+
            '    <input @keyup.enter="onKeyUpEnter" ref="input" :type="type" class="form-control input-password-box__input" :class="renderInputClass" :id="id" :name="name" :maxlength="maxlength" :placeholder="placeholder" :value="text" @change="updateValue" @input="updateValue" :autocomplete="autocomplete">'+
            '    <div class="input-password-box__info-btn-box" :class="infoBtnBoxClass"><a tabindex="-1" href="#" @click.prevent="toggleType"><i class="fa fa-eye"></i></a></div>'+
            '</div>',

        model: {
            prop: 'text',
            event: 'input'
        }, 

        props: {
            text: {
                
            },
            
            /*value: {
                type: String
            }, */
            
            id: {
                type: String,
                default: ''
            },  
            
            name: {
                type: String,
                default: ''
            },
            
            placeholder: {
                type: String,
                default: ''
            },
            
            maxlength: {
                type: Number,
                default: 1000
            },
            
            inputClass: {
                type: String,
                default: ''
            },
            
            boxClass: {
                type: String,
                default: ''
            },
            
            btnBoxClass: {
                type: String,
                default: ''
            },
            
            autocomplete: {
                type: String,
                default: 'on'
            }
        },

        computed: {
            renderInputClass: function() {
                let cls = {},
                    arr = this.inputClass !== '' ? this.inputClass.split(' ') : [];

                for(let i = 0; i < arr.length; i++) {
                    cls[arr[i]] = true;
                }

                return cls;
            },
            
            renderBoxClass: function() {
                let cls = {},
                    arr = this.boxClass !== '' ? this.boxClass.split(' ') : [];

                for(let i = 0; i < arr.length; i++) {
                    cls[arr[i]] = true;
                }

                return cls;
            },     
            
            infoBtnBoxClass: function() {
                let cls = {'shown': this.type === 'text'},
                    arr = this.btnBoxClass !== '' ? this.btnBoxClass.split(' ') : [];

                for(let i = 0; i < arr.length; i++) {
                    cls[arr[i]] = true;
                }

                return cls;                
            }
        },

        data: function() {
            return {
                //oldValue: '',
                type: typePassword // 'password' or 'text'
            };
        },

        methods: {
            updateValue: function() {
                /*
                let val = this.$refs.input.value;
                if (this.oldValue !== val) {
                    this.$emit('input', val);
                    this.$emit('change', val);
                    
                    this.oldValue = val;
                }*/
                this.$emit('input', this.$refs.input.value);
            },
            
            toggleType: function() {
                this.type = this.type === typePassword ? typeText : typePassword;
            },
            
            onKeyUpEnter: function() {
                this.$emit('action');
            },
            
            // public
            resetType: function() {
                this.type = typePassword;
            },
            
            focus: function() {
                this.$refs.input.focus();
            }
        },

        mounted: function() {
            if (typeof this.value !== 'undefined') {
                this.$emit('input', this.value);
            }
            
            //this.oldValue = this.value;
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 01.11.2019
 *
 * Диалоговое окно завершения регистрации.
 * Заполняем имя и дату рождения родителя и данные ребёнка.
 *
 * +18.06.2021:
 * Убираем заполнение данных родителя. Оставляем только данные ребенка.
 *
 * 14.06.2023:
 * Изменение название компонента WizardNewAccount => KidDlg
 * +action - 'add' or 'update'
 *
 */

(function() {

    var KidDlg = {

        data: function() {
            return {
                title: '',
                buttonTitle: '',

                action: '',

                kid: {
                    id: 0,
                    name: '',
                    birthday: '',
                    gender: 0
                },

                error: ''
            };
        },

        computed: {
            hasError: function() {
                return this.error !== '';
            }
        },

        methods: {
            show: function(options) {
                options = options || {};

                this.title = options.title || 'Завершение регистрации';
                this.buttonTitle = options.buttonTitle || 'Начать заниматься';
                this.action = options.action || 'add';

                if (this.action === 'update') {
                    this.kid.id = options.kidId;
                }

                this.$dlg.modal('show');
            },

            hide: function() {
                this.$dlg.modal('hide');
            },

            doAction: function(){
                if ( ! this.validateKidPage()) {
                    return;
                }

                switch (this.action) {
                    case 'add':
                        this.addKid();
                        break;

                    case 'update':
                        this.updateKid();
                        break;

                    default:
                        this.hide();
                        break;
                }

            },

            addKid: function() {
                ks.vk.Goal('complete_registration');

                ks.client.request({
                    controller: 'parent',
                    action: 'profile-kids/add-kid',
                    data: {
                        kid: {
                            name     : this.kid.name === '' ? 'Ребёнок' : this.kid.name,
                            birthday : this.kid.birthday,
                            gender   : this.kid.gender
                        }
                    },
                    onRequest: this.onAddKid
                }, false);
            },

            onAddKid: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.error = data && data.errors && data.errors.name ? data.errors.name : 'Что-то пошло не так. Пожалуйста, попробуйте ещё раз.';

                    return;
                }

                this.hide();

                window.location.href = data.exercisesUrl;
            },

            updateKid: function() {
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-kids/update-kid',
                    data: {
                        kid: {
                            id       : this.kid.id,
                            name     : this.kid.name === '' ? 'Ребёнок' : this.kid.name,
                            birthday : this.kid.birthday,
                            gender   : this.kid.gender
                        }
                    },
                    onRequest: this.onUpdateKid
                }, false);
            },

            onUpdateKid: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.error = 'Что-то пошло не так. Пожалуйста, попробуйте ещё раз.';

                    return;
                }

                this.hide();

                window.location.href = data.exercisesUrl;
            },

            validateKidPage: function() {
                if (this.kid.birthday === '') {
                    this.error = 'Пожалуйста, укажите день рождения ребёнка.';
                    return false;
                }

                var maxDate = moment().add(-1, 'months'),
                    birthday = moment(this.kid.birthday, 'DD.MM.YYYY');

                if (birthday > maxDate) {
                    this.error = 'Пожалуйста, укажите корректную дату рождения ребёнка.';
                    return false;
                }

                return true;
            }
        },

        watch: {
            'kid.birthday': function() {
                this.error = '';
            }
        },

        mounted: function() {
            this.$dlg = $('#kid-dlg');
        }
    };

    ks.core.addComponent('kid-dlg', KidDlg);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 22.09.2017
 */

(function() {

    var Loader = {

        data: function() {
            return {
                isShow: false
            };
        },

        methods: {
            show: function() {
                this.isShow = true;
            },

            hide: function() {
                this.isShow = false;
            }
        },

        watch: {
            isShow: function() {
                var body = $('body');

                if (this.isShow) {
                    body.addClass('loader-visible');
                } else {
                    body.removeClass('loader-visible');
                }
            }
        }

    };

    ks.core.addComponent('loader', Loader);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 26.09.2017
 *
 * 12.06.2023:
 * +hideSignup
 */

(function() {

    var LoginDlg = {

        props: {
            defaultEmail: {
                type: String,
                default: ''
            }
        },

        data: function() {
            return {
                forgotPasswordMode: false,

                login: {
                    email: {
                        value: '',
                        error: ''
                    },

                    password: {
                        value: '',
                        error: ''
                    }
                },

                forgotPassword: {
                    email: {
                        value: '',
                        error: ''
                    }
                },

                globalErrorText: '',

                reload: false,

                signupMode: 'page', // 'page' or 'dialog'

                orderPage: false,

                /**
                 * Спрятать ссылку регистрации
                 */
                hideSignup: false

            };
        },

        computed: {
            title: function() {
                return this.forgotPasswordMode ? 'Восстановление пароля' : 'Вход';
            },

            titleClass: function() {
                return {
                    'blue'  : this.forgotPasswordMode,
                    'green' : !this.forgotPasswordMode
                };
            },

            dlgClass: function() {
                return {
                    'dlg-info'    : this.forgotPasswordMode,
                    'dlg-success' : !this.forgotPasswordMode
                };
            },

            loginEmailHasError: function() {
                return this.login.email.error !== '';
            },

            loginPasswordHasError: function() {
                return this.login.password.error !== '';
            },

            forgotPasswordEmailHasError: function() {
                return this.forgotPassword.email.error !== '';
            },

            buttonTitle: function() {
                return this.forgotPasswordMode ? 'Восстановить пароль' : 'Войти';
            },

            buttonClass: function() {
                return {
                    'btn-green' : !this.forgotPasswordMode,
                    'btn-blue'  : this.forgotPasswordMode,
                    'btn-wide'  : !this.forgotPasswordMode
                };
            }
        },

        methods: {
            showLogin: function(options) {
                options = options || {};

                const email      = options.email,
                      password   = options.password,
                      errors     = options.errors,
                      reload     = options.reload,
                      signupMode = options.signupMode;

                this.hideSignup = typeof options.hideSignup !== 'undefined' ? options.hideSignup : false;
                this.orderPage = typeof options.orderPage !== 'undefined' ? options.orderPage : false;

                var self = this;

                this.forgotPasswordMode = false;

                this.login.email.value = email || this.defaultEmail;
                this.login.password.value = password || '';

                if (this.$refs.loginPassword && this.$refs.loginPassword.resetType) {
                  this.$refs.loginPassword.resetType();
                }

                this.globalErrorText = '';

                this.reload = reload || false;

                this.signupMode = signupMode || 'page';

                // Выполняем заполнение ошибок при следующем цикле обновления DOM,
                // т.к. заполнение значений выше (например, this.login.email.value = email;) в watch очистит ошибки.
                this.$nextTick(function () {
                    if (errors) {
                        for (var name in errors) {
                            if (name === 'email' || name === 'password') {
                                self.login[name].error = errors[name];
                            }
                            else if (name === 'global') {
                                self.globalErrorText = errors[name];
                            }
                        }
                    } else {
                        self.login.email.error = '';
                        self.login.password.error = '';
                    }
                });

                this.$dlg.modal('show');
            },

            showForgotPassword: function(email, password) {
                this.forgotPasswordMode = true;

                this.login.email.value = email;
                this.login.email.error = '';
                this.login.password.value = password;
                this.login.password.error = '';

                this.forgotPassword.email.value = email;
                this.forgotPassword.email.error = '';

                this.globalErrorText = '';

                this.$dlg.modal('show');
            },

            hide: function() {
                this.$dlg.modal('hide');
            },

            setAutoFocus: function() {
                if ( ! this.forgotPasswordMode) {
                    if (this.login.email.value !== '') {
                        this.$refs.loginPassword.focus();
                    } else {
                        this.$refs.loginEmail.focus();
                    }
                }
                else {
                    this.$refs.forgotPasswordEmail.focus();
                }
            },

            onSignupClick: function(){
                switch (this.signupMode) {
                    case 'page':
                        window.location.href = 'signup';
                        break;

                    case 'dialog':
                        this.hide();
                        ks.app.showSignup();
                        break;
                }
            },

            onLoginClick: function() {
                this.globalErrorText = '';
                this.forgotPasswordMode = false;
                this.$nextTick(function() {
                    this.setAutoFocus();
                });
            },

            onForgotPasswordClick: function() {
                this.globalErrorText = '';
                this.forgotPassword.email.value = this.login.email.value;
                this.forgotPassword.email.error = '';
                this.forgotPasswordMode = true;
                this.$nextTick(function() {
                    this.setAutoFocus();
                });
            },

            onButtonClick: function() {
                if (this.forgotPasswordMode) {
                    this.actionForgotPassword();
                }
                else {
                    this.actionLogin();
                }
            },

            actionForgotPassword: function() {
                this.globalErrorText = '';

                if (this.validateForgotPasswordFields()) {
                    ks.client.request({
                        controller: 'parent',
                        action: 'forgot-password',
                        data: {
                            email: this.forgotPassword.email.value
                        },
                        onRequest: this.onRequestForgotPassword
                    });
                }
            },

            actionLogin: function() {
                this.globalErrorText = '';

                if (this.validateLoginFields()) {
                    ks.client.request({
                        controller: 'parent',
                        action: 'login',
                        data: {
                            email: this.login.email.value,
                            password: this.login.password.value,
                            reload: this.reload
                        },
                        onRequest: this.onRequestLogin
                    });
                }
            },

            validateLoginFields: function() {
                return this.validateLoginEmail() & this.validateLoginPassword();
            },

            validateLoginEmail: function() {
                if (this.login.email.value === '') {
                    this.login.email.error = 'Пожалуйста, укажите ваш email.';
                    return false;
                }

                if ( ! ks.validator.validateEmail(this.login.email.value)) {
                    this.login.email.error = 'Пожалуйста, укажите корректный email.';
                    return false;
                }

                this.login.email.error = '';

                return true;
            },

            validateLoginPassword: function() {
                if (this.login.password.value === '') {
                    this.login.password.error = 'Пожалуйста, укажите пароль.';
                    return false;
                }

                if (this.login.password.value.length > 32) {
                    this.login.password.error = 'Длина пароля не может быть больше 32 символов.';
                    return false;
                }

                this.login.password.error = '';

                return true;
            },

            validateForgotPasswordFields: function() {
                return this.validateForgotPasswordEmail();
            },

            validateForgotPasswordEmail: function() {
                if (this.forgotPassword.email.value === '') {
                    this.forgotPassword.email.error = 'Пожалуйста, укажите ваш email.';
                    return false;
                }

                if ( ! ks.validator.validateEmail(this.forgotPassword.email.value)) {
                    this.forgotPassword.email.error = 'Пожалуйста, укажите корректный email.';
                    return false;
                }

                this.forgotPassword.email.error = '';

                return true;
            },

            onRequestLogin: function(errorCode, data) {
                if (data.redirect) {
                    return;
                }

                if (data.errors) {
                    for (var field in data.errors) {
                        if (field in this.login) {
                            this.login[field].error = data.errors[field];
                        }
                    }

                    if (data.errors.global) {
                        this.globalErrorText = data.errors.global;
                    }
                }
            },

            onRequestForgotPassword: function(errorCode, data) {
                if (data.errors) {
                    for (var field in data.errors) {
                        if (field in this.forgotPassword) {
                            this.forgotPassword[field].error = data.errors[field];
                        }
                    }

                    if (data.errors.global) {
                        this.globalErrorText = data.errors.global;
                    }
                }
                else {
                    this.hide();

                    ks.app.$refs.messageBox.show({
                        type    : ks.consts.MBT_INFO,
                        title   : 'Сброс пароля',
                        text    : data.text,
                        buttons : ks.consts.MBB_OK
                    });
                }
            }
        },

        watch: {
            'login.email.value': function() {
                if (this.login.email.value !== '') {
                    this.login.email.error = '';
                }
            },

            'login.password.value': function() {
                if (this.login.password.value !== '') {
                    this.login.password.error = '';
                }
            },

            'forgotPassword.email.value': function() {
                if (this.forgotPassword.email.value !== '') {
                    this.forgotPassword.email.error = '';
                }
            }
        },

        mounted: function() {
            var self = this;

            this.$dlg = $('#login-dlg');

            this.$dlg.on('shown.bs.modal', function(e) {
                self.setAutoFocus();
            });
        }

    };

    ks.core.addComponent('login-dlg', LoginDlg);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 24.09.2017
 *
 * 25.10.2017:
 * +buttons
 * 
 * 14.06.2023:
 * +maxWidth
 */

(function() {

    var MessageBox = {

        data: function() {
            return {
                type: 0,
                title: '',
                text: '',

                button1: {
                    title: '',
                    visible: true,
                    value: -1
                },

                button2: {
                    title: '',
                    visible: false,
                    value: -1
                },
                
                maxWidth: '', // '500px' or '30%' or other

                onClose: null,

                userData: null,

                modalResult: -1
            };
        },

        computed: {
            dialogClass: function() {
                return {
                    'dlg-info'    : this.type === ks.consts.MBT_INFO || this.type === ks.consts.MBT_QUESTION,
                    'dlg-warning' : this.type === ks.consts.MBT_WARNING,
                    'dlg-error'   : this.type === ks.consts.MBT_ERROR,
                    'dlg-success' : this.type === ks.consts.MBT_SUCCESS
                };
            },
            
            dialogStyle: function() {
                var style = {};
                
                if (this.maxWidth !== '') {
                    style['max-width'] = this.maxWidth;
                }
                
                return style;
            },

            iconClass: function() {
                return {
                    'fa-exclamation-triangle' : this.type === ks.consts.MBT_ERROR || this.type === ks.consts.MBT_WARNING,
                    'fa-exclamation-circle'   : this.type === ks.consts.MBT_INFO,
                    'fa-question-circle'      : this.type === ks.consts.MBT_QUESTION
                };
            },

            titleClass: function() {
                return {
                    'blue'   : this.type === ks.consts.MBT_INFO || this.type === ks.consts.MBT_QUESTION,
                    'orange' : this.type === ks.consts.MBT_WARNING,
                    'red'    : this.type === ks.consts.MBT_ERROR,
                    'green'  : this.type === ks.consts.MBT_SUCCESS
                };
            }
        },

        methods: {
            show: function(options) {
                this.type = options.type || ks.consts.MBT_INFO;
                this.title = options.title || '';
                this.text = options.text || '';
                this.maxWidth = options.maxWidth || '';
                this.onClose = options.onClose || null;
                this.userData = options.userData || null;

                this.applyButtons(options.buttons || ks.consts.MBB_CANCEL);

                this.modalResult = -1;

                this.$dlg.modal('show');
            },

            hide: function() {
                this.$dlg.modal('hide');
            },

            applyButtons: function(buttons) {
                switch (buttons) {
                    case ks.consts.MBB_CANCEL:
                        this.button2.visible = false;

                        this.button1.title = 'Отмена';
                        this.button1.value = ks.consts.MBB_CANCEL;

                        break;

                    case ks.consts.MBB_OK:
                        this.button2.visible = false;

                        this.button1.title = 'OK';
                        this.button1.value = ks.consts.MBB_OK;

                        break;

                    case ks.consts.MBB_CLOSE:
                        this.button2.visible = false;

                        this.button1.title = 'Закрыть';
                        this.button1.value = ks.consts.MBB_CLOSE;

                        break;

                    case ks.consts.MBB_YES_NO:
                        this.button2.visible = true;
                        this.button2.title = 'Да';
                        this.button2.value = ks.consts.MBB_YES;

                        this.button1.title = 'Нет';
                        this.button1.value = ks.consts.MBB_NO;

                        break;
                }
            },

            onCloseEvent: function(){
                if (this.onClose !== null) {
                    this.onClose(this.modalResult, this.userData);
                }
            }
        },

        watch: {

        },

        mounted: function() {
            var self = this;

            this.$dlg = $('#message-box');

            this.$dlg.on('hidden.bs.modal', function () {
                self.onCloseEvent();
            });
        }

    };

    ks.core.addComponent('message-box', MessageBox);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 10.08.2021
 * 
 * Предложение пройти пробную тренировку
 * 
 */

(function() {
    
    const JUMP_INTERVAL      = 4000; // msec
    const ANIMATION_INTERVAL = 2000; // msec
    
    const HIDE_TRIAL_TRAINING = 'hTrlTrg';

    Vue.component('offer-trial-training', {

        template: 
            '<div v-if="enabled" class="offer-trial-training" :class="classContainer" @mouseover="isHover = true" @mouseleave="isHover = false">' +
                '<img class="offer-trial-training__img" src="/public/images/trainings/trial/rabbit_160_250.png" />' +
                '<div class="offer-trial-training__info">'+
                    '<div class="offer-trial-training__info__close-box"><a @click.prevent="close" href="#"><i class="fa fa-close"></i></a></div>'+
                    '<div class="offer-trial-training__info__title" v-html="title"></div>'+
                    '<div class="offer-trial-training__info__text" v-html="text"></div>'+
                    '<div class="offer-trial-training__info__btn-box"><a @click.prevent="start" href="#" class="btn btn-green">{{ buttonText }}</a></div>'+
                '</div>' +
            '</div>',
    
        props: {
            title: {
                type: String,
                required: true
            },
            
            text: {
                type: String,
                required: true
            },
            
            buttonText: {
                type: String,
                required: true
            },
            
            targetUrl: {
                type: String,
                required: true
            },
            
            enabled: {
                type: Boolean,
                required: true
            }
        }, 

        data: function() {
            return {
                isShow  : false,
                isJump  : false,
                isHover : false,
                
                jumpTimer : null,
                jumpStopTime : 0,
                currentTime  : 0,
                
                hidden: false,
                
                wheelFortuneNotifyShown: false
            };
        },
        
        computed: {
            classContainer: function(){
                let isShowWFNotifyNow = this.$store.state.wheelFortuneNotifyShown;
                
                return {
                    'shown'     : this.isShow,
                    'jump'      : this.isJump && ! this.isHover,
                    'hidden-xs' : this.wheelFortuneNotifyShown || isShowWFNotifyNow,
                    'hidden-sm' : this.wheelFortuneNotifyShown || isShowWFNotifyNow
                };
            },
            
            canJump: function(){
                let interval = this.currentTime - this.jumpStopTime;
                return ! this.isHover && interval >= JUMP_INTERVAL;
            }
        },
        
        methods: {
            show: function() {
                if ( ! this.enabled || this.hidden) {
                    return false;
                }
                
                this.currentTime = this.getCurrentTime();
                
                this.isJump = false;
                this.isHover = false;
                
                this.isShow = true;
                
                this.setJumpTimer();
                
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_TRIAL_TRAINING_OFFER);
                
                return true;
            },
            
            hide: function() {
                if (this.jumpTimer !== null) {
                    clearInterval(this.jumpTimer);
                    this.jumpTimer = null;
                }
                this.isJump = false;
                this.isShow = false;
            },
            
            setJumpTimer: function(){
                if (ks.browser.isTouch()) {
                    return false;
                }
                
                let self = this;
                this.jumpTimer = setInterval(function(){
                    self.currentTime = self.getCurrentTime();
                    
                    if (self.canJump) {
                        self.isJump = true;
                        setTimeout(function(){
                            self.stopJump();
                        }, ANIMATION_INTERVAL);
                    }
                }, JUMP_INTERVAL);
                
                return true;
            },
            
            stopJump: function(){
                this.jumpStopTime = this.getCurrentTime();
                this.isJump = false;
            },
            
            getCurrentTime: function(){
                let d = new Date();
                return d.getTime();
            },
            
            start: function(){
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_TRIAL_TRAINING_START);
                
                window.location.href = this.targetUrl;
            },
            
            close: function(){
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_TRIAL_TRAINING_CLOSE);
                
                this.hidden = true;
                ks.Storage.setItem(ks.consts.STORAGE_TYPE_LOCAL, HIDE_TRIAL_TRAINING, 1, false);
                
                this.hide();
            }
        },
        
        watch: {
            isHover: function(newValue){
                if (newValue) {
                    this.stopJump();
                }
            }
        },
        
        mounted: function(){
            let i = parseInt(ks.Storage.getItem(ks.consts.STORAGE_TYPE_LOCAL, HIDE_TRIAL_TRAINING, false, false), 10);
            this.hidden = i === 1;
            
            this.wheelFortuneNotifyShown = this.$store.state.wheelFortuneNotifyShown;
        }
    });

}());
/**
 * (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 28.10.2017
 *
 */

(function() {

    var ParentPassword = {

        data: function() {
            return {
                user: {
                    role: -1,
                    id: -1
                },

                password: {
                    value: '',
                    error: ''
                }
            };
        },

        computed: {
        },

        methods: {
            show: function(options) {
                this.user.role = options.role || -1;
                this.user.id = options.id || -1;

                this.$dlg.modal('show');
            },

            hide: function() {
                this.$dlg.modal('hide');
            },

            validateFields: function() {
                return this.validatePassword();
            },

            validatePassword: function() {
                if (this.password.value === '') {
                    this.password.error = 'Пожалуйста, укажите пароль для смены пользователя.';
                    return false;
                }

                this.password.error = '';

                return true;
            },

            enterPassword: function() {
                if (this.validateFields()) {
                    ks.client.request({
                        controller: 'account',
                        action: 'switch-user/login',
                        data: {
                            user: this.user,
                            password: this.password.value
                        },
                        onRequest: this.onSwitchUser
                    });
                }
            },

            onSwitchUser: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.password.error = data.errors.global;

                    this.$refs.input.focus();

                    return;
                }
            },

            forgotPassword: function() {
                ks.app.$refs.messageBox.show({
                    type: ks.consts.MBT_QUESTION,
                    title: 'Родительский пароль',
                    text: 'Если вы забыли родительский пароль, то мы можем выслать его вам на почту.<br />'+
                          'Выслать родительский пароль на почту, указанную при регистрации?',
                    buttons: ks.consts.MBB_YES_NO,
                    onClose: this.onConfirmForgotPassword
                });
            },

            onConfirmForgotPassword: function(modalResult) {
                if (modalResult !== ks.consts.MBB_YES) return;

                ks.client.request({
                    controller: 'parent',
                    action: 'parent-password/forgot-password',
                    onRequest: this.onSendPassword
                });
            },

            onSendPassword: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }

                ks.app.$refs.messageBox.show({
                    type: ks.consts.MBT_INFO,
                    title: 'Родительский пароль',
                    text: data.text,
                    buttons: ks.consts.MBB_OK
                });
            }

        },

        watch: {
            'password.value': function(val) {
                this.password.error = '';
            }
        },

        mounted: function() {
            var self = this,
                body = $('body');

            this.$dlg = $('#parent-password');

            this.$dlg.on('hidden.bs.modal', function () {
                self.password.value = '';
                self.password.error = '';
               
                body.removeClass('modal-visible');
            });

            this.$dlg.on('shown.bs.modal', function() {
                self.$refs.input.focus();
                
                body.addClass('modal-visible');
            });
        }

    };

    ks.core.addComponent('parent-password', ParentPassword);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 26.10.2017
 */

(function() {

    Vue.component('radio', {

        template: '<div class="radio radio-blue" :class="renderClass">' +
                      '<input ref="input" type="radio" :name="name" :id="cmpId" :value="value" @change="onChange">' +
                      '<label :for="cmpId" class="checkbox-text">' +
                          '<div v-html="title"></div>' +
                      '</label>' +
                  '</div>',

        model: {
            prop: 'model',
            event: 'change'
        },

        props: {
            model: null,
            
            name: {
                type: String,
                required: true
            },
            
            value: {
                type: String,
                default: ''
            },
            
            id: {
                type: String,
                default: ''
            },
            
            title: {
                type: String,
                default: ''
            },
            
            extraClass: {
                type: String,
                default: ''
            }
        },

        computed: {
            renderClass: function() {
                var cls = {},
                    arr = this.extraClass !== '' ? this.extraClass.split(' ') : [];

                for(var i = 0; i < arr.length; i++) {
                    cls[arr[i]] = true;
                }

                return cls;
            },
            
            cmpId: function(){
                return this.id === '' ? ks.helpers.html.getUniqueId() : this.id;
            }
        },

        data: function() {
            return {};
        },

        watch: {
            model: function(val) {
                this.$refs.input.checked = this.isSelected();
            }
        },

        methods: {
            onChange: function(e) {
                this.$emit('change', e.target.value);
            },

            isSelected: function() {
                var val = typeof this.model === 'number' ? Number(this.value) : this.value;

                return val === this.model;
            }
        },

        mounted: function() {
            this.$refs.input.checked = this.isSelected();
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 20.02.2018
 */

(function() {

    Vue.component('bs-select', {

        template: '<select :id="cmpId" class="form-control bs-select" :title="title" :class="getClass">'+
                  '  <option'+
                  '    v-for="(option, index) in options"'+
                  '    :key="index"'+
                  '    :value="option.value"'+
                  '    :selected="option.selected"'+
                  '    :data-divider="isDivider(option)">'+
                  '    {{ option.title }}'+
                  '  </option>'+
                  '</select>',

        props: {
            options: {
                type: Array,
                default: function() {
                    return [];
                }
            },
            
            additionalClass: {
                type: String,
                default: ''
            },
            
            id: {
                type: String,
                default: ''
            },
            
            showTick: {
                type: Boolean,
                default: false
            },
            
            liveSearch: {
                type: Boolean,
                default: false
            },
            
            size: {
                type: String,
                default: 'auto'
            },
            
            title: {
                type: String,
                default: ''
            }
        },
        
        data: function() {
            return {
            };
        },

        computed: {
            getClass: function() {
                var classes = this.additionalClass.trim().split(' '),
                    cls = {};
            
                for (var i = 0; i < classes.length; i++) {
                    var clsName = classes[i].trim();
                    
                    if (clsName === '') {
                        continue;
                    }
                        
                    cls[clsName] = true;
                }
                
                return cls;
            },
            
            cmpId: function(){
                return this.id !== '' ? this.id : ks.helpers.html.getUniqueId();
            }
        },

        methods: {
            getOptionByValue: function(value) {
                for (var i = 0; i < this.options.length; i++) {                    
                    if (this.options[i].value.toString() === value) {
                        return this.options[i];
                    }
                }
                
                return null;
            },
            
            selectOption: function(value) {
                $(this.$el).selectpicker('val', value);
            },
            
            isDivider: function(option) {
                return typeof option.divider !== 'undefined' && option.divider === true;
            }
        },
        
        mounted: function() {
            var self = this;
            
            $(this.$el).selectpicker({
                
                showTick: this.showTick,
                liveSearch: this.liveSearch,
                //mobile: ks.browser.isMobile.any() // TODO: not work on mobile
                size: this.size
                
            }).on('changed.bs.select', function() {
                self.$emit('select-change', self.getOptionByValue($(self.$el).val()));
            });
        },
        
        updated: function() {
            $(this.$el).selectpicker('refresh');
        },
        
        destroyed: function () {
            $(this.$el).selectpicker('destroy');
        }        

    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 10.10.2017
 */

(function() {

    var SelectAvatar = {

        data: function() {
            return {
                selectedId: -1,
                role: -1,
                avatars: [],
                onSelectAvatar: null,

                userData: null,
                
                headerHeight: 80 // px
            };
        },

        computed: {
            roleFolder: function() {
                return this.role === ks.consts.ROLE_PARENT ? 'parents' : 'kids';
            },

            avatarFolder: function() {
                return '/public/images/avatars/' + this.roleFolder + '/standard/';
            },
            
            maxHeight: function() {
                return this.$store.state.window.size.height - 10;
            },
            
            modalStyle: function() {
                return {
                    'max-height': this.maxHeight + 'px'
                };
            },
            
            bodyStyle: function() {
                var maxHeight = this.maxHeight - this.headerHeight - 10;
                
                return {
                    'max-height':  maxHeight + 'px'
                };
            }
        },

        methods: {
            show: function(role, selectedId, onSelectAvatar, userData) {
                var needLoad = this.role !== role || this.avatars.length === 0;
                
                this.role = role;
                this.selectedId = parseInt(selectedId, 10);
                this.onSelectAvatar = onSelectAvatar;

                this.userData = typeof userData === 'undefined' ? null : userData;

                if (needLoad) {
                    this.load();
                } else {
                    this.$dlg.modal('show');
                }
            },

            hide: function() {
                this.$dlg.modal('hide');
            },

            load: function() {
                ks.client.request({
                    controller: 'parent',
                    action: 'profile/get-avatars',
                    data: {
                        role: this.role
                    },
                    onRequest: this.onLoad
                });
            },

            onLoad: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {

                    ks.app.$refs.messageBox.show({
                        type    : ks.consts.MBT_ERROR,
                        title   : 'Ошибка',
                        text    : data.errors.global,
                        buttons : ks.consts.MBB_CLOSE
                    });

                    return;
                }

                this.avatars = data.avatars;

                this.$dlg.modal('show');
            },

            getAvatarSrc: function(avatar) {
                return this.avatarFolder + avatar + '_' + ks.consts.AVATAR_SIZE_BIG + '.png';
            },

            onSelect: function(avatar) {
                if (this.selectedId === avatar) return;

                if (this.onSelectAvatar !== null) {
                    this.onSelectAvatar(avatar, this.avatarFolder + avatar, this.userData);
                }

                this.hide();
            }

        },

        mounted: function() {
            this.$dlg = $('#select-avatar');
            
            var self = this;
            this.$dlg.on('shown.bs.modal', function (){
                self.headerHeight = self.$refs.header.offsetHeight;
            });
        }

    };

    ks.core.addComponent('select-avatar', SelectAvatar);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 23.11.2017
 */

(function() {

    var SelectGroup = {

        data: function () {
            return {
                title: '',
                
                selectedId: -1,
                groups: [],
                onSelectGroup: null,

                allowGroups: [],
                
                headerHeight: 80 // px
            };
        },
        
        computed: {
            maxHeight: function() {
                return this.$store.state.window.size.height - 10;
            },
            
            modalStyle: function() {
                return {
                    'max-height': this.maxHeight + 'px'
                };
            },
            
            bodyStyle: function() {
                var maxHeight = this.maxHeight - this.headerHeight - 10;
                
                return {
                    'max-height':  maxHeight + 'px'
                };
            },
            
            visibleGroups() {
                const groups = [];

                for (const group of this.groups) {
                    if (this.allowGroups.length > 0 && this.allowGroups.indexOf(group.id) < 0) {
                        continue;
                    }
    
                    if (group.id === this.selectedId) {
                        continue;
                    }            
                    
                    groups.push(group);
                }

                return groups;
            }
        },

        methods: {
            /**
             * 
             * @param {number} selectedId 
             * @param {function} onSelectGroup 
             * @param {string|undefined} title 
             * @param {number[]} allowGroups 
             */
            show: function(selectedId, onSelectGroup, title, allowGroups) {
                this.title = typeof title !== 'undefined' ? title : 'Выбор возрастной группы';
                
                this.selectedId = parseInt(selectedId, 10);
                this.onSelectGroup = onSelectGroup;

                this.allowGroups = typeof allowGroups !== 'undefined' ? allowGroups : [];

                if (this.groups.length === 0) {
                    this.load();
                } else {
                    this.$dlg.modal('show');
                }
            },

            hide: function() {
                this.$dlg.modal('hide');
            },

            load: function() {
                ks.client.request({
                    controller: 'group',
                    action: 'get/items',
                    onRequest: this.onLoad
                });
            },

            onLoad: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {

                    ks.app.$refs.messageBox.show({
                        type    : ks.consts.MBT_ERROR,
                        title   : 'Ошибка',
                        text    : data.errors.global,
                        buttons : ks.consts.MBB_CLOSE
                    });

                    return;
                }

                this.groups = data.groups;

                this.$dlg.modal('show');
            },

            onSelect: function(group) {
                if (this.selectedId === group.id) return;

                if (this.onSelectGroup !== null) {
                    this.onSelectGroup(group);
                }

                this.hide();
            },
            
            getGroupClass: function(index) {
                const count = this.visibleGroups.length;
                const divRem3 = count % 3;
                const divRem2 = count % 2;

                const smOffset4 = divRem3 === 1 && index === count - 1;
                const smOffset2 = divRem3 === 2 && index === count - 2;
                const smOffset = smOffset4 || smOffset2;

                const xsOffset3 = divRem2 === 1 && index === count - 1;

                return { 
                    'col-sm-offset-4': smOffset4, 
                    'col-sm-offset-2': smOffset2,

                    'col-sm-offset-0': ! smOffset,
                    'col-xs-offset-3': xsOffset3, 
                };
            },
            
            getGroupBoxClass: function(group) {
                let cls = {
                        selected: group.id === this.selectedId
                    };
            
                cls['color-scheme-' + group.color_scheme] = true; 
                
                return cls;
            },
            
            getImage: function(group, webp) {
                let image = group.image;
                
                if (image === '') {
                    return '';
                }                
                
                return !webp ? image : image.substr(0, image.lastIndexOf('.')) + '.webp';
            }
        },

        mounted: function() {
            this.$dlg = $('#select-group');
            
            var self = this;
            this.$dlg.on('shown.bs.modal', function (){
                self.headerHeight = self.$refs.header.offsetHeight;
            });
        }
    };

    ks.core.addComponent('select-group', SelectGroup);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 15.02.2018
 */

(function() {

    var SelectImage = {

        data: function() {
            return {
                title: '',
                
                folder: null,
                selectedImage: null,
                images: [],
                onSelectImage: null,

                userData: null,
                
                headerHeight: 80 // px
            };
        },

        computed: {
            maxHeight: function() {
                return this.$store.state.window.size.height - 10;
            },
            
            modalStyle: function() {
                return {
                    'max-height': this.maxHeight + 'px'
                };
            },
            
            bodyStyle: function() {
                var maxHeight = this.maxHeight - this.headerHeight - 10;
                
                return {
                    'max-height':  maxHeight + 'px'
                };
            }             
        },

        methods: {
            show: function(title, folder, selectedImage, onSelectImage, userData) {
                var needLoad = this.folder !== folder || this.images.length === 0;
                
                this.title = title;
                this.folder = folder;
                this.selectedImage = selectedImage;
                this.onSelectImage = onSelectImage;

                this.userData = typeof userData === 'undefined' ? null : userData;

                if (needLoad) {
                    this.load();
                } else {
                    this.$dlg.modal('show');
                }
            },

            hide: function() {
                this.$dlg.modal('hide');
            },

            load: function() {
                ks.client.request({
                    controller: 'parent',
                    action: 'profile/get-images',
                    data: {
                        folder: this.folder
                    },
                    onRequest: this.onLoad
                });
            },

            onLoad: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {

                    ks.app.$refs.messageBox.show({
                        type    : ks.consts.MBT_ERROR,
                        title   : 'Ошибка',
                        text    : data.errors.global,
                        buttons : ks.consts.MBB_CLOSE
                    });

                    return;
                }

                this.images = [];
                        
                for (var i = 0; i < data.images.length; i++){
                    this.images.push('/public/images/' + this.folder + '/' + data.images[i]);
                }

                this.$dlg.modal('show');
            },

            onSelect: function(image) {
                if (this.selectedImage === image) return;

                if (this.onSelectImage !== null) {
                    this.onSelectImage(image, this.userData);
                }

                this.hide();
            }

        },

        mounted: function() {
            this.$dlg = $('#select-image');
            
            var self = this;
            this.$dlg.on('shown.bs.modal', function (){
                self.headerHeight = self.$refs.header.offsetHeight;
            });
        }

    };

    ks.core.addComponent('select-image', SelectImage);

}());
/**
 * (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 17.03.2018
 *
 */

(function() {

    var SelectKid = {
        
        data: function() {
            return {
                title: '',
                
                kids: [],
                selectedIndex: -1,
                
                onSelect: null,
                
                headerHeight: 80 // px
            };
        },

        computed: {
            maxHeight: function() {
                return this.$store.state.window.size.height - 10;
            },
            
            modalStyle: function() {
                return {
                    'max-height': this.maxHeight + 'px'
                };
            },
            
            bodyStyle: function() {
                var maxHeight = this.maxHeight - this.headerHeight - 10;
                
                return {
                    'max-height':  maxHeight + 'px'
                };
            }             
        },

        methods: {
            /*
             * @param array options [option]
             * options.title - Заголовок диалога
             * options.kids - список детей
             * options.selectedIndex - выбранный ребёнок
             * options.onSelect - событие вызывается при выборе ребёнка
             */
            show: function(options) {
                this.title = typeof options !== 'undefined' && typeof options.title !== 'undefined' ?
                    options.title : 'Выберите ребёнка';
                    
                this.kids = options.kids;
                this.selectedIndex = options.selectedIndex;
                this.onSelect = options.onSelect;
                    
                this.$dlg.modal('show');
            },

            hide: function() {
                this.$dlg.modal('hide');
            },

            getKidAvatarSrc: function(kid) {
                var src = kid.avatar.src + '_' + ks.consts.AVATAR_SIZE_BIG + '.png';
                if (kid.avatar.time > 0) {
                    src += '?t=' + kid.avatar.time;
                }
                return src;
            },

            selectKid: function(index, kid) {
                if (index === this.selectedIndex) return;

                if (this.onSelect !== null) {
                    this.onSelect(index, kid);
                }
                
                this.hide();
            }
        },

        mounted: function() {
            this.$dlg = $('#select-kid');
            
            var self = this;
            this.$dlg.on('shown.bs.modal', function (){
                self.headerHeight = self.$refs.header.offsetHeight;
            });
        }

    };

    ks.core.addComponent('select-kid', SelectKid);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 14.06.2021
 */

(function() {

    let DefaultTitle = 'Бесплатная регистрация';

    var SignupDlg = {

        data: function() {
            return {
                name: 'signUp',

                mode: 'default', // 'default' or 'email',

                title: DefaultTitle,
                text: '',

                email: {
                    value: '',
                    error: '',
                    checkMisprint: true
                },

                password: {
                    value: '',
                    error: ''
                },

                lastRequestError: 0,

                isActivationSent: false
            };
        },

        computed: {
            emailHasError: function() {
                return this.email.error !== '';
            },

            passwordHasError: function() {
                return this.password.error !== '';
            },

            isEmailLoginVisible: function(){
                return this.lastRequestError === ks.consts.ERR_EMAIL_ALREADY_EXISTS;
            },

            isDefaultMode: function(){
                return this.mode === 'default';
            },

            blockClass: function(){
                return {
                    'mode-email': this.mode === 'email',
                    'mistake-1': this.email.error !== '' || this.password.error !== '',
                    'mistake-2': this.email.error !== '' && this.password.error !== '',
                    'completed': this.mode === 'email' && this.isActivationSent
                };
            },

            infoText: function(){
                if (this.isActivationSent) {
                    return 'Подтвердите вашу почту';
                } else {
                    return this.text === '' ? 'Для начала занятий и<br /> сохранения прогресса обучения пройдите регистрацию:' : this.text;
                }
            }
        },

        methods: {
            clear: function(){
                this.mode = 'default';

                this.title = DefaultTitle;
                this.text = '';

                this.lastRequestError = 0;

                this.email.value = '';
                this.email.error = '';

                this.password.value = '';
                this.password.error = '';

                if (this.$refs.password && this.$refs.password.resetType) {
                  this.$refs.password.resetType();
                }

                this.isActivationSent = false;
            },

            show: function(options) {
                this.clear();

                if (typeof options !== 'undefined') {
                    this.title = options.title || DefaultTitle;
                    this.text = options.text || '';
                }

                this.$dlg.modal('show');

                this.$store.commit('window/setVisibleDialog', { dialog: this.name, visible: true });

                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SHOW_SIGNUP_DIALOG);
            },

            hide: function() {
                this.$dlg.modal('hide');
            },

            showLogin: function() {
                this.hide();
                ks.app.showLogin(this.email.value, '', null, false, 'dialog');
            },

            onRegistration: function() {
                if (this.validateFields()) {
                    this.lastRequestError = 0;

                    ks.client.request({
                        controller: 'parent',
                        action: 'signup',
                        data: {
                            email: this.email.value,
                            password: this.password.value,

                            check_email_misprint: this.email.checkMisprint
                        },
                        onRequest: this.onRequestRegistration
                    });
                }
            },

            validateFields: function() {
                return this.validateEmail() & this.validatePassword();
            },

            validateEmail: function() {
                if (this.email.value === '') {
                    this.email.error = 'Пожалуйста, укажите ваш email.';
                    return false;
                }

                if ( ! ks.validator.validateEmail(this.email.value)) {
                    this.email.error = 'Пожалуйста, укажите корректный email.';
                    return false;
                }

                this.email.error = '';

                return true;
            },

            validatePassword: function() {
                if (this.password.value === '') {
                    this.password.error = 'Пожалуйста, укажите пароль.';
                    return false;
                }

                if (this.password.value.length < 6) {
                    this.password.error = 'Пароль не может быть короче 6 символов.';
                    return false;
                }

                if (this.password.value.length > 32) {
                    this.password.error = 'Длина пароля не может быть больше 32 символов.';
                    return false;
                }

                this.password.error = '';

                return true;
            },

            onRequestRegistration: function(errorCode, data) {
                if (data.redirect) {
                    return;
                }

                if (data.errors) {
                    this.lastRequestError = data.error;

                    for (var field in data.errors) {
                        if (field in this) {
                            this[field].error = data.errors[field];
                        }
                    }

                    if (errorCode === ks.consts.ERR_EMAIL_MISPRINT) {
                        ks.app.$refs.messageBox.show({
                            type     : ks.consts.MBT_QUESTION,
                            title    : 'Внимание',
                            text     : data.errors.global,
                            buttons  : ks.consts.MBB_YES_NO,
                            onClose  : this.onCloseEmailMisprintDialog,
                            userData : {
                                possibleEmail: data.possibleEmail
                            }
                        });
                    } else {
                        if (data.errors.global) {
                            ks.app.$refs.messageBox.show({
                                type    : ks.consts.MBT_ERROR,
                                title   : 'Ошибка',
                                text    : data.errors.global,
                                buttons : ks.consts.MBB_CLOSE
                            });
                        }
                    }
                }
                else {
                    this.isActivationSent = true;

                    // VK Pixel Ретаргетинг
                    ks.vk.Retargeting.onEvent(ks.vk.Retargeting.EVENT_CLICK_SIGNUP);

                    ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_DIALOG);
                }
            },

            onCloseEmailMisprintDialog: function(modalResult, userData) {
                var send = false;

                switch (modalResult) {
                    case ks.consts.MBB_YES:
                        this.email.value = userData.possibleEmail;
                        this.email.checkMisprint = false;
                        send = true;
                        break;

                    case ks.consts.MBB_NO:
                        this.email.checkMisprint = false;
                        send = true;
                        break;
                }

                if (send) {
                    this.onRegistration();
                }
            },

            setEmailMode: function(){
                this.mode = 'email';
            }
        },

        watch: {
            'email.value': function() {
                if (this.email.value !== '') {
                    this.email.error = '';
                }
            },

            'password.value': function() {
                if (this.password.value !== '') {
                    this.password.error = '';
                }
            }
        },

        mounted: function() {
            this.$dlg = $('#signup-dlg');

            let self = this;
            this.$dlg.on('hidden.bs.modal', function () {
                self.$store.commit('window/setVisibleDialog', { dialog: self.name, visible: false });
            });
        }

    };

    ks.core.addComponent('signup-dlg', SignupDlg);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 21.02.2021
 */

(function() {

    Vue.component('simple-pager', {

        template: '<div v-show="isVisible" class="simple-pager" style="display: none;">' +
                    '<div class="btn-group" role="group">' +
                        '<button type="button" class="btn btn-default" :disabled="!canGoFirst" @click.prevent="goFirst"><i class="fa fa-angle-double-left" aria-hidden="true"></i></button>' +
                        '<button type="button" class="btn btn-default" :disabled="!canGoPrev" @click.prevent="goPrev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>' +
                        '<button type="button" class="btn btn-default simple-pager-info" disabled="disabled">{{ page }} / {{ count }}</button>' +
                        '<button type="button" class="btn btn-default" :disabled="!canGoNext" @click.prevent="goNext"><i class="fa fa-angle-right" aria-hidden="true"></i></button>' +
                        '<button type="button" class="btn btn-default" :disabled="!canGoLast" @click.prevent="goLast"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>' +
                    '</div>' +
                  '</div>',

        model: {
            prop: 'page',
            event: 'change'
        },

        props: {
            page: Number,
            
            count: {
                type: Number,
                default: 0
            },
            
            visible: {
                type: Boolean,
                default: true
            }
        },

        computed: {
            isVisible: function() {
                return this.visible && this.page > 0 && this.count > 1;
            },
            
            canGoFirst: function() {
                return this.page > 1;
            },
            
            canGoPrev: function() {
                return this.page > 1;
            },
            
            canGoNext: function() {
                return this.page < this.count;
            },
            
            canGoLast: function() {
                return this.page < this.count;
            }
        },

        data: function() {
            return {};
        },

        methods: {
            goFirst: function() {
                this.$emit('change', 1);
            },
    
            goPrev: function() {
                this.$emit('change', this.page - 1);
            },
            
            goNext: function() {
                this.$emit('change', this.page + 1);
            },
            
            goLast: function() {
                this.$emit('change', this.count);
            }
        }
    });

}());
/**
 * (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 25.10.2017
 *
 */

(function() {

    var SwitchUser = {

        data: function() {
            return {
                title: '',
                
                parent: {
                    name: '',
                    avatar: '',
                    selected: false
                },
                
                kids: [],
                
                redirectUrl: '',
                
                headerHeight: 80, // px
                
                needSubscription: false
            };
        },

        computed: {
            maxHeight: function() {
                return this.$store.state.window.size.height - 10;
            },
            
            modalStyle: function() {
                return {
                    'max-height': this.maxHeight + 'px'
                };
            },
            
            bodyStyle: function() {
                var maxHeight = this.maxHeight - this.headerHeight - 10;
                
                return {
                    'max-height':  maxHeight + 'px'
                };
            },
            
            countKids: function(){
                return this.$store.state.parent.countKids;
            }
        },

        methods: {
            /*
             * @param array options [option]
             * options.title - Заголовок диалога
             */
            show: function(options) {
                var opt = options || {},
                    role = typeof opt.role !== 'undefined' ? opt.role : null;
                
                this.redirectUrl = typeof opt.redirectUrl !== 'undefined' ? opt.redirectUrl : '';
                
                switch (role) {
                    case 'parent':
                        // логинемся под родителя
                         
                        // 15.06.2021 - пофиксил автоматический редирект на ребенка.
                        let url = window.location.href;
                        if (this.redirectUrl === '' && (url.indexOf('/exercises/') > 0 || url.indexOf('/trainings/run/') > 0 || url.indexOf('/trainings/group/item/') > 0)) {
                            this.redirectUrl = '/';
                        }
                        
                        this.selectParent();
                        return; // выход
                        
                        //break; 
                        
                    case 'kid':
                        if (this.countKids === 1) {
                            // id=0 означает, что мы логинемся под единственный профиль ребёнка под аккаунтом родителя
                            this.selectKid({id: 0});
                            return; // выход
                        }
                        
                        //break;
                }
                    
                this.title = typeof opt.title !== 'undefined' ? opt.title : 'Выберите пользователя';
                
                this.needSubscription = typeof opt.needSubscription !== 'undefined' ? opt.needSubscription : false;
                
                ks.client.request({
                    controller: 'account',
                    action: 'kids/get-all',
                    onRequest: this.onGetKids
                });
            },

            onGetKids: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }

                data.kids.forEach(function(kid) {
                    kid.selected = ks.app.isLogged(ks.consts.ROLE_KID, kid.id);
                });

                this.kids = data.kids;

                this.loadParent();

                this.$dlg.modal('show');
            },

            hide: function() {
                this.$dlg.modal('hide');
            },

            loadParent: function() {
                this.parent.name = this.$store.state.parent.name;
                this.parent.avatar = this.$store.getters['parent/getAvatarBySize'](ks.consts.AVATAR_SIZE_BIG);
                this.parent.selected = ks.app.isLogged(ks.consts.ROLE_PARENT);
            },

            getKidAvatarSrc: function(kid) {
                var src = kid.avatar.src + '_' + ks.consts.AVATAR_SIZE_BIG + '.png';
                if (kid.avatar.time > 0) {
                    src += '?t=' + kid.avatar.time;
                }
                return src;
            },

            selectParent: function() {
                if (ks.app.isLogged(ks.consts.ROLE_PARENT)) return;

                if (ks.app.needParentPassword() === true) {
                    this.hide();
                    ks.app.$refs.parentPassword.show({
                        role: ks.consts.ROLE_PARENT
                    });
                    return;
                }

                ks.client.request({
                    controller: 'account',
                    action: 'switch-user/login',
                    data: {
                        user: {
                            role: ks.consts.ROLE_PARENT
                        },
                        redirectUrl: this.redirectUrl
                    },
                    onRequest: this.onSwitchUser
                });
            },

            selectKid: function(kid) {
                if (kid.id === 0) {
                    if (ks.app.isLogged(ks.consts.ROLE_KID)) return;
                } else {
                    if (ks.app.isLogged(ks.consts.ROLE_KID, kid.id)) return;
                }
                
                if (this.needSubscription && ! kid.subscription.active) {
                    this.$refs.alert.show('Нужно выбрать профиль ребёнка с безлимитным доступом.', ks.consts.ALERT_INFO);
                    return;
                }

                if (ks.app.isLogged(ks.consts.ROLE_KID) && ks.app.needParentPassword() === true) {
                    this.hide();
                    ks.app.$refs.parentPassword.show({
                        role: ks.consts.ROLE_KID,
                        id: kid.id
                    });
                    return;
                }
                
                // 25.10.2021 - пофиксил автоматический редирект на родителя.
                let url = window.location.href;
                if (this.redirectUrl === '' && (url.indexOf('/parent/profile') > 0)) {
                    this.redirectUrl = '/';
                }                
                //--

                ks.client.request({
                    controller: 'account',
                    action: 'switch-user/login',
                    data: {
                        user: {
                            role: ks.consts.ROLE_KID,
                            id: kid.id
                        },
                        redirectUrl: this.redirectUrl
                    },
                    onRequest: this.onSwitchUser
                });
            },

            onSwitchUser: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);

                    return;
                }
            }
        },

        mounted: function() {
            var self = this;

            this.$dlg = $('#switch-user');

            this.$dlg.on('hidden.bs.modal', function () {
                self.$refs.alert.hide();
            });
            
            this.$dlg.on('shown.bs.modal', function (){
                self.headerHeight = self.$refs.header.offsetHeight;
            });
        }

    };

    ks.core.addComponent('switch-user', SwitchUser);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 19.10.2017
 */

(function() {

    Vue.component('touch-spin', {

        template: '<input class="form-control" :id="id" type="text" :placeholder="placeholder" :class="renderClass" :disabled="!enabled" />',

        props: {
            value: {
                default: null,
                required: true
            },

            placeholder: {
                type: String,
                default: ''
            },

            id: {
                type: String,
                default: ''
            },

            min: {
                type: Number,
                default: 0
            },

            max: {
                type: Number,
                default: 100
            },

            step: {
                type: String,
                default: '1'
            },

            verticalButtons: {
                type: Boolean,
                default: true
            },
            
            extraClass: {
                type: String,
                default: ''
            },
            
            enabled: {
                type: Boolean,
                default: true
            },
            
            postfix: {
                type: String,
                default: ''
            },
            
            userData: {
                default: null
            }
        },

        data: function() {
            return {
            };
        },
        
        computed: {
            renderClass: function() {
                var cls = {},
                    arr = this.extraClass !== '' ? this.extraClass.split(' ') : [];

                for(var i = 0; i < arr.length; i++) {
                    cls[arr[i]] = true;
                }

                return cls;
            }            
        },
        
        methods: {
            applyEnabled: function() {
                var btns = $(this.$el).parent().find('.btn');
                
                if (this.enabled) {
                    btns.removeAttr('disabled');
                } else {
                    btns.attr('disabled', 'disabled');
                }
            }
        },
        
        watch: {
            enabled: function(newValue) {
                this.applyEnabled();
            },
            
            value: function(newValue) {
                $(this.$el).TouchSpin().val(newValue);
            }
        },

        mounted: function() {
            var self = this,
                el = $(this.$el);

            el.TouchSpin({
                initval: this.value,
                min: this.min,
                max: this.max,
                step: parseInt(this.step, 10),
                verticalbuttons: this.verticalButtons,
                postfix: this.postfix
            });

            el.on('change', function(){
                var val = parseInt(el.val(), 10);

                if (val > parseInt(self.max, 10)) {
                    val = self.max;
                    el.val(val);
                }

                if (val < parseInt(self.min, 10)) {
                    val = self.min;
                    el.val(val);
                }

                self.$emit('input', isNaN(val) ? '' : val);
                self.$emit('change', isNaN(val) ? '' : val, self.userData);
            });
            
            this.applyEnabled();
        }

    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 20.02.2018
 * 
 * Диалоговое окно для добавлени/редактирование предметов тренировки.
 * 
 */

(function() {

    var TrainingSubjectDlg = {
        
        props: {
            groupId: {
                type: Number,
                required: true
            }
        },

        data: function() {
            return {
                mode: null,
                
                subjects: [],
                
                subject: {
                    id: -1,
                    parentId: -1,
                    title: '',
                    countExercises: 2
                },
                
                minCountExercises: 2,
                maxCountExercises: 10,
                
                onOK: null,
                
                userData: null
            };
        },
        
        computed: {
            dlgClass: function() {
                return {
                    'dlg-success': this.mode === 'add',
                    'dlg-info': this.mode === 'edit'
                };
            },
            
            titleClass: function() {
                return {
                    'green': this.mode === 'add',
                    'blue': this.mode === 'edit'
                };
            },
            
            title: function() {
                var title;
                
                switch (this.mode) {
                    case 'add':
                        title = '<i class="fa fa-plus"></i> Добавление темы';
                        break;
                        
                    case 'edit':
                        title = '<i class="fa fa-pencil"></i> Изменение темы';
                        break;
                        
                    default:
                        title = '';
                        break;
                }
                
                return title;
            },
            
            btnClass: function() {
                return {
                    'btn-glass-green': this.mode === 'add',
                    'btn-glass-blue': this.mode === 'edit'
                };
            },
            
            parentSubjects: function() {
                var items = [];
            
                for (var i = 0; i < this.subjects.length; i++) {
                    items.push({
                        value: this.subjects[i].id,
                        title: this.subjects[i].title,
                        selected: this.subject.parentId === this.subjects[i].id
                    });
                }
                
                return items;
            },
            
            childSubjects: function() {
                var items = [];
            
                for (var i = 0; i < this.subjects.length; i++) {
                    if (this.subjects[i].id !== this.subject.parentId) {
                        continue;
                    }
                    
                    for (var j = 0; j < this.subjects[i].items.length; j++) {
                        items.push({
                            value: this.subjects[i].items[j].id,
                            title: this.subjects[i].items[j].title,
                            selected: this.subject.id ===  this.subjects[i].items[j].id      
                        });
                    }
                }
                
                return items;
            },
            
            countExercises: function() {
                var items = [];
                
                for (var i = this.minCountExercises; i <= this.maxCountExercises; i++) {
                    items.push({
                        value: i,
                        title: i,
                        selected: this.subject.countExercises === i
                    });
                }
                
                return items;
            },
            
            canSave: function() {
                return this.subject.id !== -1 && this.subject.parentId !== -1;
            }
        },
        
        methods: {
            show: function(options) {
                //Режим диалого окна (add|edit)
                this.mode = options.mode;
                // Событие, которое вызывается после нажатия на кнопку "ОК"
                // в событие передаюсят данные предмета (this.subject) и userData
                this.onOK = options.onOK || null;
                // Любые данные, будут передаты в событие onOK вторым параметром
                this.userData = options.userData || null;
                // Если вызвали окно впервый раз - загружаем список предметов
                if (this.subjects.length === 0) {
                    this.loadSubjects(options);
                } else {
                    this.updateSubject(options.subject);
                    
                    this.$dlg.modal('show');
                }
            },

            hide: function() {
                this.$dlg.modal('hide');
            },
            
            loadSubjects: function(data) {
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-trainings/get-subjects',
                    data: {
                        groupId: this.groupId
                    },
                    onRequest: this.onLoadSubjects,
                    userData: data
                });                
            },
            
            onLoadSubjects: function(errorCode, data, userData) {
                var i,
                    parents = [];
                
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type    : ks.consts.MBT_ERROR,
                        title   : 'Ошибка',
                        text    : data.errors.global,
                        buttons : ks.consts.MBB_OK
                    }); 
                    
                    return;
                }
                
                this.subjects = [];
                
                // Обрабатываем родительские предметы
                for (i = 0; i < data.subjects.length; i++) {
                    if (data.subjects[i].parentId === 0) {
                        parents.push({
                            id: data.subjects[i].id,
                            title: data.subjects[i].title,
                            items: []
                        });
                    }
                }
                
                // Обрабатываем дочерние предметы
                for (i = 0; i < data.subjects.length; i++) {
                    if (data.subjects[i].parentId !== 0) {
                        var subject = this.getSubject(data.subjects[i].parentId, parents);
                        
                        if (subject === null) {
                            continue;
                        }
                        
                        subject.items.push({
                            id: data.subjects[i].id,
                            title: data.subjects[i].title
                        });
                    }
                }
                
                for (i = 0; i < parents.length; i++) {
                    if (parents[i].items.length === 0) {
                        continue;
                    }
                    
                    this.subjects.push(parents[i]);
                }
                
                // Минимальное и максимальное кол-во упражнений
                if (typeof data.minCountExercises !== 'undefined') {
                    this.minCountExercises = data.minCountExercises;
                }
                
                if (typeof data.maxCountExercises !== 'undefined') {
                    this.maxCountExercises = data.maxCountExercises;
                }
                
                this.updateSubject(userData.subject);
                
                this.$dlg.modal('show');
            },
            
            updateSubject: function(selectedSubject) {
                if (typeof selectedSubject === 'undefined') {
                    // Диалоговое окно в режиме добавления предмета
                    var subject = this.subjects.length > 0 ? this.subjects[0] : null;
                    
                    this.subject.parentId = subject !== null ? subject.id : -1;
                    this.subject.id = subject !== null && subject.items.length > 0 ? subject.items[0].id : -1;
                    this.subject.title = subject !== null && subject.items.length > 0 ? subject.items[0].title : '';
                    this.subject.countExercises = this.minCountExercises;
                } else {
                    // Диалогово окно в режиме изменения предмета
                    this.subject.parentId = selectedSubject.parentId;
                    this.subject.id = selectedSubject.id;
                    this.subject.title = selectedSubject.title;
                    this.subject.countExercises = selectedSubject.countExercises;
                }
            },
            
            getSubject: function(id, array) {
                var items = typeof array === 'undefined' ? this.subjects : array;
                
                for (var i = 0; i < items.length; i++) {
                   if (items[i].id === id)  {
                       return items[i];
                   }
                }
                
                return null;
            },
            
            onSelectParentSubject: function(subject) {
                var parent = this.getSubject(parseInt(subject.value));
                
                this.subject.parentId = parent !== null ? parent.id : -1;
                this.subject.id = parent !== null && parent.items.length > 0 ? parent.items[0].id : -1;
                this.subject.title = parent !== null && parent.items.length > 0 ? parent.items[0].title : '';
            },
            
            onSelectChildSubject: function(subject) {
                this.subject.id = subject.value;
                this.subject.title = subject.title;
            },
            
            onSelectCountExercises: function(option) {
                this.subject.countExercises = option.value;
            },
            
            onClickOK: function() {
                if (this.onOK !== null) {
                    this.onOK(this.subject, this.userData);
                }
                
                this.hide();
            }
        },

        mounted: function() {
            this.$dlg = $('#training-subject-dlg');
        }
    };

    ks.core.addComponent('training-subject-dlg', TrainingSubjectDlg);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 01.03.2022
 * 
 * Колесо фортуны
 * 
 */

(function() {
    Vue.component('wheel-fortune-sector', {
        template:
            '<div>' +
                '<div class="wheel-sector" :class="sectorClass" :style="sectorStyle"></div>' +
                '<div class="wheel-sector-line" :style="lineStyle"></div>' +
                '<div class="wheel-sector-content" :style="contentStyle">' + 
                    '<div v-html="item.title"></div>' +
                    '<i class="fa fa-gift" :class="iconClass"></i>' +
                '</div>' +
            '</div>',    

        props: {
            index: {
                type: Number,
                required: true
            },

            item: {
                type: Object,
                required: true
            },

            countSectors: {
                type: Number,
                required: true
            },

            diameter: {
                type: Number,
                required: true
            },

            sectorAngle: {
                type: Number,
                required: true
            },

            sectorHalfWidth: {
                type: Number,
                required: true
            }      
        },

        computed: {
            halfDiameter: function(){
                return this.diameter / 2;
            },
            
            sectorClass: function(){
                let cls = {};
                
                cls['color-scheme-' + this.item.color] = true;
                
                return cls;
            },

            sectorStyle: function() {
                let angle = 360 * this.index / this.countSectors + 90,
                    left = this.halfDiameter - this.sectorHalfWidth;

                return {
                    'transform'        : 'rotate(' + angle + 'deg)',
                    //'border-color'     : this.item.color + ' transparent',
                    'border-width'     : this.halfDiameter + 'px ' + this.sectorHalfWidth + 'px 0',
                    'transform-origin' : this.sectorHalfWidth + 'px ' + this.halfDiameter + 'px',
                    'left'             : left + 'px'
                };
            },

            lineStyle: function(){
                let angle = (360 * this.index / this.countSectors) + (180 * (this.countSectors - 1)) / this.countSectors;

                return {
                    'width'            : this.halfDiameter + 'px',
                    'transform'        : 'rotate(' + angle + 'deg)',
                    'height'           : '4px',
                    'top'              : 'calc(50% - 2px)',
                    'transform-origin' : this.halfDiameter + 'px 2px'
                };
            },

            contentStyle: function(){
                let angle = 360 * this.index / this.countSectors + 90,
                    quarterDiameter = this.diameter / 4,
                    left = this.halfDiameter - quarterDiameter;

                return {
                    'transform'        : 'rotate(' + angle + 'deg)',
                    'width'            : this.halfDiameter + 'px',
                    'height'           : this.halfDiameter + 'px',
                    'transform-origin' : quarterDiameter + 'px ' + this.halfDiameter + 'px',
                    'left'             : left + 'px'                
                };
            },

            iconClass: function(){
                let cls = {};
                
                cls['color-scheme-' + this.item.color] = true;
                
                return cls;
            }
        },

        data: function(){
            return {};
        }
    });

    Vue.component('wheel-fortune', {

        template: 
            '<div class="wheel-box">' +
                '<div ref="wrapper" class="wheel-wrp" :style="wrpStyle">' +
                    '<wheel-fortune-sector v-for="(item, index) in items" :index="index" :key="index" :item="item" :countSectors="countSectors" :diameter="diameter" :sectorAngle="sectorAngle" :sectorHalfWidth="sectorHalfWidth"></wheel-fortune-sector>' +    
                '</div>' +

                '<div class="wheel-pointer"><i class="fa fa-play"></i></div>' +
            '</div>',

        props: {
            initWidth: {
                type: Number,
                required: true
            },
            
            items: {
                type: Array,
                required: true
            }
        },

        computed: {
            countSectors: function(){
                return this.items.length;
            },

            wrpStyle: function(){
                let styles = {
                    'height'    : this.diameter + 'px',
                    'transform' : 'rotate(' + this.spinDeg + 'deg)'
                };

                if (this.animateSpin) {
                    styles.transition = 'transform ' + this.spinTime + 's cubic-bezier(0, 0.76, 0.5, 1.01)';
                }

                return styles;
            }
        },

        data: function(){
            return {
                diameter: 0,
                sectorAngle: 0,
                sectorHalfWidth: 0,

                animateSpin: false,
                spinDeg: 0,
                spinTime: 5,
                //Кол-во оборотов до остановки
                maxRevolution: 20            
            };
        },

        methods: {
            show: function(){
                this.updateSize();
                window.addEventListener('resize', this.onWindowResize);
            },

            hide: function(){
                window.removeEventListener('resize', this.onWindowResize);
            },

            updateSize: function(){
                //Диаметр колеса
                this.diameter = this.$refs.wrapper.offsetWidth;            
                if (this.diameter === 0) {
                    this.diameter = this.initWidth;
                }
                
                //Угол сектора
                this.sectorAngle = Number(((360 * Math.PI) / (this.countSectors * 180)).toFixed(3));
                //Катет сектора
                this.sectorHalfWidth = 0.5 * this.diameter * Math.tan(this.sectorAngle / 2);             
            },

            onWindowResize: function(){
                this.updateSize();
            },

            spinWheel: function(finalSector, isAnimate){
                if (this.spinDeg > 0) {
                    this.resetWheel();
                }

                let self = this;
                setTimeout(function(){
                    if (isAnimate) {
                        self.animateSpin = true;
                    }
                    self.doSpinWheel(finalSector, isAnimate);
                }, 0);
            },

            doSpinWheel: function(finalSector, isAnimate){
                if ( ! isAnimate) {
                    //Поворачиваем колесо
                    this.spinDeg = ((this.countSectors - finalSector) * 360) / this.countSectors;
                    return;
                }
                
                //Поворачиваем колесо
                this.spinDeg += this.maxRevolution * 360 + ((this.countSectors - finalSector) * 360) / this.countSectors;
                
                //Ждем пока колесо закончится крутиться
                let self = this;
                setTimeout(function(){
                    self.$emit('finish', finalSector);
                }, this.spinTime * 1000);            
            },

            resetWheel: function(){
                this.animateSpin = false;
                this.spinDeg = 0;
            }        
        },

        mounted: function(){
            this.show();
        }
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 01.03.2022
 */

(function() {
    
    const DefaultWheelSize = 310;

    var WheelFortuneDlg = {
        
        props: {
            initPromocode: {
                type: String,
                required: true
            },
            
            initIndex: {
                type: Number,
                required: true
            },
            
            items: {
                type: Array,
                required: true
            },
            
            imageBody: {
                type: String,
                default: ''
            }
        },

        data: function() {
            return {
                wheelSize: 0,
                
                isSpinWheel: false,
                
                index: -1,
                promocode: ''
            };
        },

        computed: {
            hasPromocode: function(){
                return this.index > -1;
            },
            
            prizTitle: function(){
                return this.hasPromocode ? this.items[this.index].title : '';
            },
            
            styleBody: function() {
                let style = {};
                
                if (this.imageBody !== '') {
                    style['background-image']  = 'url(' + this.imageBody + ')';
                    style['background-repeat'] = 'repeat';
                }
                
                return style;
            }          
        },

        methods: {
            show: function() {
                this.$refs.wheel.show();
                this.$dlg.modal('show');
            },

            hide: function() {
                this.$dlg.modal('hide');
            },
            
            updateWheelSize: function(){
                let maxWidth = window.innerWidth - 30/*margin*/ - 20/*padding*/ - 2/*borders*/ - 40/*padding wheel box*/;
                
                this.wheelSize = DefaultWheelSize > maxWidth ? maxWidth : DefaultWheelSize;
            },
            
            spinWheel: function(){
                if (this.isSpinWheel) {
                    return;
                }
                
                this.isSpinWheel = true;
                
                ks.client.request({
                    controller: 'promo',
                    action: 'wheel-fortune/get-index',
                    data: {},
                    onRequest: this.onGetIndexWheelFortune
                });                
                
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_WHEEL_FORTUNE_SPIN);
            },
            
            onGetIndexWheelFortune: function(errorCode, data){
                if (errorCode !== ks.consts.ERR_OK || data.index < 0) {
                    this.isSpinWheel = false;
                    this.hide();

                    ks.app.$refs.messageBox.show({
                        type    : ks.consts.MBT_ERROR,
                        title   : 'Ошибка',
                        text    : 'Что-то пошло не так. Пожалуйста, попробуйте позже.',
                        buttons : ks.consts.MBB_OK
                    });
                    
                    return;
                }
                
                this.promocode = data.promocode;
                
                this.$refs.wheel.spinWheel(data.index, true);
            },
            
            onWheelFinish: function(index){
                this.index = index;
                this.isSpinWheel = false;
            },
            
            applyPromocode: function(){
                this.hide();
                ks.app.setPromocode(this.promocode, true, true);
                
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_WHEEL_FORTUNE_APPLY_PROMO);
            },
            
            showSignup: function(options){
                this.hide();
                ks.app.showSignup(options);
            }            
        },

        mounted: function() {
            this.index = this.initIndex;
            this.promocode = this.initPromocode;
            
            if (this.index > -1) {
                this.$refs.wheel.spinWheel(this.index, false);
            }
            
            this.updateWheelSize();
            window.addEventListener('resize', this.updateWheelSize);
        
            this.$dlg = $('#wheel-fortune-dlg');

            let self = this;
            this.$dlg.on('shown.bs.modal', function(e) {
                self.$refs.wheel.updateSize();
            });
        }

    };

    ks.core.addComponent('wheel-fortune-dlg', WheelFortuneDlg);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 02.03.2022
 * 
 * Колесо фортуны - Иконка оповещения
 * 
 * 13.12.2022:
 * +Поддержка показа и для гостей. Раньше было только для зарег. пользователей.
 * 
 */

(function() {
    Vue.component('wheel-fortune-notify', {
        template:
            '<div v-if="isShow" class="wheel-fortune-notify" :class="notifyClass">' +
            '   <div class="wheel-fortune-notify__box">' +
            '       <div class="wheel-fortune-notify__close-box"><a @click.prevent="close" href="#"><i class="fa fa-close"></i></a></div>'+
            '       <a :href="targetUrl">' +
            '          <img class="wheel-fortune-notify__in wfn-rotating" :src="getImageIn" />' +
            '          <img class="wheel-fortune-notify__out" :src="getImageOut" alt="Колесо фортуны" data-container="body" data-toggle="popover" data-placement="left" :data-content="getNotifyHint" />' +
            '       </a>' +
            '   </div>' +
            '</div>',
    
        props: {
            uid: {
                type: String,
                required: true
            },
            
            days: {
                type: Number,
                required: true
            },
            
            imageIn: {
                type: String,
                default: ''
            },
            
            imageOut: {
                type: String,
                default: ''
            },
            
            notifyHint: {
                type: String,
                default: ''
            }
        }, 
        
        computed: {
            cookieName: function(){
                return 'ks_hide_wfn_' + this.uid;
            },
            
            isShow: function(){
                return this.$store.state.wheelFortuneNotifyShown;
            },
            
            getImageIn: function() {
                return this.imageIn === '' ? '/public/images/promo/wheel_fortune_in.png' : this.imageIn;
            },
            
            getImageOut: function() {
                return this.imageOut === '' ? '/public/images/promo/wheel_fortune_out.png' : this.imageOut;
            },
            
            getNotifyHint: function() {
                return this.notifyHint === 'Акция - Колесо фортуны!' ? '' : this.notifyHint;
            },
            
            isLogged: function(){
                return ! this.$store.getters.isGuest;
            },            
            
            targetUrl: function() {
                return this.isLogged ? '/parent/profile/payment?action=wfs' : '/payment?action=wfs';
            },
            
            notifyClass: function() {
                return {
                    'hidden-xs': ! this.isLogged
                };
            }
        },
    
        data: function(){
            return {};
        },
        
        methods: {
            close: function(){
                this.$store.commit('setWheelFortuneNotifyShown', false);
                
                ks.helpers.cookies.set(this.cookieName, true, { expires: this.days });
                
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_WHEEL_FORTUNE_CLOSE);
            }
        },
        
        mounted: function(){
            let hidden = Cookies.get(this.cookieName),
                isShow = true;
            
            if (typeof hidden !== 'undefined' && hidden === 'true') {
                isShow = false;
            }
            
            this.$store.commit('setWheelFortuneNotifyShown', isShow);
        }
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 17.07.2018
 * 
 * Диалоговое окно отдыха
 * 
 */

(function() {

    var WindowRest = {

        data: function() {
            return {
            };
        },
        
        computed: {

        },
        
        methods: {
            show: function() {
                this.$dlg.modal('show');
                
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_WINDOW_REST_SHOW);
            },

            hide: function() {
                this.$dlg.modal('hide');
            }
        },

        mounted: function() {
            this.$dlg = $('#window-rest');
        }
    };

    ks.core.addComponent('window-rest', WindowRest);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 28.10.2017
 */

(function() {

    var HeaderKid = {

        data: function() {
            return {
                loaded: false
            };
        },

        computed: {
            name: function() {
                return ks.helpers.text.capitalizeFirstLetter(this.$store.state.kid.name);
            },

            avatar: function() {
                return this.$store.getters['kid/getAvatarBySize'](ks.consts.AVATAR_SIZE_SMALL);
            },

            canAutoSwitchUser: function(){
                return this.$store.getters['parent/canAutoSwitchToParent'] && this.$store.getters['parent/canAutoSwitchToKid'];
            },

            subscriptionActive: function() {
                return this.$store.state.kid.subscription.active;
            },

            subscriptionExpired: function() {
                return this.subscriptionActive ? moment(this.$store.state.kid.subscription.expired, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
            },

            canInstallApp() {
              return this.$store.getters.canInstallApp;
            }
        },

        methods: {
            switchUser: function(options){
                ks.app.switchUser(options);
            },

            startInstallApp() {
              ks.app.startInstallApp();
            }
        },

        mounted: function() {
            this.loaded = true;
        }
    };

    ks.core.addComponent('header-kid', HeaderKid);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 18.09.2017
 */

(function() {

    var HeaderLoginForm = {

        data: function() {
            return {
                email: {
                    value: '',
                    hasError: false
                },

                password: {
                    value: '',
                    hasError: false
                }
            };
        },

        computed: {
          canInstallApp() {
            return this.$store.getters.canInstallApp;
          }
        },

        methods: {
            onLogin: function() {
                if (this.validateFields()) {
                    ks.client.request({
                        controller: 'parent',
                        action: 'login',
                        data: {
                            email: this.email.value,
                            password: this.password.value
                        },
                        onRequest: this.onRequestLogin
                    });
                }
                else {
                    if (this.email.hasError) {
                        this.$refs.email.focus();
                    }
                    else {
                        this.$refs.password.focus();
                    }
                }
            },

            validateFields: function() {
                return this.validateEmail() & this.validatePassword();
            },

            validateEmail: function() {
                this.email.hasError = this.email.value === '';
                return !this.email.hasError;
            },

            validatePassword: function() {
                this.password.hasError = this.password.value === '';
                return !this.password.hasError;
            },

            onForgotPassword: function() {
                ks.app.$refs.loginDlg.showForgotPassword(this.email.value, this.password.value);
            },

            onRequestLogin: function(errorCode, data) {
                if (data.redirect) {
                    return;
                }

                if (data.errors) {
                    ks.app.showLogin(this.email.value, this.password.value, data.errors);
                }
            },

            showLogin: function(){
                ks.app.showLogin(this.email.value);
            },

            startInstallApp() {
              ks.app.startInstallApp();
            }
        },

        watch: {
            'email.value': function() {
                if (this.email.value !== '') {
                    this.email.hasError = false;
                }
            },

            'password.value': function() {
                if (this.password.value !== '') {
                    this.password.hasError = false;
                }
            }
        },

        mounted: function() {
            this.email.value = $('#header-email').data('default');
        }

    };

    ks.core.addComponent('header-login-form', HeaderLoginForm);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 02.04.2018
 */

(function() {

    var HeaderMenuMobile = {

        data: function() {
            return {
                loaded: false,

                isShowBox: false,
                isShowContainer: false,

                canHide: false
            };
        },

        computed: {
            avatar: function() {
                return this.isKid ?
                    this.$store.getters['kid/getAvatarBySize'](ks.consts.AVATAR_SIZE_BIG) :
                    this.$store.getters['parent/getAvatarBySize'](ks.consts.AVATAR_SIZE_BIG);
            },

            accountName: function() {
                return this.isKid ?
                    this.$store.state.kid.name :
                    this.$store.state.parent.name;
            },

            isKid: function() {
                return this.$store.state.role === ks.consts.ROLE_KID;
            },

            kidHasNewProgress: function() {
                return this.isKid && this.$store.getters['kid/hasNewProgress'];
            },

            containerWidthCoefficient: function() {
                return this.$store.state.window.size.width > this.$store.state.window.size.height ? 0.6 : 0.8;
            },

            containerWidth: function() {
                return (this.$store.state.window.size.width * this.containerWidthCoefficient).toFixed();
            },

            containterLeft: function() {
                return this.isShowContainer ? 0 : -this.containerWidth;
            },

            containerStyle: function() {
                return {
                    'left': this.containterLeft + 'px',
                    'width': this.containerWidth + 'px'
                };
            },

            promocode: function() {
                return this.$store.state.promocode.active ? this.$store.state.promocode : null;
            },

            promocodeDiscountPercent: function() {
                return this.hasPromocodePercent ? '-' + this.promocode.discount + '%' : '';
            },

            hasPromocodePercent: function() {
                return this.promocode !== null && this.promocode.discountMode === ks.consts.PROMOCODE_DISCOUNT_MODE_PERCENT && ! this.hasPricePostfix;
            },

            hasPricePostfix: function() {
                return this.$store.state.pricePostfix !== null;
            },

            pricePostfix: function() {
                return this.hasPricePostfix ? this.$store.state.pricePostfix : '';
            },

            canAutoSwitchUser: function(){
                return this.$store.getters['parent/canAutoSwitchToParent'] && this.$store.getters['parent/canAutoSwitchToKid'];
            },

            subscriptionActive: function() {
                return this.isKid && this.$store.state.kid.subscription.active;
            },

            subscriptionExpired: function() {
                return this.subscriptionActive ? moment(this.$store.state.kid.subscription.expired, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
            },

            canInstallApp() {
              return this.$store.getters.canInstallApp;
            }
        },

        methods: {
            show: function() {
                var self = this;

                this.isShowBox = true;
                this.canHide = false;

                this.$nextTick(function() {
                    setTimeout(function() {
                        self.isShowContainer = true;

                        self.$store.commit('mobile/setMenuShow', true);
                    }, 50);

                    setTimeout(function() {
                        self.canHide = true;
                    }, 500);
                });
            },

            hide: function() {
                if ( ! this.canHide) {
                    return;
                }

                var self = this,
                    timer;

                timer = setInterval(function() {
                    if (self.$refs.container.style.left === self.containterLeft + 'px') {
                        clearInterval(timer);
                        self.isShowBox = false;
                    }
                }, 100);

                this.isShowContainer = false;

                self.$store.commit('mobile/setMenuShow', false);
            },

            showLogin: function() {
                this.hide();
                ks.app.showLogin();
            },

            switchUser: function(options) {
                this.hide();

                let opt = options || {};

                if (this.canAutoSwitchUser && typeof opt.role === 'undefined') {
                    opt.role = this.$store.getters.isKid ? 'parent' : 'kid';
                }

                ks.app.switchUser(opt);
            },

            startInstallApp() {
              ks.app.startInstallApp();
            }
        },

        watch: {
            isShowBox: function(newValue) {
                var body = $('body');

                if (newValue) {
                    body.addClass('modal-open');
                } else {
                    body.removeClass('modal-open');
                }
            }
        },

        mounted: function() {
            if (ks.browser.isTouch()) {
                var hammer = new Hammer.Manager(document.getElementById('app')),
                    swipe = new Hammer.Swipe({ direction: Hammer.DIRECTION_HORIZONTAL }),
                    self = this;

                hammer.add(swipe);

                hammer.on('swipeleft', function(){
                    if ( ! self.isShowContainer) {
                        return;
                    }

                    self.hide();
                });

                hammer.on('swiperight', function(){
                    if (self.isShowBox || self.$store.state.window.size.width > 767) {
                        return;
                    }

                    // Если открыто любое модальное окно, то меню не показываем
                    // 10.10.2023: Если происходит перетаскивание элемента, то меню не показываем
                    const body = $('body');
                    if ($('.modal-backdrop').length > 0 || body.hasClass('modal-open') || self.$store.getters['window/draggableMode']) {
                        return;
                    }

                   self.show();
                });

                var hammerMenu = new Hammer.Manager(document.getElementById('mobile-menu-container')),
                    swipeMenu = new Hammer.Swipe({ direction: Hammer.DIRECTION_HORIZONTAL });

                hammerMenu.add(swipeMenu);

                hammerMenu.on('swipeleft', function(){
                    if ( ! self.isShowContainer) {
                        return;
                    }

                    self.hide();
                });
            }

            this.loaded = true;
        }

    };

    ks.core.addComponent('header-menu-mobile', HeaderMenuMobile);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 12.05.2018
 */

(function() {

    var HeaderMenuMobileButton = {

        data: function() {
            return {
            };
        },
        
        computed: {
            isMenuShow: function() {
                return this.$store.getters['mobile/isMenuShow'];
            },
            
            buttonClass: function() {
                return {
                    'hide-button': this.isMenuShow
                };
            }
        },

        methods: {
            showMenu: function() {
                ks.app.$refs.mobileMenu.show();
            }
        }

    };

    ks.core.addComponent('header-menu-mobile-button', HeaderMenuMobileButton);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 02.04.2018
 */

(function() {

    var HeaderMenuStandard = {

        data: function() {
            return {
                loaded: false
            };
        },

        computed: {
            kidHasNewProgress: function() {
                return this.$store.state.role === ks.consts.ROLE_KID && this.$store.getters['kid/hasNewProgress'];
            },
            
            kidNewProgressHint: function() {
                if (this.$store.state.role !== ks.consts.ROLE_KID) {
                    return '';
                }
                
                var hint = 'У тебя есть новые ';
                
                if (this.$store.state.kid.hasNewDiplomas) {
                    return hint + 'дипломы';
                }
                
                if (this.$store.state.kid.hasNewAwards) {
                    return hint + 'награды';
                }
                
                if (this.$store.state.kid.hasNewAchievements) {
                    return hint + 'достижения';
                }
            },
            
            promocode: function() {
                return this.$store.state.promocode.active ? this.$store.state.promocode : null;
            },
            
            promocodeDiscountPercent: function() {
                return this.hasPromocodePercent ? '-' + this.promocode.discount + '%' : '';
            },
            
            hasPromocodePercent: function() {
                return this.promocode !== null && this.promocode.discountMode === ks.consts.PROMOCODE_DISCOUNT_MODE_PERCENT && ! this.hasPricePostfix; 
            },
            
            hasPricePostfix: function() {
                return this.$store.state.pricePostfix !== null;
            },
            
            pricePostfix: function() {
                return this.hasPricePostfix ? this.$store.state.pricePostfix : '';
            }
        },

        methods: {
        },

        watch: {
        },

        mounted: function() {
            this.loaded = true;
        }

    };

    ks.core.addComponent('header-menu-standard', HeaderMenuStandard);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 05.10.2017
 */

(function() {

    var HeaderParent = {

        data: function() {
            return {
                loaded: false
            };
        },

        computed: {
            name: function() {
                return ks.helpers.text.capitalizeFirstLetter(this.$store.state.parent.name);
            },

            avatar: function() {
                return this.$store.getters['parent/getAvatarBySize'](ks.consts.AVATAR_SIZE_SMALL);
            },

            icon: function() {
                var gender = this.$store.state.parent.gender;

                return {
                    'fa-male': gender === ks.consts.GENDER_MALE,
                    'fa-female':  gender === ks.consts.GENDER_FEMALE
                };
            },

            canAutoSwitchUser: function(){
                return this.$store.getters['parent/canAutoSwitchToParent'] && this.$store.getters['parent/canAutoSwitchToKid'];
            },

            canInstallApp() {
              return this.$store.getters.canInstallApp;
            }
        },

        methods: {
            switchUser: function(options){
                ks.app.switchUser(options);
            },

            startInstallApp() {
              ks.app.startInstallApp();
            }
        },

        watch: {
        },

        mounted: function() {
            this.loaded = true;
        }

    };

    ks.core.addComponent('header-parent', HeaderParent);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 14.03.2018
 */

(function() {

    var About = {

        data: function() {
            return {
                loaded: false
            };
        },

        computed: {
          canInstallApp() {
            return this.$store.getters.canInstallApp;
          }
        },

        methods: {
            showSignup() {
              ks.app.showSignup();
            },

            startInstallApp() {
              ks.app.startInstallApp();
            }
        },

        mounted: function() {
            this.loaded = true;
        }

    };

    ks.core.addComponent('about', About);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 26.09.2017
 *
 * 24.08.2023:
 * +EVENT_SIGNUP_COMPLETED
 */

(function() {

    var Activation = {

        data: function() {
            return {
                loaded: false,

                seconds: 5
            };
        },

        computed: {
            secondsText: function() {
                var text = this.seconds + ' ';

                switch (this.seconds) {
                    case 1:
                        text += 'секунду';
                        break;
                    case 2:
                    case 3:
                    case 4:
                        text += 'секунды';
                        break;
                    case 5:
                        text += 'секунд';
                        break;
                }

                return text;
            }
        },

        mounted: function() {
            var self = this,
                timer;

            this.loaded = true;

            ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED);
            ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED_EMAIL);

            timer = setInterval(function() {
                self.seconds--;
                if (self.seconds <= 1) {
                    clearInterval(timer);

                    window.location.href = '/';
                }
            }, 1000);
        }

    };

    ks.core.addComponent('activation', Activation);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 27.09.2021
 */

(function() {

    var ChangePassword = {
        
        props: {
            email: {
                type: String,
                required: true
            },
            
            token: {
                type: String,
                required: true
            }
        },

        data: function() {
            return {
                loaded: false,
                
                saved: false,
                
                password: {
                    value: '',
                    error: ''
                },
                
                confirmPassword: {
                    value: '',
                    error: ''
                },
                
                seconds: 5
            };
        },

        computed: {
            passwordHasError: function() {
                return this.password.error !== '';
            },
            
            confirmPasswordHasError: function() {
                return this.confirmPassword.error !== '';
            },
            
            secondsText: function() {
                let text = this.seconds + ' ';

                switch (this.seconds) {
                    case 1:
                        text += 'секунду';
                        break;
                    case 2:
                    case 3:
                    case 4:
                        text += 'секунды';
                        break;
                    case 5:
                        text += 'секунд';
                        break;
                }

                return text;
            }            
        },
        
        methods: {
            validateFields: function(checkEmptyPassword) {
                let passwordError = '', 
                    confirmPasswordError = '';
                
                if (this.password.value === '') {
                    if (checkEmptyPassword) {
                        passwordError = 'Пожалуйста, укажите новый пароль.';
                    }
                } else {
                    if (this.password.value.length < 6) {
                        passwordError = 'Пароль не может быть короче 6 символов.';
                    }

                    if (this.password.value.length > 32) {
                        passwordError = 'Длина пароля не может быть больше 32 символов.';
                    }                     
                }
                
                this.password.error = passwordError;
                
                if (this.confirmPassword.value !== this.password.value) {
                    confirmPasswordError = 'Пароли не совпадают.';
                }
                
                this.confirmPassword.error = confirmPasswordError;
                
                return passwordError === '' && confirmPasswordError === '';
            },
            
            save: function() {
                if (this.saved) {
                    return;
                }
                
                if (this.validateFields(true)) {
                    ks.client.request({
                        controller: 'parent',
                        action: 'change-password',
                        data: {
                            email: this.email,
                            token: this.token,
                            password: this.password.value
                        },
                        onRequest: this.onRequestSave
                    });
                }                
            },
            
            onRequestSave: function(errorCode, data) {
                if (data.redirect) {
                    this.saved = true;
                    return;
                }

                if (data.errors) {
                    for (var field in data.errors) {
                        if (field in this) {
                            this[field].error = data.errors[field];
                        }
                    }
                    
                    if (data.errors.global) {
                        ks.app.$refs.messageBox.show({
                            type    : ks.consts.MBT_ERROR,
                            title   : 'Ошибка',
                            text    : data.errors.global,
                            buttons : ks.consts.MBB_CLOSE
                        });
                    }
                }
                else {
                    if (errorCode !== ks.consts.ERR_OK) {
                        ks.app.$refs.messageBox.show({
                            type    : ks.consts.MBT_ERROR,
                            title   : 'Ошибка',
                            text    : ks.consts.ERR_UNKNOWN_STR_EX,
                            buttons : ks.consts.MBB_CLOSE
                        });                        
                    } else {
                        this.saved = true;
                        
                        let self = this;
                        this.$nextTick(function(){
                            self.startRedirect();                        
                        });
                    }
                }                
            },
            
            startRedirect: function() {
                let self = this,
                    timer;
            
                timer = setInterval(function() {
                    self.seconds--;
                    if (self.seconds <= 1) {
                        clearInterval(timer);

                        window.location.href = '/';
                    }
                }, 1000);                
            }
        },
        
        watch: {
            'password.value': function() {
                this.validateFields(false);
            }, 
            
            'confirmPassword.value': function() {
                this.validateFields(false);
            }            
        },

        mounted: function() {
            this.loaded = true;
        }

    };

    ks.core.addComponent('change-password', ChangePassword);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 14.03.2018
 * 
 * 24.08.2023:
 * +EVENT_CONTACTS_MESSAGE
 */

(function() {

    var Contacts = {

        data: function() {
            return {
                loaded: false,
                
                supportEmail: 'support@kids-smart.ru',
                
                errorInit: false,
                
                token: '',
                
                subject: {
                    value: '',
                    error: ''
                },
                
                name: {
                    value: '',
                    error: '',
                    enabled: true
                },                
                
                email: {
                    value: '',
                    error: '',
                    enabled: true
                },  
                
                text: {
                    value: '',
                    error: ''
                },       
                
                agreePersonalData: {
                    value: false,
                    error: '',
                    enabled: true
                },
                
                isMessageSent: false
            };
        },

        computed: {
            mailToSrc: function() {
                return 'mailto:' + this.supportEmail;
            },
            
            subjectHasError: function() {
                return this.subject.error !== '';
            },
            
            nameHasError: function() {
                return this.name.error !== '';
            },
            
            emailHasError: function() {
                return this.email.error !== '';
            },
            
            textHasError: function() {
                return this.text.error !== '';
            },
            
            agreePersonalDataHasError: function() {
                return this.agreePersonalData.error !== '';
            },
            
            successText: function() {
                return this.isMessageSent && ! this.errorInit ? 
                  '<b>Спасибо! Ваше сообщение отправлено!</b><br />В ближайшее время мы рассмотрим его и ответим вам.' : '';
            }
        },
        
        methods: {
            init: function() {
                ks.client.request({
                    controller: 'contacts',
                    action: 'init',
                    onRequest: this.onRequestInit
                });                
            },
            
            onRequestInit: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR, false);
                    
                    this.errorInit = true;
                } else {
                    this.token = data.token;

                    if ( ! this.$store.getters.isGuest) {
                        this.name.value = this.$store.state.parent.name;
                        this.name.enabled = false;

                        this.email.value = data.email;
                        this.email.enabled = false;
                        
                        this.agreePersonalData.value = true;
                        this.agreePersonalData.enabled = false;
                    }
                }
                
                this.loaded = true;
            },
            
            onSend: function() {
                this.$refs.alert.hide();
                
                if (this.validateFields()) {
                    ks.client.request({
                        controller: 'contacts',
                        action: 'send',
                        data: {
                            token: this.token,
                            subject: this.subject.value,
                            name: this.name.value,
                            email: this.email.value,
                            text: this.text.value
                        },
                        onRequest: this.onRequestSend
                    });
                    
                    ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_CONTACTS_MESSAGE);
                }
            },

            validateFields: function() {
                return this.validateSubject() & this.validateName() & this.validateEmail() & this.validateText() & this.validateAgreePersonalData();
            },
            
            validateSubject: function() {
                /*
                if (this.subject.value === '') {
                    this.subject.error = 'Пожалуйста, укажите тему сообщения.';
                    return false;
                }
                */

                if (this.subject.length > 200) {
                    this.subject.error = 'Слишком длинная тема сообщения.';
                    return false;
                }

                this.subject.error = '';

                return true;
            },            

            validateName: function() {
                if (this.name.value === '') {
                    this.name.error = 'Пожалуйста, укажите ваше имя.';
                    return false;
                }

                if (this.name.length > 50) {
                    this.name.error = 'Слишком длинное имя.';
                    return false;
                }

                this.name.error = '';

                return true;
            },
            
            validateEmail: function() {
                if (this.email.value === '') {
                    this.email.error = 'Пожалуйста, укажите ваш email.';
                    return false;
                }

                if ( ! ks.validator.validateEmail(this.email.value)) {
                    this.email.error = 'Пожалуйста, укажите корректный email.';
                    return false;
                }

                this.email.error = '';

                return true;
            },
            
            validateText: function() {
                if (this.text.value === '') {
                    this.text.error = 'Пожалуйста, введите текст сообщения.';
                    return false;
                }

                if (this.text.length > 2500) {
                    this.text.error = 'Слишком длинный текст сообщения.';
                    return false;
                }

                this.text.error = '';

                return true;
            },    
            
            validateAgreePersonalData: function() {
                if ( ! this.agreePersonalData.value) {
                    this.agreePersonalData.error = 'Необходимо согласиться с условиями Политики конфиденциальности.';
                    return false;
                }

                this.agreePersonalData.error = '';

                return true;                
            },

            onRequestSend: function(errorCode, data) {
                if (data.errors) {
                    for (var field in data.errors) {
                        if (field in this) {
                            this[field].error = data.errors[field];
                        }
                    }

                    if (data.errors.global) {
                        this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR, true);
                    }
                }
                else {
                    this.token = data.token;
                    this.isMessageSent = true;
                    this.clear();
                }
            },
            
            sendAgain: function() {
                this.isMessageSent = false;
            },
            
            clear: function() {
                this.subject.value = '';
                this.subject.error = '';
                
                if (this.name.enabled) {
                    this.name.value = '';
                    this.name.error = '';
                }
                
                if (this.email.enabled) {
                    this.email.value = '';
                    this.email.error = '';
                }
                
                if (this.agreePersonalData.enabled) {
                    this.agreePersonalData.value = false;
                    this.agreePersonalData.error = '';
                }
                
                this.text.value = '';
                this.text.error = '';
            }
        },
        
        watch: {
            'email.value': function() {
                if (this.email.value !== '') {
                    this.email.error = '';
                }
            },

            'subject.value': function() {
                if (this.subject.value !== '') {
                    this.subject.error = '';
                }
            },
            
            'name.value': function() {
                if (this.name.value !== '') {
                    this.name.error = '';
                }
            },

            'text.value': function() {
                if (this.text.value !== '') {
                    this.text.error = '';
                }
            },
            
            'agreePersonalData.value': function() {
                if (this.agreePersonalData.value) {
                    this.agreePersonalData.error = '';
                }
            }
        },

        mounted: function() {
            var self = this;
            ks.core.addAppCreateEvent(function(){
                self.init();
            });
        }

    };

    ks.core.addComponent('contacts', Contacts);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 22.03.2019
 * 
 * <span id="doc-info-ip"
 * <span id="doc-info-inn"
 */

(function() {

    var Doc = {

        data: function() {
            return {
                loaded: false
            };
        },

        computed: {

        },
        
        methods: {
            init: function() {
                /*
                 * 19.06.2020: Отключили получение данных ИП по запросу. 
                 * Теперь все данные прописаны в тексте договора.
                ks.client.request({
                    controller: 'doc',
                    action: 'info',
                    onRequest: this.onGetInfo
                });
                */ 
               
                this.loaded = true;
            },
            
            onGetInfo: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    return false;
                }               
                
                $('#doc-info-ip').text(this.decodeStr(data.ip));
                $('#doc-info-inn').text(this.decodeStr(data.inn));
                
                this.loaded = true;
            },
            
            decodeStr: function(str) {
                var isBot = this.$store.state.isBot;
                
                return isBot ? '' : decodeURI(window.atob(str));
            },
            
            scroll: function(section) {
                $('html, body').stop().animate({
                    scrollTop: $(section).offset().top - 60
                }, 800);                
            }
        },

        mounted: function() {
            var self = this;
            ks.core.addAppCreateEvent(function(){
                self.init();
            });            
        }

    };

    ks.core.addComponent('doc', Doc);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 13.05.2023
 * 
 */

(function() {
    
    var STATE_FORM    = 0,
        STATE_SENDED  = 1,
        
        MODE_REQUEST  = 'request',
        MODE_QUESTION = 'question';

    var Partners = {
        
        props: {
            
        },

        data: function() {
            return {
                mode  : MODE_REQUEST,
                state : STATE_FORM,
                
                email: {
                    value: '',
                    error: ''
                },

                name: {
                    value: '',
                    error: ''
                },

                text: {
                    value: '',
                    error: '',
                    placeholder: ''
                },
                
                agree: {
                    value: false,
                    error: ''
                },
                
                button: {
                    number: null,
                    text: ''
                },
                
                sendedText: ''
            };
        },

        computed: {
            isStateForm: function() {
                return this.state === STATE_FORM;
            },
            
            isStateSended: function() {
                return this.state === STATE_SENDED;
            },
            
            hasEmailError: function() {
                return this.email.error !== '';
            },
            
            hasNameError: function() {
                return this.name.error !== '';
            },
            
            hasTextError: function() {
                return this.text.error !== '';
            },
            
            hasAgreeError: function() {
                return this.agree.error !== '';
            }
        },
        
        methods: {
            clear: function() {
                this.state = STATE_FORM;
                
                this.email.value = '';
                this.email.error = '';
                
                this.name.value = '';
                this.name.error = '';
                
                this.text.value = '';
                this.text.error = '';
                
                this.agree.value = false;
                this.agree.error = '';
            },
            
            doRequest: function(buttonNumber, mode) {
                this.clear();
                
                this.mode = mode || MODE_REQUEST;
                this.button.number = buttonNumber || 0;
                this.button.text  = this.mode === MODE_REQUEST ? 'Подать заявку' : 'Задать вопрос';
                this.text.placeholder = this.mode === MODE_REQUEST ? 'Расскажите о себе' : 'Текст вопроса';
                
                $('#partners-request-dlg').modal('show');
                
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_PARTNERS_START_REQUEST);
            },
            
            send: function() {
                if ( ! this.validate()) {
                    return;
                }
                
                ks.client.request({
                    controller: 'partners',
                    action: 'request',
                    data: {
                        button : this.button.number,
                        email  : this.email.value,
                        name   : this.name.value,
                        text   : this.text.value
                    },
                    onRequest: this.onSend
                });
                
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_PARTNERS_START_REQUEST);
            },
            
            onSend: function(errorCode, data) {
                if (data.errors) {
                    ks.app.$refs.messageBox.show({
                        type    : ks.consts.MBT_ERROR,
                        title   : 'Отправка запроса',
                        text    : data.errors.global,
                        buttons : ks.consts.MBB_OK
                    });                        
                }
                else {
                    this.sendedText = data.text;
                    this.state = STATE_SENDED;
                }                
            },
            
            toggleAgree: function() {
                this.agree.value = ! this.agree.value;
                if (this.agree.value) {
                    this.agree.error = '';
                }
            },
            
            validate: function() {
                return this.validateEmail() && 
                       this.validateName() &&  
                       this.validateText() &&
                       this.validateAgree();
            },
            
            validateEmail: function() {
                if (this.email.value === '') {
                    this.email.error = 'Пожалуйста, укажите ваш email.';
                    return false;
                }

                if ( ! ks.validator.validateEmail(this.email.value)) {
                    this.email.error = 'Пожалуйста, укажите корректный email.';
                    return false;
                }

                this.email.error = '';

                return true;
            },
            
            validateName: function() {
                if (this.name.value === '') {
                    this.name.error = 'Пожалуйста, укажите ваше имя.';
                    return false;
                }

                this.name.error = '';

                return true;
            },
            
            validateText: function() {
                if (this.text.value === '') {
                    this.text.error = this.mode === MODE_REQUEST ? 'Пожалуйста, расскажите о себе.' : 'Пожалуйста, напишите ваш вопрос.';
                    return false;
                }

                this.text.error = '';

                return true;
            },            
            
            validateAgree: function() {
                if ( ! this.agree.value) {
                    this.agree.error = 'Необходимо ваше согласие.';
                    return false;
                }
                
                this.agree.error = '';
                
                return true;
            }
            
        },
        
        watch: {
            'email.value': function(newValue) {
                this.email.error = '';
            },
            
            'name.value': function(newValue) {
                this.name.error = '';
            },
            
            'text.value': function(newValue) {
                this.text.error = '';
            }
        },

        mounted: function() {
            $('.collapse').on('show.bs.collapse', function() {
                var img = document.getElementById(this.id + '-img');
                img.classList.add('shown');
            });  
            
            $('.collapse').on('hide.bs.collapse', function() {
                var img = document.getElementById(this.id + '-img');
                img.classList.remove('shown');
            }); 
            
            $('#partners-request-dlg').on('shown.bs.modal', function() {
                $('#email').focus();
            });
        }

    };

    ks.core.addComponent('partners', Partners);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 13.12.2022
 * 
 * 14.06.2023:
 * Переписано для оплаты под гостем
 */

(function() {

    var Payment = {
        
        props: {
            wheelFortuneShow: {
                type: Boolean,
                default: false
            },
            
            initPromocode: {
                type: String,
                default: ''
            },
            
            guestPayment: {
                type: Boolean,
                default: true
            }
        },

        data: function() {
            return {
                loaded: false,
                
                promocode: {
                    value: '',
                    
                    discountMode: -1,
                    
                    active: false,
                    discount: 0,
                    timeLeft: '',
                    periods: [],
                    error: ''
                }                
            };
        },
        
        methods: {
            showSignup: function(options){
                ks.app.showSignup(options);
            },
            
            showWheelFortune: function() {
                ks.app.showWheelFortuneDlg();
            },
            
            doPayment(period/*, alternativeMode*/) {
                if (! this.guestPayment) {
                    ks.app.showSignup();
                    
                    return;
                }
                
                var params = {
                    p  : period.id//,
                    //am : alternativeMode ? 1 : 0
                };
        
                if (this.promocode.active && ! this.$refs.periods.isDisabledPromocode(period)) {
                    params.pc = this.promocode.value;
                }                
                
                var urlParams = new URLSearchParams(params);
                
                ks.app.go('/payment/order?' + urlParams.toString());
            },
            
            /**
             * Установить промокод. Внимание! Ф-ия вызывается из ks.app
             * @param {string} promocode
             * @param {boolean} apply
             * @param {boolean} autoMode
             * @returns {void}
             */
            setPromocode: function(promocode, apply, autoMode){
                if (this.promocode.active){
                    this.$refs.promocode.clear();
                }
                
                this.promocode.value = promocode;
                this.$refs.promocode.show();
                
                if (apply) {
                    this.$refs.promocode.apply(typeof autoMode !== 'undefined' ? autoMode : false);
                }
            }            
        },

        mounted: function() {
            this.loaded = true;
            
            if (this.initPromocode !== '') {
                var self = this;
                this.$nextTick(function(){
                    self.promocode.value = self.initPromocode;

                    self.$refs.promocode.show();
                    self.$refs.promocode.apply(true);  
                });
            }            
            
            if (this.wheelFortuneShow) {
                this.$nextTick(function(){
                    setTimeout(function(){
                        ks.app.showWheelFortuneDlg();
                    }, 500);
                });
            }            
        }

    };

    ks.core.addComponent('payment', Payment);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 19.07.2019
 * 
 */

(function() {

    var Promo = {
        
        props: {
            promocode: {
                type: String,
                default: ''
            }
        },

        data: function() {
            return {
                loaded: false,
                
                msgCopyVisible: false
            };
        },

        computed: {
            
        },
        
        methods: {
            copyPromocode: function() {
                ks.helpers.clipboard.copyText(this.promocode, this.onCopyEvent);
            },
            
            onCopyEvent: function(success) {
                if (success) {
                    this.msgCopyVisible = true;
                    
                    var self = this;
                    setTimeout(function() {
                        self.msgCopyVisible = false;
                    }, 5000);
                }
            },
            
            showLogin: function() {
                ks.app.showLogin();
            }
        },

        mounted: function() {
            this.loaded = true;
        }

    };

    ks.core.addComponent('promo', Promo);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 21.09.2017
 */

(function() {

    var Signup = {

        data: function() {
            return {
                loaded: false,

                email: {
                    value: '',
                    error: '',
                    checkMisprint: true
                },

                password: {
                    value: '',
                    error: ''
                },

                userAgreement: {
                    value: false,
                    error: ''
                },
                
                lastRequestError: 0,

                isActivationSent: false
            };
        },

        computed: {
            emailHasError: function() {
                return this.email.error !== '';
            },

            passwordHasError: function() {
                return this.password.error !== '';
            },

            userAgreementHasError: function() {
                return this.userAgreement.error !== '';
            },
            
            isEmailLoginVisible: function(){
                return this.lastRequestError === ks.consts.ERR_EMAIL_ALREADY_EXISTS;
            },
            
            infoText: function(){
                return this.isActivationSent ? 'Подтвердите вашу почту' : 'Для начала занятий и<br /> сохранения прогресса обучения пройдите регистрацию:';
            },
            
            formClass: function(){
                return {
                    'completed': this.isActivationSent
                };
            }
        },

        methods: {
            showLogin: function(){
                ks.app.showLogin(this.email.value);
            },
            
            onRegistration: function() {
                if (this.validateFields()) {
                    this.lastRequestError = 0;
                    
                    ks.client.request({
                        controller: 'parent',
                        action: 'signup',
                        data: {
                            email: this.email.value,
                            password: this.password.value,
                            
                            check_email_misprint: this.email.checkMisprint
                        },
                        onRequest: this.onRequestRegistration
                    });
                }
            },

            validateFields: function() {
                return this.validateEmail() & this.validatePassword() & this.validateUserAgreement();
            },

            validateEmail: function() {
                if (this.email.value === '') {
                    this.email.error = 'Пожалуйста, укажите ваш email.';
                    return false;
                }

                if ( ! ks.validator.validateEmail(this.email.value)) {
                    this.email.error = 'Пожалуйста, укажите корректный email.';
                    return false;
                }

                this.email.error = '';

                return true;
            },

            validatePassword: function() {
                if (this.password.value === '') {
                    this.password.error = 'Пожалуйста, укажите пароль.';
                    return false;
                }

                if (this.password.value.length < 6) {
                    this.password.error = 'Пароль не может быть короче 6 символов.';
                    return false;
                }
                
                if (this.password.value.length > 32) {
                    this.password.error = 'Длина пароля не может быть больше 32 символов.';
                    return false;
                }

                this.password.error = '';

                return true;
            },

            validateUserAgreement: function() {
                // 27.05.2021 Отключили
                return true;
                /*
                if ( ! this.userAgreement.value) {
                    this.userAgreement.error = 'Необходимо принять пользовательское соглашение.';
                    return false;
                }

                this.userAgreement.error = '';

                return true;*/
            },

            onRequestRegistration: function(errorCode, data) {
                if (data.redirect) {
                    return;
                }

                if (data.errors) {
                    this.lastRequestError = data.error;
                    
                    for (var field in data.errors) {
                        if (field in this) {
                            this[field].error = data.errors[field];
                        }
                    }
                    
                    if (errorCode === ks.consts.ERR_EMAIL_MISPRINT) {
                        ks.app.$refs.messageBox.show({
                            type     : ks.consts.MBT_QUESTION,
                            title    : 'Внимание',
                            text     : data.errors.global,
                            buttons  : ks.consts.MBB_YES_NO,
                            onClose  : this.onCloseEmailMisprintDialog,
                            userData : {
                                possibleEmail: data.possibleEmail
                            }
                        });
                    } else {
                        if (data.errors.global) {
                            ks.app.$refs.messageBox.show({
                                type    : ks.consts.MBT_ERROR,
                                title   : 'Ошибка',
                                text    : data.errors.global,
                                buttons : ks.consts.MBB_CLOSE
                            });
                        }
                    }
                }
                else {
                    this.isActivationSent = true;
                    
                    // VK Pixel Ретаргетинг
                    ks.vk.Retargeting.onEvent(ks.vk.Retargeting.EVENT_CLICK_SIGNUP);

                    ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_PAGE);
                }
            },
            
            onCloseEmailMisprintDialog: function(modalResult, userData) {
                var send = false;
                
                switch (modalResult) {
                    case ks.consts.MBB_YES:
                        this.email.value = userData.possibleEmail;
                        this.email.checkMisprint = false;
                        send = true;
                        break;
                    
                    case ks.consts.MBB_NO:
                        this.email.checkMisprint = false;
                        send = true;
                        break;
                }
                
                if (send) {
                    this.onRegistration();
                }
            }
        },

        watch: {
            'email.value': function() {
                if (this.email.value !== '') {
                    this.email.error = '';
                }
            },

            'password.value': function() {
                if (this.password.value !== '') {
                    this.password.error = '';
                }
            },

            'userAgreement.value': function() {
                if (this.userAgreement.value) {
                    this.userAgreement.error = '';
                }
            }
        },

        mounted: function() {
            this.loaded = true;
        }

    };

    ks.core.addComponent('signup', Signup);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 25.07.2018
 * 
 *  17.08.2021:
 *   + 'exercise-item-add-image-row-answer' component 
 */

(function() {
    
    
    //--
    Vue.component('exercise-item-add-image-row-answer', {
        template: 
            '<div class="exercise-item-answers-item-container" :style="answerStyle">'+
            '    <div class="exercise-item-answers-item" :class="answerClass" v-hammer:tap="onTap" @mouseenter="onMouseEnterAnswer">'+
            '        <img :src="answerImageSrc" />'+
            '    </div>'+
            '</div>',    
    
        props: {
            answerStyle: {
                type: Object,
                required: true
            },
            
            answerClass: {
                type: Object,
                required: true
            },
            
            answerImageSrc: {
                type: String,
                required: true
            }
        }, 
        
        data: function() {
            return {};
        },
        
        methods: {
            onTap: function(){
                this.$emit('click');
            },
            
            onMouseEnterAnswer: function(){
                this.$emit('mouseenter');
            }
        }
    });
    //--     

    Vue.component('exercise-item-add-image-row', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                rowImages: [],
                
                answers: [],                
                
                isMainPage: false,
                
                state: -1,
                
                answerComment: '',
                
                text: ''
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },
            
            imageRowStyle: function() {
                if (this.exercise === null || this.rowImages.length <= 0) {
                    return {};
                }                
                
                return {
                    width: 100 / this.rowImages.length + '%'
                };
            },
            
            answerStyle: function() {
                if (this.exercise === null) {
                    return {};
                }
                
                return {
                    width: 100 / this.exercise.answers.columns + '%'
                }; 
            },
            
            answerMultiselect: function() {
                return this.exercise !== null ? this.exercise.answers.multiselect : false;
            },
            
            isQuestionState: function() {
                return this.state === ks.consts.EXERCISE_STATE_QUESTION;
            },
            
            isInvalidAnswerState: function() {
                return this.state === ks.consts.EXERCISE_STATE_INVALID_ANSWER;
            },
            
            isCommentEmpty: function() {
                return this.answerComment === '';
            }
        },
        
        methods: {
            init: function() {
                this.isMainPage = false;
                this.state = ks.consts.EXERCISE_STATE_QUESTION;
                this.answerComment = '';
                this.correctAnswer = [];  
                this.rowImages = [];
                this.answers = [];
                this.text = '';
            },
            
            load: function(exercise) {
                this.exercise = exercise;
                
                this.init();    
                
                this.$refs.standard.load(exercise);
                
                this.loadRowImages();
                this.loadAnswers();    
                
                this.loaded = true;
            },
            
            unload: function() {
                if (this.loaded) {
                    this.loaded = false;

                    this.$refs.standard.unload();

                    this.init(); 

                    this.exercise = null;
                }
            },
            
            loadRowImages: function() {
                this.rowImages = this.exercise.rowImages;
            },
            
            loadAnswers: function() {
                this.answers = [];
                for (var i = 0; i < this.exercise.answers.items.length; i++) {
                    this.answers.push({
                        url: this.exercise.answers.items[i],
                        selected: false
                    });
                }       
            },
            
            onClickAnswer: function(answer) {
                if (this.exercise.answers.multiselect) {
                    ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                    answer.selected = ! answer.selected;
                } else {
                    if ( ! answer.selected) {
                        ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                        answer.selected = true;
                        for (var i = 0; i < this.answers.length; i++) {
                            if (this.answers[i] !== answer) {
                                this.answers[i].selected = false;
                            }
                        }
                    }
                }
                
                // Прячем подсказку о том, что нужно выбрать ответ
                this.$refs.answerAlert.hide();
            },
            
            getSelectedAnswers: function() {
                var selectedAnswers = [];
                
                for (var i = 0; i < this.answers.length; i++) {
                    if (this.answers[i].selected) {
                        selectedAnswers.push(i);
                    }
                }
                
                return selectedAnswers;
            },
            
            onAnswer: function() {
                var selectedAnswers = this.getSelectedAnswers();
                
                if (selectedAnswers.length === 0) {
                    var info = this.exercise.answers.multiselect ?
                            { text: 'Нужно выбрать хотя бы один ответ', sound: ks.sounds.NEED_SELECT_LEAST_ONE_ANSWER } :
                            { text: 'Нужно выбрать ответ', sound: ks.sounds.NEED_SELECT_ANSWER };
                    
                    this.$refs.answerAlert.show(info.text, ks.consts.ALERT_INFO);
                    this.$emit('play-sound', info.sound);
                    
                    return;
                }
                
                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: selectedAnswers
                }, this.onCheckAnswer);                
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                this.text = data.message.text;
                
                if ( ! data.correct) {
                    this.state = ks.consts.EXERCISE_STATE_INVALID_ANSWER;
                    
                    for (var i = 0; i < data.correctAnswer.length; i++) {
                        this.$set(this.answers[data.correctAnswer[i]], 'isCorrect', true);
                    }
                    
                    if (data.comment) {
                        this.answerComment = data.comment;
                    }
                    
                    this.$emit('answer', false, data.message, true);
                    
                    return;
                }
                
                this.state = ks.consts.EXERCISE_STATE_CORRECT_ANSWER;
                
                this.$emit('answer', true, data.message, true);
            },
            
            onMouseEnterAnswer: function(answer) {
                if ( ! answer.selected) {
                    ks.soundManager.playEffect(ks.sounds.ANSWER_HOVER);
                }
            },
            
            onMouseEnterSendAnswer: function() {
                ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER);
            },
            
            showMainPage: function() {
                this.isMainPage = true;
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            onShowComment: function() {
                ks.app.$refs.answerCommentDlg.show(this.answerComment);
            }
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 25.09.2018
 * 
 *  17.08.2021:
 *   + 'exercise-item-cut-shape-answer' component
 */

(function () {
    
    var DEFAULT_SHAPE_SIZE = 200; // px
    
    //--
    Vue.component('exercise-item-cut-shape-answer', {
        template: 
            '<div class="exercise-item-cut-shape-answer" :class="answerClass" v-hammer:tap="onTap" @mouseenter="onMouseEnterAnswer" @mouseleave="onMouseLeaveAnswer">'+
            '    <div class="cut-shape-answer-img" :style="answerImgStyle">'+
            '        <div class="cut-shape-answer-img-bg" :style="answerImgBgStyle" ></div>'+
            '        <img class="cut-shape-answer-img-shape" :src="answerImgShapeSrc" :style="answerImgStyle" />'+
            '    </div>'+
            '</div>',    
    
        props: {
            answerClass: {
                type: Object,
                required: true
            },
            
            answerImgStyle: {
                type: Object,
                required: true
            },
            
            answerImgBgStyle: {
                type: Object,
                required: true                
            },
            
            answerImgShapeSrc: {
                type: String,
                required: true 
            }
        }, 
        
        data: function() {
            return {};
        },
        
        methods: {
            onTap: function(){
                this.$emit('click');
            },
            
            onMouseEnterAnswer: function(){
                this.$emit('mouseenter');
            },
            
            onMouseLeaveAnswer: function(){
                this.$emit('mouseleave');
            }
        }
    });
    //--       
    
    Vue.component('exercise-item-cut-shape', {
        data: function () {
            return {
                exercise: null,

                loaded: false,

                isMainPage: false,

                state: -1,

                answerComment: '',

                text: '',

                resizeTimer: null,

                // Размер изображения в зависимости от размера окна браузера
                imageWidth: 0,
                imageHeight: 0,

                // Сдвиг контейнера изображения по оси x для центрирования
                containerOffset: 0,

                // Вырезанные формы
                cutShapes: [],

                // Элементы-ответы
                answers: [],
                
                // Правильные ответы
                correctAnswers: []
            };
        },

        computed: {
            exerciseId: function () {
                return this.exercise !== null ? this.exercise.id : -1;
            },

            // Сдвиг контейнера элементов для центрирования
            imgContainerStyle: function () {
                return {
                    height: this.imageHeight + 'px'
                };
            },
            
            imageStyle: function() {
                return {
                    position: 'absolute',
                    left: this.containerOffset + 'px',
                    top: '0px',
                    width: this.imageWidth + 'px',
                    height: this.imageHeight + 'px'
                };
            },

            isQuestionState: function () {
                return this.state === ks.consts.EXERCISE_STATE_QUESTION;
            },

            isInvalidAnswerState: function () {
                return this.state === ks.consts.EXERCISE_STATE_INVALID_ANSWER;
            },

            isCommentEmpty: function () {
                return this.answerComment === '';
            },

            hasEntryPage: function () {
                if (this.exercise === null) {
                    return false;
                }

                return typeof this.exercise.extra !== 'undefined' && this.exercise.extra.enabled;
            },

            showInitialState: function () {
                if (this.exercise === null || !this.exercise.showInitialState) {
                    return false;
                }

                return (!this.isMainPage || !this.hasEntryPage);
            },

            imageSrc: function () {
                return this.exercise === null ? '' : this.exercise.image.url;
            },

            answerMultiselect: function () {
                return this.exercise === null ? false : this.cutShapes.length > 1;
            },
            
            shapeSize: function() {
                if (this.exercise === null) {
                    return 0;
                }
                
                var size = DEFAULT_SHAPE_SIZE * this.exercise.shapeScale / 100;
                
                return this.imageWidth / this.exercise.image.width * size;
            },

            answerImgStyle: function () {
                return {
                    width: this.shapeSize + 'px',
                    height: this.shapeSize + 'px'
                };
            }
        },

        methods: {
            init: function () {
                this.isMainPage = false;
                this.state = ks.consts.EXERCISE_STATE_QUESTION;
                this.answerComment = '';
                this.correctAnswer = [];
                this.text = '';
                this.containerOffset = 0;
                this.answers = [];
            },

            load: function (exercise) {
                this.exercise = exercise;

                this.init();

                this.$refs.standard.load(exercise);

                this.loadCutShapes();
                this.loadAnswers();

                window.addEventListener('resize', this.onWindowResize);

                this.loaded = true;

                var self = this;
                this.$nextTick(function () {
                    self.calcSizes();
                });
            },

            unload: function () {
                if (this.loaded) {
                    window.removeEventListener('resize', this.onWindowResize);

                    this.cutShapes = [];
                    this.answers = [];
                    this.correctAnswers = [];
                    this.containerOffset = 0;
                    
                    this.imageWidth = 0;
                    this.imageHeight = 0;

                    this.loaded = false;

                    this.$refs.standard.unload();

                    this.init();

                    this.exercise = null;
                }
            },

            // При изменении экрана (но не чаще 300 мс) изменяем размер элементов
            onWindowResize: function () {
                if (this.resizeTimer !== null) {
                    clearTimeout(this.resizeTimer);
                    this.resizeTimer = null;
                }

                var self = this;
                this.resizeTimer = setTimeout(function () {
                    self.calcSizes();
                    self.resizeTimer = null;
                }, 300);
            },

            calcSizes: function () {
                var width = this.$refs.imgContainer.offsetWidth;

                this.imageWidth = width > this.exercise.image.width ? this.exercise.image.width : width - 8;
                this.containerOffset = (width - this.imageWidth) / 2;

                var coef = this.exercise.image.width / this.exercise.image.height;
                this.imageHeight = this.imageWidth / coef;
            },

            loadCutShapes: function () {
                this.cutShapes = JSON.parse(this.exercise.cutShapes);
            },

            loadAnswers: function () {
                var answers = JSON.parse(this.exercise.answers.items);

                for (var i = 0; i < answers.length; i++) {
                    answers[i].selected = false;
                    answers[i].mouseHover = false;
                }

                this.answers = answers;
            },

            getAnswerImgBgStyle: function (answer) {
                if (this.exercise === null) {
                    return {};
                }
                
                var left = this.imageWidth / this.exercise.image.width * answer.shape.left,
                    top = this.imageHeight / this.exercise.image.height * answer.shape.top;    
                
                return {
                    'width': this.shapeSize + 'px',
                    'height': this.shapeSize + 'px',
                    'line-height': this.shapeSize + 'px',
                    'background-image': 'url(' + this.exercise.basePath + answer.imageUrl + ')',
                    'background-position': '-' + left + 'px -' + top + 'px',
                    'background-size': this.imageWidth + 'px ' + this.imageHeight + 'px'
                };
            },
            
            getAnswerImgShapeSrc: function(answer, index, answerMode, correctAnswerMode) {
                if (this.exercise === null) {
                    return '';
                }
                
                var name = answer.shape.name;
                
                if ( ! answerMode) {
                    if (answer.selected) {
                        name += '_green';
                    } else if (answer.mouseHover) {
                        name += '_blue';
                    } else {
                        name += '_white';
                    }
                } else {
                    if (correctAnswerMode && this.correctAnswers.indexOf(index) > -1) {
                        name += '_green';
                    }
                    else if ( ! correctAnswerMode && answer.selected) {
                        name += '_red';
                    } else {
                        name += '_white';
                    }
                }
                
                return this.exercise.baseShapePath + name + '.png';
            },
            
            getAnswerClass: function(answer, index, answerMode, correctAnswerMode) {
                if ( ! answerMode) {
                    return {
                        selected: answer.selected
                    };
                } else {
                    return {
                        'default-answer': (correctAnswerMode && this.correctAnswers.indexOf(index) < 0) || ( ! correctAnswerMode && ! answer.selected),
                        'correct-answer': correctAnswerMode && this.correctAnswers.indexOf(index) > -1,
                        'incorrect-answer': ! correctAnswerMode && answer.selected
                    };
                }
            },
            
            onMouseEnterAnswer: function(answer) {
                if ( ! answer.selected) {
                    ks.soundManager.playEffect(ks.sounds.ANSWER_HOVER);
                }
                
                // 17.08.2021
                if (ks.browser.isMobile.any() || ks.browser.isTouch()) {
                    return;
                }
                //--
                
                answer.mouseHover = true;
            },            
            
            onMouseLeaveAnswer: function(answer) {
                answer.mouseHover = false;
            }, 
            
            getCutShapeSrc: function(shape) {
                return this.exercise === null ? '' : this.exercise.baseShapePath + shape.name + '.png';
            },
            
            getCutShapeStyle: function(shape) {
                if (this.exercise === null) {
                    return {};
                }
                
                var left = this.containerOffset + this.imageWidth / this.exercise.image.width * shape.left,
                    top = this.imageHeight / this.exercise.image.height * shape.top;                 
                
                return {
                    width: this.shapeSize + 'px',
                    height: this.shapeSize + 'px',
                    left: left + 'px',
                    top: top + 'px'
                };
            },
            
            onClickAnswer: function (answer) {
                if ( ! this.answerMultiselect) {
                    
                    if (answer.selected) {
                        return;
                    }
                    
                    answer.selected = true;
                } else {
                    answer.selected = ! answer.selected;
                }

                ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                
                if ( ! this.answerMultiselect) {
                    for (var i = 0; i < this.answers.length; i++) {
                        if (this.answers[i] !== answer && this.answers[i].selected) {
                            this.answers[i].selected = false;
                        }
                    }
                }
            },
            
            getSelectedAnswers: function() {
                var selectedAnswers = [];
                
                for (var i = 0; i < this.answers.length; i++) {
                    if (this.answers[i].selected) {
                        selectedAnswers.push(i);
                    }
                }
                
                return selectedAnswers;
            },

            onAnswer: function () {
                var selectedAnswers = this.getSelectedAnswers();
                
                if (selectedAnswers.length === 0) {
                    var info = this.exercise.answers.multiselect ?
                            { text: 'Нужно выбрать хотя бы один ответ', sound: ks.sounds.NEED_SELECT_LEAST_ONE_ANSWER } :
                            { text: 'Нужно выбрать ответ', sound: ks.sounds.NEED_SELECT_ANSWER };
                    
                    this.$refs.answerAlert.show(info.text, ks.consts.ALERT_INFO);
                    this.$emit('play-sound', info.sound);
                    
                    return;
                }

                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: selectedAnswers
                }, this.onCheckAnswer);
            },

            onCheckAnswer: function (errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }

                this.text = data.message.text;

                if ( ! data.correct) {
                    this.state = ks.consts.EXERCISE_STATE_INVALID_ANSWER;

                    if (data.comment) {
                        this.answerComment = data.comment;
                    }
                    
                    this.correctAnswers = data.correctAnswer.split(',').map(function(currentValue) {
                        return parseInt(currentValue, 10);
                    });

                    this.$emit('answer', false, data.message, true);

                    var self = this;
                    this.$nextTick(function () {
                        self.calcSizes();
                    });

                    return;
                }

                this.state = ks.consts.EXERCISE_STATE_CORRECT_ANSWER;

                this.$emit('answer', true, data.message, true);
            },

            onMouseEnterSendAnswer: function () {
                ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER);
            },

            showMainPage: function () {
                this.isMainPage = true;

                var self = this;
                this.$nextTick(function () {
                    self.calcSizes();
                });
            },

            onNext: function () {
                this.unload();
                this.$emit('next');
            },

            onShowComment: function () {
                ks.app.$refs.answerCommentDlg.show(this.answerComment);
            }
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 14.04.2022-06.05.2022
 * 
 * 
 */

(function() {
    
    const MATH_TIME_QUESTION_TYPE_LEFT   = 0,
          MATH_TIME_QUESTION_TYPE_RIGHT  = 1,
          MATH_TIME_QUESTION_TYPE_RESULT = 2;    
    
    const States = {
            MAIN   : 1,
            FINISH : 2
        };    

    Vue.component('exercise-item-math-time', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                state: -1,
                
                isInvalidAnswerState: false,
                invalidAnswerText: '',
                
                correctAnswer: '12:00',
                
                clocks: {
                    left   : '12:00',
                    result : '12:00'
                },
                
                // Перемещаемый элемент-ответ
                dragAnswer: null,
                // HTML-элемент перемещаемого элемента-ответа
                dragAnswerEl: null,
                // Размеры HTML-элемента, который перемещают
                dragAnswerSize: {
                    width: 0,
                    height: 0
                },
                // Выбранный ответ
                selectedAnswer: null,
                
                // Находится ли перемещаемый ответ над вопросом
                canDragAnswer: false,
                
                // Текущее положение курсора (mouse & touch) при перемещении элемента-ответа
                mousePos: {
                    x: 0,
                    y: 0
                }                
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.hasExercise ? this.exercise.id : -1;
            },
            
            hasExercise: function() {
                return this.exercise !== null;
            },
            
            isStateMain: function() {
                return this.state === States.MAIN;
            },
            
            isStateFinish: function() {
                return this.state === States.FINISH;
            },            
            
            text: function() {
                return ! this.hasExercise ? '' : this.exercise.text;
            },
            
            leftClock: function() {
                return ! this.hasExercise ? null : this.exercise.left;
            },
            
            resultClock: function() {
                return ! this.hasExercise ? null : this.exercise.result;
            },
            
            isQuestTypeLeft: function() {
                return this.hasExercise && this.exercise.questionType === MATH_TIME_QUESTION_TYPE_LEFT;
            },
            
            isQuestTypeRight: function() {
                return this.hasExercise && this.exercise.questionType === MATH_TIME_QUESTION_TYPE_RIGHT;
            },
            
            isQuestTypeResult: function() {
                return this.hasExercise && this.exercise.questionType === MATH_TIME_QUESTION_TYPE_RESULT;
            },
            
            opSrc: function() {
                let src = '';
                
                if ( ! this.hasExercise) {
                    return src;
                }
                
                switch (this.exercise.operation) {
                    case ksGlobal.MathOperation.Addition:
                        src = this.exercise.signs.plus;
                        break;
                        
                    case ksGlobal.MathOperation.Subtraction:
                        src = this.exercise.signs.minus;
                        break;
                }
                
                return src;
            },
            
            opAlt: function() {
                let alt = '';
                
                if (this.exercise === null) {
                    return alt;
                }
                
                switch (this.exercise.operation) {
                    case ksGlobal.MathOperation.Addition:
                        alt = 'Плюс';
                        break;
                        
                    case ksGlobal.MathOperation.Subtraction:
                        alt = 'Минус';
                        break;
                }
                
                return alt;                
            },
            
            equalSrc: function() {
                return ! this.hasExercise ? '' : this.exercise.signs.equal;
            },
            
            rightTimeText: function() {
                return this.hasExercise && ! this.isQuestTypeRight ? ks.helpers.date.getMinutesText(this.exercise.rightTime, true, 'exercise-math-time__right-time__br') : '';
            },
            
            answers: function() {
                return this.hasExercise ? this.exercise.answers : [];
            },
            
            dragging: function() {
                return this.dragAnswer !== null;
            },
            
            selectedTimeText: function() {
                if ( ! this.hasExercise || ! this.isQuestTypeRight) {
                    return '';
                }
                
                return this.selectedAnswer === null ? '?' : ks.helpers.date.getMinutesText(this.selectedAnswer, true, 'exercise-math-time__right-time__br');
            },
            
            rightItemClass: function() {
                return {
                    'can-put'    : this.canDragAnswer,
                    'has-answer' : this.selectedAnswer !== null
                };
            }
        },
        
        methods: {
            load: function(exercise) {
                this.exercise = exercise;
                
                switch (this.exercise.questionType) {
                    case MATH_TIME_QUESTION_TYPE_LEFT:
                        
                        break;
                        
                    case MATH_TIME_QUESTION_TYPE_RIGHT:
                        break;
                        
                    case MATH_TIME_QUESTION_TYPE_RESULT:
                        break;
                }
                            
                this.dragAnswer = null;
                this.dragAnswerEl = null;
                this.dragAnswerSize.width = 0;
                this.dragAnswerSize.height = 0;
                this.selectedAnswer = null;
                this.canDragAnswer = false;
                this.mousePos.x = 0;
                this.mousePos.y = 0;                            
                            
                window.addEventListener('mouseup', this.stopDragAnswer);
                window.addEventListener('touchend', this.stopDragAnswer);
                
                window.addEventListener('mousemove', this.doDragAnswer);
                window.addEventListener('touchmove', this.doDragAnswer, { passive: false });                            
                
                this.state = States.MAIN;
                this.loaded = true;
            },
            
            unload: function() {
                if (this.loaded) {
                    window.removeEventListener('mouseup', this.stopDragAnswer);
                    window.removeEventListener('touchend', this.stopDragAnswer);
                    
                    window.removeEventListener('mousemove', this.doDragAnswer);
                    window.removeEventListener('touchmove', this.doDragAnswer);                    
                    
                    this.loaded = false;
                    
                    this.state = -1;
                    
                    this.isInvalidAnswerState = false;
                    this.invalidAnswerText = '';
                    
                    this.selectedAnswer = null;
                    
                    this.exercise = null;
                }
            },
            
            isAnalog: function(clockType) {
                return clockType === ksGlobal.ClockType.Analog;
            },  
            
            onMouseEnterSendAnswer: function() {
                ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER);
            },
            
            onAnswer: function() {
                let answer = null;
                
                switch (this.exercise.questionType) {
                    case MATH_TIME_QUESTION_TYPE_LEFT:
                        answer = this.leftClock.time;
                        break;
                        
                    case MATH_TIME_QUESTION_TYPE_RIGHT:
                        if (this.selectedAnswer === null) {
                            this.$refs.answerAlert.show('Нужно выбрать ответ', ks.consts.ALERT_INFO);
                            this.$emit('play-sound', ks.sounds.NEED_SELECT_ANSWER);

                            return;
                        }
                        
                        answer = this.selectedAnswer;
                        break;
                        
                    case MATH_TIME_QUESTION_TYPE_RESULT:
                        answer = this.resultClock.time;
                        break;
                }                
                
                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: answer
                }, this.onCheckAnswer);                
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                this.state = States.FINISH;
                
                if ( ! data.correct) {
                    this.correctAnswer = data.correctAnswer;
                    this.isInvalidAnswerState = true;
                    this.invalidAnswerText = data.message.text;
                    
                    switch (this.exercise.questionType) {
                        case MATH_TIME_QUESTION_TYPE_LEFT:
                            this.clocks.left = this.correctAnswer;
                            this.clocks.result = this.exercise.result.time;
                            break;
                            
                        case MATH_TIME_QUESTION_TYPE_RIGHT:
                            this.clocks.left = this.exercise.left.time;
                            this.clocks.result = this.exercise.result.time;
                            break;
                            
                        case MATH_TIME_QUESTION_TYPE_RESULT:
                            this.clocks.result = this.correctAnswer;
                            this.clocks.left = this.exercise.left.time;
                            break;
                    }
                    
                    this.$emit('answer', false, data.message, true);
                    
                    return;
                }
                
                this.$emit('answer', true, data.message, true);
            },
            
            updateSize: function() {
                this.$nextTick(function() {
                    window.dispatchEvent(new Event('resize'));
                });
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            getAnswerStyle: function(answer) {
                var pos = {
                        x: answer === this.dragAnswer ? this.mousePos.x - this.dragAnswerSize.width / 2 : 0,
                        y: answer === this.dragAnswer ? this.mousePos.y - this.dragAnswerSize.height / 2 - 8 : 0
                    };
                
                return {
                    'position': answer === this.dragAnswer ? 'fixed' : 'inherit',
                    'z-index': answer === this.dragAnswer ? 999 : 1,
                    'left': pos.x + 'px',
                    'top': pos.y + 'px'
                };
            },
            
            getAnswerClass: function(answer) {
                return {
                    'hidden'   : answer === this.selectedAnswer && answer !== this.dragAnswer,
                    'dragging' : answer === this.dragAnswer
                };
            },
            
            startDragSelectedAnswer: function(event) {
                if (this.selectedAnswer === null) {
                    return;
                }
                
                this.$store.commit('window/setDraggableMode', true);
                
                let answer = this.selectedAnswer;
                this.selectedAnswer = null;

                // Для правильного позиционирования вызываем в следующем проходе цикла
                let self = this;
                this.$nextTick(function(){
                    self.startDragAnswerItem(event, answer);
                });
            },
            
            startDragAnswerItem: function(event, answer) {
                if ( ! this.isQuestTypeRight) {
                    return;
                }
                
                if (event.type === 'touchstart') {
                    var touch = null;
                    
                    if (typeof event.touches !== 'undefined' && event.touches.length === 1) {
                        touch = event.touches[0];
                    }
                    
                    //var touch = event.touches[0] || event.originalEvent.touches[0] || event.originalEvent.changedTouches[0];
                    
                    this.mousePos.x = touch.clientX;
                    this.mousePos.y = touch.clientY;
                }
                else {
                    //LFET BUTTON: 
                    //  IE: event.which = undefined, event.button = 1
                    //  Firefox, Safari Win, Opera: event.which = 1, event.button = 0
                    if ( ! event.which && event.button) {
                        if (event.button & 1) {
                            event.which = 1;
                        }
                    }
                    
                    if (event.which !== 1) {
                        return;
                    }
                    
                    this.mousePos.x = event.clientX;
                    this.mousePos.y = event.clientY;
                }                
                
                this.dragAnswer = answer;
                this.dragAnswerEl = document.getElementById(this.getAnswerId(answer));
                
                let rect = this.dragAnswerEl.getBoundingClientRect();
                this.dragAnswerSize.width = rect.width;
                this.dragAnswerSize.height = rect.height;
                
                // На следующем проходе Vue обязательно обновим значение canDragAnswer
                var self = this;
                this.$nextTick(function() {
                    self.updateDrag();
                });
                
                ks.soundManager.playEffect(ks.sounds.ITEM_START_DRAG);
                
                if (event.cancelable) {
                    event.stopPropagation();
                    event.preventDefault();                
                }
            },
            
            stopDragAnswer: function(event) {
                this.$store.commit('window/setDraggableMode', false);
                
                if ( ! this.isQuestTypeRight || ! this.dragging) {
                    return;
                }
                
                if (this.canDragAnswer) {
                    this.selectedAnswer = this.dragAnswer;
                    
                    ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                } else {
                    ks.soundManager.playEffect(ks.sounds.ITEM_STOP_DRAG);
                }
                
                this.dragAnswer = null;
                this.dragAnswerEl = null;
                
                this.canDragAnswer = false;
                
                if (event.cancelable) {
                    event.stopPropagation();
                    event.preventDefault();                
                }
            },      
            
            doDragAnswer: function(event) {
                if ( ! this.isQuestTypeRight || ! this.dragging) {
                    return;
                }
                
                if (event.type === 'touchmove') {
                    var touch = null;
                    
                    if (typeof event.touches !== 'undefined' && event.touches.length === 1) {
                        touch = event.touches[0];
                    }
                    
                    if (touch === null) {
                        return;
                    }
                    
                    this.mousePos.x = touch.clientX;
                    this.mousePos.y = touch.clientY;
                }
                else {
                    this.mousePos.x = event.clientX;
                    this.mousePos.y = event.clientY;
                }
                
                this.updateDrag();
                
                if (event.cancelable) {
                    event.stopPropagation();
                    event.preventDefault();                
                }
            },  
            
            updateDrag: function() {
                let area = ks.helpers.math.getIntersectionAreaRectangles(this.$refs.rightItem.getBoundingClientRect(), this.dragAnswerEl.getBoundingClientRect());
                this.canDragAnswer = area > 0;
            },
            
            getAnswerText: function(answer) {
                return ks.helpers.date.getMinutesText(answer, false);
            },
            
            getAnswerId: function(answer) {
                return 'exercise-math-time-answer-' + answer;
            },
            
            getRightTime: function(correct) {
                let rightTime = correct ? this.correctAnswer : this.selectedAnswer;
                return ks.helpers.date.getMinutesText(rightTime, true, 'exercise-math-time__right-time__br');
            }
        },
        
        watch: {
            state: function(newState) {
                switch(newState) {
                    case States.MAIN:
                        this.$store.commit('current/setExercisesCurrentPage', ks.consts.EXERCISE_PAGE_MAIN);
                        break;
                }
            }
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 30.10.2020
 */

(function() {
    var States = {
            SAMPLE : 0,
            MAIN   : 1,
            FINISH : 2
        };    

    Vue.component('exercise-item-memory-magic-cubes', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                state: -1,
                
                initField: [],
                field: [],
                mirrorField: [],
                
                fieldLoaded: false,
                
                isInvalidAnswerState: false,
                invalidAnswerText: '',
                
                fieldWidth: 0,
                
                colors: []
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },
            
            isStateSample: function() {
                return this.state === States.SAMPLE;
            },
            
            isStateMain: function() {
                return this.state === States.MAIN;
            },
            
            isStateFinish: function() {
                return this.state === States.FINISH;
            },
            
            isShowOriginal: function() {
                return this.exercise !== null && this.exercise.options.show_original === true;
            },
            
            isMirrorReflection: function() {
                return this.exercise !== null && this.exercise.options.mirror_reflection === true;
            },
            
            text: function() {
                if (this.exercise === null) {
                    return '';
                }
                
                if (this.exercise.options.show_original === true) {
                    return this.exercise.text;
                } else {
                    return this.isStateSample ? this.exercise.text : this.exercise.extra.text;
                }
            },
            
            classFieldBox: function() {
                return {
                    'col-xs-12': ! this.isShowOriginal,
                    'col-xs-6': this.isShowOriginal,
                    /*
                    'col-xs-12': ! this.isShowOriginal,
                    'col-xs-10': this.isShowOriginal,
                    'col-xs-offset-1': this.isShowOriginal,*/
                    'col-md-6': this.isShowOriginal,
                    'col-md-offset-0': this.isShowOriginal,
                    'col-md-offset-1':  ! this.isShowOriginal,
                    'col-md-10':  ! this.isShowOriginal,
                    'col-lg-8':  ! this.isShowOriginal,
                    'col-lg-offset-2':  ! this.isShowOriginal
                };
            },
            
            styleFieldBox: function() {
                return {
                    padding: 0
                };
            },
            
            fieldSize: function() {
                return this.field.length;
            },
            
            classAnswerFieldContainer: function() {
                return {
                    'col-xs-12': ! this.isMirrorReflection,
                    'col-md-8': ! this.isMirrorReflection,
                    'col-md-offset-2': ! this.isMirrorReflection,
                    'col-lg-6': ! this.isMirrorReflection,
                    'col-lg-offset-3': ! this.isMirrorReflection,
                    'col-xs-6': this.isMirrorReflection,
                    'magic-cubes-field-el-init-field': this.isMirrorReflection
                };
            },
            
            classAnswerIncorrectFieldContainer: function() {
                return {
                    'col-xs-12': ! this.isMirrorReflection,
                    'col-md-8': ! this.isMirrorReflection,
                    'col-md-offset-2': ! this.isMirrorReflection,
                    'col-lg-6': ! this.isMirrorReflection,
                    'col-lg-offset-3': ! this.isMirrorReflection,
                    'col-xs-6': this.isMirrorReflection,
                    'col-xs-offset-3': this.isMirrorReflection
                };                
            }
            /*,
            
            isNeedTurnDevice: function() {
                return this.isMirrorReflection && this.$store.getters.isPortraitScreenOrientation;
            }*/
        },
        
        methods: {
            onChangeFieldWidth: function(width) {
                this.fieldWidth = width;
            },
            
            getColorsInfo: function(field, fromX, toX, fromY, toY, cellX, cellY) {
                let colors = [],
                    cellMode = typeof cellX !== 'undefined' && typeof cellY !== 'undefined';
                
                for (let y = fromY; y <= toY; y++) {
                    for (let x = fromX; x <= toX; x++) {
                        let item = field[y][x],
                            color = item.color || '',
                            bgColor = item.bgColor || '',
                            colorFound = false,
                            bgColorFound = false,
                            countColor = 1;
                        
                        if (item.type === ksGlobal.MagicCubesType.Zero) {
                            color = 'white';
                            bgColor = '';
                        } else {
                            if (item.type !== ksGlobal.MagicCubesType.Full) {
                                if (bgColor === '') {
                                    bgColor = 'white';
                                }
                            } else { // MagicCubesType.Full
                                if (cellMode && x === cellX && y === cellY) {
                                    // Для полностью заполненой цветом клетки нужно чтобы её цвет 
                                    // был обязательно вверху списка (на первых двух позициях) выбора цвета -
                                    // для этого достаточно увеличить число клеток с данным цветом на 8 (вокруг одной клетки макс. 8 смежных)
                                    countColor = 8; 
                                }
                            }
                        }
                        
                        for (let n = 0; n < colors.length; n++) {
                            if ( ! colorFound && colors[n].color === color) {
                                colorFound = true;
                                colors[n].count += countColor;
                            }
                            
                            if (bgColor !== '' && ! bgColorFound && colors[n].color === bgColor) {
                                bgColorFound = true;
                                colors[n].count++;
                            } 
                            
                            if (colorFound && (bgColorFound || bgColor === '')) {
                                break;
                            }
                        }
                        
                        if ( ! colorFound) {
                            colors.push({
                                color: color,
                                count: countColor
                            });
                        }
                        
                        if ( ! bgColorFound && bgColor !== '') {
                            colors.push({
                                color: bgColor,
                                count: 1
                            });                            
                        }
                    }
                }
                
                // Сортируем по кол-ву элементов по каждому цвету, белый в конец списка.
                let sortedColors = colors.sort(function(a, b) {
                    if (a.count > b.count) {
                        return -1;
                    } else {
                        if (a.count < b.count) {
                            return 1;
                        } else {
                            if (a.color === 'white') {
                                return 1;
                            } else {
                                return b.color === 'white' ? -1 : 0;
                            }
                        }
                    }
                });     
                
                // Случайно перемешаем первых два цвета, которые используются в окне выбора цвета
                let n = ks.helpers.math.getRandomInt(0, 2);
                if (sortedColors.length >= 2 && n > 0) {
                    sortedColors[1] = sortedColors.splice(0, 1, sortedColors[1])[0];
                }
                
                return sortedColors;
            },
            
            // Список смежных цветов, только для пустой клетки, для показа возможных кубиков
            getAdjacentColors: function(field, itemX, itemY) {
                let size = field.length,
                    // Будем искать смежные цвета только в квардрате +/-1 по x и y.
                    fromY = itemY > 0 ? itemY - 1 : 0,
                    toY = itemY < size - 1 ? itemY + 1 : size - 1,
                    fromX = itemX > 0 ? itemX - 1 : 0,
                    toX = itemX < size - 1 ? itemX + 1 : size - 1;
                
                return this.getColorsInfo(field, fromX, toX, fromY, toY, itemX, itemY);
            },
            
            loadColors: function(field) {
                this.colors = this.getColorsInfo(field, 0, field.length - 1, 0, field.length - 1);
            },
            
            loadMirrorField: function() {
                this.mirrorField = [];
                
                for (let j = 0; j < this.fieldSize; j++) {
                    let row = [];
                    for (let i = this.fieldSize - 1; i >= 0; i--) {
                        let item = this.initField[j][i];
                        row.push({
                            type: this.getMirrorType(item.type),
                            color: item.color,
                            bgColor: item.bgColor,
                            x: this.fieldSize - i - 1,
                            y: j,
                            selected: false                                
                        });
                    }
                    this.mirrorField.push(row);
                }
                
                for (let j = 0; j < this.fieldSize; j++) {
                    for (let i = 0; i < this.fieldSize; i++) {                
                        this.mirrorField[j][i].adjacentColors = this.getAdjacentColors(this.mirrorField, i, j);
                    }
                }    
            },
            
            init: function(field) {
                this.state = this.isShowOriginal === true ?  States.MAIN : States.SAMPLE;
                
                this.isInvalidAnswerState = false;
                this.invalidAnswerText = '';
                
                this.initField = [];
                this.field = [];
                this.mirrorField = [];
                
                this.loadColors(field);
                
                for (var j = 0; j < field.length; j++) {
                    var row = [],
                        emptyRow = [];

                    for (var i = 0; i < field[j].length; i++) {
                        var item = field[j][i],
                            color = item.color || '',
                            bgColor = item.bgColor || '';
                        
                        row.push({
                            type: item.type,
                            color: color,
                            bgColor: bgColor,
                            x: i,
                            y: j,
                            selected: false,
                            adjacentColors: this.getAdjacentColors(field, i, j)
                        });
                        
                        emptyRow.push({
                            type: ksGlobal.MagicCubesType.Zero,
                            bgColor: '',
                            color: '',
                            x: i,
                            y: j,
                            selected: false
                        });
                    }

                    this.initField.push(row);
                    this.field.push(emptyRow);
                }
                
                if (this.isMirrorReflection) {
                    this.loadMirrorField();
                }
                
                var self = this;
                
                this.$nextTick(function() {
                    self.fieldLoaded = true;
                });
             },
            
            load: function(exercise) {
                this.exercise = exercise;
                
                this.init(JSON.parse(exercise.field));    
                
                this.loaded = true;
            },
            
            unload: function() {
                if (this.loaded) {
                    this.loaded = false;
                    
                    this.state = -1;

                    this.initField = [];
                    this.field = [];
                    this.fieldLoaded = false;
                    
                    this.colors = [];
                    
                    this.isInvalidAnswerState = false;
                    this.invalidAnswerText = '';
                    
                    this.exercise = null;
                }
            },
            
            getAnswerField: function() {
                var field = [];
                for (var j = 0; j < this.field.length; j++) {
                    var row = [];

                    for (var i = 0; i < this.field[j].length; i++) {
                        var item = this.field[j][i];
                        row.push({
                            type: item.type,
                            color: item.color,
                            bgColor: item.bgColor
                        });
                    }

                    field.push(row);
                }
                
                return field;
            },
                    
            getMirrorType: function(type) {
                let mirrorType;
                
                switch (type) {
                    case ksGlobal.MagicCubesType.Zero:
                    case ksGlobal.MagicCubesType.Full:    
                        mirrorType = type;
                        break;

                    case ksGlobal.MagicCubesType.LeftTop:
                        mirrorType = ksGlobal.MagicCubesType.RightTop;
                        break;

                    case ksGlobal.MagicCubesType.RightTop:
                        mirrorType = ksGlobal.MagicCubesType.LeftTop;
                        break;

                    case ksGlobal.MagicCubesType.RightBottom:
                        mirrorType = ksGlobal.MagicCubesType.LeftBottom;
                        break;

                    case ksGlobal.MagicCubesType.LeftBottom:
                        mirrorType = ksGlobal.MagicCubesType.RightBottom;
                        break;
                }       
                
                return mirrorType;
            },            
            
            onAnswer: function() {
                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: JSON.stringify(this.getAnswerField())
                }, this.onCheckAnswer);
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                this.state = States.FINISH;
                
                if ( ! data.correct) {
                    this.isInvalidAnswerState = true;
                    this.invalidAnswerText = data.message.text;
                    
                    this.$emit('answer', false, data.message, true);
                    
                    return;
                }
                
                this.$emit('answer', true, data.message, true);
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            onNextState: function() {
                this.$refs.field.updateSize();
                this.state = States.MAIN;
            },
            
            onMouseEnterSendAnswer: function() {
                ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER);
            },
            
            clickItem: function(item, cursorPos) {
                if (item.type === ksGlobal.MagicCubesType.Zero) {
                    let correctItem = this.isMirrorReflection ? this.mirrorField[item.y][item.x] : this.initField[item.y][item.x],
                        color = correctItem.color,
                        bgColor = correctItem.bgColor;
                
                    // Если клетка пустая или полностью заполнена одним цветом, то попробуем получить смежные цвета. 
                    // Если смежных цветов нет, то показыем те цвета, которых больше всего на узоре.
                    if (correctItem.type === ksGlobal.MagicCubesType.Zero || correctItem.type === ksGlobal.MagicCubesType.Full) {
                        let colors = correctItem.adjacentColors.length >= 2 ? correctItem.adjacentColors : this.colors;
                        if (colors.length < 2) {
                            // Ошибка. Нужно мин. 2 цвета
                            return;
                        }
                        
                        color = colors[0].color;
                        if (color === 'white') {
                            bgColor = '';
                            color = colors[1].color;
                        } else {
                            bgColor = colors[1].color;
                            if (bgColor === 'white') {
                                bgColor = '';
                            }
                        }
                    }
                    
                    this.$refs.itemSelector.show(item, color, bgColor, cursorPos);
                } else {
                    ks.soundManager.playEffect(ks.sounds.CLEAR);
                    
                    item.type = ksGlobal.MagicCubesType.Zero;
                    item.color = '';
                    item.bgColor = '';
                }
            },
            
            // т.к. поле с неправильным ответов сначала не показывается, то
            // корректируем размер в зависимости от поля с правильным ответом
            // Аналогично для других полей.
            onCorrectFieldChangeWidth: function(width) {
                if (width > 0) {
                    this.$refs.incorrectField.updateSize(width);
                }
            },
            
            onIncorrectFieldChangeWidth: function(width) {
                if (width > 0) {
                    this.$refs.correctField.updateSize(width);
                    this.$refs.mirrorField.updateSize(width);
                }
            }
        },
        
        watch: {
            state: function(newState) {
                switch(newState) {
                    case States.SAMPLE:
                        this.$store.commit('current/setExercisesCurrentPage', ks.consts.EXERCISE_PAGE_ENTRY);
                        break;
                        
                    case States.MAIN:
                        this.$store.commit('current/setExercisesCurrentPage', ks.consts.EXERCISE_PAGE_MAIN);
                        break;
                        
                }
            }
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 11.12.2019
 */

(function() {
    var States = {
            SAMPLE : 0,
            MAIN   : 1,
            FINISH : 2
        };    

    Vue.component('exercise-item-memory-magic-points', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                state: -1,
                
                initField: [],
                field: [],
                
                fieldLoaded: false,
                
                colors: [],
                
                isInvalidAnswerState: false,
                invalidAnswerText: ''
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },
            
            isStateSample: function() {
                return this.state === States.SAMPLE;
            },
            
            isStateMain: function() {
                return this.state === States.MAIN;
            },
            
            isStateFinish: function() {
                return this.state === States.FINISH;
            },
            
            isShowOriginal: function() {
                return this.exercise !== null && this.exercise.options.show_original === true;
            },
            
            text: function() {
                if (this.exercise === null) {
                    return '';
                }
                
                if (this.exercise.options.show_original === true) {
                    return this.exercise.text;
                } else {
                    return this.isStateSample ? this.exercise.text : this.exercise.extra.text;
                }
            },
            
            classFieldBox: function() {
                return {
                    'col-xs-12': ! this.isShowOriginal,
                    'col-xs-10': this.isShowOriginal,
                    'col-xs-offset-1': this.isShowOriginal,
                    'col-md-6': this.isShowOriginal,
                    'col-md-offset-0': this.isShowOriginal,
                    'col-md-offset-1':  ! this.isShowOriginal,
                    'col-md-10':  ! this.isShowOriginal,
                    'col-lg-8':  ! this.isShowOriginal,
                    'col-lg-offset-2':  ! this.isShowOriginal
                };
            },
            
            styleFieldBox: function() {
                return {
                    padding: 0
                };
            },
            
            isSingleColor: function() {
                return this.colors.length <= 1;
            }
        },
        
        methods: {
            getColorIndex: function(color) {
                for (var i = 0; i < ksGlobal.Colors.values.length; i++) {
                    if (color === ksGlobal.Colors.values[i].name) {
                        return i;
                    }
                }
                
                return -1;
            },
            
            init: function(field) {
                this.state = this.exercise.options.show_original === true ?  States.MAIN : States.SAMPLE;
                
                this.isInvalidAnswerState = false;
                this.invalidAnswerText = '';
                
                this.initField = [];
                this.field = [];
                
                this.colors = [];
                
                for (var j = 0; j < field.length; j++) {
                    var row = [],
                        emptyRow = [];

                    for (var i = 0; i < field[j].length; i++) {
                        var item = field[j][i];
                        row.push({
                            hasPoint: item.hasPoint,
                            color: item.hasPoint ? item.color : '',
                            x: i,
                            y: j,
                            selected: false,
                            isCorrect: false
                        });
                        
                        emptyRow.push({
                            hasPoint: false,
                            color: '',
                            x: i,
                            y: j,
                            selected: false,
                            isCorrect: false
                        });
                        
                        if (item.hasPoint) {
                            if (this.colors.indexOf(item.color) === -1) {
                                this.colors.push(item.color);
                            }
                        }
                    }

                    this.initField.push(row);
                    this.field.push(emptyRow);
                }
                
                var self = this;
                
                // Сортируем цвета
                this.colors.sort(function(a, b) {
                    var aIndex = self.getColorIndex(a),
                        bIndex = self.getColorIndex(b);
                        
                    if (aIndex < bIndex) {
                        return -1;
                    } else {
                        return aIndex > bIndex ? 1 : 0;
                    }
                });
                
                this.$nextTick(function() {
                    self.fieldLoaded = true;
                });
             },
            
            load: function(exercise) {
                this.exercise = exercise;
                
                this.init(JSON.parse(exercise.field));    
                
                this.loaded = true;
            },
            
            unload: function() {
                if (this.loaded) {
                    this.loaded = false;
                    
                    this.state = -1;

                    this.initField = [];
                    this.field = [];
                    this.fieldLoaded = false;
                    
                    this.colors = [];
                    
                    this.isInvalidAnswerState = false;
                    this.invalidAnswerText = '';
                    
                    this.exercise = null;
                }
            },
            
            getAnswerField: function() {
                var field = [];
                for (var j = 0; j < this.field.length; j++) {
                    var row = [];

                    for (var i = 0; i < this.field[j].length; i++) {
                        var item = this.field[j][i];
                        row.push(item.hasPoint ? item.color : '');
                    }

                    field.push(row);
                }
                
                return field;
            },
            
            setCorrectFieldFlags: function() {
                for (var j = 0; j < this.field.length; j++) {
                    for (var i = 0; i < this.field[j].length; i++) {
                        var answerItem = this.field[j][i],
                            correctItem = this.initField[j][i];
                        
                        if (answerItem.hasPoint !== correctItem.hasPoint) {
                            continue;
                        }
                        
                        if ( ! correctItem.hasPoint) {
                            answerItem.isCorrect = true;
                            continue;
                        }
                        
                        answerItem.isCorrect = answerItem.color === correctItem.color;
                    }
                }
            },            
            
            onAnswer: function() {
                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: JSON.stringify(this.getAnswerField())
                }, this.onCheckAnswer);
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                this.state = States.FINISH;
                
                if ( ! data.correct) {
                    this.isInvalidAnswerState = true;
                    this.invalidAnswerText = data.message.text;
                    
                    this.setCorrectFieldFlags();
                    
                    this.$emit('answer', false, data.message, true);
                    
                    return;
                }
                
                this.$emit('answer', true, data.message, true);
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            onNextState: function() {
                this.$refs.field.updateSize();
                this.state = States.MAIN;
            },
            
            onMouseEnterSendAnswer: function() {
                ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER);
            },
            
            clickItem: function(item, cursorPos) {
                if (this.colors.length <= 0) {
                    return;
                }
                
                if (item.hasPoint) {
                    item.hasPoint = false;
                    
                    ks.soundManager.playEffect(ks.sounds.CLEAR);
                    
                    return;
                }
                
                if (this.colors.length === 1) {
                    item.hasPoint = true;
                    item.color = this.colors[0];
                    
                    ks.soundManager.playEffect(ks.sounds.CUBE);
                    
                    return;
                }
                
                this.$refs.colorSelector.show(item, cursorPos);
            },
            
            // т.к. поле с неправильным ответов сначала не показывается, то
            // корректируем размер в зависимости от поля с правильным ответом
            // Аналогично для других полей.
            onCorrectFieldChangeWidth: function(width) {
                if (width > 0) {
                    this.$refs.incorrectField.updateSize(width);
                }
            },
            
            onIncorrectFieldChangeWidth: function(width) {
                if (width > 0) {
                    this.$refs.correctField.updateSize(width);
                }
            }
        },
        
        watch: {
            state: function(newState) {
                switch(newState) {
                    case States.SAMPLE:
                        this.$store.commit('current/setExercisesCurrentPage', ks.consts.EXERCISE_PAGE_ENTRY);
                        break;
                        
                    case States.MAIN:
                        this.$store.commit('current/setExercisesCurrentPage', ks.consts.EXERCISE_PAGE_MAIN);
                        break;
                        
                }
            }
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 06.06.2018
 */

(function() {
    
    var States = {
            PREVIEW : 0,
            GAME    : 1,
            FINISH  : 2
        },
        
        ItemStates = {
            CLOSED  : 0,
            OPENED  : 1,
            DELETED : 2
        };    

    Vue.component('exercise-item-memory-pair', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                state: States.PREVIEW,
                
                text: '',
                
                items: [],
                
                shuffleIterations: 30,
                
                resizeTimer: null,
                
                image: {
                    width: 0,
                    originalWidth: 0,
                    coefficient: 0
                },
                
                openedItem: null,
                
                canClickItem: true,
                
                isSuccess: false
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },
            
            cover: function() {
                return this.exercise === null ? '' : this.exercise.cover;
            },
            
            imageSize: function() {
                var height = this.image.width * this.image.coefficient;
                
                return {
                    'width': this.image.width + 'px',
                    'height': height + 'px'
                };
            },
            
            isShowText: function() {
                return this.isStatePreview && this.text !== '';
            },
            
            isStatePreview: function() {
                return this.state === States.PREVIEW;
            },
            
            isStateGame: function() {
                return this.state === States.GAME;
            },
            
            isStateFinish: function() {
                return this.state === States.FINISH;
            },
            
            isShowField: function() {
                return this.image.width > 0 && (this.isStatePreview || this.isStateGame);
            }
        },
        
        methods: {
            init: function() {
                this.state = States.PREVIEW;
                this.text = '';
                this.openedItem = null;
                this.canClickItem = true;
                this.isSuccess = false;
            },
            
            load: function(exercise) {
                this.exercise = exercise;
                
                this.init();    
                
                this.text = this.exercise.text;
                this.$store.commit('current/setExercisesCurrentPage', ks.consts.EXERCISE_PAGE_MAIN);
                
                this.initImageSizes();
                
                this.generateItems();
                
                window.addEventListener('resize', this.onWindowResize);
                
                this.loaded = true;

                var self = this;
                this.$nextTick(function() {
                    self.calcSizes();
                });
            },
            
            unload: function() {
                if (this.loaded) {
                    window.removeEventListener('resize', this.onWindowResize);
                    
                    this.loaded = false;

                    this.init(); 

                    this.exercise = null;
                }
            },
            
            initImageSizes: function() {
                var img = new Image(),
                    self = this;
            
                img.onload = function() {
                    self.image.originalWidth = this.width;
                    self.image.coefficient = this.height / this.width;
                    self.calcSizes();
                };          
                
                img.src = this.cover;
            },
            
            generateItems: function() {
                var hCount = this.exercise.options.hItemsCount,
                    vCount = this.exercise.options.vItemsCount,
                    totalImageCount = Number(hCount * vCount / this.exercise.images.length),
                    currentImageCount, imageIndex, x1, y1, x2, y2;
                
                imageIndex  = 0;
                currentImageCount = 0;
                
                this.items = [];
                
                for (var i = 0; i < vCount; i++) {
                    var column = [];
                    
                    for (var j = 0; j < hCount; j++) {
                        column.push({
                            imageIndex: imageIndex, 
                            state: ItemStates.OPENED
                        });
                        
                        currentImageCount++;
                        if (currentImageCount === totalImageCount) {
                            imageIndex++;
                            currentImageCount = 0;
                        }
                    }
                    
                    this.items.push(column);
                }
                
                i = 0;
                while (i < this.shuffleIterations) {
                    
                    x1 = ks.helpers.math.getRandomInt(0, hCount - 1);
                    y1 = ks.helpers.math.getRandomInt(0, vCount - 1);                    
                    
                    x2 = ks.helpers.math.getRandomInt(0, hCount - 1);
                    y2 = ks.helpers.math.getRandomInt(0, vCount - 1);                    
                    
                    if (x1 === x2 && y1 === y2) {
                        continue;
                    }
                    
                    imageIndex = this.items[y1][x1].imageIndex;
                    this.items[y1][x1].imageIndex = this.items[y2][x2].imageIndex;
                    this.items[y2][x2].imageIndex = imageIndex;
                    
                    i++;
                }
            },
            
            getItemImage: function(item) {
                return this.exercise !== null ? this.exercise.images[item.imageIndex] : '';
            },
            
            itemClass: function(item) {
                return {
                    'flip': item.state !== ItemStates.OPENED && item.state !== ItemStates.DELETED,
                    'active': this.state === States.GAME && item.state === ItemStates.CLOSED && this.canClickItem,
                    'deleted': item.state === ItemStates.DELETED
                };
            },
            
            isCorrectFinish: function() {
                for (var i = 0; i < this.items.length; i++) {
                    for (var j = 0; j < this.items[i].length; j++) {
                        if (this.items[i][j].state !== ItemStates.DELETED) {
                            return false;
                        }
                    }
                }
                
                return true;
            },
            
            checkFinish: function() {
                if ( ! this.isCorrectFinish()) {
                    return false;
                }
                
                this.state = States.FINISH;
                this.sendFinish(true);
            },
            
            clickItem: function(item) {
                // Если в режиме просмотра, то начинаем игру
                if (this.state === States.PREVIEW) {
                    this.onStart();
                    return;
                }
                
                if (this.state !== States.GAME || ! this.canClickItem) {
                    return;
                }
                
                if (item.state === ItemStates.DELETED) {
                    return;
                }
                
                if (this.openedItem !== null && this.openedItem !== item) {
                    
                    var isCorrect = this.openedItem.imageIndex === item.imageIndex;
                    
                    ks.soundManager.playEffect(ks.sounds.FLY);
                    
                    item.state = ItemStates.OPENED;

                    this.canClickItem = false;

                    var self = this;
                    setTimeout(function() {
                        item.state = isCorrect ? ItemStates.DELETED : ItemStates.CLOSED;
                        self.openedItem.state = item.state;
                        self.openedItem = null;

                        self.canClickItem = true;
                        
                        if (isCorrect) {
                            ks.soundManager.playEffect(ks.sounds.ANSWER_HOVER);
                            self.checkFinish();
                        } else {
                            ks.soundManager.playEffect(ks.sounds.ANSWER_FALSE);
                        }
                    }, isCorrect ? 500 : 1000);                     
                    
                } else {
                    if (item.state === ItemStates.CLOSED) {
                        ks.soundManager.playEffect(ks.sounds.FLY);
                        
                        item.state = ItemStates.OPENED;
                        this.openedItem = item;
                    } 
                }
            },
            
            setItemsStates: function(itemState) {
                for (var i = 0; i < this.items.length; i++) {
                    for (var j = 0; j < this.items[i].length; j++) {
                        this.items[i][j].state = itemState;
                    }
                }
            },
            
            onStart: function() {
               ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER); 
                
               this.setItemsStates(ItemStates.CLOSED);
               this.state = States.GAME;
            },
            
            onStop: function() {
                ks.app.$refs.messageBox.show({
                    type     : ks.consts.MBT_WARNING,
                    title    : 'Завершить упражнение?',
                    text     : 'Упражнение не пройдено. Хочешь завершить упражнение сейчас?',
                    buttons  : ks.consts.MBB_YES_NO,
                    onClose  : this.confirmStop
                });                
            },
            
            confirmStop: function(modalResult) {
                if (modalResult !== ks.consts.MBB_YES) return;
                
                this.state = States.FINISH;
                this.sendFinish(false);                
            },
            
            sendFinish: function(isCorrect) {
                this.isSuccess = isCorrect;
                
                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: isCorrect
                }, this.onCheckAnswer); 
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                if (this.isSuccess) {
                    this.$emit('answer', true, data.message, true);
                } else {
                    this.$emit('answer', false, data.message, false);
                    this.onNext();
                }
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            calcSizes: function() {
                this.image.width = (this.$refs.itemsContainer.offsetWidth / this.exercise.options.hItemsCount) - 20;
                if (this.image.originalWidth > 0 && this.image.width > this.image.originalWidth) {
                    this.image.width = this.image.originalWidth;
                }
            },
            
            // При изменении экрана (но не чаще 300 мс) изменяем размер элементов
            onWindowResize: function() {
              if (this.resizeTimer !== null) {
                    clearTimeout(this.resizeTimer);
                    this.resizeTimer = null;
                }

                var self = this;
                this.resizeTimer = setTimeout(function(){
                    self.calcSizes();
                    self.resizeTimer = null;
                }, 300);            
            }              
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 13.08.2018
 */

(function() {

    Vue.component('exercise-item-missing-item', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                isMainPage: false,
                
                state: -1,
                
                answerComment: '',
                
                text: '',
                
                resizeTimer: null,
                
                // Размер изображения в зависимости от размера окна браузера
                imageWidth: 0,
                imageHeight: 0,
                
                // Элементы изображения
                items: [],
                
                // Вырезанные элементы (координаты)
                cutItems: [],
                
                // Сдвиг контейнера изображения по оси x для центрирования
                containerOffset: 0,
                
                // Элементы-ответы
                answers: [],
                
                // Перемещаемый элемент-ответ
                dragAnswer: null,
                // HTML-элемент перемещаемого элемента-ответа
                dragAnswerEl: null,
                
                // Элемент над которым находится перемещаемый элемент-ответ
                overItem: null,
                
                // Текущее положение курсора (mouse & touch) при перемещении элемента-ответа
                mousePos: {
                    x: 0,
                    y: 0
                }
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },
            
            // Ширина одного элемента
            itemWidth: function() {
                return this.imageWidth / this.exercise.options.hPiecesCount;
            },
            
            // Высота одного элемента
            itemHeight: function() {
                return this.imageHeight / this.exercise.options.vPiecesCount;
            },
            
            // Сдвиг контейнера элементов для центрирования
            itemsContainerStyle: function() {
                return {
                    'padding-left': this.containerOffset + 'px'
                };
            },
            
            // Находимся ли в режиме перемещения элемента-ответа
            dragging: function() {
                return this.dragAnswer !== null;
            },
            
            isQuestionState: function() {
                return this.state === ks.consts.EXERCISE_STATE_QUESTION;
            },
            
            isInvalidAnswerState: function() {
                return this.state === ks.consts.EXERCISE_STATE_INVALID_ANSWER;
            },
            
            isCommentEmpty: function() {
                return this.answerComment === '';
            },
            
            hasEntryPage: function() {
                if (this.exercise === null) {
                    return false;
                }
                
                return typeof this.exercise.extra !== 'undefined' && this.exercise.extra.enabled;
            },            
            
            showInitialState: function() {
                if (this.exercise === null || ! this.exercise.showInitialState) {
                    return false;
                }
                
                return ( ! this.isMainPage || ! this.hasEntryPage);
            },
            
            imageSrc: function() {
                return this.exercise === null ? '' : this.exercise.image.url;
            }
        },
        
        methods: {
            init: function() {
                this.isMainPage = false;
                this.state = ks.consts.EXERCISE_STATE_QUESTION;
                this.answerComment = '';
                this.correctAnswer = [];  
                this.text = '';
                this.items = [];
                this.cutItems = [];
                this.containerOffset = 0;
                this.answers = [];
                this.dragAnswer = null;
                this.dragAnswerEl = null;
                this.overItem = null;
                this.mousePos.x = 0;
                this.mousePos.y = 0;
            },
            
            load: function(exercise) {
                this.exercise = exercise;
                
                this.init();    
                
                this.$refs.standard.load(exercise);
                
                this.loadItems();
                this.loadAnswers();
                
                window.addEventListener('resize', this.onWindowResize);
                
                window.addEventListener('mouseup', this.stopDragAnswer);
                window.addEventListener('touchend', this.stopDragAnswer);
                
                window.addEventListener('mousemove', this.doDragAnswer);
                window.addEventListener('touchmove', this.doDragAnswer, { passive: false });
                
                this.loaded = true;
                
                var self = this;
                this.$nextTick(function() {
                    self.calcSizes();
                });
            },
            
            unload: function() {
                if (this.loaded) {
                    window.removeEventListener('resize', this.onWindowResize);
                    
                    window.removeEventListener('mouseup', this.stopDragAnswer);
                    window.removeEventListener('touchend', this.stopDragAnswer);
                    
                    window.removeEventListener('mousemove', this.doDragAnswer);
                    window.removeEventListener('touchmove', this.doDragAnswer);
                    
                    this.loaded = false;

                    this.$refs.standard.unload();

                    this.init(); 
                    
                    this.exercise = null;
                }
            },
            
            // При изменении экрана (но не чаще 300 мс) изменяем размер элементов
            onWindowResize: function() {
              if (this.resizeTimer !== null) {
                    clearTimeout(this.resizeTimer);
                    this.resizeTimer = null;
                }

                var self = this;
                this.resizeTimer = setTimeout(function(){
                    self.calcSizes();
                    self.resizeTimer = null;
                }, 300);            
            }, 
            
            calcSizes: function() {
                var width = this.isInvalidAnswerState ? this.$refs.answersContainer.offsetWidth + 30 /*.row margin-left: -15px; maring-right: 15px;*/ : 
                        this.$refs.itemsContainer.offsetWidth;
                
                this.imageWidth = width > this.exercise.image.width ? this.exercise.image.width : width - 8;
                this.containerOffset = (width - this.imageWidth) / 2;
                
                var coef = this.exercise.image.width / this.exercise.image.height;
                this.imageHeight = this.imageWidth / coef;
            },
            
            isItemCutted: function(x, y) {
                for (var i = 0; i < this.cutItems.length; i++) {
                    var item = this.cutItems[i];
                    if (item.x === x && item.y === y) {
                        return true;
                    }
                }
                
                return false;
            },
            
            loadItems: function() {
                var index = 0;
                
                this.cutItems = JSON.parse(this.exercise.cutItems);
                
                this.items = [];
                
                for (var j = 0; j < this.exercise.options.vPiecesCount; j++) {
                    var row = [];
                    
                    for (var i = 0; i < this.exercise.options.hPiecesCount; i++) {
                        var item = {
                            x: i,
                            y: j,
                            el: null,
                            cutted: this.isItemCutted(i, j), // флаг вырезан ли элемент
                            index: index,
                            answerIndex: -1 // есть ли элемент-ответ на данном элементе
                        };
                        
                        row.push(item);
                        
                        index++;
                    }
                    
                    this.items.push(row);
                }  
                
                // Получаем для каждого элемента HTML-элемент (item.el)
                var self = this;
                this.$nextTick(function() {
                    for (var j = 0; j < self.items.length; j++) {
                        for (var i = 0; i < self.items[j].length; i++) {
                            var item = self.items[j][i];
                            if ( ! item.cutted) {
                                continue;
                            }         
                            item.el = document.getElementById(self.getItemId(item));
                        }
                    }
                });
            },
            
            loadAnswers: function() {
                var answers = JSON.parse(this.exercise.answers);                
                
                for (var i = 0; i < answers.length; i++) {
                    answers[i].index = i;
                    answers[i].visible = true;
                    if (typeof answers[i].modifier === 'undefined') {
                        answers[i].modifier = ksGlobal.ImageModifier.values.None;
                    }
                }
         
                this.answers = answers; 
            },
            
            getItemId: function(item) {
                return 'exercise-missing-item-elem-' + item.index;
            },
            
            /**
             * 
             * @param {Object} item
             * @param {Boolean} answerMode Режим ответов
             * @param {Boolean} correctAnswerMode Режим ответов: правильный или неправильный(только для answerMode = true)
             * @returns {Object}
             */
            getItemStyle: function(item, answerMode, correctAnswerMode) {
                var left = item.x * this.itemWidth,
                    top = item.y * this.itemHeight,
                    style = {
                        'width': this.itemWidth + 'px',
                        'height': this.itemHeight + 'px',
                        'line-height': this.itemHeight + 'px'
                    };    
                
                if (item.cutted && ! (answerMode && correctAnswerMode)) {
                    if (item.answerIndex === -1) {
                        // nothing
                    } else {
                        if ( ! answerMode || ! correctAnswerMode) {
                            // На элементе есть ответ-элемент
                            style = this.getAnswerStyle(this.answers[item.answerIndex]);
                        } 
                    }
                } else {
                    // Элемент не вырезан
                    style['background-image'] = 'url(' + this.exercise.image.url + ')';
                    style['background-position'] = '-' + left + 'px -' + top + 'px';
                    style['background-size'] = this.imageWidth + 'px ' + this.imageHeight + 'px';
                }
                
                return style;
            },

            /**
             * 
             * @param {Object} item
             * @param {Boolean} answerMode Режим ответов
             * @param {Boolean} correctAnswerMode Режим ответов: правильный или неправильный(только для answerMode = true)
             * @returns {Object}
             */

            getItemClass: function(item, answerMode, correctAnswerMode) {
                if ( ! item.cutted) {
                    return {};
                }
                
                var correctAnswer = false;
                
                if (answerMode && item.answerIndex > -1) {
                    var answer = this.answers[item.answerIndex];
                    // Правильно ли расположен ответ-элемент
                    correctAnswer = item.x === answer.x && item.y === answer.y && answer.modifier === ksGlobal.ImageModifier.values.None;
                }
                
                return {
                    // Только для процесса выполнения упражнения
                    'can-put': ! answerMode && this.overItem === item, // можно ли положить ответ-элемент на данный элемент
                    'contains-answer': ! answerMode && item.answerIndex > -1, // содержит ли элемент ответ-элемент
                    // Только для режима ответов
                    'correct-answer': answerMode && (correctAnswerMode || correctAnswer),
                    'incorrect-answer': answerMode && (! correctAnswerMode && ! correctAnswer)
                };
            },
            
            itemIconShow: function(item) {
                // Показываем иконку только есть элемент вырезан и на элементе нет ответа-элемента
                return item.cutted && item.answerIndex === -1;
            },
            
            getItemIconClass: function(item) {
                return {
                    // Элемент вырезан и над элементом НЕТ ответа-элемента
                    'fa-question-circle-o': item.cutted && item !== this.overItem,
                    'green': item.cutted && item !== this.overItem,
                    
                    // Элемент вырезан и над элементом ЕСТЬ ответ-элемент
                    'fa-crosshairs': item.cutted && item === this.overItem,
                    'blue': item.cutted && item === this.overItem
                };
            },
            
            getAnswerContainerId: function(answer) {
                return 'exercise-missing-item-answer-container-' + answer.index;
            },
            
            getAnswerStyle: function(answer) {
                var left = answer.x * this.itemWidth,
                    top = answer.y * this.itemHeight;
                
                return {
                    'width': this.itemWidth + 'px',
                    'height': this.itemHeight + 'px',
                    'line-height': this.itemHeight + 'px',
                    'background-image': 'url(' + this.exercise.image.url + ')',
                    'background-position': '-' + left + 'px -' + top + 'px',
                    'background-size': this.imageWidth + 'px ' + this.imageHeight + 'px',
                    'transform': ksGlobal.ImageModifier.getTransform(answer.modifier),
                    '-webkit-transform': ksGlobal.ImageModifier.getTransform(answer.modifier)
                };
            },   
            
            getAnswerContainerStyle: function(answer) {
                var pos = {
                        x: answer === this.dragAnswer ? this.mousePos.x - this.itemWidth / 2 : 0,
                        y: answer === this.dragAnswer ? this.mousePos.y - this.itemHeight / 2 : 0
                    };
                
                return {
                    'position': answer === this.dragAnswer ? 'fixed' : 'inherit',
                    'z-index': answer === this.dragAnswer ? 999 : 1,
                    'left': pos.x + 'px',
                    'top': pos.y + 'px'
                };
            },             
            
            getAnswerContainerClass: function(answer) {
                return {
                    'dragging': answer === this.dragAnswer,
                    'can-put': answer === this.dragAnswer && this.overItem !== null
                };
            },
            
            stopDragAnswer: function(event) {
                this.$store.commit('window/setDraggableMode', false);
                
                if ( ! this.isQuestionState || ! this.dragging) {
                    return;
                }
                
                if (this.overItem !== null) {
                    if (this.overItem.answerIndex !== -1) {
                        this.answers[this.overItem.answerIndex].visible = true;
                    }
                    this.overItem.answerIndex = this.dragAnswer.index;
                    this.dragAnswer.visible = false;
                    
                    ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                } else {
                    ks.soundManager.playEffect(ks.sounds.ITEM_STOP_DRAG);
                }
                
                this.dragAnswer = null;
                this.dragAnswerEl = null;
                
                this.overItem = null;
                
                if (event.cancelable) {                
                    event.stopPropagation();
                    event.preventDefault();                
                }
            },
            
            startDragAnswer: function(event, answer) {
                if ( ! this.isQuestionState) {
                    return;
                }
                
                this.$store.commit('window/setDraggableMode', true);
                
                if (event.type === 'touchstart') {
                    var touch = null;
                    
                    if (typeof event.touches !== 'undefined' && event.touches.length === 1) {
                        touch = event.touches[0];
                    }
                    
                    //var touch = event.touches[0] || event.originalEvent.touches[0] || event.originalEvent.changedTouches[0];
                    
                    this.mousePos.x = touch.clientX;
                    this.mousePos.y = touch.clientY;
                }
                else {
                    //LFET BUTTON: 
                    //  IE: event.which = undefined, event.button = 1
                    //  Firefox, Safari Win, Opera: event.which = 1, event.button = 0
                    if ( ! event.which && event.button) {
                        if (event.button & 1) {
                            event.which = 1;
                        }
                    }
                    
                    if (event.which !== 1) {
                        return;
                    }
                    
                    this.mousePos.x = event.clientX;
                    this.mousePos.y = event.clientY;
                }                
                
                this.dragAnswer = answer;
                this.dragAnswerEl = document.getElementById(this.getAnswerContainerId(answer));
                
                // На следующем проходе Vue обязательно обновим значение overItem
                var self = this;
                this.$nextTick(function() {
                    self.updateOverItem();
                });
                
                ks.soundManager.playEffect(ks.sounds.ITEM_START_DRAG);
                
                if (event.cancelable) {                
                    event.stopPropagation();
                    event.preventDefault();
                }
            },
            
            doDragAnswer: function(event) {
                if ( ! this.isQuestionState || ! this.dragging) {
                    return;
                }
                
                if (event.type === 'touchmove') {
                    var touch = null;
                    
                    if (typeof event.touches !== 'undefined' && event.touches.length === 1) {
                        touch = event.touches[0];
                    }
                    
                    //var touch = event.touches[0] || event.originalEvent.touches[0] || event.originalEvent.changedTouches[0];
                    // TODO: TEST THIS!!!
                    
                    // +13.01.2020: Добавлена проверка, что touch !== null
                    if (touch === null) {
                        return;
                    }
                    
                    this.mousePos.x = touch.clientX;
                    this.mousePos.y = touch.clientY;
                }
                else {
                    this.mousePos.x = event.clientX;
                    this.mousePos.y = event.clientY;
                }
                
                this.updateOverItem();
                
                if (event.cancelable) {                
                    event.stopPropagation();
                    event.preventDefault();                
                }
            },
            
            startDragAnswerItem: function(event, item) {
                if ( ! this.isQuestionState || ! item.cutted || item.answerIndex === -1) {
                    return;
                }
                var answer = this.answers[item.answerIndex];
                
                item.answerIndex = -1;
                answer.visible = true;
                
                this.startDragAnswer(event, answer);
            },
            
            // Проверяем находится ли под перетаскиваемым ответом свобоный (вырезанный) элемент
            updateOverItem: function() {
                var max = 0, 
                    area = 0;
            
                this.overItem = null;
                
                for (var j = 0; j < this.items.length; j++) {
                    for (var i = 0; i < this.items[j].length; i++) {
                        var item = this.items[j][i];
                        if ( ! item.cutted) {
                            continue;
                        }
                        
                        area = ks.helpers.math.getIntersectionAreaRectangles(item.el.getBoundingClientRect(), this.dragAnswerEl.getBoundingClientRect());
                        if (area > 0) {
                            if (max === 0 || max < area) {
                                max = area;
                                this.overItem = item;
                            }
                        }
                    }
                }
            },
            
            hasEmptyCutItems: function() {
                for (var j = 0; j < this.items.length; j++) {
                    for (var i = 0; i < this.items[j].length; i++) {
                        var item = this.items[j][i];
                        if ( ! item.cutted) {
                            continue;
                        }
                        
                        if (item.answerIndex === -1) {
                            return true;
                        }
                    }
                }
                
                return false;
            },
            
            getAnswersList: function() {
                var answersList = [];
                
                for (var j = 0; j < this.items.length; j++) {
                    for (var i = 0; i < this.items[j].length; i++) {
                        var item = this.items[j][i];
                        if ( ! item.cutted) {
                            continue;
                        }
                        
                        var answer = this.answers[item.answerIndex];
                        answersList.push({
                            x: answer.x,
                            y: answer.y,
                            modifier: answer.modifier
                        });
                    }
                }          
                
                return answersList;
            },
            
            onAnswer: function() {
                if (this.hasEmptyCutItems()) {
                    this.$refs.answerAlert.show('Нужно заполнить все недостающие части картинки.', ks.consts.ALERT_INFO);
                    
                    return;
                }
                
                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: this.getAnswersList()
                }, this.onCheckAnswer);                
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                this.text = data.message.text;
                
                if ( ! data.correct) {
                    this.state = ks.consts.EXERCISE_STATE_INVALID_ANSWER;
                    
                    if (data.comment) {
                        this.answerComment = data.comment;
                    }
                    
                    this.$emit('answer', false, data.message, true);
                    
                    var self = this;
                    this.$nextTick(function(){
                        self.calcSizes();
                    });
                    
                    return;
                }
                
                this.state = ks.consts.EXERCISE_STATE_CORRECT_ANSWER;
                
                this.$emit('answer', true, data.message, true);
            },
            
            onMouseEnterSendAnswer: function() {
                ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER);
            },
            
            showMainPage: function() {
                this.isMainPage = true;
                
                var self = this;
                this.$nextTick(function() {
                    self.calcSizes();
                });                
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            onShowComment: function() {
                ks.app.$refs.answerCommentDlg.show(this.answerComment);
            }
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 16.08.2018
 * 
 *  17.08.2021:
 *   + 'exercise-item-missing-item-select-answer' component
 *   
 */

(function() {
    
    //--
    Vue.component('exercise-item-missing-item-select-answer', {
        template: 
            '<div class="exercise-item-missing-item-answer exercise-item-missing-item-select-answer" :class="answerContainerClass" v-hammer:tap="onTap" @mouseenter="onMouseEnterAnswer">'+
            '    <div class="exercise-item-missing-item-img" :style="answerStyle"></div>'+
            '</div>',    
    
        props: {
            answerContainerClass: {
                type: Object,
                required: true
            },
            
            answerStyle: {
                type: Object,
                required: true
            }
        }, 
        
        data: function() {
            return {};
        },
        
        methods: {
            onTap: function(){
                this.$emit('click');
            },
            
            onMouseEnterAnswer: function(){
                this.$emit('mouseenter');
            }
        }
    });
    //--      

    Vue.component('exercise-item-missing-item-select', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                isMainPage: false,
                
                state: -1,
                
                answerComment: '',
                
                text: '',
                
                resizeTimer: null,
                
                // Размер изображения в зависимости от размера окна браузера
                imageWidth: 0,
                imageHeight: 0,
                
                // Элементы изображения
                items: [],
                
                // Вырезанный элемент (координаты)
                cutItem: {
                    x: -1,
                    y: -1
                },
                
                // Сдвиг контейнера изображения по оси x для центрирования
                containerOffset: 0,
                
                // Элементы-ответы
                answers: []
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },
            
            // Ширина одного элемента
            itemWidth: function() {
                return this.imageWidth / this.exercise.options.hPiecesCount;
            },
            
            // Высота одного элемента
            itemHeight: function() {
                return this.imageHeight / this.exercise.options.vPiecesCount;
            },
            
            // Сдвиг контейнера элементов для центрирования
            itemsContainerStyle: function() {
                return {
                    'padding-left': this.containerOffset + 'px'
                };
            },
            
            // Находимся ли в режиме перемещения элемента-ответа
            dragging: function() {
                return this.dragAnswer !== null;
            },
            
            isQuestionState: function() {
                return this.state === ks.consts.EXERCISE_STATE_QUESTION;
            },
            
            isInvalidAnswerState: function() {
                return this.state === ks.consts.EXERCISE_STATE_INVALID_ANSWER;
            },
            
            isCommentEmpty: function() {
                return this.answerComment === '';
            },
            
            hasEntryPage: function() {
                if (this.exercise === null) {
                    return false;
                }
                
                return typeof this.exercise.extra !== 'undefined' && this.exercise.extra.enabled;
            },            
            
            showInitialState: function() {
                if (this.exercise === null || ! this.exercise.showInitialState) {
                    return false;
                }
                
                return ( ! this.isMainPage || ! this.hasEntryPage);
            },
            
            imageSrc: function() {
                return this.exercise === null ? '' : this.exercise.image.url;
            }
        },
        
        methods: {
            init: function() {
                this.isMainPage = false;
                this.state = ks.consts.EXERCISE_STATE_QUESTION;
                this.answerComment = '';
                this.correctAnswer = [];  
                this.text = '';
                this.items = [];
                this.cutItem.x = -1;
                this.cutItem.x = -2;
                this.containerOffset = 0;
                this.answers = [];
            },
            
            load: function(exercise) {
                this.exercise = exercise;
                
                this.init();    
                
                this.$refs.standard.load(exercise);
                
                this.cutItem.x = this.exercise.cutItem.x;
                this.cutItem.y = this.exercise.cutItem.y;
                
                this.loadItems();
                this.loadAnswers();
                
                window.addEventListener('resize', this.onWindowResize);
                
                this.loaded = true;
                
                var self = this;
                this.$nextTick(function() {
                    self.calcSizes();
                });
            },
            
            unload: function() {
                if (this.loaded) {
                    window.removeEventListener('resize', this.onWindowResize);
                    
                    this.loaded = false;

                    this.$refs.standard.unload();

                    this.init(); 
                    
                    this.exercise = null;
                }
            },
            
            // При изменении экрана (но не чаще 300 мс) изменяем размер элементов
            onWindowResize: function() {
              if (this.resizeTimer !== null) {
                    clearTimeout(this.resizeTimer);
                    this.resizeTimer = null;
                }

                var self = this;
                this.resizeTimer = setTimeout(function(){
                    self.calcSizes();
                    self.resizeTimer = null;
                }, 300);            
            }, 
            
            calcSizes: function() {
                var width = this.isInvalidAnswerState ? this.$refs.answersContainer.offsetWidth + 30 /*.row margin-left: -15px; maring-right: 15px;*/ : 
                        this.$refs.itemsContainer.offsetWidth;
                
                this.imageWidth = width > this.exercise.image.width ? this.exercise.image.width : width - 8;
                this.containerOffset = (width - this.imageWidth) / 2;
                
                var coef = this.exercise.image.width / this.exercise.image.height;
                this.imageHeight = this.imageWidth / coef;
            },
            
            loadItems: function() {
                this.items = [];
                
                for (var j = 0; j < this.exercise.options.vPiecesCount; j++) {
                    var row = [];
                    
                    for (var i = 0; i < this.exercise.options.hPiecesCount; i++) {
                        var item = {
                            x: i,
                            y: j
                        };
                        
                        row.push(item);
                    }
                    
                    this.items.push(row);
                }  
            },
            
            loadAnswers: function() {
                var answers = JSON.parse(this.exercise.answers);                
                
                for (var i = 0; i < answers.length; i++) {
                    answers[i].selected = false;
                    if (typeof answers[i].modifier === 'undefined') {
                        answers[i].modifier = ksGlobal.ImageModifier.values.None;
                    }
                }
         
                this.answers = answers; 
            },
            
            getCorrectAnswer: function() {
                for (var i = 0; i < this.answers.length; i++) {
                    var answer = this.answers[i];
                    if (answer.x === this.cutItem.x && answer.y === this.cutItem.y && 
                       (answer.modifier === ksGlobal.ImageModifier.values.None)) {
                       return answer;
                    }
                }
                
                return null;
            },
            
            getSelectedAnswer: function() {
                for (var i = 0; i < this.answers.length; i++) {
                    var answer = this.answers[i];
                    
                    if (answer.selected) {
                        return answer;
                    }
                }
                
                return null;
            },
            
            /**
             * 
             * @param {Object} item
             * @param {Boolean} answerMode Режим ответов
             * @param {Boolean} correctAnswerMode Режим ответов: правильный или неправильный(только для answerMode = true)
             * @returns {Object}
             */
            getItemStyle: function(item, answerMode, correctAnswerMode) {
                var left = item.x * this.itemWidth,
                    top = item.y * this.itemHeight,
                    style = {
                        'width': this.itemWidth + 'px',
                        'height': this.itemHeight + 'px',
                        'line-height': this.itemHeight + 'px'
                    };    
                
                if (this.isItemCut(item) && ! (answerMode && correctAnswerMode)) {
                    if ( ! answerMode) {
                        // nothing
                    } else {
                        if (correctAnswerMode) {
                            style = this.getAnswerStyle(this.getCorrectAnswer());
                        }  else {
                            style = this.getAnswerStyle(this.getSelectedAnswer());
                        }
                    }
                } else {
                    // Элемент не вырезан
                    style['background-image'] = 'url(' + this.exercise.image.url + ')';
                    style['background-position'] = '-' + left + 'px -' + top + 'px';
                    style['background-size'] = this.imageWidth + 'px ' + this.imageHeight + 'px';
                }
                
                return style;
            },

            /**
             * 
             * @param {Object} item
             * @param {Boolean} answerMode Режим ответов
             * @param {Boolean} correctAnswerMode Режим ответов: правильный или неправильный(только для answerMode = true)
             * @returns {Object}
             */

            getItemClass: function(item, answerMode, correctAnswerMode) {
                if ( ! this.isItemCut(item)) {
                    return {};
                }
                
                var correctAnswer = this.getSelectedAnswer() === this.getCorrectAnswer();
                
                return {
                    // Только для режима ответов
                    'correct-answer': answerMode && (correctAnswerMode || correctAnswer),
                    'incorrect-answer': answerMode && (! correctAnswerMode && ! correctAnswer)
                };
            },
            
            isItemCut: function(item) {
                return item.x === this.cutItem.x && item.y === this.cutItem.y;
            },
            
            getAnswerStyle: function(answer) {
                var left = answer.x * this.itemWidth,
                    top = answer.y * this.itemHeight;
                
                return {
                    'width': this.itemWidth + 'px',
                    'height': this.itemHeight + 'px',
                    'line-height': this.itemHeight + 'px',
                    'background-image': 'url(' + this.exercise.image.url + ')',
                    'background-position': '-' + left + 'px -' + top + 'px',
                    'background-size': this.imageWidth + 'px ' + this.imageHeight + 'px',
                    'transform': ksGlobal.ImageModifier.getTransform(answer.modifier),
                    '-webkit-transform': ksGlobal.ImageModifier.getTransform(answer.modifier)
                };
            },   
            
            getAnswerContainerClass: function(answer) {
                return {
                    'selected': answer.selected
                };
            },
            
            onClickAnswer: function(answer) {
                if ( ! answer.selected) {
                    ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                }
                
                answer.selected = true;
                
                for (var i = 0; i < this.answers.length; i++) {
                    if (this.answers[i] !== answer && this.answers[i].selected) {
                        this.answers[i].selected = false;
                    }
                }
            },
            
            onAnswer: function() {
                var selectedAnswer = this.getSelectedAnswer();
                
                if (selectedAnswer === null) {
                    var info = { text: 'Нужно выбрать недостающую часть картинки.', sound: ks.sounds.NEED_SELECT_MISSING_PART_PICTURE };
                    
                    this.$refs.answerAlert.show(info.text, ks.consts.ALERT_INFO);
                    this.$emit('play-sound', info.sound);
                    
                    return;
                }
                
                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: {
                        x: selectedAnswer.x,
                        y: selectedAnswer.y,
                        modifier: selectedAnswer.modifier
                    }
                }, this.onCheckAnswer);                
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                this.text = data.message.text;
                
                if ( ! data.correct) {
                    this.state = ks.consts.EXERCISE_STATE_INVALID_ANSWER;
                    
                    if (data.comment) {
                        this.answerComment = data.comment;
                    }
                    
                    this.$emit('answer', false, data.message, true);
                    
                    var self = this;
                    this.$nextTick(function(){
                        self.calcSizes();
                    });
                    
                    return;
                }
                
                this.state = ks.consts.EXERCISE_STATE_CORRECT_ANSWER;
                
                this.$emit('answer', true, data.message, true);
            },
            
            onMouseEnterAnswer: function(answer) {
                if ( ! answer.selected) {
                    ks.soundManager.playEffect(ks.sounds.ANSWER_HOVER);
                }
            },            
            
            onMouseEnterSendAnswer: function() {
                ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER);
            },
            
            showMainPage: function() {
                this.isMainPage = true;
                
                var self = this;
                this.$nextTick(function() {
                    self.calcSizes();
                });
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            onShowComment: function() {
                ks.app.$refs.answerCommentDlg.show(this.answerComment);
            }
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 24.12.2017
 */

(function() {

    var States = {
            PREVIEW : 0,
            PUZZLE  : 1,
            FINISH  : 2
        };

    Vue.component('exercise-item-puzzle-classic', {
        data: function() {
            return {
                exercise: null,

                loaded: false,

                text: '',

                state: States.PREVIEW,

                steps: 0,

                animateFinish: {
                    opacity: 0,
                    count : 0
                },

                correctAnswerMessage: '',

                isCorrect: false
            };
        },

        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },

            puzzleClass: function() {
                return {
                    'hidden' : ! this.loaded
                };
            },

            isStatePreview: function() {
                return this.state === States.PREVIEW;
            },

            isStatePuzzle: function() {
                return this.state === States.PUZZLE;
            },

            isStateFinish: function() {
                return this.state === States.FINISH;
            }
        },

        methods: {
            init: function() {
                this.text = '';

                this.state = States.PREVIEW;

                this.steps = 0;

                this.isCorrect = false;

                this.puzzle.unload(true);
            },

            load: function(exercise) {
                var self = this;

                this.exercise = exercise;

                this.init();

                this.text = this.exercise.text;
                this.$store.commit('current/setExercisesCurrentPage', ks.consts.EXERCISE_PAGE_MAIN);

                this.loaded = true;

                this.$nextTick(function() {
                    self.puzzle.load({
                        image: {
                            url: self.exercise.image.url,
                            width: self.exercise.image.width,
                            height: self.exercise.image.height
                        },

                        items: {
                            hCount: self.exercise.options.hPiecesCount,
                            vCount: self.exercise.options.vPiecesCount
                        },

                        maxShuffleIterations: self.exercise.options.maxShuffleIterations,

                        events: {
                            // Событие возникает при клике по пазлу в previwe-режиме (аналогичну нажатию кноки "Начать")
                            onStart: self.onStart,
                            // Событие возникает когда пазл собран
                            onFinish: self.onFinish,
                            // Событие возникает при каждом перемещении элементов пазла
                            onStep: self.onStep
                        }
                    });
                });
            },

            unload: function() {
                if (this.loaded) {
                    this.loaded = false;

                    this.init();

                    this.exercise = null;
                }
            },

            onNext: function() {
                this.unload();
                this.$emit('next');
            },

            onStart: function() {
                this.state = States.PUZZLE;

                this.puzzle.shuffleItems();
            },

            onStop: function() {
                ks.app.$refs.messageBox.show({
                    type     : ks.consts.MBT_WARNING,
                    title    : 'Завершить задание?',
                    text     : 'Задание не пройдено. Хочешь завершить задание сейчас?',
                    buttons  : ks.consts.MBB_YES_NO,
                    onClose  : this.confirmStop
                });
            },

            confirmStop: function(modalResult) {
                if (modalResult !== ks.consts.MBB_YES) return;

                this.onFinish(false);
            },

            onShowImage: function() {
                ks.app.$refs.imagePreviewDlg.show({
                    title: 'Должна получиться такая картинка',
                    imageSrc: this.exercise.image.url,
                    opacity: 0.8
                });
            },

            onFinish: function(isCorrect) {
                this.state = States.FINISH;
                this.isCorrect = isCorrect;

                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: isCorrect
                }, this.onCheckAnswer);

            },

            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }

                if (this.isCorrect) {
                    // Стартуем анимацию, после анимации передаем событие 'answer'
                    this.startAnimateFinish(data.message);
                } else {
                    this.$emit('answer', false, data.message, false);
                    this.onNext();
                }
            },

            onStep: function() {
                this.steps++;
            },

            startAnimateFinish: function(message) {
                this.animateFinish.opacity = 0;
                this.animateFinish.count = 0;
                this.correctBox.css('opacity', 0);

                // Запомним сообщение, чтобы потом показать его
                this.correctAnswerMessage = message;

                this.animateFinishStep();
            },

            animateFinishStep: function() {
                var self = this;

                this.animateFinish.opacity = this.animateFinish.opacity === 0 ? 0.5 : 0;

                this.correctBox.animate({
                    opacity: this.animateFinish.opacity
                }, 500, 'swing', function(){
                    if (self.animateFinish.count <= 2) {
                        self.animateFinish.count++;
                        self.animateFinishStep();
                    } else {
                        self.$emit('answer', true, self.correctAnswerMessage, true);
                    }
                });
            }

        },

        mounted: function() {
            this.puzzle = new ks.PuzzleClassic($(this.$refs.puzzle));
            this.correctBox = $(this.$refs.correctBox);
        }
    });

}());

/** (c) Kids-Smart.ru
 *  Author: -AF-
 *  Date: 07.01.2017
 */

(function() {
    
    var States = {
            PREVIEW : 0,
            PUZZLE  : 1,
            FINISH  : 2
        };

    Vue.component('exercise-item-puzzle-zero-field', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                text: '',
                
                state: States.PREVIEW,
                
                steps: 0,
                
                animateFinish: {
                    opacity: 0,
                    count : 0
                },
                
                correctAnswerMessage: '',
                
                isCorrect: false
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },
            
            puzzleZeroField: function() {
                return {
                    'hidden' : ! this.loaded
                };
            },
            
            isStatePreview: function() {
                return this.state === States.PREVIEW;
            },
            
            isStatePuzzle: function() {
                return this.state === States.PUZZLE;
            },
            
            isStateFinish: function() {
                return this.state === States.FINISH;
            }              
        },
        
        methods: {
            init: function() {
                this.text = '';
                
                this.state = States.PREVIEW;
                
                this.steps = 0;
                
                this.isCorrect = false;
                
                this.puzzle.unload(true);
            },
            
            load: function(exercise) {
                var self = this;
                
                this.exercise = exercise;
                
                this.init();    
                
                this.text = this.exercise.text;
                this.$store.commit('current/setExercisesCurrentPage', ks.consts.EXERCISE_PAGE_MAIN);
                
                var shuffleMinPercent;
                switch (this.exercise.level) {
                    case 2:
                        shuffleMinPercent = 85;
                        break;
                        
                    case 3:
                        shuffleMinPercent = 99;
                        break;
                        
                    default:
                        shuffleMinPercent = 70;
                        break;
                }
                
                this.loaded = true;
                
                this.$nextTick(function() {
                    self.puzzle.load({
                        image: {
                            url: self.exercise.image.url,
                            width: self.exercise.image.width,
                            height: self.exercise.image.height
                        },

                        items: {
                            hCount: self.exercise.options.hPiecesCount,
                            vCount: self.exercise.options.vPiecesCount
                        },
                        
                        shuffleMinPercent: shuffleMinPercent,

                        maxShuffleIterations: self.exercise.options.maxShuffleIterations,

                        events: {
                            // Событие возникает при клике по пазлу в previwe-режиме (аналогичну нажатию кноки "Начать")
                            onStart: self.onStart,
                            // Событие возникает когда пазл собран
                            onFinish: self.onFinish,
                            // Событие возникает при каждом перемещении элементов пазла
                            onStep: self.onStep
                        }                     
                    });
                });
            },
            
            unload: function() {
                if (this.loaded) {
                    this.loaded = false;

                    this.init(); 

                    this.exercise = null;
                }
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            onStart: function() {
                this.state = States.PUZZLE;
                
                this.puzzle.shuffleItems();
            },
            
            onStop: function() {
                ks.app.$refs.messageBox.show({
                    type     : ks.consts.MBT_WARNING,
                    title    : 'Завершить упражнение?',
                    text     : 'Упражнение не пройдено. Хочешь завершить упражнение сейчас?',
                    buttons  : ks.consts.MBB_YES_NO,
                    onClose  : this.confirmStop
                });                 
            },
            
            confirmStop: function(modalResult) {
                if (modalResult !== ks.consts.MBB_YES) return;
                
                this.onFinish(false);                
            },            
            
            onShowImage: function() {
                ks.app.$refs.imagePreviewDlg.show({
                    title: 'Должна получиться такая картинка',
                    imageSrc: this.exercise.image.url,
                    opacity: 0.8
                });
            },
            
            onFinish: function(isCorrect) {
                this.state = States.FINISH;
                this.isCorrect = isCorrect;
                
                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: isCorrect
                }, this.onCheckAnswer);                 
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                if (this.isCorrect) {                
                    // Стартуем анимацию, после анимации передаем событие 'correct-answer'
                    this.startAnimateFinish(data.message);                
                } else {
                    this.$emit('answer', false, data.message, false);
                    this.onNext();
                }
            },            
            
            onStep: function() {
                this.steps++;
            },
            
            startAnimateFinish: function(message) {
                this.animateFinish.opacity = 0;
                this.animateFinish.count = 0;
                this.correctBox.css('opacity', 0);  
                
                // Запомним текст, чтобы потом показать его
                this.correctAnswerMessage = message;
                
                this.animateFinishStep();
            },
            
            animateFinishStep: function() {
                var self = this;
                
                this.animateFinish.opacity = this.animateFinish.opacity === 0 ? 0.5 : 0;
                
                this.correctBox.animate({
                    opacity: this.animateFinish.opacity								
                }, 500, 'swing', function(){
                    if (self.animateFinish.count <= 2) {
                        self.animateFinish.count++;
                        self.animateFinishStep();
                    } else {
                        self.$emit('answer', true, self.correctAnswerMessage, true); 
                    }
                });                  
            }
            
        },
        
        mounted: function() {
            this.puzzle = new ks.PuzzleZeroField($(this.$refs.puzzle));
            this.correctBox = $(this.$refs.correctBox);
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 28.08.2024
 */

(function() {
  const SOUND_LOCK = 'public/sounds/exercises/sort-balls/sort_balls_lock.ogg';
  const SOUND_START_DRAG = 'public/sounds/exercises/sort-balls/sort_balls_start_drag.ogg';
  const SOUND_STOP_DRAG = 'public/sounds/exercises/sort-balls/sort_balls_stop_drag.ogg';

  Vue.component('exercise-item-sort-balls', {
    data() {
      return {
        exercise: null,

        loaded: false,

        isMainPage: false,

        state: -1,

        text: '',

        containers: [],

        hideNoTopBalls: false,

        dragBall: {
          containerIndex: -1,
          ballIndex: -1
        },

        pointer: {
          x: 0,
          y: 0,
          down: false
        },

        ballSize: {
          width: 70,
          height: 70,

          glare: {
            width: 13,
            height: 13,
            top: 10,
            left: 12
          }
        },

        ballBoxSize: {
          width: 80,
          height: 75,
          dividerHeight: 5
        },

        isCompleted: false
      };
    },

    computed: {
      exerciseId() {
        return this.exercise !== null ? this.exercise.id : -1;
      },

      isQuestionState() {
        return this.state === ks.consts.EXERCISE_STATE_QUESTION;
      },

      isInvalidAnswerState() {
        return this.state === ks.consts.EXERCISE_STATE_INVALID_ANSWER;
      },

      maxContanierSize() {
        return this.containers.length <= 0 ? 0 : Math.max(
          ...this.containers.map(container => container.size)
        );
      }
    },

    methods: {
      init() {
        this.isMainPage = false;
        this.state = ks.consts.EXERCISE_STATE_QUESTION;
        this.text = '';

        this.containers = [];

        this.hideNoTopBalls = false;

        this.pointer.x = 0;
        this.pointer.y = 0;
        this.pointer.down = false;

        this.dragBall.containerIndex = -1;
        this.dragBall.ballIndex = -1;

        this.isCompleted = false;
      },

      load(exercise) {
        this.exercise = exercise;

        this.init();

        this.$refs.standard.load(exercise);

        this.hideNoTopBalls = exercise.hideNoTopBalls;

        exercise.containers.forEach(containerData => {
          this.containers.push({
            color: containerData.color,
            size: containerData.size,
            balls: this.createBalls(containerData),
            /** @var null|DOMRect */
            rect: null,
            isTarget: false,
            completed: false,
            empty: false,
          });
        });

        this.initializeContainers();

        window.addEventListener('mouseup', this.pointerUp);
        window.addEventListener('touchend', this.pointerUp);

        window.addEventListener('mousemove', this.pointerMove);
        window.addEventListener('touchmove', this.pointerMove, { passive: false });

        window.addEventListener('resize', this.onWindowResize);

        this.onWindowResize();

        this.loaded = true;

        if (exercise.howToPlayStep && exercise.howToPlayStep > 0) {
          setTimeout(() => {
            this.showHowToPlay(exercise.howToPlayStep, true);
          }, 300);
        }
      },

      unload() {
        if (! this.loaded) {
          return;
        }

        window.removeEventListener('mouseup', this.pointerUp);
        window.removeEventListener('touchend', this.pointerUp);

        window.removeEventListener('mousemove', this.pointerMove);
        window.removeEventListener('touchmove', this.pointerMove);

        window.removeEventListener('resize', this.onWindowResize);

        this.loaded = false;

        this.$refs.standard.unload();

        this.init();

        this.exercise = null;
      },

      showMainPage() {
        this.isMainPage = true;
      },

      getAnswer() {
        return true;
      },

      onAnswer() {
        this.$parent.sendAnswer({
          exerciseId: this.exercise.id,
          answer: this.getAnswer()
        }, this.onCheckAnswer);
      },

      onCheckAnswer(errorCode, data) {
        if (errorCode !== ks.consts.ERR_OK) {
          this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
          return;
        }

        this.state = ks.consts.EXERCISE_STATE_CORRECT_ANSWER;

        this.$emit('answer', true, data.message, true);
      },

      onWindowResize() {
        const windowWidth = window.innerWidth;
        const ballSize = windowWidth > 400 ? 70 : Math.floor(windowWidth / 4) - 30;
        const ballGrareSize = windowWidth > 400 ? 13 : Math.floor(ballSize * 0.18);

        this.ballSize.width = ballSize;
        this.ballSize.height = ballSize;

        this.ballSize.glare.width = ballGrareSize;
        this.ballSize.glare.height = ballGrareSize;
        this.ballSize.glare.top = ballGrareSize;
        this.ballSize.glare.left = ballGrareSize - 1;

        this.ballBoxSize.width = ballSize + 10;
        this.ballBoxSize.height = ballSize + 5;
      },

      getContainerClass(index) {
        const count = this.containers.length;
        if (count <= 0) {
          return {};
        }

        const classList = [];

        switch (count) {
          case 3:
          case 6:
            classList.push(
              'col-lg-4',
              'col-md-4',
              'col-sm-4',
              'col-xs-4'
            );

            break;

          case 4:
            classList.push(
              'col-lg-3',
              'col-md-3',
              'col-sm-3',
              'col-xs-6'
            );

            break;

          case 5:
            classList.push(
              'col-lg-5ths',
              'col-md-5ths',
              'col-sm-5ths',
            );

            if (index >= this.containers.length - 2) {
              classList.push('col-xs-6');
            } else {
              classList.push('col-xs-4');
            }
            break;

          case 7:
            if (index >= this.containers.length - 3) {
              classList.push(
                'col-lg-4',
                'col-md-4',
                'col-sm-4',
                'col-xs-4'
              );
            } else {
              classList.push(
                'col-lg-3',
                'col-md-3',
                'col-sm-3',
                'col-xs-3'
              );
            }

            break;

          case 8:
            classList.push(
              'col-lg-3',
              'col-md-3',
              'col-sm-3',
              'col-xs-3'
            );

            break;
        }

        let classes = {}
        classList.forEach(className => classes[className] = true);

        return classes;
      },

      updateContainerRect(data) {
        this.containers[data.index].rect = data.rect;
      },

      createBalls(containerData) {
        const balls = [];
        let lastBall = '';

        for (let i = 0; i < containerData.balls.length; i++) {
          const ball = containerData.balls[i];
          balls.push({
            color: ball,
            hidden: this.hideNoTopBalls && ball !== '' && lastBall !== ''
          });

          lastBall = ball;
        }

        return balls;
      },

      initializeContainers() {
        this.containers.forEach(container => {
          container.completed = this.isContainerComplete(container);
          container.empty = this.isContainerEmpty(container);
        });
      },

      isContainerEmpty(container) {
        for (const ball of container.balls) {
          if (ball.color !== '') {
            return false;
          }
        }

        return true;
      },

      isContainerComplete(container) {
        if (container.balls.length <= 0) {
          return false;
        }

        let ballColor = null;

        for (const ball of container.balls) {
          if (this.hideNoTopBalls && ball.hidden) {
            return false;
          }

          if (container.color && ball.color !== '' && container.color !== ball.color) {
            return false;
          }

          if (ballColor === null) {
            ballColor = ball.color;
            continue;
          }

          if (ballColor !== ball.color) {
            return false;
          }
        }

        return true;
      },

      updateCompleteStatuses(containers) {
        let hasCompleted = false;

        containers.forEach(container => {
          const completed = this.isContainerComplete(container);
          const empty = this.isContainerEmpty(container);

          if ((! container.completed || container.empty) && completed && ! empty) {
            hasCompleted = true;
          }

          container.completed = completed;
          container.empty = empty;
        });

        if (hasCompleted) {
          //ks.soundManager.playEffect(SOUND_CORRECT);
        }
      },

      isComplete() {
        if (this.containers.length <= 0) {
          return false;
        }

        for (const container of this.containers) {
          if (! container.completed) {
            return false;
          }
        }

        return true;
      },

      canPutBallToContainer(container) {
        return container.size > 0 && container.balls[0].color === '';
      },

      putBallToContainer(container, ballColor) {
        for (let i = container.balls.length - 1; i >= 0; i--) {
          if (container.balls[i].color === '') {
            container.balls[i].color = ballColor;
            break;
          }
        }
      },

      moveBall(sourceContainerIndex, targetContainerIndex, ballIndex) {
        if (sourceContainerIndex === targetContainerIndex) {
          return;
        }

        const sourceContainer = this.containers[sourceContainerIndex];
        const targetContainer = this.containers[targetContainerIndex];

        const ballColor = sourceContainer.balls[ballIndex].color;
        if (ballIndex < sourceContainer.balls.length - 1) {
          sourceContainer.balls[ballIndex + 1].hidden = false;
        }

        sourceContainer.balls[ballIndex].color = '';

        this.putBallToContainer(targetContainer, ballColor);

        this.updateCompleteStatuses([sourceContainer, targetContainer]);

        setTimeout(() => {
          this.isCompleted = this.isComplete();
          if (this.isCompleted) {
            ks.soundManager.playEffect(ks.sounds.SUCCESS_ACTION);
            setTimeout(() => this.onCompleted(), 2000);
          }
        }, 100);
      },

      onCompleted() {
        this.onAnswer();
      },

      updateBallRect(data) {
        const ballRect = data.rect;

        let containerIndex = -1;
        let containerArea = 0;

        for (let i = 0; i < this.containers.length; i++) {
          const container = this.containers[i];
          const area = ks.helpers.math.getIntersectionAreaRectangles(container.rect, ballRect);

          if (area > containerArea && (data.containerIndex === i || this.canPutBallToContainer(container))) {
            containerArea = area;
            containerIndex = i;
          }
        }

        for (let i = 0, count = this.containers.length; i < count; i++) {
          this.containers[i].isTarget = i === containerIndex;
        }
      },

      startBallDrag(data) {
        this.$store.commit('window/setDraggableMode', true);

        this.dragBall.containerIndex = data.containerIndex;
        this.dragBall.ballIndex = data.ballIndex;

        const event = data.event;

        if (event.type === 'touchstart') {
          let touch = null;

          if (typeof event.touches !== 'undefined' && event.touches.length === 1) {
            touch = event.touches[0];
          }

          if (touch === null) {
            return;
          }

          this.pointer.x = touch.clientX;
          this.pointer.y = touch.clientY;
        }
        else {
          this.pointer.x = event.clientX;
          this.pointer.y = event.clientY;
        }

        this.pointer.down = true;

        ks.soundManager.playEffect(SOUND_START_DRAG);
      },

      stopBallDrag(data) {
        this.$store.commit('window/setDraggableMode', false);

        this.dragBall.containerIndex = -1;
        this.dragBall.ballIndex = -1;

        let containerIndex = -1;
        let containerArea = 0;

        for (let i = 0, count = this.containers.length; i < count; i++) {
          const container = this.containers[i];
          container.isTarget = false;

          const area = ks.helpers.math.getIntersectionAreaRectangles(this.containers[i].rect, data.rect);

          if (area > containerArea && i !== data.containerIndex && this.canPutBallToContainer(container)) {
            containerArea = area;
            containerIndex = i;
          }
        }

        if (containerIndex > -1) {
          this.moveBall(
            data.containerIndex,
            containerIndex,
            data.ballIndex
          );
        }
      },

      pointerUp: function(event) {
        if (! this.pointer.down) {
          return;
        }

        this.pointer.down = false;

        ks.soundManager.playEffect(SOUND_STOP_DRAG);

        if (event.cancelable) {
          event.stopPropagation();
          event.preventDefault();
        }
      },

      pointerMove: function(event) {
        if (! this.pointer.down) {
          return;
        }

        if (event.type === 'touchmove') {
          let touch = null;

          if (typeof event.touches !== 'undefined' && event.touches.length === 1) {
            touch = event.touches[0];
          }

          if (touch === null) {
            return;
          }

          this.pointer.x = touch.clientX;
          this.pointer.y = touch.clientY;
        }
        else {
          this.pointer.x = event.clientX;
          this.pointer.y = event.clientY;
        }

        if (event.cancelable) {
          event.stopPropagation();
          event.preventDefault();
        }
      },

      onNext: function() {
        this.unload();
        this.$emit('next');
      },

      onInactiveBall() {
        ks.soundManager.playEffect(SOUND_LOCK);
      },

      showHowToPlay(step, autoShow) {
        this.$refs.howToPlay.show(step, autoShow);
      },

      stopAudio() {
        this.$emit('stop-audio');
      },

      playExerciseAudio() {
        this.$emit('play-audio');
      }
    }
  });

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 06.10.2023
 */

(function() {

    Vue.component('exercise-item-sort-container', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                isMainPage: false,
                
                state: -1,
                
                text: '',
                
                containersWidth: 0,
                
                containers: [],
                items: [],
                
                correct: {
                    containers: [],
                    answers: []
                },
                
                settings: null,
                
                pointer: { x: 0, y: 0, down: false },
                
                dragItemIndex: -1,
                
                itemVoicePlaying: null
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },
            
            isQuestionState: function() {
                return this.state === ks.consts.EXERCISE_STATE_QUESTION;
            },
            
            isInvalidAnswerState: function() {
                return this.state === ks.consts.EXERCISE_STATE_INVALID_ANSWER;
            },
            
            voiceEnabled: function() {
                return this.$store.getters.isGuest ? this.$store.state.guest.voiceEnabled : this.$store.state.parent.options.sound_voice;
            }
        },
        
        methods: {
            init: function() {
                this.isMainPage = false;
                this.state = ks.consts.EXERCISE_STATE_QUESTION;
                this.text = '';
                
                this.containers = [];
                this.items = [];
                
                this.correct.containers = [];
                this.correct.answers = [];
                
                this.settings = null;
                
                this.pointer.x = 0;
                this.pointer.y = 0;
                this.pointer.down = false;
                
                this.dragItemIndex = -1;
                
                this.itemVoicePlaying = null;
            },
            
            load: function(exercise) {
                this.exercise = exercise;
                
                this.init();    
                
                this.$refs.standard.load(exercise);

                exercise.containers.forEach(container => {
                    this.containers.push({
                        rect          : { left: 0, top: 0, right: 0, bottom: 0 },
                        items         : [],
                        showTargetPad : false,
                        image         : container.image,
                        extra_image   : container.extra_image || null,
                        text          : container.text || null        
                    });
                    
                    this.correct.containers.push({
                        rect          : { left: 0, top: 0, right: 0, bottom: 0 },
                        items         : [],
                        showTargetPad : false,
                        image         : container.image,
                        extra_image   : container.extra_image || null,
                        text          : container.text || null        
                    });                    
                });
                
                exercise.items.forEach(item => {
                    this.items.push({
                        containerIndex : -1,
                        dragging       : false,
                        image          : item.image,
                        modifier       : typeof item.modifier === 'undefined' ? ksGlobal.ImageModifier.values.None : item.modifier,
                        text           : item.text || null,
                        voice          : item.voice || null
                    });
                });
                
                this.settings = exercise.settings;
                
                window.addEventListener('resize', this.onWindowResize);
                
                window.addEventListener('mouseup', this.pointerUp);
                window.addEventListener('touchend', this.pointerUp);
                
                window.addEventListener('mousemove', this.pointerMove);
                window.addEventListener('touchmove', this.pointerMove, { passive: false });  
                
                this.loaded = true;
                
                this.$nextTick(() => {
                    this.onWindowResize();
                });
            },
            
            unload: function() {
                if (this.loaded) {
                    window.removeEventListener('resize', this.onWindowResize);
                    
                    window.removeEventListener('mouseup', this.pointerUp);
                    window.removeEventListener('touchend', this.pointerUp);
                    
                    window.removeEventListener('mousemove', this.pointerMove);
                    window.removeEventListener('touchmove', this.pointerMove);                       
                    
                    this.loaded = false;

                    this.$refs.standard.unload();

                    this.init(); 

                    this.exercise = null;
                }
            },
            
            updateContainerRect(data) {
                data.container.rect = data.rect;
            },
            
            updateRectItem(data) {
                let containerIndex = -1,
                    containerArea = 0;                
                
                for (let i = 0, count = this.containers.length; i < count; i++) {
                    const area = ks.helpers.math.getIntersectionAreaRectangles(this.containers[i].rect, data.rect);
                    
                    if (area > containerArea) {
                        containerArea = area;
                        containerIndex = i;
                    }                    
                }
                
                for (let i = 0, count = this.containers.length; i < count; i++) {
                    this.containers[i].showTargetPad = i === containerIndex;
                }
            },
            
            startDragItem(data) {
                this.$store.commit('window/setDraggableMode', true);
                this.dragItemIndex = this.items.indexOf(data.item);
                
                const event = data.event;
        
                if (event.type === 'touchstart') {
                    var touch = null;
                    
                    if (typeof event.touches !== 'undefined' && event.touches.length === 1) {
                        touch = event.touches[0];
                    }
                    
                    if (touch === null) {
                        return;
                    }
                    
                    this.pointer.x = touch.clientX;
                    this.pointer.y = touch.clientY;
                }
                else {
                    this.pointer.x = event.clientX;
                    this.pointer.y = event.clientY;
                }                
                
                this.pointer.down = true;
            },   
            
            stopDragItem(data) {
                this.$store.commit('window/setDraggableMode', false);
                this.dragItemIndex = -1;
                
                for (let i = 0, count = this.containers.length; i < count; i++) {
                    this.containers[i].showTargetPad = false;
                }                
                
                let containerIndex = -1,
                    containerArea = 0;
                
                for (let i = 0, count = this.containers.length; i < count; i++) {
                    const area = ks.helpers.math.getIntersectionAreaRectangles(this.containers[i].rect, data.rect);
                    
                    if (area > containerArea) {
                        containerArea = area;
                        containerIndex = i;
                    }
                }
                
                if (containerIndex > -1) {
                    if (this.containers[containerIndex].items.length >= 4) {
                        return;
                    }

                    if (data.item.containerIndex === containerIndex) {
                        return;
                    }

                    if (data.item.containerIndex > -1) {
                        this.removeItemFromContainer(data.item);
                    }

                    data.item.containerIndex = containerIndex;

                    this.containers[containerIndex].items.push(this.items.indexOf(data.item));
                } else {
                    if (data.item.containerIndex > -1) {
                        this.removeItemFromContainer(data.item);    
                    }

                    data.item.containerIndex = -1;
                }
            },
            
            playVoiceItem(item) {
                if (this.itemVoicePlaying === item) {
                    return;
                }
                
                this.stopCurrentItemVoice();
        
                ks.soundManager.playVoice(item.voice, {
                    onPlay: (/*soundItem*/) => {
                        this.itemVoicePlaying = item;
                    },
                    
                    onEnd: (/*soundItem*/) => {
                        this.itemVoicePlaying = null;
                    },
                    
                    onStop: (/*soundItem*/) => {
                        this.itemVoicePlaying = null;
                    }
                });                
            },
            
            stopCurrentItemVoice() {
                if (this.itemVoicePlaying === null) {
                    return;
                }
                
                ks.soundManager.stop(this.itemVoicePlaying.voice);
                this.itemVoicePlaying = null;
            },
            
            removeItemFromContainer(item) {
                const container = this.containers[item.containerIndex],
                      itemIndex = this.items.indexOf(item),
                      index = container.items.indexOf(itemIndex);
                container.items.splice(index, 1);                 
            },
            
            pointerUp: function(event) {
                if ( ! this.pointer.down) {
                    return;
                }
                
                this.pointer.down = false;
                
                ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                
                if (event.cancelable) {
                    event.stopPropagation();
                    event.preventDefault();                
                }
            },      
            
            pointerMove: function(event) {
                if (! this.pointer.down) {
                    return;
                }
                
                if (event.type === 'touchmove') {
                    var touch = null;
                    
                    if (typeof event.touches !== 'undefined' && event.touches.length === 1) {
                        touch = event.touches[0];
                    }
                    
                    if (touch === null) {
                        return;
                    }
                    
                    this.pointer.x = touch.clientX;
                    this.pointer.y = touch.clientY;
                }
                else {
                    this.pointer.x = event.clientX;
                    this.pointer.y = event.clientY;
                }
                
                if (event.cancelable) {                
                    event.stopPropagation();
                    event.preventDefault();                
                }
            },      
            
            getAnswer: function() {
                return this.items.map(item => {
                    return item.containerIndex;
                });
            },
            
            onAnswer: function() {
                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: this.getAnswer()
                }, this.onCheckAnswer);
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                this.stopCurrentItemVoice();
                
                this.text = data.message.text;
                
                if ( ! data.correct) {
                    this.state = ks.consts.EXERCISE_STATE_INVALID_ANSWER;
                    
                    this.correct.answers = data.correctAnswer;
                    
                    for (let i = 0; i < this.correct.answers.length; i++) {
                        const containerIndex = this.correct.answers[i];
                        if (containerIndex < 0) {
                            continue;
                        }
                        this.correct.containers[containerIndex].items.push(i);
                    }
                    
                    this.$nextTick(() => {
                        this.onWindowResize();
                    });                
                    
                    this.$emit('answer', false, data.message, true);
                    
                    return;
                }
                
                this.state = ks.consts.EXERCISE_STATE_CORRECT_ANSWER;
                
                this.$emit('answer', true, data.message, true);
            },
            
            onMouseEnterSendAnswer: function() {
                ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER);
            },             
            
            showMainPage: function() {
                this.isMainPage = true;
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            onWindowResize: function() {
                this.containersWidth = this.$refs.containersWidth.clientWidth;
            }
        },
        
        watch: {
            voiceEnabled: function() {
                if (! this.voiceEnabled) {
                    this.stopCurrentItemVoice();
                }
            }
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 24.03.2020
 */

(function() {

    /*
     *
    const MODE_WORDS         = 0;
    const MODE_IMAGES        = 1;
    const MODE_FIRST_LETTER  = 2;
    const MODE_COUNT_LETTERS = 3;
     *
     */

    var States = {
            MAIN   : 0,
            FINISH : 1
        };

    Vue.component('exercise-item-square-letters', {
        data: function() {
            return {
                exercise: null,

                loaded: false,

                text: '',

                state: States.MAIN,

                field: [],
                words: [],

                mode: 0, /* MODE_WORDS */
                useHints: true,

                fieldLoaded: false,

                isCorrect: false,

                incorrectAnswer: false,

                beforeFinish: false
            };
        },

        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },

            isStateMain: function() {
                return this.state === States.MAIN;
            },

            isStateFinish: function() {
                return this.state === States.FINISH;
            }
        },

        methods: {
            init: function(field, words) {
                this.text = '';

                this.state = States.MAIN;
                this.isCorrect = false;
                this.beforeFinish = false;

                this.field = [];
                for (var j = 0; j < field.length; j++) {
                    var row = [];

                    for (var i = 0; i < field.length; i++) {
                        row.push({
                            letter: field[j][i],
                            x: i,
                            y: j,
                            selected: false,
                            animate: false,
                            showHint: false,
                            wordIndexes: []
                        });
                    }

                    this.field.push(row);
                }

                this.words = words;

                var self = this;
                this.$nextTick(function() {
                    self.fieldLoaded = true;
                });
            },

            load: function(exercise) {
                this.exercise = exercise;

                this.init(JSON.parse(exercise.field), JSON.parse(exercise.words));

                this.mode = this.exercise.mode;
                this.useHints = this.exercise.useHints;

                this.text = this.exercise.text;

                this.incorrectAnswer = false;

                this.$store.commit('current/setExercisesCurrentPage', ks.consts.EXERCISE_PAGE_MAIN);

                this.loaded = true;
            },

            unload: function() {
                if (this.loaded) {
                    this.loaded = false;

                    this.state = -1;

                    this.field = [];
                    this.fieldLoaded = false;
                    this.words = [];

                    this.exercise = null;
                }
            },

            onNext: function() {
                this.unload();
                this.$emit('next');
            },

            onStop: function() {
                ks.app.$refs.messageBox.show({
                    type     : ks.consts.MBT_WARNING,
                    title    : 'Завершить задание?',
                    text     : 'Задание не пройдено. Хочешь завершить задание сейчас?',
                    buttons  : ks.consts.MBB_YES_NO,
                    onClose  : this.confirmStop
                });
            },

            confirmStop: function(modalResult) {
                if (modalResult !== ks.consts.MBB_YES) return;

                this.onFinish(false);
            },

            onFinish: function(isCorrect) {
                this.state = States.FINISH;
                this.isCorrect = isCorrect;

                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: isCorrect
                }, this.onCheckAnswer);
            },

            onBeforeFinish: function() {
                this.beforeFinish = true;
            },

            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }

                if (this.isCorrect) {
                     this.$emit('answer', true, data.message, true);
                } else {
                    this.incorrectAnswer = true;

                    this.$emit('answer', false, data.message, false);
                    //this.onNext();
                }
            },

            wordSelected: function(word) {
                // Пока ничего не делаем
            },

            wordDuplicate: function(word) {
                // Пока ничего не делаем
            }

        },

        mounted: function() {

        }
    });

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 19.12.2017
 * 
 * 13.09.2019:
 *   + answers.useLoading
 *   
 * 17.08.2021:
 *   + 'exercise-item-standard-group-images-answer' component
 *   
 * 23.12.2021:
 *  + Добавлена поддержка нескольких модификаторов для изображений в ответах  
 */

(function() {
    
    //--
    Vue.component('exercise-item-standard-group-images-answer', {
        template: 
            '<div class="exercise-item-answers-item-container" :style="answerStyle">'+
            '  <div class="exercise-item-answers-item" :class="answerClass" v-hammer:tap="onTap" @mouseenter="onMouseEnterAnswer">'+
            '    <img :style="answerImageStyle" :src="answerImageSrc" />'+
            '    <div v-if="answerLoadingActive" class="exercise-item-answers-item-loader">'+
            '      <div>'+
            '         <img src="/public/images/loaders/answer_loader.gif" />'+
            '      </div>'+
            '    </div>'+
            '  </div>'+ 
            '</div>',
    
        props: {
            answerStyle: {
                type: Object,
                required: true
            },
            
            answerClass: {
                type: Object,
                required: true
            },
            
            answerImageStyle: {
                type: Object,
                required: true                
            },
            
            answerImageSrc: {
                type: String,
                required: true
            },
            
            answerLoadingActive: {
                type: Boolean,
                required: true
            }
        }, 
        
        data: function() {
            return {};
        },
        
        methods: {
            onTap: function(){
                this.$emit('click');
            },
            
            onMouseEnterAnswer: function(){
                this.$emit('mouseenter');
            }
        }
    });
    //--
    

    Vue.component('exercise-item-standard-group-images', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                answers: [],                
                
                isMainPage: false,
                
                state: -1,
                
                answerComment: '',
                
                text: '',
                
                answersLoader: {
                    timer: {
                        id: null,
                        interval: 700
                    }
                }
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },
            
            answerStyle: function() {
                if (this.exercise === null) {
                    return {};
                }
                
                return {
                    width: 100 / this.exercise.answers.columns + '%'
                }; 
            },
            
            answerMultiselect: function() {
                return this.exercise !== null ? this.exercise.answers.multiselect : false;
            },
            
            isQuestionState: function() {
                return this.state === ks.consts.EXERCISE_STATE_QUESTION;
            },
            
            isInvalidAnswerState: function() {
                return this.state === ks.consts.EXERCISE_STATE_INVALID_ANSWER;
            },
            
            isCommentEmpty: function() {
                return this.answerComment === '';
            },
            
            answersUseLoading: function() {
                return this.exercise !== null ? this.exercise.answers.useLoading : false;
            },
            
            isAnswersLoadingFinished: function() {
                if ( ! this.answersUseLoading) {
                    return true;
                }
                
                for (var i = 0, count = this.answers.length; i < count; i++) {
                    if (this.answers[i].loading.active) {
                        return false;
                    }
                }
                
                return true;
            }
        },
        
        methods: {
            init: function() {
                this.isMainPage = false;
                this.state = ks.consts.EXERCISE_STATE_QUESTION;
                this.answerComment = '';
                this.correctAnswer = [];   
                this.answers = [];
                this.text = '';
            },
                        
            load: function(exercise) {
                this.exercise = exercise;
                
                this.init();    
                
                this.$refs.standard.load(exercise);
                
                this.loadAnswers(); 
                
                this.loaded = true;
            },
            
            unload: function() {
                if (this.loaded) {
                    this.loaded = false;

                    this.$refs.standard.unload();

                    this.init(); 

                    this.exercise = null;
                }
            },
            
            loadAnswers: function() {
                this.answers = [];
                for (var i = 0; i < this.exercise.answers.items.length; i++) {
                    var modifiers = [];
                    for (var j = 0; j < this.exercise.answers.modifiers.length; j++) {
                        if (this.exercise.answers.modifiers[j].index !== i) {
                            continue;
                        }
                        
                        modifiers = this.exercise.answers.modifiers[j].modifiers;
                        break;
                    }
                    
                    this.answers.push({
                        url: this.exercise.answers.items[i],
                        selected: false,
                        modifiers: modifiers,
                        loading: {
                            active: this.answersUseLoading,
                            rounds: this.answersUseLoading ? ks.helpers.math.getRandomInt(5, 7) : 0
                        }
                    });
                }       
            },
            
            // 23.12.2021
            getAnswerImageStyle: function(answer) {
                let filter = 'none',
                    transform = 'none',
                    opacity = answer.loading.active ? 0.5 : 1;
                
                for (let i = 0, count = answer.modifiers.length; i < count; i++) {
                    let modifier = answer.modifiers[i],
                        mFilter = ksGlobal.ImageModifier.getFilter(modifier.value, modifier.param),
                        mTransform = ksGlobal.ImageModifier.getTransform(modifier.value, modifier.param);
                        
                    if (mFilter !== 'none') {
                        filter = filter === 'none' ? mFilter : filter + ' ' + mFilter;
                    }    
                    
                    if (mTransform !== 'none') {
                        transform = transform === 'none' ? mTransform : transform + ' ' + mTransform;
                    }    
                    
                    // 30.07.2021 для режима "тень" даем прозрачность
                    if ( ! answer.loading.active && modifier.value === ksGlobal.ImageModifier.values.Brightness && modifier.param === '0') {
                        opacity = 0.7;
                    }
                }
                
                if (answer.loading.active) {
                    let filterGrayscale = ksGlobal.ImageModifier.getFilter(ksGlobal.ImageModifier.values.Grayscale);
                    filter = filter === 'none' || filter === filterGrayscale ? filterGrayscale : filter + ' ' + filterGrayscale;
                }                
                
                return {
                    'transform': transform,
                    '-webkit-transform': transform,
                    'filter': filter,
                    'webkit-filter': filter,
                    'opacity': opacity
                };                
            },            
            
            /* OLD
            getAnswerImageStyle: function(answer) {
                var modifier = answer.modifiers.length > 0 ? 
                        answer.modifiers[0] : 
                        {value: ksGlobal.ImageModifier.values.None, param: ''},
                    filter = ksGlobal.ImageModifier.getFilter(modifier.value, modifier.param),
                    transform = ksGlobal.ImageModifier.getTransform(modifier.value, modifier.param),
                    opacity = answer.loading.active ? 0.5 : 1;
            
                if (answer.loading.active) {
                    var filterGrayscale = ksGlobal.ImageModifier.getFilter(ksGlobal.ImageModifier.values.Grayscale);
                    filter = filter === 'none' || filter === filterGrayscale ? filterGrayscale : filter + ' ' + filterGrayscale;
                } else {
                    // 30.07.2021 для режима "тень" даем прозрачность
                    if (modifier.value === ksGlobal.ImageModifier.values.Brightness && modifier.param === '0') {
                        opacity = 0.7;
                    }
                }
                
                return {
                    'transform': transform,
                    '-webkit-transform': transform,
                    'filter': filter,
                    'webkit-filter': filter,
                    'opacity': opacity
                };                
            },*/
            
            getAnswerUrl: function(answer, index) {
                if ( ! answer.loading) {
                    return answer.url;
                }
                
                var imageIndex = answer.loading.rounds > 0 ? ks.helpers.math.getRandomInt(0, this.answers.length - 1) : index;
                
                return this.answers[imageIndex].url;
            },
            
            getAnswerClass: function(answer) {
                return { 
                    disabled: ! this.isAnswersLoadingFinished,
                    active: this.isAnswersLoadingFinished && answer.selected,
                    'exercise-item-answers-item-loading': ! this.isAnswersLoadingFinished
                };
            },
            
            onClickAnswer: function(answer) {
                if ( ! this.isAnswersLoadingFinished) {
                    return;
                }
                
                if (this.exercise.answers.multiselect) {
                    ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                    answer.selected = ! answer.selected;
                } else {
                    if ( ! answer.selected) {
                        ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                        answer.selected = true;
                        for (var i = 0; i < this.answers.length; i++) {
                            if (this.answers[i] !== answer) {
                                this.answers[i].selected = false;
                            }
                        }
                    }
                }
                
                // Прячем подсказку о том, что нужно выбрать ответ
                this.$refs.answerAlert.hide();
            },
            
            getSelectedAnswers: function() {
                var selectedAnswers = [];
                
                for (var i = 0; i < this.answers.length; i++) {
                    if (this.answers[i].selected) {
                        selectedAnswers.push(i);
                    }
                }
                
                return selectedAnswers;
            },
            
            onAnswer: function() {
                if ( ! this.isAnswersLoadingFinished) {
                    return;
                }
                
                var selectedAnswers = this.getSelectedAnswers();
                
                if (selectedAnswers.length === 0) {
                    var info = this.exercise.answers.multiselect ?
                            { text: 'Нужно выбрать хотя бы один ответ', sound: ks.sounds.NEED_SELECT_LEAST_ONE_ANSWER } :
                            { text: 'Нужно выбрать ответ', sound: ks.sounds.NEED_SELECT_ANSWER };
                    
                    this.$refs.answerAlert.show(info.text, ks.consts.ALERT_INFO);
                    this.$emit('play-sound', info.sound);
                    
                    return;
                }
                
                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: selectedAnswers
                }, this.onCheckAnswer);                
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                this.text = data.message.text;
                
                if ( ! data.correct) {
                    this.state = ks.consts.EXERCISE_STATE_INVALID_ANSWER;
                    
                    for (var i = 0; i < data.correctAnswer.length; i++) {
                        this.$set(this.answers[data.correctAnswer[i]], 'isCorrect', true);
                    }
                    
                    if (data.comment) {
                        this.answerComment = data.comment;
                    }
                    
                    this.$emit('answer', false, data.message, true);
                    
                    return;
                }
                
                this.state = ks.consts.EXERCISE_STATE_CORRECT_ANSWER;
                
                this.$emit('answer', true, data.message, true);
            },
            
            onMouseEnterAnswer: function(answer) {
                if ( ! this.isAnswersLoadingFinished) {
                    return;
                }
                
                if ( ! answer.selected) {
                    ks.soundManager.playEffect(ks.sounds.ANSWER_HOVER);
                }
            },
            
            onMouseEnterSendAnswer: function() {
                if ( ! this.isAnswersLoadingFinished) {
                    return;
                }
                
                ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER);
            },
            
            showMainPage: function() {
                
                this.isMainPage = true;

                if (this.answersUseLoading) {
                    var self = this;
                    
                    this.answersLoader.timer.id = setInterval(function(){
                        var isFinished = true;
                        
                        for (var i = 0, count = self.answers.length; i < count; i++) {
                            if ( ! self.answers[i].loading.active) {
                                continue;
                            }
                            
                            self.answers[i].loading.rounds--;
                            
                            if (self.answers[i].loading.rounds <= 0) {
                                self.answers[i].loading.active = false;
                            } else {
                                isFinished = false;
                            }                            
                        }
                      
                        if (isFinished) {
                            clearTimeout(self.answersLoader.timer.id);
                        }                        
                    }, this.answersLoader.timer.interval);
                }
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            onShowComment: function() {
                ks.app.$refs.answerCommentDlg.show(this.answerComment);
            }
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 12.12.2017
 * 
 *  17.08.2021:
 *   + 'exercise-item-standard-group-texts-answer' component
 */

(function() {
    
    //--
    Vue.component('exercise-item-standard-group-texts-answer', {
        template: 
            '<div class="exercise-item-answers-item-container" :style="answerStyle">'+
            '    <div class="exercise-item-answers-item exercise-item-answers-item-text" :class="answerClass" v-hammer:tap="onTap" @mouseenter="onMouseEnterAnswer" v-html="answerText"></div>'+
            '</div>',    
    
        props: {
            answerStyle: {
                type: Object,
                required: true
            },
            
            answerClass: {
                type: Object,
                required: true
            },
            
            answerText: {
                type: String,
                required: true
            }
        }, 
        
        data: function() {
            return {};
        },
        
        methods: {
            onTap: function(){
                this.$emit('click');
            },
            
            onMouseEnterAnswer: function(){
                this.$emit('mouseenter');
            }
        }
    });
    //--    

    Vue.component('exercise-item-standard-group-texts', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                answers: [],                
                
                isMainPage: false,
                
                state: -1,
                
                answerComment: '',
                
                text: ''
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },
            
            answerStyle: function() {
                if (this.exercise === null) {
                    return {};
                }
                
                return {
                    width: 100 / this.exercise.answers.columns + '%'
                }; 
            },
            
            answerMultiselect: function() {
                return this.exercise !== null ? this.exercise.answers.multiselect : false;
            },
            
            isQuestionState: function() {
                return this.state === ks.consts.EXERCISE_STATE_QUESTION;
            },
            
            isInvalidAnswerState: function() {
                return this.state === ks.consts.EXERCISE_STATE_INVALID_ANSWER;
            },
            
            isCommentEmpty: function() {
                return this.answerComment === '';
            }
        },
        
        methods: {
            init: function() {
                this.isMainPage = false;
                this.state = ks.consts.EXERCISE_STATE_QUESTION;
                this.answerComment = '';
                this.correctAnswer = [];   
                this.answers = [];
                this.text = '';
            },
            
            load: function(exercise) {
                this.exercise = exercise;
                
                this.init();    
                
                this.$refs.standard.load(exercise);
                
                this.loadAnswers();    
                
                this.loaded = true;
            },
            
            unload: function() {
                if (this.loaded) {
                    this.loaded = false;

                    this.$refs.standard.unload();

                    this.init(); 

                    this.exercise = null;
                }
            },
            
            loadAnswers: function() {
                this.answers = [];
                for (var i = 0; i < this.exercise.answers.items.length; i++) {
                    this.answers.push({
                        text: this.exercise.answers.items[i],
                        selected: false
                    });
                }       
            },
            
            onClickAnswer: function(answer) {
                if (this.exercise.answers.multiselect) {
                    ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                    answer.selected = ! answer.selected;
                } else {
                    if ( ! answer.selected) {
                        ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                        answer.selected = true;
                        for (var i = 0; i < this.answers.length; i++) {
                            if (this.answers[i] !== answer) {
                                this.answers[i].selected = false;
                            }
                        }
                    }
                }
                
                // Прячем подсказку о том, что нужно выбрать ответ
                this.$refs.answerAlert.hide();
            },
            
            getSelectedAnswers: function() {
                var selectedAnswers = [];
                
                for (var i = 0; i < this.answers.length; i++) {
                    if (this.answers[i].selected) {
                        selectedAnswers.push(i);
                    }
                }
                
                return selectedAnswers;
            },
            
            onAnswer: function() {
                var selectedAnswers = this.getSelectedAnswers();
                
                if (selectedAnswers.length === 0) {
                    var info = this.exercise.answers.multiselect ?
                            { text: 'Нужно выбрать хотя бы один ответ', sound: ks.sounds.NEED_SELECT_LEAST_ONE_ANSWER } :
                            { text: 'Нужно выбрать ответ', sound: ks.sounds.NEED_SELECT_ANSWER };
                    
                    this.$refs.answerAlert.show(info.text, ks.consts.ALERT_INFO);
                    this.$emit('play-sound', info.sound);
                    
                    return;
                }
                
                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: selectedAnswers
                }, this.onCheckAnswer);
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                this.text = data.message.text;
                
                if ( ! data.correct) {
                    this.state = ks.consts.EXERCISE_STATE_INVALID_ANSWER;
                    
                    for (var i = 0; i < data.correctAnswer.length; i++) {
                        this.$set(this.answers[data.correctAnswer[i]], 'isCorrect', true);
                    }
                    
                    if (data.comment) {
                        this.answerComment = data.comment;
                    }
                    
                    this.$emit('answer', false, data.message, true);
                    
                    return;
                }
                
                this.state = ks.consts.EXERCISE_STATE_CORRECT_ANSWER;
                
                this.$emit('answer', true, data.message, true);
            },
            
            onMouseEnterAnswer: function(answer) {
                if ( ! answer.selected) {
                    ks.soundManager.playEffect(ks.sounds.ANSWER_HOVER);
                }
            }, 
            
            onMouseEnterSendAnswer: function() {
                ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER);
            },            
            
            showMainPage: function() {
                this.isMainPage = true;
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            onShowComment: function() {
                ks.app.$refs.answerCommentDlg.show(this.answerComment);
            }
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 20.12.2017
 */

(function() {

    Vue.component('exercise-item-standard-number', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                answer: '',                
                
                correctAnswer: '',
                
                isMainPage: false,
                
                state: -1,
                
                answerComment: '',
                
                text: ''
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },
            
            isQuestionState: function() {
                return this.state === ks.consts.EXERCISE_STATE_QUESTION;
            },
            
            isInvalidAnswerState: function() {
                return this.state === ks.consts.EXERCISE_STATE_INVALID_ANSWER;
            },
            
            isCommentEmpty: function() {
                return this.answerComment === '';
            }
        },
        
        methods: {
            init: function() {
                this.isMainPage = false;
                this.state = ks.consts.EXERCISE_STATE_QUESTION;
                this.answerComment = '';
                this.answer = '';
                this.correctAnswer = '';   
                this.text = '';
            },
            
            load: function(exercise) {
                this.exercise = exercise;
                
                this.init();    
                
                this.$refs.standard.load(exercise);
                
                this.loaded = true;
            },
            
            unload: function() {
                if (this.loaded) {
                    this.loaded = false;

                    this.$refs.standard.unload();

                    this.init(); 

                    this.exercise = null;
                }
            },
            
            onAnswer: function() {
                if (this.answer === '') {
                    var info = { text: 'Нужно указать ответ.', sound: ks.sounds.NEED_ENTER_ANSWER };
                    
                    this.$refs.answerAlert.show(info.text, ks.consts.ALERT_INFO);
                    this.$emit('play-sound', info.sound);
                    
                    this.$refs.answer.focus();
                    
                    return;
                }

                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: this.answer
                }, this.onCheckAnswer);                
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                this.text = data.message.text;
                
                if ( ! data.correct) {
                    this.state = ks.consts.EXERCISE_STATE_INVALID_ANSWER;
                    
                    this.correctAnswer = data.correctAnswer;
                    
                    if (data.comment) {
                        this.answerComment = data.comment;
                    }
                    
                    this.$emit('answer', false, data.message, true);
                    
                    return;
                }
                
                this.state = ks.consts.EXERCISE_STATE_CORRECT_ANSWER;
                
                this.$emit('answer', true, data.message, true);
            },
            
            onMouseEnterSendAnswer: function() {
                ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER);
            },             
            
            showMainPage: function() {
                this.isMainPage = true;
                
                this.$nextTick(function() {
                    this.$refs.answer.focus();
                });
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            onShowComment: function() {
                ks.app.$refs.answerCommentDlg.show(this.answerComment);
            }
        },
        
        watch: {
            answer: function(newAnswer) {
                if (newAnswer !== '') {
                    this.$refs.answerAlert.hide();
                } 
                
                var value = newAnswer.toString().replace(/\D/g, '');
                
                this.answer = value === '' ? '' : parseInt(value);
            }
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 06.06.2018
 */

(function() {

    Vue.component('exercise-item-standard-row-items', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                initialItems: [],
                items: [],
                
                isMainPage: false,
                
                state: -1,
                
                answerComment: '',
                
                text: '',
                
                drag: false
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },
            
            itemStyle: function() {
                if (this.exercise === null) {
                    return {};
                }
                
                return {
                    width: 100 / this.exercise.items.length + '%'
                }; 
            },
            
            isQuestionState: function() {
                return this.state === ks.consts.EXERCISE_STATE_QUESTION;
            },
            
            isInvalidAnswerState: function() {
                return this.state === ks.consts.EXERCISE_STATE_INVALID_ANSWER;
            },
            
            isCommentEmpty: function() {
                return this.answerComment === '';
            },
            
            // Список изображений в правильном порядке 
            // (для ввода при неправильном ответе)
            correctItems: function() {
                var items = [];
                
                for (var i = 0; i < this.items.length; i++) {
                    for (var j = 0; j < this.items.length; j++) {
                        if (this.items[j].correctIndex === i) {
                            break;
                        }
                    }
                        
                    items.push({
                        url: this.items[j].url,
                        correctIndex: i
                    });
                }
                
                return items;
            },
            
            hasEntryPage: function() {
                if (this.exercise === null) {
                    return false;
                }
                
                return typeof this.exercise.extra !== 'undefined' && this.exercise.extra.enabled;
            },            
            
            showInitialState: function() {
                if (this.exercise === null || ! this.exercise.showInitialState) {
                    return false;
                }
                
                return ( ! this.isMainPage || ! this.hasEntryPage);
            }
        },
        
        methods: {
            init: function() {
                this.isMainPage = false;
                this.state = ks.consts.EXERCISE_STATE_QUESTION;
                this.answerComment = '';
                this.initialItems = [];
                this.items = [];
                this.text = '';
            },
            
            load: function(exercise) {
                this.exercise = exercise;
                
                this.init();    
                
                this.$refs.standard.load(exercise);
                
                this.loadData();    
                
                this.loaded = true;
            },
            
            unload: function() {
                if (this.loaded) {
                    this.loaded = false;

                    this.$refs.standard.unload();

                    this.init(); 

                    this.exercise = null;
                }
            },
            
            loadData: function() {
                var mixedIndexes = JSON.parse(this.exercise.mixedIndexes);
                
                this.initialItems = [];
                this.items = [];
                for (var i = 0; i < mixedIndexes.length; i++) {
                    this.items.push({
                        url: this.exercise.items[mixedIndexes[i]],
                        correctIndex: mixedIndexes[i]
                    });
                    
                    this.initialItems.push({
                        url: this.exercise.items[i]
                    });
                }       
            },
            
            getCurrentPositions: function() {
                var positions = [];
                
                for (var i = 0; i < this.items.length; i++) {
                    positions.push(this.items[i].correctIndex);
                }
                
                return positions;
            },
            
            onAnswer: function() {
                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: this.getCurrentPositions()
                }, this.onCheckAnswer);          
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                this.text = data.message.text;
                
                if ( ! data.correct) {
                    this.state = ks.consts.EXERCISE_STATE_INVALID_ANSWER;
                    
                    if (data.comment) {
                        this.answerComment = data.comment;
                    }
                    
                    this.$emit('answer', false, data.message, true);
                    
                    return;
                }
                
                this.state = ks.consts.EXERCISE_STATE_CORRECT_ANSWER;
                
                this.$emit('answer', true, data.message, true);
            },
            
            onMouseEnterSendAnswer: function() {
                ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER);
            },
            
            showMainPage: function() {
                this.isMainPage = true;
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            onShowComment: function() {
                ks.app.$refs.answerCommentDlg.show(this.answerComment);
            },
            
            isItemCorrect: function(item) {
                return this.initialItems[this.items.indexOf(item)].url === item.url;
            },
            
            answerItemClass: function(item) {
                var isCorrect = this.isItemCorrect(item);
                
                return {
                    'active': isCorrect,
                    'active-invalid': ! isCorrect
                };
            }
        },
        
        watch: {
            drag: function(newValue) {
                ks.soundManager.playEffect(newValue ? ks.sounds.ITEM_START_DRAG : ks.sounds.ITEM_STOP_DRAG);
            }
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 20.12.2017
 */

(function() {

    Vue.component('exercise-item-standard-text', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                answer: '',                
                
                correctAnswer: '',
                
                isMainPage: false,
                
                state: -1,
                
                answerComment: '',
                
                text: ''
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },
            
            isQuestionState: function() {
                return this.state === ks.consts.EXERCISE_STATE_QUESTION;
            },
            
            isInvalidAnswerState: function() {
                return this.state === ks.consts.EXERCISE_STATE_INVALID_ANSWER;
            },
            
            isCommentEmpty: function() {
                return this.answerComment === '';
            }
        },
        
        methods: {
            init: function() {
                this.isMainPage = false;
                this.state = ks.consts.EXERCISE_STATE_QUESTION;
                this.answerComment = '';
                this.answer = '';
                this.correctAnswer = '';   
                this.text = '';
            },
            
            load: function(exercise) {
                this.exercise = exercise;
                
                this.init();    
                
                this.$refs.standard.load(exercise);
                
                this.loaded = true;
            },
            
            unload: function() {
                if (this.loaded) {
                    this.loaded = false;

                    this.$refs.standard.unload();

                    this.init(); 

                    this.exercise = null;
                }
            },
            
            onAnswer: function() {
                if (this.answer === '') {
                    var info = { text: 'Нужно указать ответ.', sound: ks.sounds.NEED_ENTER_ANSWER };
                    
                    this.$refs.answerAlert.show(info.text, ks.consts.ALERT_INFO);
                    this.$emit('play-sound', info.sound);                  
                    
                    this.$refs.answer.focus();
                    
                    return;
                }
                
                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: this.answer
                }, this.onCheckAnswer);                
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                this.text = data.message.text;
                
                if ( ! data.correct) {
                    this.state = ks.consts.EXERCISE_STATE_INVALID_ANSWER;
                    
                    this.correctAnswer = data.correctAnswer;
                    
                    if (data.comment) {
                        this.answerComment = data.comment;
                    }
                    
                    this.$emit('answer', false, data.message, true);
                    
                    return;
                }
                
                this.state = ks.consts.EXERCISE_STATE_CORRECT_ANSWER;
                
                this.$emit('answer', true, data.message, true);
            },
            
            onMouseEnterSendAnswer: function() {
                ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER);
            },             
            
            showMainPage: function() {
                this.isMainPage = true;
                
                this.$nextTick(function() {
                    this.$refs.answer.focus();
                });
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            onShowComment: function() {
                ks.app.$refs.answerCommentDlg.show(this.answerComment);
            }
        },
        
        watch: {
            answer: function(newAnswer) {
                if (newAnswer !== '') {
                    this.$refs.answerAlert.hide();
                } 
            }
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 24.01.2020
 * 
 * 
 */

(function() {
    
    var States = {
            MAIN   : 1,
            FINISH : 2
        };    

    Vue.component('exercise-item-time-select-value', {
        data: function() {
            return {
                exercise: null,
                
                loaded: false,
                
                state: -1,
                
                answers: [],
                
                isInvalidAnswerState: false,
                invalidAnswerText: '',
                
                correctTime: '12:00'
            };
        },
        
        computed: {
            exerciseId: function() {
                return this.exercise !== null ? this.exercise.id : -1;
            },
            
            isStateMain: function() {
                return this.state === States.MAIN;
            },
            
            isStateFinish: function() {
                return this.state === States.FINISH;
            },
            
            text: function() {
                return this.exercise === null ? '' : this.exercise.text;
            },
            
            answersMultiselect: function() {
                return this.exercise === null ? false : this.exercise.options.answersMultiselect;
            },
            
            answersEditable: function() {
                return this.exercise === null ? false : this.exercise.options.answersEditable;
            },
            
            answerStyle: function() {
                if (this.exercise === null) {
                    return {};
                }
                
                return {
                    width: 100 / this.exercise.options.answersColumns + '%'
                }; 
            },
            
            correctAnswers: function() {
                var answers = [];
                
                for (var i = 0, count = this.answers.length; i < count; i++) {
                    answers.push({
                        type: this.answers[i].type,
                        color: this.answers[i].color,
                        hoursVisible: this.answers[i].hoursVisible,
                        romanize: this.answers[i].romanize,
                        time: this.answersEditable ? this.correctTime : this.answers[i].time,
                        selected: this.answersEditable ? false : this.answers[i].isCorrect,
                        isCorrect: this.answersEditable ? true : this.answers[i].isCorrect                        
                    });
                }
                
                return answers;
            }
        },
        
        methods: {
            getAnswerClass: function(answer, invalidAnswerMode, isCorrectAnswerMode) {
                var isCorrect = invalidAnswerMode ? this.isCorrectAnswer(answer) : false;
                
                return { 
                    'active': 
                        ( ! invalidAnswerMode && ! this.answersEditable && answer.selected) || 
                        (invalidAnswerMode && isCorrectAnswerMode && answer.selected && ! this.answersEditable) || 
                        (invalidAnswerMode && ! isCorrectAnswerMode && isCorrect && (answer.selected || this.answersEditable)),
                    'active-invalid': invalidAnswerMode && ! isCorrectAnswerMode && ! isCorrect && (answer.selected || this.answersEditable)
                };
            }, 
            
            isCorrectAnswer: function(answer) {
                if (this.answersEditable) {
                    return this.correctTime !== null && this.compareTimes(answer.time, this.correctTime, this.isAnalog(answer));
                } else {
                    return answer.isCorrect;
                }
            },
            
            compareTimes: function(time1, time2, isAnalog) {
                var arr1 = time1.split(':'),
                    hour1 = parseInt(arr1[0], 10),
                    min1 = parseInt(arr1[1], 10),
                    arr2 = time2.split(':'),
                    hour2 = parseInt(arr2[0], 10),
                    min2 = parseInt(arr2[1], 10);

                if (min1 !== min2) {
                    return false;
                }

                if (isAnalog) {
                    if (hour1 >= 12) {
                        hour1 -= 12;
                    }
                    if (hour1 === 12) {
                        hour1 = 0;
                    }

                    if (hour2 >= 12) {
                        hour2 -= 12;
                    }
                    if (hour2 === 12) {
                        hour2 = 0;
                    }            
                }

                return hour1 === hour2;
            },            
            
            onClickAnswer: function(answer) {
                if (this.state === States.FINISH) {
                    return;
                }
                
                if (this.answersMultiselect) {
                    ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                    answer.selected = ! answer.selected;
                } else {
                    if ( ! answer.selected) {
                        ks.soundManager.playEffect(ks.sounds.ANSWER_SELECT);
                        answer.selected = true;
                        for (var i = 0; i < this.answers.length; i++) {
                            if (this.answers[i] !== answer) {
                                this.answers[i].selected = false;
                            }
                        }
                    }
                }
                
                // Прячем подсказку о том, что нужно выбрать ответ
                this.$refs.answerAlert.hide();                
            },
            
            onMouseEnterAnswer: function(answer) {
                if (this.state === States.FINISH) {
                    return;
                }
                
                if ( ! answer.selected) {
                    ks.soundManager.playEffect(ks.sounds.ANSWER_HOVER);
                }
            },
            
            onMouseEnterSendAnswer: function() {
                ks.soundManager.playEffect(ks.sounds.SEND_ANSWER_HOVER);
            },   
            
            isAnalog: function(answer) {
                return answer.type === ksGlobal.ClockType.Analog;
            },
            
            load: function(exercise) {
                this.exercise = exercise;
                
                this.answers = [];    
                for (var i = 0, count = exercise.answers.length; i < count; i++) {
                    this.answers.push({
                        type: exercise.answers[i].type,
                        color: exercise.answers[i].color,
                        hoursVisible: exercise.answers[i].hoursVisible,
                        romanize: exercise.answers[i].romanize,
                        time: exercise.answers[i].time,
                        selected: false,
                        isCorrect: exercise.answers[i].selected
                    });
                }
                
                this.state = States.MAIN;
                this.loaded = true;
            },
            
            unload: function() {
                if (this.loaded) {
                    this.loaded = false;
                    
                    this.state = -1;

                    this.answers = [];
                    
                    this.isInvalidAnswerState = false;
                    this.invalidAnswerText = '';
                    
                    this.exercise = null;
                }
            },  
            
            getSelectedAnswers: function() {
                let selectedAnswers = [];
                
                for (var i = 0, count = this.answers.length; i < count; i++) {
                    if (this.answersEditable) {
                        selectedAnswers.push(this.answers[i].time);
                    } else {
                        if (this.answers[i].selected) {
                            selectedAnswers.push(i);
                        }
                    }
                }
                
                return selectedAnswers;
            },
            
            onAnswer: function() {
                let selectedAnswers = this.getSelectedAnswers();
                
                if ( ! this.answersEditable && selectedAnswers.length === 0) {
                    var info = this.answersMultiselect ?
                            { text: 'Нужно выбрать хотя бы один ответ', sound: ks.sounds.NEED_SELECT_LEAST_ONE_ANSWER } :
                            { text: 'Нужно выбрать ответ', sound: ks.sounds.NEED_SELECT_ANSWER };
                    
                    this.$refs.answerAlert.show(info.text, ks.consts.ALERT_INFO);
                    this.$emit('play-sound', info.sound);
                    
                    return;
                }                
                
                this.$parent.sendAnswer({
                    exerciseId: this.exercise.id,
                    answer: selectedAnswers
                }, this.onCheckAnswer);
            },
            
            onCheckAnswer: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.answerAlert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    return;
                }
                
                this.state = States.FINISH;
                
                if ( ! data.correct) {
                    this.correctTime = data.correctAnswer;
                    this.isInvalidAnswerState = true;
                    this.invalidAnswerText = data.message.text;
                    
                    this.$emit('answer', false, data.message, true);
                    
                    return;
                }
                
                this.$emit('answer', true, data.message, true);
            },
            
            onNext: function() {
                this.unload();
                this.$emit('next');
            },
            
            onNextState: function() {
                this.state = States.MAIN;
            },
            
            updateSize: function() {
                this.$nextTick(function() {
                    window.dispatchEvent(new Event('resize'));
                });
            }
        },
        
        watch: {
            state: function(newState) {
                switch(newState) {
                    /*case States.SAMPLE:
                        this.$store.commit('current/setExercisesCurrentPage', ks.consts.EXERCISE_PAGE_ENTRY);
                        break;*/
                        
                    case States.MAIN:
                        this.$store.commit('current/setExercisesCurrentPage', ks.consts.EXERCISE_PAGE_MAIN);
                        break;
                        
                }
            }
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 02.06.2025
 */

(function() {
  var PrintCategoryMenuMobile = {
    data: function() {
      return {
        loaded: false
      };
    },

    methods: {
      show: function() {
        this.$dlg.modal('show');
      },

      hide: function() {
        this.$dlg.modal('hide');
      }
    },

    mounted: function() {
      this.$dlg = $('#print-category-mobile-menu');

      this.loaded = true;
    }
  };

  ks.core.addComponent('print-category-menu-mobile', PrintCategoryMenuMobile);
}());

/**
 * Author: (c) Kids-Smart.ru
 * Date: 20.01.2020
 * 
 * 12.05.2022:
 * +useMinutes
 * 
 * 11.09.2022: 
 * +Добавлена обработка часовой стрелки
 * +При определении угла часовой стрелки всегда учитываются минуты
 * 
 * 12.11.2022:
 * Исправлено перемещение стрелок (установка времени)
 */

(function() {
    
    var AnalogClockDragMode = {
        Hour: 0,
        Minute: 1
    };    
    
    Vue.component('analog-clock-point', {
        template: '<div class="analog-clock-point" :style="stylePoint"></div>',
        
        props: {
            point: {
                type: Object,
                required: true
            },
            
            position: {
                type: Object,
                required: true
            },
            
            size: {
                type: Number,
                required: true
            }
        },
        
        data: function() {
            return {
                
            };
        },
        
        computed: {
            stylePoint: function() {
                var size = this.point.value % 5 === 0 ? this.size : Math.ceil(this.size / 2),
                    radius = size,
                    left = this.position.x - size / 2 - 1,
                    top = this.position.y - size / 2 - 1;
                
                return {
                    left: left + 'px',
                    top: top + 'px',
                    width: size + 'px',
                    height: size + 'px',
                    'border-radius': radius + 'px'
                };                
            }
        }
    });
    
    Vue.component('analog-clock-hour', {
        template: '<div class="analog-clock-hour" :style="styleHour">{{text}}</div>',
        
        props: {
            hour: {
                type: Object,
                required: true
            },
            
            position: {
                type: Object,
                required: true
            },
            
            fontSize: {
                type: Number,
                required: true
            },
            
            romanize: {
                type: Boolean,
                required: true
            }
        },
        
        data: function() {
            return {
                
            };
        },
        
        computed: {
            styleHour: function() {
                return {
                    left: this.position.x + 'px',
                    top: this.position.y + 'px',
                    'font-size': this.fontSize + 'px'
                };                
            },
            
            text: function() {
                return this.romanize ? ks.helpers.math.romanize(this.hour.value) : this.hour.value;
            }
        }
    });    
    
    Vue.component('analog-clock-hour-hand', {
        template: '<div class="analog-clock-hour-hand" draggable="false" :class="classHourHand" :style="styleHourHand" @dragstart="sysDragStart" @mousedown="onStartDrag" @touchstart="onStartDrag"></div>',
        
        props: {
            position: {
                type: Object,
                required: true
            },
            
            size: {
                type: Object,
                required: true                
            },
            
            value: {
                type: Number,
                required: true
            },
            
            useMinutes: {
                type: Boolean,
                default: false
            },
            
            minutes: {
                type: Number,
                default: 0                
            },
            
            movable: {
                type: Boolean,
                default: false
            },
            
            drag: {
                type: Object,
                required: true
            }
        },
        
        data: function() {
            return {
                
            };
        },
        
        computed: {
            classHourHand: function() {
                return {
                    movable: this.movable,
                    drag: this.movable && this.drag.active && this.drag.mode === AnalogClockDragMode.Hour 
                };
            },
            
            styleHourHand: function() {
                var width = this.size.width,
                    height = this.size.height,
                    angle = -90 + 30 * this.value,
                    rotatePos = {
                        x: height / 2,
                        y: height / 2
                    };
                    
                 // 11.09.2022: Всегда минуты учитываются   
                //if (this.useMinutes && ! this.movable) {
                    angle += 0.5 * this.minutes;
                //}    
                
                return {
                    left: this.position.x + 'px',
                    top: this.position.y + 'px',
                    width: width + 'px',
                    height: height + 'px',
                    'border-radius': height + 'px',
                    'transform-origin': rotatePos.x + 'px ' + rotatePos.y + 'px',
                    transform: 'rotate(' + angle + 'deg)'
                };                
            }
        },
        
        methods: {
            sysDragStart: function(event) {
                event.preventDefault();
                return false;
            },
            
            onStartDrag: function(event) {
                if ( ! this.movable) {
                    return;
                }
                
                var pos = {
                    x: 0,
                    y: 0
                };
                
                if (event.type === 'touchstart') {
                    var touch = null;
                    
                    if (typeof event.touches !== 'undefined' && event.touches.length === 1) {
                        touch = event.touches[0];
                    }
                    
                    //var touch = event.touches[0] || event.originalEvent.touches[0] || event.originalEvent.changedTouches[0];
                    
                    pos.x = touch.clientX;
                    pos.y = touch.clientY;
                }
                else {
                    //LFET BUTTON: 
                    //  IE: event.which = undefined, event.button = 1
                    //  Firefox, Safari Win, Opera: event.which = 1, event.button = 0
                    if ( ! event.which && event.button) {
                        if (event.button & 1) {
                            event.which = 1;
                        }
                    }
                    
                    if (event.which !== 1) {
                        return;
                    }
                    
                    pos.x = event.clientX;
                    pos.y = event.clientY;
                }
                
                this.$emit('start-drag', pos);
                
                return false;
            }            
        }
    });  
    
    Vue.component('analog-clock-minute-hand', {
        template: '<div class="analog-clock-minute-hand" draggable="false" :class="classMinuteHand" :style="styleMinuteHand" @dragstart="sysDragStart" @mousedown="onStartDrag" @touchstart="onStartDrag"></div>',
        
        props: {
            position: {
                type: Object,
                required: true
            },
            
            size: {
                type: Object,
                required: true                
            },
            
            value: {
                type: Number,
                required: true
            },
            
            movable: {
                type: Boolean,
                default: false
            },
            
            drag: {
                type: Object,
                required: true
            }
        },
        
        data: function() {
            return {
                
            };
        },
        
        computed: {
            classMinuteHand: function() {
                return {
                    movable: this.movable,
                    drag: this.movable && this.drag.active && this.drag.mode === AnalogClockDragMode.Minute
                };
            },            
            
            styleMinuteHand: function() {
                var width = this.size.width,
                    height = this.size.height,
                    angle = -90 + 6 * this.value,
                    rotatePos = {
                        x: height / 2,
                        y: height / 2
                    };
                
                return {
                    left: this.position.x + 'px',
                    top: this.position.y + 'px',
                    width: width + 'px',
                    height: height + 'px',
                    'border-radius': height + 'px',
                    'transform-origin': rotatePos.x + 'px ' + rotatePos.y + 'px',
                    transform: 'rotate(' + angle + 'deg)'
                };                
            }
        },
        
        methods: {
            sysDragStart: function(event) {
                event.preventDefault();
                return false;
            },            
            
            onStartDrag: function(event) {
                if ( ! this.movable) {
                    return;
                }
                
                var pos = {
                    x: 0,
                    y: 0
                };
                
                if (event.type === 'touchstart') {
                    var touch = null;
                    
                    if (typeof event.touches !== 'undefined' && event.touches.length === 1) {
                        touch = event.touches[0];
                    }
                    
                    //var touch = event.touches[0] || event.originalEvent.touches[0] || event.originalEvent.changedTouches[0];
                    
                    pos.x = touch.clientX;
                    pos.y = touch.clientY;
                }
                else {
                    //LFET BUTTON: 
                    //  IE: event.which = undefined, event.button = 1
                    //  Firefox, Safari Win, Opera: event.which = 1, event.button = 0
                    if ( ! event.which && event.button) {
                        if (event.button & 1) {
                            event.which = 1;
                        }
                    }
                    
                    if (event.which !== 1) {
                        return;
                    }
                    
                    pos.x = event.clientX;
                    pos.y = event.clientY;
                }
                
                this.$emit('start-drag', pos);
                
                return false;
            }
        }
    });    
    
    Vue.component('analog-clock', {
        
        template: 
            '<div class="analog-clock-container">' +

            '    <div class="analog-clock-box" ref="box" :style="styleBox" draggable="false">' +
            '        <div v-show="isShow" class="analog-clock" :class="classClock">' +
            '            <div class="analog-clock-face" :style="styleFace">' +
            '                <div class="analog-clock-face-border" :style="styleFaceBorder"></div>' +

            '                <analog-clock-point v-for="point in points" :point="point" :key="\'point\' + point.value" :position="getPointPosition(point)" :size="pointSize"></analog-clock-point>' +
            '                <analog-clock-hour v-if="hoursVisible" v-for="hour in hours" :hour="hour" :key="\'hour\' + hour.value" :position="getHourPosition(hour)" :font-size="hoursFontSize" :romanize="romanize"></analog-clock-hour>' +

            '                <analog-clock-hour-hand :position="hourHandPosition" :size="hourHandSize" :value="hourHandValue" :use-minutes="useMinutes" :minutes="minuteHandValue" :movable="!readonly" :drag="drag" @start-drag="onStartDragHourHand"></analog-clock-hour-hand>' +
            '                <analog-clock-minute-hand :position="minuteHandPosition" :size="minuteHandSize" :value="minuteHandValue" :movable="!readonly" :drag="drag" @start-drag="onStartDragMinuteHand"></analog-clock-minute-hand>' +

            '                <div class="analog-clock-face-center" :style="styleFaceCenter" :class="classFaceCenter"></div>' +
            '            </div>' +
            '        </div>' +
            '    </div>' +

            '</div>',
        
        props: {
            value: {
                type: String
            },
            
            color: {
                type: String,
                required: true
            },
            
            hoursVisible: {
                type: Boolean,
                required: true
            },
            
            readonly: {
                type: Boolean,
                required: true
            },
            
            romanize: {
                type: Boolean,
                required: true
            },
            
            useMinutes: {
                type: Boolean,
                default: true
            }
        },
        
        data: function() {
            return {
                resizeTimer: null,
                
                width: 0,
                
                points: [],
                hours: [],
                
                hourHandValue: 12,
                minuteHandValue: 0,
                
                drag: {
                    active: false,
                    mode: AnalogClockDragMode.Hour,
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            };
        },
        
        computed: {
            isShow: function() {
                return this.width > 0;
            },
            
            styleBox: function(){
                return {
                    width: this.width + 'px',
                    height: this.width + 'px'
                };
            },
            
            classClock: function() {
                var cls = {};
                cls['analog-clock-' + this.color] = true;
                
                return cls;
            },
            
            faceWidth: function(){
                return this.width - 1;
            },
            
            styleFace: function() {
                var borderRadius = this.faceWidth / 2;
                
                return {
                    width: this.faceWidth + 'px',
                    height: this.faceWidth + 'px',
                    'border-radius': borderRadius + 'px'
                };                
            },
            
            faceBorderWidth: function() {
                return this.faceWidth * 0.05;
            },
            
            styleFaceBorder: function() {
                var width = this.faceWidth - 4,// - this.faceBorderWidth * 2,
                    borderRadius = (width + this.faceBorderWidth * 2) / 2;
                
                return {
                    width: width + 'px',
                    height: width + 'px',
                    'border-radius': borderRadius + 'px',
                    'border-width': this.faceBorderWidth + 'px'
                };
            },
            
            faceCenterWidth: function() {
                return this.faceWidth * 0.08;
            },
            
            styleFaceCenter: function() {
                var borderRadius = this.faceCenterWidth,
                    borderWidth = Math.ceil(this.faceCenterWidth * 0.1),
                    left = (this.faceWidth - this.faceCenterWidth) / 2,//(this.faceWidth - this.faceCenterWidth) / 2 - borderWidth,
                    top = left;
                
                return {
                    left: left + 'px',
                    top: top + 'px',
                    width: this.faceCenterWidth + 'px',
                    height: this.faceCenterWidth + 'px',
                    'border-radius': borderRadius + 'px',
                    'border-width': borderWidth + 'px'
                };
            },
            
            classFaceCenter: function() {
                return {
                    drag: ! this.readonly && this.drag.active
                };
            },
            
            centerX: function() {
                return this.width / 2;
            },
            
            centerY: function() {
                return this.centerX;
            },
            
            pointSize: function() {
                return this.faceWidth * 0.035;
            },
            
            pointRadius: function() {
                return this.faceWidth / 2 - this.faceBorderWidth * 1.5; 
            },
            
            hourRadius: function() {
                return this.pointRadius - this.faceWidth * 0.1;
            },
            
            hoursFontSize: function() {
                return this.faceWidth * 0.1;
            },
            
            hourHandPosition: function() {
                return {
                    x: this.centerX - this.faceCenterWidth / 3, //6,
                    y: this.centerY - this.hourHandSize.height / 2
                };
            },
            
            hourHandSize: function() {
                return {
                    width: this.hourRadius * 0.8,
                    height: this.hourRadius * 0.16 //0.09
                };
            },
            
            minuteHandPosition: function() {
                return {
                    x: this.centerX - this.faceCenterWidth / 4, //8,
                    y: this.centerY - this.minuteHandSize.height / 2
                };
            },
            
            minuteHandSize: function() {
                return {
                    width: this.pointRadius * 0.95,
                    height: this.hourRadius * 0.12//0.07
                };
            }
        },
        
        methods: {
            getTextSize: function(text, fontSize, style) {
                var div = document.createElement('div');

                document.body.appendChild(div);

                if (style !== null) {
                    div.style = style;
                }
                div.style.fontSize = fontSize + 'px';
                div.style.position = 'absolute';
                div.style.left = -1000;
                div.style.top = -1000;

                div.innerHTML = text;

                var size = {
                    width: div.clientWidth,
                    height: div.clientHeight
                };

                document.body.removeChild(div);
                div = null;

                return size;            
            },            
            
            twoDigits: function(value) {
                return value.toString().length > 1 ? value : '0' + value;
            },            
            
            getRectBox: function() {
                var box = this.$refs.box,
                    rectBox = typeof box === 'undefined' ? {left: 0, top: 0} : box.getBoundingClientRect();
                return rectBox;
            }, 
            
            onWindowResize: function() {
                if (this.resizeTimer !== null) {
                    clearTimeout(this.resizeTimer);
                    this.resizeTimer = null;
                }

                var self = this;
                this.resizeTimer = setTimeout(function(){
                    self.updateSize();
                    self.resizeTimer = null;
                }, 300);                
            },
            
            updateSize: function() {
                var width = this.$el.offsetWidth - 2;
                
                if (width <= 0) {
                    return;
                }
                
                this.width = width;
            },
            
            getPointPosition: function(point) {
                var x = this.centerX + this.pointRadius * Math.cos(-6 * point.value * (Math.PI / 180) + Math.PI / 2), 
                    y = this.centerY - this.pointRadius * Math.sin(-6 * point.value * (Math.PI / 180) + Math.PI / 2);
                
                return {
                    x: x,
                    y: y
                };
            },
            
            getHourPosition: function(hour) {
                var text = this.romanize ? ks.helpers.math.romanize(hour.value) : hour.value,
                    textSize = this.getTextSize(text, this.hoursFontSize),
                    x = this.centerX + this.hourRadius * Math.cos(-30 * hour.value * (Math.PI / 180) + Math.PI / 2) - textSize.width / 2 - 1, 
                    y = this.centerY - this.hourRadius * Math.sin(-30 * hour.value * (Math.PI / 180) + Math.PI / 2) - textSize.height / 2 - 1;   
            
                return {
                    x: x,
                    y: y
                };
            },
            
            onStartDragMinuteHand: function(pos) {
                var rectBox = this.getRectBox();
                
                this.drag.mode = AnalogClockDragMode.Minute;
                this.drag.pos.x = pos.x - rectBox.left;
                this.drag.pos.y = pos.y - rectBox.top;
                this.drag.active = true;
            },
            
            onStartDragHourHand: function(pos) {
                var rectBox = this.getRectBox();
                
                this.drag.mode = AnalogClockDragMode.Hour;
                this.drag.pos.x = pos.x - rectBox.left;
                this.drag.pos.y = pos.y - rectBox.top;
                this.drag.active = true;                
            },
            
            onStopDrag: function() {
                if (this.drag.active) {
                    this.drag.active = false;
                    return false;
                }
            },
            
            getDragPointDest: function(hour) {
                var pos = this.getPointPosition({value: hour.value * 5}),
                    dest = Math.sqrt(Math.pow(this.drag.pos.x - pos.x, 2) + Math.pow(this.drag.pos.y - pos.y, 2));    
            
                return dest;   
            },
            
            onDoDrag: function(event) {
                if ( ! this.drag.active) {
                    return;
                }
                
                var newPos = {
                    x: 0,
                    y: 0
                };
                
                if (event.type === 'touchmove') {
                    var touch = null;
                    
                    if (typeof event.touches !== 'undefined' && event.touches.length === 1) {
                        touch = event.touches[0];
                    }
                    
                    //var touch = event.touches[0] || event.originalEvent.touches[0] || event.originalEvent.changedTouches[0];
                    
                    if (touch === null) {
                        return;
                    }                    
                    
                    newPos.x = touch.clientX;
                    newPos.y = touch.clientY;
                }
                else {
                    newPos.x = event.clientX;
                    newPos.y = event.clientY;
                }
                
                //---
                
                var rectBox = this.getRectBox(),
                    pt = {
                        x: newPos.x - rectBox.left, 
                        y: newPos.y - rectBox.top
                    },    
                    minDest = 0,
                    hour = 0,
                    dest = 0;
                    
                this.drag.pos.x = pt.x;
                this.drag.pos.y = pt.y;
                
                for (var i = 1; i <= 12; i++) {
                    dest = this.getDragPointDest({value: i});
                   
                    if (hour === 0 || dest < minDest) {
                        minDest = dest;
                        hour = i;
                    }
                }
                
                if (hour <= 0) {
                    return;
                }

                switch (this.drag.mode) {
                    case AnalogClockDragMode.Minute:
                        let value = hour * 5;
                        
                        // 11.09.2022: Добавлена обработка часовой стрелки
                        if (value === 60) {
                            value = 0;
                        }
                        
                        if (this.minuteHandValue === value) {
                            return;
                        }
                        
                        let hourHandValue = this.hourHandValue;
                        
                        if (this.minuteHandValue === 0 && value === 55) {
                            hourHandValue--;
                            if (hourHandValue < 0) {
                                hourHandValue += 12;
                            }
                        } else {
                            if (this.minuteHandValue === 55 && value === 0) {
                                hourHandValue++;
                                if (hourHandValue >= 12) {
                                    hourHandValue -= 12;
                                }
                            }                            
                        }
                        
                        this.hourHandValue = hourHandValue;
                        
                        this.minuteHandValue = value;
                        //--
                        
                        //this.minuteHandValue = value === 60 ? 0 : value;
                        break;
                    
                    case AnalogClockDragMode.Hour:
                        this.hourHandValue = hour;
                        break;
                }
                
                return false;
            },
            
            loadValue: function() {
                let arr = this.value.split(':'),
                    hour = parseInt(arr[0], 10);
            
                if (hour >= 12) {
                    hour -= 12;
                }    
                
                if (hour === 12) {
                    hour = 0;
                }
            
                this.hourHandValue = hour;
                this.minuteHandValue = parseInt(arr[1], 10);                
            }
        },
        
        created: function() {
            var i;
            
            for (i = 0; i <= 59; i++) {
                this.points.push({
                    value: i
                });
            }
            
            for (i = 1; i <= 12; i++) {
                this.hours.push({
                    value: i
                });
            }
            
            window.addEventListener('resize', this.onWindowResize);
            
            window.addEventListener('mouseup', this.onStopDrag);
            window.addEventListener('touchend', this.onStopDrag);

            window.addEventListener('mousemove', this.onDoDrag);
            window.addEventListener('touchmove', this.onDoDrag, { passive: false });            
        },
        
        beforeDestroy: function() {
            window.removeEventListener('resize', this.onWindowResize);
            
            window.removeEventListener('mouseup', this.onStopDrag);
            window.removeEventListener('touchend', this.onStopDrag);

            window.removeEventListener('mousemove', this.onDoDrag);
            window.removeEventListener('touchmove', this.onDoDrag);            
        },
        
        mounted: function() {
            this.updateSize();
            this.loadValue();
        },
        
        watch: {
            hourHandValue: function(newValue) {
                var t = this.twoDigits(newValue) + ':' +
                        this.twoDigits(this.minuteHandValue);
                
                this.$emit('input', t);
            },
    
            minuteHandValue: function(newValue) {
                var t = this.twoDigits(this.hourHandValue) + ':' +
                        this.twoDigits(newValue);
                
                this.$emit('input', t);
            },
            
            value: function(newValue) {
                this.loadValue();
            },
            
            'drag.active': function(newValue) {
                // На мобильных и планешетах блокируем прокрутку тачем если 
                // мы режиме перемещения стрелки (любой)
                if (ks.browser.isTouch()) {
                    if (newValue) {
                        $('body').addClass('body-overflow-hidden');
                    } else {
                        $('body').removeClass('body-overflow-hidden');
                    }
                }
                    
            }
        }
    });
    
}());
/**
 * Author: (c) Kids-Smart.ru
 * Date: 20.01.2020
 * 
 * 12.05.2022:
 * Исправлено отображение элементов управления в цифровых часах при маленьком размере экрана.
 */

(function() {
    
    Vue.component('digit-clock-button', {
        template: '<button class="digit-clock-button" :class="buttonClass" :style="buttonStyle" @mousedown="fireDownEvent" @mouseup="fireUpEvent" @touchstart="fireTouchStartEvent" @touchend="fireTouchEndEvent" @mouseleave="fireUpEvent" type="button"><i class="fa" :class="iconClass"></i></button>',
    
        props: {
            /**
             * Direction: 'up' or 'down'
             */
            direction: {
                type: String,
                required: true
            },
            
            /**
             * Unit: 'hour' or 'minute'
             */
            unit: {
                type: String,
                required: true
            },
            
            fontSize: {
                type: Number,
                default: 10
            },
            
            color: {
                type: String,
                required: true
            },
            
            defaultActionInterval: {
                type: Number,
                default: 350
            },
            
            minActionInterval: {
                type: Number,
                default: 100
            }
        }, 
    
        data: function() {
            return {
                isDown: false,
                down: {
                    isClickMode: true,
                    time: 0,
                    timer: null,
                    action: {
                        lastTime: 0,
                        interval: 0
                    }
                }                    
            };
        }, 
        
        computed: {
            buttonClass: function() {
                var cls = {
                    'up'       : this.direction === 'up',
                    'down'     : this.direction === 'down'
                };
                
                cls['digit-clock-button-' + this.color] = true;
                
                return cls;
            },
            
            iconClass: function() {
                return {
                    'fa-chevron-up'   : this.direction === 'up',
                    'fa-chevron-down' : this.direction === 'down'
                };
            },
            
            buttonStyle: function() {
                return {
                    'font-size': this.fontSize + 'px'
                };
            }
        },
            
        methods: {
            fireTouchStartEvent: function() {
                this.startDown();
            },
    
            fireTouchEndEvent: function() {
                this.stopDown(); 
            },
            
            fireDownEvent: function(event) {
                if (ks.browser.isTouch() || (typeof event.which !== 'undefined' && event.which !== 1)) {
                    return;
                }
                
                this.startDown();
            },
            
            fireUpEvent: function() {
                if (ks.browser.isTouch()) {
                    return;
                }
                
                this.stopDown();                
            },
            
            startDown: function() {
                if (this.disabled) {
                    return;
                }
                
                this.isDown = true;
                this.down.isClickMode = true;
                this.down.time = (new Date()).valueOf();
                this.down.action.lastTime = 0;
                
                var self = this;
                if (this.down.timer !== null) {
                    clearInterval(self.down.timer);
                    self.down.timer = null;                     
                }
                this.down.timer = setInterval(function() {
                    if (self.disabled) {
                        clearInterval(self.down.timer);
                        self.down.timer = null;  
                        
                        self.isDown = false;
                        self.down.isClickMode = true;
                        self.down.time = 0;
                        self.down.lastActionTime = 0;      
                        
                        return;
                    }
                    
                    var currentTime = (new Date()).valueOf(),
                        tick = currentTime - self.down.time;
                    
                    if (tick > self.defaultActionInterval) {
                        self.down.isClickMode = false;
                        
                        var k = Math.floor(tick / self.defaultActionInterval),
                            newInterval = k > 0 ? Math.floor(self.defaultActionInterval / k) : self.defaultActionInterval;
                        
                        self.down.action.interval = newInterval < self.minActionInterval ? self.minActionInterval : newInterval;
                        
                        var interval = currentTime - self.down.action.lastTime;
                        if (interval >= self.down.action.interval) {
                            self.down.action.lastTime = currentTime;
                            self.$emit('change', self.unit, self.direction);                            
                        }
                    }
                    
                }, 50);                
            },
            
            stopDown: function() {
                if (this.disabled) {
                    return;
                }                
                
                if (this.down.timer !== null) {
                    clearInterval(this.down.timer);
                    this.down.timer = null;
                }
                
                if ( ! this.isDown) {
                    return;
                }
                
                if (this.down.isClickMode) {
                    this.$emit('change', this.unit, this.direction);
                }
                
                this.isDown = false;
                this.down.isClickMode = true;
                this.down.time = 0;
                this.down.lastActionTime = 0;               
            }
        }
    });    
    
    var DigitClockImagesPath = 'https://kids-smart.ru/public/images/exercises/clock/digit/';
    
    Vue.component('digit-clock', {
        
        template: 
            '<div v-if="loaded" class="digit-clock-container" :style="styleContainer">' +
            '  <div v-show="isShow" :style="styleContent">' +
                            
            '    <div v-if="!readonly" class="digit-clock-controls clearfix">' +
            '        <div class="digit-clock-control-box-left" :style="styleControlBox">' +
            '            <digit-clock-button unit="hour" direction="up" :font-size="controlFontSize" :color="color" @change="fireChangeTime"></digit-clock-button>' +
            '        </div>' +
            '        <div class="digit-clock-control-box-right" :style="styleControlBox">' +
            '            <digit-clock-button unit="minute" direction="up" :font-size="controlFontSize" :color="color" @change="fireChangeTime"></digit-clock-button>' +
            '        </div>' +
            '    </div>' +

            '    <div class="digit-clock-box" :style="styleBox">' +

            '        <div class="digit-clock" :class="classClock" :style="styleClock">' +

            '            <div class="digit-clock-time-box">' +
            '                <div class="digit-clock-time-item" :style="getTimeItemStyle(false, hourFirstDigit)"></div>' +
            '                <div class="digit-clock-time-item" :style="getTimeItemStyle(false, hourSecondDigit)"></div>' +
            '                <div class="digit-clock-time-item" :style="getTimeItemStyle(true)"></div>' +
            '                <div class="digit-clock-time-item" :style="getTimeItemStyle(false, minuteFirstDigit)"></div>' +
            '                <div class="digit-clock-time-item" :style="getTimeItemStyle(false, minuteSecondDigit)"></div>' +
            '            </div>' +

            '        </div>' +

            '    </div>' +

            '    <div v-if="!readonly" class="digit-clock-controls clearfix">' +
            '        <div class="digit-clock-control-box-left" :style="styleControlBox">' +
            '            <digit-clock-button unit="hour" direction="down" :font-size="controlFontSize" :color="color" @change="fireChangeTime"></digit-clock-button>' +
            '        </div>' +
            '        <div class="digit-clock-control-box-right" :style="styleControlBox">' +
            '            <digit-clock-button unit="minute" direction="down" :font-size="controlFontSize" :color="color" @change="fireChangeTime"></digit-clock-button>' +
            '        </div>' +
            '    </div>' + 
            
            '    <div class="digit-clock-clear"></div>' +
            '  </div>' +
            '</div>',
        
        props: {
            value: {
                type: String
            },
            
            color: {
                type: String,
                required: true
            },
            
            readonly: {
                type: Boolean,
                required: true
            },
            
            squareMode: {
                type: Boolean,
                default: true
            }
        },
        
        data: function() {
            return {
                loaded: false,
                
                resizeTimer: null,
                
                width: 0,
                
                itemSize: {
                    width: 0,
                    height: 0,
                    coef: 0
                },
                
                hourValue: 12,
                minuteValue: 0
            };
        },
        
        computed: {
            isShow: function() {
                return this.width > 0;
            },
            
            styleContainer: function() {
                var height;
                        
                if (this.squareMode) {
                    height = this.width;
                } else {
                    height = this.timeItemHeight + this.clockBorderWidth * 2;
                    if ( ! this.readonly) {
                        height += this.width * 0.1 * 4;
                    }
                }
                
                return {
                    height: height + 'px',
                    position: 'relative'
                };
            },
            
            styleContent: function() {
                return {
                    'position': 'absolute',
                    'top': '50%',
                    'transform': 'translateY(-50%)'
                };
            },
            
            styleBox: function() {
                var height = this.timeItemHeight + this.clockBorderWidth * 2;
                
                return {
                    width: this.width + 'px',
                    height: height + 'px'
                };
            },
            
            classClock: function() {
                var cls = {};
                cls['digit-clock-' + this.color] = true;
                
                return cls;                
            },
            
            clockBorderWidth: function() {
                return this.width * 0.02;
            },
            
            styleClock: function() {
                var height = this.timeItemHeight + this.clockBorderWidth * 2;
                
                return {
                    height: height + 'px',
                    'border-width': this.clockBorderWidth + 'px'
                };
            },
            
            timeItemWidth: function() {
                return (this.width - this.clockBorderWidth * 2) / 5 ;
            },
            
            timeItemHeight: function() {
                return this.timeItemWidth / this.itemSize.coef;
            },
            
            hourFirstDigit: function() {
                var s = this.hourValue.toString();
                return s.length === 1 ? '0' : s[0];
            },
            
            hourSecondDigit: function() {
                var s = this.hourValue.toString();
                return s.length === 1 ? s : s[1];
            },
            
            minuteFirstDigit: function() {
                var s = this.minuteValue.toString();
                return s.length === 1 ? '0' : s[0];
            },
            
            minuteSecondDigit: function() {
                var s = this.minuteValue.toString();
                return s.length === 1 ? s : s[1];
            },
            
            styleControlBox: function() {
                var width = this.timeItemWidth * 2;
                
                return {
                    width: width + 'px',
                    'font-size': this.controlFontSize + 'px' // 12.05.2022
                };
            },
            
            controlFontSize: function() {
                return this.width * 0.1;
            }
        },
        
        methods: {
            twoDigits: function(value) {
                return value.toString().length > 1 ? value : '0' + value;
            },
            
            onWindowResize: function() {
                if (this.resizeTimer !== null) {
                    clearTimeout(this.resizeTimer);
                    this.resizeTimer = null;
                }

                var self = this;
                this.resizeTimer = setTimeout(function(){
                    self.updateSize();
                    self.resizeTimer = null;
                }, 300);                
            },
            
            updateSize: function() {
                var width = this.$el.offsetWidth - 2;
                
                if (width <= 0) {
                    return;
                }
                
                this.width = width;
            },
            
            getTimeItemStyle: function(isDivider, value) {
                var url = isDivider ? 'divider_1.png' : 'd' + value + '.png';
                
                return {
                    'background-image': 'url(' + DigitClockImagesPath + url + ')',
                    'width': this.timeItemWidth + 'px',
                    'height': this.timeItemHeight + 'px'
                };
            },
            
            loadValue: function() {
                var arr = this.value.split(':');

                this.hourValue = parseInt(arr[0], 10);
                this.minuteValue = parseInt(arr[1], 10);                
            },
            
            checkHour: function(hour) {
                var r = hour;
                
                if (r > 23) {
                    r = 0;
                } else {
                    if (r < 0) {
                        r = 23;
                    }
                } 
                
                return r;
            },
            
            fireChangeTime: function(unit, direction) {
                
                switch (unit) {
                    case 'hour':
                        var hour = this.hourValue;
                        
                        if (direction === 'up') {
                            hour += 1;
                        } else {
                            hour -= 1;
                        }
                        
                        this.hourValue = this.checkHour(hour);
                        
                        break;
                    
                    case 'minute':
                        var minute = this.minuteValue;
                        
                        if (direction === 'up') {
                            minute += 1;
                        } else {
                            minute -= 1;
                        }
                        
                        if (minute > 59) {
                            minute = 0;
                            this.hourValue = this.checkHour(this.hourValue + 1);
                        } else {
                            if (minute < 0) {
                                minute = 59;
                                this.hourValue = this.checkHour(this.hourValue - 1);
                            }
                        }
                        
                        this.minuteValue = minute;                        
                        
                        break;
                }
                
            }
        },
        
        created: function() {
            window.addEventListener('resize', this.onWindowResize);
        },
        
        beforeDestroy: function() {
            window.removeEventListener('resize', this.onWindowResize);
        },
        
        mounted: function() {
            var img = new Image(),
                self = this;    
            img.onload = function() {      
                self.itemSize.width = this.width;
                self.itemSize.height = this.height;
                self.itemSize.coef = this.width / this.height;
                
                self.loaded = true;
                
                self.$nextTick(function() {
                    self.updateSize();

                    self.loadValue();
                });
            }; 
            
            img.src = DigitClockImagesPath + 'd0.png';
        },
        
        watch: {
            hourValue: function(newValue) {
                var t = this.twoDigits(newValue) + ':' +
                        this.twoDigits(this.minuteValue);
                
                this.$emit('input', t);
            },
    
            minuteValue: function(newValue) {
                var t = this.twoDigits(this.hourValue) + ':' +
                        this.twoDigits(newValue);
                
                this.$emit('input', t);
            },
            
            value: function(newValue) {
                this.loadValue();
            }
        }
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 28.08.2024
 *
 */

(function() {
  const SMILES_COUNT = 3;

  Vue.component('sort-balls-ball', {
    template: `
      <div
        class="sort-balls__ball-box"
        :class="boxClass"
        :style="boxStyle"
      >
        <div
          ref="ball"
          v-show="!isEmpty"
          class="sort-balls__ball"
          :class="ballClass"
          :style="ballStyle"
          @mousedown="pointerDown(false, $event)"
          @touchstart="pointerDown(true, $event)"
        >
          <div
            class="sort-balls__ball__glare"
            :class="glareClass"
            :style="glareStyle"
          ></div>

          <img
            class="sort-balls__ball__smile"
            :class="smileClass"
            :src="smileSource"
          />

          <span
            v-if="isHidden"
            class="sort-balls__ball__question"
            :style="questionStyle"
          >?</span>
        </div>
      </div>
    `,

    props: {
      ball: {
        type: Object
      },

      index: {
        type: Number,
        required: true
      },

      active: {
        type: Boolean,
        required: true
      },

      dragging: {
        type: Boolean,
        required: true
      },

      pointer: {
        type: Object,
        required: true
      },

      size: {
        type: Object,
        required: true
      },

      isTarget: {
        type: Boolean,
        required: true
      },

      boxSize: {
        type: Object,
        required: true
      },

      isCompleted: {
        type: Boolean,
        required: true
      }
    },

    data() {
      return {
        smileIndex: -1,
        loaded: false
      };
    },

    computed: {
      isEmpty() {
        return this.ball.color === '';
      },

      isFirst() {
        return this.index === 0;
      },

      isHidden() {
        return ! this.isEmpty && this.ball.hidden;
      },

      ballClass() {
        let cls = {
          'active': this.active && ! this.isCompleted,
          'dragging': this.dragging && this.pointer.down && ! this.isCompleted,
          'loaded': this.loaded,
          'secret': this.isHidden,
          'text-center': this.isHidden
        };

        if (! this.isEmpty) {
          cls[this.ball.color] = true;
        }

        return cls;
      },

      boxClass() {
        return {
          'first': this.isFirst,
          'is-target': this.isTarget
        };
      },

      ballStyle() {
        let style = {
          width: this.size.width + 'px',
          height: this.size.height + 'px'
        };

        if (this.dragging && this.pointer.down) {
          const x = this.pointer.x - this.size.width / 2;
          const y = this.pointer.y - this.size.height / 2;

          style.left = x + 'px';
          style.top  = y + 'px';
        }

        return style;
      },

      boxStyle() {
        const height = this.isFirst ? this.boxSize.height + 5 : this.boxSize.height;
        return {
          width: this.boxSize.width + 'px',
          height: height + 'px'
        };
      },

      glareClass() {
        return {
          hidden: this.size.glare.width < 5 || this.isCompleted
        };
      },

      glareStyle() {
        return {
          width: this.size.glare.width + 'px',
          height: this.size.glare.height + 'px',
          top: this.size.glare.top + 'px',
          left: this.size.glare.left + 'px'
        };
      },

      smileClass() {
        return {
          completed: this.ball.color !== '' && this.isCompleted
        };
      },

      smileSource() {
        return this.smileIndex > -1 ? `/public/images/exercises/sort-balls/smiles/smile${this.smileIndex}.svg` : '';
      },

      smileStyle() {
        const size = this.size.width * 0.8;
        const left = (this.size.width - size) / 2;
        const top = (this.size.height - size) / 2;

        return {
          width: size + 'px',
          height: size + 'px',
          left: left + 'px',
          top: top + 'px',
        };
      },

      questionStyle() {
        const fontSize = this.size.height > 50 ? 36 : Math.floor(36 * this.size.height / 50);

        return {
          'font-size': fontSize + 'px',
          'line-height': this.size.height + 'px'
        };
      }
    },

    methods: {
      pointerDown(isTouch, event) {
        if (this.isCompleted) {
          return;
        }

        if (! this.active) {
          this.$emit('inactive-ball');
          return;
        }

        if (! isTouch) {
          const isLeftButton = ('buttons' in event && event.buttons === 1) || ('which' in event && event.which === 1);
          if (! isLeftButton) {
            return;
          }
        }

        this.$emit('start-drag', { event, ballIndex: this.index });

        if (event.cancelable) {
          event.stopPropagation();
          event.preventDefault();
        }
      },

      updateRect() {
        const rect = this.$refs.ball.getBoundingClientRect();
        this.$emit('update-rect', { rect, ballIndex: this.index });
      }
    },

    watch: {
      'pointer.down'() {
        if (! this.dragging) {
          return;
        }

        if (this.pointer.down) {
          this.$nextTick(() => this.updateRect());
        } else {
          const rect = this.$refs.ball.getBoundingClientRect();
          this.$emit('stop-drag', { rect, ballIndex: this.index });
        }

      },

      pointer: {
        handler() {
          if (this.pointer.down && this.dragging) {
            this.updateRect();
          }
        },

        deep: true
      }
    },

    mounted() {
      const showSmile = ks.helpers.math.getRandomInt(1, 100)
      this.smileIndex = showSmile <= 33 ? ks.helpers.math.getRandomInt(0, SMILES_COUNT - 1) : -1;

      this.$nextTick(() => this.loaded = true);
    }
  });
}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 28.08.2024
 *
 */

(function() {
  Vue.component('sort-balls-container', {
    template: `
      <div ref="container" class="sort-balls__container">
        <div
          ref="status"
          class="sort-balls__container__status"
          :class="statusClass"
        >
          <i class="fa fa-chevron-circle-down" aria-hidden="true"></i>
        </div>

        <div
          v-for="index in zeroCount"
          class="sort-balls__ball-box__zero"
          :style="zeroStyle"
        ></div>

        <sort-balls-ball
          v-for="(ball, index) in container.balls"
          :key="index"
          :ball="ball"
          :index="index"
          :active="isActiveBall(index)"
          :dragging="isDraggingBall(index)"
          :pointer="pointer"
          :size="ballSize"
          :is-target="container.isTarget"
          :box-size="ballBoxSize"
          :is-completed="isCompleted"
          @update-rect="updateBallRect"
          @start-drag="startBallDrag"
          @stop-drag="stopBallDrag"
          @inactive-ball="onInactiveBall"
        />

        <div
          class="sort-balls_container-stand"
          :class="standClass"
        >
        </div>
      </div>
    `,

    props: {
      container: {
        type: Object,
        required: true
      },

      index: {
        type: Number,
        required: true
      },

      maxSize: {
        type: Number,
        required: true
      },

      dragBall: {
        type: Object,
        required: true
      },

      pointer: {
        type: Object,
        required: true
      },

      ballSize: {
        type: Object,
        required: true
      },

      ballBoxSize: {
        type: Object,
        required: true
      },

      isCompleted: {
        type: Boolean,
        required: true
      }
    },

    data() {
      return {};
    },

    computed: {
      zeroCount() {
        const count = this.maxSize - this.container.balls.length;
        return count < 0 ? 0 : count;
      },

      zeroStyle() {
        return {
          width: this.ballBoxSize.width + 'px',
          height: this.ballBoxSize.height + 'px'
        };
      },

      statusClass() {
        let classes = {
          'invisible': ! this.container.completed,
          'completed': this.container.completed
        };

        if (this.container.completed) {
          const isEmpty = this.container.empty;

          let color = this.getColor();
          if (! color && isEmpty) {
            color = 'default'
          }

          if (color) {
            classes[color] = true;
          }
        }

        return classes;
      },

      standClass() {
        let classes = {};

        if (this.container.color) {
          classes[this.container.color] = true;
        }

        return classes;
      }
    },

    methods: {
      getColor() {
        if (this.container.balls.length <= 0) {
          return null;
        }

        if (this.container.balls[0].color !== '') {
          return this.container.balls[0].color;
        }

        if (this.container.color !== '') {
          return this.container.color;
        }

        return null;
      },

      isActiveBall(ballIndex) {
        return ballIndex === 0 ? true : this.container.balls[ballIndex - 1].color === '';
      },

      isDraggingBall(ballIndex) {
        return this.dragBall.containerIndex === this.index && this.dragBall.ballIndex === ballIndex;
      },

      updateBallRect(data) {
        this.$emit('update-ball-rect', {
          rect: data.rect,
          containerIndex: this.index,
          ballIndex: data.ballIndex
        });
      },

      startBallDrag(data) {
        this.$emit('start-ball-drag', {
          event: data.event,
          containerIndex: this.index,
          ballIndex: data.ballIndex
        });
      },

      stopBallDrag(data) {
        this.$emit('stop-ball-drag', {
          rect: data.rect,
          containerIndex: this.index,
          ballIndex: data.ballIndex
        });
      },

      onWindowScroll() {
        this.updateRect();
      },

      onWindowResize() {
        this.updateRect();
      },

      updateRect() {
        const clientRect = this.$refs.container.getBoundingClientRect();

        clientRect.left += window.scrollX;
        clientRect.top += window.scrollY;

        const left = clientRect.left + clientRect.width / 2 - this.ballBoxSize.width / 2
        const top = clientRect.top + this.$refs.status.offsetHeight + (this.maxSize - this.container.size) * this.ballBoxSize.height;

        const height = this.container.size * this.ballBoxSize.height + this.ballBoxSize.dividerHeight;

        const rect = {
          left,
          top,
          x: left,
          y: top,
          width: this.ballBoxSize.width,
          height,
          right: left + this.ballBoxSize.width,
          bottom: top + height
        };

        this.$emit('update-rect', { rect, index: this.index });
      },

      onInactiveBall() {
        this.$emit('inactive-ball');
      }
    },

    created() {
      window.addEventListener('scroll', this.onWindowScroll);
      window.addEventListener('resize', this.onWindowResize);
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.onWindowScroll);
      window.removeEventListener('resize', this.onWindowResize);
    },

    mounted() {
      this.$nextTick(() => {
        // Иногда не успевает сработать, поэтому вызовем еще раз через 300 ms
        this.updateRect();

        setTimeout(() => {
          this.updateRect();
        }, 300);
      });
    }
  });
}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 13.12.2024
 *
 */

(function() {
  Vue.component('sort-balls-how-to-play', {
    template: `
      <div ref="dialog" class="modal fade" role="dialog">
        <div class="modal-dialog dlg-info">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <div class="modal-title text-center blue">Правила игры</div>
            </div>
            <div class="modal-body">
              <div class="dialog-how-to-play-content">
                <div class="row dialog-how-to-play-content-box">
                  <div class="dialog-how-to-play-content_audio-box">
                    <a href="#" @click.prevent="toggleAudio" class="dialog-how-to-play-content_audio" :class="audioClass">
                      <i class="fa" :class="audioIconClass"></i>
                    </a>
                  </div>

                  <div class="dialog-how-to-play-content__text">{{ currentStep.text }}</div>
                </div>

                <picture>
                    <source :srcset="getCurrentStepImage(true)" type="image/webp">
                    <img class="dialog-how-to-play-content__image" :src="getCurrentStepImage(false)">
                </picture>
              </div>

              <div class="text-center">
                <div class="small-text gray-text">{{ step }}/{{ steps.length }}</div>
                <a href="#" @click.prevent="prevStep" class="btn btn-default btn-how-to-play-nav" :disabled="!canPrevStep"><i class="fa fa-arrow-left" aria-hidden="true"></i> Назад</a>
                <a href="#" @click.prevent="nextStep" class="btn btn-default btn-how-to-play-nav" :disabled="!canNextStep">Вперёд <i class="fa fa-arrow-right" aria-hidden="true"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    `,

    data() {
      return {
        loaded: false,

        name: 'exerciseHowToPlay',

        autoShow: false,

        currentSound: null,

        step: 1,

        steps: [
          {
            text: 'Заполни колбу шариками одного цвета или оставь её пустой. Перемещать можно только верхний шарик.',
          },

          {
            text: 'Колбы бывают разных размеров. В них помещается разное количество шариков.',
          },

          {
            text: 'В колбу с цветным дном можно собрать только шарики того же цвета. Также колбу можно оставить пустой.',
          },

          {
            text: 'Цвет шарика бывает скрыт знаком вопроса. Убери все шарики над ним, чтобы узнать какого он цвета.',
          },
        ]
      };
    },

    computed: {
      currentStep() {
        return this.steps[this.step - 1];
      },

      canPrevStep() {
        return this.step > 1;
      },

      canNextStep() {
        return this.step < this.steps.length;
      },

      isPlaying() {
        return this.currentSound !== null;
      },

      isVoiceEnabled() {
        return this.loaded && ks.soundManager.isSoundEnabled(ks.consts.SOUND_TYPE_VOICE);
      },

      audioClass() {
        return {
          playing: this.isPlaying
        };
      },

      audioIconClass() {
        return {
          'fa-play': ! this.isPlaying,
          'fa-stop': this.isPlaying
        };
      }
    },

    methods: {
      getCurrentStepImage(webp) {
        const ext = webp ? '.webp' : '.png';
        return '/public/images/exercises/sort-balls/how-to-play/step' + this.step + ext;
      },

      getCurrentStepSound() {
        return 'public/sounds/exercises/sort-balls/how-to-play/step' + this.step + '.ogg';
      },

      show(step, autoShow) {
        this.autoShow = autoShow;
        this.step = step ?? 1;

        this.$dlg.modal('show');

        this.$store.commit('window/setVisibleDialog', { dialog: this.name, visible: true });

        if (this.isVoiceEnabled) {
          setTimeout(() => this.playSound(), 300);
        }
      },

      hide() {
        this.$dlg.modal('hide');
      },

      prevStep() {
        if (! this.canPrevStep) {
          return;
        }

        if (this.isPlaying) {
          this.stopSound();
        }

        this.step--;

        if (this.isVoiceEnabled) {
          this.playSound();
        }
      },

      nextStep() {
        if (! this.canNextStep) {
          return;
        }

        if (this.isPlaying) {
          this.stopSound();
        }

        this.step++;

        if (this.isVoiceEnabled) {
          this.playSound();
        }
      },

      playSound() {
        this.$emit('stop-audio');

        if (this.isPlaying) {
          this.stopSound();
        }

        const sound = this.getCurrentStepSound();

        ks.soundManager.playVoice(
          sound,
          {
            onPlay: () => this.currentSound = sound,
            onStop: () => this.currentSound = null,
            onEnd: () => this.currentSound = null
          },
          true
        );
      },

      stopSound() {
        if (! this.isPlaying) {
          return;
        }

        ks.soundManager.stop(this.currentSound);
      },

      toggleAudio() {
        this.isPlaying ? this.stopSound() : this.playSound();
      }
    },

    mounted() {
      this.loaded = true;

      this.$dlg = $(this.$refs.dialog);

      this.$dlg.on('hidden.bs.modal', () => {
        this.stopSound();
        this.$store.commit('window/setVisibleDialog', { dialog: this.name, visible: false });

        if (this.autoShow) {
          this.$emit('play-exercise-audio');
        }
      });
    }
  });

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 06.10.2023
 * 
 */

(function() {
    
    Vue.component('sort-container', {
        template: 
            `<div class="sort-container" :style="containerStyle">
                <div class="sort-container__target-pad" :style="targetPadStyle" :class="targetPadClass"></div>  
        
                <img ref="image" :src="container.image" class="sort-container__image" :style="containerImageStyle" />

                <img v-if="isExtraImageType" :src="container.extra_image" class="sort-container__extra-image" :style="extraImageStyle" />

                <div v-if="isTextType" class="sort-container__text" :style="textStyle" v-html="container.text"></div>

                <div v-for="(itemIndex, index) in containerItems" class="sort-container__item" :class="getItemClass(itemIndex)" :style="getItemStyle(index, itemIndex)" @mousedown="pointerItemDown(false, $event, itemIndex)" @touchstart="pointerItemDown(true, $event, itemIndex)">
                    <img v-if="itemIndex > -1" 
                        class="sort-container__item__image" 
                        :class="getItemImageClass(itemIndex)"
                        :src="getItemImage(itemIndex)" 
                        :style="getItemImageStyle(itemIndex)" />
        
                    <div v-if="hasItemText && itemIndex > -1" 
                        class="sort-container__item__text" 
                        :class="getItemTextClass(itemIndex)" 
                        :style="getItemTextStyle(itemIndex)"
                        v-html="getItemText(itemIndex)"></div>    
                </div>
            </div>`,
        
        props: {
            containerWidth: {
                type: Number,
                required: true
            },
            
            index: {
                type: Number,
                required: true
            },
            
            container: {
                type: Object,
                required: true
            },
            
            items: {
                type: Array,
                required: true
            },
            
            settings: {
                type: Object,
                required: true
            },
            
            dragItemIndex: {
                type: Number,
                required: true
            },
            
            readonly: {
                type: Boolean,
                required: true
            },
            
            incorrectMode: {
                type: Boolean,
                required: true
            },
            
            correctAnswers: {
                type: Array,
                required: true
            }
        },
        
        data() {
            return {
                // Расстояние между рамкой контейнера и изображением
                targetPadOffset: 4,
                
                size: {
                    width: 0,
                    height: 0
                },
                
                coef: 1
            };
        },
        
        computed: {
            width() {
                return this.settings.size.width * this.coef;
            },
            
            height() {
                return this.settings.size.height * this.coef;
            },
            
            x() {
                return Math.floor((this.containerWidth - this.width) / 2);
            },
            
            y() {
                return this.targetPadOffset;
            },
            
            containerStyle() {
                const height = this.height + this.targetPadOffset * 2;
                
                return {
                    height: height + 'px'
                };
            },
            
            targetPadStyle() {
                const width = this.width + this.targetPadOffset * 2,
                      height = this.height + this.targetPadOffset * 2,
                      left = Math.floor((this.containerWidth - width) / 2);
                
                let style = {
                    left: left + 'px',
                    top: 0,
                    width: width + 'px',
                    height: height + 'px'                    
                };
                
                return style;
            },
            
            targetPadClass() {
                return {
                    shown: this.container.showTargetPad
                };
            },
            
            containerImageStyle() {
                return {
                    left: this.x + 'px',
                    top: this.y + 'px',
                    width: this.width + 'px',
                    height: this.height + 'px'
               };
            },
            
            extraImageStyle() {
                const extraImage = this.settings.extra_image,
                      width  = Math.trunc(extraImage.width * this.coef * extraImage.scale / 100),
                      height = Math.trunc(extraImage.height * this.coef * extraImage.scale / 100),
                      x = this.x + Math.trunc(extraImage.x * this.coef - width / 2) - this.targetPadOffset,
                      y = this.y + Math.trunc(extraImage.y * this.coef - height / 2);
                
                let style = {
                    left: x + 'px',
                    top: y + 'px',
                    width: width + 'px',
                    height: height + 'px'
                };
                
                this.applyPadStyle(style, this.settings.pad, this.coef);
                
                return style;
            },
            
            textStyle() {
                let style = {
                    'font-size'   : ks.helpers.html.getStyleFontSize(this.settings.text.font.size, this.coef),
                    'font-weight' : this.settings.text.font.weight
                };
                
                this.applyPadStyle(style, this.settings.pad, this.coef);
                
                const size = ks.helpers.text.getTextSize(this.container.text, style),
                      x    = Math.trunc(this.x + this.settings.text.x * this.coef - size.width / 2);
                      y    = Math.trunc(this.y + this.settings.text.y * this.coef - size.height / 2);
                
                style.color = this.settings.text.font.color;
                style.left = x + 'px';
                style.top  = y + 'px';
                
                return style;                
            },
            
            isExtraImageType() {
                return this.settings.type === ksGlobal.SortContainerType.ExtraImage;
            },
            
            isTextType() {
                return this.settings.type === ksGlobal.SortContainerType.Text;
            },
            
            containerItems() {
                let items = this.container.items.slice();
                
                while (items.length !== 4) {
                    items.push(-1);
                }
                
                return items;
            },
            
            hasItemText() {
                return this.settings.item.has_text;
            },            
        },
        
        methods: {
            onWindowScroll() {
                this.updateRect();
            },
            
            applyPadStyle(style, pad, coef) {
                if (! pad.enabled) {
                    return;
                }
                
                style['background-color'] = pad.background_color;
                style.border = ks.helpers.html.getStyleBorder(pad.border, coef);
                style['border-radius'] = pad.border_radius;
                style['line-height'] = 1;
                
                if (pad.padding) {
                    style.padding = ks.helpers.html.getStylePadding(pad.padding, coef);     
                }
            },
            
            getItemRect(index) {
                let left = this.x + Math.trunc(this.settings.items.x * this.coef),
                    top = this.y + Math.trunc(this.settings.items.y * this.coef),    
                    size = { width: this.settings.items.size.width * this.coef, height: this.settings.items.size.height * this.coef },
                    offset = Math.trunc(this.settings.items.offset * this.coef);
                    
                if (offset < 1) {
                    offset = 1;
                }    
                    
                switch (index) {
                    case 0:
                        left -= offset + size.width;
                        top += offset;
                        break;
                    
                    case 1:
                        left += offset;
                        top += offset;
                        break;
                        
                    case 2:
                        left -= offset + size.width;
                        top -= offset + size.height;
                        break;
                        
                    case 3: 
                        left += offset;
                        top -= offset + size.height;
                        break;
                }
                
                return {
                    left   : left,
                    top    : top,
                    width  : size.width,
                    height : size.height
                };
            },
            
            getItemClass(itemIndex) {
                const answerMode = this.settings.items.pad.enabled && 
                                   this.incorrectMode && itemIndex > -1;
                           
                const isCorrect = itemIndex > -1 && this.correctAnswers[itemIndex] === this.index;           
                
                return {
                    correct   : answerMode && isCorrect,
                    incorrect : answerMode && ! isCorrect,
                };
            },
            
            getItemStyle(index, itemIndex) {
                let rect = this.getItemRect(index),
                    style = { 
                        left: rect.left + 'px',
                        top: rect.top + 'px',
                        width: rect.width + 'px', 
                        height: rect.height + 'px',
                        cursor: itemIndex > -1 && ! this.readonly ? 'move' : 'default'
                    };
                    
                if (this.readonly) {
                    style['pointer-events'] = 'none';
                }     
                
                if (this.settings.items.pad.enabled) {
                    const answerMode = this.incorrectMode && itemIndex > -1;
                    
                    if (! answerMode) {
                        style['background-color'] = this.settings.items.pad.background_color;
                    }
                    
                    style.border = ks.helpers.html.getStyleBorder(this.settings.items.pad.border, this.coef);
                    style['border-radius'] = this.settings.items.pad.border_radius;
                }
                
                return style;
            },
            
            updateRect() {
                let rect = this.$refs.image.getBoundingClientRect();
                
                rect.left += window.scrollX;
                rect.top += window.scrollY;
                
                this.$emit('update-rect', { rect: rect, container: this.container });
            },
            
            getItemImage(index) {
                return this.items[index].image;
            },
            
            getItemImageRect(index) {
                let imageRect = { left: 0, top: 0, width: 0, height: 0 };
                
                if (this.settings.items.size.width === 0 || this.settings.items.size.height === 0) {
                    return imageRect;
                }
                
                const borderSize = this.settings.items.pad.enabled ? ks.helpers.html.getStyleBorderSize(this.settings.items.pad.border, this.coef) : 0,
                      rect = this.getItemRect(index);
                      
                let offset = borderSize <= 0 ? 2 : borderSize;      
                      
                imageRect.width = rect.width - offset * 2;
                
                const coef = imageRect.width < this.settings.items.size.width ? imageRect.width / this.settings.items.size.width : 1;
                imageRect.height = this.settings.items.size.height * coef;
                
                imageRect.left = Math.round((rect.width - imageRect.width) / 2) - borderSize;
                imageRect.top  = Math.round((rect.height - imageRect.height) / 2) - borderSize;    
                
                return imageRect;
            },
            
            getItemImageStyle(index) {
                const rect = this.getItemImageRect(index),
                      item = this.items[index];
                
                let style = {
                    left   : rect.left + 'px',
                    top    : rect.top + 'px',
                    width  : rect.width + 'px',
                    height : rect.height + 'px'
                };

                if (item.modifier && item.modifier !== ksGlobal.ImageModifier.values.None) {
                    const transform = ksGlobal.ImageModifier.getTransform(item.modifier);
                    style['transform'] = transform;
                    style['-webkit-transform'] = transform;
                }                
                    
                return style;
            },
            
            getItemImageClass(index) {
                return {
                    dragging: this.dragItemIndex === index
                }
            },
            
            pointerItemDown(isTouch, event, index) {
                if (this.readonly || index < 0) {
                    return;
                }
                
                if (! isTouch) {
                    const isLeftButton = ('buttons' in event && event.buttons === 1) || ('which' in event && event.which === 1);
                    if (! isLeftButton) {
                        return;
                    }
                }                

                if (event.cancelable) {
                    event.stopPropagation();
                    event.preventDefault();                
                }                
                
                const item = this.items[index];
                item.dragging = true;
                this.$emit('start-drag-item', { event: event, item: item });
            },
            
            getItemText(index) {
                return this.items[index].text;
            },
            
            getItemTextClass(index) {
                return {
                    dragging: this.dragItemIndex === index
                }                
            },
            
            getItemTextStyle(index) {
                const rect = this.getItemImageRect(index),
                      coef = rect.width / this.settings.item.size.width;
                      
                let style = {
                    'font-size'   : ks.helpers.html.getStyleFontSize(this.settings.item.text.font.size, coef),
                    'font-weight' : this.settings.text.font.weight
                };
                
                this.applyPadStyle(style, this.settings.item.pad, coef);
                
                const size = ks.helpers.text.getTextSize(this.items[index].text, style),
                      x    = Math.trunc(this.settings.item.text.x * coef - size.width / 2),
                      y    = Math.trunc(this.settings.item.text.y * coef - size.height / 2);
                
                style.color = this.settings.item.text.font.color;
                style.left = x + 'px';
                style.top  = y + 'px';
                
                return style;
            },
            
            updateCoef() {
                const width = this.settings.size.width + this.targetPadOffset * 2;
                this.coef = width <= this.containerWidth ? 1 : this.containerWidth / width;                
            }
        },
        
        watch: {
            containerWidth() {
                this.updateCoef();
            },
            
            width() {
                this.updateRect();
            },
            
            x() {
                this.updateRect();
            }
        },
        
        created() {
            window.addEventListener('scroll', this.onWindowScroll);
        },
        
        beforeDestroy() {
            window.removeEventListener('scroll', this.onWindowScroll);
        },        
        
        mounted() {
            this.$nextTick(() => {
                // Иногда не успевает сработать, поэтому вызовем еще раз через 300 ms
                this.updateCoef();
                this.updateRect();
                
                setTimeout(() => {
                    this.updateCoef();
                    this.updateRect();
                }, 300);                
            });
        }
        
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 06.10.2023
 * 
 */

(function() {
    
    Vue.component('sort-containers', {
        template: 
            `<div class="sort-containers">
                <div v-for="(container, index) in containers" class="sort-container-box" :key="getContainerKey(index)" :style="containerBoxStyle">
                    <sort-container 
                        :container-width="containerWidth"
                        :index="index" 
                        :container="container" 
                        :settings="settings" 
                        :items="items" 
                        :drag-item-index="dragItemIndex"
                        :readonly="readonly"
                        :incorrect-mode="incorrectMode"
                        :correct-answers="correctAnswers"
                        @update-rect="updateRect" 
                        @start-drag-item="startDragItem"></sort-container>
                </div>
        
                <div class="clearfix"></div>
            </div>`,
        
        props: {
            containersWidth: {
                type: Number,
                required: true
            },            
            
            containers: {
                type: Array,
                required: true
            },
            
            items: {
                type: Array,
                required: true
            },
            
            settings: {
                type: Object,
                required: true
            },
            
            dragItemIndex: {
                type: Number,
                default: -1
            },
            
            readonly: {
                type: Boolean,
                default: false
            },
            
            incorrectMode: {
                type: Boolean,
                default: false
            },
            
            correctAnswers: {
                type: Array,
                default: () => { return []; }
            }
        },
        
        data() {
            return {};
        },
        
        computed: {
            boxWidthPercent() {
                return this.containers.length > 0 ? 100 / this.containers.length : 0;
            },
            
            containerBoxStyle() {
                return {
                    width: this.boxWidthPercent + '%'
                };
            },
            
            containerWidth() {
                return Math.floor(this.containersWidth  * this.boxWidthPercent / 100);
            }
        },
        
        methods: {
            getContainerKey(index) {
                return 'container-' + index;
            },
            
            updateRect(data) {
                this.$emit('update-rect', data);
            },
            
            startDragItem(data) {
                this.$emit('start-drag-item', data);
            }
        }      
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 09.10.2023
 * 
 */

(function() {
    
    const DefaultVoiceTextFontSize = 30; //px
    const MinVoiceTextFontSize     = 12; //px
    
    Vue.component('sort-container-item', {
        template: 
            `<div ref="item" class="sort-container-item" :class="itemClass" :style="itemStyle">
                <img class="sort-container-item__image" :src="item.image" :style="imageStyle" @mousedown="pointerDown(false, $event)" @touchstart="pointerDown(true, $event)" />
                <div v-if="hasText" class="sort-container-item__text" v-html="item.text" :style="textStyle" @mousedown="pointerDown(false, $event)" @touchstart="pointerDown(true, $event)"></div>
                <a v-if="showVoice" href="#" @click.prevent="playVoice" class="sort-container-item__voice" :class="voiceClass" :style="voiceStyle">
                    <i class="fa fa-volume-up"></i>
                </a>
            </div>`,
        
        props: {
            index: {
                type: Number,
                required: true
            },
            
            item: {
                type: Object,
                required: true
            },
            
            settings: {
                type: Object,
                required: true
            },
            
            coef: {
                type: Number,
                required: true
            },
            
            pointer: {
                type: Object,
                required: true
            },
            
            isVoicePlaying: {
                type: Boolean,
                required: true
            }
        },
        
        data() {
            return {};
        },
        
        computed: {
            isDragging() {
                return this.item.dragging && this.pointer.down;
            },
            
            isContainerd() {
                return this.item.containerIndex > -1;
            },
            
            width() {
                return Math.round(this.settings.item.size.width * this.coef);
            },
            
            height() {
                return Math.round(this.settings.item.size.height * this.coef);
            },
            
            itemClass() {
                return {
                    'no-dragging': ! this.item.dragging
                };
            },
            
            itemStyle() {
                if (this.item.containerIndex > -1 && ! this.item.dragging) {
                    return { display: 'none' };
                }
                
                let style = { width: this.width + 'px', height: this.height + 'px' };
                
                if (this.isDragging) {
                    style.position = 'fixed';
                    
                    const x = this.pointer.x - this.width / 2,
                          y  = this.pointer.y - this.height / 2;
                    style.left = x + 'px';
                    style.top  = y + 'px';
                    style['z-index'] = 999;
                } else {
                    style['z-index'] = 1;
                }
                
                return style;
            },
            
            imageStyle() {
                let style = { width: this.width + 'px' };

                if (this.item.modifier && this.item.modifier !== ksGlobal.ImageModifier.values.None) {
                    const transform = ksGlobal.ImageModifier.getTransform(this.item.modifier);
                    style['transform'] = transform;
                    style['-webkit-transform'] = transform;
                }

                return style;
            },
            
            hasText() {
                return this.settings.item.has_text;
            },
            
            voiceEnabled: function() {
                return this.$store.getters.isGuest ? this.$store.state.guest.voiceEnabled : this.$store.state.parent.options.sound_voice;
            },            
            
            showVoice() {
                return this.settings.item.has_voice && 
                       this.item.voice !== null && 
                       this.item.voice !== '' &&
                       ! this.isDragging &&
                       ! this.isContainerd &&
                       this.voiceEnabled;
            },
            
            textStyle() {
                let style = {
                    'font-size'   : ks.helpers.html.getStyleFontSize(this.settings.item.text.font.size, this.coef),
                    'font-weight' : this.settings.text.font.weight
                };
                
                this.applyPadStyle(style, this.settings.item.pad);
                
                const size = ks.helpers.text.getTextSize(this.item.text, style),
                      x    = Math.trunc(this.settings.item.text.x * this.coef - size.width / 2),
                      y    = Math.trunc(this.settings.item.text.y * this.coef - size.height / 2);
                
                style.color = this.settings.item.text.font.color;
                style.left = x + 'px';
                style.top  = y + 'px';
                
                return style;
            },
            
            voiceClass() {
                return {
                    active: this.isVoicePlaying
                };
            },
            
            voiceStyle() {
                let style = { right: '0px', top: '0px' };
                
                let fontSize = this.coef < 1 ? Math.round(DefaultVoiceTextFontSize * this.coef) : DefaultVoiceTextFontSize;
                if (fontSize < MinVoiceTextFontSize) {
                    fontSize = MinVoiceTextFontSize;
                }
                
                style['font-size'] = fontSize + 'px';
                
                return style;
            }
        },
        
        methods: {
            applyPadStyle(style, pad) {
                if (! pad.enabled) {
                    return;
                }
                
                style['background-color'] = pad.background_color;
                style.border = ks.helpers.html.getStyleBorder(pad.border, this.coef);
                style['border-radius'] = pad.border_radius;
                style['line-height'] = 1;                
                
                if (pad.padding) {
                    style.padding = ks.helpers.html.getStylePadding(pad.padding, this.coef);     
                }
            },
            
            pointerDown(isTouch, event) {
                if (! isTouch) {
                    const isLeftButton = ('buttons' in event && event.buttons === 1) || ('which' in event && event.which === 1);
                    if (! isLeftButton) {
                        return;
                    }
                }
                
                this.item.dragging = true;
                this.$emit('start-drag', { event: event, item: this.item });
                
                if (event.cancelable) {                
                    event.stopPropagation();
                    event.preventDefault();
                }                
            },
            
            updateRect() {
                const rect = this.$refs.item.getBoundingClientRect();
                this.$emit('update-rect', { rect: rect, item: this.item });                 
            },
            
            playVoice() {
                this.$emit('play-voice', this.item);
            }
        },
        
        watch: {
            'pointer.down'() {
                if (! this.pointer.down && this.item.dragging) {
                    const rect = this.$refs.item.getBoundingClientRect();
                    this.$emit('stop-drag', { rect: rect, item: this.item });
                    this.item.dragging = false;
                }
                
                if (this.pointer.down && this.item.dragging) {
                    this.$nextTick(() => {
                        this.updateRect();                 
                    });
                }
            },
            
            pointer: {
                handler: function() {
                    if (this.pointer.down && this.item.dragging) {
                        this.updateRect();
                    }
                },
                
                deep: true
            }
        }
        
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 09.10.2023
 * 
 */

(function() {
    
    Vue.component('sort-container-items', {
        template: 
            `<div class="sort-container-items">
                <sort-container-item 
                    v-for="(item, index) in items" 
                    :index="index"
                    :item="item" 
                    :settings="settings" 
                    :key="getItemKey(index)" 
                    :coef="coef"
                    :pointer="pointer"
                    :is-voice-playing="isVoicePlaying(item)"
                    @update-rect="updateRect"
                    @start-drag="startDrag"
                    @stop-drag="stopDrag"
                    @play-voice="playVoice"></sort-container-item>
            </div>`,
        
        props: {
            containerWidth: {
                type: Number,
                required: true
            },
            
            items: {
                type: Array,
                required: true
            },
            
            settings: {
                type: Object,
                required: true
            },
            
            pointer: {
                type: Object,
                required: true
            },
            
            itemVoicePlaying: {
                required: true
            }
        },
        
        data() {
            return {};
        },
        
        computed: {
            itemWidth() {
                const itemWidth = this.settings.item.row_items_count !== 0 ? Math.floor(this.containerWidth / this.settings.item.row_items_count) : 0;
                return itemWidth > this.settings.item.size.width ? this.settings.item.size.width : itemWidth;
            },
            
            coef() {
                return this.itemWidth < this.settings.item.size.width ? this.itemWidth / this.settings.item.size.width : 1;
            }
        },
        
        methods: {
            getItemKey(index) {
                return 'sort-container-item-' + index;
            },
            
            updateRect(data) {
                this.$emit('update-rect', data);
            },
            
            startDrag(data) {
                this.$emit('start-drag', data);
            },
            
            stopDrag(data) {
                this.$emit('stop-drag', data);
            },
            
            playVoice(item) {
                this.$emit('play-voice', item);
            },
            
            isVoicePlaying(item) {
                return item === this.itemVoicePlaying;
            }
        }
        
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 12.06.2023
 */

(function() {

    var numberFractionalClass = 'payment-profile-number-fractional';

    Vue.component('payment-periods', {

        template:
            `<div class="row payment-profile-period-block text-center">
                <div v-for="(period, periodIndex) in periods" :key="periodIndex" class="payment-profile-period-container" :class="classPeriodContainer(periodIndex)">
                    <div class="payment-profile-period-box" :class="classPeriodBox(periodIndex)" :style="stylePeriodBox(period)" :id="'paymentPeriod' + period.id">
                        <div v-if="hasOldPrice(period)" class="payment-profile-period-box__profitably">
                          <div>{{ getProfitablyPercentText(period) }}</div>
                        </div>

                        <!--<img v-if="hasOldPrice(period)" class="payment-profile-period-box__profitably-image" :src="getProfitablyIcon(period)" alt="Скидка" />-->

                        <!--<div v-if="isBestseller(period)" class="payment-profile-period-box__bestseller">ХИТ <span class="hidden-sm">ПРОДАЖ</span></div>-->
                        <div v-if="isBestseller(period)" class="payment-profile-period-box__bestseller">ВЫГОДНО</div>

                        <div class="payment-profile-period-box__title" :class="classPeriodBoxTitle(periodIndex)">
                            <div class="payment-profile-period-box__title__icon">
                                <img :src="getSrcPeriodCrown(periodIndex)" width="28" height="28" />
                            </div>
                            <div class="payment-profile-period-box__title__package-name">Безлимитный доступ</div>
                            <div class="payment-profile-period-box__title__package-period">на {{ period.title }}</div>
                        </div>

                        <div class="payment-profile-period-box__top-line"></div>

                        <div class="payment-profile-period-box__price-block">
                            <div class="payment-profile-period-box__price-block__price-month">
                                <span v-html="periodPriceMonth(period)"></span> &#8381;<br class="visible-sm" /> <span class="payment-profile-period-box__price-block__price-month__month-text">за месяц</span>
                            </div>
                            <div class="payment-profile-period-box__price-block__price">
                                К оплате:<br class="visible-sm" />
                                <span v-if="hasOldPrice(period)" class="payment-profile-period-box__price-block__price__old"><span v-html="periodOldPrice(period)"></span> &#8381;</span>
                                <span class="payment-profile-period-box__price-block__price__current"><span v-html="periodPrice(period)"></span> &#8381;</span>
                            </div>
                            <div v-show="hasPromocode(period)" class="payment-profile-period-box__discount" v-html="discountText(period)"></div>
                        </div>

                        <div class="payment-profile-period-box__top-line"></div>

                        <div class="payment-profile-period-box__info-text" :class="classPeriodBoxInfoText(periodIndex)">
                            Все задания и игры без ограничения по возрасту и количеству
                        </div>

                        <div class="payment-profile-period-box__top-line"></div>

                        <div class="payment-profile-period-box__gift" :class="classPeriodBoxGift(periodIndex)">
                            <!--<div><img src="/public/images/gift64.png" alt="Подарок" /></div>-->
                            <div><img src="/public/images/premium/gift.svg" alt="Подарок" /></div>
                            <div>Доступ к премиум материалам для развития ребёнка</div>
                        </div>

                        <div class="payment-profile-period-box__top-line"></div>

                        <div class="payment-profile-period-box__action-block" :class="classPeriodBoxActionBlock(periodIndex)">
                            <a href="#" @click.prevent="doPayment(period, false)" class="btn btn-lg" :class="classPeriodBoxButton(periodIndex)">{{ getPeriodPayTitle(period) }}</a>
                        </div>
                    </div>
                </div>

            </div>`,

        props: {
            periods: {
                type: Array,
                required: true
            },

            promocode: {
                type: Object,
                required: true
            }
        },

        data: function() {
            return {

            };
        },

        computed: {
            isLogged: function() {
                return ! this.$store.getters.isGuest;
            },

            hasPromocodePercent: function() {
                return this.promocode.active &&
                       this.promocode.discountMode === ks.consts.PROMOCODE_DISCOUNT_MODE_PERCENT &&
                       this.promocode.discount > 0;
            },

            hasPromocodeMonth: function() {
                return this.promocode.active && this.promocode.discountMode === ks.consts.PROMOCODE_DISCOUNT_MODE_MONTH;
            },

            hasPromocodeFixed: function() {
                return this.promocode.active &&
                       this.promocode.discountMode === ks.consts.PROMOCODE_DISCOUNT_MODE_FIXED &&
                       this.promocode.discount > 0;
            },

            hasPromocodeFixedPrice: function() {
                return this.promocode.active &&
                       this.promocode.discountMode === ks.consts.PROMOCODE_DISCOUNT_MODE_FIXED_PRICE &&
                       this.promocode.periods.length > 0;
            },

            hasPromocodeDiscount: function() {
                return this.hasPromocodePercent || this.hasPromocodeFixed || this.hasPromocodeFixedPrice;
            },

            discountMonth: function() {
                return this.hasPromocodeMonth ? this.promocode.discount : 0;
            },

            discountMonthText: function() {
                return this.discountMonth + ' ' + ks.helpers.text.pluralize(this.discountMonth, ['месяц', 'месяца', 'месяцев']);
            }
        },

        methods: {
            /**
             * Текст кнопки купить
             * @param {number} period
             * @return {string}
             */
            getPeriodPayTitle: function(period) {
                if (! this.isLogged) {
                    return typeof period.guest_pay_title === 'string' && period.guest_pay_title !== '' ? period.guest_pay_title : 'Купить сейчас';
                } else {
                    return typeof period.pay_title === 'string' && period.pay_title !== '' ? period.pay_title : 'Купить сейчас';
                }
            },

            /**
             * Получить индекс периода промокода по id периода
             * @param {number} periodId
             * @returns {number}
             */
            getPromocodePeriodIndex: function(periodId) {
                for (let i = 0; i < this.promocode.periods.length; i++) {
                    if (this.promocode.periods[i].id === periodId) {
                        return i;
                    }
                }

                return -1;
            },

            /**
             * Текст о том, какую пользу принесет промокод
             * @param {number} period
             * @returns {string}
             */
            discountText: function(period){
                if (this.hasPromocodePercent) {
                    return 'скидка по промокоду ' + this.promocode.discount + '%';
                }

                if (this.hasPromocodeMonth) {
                    return 'в подарок +' + this.discountMonthText;
                }

                if (this.hasPromocodeFixed) {
                    return 'скидка по промокоду -' + this.promocode.discount + '&#8381;';
                }

                if (this.hasPromocodeFixedPrice) {
                    const profit = this.periodOldPriceInt(period) - this.periodPriceInt(period);
                    return 'скидка по промокоду -' + profit + '&#8381;';
                }

                return '';
            },

            // Periods
            periodClass: function(periodIndex){
                let cls = {};

                cls['period-' + periodIndex] = true;

                return cls;
            },

            classPeriodContainer: function(periodIndex){
                let cls = this.periodClass(periodIndex);

                // add other classes

                return cls;
            },

            classPeriodBox: function(periodIndex){
                let cls = this.periodClass(periodIndex);

                // add other classes

                return cls;
            },

            stylePeriodBox: function(period){
                let style = {};

                if (period.bg_image !== '') {
                    style['background-image'] = 'url(' + period.bg_image + ')';
                }

                return style;
            },

            classPeriodBoxTitle: function(periodIndex){
                let cls = this.periodClass(periodIndex);

                // add other classes

                return cls;
            },

            getSrcPeriodCrown: function(periodIndex){
                return `/public/images/premium/crown-${periodIndex}.svg`;
            },

            classPeriodBoxInfoText: function(periodIndex){
                let cls = this.periodClass(periodIndex);

                // add other classes

                return cls;
            },

            classPeriodBoxGift: function(periodIndex){
                let cls = this.periodClass(periodIndex);

                // add other classes

                return cls;
            },

            classPeriodBoxActionBlock: function(periodIndex){
                let cls = this.periodClass(periodIndex);

                // add other classes

                return cls;
            },

            classPeriodBoxButton: function(periodIndex){
                return {
                    'btn-blue'    : periodIndex === 0,
                    'btn-green'   : periodIndex === 1,
                    'btn-crimson' : periodIndex === 2
                };
            },

            hasOldPrice: function(period){
                if (typeof period.old_price !== 'undefined' && period.old_price > 0) {
                    return true;
                }

                return ! this.isDisabledPromocode(period) && this.hasPromocodeDiscount;
            },

            isBestseller: function(period){
                return typeof period.bestseller !== 'undefined' && period.bestseller === true;
            },

            /**
             * Проверяем можно ли использовать промокод для данного периода
             * @param {number} periodId
             * @returns {boolean}
             */
            hasPromocodePeriod: function(periodId) {
                // Если это промокод не с фикс ценой и периоды не заданы - значит использовать можно
                if (this.promocode.mode !== ks.consts.PROMOCODE_DISCOUNT_MODE_FIXED_PRICE && this.promocode.periods.length <= 0) {
                    return true;
                }

                // Ищем период в периодах промокода
                for (let i = 0; i < this.promocode.periods.length; i++) {
                    if (this.promocode.periods[i].id === periodId) {
                        return true;
                    }
                }

                return false;
            },

            isDisabledPromocode: function(period){
                return (typeof period.disabled_promocode !== 'undefined' && period.disabled_promocode === true) ||
                       ( ! this.hasPromocodePeriod(period.id));
            },

            periodPriceMonth: function(period){
                let price = this.periodPriceInt(period) / period.months;

                return ks.helpers.text.priceHTML(price, numberFractionalClass);
            },

            periodOldPriceInt: function(period){
                if (typeof period.old_price !== 'undefined' && period.old_price > 0) {
                    return period.old_price;
                }

                if (this.hasPromocodeDiscount) {
                    return period.price;
                }

                return 0;
            },

            periodOldPrice: function(period){
                let price = this.periodOldPriceInt(period);

                return ks.helpers.text.priceHTML(price, numberFractionalClass);
            },

            periodPrice: function(period){
                let price = this.periodPriceInt(period),
                    priceHTML = ks.helpers.text.priceHTML(price, numberFractionalClass);

                if (period.color !== '') {
                    priceHTML = '<span style="font-weight: bold; color: ' + period.color + ';">' + priceHTML + '</span>';
                }

                return priceHTML;
            },

            periodPriceInt: function(period){
                let price = -1;

                if ( ! this.isDisabledPromocode(period)) {
                    if (this.hasPromocodePercent) {
                        price = this.periodOldPriceInt(period) * (100 - this.promocode.discount) / 100;
                    }

                    if (this.hasPromocodeFixed) {
                        price = this.periodOldPriceInt(period) - this.promocode.discount;
                    }

                    if (this.hasPromocodeFixedPrice) {
                        const index = this.getPromocodePeriodIndex(period.id);
                        price = index < 0 ? -1 : this.promocode.periods[index].value;
                    }
                }

                return price < 0 ? period.price : price;
            },

            hasPromocode: function(period){
                return ! this.isDisabledPromocode(period) && this.promocode.active;
            },

            getProfitablyPercentText: function(period) {
              const percent = 100 - Math.round(this.periodPriceInt(period) * 100 / this.periodOldPriceInt(period));
              //const percentText = percent > 0 && percent <= 60 && percent % 5 === 0 ? '-' + percent : '';

              return '-' + percent + '%';
            },

            getProfitablyIcon: function(period){
                if (period.profitably_icon !== '' && ! this.hasPromocode(period)) {
                    return period.profitably_icon;
                }

                let percent = 100 - Math.round(this.periodPriceInt(period) * 100 / this.periodOldPriceInt(period)),
                    fileNameSuffix = percent > 0 && percent <= 60 && percent % 5 === 0 ? '_' + percent : '';

                return '/public/images/payment/period_sale' + fileNameSuffix + '.png';
            },

            doPayment: function(period, alternativeMode) {
                if (this.isLogged || period.guest_button_action === 'pay') {
                    this.$emit('payment', period, alternativeMode);
                    return;
                }

                ks.app.showSignup({ text: 'Для начала занятий<br /> необходимо зарегистрироваться:' });
            }
        },

        mounted: function() {

        }

    });

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 12.06.2023
 */

(function() {
    
    Vue.component('payment-promocode', {
        
        template:  
            `<div class="payment-profile-promocode-container">
                <div v-show="visible" class=" text-center">
                    <div v-show="!isShow" class="text-center"><a class="payment-profile-promocode__has-promocode" href="#" @click.prevent="show">У меня есть промокод</a></div>
                    <div v-show="isShow" style="display: none;" class="row">
                        <div class="col-xs-12">
                            <div class="payment-profile-promocode__text">Промокод:</div>
                        </div>    
                        <div class="col-xs-12 col-sm-12 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4">    
                            <input type="text" class="form-control payment-profile-promocode__input" v-model.trim="promocode.value" :disabled="promocode.active" @keyup.enter="apply(false)"/>
                            <div v-show="hasError" class="error-text">{{ promocode.error }}</div>
                            <div v-show="promocode.active" class="green"><b>Промокод {{ promocode.value }} успешно активирован!</b></div>
                        </div>
                        <div class="col-xs-12 payment-profile-promocode__button-box">
                            <a v-show="!promocode.active" href="#" @click.prevent="apply(false)" class="btn btn-purple" :disabled="! canApply">Применить промокод</a>
                            <a v-show="promocode.active" href="#" @click.prevent="clear" class="btn btn-blue">Отменить промокод</a>
                        </div>
                    </div>
                </div>
            </div>`,
    
        props: {
            visible: {
                type: Boolean,
                required: true
            },    
            
            promocode: {
                type: Object,
                required: true
            } 
        },
        
        computed: {
            hasError: function() {
                return this.promocode.error !== '';
            },
            
            canApply: function() {
                return ! this.promocode.active && this.promocode.value !== '';
            }
        },
        
        data: function() {
            return {
                isShow: false
            };
        },
        
        methods: {
            show: function(){
                this.isShow = true;
            },
            
            apply(autoMode) {
                if (this.promocode.active || ! this.validate()) {
                    return false;
                }
                
                autoMode = autoMode || false;
                
                ks.client.request({
                    controller: 'payment',
                    action: 'promocode/apply',
                    data: {
                        promocode: this.promocode.value
                    },
                    onRequest: this.onApply
                });
                
                if (autoMode === false) {
                    ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_APPLY_PROMOCODE);
                }                
            },
            
            onApply: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.promocode.error = 'promocode' in data.errors ? data.errors.promocode : data.errors.global;
                } else {
                    this.promocode.discountMode = data.discountMode;

                    this.promocode.discount = data.discount;
                    this.promocode.timeLeft = data.timeLeft;
                    this.promocode.periods  = data.periods;
                    this.promocode.active   = true;
                    
                    try {
                        if (data.periods.length === 1 && document.documentElement.clientWidth <= 767 /* screen-xs-max */) {
                            const periodElement = document.getElementById('paymentPeriod' + data.periods[0].id);
                            if (periodElement) {
                                window.scrollBy({
                                    top: periodElement.getBoundingClientRect().top - 10,
                                    behavior: 'smooth'
                                });
                            }
                        }
                    } catch (e) {}
                }                
            },            
            
            clear() {
                this.promocode.discountMode = -1;
                
                this.promocode.value = '';
                this.promocode.active = false;
                this.promocode.discount = 0;
                this.promocode.timeLeft = '';
                
                this.isShow = false;                
            },
            
            validate: function() {
                if (this.promocode.value === '') {
                    this.promocode.error = 'Пожалуйста, введите промокод.';
                    return false;
                }

                if (this.promocode.value.length < 3 || this.promocode.value.length > 16) {
                    this.promocode.error = 'Неправильный промокод.';
                    return false;
                }

                this.promocode.error = '';

                return true;
            }
        },
        
        watch: {
            'promocode.value': function(newValue) {
                if (newValue !== '') {
                    this.promocode.error = '';
                }
            }
        }
    });
    
}());   
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 12.06.2023
 */

(function() {
    
    Vue.component('payment-wheel-fortune', {
        
        template:  
            `<div v-if="wheelFortune.active" class="text-center">
                <div class="page-row-title-green">
                    <img v-if="hasIcon" :src="wheelFortune.icon" />
                    <a class="btn btn-round btn-red" href="#" @click.prevent="show">Получить скидку</a>
                    <div v-if="hasExpired" class="red"><b>{{ wheelFortune.name }} - только до {{ wheelFortune.expired}}</b></div>
                </div>   
            </div>`,
    
        props: {
            wheelFortune: {
                type: Object,
                required: true
            }
        },
        
        computed: {
            hasIcon: function() {
                return this.wheelFortune.icon !== '';
            },
            
            hasExpired: function() {
                return this.wheelFortune.expired !== '';
            }
        },
        
        data: function() {
            return {};
        },
        
        methods: {
            show() {
                this.$emit('show');
            }
        }
    });
    
}());   
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 03.11.2021
 *
 * 04.01.2022:
 * + Can Download Unlogged (cdu)
 */

(function() {

    var BlogPost = {

        props: {
            /**
             * Can Download Unlogged
             */
            cdu: {
              type: Number,
              default: 0
            },
        },

        data: function() {
            return {};
        },

        methods: {
            showLogin: function() {
                ks.app.showLogin(ks.app.$refs.headerLoginForm.email.value, '', null, true, 'dialog');
            },

            download: function(url){
                ks.client.request({
                    controller: 'blog',
                    action: 'download',
                    data: {
                        url: url
                    },
                    onRequest: this.onRequestDownload
                });
            },

            onRequestDownload: function(errorCode, data){
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type     : ks.consts.MBT_ERROR,
                        title    : 'Внимание',
                        text     : data.errors.global,
                        buttons  : ks.consts.MBB_OK
                    });
                    return;
                }

                //window.open(data.url);

                let a = window.document.createElement('a');
                a.setAttribute('href', data.url);
                a.setAttribute('target', '_blank');

                //a.click();

                let e = window.document.createEvent('MouseEvents');
                e.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                a.dispatchEvent(e);
            },

            processURLs: function(){
                let items = document.querySelectorAll('a[data-download-file]');

                for (let i = 0; i < items.length; i++) {
                    let a = items[i],
                        url = a.getAttribute('data-download-file');

                    a.removeAttribute('data-download-file');

                    ks.client.request({
                        controller: 'blog',
                        action: 'download',
                        data: {
                            version: 2,
                            url: url,
                            cdu: this.cdu,
                        },
                        onRequest: this.OnGetDownloadURL,
                        userData: a
                    });
                }
            },

            OnGetDownloadURL: function(errorCode, data, a){
                if (errorCode !== ks.consts.ERR_OK) {
                    return;
                }

                a.setAttribute('href', data.url);
            },

            showSignup: function(options){
                ks.app.showSignup(options);
            },

            commentReply: function(parentCommentId, replyParentId, replyParentName, replyCommentId) {
                let writeComment = this.$refs[this.getWriteCommentRef(parentCommentId)];

                writeComment.focus();
                writeComment.reply(replyParentId, replyParentName, replyCommentId);
            },

            getWriteCommentRef: function(parentCommentId) {
                return 'blogWriteComment' + parentCommentId;
            },

            getCommentHtmlId: function(commentId) {
                return 'blogComment' + commentId;
            },

            commentView: function(commentId) {
                if (document.activeElement !== null && document.activeElement instanceof HTMLElement) {
                    document.activeElement.blur();
                }

                let comment = document.getElementById(this.getCommentHtmlId(commentId));

                if (comment === null) {
                    return;
                }

                comment.scrollIntoView({block: 'center', behavior: 'smooth'});
            },

            getCommentRatingRef: function(commentId) {
                return 'blogCommentRating' + commentId;
            },

            commentRating: function(commentId){
                ks.client.request({
                    controller: 'postComments',
                    action: 'rating',
                    data: {
                        commentId: commentId
                    },
                    onRequest: this.onCommentRating,
                    userData: commentId
                }, true);
            },

            onCommentRating: function(errorCode, data, commentId){
                let commentRating = this.$refs[this.getCommentRatingRef(commentId)];

                commentRating.setLoading(false);

                if (errorCode !== ks.consts.ERR_OK) {
                    return;
                }

                commentRating.setRating(data.rating);
            },

            navigateHashComment: function(){
                let commentId;

                try {
                    commentId = parseInt(window.location.hash.substring(2), 10);
                } catch (err) {
                    commentId = -1;
                }

                if (commentId < 0) {
                    return;
                }

                let comment = document.getElementById('blogComment' + commentId);
                if (comment === null) {
                    return;
                }

                this.$nextTick(function(){
                    comment.scrollIntoView({block: 'center'/*, behavior: 'smooth'*/});
                });
            },

            scrollTo: function(id, block){
                let element = document.getElementById(id);

                if (element === null) {
                    return;
                }

                element.scrollIntoView({
                    block: typeof block === 'undefined' ? 'center' : block,
                    behavior: 'smooth'
                });
            }
        },

        created: function(){
            let self = this;
            ks.core.addAppCreateEvent(function(){
                self.processURLs();
            });
        },

        mounted: function(){
            this.navigateHashComment();
        }

    };

    ks.core.addComponent('blog-post', BlogPost);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 26.02.2018
 * 
 * 25.03.2021:
 * Полностью переписан код, добавлена поддержка смартов и планшетов
 */

(function() {

    Vue.component('exercise-answers-info', {
        
        template: 
            '<div v-if="loaded" class="answers-info-panel">'+
            '    <div class="answers-info-panel__box-mobile text-center hidden-lg hidden-md" @click="showInfo">'+
            '        <span class="answers-info-panel__box-mobile__icon green"><i class="fa fa-check" aria-hidden="true"></i></span>'+
            '        <span class="answers-info-panel__box-mobile__count green">{{ countCorrectAnswers }}</span>'+
            '        <span class="answers-info-panel__box-mobile__divider"></span>'+
            '        <span class="answers-info-panel__box-mobile__icon red"><i class="fa fa-times" aria-hidden="true"></i></span>'+
            '        <span class="answers-info-panel__box-mobile__count red">{{ countIncorrectAnswers }}</span>'+
            '    </div>'+
            '    <div class="answers-info-panel__title text-center hidden-xs hidden-sm">Ответы</div>'+
            '    <div class="answers-info-panel__box text-center hidden-xs hidden-sm">'+
            '        <div class="answers-info-panel__box__line row row-flex">'+
            '            <div class="answers-info-panel__box__line__icon col-xs-6 green"><i class="fa fa-check" aria-hidden="true"></i></div>'+
            '            <div class="answers-info-panel__box__line__count col-xs-6 green"><div>{{ countCorrectAnswers }}</div></div>'+
            '        </div>'+
            '        <div class="answers-info-panel__box__line row row-flex">'+
            '            <div class="answers-info-panel__box__line__icon col-xs-6 red"><i class="fa fa-times" aria-hidden="true"></i></div>'+
            '            <div class="answers-info-panel__box__line__count col-xs-6 red"><div>{{ countIncorrectAnswers }}</div></div>'+
            '        </div>'+
            '    </div>'+
            '</div>',
        
        data: function () {
            return {
                loaded: false
            };
        },
        
        computed: {
            countCorrectAnswers: function() {
                var exercises = this.$store.state.current.history.exercises,
                    count = 0;
                
                if (this.loaded) {
                    for (var i = 0; i < exercises.length; i++) {
                        if (exercises[i].isFinished && exercises[i].isCorrectAnswer) {
                            count++;
                        }
                    }
                }
                
                return count;
            },
            
            countIncorrectAnswers: function() {
                var exercises = this.$store.state.current.history.exercises,
                    count = 0;
                
                if (this.loaded) {
                    for (var i = 0; i < exercises.length; i++) {
                        if (exercises[i].isFinished && ! exercises[i].isCorrectAnswer) {
                            count++;
                        }
                    }
                }
                
                return count;
            }            
        },
        
        methods: {
            showInfo: function() {
                ks.app.$refs.messageBox.show({
                    type    : ks.consts.MBT_INFO,
                    title   : 'Ответы',
                    text    : 'Правильные и неправильные ответы.',
                    buttons : ks.consts.MBB_CLOSE
                });                
            }            
        },
        
        mounted: function() {
            this.loaded = true;
        }
        
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 06.04.2018
 */

(function() {

    Vue.component('exercise-audio', {
        
        template: 
            '<div v-show="active" class="text-center" style="display: none;">' +
            '  <button type="button" class="btn btn-glass" :class="getButtonClass" @click="click" :disabled="disabled"><i class="fa" :class="getIconClass"></i> {{ getButtonTitle }}</button>' +
            '</div>',

        props: {
            displayInline: {
                type: Boolean,
                default: false
            }
        },

        data: function() {
            return {
                loaded: false,
                disabled: false
            };
        },
        
        computed: {
            style: function() {
                var style = {};
                
                if (this.displayInline) {
                    style.display = 'inline-block';
                }
                
                return style;
            },
            
            exercise: function() {
                return this.$store.state.current.exercise;
            },
            
            active: function() {
                if (this.exercise === null || ! this.$store.state.settings.voiceEnabled) {
                    return false;
                }
                
                if (this.$store.state.current.hasAnswer) {
                    return false;
                }
                
                if (this.$store.getters.isGuest) {
                    if ( ! this.$store.state.guest.voiceEnabled) {
                        return false;
                    }
                } else {
                    if ( ! this.$store.state.parent.options.sound_voice) {
                        return false;
                    }
                }
                
                if (typeof this.exercise.extra !== 'undefined' && this.exercise.extra.enabled) {
                    var active = false;
                    
                    switch (this.exercise.currentPage) {
                        case ks.consts.EXERCISE_PAGE_ENTRY:
                            active = this.exercise.audio !== '';
                            break;
                            
                        case ks.consts.EXERCISE_PAGE_MAIN:
                            active = this.exercise.extra.audio !== '';
                            break;
                    }
                    
                    return active;
                } else {
                    return this.exercise.audio !== '';
                }
            },
            
            playing: function(){
                return this.exercise !== null ? this.exercise.currentAudioPlaying !== null : false;
            },
            
            exerciseAnswered: function() {
                return this.exercise !== null ? this.exercise.answered : false;
            },
            
            getIconClass: function() {
                return {
                    'fa-play': ! this.playing,
                    'fa-stop': this.playing
                };
            },
            
            getButtonClass: function() {
                return {
                    'btn-glass-green': ! this.playing,
                    'btn-glass-crimson': this.playing
                };
            },
            
            getButtonTitle: function() {
                return this.playing ? 'Остановить' : 'Озвучить';
            }
        },
        
        methods: {
            click: function() {
                this.disabled = true;
                
                this.$emit(this.playing ? 'stop': 'play');
            }
        },
        
        watch: {
            playing: function(newValue) {
                if ( ! this.exerciseAnswered) {
                    this.disabled = false;
                }
            },
            
            exerciseAnswered: function(newValue) {
                if (newValue === true) {
                    this.disabled = true;
                }
            }
        },

        mounted: function() {
            this.loaded = true;
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 15.10.2019
 */

(function() {

    Vue.component('exercise-audio-button', {

        template: '<div v-if="visible" class="exercise-audio-button">' +
                  '  <div class="exercise-audio-button-status">Вкл/выкл озвучку: <i title="Включить или выключить озвучивание заданий." data-toggle="tooltip" data-placement="top" class="hidden-xs hidden-sm fa help-popover ks-tooltip fa-question-circle"></i></div>' +
                  '  <div class="exercise-audio-button-icon-box"><a class="exercise-audio-button-icon" :class="iconClass" href="#" @click.prevent="onClick"><i class="fa fa-volume-up"></i></a></div>' +
                  '</div>',

        computed: {
            exerciseLoaded: function() {
                return this.$store.state.current.exercise !== null;
            },
            
            visible: function() {
                return this.exerciseLoaded && this.$store.state.settings.voiceEnabled && 
                        ! this.$store.state.current.isDayLimitExceeded &&
                        ! this.$store.state.current.hasAnswer;
            },
            
            voiceEnabled: function() {
                return this.$store.getters.isGuest ? this.$store.state.guest.voiceEnabled : this.$store.state.parent.options.sound_voice;
            },
            
            iconClass: function() {
                return {
                    active: this.voiceEnabled,
                    notactive: ! this.voiceEnabled
                };
            }
            
        },
            
        data: function() {
            return {
               
            };
        },
        
        methods: {
            onClick: function(){
                var voiceEnabled = ! this.voiceEnabled;
                
                if ( ! this.$store.getters.isGuest) {
                    ks.client.request({
                        controller: 'kid',
                        action: 'voice/update',
                        data: {
                            sound_voice: voiceEnabled
                        },
                        userData: {
                            voiceEnabled: voiceEnabled
                        },
                        onRequest: this.onUpdate
                    });                
                } else {
                    this.$store.commit('guest/setVoiceEnabled', voiceEnabled); 
                    
                    this.$emit('toggle');
                }
            },
            
            onUpdate: function(errorCode, data, userData) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);

                    return;
                }

                this.$store.commit('parent/setOptions', { sound_voice: userData.voiceEnabled });   
                
                this.$emit('toggle');
            }
        }
        
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 24.03.2021
 *
 * 17.12.2024:
 * Добавлен параметр playForce в playVoice и play.
 * Если параметр установлен в true, то звук будет воспроизодиться даже при voice_enabled=false
 */

(function() {

    Vue.component('exercise-audio-contoller', {

        template:
            '<div v-show="visible" style="display: none;" class="exercise-audio-contoller">'+
            '    <div class="exercise-audio-contoller__box" :class="boxClass">'+
            '        <a class="exercise-audio-contoller__button exercise-audio-contoller__toggle" :class="toggleClass" href="#" @click.prevent="onToggleVoice" :disabled="disabled">'+
            '            <div>'+
            '                <i class="fa exercise-audio-contoller__toggle__volume" :class="toggleIconClass"></i>'+
            '                <i v-show=" ! voiceEnabled" style="display: none;" class="fa fa-times exercise-audio-contoller__toggle__cross"></i>'+
            '            </div>'+
            '        </a>'+
            '        <a v-show="voiceEnabled" style="display: none;" class="exercise-audio-contoller__button exercise-audio-contoller__action" :class="actionClass" @click.prevent="onActionClick" :disabled="disabledAction">'+
            '            <div>'+
            '                <i class="fa" :class="actionIconClass"></i>'+
            '            </div>'+
            '        </a>'+
            '    </div>'+
            '</div>',

        props: {

        },

        data: function() {
            return {
                loaded: false,
                disableActionButton: false
            };
        },

        computed: {
            exercise: function() {
                return this.$store.state.current.exercise;
            },

            exerciseLoaded: function() {
                return this.exercise !== null;
            },

            visible: function() {
                return this.loaded &&
                       this.$store.state.settings.voiceEnabled &&
                       ! this.$store.state.current.isDayLimitExceeded;
            },

            disabled: function() {
                return ! this.exerciseLoaded || this.$store.state.current.hasAnswer;
            },

            disabledAction: function() {
                return this.disabled || this.disableActionButton || ! this.voiceEnabled || ! this.exerciseHasAudio;
            },

            exerciseHasAudio: function() {
                if (typeof this.exercise.extra !== 'undefined' && this.exercise.extra.enabled) {
                    var hasAudio = false;

                    switch (this.exercise.currentPage) {
                        case ks.consts.EXERCISE_PAGE_ENTRY:
                            hasAudio = this.exercise.audio !== '';
                            break;

                        case ks.consts.EXERCISE_PAGE_MAIN:
                            hasAudio = this.exercise.extra.audio !== '';
                            break;
                    }

                    return hasAudio;
                } else {
                    return this.exercise.audio !== '';
                }
            },

            voiceEnabled: function() {
                return this.$store.getters.isGuest ? this.$store.state.guest.voiceEnabled : this.$store.state.parent.options.sound_voice;
            },

            exerciseAnswered: function() {
                return this.exercise !== null ? this.exercise.answered : false;
            },

            playing: function(){
                return this.exercise !== null ? this.exercise.currentAudioPlaying !== null : false;
            },

            toggleClass: function() {
                return {
                    'voice-enabled': this.voiceEnabled,
                    'voice-disabled': ! this.voiceEnabled,
                    disabled: this.disabled
                };
            },

            toggleIconClass: function() {
                return {
                    'fa-volume-off': ! this.voiceEnabled,
                    'fa-volume-up ': this.voiceEnabled
                };
            },

            actionClass: function() {
                return {
                    'play': ! this.playing,
                    'stop': this.playing,
                    'disabled': this.disabledAction
                };
            },

            actionIconClass: function() {
                return {
                    'fa-play': ! this.playing,
                    'fa-stop': this.playing
                };
            },

            actionHint: function() {
                return this.playing ? 'Остановить' : 'Озвучить';
            },

            boxClass: function() {
                return {
                    open: this.voiceEnabled,
                    disabled: this.disabled
                };
            }
        },

        methods: {
            onToggleVoice: function(){
                var voiceEnabled = ! this.voiceEnabled;

                if ( ! this.$store.getters.isGuest) {
                    ks.client.request({
                        controller: 'kid',
                        action: 'voice/update',
                        data: {
                            sound_voice: voiceEnabled
                        },
                        userData: {
                            voiceEnabled: voiceEnabled
                        },
                        onRequest: this.onUpdateVoiceEnabled
                    });
                } else {
                    this.$store.commit('guest/setVoiceEnabled', voiceEnabled);

                    this.$emit('toggle');
                }
            },

            onUpdateVoiceEnabled: function(errorCode, data, userData) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);

                    return;
                }

                this.$store.commit('parent/setOptions', { sound_voice: userData.voiceEnabled });

                this.$emit('toggle');
            },

            onActionClick: function() {
                this.disableActionButton = true;

                this.$emit(this.playing ? 'stop': 'play');
            }

        },

        watch: {
            playing: function(newValue) {
                if ( ! this.exerciseAnswered) {
                    this.disableActionButton = false;
                }
            },

            exerciseAnswered: function(newValue) {
                if (newValue === true) {
                    this.disableActionButton = true;
                }
            }
        },

        mounted: function() {
            this.loaded = true;
        }
    });

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 01.02.2018
 * 
 * 25.06.2021:
 * +classAvailableValue
 * 
 * 14.11.2023:
 * +isTrainingAdMode
 * 
 * 27.11.2023:
 * Убрали показ для гостя
 */

(function() {

    Vue.component('exercise-available', {

        props: {

        },
        
        computed: {
            isShow: function() {
                return this.$store.getters.isKid && ! this.$store.getters['kid/hasActiveSubscription'];
            },
            
            getDayLimit: function() {
                return this.$store.getters.getExercisesDayLimit;
            },
            
            getAvailable: function() {
                return this.$store.getters.getAvailableExercises;
            },
            
            promocode: function() {
                return this.$store.state.promocode.active ? this.$store.state.promocode : null;             
            },
            
            classAvailableValue: function(){
                return {
                    'exercise-available-value__zero': ! this.hasAvailableExersises
                };
            },
            
            hasAvailableExersises: function(){
                return this.getAvailable > 0 || this.isTrainingAdMode;
            },
            
            isTrainingTrialMode: function(){
                if ( ! this.$store.getters.isKid) {
                    return false;
                }
                
                return this.$store.state.current.mode === ks.consts.EXERCISE_MODE_TRAINING &&
                       this.$store.state.current.training !== null &&
                       this.$store.state.current.training.type === ks.consts.TRAINING_TYPE_TRIAL;
            },
            
            isTrainingAdMode: function(){
                if ( ! this.$store.getters.isGuest) {
                    return false;
                }
                
                return this.$store.state.current.mode === ks.consts.EXERCISE_MODE_TRAINING &&
                       this.$store.state.current.training !== null &&
                       this.$store.state.current.training.type === ks.consts.TRAINING_TYPE_AD;
            }            
        },

        data: function() {
            return {
                loaded: false
            };
        },
        
        methods: {
            showSignup: function(options){
                ks.app.showSignup(options);
            }
        },

        mounted: function() {
            this.loaded = true;
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 19.12.2017
 */

(function() {

    Vue.component('exercise-correct-answer', {

        template: '<div ref="box" class="correct-answer-box text-center" v-show="visible">' +
                  '  <div class="correct-answer-box-text" v-show="isTextShow"><div>{{text}}</div></div>' +
                  '  <div class="correct-answer-animation-box text-center">'+
                  '     <img :src="imageSrc" />'+
                  '  </div>' +
                  '  <div v-show="autoStartEnabled" class="correct-answer-auto-start" :class="autoStartBoxClass">'+
                  '    <div class="correct-answer-auto-start__progress" :class="autoStartClass" :style="autoStartStyle"></div>' +
                  '  </div>'+
                  '  <div class="text-center">' +
                  '     <button ref="btnNext" type="button" @click="onNext" class="btn btn-green exercise-item-btn-next">Продолжить</button>'+
                  '  </div>' +
                  '</div>',
          
        props: {
            autoStartEnabled: {
                type: Boolean,
                default: false
            },
            
            /**
             * Seconds
             */
            autoStartInterval: {
                type: Number,
                default: 0
            }
        },

        data: function() {
            return {
                visible: false,
                
                imageIndex: 0,
                
                text: '',
                
                animationName: 'win',
                
                animationBox: {
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                },
                
                animationShow: false,
                
                autoStart: {
                    timer: null,
                    colorScheme: null,
                    showProgress: false
                }
            };
        },
        
        computed: {
            isTextShow: function() {
                return this.text !== '';
            },
            
            imageSrc: function() {
                return '/public/images/win/' + this.imageIndex + '.png';
            },
            
            autoStartBoxClass: function(){
                let cls = {};
                
                cls['color-scheme-' + this.autoStart.colorScheme] = true;
                
                return cls;
            },
            
            autoStartClass: function(){
                let cls = {
                    'shown': this.autoStartEnabled && this.visible && this.autoStart.showProgress
                };
                
                cls['color-scheme-' + this.autoStart.colorScheme] = true;
                
                return cls;
            },
            
            autoStartStyle: function(){
                return {
                    'transition': 'width ' + this.autoStartInterval + 's'
                };
            },
            
            hasVisibileDialogs: function(){
                return this.$store.getters['window/hasVisibileDialogs'];
            }
        },
        
        methods: {
            show: function(text) {
                this.resetAutoStart();
                
                this.text = text || '';
                this.visible = true;
                
                let self = this;
                this.$nextTick(function() {
                    self.onWindowResize();
                    self.animationShow = true;
                    ks.particleAnimations.start(self.animationName, self.animationBox, {
                        type: 'symbol',
                        symbols: ks.particleManager.symbols[Math.floor(Math.random() * ks.particleManager.symbols.length)],
                        amount: 20,
                        duration: (Math.random() + 2) * 1000
                    }, 20, (Math.random() + 1) * 1000, function() {
                        self.animationShow = false;
                    });
                    
                    // 19.08.2021: Автоматическое старт следующего упражнения
                    // Нужно запускать с задержкой, т.к. на мобильных анимация не срабатывает
                    // Если показан какой-нибудь диалог, то подождем пока пользователь закроет диалог
                    if ( ! self.hasVisibileDialogs) {
                        setTimeout(function(){
                            //self.$nextTick(function(){
                                self.processAutoStart();
                            //});
                        }, 100);
                    }
                    //--
                    
                    // 14.11.2023
                    try {
                        self.$refs.btnNext.focus();
                    } catch (e) {}
                    //--
                });
            },
            
            hide: function() {
                this.resetAutoStart();
                
                if (this.animationShow) {
                    ks.particleAnimations.stop(this.animationName);
                }
                
                this.visible = false;
                this.text = '';
                
                var self = this;
                this.$nextTick(function() {
                    self.randomIndex();                    
                });
            },
            
            onNext: function() {
                this.hide();
                
                this.$emit('next');
            },
            
            randomIndex: function() {
                var index = -1;
                do {
                    index = ks.helpers.math.getRandomInt(0, 8);
                } while (index === this.imageIndex);
                
                this.imageIndex = index;
            },
            
            onWindowResize: function() {
                let isMobile = ks.browser.isTouch(),
                    boxRect = isMobile ? null : ks.helpers.html.getElemRect(this.$refs.box);  
            
                this.animationBox.left = isMobile ? 0 : boxRect.left;
                this.animationBox.top = isMobile ? 0 : boxRect.top;
                this.animationBox.right = isMobile ? window.innerWidth : boxRect.right;
                this.animationBox.bottom = isMobile ? window.innerHeight : boxRect.bottom;
            },
            
            resetAutoStart: function(){
                if (this.autoStart.timer !== null) {
                    clearTimeout(this.autoStart.timer);
                    this.autoStart.timer = null;
                }
                
                let colorSchemeIndex = ks.helpers.math.getRandomInt(0, ksGlobal.ColorSchemes.length - 1);
                this.autoStart.colorScheme = ksGlobal.ColorSchemes[colorSchemeIndex];
                
                this.autoStart.showProgress = false;
            },
            
            processAutoStart: function(){
                if ( ! this.autoStartEnabled) {
                    return; 
                }
                
                this.autoStart.showProgress = true;

                let self = this;
                this.autoStart.timer = setTimeout(function(){
                    self.autoStart.timer = null;
                    self.onNext();
                }, self.autoStartInterval * 1000);
            }
        },
        
        watch: {
            animationBox: function(newAnimationBox) {
                if (this.animationShow) {
                    ks.particleAnimations.changeRectangle(this.animationName, newAnimationBox);
                }
            },
            
            hasVisibileDialogs: function(newValue){
                // Если пользователь закрыл диалог, то запускаем автоматический старт нового упражнения
                if (newValue || ! this.visible || this.autoStart.timer !== null) {
                    return;
                }
                
                this.processAutoStart();
            }
        },
        
        created: function() {
            window.addEventListener('resize', this.onWindowResize);
        },
        
        destroyed: function() {
            window.removeEventListener('resize', this.onWindowResize);
        },        
        
        mounted: function() {
            this.onWindowResize();
        }
        
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 25.11.2017
 */

(function() {
    const DAY_LIMIT_EXCEEDED_SUBJECT         = 'dLtEdSt';
    const DAY_LIMIT_EXCEEDED_SUBJECT_CHANGED = 'dLtEdStCd';

    Vue.component('exercise-engine', {

        props: {
            mode: {
                type: Number,
                required: true
            }
        },

        data: function() {
            return {
                loaded: false,

                prevExerciseId: -1,

                eventOnCheckAnswer: null,

                exerciseSound: null,

                answerSoundName: null
            };
        },

        computed: {
            exercise: function() {
                return this.$store.state.current.exercise;
            },

            exerciseId: function(){
                return this.exercise !== null ? this.exercise.id : -1;
            },

            trainingMode: function() {
                return this.mode === ks.consts.EXERCISE_MODE_TRAINING;
            },

            subjectStageMode: function() {
                return this.mode === ks.consts.EXERCISE_MODE_SUBJECT_STAGE;
            },

            audioActive: function() {
                if (this.exercise === null || ! this.$store.state.settings.voiceEnabled) {
                    return false;
                }

                if (typeof this.exercise.extra !== 'undefined' && this.exercise.extra.enabled) {
                    var active = false;

                    switch (this.exercise.currentPage) {
                        case ks.consts.EXERCISE_PAGE_ENTRY:
                            active = this.exercise.audio !== '';
                            break;

                        case ks.consts.EXERCISE_PAGE_MAIN:
                            active = this.exercise.extra.audio !== '';
                            break;
                    }

                    return active;
                } else {
                    return this.exercise.audio !== '';
                }
            },

            audioPlaying: function() {
                return this.exercise !== null ? this.exercise.currentAudioPlaying !== null : false;
            },

            currentAudio: function() {
                if (typeof this.exercise.extra !== 'undefined' && this.exercise.extra.enabled) {
                    return this.exercise.currentPage === ks.consts.EXERCISE_PAGE_ENTRY ?
                        this.exercise.audio :
                        this.exercise.extra.audio;
                } else {
                    return this.exercise.audio;
                }
            },

          titleClass() {
            return {
              'hidden': this.$store.getters.isGuest && this.$store.getters.getAvailableExercises <= 0
            };
          }
        },

        methods: {
            getExerciseRef: function() {
                return 'exercise' + this.exercise.type;
            },

            getExercise: function() {
                return this.$refs[this.getExerciseRef()];
            },

            unloadExercise: function() {
                if (this.exercise !== null) {
                    if (this.audioActive) {
                        this.stopAudio();

                        ks.soundManager.removeItem(this.exercise.audio);
                    }

                    var exercise = this.getExercise();
                    if (exercise.loaded) {
                        this.getExercise().unload();
                    }

                    this.prevExerciseId = this.exercise.id;

                    this.$store.commit('current/exercise', null);

                }
            },

            loadExercise: function() {
                var data = {
                    mode: this.$store.state.current.mode,

                    groupId: this.$parent.groupId,
                    subjectId: this.$parent.subjectId,

                    prevExerciseId: this.prevExerciseId
                };

                switch (this.mode) {
                    case ks.consts.EXERCISE_MODE_SUBJECT_STAGE:
                        if (this.$store.getters.isKid) {
                            // Если мы только начали этап упражнений, то попробуем
                            // получить данные по этапу
                            if (this.$store.state.current.subjectStage.completedCountExercises === 0) {
                                data.loadSubjectStageState = true;
                            }
                        }
                        break;

                    case ks.consts.EXERCISE_MODE_TRAINING:
                        data.trainingId = this.$store.state.current.training.id;
                        // 13.11.2023
                        data.trainingType = this.$store.state.current.training.type;
                        // --

                        // 10.08.2021
                        //if (this.$store.state.current.training.type === ks.consts.TRAINING_TYPE_TRIAL) {
                        //    data.trainingTrial = true;
                        //}
                        break;
                }

                this.unloadExercise();

                this.$store.commit('current/setHasAnswer', false);

                ks.client.request({
                    controller: 'exercise',
                    action: 'get',
                    data: data,
                    onRequest: this.onLoadExercise
                });
            },

            onLoadExercise: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    var type,
                        isDayLimitExceeded = false;

                    switch (errorCode) {
                        case ks.consts.ERR_EXERCISE_NOT_FOUND:
                            type = ks.consts.ALERT_INFO;
                            break;

                        case ks.consts.ERR_EXERCISE_DAY_LIMIT_EXCEEDED:
                            isDayLimitExceeded = true;
                            this.$store.commit('current/setIsDayLimitExceeded', true);
                            this.$store.commit('setAvailableExercises', 0);

                            // 11.08.2021
                            this.processDayLimitExceeded();
                            //--

                            break;

                        default:
                            type = ks.consts.ALERT_ERROR;
                            break;
                    }

                    if ( ! isDayLimitExceeded) {
                        this.$refs.alert.show(data.errors.global, type);
                    } else {
                        this.$refs.dayLimitExceeded.show();
                    }

                    return;
                }

                data.exercise.answered = false;
                data.exercise.currentAudioPlaying = null;
                data.exercise.currentPage = -1;

                // Сохраним данные о текущем упражнении в глобальном сторе
                this.$store.commit('current/exercise', data.exercise);

                // Если мы под аккаунтом ребёнка, в режиме этапа упражнений и
                // пришли данные по этапу, то применим их
                if (this.$store.getters.isKid && this.subjectStageMode && typeof data.subjectStageState !== 'undefined') {
                    this.applySubjectStageState(data.subjectStageState);
                }

                // Оповестим компонент-родителя о том, что упражнение загружено
                this.$emit('exercise-loaded', this.exercise);

                // Загрузка текущего упражнения в соответсвующий компонент
                this.getExercise().load(this.exercise);

                // Обновляем кол-во доступных упражнений
                if (typeof data.exerciseAvailable !== 'undefined') {
                    this.$store.commit('setAvailableExercises', data.exerciseAvailable);
                }

                this.profiler.start();
            },

            // 11.08.2021
            // Обработка показа предложения пробной тренировки
            processDayLimitExceeded: function(){
                // Если мы в режиме пробной тренировки, то не выходим
                if (this.mode === ks.consts.EXERCISE_MODE_TRAINING && this.$store.state.current.training.type === ks.consts.TRAINING_TYPE_TRIAL) {
                    return;
                }
                //--

                let subjectId = ks.Storage.getItem(ks.consts.STORAGE_TYPE_SESSION, DAY_LIMIT_EXCEEDED_SUBJECT, false, false),
                    subjectChanged = ks.Storage.getItem(ks.consts.STORAGE_TYPE_SESSION, DAY_LIMIT_EXCEEDED_SUBJECT_CHANGED, false, false);

                // Если упражнения еще не заканчивались сохраним id предмета
                if (subjectId !== null) {
                    // Если упражнения уже заканчивались и предмет уже "не переключали" на другой, то покажем предложение пробной тренировки
                    if (subjectChanged !== null && parseInt(subjectChanged, 10) === 1) {
                        ks.app.showOfferTrialTraining();
                    } else {
                        // Проверим "переключали" ли предмет
                        if (parseInt(subjectId, 10) !== this.$parent.subjectId) {
                            ks.Storage.setItem(ks.consts.STORAGE_TYPE_SESSION, DAY_LIMIT_EXCEEDED_SUBJECT_CHANGED, 1, false);
                            ks.app.showOfferTrialTraining();
                        }
                    }
                } else {
                    ks.Storage.setItem(ks.consts.STORAGE_TYPE_SESSION, DAY_LIMIT_EXCEEDED_SUBJECT, this.$parent.subjectId, false);
                }
            },

            playAudio: function() {
                if ( ! this.audioActive) {
                    return;
                }

                this.exerciseSound.stop();
                this.stopAudio();

                ks.soundManager.playVoice(this.currentAudio, {
                    onPlay: this.onPlayAudio,
                    onStop: this.onStopAudio,
                    onEnd: this.onEndAudio
                });
            },

            onPlayAudio: function(soundItem) {
                this.$store.commit('current/setExerciseAudioPlaying', soundItem.name);
            },

            onStopAudio: function(soundItem) {
                this.$store.commit('current/setExerciseAudioPlaying', null);
            },

            onEndAudio: function(soundItem) {
                this.$store.commit('current/setExerciseAudioPlaying', null);
            },

            stopAudio: function() {
                ks.soundManager.stop(this.answerSoundName);

                if ( ! this.audioPlaying) {
                    return;
                }

                ks.soundManager.stop(this.exercise.currentAudioPlaying);
            },

            pauseAudio: function() {
                if ( ! this.audioActive) {
                    return;
                }

                ks.soundManager.pause(this.currentAudio);
            },

            exercisePlayAudio: function(sound) {
                this.stopAudio();
                this.exerciseSound.play(sound);
            },

            onToggleAudioButton: function() {
                if (this.audioActive) {
                    this.playAudio();
                } else {
                    this.stopAudio();
                    this.exerciseSound.stop();
                }
            },

            applySubjectStageState: function(subjectStageState) {
                if (this.$store.state.current.subjectStage.countExercises <= subjectStageState.completedCountExercises) {
                    return;
                }

                var historyExercises = typeof subjectStageState.historyExercises !== 'undefined' ? subjectStageState.historyExercises : [];

                if (historyExercises.length > 0) {
                    this.$store.commit('current/setHistoryExercises', historyExercises);
                }

                this.$store.commit('current/subjectStage', {
                    completedCountExercises: subjectStageState.completedCountExercises
                });
            },

            onNextExercise: function() {
                // Проверим если предыдущее задание было последним из доступных, то обновим(обнулим) счетчик
                if (this.$store.getters.isGuest || (this.$store.getters.isKid && ! this.$store.getters['kid/hasActiveSubscription'])) {
                    if (this.$store.getters.getAvailableExercises === 1) {
                        this.$store.commit('setAvailableExercises', 0);
                    }
                }

                switch (this.mode) {
                    case ks.consts.EXERCISE_MODE_SUBJECT_STAGE:
                        // Проверим - может быть упражнения в этапе закончились
                        if (this.$store.getters['current/isLastExerciseSubjectStage']) {
                            this.unloadExercise();
                            this.$refs.finishStage.show();
                        }
                        else {
                            this.loadExercise();
                        }
                        break;

                    case ks.consts.EXERCISE_MODE_TRAINING:
                        this.unloadExercise();
                        this.$parent.nextExercise();
                        break;
                }
            },

            onAnswer: function(isCorrect, message, playVoice) {
                // 27.11.2023
                if (this.$store.getters.isGuest && this.$store.getters['guest/getExerciseDay'] === 0) {
                    try {
                        ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_GUEST_COMPLETE_FIRST_EXERCISE);
                    } catch (exception) {}
                }
                //--

                this.$emit('answer', isCorrect);

                this.$store.commit('current/setHasAnswer', true);

                if (isCorrect) {
                    // Выгружаем данные упражнения из компонентов,
                    // будем показывать сообщение о правильном ответе;
                    // Выгружать this.exercise = null нельзя, т.к.
                    // нужно еще показывать параметры (например,
                    // уровень сложности) упражнения. Окончательная выгрузка
                    // произойдет в ф-ии unloadExercise.
                    this.getExercise().unload();

                    // Показываем сообщение о том, что ответ правильный
                    this.$refs.correctAnswer.show(message.text);
                }

                if (playVoice === true) {
                    ks.soundManager.playVoice(message.sound);
                }
            },

            showAlert: function(text, type) {
                this.$refs.alert.show(text, type);
            },

            sendAnswer: function(data, onCheckAnswer) {
                this.$store.commit('current/setExerciseAnswered', true);
                this.$store.commit('current/stopRecordHistoryExercise');

                this.stopAudio();

                this.eventOnCheckAnswer = onCheckAnswer;

                // Кол-во секунд, потраченных на выполнение задания
                data.time = this.profiler.stop().getTime();

                data.mode = this.$store.state.current.mode;

                data.groupId = this.$parent.groupId;
                data.subjectId = this.$parent.subjectId;

                switch (this.mode) {
                    case ks.consts.EXERCISE_MODE_TRAINING:
                        // 11.08.2021
                        data.trainingId = this.$store.state.current.training.id;
                        // 13.11.2023
                        data.trainingType = this.$store.state.current.training.type;
                        //--

                        var countExercises = this.$store.state.current.trainingState.countExercises + 1;
                        if (this.$store.getters['current/isLastExerciseTraining'](countExercises)) {
                            data.trainingFinished = true;
                        } else {
                            data.subjectIndex = this.$store.state.current.trainingState.subjectIndex;
                            data.countExercises = countExercises;
                        }

                        break;
                }

                var exerciseHistory;
                if (this.$store.getters.isKid) {
                    switch (this.mode) {
                        case ks.consts.EXERCISE_MODE_SUBJECT_STAGE:
                            var completedCountExercises = this.$store.state.current.subjectStage.completedCountExercises + 1;

                            // Если в режиме этапа упражнений по теме, то оправляем данные по текущему этапу на сервер
                            if (completedCountExercises >= this.$store.state.current.subjectStage.countExercises) {
                                data.subjectStageFinished = true;
                            } else {
                                data.completedCountExercises = completedCountExercises;
                            }

                            exerciseHistory = this.$store.getters['current/getLastHistoryExercise'];
                            data.exerciseHistory = {
                                groupId: exerciseHistory.groupId,
                                subjectId: exerciseHistory.subjectId,
                                startDate: exerciseHistory.startDate,
                                stopDate: exerciseHistory.stopDate
                            };
                            break;

                        case ks.consts.EXERCISE_MODE_TRAINING:
                            // Если в режиме тренировки, то оправляем данные по текущей тренировке на сервер
                            // или если это последнее задание в тренировке, то сообщаем об этом серверу

                            // 14.11.2023: Перенес этот код выше
                            /*var countExercises = this.$store.state.current.trainingState.countExercises + 1;

                            if (this.$store.getters['current/isLastExerciseTraining'](countExercises)) {
                                data.trainingFinished = true;
                            } else {
                                data.subjectIndex = this.$store.state.current.trainingState.subjectIndex;
                                data.countExercises = countExercises;
                            }*/

                            exerciseHistory = this.$store.getters['current/getLastHistoryExercise'];
                            data.exerciseHistory = {
                                groupId: exerciseHistory.groupId,
                                subjectId: exerciseHistory.subjectId,
                                startDate: exerciseHistory.startDate,
                                stopDate: exerciseHistory.stopDate
                            };
                            break;
                    }
                }

                ks.client.request({
                    controller: 'exercise',
                    action: 'answer/check',
                    data: data,
                    onRequest: this.onCheckAnswer
                });
            },

            onCheckAnswer: function(errorCode, data) {
                if (errorCode === ks.consts.ERR_OK) {
                    if (this.$store.getters.isKid) {
                        // 15.11.2023
                        this.$store.commit('kid/setHasNewAchievements', data.hasNewAchievements);
                        this.$store.commit('kid/setHasNewAwards', data.hasNewAwards);
                        this.$store.commit('kid/setHasNewDiplomas', data.hasNewDiplomas);
                        //--

                        /*
                        // Проверим может появились новые ачивки
                        if (data.hasNewAchievements === true) {
                            this.$store.commit('kid/setHasNewAchievements', true);
                        }
                        // Проверим может появились новые награды
                        if (data.hasNewAwards === true) {
                            this.$store.commit('kid/setHasNewAwards', true);
                        }
                        // Проверим может появились новые дипломы
                        if (data.hasNewDiplomas === true) {
                            this.$store.commit('kid/setHasNewDiplomas', true);
                        }*/

                        // Увеличим количество пройденных заданий за сегодня
                        this.$store.commit('kid/incDayExercisesCount');

                        if (this.needShowWindowRest()) {
                            ks.app.$refs.windowRest.show();
                        }
                    }

                    this.answerSoundName = data.correct ? /*ks.sounds.ANSWER_TRUE*/ ks.soundManager.getRandomSound('WIN') : ks.sounds.ANSWER_FALSE;
                }
                else {
                    this.answerSoundName = ks.sounds.ERROR;
                }

                ks.soundManager.playEffect(this.answerSoundName, {}, 0.6);

                // +22.10.2019
                // +09.12.2020: Показываем предложение о регистрации не после первого выполненого упражнения
                // +27.11.2023: Отключили
                /*if (this.$store.getters.isGuest && this.$store.getters['guest/getExerciseDay'] >= 1 && ! ks.Guest.isOfferRegisterShowed()) {
                    // 25.06.2021 Замена оффер окна
                    ks.app.showSignup({
                        title: 'Начните заниматься эффективней',
                        text: '<b>Зарегистрируйтесь и откройте все преимущества обучения!</b><br />'+
                              'Сохраняйте прогресс занятий, получайте награды и именные дипломы.'
                    });
                    //ks.app.$refs.guestOfferRegister.show();

                    ks.Guest.setOfferRegisterShowed();
                }*/

                // Обязательно _после_ показа предложения о регистрации (см. выше),
                // т.к. при правильном ответе ждем закрытия предложения,
                // чтобы начать анимацию автозапуска след. упражнения
                this.eventOnCheckAnswer(errorCode, data);
            },

            /**
             * Нужно ли показать окно отдыха
             * @returns {Boolean}
             */
            needShowWindowRest: function() {
                if ( ! this.$store.getters.isKid) {
                    return false;
                }

                if ( ! this.$store.state.parent.options.window_rest_enabled) {
                    return false;
                }

                var dayCount = this.$store.state.kid.exercises.dayCount;

                if (dayCount <= 0 || dayCount % this.$store.state.parent.options.window_rest_exercises !== 0) {
                    return false;
                }

                // Получаем данные когда мы показывали последний раз окно отдыха
                var lastState = ks.windowRestHelper.getLastState(this.$store.state.kid.id);
                if (lastState !== false && lastState.exercises >= dayCount) {
                    return false;
                }

                // Сохраняем данные о последнем показе окна отдыха
                ks.windowRestHelper.setLastState(this.$store.state.kid.id, dayCount);

                return true;
            },

            processOfferLogin: function() {
                if ( ! this.$store.getters.isGuest || ! this.$store.getters['guest/canShowOfferLogin']) {
                    return;
                }

                this.$store.commit('guest/setOfferLoginShowed', true);

                this.$nextTick(function() {
                    setTimeout(function() {
                        ks.app.$refs.messageBox.show({
                            type    : ks.consts.MBT_QUESTION,
                            title   : 'Войти в аккаунт',
                            text    : 'Вы сейчас находитесь в режиме гостя. Хотите войти в свой аккаунт?',
                            buttons : ks.consts.MBB_YES_NO,
                            onClose : function(modalResult) {
                                if (modalResult === ks.consts.MBB_YES) {
                                    ks.app.showLogin(this.$store.getters['guest/getOfferLoginEmail']);
                                }
                            }
                        });
                    }, 500);
                });
            },

            continueWork() {
                this.$emit('continue-work');
            }
        },

        watch: {
            'exercise.currentPage': function(newValue) {
                if (newValue > -1) {
                    this.playAudio();
                }
            }
        },

        created: function() {
            this.exerciseSound = new ks.ExerciseSound();
        },

        mounted: function(){
            this.loaded = true;

            /*
            if (this.$refs.container) {
                this.$refs.container.oncontextmenu = function() { return false; };
            }*/

            this.$store.commit('current/mode', this.mode);

            this.profiler = new ks.ExerciseProfiler();

            this.processOfferLogin();
        }
    });

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 27.02.2018
 */

(function() {

    Vue.component('finish-subject-stage', {
        
        props: {
            groupName: {
                type: String,
                required: true
            },
            
            subjectTitle: {
                type: String,
                required: true
            }
        }, 

        data: function() {
            return {
                visible: false
            };
        },
        
        computed: {
            showSelectSubject: function() {
                return !this.$store.getters.isGuest;
            },
            
            getSelectSubjectUrl: function() {
                return '/exercises/groups/' + this.groupName;
            },
            
            countExercies: function() {
                return this.$store.state.current.subjectStage.countExercises;
            },
            
            correctAnswersCount: function() {
                var exercises = this.$store.state.current.history.exercises,
                    count = 0;
                
                for (var i = 0; i < exercises.length; i++) {
                    if (exercises[i].isCorrectAnswer) {
                        count++;
                    }
                }
                
                return count;
            },
            
            incorrectAnswersCount: function() {
                var exercises = this.$store.state.current.history.exercises,
                    count = 0;
                
                for (var i = 0; i < exercises.length; i++) {
                    if ( ! exercises[i].isCorrectAnswer) {
                        count++;
                    }
                }
                
                return count;
            },
            
            correctAnswersPercent: function() {
                return Math.round(100 * this.correctAnswersCount / this.countExercies);
            },
            
            incorrectAnswersPercent: function() {
                return 100 - this.correctAnswersPercent;
            }
        },
       
        methods: {
            show: function() {
                this.visible = true;
                
                this.$nextTick(() => {
                    this.$refs.finishResult.show();
                });
            },
            
            hide: function() {
                this.visible = false;
                
                this.$refs.finishResult.hide();
            },
            
            onContinue: function() {
                this.hide();
                
                this.$emit('continue-work');
            }
        }        
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 21.11.2017
 */

(function() {

    Vue.component('exercise-group', {

        props: {
            group: {
                type: Object,
                required: true
            },

            subjectId: {
                type: Number,
                required: true
            }
        },

        data: function() {
            return {
                loaded: false
            };
        },

        computed: {
            groupLoaded: function() {
                return this.group.id !== -1;
            },
            
            groupClass: function() {
                let cls = {};
                
                if (this.groupLoaded) {
                    cls['color-scheme-' + this.group.color_scheme] = true;
                }
                
                return cls;
            }
        },

        methods: {
            selectSubject: function(subjectId) {
                var a = $('#subject-' + subjectId);

                if (a.length === 1) {
                    a.closest('.panel').find('.panel-heading').find('a').trigger('click');
                }
            },

            clickGroup: function() {
                ks.app.$refs.selectGroup.show(this.group.id, this.onSelectGroup);
            },

            onSelectGroup: function(group) {
                this.$parent.loadGroup(group.id, true);
            },

            clickSubject: function(item, e) {
                // Если уже выбран текущий предмет, то не переходим по ссылке
                if (this.isSubjectSelected(item.id)) {
                    e.preventDefault();
                    return;
                }
            },
            
            isSubjectSelected: function(subjectId) {
                return subjectId === this.subjectId && this.group.id === this.$parent.groupId;
            },
            
            subjectClass: function(subject, subitem) {
                let cls = {
                    selected: subitem ? this.isSubjectSelected(subitem.id) : false
                };
                
                cls['color-scheme-' + subject.color_scheme] = true;
                
                return cls;                
            }
        },

        mounted: function() {
            this.loaded = true;
        }

    });

}());
/** 
 * (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 25.02.2018
 */

(function() {
    
    ks.ExerciseHistoryInfo = function(info) {
        if (typeof info !== 'undefined') {
            this.id = info.id;
            this.groupId = info.groupId;
            this.subjectId = info.subjectId;
            this.startDate = Date.now();
        } else {
            this.id = null;
            this.groupId = null;
            this.subjectId = null;
            this.startDate = null;
        }
        
        this.stopDate = null;
        this.isFinished = false;
        this.isCorrectAnswer = false;
    };
    
    ks.ExerciseHistoryInfoToCompact = function(exerciseHistoryInfo) {
        return {
            id: exerciseHistoryInfo.id,
            gid: exerciseHistoryInfo.groupId,
            sid: exerciseHistoryInfo.subjectId,
            std: exerciseHistoryInfo.startDate,
            spd: exerciseHistoryInfo.stopDate,
            isf: exerciseHistoryInfo.isFinished,
            isca: exerciseHistoryInfo.isCorrectAnswer
        };
    };
    
    ks.ExerciseHistoryInfoFromCompact = function(compact) {
        var exerciseHistoryInfo = new ks.ExerciseHistoryInfo();
        
        exerciseHistoryInfo.id = compact.id;
        exerciseHistoryInfo.groupId = compact.gid;
        exerciseHistoryInfo.subjectId = compact.sid;
        exerciseHistoryInfo.startDate = compact.std;
        exerciseHistoryInfo.stopDate = compact.std;
        exerciseHistoryInfo.isFinished = compact.isf;
        exerciseHistoryInfo.isCorrectAnswer = compact.isca;
        
        return exerciseHistoryInfo;
    };
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 25.11.2017
 * 
 * 08.11.2021:
 * +exerciseId
 */

(function() {

    Vue.component('exercise-info-panel', {

        computed: {
            isGuest: function() {
                return this.$store.getters.isGuest;
            },
            
            exerciseId: function(){
                let exercise = this.$store.state.current.exercise;
                
                return exercise === null ? -1 : exercise.id;
            }
        },

        data: function() {
            return {
                loaded: false
            };
        },
        
        methods: {
            showLogin: function() {
                ks.app.showLogin();
            },
            
            playAudio: function() {
                this.$parent.$refs.engine.playAudio();
            },
            
            stopAudio: function() {
                this.$parent.$refs.engine.stopAudio();
            },
            
            audioActive: function() {
                return this.$parent.$refs.engine.audioActive;
            },
            
            onToggleAudioButton: function() {
                if (this.audioActive()) {
                    this.playAudio();
                } else {
                    this.stopAudio();
                    this.$parent.$refs.engine.exerciseSound.stop();
                }
            }            
        },

        mounted: function() {
            this.loaded = true;
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 06.02.2018
 * 
 * 25.03.2021: Add image for stars
 */

(function() {

    Vue.component('exercise-level', {
        
        template: 
            '<div class="exercise-level-box">'+
            '    <div class="exercise-level-title">Уровень</div>'+
                
            '    <div class="exercise-level-stars">'+
            '        <img class="exercise-level-star ks-tooltip" v-for="level in levels"'+
                       ' src="/public/images/exercises/star.png"'+
                       ' :alt="getImgStarAlt(level)"'+
                       ' :class="getImgStarClass(level)"'+
                       ' data-toggle="tooltip" data-placement="bottom" :title="getImgStarHint(level)" @click="showInfo"/>'+
            '    </div>'+
            
            '</div>',

        props: {
            showHint: {
                type: Boolean,
                default: true
            }
        },

        data: function() {
            return {
                levels: [ 1, 2, 3 ]
            };
        },
        
        methods: {
            getImgStarAlt: function(level) {
                return 'Уровень сложности ' + level;
            },
            
            getImgStarClass: function(level) {
                var exercise = this.$store.state.current.exercise;
            
                return {
                    filled: exercise !== null && level <= exercise.level
                };    
            },
            
            getImgStarHint: function(level) {
                let text = '';
                
                if ( ! this.showHint) {
                    return text;
                }
                
                switch (level) {
                    case 1: 
                        text = 'Лёгкий';
                        break;
                        
                    case 2: 
                        text = 'Средний';
                        break;
                        
                    case 3: 
                        text = 'Сложный';
                        break;
                }
                
                return text;
            },
            
            showInfo: function() {
                ks.app.$refs.messageBox.show({
                    type    : ks.consts.MBT_INFO,
                    title   : 'Уровень сложности',
                    text    : 
                        'Задания различиются между собой по уровню сложности (лёгкий, средний, сложный).<br /><br />' +    
                        'Уровень сложности упражнений автоматически регулируется платформой в зависимости от успеваемости ребёнка.',
                    buttons : ks.consts.MBB_CLOSE
                });                
            }
        },

        mounted: function() {
            
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 25.03.2021
 *
 * 06.09.2024:
 * +isShow
 */

(function() {

    Vue.component('exercise-mobile-info-panel', {

        computed: {
          isGuest() {
            return this.$store.getters.isGuest;
          },

          isShow() {
            return this.loaded && (! this.isGuest || this.$store.getters.getAvailableExercises > 0);
          }
        },

        data: function() {
            return {
                loaded: false
            };
        },

        methods: {
            showLogin: function() {
                ks.app.showLogin();
            },

            playAudio: function() {
                this.$parent.$refs.engine.playAudio();
            },

            stopAudio: function() {
                this.$parent.$refs.engine.stopAudio();
            },

            audioActive: function() {
                return this.$parent.$refs.engine.audioActive;
            },

            onToggleAudioButton: function() {
                if (this.audioActive()) {
                    this.playAudio();
                } else {
                    this.stopAudio();
                    this.$parent.$refs.engine.exerciseSound.stop();
                }
            }
        },

        mounted: function() {
            this.loaded = true;
        }
    });

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 21.11.2017
 * 
 * 14.11.2023:
 * +continueWork
 * 
 * 08.12.2023:
 * +redirect to group.favourite_subject
 */

(function() {

    var ExercisePage = {

        props: {
            groupId: {
                type: Number,
                required: true
            },

            subjectId: {
                type: Number,
                required: true
            },
            
            stageCountExercises: {
                type: Number,
                required: true
            }
        },

        data: function() {
            return {
                loaded: false,

                group: {
                    id: -1,
                    name: '',
                    image: '',
                    title: '',
                    color_scheme: '',
                    subjects: [],
                    favourite_subject: null
                }
            };
        },
        
        computed: {
            isGuest: function() {
                return this.$store.getters.isGuest;
            },
            
            favouriteSubject: function() {
                return this.group.favourite_subject;
            }
        },

        methods: {
            init: function(){
                this.$store.commit('current/subjectStage', {
                    countExercises: this.stageCountExercises
                });
                
                this.$store.commit('current/clearHistoryExercises');
                
                this.loadGroup(this.groupId, true);
            },

            loadGroup: function(groupId, isSelectSubject) {
                ks.client.request({
                    controller: 'group',
                    action: 'get/item',
                    data: {
                        groupId: groupId
                    },
                    onRequest: this.onLoadGroup,
                    userData: isSelectSubject
                });
            },

            onLoadGroup: function(errorCode, data, isSelectSubject) {
                if (errorCode !== ks.consts.ERR_OK) {
                    if (data.errors && data.errors.global) {
                        ks.app.$refs.messageBox.show({
                            type: ks.consts.MBT_ERROR,
                            title: 'Ошибка',
                            text: data.errors.global,
                            buttons: ks.consts.MBB_CLOSE
                        });
                    }

                    return;
                }

                this.group = data.group;

                if (isSelectSubject) {
                    var self = this;
                    this.$nextTick(function() {
                        self.$refs.group.selectSubject(self.subjectId);
                    });
                }
                
                // Загружаем задание только в первый раз;
                // в дальнейшем пользователь может выбирать возрастную группу,
                // но упражнение уже не загружаем!
                if (this.$refs.engine.exercise !== null) {
                    return;
                }

                this.startExercise();    

                this.loaded = true;
            },
            
            startExercise: function() {
                this.$refs.engine.loadExercise();
            },            
            
            /**
             * Задание получено от сервера
             * @param {Object} exercise
             * @returns {undefined}
             */
            onExerciseEngineLoaded: function(exercise) {
                this.$store.commit('current/startRecordHistoryExercise', {
                    id: exercise.id,
                    groupId: this.groupId,
                    subjectId: this.subjectId
                });
            },
            
            /**
             * Правильно ответил ребенок или нет
             * @param {Boolean} isCorrect
             * @returns {undefined}
             */
            onAnswer: function(isCorrect) {
                var completedCount = this.$store.state.current.subjectStage.completedCountExercises;
                
                this.$store.commit('current/subjectStage', {
                    completedCountExercises: completedCount + 1
                });                
                
                this.$store.commit('current/setLastHistoryExerciseAnswer', isCorrect);
            },
            
            continueWork() {
                // 08.12.2023
                // Если под гостем и предмет "выбор пользователей", то редиректим на него
                if (this.isGuest && this.favouriteSubject !== null && this.favouriteSubject.id !== this.subjectId) {
                    ks.app.go('/exercises/' + this.group.name + '/' + this.favouriteSubject.name);
                    return;
                }
                //--
                
                this.$store.commit('current/subjectStage', {
                    countExercises: this.stageCountExercises
                });
                
                this.$store.commit('current/subjectStage', {
                    completedCountExercises: 0
                });                
                
                this.$store.commit('current/clearHistoryExercises');
                
                this.startExercise();
            }            
        },

        mounted: function() {
            var self = this;
            ks.core.addAppCreateEvent(function(){
                self.init();
            });
        }

    };

    ks.core.addComponent('exercise-page', ExercisePage);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 26.02.2018
 */

(function() {

    Vue.component('subject-stage-info', {
        
        data: function () {
            return {
                loaded: false
            };
        },
        
        computed: {
            visible: function() {
                return this.$store.state.current.mode === ks.consts.EXERCISE_MODE_SUBJECT_STAGE;
            },
            
            completedCountExercises: function() {
                return this.$store.state.current.subjectStage.completedCountExercises;
            },
            
            countExercises: function() {
                return this.$store.state.current.subjectStage.countExercises;
            }
        },
        
        mounted: function() {
            this.loaded = true;
        }
        
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 13.03.2018
 */

(function() {

    var FaqCategory = {

        data: function() {
           return {
               questionId: -1
           };
        },

        methods: {
            isExpanded: function(id) {
                return this.questionId === id ? 'true' : 'false';
            },
            
            getCollapseClass: function(id) {
                return {
                    'in': this.questionId === id
                };
            }
        },
        
        mounted: function() {
            try {
                this.questionId = parseInt(window.location.hash.substring(2), 10);
            } catch (err) {
                this.questionId = -1;
            }
            
            if (this.questionId > -1) {
                let heading = $('#q' + this.questionId),
                    links = heading.find('a');
            
                links.removeClass('collapsed');    
            }
        }

    };

    ks.core.addComponent('faq-category', FaqCategory);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 02.07.2018
 *
 * 29.03.2021:
 * + Image Alt
 */

(function() {

    var MainGuest = {

        data: function() {
            return {
                slides: [],

                slideIndex: -1,

                sliderPlaying: false,

                slideTimeout: 5000,

                sliderTimer: null,

                isImageLoading: true,

                loadTime: {
                    start : 0,
                    last  : 0
                }
            };
        },

        computed: {
            slide: function(){
                return this.slideIndex > -1 ? this.slides[this.slideIndex] : null;
            },

            slideTitle: function() {
                return this.slide !== null ? this.slide.title : '';
            },

            slideText: function() {
                return this.slide !== null ? this.slide.text : '';
            },

            slideAlt: function() {
                return this.slide !== null ? this.slide.alt : '';
            },

            slideColor: function() {
                return this.slide !== null ? this.slide.color : '';
            },

            slideTitleClass: function() {
                return 'bg-' + this.slideColor;
            },

            slideImageClass: function() {
                return 'brd-' + this.slideColor;
            },

            canInstallApp() {
              return this.$store.getters.canInstallApp;
            }
        },

        methods: {
            slideImage: function(webp) {
                let image = this.slideIndex > -1 ? this.slides[this.slideIndex].image : '';

                if (image === '') {
                    return '';
                }

                return !webp ? image : image.substr(0, image.lastIndexOf('.')) + '.webp';
            },

            loadSlides: function() {
                let items = document.getElementsByClassName('main-slider-item');
                for (let i = 0; i < items.length; i++) {
                    this.createSlide(i, items[i]);
                }
            },

            createSlide: function(index, item) {
                let title  = index > 0 ? item.getElementsByClassName('main-slider-item-title')[0] : document.getElementById('main-slider-item-info-title'),
                    text   = index > 0 ? item.getElementsByClassName('main-slider-item-text')[0] : document.getElementById('main-slider-item-info-text'),
                    img    = item.getElementsByClassName('main-slider-item-img')[0],
                    imgSrc = img.getAttribute('data-src');

                this.slides.push({
                    color    : item.getAttribute('data-color'),
                    title    : title.innerText.trim(),
                    text     : text.innerHTML.trim(),
                    image    : imgSrc,
                    alt      : img.getAttribute('data-alt'),
                    loaded   : false
                });
            },

            getSlideIndexByName: function(slideName) {
                for (let i = 0; i < this.slides.length; i++) {
                    if (this.slides[i].name === slideName) {
                        return i;
                    }
                }

                return -1;
            },

            setSlide: function(slideIndex) {
                this.sliderStop();
                this.slideIndex = slideIndex;
                this.sliderPlay();
            },

            sliderButtonClass: function(slideIndex) {
                let cls = {};

                cls['main-slider-button-' + slideIndex] = true;
                cls['main-slider-button-' + this.slideColor] = slideIndex === this.slideIndex;
                cls.active = slideIndex === this.slideIndex;

                return cls;
            },

            sliderPlay: function() {
                if (this.sliderPlaying) {
                    return;
                }

                let self = this;
                this.sliderTimer = setInterval(function() {
                    if (self.slideIndex + 1 >= self.slides.length) {
                        self.slideIndex = 0;
                    } else {
                        self.slideIndex++;
                    }
                }, this.slideTimeout);

                this.sliderPlaying = true;
            },

            sliderStop: function() {
                if ( ! this.sliderPlaying) {
                    return;
                }

                clearInterval(this.sliderTimer);
                this.sliderTimer = null;

                this.sliderPlaying = false;
            },

            showSignup: function(options){
                ks.app.showSignup(options);
            },

            onLoadImage: function(){
                if (this.slide === null) {
                    this.isImageLoading = false;
                    return;
                }

                if ( ! this.slide.loaded) {
                    try {
                        let d = new Date();
                        this.loadTime.last = d.getTime()/*performance.now()*/ - this.loadTime.start;
                    } catch (err) {
                        this.loadTime.last = 0;
                    }

                    this.slide.loaded = true;

                    this.sliderPlay();
                }

                this.isImageLoading = false;
            },

            startInstallApp() {
              ks.app.startInstallApp();
            }
        },

        watch: {
            slideIndex: function(newIndex){
                if ( ! this.slides[newIndex].loaded) {
                    if (newIndex === 0 || this.loadTime.last > 250) {
                        this.isImageLoading = true;
                    }

                    try {
                        let d = new Date();
                        this.loadTime.start = d.getTime();//performance.now(); // Safari not support
                    } catch (err) {
                        this.loadTime.start = 0;
                    }
                }
            }
        },

        created: function(){
            this.loadSlides();
        },

        mounted: function() {
            this.slideIndex = 0;
        }

    };

    ks.core.addComponent('main-guest', MainGuest);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 24.04.2018
 */

(function() {

    Vue.component('main-hint-list', {
        
        data: function() {
            return {
                loaded: false,
                
                index: 0,
                count: 0
            };
        },

        computed: {
        },
        
        methods: {
            prev: function() {
                this.slider.trigger('prev.owl.carousel');
            },
    
            next: function() {
                this.slider.trigger('next.owl.carousel');
            }
        },
        
        mounted: function() {
            var self = this;
            
            this.loaded = true;
            
            this.slider = $('#main-hints-slider').owlCarousel({
                items: 1,
                loop: true,
                autoplay: true,
                autoplayTimeout: 5000,
                autoplaySpeed: 1000
            });
            
            this.slider.on('changed.owl.carousel', function(event) {
                self.index = event.page.index + 1;
                self.count = event.page.count;
            });
        }
        
    });
    
}());
    
    
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 03.05.2018
 * 
 * 14.06.2023:
 * +hasAge
 */

(function() {

    var MainKid = {

        data: function() {
            return {
                loaded: false,
                
                info: []
            };
        },

        computed: {
            name: function() {
                return ks.helpers.text.capitalizeFirstLetter(this.$store.state.kid.name);
            },
            
            avatarSrc: function() {
                return this.$store.getters['kid/getAvatarBySize'](ks.consts.AVATAR_SIZE_BIG);
            },
            
            hasAge: function() {
                return this.$store.state.kid.birthday !== '';
            },
            
            age: function() {
                return ks.helpers.date.getReadableAge(this.$store.state.kid.birthday);
            },
            
            birthday: function() {
                return this.$store.state.kid.birthday;
            },
            
            starsCountClass: function() {
                return {
                    'orange': this.stars > 0,
                    'gray-dark-text':  this.stars <= 0
                };                
            },
            
            stars: function() {
                return this.$store.state.kid.stars;
            },
            
            todayTime: function() {
                if (this.info.length === 0 || this.info.today.time <= 0) {
                    return '-';
                }
                
                var time = this.info.today.time,
                    value;
            
                if (time > 60) {
                    time = Math.ceil(time / 60);
                    value = time + ' ' + ks.helpers.text.pluralize(time, ['минута', 'минуты', 'минут']);
                } else {
                    value = time + ' ' + ks.helpers.text.pluralize(time, ['секунда', 'секунды', 'секунд']);
                }   
                
                return value;
            },
            
            todayCountExercises: function() {
                if (this.info.length === 0) {
                    return '-';
                }
                
                return this.info.today.countExercises;
            },
            
            todayCountCorrectAnswers: function() {
                if (this.info.length === 0) {
                    return '-';
                }
                
                return this.info.today.correctAnswers;
            },
            
            todayCountIncorrectAnswers: function() {
                if (this.info.length === 0) {
                    return '-';
                }
                
                return this.info.today.countExercises - this.info.today.correctAnswers;
            },
            
            todayCountCorrectAnswersPercent: function() {
                if (this.info.length === 0) {
                    return '';
                }
                
                var value = this.info.today.countExercises === 0 ? 0 : Math.ceil(100 * this.info.today.correctAnswers / this.info.today.countExercises);
                
                return value;
            },
            
            todayCountIncorrectAnswersPercent: function() {
                var correctAnswersPercent = this.todayCountCorrectAnswersPercent;
                
                if (correctAnswersPercent === '') {
                    return '';
                }
                
                return this.info.today.countExercises === 0 ? 0 : 100 - correctAnswersPercent;
            },
            
            hasCurrentStage: function() {
                return typeof this.info.current !== 'undefined' && typeof this.info.current.stage !== 'undefined' && this.info.current.stage !== null;
            },
            
            currentStageTarget: function() {
                return this.hasCurrentStage ? '/exercises/' + 
                    this.info.current.stage.group.name + '/' +
                    this.info.current.stage.subject.name :
                    '';
            },
            
            currentStageText: function() {
                if ( ! this.hasCurrentStage) {
                    return '';
                }
                
                var text = this.name + ', у тебя есть незаконченный этап упражнений<br /> по теме &laquo;<b>' +
                    this.info.current.stage.subject.title + '</b>&raquo; (' + 
                    this.info.current.stage.group.title + ')';
            
                return text;    
            },
            
            selectExercisesTitle: function() {
                return this.hasCurrentStage ? 'Выбрать другую тему упражнений' : 'Выбрать тему упражнений';
            },
            
            hasCurrentTraining: function() {
                return typeof this.info.current !== 'undefined' && typeof this.info.current.training !== 'undefined' && this.info.current.training !== null;
            },
            
            currentTrainingTarget: function() {
                return this.hasCurrentTraining ? '/trainings/run/item/' + 
                    this.info.current.training.id :
                    '';                
            },
            
            currentTrainingText: function() {
                if ( ! this.hasCurrentTraining) {
                    return '';
                }
                
                var text = this.name + ', у тебя есть незаконченная тренировка<br />&laquo;<b>' +
                    this.info.current.training.name + '</b>&raquo; (' + 
                    this.info.current.training.group.title + ')';
            
                return text;                 
            },
            
            selectTrainingTitle: function() {
                return this.hasCurrentTraining ? 'Выбрать другую тренировку' : 'Выбрать тренировку';
            },
            
            subscriptionActive: function() {
                return this.$store.state.kid.subscription.active;
            },
            
            subscriptionExpireLessThanMonth: function() {
                var expired = moment(this.$store.state.kid.subscription.expired, 'YYYY-MM-DD'),
                    duration = moment.duration(expired.diff(moment())),
                    days = duration.asDays();
                
                return days < 30;
            },
            
            subscriptionInfoClass: function() {
                return {
                    'red': ! this.subscriptionActive,
                    'green': this.subscriptionActive
                };
            },
            
            subscriptionInfo: function() {
                if (this.$store.state.kid.subscription.active) {
                    return 'Активна до ' + moment(this.$store.state.kid.subscription.expired, 'YYYY-MM-DD').format('DD.MM.YYYY') + '.';
                } else {
                    return '<i class="fa fa-exclamation-triangle ks-tooltip" data-toggle="tooltip" data-placement="bottom" title="Пока подписка неактивна часть функционала платформы будет недоступна." aria-hidden="true"></i> Неактивна.';
                }
            },
            
            subscriptionButtonText: function() {
                return this.$store.state.kid.subscription.active ? 'Продлить?' : 'Активировать?';
            },
            
            hasNewAwards: function() {
                return this.$store.getters['kid/hasNewProgress'];
            }
         },

        methods: {
            onGetInfo: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);
                } else {
                    this.info = data.info;
                }
                
                this.loaded = true;
            }
            
        },

        mounted: function() {
            var self = this;
            
            ks.core.addAppCreateEvent(function(){
                ks.client.request({
                    controller: 'kid',
                    action: 'info/get',
                    onRequest: self.onGetInfo
                });
            });
        }

    };

    ks.core.addComponent('main-kid', MainKid);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 13.04.2018
 *
 * 24.08.2023:
 * +EVENT_SIGNUP_COMPLETED
 */

(function() {

    var MainParent = {

        data: function() {
            return {
                loaded: false,

                kids: []
            };
        },

        computed: {
            parentName: function() {
                return ks.helpers.text.capitalizeFirstLetter(this.$store.state.parent.name);
            },

            parentAvatarSrc: function() {
                return this.$store.getters['parent/getAvatarBySize'](ks.consts.AVATAR_SIZE_BIG);
            },

            parentBirthday: function() {
                return this.$store.state.parent.birthday;
            },

            chartKidsLength: function() {
                var count = 0;

                for (var i = 0; i < this.kids.length; i++) {
                    if (this.kids[i].countExercises > 0) {
                        count++;
                    }
                }

                return count > ks.colors.items.length ? ks.colors.items.length : count;
            },

            promocode: function() {
                return this.$store.state.promocode.active ? this.$store.state.promocode : null;
            },

            promocodeCountDownEnabled: function() {
                return this.promocode !== null && this.promocode.timeLeft !== '';
            },

            promocodeTimeLeft: function() {
                return this.promocode === null ? '' : this.promocode.timeLeft;
            },

            promocodeBlockTitle: function (){
                if (this.promocode === null) {
                    return '';
                }

                var title;

                switch (this.promocode.discountMode) {
                    case ks.consts.PROMOCODE_DISCOUNT_MODE_PERCENT:
                        title = 'Вас ждёт скидка';
//                        title = 'Вас ждёт персональная скидка';
                        break;

                    case ks.consts.PROMOCODE_DISCOUNT_MODE_MONTH:
                        title = 'У вас есть промокод';
//                        title = 'У вас есть персональный промокод';
                        break;

                    default:
                        title = '';
                }

                return title;
            },

            promocodeText: function() {
                if (this.promocode === null) {
                    return '';
                }

                var text;

                switch (this.promocode.discountMode) {
                    case ks.consts.PROMOCODE_DISCOUNT_MODE_PERCENT:
                        text = 'Успейте получить безлимитный доступ со скидкой  <b>' + this.promocode.discount + '</b>% до <b>' + this.promocode.expireDate + '</b>!';
                        break;

                    case ks.consts.PROMOCODE_DISCOUNT_MODE_MONTH:
                        text = 'Воспользуйтесь до <b>' + this.promocode.expireDate + '</b> промокодом и получите <b>' +
                                this.promocode.discount + ' '+ ks.helpers.text.pluralize(this.promocode.discount, ['месяц', 'месяца', 'месяцев']) +
                                '</b> безлимитного доступа бесплатно!';
                        break;

                    default:
                        text = '';
                }

                return text;
            },

            promocodeButtonTitle: function() {
                if (this.promocode === null) {
                    return '';
                }

                var title;

                switch (this.promocode.discountMode) {
                    case ks.consts.PROMOCODE_DISCOUNT_MODE_PERCENT:
                        title = 'Воспользоваться скидкой';
                        break;

                    case ks.consts.PROMOCODE_DISCOUNT_MODE_MONTH:
                        title = 'Воспользоваться промокодом';
                        break;

                    default:
                        title = '';
                }

                return title;
            },

            promocodeInfoText: function() {
                if (this.promocode === null) {
                    return '';
                }

                var text;

                switch (this.promocode.discountMode) {
                    case ks.consts.PROMOCODE_DISCOUNT_MODE_PERCENT:
                        text = 'Действие скидки истекает через:';
                        break;

                    case ks.consts.PROMOCODE_DISCOUNT_MODE_MONTH:
                        text = 'Действие промокода истекает через:';
                        break;

                    default:
                        text = '';
                }

                return text;
            }
        },

        methods: {
            onGetKids: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);
                } else {
                    this.kids = data.kids;
                }

                this.loaded = true;

                this.$refs.chart.load(this.kids.length > 0);

                if (this.kids.length <= 0) {
                    setTimeout(function() {
                        ks.app.$refs.kidDlg.show();
                    }, 500);
                } else {
                    if (this.kids.length === 1 && this.kids[0].birthday === '') {
                        ks.app.$refs.kidDlg.show({
                            title  : 'Данные ребёнка',
                            action : 'update',
                            kidId  : this.kids[0].id
                        });
                    }
                }
            },

            getKidAvatarSrc: function(kid) {
                var src = kid.avatar.src + '_' + ks.consts.AVATAR_SIZE_BIG + '.png';
                if (kid.avatar.time > 0) {
                    src += '?t=' + kid.avatar.time;
                }
                return src;
            },

            getKidSubscriptionHint: function(kid) {
                if ( ! kid.subscription.active) {
                    return '';
                }

                return 'Подписка активна до ' + moment(kid.subscription.expired, 'YYYY-MM-DD').format('DD.MM.YYYY') + '.';
            },

            selectKid: function(kid) {
                ks.client.request({
                    controller: 'account',
                    action: 'switch-user/login',
                    data: {
                        user: {
                            role: ks.consts.ROLE_KID,
                            id: kid.id
                        }
                    },
                    onRequest: this.onSelectKid
                });
            },

            onSelectKid: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }
            }
        },

        mounted() {
          const self = this;

          ks.core.addAppCreateEvent(function(){
            ks.client.request({
              controller: 'account',
              action: 'kids/get-all',
              data: {
                options: {
                  countExercises: true
                }
              },
              onRequest: self.onGetKids
            });
          });

          const signupCompleted = document.getElementById('signup-completed');
          if (signupCompleted !== null) {
            const sourcePage = +signupCompleted.getAttribute('data-sp');

            ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED);
            ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED_TPS);

            switch (sourcePage) {
              case ks.consts.OAUTH_SOURCE_PAGE_EXERCISES_OVER:
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED_TPS_EXERCISES_OVER);
                break;

              case ks.consts.OAUTH_SOURCE_PAGE_SIGNUP_PAGE:
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_PAGE_COMPLETED_TPS);
                break;

              case ks.consts.OAUTH_SOURCE_PAGE_DIALOG:
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_DIALOG_COMPLETED_TPS);
                break;

              case ks.consts.OAUTH_SOURCE_PAGE_ORDER_PAGE:
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED_ORDER_TPS);
                break;

              case ks.consts.OAUTH_SOURCE_PAGE_LOGIN_DIALOG:
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED_LOGIN_DIALOG_TPS);
                break;
            }
          }
        }

    };

    ks.core.addComponent('main-parent', MainParent);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 17.04.2018
 */

(function() {

    Vue.component('main-parent-chart', {
        
        data: function() {
            return {
                loaded: false,
                
                days: 7,
                
                dates: []
            };
        },

        computed: {
        },
        
        methods: {
            isActiveDays: function(days) {
                return {
                    'active': this.days === days
                };
            },
            
            setDays: function(days) {
                this.days = days;
            },
            
            load: function(hasKids) {
                if (hasKids) {
                    // Получаем данные для графика
                    ks.client.request({
                        controller: 'parent',
                        action: 'main-chart/load',
                        data: {
                            days: this.days
                        },
                        onRequest: this.onLoad
                    }); 
                } else {
                    this.onLoad(ks.consts.ERR_OK, {kids: []});
                }
                
                return true;
            },
            
            onLoad: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }
                
                this.fillDates();
                
                this.loaded = true;                
                
                this.chart.data = {
                    labels: this.getChartLabels(),
                    
                    datasets: this.getDatasets(data.kids)
                };
                
                this.chart.update();
            },
            
            getKidData: function(kidDates) {
                var data = [];
                
                for (var i = 0; i < this.dates.length; i++) {
                    var date = this.dates[i].format('YYYY-MM-DD');
                    
                    data.push(date in kidDates ? kidDates[date] : 0);
                }
                
                return data;
            },
            
            getDatasets: function(kids) {
                var count = kids.length > ks.colors.items.length ? ks.colors.items : kids.length,
                    datasets = [];
              
                for (var i = 0; i < count; i++) {
                    var data = {
                        label: kids[i].name,
                        backgroundColor: ks.colors.items[i].background,
                        borderColor: ks.colors.items[i].border,
                        fill: false,
                        data: this.getKidData(kids[i].dates),
                        borderWidth: 1
                    };
                    
                    datasets.push(data);
                }
                
                return datasets;
            },
            
            fillDates: function() {
                this.dates = [];
                
                for (var i = this.days; i >= 0; i--) {
                    this.dates.push(moment().add(-i, 'days'));
                }
            },
            
            getChartLabels: function() {
                var labels = [];
                
                for (var i = 0; i < this.dates.length; i++) {
                    labels.push(this.dates[i].format('DD.MM'));
                }
                
                return labels;
            },
            
            createChart: function() {
                var ctx = $('#main-parent-chart-canvas');
                
                this.chart = new Chart(ctx, {
                    type: 'line',
                    
                    options: {
                        scales: {
                            xAxes: [{
                                display: true,
                                scaleLabel: {
                                    display: true,
                                    labelString: 'Дата'
                                }
                            }],
                            yAxes: [{
                                display: true,
                                scaleLabel: {
                                    display: true,
                                    labelString: 'Упражнения'
                                },
                                ticks: {
                                    min: 0,
                                    beginAtZero: true,
                                    callback: function(value, index, values) {
                                        if (Math.floor(value) === value) {
                                            return value;
                                        }
                                    }
                                }                                
                            }]
                        },                        
                        
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItems, data) {
                                    var count = parseInt(tooltipItems.yLabel, 10),
                                        text = count > 0 ? 
                                            count + ' ' + ks.helpers.text.pluralize(count, ['упражнение', 'упражнения', 'упражнений']) : 
                                            'ребёнок не занимался';
                                    
                                    return data.datasets[tooltipItems.datasetIndex].label +': ' + text;
                                }
                            },                            
                            
                            backgroundColor: '#fafeff',
                            
                            titleFontColor: '#4091a5',
                            
                            bodyFontColor: '#4091a5',
                            
                            borderColor: '#4ba4ba',
                            borderWidth: 1,
                            
                            displayColors: false
                        }    
                    }  
                    
                });
            }            
        },
        
        watch: {
            days: function(newValue) {
                this.load(true);
            }
        },

        mounted: function() {
            var self = this;
            
            ks.core.addAppCreateEvent(function(){
                self.createChart();
            });            
        }

    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 02.04.2021
 */

(function() {

    Vue.component('main-parent-discount', {
        
        data: function() {
            return {
                loaded: false
            };
        },

        computed: {

        },
        
        methods: {

        },
        
        mounted: function() {
            this.loaded = true;
        }
        
    });
    
}());
    
    
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 30.04.2018
 */

(function() {

    Vue.component('main-parent-info', {
        
        data: function() {
            return {
                loaded: false              
            };
        },

        computed: {
            
        },
        
        methods: {

        },
        
        mounted: function() {
            this.loaded = true;
        }
        
    });
    
}());
    
    
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 13.06.2023
 */

(function() {

    Vue.component('payment-order-code-number', {

        template:
                `<div class="col-xs-3" :class="{ 'has-error': error }">
                    <input ref="input" :value="value" @input="setNumber($event)" @keyup.enter="onEnter" type="text" maxlength="1" class="form-control payment-order-confirm-email__code__input" />
                </div>`,

        props: {
            index: {
                type: Number,
                required: true
            }
        },

        data: function() {
            return {
                value: '',
                error: false
            };
        },

        methods: {
            clear: function() {
                this.value = '';
                this.error = false;
            },

            focus: function() {
                this.$refs.input.focus();
                this.$refs.input.select();
            },

            setNumber: function(event) {
                const val = event.target.value.replace(/[^0-9]/g, '');
                this.value = val;
                this.error = false;

                this.$emit('changed', this.index, val);

                this.$forceUpdate();
            },

            onEnter: function() {
                this.$emit('enter', this.index);
            },

            setError: function(error) {
                this.error = error;
            }
        }

    });

    var PaymentOrderConfirmEmail = {

        data: function() {
            return {
                email: '',

                onSuccess: null,

                code: {
                    n1: '',
                    n2: '',
                    n3: '',
                    n4: ''
                },

                errorText: ''
            };
        },

        computed: {
            codeText: function() {
                let code = '';
                for (let i = 1; i <= 4; i++) {
                    if (this.code['n' + i] === '') {
                        return '';
                    }

                    code += this.code['n' + i];
                }

                return code;
            },

            hasError: function() {
                return this.errorText !== '';
            }
        },

        methods: {
            show: function(options) {
                this.errorText = '';

                for (var i = 1; i <= 4; i++) {
                    this.$refs['n' + i].clear();
                    this.code['n' + i] = '';
                }

                options = options || {};

                this.email = options.email || '';
                this.onSuccess = options.onSuccess || null;

                this.$dlg.modal('show');

                var self = this;
                setTimeout(function() {
                    self.$refs['n1'].focus();
                }, 300);
            },

            hide: function() {
                this.$dlg.modal('hide');
            },

            onChangedNumber: function(index, value) {
                this.code['n' + index] = value;

                if (index < 4 && value !== '') {
                    const nextIndex = index + 1,
                          input = this.$refs['n' + nextIndex];

                    input.focus();
                }

                this.errorText = '';
            },

            validateCode: function() {
                var focusProcessed = false,
                    isValid = true;

                for (var i = 1; i <= 4; i++) {
                    var isValidNumber = this.code['n' + i] !== '';
                    this.$refs['n' + i].setError(! isValidNumber);

                    if (! isValidNumber) {
                        isValid = false;

                        if (! focusProcessed) {
                            focusProcessed = true;
                            this.$refs['n' + i].focus();
                        }
                    }
                }

                return isValid;
            },

            confirmCode: function() {
                if (! this.validateCode()) {
                    return;
                }

                this.errorText = '';

                ks.client.request({
                    controller: 'account',
                    action: 'email/confirm',
                    data: {
                      mode  : ks.consts.CONTROLLER_ACCOUNT_EMAIL_MODE_ORDER,
                      email : this.email,
                      code  : this.codeText
                    },
                    onRequest: this.onConfirmCode
                });
            },

            onConfirmCode: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    if (errorCode === ks.consts.ERR_CONFIRM_CODE_MAX_ATTEMPTS) {
                        this.hide();

                        ks.app.messageBox({
                            type     : ks.consts.MBT_WARNING,
                            title    : 'Что-то пошло не так...',
                            text     : 'Превышено максимальное количество проверок кода.',
                            buttons  : ks.consts.MBB_OK,
                            maxWidth : '420px'
                        });

                        return;
                    } else {
                        // Больше одного ребенка под аккаунтом
                        if (errorCode === ks.consts.ERR_KID_NOT_ONE) {
                            this.hide();
                            window.location.reload(true);
                            return;
                        }
                    }

                    this.errorText = errorCode === ks.consts.ERR_CONFIRM_CODE_INVALID ? 'Неправильный код.' : data.errors.global;
                    return;
                }

                this.hide();

                if (this.onSuccess !== null) {
                    this.onSuccess(data.parentId, data.kidId, data.isNewAccount);
                }
            }

        },

        mounted: function() {
            this.$dlg = $('#payment-order-confirm-email');
        }

    };

    ks.core.addComponent('payment-order-confirm-email', PaymentOrderConfirmEmail);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 12.06.2023
 *
 * 24.08.2023:
 * +EVENT_SIGNUP_COMPLETED
 */

(function() {

    var PaymentOrder = {

        props: {
            p: {
                type: Number,
                required: true
            },

            /*am: {
                type: Boolean,
                default: false
            },*/

            pc: {
                type: String,
                required: true
            }
        },

        data: function() {
            return {
                loaded: false,

                periodId: 0,
                //alternativeMode: false,

                price: 0,
                total: 0,

                title: '',
                expired: '',

                email: {
                    value: '',
                    error: ''
                },

                promocode: {
                    value  : '',
                    active : false,
                    error  : '',
                    show   : false
                },

                kidId: 0,

                kids: [],

                pf: ''
            };
        },

        computed: {
            isLogged: function() {
                return ! this.$store.getters.isGuest;
            },

            userBlockVisible: function() {
                return ! this.isLogged || this.kids.length > 1;
            },

            userBlockTitle: function() {
                return this.isLogged ? 'Выберите профиль ребёнка для оплаты:' : 'Ваши данные:';
            },

            productTitle: function() {
                return 'Безлимитный доступ на ' + this.title;
            },

            subscriptionExpired: function() {
                return this.expired;
            },

            priceText: function() {
                return ks.helpers.text.price(this.price);
            },

            hasDiscount: function() {
                return this.price !== this.total;
            },

            discountText: function() {
                return ks.helpers.text.price(this.price - this.total);
            },

            totalText: function() {
                return ks.helpers.text.price(this.total);
            },

            canApplyPromocode: function() {
                return ! this.promocode.active && this.promocode.value !== '';
            },

            hasErrorPromocode: function() {
                return this.promocode.error !== '';
            },

            hasErrorEmail: function() {
                return this.email.error !== '';
            },

            selectedKid: function() {
                for (let i = 0; i < this.kids.length; i++) {
                    if (this.kids[i].selected) {
                        return this.kids[i];
                    }
                }

                return null;
            }
        },

        methods: {
            get: function() {
                this.promocode.active = false;
                this.promocode.error = '';

                this.price = 0;
                this.total = 0;

                ks.client.request({
                    controller: 'payment',
                    action: 'order/get',
                    data: {
                        periodId  : this.periodId,
                        promocode : this.promocode.value
                    },
                    onRequest: this.onGet
                });
            },

            onGet: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    if ('promocode' in data.errors) {
                        this.promocode.error = data.errors.promocode;
                    } else {
                        this.loaded = false;

                        ks.app.messageBox({
                            type     : ks.consts.MBT_ERROR,
                            title    : 'Что-то пошло не так...',
                            text     : data.errors.global,
                            buttons  : ks.consts.MBB_OK,
                            maxWidth : '400px'
                        });
                    }
                } else {
                    if ('promocode' in data.errors) {
                        this.promocode.error = data.errors.promocode;
                    } else {
                        if (this.promocode.value !== '') {
                            this.promocode.active = true;
                            this.promocode.show = true;
                        }
                    }

                    this.price = data.price;
                    this.total = data.total;

                    this.title = data.title;
                    this.expired = data.expired;

                    this.kidId = 0;

                    this.kids = [];
                    if (this.isLogged) {
                        for (var i = 0; i < data.kids.length; i++) {
                            this.kids.push({
                                id       : data.kids[i].id,
                                name     : data.kids[i].name,
                                avatar   : data.kids[i].avatar,
                                selected : i === 0
                            });
                        }
                    }

                    this.loaded = true;
                }
            },

            showLogin: function() {
                ks.app.showLoginEx({ hideSignup: true, orderPage: true, reload: true });
            },

            showPromocode: function() {
                this.promocode.show = true;
            },

            applyPromocode: function() {
                if (this.promocode.active || ! this.validatePromocode()) {
                    return false;
                }

                this.get();
            },

            validatePromocode: function() {
                if (this.promocode.value === '') {
                    this.promocode.error = 'Пожалуйста, введите промокод.';
                    return false;
                }

                if (this.promocode.value.length < 3 || this.promocode.value.length > 16) {
                    this.promocode.error = 'Неправильный промокод.';
                    return false;
                }

                this.promocode.error = '';

                return true;
            },

            clearPromocode: function() {
                var reload = this.promocode.active;

                this.promocode.value  = '';
                this.promocode.active = false;
                this.promocode.error  = '';
                this.promocode.show   = false;

                if (reload) {
                    this.get();
                }
            },

            doPreparePayment: function() {
                // VK Pixel Ретаргетинг
                ks.vk.Retargeting.onEvent(ks.vk.Retargeting.EVENT_CLICK_PAY);
                ks.vk.Goal('add_to_cart');
                // Yandex Events
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_CLICK_PAY_BR);

                if ( ! this.isLogged) {
                    if ( ! this.validateEmail(false)) {
                        var emailInput = this.$refs.email;
                        ks.app.messageBox({
                            type: ks.consts.MBT_WARNING,
                            title: 'Что-то пошло не так...',
                            text: this.email.error,
                            buttons: ks.consts.MBB_OK,
                            maxWidth: '400px',
                            onClose: function() {
                                emailInput.scrollIntoView();
                                emailInput.focus();
                            }
                        });

                        return;
                    }

                    ks.client.request({
                        controller: 'account',
                        action: 'email/send-code',
                        data: {
                          mode  : ks.consts.CONTROLLER_ACCOUNT_EMAIL_MODE_ORDER,
                          email : this.email.value
                        },
                        onRequest: this.onSendCode
                    });

                    return;
                } else {
                    this.doPayment();
                }
            },

            onSendCode: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    var errorText = '',
                        showMessage = false;

                    switch (errorCode) {
                        case ks.consts.ERR_CONFIRM_CODE_USER_EMPTY:
                            errorText = 'Произошла ошибка. Обновите, пожалуйста, страницу и попробуйте ещё раз.';
                            showMessage = true;
                            break;

                        case ks.consts.ERR_CONFIRM_CODE_MAX_LIMIT:
                            errorText = 'Превышен лимит отправки кодов. Пожалуйста, повторите позже.';
                            showMessage = true;
                            break;

                        case ks.consts.ERR_CONFIRM_CODE_WAIT_INTERVAL:
                            errorText = 'Отправить новый код можно будет через ' +
                                data.errors.interval + ' ' +
                                ks.helpers.text.pluralize(data.errors.interval, ['секунду', 'секунды', 'секунд']) + '.';
                            showMessage = true;
                            break;

                        default:
                            errorText = data.errors.global;
                            break;
                    }

                    if (showMessage) {
                        ks.app.messageBox({
                            type     : ks.consts.MBT_WARNING,
                            title    : 'Что-то пошло не так...',
                            text     : errorText,
                            buttons  : ks.consts.MBB_OK,
                            maxWidth : '420px'
                        });
                    } else {
                        this.email.error = errorText;
                    }

                    return;
                }

                ks.app.$refs.confirmEmail.show({
                    email     : this.email.value,
                    onSuccess : this.onConfirmEmail
                });
            },

            onConfirmEmail: function(parentId, kidId, isNewAccount) {
              if (isNewAccount) {
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED);
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED_ORDER);
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED_ORDER_EMAIL);
              }

              this.kidId = kidId;
              this.doPayment();
            },

            validateEmail: function(allowEmpty) {
                if (this.email.value === '') {
                    this.email.error = allowEmpty ? '' : 'Пожалуйста, введите ваш email.';
                    return allowEmpty;
                }

                if ( ! ks.validator.validateEmail(this.email.value)) {
                    this.email.error = 'Пожалуйста, укажите корректный email.';
                    return false;
                }

                this.email.error = '';

                return true;
            },

            doPayment: function() {
                var kidId = this.isLogged ? this.selectedKid.id : this.kidId;

                if (kidId <= 0) {
                    ks.app.messageBox({
                        type     : ks.consts.MBT_WARNING,
                        title    : 'Что-то пошло не так...',
                        text     : 'Ошибка. Обновите, пожалуйста, страницу.',
                        buttons  : ks.consts.MBB_OK,
                        maxWidth : '420px'
                    });

                    return;
                }

                var data = {
                   kids: [],

                   alternativeMode: false,

                   totalPrice: this.total,

                   page: ks.consts.INVOICE_PAGE_ORDER
                };

                data.kids.push({
                    id: kidId,
                    periodId: this.periodId
                });

                if (this.promocode.active) {
                    data.promocode = this.promocode.value;
                }

                ks.client.request({
                    controller: 'parent',
                    action: 'profile-payment/create-invoice',
                    data: data,
                    onRequest: this.onCreateInvoice
                });
            },

            onCreateInvoice: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type    : ks.consts.MBT_WARNING,
                        title   : 'Что-то пошло не так...',
                        text    : data.errors.global,
                        buttons : ks.consts.MBB_OK
                    });
                } else {
                    if (data.frameMode) {
                        switch (data.provider) {
                            case 'robokassa':
                                Robokassa.StartPayment(data.frame);
                                break;
                        }
                    } else {
                        this.pf = data.form;

                        this.$nextTick(function() {
                            var form = document.getElementById('paymentForm');

                            form.submit();
                        });
                    }
                }
            },

            selectKid: function(kid) {
                if (kid.selected) {
                    return;
                }

                for (let i = 0, count = this.kids.length; i < count; i++) {
                    this.kids[i].selected = this.kids[i] === kid;
                }
            },

            getAvatarSrc: function(kid) {
                var src = kid.avatar.src + '_' + ks.consts.AVATAR_SIZE_BIG + '.png';
                if (kid.avatar.time > 0) {
                    src += '?t=' + kid.avatar.time;
                }
                return src;
            },

            classKidSelected: function(kid) {
                return {
                    'selected': kid.selected,
                    'cursor-default': kid.selected
                };
            }
        },

        watch: {
            'promocode.value': function() {
                this.promocode.error = '';
            },

            'email.value': function() {
                this.email.error = '';
            }
        },

        mounted: function() {
            this.periodId = this.p;
            //this.alternativeMode = this.am;
            this.promocode.value = this.pc;

            var self = this;
            this.$nextTick(function() {
                self.get();
            });

            var signupCompleted = document.getElementById('signup-completed');
            if (signupCompleted !== null) {
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED);
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED_ORDER);
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED_ORDER_TPS);
            }
        }

    };

    ks.core.addComponent('payment-order', PaymentOrder);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 19.10.2017
 * 
 * 14.06.2023:
 * +hasAge
 */

(function() {

    var ProfileKids = {
        
        props: {
            action: {
                type: String,
                default: ''
            },
            
            maxKids: {
                type: Number,
                default: -1
            }
        },

        data: function() {
            return {
                loaded: false,

                kids: []
            };
        },

        computed: {
            canAddKid: function() {
                return this.$store.state.parent.hasActiveSubscription || this.kids.length < this.maxKids;
            },
            
            subscrLinkClass: function() {
                return {
                    'touch-link-button': ks.browser.isTouch()
                };
            },
            
            promocode: function() {
                return this.$store.state.promocode.active ? this.$store.state.promocode : null;
            },
            
            hasActiveSubscription: function() {
                for (var i = 0, count = this.kids.length; i < count; i++) {
                    if (this.kids[i].subscription.active) {
                        return true;
                    }
                }
                
                return false;
            },
            
            promocodeCountDownEnabled: function() {
                return ! this.hasActiveSubscription && this.promocode !== null && this.promocode.timeLeft !== '';
            }
        },

        methods: {
            getIndexById: function(id) {
                for (var i = 0; i < this.kids.length; i++) {
                    if (parseInt(this.kids[i].id, 10) === id) {
                        return i;
                    }
                }

                return -1;
            },

            getAlertRef: function(kid){
                return 'alert' + kid.id;
            },

            getAlert: function(kid){
                // т.к. алерты создаются в цикле(v-for) ссылка на компонент будет находится в массиве по индексу 0
                return this.$refs[this.getAlertRef(kid)][0];
            },

            getDisplayName: function(kid){
                return kid.name === '' ? 'Имя ребёнка' : kid.name;
            },
            
            hasAge: function(kid) {
                return kid.birthday !== '';
            },
            
            getAge: function(kid) {
                return ks.helpers.date.getReadableAge(kid.birthday);
            },
            
            getDisplayBoxClass: function(kid) {
                return {
                    'profile-box-female' : kid.gender === ks.consts.GENDER_FEMALE,
                    'profile-box-male'   : kid.gender === ks.consts.GENDER_MALE
                };
            },            

            getDisplayNameClass: function(kid) {
                return {
                    'profile-kid-name-female' : kid.gender === ks.consts.GENDER_FEMALE,
                    'profile-kid-name-male'   : kid.gender === ks.consts.GENDER_MALE
                };
            },

            getAvatarSrc: function(kid) {
                if (kid.avatar.src === '') {
                    return '';
                }
                
                var src = kid.avatar.src + '_' + ks.consts.AVATAR_SIZE_BIG + '.png';
                if (kid.avatar.time > 0) {
                    src += '?t=' + kid.avatar.time;
                }
                return src;
            },
            
            getSubscriptionExpired: function(kid) {
                return moment(kid.subscription.expired, 'YYYY-MM-DD').format('DD.MM.YYYY');
            },
            
            getSubscriptionDaysLeft: function(kid) {
                var expired = moment(kid.subscription.expired, 'YYYY-MM-DD').startOf('day'),
                    now = moment().startOf('day');
                
                return Math.abs(expired.diff(now, 'days'));
            },
            
            hasSubscriptionDaysLeftText: function(kid){
                return this.getSubscriptionDaysLeft(kid) <= 7;
            },
            
            getSubscriptionDaysLeftText: function(kid) {
                let days = this.getSubscriptionDaysLeft(kid),
                    text = 'Закончится ';
            
                if (days <= 0) {
                    text += 'сегодня';
                } else {
                    if (days === 1) {
                        text += 'завтра';
                    } else {
                        text += 'через ' + days + ' ' + ks.helpers.text.pluralize(days, ['день', 'дня', 'дней']);
                    }
                }
                
                return text;
            },

            onGetKids: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);
                } else {
                    for (var i = 0; i < data.kids.length; i++) {
                        data.kids[i].avatar.modified = false;
                    }

                    this.kids = data.kids;
                }

                this.loaded = true;
                
                if (this.action === 'add') {
                    this.addKid();
                }
            },

            showAvatarsLibrary: function(kid) {
                ks.app.$refs.selectAvatar.show(
                    ks.consts.ROLE_KID,
                    kid.avatar.id,
                    this.onSelectAvatarFromLibrary,
                    kid
                );
            },

            onSelectAvatarFromLibrary: function(avatarId, avatarSrc, kid) {
                kid.avatar.id = avatarId;
                kid.avatar.src = avatarSrc;
                kid.avatar.time = 0;
                kid.avatar.modified = true;
            },

            changeCustomAvatar: function(e) {
                var files = e.target.files,
                    index = e.target.getAttribute('data-index');

                if (files.length !== 1) {
                    return;
                }

                this.uploadAvatar(files[0], this.kids[index]);
            },

            uploadAvatar: function(fileData, kid) {
                var result = ks.upload.checkImage(fileData);
                
                if (result !== true) {
                    this.$refs.alert.show(result, ks.consts.ALERT_ERROR);
                    
                    return false;
                }                
                
                ks.client.uploadFile({
                    controller: 'parent',
                    action: 'profile-kids/upload-avatar?id=' + kid.id,
                    file: {
                        name: 'avatar',
                        data: fileData
                    },
                    userData: kid,
                    onRequest: this.onUploadAvatar
                });
            },

            onUploadAvatar: function(errorCode, data, kid) {
                var alert = this.getAlert(kid);

                if (errorCode !== ks.consts.ERR_OK) {
                    alert.show(data.errors.global, ks.consts.ALERT_ERROR);

                    return;
                }

                kid.avatar.id = ks.consts.CUSTOM_AVATAR;
                kid.avatar.src = data.avatar.src;
                kid.avatar.time = data.avatar.time;
                kid.avatar.modified = true;
            },

            saveKid: function(kid) {
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-kids/update-kid',
                    data: {
                        kid: kid
                    },
                    userData: kid,
                    onRequest: this.onSaveKid
                });
            },

            onSaveKid: function(errorCode, data, kid){
                var alert = this.getAlert(kid);

                if (errorCode !== ks.consts.ERR_OK) {
                    alert.show(data.errors.global, ks.consts.ALERT_ERROR);

                    return;
                }
                
                kid.name = data.kid.name;

                kid.avatar.modified = false;

                alert.show(data.text, ks.consts.ALERT_SUCCESS);
            },
            
            startPracticing: function(kid) {
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-kids/start-practicing',
                    data: {
                        kidId: kid.id
                    },
                    userData: kid,
                    onRequest: this.onStartPracticing
                });                
            },
            
            onStartPracticing: function(errorCode, data, kid) {
                var alert = this.getAlert(kid);

                if (errorCode !== ks.consts.ERR_OK) {
                    alert.show(data.errors.global, ks.consts.ALERT_ERROR);

                    return;
                }                
            },

            addKid: function(){
                if ( ! this.canAddKid) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_INFO,
                        title: 'Лимит профилей детей достигнут',
                        text: 'Если вы хотите создать профиль для ещё одного ребёнка, то вам нужна хотя бы одна активная подписка.',
                        buttons: ks.consts.MBB_OK
                    });

                    return;                     
                }
                
                if (this.kids.length >= this.$store.state.parent.maxKids) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_INFO,
                        title: 'Лимит профилей детей достигнут',
                        text: 'Достигнуто максимальное количество профилей детей. '+
                              'Если вам необходимо создать ещё профиль для ребёнка, то, '+
                              'пожалуйста, обратитесь в нашу  <a href="/contacts">службу поддержки</a>.',
                        buttons: ks.consts.MBB_OK
                    });

                    return;                    
                }
                
                ks.app.$refs.createKid.show({
                    onAdd: this.onAddKid
                });
            },

            onAddKid: function(kid) {
                this.kids.push(kid);
            },

            deleteKid: function(kid){
                ks.app.$refs.messageBox.show({
                    type     : ks.consts.MBT_WARNING,
                    title    : 'Удаление профиля ребёнка',
                    text     : 'Вы действительно хотите удалить профиль ребёнка &laquo;<b>' + kid.name + '</b>&raquo;?<br>' +
                               'Внимание! После удаления восстановить профиль будет невозможно!',
                    buttons  : ks.consts.MBB_YES_NO,
                    userData : kid,
                    onClose  : this.confirmDeleteKid
                });
            },

            confirmDeleteKid: function(modalResult, kid) {
                if (modalResult !== ks.consts.MBB_YES) return;

                ks.client.request({
                    controller: 'parent',
                    action: 'profile-kids/delete-kid',
                    data: {
                        id: kid.id
                    },
                    userData: kid,
                    onRequest: this.onDeleteKid
                });
            },

            onDeleteKid: function(errorCode, data, kid){
                var alert = this.getAlert(kid);

                if (errorCode !== ks.consts.ERR_OK) {
                    alert.show(data.errors.global, ks.consts.ALERT_ERROR);

                    return;
                }

                var index = this.kids.indexOf(kid);

                this.kids.splice(index, 1);
            },
            
            useCoupon: function(kid) {
                ks.app.$refs.couponDlg.show({
                    kid: kid,
                    onApplySuccess: this.onCouponApplySuccess
                });
            },
            
            onCouponApplySuccess: function(kid, expired) {
                kid.subscription.active = true;
                kid.subscription.expired = expired;
                
                ks.app.$refs.messageBox.show({
                    type     : ks.consts.MBT_INFO,
                    title    : 'Информация',
                    text     : 'Купон успешно активирован!',
                    buttons  : ks.consts.MBB_OK
                });                
            }
        },

        watch: {
        },

        mounted: function() {
            var self = this;

            ks.core.addAppCreateEvent(function(){
                ks.client.request({
                    controller: 'account',
                    action: 'kids/get-all',
                    onRequest: self.onGetKids
                });
            });
        }

    };

    ks.core.addComponent('profile-kids', ProfileKids);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 11.04.2018
 */

(function() {

    var ProfileNotifications = {

        data: function() {
            return {
                loaded: false,

                notifications: []
            };
        },

        computed: {
        },

        methods: {
            save: function() {
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-notifications/update',
                    data: {
                        notifications: this.notifications
                    },
                    onRequest: this.onSave
                });
            },

            onSave: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);

                    return;
                }

                /*
                this.$store.commit('parent/setOptions', data.options);

                ks.helpers.loadProperties(this.options, data.options);
                */

                this.$refs.alert.show(data.text, ks.consts.ALERT_SUCCESS);
            },

            onGetNotifications: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });
                } else {
                    this.notifications = data.notifications;
                }

                this.loaded = true;
            },
            
            notificationHasParam: function(notification) {
                return 'param' in notification;
            }
        },

        mounted: function() {
            var self = this;

            ks.core.addAppCreateEvent(function(){
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-notifications/get',
                    onRequest: self.onGetNotifications
                });
            });
        }

    };

    ks.core.addComponent('profile-notifications', ProfileNotifications);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 07.10.2017
 */

(function() {

    var ProfileParent = {

        data: function() {
            return {
                loaded: false,

                email: '',

                name: '',
                nameComment: '',

                gender: 0,

                birthday: '',

                avatar: {
                    id: 0,
                    src: '',
                    time: 0,
                    modified: false
                }
            };
        },

        computed: {
            avatarSrc: function() {
                if (this.avatar.src === '') {
                    return '';
                }
                
                var src = this.avatar.src + '_' + ks.consts.AVATAR_SIZE_BIG + '.png';
                if (this.avatar.time > 0) {
                    src += '?t=' + this.avatar.time;
                }
                return src;
            },
            
            displayBoxClass: function() {
                return {
                    'profile-box-female' : this.gender === ks.consts.GENDER_FEMALE,
                    'profile-box-male'   : this.gender === ks.consts.GENDER_MALE
                };
            },
            
            displayNameClass: function() {
                return {
                    'profile-kid-name-female' : this.gender === ks.consts.GENDER_FEMALE,
                    'profile-kid-name-male'   : this.gender === ks.consts.GENDER_MALE
                };
            },            
            
            displayName: function(){
                return this.name === '' ? 'Родитель' : this.name;
            }            
        },

        methods: {
            onGetProfile: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);
                } else {
                    this.email = data.profile.email;

                    this.name = this.$store.state.parent.name;
                    this.nameComment = this.$store.state.parent.nameComment;

                    this.gender = this.$store.state.parent.gender;

                    this.birthday = this.$store.state.parent.birthday;

                    this.avatar.id = this.$store.state.parent.avatar.id;
                    this.avatar.src = this.$store.state.parent.avatar.src;
                    this.avatar.time = this.$store.state.parent.avatar.time;
                }

                this.loaded = true;
            },

            showAvatarsLibrary: function() {
                ks.app.$refs.selectAvatar.show(ks.consts.ROLE_PARENT, this.avatar.id, this.onSelectAvatarFromLibrary);
            },

            onSelectAvatarFromLibrary: function(avatarId) {
                this.avatar.id = avatarId;
                this.avatar.src = '/public/images/avatars/parents/standard/' + this.avatar.id;
                this.avatar.time = 0;
                this.avatar.modified = true;
            },

            save: function() {
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-parent/update',
                    data: {
                        name           : this.name,
                        nameComment    : this.nameComment,
                        gender         : this.gender,
                        birthday       : this.birthday,
                        avatarId       : this.avatar.id,
                        avatarModified : this.avatar.modified
                    },
                    onRequest: this.onSave
                });
            },

            onSave: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);

                    return;
                }

                this.$store.commit('parent/setProfile', data.parent);
                
                this.name = data.parent.name;

                this.avatar.modified = false;

                this.$refs.alert.show(data.text, ks.consts.ALERT_SUCCESS);
            },

            changeCustomAvatar: function(e) {
                var files = e.target.files;

                if (files.length !== 1) {
                    return;
                }

                this.uploadAvatar(files[0]);
            },

            uploadAvatar: function(fileData) {
                var result = ks.upload.checkImage(fileData);
                
                if (result !== true) {
                    this.$refs.alert.show(result, ks.consts.ALERT_ERROR);
                    
                    return false;
                }                
                
                ks.client.uploadFile({
                    controller: 'parent',
                    action: 'profile-parent/upload-avatar',
                    file: {
                        name: 'avatar',
                        data: fileData
                    },
                    onRequest: this.onRequestUploadAvatar
                });
            },

            onRequestUploadAvatar: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);

                    return;
                }
                
                var d = new Date();
                
                this.avatar.id = ks.consts.CUSTOM_AVATAR;
                this.avatar.src = data.avatar.src;
                this.avatar.time = data.avatar.time + d.getMilliseconds();
                this.avatar.modified = true;
            }
        },

        mounted: function() {
            var self = this;

            ks.core.addAppCreateEvent(function(){
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-parent/get-profile',
                    onRequest: self.onGetProfile
                });
            });
        }

    };

    ks.core.addComponent('profile-parent', ProfileParent);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 18.10.2017
 */

(function() {

    var ProfilePassword = {

        data: function() {
            return {
                loaded: false,

                oldPassword: {
                    value: '',
                    error: ''
                },

                newPassword: {
                    value: '',
                    error: ''
                },

                confirmPassword: {
                    value: '',
                    error: ''
                }
            };
        },

        computed: {
            oldPasswordHasError: function() {
                return this.oldPassword.error !== '';
            },

            newPasswordHasError: function() {
                return this.newPassword.error !== '';
            },

            confirmPasswordHasError: function() {
                return this.confirmPassword.error !== '';
            }
        },

        methods: {
            init: function() {
                this.loaded = true;
            },

            validateFields: function() {
                return this.validateOldPassword() & this.validateNewPassword() & this.validateConfirmPassword();
            },

            validateOldPassword: function() {
                if (this.oldPassword.value === '') {
                    this.oldPassword.error = 'Пожалуйста, укажите старый пароль.';
                    return false;
                }

                if (this.oldPassword.value.length > 32) {
                    this.oldPassword.error = 'Длина пароля не может быть больше 32 символов.';
                    return false;
                }

                this.oldPassword.error = '';

                return true;
            },

            validateNewPassword: function() {
                if (this.newPassword.value === '') {
                    this.newPassword.error = 'Пожалуйста, укажите новый пароль.';
                    return false;
                }

                if (this.newPassword.value.length < 6) {
                    this.newPassword.error = 'Пароль не может быть короче 6 символов.';
                    return false;
                }

                if (this.newPassword.value.length > 32) {
                    this.newPassword.error = 'Длина пароля не может быть больше 32 символов.';
                    return false;
                }

                if (this.oldPassword.value === this.newPassword.value) {
                    this.newPassword.error = 'Новый пароль совпадает со старым паролем.';
                    return false;
                }

                this.newPassword.error = '';

                return true;
            },

            validateConfirmPassword: function() {
                if (this.confirmPassword.value === '') {
                    this.confirmPassword.error = 'Пожалуйста, введите новый пароль ещё раз.';
                    return false;
                }

                if (this.confirmPassword.value !== this.newPassword.value) {
                    this.confirmPassword.error = 'Пароли не совпадают.';
                    return false;
                }

                this.confirmPassword.error = '';

                return true;
            },

            save: function() {
                if (this.validateFields()) {
                    ks.client.request({
                        controller: 'parent',
                        action: 'profile-password/update',
                        data: {
                            oldPassword: this.oldPassword.value,
                            newPassword: this.newPassword.value
                        },
                        onRequest: this.onSave
                    });
                }
            },

            onSave: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    if (data.errors.global) {
                        this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    }
                    else {
                        for (var field in data.errors) {
                            if (field in this) {
                                this[field].error = data.errors[field];
                            }
                        }
                    }

                    return;
                }

                this.oldPassword.value = '';
                this.oldPassword.error = '';

                if (this.$refs.oldPassword && this.$refs.oldPassword.resetType) {
                  this.$refs.oldPassword.resetType();
                }

                this.newPassword.value = '';
                this.newPassword.error = '';

                if (this.$refs.newPassword && this.$refs.newPassword.resetType) {
                  this.$refs.newPassword.resetType();
                }

                this.confirmPassword.value = '';
                this.confirmPassword.error = '';

                if (this.$refs.confirmPassword && this.$refs.confirmPassword.resetType) {
                  this.$refs.confirmPassword.resetType();
                }

                this.$refs.alert.show(data.text, ks.consts.ALERT_SUCCESS);
            }
        },

        watch: {
            'oldPassword.value': function() {
                if (this.oldPassword.value !== '') {
                    this.oldPassword.error = '';
                }
            },

            'newPassword.value': function() {
                if (this.newPassword.value !== '') {
                    this.newPassword.error = '';
                }
            },

            'confirmPassword.value': function() {
                if (this.confirmPassword.value !== '') {
                    this.confirmPassword.error = '';
                }
            }
        },

        mounted: function() {
            ks.core.addStoreLoadEvent(this.init);
        }

    };

    ks.core.addComponent('profile-password', ProfilePassword);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 09.05.2018
 * 
 * 03.08.2019:
 * +period.profitably
 * +periodId
 * 
 * 21.02.2020
 * +promocode.type
 * 
 * 11.04.2021
 * +reviews
 * 
 * 23.04.2021
 * +different profitably icons
 * 
 * 24.06.2021
 * Глобальная переработка пакетов и работы модуля
 * 
 * 09.11.2021
 * Добавлена поддержка Робокассы-фрейма оплаты
 * 
 * 17.02.2022
 * Добавлена обработка периодов промокода
 * 
 * 23.02.2022
 * Добавлены промокоды с фиксированной скидкой в руб.
 * 
 * 02.03.2022
 * +wheelFortuneShow
 * 
 * 09.08.2022
 * +Fixed Price Promocode
 * 
 * 13.12.2022
 * +Кнопка "Получить скидку" для колеса фортуны
 * 
 * 12.06.2023
 * Разбивка на отдельные компоненты
 */

(function() {
    
    var PP_MODE_DEFAULT         = 0,
        PP_MODE_SUCCESS_PAYMENT = 1;

    var ProfilePayment = {
        
        props: {
            kidId: {
                type: Number,
                default: -1
            },
            
            initMode: {
                type: Number,
                default: PP_MODE_DEFAULT
            },
            
            invoicePrice: {
                type: Number,
                default: 0
            },
            
            invoiceMonths: {
                type: Number,
                default: 0  
            },
            
            initPromocode: {
                type: String,
                default: ''
            },             
            
            wheelFortuneShow: {
                type: Boolean,
                default: false
            },             
            
            wheelFortuneActive: {
                type: Boolean,
                default: false
            }
        },

        data: function() {
            return {
                loaded: false,
                
                mode: PP_MODE_DEFAULT,

                kids: [],
                
                promocode: {
                    value: '',
                    
                    discountMode: -1,
                    
                    active: false,
                    discount: 0,
                    timeLeft: '',
                    periods: [],
                    error: ''
                },
                
                reviews: {
                    items: [],
                    page: 1,
                    pagesCount: 0,
                    loading: false
                },
                
                pf: '' // Payment Form
            };
        },

        computed: {
            // Mode
            isDefaultMode: function() {
                return this.mode === PP_MODE_DEFAULT;
            },
            
            // Reviews
            showReviews: function(){
                return this.mode === PP_MODE_DEFAULT && this.reviews.items.length > 0;
            },
            
            canLoadMoreReviews: function(){
                return this.reviews.pagesCount > this.reviews.page;
            },
            
            loadMoreReviewsText: function(){
                return this.reviews.loading ? 'Загрузка' : 'Ещё отзывы';
            },
            
            // Kids
            countKids: function() {
                return this.kids.length;
            },
            
            selectedKid: function() {
                for (let i = 0; i < this.countKids; i++) {
                    if (this.kids[i].selected) {
                        return this.kids[i];
                    }
                }
                
                return null;
            },
            
            hasKids: function() {
                return this.countKids > 0;
            },
            
            kidsMoreOne: function() {
                return this.countKids > 1;
            },
            
            hasSelectedKid: function() {
                return this.selectedKid !== null;
            }
        },

        methods: {
            getAvatarSrc: function(kid) {
                var src = kid.avatar.src + '_' + ks.consts.AVATAR_SIZE_BIG + '.png';
                if (kid.avatar.time > 0) {
                    src += '?t=' + kid.avatar.time;
                }
                return src;
            },
            
            classKidSelected: function(kid) {
                return {
                    'selected': kid.selected,
                    'cursor-default': kid.selected
                };
            },
            
            onGetKids: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);
                } else {
                    let i;
                
                    for (i = 0; i < data.kids.length; i++) {
                        data.kids[i].avatar.modified = false;
                    }
                    
                    let hasSelected = false;
                    for (i = 0; i < data.kids.length; i++) {
                        data.kids[i].selected = data.kids[i].id === this.kidId;
                        if (data.kids[i].selected) {
                            hasSelected = true;
                        }
                    }

                    // Проверим - если не выбран ни один профиль - выберем первый
                    if ( ! hasSelected && data.kids.length > 0) {
                        data.kids[0].selected = true;
                    }
                    
                    this.kids = data.kids;
                    
                    if (this.mode === PP_MODE_SUCCESS_PAYMENT && this.kids.length === 1 && this.kids[0].birthday === '') {
                        ks.app.$refs.kidDlg.show({ 
                            title  : 'Данные ребёнка',
                            action : 'update',
                            kidId  : this.kids[0].id
                        });
                    }
                }
                
                this.loaded = true;
                
                if (this.initPromocode !== '' && this.isDefaultMode) {
                    var self = this;
                    this.$nextTick(function(){                    
                        self.promocode.value = self.initPromocode;

                        self.$refs.promocode.show();

                        if (self.kids.length > 0) {
                            self.$refs.promocode.apply(true);                     
                        }
                    });
                }
                
                if (this.wheelFortuneShow && this.isDefaultMode) {
                    this.$nextTick(function(){
                        setTimeout(function(){
                            ks.app.showWheelFortuneDlg();
                        }, 500);
                    });
                }                
                
                this.$nextTick(function(){
                    var hash = window.location.hash;
                    if (hash === '#reviews') {
                        var el = $(hash),
                            destination = el.length === 1 ? el.offset().top : 0;
                        $("html").animate({ scrollTop: destination }, 500);
                    }
                });                
            },
            
            showWheelFortune: function() {
                ks.app.showWheelFortuneDlg();
            },
            
            loadReviews: function(page){
                this.reviews.loading = true;
                
                var client = new ks.Client();
                client.request({
                    controller: 'reviews',
                    action: 'get/all',
                    data: {
                        page: page
                    },
                    onRequest: this.onGetReviews
                }, true /* лоадер не показываем */);             
            },
            
            onGetReviews: function(errorCode, data){
                this.reviews.loading = false;
                
                if (errorCode !== ks.consts.ERR_OK) {
                    return;
                }
                
                this.reviews.pagesCount = data.pages_count;
                this.reviews.page = data.page;
                
                for(var i = 0; i < data.reviews.length; i++){
                    this.reviews.items.push(data.reviews[i]);
                }
            },
            
            loadMoreReviews: function(){
                if (this.reviews.loading || this.reviews.pagesCount <= this.reviews.page) {
                    return;
                }
                
                this.loadReviews(this.reviews.page + 1);
                
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_LOAD_MORE_REVIEWS);
            },
            
            selectKid: function(kid) {
                if (kid.selected) {
                    return;
                }
                
                for (let i = 0, count = this.kids.length; i < count; i++) {
                    this.kids[i].selected = this.kids[i] === kid;
                }                
            },
            
            /**
             * Установить промокод. Внимание! Ф-ия вызывается из ks.app
             * @param {string} promocode
             * @param {boolean} apply
             * @param {boolean} autoMode
             * @returns {void}
             */
            setPromocode: function(promocode, apply, autoMode){
                if (this.promocode.active){
                    this.$refs.promocode.clear();
                }
                
                this.promocode.value = promocode;
                this.$refs.promocode.show();
                
                if (apply) {
                    this.$refs.promocode.apply(typeof autoMode !== 'undefined' ? autoMode : false);
                }
            },
            
            doPayment: function(period, alternativeMode) {
                var data = {
                   kids: [],
                   
                   alternativeMode: alternativeMode,
                   
                   totalPrice: this.$refs.periods.periodPriceInt(period),
                   
                   page: ks.consts.INVOICE_PAGE_PAYMENT
                };
                
                // VK Pixel Ретаргетинг
                ks.vk.Retargeting.onEvent(ks.vk.Retargeting.EVENT_CLICK_PAY); 
                ks.vk.Goal('add_to_cart');
                // Yandex Events
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_CLICK_PAY);
                
                data.kids.push({
                    id: this.selectedKid.id,
                    periodId: period.id
                });
                
                if (this.promocode.active && ! this.$refs.periods.isDisabledPromocode(period)) {
                    data.promocode = this.promocode.value;
                }
                
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-payment/create-invoice',
                    data: data,
                    onRequest: this.onCreateInvoice
                });                
            },
            
            onCreateInvoice: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    if (errorCode !== ks.consts.ERR_PAYMENT_PROBLEM) {
                        this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);
                    } else {
                        ks.app.$refs.messageBox.show({
                            type    : ks.consts.MBT_WARNING,
                            title   : 'Технические работы',
                            text    : data.errors.global,
                            buttons : ks.consts.MBB_OK
                        });                           
                    }
                } else {
                    if (data.urlMode) {
                        ks.app.go(data.url);
                    } else {
                        if (data.frameMode) {
                            switch (data.provider) {
                                case 'robokassa':
                                    Robokassa.StartPayment(data.frame);
                                    break;
                            }
                        } else {
                            this.pf = data.form; 

                            this.$nextTick(function() {
                                var form = document.getElementById('paymentForm');

                                form.submit();
                            });
                        }
                    }
                }                 
            },
            
            setDefaultMode: function() {
                this.mode = PP_MODE_DEFAULT;
            }
        },

        mounted: function() {
            this.mode = this.initMode;
            
            if (this.mode === PP_MODE_SUCCESS_PAYMENT) {
                const self = this;
                setTimeout(function(){
                    ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_PAID, self.invoicePrice > 0 ? {
                        order_price : self.invoicePrice, 
                        currency    : 'RUB'                        
                    } : null);
                    
                    if (self.invoiceMonths > 0) {
                        let event = 0;
                        switch (self.invoiceMonths) {
                            case 1:
                                event = ks.yandex.Events.EVENT_PAID_1_MONTH;
                                break;
                                
                            case 3:
                                event = ks.yandex.Events.EVENT_PAID_3_MONTHS;
                                break; 
                            
                            case 6:
                                event = ks.yandex.Events.EVENT_PAID_6_MONTHS;
                                break;  
                            
                            case 12:
                                event = ks.yandex.Events.EVENT_PAID_12_MONTHS;
                                break;                             
                        }
                        
                        if (event > 0) {
                            ks.yandex.Events.onEvent(event, self.invoicePrice > 0 ? {
                                order_price : self.invoicePrice, 
                                currency    : 'RUB'                        
                            } : null);       
                        }
                    }
                    
                    ks.vk.Goal('purchase', self.invoicePrice > 0 ? { value: self.invoicePrice} : null);
                }, 50);
            }
            
            var self = this;

            ks.core.addAppCreateEvent(function(){
                ks.client.request({
                    controller: 'account',
                    action: 'kids/get-all',
                    onRequest: self.onGetKids
                });
                
                self.loadReviews(1);
            });
        }

    };

    ks.core.addComponent('profile-payment', ProfilePayment);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 12.04.2021
 */

(function() {
    
    var ProfileMenuMobileButton = {
        data: function() {
            return {};
        },
        
        methods: {
            showMenu: function(){
                ks.app.$refs.profileMobileMenu.show();
            }
        }
    };

    var ProfileMenuMobile = {

        data: function() {
            return {
                loaded: false
            };
        },

        computed: {

        },

        methods: {
            show: function() {
                this.$dlg.modal('show');
            },
            
            hide: function() {
                this.$dlg.modal('hide');
            }
        },
        
        watch: {

        },

        mounted: function() {
            this.$dlg = $('#profile-mobile-menu');
            
            this.loaded = true;
        }

    };

    ks.core.addComponent('profile-menu-mobile-button', ProfileMenuMobileButton);
    ks.core.addComponent('profile-menu-mobile', ProfileMenuMobile);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 02.04.2021
 */

(function() {

    var ProfilePromocodes = {

        data: function() {
            return {
                loaded: false
            };
        },

        computed: {

        },

        methods: {
        },

        watch: {
        },

        mounted: function() {
            /*
            var self = this;

            ks.core.addAppCreateEvent(function(){
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-invite/get-info',
                    onRequest: self.onGetInviteInfo
                });
            });*/
            
            this.loaded = true;
        }

    };

    ks.core.addComponent('profile-promocodes', ProfilePromocodes);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 26.10.2017
 */

(function() {

    var ProfileSettings = {

        data: function() {
            return {
                loaded: false,

                options: {
                    need_parent_password: false,
                    parent_password: '',
                    sound_effects: true,
                    sound_voice: true,
                    background_image: '',
                    window_rest_enabled: true,
                    window_rest_exercises: 20
                },

                errors: {
                    parent_password: ''
                }
            };
        },

        computed: {
            voiceEnabled: function() {
                return this.$store.state.settings.voiceEnabled;
            }
        },

        methods: {
            validateFields: function() {
                return this.validateParentPassword();
            },

            validateParentPassword: function() {
                if ( ! this.options.need_parent_password) {
                    return true;
                }

                if (this.options.parent_password === '') {
                    this.errors.parent_password = 'Пожалуйста, укажите родительский пароль.';
                    return false;
                }

                this.errors.parent_password = '';

                return true;
            },

            save: function() {
                if (this.validateFields()) {
                    ks.client.request({
                        controller: 'parent',
                        action: 'profile-settings/update',
                        data: this.options,
                        onRequest: this.onSave
                    });
                }
            },

            onSave: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);

                    return;
                }

                this.$store.commit('parent/setOptions', data.options);

                ks.helpers.loadProperties(this.options, data.options);

                this.$refs.alert.show(data.text, ks.consts.ALERT_SUCCESS);
            },

            onGetSettings: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });
                } else {
                    ks.helpers.loadProperties(this.options, data.options);
                }

                this.loaded = true;
            },
            
            getBackgroundImageClass: function(image) {
                return {
                    'active': image === this.options.background_image
                };
            },
            
            selectBackgroundImage: function(image) {
                if (this.options.background_image === image) {
                    return;
                }
                
                this.options.background_image = image;
                
                ks.app.applyPageBackgroundImage(image);
            }
        },

        watch: {
            'options.need_parent_password': function(val) {
                if ( ! val) {
                    this.errors.parent_password = '';
                }
            },

            'options.parent_password': function(val) {
                if (val !== '') {
                    this.errors.parent_password = '';
                }
            }
        },

        mounted: function() {
            var self = this;

            ks.core.addAppCreateEvent(function(){
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-settings/get',
                    onRequest: self.onGetSettings
                });
            });
        }

    };

    ks.core.addComponent('profile-settings', ProfileSettings);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 15.02.2018
 */

(function() {

    var ProfileTrainings = {
        
        props: {
            action: {
                type: String,
                default: ''
            }
        },

        data: function() {
            return {
                loaded: false,
                
                trainings: [],
                
                groups: []
            };
        },

        computed: {
        },

        methods: {
            onGetTrainings: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);
                } else {
                    this.trainings = data.trainings;
                    this.groups = data.groups;
                }

                this.loaded = true;
                
                if (this.action === 'create') {
                    this.addTraining();
                }
            },
            
            getTrainingImageSrc: function(training) {
                var src = training.image;
                
                if (training.imageTime !== 0) {
                    src += '?t=' + training.imageTime;
                }
                
                return src;
            },
            
            deleteTraining: function(training) {
                ks.app.$refs.messageBox.show({
                    type     : ks.consts.MBT_WARNING,
                    title    : 'Удаление тренировки',
                    text     : 'Вы действительно хотите удалить тренировку &laquo;<b>' + training.name + '</b>&raquo;?',
                    buttons  : ks.consts.MBB_YES_NO,
                    userData : training,
                    onClose  : this.confirmDeleteTraining
                });                
            },
            
            confirmDeleteTraining: function(modalResult, training) {
                if (modalResult !== ks.consts.MBB_YES) return;

                ks.client.request({
                    controller: 'parent',
                    action: 'profile-trainings/delete',
                    data: {
                        id: training.id
                    },
                    userData: training,
                    onRequest: this.onDeleteTraining
                });
            },

            onDeleteTraining: function(errorCode, data, training){
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);

                    return;
                }

                var index = this.trainings.indexOf(training);

                this.trainings.splice(index, 1);
            },
            
            addTraining: function() {
                if (! this.$store.getters['parent/hasActiveSubscription']) {
                    return;
                }
                
                if (this.trainings.length >= this.$store.state.parent.maxTrainings) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_INFO,
                        title: 'Лимит тренировок достигнут',
                        text: 'Достигнуто максимальное количество тренировок. '+
                              'Если вам необходимо больше тренировок, то, '+
                              'пожалуйста, обратитесь в нашу  <a href="/contacts">службу поддержки</a>.',
                        buttons: ks.consts.MBB_OK
                    });

                    return;                    
                }
                
                ks.app.$refs.selectGroup.show(-1, this.onSelectGroup, 'Выберите возрастную группу тренировки');
            },
            
            onSelectGroup: function(group) {
                ks.app.go('/parent/profile/trainings/create?group=' + group.id);
            },
            
            getGroupTitle: function(groupId) {
                for (var i = 0; i < this.groups.length; i++) {
                    if (this.groups[i].id === groupId) {
                        return this.groups[i].title;
                    }
                }
                
                return '';
            },
            
            startTraining: function(training) {
                ks.app.switchUser({
                    title: 'Для продолжения выберите аккаунт ребёнка',
                    redirectUrl: '/trainings/run/item/' + training.id,
                    role: 'kid'
                });                
            }
        },

        mounted: function() {
            var self = this;

            ks.core.addAppCreateEvent(function(){
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-trainings/get-all',
                    onRequest: self.onGetTrainings
                });
            });
        }

    };

    ks.core.addComponent('profile-trainings', ProfileTrainings);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 15.02.2018
 */

(function() {
    
    var ProfileTrainingsDesigner = {
        
        props: {
            groupId: {
                type: Number,
                required: true
            },
            
            trainingId: {
                type: Number,
                default: -1
            },
            
            defaultImage: {
                type: String,
                default: ''
            }
        },

        data: function() {
            return {
                loaded: false,
                
                name: '',
                
                image: {
                    src: '',
                    time: 0,
                    modified: false
                },
                
                subjects: []                
            };
        },

        computed: {
            getImageSrc: function() {
                var src = this.image.src;
                
                if (this.image.time !== 0) {
                    src += '?t=' + this.image.time;
                }
                
                return src;
            }
        },

        methods: {
            onLoad: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);
                } else {
                    this.name = data.training.name;
                    this.image.src = data.training.image;
                    this.image.time = data.training.imageTime;
                    this.subjects = data.training.subjects;
                }

                this.loaded = true;
            },
            
            validateName: function() {
                var error = '';
                
                if (this.name === '') {
                    error = 'Пожалуйста, укажите название тренировки.';
                }

                if (this.name.length > 50) {
                    error = 'Длина названия не может быть больше 50 символов.';
                }
                
                if (error !== '') {
                    this.$refs.alert.show(error, ks.consts.ALERT_ERROR);
                    this.$refs.name.focus();
                    return false;
                } else {
                    return true;                
                }
            },
            
            moveUpSubjectClass: function(subject) {
                return {
                    'disabled': this.subjects.indexOf(subject) <= 0
                };
            },
            
            moveDownSubjectClass: function(subject) {
                return {
                    'disabled': this.subjects.indexOf(subject) >= this.subjects.length - 1
                };
            },
            
            getSubjects: function() {
                var subjects = [];
                
                for (var i = 0; i < this.subjects.length; i++) {
                    subjects.push({
                        id: this.subjects[i].id,
                        index: i,
                        countExercises: this.subjects[i].countExercises
                    });
                }
                
                return subjects;
            },
            
            save: function() {
                if ( ! this.validateName()) {
                    return false;
                }
                
                var action = this.trainingId === -1 ? 'create' : 'update';
                
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-trainings/' + action,
                    data: {
                        id             : this.trainingId,
                        groupId        : this.groupId,
                        name           : this.name,
                        imageSrc       : this.image.src,
                        imageModified  : this.image.modified,
                        subjects       : this.getSubjects()
                    },
                    onRequest: this.onSave
                });                    
            },
            
            onSave: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);

                    return;
                }

                this.image.modified = false;

                this.$refs.alert.show(data.text, ks.consts.ALERT_SUCCESS);
            },            
            
            showImagesLibrary: function() {
                ks.app.$refs.selectImage.show(
                    'Выбор изображения из библиотеки',
                    'trainings',
                    this.image.src,
                    this.onSelectImageFromLibrary
                );
            },          
            
            onSelectImageFromLibrary: function(imageSrc) {
                this.image.src = imageSrc;
                this.image.time = 0;
                this.image.modified = true;
            },
            
            changeCustomImage: function(e) {
                var files = e.target.files;

                if (files.length !== 1) {
                    return;
                }

                this.uploadImage(files[0]);                
            },
            
            uploadImage: function(fileData) {
                var result = ks.upload.checkImage(fileData);
                
                if (result !== true) {
                    this.$refs.alert.show(result, ks.consts.ALERT_ERROR);
                    
                    return false;
                }
                
                ks.client.uploadFile({
                    controller: 'parent',
                    action: 'profile-trainings/upload-image',
                    file: {
                        name: 'image',
                        data: fileData
                    },
                    onRequest: this.onRequestUploadImage
                });
                
                return true;
            },

            onRequestUploadImage: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);

                    return;
                }

                this.image.src = data.image.src;
                this.image.time = data.image.time;
                this.image.modified = true;
            },
            
            startAddSubject: function() {
                ks.app.$refs.trainingSubjectDlg.show({
                    mode: 'add',
                    onOK: this.addSubject
                });
            },
            
            addSubject: function(subject) {
                this.subjects.push({
                    id: subject.id,
                    parentId: subject.parentId,
                    title: subject.title,
                    countExercises: subject.countExercises
                });
            },
            
            startChangeSubject: function(subject) {
                ks.app.$refs.trainingSubjectDlg.show({
                    mode: 'edit',
                    onOK: this.changeSubject,
                    subject: subject,
                    userData: subject
                });                
            },
            
            changeSubject: function(selectedSubject, subject) {
                subject.id = selectedSubject.id;
                subject.parentId = selectedSubject.parentId;
                subject.title = selectedSubject.title;
                subject.countExercises = selectedSubject.countExercises;
            },
            
            startDeleteSubject: function(subject) {
                ks.app.$refs.messageBox.show({
                    type     : ks.consts.MBT_WARNING,
                    title    : 'Удаление темы',
                    text     : 'Вы действительно хотите удалить тему &laquo;<b>' + subject.title + '</b>&raquo;?',
                    buttons  : ks.consts.MBB_YES_NO,
                    userData : subject,
                    onClose  : this.deleteSubject
                });                
            },
            
            deleteSubject: function(modalResult, subject) {
                if (modalResult !== ks.consts.MBB_YES) return;
                
                var index = this.subjects.indexOf(subject);
                
                this.subjects.splice(index, 1);
            },
            
            moveUpSubject: function(subject) {
                var index = this.subjects.indexOf(subject);
                        
                this.subjects.splice(index, 1);
                this.subjects.splice(index - 1, 0, subject);                
            },
            
            moveDownSubject: function(subject) {
                var index = this.subjects.indexOf(subject);
                        
                this.subjects.splice(index, 1);
                this.subjects.splice(index + 1, 0, subject);                
            }
        },

        watch: {
          
        },

        mounted: function() {
            var self = this;
            
            if (this.trainingId === -1) {
                this.image.src = this.defaultImage;
                
                this.loaded = true;
                return;
            }
            
            ks.core.addAppCreateEvent(function(){
                ks.client.request({
                    controller: 'parent',
                    action: 'profile-trainings/get',
                    data: {
                        id: self.trainingId
                    },
                    onRequest: self.onLoad
                });                
            });         
        }

    };

    ks.core.addComponent('profile-trainings-designer', ProfileTrainingsDesigner);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 17.03.2018
 */

(function() {

    Vue.component('report-date-range-picker', {
        
        props: {
            format: {
                type: String,
                default: 'DD.MM.YYYY'
            },
            
            outputFormat: {
                type: String,
                default: 'YYYY-MM-DD'
            },
            
            fromDate: {
                type: String,
                default: ''
            },
            
            toDate: {
                type: String,
                default: ''
            },
            
            maxHistoryDays: {
                type: Number,
                default: 0
            }
        },
        
        data: function() {
            return {
                loaded: false,
                
                range: {
                    from: '',
                    to: ''
                }
            };
        },

        computed: {
            isActiveToday: function() {
                var from = moment(this.range.from, this.format),
                    to = moment(this.range.to, this.format);    
                
                return {
                    'active': from.isSame(moment(), 'day') && from.isSame(to, 'day')
                };
            },
            
            isActiveYesterday: function() {
                var from = moment(this.range.from, this.format),
                    to = moment(this.range.to, this.format);    
                
                return {
                    'active': from.isSame(moment().add(-1, 'days'), 'day') && from.isSame(to, 'day')
                };
            },

            isActiveWeek: function() {
                var from = moment(this.range.from, this.format),
                    to = moment(this.range.to, this.format);    
                
                return {
                    'active': from.isSame(moment().add(-1, 'weeks'), 'day') && to.isSame(moment(), 'day')
                };
            },
            
            isActiveLastWeek: function() {
                var from = moment(this.range.from, this.format),
                    to = moment(this.range.to, this.format);    
                
                return {
                    'active': from.isSame(moment().add(-2, 'weeks'), 'day') && to.isSame(moment().add(-1, 'weeks'), 'day')
                };
            },

            isActiveMonth: function() {
                var from = moment(this.range.from, this.format),
                    to = moment(this.range.to, this.format);    
                
                return {
                    'active': from.isSame(moment().add(-1, 'months'), 'day') && to.isSame(moment(), 'day')
                };
            },
            
            isActiveLastMonth: function() {
                var from = moment(this.range.from, this.format),
                    to = moment(this.range.to, this.format);    
                
                return {
                    'active': from.isSame(moment().add(-2, 'months'), 'day') && to.isSame(moment().add(-1, 'months'), 'day')
                };
            },

            isActiveOld: function() {
                var from = moment(this.range.from, this.format),
                    to = moment(this.range.to, this.format);    
                
                return {
                    'active': from.isSame(moment().add(-1 * this.maxHistoryDays, 'days'), 'day') && to.isSame(moment(), 'day')
                };
            }
        },
        
        methods: {
            setRange: function(from, to) {
                var valueFrom = typeof from === 'undefined' ? {} : from,
                    valueTo = typeof to === 'undefined' ? {} : to;    
                
                this.range.from = moment().add(valueFrom).format(this.format);
                this.range.to = moment().add(valueTo).format(this.format);                
            },
            
            fireChange: function() {
                var rangeDate = {
                    from: moment(this.range.from, this.format).format(this.outputFormat),
                    to: moment(this.range.to, this.format).format(this.outputFormat),
                };
                
                this.$emit('change', rangeDate);
            }
        },
        
        watch: {
            'range.from': function() {
                this.fireChange();
            },
    
            'range.to': function() {
                this.fireChange();
            }
        },
        
        created: function() {
            if (this.fromDate === '' || this.toDate === '') {
                this.setRange({weeks: -1});
            } else {
                this.range.from = this.fromDate;
                this.range.to = this.toDate;
            }
        },

        mounted: function() {
            this.loaded = true;
        }

    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 20.03.2018
 */

(function() {

    Vue.component('report-exercises', {
        
        props: {
            kid: null
        },

        data: function() {
            return {
                loaded: false,
                
                rangeDate: {
                    from: '',
                    to: ''
                },
                
                hasChartData: false,
                
                allCount: 0
            };
        },

        computed: {
            allCountText: function() {
                return this.allCount + ' ' + ks.helpers.text.pluralize(this.allCount, ['упражнение', 'упражнения', 'упражнений']);
            }
        },
        
        methods: {
            load: function() {
                if (this.kid === null || this.rangeDate.from === '' || this.rangeDate.to === '') {
                    return false;
                }
                
                // Получаем данные для графика
                ks.client.request({
                    controller: 'report',
                    action: 'exercises/load',
                    data: {
                        kidId: this.kid === null ? -1 : this.kid.id,
                        rangeDate: this.rangeDate
                    },
                    onRequest: this.onLoad
                }); 
                
                return true;
            },
            
            onLoad: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }
                
                this.hasChartData = data.subjects.length > 0;
                
                this.allCount = 0;
                for (var i = 0; i < data.subjects.length; i++) {
                    this.allCount += data.subjects[i].count;
                }
                
                this.chart.data = {
                    labels: this.getChartLabels(data.subjects),
                    datasets: [{
                        data: this.getChartData(data.subjects),
                        
                        backgroundColor: ks.colors.getBackgroundColors(data.subjects.length),
                        borderColor: ks.colors.getBorderColors(data.subjects.length),
                        borderWidth: 1
                    }]                    
                };
                
                this.chart.update();
            },
            
            getChartLabels: function(data) {
                var labels = [];
                
                for (var i = 0; i < data.length; i++) {
                    labels.push(data[i].title + ' ' + ks.helpers.text.pluralize(data[i].count, ['упражнение', 'упражнения', 'упражнений']));
                }
                
                return labels;
            },
            
            getChartData: function(data) {
                var chartData = [];
                
                for (var i = 0; i < data.length; i++) {
                    chartData.push(data[i].count);
                }
                
                return chartData;                
            },
    
            changeRangeDate: function(range) {
                if (this.rangeDate.from === range.from && this.rangeDate.to === range.to) {
                    return;
                }
                
                var reload = this.rangeDate.from !== '' && this.rangeDate.to !== '';
                
                this.rangeDate.from = range.from;
                this.rangeDate.to = range.to;
                
                if (reload) {
                    this.load();
                }
            },
            
            createChart: function() {
                var ctx = $('#report-chart-canvas');
                
                this.chart = new Chart(ctx, {
                    type: 'doughnut',
                    
                    options: {
                        title: {
                            display: false
                        },
                        
                        legend: {
                            display: true
                        },
                        
                        tooltips: {
                            callbacks: {
                                title: function(tooltipItem, data) {
                                    return data.labels[tooltipItem[0].index];
                                },
                                
                                label: function(tooltipItem, data) {
                                    return '';
                                },
                                
                                afterLabel: function(tooltipItem, data) {
                                    var dataset = data.datasets[0],
                                        percent = Math.round((dataset.data[tooltipItem.index] / dataset._meta[0].total) * 100);
                                    return '(' + percent + '%)';
                                }
                            },
                            
                            backgroundColor: '#fafeff',
                            
                            titleFontColor: '#4091a5',
                            
                            bodyFontColor: '#4091a5',
                            
                            borderColor: '#4ba4ba',
                            borderWidth: 1,
                            
                            displayColors: false
                        }                        
                    }  
                    
                });                
            }            
        },

        mounted: function() {
            this.createChart();
            this.loaded = true;
        }

    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 13.06.2018
 */

(function() {

    Vue.component('report-list', {
        
        props: {
            kid: {
                type: Object
            },
            
            kidIndex: {
                type: Number,
                default: -1
            }
        },
        
        data: function() {
            return {
            };
        },

        computed: {
        },
        
        methods: {
            getReportUrl: function(url) {
                if (this.$store.getters.isKid || this.kid === null || this.kidIndex <= 0) {
                    return url;
                }
                
                return url + '?kid=' + this.kid.id;
            }
        },
        
        mounted: function() {
        }

    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 17.03.2018
 */

(function() {

    var ReportPage = {
        
        props: {
            kidId: {
                type: Number,
                default: -1
            }            
        },

        data: function() {
            return {
                loaded: false,
                
                kids: [],
                
                currentKidIndex: -1
            };
        },

        computed: {
            currentKid: function() {
                return this.currentKidIndex > -1 ? this.kids[this.currentKidIndex] : null;
            }
        },
        
        methods: {
            init: function() {
                // Загружаем список детей
                ks.client.request({
                    controller: 'account',
                    action: 'kids/get-all',
                    onRequest: this.onGetKids
                });              
            },
            
            onGetKids: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }

                this.kids = data.kids;
                
                var kidId = -1;
                if (this.$store.getters.isParent) {
                    kidId = this.kidId;
                } else { // isKid
                    kidId = this.$store.state.kid.id;
                }
                
                if (kidId > -1) {
                    for (var i = 0; i < this.kids.length; i++) {
                        if (this.kids[i].id === kidId) {
                            this.currentKidIndex = i;
                            break;
                        }
                    }
                } 
                
                if (this.currentKidIndex < 0) {
                    if (this.kids.length > 0 && this.$store.getters.isParent) {
                        this.currentKidIndex = 0;
                    }
                }
                
                if (this.currentKid !== null) {
                    var self = this;
                    this.$nextTick(function() {
                        self.loadReport();
                    });
                }
                
                this.loaded = true;
            },    
            
            changeKid: function() {
                this.$parent.$refs.selectKid.show({
                    kids: this.kids,
                    selectedIndex: this.currentKidIndex,
                    onSelect: this.onSelectKid
                });
            },
            
            onSelectKid: function(index, kid) {
                this.currentKidIndex = index;
                
                var self = this;
                this.$nextTick(function() {
                    self.loadReport();
                });
            },
            
            loadReport: function() {
                this.$refs.report.load();
            }
        },

        mounted: function() {
            var self = this;
            ks.core.addAppCreateEvent(function(){
                self.init();
            });
        }

    };

    ks.core.addComponent('report-page', ReportPage);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 20.03.2018
 */

(function() {

    Vue.component('report-subjects', {
        
        props: {
            kid: null
        },

        data: function() {
            return {
                loaded: false,
                
                rangeDate: {
                    from: '',
                    to: ''
                },
                
                hasChartData: false,
                
                subjects: [],
                
                maxSteps: 10
            };
        },

        computed: {
        },
        
        methods: {
            load: function() {
                if (this.kid === null || this.rangeDate.from === '' || this.rangeDate.to === '') {
                    return false;
                }
                
                if (this.hasChartData) {
                    this.destroyCharts();
                }
                
                // Получаем данные для графика
                ks.client.request({
                    controller: 'report',
                    action: 'subjects/load',
                    data: {
                        kidId: this.kid === null ? -1 : this.kid.id,
                        rangeDate: this.rangeDate
                    },
                    onRequest: this.onLoad
                }); 
                
                return true;
            },
            
            onLoad: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }
                
                this.hasChartData = data.subjects.length > 0;
                
                this.subjects = data.subjects;
                
                var self = this;
                this.$nextTick(function(){
                    self.createCharts();
                });
            },
            
            getChartLabels: function(data) {
                var labels = [];
                
                for (var i = 0; i < data.length; i++) {
                    labels.push(data[i].title);
                }
                
                return labels;
            },
            
            getChartData: function(data) {
                var chartData = [];
                
                for (var i = 0; i < data.length; i++) {
                    chartData.push(data[i].time);
                }
                
                return chartData;                
            },
    
            changeRangeDate: function(range) {
                if (this.rangeDate.from === range.from && this.rangeDate.to === range.to) {
                    return;
                }
                
                var reload = this.rangeDate.from !== '' && this.rangeDate.to !== '';
                
                this.rangeDate.from = range.from;
                this.rangeDate.to = range.to;
                
                if (reload) {
                    this.load();
                }
            },
            
            destroyCharts: function() {
                for (var i = 0; i < this.subjects.length; i++) {
                    $('#report-chart-canvas-' + i).remove();
                    this.charts[i].destroy();
                }
                
                this.charts = [];
                this.subjects = [];
            },
            
            createCharts: function() {
                for (var i = 0; i < this.subjects.length; i++) {
                    this.charts.push(this.createChart(
                        '#report-chart-canvas-' + i, 
                        this.subjects[i].correctAnswers,
                        this.subjects[i].incorrectAnswers));
                }
            },
            
            createChart: function(id, correctAnswers, incorrectAnswers) {
                var ctx = $(id);
                
                return new Chart(ctx, {
                    type: 'bar',
                    
                    data: {
                        labels: ['Правильные ответы', 'Неправильные ответы'],
                        datasets: [{
                            data: [correctAnswers, incorrectAnswers],
                            backgroundColor: [
                                ks.colors.getBackgroundColor('green'),
                                ks.colors.getBackgroundColor('red')
                            ],
                            borderColor: [
                                ks.colors.getBorderColor('green'),
                                ks.colors.getBorderColor('red')
                            ],
                            borderWidth: 1
                        }]
                    },
                    
                    options: {
                        title: {
                            display: false
                        },
                        
                        legend: {
                            display: false
                        },                        
                        
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true,
                                    stepSize: this.getChartStepSize(correctAnswers, incorrectAnswers)
                                }
                            }]
                        },
                        
                        tooltips: {
                            backgroundColor: '#fafeff',
                            
                            titleFontColor: '#4091a5',
                            
                            bodyFontColor: '#4091a5',
                            
                            borderColor: '#4ba4ba',
                            borderWidth: 1,
                            
                            displayColors: false
                        }                         
                    }  
                    
                }); 
            },
            
            getChartStepSize: function(correctAnswers, incorrectAnswers) {
                var max = correctAnswers > incorrectAnswers ? correctAnswers : incorrectAnswers,
                    step = Math.ceil(max / this.maxSteps);
                
                return step < 1 ? 1 : step;
            }
        },
        
        created: function() {
            this.charts = [];
        },

        mounted: function() {
            this.loaded = true;
        }

    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 17.03.2018
 */

(function() {

    Vue.component('report-time', {
        
        props: {
            kid: null
        },

        data: function() {
            return {
                loaded: false,
                
                rangeDate: {
                    from: '',
                    to: ''
                },
                
                hasChartData: false,
                
                allTime: 0
            };
        },

        computed: {
            allTimeText: function() {
                return this.allTime + ' ' + ks.helpers.text.pluralize(this.allTime, ['минута', 'минуты', 'минут']);
            }
        },
        
        methods: {
            load: function() {
                if (this.kid === null || this.rangeDate.from === '' || this.rangeDate.to === '') {
                    return false;
                }
                
                // Получаем данные для графика
                ks.client.request({
                    controller: 'report',
                    action: 'time/load',
                    data: {
                        kidId: this.kid === null ? -1 : this.kid.id,
                        rangeDate: this.rangeDate
                    },
                    onRequest: this.onLoad
                }); 
                
                return true;
            },
            
            onLoad: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }
                
                this.hasChartData = data.subjects.length > 0;
                
                this.allTime = 0;
                for (var i = 0; i < data.subjects.length; i++) {
                    this.allTime += data.subjects[i].time;
                }
                
                this.chart.data = {
                    labels: this.getChartLabels(data.subjects),
                    datasets: [{
                        data: this.getChartData(data.subjects),
                        
                        backgroundColor: ks.colors.getBackgroundColors(data.subjects.length),
                        borderColor: ks.colors.getBorderColors(data.subjects.length),
                        borderWidth: 1
                    }]                    
                };
                
                this.chart.update();
            },
            
            getChartLabels: function(data) {
                var labels = [];
                
                for (var i = 0; i < data.length; i++) {
                    labels.push(data[i].title + ': ' + data[i].time + ' ' + ks.helpers.text.pluralize(data[i].time, ['минута', 'минуты', 'минут']));
                }
                
                return labels;
            },
            
            getChartData: function(data) {
                var chartData = [];
                
                for (var i = 0; i < data.length; i++) {
                    chartData.push(data[i].time);
                }
                
                return chartData;                
            },
    
            changeRangeDate: function(range) {
                if (this.rangeDate.from === range.from && this.rangeDate.to === range.to) {
                    return;
                }
                
                var reload = this.rangeDate.from !== '' && this.rangeDate.to !== '';
                
                this.rangeDate.from = range.from;
                this.rangeDate.to = range.to;
                
                if (reload) {
                    this.load();
                }
            },
            
            createChart: function() {
                var ctx = $('#report-chart-canvas');
                
                this.chart = new Chart(ctx, {
                    type: 'doughnut',
                    
                    options: {
                        title: {
                            display: false
                        },
                        
                        legend: {
                            display: true
                        },
                        
                        tooltips: {
                            callbacks: {
                                title: function(tooltipItem, data) {
                                    return data.labels[tooltipItem[0].index];
                                },
                                
                                label: function(tooltipItem, data) {
                                    return '';
                                },
                                
                                afterLabel: function(tooltipItem, data) {
                                    var dataset = data.datasets[0],
                                        percent = Math.round((dataset.data[tooltipItem.index] / dataset._meta[0].total) * 100);
                                    return '(' + percent + '%)';
                                }
                            },
                            
                            backgroundColor: '#fafeff',
                            
                            titleFontColor: '#4091a5',
                            
                            bodyFontColor: '#4091a5',
                            
                            borderColor: '#4ba4ba',
                            borderWidth: 1,
                            
                            displayColors: false
                        }                        
                    }  
                    
                });                
            }            
        },

        mounted: function() {
            this.createChart();
            this.loaded = true;
        }

    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 20.03.2018
 */

(function() {

    Vue.component('report-trainings', {
        
        props: {
            kid: null
        },

        data: function() {
            return {
                loaded: false,
                
                rangeDate: {
                    from: '',
                    to: ''
                },
                
                hasChartData: false,
                
                allCount: 0
            };
        },

        computed: {
        },
        
        methods: {
            load: function() {
                if (this.kid === null || this.rangeDate.from === '' || this.rangeDate.to === '') {
                    return false;
                }
                
                // Получаем данные для графика
                ks.client.request({
                    controller: 'report',
                    action: 'trainings/load',
                    data: {
                        kidId: this.kid === null ? -1 : this.kid.id,
                        rangeDate: this.rangeDate
                    },
                    onRequest: this.onLoad
                }); 
                
                return true;
            },
            
            onLoad: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }
                
                this.hasChartData = data.trainings.length > 0;
                
                this.allCount = 0;
                for (var i = 0; i < data.trainings.length; i++) {
                    this.allCount += data.trainings[i].count;
                }
                
                this.chart.data = {
                    labels: this.getChartLabels(data.trainings),
                    datasets: [{
                        data: this.getChartData(data.trainings),
                        
                        backgroundColor: ks.colors.getBackgroundColors(data.trainings.length),
                        borderColor: ks.colors.getBorderColors(data.trainings.length),
                        borderWidth: 1
                    }]                    
                };
                
                this.chart.update();
            },
            
            getChartLabels: function(data) {
                var labels = [];
                
                for (var i = 0; i < data.length; i++) {
                    labels.push(data[i].title);
                }
                
                return labels;
            },
            
            getChartData: function(data) {
                var chartData = [];
                
                for (var i = 0; i < data.length; i++) {
                    chartData.push(data[i].count);
                }
                
                return chartData;                
            },
    
            changeRangeDate: function(range) {
                if (this.rangeDate.from === range.from && this.rangeDate.to === range.to) {
                    return;
                }
                
                var reload = this.rangeDate.from !== '' && this.rangeDate.to !== '';
                
                this.rangeDate.from = range.from;
                this.rangeDate.to = range.to;
                
                if (reload) {
                    this.load();
                }
            },
            
            createChart: function() {
                var ctx = $('#report-chart-canvas');
                
                this.chart = new Chart(ctx, {
                    type: 'doughnut',
                    
                    options: {
                        title: {
                            display: false
                        },
                        
                        legend: {
                            display: true
                        },
                        
                        tooltips: {
                            callbacks: {
                                title: function(tooltipItem, data) {
                                    return data.labels[tooltipItem[0].index];
                                },
                                
                                label: function(tooltipItem, data) {
                                    return '';
                                },
                                
                                afterLabel: function(tooltipItem, data) {
                                    var dataset = data.datasets[0],
                                        percent = Math.round((dataset.data[tooltipItem.index] / dataset._meta[0].total) * 100);
                                    return '(' + percent + '%)';
                                }
                            },
                            
                            backgroundColor: '#fafeff',
                            
                            titleFontColor: '#4091a5',
                            
                            bodyFontColor: '#4091a5',
                            
                            borderColor: '#4ba4ba',
                            borderWidth: 1,
                            
                            displayColors: false
                        }                        
                    }  
                    
                });                
            }            
        },

        mounted: function() {
            this.createChart();
            this.loaded = true;
        }

    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 01.04.2018
 * 
 * 16.04.2021: Переделано
 */

(function() {

    Vue.component('achievement', {
        
        template: 
            '<div class="achievement-item text-center" :class="itemClass" @click="toggleExpand">'+
            '    <div class="achievement-item__top">'+
            '        <div class="achievement-item__top__left">'+
            '            <img class="achievement-item__top__img" :class="imageClass" :src="achievement.image" :alt="achievement.title" />'+
            '        </div>'+
            '        <div class="achievement-item__top__center">'+
            '            <div class="achievement-item__title" v-html="getTitle"></div>'+
            '            <div class="achievement-item__description" v-html="achievement.description"></div>'+
            '            <div class="achievement-item__progress">'+
            '                <div class="achievement-item__progress-bar">'+
            '                    <span class="achievement-item__progress-bar__value" :class="progressBarValueClass" :style="progressBarValueStyle"></span>'+
            '                </div>'+
            '                <div v-if="!isCompleted" class="achievement-item__progress-state">'+
            '                    <span class="achievement-item__progress-state__text">{{ progressStateText }}</span> <a class="achievement-item__progress-state__start" :class="startButtonClass" v-if="hasStartButton" href="#" @click.prevent="start($event)">Начать!</a>'+
            '                </div>'+
            '            </div>'+
            '        </div>'+
            '        <div class="achievement-item__top__right">'+
            '            <div class="achievement-item__top__stars" :class="topStarsClass">{{ countStarsText }} <i class="fa fa-star"></i></div>'+
            '            <div v-if="!isCompleted" class="achievement-item__top__expand"><i class="fa" :class="iconExpandClass"></i></div>'+
            '            <div v-if="isCompleted" class="achievement-item__top__completed hidden-xs"><i class="fa fa-check"></i></div>'+
            '        </div>'+
            '    </div>'+

            '    <div class="achievement-item__targets">'+
            '        <div v-for="(target, targetIndex) in achievement.targets" class="achievement-item__target" :class="targetClass(targetIndex)">'+
            '            <div class="achievement-item__target__text" v-html="getTargetText(targetIndex)"></div>'+
            '            <div class="achievement-item__target__stars">+{{ targetIndex + 1 }} <i class="fa fa-star"></i></div>'+
            '        </div>'+
            '    </div>'+

            '</div>',
                            
        
        props: {
            achievement: null,
            
            index: {
                type: Number,
                required: true
            },
            
            currentKid: null
        },

        data: function() {
            return {
                loaded: false
            };
        },

        computed: {
            itemClass: function() {
                return {
                    'active'    : ! this.achievement.completed,
                    //'new'       : this.achievement.targetChanged,
                    //'completed' : this.achievement.completed && ! this.achievement.targetChanged,
                    'expanded'  : this.achievement.expand 
                };
            },
            
            imageClass: function(){
                var cls = {};
                cls['color-scheme-' + this.achievement.colorScheme] = true;
                return cls;
            },
            
            countStars: function(){
                var count = 0;
                for (var i = this.achievement.currentTargetIndex; i > 0; i--) {
                    count += i;
                }
                return count;
            },
            
            countStarsText: function(){
                return this.countStars <= 0 ? '' : this.countStars;
            },
            
            topStarsClass: function(){
                return {
                    'no-stars': this.countStars <= 0,
                    'has-stars': this.countStars > 0
                };
            },
            
            iconExpandClass: function(){
                return {
                    'fa-minus-circle' : this.achievement.expand,
                    'fa-plus-circle'  : ! this.achievement.expand
                };
            },
            
            currentValue: function() {
                return this.achievement.currentValue;
            },
            
            currentTargetValue: function() {
                var target = this.achievement.currentTargetIndex >= this.achievement.targets.length ?
                    null :
                    this.achievement.targets[this.achievement.currentTargetIndex];
                
                return target === null ? null : target.value;
            },            
            
            progressBarValueStyle: function() {
                var val = this.currentTargetValue !== null ? 100 * this.currentValue / this.currentTargetValue : 0;
                
                // При < 5% некрасиво показывается полоса прогресса
                if (val > 0 && val < 5) {
                    val = 5;
                }
                
                if (this.achievement.completed) {
                    val = 100;
                }
                
                return {
                    'width': val + '%' 
                };                
            }, 
            
            progressBarValueClass: function(){
                var cls = {};
                cls['color-scheme-' + this.achievement.colorScheme] = true;
                return cls;
            },   
            
            progressStateText: function() {
                return this.currentTargetValue !== null ? 
                    this.achievement.currentValue + '/' + this.currentTargetValue :
                    '';
            },   
            
            hasStartButton: function(){
                return true;
                //return this.achievement.type === ks.consts.ACHIEVEMENT_CORRECT_ANSWERS_SUBJECT;
            },
            
            startButtonClass: function(){
                var cls = {};
                cls['color-scheme-' + this.achievement.colorScheme] = true;
                return cls;                
            },
            
            isCompleted: function(){
                return this.achievement.completed;
            },
            
            isNew: function(){
                return this.achievement.targetChanged && ! this.achievement.completed;
            },
            
            getTitle: function(){
                var title = this.achievement.title;
                
                if (this.isCompleted) {
                    title = title + ' <br class="visible-xs" /><span class="achievement-item__title__completed">получено</span>';
                } else {
                    if (this.isNew) {
                        title = '<span class="achievement-item__title__new">новое</span> <br class="visible-xs" />' + title;
                    }
                }
                
                return title;
            }
        },
        
        methods: {
            toggleExpand: function(){
                if (this.achievement.completed) {
                    return;
                }                
                
                this.achievement.expand = ! this.achievement.expand;
                this.$emit('expand', this.index);
            },
            
            start: function(e){
                e.stopPropagation();
                
                if (this.currentKid === null) {
                    return;
                }
                
                ks.client.request({
                    controller: 'achievements',
                    action: 'kid/get_start_url',
                    data: {
                        kidId: this.currentKid.id,
                        type: this.achievement.type,
                        id: this.achievement.id
                    },
                    onRequest: this.onStartRequest
                });                
            },
            
            onStartRequest: function(errorCode, data){
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }
                
                if (typeof data.url === 'undefined' || data.url === '') {
                    return;
                }
                
                window.location.href = data.url;
            },
            
            targetClass: function(targetIndex){
                var cls = {
                    'achieved' : this.achievement.currentTargetIndex > targetIndex,
                    'current'  : this.achievement.currentTargetIndex === targetIndex
                };
                cls['achievement-item__target-' + this.achievement.targets.length] = true;
                return cls;
            },
            
            getTargetText: function(targetIndex) {
                var target = this.achievement.targets[targetIndex],
                    isCurrent = this.achievement.currentTargetIndex === targetIndex,
                    text = isCurrent ? '<b>' : '';
            
                text += '<span class="hidden-xs">' + target.title.normal + '</span>' +  
                        '<span class="hidden-sm hidden-md hidden-lg">' + target.title.small + '</span>'; 
                
                if (isCurrent) {
                    text += '</b>';
                }
                
                return text;
            }
        },

        mounted: function() {
            this.loaded = true;
        }

    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 30.03.2018
 * 
 * 21.02.2021: add paginate
 */

(function() {

    var AchievementsPage = {
        
        props: {
            kidId: {
                type: Number,
                default: -1
            }
        },

        data: function() {
            return {
                loaded: false,
                
                loadingAchievements: false,
                
                kids: [],
                
                currentKidIndex: -1,
                
                tabName: 'active', // 'active' or 'complete'
                
                activeAchievements: {
                    page: {
                        current: 1,
                        count: 0
                    },
                    items: [],
                    count: 0
                },
                completedAchievements: {
                    page: {
                        current: 1,
                        count: 0
                    },
                    items: [],
                    count: 0
                }
            };
        },

        computed: {
            currentKid: function() {
                return this.currentKidIndex > -1 ? this.kids[this.currentKidIndex] : null;
            },
            
            isEmptyActiveAchievements: function() {
                return this.activeAchievements.count === 0 && ! this.loadingAchievements;
            },
            
            isEmptyCompletedAchievements: function() {
                return this.completedAchievements.count === 0 && ! this.loadingAchievements;
            },
            
            stars: function() {
                return this.currentKid === null ? 0 : this.currentKid.stars;
            },
            
            starsCountClass: function() {
                return {
                    'orange': this.stars > 0,
                    'gray-dark-text':  this.stars <= 0
                };
            },
            
            canLoadMoreActiveAchievements: function(){
                return this.activeAchievements.page.current < this.activeAchievements.page.count && this.activeAchievements.items.length > 0;
            },
            
            canLoadMoreCompletedAchievements: function(){
                return this.completedAchievements.page.current < this.completedAchievements.page.count && this.completedAchievements.items.length > 0;
            },
            
            loadMoreAchievementsText: function(){
                return this.loadingAchievements ? 'Загрузка' : 'Ещё достижения';
            }
        },
        
        methods: {
            init: function() {
                // Загружаем список детей
                ks.client.request({
                    controller: 'account',
                    action: 'kids/get-all',
                    onRequest: this.onGetKids
                });              
            },
            
            onGetKids: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }

                this.kids = data.kids;
                
                var kidId = -1;
                if (this.$store.getters.isParent) {
                    kidId = this.kidId;
                } else { // isKid
                    kidId = this.$store.state.kid.id;
                }
                
                if (kidId > -1) {
                    for (var i = 0; i < this.kids.length; i++) {
                        if (this.kids[i].id === kidId) {
                            this.currentKidIndex = i;
                            break;
                        }
                    }
                } 
                
                if (this.currentKidIndex < 0) {
                    if (this.kids.length > 0 && this.$store.getters.isParent) {
                        this.currentKidIndex = 0;
                    }
                }
                
                if (this.currentKid !== null) {
                    var self = this;
                    this.$nextTick(function() {
                        self.loadAchievements(true);
                    });
                }
                
                this.loaded = true;
            },    
            
            changeKid: function() {
                this.$parent.$refs.selectKid.show({
                    kids: this.kids,
                    selectedIndex: this.currentKidIndex,
                    onSelect: this.onSelectKid
                });
            },
            
            onSelectKid: function(index, kid) {
                this.currentKidIndex = index;
                
                var self = this;
                this.$nextTick(function() {
                    self.loadAchievements(true);
                });
            },
            
            loadAchievements: function(resetPage) {
                if (this.loadingAchievements) {
                    return;
                }
                
                this.loadingAchievements = true;
                
                let completed = this.tabName === 'complete';
                
                if (resetPage) {
                    this.completedAchievements.items = [];
                    this.activeAchievements.items = [];
                    
                    this.completedAchievements.page.current = 1;
                    this.activeAchievements.page.current = 1;
                }
                
                // Получаем список достижений
                ks.client.request({
                    controller: 'achievements',
                    action: 'kid/get',
                    data: {
                        kidId: this.currentKid.id,
                        completed: completed,
                        page: completed ? this.completedAchievements.page.current : this.activeAchievements.page.current
                    },
                    onRequest: this.onLoadAchievements,
                    userData: completed
                }, ! resetPage);
            },
            
            onLoadAchievements: function(errorCode, data, completed) {
                this.loadingAchievements = false;
                
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }
                
                // Сортируем ачивки
                /*data.achievements.sort(function(a, b) {
                    if (a.targetChanged && ! b.targetChanged) {
                        return -1;
                    }
                    
                    if ( ! a.targetChanged && b.targetChanged) {
                        return 1;
                    }
                    
                    if (a.modified > b.modified) {
                        return -1;
                    }
                    
                    if (a.modified < b.modified) {
                        return 1;
                    }
                    
                    return 0;
                });*/
                
                var i;
                if (completed) {
                    for (i = 0; i < data.achievements.length; i++) {
                        if (this.isAchievementExists(this.completedAchievements.items, data.achievements[i].id)) {
                            continue;
                        }
                        this.completedAchievements.items.push(data.achievements[i]);
                    }
                    this.completedAchievements.page.current = data.page;
                    this.completedAchievements.page.count = data.pageCount;
                } else {
                    for (i = 0; i < data.achievements.length; i++) {
                        if (this.isAchievementExists(this.activeAchievements.items, data.achievements[i].id)) {
                            continue;
                        }                        
                        this.activeAchievements.items.push(data.achievements[i]);
                    }                    
                    this.activeAchievements.page.current = data.page;
                    this.activeAchievements.page.count = data.pageCount;
                }                
                
                this.completedAchievements.count = data.completedCount;
                this.activeAchievements.count = data.activeCount;
            },
            
            isAchievementExists: function(achievements, id){
                for (var i = 0; i < achievements.length; i++) {
                    if (achievements[i].id === id) {
                        return true;
                    }
                }
                
                return false;
            },
            
            onSelectTab: function(tabName) {
                this.tabName = tabName;
                this.loadAchievements(true);
            },
            
            onExpandAchievement: function(achievementIndex){
                var achievements = this.tabName === 'complete' ? this.completedAchievements.items : this.activeAchievements.items;
                
                for (var i = 0; i < achievements.length; i++) {
                    if (i === achievementIndex) {
                        continue;
                    }
                    
                    achievements[i].expand = false;
                }
            },
            
            loadMoreActiveAchievements: function(){
                if (this.loadingAchievements) {
                    return;
                }
                this.activeAchievements.page.current++;
            },
            
            loadMoreCompletedAchievements: function(){
                if (this.loadingAchievements) {
                    return;
                }
                this.completedAchievements.page.current++;
            }
        },
        
        watch: {
            'activeAchievements.page.current': function(newPage) {
                this.loadAchievements(false);
            },
            
            'completedAchievements.page.current': function(newPage) {
                this.loadAchievements(false);
            }
        },
        
        mounted: function() {
            var self = this;
            
            $('a[data-tab-group="achievements"]').on('shown.bs.tab', function(e) {
                let target = $(e.target).attr("href");

                switch (target) {
                    case '#active':
                        self.onSelectTab('active');
                        break;
                    case '#complete':
                        self.onSelectTab('complete');
                        break;
                }
            }); 
                    
            ks.core.addAppCreateEvent(function(){
                self.init();
            });
        }

    };

    ks.core.addComponent('achievements-page', AchievementsPage);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 30.03.2018
 */

(function() {

    var AwardsPage = {
        
        props: {
            kidId: {
                type: Number,
                default: -1
            }
        },

        data: function() {
            return {
                loaded: false,
                
                loadingAwards: false,
                
                kids: [],
                
                currentKidIndex: -1,
                
                awards: [],
                
                awardsInRow: 4
            };
        },

        computed: {
            currentKid: function() {
                return this.currentKidIndex > -1 ? this.kids[this.currentKidIndex] : null;
            },            
            
            stars: function() {
                return this.currentKid === null ? 0 : this.currentKid.stars;
            },
            
            starsCountClass: function() {
                return {
                    'orange': this.stars > 0,
                    'gray-dark-text':  this.stars <= 0
                };
            },
            
            rows: function() {
                var count = Math.ceil(this.awards.length / this.awardsInRow),
                    rows = [];
            
                for (var i = 0; i < count; i++) {
                    rows.push(i);
                }
                
                return rows;
            }
        },
        
        methods: {
            init: function() {
                // Загружаем список детей
                ks.client.request({
                    controller: 'account',
                    action: 'kids/get-all',
                    onRequest: this.onGetKids
                });              
            },
            
            onGetKids: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }

                this.kids = data.kids;
                
                var kidId = -1;
                if (this.$store.getters.isParent) {
                    kidId = this.kidId;
                } else { // isKid
                    kidId = this.$store.state.kid.id;
                }
                
                if (kidId > -1) {
                    for (var i = 0; i < this.kids.length; i++) {
                        if (this.kids[i].id === kidId) {
                            this.currentKidIndex = i;
                            break;
                        }
                    }
                } 
                
                if (this.currentKidIndex < 0) {
                    if (this.kids.length > 0 && this.$store.getters.isParent) {
                        this.currentKidIndex = 0;
                    }
                }
                
                if (this.currentKid !== null) {
                    var self = this;
                    this.$nextTick(function() {
                        self.loadAwards();
                    });
                }
                
                this.loaded = true;
            },    
            
            changeKid: function() {
                this.$parent.$refs.selectKid.show({
                    kids: this.kids,
                    selectedIndex: this.currentKidIndex,
                    onSelect: this.onSelectKid
                });
            },
            
            onSelectKid: function(index, kid) {
                this.currentKidIndex = index;
                
                var self = this;
                this.$nextTick(function() {
                    self.loadAwards();
                });
            },
            
            loadAwards: function() {
                this.awards = [];
                
                this.loadingAwards = true;
                
                // Получаем список наград
                ks.client.request({
                    controller: 'awards',
                    action: 'kid/get-all',
                    data: {
                        kidId: this.currentKid.id
                    },
                    onRequest: this.onLoadAwards
                });
            },
            
            onLoadAwards: function(errorCode, data) {
                this.loadingAwards = false;
                
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }
                
                this.awards = data.awards;
            },
            
            rowAwards: function(row) {
                var awards = [],
                    count = (row + 1) * this.awardsInRow;
            
                if (count > this.awards.length) {
                    count = this.awards.length;
                }
                
                for (var i = row * this.awardsInRow; i < count; i++) {
                    awards.push(this.awards[i]);
                }
                
                return awards;
            },
            
            /*
            getAwardLevel: function(award) {
                return ks.helpers.math.romanize(award.level);
            },*/
            
            getAwardClass: function(award) {
                return {
                    'disabled': ! this.isAwardActive(award)
                };
            },
            
            isAwardActive: function(award) {
                var kid = this.currentKid;
                
                return kid !== null && kid.stars >= award.stars;
            },
            
            /*
            getAwardTitleClass: function(award) {
                var active = this.isAwardActive(award);
                
                return {
                  'award-item-title-green': active && award.color === 1,
                  'award-item-title-blue': active && award.color === 2,
                  'award-item-title-purple': active && award.color === 3,
                  'award-item-title-crimson': active && award.color === 4
                };
            },*/
            
            getAwardHint: function(award) {
                return this.isAwardActive(award) ? '' :
                       'Для получения награды нужно собрать ' + award.stars + 
                       ' ' + ks.helpers.text.pluralize(award.stars, ['звезда', 'звезды', 'звёзд']) + '.';
            },
            
            calcRows: function() {
                this.awardsInRow = document.body.offsetWidth < 768 ? 2 : 4;
            },
            
            // При изменении экрана (но не чаще 300 мс)
            onWindowResize: function() {
              if (this.resizeTimer !== null) {
                    clearTimeout(this.resizeTimer);
                    this.resizeTimer = null;
                }

                var self = this;
                this.resizeTimer = setTimeout(function(){
                    self.calcRows();
                    self.resizeTimer = null;
                }, 300);            
            }            
        },

        mounted: function() {
            window.addEventListener('resize', this.onWindowResize);
            
            var self = this;
            ks.core.addAppCreateEvent(function(){
                self.init();
            });
            
            this.$nextTick(function() {
                self.calcRows();
            });            
        },
        
        destroyed: function() {
            window.removeEventListener('resize', this.onWindowResize);
        }

    };

    ks.core.addComponent('awards-page', AwardsPage);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 15.06.2018
 * 22.04.2021:
 * +closed state
 */

(function() {

    var DiplomasPage = {

        props: {
            kidId: {
                type: Number,
                default: -1
            }
        },

        data: function() {
            return {
                loaded: false,

                loadingDiplomas: false,

                kids: [],

                currentKidIndex: -1,

                diplomas: []
            };
        },

        computed: {
            currentKid: function() {
                return this.currentKidIndex > -1 ? this.kids[this.currentKidIndex] : null;
            },

            stars: function() {
                return this.currentKid === null ? 0 : this.currentKid.stars;
            },

            starsCountClass: function() {
                return {
                    'orange': this.stars > 0,
                    'gray-dark-text':  this.stars <= 0
                };
            }
        },

        methods: {
            init: function() {
                // Загружаем список детей
                ks.client.request({
                    controller: 'account',
                    action: 'kids/get-all',
                    onRequest: this.onGetKids
                });
            },

            onGetKids: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }

                this.kids = data.kids;

                var kidId = -1;
                if (this.$store.getters.isParent) {
                    kidId = this.kidId;
                } else { // isKid
                    kidId = this.$store.state.kid.id;
                }

                if (kidId > -1) {
                    for (var i = 0; i < this.kids.length; i++) {
                        if (this.kids[i].id === kidId) {
                            this.currentKidIndex = i;
                            break;
                        }
                    }
                }

                if (this.currentKidIndex < 0) {
                    if (this.kids.length > 0 && this.$store.getters.isParent) {
                        this.currentKidIndex = 0;
                    }
                }

                if (this.currentKid !== null) {
                    var self = this;
                    this.$nextTick(function() {
                        self.loadDiplomas();
                    });
                }

                this.loaded = true;
            },

            changeKid: function() {
                this.$parent.$refs.selectKid.show({
                    kids: this.kids,
                    selectedIndex: this.currentKidIndex,
                    onSelect: this.onSelectKid
                });
            },

            onSelectKid: function(index, kid) {
                this.currentKidIndex = index;

                var self = this;
                this.$nextTick(function() {
                    self.loadDiplomas();
                });
            },

            loadDiplomas: function() {
                this.diplomas = [];

                this.loadingDiplomas = true;

                // Получаем список дипломов
                ks.client.request({
                    controller: 'diplomas',
                    action: 'kid/get-all',
                    data: {
                        kidId: this.currentKid.id
                    },
                    onRequest: this.onLoadDiplomas
                });
            },

            onLoadDiplomas: function(errorCode, data) {
                this.loadingDiplomas = false;

                if (errorCode !== ks.consts.ERR_OK) {
                    ks.app.$refs.messageBox.show({
                        type: ks.consts.MBT_ERROR,
                        title: 'Ошибка',
                        text: data.errors.global
                    });

                    return;
                }

                this.diplomas = data.diplomas;
            },

            getDiplomaClass: function(diploma) {
                return {
                    'new'    : diploma.isNew,
                    'closed' : diploma.closed
                };
            },

            getPreview: function(diploma) {
                return diploma.closed ? diploma.preview_closed : diploma.preview;
            },

            getTitle: function(diploma){
                var title = diploma.closed ? '<i class="fa fa-lock diploma-item-closed"></i>' : diploma.title;

                if (diploma.isNew) {
                    title += ' <span v-show="diploma.isNew" class="diploma-item-new">новый диплом</span>';
                }

                return title;
            },

            printUrl: function(diploma) {
                return diploma.closed ? '' : '/print-awards/diplomas?kid=' + this.currentKid.id + '&diploma=' + diploma.id;
            },

            print: function(diploma){
                if (diploma.closed) {
                    return;
                }

                var url = this.printUrl(diploma);

                if (url === '') {
                    return;
                }

                window.open(url);
            }
        },

        mounted: function() {
            var self = this;
            ks.core.addAppCreateEvent(function(){
                self.init();
            });
        }

    };

    ks.core.addComponent('diplomas-page', DiplomasPage);

}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 15.06.2018
 */

(function() {

    Vue.component('progress-menu', {
        
        props: {
            kid: {
                type: Object
            },
            
            kidIndex: {
                type: Number,
                default: -1
            },
            
            /**
             * achievements|awards|diplomas
             */
            currentItem: {
                type: String,
                required: true
            }
        },
        
        data: function() {
            return {
            };
        },

        computed: {
            getAchievementsClass: function() {
                return {
                    'active': this.currentItem === 'achievements'
                };
            },
            
            getAwardsClass: function() {
                return {
                    'active': this.currentItem === 'awards'
                };
            },      
            
            getDiplomasClass: function() {
                return {
                    'active': this.currentItem === 'diplomas'
                };
            },
            
            hasNewAchievements: function() {
                if ( ! this.$store.getters.isKid) {
                    return false;
                }
                
                return this.$store.state.kid.hasNewAchievements;
            },
            
            hasNewAwards: function() {
                if ( ! this.$store.getters.isKid) {
                    return false;
                }
                
                return this.$store.state.kid.hasNewAwards;
            },
            
            hasNewDiplomas: function() {
                if ( ! this.$store.getters.isKid) {
                    return false;
                }
                
                return this.$store.state.kid.hasNewDiplomas;
            },            
            
            awardsUrl: function() {
                var url = '/progress/awards';
                
                if (this.$store.getters.isKid || this.kid === null || this.kidIndex <= 0) {
                    return url;
                }
                
                url += '?kid=' + this.kid.id;
                
                return url;
            },
            
            achievementsUrl: function() {
                var url = '/progress/achievements';
                
                if (this.$store.getters.isKid || this.kid === null || this.kidIndex <= 0) {
                    return url;
                }
                
                url += '?kid=' + this.kid.id;
                
                return url;
            },
            
            diplomasUrl: function() {
                var url = '/progress/diplomas';
                
                if (this.$store.getters.isKid || this.kid === null || this.kidIndex <= 0) {
                    return url;
                }
                
                url += '?kid=' + this.kid.id;
                
                return url;
            }             
        },
        
        methods: {

        }

    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 25.08.2024
 */

(function() {

  Vue.component('subject-child', {

    props: {
      name: {
        type: String,
        required: true
      },

      ageGroups: {
        type: Array,
        required: true
      }
    },
      
    data: function () {
      return {
        ageGroupsVisible: false,
      };
    },

    computed: {
      toggleAgeGroupsButtonClass() {
        return {
          'fa-angle-double-down': ! this.ageGroupsVisible,
          'fa-angle-double-up': this.ageGroupsVisible
        };
      },

      ageGroupsBlockStyle() {
        return {
          height: this.ageGroupsVisible ? 'auto' : '0px'
        };
      }
    },

    methods: {
      toggleAgeGroups() {
        this.ageGroupsVisible = ! this.ageGroupsVisible;
      },

      start() {
        ks.app.$refs.selectGroup.show(-1, this.onSelectGroup, 'Выбор возрастной группы', this.ageGroups);
      },

      onSelectGroup: function(group) {
        ks.app.go(`/exercises/${group.name}/${this.name}/`);
      }      
    }
      
  });
  
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 13.11.2023
 * 
 */

(function() {

    var TrainingsAges = {

        props: {
            groups: {
                type: Array,
                required: true
            }
        },
        
        data: function() {
            return {
                loaded: false,
                windowWidth: 0
            };
        },
        
        computed: {
            itemBoxStyle() {
                let rowCount = 4;
        
                if (ks.helpers.sizes.isLg(this.windowWidth) || ks.helpers.sizes.isMd(this.windowWidth)) {
                    rowCount = 4;
                } else {
                    if (ks.helpers.sizes.isSm(this.windowWidth)) {
                        rowCount = 3;
                    } else {
                        if (ks.helpers.sizes.isXs(this.windowWidth)) {
                            rowCount = 1;
                        }
                    }
                }
        
                let width = Math.trunc(this.windowWidth / rowCount);
                
                return {
                    width: width + 'px'
                };
            },
            
            groupStyle() {
                let width;
                
                if (ks.helpers.sizes.isXs(this.windowWidth)) {
                    width = '100%';
                } else {
                    width = '200px';
                }
                
                return {
                    width: width
                };
            }
        },

        methods: {
            getGroupClass: function(group){
                let cls = {};
                
                cls['color-scheme-' + group.color_scheme] = true;
                
                return cls;
            },
            
            getGroupImage: function(group, webp) {
                let image = group.image;
                
                if (image === '') {
                    return '';
                }                
                
                return !webp ? image : image.substr(0, image.lastIndexOf('.')) + '.webp';                
            },
            
            getTrainingUrl: function(group) {
                return '/trainings/run/item/' + group.training_id;
            },            
            
            selectGroup: function(group) {
                ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_START_AD_TRAINING);
                
                ks.app.go(this.getTrainingUrl(group));
            },
            
            onWindowResize() {
                this.updateWindowWidth();
            },
            
            updateWindowWidth() {
                this.windowWidth = window.innerWidth;
            }
        },
        
        created() {
            window.addEventListener('resize', this.onWindowResize);
        },
        
        destroyed() {
            window.removeEventListener('resize', this.onWindowResize);
        },
        
        mounted() {
            this.updateWindowWidth();
            this.loaded = true;
        }

    };

    ks.core.addComponent('trainings-ages', TrainingsAges);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 04.09.2024
 */

(function() {

  const STATE_EMAIL  = 0;
  const STATE_CODE   = 1;
  const STATE_FINISH = 2;

  Vue.component('day-limit-exceeded-guest', {

    data() {
      return {
        visible: false,
        state: STATE_EMAIL,

        email: {
          value: '',
          error: '',
          checkMisprint: true
        },

        code: {
          errorText: ''
        }
      };
    },

    computed: {
      isStateEmail() {
        return this.state === STATE_EMAIL;
      },

      isStateCode() {
        return this.state === STATE_CODE;
      },

      isStateFinish() {
        return this.state === STATE_FINISH;
      },

      hasEmailError() {
        return this.email.error !== '';
      },

      emailBoxClass() {
        return {
          'has-error': this.hasEmailError
        };
      },

      createAccountBoxClass() {
        return {
          'small-space': this.hasEmailError
        };
      }
    },

    methods: {
      clear() {
        this.email.value = '';
        this.email.error = '';

        this.code.errorText = '';

        if (this.$refs.emailCode) {
          this.$refs.emailCode.clear();
        }
      },

      show() {
        this.clear();

        this.visible = true;

        ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_DAY_LIMIT_EXCEEDED);
        ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_DAY_LIMIT_EXCEEDED_GUEST);
      },

      hide() {
        this.visible = false;
      },

      showLogin() {
        ks.app.showLogin();
      },

      validateEmail: function(allowEmpty) {
        if (this.email.value === '') {
          this.email.error = allowEmpty ? '' : 'Пожалуйста, введите ваш email.';
          return allowEmpty;
        }

        if (! ks.validator.validateEmail(this.email.value)) {
          this.email.error = 'Пожалуйста, укажите корректный email.';
          return false;
        }

        this.email.error = '';

        return true;
      },

      onRegistration() {
        if (! this.validateEmail(false)) {
          return;
        }

        ks.client.request({
            controller: 'account',
            action: 'email/send-code',
            data: {
              mode  : ks.consts.CONTROLLER_ACCOUNT_EMAIL_MODE_SIGNUP,
              email : this.email.value
            },
            onRequest: this.onSendCode
        });
      },

      onSendCode(errorCode, data) {
        if (errorCode !== ks.consts.ERR_OK) {
          let errorText = '';

          switch (errorCode) {
            case ks.consts.ERR_CONFIRM_CODE_USER_EMPTY:
              errorText = 'Произошла ошибка. Обновите, пожалуйста, страницу и попробуйте ещё раз.';
              break;

            case ks.consts.ERR_CONFIRM_CODE_MAX_LIMIT:
              errorText = 'Превышен лимит отправки кодов. Пожалуйста, повторите позже.';
              break;

            case ks.consts.ERR_CONFIRM_CODE_WAIT_INTERVAL:
              errorText = 'Отправить новый код можно будет через ' +
                data.errors.interval + ' ' +
                ks.helpers.text.pluralize(data.errors.interval, ['секунду', 'секунды', 'секунд']) + '.';
              break;

            case ks.consts.ERR_EMAIL_ALREADY_EXISTS:
              errorText = 'Данный email уже зарегистрирован.';
              break;

            default:
              errorText = data.errors.global;
              break;
          }

          this.email.error = errorText;

          return;
        }

        this.state = STATE_CODE;
      },

      changeCode(code) {
        this.code.errorText = '';
      },

      confirmCode(code) {
        this.code.errorText = '';

        ks.client.request({
          controller: 'account',
          action: 'email/confirm',
          data: {
            mode  : ks.consts.CONTROLLER_ACCOUNT_EMAIL_MODE_SIGNUP,
            email : this.email.value,
            code
          },
          onRequest: this.onConfirmCode
        });
      },

      onConfirmCode: function(errorCode, data) {
        if (errorCode !== ks.consts.ERR_OK) {
          let errorText = 'Произошла ошибка. Пожалуйста, попробуйте ещё раз.';

          switch (errorCode) {
            case ks.consts.ERR_CONFIRM_CODE_MAX_ATTEMPTS:
              errorText = 'Превышено максимальное количество проверок кода.';
              break;

            case ks.consts.ERR_CONFIRM_CODE_INVALID:
              errorText = 'Неправильный код.';
              break;

            default:
              if (data.errors.global) {
                errorText = data.errors.global;
              }
              break;
          }

          this.code.errorText = errorText;

          return;
        }

        if (data.isNewAccount) {
          ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED);
          ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_SIGNUP_COMPLETED_EMAIL_EXERCISES_OVER);
        }

        this.state = STATE_FINISH;

        window.location.href = data.url;
      },

      backToEmail() {
        this.code.errorText = '';

        if (this.$refs.emailCode) {
          this.$refs.emailCode.clear();
        }

        this.state = STATE_EMAIL;
      }
    },

    watch: {
      'email.value'() {
        if (this.email.value !== '') {
          this.email.error = '';
        }
      }
    }
  });
}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 16.07.2019
 *
 * 25.06.2021
 * Разделение на два варианта - для гостя и зарег. пользователя
 *
 * 27.11.2023:
 * +isKid
 * +boxClass
 *
 * 04.09.2024:
 * +isGuest
 * Разделил на два компонента 'day-limit-exceeded-guest' и 'day-limit-exceeded-user'
 */

(function() {

  Vue.component('day-limit-exceeded-user', {

    data() {
      return {
        visible: false
      };
    },

    methods: {
      show() {
        this.visible = true;

        ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_DAY_LIMIT_EXCEEDED);
        ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_DAY_LIMIT_EXCEEDED_USER);
      },

      hide() {
        this.visible = false;
      }
    }
  });
}());

/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 22.02.2018
 * 
 * 07.07.2021: Редизайн
 */

(function() {

    var TrainingsGroupsItem = {
        
        props: {
            groupId: {
                type: Number,
                required: true
            }
        },

        data: function() {
            return {
                loaded: false,
                
                trainings: []
            };
        },
        
        computed: {
            systemTrainings: function(){
                return this.trainings.filter(function(training){
                    return training.owner === ks.consts.TRAINING_OWNER_SYSTEM;
                });
            },
            
            parentTrainings: function(){
                return this.trainings.filter(function(training){
                    return training.owner === ks.consts.TRAINING_OWNER_PARENT;
                });
            },
            
            allTrainings: function(){
                let trainings = [{
                    owner: ks.consts.TRAINING_OWNER_SYSTEM,
                    items: this.systemTrainings
                }];
                
                if (this.parentTrainings.length > 0) {
                    trainings.push({
                        owner: ks.consts.TRAINING_OWNER_PARENT,
                        items: this.parentTrainings
                    });
                }
                
                return trainings;
            },
            
            isLogged: function(){
                return ! this.$store.getters.isGuest;
            },
            
            hasTrainings: function(){
                return this.trainings.length > 0;
            }
        },

        methods: {
            onGetTrainings: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    this.$refs.alert.show(data.errors.global, ks.consts.ALERT_ERROR);
                } else {
                    this.trainings = [];
                    for (let i = 0; i < data.trainings.length; i++) {
                        let training = data.trainings[i];
                        
                        training.lock = {
                            timerId: null,
                            show: false
                        };
                        
                        this.trainings.push(training);
                    }
                }

                this.loaded = true;
                
                // 11.08.2021
                ks.app.showOfferTrialTraining();
            },            
            
            startTraining: function(training) {
                if ( ! this.isLockTraining(training)) {
                    ks.app.go('/trainings/run/item/' + training.id);
                    return;
                }
                
                if (this.$store.getters.isGuest) {
                    ks.app.showSignup({
                        text: 'Тренировка доступна только для<br /> зарегистрированных пользователей с безлимитным аккаунтом.'
                    });
                    return;
                }
                
                if (training.lock.show) {
                    clearTimeout(training.lock.timerId);
                }                
                
                this.$nextTick(function(){
                    training.lock.show = true;
                    
                    training.lock.timerId = setTimeout(function(){
                        training.lock.show = false;
                        training.lock.timerId = null;
                    }, 7000);
                });
            },
            
            getItemBoxClass: function(training, index){
                let count = training.owner === ks.consts.TRAINING_OWNER_SYSTEM ? this.systemTrainings.length : this.parentTrainings.length,
                    mod = count % 3;
                
                return {
                    'col-sm-offset-4': mod === 1 && count - index === 1,
                    'col-sm-offset-1_5': mod === 2 && count - index === 2
                };
            },
            
            getColorSchemeClass: function(training){
                let cls = {};
                
                cls['color-scheme-' + training.colorScheme] = true;

                return cls;
            },
            
            isLockTraining: function(training) {
                if (training.type !== ks.consts.TRAINING_TYPE_PAID && training.owner === ks.consts.TRAINING_OWNER_SYSTEM) {
                    return false;
                }
                
                return (this.$store.getters.isGuest || ! this.$store.getters['kid/hasActiveSubscription']);
            },
            
            showLogin: function() {
                ks.app.showLogin(ks.app.$refs.headerLoginForm.email.value, '', null, true);
            },
            
            isOwnerParent: function(item){
                return item.owner === ks.consts.TRAINING_OWNER_PARENT;
            },
            
            getTrainingText: function(training){
                return training.owner === ks.consts.TRAINING_OWNER_PARENT ? 'Личная тренировка' : training.text;
            },
            
            getLockBlockClass: function(training){
                return {
                    'shown': training.lock.show
                };
            },
            
            goPayment: function(){
                ks.app.go('/parent/profile/payment');
            },
            
            clickSelectGroup: function(){
                ks.app.$refs.selectGroup.show(this.groupId, this.onSelectGroup);
            },

            onSelectGroup: function(group) {
                ks.app.go('/trainings/group/item/' + group.name);
            },
            
            getImage: function(training, webp) {
                let image = training.image;
                
                if (image === '') {
                    return '';
                }                
                
                return !webp ? image : image.substr(0, image.lastIndexOf('.')) + '.webp';                
            },
            
            getGroupAgeTitle: function(training) {
                if (training.groupAge < 8) {
                    return 'для ' + training.groupAge + ' лет';
                } else {
                    // для возраста от 8 лет
                    var classNumber = training.groupAge - 7;
                    return 'для ' + classNumber + ' класса';
                }
            },
            
            createTraining: function() {
                if (! this.$store.getters['parent/hasActiveSubscription']) {
                    ks.app.$refs.messageBox.show({
                        type    : ks.consts.MBT_INFO,
                        title   : 'Информация',
                        text    : 'Для создания тренировок необходим безлимитный доступ. <a href="/parent/profile/payment">Купить!</a>',
                        buttons : ks.consts.MBB_OK
                    });                    
                } else {
                    ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_CREATE_TRAINING_PAGE);
                    
                    ks.app.go('/parent/profile/trainings?action=create'); 
                }                
            }
        },

        mounted: function() {
            var self = this;

            ks.core.addAppCreateEvent(function(){
                ks.client.request({
                    controller: 'training',
                    action: 'get/items',
                    data: {
                        groupId: self.groupId
                    },
                    onRequest: self.onGetTrainings
                });
            });
        }

    };

    ks.core.addComponent('trainings-groups-item', TrainingsGroupsItem);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 22.02.2018
 */

(function() {

    var TrainingsMainGuest = {

        data: function() {
            return {
                loaded: false
            };
        },

        methods: {
            startTraining: function() {
                ks.app.$refs.selectGroup.show(-1, this.onSelectGroup, 'Выберите возрастную группу тренировки');
            },
            
            onSelectGroup: function(group) {
                ks.app.go('/trainings/group/item/' + group.name);
            },
            
            showLogin: function() {
                ks.app.showLogin(ks.app.$refs.headerLoginForm.email.value, '', null, true);
            },
            
            showSignup: function(options){
                ks.app.showSignup(options);
            }            
        },

        mounted: function() {
            this.loaded = true;
        }

    };

    ks.core.addComponent('trainings-main-guest', TrainingsMainGuest);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 09.07.2021
 * 
 * 01.06.2023:
 * +Мои тренировки
 */

(function() {

    var TrainingsMainLogged = {

        props: {
            groups: {
                type: Array,
                required: true
            }
        },
        
        data: function() {
            return {
                loaded: false,
                
                parentTrainings: []
            };
        },
        
        computed: {
            /*preschoolGroups: function(){
                return this.groups.filter(function(group){
                    return ! group.school;
                });
            },
            
            schoolGroups: function(){
                return this.groups.filter(function(group){
                    return group.school;
                });
            },*/
            
            isLockTraining: function() {
                var role = ks.app.isLogged(ks.consts.ROLE_PARENT) ? 'parent' : 'kid';
                
                return ! this.$store.getters[role + '/hasActiveSubscription'];        
            }            
        },

        methods: {
            getGroupBoxClass(index) {
                return {
                    'col-sm-offset-4': index === this.groups.length - 1
                };
            },
            
            getGroupClass: function(group){
                let cls = {};
                
                cls['color-scheme-' + group.color_scheme] = true;
                
                return cls;
            },
            
            selectGroup: function(group){
                if (ks.app.isLogged(ks.consts.ROLE_PARENT)) { 
                    let countKids = this.$store.state.parent.countKids;
                    
                    if (countKids === 1) {
                        this.goGroup(group); // автовход
                    } else { 
                        ks.app.switchUser({ 
                            title: 'Для продолжения выберите аккаунт ребёнка',
                            redirectUrl: this.getGroupUrl(group)
                        });
                    }
                } else {
                    this.goGroup(group);
                }
            },
            
            getGroupUrl: function(group){
                return '/trainings/group/item/' + group.name;
            },
            
            goGroup: function(group){
                ks.app.go(this.getGroupUrl(group));
            },
            
            getGroupImage: function(group, webp) {
                let image = group.image;
                
                if (image === '') {
                    return '';
                }                
                
                return !webp ? image : image.substr(0, image.lastIndexOf('.')) + '.webp';                
            },
            
            onGetParentTrainings: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    // TODO: возможно нужно добавить обработку ошибки
                    return;
                }
                
                this.parentTrainings = [];
                for (let i = 0; i < data.trainings.length; i++) {
                    let training = data.trainings[i];

                    training.lock = {
                        timerId: null,
                        show: false
                    };

                    this.parentTrainings.push(training);
                }                
                
                this.loaded = true;
            },
            
            getTrainingItemBoxClass: function(training, index) {
                let count = training.owner === ks.consts.TRAINING_OWNER_SYSTEM ? this.systemTrainings.length : this.parentTrainings.length,
                    mod = count % 3;
                
                return {
                    'col-sm-offset-4': mod === 1 && count - index === 1,
                    'col-sm-offset-1_5': mod === 2 && count - index === 2
                };                
            },
            
            getTrainingColorSchemeClass: function(training) {
                let cls = {};
                
                cls['color-scheme-' + training.colorScheme] = true;

                return cls;                
            },
            
            getTrainingImage: function(training, webp) {
                let image = training.image;
                
                if (image === '') {
                    return '';
                }                
                
                return !webp ? image : image.substr(0, image.lastIndexOf('.')) + '.webp';                 
            },
            
            getTrainingLockBlockClass: function(training) {
                return {
                    'shown': training.lock.show
                };                
            },
            
            getTrainingGroupAgeTitle: function(training) {
                if (training.groupAge < 8) {
                    return 'для ' + training.groupAge + ' лет';
                } else {
                    // для возраста от 8 лет
                    var classNumber = training.groupAge - 7;
                    return 'для ' + classNumber + ' класса';
                }
            },
            
            goPayment: function() {
                ks.app.go('/parent/profile/payment');                
            },
            
            goTrainingUrl: function(training) {
                return '/trainings/run/item/' + training.id;
            },
            
            goTraining: function(training) {
                ks.app.go(this.goTrainingUrl(training));
            },
            
            startTraining: function(training) {
                if ( ! this.isLockTraining) {
                    
                    if (ks.app.isLogged(ks.consts.ROLE_PARENT)) { 
                        let countKids = this.$store.state.parent.countKids;

                        if (countKids === 1) {
                            this.goTraining(training); // автовход
                        } else { 
                            ks.app.switchUser({ 
                                needSubscription: true,
                                title: 'Для продолжения выберите аккаунт ребёнка',
                                redirectUrl: this.goTrainingUrl(training)
                            });
                        }
                    } else {
                        this.goTraining(training);
                    }                    
                    
                    return;
                }
                
                if (training.lock.show) {
                    clearTimeout(training.lock.timerId);
                }                
                
                this.$nextTick(function(){
                    training.lock.show = true;
                    
                    training.lock.timerId = setTimeout(function(){
                        training.lock.show = false;
                        training.lock.timerId = null;
                    }, 7000);
                });                
            },
            
            createTraining() {
                if (this.isLockTraining) {
                    ks.app.$refs.messageBox.show({
                        type    : ks.consts.MBT_INFO,
                        title   : 'Информация',
                        text    : 'Для создания тренировок необходим безлимитный доступ. <a href="/parent/profile/payment">Купить!</a>',
                        buttons : ks.consts.MBB_OK
                    });                    
                } else {
                    ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_CREATE_TRAINING_PAGE);
                    
                    ks.app.go('/parent/profile/trainings?action=create'); 
                }
            }
        },

        mounted: function() {
            var self = this;

            ks.core.addAppCreateEvent(function(){
                ks.client.request({
                    controller: 'training',
                    action: 'get/items',
                    data: {
                        onlyParent: true
                    },
                    onRequest: self.onGetParentTrainings
                });
            });            
        }

    };

    ks.core.addComponent('trainings-main-logged', TrainingsMainLogged);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 22.02.2018
 */

(function() {

    var TrainingAccessDenied = {

        data: function() {
            return {
                loaded: false
            };
        },

        methods: {
            showLogin: function() {
                ks.app.showLogin(ks.app.$refs.headerLoginForm.email.value, '', null, true);
            }            
        },

        mounted: function() {
            this.loaded = true;
        }

    };

    ks.core.addComponent('training-access-denied', TrainingAccessDenied);

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 07.03.2018
 */

(function() {

    Vue.component('finish-training', {
        
        props: {
            groupName: {
                type: String,
                required: true
            }
        },         
        
        data: function() {
            return {
                visible: false,
                
                continueURL: '',
                continueText: ''
            };
        },
        
        computed: {
            trainingName: function() {
                var training = this.$store.state.current.training;
                
                return training === null ? '' : training.name;
            },
            
            trainingTrial: function(){
                var training = this.$store.state.current.training;
                
                return training === null ? false : training.type === ks.consts.TRAINING_TYPE_TRIAL;
            },
            
            getTrainingsUrl: function() {
                return this.continueURL === '' ? '/trainings/group/item/' + this.groupName : this.continueURL;
            },
            
            countExercies: function() {
                return this.$store.state.current.history.exercises.length;
            },
            
            correctAnswersCount: function() {
                var exercises = this.$store.state.current.history.exercises,
                    count = 0;
                
                for (var i = 0; i < exercises.length; i++) {
                    if (exercises[i].isCorrectAnswer) {
                        count++;
                    }
                }
                
                return count;
            },
            
            incorrectAnswersCount: function() {
                var exercises = this.$store.state.current.history.exercises,
                    count = 0;
                
                for (var i = 0; i < exercises.length; i++) {
                    if ( ! exercises[i].isCorrectAnswer) {
                        count++;
                    }
                }
                
                return count;
            },
            
            correctAnswersPercent: function() {
                return Math.round(100 * this.correctAnswersCount / this.countExercies);
            },
            
            incorrectAnswersPercent: function() {
                return 100 - this.correctAnswersPercent;
            }            
        },
       
        methods: {
            show: function(continueURL, continueText) {
                this.continueURL = continueURL || '';
                this.continueText = continueText && continueText !== '' ? continueText : 'Выбрать тренировку';
                
                this.visible = true;
                
                if (! this.trainingTrial) {
                    this.$nextTick(() => {
                        this.$refs.finishResult.show();
                    });
                }
            },
            
            hide: function() {
                this.visible = false;
                this.continueURL = '';
                
                if (! this.trainingTrial) {
                    this.$refs.finishResult.hide();
                }
            }
        }       
        
    });
    
}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 22.02.2018
 */

(function() {

    Vue.component('training-info-panel', {
        
        data: function() {
            return {
                loaded: false
            };
        },
        
        computed: {
            isTrainingLoaded: function() {
                return this.$store.state.current.training !== null;
            },
            
            hasSubjects: function() {
                return this.subjects.length > 0;
            },
            
            subjects: function() {
                return this.isTrainingLoaded ? this.$store.state.current.training.subjects : [];
            }
        },

        methods: { 
            getSubjectClass: function(subjectIndex) {
                var state = this.$store.state.current.trainingState;
                
                return {
                    'training-info-panel-subject-item-disable': subjectIndex > state.subjectIndex && state.subjectIndex > -1,
                    'training-info-panel-subject-item-current': subjectIndex === state.subjectIndex && state.subjectIndex > -1,
                    'training-info-panel-subject-item-completed': subjectIndex < state.subjectIndex || state.subjectIndex === -1,
                    'last-completed': subjectIndex + 1 === state.subjectIndex
                };
            },
            
            isShowCount: function(subjectIndex) {
                var state = this.$store.state.current.trainingState;
                
                return subjectIndex <= state.subjectIndex || state.subjectIndex === -1;
            },
            
            getSubjectCompletedExercises: function(subject, subjectIndex) {
                var state = this.$store.state.current.trainingState;
                
                if (state.subjectIndex === -1) {
                    return subject.countExercises;
                }
                
                if (subjectIndex === state.subjectIndex) {
                    return state.countExercises;
                } else {
                    if (subjectIndex < state.subjectIndex) {
                        return subject.countExercises;
                    } else {
                        return 0;
                    }
                }
            }            
        },

        mounted: function() {
            this.loaded = true;
        }
    });

}());
/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 22.02.2018
 */

(function() {

    var TrainingPage = {

        props: {
            trainingId: {
                type: Number,
                required: true
            },
            
            groupName: {
                type: String,
                required: true
            }
        },

        data: function() {
            return {
                loaded: false,
                
                training: null    
            };
        },

        computed: {
            groupId: function() {
                return this.training === null ? -1 : this.training.groupId;
            },
            
            subjectId: function() {
                var state = this.$store.state.current.trainingState;
                
                return this.training === null || state.subjectIndex === -1 ? -1 : this.training.subjects[state.subjectIndex].id;
            },
            
            canForceFinishTraining: function() {
                if (this.training === null) {
                    return false;
                }
                
                var state = this.$store.state.current.trainingState;
                
                if (state.subjectIndex < 0 || (state.subjectIndex === 0 && state.countExercises === 0)) {
                    return false;
                }
                
                if (state.subjectIndex === this.training.subjects.length - 1 && 
                    state.countExercises >= this.training.subjects[state.subjectIndex].countExercises) {
                    return false;
                }
                
                return true;
            }
        },

        methods: {
            init: function(){
                this.loadTraining(this.trainingId);
            },

            loadTraining: function(trainingId) {
                ks.client.request({
                    controller: 'training',
                    action: 'get/item',
                    data: {
                        trainingId: trainingId
                    },
                    onRequest: this.onLoadTraining
                });
            },

            onLoadTraining: function(errorCode, data) {
                var i;
                
                if (errorCode !== ks.consts.ERR_OK) {
                    if (errorCode === ks.consts.ERR_TRAINING_AD_FINISHED) {
                        ks.app.go('/exercises/groups');
                        return;
                    }
                    
                    if (data.errors && data.errors.global) {
                        ks.app.$refs.messageBox.show({
                            type: ks.consts.MBT_ERROR,
                            title: 'Ошибка',
                            text: data.errors.global,
                            buttons: ks.consts.MBB_CLOSE,
                            onClose: function(){
                                if (errorCode === ks.consts.ERR_TRAINING_ACCESS_DENIED) {
                                    window.location.href = '/trainings';
                                }
                            }
                        });
                    }

                    return;
                }

                this.training = data.training;
                
                this.$store.commit('current/training', this.training);
                this.$store.commit('current/clearHistoryExercises');
                
                var subjectIndex = -1,
                    countExercises = 0,
                    historyExercises = [];
            
                // Если мы под ребёнком и есть данные о текущей тренировке, 
                // то применяем данные о текущей тренировке
                if (this.$store.getters.isKid) {
                    subjectIndex = typeof data.subjectIndex === 'undefined' ? -1 : data.subjectIndex;
                    countExercises = typeof data.countExercises === 'undefined' ? 0 : data.countExercises; 
                    if (typeof data.historyExercises !== 'undefined') {
                        historyExercises = data.historyExercises;
                    }
                } else {
                    // Если мы под гостем, то пробуем получить состояние тренировки
                    if (this.$store.getters.isGuest) {
                        var trainingStorage = ks.Guest.loadTrainingInfo();
                        if (trainingStorage !== null) {
                            subjectIndex = trainingStorage.subjectIndex;
                            countExercises = trainingStorage.countExercises;
                            historyExercises = trainingStorage.historyExercises;
                        }
                    }
                }
                
                // Проверяем корректный ли индекс темы;
                // если это последняя тема и было выполнено последнее задание, 
                // то начинаем тренировку заново
                if (subjectIndex < 0 || 
                    subjectIndex > this.training.subjects.length - 1 || 
                   (subjectIndex === this.training.subjects.length - 1 && countExercises >= this.training.subjects[subjectIndex].countExercises)) {
                    
                    subjectIndex = -1;
                    countExercises = 0;
                
                    // Находим первый предмет в тренировке в котором есть задания
                    for (i = 0; i < this.training.subjects.length; i++) {
                        if (this.training.subjects[i].countExercises > 0) {
                            subjectIndex = i;
                            break;
                        }
                    }
                } else {
                    // Индекс темы корректен - загрузим данные истории
                    if (historyExercises.length > 0) {
                        this.$store.commit('current/setHistoryExercises', historyExercises);
                    }
                    
                    var subject = this.training.subjects[subjectIndex];
                    
                    // Проверяем корректно ли кол-во пройденных заданий;
                    // Если были пройдены все задания в теме, то переходим к следующей теме (если она есть)
                    if (countExercises < 0 || subject.countExercises <= countExercises) {
                        var index = subjectIndex;
                        
                        countExercises = 0;
                        subjectIndex = -1;

                        // Находим предмет в тернировке в котором есть задания
                        for (i = index + 1; i < this.training.subjects.length; i++) {
                            if (this.training.subjects[i].countExercises > 0) {
                                subjectIndex = i;
                                break;
                            }
                        }                            
                    }
                }
                
                // Индекс темы и кол-во выполненных заданий сохраняем
                this.$store.commit('current/trainingState', {
                    subjectIndex: subjectIndex,
                    countExercises: countExercises
                });
                
                // Проверяем если в тренировке есть упражнения - загружаем упражнение
                if (subjectIndex === -1 || this.training.subjects[subjectIndex].countExercises <= 0) {
                    this.$refs.engine.showAlert('В данной тренировке нет упражнений.', ks.consts.ALERT_INFO);
                } else {
                    this.startExercise();    
                }

                this.loaded = true;
            },
            
            nextExercise: function() {
                var state = this.$store.state.current.trainingState,
                    newSubjectIndex = -1;
                // Проверяем не закончились ли упражнения по предмету
                // Если закончились переключаемся на следующий предмет
                if (this.training.subjects[state.subjectIndex].countExercises <= state.countExercises) {
                    for (var i = state.subjectIndex + 1; i < this.training.subjects.length; i++) {
                        if (this.training.subjects[i].countExercises > 0) {
                            newSubjectIndex = i;
                            break;
                        }
                    }
                    
                    this.$store.commit('current/trainingState', {
                        subjectIndex: newSubjectIndex,
                        countExercises: 0
                    });
                    
                    // Проверяем не закончилась ли тренировка
                    if (newSubjectIndex === -1) {
                        let url = '',
                            text = '';
                        
                        if (this.training.type === ks.consts.TRAINING_TYPE_AD) {
                            ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_FINISH_AD_TRAINING);
                            
                            url = '/exercises/groups';
                            if (this.training.groupName !== '') {
                                url += '/' + this.training.groupName;
                            }
                            
                            text = 'Продолжить';
                        }
                        
                        this.$refs.engine.$refs.finishTraining.show(url, text);
                        return;
                    }
                }
                
                this.startExercise();
            },
            
            startExercise: function() {
                this.$refs.engine.loadExercise();
            },

            /**
             * Задание получено от сервера
             * @param {Object} exercise
             * @returns {undefined}
             */
            onExerciseEngineLoaded: function(exercise) {
                var state = this.$store.state.current.trainingState;
                
                this.$store.commit('current/startRecordHistoryExercise', {
                    id: exercise.id,
                    groupId: this.training.groupId,
                    subjectId: this.training.subjects[state.subjectIndex].id
                });                
            },
            
            /**
             * Правильно ответил ребенок или нет
             * @param {Boolean} isCorrect
             * @returns {undefined}
             */
            onAnswer: function(isCorrect) {
                var state = this.$store.state.current.trainingState;
                
                this.$store.commit('current/setLastHistoryExerciseAnswer', isCorrect);
                
                // Увеличиваем кол-во пройденных заданий по текущему предмету
                this.$store.commit('current/trainingState', {
                    subjectIndex: state.subjectIndex,
                    countExercises: state.countExercises + 1
                });
                
                // Мы под гостем?
                if (this.$store.getters.isGuest) {
                    // Если это было последнее упражнение тренировки, то очищаем данные о тренировке
                    if (this.$store.getters['current/isLastExerciseTraining'](state.countExercises)) {
                        ks.Guest.clearTrainingInfo();
                    } else {
                        // Если это было не последнее упражнение тренировки, то сохраянем состояние тренировки
                        ks.Guest.saveTrainingInfo({
                            subjectIndex: state.subjectIndex,
                            countExercises: state.countExercises,
                            historyExercises: this.$store.state.current.history.exercises
                        });
                    }
                }
            },
            
            forceFinishTraining: function() {
                ks.app.$refs.messageBox.show({
                    type     : ks.consts.MBT_INFO,
                    title    : 'Завершение тренировки',
                    text     : 'Вы действительно хотите завершить тренировку?',
                    buttons  : ks.consts.MBB_YES_NO,
                    onClose  : this.onForceFinishTraining
                });                
            },
            
            onForceFinishTraining: function(modalResult) {
                if (modalResult !== ks.consts.MBB_YES) return;
                
                if (this.$store.getters.isGuest) {
                    ks.Guest.clearTrainingInfo();
                    
                    ks.app.go('/trainings/group/item/' + this.groupName); 
                } else {
                    if (this.$store.getters.isKid) {
                        ks.client.request({
                            controller: 'training',
                            action: 'action/force-finish',
                            data: {
                                trainingId: this.trainingId,
                                groupName: this.groupName
                            },
                            onRequest: this.onActionForceFinish
                        });
                    }
                }
            },
            
            onActionForceFinish: function(errorCode, data) {
                if (errorCode !== ks.consts.ERR_OK) {
                    if (data.errors && data.errors.global) {
                        ks.app.$refs.messageBox.show({
                            type: ks.consts.MBT_ERROR,
                            title: 'Ошибка',
                            text: data.errors.global,
                            buttons: ks.consts.MBB_CLOSE
                        });
                    }

                    return;
                }
                
                // nothing
            },
            
            continueWork() {
                // Заглушка. Не используется, только для Subject Stage (page.js)
            }
        },

        mounted: function() {
            var self = this;
            ks.core.addAppCreateEvent(function(){
                self.init();
            });
        }

    };

    ks.core.addComponent('training-page', TrainingPage);

}());
/**
 * (c) Kids Smart 2017-2024
 * 19.09.2017
 */
ks.start();
